var Qg = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ey(Cn) {
  return Cn && Cn.__esModule && Object.prototype.hasOwnProperty.call(Cn, "default") ? Cn.default : Cn;
}
function ry(Cn) {
  if (Cn.__esModule) return Cn;
  var ua = Cn.default;
  if (typeof ua == "function") {
    var ta = function Ta() {
      return this instanceof Ta ? Reflect.construct(ua, arguments, this.constructor) : ua.apply(this, arguments);
    };
    ta.prototype = ua.prototype;
  } else ta = {};
  return Object.defineProperty(ta, "__esModule", { value: !0 }), Object.keys(Cn).forEach(function(Ta) {
    var xi = Object.getOwnPropertyDescriptor(Cn, Ta);
    Object.defineProperty(ta, Ta, xi.get ? xi : {
      enumerable: !0,
      get: function() {
        return Cn[Ta];
      }
    });
  }), ta;
}
var gf = { exports: {} };
(function(Cn) {
  (function(ua, ta) {
    Cn.exports ? Cn.exports = ta() : ua.moduleName = ta();
  })(typeof self < "u" ? self : Qg, () => {
    var ua = (() => {
      var ta = Object.defineProperty, Ta = Object.defineProperties, xi = Object.getOwnPropertyDescriptors, jl = Object.getOwnPropertySymbols, yf = Object.prototype.hasOwnProperty, mf = Object.prototype.propertyIsEnumerable, Hl = (L, k, n) => k in L ? ta(L, k, { enumerable: !0, configurable: !0, writable: !0, value: n }) : L[k] = n, Za = (L, k) => {
        for (var n in k || (k = {})) yf.call(k, n) && Hl(L, n, k[n]);
        if (jl) for (var n of jl(k)) mf.call(k, n) && Hl(L, n, k[n]);
        return L;
      }, no = (L, k) => Ta(L, xi(k)), xe = (L, k) => () => (k || L((k = { exports: {} }).exports, k), k.exports), ao = xe((L) => {
        L.version = "3.2.0";
      }), xf = xe((L, k) => {
        (function(n, e, a) {
          e[n] = e[n] || a(), typeof k < "u" && k.exports && (k.exports = e[n]);
        })("Promise", typeof window < "u" ? window : L, function() {
          var n, e, a, i = Object.prototype.toString, o = typeof setImmediate < "u" ? function(m) {
            return setImmediate(m);
          } : setTimeout;
          try {
            Object.defineProperty({}, "x", {}), n = function(m, u, d, y) {
              return Object.defineProperty(m, u, { value: d, writable: !0, configurable: y !== !1 });
            };
          } catch {
            n = function(u, d, y) {
              return u[d] = y, u;
            };
          }
          a = /* @__PURE__ */ function() {
            var m, u, d;
            function y(_, T) {
              this.fn = _, this.self = T, this.next = void 0;
            }
            return { add: function(_, T) {
              d = new y(_, T), u ? u.next = d : m = d, u = d, d = void 0;
            }, drain: function() {
              var _ = m;
              for (m = u = e = void 0; _; ) _.fn.call(_.self), _ = _.next;
            } };
          }();
          function r(m, u) {
            a.add(m, u), e || (e = o(a.drain));
          }
          function s(m) {
            var u, d = typeof m;
            return m != null && (d == "object" || d == "function") && (u = m.then), typeof u == "function" ? u : !1;
          }
          function c() {
            for (var m = 0; m < this.chain.length; m++) t(this, this.state === 1 ? this.chain[m].success : this.chain[m].failure, this.chain[m]);
            this.chain.length = 0;
          }
          function t(m, u, d) {
            var y, _;
            try {
              u === !1 ? d.reject(m.msg) : (u === !0 ? y = m.msg : y = u.call(void 0, m.msg), y === d.promise ? d.reject(TypeError("Promise-chain cycle")) : (_ = s(y)) ? _.call(y, d.resolve, d.reject) : d.resolve(y));
            } catch (T) {
              d.reject(T);
            }
          }
          function p(m) {
            var u, d = this;
            if (!d.triggered) {
              d.triggered = !0, d.def && (d = d.def);
              try {
                (u = s(m)) ? r(function() {
                  var y = new v(d);
                  try {
                    u.call(m, function() {
                      p.apply(y, arguments);
                    }, function() {
                      l.apply(y, arguments);
                    });
                  } catch (_) {
                    l.call(y, _);
                  }
                }) : (d.msg = m, d.state = 1, d.chain.length > 0 && r(c, d));
              } catch (y) {
                l.call(new v(d), y);
              }
            }
          }
          function l(m) {
            var u = this;
            u.triggered || (u.triggered = !0, u.def && (u = u.def), u.msg = m, u.state = 2, u.chain.length > 0 && r(c, u));
          }
          function f(m, u, d, y) {
            for (var _ = 0; _ < u.length; _++) (function(T) {
              m.resolve(u[T]).then(function(R) {
                d(T, R);
              }, y);
            })(_);
          }
          function v(m) {
            this.def = m, this.triggered = !1;
          }
          function g(m) {
            this.promise = m, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
          }
          function x(m) {
            if (typeof m != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            this.__NPO__ = 1;
            var u = new g(this);
            this.then = function(d, y) {
              var _ = { success: typeof d == "function" ? d : !0, failure: typeof y == "function" ? y : !1 };
              return _.promise = new this.constructor(function(T, R) {
                if (typeof T != "function" || typeof R != "function") throw TypeError("Not a function");
                _.resolve = T, _.reject = R;
              }), u.chain.push(_), u.state !== 0 && r(c, u), _.promise;
            }, this.catch = function(d) {
              return this.then(void 0, d);
            };
            try {
              m.call(void 0, function(d) {
                p.call(u, d);
              }, function(d) {
                l.call(u, d);
              });
            } catch (d) {
              l.call(u, d);
            }
          }
          var h = n({}, "constructor", x, !1);
          return x.prototype = h, n(h, "__NPO__", 0, !1), n(x, "resolve", function(m) {
            var u = this;
            return m && typeof m == "object" && m.__NPO__ === 1 ? m : new u(function(d, y) {
              if (typeof d != "function" || typeof y != "function") throw TypeError("Not a function");
              d(m);
            });
          }), n(x, "reject", function(m) {
            return new this(function(u, d) {
              if (typeof u != "function" || typeof d != "function") throw TypeError("Not a function");
              d(m);
            });
          }), n(x, "all", function(m) {
            var u = this;
            return i.call(m) != "[object Array]" ? u.reject(TypeError("Not an array")) : m.length === 0 ? u.resolve([]) : new u(function(d, y) {
              if (typeof d != "function" || typeof y != "function") throw TypeError("Not a function");
              var _ = m.length, T = Array(_), R = 0;
              f(u, m, function(I, P) {
                T[I] = P, ++R === _ && d(T);
              }, y);
            });
          }), n(x, "race", function(m) {
            var u = this;
            return i.call(m) != "[object Array]" ? u.reject(TypeError("Not an array")) : new u(function(d, y) {
              if (typeof d != "function" || typeof y != "function") throw TypeError("Not a function");
              f(u, m, function(_, T) {
                d(T);
              }, y);
            });
          }), x;
        });
      }), vr = xe((L, k) => {
        (function() {
          var n = { version: "3.8.2" }, e = [].slice, a = function(b) {
            return e.call(b);
          }, i = self.document;
          function o(b) {
            return b && (b.ownerDocument || b.document || b).documentElement;
          }
          function r(b) {
            return b && (b.ownerDocument && b.ownerDocument.defaultView || b.document && b || b.defaultView);
          }
          if (i) try {
            a(i.documentElement.childNodes)[0].nodeType;
          } catch {
            a = function(D) {
              for (var Q = D.length, oe = new Array(Q); Q--; ) oe[Q] = D[Q];
              return oe;
            };
          }
          if (Date.now || (Date.now = function() {
            return +/* @__PURE__ */ new Date();
          }), i) try {
            i.createElement("DIV").style.setProperty("opacity", 0, "");
          } catch {
            var s = this.Element.prototype, c = s.setAttribute, t = s.setAttributeNS, p = this.CSSStyleDeclaration.prototype, l = p.setProperty;
            s.setAttribute = function(D, Q) {
              c.call(this, D, Q + "");
            }, s.setAttributeNS = function(D, Q, oe) {
              t.call(this, D, Q, oe + "");
            }, p.setProperty = function(D, Q, oe) {
              l.call(this, D, Q + "", oe);
            };
          }
          n.ascending = f;
          function f(b, D) {
            return b < D ? -1 : b > D ? 1 : b >= D ? 0 : NaN;
          }
          n.descending = function(b, D) {
            return D < b ? -1 : D > b ? 1 : D >= b ? 0 : NaN;
          }, n.min = function(b, D) {
            var Q = -1, oe = b.length, ue, de;
            if (arguments.length === 1) {
              for (; ++Q < oe; ) if ((de = b[Q]) != null && de >= de) {
                ue = de;
                break;
              }
              for (; ++Q < oe; ) (de = b[Q]) != null && ue > de && (ue = de);
            } else {
              for (; ++Q < oe; ) if ((de = D.call(b, b[Q], Q)) != null && de >= de) {
                ue = de;
                break;
              }
              for (; ++Q < oe; ) (de = D.call(b, b[Q], Q)) != null && ue > de && (ue = de);
            }
            return ue;
          }, n.max = function(b, D) {
            var Q = -1, oe = b.length, ue, de;
            if (arguments.length === 1) {
              for (; ++Q < oe; ) if ((de = b[Q]) != null && de >= de) {
                ue = de;
                break;
              }
              for (; ++Q < oe; ) (de = b[Q]) != null && de > ue && (ue = de);
            } else {
              for (; ++Q < oe; ) if ((de = D.call(b, b[Q], Q)) != null && de >= de) {
                ue = de;
                break;
              }
              for (; ++Q < oe; ) (de = D.call(b, b[Q], Q)) != null && de > ue && (ue = de);
            }
            return ue;
          }, n.extent = function(b, D) {
            var Q = -1, oe = b.length, ue, de, we;
            if (arguments.length === 1) {
              for (; ++Q < oe; ) if ((de = b[Q]) != null && de >= de) {
                ue = we = de;
                break;
              }
              for (; ++Q < oe; ) (de = b[Q]) != null && (ue > de && (ue = de), we < de && (we = de));
            } else {
              for (; ++Q < oe; ) if ((de = D.call(b, b[Q], Q)) != null && de >= de) {
                ue = we = de;
                break;
              }
              for (; ++Q < oe; ) (de = D.call(b, b[Q], Q)) != null && (ue > de && (ue = de), we < de && (we = de));
            }
            return [ue, we];
          };
          function v(b) {
            return b === null ? NaN : +b;
          }
          function g(b) {
            return !isNaN(b);
          }
          n.sum = function(b, D) {
            var Q = 0, oe = b.length, ue, de = -1;
            if (arguments.length === 1) for (; ++de < oe; ) g(ue = +b[de]) && (Q += ue);
            else for (; ++de < oe; ) g(ue = +D.call(b, b[de], de)) && (Q += ue);
            return Q;
          }, n.mean = function(b, D) {
            var Q = 0, oe = b.length, ue, de = -1, we = oe;
            if (arguments.length === 1) for (; ++de < oe; ) g(ue = v(b[de])) ? Q += ue : --we;
            else for (; ++de < oe; ) g(ue = v(D.call(b, b[de], de))) ? Q += ue : --we;
            if (we) return Q / we;
          }, n.quantile = function(b, D) {
            var Q = (b.length - 1) * D + 1, oe = Math.floor(Q), ue = +b[oe - 1], de = Q - oe;
            return de ? ue + de * (b[oe] - ue) : ue;
          }, n.median = function(b, D) {
            var Q = [], oe = b.length, ue, de = -1;
            if (arguments.length === 1) for (; ++de < oe; ) g(ue = v(b[de])) && Q.push(ue);
            else for (; ++de < oe; ) g(ue = v(D.call(b, b[de], de))) && Q.push(ue);
            if (Q.length) return n.quantile(Q.sort(f), 0.5);
          }, n.variance = function(b, D) {
            var Q = b.length, oe = 0, ue, de, we = 0, me = -1, Le = 0;
            if (arguments.length === 1) for (; ++me < Q; ) g(ue = v(b[me])) && (de = ue - oe, oe += de / ++Le, we += de * (ue - oe));
            else for (; ++me < Q; ) g(ue = v(D.call(b, b[me], me))) && (de = ue - oe, oe += de / ++Le, we += de * (ue - oe));
            if (Le > 1) return we / (Le - 1);
          }, n.deviation = function() {
            var b = n.variance.apply(this, arguments);
            return b && Math.sqrt(b);
          };
          function x(b) {
            return { left: function(D, Q, oe, ue) {
              for (arguments.length < 3 && (oe = 0), arguments.length < 4 && (ue = D.length); oe < ue; ) {
                var de = oe + ue >>> 1;
                b(D[de], Q) < 0 ? oe = de + 1 : ue = de;
              }
              return oe;
            }, right: function(D, Q, oe, ue) {
              for (arguments.length < 3 && (oe = 0), arguments.length < 4 && (ue = D.length); oe < ue; ) {
                var de = oe + ue >>> 1;
                b(D[de], Q) > 0 ? ue = de : oe = de + 1;
              }
              return oe;
            } };
          }
          var h = x(f);
          n.bisectLeft = h.left, n.bisect = n.bisectRight = h.right, n.bisector = function(b) {
            return x(b.length === 1 ? function(D, Q) {
              return f(b(D), Q);
            } : b);
          }, n.shuffle = function(b, D, Q) {
            (oe = arguments.length) < 3 && (Q = b.length, oe < 2 && (D = 0));
            for (var oe = Q - D, ue, de; oe; ) de = Math.random() * oe-- | 0, ue = b[oe + D], b[oe + D] = b[de + D], b[de + D] = ue;
            return b;
          }, n.permute = function(b, D) {
            for (var Q = D.length, oe = new Array(Q); Q--; ) oe[Q] = b[D[Q]];
            return oe;
          }, n.pairs = function(b) {
            for (var D = 0, Q = b.length - 1, oe, ue = b[0], de = new Array(Q < 0 ? 0 : Q); D < Q; ) de[D] = [oe = ue, ue = b[++D]];
            return de;
          }, n.transpose = function(b) {
            if (!(de = b.length)) return [];
            for (var D = -1, Q = n.min(b, m), oe = new Array(Q); ++D < Q; ) for (var ue = -1, de, we = oe[D] = new Array(de); ++ue < de; ) we[ue] = b[ue][D];
            return oe;
          };
          function m(b) {
            return b.length;
          }
          n.zip = function() {
            return n.transpose(arguments);
          }, n.keys = function(b) {
            var D = [];
            for (var Q in b) D.push(Q);
            return D;
          }, n.values = function(b) {
            var D = [];
            for (var Q in b) D.push(b[Q]);
            return D;
          }, n.entries = function(b) {
            var D = [];
            for (var Q in b) D.push({ key: Q, value: b[Q] });
            return D;
          }, n.merge = function(b) {
            for (var D = b.length, Q, oe = -1, ue = 0, de, we; ++oe < D; ) ue += b[oe].length;
            for (de = new Array(ue); --D >= 0; ) for (we = b[D], Q = we.length; --Q >= 0; ) de[--ue] = we[Q];
            return de;
          };
          var u = Math.abs;
          n.range = function(b, D, Q) {
            if (arguments.length < 3 && (Q = 1, arguments.length < 2 && (D = b, b = 0)), (D - b) / Q === 1 / 0) throw new Error("infinite range");
            var oe = [], ue = d(u(Q)), de = -1, we;
            if (b *= ue, D *= ue, Q *= ue, Q < 0) for (; (we = b + Q * ++de) > D; ) oe.push(we / ue);
            else for (; (we = b + Q * ++de) < D; ) oe.push(we / ue);
            return oe;
          };
          function d(b) {
            for (var D = 1; b * D % 1; ) D *= 10;
            return D;
          }
          function y(b, D) {
            for (var Q in D) Object.defineProperty(b.prototype, Q, { value: D[Q], enumerable: !1 });
          }
          n.map = function(b, D) {
            var Q = new _();
            if (b instanceof _) b.forEach(function(me, Le) {
              Q.set(me, Le);
            });
            else if (Array.isArray(b)) {
              var oe = -1, ue = b.length, de;
              if (arguments.length === 1) for (; ++oe < ue; ) Q.set(oe, b[oe]);
              else for (; ++oe < ue; ) Q.set(D.call(b, de = b[oe], oe), de);
            } else for (var we in b) Q.set(we, b[we]);
            return Q;
          };
          function _() {
            this._ = /* @__PURE__ */ Object.create(null);
          }
          var T = "__proto__", R = "\0";
          y(_, { has: M, get: function(b) {
            return this._[I(b)];
          }, set: function(b, D) {
            return this._[I(b)] = D;
          }, remove: B, keys: z, values: function() {
            var b = [];
            for (var D in this._) b.push(this._[D]);
            return b;
          }, entries: function() {
            var b = [];
            for (var D in this._) b.push({ key: P(D), value: this._[D] });
            return b;
          }, size: q, empty: U, forEach: function(b) {
            for (var D in this._) b.call(this, P(D), this._[D]);
          } });
          function I(b) {
            return (b += "") === T || b[0] === R ? R + b : b;
          }
          function P(b) {
            return (b += "")[0] === R ? b.slice(1) : b;
          }
          function M(b) {
            return I(b) in this._;
          }
          function B(b) {
            return (b = I(b)) in this._ && delete this._[b];
          }
          function z() {
            var b = [];
            for (var D in this._) b.push(P(D));
            return b;
          }
          function q() {
            var b = 0;
            for (var D in this._) ++b;
            return b;
          }
          function U() {
            for (var b in this._) return !1;
            return !0;
          }
          n.nest = function() {
            var b = {}, D = [], Q = [], oe, ue;
            function de(me, Le, Fe) {
              if (Fe >= D.length) return ue ? ue.call(b, Le) : oe ? Le.sort(oe) : Le;
              for (var Be = -1, et = Le.length, rt = D[Fe++], pt, bt, nt, ut = new _(), ft; ++Be < et; ) (ft = ut.get(pt = rt(bt = Le[Be]))) ? ft.push(bt) : ut.set(pt, [bt]);
              return me ? (bt = me(), nt = function(yt, mt) {
                bt.set(yt, de(me, mt, Fe));
              }) : (bt = {}, nt = function(yt, mt) {
                bt[yt] = de(me, mt, Fe);
              }), ut.forEach(nt), bt;
            }
            function we(me, Le) {
              if (Le >= D.length) return me;
              var Fe = [], Be = Q[Le++];
              return me.forEach(function(et, rt) {
                Fe.push({ key: et, values: we(rt, Le) });
              }), Be ? Fe.sort(function(et, rt) {
                return Be(et.key, rt.key);
              }) : Fe;
            }
            return b.map = function(me, Le) {
              return de(Le, me, 0);
            }, b.entries = function(me) {
              return we(de(n.map, me, 0), 0);
            }, b.key = function(me) {
              return D.push(me), b;
            }, b.sortKeys = function(me) {
              return Q[D.length - 1] = me, b;
            }, b.sortValues = function(me) {
              return oe = me, b;
            }, b.rollup = function(me) {
              return ue = me, b;
            }, b;
          }, n.set = function(b) {
            var D = new G();
            if (b) for (var Q = 0, oe = b.length; Q < oe; ++Q) D.add(b[Q]);
            return D;
          };
          function G() {
            this._ = /* @__PURE__ */ Object.create(null);
          }
          y(G, { has: M, add: function(b) {
            return this._[I(b += "")] = !0, b;
          }, remove: B, values: z, size: q, empty: U, forEach: function(b) {
            for (var D in this._) b.call(this, P(D));
          } }), n.behavior = {};
          function K(b) {
            return b;
          }
          n.rebind = function(b, D) {
            for (var Q = 1, oe = arguments.length, ue; ++Q < oe; ) b[ue = arguments[Q]] = te(b, D, D[ue]);
            return b;
          };
          function te(b, D, Q) {
            return function() {
              var oe = Q.apply(D, arguments);
              return oe === D ? b : oe;
            };
          }
          function V(b, D) {
            if (D in b) return D;
            D = D.charAt(0).toUpperCase() + D.slice(1);
            for (var Q = 0, oe = Z.length; Q < oe; ++Q) {
              var ue = Z[Q] + D;
              if (ue in b) return ue;
            }
          }
          var Z = ["webkit", "ms", "moz", "Moz", "o", "O"];
          function Y() {
          }
          n.dispatch = function() {
            for (var b = new C(), D = -1, Q = arguments.length; ++D < Q; ) b[arguments[D]] = j(b);
            return b;
          };
          function C() {
          }
          C.prototype.on = function(b, D) {
            var Q = b.indexOf("."), oe = "";
            if (Q >= 0 && (oe = b.slice(Q + 1), b = b.slice(0, Q)), b) return arguments.length < 2 ? this[b].on(oe) : this[b].on(oe, D);
            if (arguments.length === 2) {
              if (D == null) for (b in this) this.hasOwnProperty(b) && this[b].on(oe, null);
              return this;
            }
          };
          function j(b) {
            var D = [], Q = new _();
            function oe() {
              for (var ue = D, de = -1, we = ue.length, me; ++de < we; ) (me = ue[de].on) && me.apply(this, arguments);
              return b;
            }
            return oe.on = function(ue, de) {
              var we = Q.get(ue), me;
              return arguments.length < 2 ? we && we.on : (we && (we.on = null, D = D.slice(0, me = D.indexOf(we)).concat(D.slice(me + 1)), Q.remove(ue)), de && D.push(Q.set(ue, { on: de })), b);
            }, oe;
          }
          n.event = null;
          function J() {
            n.event.preventDefault();
          }
          function ne() {
            for (var b = n.event, D; D = b.sourceEvent; ) b = D;
            return b;
          }
          function ae(b) {
            for (var D = new C(), Q = 0, oe = arguments.length; ++Q < oe; ) D[arguments[Q]] = j(D);
            return D.of = function(ue, de) {
              return function(we) {
                try {
                  var me = we.sourceEvent = n.event;
                  we.target = b, n.event = we, D[we.type].apply(ue, de);
                } finally {
                  n.event = me;
                }
              };
            }, D;
          }
          n.requote = function(b) {
            return b.replace(se, "\\$&");
          };
          var se = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, O = {}.__proto__ ? function(b, D) {
            b.__proto__ = D;
          } : function(b, D) {
            for (var Q in D) b[Q] = D[Q];
          };
          function F(b) {
            return O(b, E), b;
          }
          var S = function(b, D) {
            return D.querySelector(b);
          }, $ = function(b, D) {
            return D.querySelectorAll(b);
          }, re = function(b, D) {
            var Q = b.matches || b[V(b, "matchesSelector")];
            return re = function(oe, ue) {
              return Q.call(oe, ue);
            }, re(b, D);
          };
          typeof Sizzle == "function" && (S = function(b, D) {
            return Sizzle(b, D)[0] || null;
          }, $ = Sizzle, re = Sizzle.matchesSelector), n.selection = function() {
            return n.select(i.documentElement);
          };
          var E = n.selection.prototype = [];
          E.select = function(b) {
            var D = [], Q, oe, ue, de;
            b = w(b);
            for (var we = -1, me = this.length; ++we < me; ) {
              D.push(Q = []), Q.parentNode = (ue = this[we]).parentNode;
              for (var Le = -1, Fe = ue.length; ++Le < Fe; ) (de = ue[Le]) ? (Q.push(oe = b.call(de, de.__data__, Le, we)), oe && "__data__" in de && (oe.__data__ = de.__data__)) : Q.push(null);
            }
            return F(D);
          };
          function w(b) {
            return typeof b == "function" ? b : function() {
              return S(b, this);
            };
          }
          E.selectAll = function(b) {
            var D = [], Q, oe;
            b = N(b);
            for (var ue = -1, de = this.length; ++ue < de; ) for (var we = this[ue], me = -1, Le = we.length; ++me < Le; ) (oe = we[me]) && (D.push(Q = a(b.call(oe, oe.__data__, me, ue))), Q.parentNode = oe);
            return F(D);
          };
          function N(b) {
            return typeof b == "function" ? b : function() {
              return $(b, this);
            };
          }
          var W = "http://www.w3.org/1999/xhtml", ee = { svg: "http://www.w3.org/2000/svg", xhtml: W, xlink: "http://www.w3.org/1999/xlink", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/" };
          n.ns = { prefix: ee, qualify: function(b) {
            var D = b.indexOf(":"), Q = b;
            return D >= 0 && (Q = b.slice(0, D)) !== "xmlns" && (b = b.slice(D + 1)), ee.hasOwnProperty(Q) ? { space: ee[Q], local: b } : b;
          } }, E.attr = function(b, D) {
            if (arguments.length < 2) {
              if (typeof b == "string") {
                var Q = this.node();
                return b = n.ns.qualify(b), b.local ? Q.getAttributeNS(b.space, b.local) : Q.getAttribute(b);
              }
              for (D in b) this.each(le(D, b[D]));
              return this;
            }
            return this.each(le(b, D));
          };
          function le(b, D) {
            b = n.ns.qualify(b);
            function Q() {
              this.removeAttribute(b);
            }
            function oe() {
              this.removeAttributeNS(b.space, b.local);
            }
            function ue() {
              this.setAttribute(b, D);
            }
            function de() {
              this.setAttributeNS(b.space, b.local, D);
            }
            function we() {
              var Le = D.apply(this, arguments);
              Le == null ? this.removeAttribute(b) : this.setAttribute(b, Le);
            }
            function me() {
              var Le = D.apply(this, arguments);
              Le == null ? this.removeAttributeNS(b.space, b.local) : this.setAttributeNS(b.space, b.local, Le);
            }
            return D == null ? b.local ? oe : Q : typeof D == "function" ? b.local ? me : we : b.local ? de : ue;
          }
          function ie(b) {
            return b.trim().replace(/\s+/g, " ");
          }
          E.classed = function(b, D) {
            if (arguments.length < 2) {
              if (typeof b == "string") {
                var Q = this.node(), oe = (b = _e(b)).length, ue = -1;
                if (D = Q.classList) {
                  for (; ++ue < oe; ) if (!D.contains(b[ue])) return !1;
                } else for (D = Q.getAttribute("class"); ++ue < oe; ) if (!pe(b[ue]).test(D)) return !1;
                return !0;
              }
              for (D in b) this.each(Ae(D, b[D]));
              return this;
            }
            return this.each(Ae(b, D));
          };
          function pe(b) {
            return new RegExp("(?:^|\\s+)" + n.requote(b) + "(?:\\s+|$)", "g");
          }
          function _e(b) {
            return (b + "").trim().split(/^|\s+/);
          }
          function Ae(b, D) {
            b = _e(b).map(Ce);
            var Q = b.length;
            function oe() {
              for (var de = -1; ++de < Q; ) b[de](this, D);
            }
            function ue() {
              for (var de = -1, we = D.apply(this, arguments); ++de < Q; ) b[de](this, we);
            }
            return typeof D == "function" ? ue : oe;
          }
          function Ce(b) {
            var D = pe(b);
            return function(Q, oe) {
              if (ue = Q.classList) return oe ? ue.add(b) : ue.remove(b);
              var ue = Q.getAttribute("class") || "";
              oe ? (D.lastIndex = 0, D.test(ue) || Q.setAttribute("class", ie(ue + " " + b))) : Q.setAttribute("class", ie(ue.replace(D, " ")));
            };
          }
          E.style = function(b, D, Q) {
            var oe = arguments.length;
            if (oe < 3) {
              if (typeof b != "string") {
                oe < 2 && (D = "");
                for (Q in b) this.each(Ue(Q, b[Q], D));
                return this;
              }
              if (oe < 2) {
                var ue = this.node();
                return r(ue).getComputedStyle(ue, null).getPropertyValue(b);
              }
              Q = "";
            }
            return this.each(Ue(b, D, Q));
          };
          function Ue(b, D, Q) {
            function oe() {
              this.style.removeProperty(b);
            }
            function ue() {
              this.style.setProperty(b, D, Q);
            }
            function de() {
              var we = D.apply(this, arguments);
              we == null ? this.style.removeProperty(b) : this.style.setProperty(b, we, Q);
            }
            return D == null ? oe : typeof D == "function" ? de : ue;
          }
          E.property = function(b, D) {
            if (arguments.length < 2) {
              if (typeof b == "string") return this.node()[b];
              for (D in b) this.each(Ne(D, b[D]));
              return this;
            }
            return this.each(Ne(b, D));
          };
          function Ne(b, D) {
            function Q() {
              delete this[b];
            }
            function oe() {
              this[b] = D;
            }
            function ue() {
              var de = D.apply(this, arguments);
              de == null ? delete this[b] : this[b] = de;
            }
            return D == null ? Q : typeof D == "function" ? ue : oe;
          }
          E.text = function(b) {
            return arguments.length ? this.each(typeof b == "function" ? function() {
              var D = b.apply(this, arguments);
              this.textContent = D ?? "";
            } : b == null ? function() {
              this.textContent = "";
            } : function() {
              this.textContent = b;
            }) : this.node().textContent;
          }, E.html = function(b) {
            return arguments.length ? this.each(typeof b == "function" ? function() {
              var D = b.apply(this, arguments);
              this.innerHTML = D ?? "";
            } : b == null ? function() {
              this.innerHTML = "";
            } : function() {
              this.innerHTML = b;
            }) : this.node().innerHTML;
          }, E.append = function(b) {
            return b = ke(b), this.select(function() {
              return this.appendChild(b.apply(this, arguments));
            });
          };
          function ke(b) {
            function D() {
              var oe = this.ownerDocument, ue = this.namespaceURI;
              return ue === W && oe.documentElement.namespaceURI === W ? oe.createElement(b) : oe.createElementNS(ue, b);
            }
            function Q() {
              return this.ownerDocument.createElementNS(b.space, b.local);
            }
            return typeof b == "function" ? b : (b = n.ns.qualify(b)).local ? Q : D;
          }
          E.insert = function(b, D) {
            return b = ke(b), D = w(D), this.select(function() {
              return this.insertBefore(b.apply(this, arguments), D.apply(this, arguments) || null);
            });
          }, E.remove = function() {
            return this.each(A);
          };
          function A() {
            var b = this.parentNode;
            b && b.removeChild(this);
          }
          E.data = function(b, D) {
            var Q = -1, oe = this.length, ue, de;
            if (!arguments.length) {
              for (b = new Array(oe = (ue = this[0]).length); ++Q < oe; ) (de = ue[Q]) && (b[Q] = de.__data__);
              return b;
            }
            function we(Be, et) {
              var rt, pt = Be.length, bt = et.length, nt = Math.min(pt, bt), ut = new Array(bt), ft = new Array(bt), yt = new Array(pt), mt, dt;
              if (D) {
                var zt = new _(), Zt = new Array(pt), Jt;
                for (rt = -1; ++rt < pt; ) (mt = Be[rt]) && (zt.has(Jt = D.call(mt, mt.__data__, rt)) ? yt[rt] = mt : zt.set(Jt, mt), Zt[rt] = Jt);
                for (rt = -1; ++rt < bt; ) (mt = zt.get(Jt = D.call(et, dt = et[rt], rt))) ? mt !== !0 && (ut[rt] = mt, mt.__data__ = dt) : ft[rt] = X(dt), zt.set(Jt, !0);
                for (rt = -1; ++rt < pt; ) rt in Zt && zt.get(Zt[rt]) !== !0 && (yt[rt] = Be[rt]);
              } else {
                for (rt = -1; ++rt < nt; ) mt = Be[rt], dt = et[rt], mt ? (mt.__data__ = dt, ut[rt] = mt) : ft[rt] = X(dt);
                for (; rt < bt; ++rt) ft[rt] = X(et[rt]);
                for (; rt < pt; ++rt) yt[rt] = Be[rt];
              }
              ft.update = ut, ft.parentNode = ut.parentNode = yt.parentNode = Be.parentNode, me.push(ft), Le.push(ut), Fe.push(yt);
            }
            var me = Se([]), Le = F([]), Fe = F([]);
            if (typeof b == "function") for (; ++Q < oe; ) we(ue = this[Q], b.call(ue, ue.parentNode.__data__, Q));
            else for (; ++Q < oe; ) we(ue = this[Q], b);
            return Le.enter = function() {
              return me;
            }, Le.exit = function() {
              return Fe;
            }, Le;
          };
          function X(b) {
            return { __data__: b };
          }
          E.datum = function(b) {
            return arguments.length ? this.property("__data__", b) : this.property("__data__");
          }, E.filter = function(b) {
            var D = [], Q, oe, ue;
            typeof b != "function" && (b = H(b));
            for (var de = 0, we = this.length; de < we; de++) {
              D.push(Q = []), Q.parentNode = (oe = this[de]).parentNode;
              for (var me = 0, Le = oe.length; me < Le; me++) (ue = oe[me]) && b.call(ue, ue.__data__, me, de) && Q.push(ue);
            }
            return F(D);
          };
          function H(b) {
            return function() {
              return re(this, b);
            };
          }
          E.order = function() {
            for (var b = -1, D = this.length; ++b < D; ) for (var Q = this[b], oe = Q.length - 1, ue = Q[oe], de; --oe >= 0; ) (de = Q[oe]) && (ue && ue !== de.nextSibling && ue.parentNode.insertBefore(de, ue), ue = de);
            return this;
          }, E.sort = function(b) {
            b = ve.apply(this, arguments);
            for (var D = -1, Q = this.length; ++D < Q; ) this[D].sort(b);
            return this.order();
          };
          function ve(b) {
            return arguments.length || (b = f), function(D, Q) {
              return D && Q ? b(D.__data__, Q.__data__) : !D - !Q;
            };
          }
          E.each = function(b) {
            return be(this, function(D, Q, oe) {
              b.call(D, D.__data__, Q, oe);
            });
          };
          function be(b, D) {
            for (var Q = 0, oe = b.length; Q < oe; Q++) for (var ue = b[Q], de = 0, we = ue.length, me; de < we; de++) (me = ue[de]) && D(me, de, Q);
            return b;
          }
          E.call = function(b) {
            var D = a(arguments);
            return b.apply(D[0] = this, D), this;
          }, E.empty = function() {
            return !this.node();
          }, E.node = function() {
            for (var b = 0, D = this.length; b < D; b++) for (var Q = this[b], oe = 0, ue = Q.length; oe < ue; oe++) {
              var de = Q[oe];
              if (de) return de;
            }
            return null;
          }, E.size = function() {
            var b = 0;
            return be(this, function() {
              ++b;
            }), b;
          };
          function Se(b) {
            return O(b, De), b;
          }
          var De = [];
          n.selection.enter = Se, n.selection.enter.prototype = De, De.append = E.append, De.empty = E.empty, De.node = E.node, De.call = E.call, De.size = E.size, De.select = function(b) {
            for (var D = [], Q, oe, ue, de, we, me = -1, Le = this.length; ++me < Le; ) {
              ue = (de = this[me]).update, D.push(Q = []), Q.parentNode = de.parentNode;
              for (var Fe = -1, Be = de.length; ++Fe < Be; ) (we = de[Fe]) ? (Q.push(ue[Fe] = oe = b.call(de.parentNode, we.__data__, Fe, me)), oe.__data__ = we.__data__) : Q.push(null);
            }
            return F(D);
          }, De.insert = function(b, D) {
            return arguments.length < 2 && (D = He(this)), E.insert.call(this, b, D);
          };
          function He(b) {
            var D, Q;
            return function(oe, ue, de) {
              var we = b[de].update, me = we.length, Le;
              for (de != Q && (Q = de, D = 0), ue >= D && (D = ue + 1); !(Le = we[D]) && ++D < me; ) ;
              return Le;
            };
          }
          n.select = function(b) {
            var D;
            return typeof b == "string" ? (D = [S(b, i)], D.parentNode = i.documentElement) : (D = [b], D.parentNode = o(b)), F([D]);
          }, n.selectAll = function(b) {
            var D;
            return typeof b == "string" ? (D = a($(b, i)), D.parentNode = i.documentElement) : (D = a(b), D.parentNode = null), F([D]);
          }, E.on = function(b, D, Q) {
            var oe = arguments.length;
            if (oe < 3) {
              if (typeof b != "string") {
                oe < 2 && (D = !1);
                for (Q in b) this.each(Ze(Q, b[Q], D));
                return this;
              }
              if (oe < 2) return (oe = this.node()["__on" + b]) && oe._;
              Q = !1;
            }
            return this.each(Ze(b, D, Q));
          };
          function Ze(b, D, Q) {
            var oe = "__on" + b, ue = b.indexOf("."), de = $e;
            ue > 0 && (b = b.slice(0, ue));
            var we = We.get(b);
            we && (b = we, de = it);
            function me() {
              var Be = this[oe];
              Be && (this.removeEventListener(b, Be, Be.$), delete this[oe]);
            }
            function Le() {
              var Be = de(D, a(arguments));
              me.call(this), this.addEventListener(b, this[oe] = Be, Be.$ = Q), Be._ = D;
            }
            function Fe() {
              var Be = new RegExp("^__on([^.]+)" + n.requote(b) + "$"), et;
              for (var rt in this) if (et = rt.match(Be)) {
                var pt = this[rt];
                this.removeEventListener(et[1], pt, pt.$), delete this[rt];
              }
            }
            return ue ? D ? Le : me : D ? Y : Fe;
          }
          var We = n.map({ mouseenter: "mouseover", mouseleave: "mouseout" });
          i && We.forEach(function(b) {
            "on" + b in i && We.remove(b);
          });
          function $e(b, D) {
            return function(Q) {
              var oe = n.event;
              n.event = Q, D[0] = this.__data__;
              try {
                b.apply(this, D);
              } finally {
                n.event = oe;
              }
            };
          }
          function it(b, D) {
            var Q = $e(b, D);
            return function(oe) {
              var ue = this, de = oe.relatedTarget;
              (!de || de !== ue && !(de.compareDocumentPosition(ue) & 8)) && Q.call(ue, oe);
            };
          }
          var Ke, ct = 0;
          function gt(b) {
            var D = ".dragsuppress-" + ++ct, Q = "click" + D, oe = n.select(r(b)).on("touchmove" + D, J).on("dragstart" + D, J).on("selectstart" + D, J);
            if (Ke == null && (Ke = "onselectstart" in b ? !1 : V(b.style, "userSelect")), Ke) {
              var ue = o(b).style, de = ue[Ke];
              ue[Ke] = "none";
            }
            return function(we) {
              if (oe.on(D, null), Ke && (ue[Ke] = de), we) {
                var me = function() {
                  oe.on(Q, null);
                };
                oe.on(Q, function() {
                  J(), me();
                }, !0), setTimeout(me, 0);
              }
            };
          }
          n.mouse = function(b) {
            return _t(b, ne());
          };
          var ht = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
          function _t(b, D) {
            D.changedTouches && (D = D.changedTouches[0]);
            var Q = b.ownerSVGElement || b;
            if (Q.createSVGPoint) {
              var oe = Q.createSVGPoint();
              if (ht < 0) {
                var ue = r(b);
                if (ue.scrollX || ue.scrollY) {
                  Q = n.select("body").append("svg").style({ position: "absolute", top: 0, left: 0, margin: 0, padding: 0, border: "none" }, "important");
                  var de = Q[0][0].getScreenCTM();
                  ht = !(de.f || de.e), Q.remove();
                }
              }
              return ht ? (oe.x = D.pageX, oe.y = D.pageY) : (oe.x = D.clientX, oe.y = D.clientY), oe = oe.matrixTransform(b.getScreenCTM().inverse()), [oe.x, oe.y];
            }
            var we = b.getBoundingClientRect();
            return [D.clientX - we.left - b.clientLeft, D.clientY - we.top - b.clientTop];
          }
          n.touch = function(b, D, Q) {
            if (arguments.length < 3 && (Q = D, D = ne().changedTouches), D) {
              for (var oe = 0, ue = D.length, de; oe < ue; ++oe) if ((de = D[oe]).identifier === Q) return _t(b, de);
            }
          }, n.behavior.drag = function() {
            var b = ae(ue, "drag", "dragstart", "dragend"), D = null, Q = de(Y, n.mouse, r, "mousemove", "mouseup"), oe = de(Te, n.touch, K, "touchmove", "touchend");
            function ue() {
              this.on("mousedown.drag", Q).on("touchstart.drag", oe);
            }
            function de(we, me, Le, Fe, Be) {
              return function() {
                var et = this, rt = n.event.target.correspondingElement || n.event.target, pt = et.parentNode, bt = b.of(et, arguments), nt = 0, ut = we(), ft = ".drag" + (ut == null ? "" : "-" + ut), yt, mt = n.select(Le(rt)).on(Fe + ft, Zt).on(Be + ft, Jt), dt = gt(rt), zt = me(pt, ut);
                D ? (yt = D.apply(et, arguments), yt = [yt.x - zt[0], yt.y - zt[1]]) : yt = [0, 0], bt({ type: "dragstart" });
                function Zt() {
                  var Xt = me(pt, ut), er, tr;
                  Xt && (er = Xt[0] - zt[0], tr = Xt[1] - zt[1], nt |= er | tr, zt = Xt, bt({ type: "drag", x: Xt[0] + yt[0], y: Xt[1] + yt[1], dx: er, dy: tr }));
                }
                function Jt() {
                  me(pt, ut) && (mt.on(Fe + ft, null).on(Be + ft, null), dt(nt), bt({ type: "dragend" }));
                }
              };
            }
            return ue.origin = function(we) {
              return arguments.length ? (D = we, ue) : D;
            }, n.rebind(ue, b, "on");
          };
          function Te() {
            return n.event.changedTouches[0].identifier;
          }
          n.touches = function(b, D) {
            return arguments.length < 2 && (D = ne().touches), D ? a(D).map(function(Q) {
              var oe = _t(b, Q);
              return oe.identifier = Q.identifier, oe;
            }) : [];
          };
          var Ie = 1e-6, ce = Ie * Ie, ge = Math.PI, ye = 2 * ge, Me = ye - Ie, Oe = ge / 2, je = ge / 180, qe = 180 / ge;
          function Qe(b, D, Q) {
            return (D[0] - b[0]) * (Q[1] - b[1]) - (D[1] - b[1]) * (Q[0] - b[0]);
          }
          function Xe(b) {
            return b > 1 ? Oe : b < -1 ? -Oe : Math.asin(b);
          }
          function Je(b) {
            return ((b = Math.exp(b)) - 1 / b) / 2;
          }
          function ot(b) {
            return ((b = Math.exp(b)) + 1 / b) / 2;
          }
          function lt(b) {
            return ((b = Math.exp(2 * b)) - 1) / (b + 1);
          }
          var st = Math.SQRT2, xt = 2, Et = 4;
          n.interpolateZoom = function(b, D) {
            var Q = b[0], oe = b[1], ue = b[2], de = D[0], we = D[1], me = D[2], Le = de - Q, Fe = we - oe, Be = Le * Le + Fe * Fe, et, rt;
            if (Be < ce) rt = Math.log(me / ue) / st, et = function(yt) {
              return [Q + yt * Le, oe + yt * Fe, ue * Math.exp(st * yt * rt)];
            };
            else {
              var pt = Math.sqrt(Be), bt = (me * me - ue * ue + Et * Be) / (2 * ue * xt * pt), nt = (me * me - ue * ue - Et * Be) / (2 * me * xt * pt), ut = Math.log(Math.sqrt(bt * bt + 1) - bt), ft = Math.log(Math.sqrt(nt * nt + 1) - nt);
              rt = (ft - ut) / st, et = function(yt) {
                var mt = yt * rt, dt = ot(ut), zt = ue / (xt * pt) * (dt * lt(st * mt + ut) - Je(ut));
                return [Q + zt * Le, oe + zt * Fe, ue * dt / ot(st * mt + ut)];
              };
            }
            return et.duration = rt * 1e3, et;
          }, n.behavior.zoom = function() {
            var b = { x: 0, y: 0, k: 1 }, D, Q, oe, ue = [960, 500], de = Bt, we = 250, me = 0, Le = "mousedown.zoom", Fe = "mousemove.zoom", Be = "mouseup.zoom", et, rt = "touchstart.zoom", pt, bt = ae(mt, "zoomstart", "zoom", "zoomend"), nt, ut, ft, yt;
            jt || (jt = "onwheel" in i ? (qt = function() {
              return -n.event.deltaY * (n.event.deltaMode ? 120 : 1);
            }, "wheel") : "onmousewheel" in i ? (qt = function() {
              return n.event.wheelDelta;
            }, "mousewheel") : (qt = function() {
              return -n.event.detail;
            }, "MozMousePixelScroll"));
            function mt(Gt) {
              Gt.on(Le, pr).on(jt + ".zoom", an).on("dblclick.zoom", Fr).on(rt, zr);
            }
            mt.event = function(Gt) {
              Gt.each(function() {
                var yr = bt.of(this, arguments), wr = b;
                Ca ? n.select(this).transition().each("start.zoom", function() {
                  b = this.__chart__ || { x: 0, y: 0, k: 1 }, tr(yr);
                }).tween("zoom:zoom", function() {
                  var Rr = ue[0], Qr = ue[1], pn = Q ? Q[0] : Rr / 2, bn = Q ? Q[1] : Qr / 2, Ln = n.interpolateZoom([(pn - b.x) / b.k, (bn - b.y) / b.k, Rr / b.k], [(pn - wr.x) / wr.k, (bn - wr.y) / wr.k, Rr / wr.k]);
                  return function(Dn) {
                    var On = Ln(Dn), zn = Rr / On[2];
                    this.__chart__ = b = { x: pn - On[0] * zn, y: bn - On[1] * zn, k: zn }, gr(yr);
                  };
                }).each("interrupt.zoom", function() {
                  ir(yr);
                }).each("end.zoom", function() {
                  ir(yr);
                }) : (this.__chart__ = b, tr(yr), gr(yr), ir(yr));
              });
            }, mt.translate = function(Gt) {
              return arguments.length ? (b = { x: +Gt[0], y: +Gt[1], k: b.k }, er(), mt) : [b.x, b.y];
            }, mt.scale = function(Gt) {
              return arguments.length ? (b = { x: b.x, y: b.y, k: null }, Zt(+Gt), er(), mt) : b.k;
            }, mt.scaleExtent = function(Gt) {
              return arguments.length ? (de = Gt == null ? Bt : [+Gt[0], +Gt[1]], mt) : de;
            }, mt.center = function(Gt) {
              return arguments.length ? (oe = Gt && [+Gt[0], +Gt[1]], mt) : oe;
            }, mt.size = function(Gt) {
              return arguments.length ? (ue = Gt && [+Gt[0], +Gt[1]], mt) : ue;
            }, mt.duration = function(Gt) {
              return arguments.length ? (we = +Gt, mt) : we;
            }, mt.x = function(Gt) {
              return arguments.length ? (ut = Gt, nt = Gt.copy(), b = { x: 0, y: 0, k: 1 }, mt) : ut;
            }, mt.y = function(Gt) {
              return arguments.length ? (yt = Gt, ft = Gt.copy(), b = { x: 0, y: 0, k: 1 }, mt) : yt;
            };
            function dt(Gt) {
              return [(Gt[0] - b.x) / b.k, (Gt[1] - b.y) / b.k];
            }
            function zt(Gt) {
              return [Gt[0] * b.k + b.x, Gt[1] * b.k + b.y];
            }
            function Zt(Gt) {
              b.k = Math.max(de[0], Math.min(de[1], Gt));
            }
            function Jt(Gt, yr) {
              yr = zt(yr), b.x += Gt[0] - yr[0], b.y += Gt[1] - yr[1];
            }
            function Xt(Gt, yr, wr, Rr) {
              Gt.__chart__ = { x: b.x, y: b.y, k: b.k }, Zt(Math.pow(2, Rr)), Jt(Q = yr, wr), Gt = n.select(Gt), we > 0 && (Gt = Gt.transition().duration(we)), Gt.call(mt.event);
            }
            function er() {
              ut && ut.domain(nt.range().map(function(Gt) {
                return (Gt - b.x) / b.k;
              }).map(nt.invert)), yt && yt.domain(ft.range().map(function(Gt) {
                return (Gt - b.y) / b.k;
              }).map(ft.invert));
            }
            function tr(Gt) {
              me++ || Gt({ type: "zoomstart" });
            }
            function gr(Gt) {
              er(), Gt({ type: "zoom", scale: b.k, translate: [b.x, b.y] });
            }
            function ir(Gt) {
              --me || (Gt({ type: "zoomend" }), Q = null);
            }
            function pr() {
              var Gt = this, yr = bt.of(Gt, arguments), wr = 0, Rr = n.select(r(Gt)).on(Fe, bn).on(Be, Ln), Qr = dt(n.mouse(Gt)), pn = gt(Gt);
              Qi.call(Gt), tr(yr);
              function bn() {
                wr = 1, Jt(n.mouse(Gt), Qr), gr(yr);
              }
              function Ln() {
                Rr.on(Fe, null).on(Be, null), pn(wr), ir(yr);
              }
            }
            function zr() {
              var Gt = this, yr = bt.of(Gt, arguments), wr = {}, Rr = 0, Qr, pn = ".zoom-" + n.event.changedTouches[0].identifier, bn = "touchmove" + pn, Ln = "touchend" + pn, Dn = [], On = n.select(Gt), zn = gt(Gt);
              Rn(), tr(yr), On.on(Le, null).on(rt, Rn);
              function Tn() {
                var ea = n.touches(Gt);
                return Qr = b.k, ea.forEach(function(_n) {
                  _n.identifier in wr && (wr[_n.identifier] = dt(_n));
                }), ea;
              }
              function Rn() {
                var ea = n.event.target;
                n.select(ea).on(bn, Ea).on(Ln, Kg), Dn.push(ea);
                for (var _n = n.event.changedTouches, Yn = 0, sa = _n.length; Yn < sa; ++Yn) wr[_n[Yn].identifier] = null;
                var Gn = Tn(), Ga = Date.now();
                if (Gn.length === 1) {
                  if (Ga - pt < 500) {
                    var Da = Gn[0];
                    Xt(Gt, Da, wr[Da.identifier], Math.floor(Math.log(b.k) / Math.LN2) + 1), J();
                  }
                  pt = Ga;
                } else if (Gn.length > 1) {
                  var Da = Gn[0], wa = Gn[1], ro = Da[0] - wa[0], vf = Da[1] - wa[1];
                  Rr = ro * ro + vf * vf;
                }
              }
              function Ea() {
                var ea = n.touches(Gt), _n, Yn, sa, Gn;
                Qi.call(Gt);
                for (var Ga = 0, Da = ea.length; Ga < Da; ++Ga, Gn = null) if (sa = ea[Ga], Gn = wr[sa.identifier]) {
                  if (Yn) break;
                  _n = sa, Yn = Gn;
                }
                if (Gn) {
                  var wa = (wa = sa[0] - _n[0]) * wa + (wa = sa[1] - _n[1]) * wa, ro = Rr && Math.sqrt(wa / Rr);
                  _n = [(_n[0] + sa[0]) / 2, (_n[1] + sa[1]) / 2], Yn = [(Yn[0] + Gn[0]) / 2, (Yn[1] + Gn[1]) / 2], Zt(ro * Qr);
                }
                pt = null, Jt(_n, Yn), gr(yr);
              }
              function Kg() {
                if (n.event.touches.length) {
                  for (var ea = n.event.changedTouches, _n = 0, Yn = ea.length; _n < Yn; ++_n) delete wr[ea[_n].identifier];
                  for (var sa in wr) return void Tn();
                }
                n.selectAll(Dn).on(pn, null), On.on(Le, pr).on(rt, zr), zn(), ir(yr);
              }
            }
            function an() {
              var Gt = bt.of(this, arguments);
              et ? clearTimeout(et) : (Qi.call(this), D = dt(Q = oe || n.mouse(this)), tr(Gt)), et = setTimeout(function() {
                et = null, ir(Gt);
              }, 50), J(), Zt(Math.pow(2, qt() * 2e-3) * b.k), Jt(Q, D), gr(Gt);
            }
            function Fr() {
              var Gt = n.mouse(this), yr = Math.log(b.k) / Math.LN2;
              Xt(this, Gt, dt(Gt), n.event.shiftKey ? Math.ceil(yr) - 1 : Math.floor(yr) + 1);
            }
            return n.rebind(mt, bt, "on");
          };
          var Bt = [0, 1 / 0], qt, jt;
          n.color = It;
          function It() {
          }
          It.prototype.toString = function() {
            return this.rgb() + "";
          }, n.hsl = Tt;
          function Tt(b, D, Q) {
            return this instanceof Tt ? (this.h = +b, this.s = +D, void (this.l = +Q)) : arguments.length < 2 ? b instanceof Tt ? new Tt(b.h, b.s, b.l) : Re("" + b, Ye, Tt) : new Tt(b, D, Q);
          }
          var Rt = Tt.prototype = new It();
          Rt.brighter = function(b) {
            return b = Math.pow(0.7, arguments.length ? b : 1), new Tt(this.h, this.s, this.l / b);
          }, Rt.darker = function(b) {
            return b = Math.pow(0.7, arguments.length ? b : 1), new Tt(this.h, this.s, b * this.l);
          }, Rt.rgb = function() {
            return Vt(this.h, this.s, this.l);
          };
          function Vt(b, D, Q) {
            var oe, ue;
            b = isNaN(b) ? 0 : (b %= 360) < 0 ? b + 360 : b, D = isNaN(D) || D < 0 ? 0 : D > 1 ? 1 : D, Q = Q < 0 ? 0 : Q > 1 ? 1 : Q, ue = Q <= 0.5 ? Q * (1 + D) : Q + D - Q * D, oe = 2 * Q - ue;
            function de(me) {
              return me > 360 ? me -= 360 : me < 0 && (me += 360), me < 60 ? oe + (ue - oe) * me / 60 : me < 180 ? ue : me < 240 ? oe + (ue - oe) * (240 - me) / 60 : oe;
            }
            function we(me) {
              return Math.round(de(me) * 255);
            }
            return new Kt(we(b + 120), we(b), we(b - 120));
          }
          n.hcl = Ft;
          function Ft(b, D, Q) {
            return this instanceof Ft ? (this.h = +b, this.c = +D, void (this.l = +Q)) : arguments.length < 2 ? b instanceof Ft ? new Ft(b.h, b.c, b.l) : b instanceof Ot ? lr(b.l, b.a, b.b) : lr((b = Ee((b = n.rgb(b)).r, b.g, b.b)).l, b.a, b.b) : new Ft(b, D, Q);
          }
          var Dt = Ft.prototype = new It();
          Dt.brighter = function(b) {
            return new Ft(this.h, this.c, Math.min(100, this.l + Wt * (arguments.length ? b : 1)));
          }, Dt.darker = function(b) {
            return new Ft(this.h, this.c, Math.max(0, this.l - Wt * (arguments.length ? b : 1)));
          }, Dt.rgb = function() {
            return Ct(this.h, this.c, this.l).rgb();
          };
          function Ct(b, D, Q) {
            return isNaN(b) && (b = 0), isNaN(D) && (D = 0), new Ot(Q, Math.cos(b *= je) * D, Math.sin(b) * D);
          }
          n.lab = Ot;
          function Ot(b, D, Q) {
            return this instanceof Ot ? (this.l = +b, this.a = +D, void (this.b = +Q)) : arguments.length < 2 ? b instanceof Ot ? new Ot(b.l, b.a, b.b) : b instanceof Ft ? Ct(b.h, b.c, b.l) : Ee((b = Kt(b)).r, b.g, b.b) : new Ot(b, D, Q);
          }
          var Wt = 18, rr = 0.95047, Ut = 1, Qt = 1.08883, nr = Ot.prototype = new It();
          nr.brighter = function(b) {
            return new Ot(Math.min(100, this.l + Wt * (arguments.length ? b : 1)), this.a, this.b);
          }, nr.darker = function(b) {
            return new Ot(Math.max(0, this.l - Wt * (arguments.length ? b : 1)), this.a, this.b);
          }, nr.rgb = function() {
            return cr(this.l, this.a, this.b);
          };
          function cr(b, D, Q) {
            var oe = (b + 16) / 116, ue = oe + D / 500, de = oe - Q / 200;
            return ue = $t(ue) * rr, oe = $t(oe) * Ut, de = $t(de) * Qt, new Kt(St(3.2404542 * ue - 1.5371385 * oe - 0.4985314 * de), St(-0.969266 * ue + 1.8760108 * oe + 0.041556 * de), St(0.0556434 * ue - 0.2040259 * oe + 1.0572252 * de));
          }
          function lr(b, D, Q) {
            return b > 0 ? new Ft(Math.atan2(Q, D) * qe, Math.sqrt(D * D + Q * Q), b) : new Ft(NaN, NaN, b);
          }
          function $t(b) {
            return b > 0.206893034 ? b * b * b : (b - 4 / 29) / 7.787037;
          }
          function sr(b) {
            return b > 8856e-6 ? Math.pow(b, 1 / 3) : 7.787037 * b + 4 / 29;
          }
          function St(b) {
            return Math.round(255 * (b <= 304e-5 ? 12.92 * b : 1.055 * Math.pow(b, 1 / 2.4) - 0.055));
          }
          n.rgb = Kt;
          function Kt(b, D, Q) {
            return this instanceof Kt ? (this.r = ~~b, this.g = ~~D, void (this.b = ~~Q)) : arguments.length < 2 ? b instanceof Kt ? new Kt(b.r, b.g, b.b) : Re("" + b, Kt, Vt) : new Kt(b, D, Q);
          }
          function hr(b) {
            return new Kt(b >> 16, b >> 8 & 255, b & 255);
          }
          function he(b) {
            return hr(b) + "";
          }
          var fe = Kt.prototype = new It();
          fe.brighter = function(b) {
            b = Math.pow(0.7, arguments.length ? b : 1);
            var D = this.r, Q = this.g, oe = this.b, ue = 30;
            return !D && !Q && !oe ? new Kt(ue, ue, ue) : (D && D < ue && (D = ue), Q && Q < ue && (Q = ue), oe && oe < ue && (oe = ue), new Kt(Math.min(255, D / b), Math.min(255, Q / b), Math.min(255, oe / b)));
          }, fe.darker = function(b) {
            return b = Math.pow(0.7, arguments.length ? b : 1), new Kt(b * this.r, b * this.g, b * this.b);
          }, fe.hsl = function() {
            return Ye(this.r, this.g, this.b);
          }, fe.toString = function() {
            return "#" + Pe(this.r) + Pe(this.g) + Pe(this.b);
          };
          function Pe(b) {
            return b < 16 ? "0" + Math.max(0, b).toString(16) : Math.min(255, b).toString(16);
          }
          function Re(b, D, Q) {
            var oe = 0, ue = 0, de = 0, we, me, Le;
            if (we = /([a-z]+)\((.*)\)/.exec(b = b.toLowerCase()), we) switch (me = we[2].split(","), we[1]) {
              case "hsl":
                return Q(parseFloat(me[0]), parseFloat(me[1]) / 100, parseFloat(me[2]) / 100);
              case "rgb":
                return D(Ge(me[0]), Ge(me[1]), Ge(me[2]));
            }
            return (Le = Ve.get(b)) ? D(Le.r, Le.g, Le.b) : (b != null && b.charAt(0) === "#" && !isNaN(Le = parseInt(b.slice(1), 16)) && (b.length === 4 ? (oe = (Le & 3840) >> 4, oe = oe >> 4 | oe, ue = Le & 240, ue = ue >> 4 | ue, de = Le & 15, de = de << 4 | de) : b.length === 7 && (oe = (Le & 16711680) >> 16, ue = (Le & 65280) >> 8, de = Le & 255)), D(oe, ue, de));
          }
          function Ye(b, D, Q) {
            var oe = Math.min(b /= 255, D /= 255, Q /= 255), ue = Math.max(b, D, Q), de = ue - oe, we, me, Le = (ue + oe) / 2;
            return de ? (me = Le < 0.5 ? de / (ue + oe) : de / (2 - ue - oe), b == ue ? we = (D - Q) / de + (D < Q ? 6 : 0) : D == ue ? we = (Q - b) / de + 2 : we = (b - D) / de + 4, we *= 60) : (we = NaN, me = Le > 0 && Le < 1 ? 0 : we), new Tt(we, me, Le);
          }
          function Ee(b, D, Q) {
            b = ze(b), D = ze(D), Q = ze(Q);
            var oe = sr((0.4124564 * b + 0.3575761 * D + 0.1804375 * Q) / rr), ue = sr((0.2126729 * b + 0.7151522 * D + 0.072175 * Q) / Ut), de = sr((0.0193339 * b + 0.119192 * D + 0.9503041 * Q) / Qt);
            return Ot(116 * ue - 16, 500 * (oe - ue), 200 * (ue - de));
          }
          function ze(b) {
            return (b /= 255) <= 0.04045 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
          }
          function Ge(b) {
            var D = parseFloat(b);
            return b.charAt(b.length - 1) === "%" ? Math.round(D * 2.55) : D;
          }
          var Ve = n.map({ aliceblue: 15792383, antiquewhite: 16444375, aqua: 65535, aquamarine: 8388564, azure: 15794175, beige: 16119260, bisque: 16770244, black: 0, blanchedalmond: 16772045, blue: 255, blueviolet: 9055202, brown: 10824234, burlywood: 14596231, cadetblue: 6266528, chartreuse: 8388352, chocolate: 13789470, coral: 16744272, cornflowerblue: 6591981, cornsilk: 16775388, crimson: 14423100, cyan: 65535, darkblue: 139, darkcyan: 35723, darkgoldenrod: 12092939, darkgray: 11119017, darkgreen: 25600, darkgrey: 11119017, darkkhaki: 12433259, darkmagenta: 9109643, darkolivegreen: 5597999, darkorange: 16747520, darkorchid: 10040012, darkred: 9109504, darksalmon: 15308410, darkseagreen: 9419919, darkslateblue: 4734347, darkslategray: 3100495, darkslategrey: 3100495, darkturquoise: 52945, darkviolet: 9699539, deeppink: 16716947, deepskyblue: 49151, dimgray: 6908265, dimgrey: 6908265, dodgerblue: 2003199, firebrick: 11674146, floralwhite: 16775920, forestgreen: 2263842, fuchsia: 16711935, gainsboro: 14474460, ghostwhite: 16316671, gold: 16766720, goldenrod: 14329120, gray: 8421504, green: 32768, greenyellow: 11403055, grey: 8421504, honeydew: 15794160, hotpink: 16738740, indianred: 13458524, indigo: 4915330, ivory: 16777200, khaki: 15787660, lavender: 15132410, lavenderblush: 16773365, lawngreen: 8190976, lemonchiffon: 16775885, lightblue: 11393254, lightcoral: 15761536, lightcyan: 14745599, lightgoldenrodyellow: 16448210, lightgray: 13882323, lightgreen: 9498256, lightgrey: 13882323, lightpink: 16758465, lightsalmon: 16752762, lightseagreen: 2142890, lightskyblue: 8900346, lightslategray: 7833753, lightslategrey: 7833753, lightsteelblue: 11584734, lightyellow: 16777184, lime: 65280, limegreen: 3329330, linen: 16445670, magenta: 16711935, maroon: 8388608, mediumaquamarine: 6737322, mediumblue: 205, mediumorchid: 12211667, mediumpurple: 9662683, mediumseagreen: 3978097, mediumslateblue: 8087790, mediumspringgreen: 64154, mediumturquoise: 4772300, mediumvioletred: 13047173, midnightblue: 1644912, mintcream: 16121850, mistyrose: 16770273, moccasin: 16770229, navajowhite: 16768685, navy: 128, oldlace: 16643558, olive: 8421376, olivedrab: 7048739, orange: 16753920, orangered: 16729344, orchid: 14315734, palegoldenrod: 15657130, palegreen: 10025880, paleturquoise: 11529966, palevioletred: 14381203, papayawhip: 16773077, peachpuff: 16767673, peru: 13468991, pink: 16761035, plum: 14524637, powderblue: 11591910, purple: 8388736, rebeccapurple: 6697881, red: 16711680, rosybrown: 12357519, royalblue: 4286945, saddlebrown: 9127187, salmon: 16416882, sandybrown: 16032864, seagreen: 3050327, seashell: 16774638, sienna: 10506797, silver: 12632256, skyblue: 8900331, slateblue: 6970061, slategray: 7372944, slategrey: 7372944, snow: 16775930, springgreen: 65407, steelblue: 4620980, tan: 13808780, teal: 32896, thistle: 14204888, tomato: 16737095, turquoise: 4251856, violet: 15631086, wheat: 16113331, white: 16777215, whitesmoke: 16119285, yellow: 16776960, yellowgreen: 10145074 });
          Ve.forEach(function(b, D) {
            Ve.set(b, hr(D));
          });
          function tt(b) {
            return typeof b == "function" ? b : function() {
              return b;
            };
          }
          n.functor = tt, n.xhr = at(K);
          function at(b) {
            return function(D, Q, oe) {
              return arguments.length === 2 && typeof Q == "function" && (oe = Q, Q = null), vt(D, Q, b, oe);
            };
          }
          function vt(b, D, Q, oe) {
            var ue = {}, de = n.dispatch("beforesend", "progress", "load", "error"), we = {}, me = new XMLHttpRequest(), Le = null;
            self.XDomainRequest && !("withCredentials" in me) && /^(http(s)?:)?\/\//.test(b) && (me = new XDomainRequest()), "onload" in me ? me.onload = me.onerror = Fe : me.onreadystatechange = function() {
              me.readyState > 3 && Fe();
            };
            function Fe() {
              var Be = me.status, et;
              if (!Be && At(me) || Be >= 200 && Be < 300 || Be === 304) {
                try {
                  et = Q.call(ue, me);
                } catch (rt) {
                  de.error.call(ue, rt);
                  return;
                }
                de.load.call(ue, et);
              } else de.error.call(ue, me);
            }
            return me.onprogress = function(Be) {
              var et = n.event;
              n.event = Be;
              try {
                de.progress.call(ue, me);
              } finally {
                n.event = et;
              }
            }, ue.header = function(Be, et) {
              return Be = (Be + "").toLowerCase(), arguments.length < 2 ? we[Be] : (et == null ? delete we[Be] : we[Be] = et + "", ue);
            }, ue.mimeType = function(Be) {
              return arguments.length ? (D = Be == null ? null : Be + "", ue) : D;
            }, ue.responseType = function(Be) {
              return arguments.length ? (Le = Be, ue) : Le;
            }, ue.response = function(Be) {
              return Q = Be, ue;
            }, ["get", "post"].forEach(function(Be) {
              ue[Be] = function() {
                return ue.send.apply(ue, [Be].concat(a(arguments)));
              };
            }), ue.send = function(Be, et, rt) {
              if (arguments.length === 2 && typeof et == "function" && (rt = et, et = null), me.open(Be, b, !0), D != null && !("accept" in we) && (we.accept = D + ",*/*"), me.setRequestHeader) for (var pt in we) me.setRequestHeader(pt, we[pt]);
              return D != null && me.overrideMimeType && me.overrideMimeType(D), Le != null && (me.responseType = Le), rt != null && ue.on("error", rt).on("load", function(bt) {
                rt(null, bt);
              }), de.beforesend.call(ue, me), me.send(et ?? null), ue;
            }, ue.abort = function() {
              return me.abort(), ue;
            }, n.rebind(ue, de, "on"), oe == null ? ue : ue.get(kt(oe));
          }
          function kt(b) {
            return b.length === 1 ? function(D, Q) {
              b(D == null ? Q : null);
            } : b;
          }
          function At(b) {
            var D = b.responseType;
            return D && D !== "text" ? b.response : b.responseText;
          }
          n.dsv = function(b, D) {
            var Q = new RegExp('["' + b + `
]`), oe = b.charCodeAt(0);
            function ue(Fe, Be, et) {
              arguments.length < 3 && (et = Be, Be = null);
              var rt = vt(Fe, D, Be == null ? de : we(Be), et);
              return rt.row = function(pt) {
                return arguments.length ? rt.response((Be = pt) == null ? de : we(pt)) : Be;
              }, rt;
            }
            function de(Fe) {
              return ue.parse(Fe.responseText);
            }
            function we(Fe) {
              return function(Be) {
                return ue.parse(Be.responseText, Fe);
              };
            }
            ue.parse = function(Fe, Be) {
              var et;
              return ue.parseRows(Fe, function(rt, pt) {
                if (et) return et(rt, pt - 1);
                var bt = function(nt) {
                  for (var ut = {}, ft = rt.length, yt = 0; yt < ft; ++yt) ut[rt[yt]] = nt[yt];
                  return ut;
                };
                et = Be ? function(nt, ut) {
                  return Be(bt(nt), ut);
                } : bt;
              });
            }, ue.parseRows = function(Fe, Be) {
              var et = {}, rt = {}, pt = [], bt = Fe.length, nt = 0, ut = 0, ft, yt;
              function mt() {
                if (nt >= bt) return rt;
                if (yt) return yt = !1, et;
                var zt = nt;
                if (Fe.charCodeAt(zt) === 34) {
                  for (var Zt = zt; Zt++ < bt; ) if (Fe.charCodeAt(Zt) === 34) {
                    if (Fe.charCodeAt(Zt + 1) !== 34) break;
                    ++Zt;
                  }
                  nt = Zt + 2;
                  var Jt = Fe.charCodeAt(Zt + 1);
                  return Jt === 13 ? (yt = !0, Fe.charCodeAt(Zt + 2) === 10 && ++nt) : Jt === 10 && (yt = !0), Fe.slice(zt + 1, Zt).replace(/""/g, '"');
                }
                for (; nt < bt; ) {
                  var Jt = Fe.charCodeAt(nt++), Xt = 1;
                  if (Jt === 10) yt = !0;
                  else if (Jt === 13) yt = !0, Fe.charCodeAt(nt) === 10 && (++nt, ++Xt);
                  else if (Jt !== oe) continue;
                  return Fe.slice(zt, nt - Xt);
                }
                return Fe.slice(zt);
              }
              for (; (ft = mt()) !== rt; ) {
                for (var dt = []; ft !== et && ft !== rt; ) dt.push(ft), ft = mt();
                Be && (dt = Be(dt, ut++)) == null || pt.push(dt);
              }
              return pt;
            }, ue.format = function(Fe) {
              if (Array.isArray(Fe[0])) return ue.formatRows(Fe);
              var Be = new G(), et = [];
              return Fe.forEach(function(rt) {
                for (var pt in rt) Be.has(pt) || et.push(Be.add(pt));
              }), [et.map(Le).join(b)].concat(Fe.map(function(rt) {
                return et.map(function(pt) {
                  return Le(rt[pt]);
                }).join(b);
              })).join(`
`);
            }, ue.formatRows = function(Fe) {
              return Fe.map(me).join(`
`);
            };
            function me(Fe) {
              return Fe.map(Le).join(b);
            }
            function Le(Fe) {
              return Q.test(Fe) ? '"' + Fe.replace(/\"/g, '""') + '"' : Fe;
            }
            return ue;
          }, n.csv = n.dsv(",", "text/csv"), n.tsv = n.dsv("	", "text/tab-separated-values");
          var Nt, Mt, Pt, Lt, ur = this[V(this, "requestAnimationFrame")] || function(b) {
            setTimeout(b, 17);
          };
          n.timer = function() {
            Ht.apply(this, arguments);
          };
          function Ht(b, D, Q) {
            var oe = arguments.length;
            oe < 2 && (D = 0), oe < 3 && (Q = Date.now());
            var ue = Q + D, de = { c: b, t: ue, n: null };
            return Mt ? Mt.n = de : Nt = de, Mt = de, Pt || (Lt = clearTimeout(Lt), Pt = 1, ur(mr)), de;
          }
          function mr() {
            var b = ar(), D = kr() - b;
            D > 24 ? (isFinite(D) && (clearTimeout(Lt), Lt = setTimeout(mr, D)), Pt = 0) : (Pt = 1, ur(mr));
          }
          n.timer.flush = function() {
            ar(), kr();
          };
          function ar() {
            for (var b = Date.now(), D = Nt; D; ) b >= D.t && D.c(b - D.t) && (D.c = null), D = D.n;
            return b;
          }
          function kr() {
            for (var b, D = Nt, Q = 1 / 0; D; ) D.c ? (D.t < Q && (Q = D.t), D = (b = D).n) : D = b ? b.n = D.n : Nt = D.n;
            return Mt = b, Q;
          }
          n.round = function(b, D) {
            return D ? Math.round(b * (D = Math.pow(10, D))) / D : Math.round(b);
          }, n.geom = {};
          function _r(b) {
            return b[0];
          }
          function Cr(b) {
            return b[1];
          }
          n.geom.hull = function(b) {
            var D = _r, Q = Cr;
            if (arguments.length) return oe(b);
            function oe(ue) {
              if (ue.length < 3) return [];
              var de = tt(D), we = tt(Q), me, Le = ue.length, Fe = [], Be = [];
              for (me = 0; me < Le; me++) Fe.push([+de.call(this, ue[me], me), +we.call(this, ue[me], me), me]);
              for (Fe.sort(Sr), me = 0; me < Le; me++) Be.push([Fe[me][0], -Fe[me][1]]);
              var et = Yt(Fe), rt = Yt(Be), pt = rt[0] === et[0], bt = rt[rt.length - 1] === et[et.length - 1], nt = [];
              for (me = et.length - 1; me >= 0; --me) nt.push(ue[Fe[et[me]][2]]);
              for (me = +pt; me < rt.length - bt; ++me) nt.push(ue[Fe[rt[me]][2]]);
              return nt;
            }
            return oe.x = function(ue) {
              return arguments.length ? (D = ue, oe) : D;
            }, oe.y = function(ue) {
              return arguments.length ? (Q = ue, oe) : Q;
            }, oe;
          };
          function Yt(b) {
            for (var D = b.length, Q = [0, 1], oe = 2, ue = 2; ue < D; ue++) {
              for (; oe > 1 && Qe(b[Q[oe - 2]], b[Q[oe - 1]], b[ue]) <= 0; ) --oe;
              Q[oe++] = ue;
            }
            return Q.slice(0, oe);
          }
          function Sr(b, D) {
            return b[0] - D[0] || b[1] - D[1];
          }
          n.geom.polygon = function(b) {
            return O(b, Tr), b;
          };
          var Tr = n.geom.polygon.prototype = [];
          Tr.area = function() {
            for (var b = -1, D = this.length, Q, oe = this[D - 1], ue = 0; ++b < D; ) Q = oe, oe = this[b], ue += Q[1] * oe[0] - Q[0] * oe[1];
            return ue * 0.5;
          }, Tr.centroid = function(b) {
            var D = -1, Q = this.length, oe = 0, ue = 0, de, we = this[Q - 1], me;
            for (arguments.length || (b = -1 / (6 * this.area())); ++D < Q; ) de = we, we = this[D], me = de[0] * we[1] - we[0] * de[1], oe += (de[0] + we[0]) * me, ue += (de[1] + we[1]) * me;
            return [oe * b, ue * b];
          }, Tr.clip = function(b) {
            for (var D, Q = Ir(b), oe = -1, ue = this.length - Ir(this), de, we, me = this[ue - 1], Le, Fe, Be; ++oe < ue; ) {
              for (D = b.slice(), b.length = 0, Le = this[oe], Fe = D[(we = D.length - Q) - 1], de = -1; ++de < we; ) Be = D[de], Gr(Be, me, Le) ? (Gr(Fe, me, Le) || b.push(dr(Fe, Be, me, Le)), b.push(Be)) : Gr(Fe, me, Le) && b.push(dr(Fe, Be, me, Le)), Fe = Be;
              Q && b.push(b[0]), me = Le;
            }
            return b;
          };
          function Gr(b, D, Q) {
            return (Q[0] - D[0]) * (b[1] - D[1]) < (Q[1] - D[1]) * (b[0] - D[0]);
          }
          function dr(b, D, Q, oe) {
            var ue = b[0], de = Q[0], we = D[0] - ue, me = oe[0] - de, Le = b[1], Fe = Q[1], Be = D[1] - Le, et = oe[1] - Fe, rt = (me * (Le - Fe) - et * (ue - de)) / (et * we - me * Be);
            return [ue + rt * we, Le + rt * Be];
          }
          function Ir(b) {
            var D = b[0], Q = b[b.length - 1];
            return !(D[0] - Q[0] || D[1] - Q[1]);
          }
          var Er, Zr, ln, un = [], br, Dr, Mr = [];
          function Hr() {
            $r(this), this.edge = this.site = this.circle = null;
          }
          function Ur(b) {
            var D = un.pop() || new Hr();
            return D.site = b, D;
          }
          function Wr(b) {
            rn(b), ln.remove(b), un.push(b), $r(b);
          }
          function en(b) {
            var D = b.circle, Q = D.x, oe = D.cy, ue = { x: Q, y: oe }, de = b.P, we = b.N, me = [b];
            Wr(b);
            for (var Le = de; Le.circle && u(Q - Le.circle.x) < Ie && u(oe - Le.circle.cy) < Ie; ) de = Le.P, me.unshift(Le), Wr(Le), Le = de;
            me.unshift(Le), rn(Le);
            for (var Fe = we; Fe.circle && u(Q - Fe.circle.x) < Ie && u(oe - Fe.circle.cy) < Ie; ) we = Fe.N, me.push(Fe), Wr(Fe), Fe = we;
            me.push(Fe), rn(Fe);
            var Be = me.length, et;
            for (et = 1; et < Be; ++et) Fe = me[et], Le = me[et - 1], Vr(Fe.edge, Le.site, Fe.site, ue);
            Le = me[0], Fe = me[Be - 1], Fe.edge = jn(Le.site, Fe.site, null, ue), fn(Le), fn(Fe);
          }
          function Xr(b) {
            for (var D = b.x, Q = b.y, oe, ue, de, we, me = ln._; me; ) if (de = cn(me, Q) - D, de > Ie) me = me.L;
            else if (we = D - Jr(me, Q), we > Ie) {
              if (!me.R) {
                oe = me;
                break;
              }
              me = me.R;
            } else {
              de > -Ie ? (oe = me.P, ue = me) : we > -Ie ? (oe = me, ue = me.N) : oe = ue = me;
              break;
            }
            var Le = Ur(b);
            if (ln.insert(oe, Le), !(!oe && !ue)) {
              if (oe === ue) {
                rn(oe), ue = Ur(oe.site), ln.insert(Le, ue), Le.edge = ue.edge = jn(oe.site, Le.site), fn(oe), fn(ue);
                return;
              }
              if (!ue) {
                Le.edge = jn(oe.site, Le.site);
                return;
              }
              rn(oe), rn(ue);
              var Fe = oe.site, Be = Fe.x, et = Fe.y, rt = b.x - Be, pt = b.y - et, bt = ue.site, nt = bt.x - Be, ut = bt.y - et, ft = 2 * (rt * ut - pt * nt), yt = rt * rt + pt * pt, mt = nt * nt + ut * ut, dt = { x: (ut * yt - pt * mt) / ft + Be, y: (rt * mt - nt * yt) / ft + et };
              Vr(ue.edge, Fe, bt, dt), Le.edge = jn(Fe, b, null, dt), ue.edge = jn(b, bt, null, dt), fn(oe), fn(ue);
            }
          }
          function cn(b, D) {
            var Q = b.site, oe = Q.x, ue = Q.y, de = ue - D;
            if (!de) return oe;
            var we = b.P;
            if (!we) return -1 / 0;
            Q = we.site;
            var me = Q.x, Le = Q.y, Fe = Le - D;
            if (!Fe) return me;
            var Be = me - oe, et = 1 / de - 1 / Fe, rt = Be / Fe;
            return et ? (-rt + Math.sqrt(rt * rt - 2 * et * (Be * Be / (-2 * Fe) - Le + Fe / 2 + ue - de / 2))) / et + oe : (oe + me) / 2;
          }
          function Jr(b, D) {
            var Q = b.N;
            if (Q) return cn(Q, D);
            var oe = b.site;
            return oe.y === D ? oe.x : 1 / 0;
          }
          function Lr(b) {
            this.site = b, this.edges = [];
          }
          Lr.prototype.prepare = function() {
            for (var b = this.edges, D = b.length, Q; D--; ) Q = b[D].edge, (!Q.b || !Q.a) && b.splice(D, 1);
            return b.sort(tn), b.length;
          };
          function Sn(b) {
            for (var D = b[0][0], Q = b[1][0], oe = b[0][1], ue = b[1][1], de, we, me, Le, Fe = Zr, Be = Fe.length, et, rt, pt, bt, nt, ut; Be--; ) if (et = Fe[Be], !(!et || !et.prepare())) for (pt = et.edges, bt = pt.length, rt = 0; rt < bt; ) ut = pt[rt].end(), me = ut.x, Le = ut.y, nt = pt[++rt % bt].start(), de = nt.x, we = nt.y, (u(me - de) > Ie || u(Le - we) > Ie) && (pt.splice(rt, 0, new Kr(Pr(et.site, ut, u(me - D) < Ie && ue - Le > Ie ? { x: D, y: u(de - D) < Ie ? we : ue } : u(Le - ue) < Ie && Q - me > Ie ? { x: u(we - ue) < Ie ? de : Q, y: ue } : u(me - Q) < Ie && Le - oe > Ie ? { x: Q, y: u(de - Q) < Ie ? we : oe } : u(Le - oe) < Ie && me - D > Ie ? { x: u(we - oe) < Ie ? de : D, y: oe } : null), et.site, null)), ++bt);
          }
          function tn(b, D) {
            return D.angle - b.angle;
          }
          function vn() {
            $r(this), this.x = this.y = this.arc = this.site = this.cy = null;
          }
          function fn(b) {
            var D = b.P, Q = b.N;
            if (!(!D || !Q)) {
              var oe = D.site, ue = b.site, de = Q.site;
              if (oe !== de) {
                var we = ue.x, me = ue.y, Le = oe.x - we, Fe = oe.y - me, Be = de.x - we, et = de.y - me, rt = 2 * (Le * et - Fe * Be);
                if (!(rt >= -ce)) {
                  var pt = Le * Le + Fe * Fe, bt = Be * Be + et * et, nt = (et * pt - Fe * bt) / rt, ut = (Le * bt - Be * pt) / rt, et = ut + me, ft = Mr.pop() || new vn();
                  ft.arc = b, ft.site = ue, ft.x = nt + we, ft.y = et + Math.sqrt(nt * nt + ut * ut), ft.cy = et, b.circle = ft;
                  for (var yt = null, mt = Dr._; mt; ) if (ft.y < mt.y || ft.y === mt.y && ft.x <= mt.x) if (mt.L) mt = mt.L;
                  else {
                    yt = mt.P;
                    break;
                  }
                  else if (mt.R) mt = mt.R;
                  else {
                    yt = mt;
                    break;
                  }
                  Dr.insert(yt, ft), yt || (br = ft);
                }
              }
            }
          }
          function rn(b) {
            var D = b.circle;
            D && (D.P || (br = D.N), Dr.remove(D), Mr.push(D), $r(D), b.circle = null);
          }
          function In(b, D, Q, oe) {
            return function(ue) {
              var de = ue.a, we = ue.b, me = de.x, Le = de.y, Fe = we.x, Be = we.y, et = 0, rt = 1, pt = Fe - me, bt = Be - Le, nt;
              if (nt = b - me, !(!pt && nt > 0)) {
                if (nt /= pt, pt < 0) {
                  if (nt < et) return;
                  nt < rt && (rt = nt);
                } else if (pt > 0) {
                  if (nt > rt) return;
                  nt > et && (et = nt);
                }
                if (nt = Q - me, !(!pt && nt < 0)) {
                  if (nt /= pt, pt < 0) {
                    if (nt > rt) return;
                    nt > et && (et = nt);
                  } else if (pt > 0) {
                    if (nt < et) return;
                    nt < rt && (rt = nt);
                  }
                  if (nt = D - Le, !(!bt && nt > 0)) {
                    if (nt /= bt, bt < 0) {
                      if (nt < et) return;
                      nt < rt && (rt = nt);
                    } else if (bt > 0) {
                      if (nt > rt) return;
                      nt > et && (et = nt);
                    }
                    if (nt = oe - Le, !(!bt && nt < 0)) {
                      if (nt /= bt, bt < 0) {
                        if (nt > rt) return;
                        nt > et && (et = nt);
                      } else if (bt > 0) {
                        if (nt < et) return;
                        nt < rt && (rt = nt);
                      }
                      return et > 0 && (ue.a = { x: me + et * pt, y: Le + et * bt }), rt < 1 && (ue.b = { x: me + rt * pt, y: Le + rt * bt }), ue;
                    }
                  }
                }
              }
            };
          }
          function wn(b) {
            for (var D = Er, Q = In(b[0][0], b[0][1], b[1][0], b[1][1]), oe = D.length, ue; oe--; ) ue = D[oe], (!nn(ue, b) || !Q(ue) || u(ue.a.x - ue.b.x) < Ie && u(ue.a.y - ue.b.y) < Ie) && (ue.a = ue.b = null, D.splice(oe, 1));
          }
          function nn(b, D) {
            var Q = b.b;
            if (Q) return !0;
            var oe = b.a, ue = D[0][0], de = D[1][0], we = D[0][1], me = D[1][1], Le = b.l, Fe = b.r, Be = Le.x, et = Le.y, rt = Fe.x, pt = Fe.y, bt = (Be + rt) / 2, nt = (et + pt) / 2, ut, ft;
            if (pt === et) {
              if (bt < ue || bt >= de) return;
              if (Be > rt) {
                if (!oe) oe = { x: bt, y: we };
                else if (oe.y >= me) return;
                Q = { x: bt, y: me };
              } else {
                if (!oe) oe = { x: bt, y: me };
                else if (oe.y < we) return;
                Q = { x: bt, y: we };
              }
            } else if (ut = (Be - rt) / (pt - et), ft = nt - ut * bt, ut < -1 || ut > 1) if (Be > rt) {
              if (!oe) oe = { x: (we - ft) / ut, y: we };
              else if (oe.y >= me) return;
              Q = { x: (me - ft) / ut, y: me };
            } else {
              if (!oe) oe = { x: (me - ft) / ut, y: me };
              else if (oe.y < we) return;
              Q = { x: (we - ft) / ut, y: we };
            }
            else if (et < pt) {
              if (!oe) oe = { x: ue, y: ut * ue + ft };
              else if (oe.x >= de) return;
              Q = { x: de, y: ut * de + ft };
            } else {
              if (!oe) oe = { x: de, y: ut * de + ft };
              else if (oe.x < ue) return;
              Q = { x: ue, y: ut * ue + ft };
            }
            return b.a = oe, b.b = Q, !0;
          }
          function En(b, D) {
            this.l = b, this.r = D, this.a = this.b = null;
          }
          function jn(b, D, Q, oe) {
            var ue = new En(b, D);
            return Er.push(ue), Q && Vr(ue, b, D, Q), oe && Vr(ue, D, b, oe), Zr[b.i].edges.push(new Kr(ue, b, D)), Zr[D.i].edges.push(new Kr(ue, D, b)), ue;
          }
          function Pr(b, D, Q) {
            var oe = new En(b, null);
            return oe.a = D, oe.b = Q, Er.push(oe), oe;
          }
          function Vr(b, D, Q, oe) {
            !b.a && !b.b ? (b.a = oe, b.l = D, b.r = Q) : b.l === Q ? b.b = oe : b.a = oe;
          }
          function Kr(b, D, Q) {
            var oe = b.a, ue = b.b;
            this.edge = b, this.site = D, this.angle = Q ? Math.atan2(Q.y - D.y, Q.x - D.x) : b.l === D ? Math.atan2(ue.x - oe.x, oe.y - ue.y) : Math.atan2(oe.x - ue.x, ue.y - oe.y);
          }
          Kr.prototype = { start: function() {
            return this.edge.l === this.site ? this.edge.a : this.edge.b;
          }, end: function() {
            return this.edge.l === this.site ? this.edge.b : this.edge.a;
          } };
          function gn() {
            this._ = null;
          }
          function $r(b) {
            b.U = b.C = b.L = b.R = b.P = b.N = null;
          }
          gn.prototype = { insert: function(b, D) {
            var Q, oe, ue;
            if (b) {
              if (D.P = b, D.N = b.N, b.N && (b.N.P = D), b.N = D, b.R) {
                for (b = b.R; b.L; ) b = b.L;
                b.L = D;
              } else b.R = D;
              Q = b;
            } else this._ ? (b = xa(this._), D.P = null, D.N = b, b.P = b.L = D, Q = b) : (D.P = D.N = null, this._ = D, Q = null);
            for (D.L = D.R = null, D.U = Q, D.C = !0, b = D; Q && Q.C; ) oe = Q.U, Q === oe.L ? (ue = oe.R, ue && ue.C ? (Q.C = ue.C = !1, oe.C = !0, b = oe) : (b === Q.R && (Nr(this, Q), b = Q, Q = b.U), Q.C = !1, oe.C = !0, yn(this, oe))) : (ue = oe.L, ue && ue.C ? (Q.C = ue.C = !1, oe.C = !0, b = oe) : (b === Q.L && (yn(this, Q), b = Q, Q = b.U), Q.C = !1, oe.C = !0, Nr(this, oe))), Q = b.U;
            this._.C = !1;
          }, remove: function(b) {
            b.N && (b.N.P = b.P), b.P && (b.P.N = b.N), b.N = b.P = null;
            var D = b.U, Q, oe = b.L, ue = b.R, de, we;
            if (oe ? ue ? de = xa(ue) : de = oe : de = ue, D ? D.L === b ? D.L = de : D.R = de : this._ = de, oe && ue ? (we = de.C, de.C = b.C, de.L = oe, oe.U = de, de !== ue ? (D = de.U, de.U = b.U, b = de.R, D.L = b, de.R = ue, ue.U = de) : (de.U = D, D = de, b = de.R)) : (we = b.C, b = de), b && (b.U = D), !we) {
              if (b && b.C) {
                b.C = !1;
                return;
              }
              do {
                if (b === this._) break;
                if (b === D.L) {
                  if (Q = D.R, Q.C && (Q.C = !1, D.C = !0, Nr(this, D), Q = D.R), Q.L && Q.L.C || Q.R && Q.R.C) {
                    (!Q.R || !Q.R.C) && (Q.L.C = !1, Q.C = !0, yn(this, Q), Q = D.R), Q.C = D.C, D.C = Q.R.C = !1, Nr(this, D), b = this._;
                    break;
                  }
                } else if (Q = D.L, Q.C && (Q.C = !1, D.C = !0, yn(this, D), Q = D.L), Q.L && Q.L.C || Q.R && Q.R.C) {
                  (!Q.L || !Q.L.C) && (Q.R.C = !1, Q.C = !0, Nr(this, Q), Q = D.L), Q.C = D.C, D.C = Q.L.C = !1, yn(this, D), b = this._;
                  break;
                }
                Q.C = !0, b = D, D = D.U;
              } while (!b.C);
              b && (b.C = !1);
            }
          } };
          function Nr(b, D) {
            var Q = D, oe = D.R, ue = Q.U;
            ue ? ue.L === Q ? ue.L = oe : ue.R = oe : b._ = oe, oe.U = ue, Q.U = oe, Q.R = oe.L, Q.R && (Q.R.U = Q), oe.L = Q;
          }
          function yn(b, D) {
            var Q = D, oe = D.L, ue = Q.U;
            ue ? ue.L === Q ? ue.L = oe : ue.R = oe : b._ = oe, oe.U = ue, Q.U = oe, Q.L = oe.R, Q.L && (Q.L.U = Q), oe.R = Q;
          }
          function xa(b) {
            for (; b.L; ) b = b.L;
            return b;
          }
          function ia(b, D) {
            var Q = b.sort(hi).pop(), oe, ue, de;
            for (Er = [], Zr = new Array(b.length), ln = new gn(), Dr = new gn(); ; ) if (de = br, Q && (!de || Q.y < de.y || Q.y === de.y && Q.x < de.x)) (Q.x !== oe || Q.y !== ue) && (Zr[Q.i] = new Lr(Q), Xr(Q), oe = Q.x, ue = Q.y), Q = b.pop();
            else if (de) en(de.arc);
            else break;
            D && (wn(D), Sn(D));
            var we = { cells: Zr, edges: Er };
            return ln = Dr = Er = Zr = null, we;
          }
          function hi(b, D) {
            return D.y - b.y || D.x - b.x;
          }
          n.geom.voronoi = function(b) {
            var D = _r, Q = Cr, oe = D, ue = Q, de = oa;
            if (b) return we(b);
            function we(Le) {
              var Fe = new Array(Le.length), Be = de[0][0], et = de[0][1], rt = de[1][0], pt = de[1][1];
              return ia(me(Le), de).cells.forEach(function(bt, nt) {
                var ut = bt.edges, ft = bt.site, yt = Fe[nt] = ut.length ? ut.map(function(mt) {
                  var dt = mt.start();
                  return [dt.x, dt.y];
                }) : ft.x >= Be && ft.x <= rt && ft.y >= et && ft.y <= pt ? [[Be, pt], [rt, pt], [rt, et], [Be, et]] : [];
                yt.point = Le[nt];
              }), Fe;
            }
            function me(Le) {
              return Le.map(function(Fe, Be) {
                return { x: Math.round(oe(Fe, Be) / Ie) * Ie, y: Math.round(ue(Fe, Be) / Ie) * Ie, i: Be };
              });
            }
            return we.links = function(Le) {
              return ia(me(Le)).edges.filter(function(Fe) {
                return Fe.l && Fe.r;
              }).map(function(Fe) {
                return { source: Le[Fe.l.i], target: Le[Fe.r.i] };
              });
            }, we.triangles = function(Le) {
              var Fe = [];
              return ia(me(Le)).cells.forEach(function(Be, et) {
                for (var rt = Be.site, pt = Be.edges.sort(tn), bt = -1, nt = pt.length, ut, ft, yt = pt[nt - 1].edge, mt = yt.l === rt ? yt.r : yt.l; ++bt < nt; ) ut = yt, ft = mt, yt = pt[bt].edge, mt = yt.l === rt ? yt.r : yt.l, et < ft.i && et < mt.i && Hi(rt, ft, mt) < 0 && Fe.push([Le[et], Le[ft.i], Le[mt.i]]);
              }), Fe;
            }, we.x = function(Le) {
              return arguments.length ? (oe = tt(D = Le), we) : D;
            }, we.y = function(Le) {
              return arguments.length ? (ue = tt(Q = Le), we) : Q;
            }, we.clipExtent = function(Le) {
              return arguments.length ? (de = Le ?? oa, we) : de === oa ? null : de;
            }, we.size = function(Le) {
              return arguments.length ? we.clipExtent(Le && [[0, 0], Le]) : de === oa ? null : de && de[1];
            }, we;
          };
          var oa = [[-1e6, -1e6], [1e6, 1e6]];
          function Hi(b, D, Q) {
            return (b.x - Q.x) * (D.y - b.y) - (b.x - D.x) * (Q.y - b.y);
          }
          n.geom.delaunay = function(b) {
            return n.geom.voronoi().triangles(b);
          }, n.geom.quadtree = function(b, D, Q, oe, ue) {
            var de = _r, we = Cr, me;
            if (me = arguments.length) return de = qi, we = Ui, me === 3 && (ue = Q, oe = D, Q = D = 0), Le(b);
            function Le(Fe) {
              var Be, et = tt(de), rt = tt(we), pt, bt, nt, ut, ft, yt, mt, dt;
              if (D != null) ft = D, yt = Q, mt = oe, dt = ue;
              else if (mt = dt = -(ft = yt = 1 / 0), pt = [], bt = [], ut = Fe.length, me) for (nt = 0; nt < ut; ++nt) Be = Fe[nt], Be.x < ft && (ft = Be.x), Be.y < yt && (yt = Be.y), Be.x > mt && (mt = Be.x), Be.y > dt && (dt = Be.y), pt.push(Be.x), bt.push(Be.y);
              else for (nt = 0; nt < ut; ++nt) {
                var zt = +et(Be = Fe[nt], nt), Zt = +rt(Be, nt);
                zt < ft && (ft = zt), Zt < yt && (yt = Zt), zt > mt && (mt = zt), Zt > dt && (dt = Zt), pt.push(zt), bt.push(Zt);
              }
              var Jt = mt - ft, Xt = dt - yt;
              Jt > Xt ? dt = yt + Jt : mt = ft + Xt;
              function er(ir, pr, zr, an, Fr, Gt, yr, wr) {
                if (!(isNaN(zr) || isNaN(an))) if (ir.leaf) {
                  var Rr = ir.x, Qr = ir.y;
                  if (Rr != null) if (u(Rr - zr) + u(Qr - an) < 0.01) tr(ir, pr, zr, an, Fr, Gt, yr, wr);
                  else {
                    var pn = ir.point;
                    ir.x = ir.y = ir.point = null, tr(ir, pn, Rr, Qr, Fr, Gt, yr, wr), tr(ir, pr, zr, an, Fr, Gt, yr, wr);
                  }
                  else ir.x = zr, ir.y = an, ir.point = pr;
                } else tr(ir, pr, zr, an, Fr, Gt, yr, wr);
              }
              function tr(ir, pr, zr, an, Fr, Gt, yr, wr) {
                var Rr = (Fr + yr) * 0.5, Qr = (Gt + wr) * 0.5, pn = zr >= Rr, bn = an >= Qr, Ln = bn << 1 | pn;
                ir.leaf = !1, ir = ir.nodes[Ln] || (ir.nodes[Ln] = vi()), pn ? Fr = Rr : yr = Rr, bn ? Gt = Qr : wr = Qr, er(ir, pr, zr, an, Fr, Gt, yr, wr);
              }
              var gr = vi();
              if (gr.add = function(ir) {
                er(gr, ir, +et(ir, ++nt), +rt(ir, nt), ft, yt, mt, dt);
              }, gr.visit = function(ir) {
                ba(ir, gr, ft, yt, mt, dt);
              }, gr.find = function(ir) {
                return yv(gr, ir[0], ir[1], ft, yt, mt, dt);
              }, nt = -1, D == null) {
                for (; ++nt < ut; ) er(gr, Fe[nt], pt[nt], bt[nt], ft, yt, mt, dt);
                --nt;
              } else Fe.forEach(gr.add);
              return pt = bt = Fe = Be = null, gr;
            }
            return Le.x = function(Fe) {
              return arguments.length ? (de = Fe, Le) : de;
            }, Le.y = function(Fe) {
              return arguments.length ? (we = Fe, Le) : we;
            }, Le.extent = function(Fe) {
              return arguments.length ? (Fe == null ? D = Q = oe = ue = null : (D = +Fe[0][0], Q = +Fe[0][1], oe = +Fe[1][0], ue = +Fe[1][1]), Le) : D == null ? null : [[D, Q], [oe, ue]];
            }, Le.size = function(Fe) {
              return arguments.length ? (Fe == null ? D = Q = oe = ue = null : (D = Q = 0, oe = +Fe[0], ue = +Fe[1]), Le) : D == null ? null : [oe - D, ue - Q];
            }, Le;
          };
          function qi(b) {
            return b.x;
          }
          function Ui(b) {
            return b.y;
          }
          function vi() {
            return { leaf: !0, nodes: [], point: null, x: null, y: null };
          }
          function ba(b, D, Q, oe, ue, de) {
            if (!b(D, Q, oe, ue, de)) {
              var we = (Q + ue) * 0.5, me = (oe + de) * 0.5, Le = D.nodes;
              Le[0] && ba(b, Le[0], Q, oe, we, me), Le[1] && ba(b, Le[1], we, oe, ue, me), Le[2] && ba(b, Le[2], Q, me, we, de), Le[3] && ba(b, Le[3], we, me, ue, de);
            }
          }
          function yv(b, D, Q, oe, ue, de, we) {
            var me = 1 / 0, Le;
            return function Fe(Be, et, rt, pt, bt) {
              if (!(et > de || rt > we || pt < oe || bt < ue)) {
                if (nt = Be.point) {
                  var nt, ut = D - Be.x, ft = Q - Be.y, yt = ut * ut + ft * ft;
                  if (yt < me) {
                    var mt = Math.sqrt(me = yt);
                    oe = D - mt, ue = Q - mt, de = D + mt, we = Q + mt, Le = nt;
                  }
                }
                for (var dt = Be.nodes, zt = (et + pt) * 0.5, Zt = (rt + bt) * 0.5, Jt = D >= zt, Xt = Q >= Zt, er = Xt << 1 | Jt, tr = er + 4; er < tr; ++er) if (Be = dt[er & 3]) switch (er & 3) {
                  case 0:
                    Fe(Be, et, rt, zt, Zt);
                    break;
                  case 1:
                    Fe(Be, zt, rt, pt, Zt);
                    break;
                  case 2:
                    Fe(Be, et, Zt, zt, bt);
                    break;
                  case 3:
                    Fe(Be, zt, Zt, pt, bt);
                    break;
                }
              }
            }(b, oe, ue, de, we), Le;
          }
          n.interpolateRgb = xl;
          function xl(b, D) {
            b = n.rgb(b), D = n.rgb(D);
            var Q = b.r, oe = b.g, ue = b.b, de = D.r - Q, we = D.g - oe, me = D.b - ue;
            return function(Le) {
              return "#" + Pe(Math.round(Q + de * Le)) + Pe(Math.round(oe + we * Le)) + Pe(Math.round(ue + me * Le));
            };
          }
          n.interpolateObject = vc;
          function vc(b, D) {
            var Q = {}, oe = {}, ue;
            for (ue in b) ue in D ? Q[ue] = Oa(b[ue], D[ue]) : oe[ue] = b[ue];
            for (ue in D) ue in b || (oe[ue] = D[ue]);
            return function(de) {
              for (ue in Q) oe[ue] = Q[ue](de);
              return oe;
            };
          }
          n.interpolateNumber = ha;
          function ha(b, D) {
            return b = +b, D = +D, function(Q) {
              return b * (1 - Q) + D * Q;
            };
          }
          n.interpolateString = gc;
          function gc(b, D) {
            var Q = bl.lastIndex = _l.lastIndex = 0, oe, ue, de, we = -1, me = [], Le = [];
            for (b = b + "", D = D + ""; (oe = bl.exec(b)) && (ue = _l.exec(D)); ) (de = ue.index) > Q && (de = D.slice(Q, de), me[we] ? me[we] += de : me[++we] = de), (oe = oe[0]) === (ue = ue[0]) ? me[we] ? me[we] += ue : me[++we] = ue : (me[++we] = null, Le.push({ i: we, x: ha(oe, ue) })), Q = _l.lastIndex;
            return Q < D.length && (de = D.slice(Q), me[we] ? me[we] += de : me[++we] = de), me.length < 2 ? Le[0] ? (D = Le[0].x, function(Fe) {
              return D(Fe) + "";
            }) : function() {
              return D;
            } : (D = Le.length, function(Fe) {
              for (var Be = 0, et; Be < D; ++Be) me[(et = Le[Be]).i] = et.x(Fe);
              return me.join("");
            });
          }
          var bl = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, _l = new RegExp(bl.source, "g");
          n.interpolate = Oa;
          function Oa(b, D) {
            for (var Q = n.interpolators.length, oe; --Q >= 0 && !(oe = n.interpolators[Q](b, D)); ) ;
            return oe;
          }
          n.interpolators = [function(b, D) {
            var Q = typeof D;
            return (Q === "string" ? Ve.has(D.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(D) ? xl : gc : D instanceof It ? xl : Array.isArray(D) ? Vi : Q === "object" && isNaN(D) ? vc : ha)(b, D);
          }], n.interpolateArray = Vi;
          function Vi(b, D) {
            var Q = [], oe = [], ue = b.length, de = D.length, we = Math.min(b.length, D.length), me;
            for (me = 0; me < we; ++me) Q.push(Oa(b[me], D[me]));
            for (; me < ue; ++me) oe[me] = b[me];
            for (; me < de; ++me) oe[me] = D[me];
            return function(Le) {
              for (me = 0; me < we; ++me) oe[me] = Q[me](Le);
              return oe;
            };
          }
          var yc = function() {
            return K;
          }, mv = n.map({ linear: yc, poly: kv, quad: function() {
            return _v;
          }, cubic: function() {
            return wv;
          }, sin: function() {
            return Mv;
          }, exp: function() {
            return Av;
          }, circle: function() {
            return Sv;
          }, elastic: Lv, back: Ov, bounce: function() {
            return Cv;
          } }), xv = n.map({ in: K, out: mc, "in-out": xc, "out-in": function(b) {
            return xc(mc(b));
          } });
          n.ease = function(b) {
            var D = b.indexOf("-"), Q = D >= 0 ? b.slice(0, D) : b, oe = D >= 0 ? b.slice(D + 1) : "in";
            return Q = mv.get(Q) || yc, oe = xv.get(oe) || K, bv(oe(Q.apply(null, e.call(arguments, 1))));
          };
          function bv(b) {
            return function(D) {
              return D <= 0 ? 0 : D >= 1 ? 1 : b(D);
            };
          }
          function mc(b) {
            return function(D) {
              return 1 - b(1 - D);
            };
          }
          function xc(b) {
            return function(D) {
              return 0.5 * (D < 0.5 ? b(2 * D) : 2 - b(2 - 2 * D));
            };
          }
          function _v(b) {
            return b * b;
          }
          function wv(b) {
            return b * b * b;
          }
          function Tv(b) {
            if (b <= 0) return 0;
            if (b >= 1) return 1;
            var D = b * b, Q = D * b;
            return 4 * (b < 0.5 ? Q : 3 * (b - D) + Q - 0.75);
          }
          function kv(b) {
            return function(D) {
              return Math.pow(D, b);
            };
          }
          function Mv(b) {
            return 1 - Math.cos(b * Oe);
          }
          function Av(b) {
            return Math.pow(2, 10 * (b - 1));
          }
          function Sv(b) {
            return 1 - Math.sqrt(1 - b * b);
          }
          function Lv(b, D) {
            var Q;
            return arguments.length < 2 && (D = 0.45), arguments.length ? Q = D / ye * Math.asin(1 / b) : (b = 1, Q = D / 4), function(oe) {
              return 1 + b * Math.pow(2, -10 * oe) * Math.sin((oe - Q) * ye / D);
            };
          }
          function Ov(b) {
            return b || (b = 1.70158), function(D) {
              return D * D * ((b + 1) * D - b);
            };
          }
          function Cv(b) {
            return b < 1 / 2.75 ? 7.5625 * b * b : b < 2 / 2.75 ? 7.5625 * (b -= 1.5 / 2.75) * b + 0.75 : b < 2.5 / 2.75 ? 7.5625 * (b -= 2.25 / 2.75) * b + 0.9375 : 7.5625 * (b -= 2.625 / 2.75) * b + 0.984375;
          }
          n.interpolateHcl = Ev;
          function Ev(b, D) {
            b = n.hcl(b), D = n.hcl(D);
            var Q = b.h, oe = b.c, ue = b.l, de = D.h - Q, we = D.c - oe, me = D.l - ue;
            return isNaN(we) && (we = 0, oe = isNaN(oe) ? D.c : oe), isNaN(de) ? (de = 0, Q = isNaN(Q) ? D.h : Q) : de > 180 ? de -= 360 : de < -180 && (de += 360), function(Le) {
              return Ct(Q + de * Le, oe + we * Le, ue + me * Le) + "";
            };
          }
          n.interpolateHsl = Dv;
          function Dv(b, D) {
            b = n.hsl(b), D = n.hsl(D);
            var Q = b.h, oe = b.s, ue = b.l, de = D.h - Q, we = D.s - oe, me = D.l - ue;
            return isNaN(we) && (we = 0, oe = isNaN(oe) ? D.s : oe), isNaN(de) ? (de = 0, Q = isNaN(Q) ? D.h : Q) : de > 180 ? de -= 360 : de < -180 && (de += 360), function(Le) {
              return Vt(Q + de * Le, oe + we * Le, ue + me * Le) + "";
            };
          }
          n.interpolateLab = Pv;
          function Pv(b, D) {
            b = n.lab(b), D = n.lab(D);
            var Q = b.l, oe = b.a, ue = b.b, de = D.l - Q, we = D.a - oe, me = D.b - ue;
            return function(Le) {
              return cr(Q + de * Le, oe + we * Le, ue + me * Le) + "";
            };
          }
          n.interpolateRound = bc;
          function bc(b, D) {
            return D -= b, function(Q) {
              return Math.round(b + D * Q);
            };
          }
          n.transform = function(b) {
            var D = i.createElementNS(n.ns.prefix.svg, "g");
            return (n.transform = function(Q) {
              if (Q != null) {
                D.setAttribute("transform", Q);
                var oe = D.transform.baseVal.consolidate();
              }
              return new _c(oe ? oe.matrix : zv);
            })(b);
          };
          function _c(b) {
            var D = [b.a, b.b], Q = [b.c, b.d], oe = Tc(D), ue = wc(D, Q), de = Tc(Iv(Q, D, -ue)) || 0;
            D[0] * Q[1] < Q[0] * D[1] && (D[0] *= -1, D[1] *= -1, oe *= -1, ue *= -1), this.rotate = (oe ? Math.atan2(D[1], D[0]) : Math.atan2(-Q[0], Q[1])) * qe, this.translate = [b.e, b.f], this.scale = [oe, de], this.skew = de ? Math.atan2(ue, de) * qe : 0;
          }
          _c.prototype.toString = function() {
            return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
          };
          function wc(b, D) {
            return b[0] * D[0] + b[1] * D[1];
          }
          function Tc(b) {
            var D = Math.sqrt(wc(b, b));
            return D && (b[0] /= D, b[1] /= D), D;
          }
          function Iv(b, D, Q) {
            return b[0] += Q * D[0], b[1] += Q * D[1], b;
          }
          var zv = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 };
          n.interpolateTransform = kc;
          function Ya(b) {
            return b.length ? b.pop() + "," : "";
          }
          function Rv(b, D, Q, oe) {
            if (b[0] !== D[0] || b[1] !== D[1]) {
              var ue = Q.push("translate(", null, ",", null, ")");
              oe.push({ i: ue - 4, x: ha(b[0], D[0]) }, { i: ue - 2, x: ha(b[1], D[1]) });
            } else (D[0] || D[1]) && Q.push("translate(" + D + ")");
          }
          function Nv(b, D, Q, oe) {
            b !== D ? (b - D > 180 ? D += 360 : D - b > 180 && (b += 360), oe.push({ i: Q.push(Ya(Q) + "rotate(", null, ")") - 2, x: ha(b, D) })) : D && Q.push(Ya(Q) + "rotate(" + D + ")");
          }
          function Fv(b, D, Q, oe) {
            b !== D ? oe.push({ i: Q.push(Ya(Q) + "skewX(", null, ")") - 2, x: ha(b, D) }) : D && Q.push(Ya(Q) + "skewX(" + D + ")");
          }
          function Bv(b, D, Q, oe) {
            if (b[0] !== D[0] || b[1] !== D[1]) {
              var ue = Q.push(Ya(Q) + "scale(", null, ",", null, ")");
              oe.push({ i: ue - 4, x: ha(b[0], D[0]) }, { i: ue - 2, x: ha(b[1], D[1]) });
            } else (D[0] !== 1 || D[1] !== 1) && Q.push(Ya(Q) + "scale(" + D + ")");
          }
          function kc(b, D) {
            var Q = [], oe = [];
            return b = n.transform(b), D = n.transform(D), Rv(b.translate, D.translate, Q, oe), Nv(b.rotate, D.rotate, Q, oe), Fv(b.skew, D.skew, Q, oe), Bv(b.scale, D.scale, Q, oe), b = D = null, function(ue) {
              for (var de = -1, we = oe.length, me; ++de < we; ) Q[(me = oe[de]).i] = me.x(ue);
              return Q.join("");
            };
          }
          function jv(b, D) {
            return D = (D -= b = +b) || 1 / D, function(Q) {
              return (Q - b) / D;
            };
          }
          function Hv(b, D) {
            return D = (D -= b = +b) || 1 / D, function(Q) {
              return Math.max(0, Math.min(1, (Q - b) / D));
            };
          }
          n.layout = {}, n.layout.bundle = function() {
            return function(b) {
              for (var D = [], Q = -1, oe = b.length; ++Q < oe; ) D.push(qv(b[Q]));
              return D;
            };
          };
          function qv(b) {
            for (var D = b.source, Q = b.target, oe = Uv(D, Q), ue = [D]; D !== oe; ) D = D.parent, ue.push(D);
            for (var de = ue.length; Q !== oe; ) ue.splice(de, 0, Q), Q = Q.parent;
            return ue;
          }
          function Mc(b) {
            for (var D = [], Q = b.parent; Q != null; ) D.push(b), b = Q, Q = Q.parent;
            return D.push(b), D;
          }
          function Uv(b, D) {
            if (b === D) return b;
            for (var Q = Mc(b), oe = Mc(D), ue = Q.pop(), de = oe.pop(), we = null; ue === de; ) we = ue, ue = Q.pop(), de = oe.pop();
            return we;
          }
          n.layout.chord = function() {
            var b = {}, D, Q, oe, ue, de = 0, we, me, Le;
            function Fe() {
              var et = {}, rt = [], pt = n.range(ue), bt = [], nt, ut, ft, yt, mt;
              for (D = [], Q = [], nt = 0, yt = -1; ++yt < ue; ) {
                for (ut = 0, mt = -1; ++mt < ue; ) ut += oe[yt][mt];
                rt.push(ut), bt.push(n.range(ue)), nt += ut;
              }
              for (we && pt.sort(function(gr, ir) {
                return we(rt[gr], rt[ir]);
              }), me && bt.forEach(function(gr, ir) {
                gr.sort(function(pr, zr) {
                  return me(oe[ir][pr], oe[ir][zr]);
                });
              }), nt = (ye - de * ue) / nt, ut = 0, yt = -1; ++yt < ue; ) {
                for (ft = ut, mt = -1; ++mt < ue; ) {
                  var dt = pt[yt], zt = bt[dt][mt], Zt = oe[dt][zt], Jt = ut, Xt = ut += Zt * nt;
                  et[dt + "-" + zt] = { index: dt, subindex: zt, startAngle: Jt, endAngle: Xt, value: Zt };
                }
                Q[dt] = { index: dt, startAngle: ft, endAngle: ut, value: rt[dt] }, ut += de;
              }
              for (yt = -1; ++yt < ue; ) for (mt = yt - 1; ++mt < ue; ) {
                var er = et[yt + "-" + mt], tr = et[mt + "-" + yt];
                (er.value || tr.value) && D.push(er.value < tr.value ? { source: tr, target: er } : { source: er, target: tr });
              }
              Le && Be();
            }
            function Be() {
              D.sort(function(et, rt) {
                return Le((et.source.value + et.target.value) / 2, (rt.source.value + rt.target.value) / 2);
              });
            }
            return b.matrix = function(et) {
              return arguments.length ? (ue = (oe = et) && oe.length, D = Q = null, b) : oe;
            }, b.padding = function(et) {
              return arguments.length ? (de = et, D = Q = null, b) : de;
            }, b.sortGroups = function(et) {
              return arguments.length ? (we = et, D = Q = null, b) : we;
            }, b.sortSubgroups = function(et) {
              return arguments.length ? (me = et, D = null, b) : me;
            }, b.sortChords = function(et) {
              return arguments.length ? (Le = et, D && Be(), b) : Le;
            }, b.chords = function() {
              return D || Fe(), D;
            }, b.groups = function() {
              return Q || Fe(), Q;
            }, b;
          }, n.layout.force = function() {
            var b = {}, D = n.dispatch("start", "tick", "end"), Q, oe = [1, 1], ue, de, we = 0.9, me = Wv, Le = Xv, Fe = -30, Be = Jv, et = 0.1, rt = 0.64, pt = [], bt = [], nt, ut, ft;
            function yt(dt) {
              return function(zt, Zt, Jt, Xt) {
                if (zt.point !== dt) {
                  var er = zt.cx - dt.x, tr = zt.cy - dt.y, gr = Xt - Zt, ir = er * er + tr * tr;
                  if (gr * gr / rt < ir) {
                    if (ir < Be) {
                      var pr = zt.charge / ir;
                      dt.px -= er * pr, dt.py -= tr * pr;
                    }
                    return !0;
                  }
                  if (zt.point && ir && ir < Be) {
                    var pr = zt.pointCharge / ir;
                    dt.px -= er * pr, dt.py -= tr * pr;
                  }
                }
                return !zt.charge;
              };
            }
            b.tick = function() {
              if ((de *= 0.99) < 5e-3) return Q = null, D.end({ type: "end", alpha: de = 0 }), !0;
              var dt = pt.length, zt = bt.length, Zt, Jt, Xt, er, tr, gr, ir, pr, zr;
              for (Jt = 0; Jt < zt; ++Jt) Xt = bt[Jt], er = Xt.source, tr = Xt.target, pr = tr.x - er.x, zr = tr.y - er.y, (gr = pr * pr + zr * zr) && (gr = de * ut[Jt] * ((gr = Math.sqrt(gr)) - nt[Jt]) / gr, pr *= gr, zr *= gr, tr.x -= pr * (ir = er.weight + tr.weight ? er.weight / (er.weight + tr.weight) : 0.5), tr.y -= zr * ir, er.x += pr * (ir = 1 - ir), er.y += zr * ir);
              if ((ir = de * et) && (pr = oe[0] / 2, zr = oe[1] / 2, Jt = -1, ir)) for (; ++Jt < dt; ) Xt = pt[Jt], Xt.x += (pr - Xt.x) * ir, Xt.y += (zr - Xt.y) * ir;
              if (Fe) for (Ac(Zt = n.geom.quadtree(pt), de, ft), Jt = -1; ++Jt < dt; ) (Xt = pt[Jt]).fixed || Zt.visit(yt(Xt));
              for (Jt = -1; ++Jt < dt; ) Xt = pt[Jt], Xt.fixed ? (Xt.x = Xt.px, Xt.y = Xt.py) : (Xt.x -= (Xt.px - (Xt.px = Xt.x)) * we, Xt.y -= (Xt.py - (Xt.py = Xt.y)) * we);
              D.tick({ type: "tick", alpha: de });
            }, b.nodes = function(dt) {
              return arguments.length ? (pt = dt, b) : pt;
            }, b.links = function(dt) {
              return arguments.length ? (bt = dt, b) : bt;
            }, b.size = function(dt) {
              return arguments.length ? (oe = dt, b) : oe;
            }, b.linkDistance = function(dt) {
              return arguments.length ? (me = typeof dt == "function" ? dt : +dt, b) : me;
            }, b.distance = b.linkDistance, b.linkStrength = function(dt) {
              return arguments.length ? (Le = typeof dt == "function" ? dt : +dt, b) : Le;
            }, b.friction = function(dt) {
              return arguments.length ? (we = +dt, b) : we;
            }, b.charge = function(dt) {
              return arguments.length ? (Fe = typeof dt == "function" ? dt : +dt, b) : Fe;
            }, b.chargeDistance = function(dt) {
              return arguments.length ? (Be = dt * dt, b) : Math.sqrt(Be);
            }, b.gravity = function(dt) {
              return arguments.length ? (et = +dt, b) : et;
            }, b.theta = function(dt) {
              return arguments.length ? (rt = dt * dt, b) : Math.sqrt(rt);
            }, b.alpha = function(dt) {
              return arguments.length ? (dt = +dt, de ? dt > 0 ? de = dt : (Q.c = null, Q.t = NaN, Q = null, D.end({ type: "end", alpha: de = 0 })) : dt > 0 && (D.start({ type: "start", alpha: de = dt }), Q = Ht(b.tick)), b) : de;
            }, b.start = function() {
              var dt, zt = pt.length, Zt = bt.length, Jt = oe[0], Xt = oe[1], er, tr;
              for (dt = 0; dt < zt; ++dt) (tr = pt[dt]).index = dt, tr.weight = 0;
              for (dt = 0; dt < Zt; ++dt) tr = bt[dt], typeof tr.source == "number" && (tr.source = pt[tr.source]), typeof tr.target == "number" && (tr.target = pt[tr.target]), ++tr.source.weight, ++tr.target.weight;
              for (dt = 0; dt < zt; ++dt) tr = pt[dt], isNaN(tr.x) && (tr.x = gr("x", Jt)), isNaN(tr.y) && (tr.y = gr("y", Xt)), isNaN(tr.px) && (tr.px = tr.x), isNaN(tr.py) && (tr.py = tr.y);
              if (nt = [], typeof me == "function") for (dt = 0; dt < Zt; ++dt) nt[dt] = +me.call(this, bt[dt], dt);
              else for (dt = 0; dt < Zt; ++dt) nt[dt] = me;
              if (ut = [], typeof Le == "function") for (dt = 0; dt < Zt; ++dt) ut[dt] = +Le.call(this, bt[dt], dt);
              else for (dt = 0; dt < Zt; ++dt) ut[dt] = Le;
              if (ft = [], typeof Fe == "function") for (dt = 0; dt < zt; ++dt) ft[dt] = +Fe.call(this, pt[dt], dt);
              else for (dt = 0; dt < zt; ++dt) ft[dt] = Fe;
              function gr(ir, pr) {
                if (!er) {
                  for (er = new Array(zt), Fr = 0; Fr < zt; ++Fr) er[Fr] = [];
                  for (Fr = 0; Fr < Zt; ++Fr) {
                    var zr = bt[Fr];
                    er[zr.source.index].push(zr.target), er[zr.target.index].push(zr.source);
                  }
                }
                for (var an = er[dt], Fr = -1, Gt = an.length, yr; ++Fr < Gt; ) if (!isNaN(yr = an[Fr][ir])) return yr;
                return Math.random() * pr;
              }
              return b.resume();
            }, b.resume = function() {
              return b.alpha(0.1);
            }, b.stop = function() {
              return b.alpha(0);
            }, b.drag = function() {
              if (ue || (ue = n.behavior.drag().origin(K).on("dragstart.force", Vv).on("drag.force", mt).on("dragend.force", Yv)), !arguments.length) return ue;
              this.on("mouseover.force", Gv).on("mouseout.force", Zv).call(ue);
            };
            function mt(dt) {
              dt.px = n.event.x, dt.py = n.event.y, b.resume();
            }
            return n.rebind(b, D, "on");
          };
          function Vv(b) {
            b.fixed |= 2;
          }
          function Yv(b) {
            b.fixed &= -7;
          }
          function Gv(b) {
            b.fixed |= 4, b.px = b.x, b.py = b.y;
          }
          function Zv(b) {
            b.fixed &= -5;
          }
          function Ac(b, D, Q) {
            var oe = 0, ue = 0;
            if (b.charge = 0, !b.leaf) for (var de = b.nodes, we = de.length, me = -1, Le; ++me < we; ) Le = de[me], Le != null && (Ac(Le, D, Q), b.charge += Le.charge, oe += Le.charge * Le.cx, ue += Le.charge * Le.cy);
            if (b.point) {
              b.leaf || (b.point.x += Math.random() - 0.5, b.point.y += Math.random() - 0.5);
              var Fe = D * Q[b.point.index];
              b.charge += b.pointCharge = Fe, oe += Fe * b.point.x, ue += Fe * b.point.y;
            }
            b.cx = oe / b.charge, b.cy = ue / b.charge;
          }
          var Wv = 20, Xv = 1, Jv = 1 / 0;
          n.layout.hierarchy = function() {
            var b = Qv, D = $v, Q = Kv;
            function oe(ue) {
              var de = [ue], we = [], me;
              for (ue.depth = 0; (me = de.pop()) != null; ) if (we.push(me), (Fe = D.call(oe, me, me.depth)) && (Le = Fe.length)) {
                for (var Le, Fe, Be; --Le >= 0; ) de.push(Be = Fe[Le]), Be.parent = me, Be.depth = me.depth + 1;
                Q && (me.value = 0), me.children = Fe;
              } else Q && (me.value = +Q.call(oe, me, me.depth) || 0), delete me.children;
              return la(ue, function(et) {
                var rt, pt;
                b && (rt = et.children) && rt.sort(b), Q && (pt = et.parent) && (pt.value += et.value);
              }), we;
            }
            return oe.sort = function(ue) {
              return arguments.length ? (b = ue, oe) : b;
            }, oe.children = function(ue) {
              return arguments.length ? (D = ue, oe) : D;
            }, oe.value = function(ue) {
              return arguments.length ? (Q = ue, oe) : Q;
            }, oe.revalue = function(ue) {
              return Q && (yi(ue, function(de) {
                de.children && (de.value = 0);
              }), la(ue, function(de) {
                var we;
                de.children || (de.value = +Q.call(oe, de, de.depth) || 0), (we = de.parent) && (we.value += de.value);
              })), ue;
            }, oe;
          };
          function gi(b, D) {
            return n.rebind(b, D, "sort", "children", "value"), b.nodes = b, b.links = eg, b;
          }
          function yi(b, D) {
            for (var Q = [b]; (b = Q.pop()) != null; ) if (D(b), (ue = b.children) && (oe = ue.length)) for (var oe, ue; --oe >= 0; ) Q.push(ue[oe]);
          }
          function la(b, D) {
            for (var Q = [b], oe = []; (b = Q.pop()) != null; ) if (oe.push(b), (we = b.children) && (de = we.length)) for (var ue = -1, de, we; ++ue < de; ) Q.push(we[ue]);
            for (; (b = oe.pop()) != null; ) D(b);
          }
          function $v(b) {
            return b.children;
          }
          function Kv(b) {
            return b.value;
          }
          function Qv(b, D) {
            return D.value - b.value;
          }
          function eg(b) {
            return n.merge(b.map(function(D) {
              return (D.children || []).map(function(Q) {
                return { source: D, target: Q };
              });
            }));
          }
          n.layout.partition = function() {
            var b = n.layout.hierarchy(), D = [1, 1];
            function Q(de, we, me, Le) {
              var Fe = de.children;
              if (de.x = we, de.y = de.depth * Le, de.dx = me, de.dy = Le, Fe && (et = Fe.length)) {
                var Be = -1, et, rt, pt;
                for (me = de.value ? me / de.value : 0; ++Be < et; ) Q(rt = Fe[Be], we, pt = rt.value * me, Le), we += pt;
              }
            }
            function oe(de) {
              var we = de.children, me = 0;
              if (we && (Fe = we.length)) for (var Le = -1, Fe; ++Le < Fe; ) me = Math.max(me, oe(we[Le]));
              return 1 + me;
            }
            function ue(de, we) {
              var me = b.call(this, de, we);
              return Q(me[0], 0, D[0], D[1] / oe(me[0])), me;
            }
            return ue.size = function(de) {
              return arguments.length ? (D = de, ue) : D;
            }, gi(ue, b);
          }, n.layout.pie = function() {
            var b = Number, D = Sc, Q = 0, oe = ye, ue = 0;
            function de(we) {
              var me = we.length, Le = we.map(function(yt, mt) {
                return +b.call(de, yt, mt);
              }), Fe = +(typeof Q == "function" ? Q.apply(this, arguments) : Q), Be = (typeof oe == "function" ? oe.apply(this, arguments) : oe) - Fe, et = Math.min(Math.abs(Be) / me, +(typeof ue == "function" ? ue.apply(this, arguments) : ue)), rt = et * (Be < 0 ? -1 : 1), pt = n.sum(Le), bt = pt ? (Be - me * rt) / pt : 0, nt = n.range(me), ut = [], ft;
              return D != null && nt.sort(D === Sc ? function(yt, mt) {
                return Le[mt] - Le[yt];
              } : function(yt, mt) {
                return D(we[yt], we[mt]);
              }), nt.forEach(function(yt) {
                ut[yt] = { data: we[yt], value: ft = Le[yt], startAngle: Fe, endAngle: Fe += ft * bt + rt, padAngle: et };
              }), ut;
            }
            return de.value = function(we) {
              return arguments.length ? (b = we, de) : b;
            }, de.sort = function(we) {
              return arguments.length ? (D = we, de) : D;
            }, de.startAngle = function(we) {
              return arguments.length ? (Q = we, de) : Q;
            }, de.endAngle = function(we) {
              return arguments.length ? (oe = we, de) : oe;
            }, de.padAngle = function(we) {
              return arguments.length ? (ue = we, de) : ue;
            }, de;
          };
          var Sc = {};
          n.layout.stack = function() {
            var b = K, D = wl, Q = Tl, oe = ng, ue = tg, de = rg;
            function we(me, Le) {
              if (!(bt = me.length)) return me;
              var Fe = me.map(function(yt, mt) {
                return b.call(we, yt, mt);
              }), Be = Fe.map(function(yt) {
                return yt.map(function(mt, dt) {
                  return [ue.call(we, mt, dt), de.call(we, mt, dt)];
                });
              }), et = D.call(we, Be, Le);
              Fe = n.permute(Fe, et), Be = n.permute(Be, et);
              var rt = Q.call(we, Be, Le), pt = Fe[0].length, bt, nt, ut, ft;
              for (ut = 0; ut < pt; ++ut) for (oe.call(we, Fe[0][ut], ft = rt[ut], Be[0][ut][1]), nt = 1; nt < bt; ++nt) oe.call(we, Fe[nt][ut], ft += Be[nt - 1][ut][1], Be[nt][ut][1]);
              return me;
            }
            return we.values = function(me) {
              return arguments.length ? (b = me, we) : b;
            }, we.order = function(me) {
              return arguments.length ? (D = typeof me == "function" ? me : ag.get(me) || wl, we) : D;
            }, we.offset = function(me) {
              return arguments.length ? (Q = typeof me == "function" ? me : ig.get(me) || Tl, we) : Q;
            }, we.x = function(me) {
              return arguments.length ? (ue = me, we) : ue;
            }, we.y = function(me) {
              return arguments.length ? (de = me, we) : de;
            }, we.out = function(me) {
              return arguments.length ? (oe = me, we) : oe;
            }, we;
          };
          function tg(b) {
            return b.x;
          }
          function rg(b) {
            return b.y;
          }
          function ng(b, D, Q) {
            b.y0 = D, b.y = Q;
          }
          var ag = n.map({ "inside-out": function(b) {
            var D = b.length, Q, oe, ue = b.map(og), de = b.map(lg), we = n.range(D).sort(function(et, rt) {
              return ue[et] - ue[rt];
            }), me = 0, Le = 0, Fe = [], Be = [];
            for (Q = 0; Q < D; ++Q) oe = we[Q], me < Le ? (me += de[oe], Fe.push(oe)) : (Le += de[oe], Be.push(oe));
            return Be.reverse().concat(Fe);
          }, reverse: function(b) {
            return n.range(b.length).reverse();
          }, default: wl }), ig = n.map({ silhouette: function(b) {
            var D = b.length, Q = b[0].length, oe = [], ue = 0, de, we, me, Le = [];
            for (we = 0; we < Q; ++we) {
              for (de = 0, me = 0; de < D; de++) me += b[de][we][1];
              me > ue && (ue = me), oe.push(me);
            }
            for (we = 0; we < Q; ++we) Le[we] = (ue - oe[we]) / 2;
            return Le;
          }, wiggle: function(b) {
            var D = b.length, Q = b[0], oe = Q.length, ue, de, we, me, Le, Fe, Be, et, rt, pt = [];
            for (pt[0] = et = rt = 0, de = 1; de < oe; ++de) {
              for (ue = 0, me = 0; ue < D; ++ue) me += b[ue][de][1];
              for (ue = 0, Le = 0, Be = Q[de][0] - Q[de - 1][0]; ue < D; ++ue) {
                for (we = 0, Fe = (b[ue][de][1] - b[ue][de - 1][1]) / (2 * Be); we < ue; ++we) Fe += (b[we][de][1] - b[we][de - 1][1]) / Be;
                Le += Fe * b[ue][de][1];
              }
              pt[de] = et -= me ? Le / me * Be : 0, et < rt && (rt = et);
            }
            for (de = 0; de < oe; ++de) pt[de] -= rt;
            return pt;
          }, expand: function(b) {
            var D = b.length, Q = b[0].length, oe = 1 / D, ue, de, we, me = [];
            for (de = 0; de < Q; ++de) {
              for (ue = 0, we = 0; ue < D; ue++) we += b[ue][de][1];
              if (we) for (ue = 0; ue < D; ue++) b[ue][de][1] /= we;
              else for (ue = 0; ue < D; ue++) b[ue][de][1] = oe;
            }
            for (de = 0; de < Q; ++de) me[de] = 0;
            return me;
          }, zero: Tl });
          function wl(b) {
            return n.range(b.length);
          }
          function Tl(b) {
            for (var D = -1, Q = b[0].length, oe = []; ++D < Q; ) oe[D] = 0;
            return oe;
          }
          function og(b) {
            for (var D = 1, Q = 0, oe = b[0][1], ue, de = b.length; D < de; ++D) (ue = b[D][1]) > oe && (Q = D, oe = ue);
            return Q;
          }
          function lg(b) {
            return b.reduce(sg, 0);
          }
          function sg(b, D) {
            return b + D[1];
          }
          n.layout.histogram = function() {
            var b = !0, D = Number, Q = cg, oe = ug;
            function ue(de, we) {
              for (var me = [], Le = de.map(D, this), Fe = Q.call(this, Le, we), Be = oe.call(this, Fe, Le, we), et, we = -1, rt = Le.length, pt = Be.length - 1, bt = b ? 1 : 1 / rt, nt; ++we < pt; ) et = me[we] = [], et.dx = Be[we + 1] - (et.x = Be[we]), et.y = 0;
              if (pt > 0) for (we = -1; ++we < rt; ) nt = Le[we], nt >= Fe[0] && nt <= Fe[1] && (et = me[n.bisect(Be, nt, 1, pt) - 1], et.y += bt, et.push(de[we]));
              return me;
            }
            return ue.value = function(de) {
              return arguments.length ? (D = de, ue) : D;
            }, ue.range = function(de) {
              return arguments.length ? (Q = tt(de), ue) : Q;
            }, ue.bins = function(de) {
              return arguments.length ? (oe = typeof de == "number" ? function(we) {
                return Lc(we, de);
              } : tt(de), ue) : oe;
            }, ue.frequency = function(de) {
              return arguments.length ? (b = !!de, ue) : b;
            }, ue;
          };
          function ug(b, D) {
            return Lc(b, Math.ceil(Math.log(D.length) / Math.LN2 + 1));
          }
          function Lc(b, D) {
            for (var Q = -1, oe = +b[0], ue = (b[1] - oe) / D, de = []; ++Q <= D; ) de[Q] = ue * Q + oe;
            return de;
          }
          function cg(b) {
            return [n.min(b), n.max(b)];
          }
          n.layout.pack = function() {
            var b = n.layout.hierarchy().sort(fg), D = 0, Q = [1, 1], oe;
            function ue(de, we) {
              var me = b.call(this, de, we), Le = me[0], Fe = Q[0], Be = Q[1], et = oe == null ? Math.sqrt : typeof oe == "function" ? oe : function() {
                return oe;
              };
              if (Le.x = Le.y = 0, la(Le, function(pt) {
                pt.r = +et(pt.value);
              }), la(Le, Ec), D) {
                var rt = D * (oe ? 1 : Math.max(2 * Le.r / Fe, 2 * Le.r / Be)) / 2;
                la(Le, function(pt) {
                  pt.r += rt;
                }), la(Le, Ec), la(Le, function(pt) {
                  pt.r -= rt;
                });
              }
              return Dc(Le, Fe / 2, Be / 2, oe ? 1 : 1 / Math.max(2 * Le.r / Fe, 2 * Le.r / Be)), me;
            }
            return ue.size = function(de) {
              return arguments.length ? (Q = de, ue) : Q;
            }, ue.radius = function(de) {
              return arguments.length ? (oe = de == null || typeof de == "function" ? de : +de, ue) : oe;
            }, ue.padding = function(de) {
              return arguments.length ? (D = +de, ue) : D;
            }, gi(ue, b);
          };
          function fg(b, D) {
            return b.value - D.value;
          }
          function kl(b, D) {
            var Q = b._pack_next;
            b._pack_next = D, D._pack_prev = b, D._pack_next = Q, Q._pack_prev = D;
          }
          function Oc(b, D) {
            b._pack_next = D, D._pack_prev = b;
          }
          function Cc(b, D) {
            var Q = D.x - b.x, oe = D.y - b.y, ue = b.r + D.r;
            return 0.999 * ue * ue > Q * Q + oe * oe;
          }
          function Ec(b) {
            if (!(D = b.children) || !(rt = D.length)) return;
            var D, Q = 1 / 0, oe = -1 / 0, ue = 1 / 0, de = -1 / 0, we, me, Le, Fe, Be, et, rt;
            function pt(dt) {
              Q = Math.min(dt.x - dt.r, Q), oe = Math.max(dt.x + dt.r, oe), ue = Math.min(dt.y - dt.r, ue), de = Math.max(dt.y + dt.r, de);
            }
            if (D.forEach(dg), we = D[0], we.x = -we.r, we.y = 0, pt(we), rt > 1 && (me = D[1], me.x = me.r, me.y = 0, pt(me), rt > 2)) for (Le = D[2], Pc(we, me, Le), pt(Le), kl(we, Le), we._pack_prev = Le, kl(Le, me), me = we._pack_next, Fe = 3; Fe < rt; Fe++) {
              Pc(we, me, Le = D[Fe]);
              var bt = 0, nt = 1, ut = 1;
              for (Be = me._pack_next; Be !== me; Be = Be._pack_next, nt++) if (Cc(Be, Le)) {
                bt = 1;
                break;
              }
              if (bt == 1) for (et = we._pack_prev; et !== Be._pack_prev && !Cc(et, Le); et = et._pack_prev, ut++) ;
              bt ? (nt < ut || nt == ut && me.r < we.r ? Oc(we, me = Be) : Oc(we = et, me), Fe--) : (kl(we, Le), me = Le, pt(Le));
            }
            var ft = (Q + oe) / 2, yt = (ue + de) / 2, mt = 0;
            for (Fe = 0; Fe < rt; Fe++) Le = D[Fe], Le.x -= ft, Le.y -= yt, mt = Math.max(mt, Le.r + Math.sqrt(Le.x * Le.x + Le.y * Le.y));
            b.r = mt, D.forEach(pg);
          }
          function dg(b) {
            b._pack_next = b._pack_prev = b;
          }
          function pg(b) {
            delete b._pack_next, delete b._pack_prev;
          }
          function Dc(b, D, Q, oe) {
            var ue = b.children;
            if (b.x = D += oe * b.x, b.y = Q += oe * b.y, b.r *= oe, ue) for (var de = -1, we = ue.length; ++de < we; ) Dc(ue[de], D, Q, oe);
          }
          function Pc(b, D, Q) {
            var oe = b.r + Q.r, ue = D.x - b.x, de = D.y - b.y;
            if (oe && (ue || de)) {
              var we = D.r + Q.r, me = ue * ue + de * de;
              we *= we, oe *= oe;
              var Le = 0.5 + (oe - we) / (2 * me), Fe = Math.sqrt(Math.max(0, 2 * we * (oe + me) - (oe -= me) * oe - we * we)) / (2 * me);
              Q.x = b.x + Le * ue + Fe * de, Q.y = b.y + Le * de - Fe * ue;
            } else Q.x = b.x + oe, Q.y = b.y;
          }
          n.layout.tree = function() {
            var b = n.layout.hierarchy().sort(null).value(null), D = Ic, Q = [1, 1], oe = null;
            function ue(Be, et) {
              var rt = b.call(this, Be, et), pt = rt[0], bt = de(pt);
              if (la(bt, we), bt.parent.m = -bt.z, yi(bt, me), oe) yi(pt, Fe);
              else {
                var nt = pt, ut = pt, ft = pt;
                yi(pt, function(zt) {
                  zt.x < nt.x && (nt = zt), zt.x > ut.x && (ut = zt), zt.depth > ft.depth && (ft = zt);
                });
                var yt = D(nt, ut) / 2 - nt.x, mt = Q[0] / (ut.x + D(ut, nt) / 2 + yt), dt = Q[1] / (ft.depth || 1);
                yi(pt, function(zt) {
                  zt.x = (zt.x + yt) * mt, zt.y = zt.depth * dt;
                });
              }
              return rt;
            }
            function de(Be) {
              for (var et = { A: null, children: [Be] }, rt = [et], pt; (pt = rt.pop()) != null; ) for (var bt = pt.children, nt, ut = 0, ft = bt.length; ut < ft; ++ut) rt.push((bt[ut] = nt = { _: bt[ut], parent: pt, children: (nt = bt[ut].children) && nt.slice() || [], A: null, a: null, z: 0, m: 0, c: 0, s: 0, t: null, i: ut }).a = nt);
              return et.children[0];
            }
            function we(Be) {
              var et = Be.children, rt = Be.parent.children, pt = Be.i ? rt[Be.i - 1] : null;
              if (et.length) {
                vg(Be);
                var bt = (et[0].z + et[et.length - 1].z) / 2;
                pt ? (Be.z = pt.z + D(Be._, pt._), Be.m = Be.z - bt) : Be.z = bt;
              } else pt && (Be.z = pt.z + D(Be._, pt._));
              Be.parent.A = Le(Be, pt, Be.parent.A || rt[0]);
            }
            function me(Be) {
              Be._.x = Be.z + Be.parent.m, Be.m += Be.parent.m;
            }
            function Le(Be, et, rt) {
              if (et) {
                for (var pt = Be, bt = Be, nt = et, ut = pt.parent.children[0], ft = pt.m, yt = bt.m, mt = nt.m, dt = ut.m, zt; nt = Al(nt), pt = Ml(pt), nt && pt; ) ut = Ml(ut), bt = Al(bt), bt.a = Be, zt = nt.z + mt - pt.z - ft + D(nt._, pt._), zt > 0 && (hg(gg(nt, Be, rt), Be, zt), ft += zt, yt += zt), mt += nt.m, ft += pt.m, dt += ut.m, yt += bt.m;
                nt && !Al(bt) && (bt.t = nt, bt.m += mt - yt), pt && !Ml(ut) && (ut.t = pt, ut.m += ft - dt, rt = Be);
              }
              return rt;
            }
            function Fe(Be) {
              Be.x *= Q[0], Be.y = Be.depth * Q[1];
            }
            return ue.separation = function(Be) {
              return arguments.length ? (D = Be, ue) : D;
            }, ue.size = function(Be) {
              return arguments.length ? (oe = (Q = Be) == null ? Fe : null, ue) : oe ? null : Q;
            }, ue.nodeSize = function(Be) {
              return arguments.length ? (oe = (Q = Be) == null ? null : Fe, ue) : oe ? Q : null;
            }, gi(ue, b);
          };
          function Ic(b, D) {
            return b.parent == D.parent ? 1 : 2;
          }
          function Ml(b) {
            var D = b.children;
            return D.length ? D[0] : b.t;
          }
          function Al(b) {
            var D = b.children, Q;
            return (Q = D.length) ? D[Q - 1] : b.t;
          }
          function hg(b, D, Q) {
            var oe = Q / (D.i - b.i);
            D.c -= oe, D.s += Q, b.c += oe, D.z += Q, D.m += Q;
          }
          function vg(b) {
            for (var D = 0, Q = 0, oe = b.children, ue = oe.length, de; --ue >= 0; ) de = oe[ue], de.z += D, de.m += D, D += de.s + (Q += de.c);
          }
          function gg(b, D, Q) {
            return b.a.parent === D.parent ? b.a : Q;
          }
          n.layout.cluster = function() {
            var b = n.layout.hierarchy().sort(null).value(null), D = Ic, Q = [1, 1], oe = !1;
            function ue(de, we) {
              var me = b.call(this, de, we), Le = me[0], Fe, Be = 0;
              la(Le, function(nt) {
                var ut = nt.children;
                ut && ut.length ? (nt.x = mg(ut), nt.y = yg(ut)) : (nt.x = Fe ? Be += D(nt, Fe) : 0, nt.y = 0, Fe = nt);
              });
              var et = zc(Le), rt = Rc(Le), pt = et.x - D(et, rt) / 2, bt = rt.x + D(rt, et) / 2;
              return la(Le, oe ? function(nt) {
                nt.x = (nt.x - Le.x) * Q[0], nt.y = (Le.y - nt.y) * Q[1];
              } : function(nt) {
                nt.x = (nt.x - pt) / (bt - pt) * Q[0], nt.y = (1 - (Le.y ? nt.y / Le.y : 1)) * Q[1];
              }), me;
            }
            return ue.separation = function(de) {
              return arguments.length ? (D = de, ue) : D;
            }, ue.size = function(de) {
              return arguments.length ? (oe = (Q = de) == null, ue) : oe ? null : Q;
            }, ue.nodeSize = function(de) {
              return arguments.length ? (oe = (Q = de) != null, ue) : oe ? Q : null;
            }, gi(ue, b);
          };
          function yg(b) {
            return 1 + n.max(b, function(D) {
              return D.y;
            });
          }
          function mg(b) {
            return b.reduce(function(D, Q) {
              return D + Q.x;
            }, 0) / b.length;
          }
          function zc(b) {
            var D = b.children;
            return D && D.length ? zc(D[0]) : b;
          }
          function Rc(b) {
            var D = b.children, Q;
            return D && (Q = D.length) ? Rc(D[Q - 1]) : b;
          }
          n.layout.treemap = function() {
            var b = n.layout.hierarchy(), D = Math.round, Q = [1, 1], oe = null, ue = Sl, de = !1, we, me = "squarify", Le = 0.5 * (1 + Math.sqrt(5));
            function Fe(nt, ut) {
              for (var ft = -1, yt = nt.length, mt, dt; ++ft < yt; ) dt = (mt = nt[ft]).value * (ut < 0 ? 0 : ut), mt.area = isNaN(dt) || dt <= 0 ? 0 : dt;
            }
            function Be(nt) {
              var ut = nt.children;
              if (ut && ut.length) {
                var ft = ue(nt), yt = [], mt = ut.slice(), dt, zt = 1 / 0, Zt, Jt = me === "slice" ? ft.dx : me === "dice" ? ft.dy : me === "slice-dice" ? nt.depth & 1 ? ft.dy : ft.dx : Math.min(ft.dx, ft.dy), Xt;
                for (Fe(mt, ft.dx * ft.dy / nt.value), yt.area = 0; (Xt = mt.length) > 0; ) yt.push(dt = mt[Xt - 1]), yt.area += dt.area, me !== "squarify" || (Zt = rt(yt, Jt)) <= zt ? (mt.pop(), zt = Zt) : (yt.area -= yt.pop().area, pt(yt, Jt, ft, !1), Jt = Math.min(ft.dx, ft.dy), yt.length = yt.area = 0, zt = 1 / 0);
                yt.length && (pt(yt, Jt, ft, !0), yt.length = yt.area = 0), ut.forEach(Be);
              }
            }
            function et(nt) {
              var ut = nt.children;
              if (ut && ut.length) {
                var ft = ue(nt), yt = ut.slice(), mt, dt = [];
                for (Fe(yt, ft.dx * ft.dy / nt.value), dt.area = 0; mt = yt.pop(); ) dt.push(mt), dt.area += mt.area, mt.z != null && (pt(dt, mt.z ? ft.dx : ft.dy, ft, !yt.length), dt.length = dt.area = 0);
                ut.forEach(et);
              }
            }
            function rt(nt, ut) {
              for (var ft = nt.area, yt, mt = 0, dt = 1 / 0, zt = -1, Zt = nt.length; ++zt < Zt; ) (yt = nt[zt].area) && (yt < dt && (dt = yt), yt > mt && (mt = yt));
              return ft *= ft, ut *= ut, ft ? Math.max(ut * mt * Le / ft, ft / (ut * dt * Le)) : 1 / 0;
            }
            function pt(nt, ut, ft, yt) {
              var mt = -1, dt = nt.length, zt = ft.x, Zt = ft.y, Jt = ut ? D(nt.area / ut) : 0, Xt;
              if (ut == ft.dx) {
                for ((yt || Jt > ft.dy) && (Jt = ft.dy); ++mt < dt; ) Xt = nt[mt], Xt.x = zt, Xt.y = Zt, Xt.dy = Jt, zt += Xt.dx = Math.min(ft.x + ft.dx - zt, Jt ? D(Xt.area / Jt) : 0);
                Xt.z = !0, Xt.dx += ft.x + ft.dx - zt, ft.y += Jt, ft.dy -= Jt;
              } else {
                for ((yt || Jt > ft.dx) && (Jt = ft.dx); ++mt < dt; ) Xt = nt[mt], Xt.x = zt, Xt.y = Zt, Xt.dx = Jt, Zt += Xt.dy = Math.min(ft.y + ft.dy - Zt, Jt ? D(Xt.area / Jt) : 0);
                Xt.z = !1, Xt.dy += ft.y + ft.dy - Zt, ft.x += Jt, ft.dx -= Jt;
              }
            }
            function bt(nt) {
              var ut = we || b(nt), ft = ut[0];
              return ft.x = ft.y = 0, ft.value ? (ft.dx = Q[0], ft.dy = Q[1]) : ft.dx = ft.dy = 0, we && b.revalue(ft), Fe([ft], ft.dx * ft.dy / ft.value), (we ? et : Be)(ft), de && (we = ut), ut;
            }
            return bt.size = function(nt) {
              return arguments.length ? (Q = nt, bt) : Q;
            }, bt.padding = function(nt) {
              if (!arguments.length) return oe;
              function ut(mt) {
                var dt = nt.call(bt, mt, mt.depth);
                return dt == null ? Sl(mt) : Nc(mt, typeof dt == "number" ? [dt, dt, dt, dt] : dt);
              }
              function ft(mt) {
                return Nc(mt, nt);
              }
              var yt;
              return ue = (oe = nt) == null ? Sl : (yt = typeof nt) == "function" ? ut : (yt === "number" && (nt = [nt, nt, nt, nt]), ft), bt;
            }, bt.round = function(nt) {
              return arguments.length ? (D = nt ? Math.round : Number, bt) : D != Number;
            }, bt.sticky = function(nt) {
              return arguments.length ? (de = nt, we = null, bt) : de;
            }, bt.ratio = function(nt) {
              return arguments.length ? (Le = nt, bt) : Le;
            }, bt.mode = function(nt) {
              return arguments.length ? (me = nt + "", bt) : me;
            }, gi(bt, b);
          };
          function Sl(b) {
            return { x: b.x, y: b.y, dx: b.dx, dy: b.dy };
          }
          function Nc(b, D) {
            var Q = b.x + D[3], oe = b.y + D[0], ue = b.dx - D[1] - D[3], de = b.dy - D[0] - D[2];
            return ue < 0 && (Q += ue / 2, ue = 0), de < 0 && (oe += de / 2, de = 0), { x: Q, y: oe, dx: ue, dy: de };
          }
          n.random = { normal: function(b, D) {
            var Q = arguments.length;
            return Q < 2 && (D = 1), Q < 1 && (b = 0), function() {
              var oe, ue, de;
              do
                oe = Math.random() * 2 - 1, ue = Math.random() * 2 - 1, de = oe * oe + ue * ue;
              while (!de || de > 1);
              return b + D * oe * Math.sqrt(-2 * Math.log(de) / de);
            };
          }, logNormal: function() {
            var b = n.random.normal.apply(n, arguments);
            return function() {
              return Math.exp(b());
            };
          }, bates: function(b) {
            var D = n.random.irwinHall(b);
            return function() {
              return D() / b;
            };
          }, irwinHall: function(b) {
            return function() {
              for (var D = 0, Q = 0; Q < b; Q++) D += Math.random();
              return D;
            };
          } }, n.scale = {};
          function Yi(b) {
            var D = b[0], Q = b[b.length - 1];
            return D < Q ? [D, Q] : [Q, D];
          }
          function Gi(b) {
            return b.rangeExtent ? b.rangeExtent() : Yi(b.range());
          }
          function xg(b, D, Q, oe) {
            var ue = Q(b[0], b[1]), de = oe(D[0], D[1]);
            return function(we) {
              return de(ue(we));
            };
          }
          function Ll(b, D) {
            var Q = 0, oe = b.length - 1, ue = b[Q], de = b[oe], we;
            return de < ue && (we = Q, Q = oe, oe = we, we = ue, ue = de, de = we), b[Q] = D.floor(ue), b[oe] = D.ceil(de), b;
          }
          function Fc(b) {
            return b ? { floor: function(D) {
              return Math.floor(D / b) * b;
            }, ceil: function(D) {
              return Math.ceil(D / b) * b;
            } } : bg;
          }
          var bg = { floor: K, ceil: K };
          function _g(b, D, Q, oe) {
            var ue = [], de = [], we = 0, me = Math.min(b.length, D.length) - 1;
            for (b[me] < b[0] && (b = b.slice().reverse(), D = D.slice().reverse()); ++we <= me; ) ue.push(Q(b[we - 1], b[we])), de.push(oe(D[we - 1], D[we]));
            return function(Le) {
              var Fe = n.bisect(b, Le, 1, me) - 1;
              return de[Fe](ue[Fe](Le));
            };
          }
          n.scale.linear = function() {
            return Bc([0, 1], [0, 1], Oa, !1);
          };
          function Bc(b, D, Q, oe) {
            var ue, de;
            function we() {
              var Le = Math.min(b.length, D.length) > 2 ? _g : xg, Fe = oe ? Hv : jv;
              return ue = Le(b, D, Fe, Q), de = Le(D, b, Fe, Oa), me;
            }
            function me(Le) {
              return ue(Le);
            }
            return me.invert = function(Le) {
              return de(Le);
            }, me.domain = function(Le) {
              return arguments.length ? (b = Le.map(Number), we()) : b;
            }, me.range = function(Le) {
              return arguments.length ? (D = Le, we()) : D;
            }, me.rangeRound = function(Le) {
              return me.range(Le).interpolate(bc);
            }, me.clamp = function(Le) {
              return arguments.length ? (oe = Le, we()) : oe;
            }, me.interpolate = function(Le) {
              return arguments.length ? (Q = Le, we()) : Q;
            }, me.ticks = function(Le) {
              return Cl(b, Le);
            }, me.tickFormat = function(Le, Fe) {
              return d3_scale_linearTickFormat(b, Le, Fe);
            }, me.nice = function(Le) {
              return Hc(b, Le), we();
            }, me.copy = function() {
              return Bc(b, D, Q, oe);
            }, we();
          }
          function jc(b, D) {
            return n.rebind(b, D, "range", "rangeRound", "interpolate", "clamp");
          }
          function Hc(b, D) {
            return Ll(b, Fc(Ol(b, D)[2])), Ll(b, Fc(Ol(b, D)[2])), b;
          }
          function Ol(b, D) {
            D == null && (D = 10);
            var Q = Yi(b), oe = Q[1] - Q[0], ue = Math.pow(10, Math.floor(Math.log(oe / D) / Math.LN10)), de = D / oe * ue;
            return de <= 0.15 ? ue *= 10 : de <= 0.35 ? ue *= 5 : de <= 0.75 && (ue *= 2), Q[0] = Math.ceil(Q[0] / ue) * ue, Q[1] = Math.floor(Q[1] / ue) * ue + ue * 0.5, Q[2] = ue, Q;
          }
          function Cl(b, D) {
            return n.range.apply(n, Ol(b, D));
          }
          n.scale.log = function() {
            return qc(n.scale.linear().domain([0, 1]), 10, !0, [1, 10]);
          };
          function qc(b, D, Q, oe) {
            function ue(me) {
              return (Q ? Math.log(me < 0 ? 0 : me) : -Math.log(me > 0 ? 0 : -me)) / Math.log(D);
            }
            function de(me) {
              return Q ? Math.pow(D, me) : -Math.pow(D, -me);
            }
            function we(me) {
              return b(ue(me));
            }
            return we.invert = function(me) {
              return de(b.invert(me));
            }, we.domain = function(me) {
              return arguments.length ? (Q = me[0] >= 0, b.domain((oe = me.map(Number)).map(ue)), we) : oe;
            }, we.base = function(me) {
              return arguments.length ? (D = +me, b.domain(oe.map(ue)), we) : D;
            }, we.nice = function() {
              var me = Ll(oe.map(ue), Q ? Math : wg);
              return b.domain(me), oe = me.map(de), we;
            }, we.ticks = function() {
              var me = Yi(oe), Le = [], Fe = me[0], Be = me[1], et = Math.floor(ue(Fe)), rt = Math.ceil(ue(Be)), pt = D % 1 ? 2 : D;
              if (isFinite(rt - et)) {
                if (Q) {
                  for (; et < rt; et++) for (var bt = 1; bt < pt; bt++) Le.push(de(et) * bt);
                  Le.push(de(et));
                } else for (Le.push(de(et)); et++ < rt; ) for (var bt = pt - 1; bt > 0; bt--) Le.push(de(et) * bt);
                for (et = 0; Le[et] < Fe; et++) ;
                for (rt = Le.length; Le[rt - 1] > Be; rt--) ;
                Le = Le.slice(et, rt);
              }
              return Le;
            }, we.copy = function() {
              return qc(b.copy(), D, Q, oe);
            }, jc(we, b);
          }
          var wg = { floor: function(b) {
            return -Math.ceil(-b);
          }, ceil: function(b) {
            return -Math.floor(-b);
          } };
          n.scale.pow = function() {
            return Uc(n.scale.linear(), 1, [0, 1]);
          };
          function Uc(b, D, Q) {
            var oe = Zi(D), ue = Zi(1 / D);
            function de(we) {
              return b(oe(we));
            }
            return de.invert = function(we) {
              return ue(b.invert(we));
            }, de.domain = function(we) {
              return arguments.length ? (b.domain((Q = we.map(Number)).map(oe)), de) : Q;
            }, de.ticks = function(we) {
              return Cl(Q, we);
            }, de.tickFormat = function(we, me) {
              return d3_scale_linearTickFormat(Q, we, me);
            }, de.nice = function(we) {
              return de.domain(Hc(Q, we));
            }, de.exponent = function(we) {
              return arguments.length ? (oe = Zi(D = we), ue = Zi(1 / D), b.domain(Q.map(oe)), de) : D;
            }, de.copy = function() {
              return Uc(b.copy(), D, Q);
            }, jc(de, b);
          }
          function Zi(b) {
            return function(D) {
              return D < 0 ? -Math.pow(-D, b) : Math.pow(D, b);
            };
          }
          n.scale.sqrt = function() {
            return n.scale.pow().exponent(0.5);
          }, n.scale.ordinal = function() {
            return Vc([], { t: "range", a: [[]] });
          };
          function Vc(b, D) {
            var Q, oe, ue;
            function de(me) {
              return oe[((Q.get(me) || (D.t === "range" ? Q.set(me, b.push(me)) : NaN)) - 1) % oe.length];
            }
            function we(me, Le) {
              return n.range(b.length).map(function(Fe) {
                return me + Le * Fe;
              });
            }
            return de.domain = function(me) {
              if (!arguments.length) return b;
              b = [], Q = new _();
              for (var Le = -1, Fe = me.length, Be; ++Le < Fe; ) Q.has(Be = me[Le]) || Q.set(Be, b.push(Be));
              return de[D.t].apply(de, D.a);
            }, de.range = function(me) {
              return arguments.length ? (oe = me, ue = 0, D = { t: "range", a: arguments }, de) : oe;
            }, de.rangePoints = function(me, Le) {
              arguments.length < 2 && (Le = 0);
              var Fe = me[0], Be = me[1], et = b.length < 2 ? (Fe = (Fe + Be) / 2, 0) : (Be - Fe) / (b.length - 1 + Le);
              return oe = we(Fe + et * Le / 2, et), ue = 0, D = { t: "rangePoints", a: arguments }, de;
            }, de.rangeRoundPoints = function(me, Le) {
              arguments.length < 2 && (Le = 0);
              var Fe = me[0], Be = me[1], et = b.length < 2 ? (Fe = Be = Math.round((Fe + Be) / 2), 0) : (Be - Fe) / (b.length - 1 + Le) | 0;
              return oe = we(Fe + Math.round(et * Le / 2 + (Be - Fe - (b.length - 1 + Le) * et) / 2), et), ue = 0, D = { t: "rangeRoundPoints", a: arguments }, de;
            }, de.rangeBands = function(me, Le, Fe) {
              arguments.length < 2 && (Le = 0), arguments.length < 3 && (Fe = Le);
              var Be = me[1] < me[0], et = me[Be - 0], rt = me[1 - Be], pt = (rt - et) / (b.length - Le + 2 * Fe);
              return oe = we(et + pt * Fe, pt), Be && oe.reverse(), ue = pt * (1 - Le), D = { t: "rangeBands", a: arguments }, de;
            }, de.rangeRoundBands = function(me, Le, Fe) {
              arguments.length < 2 && (Le = 0), arguments.length < 3 && (Fe = Le);
              var Be = me[1] < me[0], et = me[Be - 0], rt = me[1 - Be], pt = Math.floor((rt - et) / (b.length - Le + 2 * Fe));
              return oe = we(et + Math.round((rt - et - (b.length - Le) * pt) / 2), pt), Be && oe.reverse(), ue = Math.round(pt * (1 - Le)), D = { t: "rangeRoundBands", a: arguments }, de;
            }, de.rangeBand = function() {
              return ue;
            }, de.rangeExtent = function() {
              return Yi(D.a[0]);
            }, de.copy = function() {
              return Vc(b, D);
            }, de.domain(b);
          }
          n.scale.category10 = function() {
            return n.scale.ordinal().range(Tg);
          }, n.scale.category20 = function() {
            return n.scale.ordinal().range(kg);
          }, n.scale.category20b = function() {
            return n.scale.ordinal().range(Mg);
          }, n.scale.category20c = function() {
            return n.scale.ordinal().range(Ag);
          };
          var Tg = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(he), kg = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(he), Mg = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(he), Ag = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(he);
          n.scale.quantile = function() {
            return Yc([], []);
          };
          function Yc(b, D) {
            var Q;
            function oe() {
              var de = 0, we = D.length;
              for (Q = []; ++de < we; ) Q[de - 1] = n.quantile(b, de / we);
              return ue;
            }
            function ue(de) {
              if (!isNaN(de = +de)) return D[n.bisect(Q, de)];
            }
            return ue.domain = function(de) {
              return arguments.length ? (b = de.map(v).filter(g).sort(f), oe()) : b;
            }, ue.range = function(de) {
              return arguments.length ? (D = de, oe()) : D;
            }, ue.quantiles = function() {
              return Q;
            }, ue.invertExtent = function(de) {
              return de = D.indexOf(de), de < 0 ? [NaN, NaN] : [de > 0 ? Q[de - 1] : b[0], de < Q.length ? Q[de] : b[b.length - 1]];
            }, ue.copy = function() {
              return Yc(b, D);
            }, oe();
          }
          n.scale.quantize = function() {
            return Gc(0, 1, [0, 1]);
          };
          function Gc(b, D, Q) {
            var oe, ue;
            function de(me) {
              return Q[Math.max(0, Math.min(ue, Math.floor(oe * (me - b))))];
            }
            function we() {
              return oe = Q.length / (D - b), ue = Q.length - 1, de;
            }
            return de.domain = function(me) {
              return arguments.length ? (b = +me[0], D = +me[me.length - 1], we()) : [b, D];
            }, de.range = function(me) {
              return arguments.length ? (Q = me, we()) : Q;
            }, de.invertExtent = function(me) {
              return me = Q.indexOf(me), me = me < 0 ? NaN : me / oe + b, [me, me + 1 / oe];
            }, de.copy = function() {
              return Gc(b, D, Q);
            }, we();
          }
          n.scale.threshold = function() {
            return Zc([0.5], [0, 1]);
          };
          function Zc(b, D) {
            function Q(oe) {
              if (oe <= oe) return D[n.bisect(b, oe)];
            }
            return Q.domain = function(oe) {
              return arguments.length ? (b = oe, Q) : b;
            }, Q.range = function(oe) {
              return arguments.length ? (D = oe, Q) : D;
            }, Q.invertExtent = function(oe) {
              return oe = D.indexOf(oe), [b[oe - 1], b[oe]];
            }, Q.copy = function() {
              return Zc(b, D);
            }, Q;
          }
          n.scale.identity = function() {
            return Wc([0, 1]);
          };
          function Wc(b) {
            function D(Q) {
              return +Q;
            }
            return D.invert = D, D.domain = D.range = function(Q) {
              return arguments.length ? (b = Q.map(D), D) : b;
            }, D.ticks = function(Q) {
              return Cl(b, Q);
            }, D.tickFormat = function(Q, oe) {
              return d3_scale_linearTickFormat(b, Q, oe);
            }, D.copy = function() {
              return Wc(b);
            }, D;
          }
          n.svg = {};
          function Sg() {
            return 0;
          }
          n.svg.arc = function() {
            var b = Lg, D = Og, Q = Sg, oe = Wi, ue = Xc, de = Jc, we = Cg;
            function me() {
              var Fe = Math.max(0, +b.apply(this, arguments)), Be = Math.max(0, +D.apply(this, arguments)), et = ue.apply(this, arguments) - Oe, rt = de.apply(this, arguments) - Oe, pt = Math.abs(rt - et), bt = et > rt ? 0 : 1;
              if (Be < Fe && (nt = Be, Be = Fe, Fe = nt), pt >= Me) return Le(Be, bt) + (Fe ? Le(Fe, 1 - bt) : "") + "Z";
              var nt, ut, ft, yt, mt = 0, dt = 0, zt, Zt, Jt, Xt, er, tr, gr, ir, pr = [];
              if ((yt = (+we.apply(this, arguments) || 0) / 2) && (ft = oe === Wi ? Math.sqrt(Fe * Fe + Be * Be) : +oe.apply(this, arguments), bt || (dt *= -1), Be && (dt = Xe(ft / Be * Math.sin(yt))), Fe && (mt = Xe(ft / Fe * Math.sin(yt)))), Be) {
                zt = Be * Math.cos(et + dt), Zt = Be * Math.sin(et + dt), Jt = Be * Math.cos(rt - dt), Xt = Be * Math.sin(rt - dt);
                var zr = Math.abs(rt - et - 2 * dt) <= ge ? 0 : 1;
                if (dt && Xi(zt, Zt, Jt, Xt) === bt ^ zr) {
                  var an = (et + rt) / 2;
                  zt = Be * Math.cos(an), Zt = Be * Math.sin(an), Jt = Xt = null;
                }
              } else zt = Zt = 0;
              if (Fe) {
                er = Fe * Math.cos(rt - mt), tr = Fe * Math.sin(rt - mt), gr = Fe * Math.cos(et + mt), ir = Fe * Math.sin(et + mt);
                var Fr = Math.abs(et - rt + 2 * mt) <= ge ? 0 : 1;
                if (mt && Xi(er, tr, gr, ir) === 1 - bt ^ Fr) {
                  var Gt = (et + rt) / 2;
                  er = Fe * Math.cos(Gt), tr = Fe * Math.sin(Gt), gr = ir = null;
                }
              } else er = tr = 0;
              if (pt > Ie && (nt = Math.min(Math.abs(Be - Fe) / 2, +Q.apply(this, arguments))) > 1e-3) {
                ut = Fe < Be ^ bt ? 0 : 1;
                var yr = nt, wr = nt;
                if (pt < ge) {
                  var Rr = gr == null ? [er, tr] : Jt == null ? [zt, Zt] : dr([zt, Zt], [gr, ir], [Jt, Xt], [er, tr]), Qr = zt - Rr[0], pn = Zt - Rr[1], bn = Jt - Rr[0], Ln = Xt - Rr[1], Dn = 1 / Math.sin(Math.acos((Qr * bn + pn * Ln) / (Math.sqrt(Qr * Qr + pn * pn) * Math.sqrt(bn * bn + Ln * Ln))) / 2), On = Math.sqrt(Rr[0] * Rr[0] + Rr[1] * Rr[1]);
                  wr = Math.min(nt, (Fe - On) / (Dn - 1)), yr = Math.min(nt, (Be - On) / (Dn + 1));
                }
                if (Jt != null) {
                  var zn = Ji(gr == null ? [er, tr] : [gr, ir], [zt, Zt], Be, yr, bt), Tn = Ji([Jt, Xt], [er, tr], Be, yr, bt);
                  nt === yr ? pr.push("M", zn[0], "A", yr, ",", yr, " 0 0,", ut, " ", zn[1], "A", Be, ",", Be, " 0 ", 1 - bt ^ Xi(zn[1][0], zn[1][1], Tn[1][0], Tn[1][1]), ",", bt, " ", Tn[1], "A", yr, ",", yr, " 0 0,", ut, " ", Tn[0]) : pr.push("M", zn[0], "A", yr, ",", yr, " 0 1,", ut, " ", Tn[0]);
                } else pr.push("M", zt, ",", Zt);
                if (gr != null) {
                  var Rn = Ji([zt, Zt], [gr, ir], Fe, -wr, bt), Ea = Ji([er, tr], Jt == null ? [zt, Zt] : [Jt, Xt], Fe, -wr, bt);
                  nt === wr ? pr.push("L", Ea[0], "A", wr, ",", wr, " 0 0,", ut, " ", Ea[1], "A", Fe, ",", Fe, " 0 ", bt ^ Xi(Ea[1][0], Ea[1][1], Rn[1][0], Rn[1][1]), ",", 1 - bt, " ", Rn[1], "A", wr, ",", wr, " 0 0,", ut, " ", Rn[0]) : pr.push("L", Ea[0], "A", wr, ",", wr, " 0 0,", ut, " ", Rn[0]);
                } else pr.push("L", er, ",", tr);
              } else pr.push("M", zt, ",", Zt), Jt != null && pr.push("A", Be, ",", Be, " 0 ", zr, ",", bt, " ", Jt, ",", Xt), pr.push("L", er, ",", tr), gr != null && pr.push("A", Fe, ",", Fe, " 0 ", Fr, ",", 1 - bt, " ", gr, ",", ir);
              return pr.push("Z"), pr.join("");
            }
            function Le(Fe, Be) {
              return "M0," + Fe + "A" + Fe + "," + Fe + " 0 1," + Be + " 0," + -Fe + "A" + Fe + "," + Fe + " 0 1," + Be + " 0," + Fe;
            }
            return me.innerRadius = function(Fe) {
              return arguments.length ? (b = tt(Fe), me) : b;
            }, me.outerRadius = function(Fe) {
              return arguments.length ? (D = tt(Fe), me) : D;
            }, me.cornerRadius = function(Fe) {
              return arguments.length ? (Q = tt(Fe), me) : Q;
            }, me.padRadius = function(Fe) {
              return arguments.length ? (oe = Fe == Wi ? Wi : tt(Fe), me) : oe;
            }, me.startAngle = function(Fe) {
              return arguments.length ? (ue = tt(Fe), me) : ue;
            }, me.endAngle = function(Fe) {
              return arguments.length ? (de = tt(Fe), me) : de;
            }, me.padAngle = function(Fe) {
              return arguments.length ? (we = tt(Fe), me) : we;
            }, me.centroid = function() {
              var Fe = (+b.apply(this, arguments) + +D.apply(this, arguments)) / 2, Be = (+ue.apply(this, arguments) + +de.apply(this, arguments)) / 2 - Oe;
              return [Math.cos(Be) * Fe, Math.sin(Be) * Fe];
            }, me;
          };
          var Wi = "auto";
          function Lg(b) {
            return b.innerRadius;
          }
          function Og(b) {
            return b.outerRadius;
          }
          function Xc(b) {
            return b.startAngle;
          }
          function Jc(b) {
            return b.endAngle;
          }
          function Cg(b) {
            return b && b.padAngle;
          }
          function Xi(b, D, Q, oe) {
            return (b - Q) * D - (D - oe) * b > 0 ? 0 : 1;
          }
          function Ji(b, D, Q, oe, ue) {
            var de = b[0] - D[0], we = b[1] - D[1], me = (ue ? oe : -oe) / Math.sqrt(de * de + we * we), Le = me * we, Fe = -me * de, Be = b[0] + Le, et = b[1] + Fe, rt = D[0] + Le, pt = D[1] + Fe, bt = (Be + rt) / 2, nt = (et + pt) / 2, ut = rt - Be, ft = pt - et, yt = ut * ut + ft * ft, mt = Q - oe, dt = Be * pt - rt * et, zt = (ft < 0 ? -1 : 1) * Math.sqrt(Math.max(0, mt * mt * yt - dt * dt)), Zt = (dt * ft - ut * zt) / yt, Jt = (-dt * ut - ft * zt) / yt, Xt = (dt * ft + ut * zt) / yt, er = (-dt * ut + ft * zt) / yt, tr = Zt - bt, gr = Jt - nt, ir = Xt - bt, pr = er - nt;
            return tr * tr + gr * gr > ir * ir + pr * pr && (Zt = Xt, Jt = er), [[Zt - Le, Jt - Fe], [Zt * Q / mt, Jt * Q / mt]];
          }
          function $c() {
            return !0;
          }
          function Kc(b) {
            var D = _r, Q = Cr, oe = $c, ue = Qn, de = ue.key, we = 0.7;
            function me(Le) {
              var Fe = [], Be = [], et = -1, rt = Le.length, pt, bt = tt(D), nt = tt(Q);
              function ut() {
                Fe.push("M", ue(b(Be), we));
              }
              for (; ++et < rt; ) oe.call(this, pt = Le[et], et) ? Be.push([+bt.call(this, pt, et), +nt.call(this, pt, et)]) : Be.length && (ut(), Be = []);
              return Be.length && ut(), Fe.length ? Fe.join("") : null;
            }
            return me.x = function(Le) {
              return arguments.length ? (D = Le, me) : D;
            }, me.y = function(Le) {
              return arguments.length ? (Q = Le, me) : Q;
            }, me.defined = function(Le) {
              return arguments.length ? (oe = Le, me) : oe;
            }, me.interpolate = function(Le) {
              return arguments.length ? (typeof Le == "function" ? de = ue = Le : de = (ue = El.get(Le) || Qn).key, me) : de;
            }, me.tension = function(Le) {
              return arguments.length ? (we = Le, me) : we;
            }, me;
          }
          n.svg.line = function() {
            return Kc(K);
          };
          var El = n.map({ linear: Qn, "linear-closed": Qc, step: Eg, "step-before": Dl, "step-after": Pl, basis: ef, "basis-open": zg, "basis-closed": Rg, bundle: Ng, cardinal: Ig, "cardinal-open": Dg, "cardinal-closed": Pg, monotone: jg });
          El.forEach(function(b, D) {
            D.key = b, D.closed = /-closed$/.test(b);
          });
          function Qn(b) {
            return b.length > 1 ? b.join("L") : b + "Z";
          }
          function Qc(b) {
            return b.join("L") + "Z";
          }
          function Eg(b) {
            for (var D = 0, Q = b.length, oe = b[0], ue = [oe[0], ",", oe[1]]; ++D < Q; ) ue.push("H", (oe[0] + (oe = b[D])[0]) / 2, "V", oe[1]);
            return Q > 1 && ue.push("H", oe[0]), ue.join("");
          }
          function Dl(b) {
            for (var D = 0, Q = b.length, oe = b[0], ue = [oe[0], ",", oe[1]]; ++D < Q; ) ue.push("V", (oe = b[D])[1], "H", oe[0]);
            return ue.join("");
          }
          function Pl(b) {
            for (var D = 0, Q = b.length, oe = b[0], ue = [oe[0], ",", oe[1]]; ++D < Q; ) ue.push("H", (oe = b[D])[0], "V", oe[1]);
            return ue.join("");
          }
          function Dg(b, D) {
            return b.length < 4 ? Qn(b) : b[1] + $i(b.slice(1, -1), Il(b, D));
          }
          function Pg(b, D) {
            return b.length < 3 ? Qc(b) : b[0] + $i((b.push(b[0]), b), Il([b[b.length - 2]].concat(b, [b[1]]), D));
          }
          function Ig(b, D) {
            return b.length < 3 ? Qn(b) : b[0] + $i(b, Il(b, D));
          }
          function $i(b, D) {
            if (D.length < 1 || b.length != D.length && b.length != D.length + 2) return Qn(b);
            var Q = b.length != D.length, oe = "", ue = b[0], de = b[1], we = D[0], me = we, Le = 1;
            if (Q && (oe += "Q" + (de[0] - we[0] * 2 / 3) + "," + (de[1] - we[1] * 2 / 3) + "," + de[0] + "," + de[1], ue = b[1], Le = 2), D.length > 1) {
              me = D[1], de = b[Le], Le++, oe += "C" + (ue[0] + we[0]) + "," + (ue[1] + we[1]) + "," + (de[0] - me[0]) + "," + (de[1] - me[1]) + "," + de[0] + "," + de[1];
              for (var Fe = 2; Fe < D.length; Fe++, Le++) de = b[Le], me = D[Fe], oe += "S" + (de[0] - me[0]) + "," + (de[1] - me[1]) + "," + de[0] + "," + de[1];
            }
            if (Q) {
              var Be = b[Le];
              oe += "Q" + (de[0] + me[0] * 2 / 3) + "," + (de[1] + me[1] * 2 / 3) + "," + Be[0] + "," + Be[1];
            }
            return oe;
          }
          function Il(b, D) {
            for (var Q = [], oe = (1 - D) / 2, ue, de = b[0], we = b[1], me = 1, Le = b.length; ++me < Le; ) ue = de, de = we, we = b[me], Q.push([oe * (we[0] - ue[0]), oe * (we[1] - ue[1])]);
            return Q;
          }
          function ef(b) {
            if (b.length < 3) return Qn(b);
            var D = 1, Q = b.length, oe = b[0], ue = oe[0], de = oe[1], we = [ue, ue, ue, (oe = b[1])[0]], me = [de, de, de, oe[1]], Le = [ue, ",", de, "L", Vn(_a, we), ",", Vn(_a, me)];
            for (b.push(b[Q - 1]); ++D <= Q; ) oe = b[D], we.shift(), we.push(oe[0]), me.shift(), me.push(oe[1]), zl(Le, we, me);
            return b.pop(), Le.push("L", oe), Le.join("");
          }
          function zg(b) {
            if (b.length < 4) return Qn(b);
            for (var D = [], Q = -1, oe = b.length, ue, de = [0], we = [0]; ++Q < 3; ) ue = b[Q], de.push(ue[0]), we.push(ue[1]);
            for (D.push(Vn(_a, de) + "," + Vn(_a, we)), --Q; ++Q < oe; ) ue = b[Q], de.shift(), de.push(ue[0]), we.shift(), we.push(ue[1]), zl(D, de, we);
            return D.join("");
          }
          function Rg(b) {
            for (var D, Q = -1, oe = b.length, ue = oe + 4, de, we = [], me = []; ++Q < 4; ) de = b[Q % oe], we.push(de[0]), me.push(de[1]);
            for (D = [Vn(_a, we), ",", Vn(_a, me)], --Q; ++Q < ue; ) de = b[Q % oe], we.shift(), we.push(de[0]), me.shift(), me.push(de[1]), zl(D, we, me);
            return D.join("");
          }
          function Ng(b, D) {
            var Q = b.length - 1;
            if (Q) for (var oe = b[0][0], ue = b[0][1], de = b[Q][0] - oe, we = b[Q][1] - ue, me = -1, Le, Fe; ++me <= Q; ) Le = b[me], Fe = me / Q, Le[0] = D * Le[0] + (1 - D) * (oe + Fe * de), Le[1] = D * Le[1] + (1 - D) * (ue + Fe * we);
            return ef(b);
          }
          function Vn(b, D) {
            return b[0] * D[0] + b[1] * D[1] + b[2] * D[2] + b[3] * D[3];
          }
          var tf = [0, 2 / 3, 1 / 3, 0], rf = [0, 1 / 3, 2 / 3, 0], _a = [0, 1 / 6, 2 / 3, 1 / 6];
          function zl(b, D, Q) {
            b.push("C", Vn(tf, D), ",", Vn(tf, Q), ",", Vn(rf, D), ",", Vn(rf, Q), ",", Vn(_a, D), ",", Vn(_a, Q));
          }
          function Rl(b, D) {
            return (D[1] - b[1]) / (D[0] - b[0]);
          }
          function Fg(b) {
            for (var D = 0, Q = b.length - 1, oe = [], ue = b[0], de = b[1], we = oe[0] = Rl(ue, de); ++D < Q; ) oe[D] = (we + (we = Rl(ue = de, de = b[D + 1]))) / 2;
            return oe[D] = we, oe;
          }
          function Bg(b) {
            for (var D = [], Q, oe, ue, de, we = Fg(b), me = -1, Le = b.length - 1; ++me < Le; ) Q = Rl(b[me], b[me + 1]), u(Q) < Ie ? we[me] = we[me + 1] = 0 : (oe = we[me] / Q, ue = we[me + 1] / Q, de = oe * oe + ue * ue, de > 9 && (de = Q * 3 / Math.sqrt(de), we[me] = de * oe, we[me + 1] = de * ue));
            for (me = -1; ++me <= Le; ) de = (b[Math.min(Le, me + 1)][0] - b[Math.max(0, me - 1)][0]) / (6 * (1 + we[me] * we[me])), D.push([de || 0, we[me] * de || 0]);
            return D;
          }
          function jg(b) {
            return b.length < 3 ? Qn(b) : b[0] + $i(b, Bg(b));
          }
          n.svg.line.radial = function() {
            var b = Kc(nf);
            return b.radius = b.x, delete b.x, b.angle = b.y, delete b.y, b;
          };
          function nf(b) {
            for (var D, Q = -1, oe = b.length, ue, de; ++Q < oe; ) D = b[Q], ue = D[0], de = D[1] - Oe, D[0] = ue * Math.cos(de), D[1] = ue * Math.sin(de);
            return b;
          }
          function af(b) {
            var D = _r, Q = _r, oe = 0, ue = Cr, de = $c, we = Qn, me = we.key, Le = we, Fe = "L", Be = 0.7;
            function et(rt) {
              var pt = [], bt = [], nt = [], ut = -1, ft = rt.length, yt, mt = tt(D), dt = tt(oe), zt = D === Q ? function() {
                return Jt;
              } : tt(Q), Zt = oe === ue ? function() {
                return Xt;
              } : tt(ue), Jt, Xt;
              function er() {
                pt.push("M", we(b(nt), Be), Fe, Le(b(bt.reverse()), Be), "Z");
              }
              for (; ++ut < ft; ) de.call(this, yt = rt[ut], ut) ? (bt.push([Jt = +mt.call(this, yt, ut), Xt = +dt.call(this, yt, ut)]), nt.push([+zt.call(this, yt, ut), +Zt.call(this, yt, ut)])) : bt.length && (er(), bt = [], nt = []);
              return bt.length && er(), pt.length ? pt.join("") : null;
            }
            return et.x = function(rt) {
              return arguments.length ? (D = Q = rt, et) : Q;
            }, et.x0 = function(rt) {
              return arguments.length ? (D = rt, et) : D;
            }, et.x1 = function(rt) {
              return arguments.length ? (Q = rt, et) : Q;
            }, et.y = function(rt) {
              return arguments.length ? (oe = ue = rt, et) : ue;
            }, et.y0 = function(rt) {
              return arguments.length ? (oe = rt, et) : oe;
            }, et.y1 = function(rt) {
              return arguments.length ? (ue = rt, et) : ue;
            }, et.defined = function(rt) {
              return arguments.length ? (de = rt, et) : de;
            }, et.interpolate = function(rt) {
              return arguments.length ? (typeof rt == "function" ? me = we = rt : me = (we = El.get(rt) || Qn).key, Le = we.reverse || we, Fe = we.closed ? "M" : "L", et) : me;
            }, et.tension = function(rt) {
              return arguments.length ? (Be = rt, et) : Be;
            }, et;
          }
          Dl.reverse = Pl, Pl.reverse = Dl, n.svg.area = function() {
            return af(K);
          }, n.svg.area.radial = function() {
            var b = af(nf);
            return b.radius = b.x, delete b.x, b.innerRadius = b.x0, delete b.x0, b.outerRadius = b.x1, delete b.x1, b.angle = b.y, delete b.y, b.startAngle = b.y0, delete b.y0, b.endAngle = b.y1, delete b.y1, b;
          };
          function of(b) {
            return b.source;
          }
          function lf(b) {
            return b.target;
          }
          n.svg.chord = function() {
            var b = of, D = lf, Q = Hg, oe = Xc, ue = Jc;
            function de(Be, et) {
              var rt = we(this, b, Be, et), pt = we(this, D, Be, et);
              return "M" + rt.p0 + Le(rt.r, rt.p1, rt.a1 - rt.a0) + (me(rt, pt) ? Fe(rt.r, rt.p1, rt.r, rt.p0) : Fe(rt.r, rt.p1, pt.r, pt.p0) + Le(pt.r, pt.p1, pt.a1 - pt.a0) + Fe(pt.r, pt.p1, rt.r, rt.p0)) + "Z";
            }
            function we(Be, et, rt, pt) {
              var bt = et.call(Be, rt, pt), nt = Q.call(Be, bt, pt), ut = oe.call(Be, bt, pt) - Oe, ft = ue.call(Be, bt, pt) - Oe;
              return { r: nt, a0: ut, a1: ft, p0: [nt * Math.cos(ut), nt * Math.sin(ut)], p1: [nt * Math.cos(ft), nt * Math.sin(ft)] };
            }
            function me(Be, et) {
              return Be.a0 == et.a0 && Be.a1 == et.a1;
            }
            function Le(Be, et, rt) {
              return "A" + Be + "," + Be + " 0 " + +(rt > ge) + ",1 " + et;
            }
            function Fe(Be, et, rt, pt) {
              return "Q 0,0 " + pt;
            }
            return de.radius = function(Be) {
              return arguments.length ? (Q = tt(Be), de) : Q;
            }, de.source = function(Be) {
              return arguments.length ? (b = tt(Be), de) : b;
            }, de.target = function(Be) {
              return arguments.length ? (D = tt(Be), de) : D;
            }, de.startAngle = function(Be) {
              return arguments.length ? (oe = tt(Be), de) : oe;
            }, de.endAngle = function(Be) {
              return arguments.length ? (ue = tt(Be), de) : ue;
            }, de;
          };
          function Hg(b) {
            return b.radius;
          }
          n.svg.diagonal = function() {
            var b = of, D = lf, Q = sf;
            function oe(ue, de) {
              var we = b.call(this, ue, de), me = D.call(this, ue, de), Le = (we.y + me.y) / 2, Fe = [we, { x: we.x, y: Le }, { x: me.x, y: Le }, me];
              return Fe = Fe.map(Q), "M" + Fe[0] + "C" + Fe[1] + " " + Fe[2] + " " + Fe[3];
            }
            return oe.source = function(ue) {
              return arguments.length ? (b = tt(ue), oe) : b;
            }, oe.target = function(ue) {
              return arguments.length ? (D = tt(ue), oe) : D;
            }, oe.projection = function(ue) {
              return arguments.length ? (Q = ue, oe) : Q;
            }, oe;
          };
          function sf(b) {
            return [b.x, b.y];
          }
          n.svg.diagonal.radial = function() {
            var b = n.svg.diagonal(), D = sf, Q = b.projection;
            return b.projection = function(oe) {
              return arguments.length ? Q(qg(D = oe)) : D;
            }, b;
          };
          function qg(b) {
            return function() {
              var D = b.apply(this, arguments), Q = D[0], oe = D[1] - Oe;
              return [Q * Math.cos(oe), Q * Math.sin(oe)];
            };
          }
          n.svg.symbol = function() {
            var b = Vg, D = Ug;
            function Q(oe, ue) {
              return (cf.get(b.call(this, oe, ue)) || uf)(D.call(this, oe, ue));
            }
            return Q.type = function(oe) {
              return arguments.length ? (b = tt(oe), Q) : b;
            }, Q.size = function(oe) {
              return arguments.length ? (D = tt(oe), Q) : D;
            }, Q;
          };
          function Ug() {
            return 64;
          }
          function Vg() {
            return "circle";
          }
          function uf(b) {
            var D = Math.sqrt(b / ge);
            return "M0," + D + "A" + D + "," + D + " 0 1,1 0," + -D + "A" + D + "," + D + " 0 1,1 0," + D + "Z";
          }
          var cf = n.map({ circle: uf, cross: function(b) {
            var D = Math.sqrt(b / 5) / 2;
            return "M" + -3 * D + "," + -D + "H" + -D + "V" + -3 * D + "H" + D + "V" + -D + "H" + 3 * D + "V" + D + "H" + D + "V" + 3 * D + "H" + -D + "V" + D + "H" + -3 * D + "Z";
          }, diamond: function(b) {
            var D = Math.sqrt(b / (2 * ff)), Q = D * ff;
            return "M0," + -D + "L" + Q + ",0 0," + D + " " + -Q + ",0Z";
          }, square: function(b) {
            var D = Math.sqrt(b) / 2;
            return "M" + -D + "," + -D + "L" + D + "," + -D + " " + D + "," + D + " " + -D + "," + D + "Z";
          }, "triangle-down": function(b) {
            var D = Math.sqrt(b / Ki), Q = D * Ki / 2;
            return "M0," + Q + "L" + D + "," + -Q + " " + -D + "," + -Q + "Z";
          }, "triangle-up": function(b) {
            var D = Math.sqrt(b / Ki), Q = D * Ki / 2;
            return "M0," + -Q + "L" + D + "," + Q + " " + -D + "," + Q + "Z";
          } });
          n.svg.symbolTypes = cf.keys();
          var Ki = Math.sqrt(3), ff = Math.tan(30 * je);
          E.transition = function(b) {
            for (var D = Ca || ++pf, Q = Fl(b), oe = [], ue, de, we = eo || { time: Date.now(), ease: Tv, delay: 0, duration: 250 }, me = -1, Le = this.length; ++me < Le; ) {
              oe.push(ue = []);
              for (var Fe = this[me], Be = -1, et = Fe.length; ++Be < et; ) (de = Fe[Be]) && to(de, Be, Q, D, we), ue.push(de);
            }
            return mi(oe, Q, D);
          }, E.interrupt = function(b) {
            return this.each(b == null ? Qi : df(Fl(b)));
          };
          var Qi = df(Fl());
          function df(b) {
            return function() {
              var D, Q, oe;
              (D = this[b]) && (oe = D[Q = D.active]) && (oe.timer.c = null, oe.timer.t = NaN, --D.count ? delete D[Q] : delete this[b], D.active += 0.5, oe.event && oe.event.interrupt.call(this, this.__data__, oe.index));
            };
          }
          function mi(b, D, Q) {
            return O(b, dn), b.namespace = D, b.id = Q, b;
          }
          var dn = [], pf = 0, Ca, eo;
          dn.call = E.call, dn.empty = E.empty, dn.node = E.node, dn.size = E.size, n.transition = function(b, D) {
            return b && b.transition ? Ca ? b.transition(D) : b : n.selection().transition(b);
          }, n.transition.prototype = dn, dn.select = function(b) {
            var D = this.id, Q = this.namespace, oe = [], ue, de, we;
            b = w(b);
            for (var me = -1, Le = this.length; ++me < Le; ) {
              oe.push(ue = []);
              for (var Fe = this[me], Be = -1, et = Fe.length; ++Be < et; ) (we = Fe[Be]) && (de = b.call(we, we.__data__, Be, me)) ? ("__data__" in we && (de.__data__ = we.__data__), to(de, Be, Q, D, we[Q][D]), ue.push(de)) : ue.push(null);
            }
            return mi(oe, Q, D);
          }, dn.selectAll = function(b) {
            var D = this.id, Q = this.namespace, oe = [], ue, de, we, me, Le;
            b = N(b);
            for (var Fe = -1, Be = this.length; ++Fe < Be; ) for (var et = this[Fe], rt = -1, pt = et.length; ++rt < pt; ) if (we = et[rt]) {
              Le = we[Q][D], de = b.call(we, we.__data__, rt, Fe), oe.push(ue = []);
              for (var bt = -1, nt = de.length; ++bt < nt; ) (me = de[bt]) && to(me, bt, Q, D, Le), ue.push(me);
            }
            return mi(oe, Q, D);
          }, dn.filter = function(b) {
            var D = [], Q, oe, ue;
            typeof b != "function" && (b = H(b));
            for (var de = 0, we = this.length; de < we; de++) {
              D.push(Q = []);
              for (var oe = this[de], me = 0, Le = oe.length; me < Le; me++) (ue = oe[me]) && b.call(ue, ue.__data__, me, de) && Q.push(ue);
            }
            return mi(D, this.namespace, this.id);
          }, dn.tween = function(b, D) {
            var Q = this.id, oe = this.namespace;
            return arguments.length < 2 ? this.node()[oe][Q].tween.get(b) : be(this, D == null ? function(ue) {
              ue[oe][Q].tween.remove(b);
            } : function(ue) {
              ue[oe][Q].tween.set(b, D);
            });
          };
          function Nl(b, D, Q, oe) {
            var ue = b.id, de = b.namespace;
            return be(b, typeof Q == "function" ? function(we, me, Le) {
              we[de][ue].tween.set(D, oe(Q.call(we, we.__data__, me, Le)));
            } : (Q = oe(Q), function(we) {
              we[de][ue].tween.set(D, Q);
            }));
          }
          dn.attr = function(b, D) {
            if (arguments.length < 2) {
              for (D in b) this.attr(D, b[D]);
              return this;
            }
            var Q = b == "transform" ? kc : Oa, oe = n.ns.qualify(b);
            function ue() {
              this.removeAttribute(oe);
            }
            function de() {
              this.removeAttributeNS(oe.space, oe.local);
            }
            function we(Le) {
              return Le == null ? ue : (Le += "", function() {
                var Fe = this.getAttribute(oe), Be;
                return Fe !== Le && (Be = Q(Fe, Le), function(et) {
                  this.setAttribute(oe, Be(et));
                });
              });
            }
            function me(Le) {
              return Le == null ? de : (Le += "", function() {
                var Fe = this.getAttributeNS(oe.space, oe.local), Be;
                return Fe !== Le && (Be = Q(Fe, Le), function(et) {
                  this.setAttributeNS(oe.space, oe.local, Be(et));
                });
              });
            }
            return Nl(this, "attr." + b, D, oe.local ? me : we);
          }, dn.attrTween = function(b, D) {
            var Q = n.ns.qualify(b);
            function oe(de, we) {
              var me = D.call(this, de, we, this.getAttribute(Q));
              return me && function(Le) {
                this.setAttribute(Q, me(Le));
              };
            }
            function ue(de, we) {
              var me = D.call(this, de, we, this.getAttributeNS(Q.space, Q.local));
              return me && function(Le) {
                this.setAttributeNS(Q.space, Q.local, me(Le));
              };
            }
            return this.tween("attr." + b, Q.local ? ue : oe);
          }, dn.style = function(b, D, Q) {
            var oe = arguments.length;
            if (oe < 3) {
              if (typeof b != "string") {
                oe < 2 && (D = "");
                for (Q in b) this.style(Q, b[Q], D);
                return this;
              }
              Q = "";
            }
            function ue() {
              this.style.removeProperty(b);
            }
            function de(we) {
              return we == null ? ue : (we += "", function() {
                var me = r(this).getComputedStyle(this, null).getPropertyValue(b), Le;
                return me !== we && (Le = Oa(me, we), function(Fe) {
                  this.style.setProperty(b, Le(Fe), Q);
                });
              });
            }
            return Nl(this, "style." + b, D, de);
          }, dn.styleTween = function(b, D, Q) {
            arguments.length < 3 && (Q = "");
            function oe(ue, de) {
              var we = D.call(this, ue, de, r(this).getComputedStyle(this, null).getPropertyValue(b));
              return we && function(me) {
                this.style.setProperty(b, we(me), Q);
              };
            }
            return this.tween("style." + b, oe);
          }, dn.text = function(b) {
            return Nl(this, "text", b, Yg);
          };
          function Yg(b) {
            return b == null && (b = ""), function() {
              this.textContent = b;
            };
          }
          dn.remove = function() {
            var b = this.namespace;
            return this.each("end.transition", function() {
              var D;
              this[b].count < 2 && (D = this.parentNode) && D.removeChild(this);
            });
          }, dn.ease = function(b) {
            var D = this.id, Q = this.namespace;
            return arguments.length < 1 ? this.node()[Q][D].ease : (typeof b != "function" && (b = n.ease.apply(n, arguments)), be(this, function(oe) {
              oe[Q][D].ease = b;
            }));
          }, dn.delay = function(b) {
            var D = this.id, Q = this.namespace;
            return arguments.length < 1 ? this.node()[Q][D].delay : be(this, typeof b == "function" ? function(oe, ue, de) {
              oe[Q][D].delay = +b.call(oe, oe.__data__, ue, de);
            } : (b = +b, function(oe) {
              oe[Q][D].delay = b;
            }));
          }, dn.duration = function(b) {
            var D = this.id, Q = this.namespace;
            return arguments.length < 1 ? this.node()[Q][D].duration : be(this, typeof b == "function" ? function(oe, ue, de) {
              oe[Q][D].duration = Math.max(1, b.call(oe, oe.__data__, ue, de));
            } : (b = Math.max(1, b), function(oe) {
              oe[Q][D].duration = b;
            }));
          }, dn.each = function(b, D) {
            var Q = this.id, oe = this.namespace;
            if (arguments.length < 2) {
              var ue = eo, de = Ca;
              try {
                Ca = Q, be(this, function(we, me, Le) {
                  eo = we[oe][Q], b.call(we, we.__data__, me, Le);
                });
              } finally {
                eo = ue, Ca = de;
              }
            } else be(this, function(we) {
              var me = we[oe][Q];
              (me.event || (me.event = n.dispatch("start", "end", "interrupt"))).on(b, D);
            });
            return this;
          }, dn.transition = function() {
            for (var b = this.id, D = ++pf, Q = this.namespace, oe = [], ue, de, we, me, Le = 0, Fe = this.length; Le < Fe; Le++) {
              oe.push(ue = []);
              for (var de = this[Le], Be = 0, et = de.length; Be < et; Be++) (we = de[Be]) && (me = we[Q][b], to(we, Be, Q, D, { time: me.time, ease: me.ease, delay: me.delay + me.duration, duration: me.duration })), ue.push(we);
            }
            return mi(oe, Q, D);
          };
          function Fl(b) {
            return b == null ? "__transition__" : "__transition_" + b + "__";
          }
          function to(b, D, Q, oe, ue) {
            var de = b[Q] || (b[Q] = { active: 0, count: 0 }), we = de[oe], me, Le, Fe, Be, et;
            function rt(nt) {
              var ut = we.delay;
              if (Le.t = ut + me, ut <= nt) return pt(nt - ut);
              Le.c = pt;
            }
            function pt(nt) {
              var ut = de.active, ft = de[ut];
              ft && (ft.timer.c = null, ft.timer.t = NaN, --de.count, delete de[ut], ft.event && ft.event.interrupt.call(b, b.__data__, ft.index));
              for (var yt in de) if (+yt < oe) {
                var mt = de[yt];
                mt.timer.c = null, mt.timer.t = NaN, --de.count, delete de[yt];
              }
              Le.c = bt, Ht(function() {
                return Le.c && bt(nt || 1) && (Le.c = null, Le.t = NaN), 1;
              }, 0, me), de.active = oe, we.event && we.event.start.call(b, b.__data__, D), et = [], we.tween.forEach(function(dt, zt) {
                (zt = zt.call(b, b.__data__, D)) && et.push(zt);
              }), Be = we.ease, Fe = we.duration;
            }
            function bt(nt) {
              for (var ut = nt / Fe, ft = Be(ut), yt = et.length; yt > 0; ) et[--yt].call(b, ft);
              if (ut >= 1) return we.event && we.event.end.call(b, b.__data__, D), --de.count ? delete de[oe] : delete b[Q], 1;
            }
            we || (me = ue.time, Le = Ht(rt, 0, me), we = de[oe] = { tween: new _(), time: me, timer: Le, delay: ue.delay, duration: ue.duration, ease: ue.ease, index: D }, ue = null, ++de.count);
          }
          n.svg.axis = function() {
            var b = n.scale.linear(), D = hf, Q = 6, oe = 6, ue = 3, de = [10], we = null, me;
            function Le(Fe) {
              Fe.each(function() {
                var Be = n.select(this), et = this.__chart__ || b, rt = this.__chart__ = b.copy(), pt = we ?? (rt.ticks ? rt.ticks.apply(rt, de) : rt.domain()), bt = me ?? (rt.tickFormat ? rt.tickFormat.apply(rt, de) : K), nt = Be.selectAll(".tick").data(pt, rt), ut = nt.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Ie), ft = n.transition(nt.exit()).style("opacity", Ie).remove(), yt = n.transition(nt.order()).style("opacity", 1), mt = Math.max(Q, 0) + ue, dt, zt = Gi(rt), Zt = Be.selectAll(".domain").data([0]), Jt = (Zt.enter().append("path").attr("class", "domain"), n.transition(Zt));
                ut.append("line"), ut.append("text");
                var Xt = ut.select("line"), er = yt.select("line"), tr = nt.select("text").text(bt), gr = ut.select("text"), ir = yt.select("text"), pr = D === "top" || D === "left" ? -1 : 1, zr, an, Fr, Gt;
                if (D === "bottom" || D === "top" ? (dt = Zg, zr = "x", Fr = "y", an = "x2", Gt = "y2", tr.attr("dy", pr < 0 ? "0em" : ".71em").style("text-anchor", "middle"), Jt.attr("d", "M" + zt[0] + "," + pr * oe + "V0H" + zt[1] + "V" + pr * oe)) : (dt = Wg, zr = "y", Fr = "x", an = "y2", Gt = "x2", tr.attr("dy", ".32em").style("text-anchor", pr < 0 ? "end" : "start"), Jt.attr("d", "M" + pr * oe + "," + zt[0] + "H0V" + zt[1] + "H" + pr * oe)), Xt.attr(Gt, pr * Q), gr.attr(Fr, pr * mt), er.attr(an, 0).attr(Gt, pr * Q), ir.attr(zr, 0).attr(Fr, pr * mt), rt.rangeBand) {
                  var yr = rt, wr = yr.rangeBand() / 2;
                  et = rt = function(Rr) {
                    return yr(Rr) + wr;
                  };
                } else et.rangeBand ? et = rt : ft.call(dt, rt, et);
                ut.call(dt, et, rt), yt.call(dt, rt, rt);
              });
            }
            return Le.scale = function(Fe) {
              return arguments.length ? (b = Fe, Le) : b;
            }, Le.orient = function(Fe) {
              return arguments.length ? (D = Fe in Gg ? Fe + "" : hf, Le) : D;
            }, Le.ticks = function() {
              return arguments.length ? (de = a(arguments), Le) : de;
            }, Le.tickValues = function(Fe) {
              return arguments.length ? (we = Fe, Le) : we;
            }, Le.tickFormat = function(Fe) {
              return arguments.length ? (me = Fe, Le) : me;
            }, Le.tickSize = function(Fe) {
              var Be = arguments.length;
              return Be ? (Q = +Fe, oe = +arguments[Be - 1], Le) : Q;
            }, Le.innerTickSize = function(Fe) {
              return arguments.length ? (Q = +Fe, Le) : Q;
            }, Le.outerTickSize = function(Fe) {
              return arguments.length ? (oe = +Fe, Le) : oe;
            }, Le.tickPadding = function(Fe) {
              return arguments.length ? (ue = +Fe, Le) : ue;
            }, Le.tickSubdivide = function() {
              return arguments.length && Le;
            }, Le;
          };
          var hf = "bottom", Gg = { top: 1, right: 1, bottom: 1, left: 1 };
          function Zg(b, D, Q) {
            b.attr("transform", function(oe) {
              var ue = D(oe);
              return "translate(" + (isFinite(ue) ? ue : Q(oe)) + ",0)";
            });
          }
          function Wg(b, D, Q) {
            b.attr("transform", function(oe) {
              var ue = D(oe);
              return "translate(0," + (isFinite(ue) ? ue : Q(oe)) + ")";
            });
          }
          n.svg.brush = function() {
            var b = ae(Be, "brushstart", "brush", "brushend"), D = null, Q = null, oe = [0, 0], ue = [0, 0], de, we, me = !0, Le = !0, Fe = Bl[0];
            function Be(nt) {
              nt.each(function() {
                var ut = n.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", bt).on("touchstart.brush", bt), ft = ut.selectAll(".background").data([0]);
                ft.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), ut.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                var yt = ut.selectAll(".resize").data(Fe, K);
                yt.exit().remove(), yt.enter().append("g").attr("class", function(Zt) {
                  return "resize " + Zt;
                }).style("cursor", function(Zt) {
                  return Xg[Zt];
                }).append("rect").attr("x", function(Zt) {
                  return /[ew]$/.test(Zt) ? -3 : null;
                }).attr("y", function(Zt) {
                  return /^[ns]/.test(Zt) ? -3 : null;
                }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), yt.style("display", Be.empty() ? "none" : null);
                var mt = n.transition(ut), dt = n.transition(ft), zt;
                D && (zt = Gi(D), dt.attr("x", zt[0]).attr("width", zt[1] - zt[0]), rt(mt)), Q && (zt = Gi(Q), dt.attr("y", zt[0]).attr("height", zt[1] - zt[0]), pt(mt)), et(mt);
              });
            }
            Be.event = function(nt) {
              nt.each(function() {
                var ut = b.of(this, arguments), ft = { x: oe, y: ue, i: de, j: we }, yt = this.__chart__ || ft;
                this.__chart__ = ft, Ca ? n.select(this).transition().each("start.brush", function() {
                  de = yt.i, we = yt.j, oe = yt.x, ue = yt.y, ut({ type: "brushstart" });
                }).tween("brush:brush", function() {
                  var mt = Vi(oe, ft.x), dt = Vi(ue, ft.y);
                  return de = we = null, function(zt) {
                    oe = ft.x = mt(zt), ue = ft.y = dt(zt), ut({ type: "brush", mode: "resize" });
                  };
                }).each("end.brush", function() {
                  de = ft.i, we = ft.j, ut({ type: "brush", mode: "resize" }), ut({ type: "brushend" });
                }) : (ut({ type: "brushstart" }), ut({ type: "brush", mode: "resize" }), ut({ type: "brushend" }));
              });
            };
            function et(nt) {
              nt.selectAll(".resize").attr("transform", function(ut) {
                return "translate(" + oe[+/e$/.test(ut)] + "," + ue[+/^s/.test(ut)] + ")";
              });
            }
            function rt(nt) {
              nt.select(".extent").attr("x", oe[0]), nt.selectAll(".extent,.n>rect,.s>rect").attr("width", oe[1] - oe[0]);
            }
            function pt(nt) {
              nt.select(".extent").attr("y", ue[0]), nt.selectAll(".extent,.e>rect,.w>rect").attr("height", ue[1] - ue[0]);
            }
            function bt() {
              var nt = this, ut = n.select(n.event.target), ft = b.of(nt, arguments), yt = n.select(nt), mt = ut.datum(), dt = !/^(n|s)$/.test(mt) && D, zt = !/^(e|w)$/.test(mt) && Q, Zt = ut.classed("extent"), Jt = gt(nt), Xt, er = n.mouse(nt), tr, gr = n.select(r(nt)).on("keydown.brush", zr).on("keyup.brush", an);
              if (n.event.changedTouches ? gr.on("touchmove.brush", Fr).on("touchend.brush", yr) : gr.on("mousemove.brush", Fr).on("mouseup.brush", yr), yt.interrupt().selectAll("*").interrupt(), Zt) er[0] = oe[0] - er[0], er[1] = ue[0] - er[1];
              else if (mt) {
                var ir = +/w$/.test(mt), pr = +/^n/.test(mt);
                tr = [oe[1 - ir] - er[0], ue[1 - pr] - er[1]], er[0] = oe[ir], er[1] = ue[pr];
              } else n.event.altKey && (Xt = er.slice());
              yt.style("pointer-events", "none").selectAll(".resize").style("display", null), n.select("body").style("cursor", ut.style("cursor")), ft({ type: "brushstart" }), Fr();
              function zr() {
                n.event.keyCode == 32 && (Zt || (Xt = null, er[0] -= oe[1], er[1] -= ue[1], Zt = 2), J());
              }
              function an() {
                n.event.keyCode == 32 && Zt == 2 && (er[0] += oe[1], er[1] += ue[1], Zt = 0, J());
              }
              function Fr() {
                var wr = n.mouse(nt), Rr = !1;
                tr && (wr[0] += tr[0], wr[1] += tr[1]), Zt || (n.event.altKey ? (Xt || (Xt = [(oe[0] + oe[1]) / 2, (ue[0] + ue[1]) / 2]), er[0] = oe[+(wr[0] < Xt[0])], er[1] = ue[+(wr[1] < Xt[1])]) : Xt = null), dt && Gt(wr, D, 0) && (rt(yt), Rr = !0), zt && Gt(wr, Q, 1) && (pt(yt), Rr = !0), Rr && (et(yt), ft({ type: "brush", mode: Zt ? "move" : "resize" }));
              }
              function Gt(wr, Rr, Qr) {
                var pn = Gi(Rr), bn = pn[0], Ln = pn[1], Dn = er[Qr], On = Qr ? ue : oe, zn = On[1] - On[0], Tn, Rn;
                if (Zt && (bn -= Dn, Ln -= zn + Dn), Tn = (Qr ? Le : me) ? Math.max(bn, Math.min(Ln, wr[Qr])) : wr[Qr], Zt ? Rn = (Tn += Dn) + zn : (Xt && (Dn = Math.max(bn, Math.min(Ln, 2 * Xt[Qr] - Tn))), Dn < Tn ? (Rn = Tn, Tn = Dn) : Rn = Dn), On[0] != Tn || On[1] != Rn) return Qr ? we = null : de = null, On[0] = Tn, On[1] = Rn, !0;
              }
              function yr() {
                Fr(), yt.style("pointer-events", "all").selectAll(".resize").style("display", Be.empty() ? "none" : null), n.select("body").style("cursor", null), gr.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), Jt(), ft({ type: "brushend" });
              }
            }
            return Be.x = function(nt) {
              return arguments.length ? (D = nt, Fe = Bl[!D << 1 | !Q], Be) : D;
            }, Be.y = function(nt) {
              return arguments.length ? (Q = nt, Fe = Bl[!D << 1 | !Q], Be) : Q;
            }, Be.clamp = function(nt) {
              return arguments.length ? (D && Q ? (me = !!nt[0], Le = !!nt[1]) : D ? me = !!nt : Q && (Le = !!nt), Be) : D && Q ? [me, Le] : D ? me : Q ? Le : null;
            }, Be.extent = function(nt) {
              var ut, ft, yt, mt, dt;
              return arguments.length ? (D && (ut = nt[0], ft = nt[1], Q && (ut = ut[0], ft = ft[0]), de = [ut, ft], D.invert && (ut = D(ut), ft = D(ft)), ft < ut && (dt = ut, ut = ft, ft = dt), (ut != oe[0] || ft != oe[1]) && (oe = [ut, ft])), Q && (yt = nt[0], mt = nt[1], D && (yt = yt[1], mt = mt[1]), we = [yt, mt], Q.invert && (yt = Q(yt), mt = Q(mt)), mt < yt && (dt = yt, yt = mt, mt = dt), (yt != ue[0] || mt != ue[1]) && (ue = [yt, mt])), Be) : (D && (de ? (ut = de[0], ft = de[1]) : (ut = oe[0], ft = oe[1], D.invert && (ut = D.invert(ut), ft = D.invert(ft)), ft < ut && (dt = ut, ut = ft, ft = dt))), Q && (we ? (yt = we[0], mt = we[1]) : (yt = ue[0], mt = ue[1], Q.invert && (yt = Q.invert(yt), mt = Q.invert(mt)), mt < yt && (dt = yt, yt = mt, mt = dt))), D && Q ? [[ut, yt], [ft, mt]] : D ? [ut, ft] : Q && [yt, mt]);
            }, Be.clear = function() {
              return Be.empty() || (oe = [0, 0], ue = [0, 0], de = we = null), Be;
            }, Be.empty = function() {
              return !!D && oe[0] == oe[1] || !!Q && ue[0] == ue[1];
            }, n.rebind(Be, b, "on");
          };
          var Xg = { n: "ns-resize", e: "ew-resize", s: "ns-resize", w: "ew-resize", nw: "nwse-resize", ne: "nesw-resize", se: "nwse-resize", sw: "nesw-resize" }, Bl = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
          n.text = at(function(b) {
            return b.responseText;
          }), n.json = function(b, D) {
            return vt(b, "application/json", Jg, D);
          };
          function Jg(b) {
            return JSON.parse(b.responseText);
          }
          n.html = function(b, D) {
            return vt(b, "text/html", $g, D);
          };
          function $g(b) {
            var D = i.createRange();
            return D.selectNode(i.body), D.createContextualFragment(b.responseText);
          }
          n.xml = at(function(b) {
            return b.responseXML;
          }), typeof k == "object" && k.exports ? k.exports = n : this.d3 = n;
        }).apply(self);
      }), ql = xe((L, k) => {
        (function(n, e) {
          typeof L == "object" && typeof k < "u" ? e(L) : (n = n || self, e(n.d3 = n.d3 || {}));
        })(L, function(n) {
          var e = /* @__PURE__ */ new Date(), a = /* @__PURE__ */ new Date();
          function i(H, ve, be, Se) {
            function De(He) {
              return H(He = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+He)), He;
            }
            return De.floor = function(He) {
              return H(He = /* @__PURE__ */ new Date(+He)), He;
            }, De.ceil = function(He) {
              return H(He = new Date(He - 1)), ve(He, 1), H(He), He;
            }, De.round = function(He) {
              var Ze = De(He), We = De.ceil(He);
              return He - Ze < We - He ? Ze : We;
            }, De.offset = function(He, Ze) {
              return ve(He = /* @__PURE__ */ new Date(+He), Ze == null ? 1 : Math.floor(Ze)), He;
            }, De.range = function(He, Ze, We) {
              var $e = [], it;
              if (He = De.ceil(He), We = We == null ? 1 : Math.floor(We), !(He < Ze) || !(We > 0)) return $e;
              do
                $e.push(it = /* @__PURE__ */ new Date(+He)), ve(He, We), H(He);
              while (it < He && He < Ze);
              return $e;
            }, De.filter = function(He) {
              return i(function(Ze) {
                if (Ze >= Ze) for (; H(Ze), !He(Ze); ) Ze.setTime(Ze - 1);
              }, function(Ze, We) {
                if (Ze >= Ze) if (We < 0) for (; ++We <= 0; ) for (; ve(Ze, -1), !He(Ze); ) ;
                else for (; --We >= 0; ) for (; ve(Ze, 1), !He(Ze); ) ;
              });
            }, be && (De.count = function(He, Ze) {
              return e.setTime(+He), a.setTime(+Ze), H(e), H(a), Math.floor(be(e, a));
            }, De.every = function(He) {
              return He = Math.floor(He), !isFinite(He) || !(He > 0) ? null : He > 1 ? De.filter(Se ? function(Ze) {
                return Se(Ze) % He === 0;
              } : function(Ze) {
                return De.count(0, Ze) % He === 0;
              }) : De;
            }), De;
          }
          var o = i(function() {
          }, function(H, ve) {
            H.setTime(+H + ve);
          }, function(H, ve) {
            return ve - H;
          });
          o.every = function(H) {
            return H = Math.floor(H), !isFinite(H) || !(H > 0) ? null : H > 1 ? i(function(ve) {
              ve.setTime(Math.floor(ve / H) * H);
            }, function(ve, be) {
              ve.setTime(+ve + be * H);
            }, function(ve, be) {
              return (be - ve) / H;
            }) : o;
          };
          var r = o.range, s = 1e3, c = 6e4, t = 36e5, p = 864e5, l = 6048e5, f = i(function(H) {
            H.setTime(H - H.getMilliseconds());
          }, function(H, ve) {
            H.setTime(+H + ve * s);
          }, function(H, ve) {
            return (ve - H) / s;
          }, function(H) {
            return H.getUTCSeconds();
          }), v = f.range, g = i(function(H) {
            H.setTime(H - H.getMilliseconds() - H.getSeconds() * s);
          }, function(H, ve) {
            H.setTime(+H + ve * c);
          }, function(H, ve) {
            return (ve - H) / c;
          }, function(H) {
            return H.getMinutes();
          }), x = g.range, h = i(function(H) {
            H.setTime(H - H.getMilliseconds() - H.getSeconds() * s - H.getMinutes() * c);
          }, function(H, ve) {
            H.setTime(+H + ve * t);
          }, function(H, ve) {
            return (ve - H) / t;
          }, function(H) {
            return H.getHours();
          }), m = h.range, u = i(function(H) {
            H.setHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setDate(H.getDate() + ve);
          }, function(H, ve) {
            return (ve - H - (ve.getTimezoneOffset() - H.getTimezoneOffset()) * c) / p;
          }, function(H) {
            return H.getDate() - 1;
          }), d = u.range;
          function y(H) {
            return i(function(ve) {
              ve.setDate(ve.getDate() - (ve.getDay() + 7 - H) % 7), ve.setHours(0, 0, 0, 0);
            }, function(ve, be) {
              ve.setDate(ve.getDate() + be * 7);
            }, function(ve, be) {
              return (be - ve - (be.getTimezoneOffset() - ve.getTimezoneOffset()) * c) / l;
            });
          }
          var _ = y(0), T = y(1), R = y(2), I = y(3), P = y(4), M = y(5), B = y(6), z = _.range, q = T.range, U = R.range, G = I.range, K = P.range, te = M.range, V = B.range, Z = i(function(H) {
            H.setDate(1), H.setHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setMonth(H.getMonth() + ve);
          }, function(H, ve) {
            return ve.getMonth() - H.getMonth() + (ve.getFullYear() - H.getFullYear()) * 12;
          }, function(H) {
            return H.getMonth();
          }), Y = Z.range, C = i(function(H) {
            H.setMonth(0, 1), H.setHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setFullYear(H.getFullYear() + ve);
          }, function(H, ve) {
            return ve.getFullYear() - H.getFullYear();
          }, function(H) {
            return H.getFullYear();
          });
          C.every = function(H) {
            return !isFinite(H = Math.floor(H)) || !(H > 0) ? null : i(function(ve) {
              ve.setFullYear(Math.floor(ve.getFullYear() / H) * H), ve.setMonth(0, 1), ve.setHours(0, 0, 0, 0);
            }, function(ve, be) {
              ve.setFullYear(ve.getFullYear() + be * H);
            });
          };
          var j = C.range, J = i(function(H) {
            H.setUTCSeconds(0, 0);
          }, function(H, ve) {
            H.setTime(+H + ve * c);
          }, function(H, ve) {
            return (ve - H) / c;
          }, function(H) {
            return H.getUTCMinutes();
          }), ne = J.range, ae = i(function(H) {
            H.setUTCMinutes(0, 0, 0);
          }, function(H, ve) {
            H.setTime(+H + ve * t);
          }, function(H, ve) {
            return (ve - H) / t;
          }, function(H) {
            return H.getUTCHours();
          }), se = ae.range, O = i(function(H) {
            H.setUTCHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setUTCDate(H.getUTCDate() + ve);
          }, function(H, ve) {
            return (ve - H) / p;
          }, function(H) {
            return H.getUTCDate() - 1;
          }), F = O.range;
          function S(H) {
            return i(function(ve) {
              ve.setUTCDate(ve.getUTCDate() - (ve.getUTCDay() + 7 - H) % 7), ve.setUTCHours(0, 0, 0, 0);
            }, function(ve, be) {
              ve.setUTCDate(ve.getUTCDate() + be * 7);
            }, function(ve, be) {
              return (be - ve) / l;
            });
          }
          var $ = S(0), re = S(1), E = S(2), w = S(3), N = S(4), W = S(5), ee = S(6), le = $.range, ie = re.range, pe = E.range, _e = w.range, Ae = N.range, Ce = W.range, Ue = ee.range, Ne = i(function(H) {
            H.setUTCDate(1), H.setUTCHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setUTCMonth(H.getUTCMonth() + ve);
          }, function(H, ve) {
            return ve.getUTCMonth() - H.getUTCMonth() + (ve.getUTCFullYear() - H.getUTCFullYear()) * 12;
          }, function(H) {
            return H.getUTCMonth();
          }), ke = Ne.range, A = i(function(H) {
            H.setUTCMonth(0, 1), H.setUTCHours(0, 0, 0, 0);
          }, function(H, ve) {
            H.setUTCFullYear(H.getUTCFullYear() + ve);
          }, function(H, ve) {
            return ve.getUTCFullYear() - H.getUTCFullYear();
          }, function(H) {
            return H.getUTCFullYear();
          });
          A.every = function(H) {
            return !isFinite(H = Math.floor(H)) || !(H > 0) ? null : i(function(ve) {
              ve.setUTCFullYear(Math.floor(ve.getUTCFullYear() / H) * H), ve.setUTCMonth(0, 1), ve.setUTCHours(0, 0, 0, 0);
            }, function(ve, be) {
              ve.setUTCFullYear(ve.getUTCFullYear() + be * H);
            });
          };
          var X = A.range;
          n.timeDay = u, n.timeDays = d, n.timeFriday = M, n.timeFridays = te, n.timeHour = h, n.timeHours = m, n.timeInterval = i, n.timeMillisecond = o, n.timeMilliseconds = r, n.timeMinute = g, n.timeMinutes = x, n.timeMonday = T, n.timeMondays = q, n.timeMonth = Z, n.timeMonths = Y, n.timeSaturday = B, n.timeSaturdays = V, n.timeSecond = f, n.timeSeconds = v, n.timeSunday = _, n.timeSundays = z, n.timeThursday = P, n.timeThursdays = K, n.timeTuesday = R, n.timeTuesdays = U, n.timeWednesday = I, n.timeWednesdays = G, n.timeWeek = _, n.timeWeeks = z, n.timeYear = C, n.timeYears = j, n.utcDay = O, n.utcDays = F, n.utcFriday = W, n.utcFridays = Ce, n.utcHour = ae, n.utcHours = se, n.utcMillisecond = o, n.utcMilliseconds = r, n.utcMinute = J, n.utcMinutes = ne, n.utcMonday = re, n.utcMondays = ie, n.utcMonth = Ne, n.utcMonths = ke, n.utcSaturday = ee, n.utcSaturdays = Ue, n.utcSecond = f, n.utcSeconds = v, n.utcSunday = $, n.utcSundays = le, n.utcThursday = N, n.utcThursdays = Ae, n.utcTuesday = E, n.utcTuesdays = pe, n.utcWednesday = w, n.utcWednesdays = _e, n.utcWeek = $, n.utcWeeks = le, n.utcYear = A, n.utcYears = X, Object.defineProperty(n, "__esModule", { value: !0 });
        });
      }), Wa = xe((L, k) => {
        (function(n, e) {
          typeof L == "object" && typeof k < "u" ? e(L, ql()) : (n = n || self, e(n.d3 = n.d3 || {}, n.d3));
        })(L, function(n, e) {
          function a(Te) {
            if (0 <= Te.y && Te.y < 100) {
              var Ie = new Date(-1, Te.m, Te.d, Te.H, Te.M, Te.S, Te.L);
              return Ie.setFullYear(Te.y), Ie;
            }
            return new Date(Te.y, Te.m, Te.d, Te.H, Te.M, Te.S, Te.L);
          }
          function i(Te) {
            if (0 <= Te.y && Te.y < 100) {
              var Ie = new Date(Date.UTC(-1, Te.m, Te.d, Te.H, Te.M, Te.S, Te.L));
              return Ie.setUTCFullYear(Te.y), Ie;
            }
            return new Date(Date.UTC(Te.y, Te.m, Te.d, Te.H, Te.M, Te.S, Te.L));
          }
          function o(Te, Ie, ce) {
            return { y: Te, m: Ie, d: ce, H: 0, M: 0, S: 0, L: 0 };
          }
          function r(Te) {
            var Ie = Te.dateTime, ce = Te.date, ge = Te.time, ye = Te.periods, Me = Te.days, Oe = Te.shortDays, je = Te.months, qe = Te.shortMonths, Qe = v(ye), Xe = g(ye), Je = v(Me), ot = g(Me), lt = v(Oe), st = g(Oe), xt = v(je), Et = g(je), Bt = v(qe), qt = g(qe), jt = { a: cr, A: lr, b: $t, B: sr, c: null, d: Z, e: Z, f: ne, H: Y, I: C, j, L: J, m: ae, M: se, p: St, q: Kt, Q: Ze, s: We, S: O, u: F, U: S, V: $, w: re, W: E, x: null, X: null, y: w, Y: N, Z: W, "%": He }, It = { a: hr, A: he, b: fe, B: Pe, c: null, d: ee, e: ee, f: Ae, H: le, I: ie, j: pe, L: _e, m: Ce, M: Ue, p: Re, q: Ye, Q: Ze, s: We, S: Ne, u: ke, U: A, V: X, w: H, W: ve, x: null, X: null, y: be, Y: Se, Z: De, "%": He }, Tt = { a: Ct, A: Ot, b: Wt, B: rr, c: Ut, d: P, e: P, f: G, H: B, I: B, j: M, L: U, m: I, M: z, p: Dt, q: R, Q: te, s: V, S: q, u: h, U: m, V: u, w: x, W: d, x: Qt, X: nr, y: _, Y: y, Z: T, "%": K };
            jt.x = Rt(ce, jt), jt.X = Rt(ge, jt), jt.c = Rt(Ie, jt), It.x = Rt(ce, It), It.X = Rt(ge, It), It.c = Rt(Ie, It);
            function Rt(Ee, ze) {
              return function(Ge) {
                var Ve = [], tt = -1, at = 0, vt = Ee.length, kt, At, Nt;
                for (Ge instanceof Date || (Ge = /* @__PURE__ */ new Date(+Ge)); ++tt < vt; ) Ee.charCodeAt(tt) === 37 && (Ve.push(Ee.slice(at, tt)), (At = s[kt = Ee.charAt(++tt)]) != null ? kt = Ee.charAt(++tt) : At = kt === "e" ? " " : "0", (Nt = ze[kt]) && (kt = Nt(Ge, At)), Ve.push(kt), at = tt + 1);
                return Ve.push(Ee.slice(at, tt)), Ve.join("");
              };
            }
            function Vt(Ee, ze) {
              return function(Ge) {
                var Ve = o(1900, void 0, 1), tt = Ft(Ve, Ee, Ge += "", 0), at, vt;
                if (tt != Ge.length) return null;
                if ("Q" in Ve) return new Date(Ve.Q);
                if ("s" in Ve) return new Date(Ve.s * 1e3 + ("L" in Ve ? Ve.L : 0));
                if (ze && !("Z" in Ve) && (Ve.Z = 0), "p" in Ve && (Ve.H = Ve.H % 12 + Ve.p * 12), Ve.m === void 0 && (Ve.m = "q" in Ve ? Ve.q : 0), "V" in Ve) {
                  if (Ve.V < 1 || Ve.V > 53) return null;
                  "w" in Ve || (Ve.w = 1), "Z" in Ve ? (at = i(o(Ve.y, 0, 1)), vt = at.getUTCDay(), at = vt > 4 || vt === 0 ? e.utcMonday.ceil(at) : e.utcMonday(at), at = e.utcDay.offset(at, (Ve.V - 1) * 7), Ve.y = at.getUTCFullYear(), Ve.m = at.getUTCMonth(), Ve.d = at.getUTCDate() + (Ve.w + 6) % 7) : (at = a(o(Ve.y, 0, 1)), vt = at.getDay(), at = vt > 4 || vt === 0 ? e.timeMonday.ceil(at) : e.timeMonday(at), at = e.timeDay.offset(at, (Ve.V - 1) * 7), Ve.y = at.getFullYear(), Ve.m = at.getMonth(), Ve.d = at.getDate() + (Ve.w + 6) % 7);
                } else ("W" in Ve || "U" in Ve) && ("w" in Ve || (Ve.w = "u" in Ve ? Ve.u % 7 : "W" in Ve ? 1 : 0), vt = "Z" in Ve ? i(o(Ve.y, 0, 1)).getUTCDay() : a(o(Ve.y, 0, 1)).getDay(), Ve.m = 0, Ve.d = "W" in Ve ? (Ve.w + 6) % 7 + Ve.W * 7 - (vt + 5) % 7 : Ve.w + Ve.U * 7 - (vt + 6) % 7);
                return "Z" in Ve ? (Ve.H += Ve.Z / 100 | 0, Ve.M += Ve.Z % 100, i(Ve)) : a(Ve);
              };
            }
            function Ft(Ee, ze, Ge, Ve) {
              for (var tt = 0, at = ze.length, vt = Ge.length, kt, At; tt < at; ) {
                if (Ve >= vt) return -1;
                if (kt = ze.charCodeAt(tt++), kt === 37) {
                  if (kt = ze.charAt(tt++), At = Tt[kt in s ? ze.charAt(tt++) : kt], !At || (Ve = At(Ee, Ge, Ve)) < 0) return -1;
                } else if (kt != Ge.charCodeAt(Ve++)) return -1;
              }
              return Ve;
            }
            function Dt(Ee, ze, Ge) {
              var Ve = Qe.exec(ze.slice(Ge));
              return Ve ? (Ee.p = Xe[Ve[0].toLowerCase()], Ge + Ve[0].length) : -1;
            }
            function Ct(Ee, ze, Ge) {
              var Ve = lt.exec(ze.slice(Ge));
              return Ve ? (Ee.w = st[Ve[0].toLowerCase()], Ge + Ve[0].length) : -1;
            }
            function Ot(Ee, ze, Ge) {
              var Ve = Je.exec(ze.slice(Ge));
              return Ve ? (Ee.w = ot[Ve[0].toLowerCase()], Ge + Ve[0].length) : -1;
            }
            function Wt(Ee, ze, Ge) {
              var Ve = Bt.exec(ze.slice(Ge));
              return Ve ? (Ee.m = qt[Ve[0].toLowerCase()], Ge + Ve[0].length) : -1;
            }
            function rr(Ee, ze, Ge) {
              var Ve = xt.exec(ze.slice(Ge));
              return Ve ? (Ee.m = Et[Ve[0].toLowerCase()], Ge + Ve[0].length) : -1;
            }
            function Ut(Ee, ze, Ge) {
              return Ft(Ee, Ie, ze, Ge);
            }
            function Qt(Ee, ze, Ge) {
              return Ft(Ee, ce, ze, Ge);
            }
            function nr(Ee, ze, Ge) {
              return Ft(Ee, ge, ze, Ge);
            }
            function cr(Ee) {
              return Oe[Ee.getDay()];
            }
            function lr(Ee) {
              return Me[Ee.getDay()];
            }
            function $t(Ee) {
              return qe[Ee.getMonth()];
            }
            function sr(Ee) {
              return je[Ee.getMonth()];
            }
            function St(Ee) {
              return ye[+(Ee.getHours() >= 12)];
            }
            function Kt(Ee) {
              return 1 + ~~(Ee.getMonth() / 3);
            }
            function hr(Ee) {
              return Oe[Ee.getUTCDay()];
            }
            function he(Ee) {
              return Me[Ee.getUTCDay()];
            }
            function fe(Ee) {
              return qe[Ee.getUTCMonth()];
            }
            function Pe(Ee) {
              return je[Ee.getUTCMonth()];
            }
            function Re(Ee) {
              return ye[+(Ee.getUTCHours() >= 12)];
            }
            function Ye(Ee) {
              return 1 + ~~(Ee.getUTCMonth() / 3);
            }
            return { format: function(Ee) {
              var ze = Rt(Ee += "", jt);
              return ze.toString = function() {
                return Ee;
              }, ze;
            }, parse: function(Ee) {
              var ze = Vt(Ee += "", !1);
              return ze.toString = function() {
                return Ee;
              }, ze;
            }, utcFormat: function(Ee) {
              var ze = Rt(Ee += "", It);
              return ze.toString = function() {
                return Ee;
              }, ze;
            }, utcParse: function(Ee) {
              var ze = Vt(Ee += "", !0);
              return ze.toString = function() {
                return Ee;
              }, ze;
            } };
          }
          var s = { "-": "", _: " ", 0: "0" }, c = /^\s*\d+/, t = /^%/, p = /[\\^$*+?|[\]().{}]/g;
          function l(Te, Ie, ce) {
            var ge = Te < 0 ? "-" : "", ye = (ge ? -Te : Te) + "", Me = ye.length;
            return ge + (Me < ce ? new Array(ce - Me + 1).join(Ie) + ye : ye);
          }
          function f(Te) {
            return Te.replace(p, "\\$&");
          }
          function v(Te) {
            return new RegExp("^(?:" + Te.map(f).join("|") + ")", "i");
          }
          function g(Te) {
            for (var Ie = {}, ce = -1, ge = Te.length; ++ce < ge; ) Ie[Te[ce].toLowerCase()] = ce;
            return Ie;
          }
          function x(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 1));
            return ge ? (Te.w = +ge[0], ce + ge[0].length) : -1;
          }
          function h(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 1));
            return ge ? (Te.u = +ge[0], ce + ge[0].length) : -1;
          }
          function m(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.U = +ge[0], ce + ge[0].length) : -1;
          }
          function u(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.V = +ge[0], ce + ge[0].length) : -1;
          }
          function d(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.W = +ge[0], ce + ge[0].length) : -1;
          }
          function y(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 4));
            return ge ? (Te.y = +ge[0], ce + ge[0].length) : -1;
          }
          function _(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.y = +ge[0] + (+ge[0] > 68 ? 1900 : 2e3), ce + ge[0].length) : -1;
          }
          function T(Te, Ie, ce) {
            var ge = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(Ie.slice(ce, ce + 6));
            return ge ? (Te.Z = ge[1] ? 0 : -(ge[2] + (ge[3] || "00")), ce + ge[0].length) : -1;
          }
          function R(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 1));
            return ge ? (Te.q = ge[0] * 3 - 3, ce + ge[0].length) : -1;
          }
          function I(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.m = ge[0] - 1, ce + ge[0].length) : -1;
          }
          function P(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.d = +ge[0], ce + ge[0].length) : -1;
          }
          function M(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 3));
            return ge ? (Te.m = 0, Te.d = +ge[0], ce + ge[0].length) : -1;
          }
          function B(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.H = +ge[0], ce + ge[0].length) : -1;
          }
          function z(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.M = +ge[0], ce + ge[0].length) : -1;
          }
          function q(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 2));
            return ge ? (Te.S = +ge[0], ce + ge[0].length) : -1;
          }
          function U(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 3));
            return ge ? (Te.L = +ge[0], ce + ge[0].length) : -1;
          }
          function G(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce, ce + 6));
            return ge ? (Te.L = Math.floor(ge[0] / 1e3), ce + ge[0].length) : -1;
          }
          function K(Te, Ie, ce) {
            var ge = t.exec(Ie.slice(ce, ce + 1));
            return ge ? ce + ge[0].length : -1;
          }
          function te(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce));
            return ge ? (Te.Q = +ge[0], ce + ge[0].length) : -1;
          }
          function V(Te, Ie, ce) {
            var ge = c.exec(Ie.slice(ce));
            return ge ? (Te.s = +ge[0], ce + ge[0].length) : -1;
          }
          function Z(Te, Ie) {
            return l(Te.getDate(), Ie, 2);
          }
          function Y(Te, Ie) {
            return l(Te.getHours(), Ie, 2);
          }
          function C(Te, Ie) {
            return l(Te.getHours() % 12 || 12, Ie, 2);
          }
          function j(Te, Ie) {
            return l(1 + e.timeDay.count(e.timeYear(Te), Te), Ie, 3);
          }
          function J(Te, Ie) {
            return l(Te.getMilliseconds(), Ie, 3);
          }
          function ne(Te, Ie) {
            return J(Te, Ie) + "000";
          }
          function ae(Te, Ie) {
            return l(Te.getMonth() + 1, Ie, 2);
          }
          function se(Te, Ie) {
            return l(Te.getMinutes(), Ie, 2);
          }
          function O(Te, Ie) {
            return l(Te.getSeconds(), Ie, 2);
          }
          function F(Te) {
            var Ie = Te.getDay();
            return Ie === 0 ? 7 : Ie;
          }
          function S(Te, Ie) {
            return l(e.timeSunday.count(e.timeYear(Te) - 1, Te), Ie, 2);
          }
          function $(Te, Ie) {
            var ce = Te.getDay();
            return Te = ce >= 4 || ce === 0 ? e.timeThursday(Te) : e.timeThursday.ceil(Te), l(e.timeThursday.count(e.timeYear(Te), Te) + (e.timeYear(Te).getDay() === 4), Ie, 2);
          }
          function re(Te) {
            return Te.getDay();
          }
          function E(Te, Ie) {
            return l(e.timeMonday.count(e.timeYear(Te) - 1, Te), Ie, 2);
          }
          function w(Te, Ie) {
            return l(Te.getFullYear() % 100, Ie, 2);
          }
          function N(Te, Ie) {
            return l(Te.getFullYear() % 1e4, Ie, 4);
          }
          function W(Te) {
            var Ie = Te.getTimezoneOffset();
            return (Ie > 0 ? "-" : (Ie *= -1, "+")) + l(Ie / 60 | 0, "0", 2) + l(Ie % 60, "0", 2);
          }
          function ee(Te, Ie) {
            return l(Te.getUTCDate(), Ie, 2);
          }
          function le(Te, Ie) {
            return l(Te.getUTCHours(), Ie, 2);
          }
          function ie(Te, Ie) {
            return l(Te.getUTCHours() % 12 || 12, Ie, 2);
          }
          function pe(Te, Ie) {
            return l(1 + e.utcDay.count(e.utcYear(Te), Te), Ie, 3);
          }
          function _e(Te, Ie) {
            return l(Te.getUTCMilliseconds(), Ie, 3);
          }
          function Ae(Te, Ie) {
            return _e(Te, Ie) + "000";
          }
          function Ce(Te, Ie) {
            return l(Te.getUTCMonth() + 1, Ie, 2);
          }
          function Ue(Te, Ie) {
            return l(Te.getUTCMinutes(), Ie, 2);
          }
          function Ne(Te, Ie) {
            return l(Te.getUTCSeconds(), Ie, 2);
          }
          function ke(Te) {
            var Ie = Te.getUTCDay();
            return Ie === 0 ? 7 : Ie;
          }
          function A(Te, Ie) {
            return l(e.utcSunday.count(e.utcYear(Te) - 1, Te), Ie, 2);
          }
          function X(Te, Ie) {
            var ce = Te.getUTCDay();
            return Te = ce >= 4 || ce === 0 ? e.utcThursday(Te) : e.utcThursday.ceil(Te), l(e.utcThursday.count(e.utcYear(Te), Te) + (e.utcYear(Te).getUTCDay() === 4), Ie, 2);
          }
          function H(Te) {
            return Te.getUTCDay();
          }
          function ve(Te, Ie) {
            return l(e.utcMonday.count(e.utcYear(Te) - 1, Te), Ie, 2);
          }
          function be(Te, Ie) {
            return l(Te.getUTCFullYear() % 100, Ie, 2);
          }
          function Se(Te, Ie) {
            return l(Te.getUTCFullYear() % 1e4, Ie, 4);
          }
          function De() {
            return "+0000";
          }
          function He() {
            return "%";
          }
          function Ze(Te) {
            return +Te;
          }
          function We(Te) {
            return Math.floor(+Te / 1e3);
          }
          var $e;
          it({ dateTime: "%x, %X", date: "%-m/%-d/%Y", time: "%-I:%M:%S %p", periods: ["AM", "PM"], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] });
          function it(Te) {
            return $e = r(Te), n.timeFormat = $e.format, n.timeParse = $e.parse, n.utcFormat = $e.utcFormat, n.utcParse = $e.utcParse, $e;
          }
          var Ke = "%Y-%m-%dT%H:%M:%S.%LZ";
          function ct(Te) {
            return Te.toISOString();
          }
          var gt = Date.prototype.toISOString ? ct : n.utcFormat(Ke);
          function ht(Te) {
            var Ie = new Date(Te);
            return isNaN(Ie) ? null : Ie;
          }
          var _t = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? ht : n.utcParse(Ke);
          n.isoFormat = gt, n.isoParse = _t, n.timeFormatDefaultLocale = it, n.timeFormatLocale = r, Object.defineProperty(n, "__esModule", { value: !0 });
        });
      }), Ul = xe((L, k) => {
        (function(n, e) {
          typeof L == "object" && typeof k < "u" ? e(L) : (n = typeof globalThis < "u" ? globalThis : n || self, e(n.d3 = n.d3 || {}));
        })(L, function(n) {
          function e(I) {
            return Math.abs(I = Math.round(I)) >= 1e21 ? I.toLocaleString("en").replace(/,/g, "") : I.toString(10);
          }
          function a(I, P) {
            if ((M = (I = P ? I.toExponential(P - 1) : I.toExponential()).indexOf("e")) < 0) return null;
            var M, B = I.slice(0, M);
            return [B.length > 1 ? B[0] + B.slice(2) : B, +I.slice(M + 1)];
          }
          function i(I) {
            return I = a(Math.abs(I)), I ? I[1] : NaN;
          }
          function o(I, P) {
            return function(M, B) {
              for (var z = M.length, q = [], U = 0, G = I[0], K = 0; z > 0 && G > 0 && (K + G + 1 > B && (G = Math.max(1, B - K)), q.push(M.substring(z -= G, z + G)), !((K += G + 1) > B)); ) G = I[U = (U + 1) % I.length];
              return q.reverse().join(P);
            };
          }
          function r(I) {
            return function(P) {
              return P.replace(/[0-9]/g, function(M) {
                return I[+M];
              });
            };
          }
          var s = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
          function c(I) {
            if (!(P = s.exec(I))) throw new Error("invalid format: " + I);
            var P;
            return new t({ fill: P[1], align: P[2], sign: P[3], symbol: P[4], zero: P[5], width: P[6], comma: P[7], precision: P[8] && P[8].slice(1), trim: P[9], type: P[10] });
          }
          c.prototype = t.prototype;
          function t(I) {
            this.fill = I.fill === void 0 ? " " : I.fill + "", this.align = I.align === void 0 ? ">" : I.align + "", this.sign = I.sign === void 0 ? "-" : I.sign + "", this.symbol = I.symbol === void 0 ? "" : I.symbol + "", this.zero = !!I.zero, this.width = I.width === void 0 ? void 0 : +I.width, this.comma = !!I.comma, this.precision = I.precision === void 0 ? void 0 : +I.precision, this.trim = !!I.trim, this.type = I.type === void 0 ? "" : I.type + "";
          }
          t.prototype.toString = function() {
            return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
          };
          function p(I) {
            e: for (var P = I.length, M = 1, B = -1, z; M < P; ++M) switch (I[M]) {
              case ".":
                B = z = M;
                break;
              case "0":
                B === 0 && (B = M), z = M;
                break;
              default:
                if (!+I[M]) break e;
                B > 0 && (B = 0);
                break;
            }
            return B > 0 ? I.slice(0, B) + I.slice(z + 1) : I;
          }
          var l;
          function f(I, P) {
            var M = a(I, P);
            if (!M) return I + "";
            var B = M[0], z = M[1], q = z - (l = Math.max(-8, Math.min(8, Math.floor(z / 3))) * 3) + 1, U = B.length;
            return q === U ? B : q > U ? B + new Array(q - U + 1).join("0") : q > 0 ? B.slice(0, q) + "." + B.slice(q) : "0." + new Array(1 - q).join("0") + a(I, Math.max(0, P + q - 1))[0];
          }
          function v(I, P) {
            var M = a(I, P);
            if (!M) return I + "";
            var B = M[0], z = M[1];
            return z < 0 ? "0." + new Array(-z).join("0") + B : B.length > z + 1 ? B.slice(0, z + 1) + "." + B.slice(z + 1) : B + new Array(z - B.length + 2).join("0");
          }
          var g = { "%": function(I, P) {
            return (I * 100).toFixed(P);
          }, b: function(I) {
            return Math.round(I).toString(2);
          }, c: function(I) {
            return I + "";
          }, d: e, e: function(I, P) {
            return I.toExponential(P);
          }, f: function(I, P) {
            return I.toFixed(P);
          }, g: function(I, P) {
            return I.toPrecision(P);
          }, o: function(I) {
            return Math.round(I).toString(8);
          }, p: function(I, P) {
            return v(I * 100, P);
          }, r: v, s: f, X: function(I) {
            return Math.round(I).toString(16).toUpperCase();
          }, x: function(I) {
            return Math.round(I).toString(16);
          } };
          function x(I) {
            return I;
          }
          var h = Array.prototype.map, m = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
          function u(I) {
            var P = I.grouping === void 0 || I.thousands === void 0 ? x : o(h.call(I.grouping, Number), I.thousands + ""), M = I.currency === void 0 ? "" : I.currency[0] + "", B = I.currency === void 0 ? "" : I.currency[1] + "", z = I.decimal === void 0 ? "." : I.decimal + "", q = I.numerals === void 0 ? x : r(h.call(I.numerals, String)), U = I.percent === void 0 ? "%" : I.percent + "", G = I.minus === void 0 ? "-" : I.minus + "", K = I.nan === void 0 ? "NaN" : I.nan + "";
            function te(Z) {
              Z = c(Z);
              var Y = Z.fill, C = Z.align, j = Z.sign, J = Z.symbol, ne = Z.zero, ae = Z.width, se = Z.comma, O = Z.precision, F = Z.trim, S = Z.type;
              S === "n" ? (se = !0, S = "g") : g[S] || (O === void 0 && (O = 12), F = !0, S = "g"), (ne || Y === "0" && C === "=") && (ne = !0, Y = "0", C = "=");
              var $ = J === "$" ? M : J === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", re = J === "$" ? B : /[%p]/.test(S) ? U : "", E = g[S], w = /[defgprs%]/.test(S);
              O = O === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, O)) : Math.max(0, Math.min(20, O));
              function N(W) {
                var ee = $, le = re, ie, pe, _e;
                if (S === "c") le = E(W) + le, W = "";
                else {
                  W = +W;
                  var Ae = W < 0 || 1 / W < 0;
                  if (W = isNaN(W) ? K : E(Math.abs(W), O), F && (W = p(W)), Ae && +W == 0 && j !== "+" && (Ae = !1), ee = (Ae ? j === "(" ? j : G : j === "-" || j === "(" ? "" : j) + ee, le = (S === "s" ? m[8 + l / 3] : "") + le + (Ae && j === "(" ? ")" : ""), w) {
                    for (ie = -1, pe = W.length; ++ie < pe; ) if (_e = W.charCodeAt(ie), 48 > _e || _e > 57) {
                      le = (_e === 46 ? z + W.slice(ie + 1) : W.slice(ie)) + le, W = W.slice(0, ie);
                      break;
                    }
                  }
                }
                se && !ne && (W = P(W, 1 / 0));
                var Ce = ee.length + W.length + le.length, Ue = Ce < ae ? new Array(ae - Ce + 1).join(Y) : "";
                switch (se && ne && (W = P(Ue + W, Ue.length ? ae - le.length : 1 / 0), Ue = ""), C) {
                  case "<":
                    W = ee + W + le + Ue;
                    break;
                  case "=":
                    W = ee + Ue + W + le;
                    break;
                  case "^":
                    W = Ue.slice(0, Ce = Ue.length >> 1) + ee + W + le + Ue.slice(Ce);
                    break;
                  default:
                    W = Ue + ee + W + le;
                    break;
                }
                return q(W);
              }
              return N.toString = function() {
                return Z + "";
              }, N;
            }
            function V(Z, Y) {
              var C = te((Z = c(Z), Z.type = "f", Z)), j = Math.max(-8, Math.min(8, Math.floor(i(Y) / 3))) * 3, J = Math.pow(10, -j), ne = m[8 + j / 3];
              return function(ae) {
                return C(J * ae) + ne;
              };
            }
            return { format: te, formatPrefix: V };
          }
          var d;
          y({ decimal: ".", thousands: ",", grouping: [3], currency: ["$", ""], minus: "-" });
          function y(I) {
            return d = u(I), n.format = d.format, n.formatPrefix = d.formatPrefix, d;
          }
          function _(I) {
            return Math.max(0, -i(Math.abs(I)));
          }
          function T(I, P) {
            return Math.max(0, Math.max(-8, Math.min(8, Math.floor(i(P) / 3))) * 3 - i(Math.abs(I)));
          }
          function R(I, P) {
            return I = Math.abs(I), P = Math.abs(P) - I, Math.max(0, i(P) - i(I)) + 1;
          }
          n.FormatSpecifier = t, n.formatDefaultLocale = y, n.formatLocale = u, n.formatSpecifier = c, n.precisionFixed = _, n.precisionPrefix = T, n.precisionRound = R, Object.defineProperty(n, "__esModule", { value: !0 });
        });
      }), bf = xe((L, k) => {
        k.exports = function(n) {
          for (var e = n.length, a, i = 0; i < e; i++) if (a = n.charCodeAt(i), (a < 9 || a > 13) && a !== 32 && a !== 133 && a !== 160 && a !== 5760 && a !== 6158 && (a < 8192 || a > 8205) && a !== 8232 && a !== 8233 && a !== 8239 && a !== 8287 && a !== 8288 && a !== 12288 && a !== 65279) return !1;
          return !0;
        };
      }), xr = xe((L, k) => {
        var n = bf();
        k.exports = function(e) {
          var a = typeof e;
          if (a === "string") {
            var i = e;
            if (e = +e, e === 0 && n(i)) return !1;
          } else if (a !== "number") return !1;
          return e - e < 1;
        };
      }), Yr = xe((L, k) => {
        k.exports = { BADNUM: void 0, FP_SAFE: Number.MAX_VALUE * 1e-4, ONEMAXYEAR: 316224e5, ONEAVGYEAR: 315576e5, ONEMINYEAR: 31536e6, ONEMAXQUARTER: 79488e5, ONEAVGQUARTER: 78894e5, ONEMINQUARTER: 76896e5, ONEMAXMONTH: 26784e5, ONEAVGMONTH: 26298e5, ONEMINMONTH: 24192e5, ONEWEEK: 6048e5, ONEDAY: 864e5, ONEHOUR: 36e5, ONEMIN: 6e4, ONESEC: 1e3, ONEMILLI: 1, ONEMICROSEC: 1e-3, EPOCHJD: 24405875e-1, ALMOST_EQUAL: 1 - 1e-6, LOG_CLIP: 10, MINUS_SIGN: "−" };
      }), Vl = xe((L, k) => {
        (function(n, e) {
          typeof L == "object" && typeof k < "u" ? e(L) : (n = typeof globalThis < "u" ? globalThis : n || self, e(n["base64-arraybuffer"] = {}));
        })(L, function(n) {
          for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = typeof Uint8Array > "u" ? [] : new Uint8Array(256), i = 0; i < e.length; i++) a[e.charCodeAt(i)] = i;
          var o = function(s) {
            var c = new Uint8Array(s), t, p = c.length, l = "";
            for (t = 0; t < p; t += 3) l += e[c[t] >> 2], l += e[(c[t] & 3) << 4 | c[t + 1] >> 4], l += e[(c[t + 1] & 15) << 2 | c[t + 2] >> 6], l += e[c[t + 2] & 63];
            return p % 3 === 2 ? l = l.substring(0, l.length - 1) + "=" : p % 3 === 1 && (l = l.substring(0, l.length - 2) + "=="), l;
          }, r = function(s) {
            var c = s.length * 0.75, t = s.length, p, l = 0, f, v, g, x;
            s[s.length - 1] === "=" && (c--, s[s.length - 2] === "=" && c--);
            var h = new ArrayBuffer(c), m = new Uint8Array(h);
            for (p = 0; p < t; p += 4) f = a[s.charCodeAt(p)], v = a[s.charCodeAt(p + 1)], g = a[s.charCodeAt(p + 2)], x = a[s.charCodeAt(p + 3)], m[l++] = f << 2 | v >> 4, m[l++] = (v & 15) << 4 | g >> 2, m[l++] = (g & 3) << 6 | x & 63;
            return h;
          };
          n.decode = r, n.encode = o, Object.defineProperty(n, "__esModule", { value: !0 });
        });
      }), ka = xe((L, k) => {
        k.exports = function(n) {
          return window && window.process && window.process.versions ? Object.prototype.toString.call(n) === "[object Object]" : Object.prototype.toString.call(n) === "[object Object]" && Object.getPrototypeOf(n).hasOwnProperty("hasOwnProperty");
        };
      }), Hn = xe((L) => {
        var k = Vl().decode, n = ka(), e = Array.isArray, a = ArrayBuffer, i = DataView;
        function o(f) {
          return a.isView(f) && !(f instanceof i);
        }
        L.isTypedArray = o;
        function r(f) {
          return e(f) || o(f);
        }
        L.isArrayOrTypedArray = r;
        function s(f) {
          return !r(f[0]);
        }
        L.isArray1D = s, L.ensureArray = function(f, v) {
          return e(f) || (f = []), f.length = v, f;
        };
        var c = { u1c: typeof Uint8ClampedArray > "u" ? void 0 : Uint8ClampedArray, i1: typeof Int8Array > "u" ? void 0 : Int8Array, u1: typeof Uint8Array > "u" ? void 0 : Uint8Array, i2: typeof Int16Array > "u" ? void 0 : Int16Array, u2: typeof Uint16Array > "u" ? void 0 : Uint16Array, i4: typeof Int32Array > "u" ? void 0 : Int32Array, u4: typeof Uint32Array > "u" ? void 0 : Uint32Array, f4: typeof Float32Array > "u" ? void 0 : Float32Array, f8: typeof Float64Array > "u" ? void 0 : Float64Array };
        c.uint8c = c.u1c, c.uint8 = c.u1, c.int8 = c.i1, c.uint16 = c.u2, c.int16 = c.i2, c.uint32 = c.u4, c.int32 = c.i4, c.float32 = c.f4, c.float64 = c.f8;
        function t(f) {
          return f.constructor === ArrayBuffer;
        }
        L.isArrayBuffer = t, L.decodeTypedArraySpec = function(f) {
          var v = [], g = p(f), x = g.dtype, h = c[x];
          if (!h) throw new Error('Error in dtype: "' + x + '"');
          var m = h.BYTES_PER_ELEMENT, u = g.bdata;
          t(u) || (u = k(u));
          var d = g.shape === void 0 ? [u.byteLength / m] : ("" + g.shape).split(",");
          d.reverse();
          var y = d.length, _, T, R = +d[0], I = m * R, P = 0;
          if (y === 1) v = new h(u);
          else if (y === 2) for (_ = +d[1], T = 0; T < _; T++) v[T] = new h(u, P, R), P += I;
          else if (y === 3) {
            _ = +d[1];
            for (var M = +d[2], B = 0; B < M; B++) for (v[B] = [], T = 0; T < _; T++) v[B][T] = new h(u, P, R), P += I;
          } else throw new Error("ndim: " + y + 'is not supported with the shape:"' + g.shape + '"');
          return v.bdata = g.bdata, v.dtype = g.dtype, v.shape = d.reverse().join(","), f._inputArray = v, v;
        }, L.isTypedArraySpec = function(f) {
          return n(f) && f.hasOwnProperty("dtype") && typeof f.dtype == "string" && f.hasOwnProperty("bdata") && (typeof f.bdata == "string" || t(f.bdata)) && (f.shape === void 0 || f.hasOwnProperty("shape") && (typeof f.shape == "string" || typeof f.shape == "number"));
        };
        function p(f) {
          return { bdata: f.bdata, dtype: f.dtype, shape: f.shape };
        }
        L.concat = function() {
          var f = [], v = !0, g = 0, x, h, m, u, d, y, _, T;
          for (m = 0; m < arguments.length; m++) u = arguments[m], y = u.length, y && (h ? f.push(u) : (h = u, d = y), e(u) ? x = !1 : (v = !1, g ? x !== u.constructor && (x = !1) : x = u.constructor), g += y);
          if (!g) return [];
          if (!f.length) return h;
          if (v) return h.concat.apply(h, f);
          if (x) {
            for (_ = new x(g), _.set(h), m = 0; m < f.length; m++) u = f[m], _.set(u, d), d += u.length;
            return _;
          }
          for (_ = new Array(g), T = 0; T < h.length; T++) _[T] = h[T];
          for (m = 0; m < f.length; m++) {
            for (u = f[m], T = 0; T < u.length; T++) _[d + T] = u[T];
            d += T;
          }
          return _;
        }, L.maxRowLength = function(f) {
          return l(f, Math.max, 0);
        }, L.minRowLength = function(f) {
          return l(f, Math.min, 1 / 0);
        };
        function l(f, v, g) {
          if (r(f)) if (r(f[0])) {
            for (var x = g, h = 0; h < f.length; h++) x = v(x, f[h].length);
            return x;
          } else return f.length;
          return 0;
        }
      }), io = xe((L, k) => {
        var n = xr(), e = Hn().isArrayOrTypedArray;
        k.exports = function(l, f) {
          if (n(f)) f = String(f);
          else if (typeof f != "string" || f.substr(f.length - 4) === "[-1]") throw "bad property string";
          var v = f.split("."), g, x, h, m;
          for (m = 0; m < v.length; m++) if (String(v[m]).slice(0, 2) === "__") throw "bad property string";
          for (m = 0; m < v.length; ) {
            if (g = String(v[m]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/), g) {
              if (g[1]) v[m] = g[1];
              else if (m === 0) v.splice(0, 1);
              else throw "bad property string";
              for (x = g[2].substr(1, g[2].length - 2).split("]["), h = 0; h < x.length; h++) m++, v.splice(m, 0, Number(x[h]));
            }
            m++;
          }
          return typeof l != "object" ? p(l, f, v) : { set: r(l, v, f), get: a(l, v), astr: f, parts: v, obj: l };
        };
        function a(l, f) {
          return function(v) {
            var g = l, x, h, m, u, d;
            for (u = 0; u < f.length - 1; u++) {
              if (x = f[u], x === -1) {
                for (h = !0, m = [], d = 0; d < g.length; d++) m[d] = a(g[d], f.slice(u + 1))(v), m[d] !== m[0] && (h = !1);
                return h ? m[0] : m;
              }
              if (typeof x == "number" && !e(g) || (g = g[x], typeof g != "object" || g === null)) return;
            }
            if (!(typeof g != "object" || g === null) && (m = g[f[u]], !(!v && m === null))) return m;
          };
        }
        var i = /(^|\.)args\[/;
        function o(l, f) {
          return l === void 0 || l === null && !f.match(i);
        }
        function r(l, f, v) {
          return function(g) {
            var x = l, h = "", m = o(g, v), u, d;
            for (d = 0; d < f.length - 1; d++) {
              if (u = f[d], typeof u == "number" && !e(x)) throw "array index but container is not an array";
              if (u === -1) {
                if (m = !c(x, f.slice(d + 1), g, v), m) break;
                return;
              }
              if (!t(x, u, f[d + 1], m)) break;
              if (x = x[u], typeof x != "object" || x === null) throw "container is not an object";
              h = s(h, u);
            }
            if (m) {
              if (d === f.length - 1 && (delete x[f[d]], Array.isArray(x) && +f[d] === x.length - 1)) for (; x.length && x[x.length - 1] === void 0; ) x.pop();
            } else x[f[d]] = g;
          };
        }
        function s(l, f) {
          var v = f;
          return n(f) ? v = "[" + f + "]" : l && (v = "." + f), l + v;
        }
        function c(l, f, v, g) {
          var x = e(v), h = !0, m = v, u = g.replace("-1", 0), d = x ? !1 : o(v, u), y = f[0], _;
          for (_ = 0; _ < l.length; _++) u = g.replace("-1", _), x && (m = v[_ % v.length], d = o(m, u)), d && (h = !1), t(l, _, y, d) && r(l[_], f, g.replace("-1", _))(m);
          return h;
        }
        function t(l, f, v, g) {
          if (l[f] === void 0) {
            if (g) return !1;
            typeof v == "number" ? l[f] = [] : l[f] = {};
          }
          return !0;
        }
        function p(l, f, v) {
          return { set: function() {
            throw "bad container";
          }, get: function() {
          }, astr: f, parts: v, obj: l };
        }
      }), _f = xe((L, k) => {
        var n = io(), e = /^\w*$/, a = 0, i = 1, o = 2, r = 3, s = 4;
        k.exports = function(c, t, p, l) {
          p = p || "name", l = l || "value";
          var f, v, g, x = {};
          t && t.length ? (g = n(c, t), v = g.get()) : v = c, t = t || "";
          var h = {};
          if (v) for (f = 0; f < v.length; f++) h[v[f][p]] = f;
          var m = e.test(l), u = { set: function(d, y) {
            var _ = y === null ? s : a;
            if (!v) {
              if (!g || _ === s) return;
              v = [], g.set(v);
            }
            var T = h[d];
            if (T === void 0) {
              if (_ === s) return;
              _ = _ | r, T = v.length, h[d] = T;
            } else y !== (m ? v[T][l] : n(v[T], l).get()) && (_ = _ | o);
            var R = v[T] = v[T] || {};
            return R[p] = d, m ? R[l] = y : n(R, l).set(y), y !== null && (_ = _ & ~s), x[T] = x[T] | _, u;
          }, get: function(d) {
            if (v) {
              var y = h[d];
              if (y !== void 0) return m ? v[y][l] : n(v[y], l).get();
            }
          }, rename: function(d, y) {
            var _ = h[d];
            return _ === void 0 || (x[_] = x[_] | i, h[y] = _, delete h[d], v[_][p] = y), u;
          }, remove: function(d) {
            var y = h[d];
            if (y === void 0) return u;
            var _ = v[y];
            if (Object.keys(_).length > 2) return x[y] = x[y] | o, u.set(d, null);
            if (m) {
              for (f = y; f < v.length; f++) x[f] = x[f] | r;
              for (f = y; f < v.length; f++) h[v[f][p]]--;
              v.splice(y, 1), delete h[d];
            } else n(_, l).set(null), x[y] = x[y] | o | s;
            return u;
          }, constructUpdate: function() {
            for (var d, y, _ = {}, T = Object.keys(x), R = 0; R < T.length; R++) y = T[R], d = t + "[" + y + "]", v[y] ? (x[y] & i && (_[d + "." + p] = v[y][p]), x[y] & o && (m ? _[d + "." + l] = x[y] & s ? null : v[y][l] : _[d + "." + l] = x[y] & s ? null : n(v[y], l).get())) : _[d] = null;
            return _;
          } };
          return u;
        };
      }), wf = xe((L, k) => {
        var n = /^(.*)(\.[^\.\[\]]+|\[\d\])$/, e = /^[^\.\[\]]+$/;
        k.exports = function(a, i) {
          for (; i; ) {
            var o = a.match(n);
            if (o) a = o[1];
            else if (a.match(e)) a = "";
            else throw new Error("bad relativeAttr call:" + [a, i]);
            if (i.charAt(0) === "^") i = i.slice(1);
            else break;
          }
          return a && i.charAt(0) !== "[" ? a + "." + i : a + i;
        };
      }), oo = xe((L, k) => {
        var n = xr();
        k.exports = function(e, a) {
          if (e > 0) return Math.log(e) / Math.LN10;
          var i = Math.log(Math.min(a[0], a[1])) / Math.LN10;
          return n(i) || (i = Math.log(Math.max(a[0], a[1])) / Math.LN10 - 6), i;
        };
      }), Tf = xe((L, k) => {
        var n = Hn().isArrayOrTypedArray, e = ka();
        k.exports = function a(i, o) {
          for (var r in o) {
            var s = o[r], c = i[r];
            if (c !== s) if (r.charAt(0) === "_" || typeof s == "function") {
              if (r in i) continue;
              i[r] = s;
            } else if (n(s) && n(c) && e(s[0])) {
              if (r === "customdata" || r === "ids") continue;
              for (var t = Math.min(s.length, c.length), p = 0; p < t; p++) c[p] !== s[p] && e(s[p]) && e(c[p]) && a(c[p], s[p]);
            } else e(s) && e(c) && (a(c, s), Object.keys(c).length || delete i[r]);
          }
        };
      }), Xa = xe((L, k) => {
        function n(a, i) {
          var o = a % i;
          return o < 0 ? o + i : o;
        }
        function e(a, i) {
          return Math.abs(a) > i / 2 ? a - Math.round(a / i) * i : a;
        }
        k.exports = { mod: n, modHalf: e };
      }), Nn = xe((L, k) => {
        (function(n) {
          var e = /^\s+/, a = /\s+$/, i = 0, o = n.round, r = n.min, s = n.max, c = n.random;
          function t(w, N) {
            if (w = w || "", N = N || {}, w instanceof t) return w;
            if (!(this instanceof t)) return new t(w, N);
            var W = p(w);
            this._originalInput = w, this._r = W.r, this._g = W.g, this._b = W.b, this._a = W.a, this._roundA = o(100 * this._a) / 100, this._format = N.format || W.format, this._gradientType = N.gradientType, this._r < 1 && (this._r = o(this._r)), this._g < 1 && (this._g = o(this._g)), this._b < 1 && (this._b = o(this._b)), this._ok = W.ok, this._tc_id = i++;
          }
          t.prototype = { isDark: function() {
            return this.getBrightness() < 128;
          }, isLight: function() {
            return !this.isDark();
          }, isValid: function() {
            return this._ok;
          }, getOriginalInput: function() {
            return this._originalInput;
          }, getFormat: function() {
            return this._format;
          }, getAlpha: function() {
            return this._a;
          }, getBrightness: function() {
            var w = this.toRgb();
            return (w.r * 299 + w.g * 587 + w.b * 114) / 1e3;
          }, getLuminance: function() {
            var w = this.toRgb(), N, W, ee, le, ie, pe;
            return N = w.r / 255, W = w.g / 255, ee = w.b / 255, N <= 0.03928 ? le = N / 12.92 : le = n.pow((N + 0.055) / 1.055, 2.4), W <= 0.03928 ? ie = W / 12.92 : ie = n.pow((W + 0.055) / 1.055, 2.4), ee <= 0.03928 ? pe = ee / 12.92 : pe = n.pow((ee + 0.055) / 1.055, 2.4), 0.2126 * le + 0.7152 * ie + 0.0722 * pe;
          }, setAlpha: function(w) {
            return this._a = Z(w), this._roundA = o(100 * this._a) / 100, this;
          }, toHsv: function() {
            var w = g(this._r, this._g, this._b);
            return { h: w.h * 360, s: w.s, v: w.v, a: this._a };
          }, toHsvString: function() {
            var w = g(this._r, this._g, this._b), N = o(w.h * 360), W = o(w.s * 100), ee = o(w.v * 100);
            return this._a == 1 ? "hsv(" + N + ", " + W + "%, " + ee + "%)" : "hsva(" + N + ", " + W + "%, " + ee + "%, " + this._roundA + ")";
          }, toHsl: function() {
            var w = f(this._r, this._g, this._b);
            return { h: w.h * 360, s: w.s, l: w.l, a: this._a };
          }, toHslString: function() {
            var w = f(this._r, this._g, this._b), N = o(w.h * 360), W = o(w.s * 100), ee = o(w.l * 100);
            return this._a == 1 ? "hsl(" + N + ", " + W + "%, " + ee + "%)" : "hsla(" + N + ", " + W + "%, " + ee + "%, " + this._roundA + ")";
          }, toHex: function(w) {
            return h(this._r, this._g, this._b, w);
          }, toHexString: function(w) {
            return "#" + this.toHex(w);
          }, toHex8: function(w) {
            return m(this._r, this._g, this._b, this._a, w);
          }, toHex8String: function(w) {
            return "#" + this.toHex8(w);
          }, toRgb: function() {
            return { r: o(this._r), g: o(this._g), b: o(this._b), a: this._a };
          }, toRgbString: function() {
            return this._a == 1 ? "rgb(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ")" : "rgba(" + o(this._r) + ", " + o(this._g) + ", " + o(this._b) + ", " + this._roundA + ")";
          }, toPercentageRgb: function() {
            return { r: o(Y(this._r, 255) * 100) + "%", g: o(Y(this._g, 255) * 100) + "%", b: o(Y(this._b, 255) * 100) + "%", a: this._a };
          }, toPercentageRgbString: function() {
            return this._a == 1 ? "rgb(" + o(Y(this._r, 255) * 100) + "%, " + o(Y(this._g, 255) * 100) + "%, " + o(Y(this._b, 255) * 100) + "%)" : "rgba(" + o(Y(this._r, 255) * 100) + "%, " + o(Y(this._g, 255) * 100) + "%, " + o(Y(this._b, 255) * 100) + "%, " + this._roundA + ")";
          }, toName: function() {
            return this._a === 0 ? "transparent" : this._a < 1 ? !1 : te[h(this._r, this._g, this._b, !0)] || !1;
          }, toFilter: function(w) {
            var N = "#" + u(this._r, this._g, this._b, this._a), W = N, ee = this._gradientType ? "GradientType = 1, " : "";
            if (w) {
              var le = t(w);
              W = "#" + u(le._r, le._g, le._b, le._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + ee + "startColorstr=" + N + ",endColorstr=" + W + ")";
          }, toString: function(w) {
            var N = !!w;
            w = w || this._format;
            var W = !1, ee = this._a < 1 && this._a >= 0, le = !N && ee && (w === "hex" || w === "hex6" || w === "hex3" || w === "hex4" || w === "hex8" || w === "name");
            return le ? w === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (w === "rgb" && (W = this.toRgbString()), w === "prgb" && (W = this.toPercentageRgbString()), (w === "hex" || w === "hex6") && (W = this.toHexString()), w === "hex3" && (W = this.toHexString(!0)), w === "hex4" && (W = this.toHex8String(!0)), w === "hex8" && (W = this.toHex8String()), w === "name" && (W = this.toName()), w === "hsl" && (W = this.toHslString()), w === "hsv" && (W = this.toHsvString()), W || this.toHexString());
          }, clone: function() {
            return t(this.toString());
          }, _applyModification: function(w, N) {
            var W = w.apply(null, [this].concat([].slice.call(N)));
            return this._r = W._r, this._g = W._g, this._b = W._b, this.setAlpha(W._a), this;
          }, lighten: function() {
            return this._applyModification(T, arguments);
          }, brighten: function() {
            return this._applyModification(R, arguments);
          }, darken: function() {
            return this._applyModification(I, arguments);
          }, desaturate: function() {
            return this._applyModification(d, arguments);
          }, saturate: function() {
            return this._applyModification(y, arguments);
          }, greyscale: function() {
            return this._applyModification(_, arguments);
          }, spin: function() {
            return this._applyModification(P, arguments);
          }, _applyCombination: function(w, N) {
            return w.apply(null, [this].concat([].slice.call(N)));
          }, analogous: function() {
            return this._applyCombination(U, arguments);
          }, complement: function() {
            return this._applyCombination(M, arguments);
          }, monochromatic: function() {
            return this._applyCombination(G, arguments);
          }, splitcomplement: function() {
            return this._applyCombination(q, arguments);
          }, triad: function() {
            return this._applyCombination(B, arguments);
          }, tetrad: function() {
            return this._applyCombination(z, arguments);
          } }, t.fromRatio = function(w, N) {
            if (typeof w == "object") {
              var W = {};
              for (var ee in w) w.hasOwnProperty(ee) && (ee === "a" ? W[ee] = w[ee] : W[ee] = se(w[ee]));
              w = W;
            }
            return t(w, N);
          };
          function p(w) {
            var N = { r: 0, g: 0, b: 0 }, W = 1, ee = null, le = null, ie = null, pe = !1, _e = !1;
            return typeof w == "string" && (w = re(w)), typeof w == "object" && ($(w.r) && $(w.g) && $(w.b) ? (N = l(w.r, w.g, w.b), pe = !0, _e = String(w.r).substr(-1) === "%" ? "prgb" : "rgb") : $(w.h) && $(w.s) && $(w.v) ? (ee = se(w.s), le = se(w.v), N = x(w.h, ee, le), pe = !0, _e = "hsv") : $(w.h) && $(w.s) && $(w.l) && (ee = se(w.s), ie = se(w.l), N = v(w.h, ee, ie), pe = !0, _e = "hsl"), w.hasOwnProperty("a") && (W = w.a)), W = Z(W), { ok: pe, format: w.format || _e, r: r(255, s(N.r, 0)), g: r(255, s(N.g, 0)), b: r(255, s(N.b, 0)), a: W };
          }
          function l(w, N, W) {
            return { r: Y(w, 255) * 255, g: Y(N, 255) * 255, b: Y(W, 255) * 255 };
          }
          function f(w, N, W) {
            w = Y(w, 255), N = Y(N, 255), W = Y(W, 255);
            var ee = s(w, N, W), le = r(w, N, W), ie, pe, _e = (ee + le) / 2;
            if (ee == le) ie = pe = 0;
            else {
              var Ae = ee - le;
              switch (pe = _e > 0.5 ? Ae / (2 - ee - le) : Ae / (ee + le), ee) {
                case w:
                  ie = (N - W) / Ae + (N < W ? 6 : 0);
                  break;
                case N:
                  ie = (W - w) / Ae + 2;
                  break;
                case W:
                  ie = (w - N) / Ae + 4;
                  break;
              }
              ie /= 6;
            }
            return { h: ie, s: pe, l: _e };
          }
          function v(w, N, W) {
            var ee, le, ie;
            w = Y(w, 360), N = Y(N, 100), W = Y(W, 100);
            function pe(Ce, Ue, Ne) {
              return Ne < 0 && (Ne += 1), Ne > 1 && (Ne -= 1), Ne < 1 / 6 ? Ce + (Ue - Ce) * 6 * Ne : Ne < 1 / 2 ? Ue : Ne < 2 / 3 ? Ce + (Ue - Ce) * (2 / 3 - Ne) * 6 : Ce;
            }
            if (N === 0) ee = le = ie = W;
            else {
              var _e = W < 0.5 ? W * (1 + N) : W + N - W * N, Ae = 2 * W - _e;
              ee = pe(Ae, _e, w + 1 / 3), le = pe(Ae, _e, w), ie = pe(Ae, _e, w - 1 / 3);
            }
            return { r: ee * 255, g: le * 255, b: ie * 255 };
          }
          function g(w, N, W) {
            w = Y(w, 255), N = Y(N, 255), W = Y(W, 255);
            var ee = s(w, N, W), le = r(w, N, W), ie, pe, _e = ee, Ae = ee - le;
            if (pe = ee === 0 ? 0 : Ae / ee, ee == le) ie = 0;
            else {
              switch (ee) {
                case w:
                  ie = (N - W) / Ae + (N < W ? 6 : 0);
                  break;
                case N:
                  ie = (W - w) / Ae + 2;
                  break;
                case W:
                  ie = (w - N) / Ae + 4;
                  break;
              }
              ie /= 6;
            }
            return { h: ie, s: pe, v: _e };
          }
          function x(w, N, W) {
            w = Y(w, 360) * 6, N = Y(N, 100), W = Y(W, 100);
            var ee = n.floor(w), le = w - ee, ie = W * (1 - N), pe = W * (1 - le * N), _e = W * (1 - (1 - le) * N), Ae = ee % 6, Ce = [W, pe, ie, ie, _e, W][Ae], Ue = [_e, W, W, pe, ie, ie][Ae], Ne = [ie, ie, _e, W, W, pe][Ae];
            return { r: Ce * 255, g: Ue * 255, b: Ne * 255 };
          }
          function h(w, N, W, ee) {
            var le = [ae(o(w).toString(16)), ae(o(N).toString(16)), ae(o(W).toString(16))];
            return ee && le[0].charAt(0) == le[0].charAt(1) && le[1].charAt(0) == le[1].charAt(1) && le[2].charAt(0) == le[2].charAt(1) ? le[0].charAt(0) + le[1].charAt(0) + le[2].charAt(0) : le.join("");
          }
          function m(w, N, W, ee, le) {
            var ie = [ae(o(w).toString(16)), ae(o(N).toString(16)), ae(o(W).toString(16)), ae(O(ee))];
            return le && ie[0].charAt(0) == ie[0].charAt(1) && ie[1].charAt(0) == ie[1].charAt(1) && ie[2].charAt(0) == ie[2].charAt(1) && ie[3].charAt(0) == ie[3].charAt(1) ? ie[0].charAt(0) + ie[1].charAt(0) + ie[2].charAt(0) + ie[3].charAt(0) : ie.join("");
          }
          function u(w, N, W, ee) {
            var le = [ae(O(ee)), ae(o(w).toString(16)), ae(o(N).toString(16)), ae(o(W).toString(16))];
            return le.join("");
          }
          t.equals = function(w, N) {
            return !w || !N ? !1 : t(w).toRgbString() == t(N).toRgbString();
          }, t.random = function() {
            return t.fromRatio({ r: c(), g: c(), b: c() });
          };
          function d(w, N) {
            N = N === 0 ? 0 : N || 10;
            var W = t(w).toHsl();
            return W.s -= N / 100, W.s = C(W.s), t(W);
          }
          function y(w, N) {
            N = N === 0 ? 0 : N || 10;
            var W = t(w).toHsl();
            return W.s += N / 100, W.s = C(W.s), t(W);
          }
          function _(w) {
            return t(w).desaturate(100);
          }
          function T(w, N) {
            N = N === 0 ? 0 : N || 10;
            var W = t(w).toHsl();
            return W.l += N / 100, W.l = C(W.l), t(W);
          }
          function R(w, N) {
            N = N === 0 ? 0 : N || 10;
            var W = t(w).toRgb();
            return W.r = s(0, r(255, W.r - o(255 * -(N / 100)))), W.g = s(0, r(255, W.g - o(255 * -(N / 100)))), W.b = s(0, r(255, W.b - o(255 * -(N / 100)))), t(W);
          }
          function I(w, N) {
            N = N === 0 ? 0 : N || 10;
            var W = t(w).toHsl();
            return W.l -= N / 100, W.l = C(W.l), t(W);
          }
          function P(w, N) {
            var W = t(w).toHsl(), ee = (W.h + N) % 360;
            return W.h = ee < 0 ? 360 + ee : ee, t(W);
          }
          function M(w) {
            var N = t(w).toHsl();
            return N.h = (N.h + 180) % 360, t(N);
          }
          function B(w) {
            var N = t(w).toHsl(), W = N.h;
            return [t(w), t({ h: (W + 120) % 360, s: N.s, l: N.l }), t({ h: (W + 240) % 360, s: N.s, l: N.l })];
          }
          function z(w) {
            var N = t(w).toHsl(), W = N.h;
            return [t(w), t({ h: (W + 90) % 360, s: N.s, l: N.l }), t({ h: (W + 180) % 360, s: N.s, l: N.l }), t({ h: (W + 270) % 360, s: N.s, l: N.l })];
          }
          function q(w) {
            var N = t(w).toHsl(), W = N.h;
            return [t(w), t({ h: (W + 72) % 360, s: N.s, l: N.l }), t({ h: (W + 216) % 360, s: N.s, l: N.l })];
          }
          function U(w, N, W) {
            N = N || 6, W = W || 30;
            var ee = t(w).toHsl(), le = 360 / W, ie = [t(w)];
            for (ee.h = (ee.h - (le * N >> 1) + 720) % 360; --N; ) ee.h = (ee.h + le) % 360, ie.push(t(ee));
            return ie;
          }
          function G(w, N) {
            N = N || 6;
            for (var W = t(w).toHsv(), ee = W.h, le = W.s, ie = W.v, pe = [], _e = 1 / N; N--; ) pe.push(t({ h: ee, s: le, v: ie })), ie = (ie + _e) % 1;
            return pe;
          }
          t.mix = function(w, N, W) {
            W = W === 0 ? 0 : W || 50;
            var ee = t(w).toRgb(), le = t(N).toRgb(), ie = W / 100, pe = { r: (le.r - ee.r) * ie + ee.r, g: (le.g - ee.g) * ie + ee.g, b: (le.b - ee.b) * ie + ee.b, a: (le.a - ee.a) * ie + ee.a };
            return t(pe);
          }, t.readability = function(w, N) {
            var W = t(w), ee = t(N);
            return (n.max(W.getLuminance(), ee.getLuminance()) + 0.05) / (n.min(W.getLuminance(), ee.getLuminance()) + 0.05);
          }, t.isReadable = function(w, N, W) {
            var ee = t.readability(w, N), le, ie;
            switch (ie = !1, le = E(W), le.level + le.size) {
              case "AAsmall":
              case "AAAlarge":
                ie = ee >= 4.5;
                break;
              case "AAlarge":
                ie = ee >= 3;
                break;
              case "AAAsmall":
                ie = ee >= 7;
                break;
            }
            return ie;
          }, t.mostReadable = function(w, N, W) {
            var ee = null, le = 0, ie, pe, _e, Ae;
            W = W || {}, pe = W.includeFallbackColors, _e = W.level, Ae = W.size;
            for (var Ce = 0; Ce < N.length; Ce++) ie = t.readability(w, N[Ce]), ie > le && (le = ie, ee = t(N[Ce]));
            return t.isReadable(w, ee, { level: _e, size: Ae }) || !pe ? ee : (W.includeFallbackColors = !1, t.mostReadable(w, ["#fff", "#000"], W));
          };
          var K = t.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }, te = t.hexNames = V(K);
          function V(w) {
            var N = {};
            for (var W in w) w.hasOwnProperty(W) && (N[w[W]] = W);
            return N;
          }
          function Z(w) {
            return w = parseFloat(w), (isNaN(w) || w < 0 || w > 1) && (w = 1), w;
          }
          function Y(w, N) {
            J(w) && (w = "100%");
            var W = ne(w);
            return w = r(N, s(0, parseFloat(w))), W && (w = parseInt(w * N, 10) / 100), n.abs(w - N) < 1e-6 ? 1 : w % N / parseFloat(N);
          }
          function C(w) {
            return r(1, s(0, w));
          }
          function j(w) {
            return parseInt(w, 16);
          }
          function J(w) {
            return typeof w == "string" && w.indexOf(".") != -1 && parseFloat(w) === 1;
          }
          function ne(w) {
            return typeof w == "string" && w.indexOf("%") != -1;
          }
          function ae(w) {
            return w.length == 1 ? "0" + w : "" + w;
          }
          function se(w) {
            return w <= 1 && (w = w * 100 + "%"), w;
          }
          function O(w) {
            return n.round(parseFloat(w) * 255).toString(16);
          }
          function F(w) {
            return j(w) / 255;
          }
          var S = function() {
            var w = "[-\\+]?\\d+%?", N = "[-\\+]?\\d*\\.\\d+%?", W = "(?:" + N + ")|(?:" + w + ")", ee = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?", le = "[\\s|\\(]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")[,|\\s]+(" + W + ")\\s*\\)?";
            return { CSS_UNIT: new RegExp(W), rgb: new RegExp("rgb" + ee), rgba: new RegExp("rgba" + le), hsl: new RegExp("hsl" + ee), hsla: new RegExp("hsla" + le), hsv: new RegExp("hsv" + ee), hsva: new RegExp("hsva" + le), hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ };
          }();
          function $(w) {
            return !!S.CSS_UNIT.exec(w);
          }
          function re(w) {
            w = w.replace(e, "").replace(a, "").toLowerCase();
            var N = !1;
            if (K[w]) w = K[w], N = !0;
            else if (w == "transparent") return { r: 0, g: 0, b: 0, a: 0, format: "name" };
            var W;
            return (W = S.rgb.exec(w)) ? { r: W[1], g: W[2], b: W[3] } : (W = S.rgba.exec(w)) ? { r: W[1], g: W[2], b: W[3], a: W[4] } : (W = S.hsl.exec(w)) ? { h: W[1], s: W[2], l: W[3] } : (W = S.hsla.exec(w)) ? { h: W[1], s: W[2], l: W[3], a: W[4] } : (W = S.hsv.exec(w)) ? { h: W[1], s: W[2], v: W[3] } : (W = S.hsva.exec(w)) ? { h: W[1], s: W[2], v: W[3], a: W[4] } : (W = S.hex8.exec(w)) ? { r: j(W[1]), g: j(W[2]), b: j(W[3]), a: F(W[4]), format: N ? "name" : "hex8" } : (W = S.hex6.exec(w)) ? { r: j(W[1]), g: j(W[2]), b: j(W[3]), format: N ? "name" : "hex" } : (W = S.hex4.exec(w)) ? { r: j(W[1] + "" + W[1]), g: j(W[2] + "" + W[2]), b: j(W[3] + "" + W[3]), a: F(W[4] + "" + W[4]), format: N ? "name" : "hex8" } : (W = S.hex3.exec(w)) ? { r: j(W[1] + "" + W[1]), g: j(W[2] + "" + W[2]), b: j(W[3] + "" + W[3]), format: N ? "name" : "hex" } : !1;
          }
          function E(w) {
            var N, W;
            return w = w || { level: "AA", size: "small" }, N = (w.level || "AA").toUpperCase(), W = (w.size || "small").toLowerCase(), N !== "AA" && N !== "AAA" && (N = "AA"), W !== "small" && W !== "large" && (W = "small"), { level: N, size: W };
          }
          typeof k < "u" && k.exports ? k.exports = t : window.tinycolor = t;
        })(Math);
      }), Br = xe((L) => {
        var k = ka(), n = Array.isArray;
        function e(i, o) {
          var r, s;
          for (r = 0; r < i.length; r++) {
            if (s = i[r], s !== null && typeof s == "object") return !1;
            s !== void 0 && (o[r] = s);
          }
          return !0;
        }
        L.extendFlat = function() {
          return a(arguments, !1, !1, !1);
        }, L.extendDeep = function() {
          return a(arguments, !0, !1, !1);
        }, L.extendDeepAll = function() {
          return a(arguments, !0, !0, !1);
        }, L.extendDeepNoArrays = function() {
          return a(arguments, !0, !1, !0);
        };
        function a(i, o, r, s) {
          var c = i[0], t = i.length, p, l, f, v, g, x, h;
          if (t === 2 && n(c) && n(i[1]) && c.length === 0) {
            if (h = e(i[1], c), h) return c;
            c.splice(0, c.length);
          }
          for (var m = 1; m < t; m++) {
            p = i[m];
            for (l in p) f = c[l], v = p[l], s && n(v) ? c[l] = v : o && v && (k(v) || (g = n(v))) ? (g ? (g = !1, x = f && n(f) ? f : []) : x = f && k(f) ? f : {}, c[l] = a([x, v], o, r, s)) : (typeof v < "u" || r) && (c[l] = v);
          }
          return c;
        }
      }), hn = xe((L, k) => {
        k.exports = function(n) {
          var e = n.variantValues, a = n.editType, i = n.colorEditType;
          i === void 0 && (i = a);
          var o = { editType: a, valType: "integer", min: 1, max: 1e3, extras: ["normal", "bold"], dflt: "normal" };
          n.noNumericWeightValues && (o.valType = "enumerated", o.values = o.extras, o.extras = void 0, o.min = void 0, o.max = void 0);
          var r = { family: { valType: "string", noBlank: !0, strict: !0, editType: a }, size: { valType: "number", min: 1, editType: a }, color: { valType: "color", editType: i }, weight: o, style: { editType: a, valType: "enumerated", values: ["normal", "italic"], dflt: "normal" }, variant: n.noFontVariant ? void 0 : { editType: a, valType: "enumerated", values: e || ["normal", "small-caps", "all-small-caps", "all-petite-caps", "petite-caps", "unicase"], dflt: "normal" }, textcase: n.noFontTextcase ? void 0 : { editType: a, valType: "enumerated", values: ["normal", "word caps", "upper", "lower"], dflt: "normal" }, lineposition: n.noFontLineposition ? void 0 : { editType: a, valType: "flaglist", flags: ["under", "over", "through"], extras: ["none"], dflt: "none" }, shadow: n.noFontShadow ? void 0 : { editType: a, valType: "string", dflt: n.autoShadowDflt ? "auto" : "none" }, editType: a };
          return n.autoSize && (r.size.dflt = "auto"), n.autoColor && (r.color.dflt = "auto"), n.arrayOk && (r.family.arrayOk = !0, r.weight.arrayOk = !0, r.style.arrayOk = !0, n.noFontVariant || (r.variant.arrayOk = !0), n.noFontTextcase || (r.textcase.arrayOk = !0), n.noFontLineposition || (r.lineposition.arrayOk = !0), n.noFontShadow || (r.shadow.arrayOk = !0), r.size.arrayOk = !0, r.color.arrayOk = !0), r;
        };
      }), bi = xe((L, k) => {
        k.exports = { YANGLE: 60, HOVERARROWSIZE: 6, HOVERTEXTPAD: 3, HOVERFONTSIZE: 13, HOVERFONT: "Arial, sans-serif", HOVERMINTIME: 50, HOVERID: "-hover" };
      }), Ja = xe((L, k) => {
        var n = bi(), e = hn(), a = e({ editType: "none" });
        a.family.dflt = n.HOVERFONT, a.size.dflt = n.HOVERFONTSIZE, k.exports = { clickmode: { valType: "flaglist", flags: ["event", "select"], dflt: "event", editType: "plot", extras: ["none"] }, dragmode: { valType: "enumerated", values: ["zoom", "pan", "select", "lasso", "drawclosedpath", "drawopenpath", "drawline", "drawrect", "drawcircle", "orbit", "turntable", !1], dflt: "zoom", editType: "modebar" }, hovermode: { valType: "enumerated", values: ["x", "y", "closest", !1, "x unified", "y unified"], dflt: "closest", editType: "modebar" }, hoversubplots: { valType: "enumerated", values: ["single", "overlaying", "axis"], dflt: "overlaying", editType: "none" }, hoverdistance: { valType: "integer", min: -1, dflt: 20, editType: "none" }, spikedistance: { valType: "integer", min: -1, dflt: -1, editType: "none" }, hoverlabel: { bgcolor: { valType: "color", editType: "none" }, bordercolor: { valType: "color", editType: "none" }, font: a, grouptitlefont: e({ editType: "none" }), align: { valType: "enumerated", values: ["left", "right", "auto"], dflt: "auto", editType: "none" }, namelength: { valType: "integer", min: -1, dflt: 15, editType: "none" }, showarrow: { valType: "boolean", dflt: !0, editType: "none" }, editType: "none" }, selectdirection: { valType: "enumerated", values: ["h", "v", "d", "any"], dflt: "any", editType: "none" } };
      }), lo = xe((L, k) => {
        var n = hn(), e = Ja().hoverlabel, a = Br().extendFlat;
        k.exports = { hoverlabel: { bgcolor: a({}, e.bgcolor, { arrayOk: !0 }), bordercolor: a({}, e.bordercolor, { arrayOk: !0 }), font: n({ arrayOk: !0, editType: "none" }), align: a({}, e.align, { arrayOk: !0 }), namelength: a({}, e.namelength, { arrayOk: !0 }), showarrow: a({}, e.showarrow), editType: "none" } };
      }), Pn = xe((L, k) => {
        var n = hn(), e = lo();
        k.exports = { type: { valType: "enumerated", values: [], dflt: "scatter", editType: "calc+clearAxisTypes", _noTemplating: !0 }, visible: { valType: "enumerated", values: [!0, !1, "legendonly"], dflt: !0, editType: "calc" }, showlegend: { valType: "boolean", dflt: !0, editType: "style" }, legend: { valType: "subplotid", dflt: "legend", editType: "style" }, legendgroup: { valType: "string", dflt: "", editType: "style" }, legendgrouptitle: { text: { valType: "string", dflt: "", editType: "style" }, font: n({ editType: "style" }), editType: "style" }, legendrank: { valType: "number", dflt: 1e3, editType: "style" }, legendwidth: { valType: "number", min: 0, editType: "style" }, opacity: { valType: "number", min: 0, max: 1, dflt: 1, editType: "style" }, name: { valType: "string", editType: "style" }, uid: { valType: "string", editType: "plot", anim: !0 }, ids: { valType: "data_array", editType: "calc", anim: !0 }, customdata: { valType: "data_array", editType: "calc" }, meta: { valType: "any", arrayOk: !0, editType: "plot" }, selectedpoints: { valType: "any", editType: "calc" }, hoverinfo: { valType: "flaglist", flags: ["x", "y", "z", "text", "name"], extras: ["all", "none", "skip"], arrayOk: !0, dflt: "all", editType: "none" }, hoverlabel: e.hoverlabel, stream: { token: { valType: "string", noBlank: !0, strict: !0, editType: "calc" }, maxpoints: { valType: "number", min: 0, max: 1e4, dflt: 500, editType: "calc" }, editType: "calc" }, uirevision: { valType: "any", editType: "none" } };
      }), Pa = xe((L, k) => {
        var n = Nn(), e = { Greys: [[0, "rgb(0,0,0)"], [1, "rgb(255,255,255)"]], YlGnBu: [[0, "rgb(8,29,88)"], [0.125, "rgb(37,52,148)"], [0.25, "rgb(34,94,168)"], [0.375, "rgb(29,145,192)"], [0.5, "rgb(65,182,196)"], [0.625, "rgb(127,205,187)"], [0.75, "rgb(199,233,180)"], [0.875, "rgb(237,248,217)"], [1, "rgb(255,255,217)"]], Greens: [[0, "rgb(0,68,27)"], [0.125, "rgb(0,109,44)"], [0.25, "rgb(35,139,69)"], [0.375, "rgb(65,171,93)"], [0.5, "rgb(116,196,118)"], [0.625, "rgb(161,217,155)"], [0.75, "rgb(199,233,192)"], [0.875, "rgb(229,245,224)"], [1, "rgb(247,252,245)"]], YlOrRd: [[0, "rgb(128,0,38)"], [0.125, "rgb(189,0,38)"], [0.25, "rgb(227,26,28)"], [0.375, "rgb(252,78,42)"], [0.5, "rgb(253,141,60)"], [0.625, "rgb(254,178,76)"], [0.75, "rgb(254,217,118)"], [0.875, "rgb(255,237,160)"], [1, "rgb(255,255,204)"]], Bluered: [[0, "rgb(0,0,255)"], [1, "rgb(255,0,0)"]], RdBu: [[0, "rgb(5,10,172)"], [0.35, "rgb(106,137,247)"], [0.5, "rgb(190,190,190)"], [0.6, "rgb(220,170,132)"], [0.7, "rgb(230,145,90)"], [1, "rgb(178,10,28)"]], Reds: [[0, "rgb(220,220,220)"], [0.2, "rgb(245,195,157)"], [0.4, "rgb(245,160,105)"], [1, "rgb(178,10,28)"]], Blues: [[0, "rgb(5,10,172)"], [0.35, "rgb(40,60,190)"], [0.5, "rgb(70,100,245)"], [0.6, "rgb(90,120,245)"], [0.7, "rgb(106,137,247)"], [1, "rgb(220,220,220)"]], Picnic: [[0, "rgb(0,0,255)"], [0.1, "rgb(51,153,255)"], [0.2, "rgb(102,204,255)"], [0.3, "rgb(153,204,255)"], [0.4, "rgb(204,204,255)"], [0.5, "rgb(255,255,255)"], [0.6, "rgb(255,204,255)"], [0.7, "rgb(255,153,255)"], [0.8, "rgb(255,102,204)"], [0.9, "rgb(255,102,102)"], [1, "rgb(255,0,0)"]], Rainbow: [[0, "rgb(150,0,90)"], [0.125, "rgb(0,0,200)"], [0.25, "rgb(0,25,255)"], [0.375, "rgb(0,152,255)"], [0.5, "rgb(44,255,150)"], [0.625, "rgb(151,255,0)"], [0.75, "rgb(255,234,0)"], [0.875, "rgb(255,111,0)"], [1, "rgb(255,0,0)"]], Portland: [[0, "rgb(12,51,131)"], [0.25, "rgb(10,136,186)"], [0.5, "rgb(242,211,56)"], [0.75, "rgb(242,143,56)"], [1, "rgb(217,30,30)"]], Jet: [[0, "rgb(0,0,131)"], [0.125, "rgb(0,60,170)"], [0.375, "rgb(5,255,255)"], [0.625, "rgb(255,255,0)"], [0.875, "rgb(250,0,0)"], [1, "rgb(128,0,0)"]], Hot: [[0, "rgb(0,0,0)"], [0.3, "rgb(230,0,0)"], [0.6, "rgb(255,210,0)"], [1, "rgb(255,255,255)"]], Blackbody: [[0, "rgb(0,0,0)"], [0.2, "rgb(230,0,0)"], [0.4, "rgb(230,210,0)"], [0.7, "rgb(255,255,255)"], [1, "rgb(160,200,255)"]], Earth: [[0, "rgb(0,0,130)"], [0.1, "rgb(0,180,180)"], [0.2, "rgb(40,210,40)"], [0.4, "rgb(230,230,50)"], [0.6, "rgb(120,70,20)"], [1, "rgb(255,255,255)"]], Electric: [[0, "rgb(0,0,0)"], [0.15, "rgb(30,0,100)"], [0.4, "rgb(120,0,100)"], [0.6, "rgb(160,90,0)"], [0.8, "rgb(230,200,0)"], [1, "rgb(255,250,220)"]], Viridis: [[0, "#440154"], [0.06274509803921569, "#48186a"], [0.12549019607843137, "#472d7b"], [0.18823529411764706, "#424086"], [0.25098039215686274, "#3b528b"], [0.3137254901960784, "#33638d"], [0.3764705882352941, "#2c728e"], [0.4392156862745098, "#26828e"], [0.5019607843137255, "#21918c"], [0.5647058823529412, "#1fa088"], [0.6274509803921569, "#28ae80"], [0.6901960784313725, "#3fbc73"], [0.7529411764705882, "#5ec962"], [0.8156862745098039, "#84d44b"], [0.8784313725490196, "#addc30"], [0.9411764705882353, "#d8e219"], [1, "#fde725"]], Cividis: [[0, "rgb(0,32,76)"], [0.058824, "rgb(0,42,102)"], [0.117647, "rgb(0,52,110)"], [0.176471, "rgb(39,63,108)"], [0.235294, "rgb(60,74,107)"], [0.294118, "rgb(76,85,107)"], [0.352941, "rgb(91,95,109)"], [0.411765, "rgb(104,106,112)"], [0.470588, "rgb(117,117,117)"], [0.529412, "rgb(131,129,120)"], [0.588235, "rgb(146,140,120)"], [0.647059, "rgb(161,152,118)"], [0.705882, "rgb(176,165,114)"], [0.764706, "rgb(192,177,109)"], [0.823529, "rgb(209,191,102)"], [0.882353, "rgb(225,204,92)"], [0.941176, "rgb(243,219,79)"], [1, "rgb(255,233,69)"]] }, a = e.RdBu;
        function i(s, c) {
          if (c || (c = a), !s) return c;
          function t() {
            try {
              s = e[s] || JSON.parse(s);
            } catch {
              s = c;
            }
          }
          return typeof s == "string" && (t(), typeof s == "string" && t()), o(s) ? s : c;
        }
        function o(s) {
          var c = 0;
          if (!Array.isArray(s) || s.length < 2 || !s[0] || !s[s.length - 1] || +s[0][0] != 0 || +s[s.length - 1][0] != 1) return !1;
          for (var t = 0; t < s.length; t++) {
            var p = s[t];
            if (p.length !== 2 || +p[0] < c || !n(p[1]).isValid()) return !1;
            c = +p[0];
          }
          return !0;
        }
        function r(s) {
          return e[s] !== void 0 ? !0 : o(s);
        }
        k.exports = { scales: e, defaultScale: a, get: i, isValid: r };
      }), Zn = xe((L) => {
        L.defaults = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"], L.defaultLine = "#444", L.lightLine = "#eee", L.background = "#fff", L.borderLine = "#BEC8D9", L.lightFraction = 100 * 10 / 11;
      }), fr = xe((L, k) => {
        var n = Nn(), e = xr(), a = Hn().isTypedArray, i = k.exports = {}, o = Zn();
        i.defaults = o.defaults;
        var r = i.defaultLine = o.defaultLine;
        i.lightLine = o.lightLine;
        var s = i.background = o.background;
        i.tinyRGB = function(t) {
          var p = t.toRgb();
          return "rgb(" + Math.round(p.r) + ", " + Math.round(p.g) + ", " + Math.round(p.b) + ")";
        }, i.rgb = function(t) {
          return i.tinyRGB(n(t));
        }, i.opacity = function(t) {
          return t ? n(t).getAlpha() : 0;
        }, i.addOpacity = function(t, p) {
          var l = n(t).toRgb();
          return "rgba(" + Math.round(l.r) + ", " + Math.round(l.g) + ", " + Math.round(l.b) + ", " + p + ")";
        }, i.combine = function(t, p) {
          var l = n(t).toRgb();
          if (l.a === 1) return n(t).toRgbString();
          var f = n(p || s).toRgb(), v = f.a === 1 ? f : { r: 255 * (1 - f.a) + f.r * f.a, g: 255 * (1 - f.a) + f.g * f.a, b: 255 * (1 - f.a) + f.b * f.a }, g = { r: v.r * (1 - l.a) + l.r * l.a, g: v.g * (1 - l.a) + l.g * l.a, b: v.b * (1 - l.a) + l.b * l.a };
          return n(g).toRgbString();
        }, i.interpolate = function(t, p, l) {
          var f = n(t).toRgb(), v = n(p).toRgb(), g = { r: l * f.r + (1 - l) * v.r, g: l * f.g + (1 - l) * v.g, b: l * f.b + (1 - l) * v.b };
          return n(g).toRgbString();
        }, i.contrast = function(t, p, l) {
          var f = n(t);
          f.getAlpha() !== 1 && (f = n(i.combine(t, s)));
          var v = f.isDark() ? p ? f.lighten(p) : s : l ? f.darken(l) : r;
          return v.toString();
        }, i.stroke = function(t, p) {
          var l = n(p);
          t.style({ stroke: i.tinyRGB(l), "stroke-opacity": l.getAlpha() });
        }, i.fill = function(t, p) {
          var l = n(p);
          t.style({ fill: i.tinyRGB(l), "fill-opacity": l.getAlpha() });
        }, i.clean = function(t) {
          if (!(!t || typeof t != "object")) {
            var p = Object.keys(t), l, f, v, g;
            for (l = 0; l < p.length; l++) if (v = p[l], g = t[v], v.substr(v.length - 5) === "color") if (Array.isArray(g)) for (f = 0; f < g.length; f++) g[f] = c(g[f]);
            else t[v] = c(g);
            else if (v.substr(v.length - 10) === "colorscale" && Array.isArray(g)) for (f = 0; f < g.length; f++) Array.isArray(g[f]) && (g[f][1] = c(g[f][1]));
            else if (Array.isArray(g)) {
              var x = g[0];
              if (!Array.isArray(x) && x && typeof x == "object") for (f = 0; f < g.length; f++) i.clean(g[f]);
            } else g && typeof g == "object" && !a(g) && i.clean(g);
          }
        };
        function c(t) {
          if (e(t) || typeof t != "string") return t;
          var p = t.trim();
          if (p.substr(0, 3) !== "rgb") return t;
          var l = p.match(/^rgba?\s*\(([^()]*)\)$/);
          if (!l) return t;
          var f = l[1].trim().split(/\s*[\s,]\s*/), v = p.charAt(3) === "a" && f.length === 4;
          if (!v && f.length !== 3) return t;
          for (var g = 0; g < f.length; g++) {
            if (!f[g].length || (f[g] = Number(f[g]), !(f[g] >= 0))) return t;
            if (g === 3) f[g] > 1 && (f[g] = 1);
            else if (f[g] >= 1) return t;
          }
          var x = Math.round(f[0] * 255) + ", " + Math.round(f[1] * 255) + ", " + Math.round(f[2] * 255);
          return v ? "rgba(" + x + ", " + f[3] + ")" : "rgb(" + x + ")";
        }
      }), so = xe((L, k) => {
        k.exports = { SHOW_PLACEHOLDER: 100, HIDE_PLACEHOLDER: 1e3, DESELECTDIM: 0.2 };
      }), $a = xe((L) => {
        L.counter = function(k, n, e, a) {
          var i = (n || "") + (e ? "" : "$"), o = a === !1 ? "" : "^";
          return k === "xy" ? new RegExp(o + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(o + k + "([2-9]|[1-9][0-9]+)?" + i);
        };
      }), kf = xe((L) => {
        var k = xr(), n = Nn(), e = Br().extendFlat, a = Pn(), i = Pa(), o = fr(), r = so().DESELECTDIM, s = io(), c = $a().counter, t = Xa().modHalf, p = Hn().isArrayOrTypedArray, l = Hn().isTypedArraySpec, f = Hn().decodeTypedArraySpec;
        L.valObjectMeta = { data_array: { coerceFunction: function(g, x, h) {
          x.set(p(g) ? g : l(g) ? f(g) : h);
        } }, enumerated: { coerceFunction: function(g, x, h, m) {
          m.coerceNumber && (g = +g), m.values.indexOf(g) === -1 ? x.set(h) : x.set(g);
        }, validateFunction: function(g, x) {
          x.coerceNumber && (g = +g);
          for (var h = x.values, m = 0; m < h.length; m++) {
            var u = String(h[m]);
            if (u.charAt(0) === "/" && u.charAt(u.length - 1) === "/") {
              var d = new RegExp(u.substr(1, u.length - 2));
              if (d.test(g)) return !0;
            } else if (g === h[m]) return !0;
          }
          return !1;
        } }, boolean: { coerceFunction: function(g, x, h) {
          g === !0 || g === !1 ? x.set(g) : x.set(h);
        } }, number: { coerceFunction: function(g, x, h, m) {
          l(g) && (g = f(g)), !k(g) || m.min !== void 0 && g < m.min || m.max !== void 0 && g > m.max ? x.set(h) : x.set(+g);
        } }, integer: { coerceFunction: function(g, x, h, m) {
          if ((m.extras || []).indexOf(g) !== -1) {
            x.set(g);
            return;
          }
          l(g) && (g = f(g)), g % 1 || !k(g) || m.min !== void 0 && g < m.min || m.max !== void 0 && g > m.max ? x.set(h) : x.set(+g);
        } }, string: { coerceFunction: function(g, x, h, m) {
          if (typeof g != "string") {
            var u = typeof g == "number";
            m.strict === !0 || !u ? x.set(h) : x.set(String(g));
          } else m.noBlank && !g ? x.set(h) : x.set(g);
        } }, color: { coerceFunction: function(g, x, h) {
          l(g) && (g = f(g)), n(g).isValid() ? x.set(g) : x.set(h);
        } }, colorlist: { coerceFunction: function(g, x, h) {
          function m(u) {
            return n(u).isValid();
          }
          !Array.isArray(g) || !g.length ? x.set(h) : g.every(m) ? x.set(g) : x.set(h);
        } }, colorscale: { coerceFunction: function(g, x, h) {
          x.set(i.get(g, h));
        } }, angle: { coerceFunction: function(g, x, h) {
          l(g) && (g = f(g)), g === "auto" ? x.set("auto") : k(g) ? x.set(t(+g, 360)) : x.set(h);
        } }, subplotid: { coerceFunction: function(g, x, h, m) {
          var u = m.regex || c(h);
          if (typeof g == "string" && u.test(g)) {
            x.set(g);
            return;
          }
          x.set(h);
        }, validateFunction: function(g, x) {
          var h = x.dflt;
          return g === h ? !0 : typeof g != "string" ? !1 : !!c(h).test(g);
        } }, flaglist: { coerceFunction: function(g, x, h, m) {
          if ((m.extras || []).indexOf(g) !== -1) {
            x.set(g);
            return;
          }
          if (typeof g != "string") {
            x.set(h);
            return;
          }
          for (var u = g.split("+"), d = 0; d < u.length; ) {
            var y = u[d];
            m.flags.indexOf(y) === -1 || u.indexOf(y) < d ? u.splice(d, 1) : d++;
          }
          u.length ? x.set(u.join("+")) : x.set(h);
        } }, any: { coerceFunction: function(g, x, h) {
          g === void 0 ? x.set(h) : x.set(l(g) ? f(g) : g);
        } }, info_array: { coerceFunction: function(g, x, h, m) {
          function u(K, te, V) {
            var Z, Y = { set: function(C) {
              Z = C;
            } };
            return V === void 0 && (V = te.dflt), L.valObjectMeta[te.valType].coerceFunction(K, Y, V, te), Z;
          }
          if (l(g) && (g = f(g)), !p(g)) {
            x.set(h);
            return;
          }
          var d = m.dimensions === 2 || m.dimensions === "1-2" && Array.isArray(g) && p(g[0]), y = m.items, _ = [], T = Array.isArray(y), R = T && d && p(y[0]), I = d && T && !R, P = T && !I ? y.length : g.length, M, B, z, q, U, G;
          if (h = Array.isArray(h) ? h : [], d) for (M = 0; M < P; M++) for (_[M] = [], z = p(g[M]) ? g[M] : [], I ? U = y.length : T ? U = y[M].length : U = z.length, B = 0; B < U; B++) I ? q = y[B] : T ? q = y[M][B] : q = y, G = u(z[B], q, (h[M] || [])[B]), G !== void 0 && (_[M][B] = G);
          else for (M = 0; M < P; M++) G = u(g[M], T ? y[M] : y, h[M]), G !== void 0 && (_[M] = G);
          x.set(_);
        }, validateFunction: function(g, x) {
          if (!p(g)) return !1;
          var h = x.items, m = Array.isArray(h), u = x.dimensions === 2;
          if (!x.freeLength && g.length !== h.length) return !1;
          for (var d = 0; d < g.length; d++) if (u) {
            if (!p(g[d]) || !x.freeLength && g[d].length !== h[d].length) return !1;
            for (var y = 0; y < g[d].length; y++) if (!v(g[d][y], m ? h[d][y] : h)) return !1;
          } else if (!v(g[d], m ? h[d] : h)) return !1;
          return !0;
        } } }, L.coerce = function(g, x, h, m, u) {
          var d = s(h, m).get(), y = s(g, m), _ = s(x, m), T = y.get(), R = x._template;
          if (T === void 0 && R && (T = s(R, m).get(), R = 0), u === void 0 && (u = d.dflt), d.arrayOk) {
            if (p(T)) return _.set(T), T;
            if (l(T)) return T = f(T), _.set(T), T;
          }
          var I = L.valObjectMeta[d.valType].coerceFunction;
          I(T, _, u, d);
          var P = _.get();
          return R && P === u && !v(T, d) && (T = s(R, m).get(), I(T, _, u, d), P = _.get()), P;
        }, L.coerce2 = function(g, x, h, m, u) {
          var d = s(g, m), y = L.coerce(g, x, h, m, u), _ = d.get();
          return _ != null ? y : !1;
        }, L.coerceFont = function(g, x, h, m) {
          m || (m = {}), h = e({}, h), h = e(h, m.overrideDflt || {});
          var u = { family: g(x + ".family", h.family), size: g(x + ".size", h.size), color: g(x + ".color", h.color), weight: g(x + ".weight", h.weight), style: g(x + ".style", h.style) };
          if (m.noFontVariant || (u.variant = g(x + ".variant", h.variant)), m.noFontLineposition || (u.lineposition = g(x + ".lineposition", h.lineposition)), m.noFontTextcase || (u.textcase = g(x + ".textcase", h.textcase)), !m.noFontShadow) {
            var d = h.shadow;
            d === "none" && m.autoShadowDflt && (d = "auto"), u.shadow = g(x + ".shadow", d);
          }
          return u;
        }, L.coercePattern = function(g, x, h, m) {
          var u = g(x + ".shape"), d;
          if (u || (d = g(x + ".path")), u || d) {
            u && g(x + ".solidity"), g(x + ".size");
            var y = g(x + ".fillmode"), _ = y === "overlay";
            if (!m) {
              var T = g(x + ".bgcolor", _ ? h : void 0);
              g(x + ".fgcolor", _ ? o.contrast(T) : h);
            }
            g(x + ".fgopacity", _ ? 0.5 : 1);
          }
        }, L.coerceHoverinfo = function(g, x, h) {
          var m = x._module.attributes, u = m.hoverinfo ? m : a, d = u.hoverinfo, y;
          if (h._dataLength === 1) {
            var _ = d.dflt === "all" ? d.flags.slice() : d.dflt.split("+");
            _.splice(_.indexOf("name"), 1), y = _.join("+");
          }
          return L.coerce(g, x, u, "hoverinfo", y);
        }, L.coerceSelectionMarkerOpacity = function(g, x) {
          if (g.marker) {
            var h = g.marker.opacity;
            if (h !== void 0) {
              var m, u;
              !p(h) && !g.selected && !g.unselected && (m = h, u = r * h), x("selected.marker.opacity", m), x("unselected.marker.opacity", u);
            }
          }
        };
        function v(g, x) {
          var h = L.valObjectMeta[x.valType];
          if (x.arrayOk && p(g)) return !0;
          if (h.validateFunction) return h.validateFunction(g, x);
          var m = {}, u = m, d = { set: function(y) {
            u = y;
          } };
          return h.coerceFunction(g, d, m, x), u !== m;
        }
        L.validate = v;
      }), Ia = xe((L, k) => {
        var n = { staticPlot: { valType: "boolean", dflt: !1 }, typesetMath: { valType: "boolean", dflt: !0 }, plotlyServerURL: { valType: "string", dflt: "" }, editable: { valType: "boolean", dflt: !1 }, edits: { annotationPosition: { valType: "boolean", dflt: !1 }, annotationTail: { valType: "boolean", dflt: !1 }, annotationText: { valType: "boolean", dflt: !1 }, axisTitleText: { valType: "boolean", dflt: !1 }, colorbarPosition: { valType: "boolean", dflt: !1 }, colorbarTitleText: { valType: "boolean", dflt: !1 }, legendPosition: { valType: "boolean", dflt: !1 }, legendText: { valType: "boolean", dflt: !1 }, shapePosition: { valType: "boolean", dflt: !1 }, titleText: { valType: "boolean", dflt: !1 } }, editSelection: { valType: "boolean", dflt: !0 }, autosizable: { valType: "boolean", dflt: !1 }, responsive: { valType: "boolean", dflt: !1 }, fillFrame: { valType: "boolean", dflt: !1 }, frameMargins: { valType: "number", dflt: 0, min: 0, max: 0.5 }, scrollZoom: { valType: "flaglist", flags: ["cartesian", "gl3d", "geo", "mapbox", "map"], extras: [!0, !1], dflt: "gl3d+geo+map" }, doubleClick: { valType: "enumerated", values: [!1, "reset", "autosize", "reset+autosize"], dflt: "reset+autosize" }, doubleClickDelay: { valType: "number", dflt: 300, min: 0 }, showAxisDragHandles: { valType: "boolean", dflt: !0 }, showAxisRangeEntryBoxes: { valType: "boolean", dflt: !0 }, showTips: { valType: "boolean", dflt: !0 }, showLink: { valType: "boolean", dflt: !1 }, linkText: { valType: "string", dflt: "Edit chart", noBlank: !0 }, sendData: { valType: "boolean", dflt: !0 }, showSources: { valType: "any", dflt: !1 }, displayModeBar: { valType: "enumerated", values: ["hover", !0, !1], dflt: "hover" }, showSendToCloud: { valType: "boolean", dflt: !1 }, showEditInChartStudio: { valType: "boolean", dflt: !1 }, modeBarButtonsToRemove: { valType: "any", dflt: [] }, modeBarButtonsToAdd: { valType: "any", dflt: [] }, modeBarButtons: { valType: "any", dflt: !1 }, toImageButtonOptions: { valType: "any", dflt: {} }, displaylogo: { valType: "boolean", dflt: !0 }, watermark: { valType: "boolean", dflt: !1 }, plotGlPixelRatio: { valType: "number", dflt: 2, min: 1, max: 4 }, setBackground: { valType: "any", dflt: "transparent" }, topojsonURL: { valType: "string", noBlank: !0, dflt: "https://cdn.plot.ly/un/" }, mapboxAccessToken: { valType: "string", dflt: null }, logging: { valType: "integer", min: 0, max: 2, dflt: 1 }, notifyOnLogging: { valType: "integer", min: 0, max: 2, dflt: 0 }, queueLength: { valType: "integer", min: 0, dflt: 0 }, locale: { valType: "string", dflt: "en-US" }, locales: { valType: "any", dflt: {} } }, e = {};
        function a(i, o) {
          for (var r in i) {
            var s = i[r];
            s.valType ? o[r] = s.dflt : (o[r] || (o[r] = {}), a(s, o[r]));
          }
        }
        a(n, e), k.exports = { configAttributes: n, dfltConfig: e };
      }), Yl = xe((L, k) => {
        var n = vr(), e = xr(), a = [];
        k.exports = function(i, o) {
          if (a.indexOf(i) !== -1) return;
          a.push(i);
          var r = 1e3;
          e(o) ? r = o : o === "long" && (r = 3e3);
          var s = n.select("body").selectAll(".plotly-notifier").data([0]);
          s.enter().append("div").classed("plotly-notifier", !0);
          var c = s.selectAll(".notifier-note").data(a);
          function t(p) {
            p.duration(700).style("opacity", 0).each("end", function(l) {
              var f = a.indexOf(l);
              f !== -1 && a.splice(f, 1), n.select(this).remove();
            });
          }
          c.enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function(p) {
            var l = n.select(this);
            l.append("button").classed("notifier-close", !0).html("&times;").on("click", function() {
              l.transition().call(t);
            });
            for (var f = l.append("p"), v = p.split(/<br\s*\/?>/g), g = 0; g < v.length; g++) g && f.append("br"), f.append("span").text(v[g]);
            o === "stick" ? l.transition().duration(350).style("opacity", 1) : l.transition().duration(700).style("opacity", 1).transition().delay(r).call(t);
          });
        };
      }), za = xe((L, k) => {
        var n = Ia().dfltConfig, e = Yl(), a = k.exports = {};
        a.log = function() {
          var i;
          if (n.logging > 1) {
            var o = ["LOG:"];
            for (i = 0; i < arguments.length; i++) o.push(arguments[i]);
            console.trace.apply(console, o);
          }
          if (n.notifyOnLogging > 1) {
            var r = [];
            for (i = 0; i < arguments.length; i++) r.push(arguments[i]);
            e(r.join("<br>"), "long");
          }
        }, a.warn = function() {
          var i;
          if (n.logging > 0) {
            var o = ["WARN:"];
            for (i = 0; i < arguments.length; i++) o.push(arguments[i]);
            console.trace.apply(console, o);
          }
          if (n.notifyOnLogging > 0) {
            var r = [];
            for (i = 0; i < arguments.length; i++) r.push(arguments[i]);
            e(r.join("<br>"), "stick");
          }
        }, a.error = function() {
          var i;
          if (n.logging > 0) {
            var o = ["ERROR:"];
            for (i = 0; i < arguments.length; i++) o.push(arguments[i]);
            console.error.apply(console, o);
          }
          if (n.notifyOnLogging > 0) {
            var r = [];
            for (i = 0; i < arguments.length; i++) r.push(arguments[i]);
            e(r.join("<br>"), "stick");
          }
        };
      }), uo = xe((L, k) => {
        k.exports = function() {
        };
      }), Gl = xe((L, k) => {
        k.exports = function(n, e) {
          if (e instanceof RegExp) {
            for (var a = e.toString(), i = 0; i < n.length; i++) if (n[i] instanceof RegExp && n[i].toString() === a) return n;
            n.push(e);
          } else (e || e === 0) && n.indexOf(e) === -1 && n.push(e);
          return n;
        };
      }), Mf = xe((L, k) => {
        k.exports = n;
        function n() {
          var e = new Float32Array(16);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Af = xe((L, k) => {
        k.exports = n;
        function n(e) {
          var a = new Float32Array(16);
          return a[0] = e[0], a[1] = e[1], a[2] = e[2], a[3] = e[3], a[4] = e[4], a[5] = e[5], a[6] = e[6], a[7] = e[7], a[8] = e[8], a[9] = e[9], a[10] = e[10], a[11] = e[11], a[12] = e[12], a[13] = e[13], a[14] = e[14], a[15] = e[15], a;
        }
      }), Sf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          return e[0] = a[0], e[1] = a[1], e[2] = a[2], e[3] = a[3], e[4] = a[4], e[5] = a[5], e[6] = a[6], e[7] = a[7], e[8] = a[8], e[9] = a[9], e[10] = a[10], e[11] = a[11], e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15], e;
        }
      }), Zl = xe((L, k) => {
        k.exports = n;
        function n(e) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Lf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          if (e === a) {
            var i = a[1], o = a[2], r = a[3], s = a[6], c = a[7], t = a[11];
            e[1] = a[4], e[2] = a[8], e[3] = a[12], e[4] = i, e[6] = a[9], e[7] = a[13], e[8] = o, e[9] = s, e[11] = a[14], e[12] = r, e[13] = c, e[14] = t;
          } else e[0] = a[0], e[1] = a[4], e[2] = a[8], e[3] = a[12], e[4] = a[1], e[5] = a[5], e[6] = a[9], e[7] = a[13], e[8] = a[2], e[9] = a[6], e[10] = a[10], e[11] = a[14], e[12] = a[3], e[13] = a[7], e[14] = a[11], e[15] = a[15];
          return e;
        }
      }), Of = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = a[0], o = a[1], r = a[2], s = a[3], c = a[4], t = a[5], p = a[6], l = a[7], f = a[8], v = a[9], g = a[10], x = a[11], h = a[12], m = a[13], u = a[14], d = a[15], y = i * t - o * c, _ = i * p - r * c, T = i * l - s * c, R = o * p - r * t, I = o * l - s * t, P = r * l - s * p, M = f * m - v * h, B = f * u - g * h, z = f * d - x * h, q = v * u - g * m, U = v * d - x * m, G = g * d - x * u, K = y * G - _ * U + T * q + R * z - I * B + P * M;
          return K ? (K = 1 / K, e[0] = (t * G - p * U + l * q) * K, e[1] = (r * U - o * G - s * q) * K, e[2] = (m * P - u * I + d * R) * K, e[3] = (g * I - v * P - x * R) * K, e[4] = (p * z - c * G - l * B) * K, e[5] = (i * G - r * z + s * B) * K, e[6] = (u * T - h * P - d * _) * K, e[7] = (f * P - g * T + x * _) * K, e[8] = (c * U - t * z + l * M) * K, e[9] = (o * z - i * U - s * M) * K, e[10] = (h * I - m * T + d * y) * K, e[11] = (v * T - f * I - x * y) * K, e[12] = (t * B - c * q - p * M) * K, e[13] = (i * q - o * B + r * M) * K, e[14] = (m * _ - h * R - u * y) * K, e[15] = (f * R - v * _ + g * y) * K, e) : null;
        }
      }), Cf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = a[0], o = a[1], r = a[2], s = a[3], c = a[4], t = a[5], p = a[6], l = a[7], f = a[8], v = a[9], g = a[10], x = a[11], h = a[12], m = a[13], u = a[14], d = a[15];
          return e[0] = t * (g * d - x * u) - v * (p * d - l * u) + m * (p * x - l * g), e[1] = -(o * (g * d - x * u) - v * (r * d - s * u) + m * (r * x - s * g)), e[2] = o * (p * d - l * u) - t * (r * d - s * u) + m * (r * l - s * p), e[3] = -(o * (p * x - l * g) - t * (r * x - s * g) + v * (r * l - s * p)), e[4] = -(c * (g * d - x * u) - f * (p * d - l * u) + h * (p * x - l * g)), e[5] = i * (g * d - x * u) - f * (r * d - s * u) + h * (r * x - s * g), e[6] = -(i * (p * d - l * u) - c * (r * d - s * u) + h * (r * l - s * p)), e[7] = i * (p * x - l * g) - c * (r * x - s * g) + f * (r * l - s * p), e[8] = c * (v * d - x * m) - f * (t * d - l * m) + h * (t * x - l * v), e[9] = -(i * (v * d - x * m) - f * (o * d - s * m) + h * (o * x - s * v)), e[10] = i * (t * d - l * m) - c * (o * d - s * m) + h * (o * l - s * t), e[11] = -(i * (t * x - l * v) - c * (o * x - s * v) + f * (o * l - s * t)), e[12] = -(c * (v * u - g * m) - f * (t * u - p * m) + h * (t * g - p * v)), e[13] = i * (v * u - g * m) - f * (o * u - r * m) + h * (o * g - r * v), e[14] = -(i * (t * u - p * m) - c * (o * u - r * m) + h * (o * p - r * t)), e[15] = i * (t * g - p * v) - c * (o * g - r * v) + f * (o * p - r * t), e;
        }
      }), Ef = xe((L, k) => {
        k.exports = n;
        function n(e) {
          var a = e[0], i = e[1], o = e[2], r = e[3], s = e[4], c = e[5], t = e[6], p = e[7], l = e[8], f = e[9], v = e[10], g = e[11], x = e[12], h = e[13], m = e[14], u = e[15], d = a * c - i * s, y = a * t - o * s, _ = a * p - r * s, T = i * t - o * c, R = i * p - r * c, I = o * p - r * t, P = l * h - f * x, M = l * m - v * x, B = l * u - g * x, z = f * m - v * h, q = f * u - g * h, U = v * u - g * m;
          return d * U - y * q + _ * z + T * B - R * M + I * P;
        }
      }), Df = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = a[0], r = a[1], s = a[2], c = a[3], t = a[4], p = a[5], l = a[6], f = a[7], v = a[8], g = a[9], x = a[10], h = a[11], m = a[12], u = a[13], d = a[14], y = a[15], _ = i[0], T = i[1], R = i[2], I = i[3];
          return e[0] = _ * o + T * t + R * v + I * m, e[1] = _ * r + T * p + R * g + I * u, e[2] = _ * s + T * l + R * x + I * d, e[3] = _ * c + T * f + R * h + I * y, _ = i[4], T = i[5], R = i[6], I = i[7], e[4] = _ * o + T * t + R * v + I * m, e[5] = _ * r + T * p + R * g + I * u, e[6] = _ * s + T * l + R * x + I * d, e[7] = _ * c + T * f + R * h + I * y, _ = i[8], T = i[9], R = i[10], I = i[11], e[8] = _ * o + T * t + R * v + I * m, e[9] = _ * r + T * p + R * g + I * u, e[10] = _ * s + T * l + R * x + I * d, e[11] = _ * c + T * f + R * h + I * y, _ = i[12], T = i[13], R = i[14], I = i[15], e[12] = _ * o + T * t + R * v + I * m, e[13] = _ * r + T * p + R * g + I * u, e[14] = _ * s + T * l + R * x + I * d, e[15] = _ * c + T * f + R * h + I * y, e;
        }
      }), Pf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = i[0], r = i[1], s = i[2], c, t, p, l, f, v, g, x, h, m, u, d;
          return a === e ? (e[12] = a[0] * o + a[4] * r + a[8] * s + a[12], e[13] = a[1] * o + a[5] * r + a[9] * s + a[13], e[14] = a[2] * o + a[6] * r + a[10] * s + a[14], e[15] = a[3] * o + a[7] * r + a[11] * s + a[15]) : (c = a[0], t = a[1], p = a[2], l = a[3], f = a[4], v = a[5], g = a[6], x = a[7], h = a[8], m = a[9], u = a[10], d = a[11], e[0] = c, e[1] = t, e[2] = p, e[3] = l, e[4] = f, e[5] = v, e[6] = g, e[7] = x, e[8] = h, e[9] = m, e[10] = u, e[11] = d, e[12] = c * o + f * r + h * s + a[12], e[13] = t * o + v * r + m * s + a[13], e[14] = p * o + g * r + u * s + a[14], e[15] = l * o + x * r + d * s + a[15]), e;
        }
      }), If = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = i[0], r = i[1], s = i[2];
          return e[0] = a[0] * o, e[1] = a[1] * o, e[2] = a[2] * o, e[3] = a[3] * o, e[4] = a[4] * r, e[5] = a[5] * r, e[6] = a[6] * r, e[7] = a[7] * r, e[8] = a[8] * s, e[9] = a[9] * s, e[10] = a[10] * s, e[11] = a[11] * s, e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15], e;
        }
      }), zf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i, o) {
          var r = o[0], s = o[1], c = o[2], t = Math.sqrt(r * r + s * s + c * c), p, l, f, v, g, x, h, m, u, d, y, _, T, R, I, P, M, B, z, q, U, G, K, te;
          return Math.abs(t) < 1e-6 ? null : (t = 1 / t, r *= t, s *= t, c *= t, p = Math.sin(i), l = Math.cos(i), f = 1 - l, v = a[0], g = a[1], x = a[2], h = a[3], m = a[4], u = a[5], d = a[6], y = a[7], _ = a[8], T = a[9], R = a[10], I = a[11], P = r * r * f + l, M = s * r * f + c * p, B = c * r * f - s * p, z = r * s * f - c * p, q = s * s * f + l, U = c * s * f + r * p, G = r * c * f + s * p, K = s * c * f - r * p, te = c * c * f + l, e[0] = v * P + m * M + _ * B, e[1] = g * P + u * M + T * B, e[2] = x * P + d * M + R * B, e[3] = h * P + y * M + I * B, e[4] = v * z + m * q + _ * U, e[5] = g * z + u * q + T * U, e[6] = x * z + d * q + R * U, e[7] = h * z + y * q + I * U, e[8] = v * G + m * K + _ * te, e[9] = g * G + u * K + T * te, e[10] = x * G + d * K + R * te, e[11] = h * G + y * K + I * te, a !== e && (e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15]), e);
        }
      }), Rf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = Math.sin(i), r = Math.cos(i), s = a[4], c = a[5], t = a[6], p = a[7], l = a[8], f = a[9], v = a[10], g = a[11];
          return a !== e && (e[0] = a[0], e[1] = a[1], e[2] = a[2], e[3] = a[3], e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15]), e[4] = s * r + l * o, e[5] = c * r + f * o, e[6] = t * r + v * o, e[7] = p * r + g * o, e[8] = l * r - s * o, e[9] = f * r - c * o, e[10] = v * r - t * o, e[11] = g * r - p * o, e;
        }
      }), Nf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = Math.sin(i), r = Math.cos(i), s = a[0], c = a[1], t = a[2], p = a[3], l = a[8], f = a[9], v = a[10], g = a[11];
          return a !== e && (e[4] = a[4], e[5] = a[5], e[6] = a[6], e[7] = a[7], e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15]), e[0] = s * r - l * o, e[1] = c * r - f * o, e[2] = t * r - v * o, e[3] = p * r - g * o, e[8] = s * o + l * r, e[9] = c * o + f * r, e[10] = t * o + v * r, e[11] = p * o + g * r, e;
        }
      }), Ff = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = Math.sin(i), r = Math.cos(i), s = a[0], c = a[1], t = a[2], p = a[3], l = a[4], f = a[5], v = a[6], g = a[7];
          return a !== e && (e[8] = a[8], e[9] = a[9], e[10] = a[10], e[11] = a[11], e[12] = a[12], e[13] = a[13], e[14] = a[14], e[15] = a[15]), e[0] = s * r + l * o, e[1] = c * r + f * o, e[2] = t * r + v * o, e[3] = p * r + g * o, e[4] = l * r - s * o, e[5] = f * r - c * o, e[6] = v * r - t * o, e[7] = g * r - p * o, e;
        }
      }), Bf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o, r, s, c = i[0], t = i[1], p = i[2], l = Math.sqrt(c * c + t * t + p * p);
          return Math.abs(l) < 1e-6 ? null : (l = 1 / l, c *= l, t *= l, p *= l, o = Math.sin(a), r = Math.cos(a), s = 1 - r, e[0] = c * c * s + r, e[1] = t * c * s + p * o, e[2] = p * c * s - t * o, e[3] = 0, e[4] = c * t * s - p * o, e[5] = t * t * s + r, e[6] = p * t * s + c * o, e[7] = 0, e[8] = c * p * s + t * o, e[9] = t * p * s - c * o, e[10] = p * p * s + r, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
        }
      }), jf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i) {
          var o = a[0], r = a[1], s = a[2], c = a[3], t = o + o, p = r + r, l = s + s, f = o * t, v = o * p, g = o * l, x = r * p, h = r * l, m = s * l, u = c * t, d = c * p, y = c * l;
          return e[0] = 1 - (x + m), e[1] = v + y, e[2] = g - d, e[3] = 0, e[4] = v - y, e[5] = 1 - (f + m), e[6] = h + u, e[7] = 0, e[8] = g + d, e[9] = h - u, e[10] = 1 - (f + x), e[11] = 0, e[12] = i[0], e[13] = i[1], e[14] = i[2], e[15] = 1, e;
        }
      }), Hf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          return e[0] = a[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = a[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), qf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = a[0], e[13] = a[1], e[14] = a[2], e[15] = 1, e;
        }
      }), Uf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = Math.sin(a), o = Math.cos(a);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = o, e[6] = i, e[7] = 0, e[8] = 0, e[9] = -i, e[10] = o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Vf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = Math.sin(a), o = Math.cos(a);
          return e[0] = o, e[1] = 0, e[2] = -i, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = i, e[9] = 0, e[10] = o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Yf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = Math.sin(a), o = Math.cos(a);
          return e[0] = o, e[1] = i, e[2] = 0, e[3] = 0, e[4] = -i, e[5] = o, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Gf = xe((L, k) => {
        k.exports = n;
        function n(e, a) {
          var i = a[0], o = a[1], r = a[2], s = a[3], c = i + i, t = o + o, p = r + r, l = i * c, f = o * c, v = o * t, g = r * c, x = r * t, h = r * p, m = s * c, u = s * t, d = s * p;
          return e[0] = 1 - v - h, e[1] = f + d, e[2] = g - u, e[3] = 0, e[4] = f - d, e[5] = 1 - l - h, e[6] = x + m, e[7] = 0, e[8] = g + u, e[9] = x - m, e[10] = 1 - l - v, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }
      }), Zf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i, o, r, s, c) {
          var t = 1 / (i - a), p = 1 / (r - o), l = 1 / (s - c);
          return e[0] = s * 2 * t, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = s * 2 * p, e[6] = 0, e[7] = 0, e[8] = (i + a) * t, e[9] = (r + o) * p, e[10] = (c + s) * l, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = c * s * 2 * l, e[15] = 0, e;
        }
      }), Wf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i, o, r) {
          var s = 1 / Math.tan(a / 2), c = 1 / (o - r);
          return e[0] = s / i, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = s, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (r + o) * c, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * r * o * c, e[15] = 0, e;
        }
      }), Xf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i, o) {
          var r = Math.tan(a.upDegrees * Math.PI / 180), s = Math.tan(a.downDegrees * Math.PI / 180), c = Math.tan(a.leftDegrees * Math.PI / 180), t = Math.tan(a.rightDegrees * Math.PI / 180), p = 2 / (c + t), l = 2 / (r + s);
          return e[0] = p, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = l, e[6] = 0, e[7] = 0, e[8] = -((c - t) * p * 0.5), e[9] = (r - s) * l * 0.5, e[10] = o / (i - o), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * i / (i - o), e[15] = 0, e;
        }
      }), Jf = xe((L, k) => {
        k.exports = n;
        function n(e, a, i, o, r, s, c) {
          var t = 1 / (a - i), p = 1 / (o - r), l = 1 / (s - c);
          return e[0] = -2 * t, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * p, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * l, e[11] = 0, e[12] = (a + i) * t, e[13] = (r + o) * p, e[14] = (c + s) * l, e[15] = 1, e;
        }
      }), $f = xe((L, k) => {
        var n = Zl();
        k.exports = e;
        function e(a, i, o, r) {
          var s, c, t, p, l, f, v, g, x, h, m = i[0], u = i[1], d = i[2], y = r[0], _ = r[1], T = r[2], R = o[0], I = o[1], P = o[2];
          return Math.abs(m - R) < 1e-6 && Math.abs(u - I) < 1e-6 && Math.abs(d - P) < 1e-6 ? n(a) : (v = m - R, g = u - I, x = d - P, h = 1 / Math.sqrt(v * v + g * g + x * x), v *= h, g *= h, x *= h, s = _ * x - T * g, c = T * v - y * x, t = y * g - _ * v, h = Math.sqrt(s * s + c * c + t * t), h ? (h = 1 / h, s *= h, c *= h, t *= h) : (s = 0, c = 0, t = 0), p = g * t - x * c, l = x * s - v * t, f = v * c - g * s, h = Math.sqrt(p * p + l * l + f * f), h ? (h = 1 / h, p *= h, l *= h, f *= h) : (p = 0, l = 0, f = 0), a[0] = s, a[1] = p, a[2] = v, a[3] = 0, a[4] = c, a[5] = l, a[6] = g, a[7] = 0, a[8] = t, a[9] = f, a[10] = x, a[11] = 0, a[12] = -(s * m + c * u + t * d), a[13] = -(p * m + l * u + f * d), a[14] = -(v * m + g * u + x * d), a[15] = 1, a);
        }
      }), Kf = xe((L, k) => {
        k.exports = n;
        function n(e) {
          return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
        }
      }), Wl = xe((L, k) => {
        k.exports = { create: Mf(), clone: Af(), copy: Sf(), identity: Zl(), transpose: Lf(), invert: Of(), adjoint: Cf(), determinant: Ef(), multiply: Df(), translate: Pf(), scale: If(), rotate: zf(), rotateX: Rf(), rotateY: Nf(), rotateZ: Ff(), fromRotation: Bf(), fromRotationTranslation: jf(), fromScaling: Hf(), fromTranslation: qf(), fromXRotation: Uf(), fromYRotation: Vf(), fromZRotation: Yf(), fromQuat: Gf(), frustum: Zf(), perspective: Wf(), perspectiveFromFieldOfView: Xf(), ortho: Jf(), lookAt: $f(), str: Kf() };
      }), co = xe((L) => {
        var k = Wl();
        L.init2dArray = function(n, e) {
          for (var a = new Array(n), i = 0; i < n; i++) a[i] = new Array(e);
          return a;
        }, L.transposeRagged = function(n) {
          var e = 0, a = n.length, i, o;
          for (i = 0; i < a; i++) e = Math.max(e, n[i].length);
          var r = new Array(e);
          for (i = 0; i < e; i++) for (r[i] = new Array(a), o = 0; o < a; o++) r[i][o] = n[o][i];
          return r;
        }, L.dot = function(n, e) {
          if (!(n.length && e.length) || n.length !== e.length) return null;
          var a = n.length, i, o;
          if (n[0].length) for (i = new Array(a), o = 0; o < a; o++) i[o] = L.dot(n[o], e);
          else if (e[0].length) {
            var r = L.transposeRagged(e);
            for (i = new Array(r.length), o = 0; o < r.length; o++) i[o] = L.dot(n, r[o]);
          } else for (i = 0, o = 0; o < a; o++) i += n[o] * e[o];
          return i;
        }, L.translationMatrix = function(n, e) {
          return [[1, 0, n], [0, 1, e], [0, 0, 1]];
        }, L.rotationMatrix = function(n) {
          var e = n * Math.PI / 180;
          return [[Math.cos(e), -Math.sin(e), 0], [Math.sin(e), Math.cos(e), 0], [0, 0, 1]];
        }, L.rotationXYMatrix = function(n, e, a) {
          return L.dot(L.dot(L.translationMatrix(e, a), L.rotationMatrix(n)), L.translationMatrix(-e, -a));
        }, L.apply3DTransform = function(n) {
          return function() {
            var e = arguments, a = arguments.length === 1 ? e[0] : [e[0], e[1], e[2] || 0];
            return L.dot(n, [a[0], a[1], a[2], 1]).slice(0, 3);
          };
        }, L.apply2DTransform = function(n) {
          return function() {
            var e = arguments;
            e.length === 3 && (e = e[0]);
            var a = arguments.length === 1 ? e[0] : [e[0], e[1]];
            return L.dot(n, [a[0], a[1], 1]).slice(0, 2);
          };
        }, L.apply2DTransform2 = function(n) {
          var e = L.apply2DTransform(n);
          return function(a) {
            return e(a.slice(0, 2)).concat(e(a.slice(2, 4)));
          };
        }, L.convertCssMatrix = function(n) {
          if (n) {
            var e = n.length;
            if (e === 16) return n;
            if (e === 6) return [n[0], n[1], 0, 0, n[2], n[3], 0, 0, 0, 0, 1, 0, n[4], n[5], 0, 1];
          }
          return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        }, L.inverseTransformMatrix = function(n) {
          var e = [];
          return k.invert(e, n), [[e[0], e[1], e[2], e[3]], [e[4], e[5], e[6], e[7]], [e[8], e[9], e[10], e[11]], [e[12], e[13], e[14], e[15]]];
        };
      }), _i = xe((L, k) => {
        var n = vr(), e = za(), a = co(), i = Wl();
        function o(m) {
          var u;
          if (typeof m == "string") {
            if (u = document.getElementById(m), u === null) throw new Error("No DOM element with id '" + m + "' exists on the page.");
            return u;
          } else if (m == null) throw new Error("DOM element provided is null or undefined");
          return m;
        }
        function r(m) {
          var u = n.select(m);
          return u.node() instanceof HTMLElement && u.size() && u.classed("js-plotly-plot");
        }
        function s(m) {
          var u = m && m.parentNode;
          u && u.removeChild(m);
        }
        function c(m, u) {
          t("global", m, u);
        }
        function t(m, u, d) {
          var y = "plotly.js-style-" + m, _ = document.getElementById(y);
          if (!(_ && _.matches(".no-inline-styles"))) {
            _ || (_ = document.createElement("style"), _.setAttribute("id", y), _.appendChild(document.createTextNode("")), document.head.appendChild(_));
            var T = _.sheet;
            T ? T.insertRule ? T.insertRule(u + "{" + d + "}", 0) : T.addRule ? T.addRule(u, d, 0) : e.warn("addStyleRule failed") : e.warn("Cannot addRelatedStyleRule, probably due to strict CSP...");
          }
        }
        function p(m) {
          var u = "plotly.js-style-" + m, d = document.getElementById(u);
          d && s(d);
        }
        function l(m, u, d, y, _, T) {
          var R = y.split(":"), I = _.split(":"), P = "data-btn-style-event-added";
          T || (T = document), T.querySelectorAll(m).forEach(function(M) {
            M.getAttribute(P) || (M.addEventListener("mouseenter", function() {
              var B = this.querySelector(d);
              B && (B.style[R[0]] = R[1]);
            }), M.addEventListener("mouseleave", function() {
              var B = this.querySelector(d);
              B && (u && this.matches(u) ? B.style[R[0]] = R[1] : B.style[I[0]] = I[1]);
            }), M.setAttribute(P, !0));
          });
        }
        function f(m) {
          var u = g(m), d = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          return u.forEach(function(y) {
            var _ = v(y);
            if (_) {
              var T = a.convertCssMatrix(_);
              d = i.multiply(d, d, T);
            }
          }), d;
        }
        function v(m) {
          var u = window.getComputedStyle(m, null), d = u.getPropertyValue("-webkit-transform") || u.getPropertyValue("-moz-transform") || u.getPropertyValue("-ms-transform") || u.getPropertyValue("-o-transform") || u.getPropertyValue("transform");
          return d === "none" ? null : d.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(y) {
            return +y;
          });
        }
        function g(m) {
          for (var u = []; x(m); ) u.push(m), m = m.parentNode, typeof ShadowRoot == "function" && m instanceof ShadowRoot && (m = m.host);
          return u;
        }
        function x(m) {
          return m && (m instanceof Element || m instanceof HTMLElement);
        }
        function h(m, u) {
          return m && u && m.top === u.top && m.left === u.left && m.right === u.right && m.bottom === u.bottom;
        }
        k.exports = { getGraphDiv: o, isPlotDiv: r, removeElement: s, addStyleRule: c, addRelatedStyleRule: t, deleteRelatedStyleRule: p, setStyleOnHover: l, getFullTransformMatrix: f, getElementTransformMatrix: v, getElementAndAncestors: g, equalDomRects: h };
      }), wi = xe((L, k) => {
        k.exports = { mode: { valType: "enumerated", dflt: "afterall", values: ["immediate", "next", "afterall"] }, direction: { valType: "enumerated", values: ["forward", "reverse"], dflt: "forward" }, fromcurrent: { valType: "boolean", dflt: !1 }, frame: { duration: { valType: "number", min: 0, dflt: 500 }, redraw: { valType: "boolean", dflt: !0 } }, transition: { duration: { valType: "number", min: 0, dflt: 500, editType: "none" }, easing: { valType: "enumerated", dflt: "cubic-in-out", values: ["linear", "quad", "cubic", "sin", "exp", "circle", "elastic", "back", "bounce", "linear-in", "quad-in", "cubic-in", "sin-in", "exp-in", "circle-in", "elastic-in", "back-in", "bounce-in", "linear-out", "quad-out", "cubic-out", "sin-out", "exp-out", "circle-out", "elastic-out", "back-out", "bounce-out", "linear-in-out", "quad-in-out", "cubic-in-out", "sin-in-out", "exp-in-out", "circle-in-out", "elastic-in-out", "back-in-out", "bounce-in-out"], editType: "none" }, ordering: { valType: "enumerated", values: ["layout first", "traces first"], dflt: "layout first", editType: "none" } } };
      }), ra = xe((L, k) => {
        var n = Br().extendFlat, e = ka(), a = { valType: "flaglist", extras: ["none"], flags: ["calc", "clearAxisTypes", "plot", "style", "markerSize", "colorbars"] }, i = { valType: "flaglist", extras: ["none"], flags: ["calc", "plot", "legend", "ticks", "axrange", "layoutstyle", "modebar", "camera", "arraydraw", "colorbars"] }, o = a.flags.slice().concat(["fullReplot"]), r = i.flags.slice().concat("layoutReplot");
        k.exports = { traces: a, layout: i, traceFlags: function() {
          return s(o);
        }, layoutFlags: function() {
          return s(r);
        }, update: function(p, l) {
          var f = l.editType;
          if (f && f !== "none") for (var v = f.split("+"), g = 0; g < v.length; g++) p[v[g]] = !0;
        }, overrideAll: c };
        function s(p) {
          for (var l = {}, f = 0; f < p.length; f++) l[p[f]] = !1;
          return l;
        }
        function c(p, l, f) {
          var v = n({}, p);
          for (var g in v) {
            var x = v[g];
            e(x) && (v[g] = t(x, l, f, g));
          }
          return f === "from-root" && (v.editType = l), v;
        }
        function t(p, l, f, v) {
          if (p.valType) {
            var g = n({}, p);
            if (g.editType = l, Array.isArray(p.items)) {
              g.items = new Array(p.items.length);
              for (var x = 0; x < p.items.length; x++) g.items[x] = t(p.items[x], l);
            }
            return g;
          } else return c(p, l, v.charAt(0) === "_" ? "nested" : "from-root");
        }
      }), Wn = xe((L) => {
        L.dash = { valType: "string", values: ["solid", "dot", "dash", "longdash", "dashdot", "longdashdot"], dflt: "solid", editType: "style" }, L.pattern = { shape: { valType: "enumerated", values: ["", "/", "\\", "x", "-", "|", "+", "."], dflt: "", arrayOk: !0, editType: "style" }, path: { valType: "string", arrayOk: !0, editType: "style" }, fillmode: { valType: "enumerated", values: ["replace", "overlay"], dflt: "replace", editType: "style" }, bgcolor: { valType: "color", arrayOk: !0, editType: "style" }, fgcolor: { valType: "color", arrayOk: !0, editType: "style" }, fgopacity: { valType: "number", editType: "style", min: 0, max: 1 }, size: { valType: "number", min: 0, dflt: 8, arrayOk: !0, editType: "style" }, solidity: { valType: "number", min: 0, max: 1, dflt: 0.3, arrayOk: !0, editType: "style" }, editType: "style" };
      }), Xl = xe((L, k) => {
        k.exports = { FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format", DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format" };
      }), qn = xe((L) => {
        var { DATE_FORMAT_LINK: k, FORMAT_LINK: n } = Xl(), e = ["Variables that can't be found will be replaced with the specifier.", 'For example, a template of "data: %{x}, %{y}" will result in a value of "data: 1, %{y}" if x is 1 and y is missing.', "Variables with an undefined value will be replaced with the fallback value."].join(" ");
        function a({ supportOther: i } = {}) {
          return ["Variables are inserted using %{variable},", 'for example "y: %{y}"' + (i ? " as well as %{xother}, {%_xother}, {%_xother_}, {%xother_}. When showing info for several points, *xother* will be added to those with different x positions from the first point. An underscore before or after *(x|y)other* will add a space on that side, only when this field is shown." : "."), `Numbers are formatted using d3-format's syntax %{variable:d3-format}, for example "Price: %{y:$.2f}".`, n, "for details on the formatting syntax.", `Dates are formatted using d3-time-format's syntax %{variable|d3-time-format}, for example "Day: %{2019-01-01|%A}".`, k, "for details on the date formatting syntax.", e].join(" ");
        }
        L.templateFormatStringDescription = a, L.hovertemplateAttrs = ({ editType: i = "none", arrayOk: o } = {}, r = {}) => Za({ valType: "string", dflt: "", editType: i }, o !== !1 ? { arrayOk: !0 } : {}), L.texttemplateAttrs = ({ editType: i = "calc", arrayOk: o } = {}, r = {}) => Za({ valType: "string", dflt: "", editType: i }, o !== !1 ? { arrayOk: !0 } : {}), L.shapeTexttemplateAttrs = ({ editType: i = "arraydraw", newshape: o } = {}, r = {}) => ({ valType: "string", dflt: "", editType: i }), L.templatefallbackAttrs = ({ editType: i = "none" } = {}) => ({ valType: "any", dflt: "-", editType: i });
      }), fo = xe((L, k) => {
        function n(d, y) {
          return y ? y.d2l(d) : d;
        }
        function e(d, y) {
          return y ? y.l2d(d) : d;
        }
        function a(d) {
          return d.x0;
        }
        function i(d) {
          return d.x1;
        }
        function o(d) {
          return d.y0;
        }
        function r(d) {
          return d.y1;
        }
        function s(d) {
          return d.x0shift || 0;
        }
        function c(d) {
          return d.x1shift || 0;
        }
        function t(d) {
          return d.y0shift || 0;
        }
        function p(d) {
          return d.y1shift || 0;
        }
        function l(d, y) {
          return n(d.x1, y) + c(d) - n(d.x0, y) - s(d);
        }
        function f(d, y, _) {
          return n(d.y1, _) + p(d) - n(d.y0, _) - t(d);
        }
        function v(d, y) {
          return Math.abs(l(d, y));
        }
        function g(d, y, _) {
          return Math.abs(f(d, y, _));
        }
        function x(d, y, _) {
          return d.type !== "line" ? void 0 : Math.sqrt(Math.pow(l(d, y), 2) + Math.pow(f(d, y, _), 2));
        }
        function h(d, y) {
          return e((n(d.x1, y) + c(d) + n(d.x0, y) + s(d)) / 2, y);
        }
        function m(d, y, _) {
          return e((n(d.y1, _) + p(d) + n(d.y0, _) + t(d)) / 2, _);
        }
        function u(d, y, _) {
          return d.type !== "line" ? void 0 : f(d, y, _) / l(d, y);
        }
        k.exports = { x0: a, x1: i, y0: o, y1: r, slope: u, dx: l, dy: f, width: v, height: g, length: x, xcenter: h, ycenter: m };
      }), Qf = xe((L, k) => {
        var n = ra().overrideAll, e = Pn(), a = hn(), i = Wn().dash, o = Br().extendFlat, { shapeTexttemplateAttrs: r, templatefallbackAttrs: s } = qn(), c = fo();
        k.exports = n({ newshape: { visible: o({}, e.visible, {}), showlegend: { valType: "boolean", dflt: !1 }, legend: o({}, e.legend, {}), legendgroup: o({}, e.legendgroup, {}), legendgrouptitle: { text: o({}, e.legendgrouptitle.text, {}), font: a({}) }, legendrank: o({}, e.legendrank, {}), legendwidth: o({}, e.legendwidth, {}), line: { color: { valType: "color" }, width: { valType: "number", min: 0, dflt: 4 }, dash: o({}, i, { dflt: "solid" }) }, fillcolor: { valType: "color", dflt: "rgba(0,0,0,0)" }, fillrule: { valType: "enumerated", values: ["evenodd", "nonzero"], dflt: "evenodd" }, opacity: { valType: "number", min: 0, max: 1, dflt: 1 }, layer: { valType: "enumerated", values: ["below", "above", "between"], dflt: "above" }, drawdirection: { valType: "enumerated", values: ["ortho", "horizontal", "vertical", "diagonal"], dflt: "diagonal" }, name: o({}, e.name, {}), label: { text: { valType: "string", dflt: "" }, texttemplate: r({ newshape: !0 }, { keys: Object.keys(c) }), texttemplatefallback: s({ editType: "arraydraw" }), font: a({}), textposition: { valType: "enumerated", values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"] }, textangle: { valType: "angle", dflt: "auto" }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "auto" }, yanchor: { valType: "enumerated", values: ["top", "middle", "bottom"] }, padding: { valType: "number", dflt: 3, min: 0 } } }, activeshape: { fillcolor: { valType: "color", dflt: "rgb(255,0,255)", description: "Sets the color filling the active shape' interior." }, opacity: { valType: "number", min: 0, max: 1, dflt: 0.5 } } }, "none", "from-root");
      }), ed = xe((L, k) => {
        var n = Wn().dash, e = Br().extendFlat;
        k.exports = { newselection: { mode: { valType: "enumerated", values: ["immediate", "gradual"], dflt: "immediate", editType: "none" }, line: { color: { valType: "color", editType: "none" }, width: { valType: "number", min: 1, dflt: 1, editType: "none" }, dash: e({}, n, { dflt: "dot", editType: "none" }), editType: "none" }, editType: "none" }, activeselection: { fillcolor: { valType: "color", dflt: "rgba(0,0,0,0)", editType: "none" }, opacity: { valType: "number", min: 0, max: 1, dflt: 0.5, editType: "none" }, editType: "none" } };
      }), po = xe((L, k) => {
        k.exports = function(n) {
          var e = n.editType;
          return { t: { valType: "number", dflt: 0, editType: e }, r: { valType: "number", dflt: 0, editType: e }, b: { valType: "number", dflt: 0, editType: e }, l: { valType: "number", dflt: 0, editType: e }, editType: e };
        };
      }), Ka = xe((L, k) => {
        var n = hn(), e = wi(), a = Zn(), i = Qf(), o = ed(), r = po(), s = Br().extendFlat, c = n({ editType: "calc" });
        c.family.dflt = '"Open Sans", verdana, arial, sans-serif', c.size.dflt = 12, c.color.dflt = a.defaultLine, k.exports = { font: c, title: { text: { valType: "string", editType: "layoutstyle" }, font: n({ editType: "layoutstyle" }), subtitle: { text: { valType: "string", editType: "layoutstyle" }, font: n({ editType: "layoutstyle" }), editType: "layoutstyle" }, xref: { valType: "enumerated", dflt: "container", values: ["container", "paper"], editType: "layoutstyle" }, yref: { valType: "enumerated", dflt: "container", values: ["container", "paper"], editType: "layoutstyle" }, x: { valType: "number", min: 0, max: 1, dflt: 0.5, editType: "layoutstyle" }, y: { valType: "number", min: 0, max: 1, dflt: "auto", editType: "layoutstyle" }, xanchor: { valType: "enumerated", dflt: "auto", values: ["auto", "left", "center", "right"], editType: "layoutstyle" }, yanchor: { valType: "enumerated", dflt: "auto", values: ["auto", "top", "middle", "bottom"], editType: "layoutstyle" }, pad: s(r({ editType: "layoutstyle" }), {}), automargin: { valType: "boolean", dflt: !1, editType: "plot" }, editType: "layoutstyle" }, uniformtext: { mode: { valType: "enumerated", values: [!1, "hide", "show"], dflt: !1, editType: "plot" }, minsize: { valType: "number", min: 0, dflt: 0, editType: "plot" }, editType: "plot" }, autosize: { valType: "boolean", dflt: !1, editType: "none" }, width: { valType: "number", min: 10, dflt: 700, editType: "plot" }, height: { valType: "number", min: 10, dflt: 450, editType: "plot" }, minreducedwidth: { valType: "number", min: 2, dflt: 64, editType: "plot" }, minreducedheight: { valType: "number", min: 2, dflt: 64, editType: "plot" }, margin: { l: { valType: "number", min: 0, dflt: 80, editType: "plot" }, r: { valType: "number", min: 0, dflt: 80, editType: "plot" }, t: { valType: "number", min: 0, dflt: 100, editType: "plot" }, b: { valType: "number", min: 0, dflt: 80, editType: "plot" }, pad: { valType: "number", min: 0, dflt: 0, editType: "plot" }, autoexpand: { valType: "boolean", dflt: !0, editType: "plot" }, editType: "plot" }, computed: { valType: "any", editType: "none" }, paper_bgcolor: { valType: "color", dflt: a.background, editType: "plot" }, plot_bgcolor: { valType: "color", dflt: a.background, editType: "layoutstyle" }, autotypenumbers: { valType: "enumerated", values: ["convert types", "strict"], dflt: "convert types", editType: "calc" }, separators: { valType: "string", editType: "plot" }, hidesources: { valType: "boolean", dflt: !1, editType: "plot" }, showlegend: { valType: "boolean", editType: "legend" }, colorway: { valType: "colorlist", dflt: a.defaults, editType: "calc" }, datarevision: { valType: "any", editType: "calc" }, uirevision: { valType: "any", editType: "none" }, editrevision: { valType: "any", editType: "none" }, selectionrevision: { valType: "any", editType: "none" }, template: { valType: "any", editType: "calc" }, newshape: i.newshape, activeshape: i.activeshape, newselection: o.newselection, activeselection: o.activeselection, meta: { valType: "any", arrayOk: !0, editType: "plot" }, transition: s({}, e.transition, { editType: "none" }) };
      }), td = xe(() => {
        (function() {
          if (!document.getElementById("8431bff7cc77ea8693f8122c6e0981316b936a0a4930625e08b1512d134062bc")) {
            var L = document.createElement("style");
            L.id = "8431bff7cc77ea8693f8122c6e0981316b936a0a4930625e08b1512d134062bc", L.textContent = `.maplibregl-map{font:12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;overflow:hidden;position:relative;-webkit-tap-highlight-color:rgb(0 0 0/0)}.maplibregl-canvas{left:0;position:absolute;top:0}.maplibregl-map:fullscreen{height:100%;width:100%}.maplibregl-ctrl-group button.maplibregl-ctrl-compass{touch-action:none}.maplibregl-canvas-container.maplibregl-interactive,.maplibregl-ctrl-group button.maplibregl-ctrl-compass{cursor:grab;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-canvas-container.maplibregl-interactive.maplibregl-track-pointer{cursor:pointer}.maplibregl-canvas-container.maplibregl-interactive:active,.maplibregl-ctrl-group button.maplibregl-ctrl-compass:active{cursor:grabbing}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-canvas-container.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:pinch-zoom}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:none}.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures,.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-ctrl-bottom-left,.maplibregl-ctrl-bottom-right,.maplibregl-ctrl-top-left,.maplibregl-ctrl-top-right{pointer-events:none;position:absolute;z-index:2}.maplibregl-ctrl-top-left{left:0;top:0}.maplibregl-ctrl-top-right{right:0;top:0}.maplibregl-ctrl-bottom-left{bottom:0;left:0}.maplibregl-ctrl-bottom-right{bottom:0;right:0}.maplibregl-ctrl{clear:both;pointer-events:auto;transform:translate(0)}.maplibregl-ctrl-top-left .maplibregl-ctrl{float:left;margin:10px 0 0 10px}.maplibregl-ctrl-top-right .maplibregl-ctrl{float:right;margin:10px 10px 0 0}.maplibregl-ctrl-bottom-left .maplibregl-ctrl{float:left;margin:0 0 10px 10px}.maplibregl-ctrl-bottom-right .maplibregl-ctrl{float:right;margin:0 10px 10px 0}.maplibregl-ctrl-group{background:#fff;border-radius:4px}.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px rgba(0,0,0,.1)}@media (forced-colors:active){.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px ButtonText}}.maplibregl-ctrl-group button{background-color:transparent;border:0;box-sizing:border-box;cursor:pointer;display:block;height:29px;outline:none;padding:0;width:29px}.maplibregl-ctrl-group button+button{border-top:1px solid #ddd}.maplibregl-ctrl button .maplibregl-ctrl-icon{background-position:50%;background-repeat:no-repeat;display:block;height:100%;width:100%}@media (forced-colors:active){.maplibregl-ctrl-icon{background-color:transparent}.maplibregl-ctrl-group button+button{border-top:1px solid ButtonText}}.maplibregl-ctrl button::-moz-focus-inner{border:0;padding:0}.maplibregl-ctrl-attrib-button:focus,.maplibregl-ctrl-group button:focus{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl button:disabled{cursor:not-allowed}.maplibregl-ctrl button:disabled .maplibregl-ctrl-icon{opacity:.25}.maplibregl-ctrl button:not(:disabled):hover{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-group button:focus:focus-visible{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl-group button:focus:not(:focus-visible){box-shadow:none}.maplibregl-ctrl-group button:focus:first-child{border-radius:4px 4px 0 0}.maplibregl-ctrl-group button:focus:last-child{border-radius:0 0 4px 4px}.maplibregl-ctrl-group button:focus:only-child{border-radius:inherit}.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23333' viewBox='0 0 29 29'%3E%3Cpath d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23333' viewBox='0 0 29 29'%3E%3Cpath d='M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5'/%3E%3C/svg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 29 29'%3E%3Cpath d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 29 29'%3E%3Cpath d='M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5'/%3E%3C/svg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5'/%3E%3C/svg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23333' viewBox='0 0 29 29'%3E%3Cpath d='M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z'/%3E%3C/svg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 29 29'%3E%3Cpath d='M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 29 29'%3E%3Cpath d='M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z'/%3E%3C/svg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='M24 16v5.5c0 1.75-.75 2.5-2.5 2.5H16v-1l3-1.5-4-5.5 1-1 5.5 4 1.5-3zM6 16l1.5 3 5.5-4 1 1-4 5.5 3 1.5v1H7.5C5.75 24 5 23.25 5 21.5V16zm7-11v1l-3 1.5 4 5.5-1 1-5.5-4L6 13H5V7.5C5 5.75 5.75 5 7.5 5zm11 2.5c0-1.75-.75-2.5-2.5-2.5H16v1l3 1.5-4 5.5 1 1 5.5-4 1.5 3h1z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='M18.5 16c-1.75 0-2.5.75-2.5 2.5V24h1l1.5-3 5.5 4 1-1-4-5.5 3-1.5v-1zM13 18.5c0-1.75-.75-2.5-2.5-2.5H5v1l3 1.5L4 24l1 1 5.5-4 1.5 3h1zm3-8c0 1.75.75 2.5 2.5 2.5H24v-1l-3-1.5L25 5l-1-1-5.5 4L17 5h-1zM10.5 13c1.75 0 2.5-.75 2.5-2.5V5h-1l-1.5 3L5 4 4 5l4 5.5L5 12v1z'/%3E%3C/svg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23333' viewBox='0 0 29 29'%3E%3Cpath d='m10.5 14 4-8 4 8z'/%3E%3Cpath fill='%23ccc' d='m10.5 16 4 8 4-8z'/%3E%3C/svg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 29 29'%3E%3Cpath d='m10.5 14 4-8 4 8z'/%3E%3Cpath fill='%23ccc' d='m10.5 16 4 8 4-8z'/%3E%3C/svg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 29 29'%3E%3Cpath d='m10.5 14 4-8 4 8z'/%3E%3Cpath fill='%23ccc' d='m10.5 16 4 8 4-8z'/%3E%3C/svg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-terrain .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='%23333' viewBox='0 0 22 22'%3E%3Cpath d='m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-terrain-enabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' fill='%2333b5e5' viewBox='0 0 22 22'%3E%3Cpath d='m1.754 13.406 4.453-4.851 3.09 3.09 3.281 3.277.969-.969-3.309-3.312 3.844-4.121 6.148 6.886h1.082v-.855l-7.207-8.07-4.84 5.187L6.169 6.57l-5.48 5.965v.871ZM.688 16.844h20.625v1.375H.688Zm0 0'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23333' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23aaa' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3Cpath fill='red' d='m14 5 1 1-9 9-1-1z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%2333b5e5' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23e58978' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%2333b5e5' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23e54e33' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-waiting .maplibregl-ctrl-icon{animation:maplibregl-spin 2s linear infinite}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23fff' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23999' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3Cpath fill='red' d='m14 5 1 1-9 9-1-1z'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%2333b5e5' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23e58978' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%2333b5e5' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23e54e33' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3C/svg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3C/svg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='29' fill='%23666' viewBox='0 0 20 20'%3E%3Cpath d='M10 4C9 4 9 5 9 5v.1A5 5 0 0 0 5.1 9H5s-1 0-1 1 1 1 1 1h.1A5 5 0 0 0 9 14.9v.1s0 1 1 1 1-1 1-1v-.1a5 5 0 0 0 3.9-3.9h.1s1 0 1-1-1-1-1-1h-.1A5 5 0 0 0 11 5.1V5s0-1-1-1m0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 1 1 0-7'/%3E%3Ccircle cx='10' cy='10' r='2'/%3E%3Cpath fill='red' d='m14 5 1 1-9 9-1-1z'/%3E%3C/svg%3E")}}@keyframes maplibregl-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}a.maplibregl-ctrl-logo{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='23' fill='none'%3E%3Cpath fill='%23000' fill-opacity='.4' fill-rule='evenodd' d='M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z'/%3E%3Cpath fill='%23fff' d='m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z'/%3E%3Cpath fill='%23e1e3e9' d='M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z'/%3E%3Cpath d='M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z' style='fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001'/%3E%3Cg style='stroke-width:1.12603545'%3E%3Cpath d='M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668' style='color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3' style='clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z' style='clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3C/g%3E%3C/svg%3E");background-repeat:no-repeat;cursor:pointer;display:block;height:23px;margin:0 0 -4px -4px;overflow:hidden;width:88px}a.maplibregl-ctrl-logo.maplibregl-compact{width:14px}@media (forced-colors:active){a.maplibregl-ctrl-logo{background-color:transparent;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='23' fill='none'%3E%3Cpath fill='%23000' fill-opacity='.4' fill-rule='evenodd' d='M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z'/%3E%3Cpath fill='%23fff' d='m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z'/%3E%3Cpath fill='%23e1e3e9' d='M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z'/%3E%3Cpath d='M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z' style='fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001'/%3E%3Cg style='stroke-width:1.12603545'%3E%3Cpath d='M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668' style='color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3' style='clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z' style='clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3C/g%3E%3C/svg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){a.maplibregl-ctrl-logo{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='23' fill='none'%3E%3Cpath fill='%23000' fill-opacity='.4' fill-rule='evenodd' d='M17.408 16.796h-1.827l2.501-12.095h.198l3.324 6.533.988 2.19.988-2.19 3.258-6.533h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.929 5.644h-.098l-2.914-5.644-.757-1.71-.345 1.71zm1.958-3.42-.726 3.663a1.255 1.255 0 0 1-1.232 1.011h-1.827a1.255 1.255 0 0 1-1.229-1.509l2.501-12.095a1.255 1.255 0 0 1 1.23-1.001h.197a1.25 1.25 0 0 1 1.12.685l3.19 6.273 3.125-6.263a1.25 1.25 0 0 1 1.123-.695h.181a1.255 1.255 0 0 1 1.227.991l1.443 6.71a5 5 0 0 1 .314-.787l.009-.016a4.6 4.6 0 0 1 1.777-1.887c.782-.46 1.668-.667 2.611-.667a4.6 4.6 0 0 1 1.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255 1.255 0 0 1 1.212.925 1.255 1.255 0 0 1 1.212-.925h1.711c.284 0 .545.094.755.252.613-.3 1.312-.45 2.075-.45 1.356 0 2.557.445 3.482 1.4q.47.48.763 1.064V4.701a1.255 1.255 0 0 1 1.255-1.255h1.86A1.255 1.255 0 0 1 54.44 4.7v9.194h2.217c.19 0 .37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42 2.42 0 0 1-.682-1.71c0-.665.267-1.253.735-1.7a2.45 2.45 0 0 1 1.722-.674 2.43 2.43 0 0 1 1.705.675q.318.302.504.683V4.7a1.255 1.255 0 0 1 1.255-1.255h1.744A1.255 1.255 0 0 1 65.812 4.7v3.335a4.8 4.8 0 0 1 1.526-.246c.938 0 1.817.214 2.59.69a4.47 4.47 0 0 1 1.67 1.743v-.98a1.255 1.255 0 0 1 1.256-1.256h1.777c.233 0 .451.064.639.174a3.4 3.4 0 0 1 1.567-.372c.346 0 .861.02 1.285.232a1.25 1.25 0 0 1 .689 1.004 4.7 4.7 0 0 1 .853-.588c.795-.44 1.675-.647 2.61-.647 1.385 0 2.65.39 3.525 1.396.836.938 1.168 2.173 1.168 3.528q-.001.515-.056 1.051a1.255 1.255 0 0 1-.947 1.09l.408.952a1.255 1.255 0 0 1-.477 1.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06 0-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8 5.8 0 0 1-.548-2.512q0-.429.053-.843a1.3 1.3 0 0 1-.333-.086l-.166-.004c-.223 0-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255 1.255 0 0 1-1.256 1.256h-1.777a1.255 1.255 0 0 1-1.256-1.256V15.69l-.032.057a4.8 4.8 0 0 1-1.86 1.833 5.04 5.04 0 0 1-2.484.634 4.5 4.5 0 0 1-1.935-.424 1.25 1.25 0 0 1-.764.258h-1.71a1.255 1.255 0 0 1-1.256-1.255V7.687a2.4 2.4 0 0 1-.428.625c.253.23.412.561.412.93v7.553a1.255 1.255 0 0 1-1.256 1.255h-1.843a1.25 1.25 0 0 1-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255 1.255 0 0 1-1.256-1.255v-1.251l-.061.117a4.7 4.7 0 0 1-1.782 1.884 4.77 4.77 0 0 1-2.485.67 5.6 5.6 0 0 1-1.485-.188l.009 2.764a1.255 1.255 0 0 1-1.255 1.259h-1.729a1.255 1.255 0 0 1-1.255-1.255v-3.537a1.255 1.255 0 0 1-1.167.793h-1.679a1.25 1.25 0 0 1-.77-.263 4.5 4.5 0 0 1-1.945.429c-.885 0-1.724-.21-2.495-.632l-.017-.01a5 5 0 0 1-1.081-.836 1.255 1.255 0 0 1-1.254 1.312h-1.81a1.255 1.255 0 0 1-1.228-.99l-.782-3.625-2.044 3.939a1.25 1.25 0 0 1-1.115.676h-.098a1.25 1.25 0 0 1-1.116-.68l-2.061-3.994zM35.92 16.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033 1.332h1.678V9.242h-1.694l-.033 1.267q-.133-.329-.526-.658l-.032-.028a3.2 3.2 0 0 0-.668-.428l-.27-.12a3.3 3.3 0 0 0-1.235-.23q-1.136-.001-1.974.493a3.36 3.36 0 0 0-1.3 1.382q-.445.89-.444 2.074 0 1.2.51 2.107a3.8 3.8 0 0 0 1.382 1.381 3.9 3.9 0 0 0 1.893.477q.795 0 1.455-.33zm-2.789-5.38q-.576.675-.575 1.762 0 1.102.559 1.794.576.675 1.645.675a2.25 2.25 0 0 0 .934-.19 2.2 2.2 0 0 0 .468-.29l.178-.161a2.2 2.2 0 0 0 .397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2 2.2 0 0 0-.633-.709l-.13-.086-.047-.028a2.1 2.1 0 0 0-1.073-.285q-1.052 0-1.629.692zm2.316 2.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96 0 0 0-.353-.389.85.85 0 0 0-.464-.127c-.4 0-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945 0 .506.122.801.27.99.097.11.266.224.68.224.303 0 .504-.09.687-.269zm7.545 1.705a2.6 2.6 0 0 0 .331.423q.319.33.755.548l.173.074q.65.255 1.49.255 1.02 0 1.844-.493a3.45 3.45 0 0 0 1.316-1.4q.493-.904.493-2.089 0-1.909-.988-2.913-.988-1.02-2.584-1.02-.898 0-1.575.347a3 3 0 0 0-.415.262l-.199.166a3.4 3.4 0 0 0-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296 1.119.297 1.07 0 1.645-.675.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.435 0-.835.16a2 2 0 0 0-.284.136 2 2 0 0 0-.363.254 2.2 2.2 0 0 0-.46.569l-.082.162a2.6 2.6 0 0 0-.213 1.072v.115q0 .707.296 1.267l.135.211zm.964-.818a1.1 1.1 0 0 0 .367.385.94.94 0 0 0 .476.118c.423 0 .59-.117.687-.23.159-.194.28-.478.28-.95 0-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1 1 0 0 0-.503.135l-.012.007a.86.86 0 0 0-.335.343c-.073.133-.132.324-.132.614v.115a1.4 1.4 0 0 0 .14.66zm15.7-6.222q.347-.346.346-.856a1.05 1.05 0 0 0-.345-.79 1.18 1.18 0 0 0-.84-.329q-.51 0-.855.33a1.05 1.05 0 0 0-.346.79q0 .51.346.855.345.346.856.346.51 0 .839-.346zm4.337 9.314.033-1.332q.191.403.59.747l.098.081a4 4 0 0 0 .316.224l.223.122a3.2 3.2 0 0 0 1.44.322 3.8 3.8 0 0 0 1.875-.477 3.5 3.5 0 0 0 1.382-1.366q.527-.89.526-2.09 0-1.184-.444-2.073a3.24 3.24 0 0 0-1.283-1.399q-.823-.51-1.942-.51a3.5 3.5 0 0 0-1.527.344l-.086.043-.165.09a3 3 0 0 0-.33.214q-.432.315-.656.707a2 2 0 0 0-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5 2.5 0 0 0 .566.7q.117.098.245.18l.144.08a2.1 2.1 0 0 0 .975.232q1.07 0 1.645-.675.576-.69.576-1.778 0-1.102-.576-1.777-.56-.691-1.645-.692a2.2 2.2 0 0 0-1.015.235q-.22.113-.415.282l-.15.142a2.1 2.1 0 0 0-.42.594q-.223.479-.223 1.1v.115q0 .705.293 1.26zm2.616-.293c.157-.191.28-.479.28-.967 0-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87 0 0 0-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0 .285.057.499.144.669a1.1 1.1 0 0 0 .367.405c.137.082.28.123.455.123.423 0 .59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493 0 .642.099l.247-1.794q-.196-.099-.717-.099a2.3 2.3 0 0 0-.545.063 2 2 0 0 0-.411.148 2.2 2.2 0 0 0-.4.249 2.5 2.5 0 0 0-.485.499 2.7 2.7 0 0 0-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5 1.5 0 0 1 .466-.636 2.5 2.5 0 0 1 .399-.253 2 2 0 0 1 .224-.099zm9.784 2.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46 3.46 0 0 0-1.4 1.382q-.493.906-.493 2.106 0 1.07.428 1.975.428.89 1.332 1.432.906.526 2.255.526.973 0 1.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954 0-1.497-.444a1.6 1.6 0 0 1-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1 1 0 0 0-.156-.176q-.46-.428-1.316-.428-.986 0-1.494.604-.379.45-.494 1.234zm-27.053 2.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z'/%3E%3Cpath fill='%23fff' d='m19.63 11.151-.757-1.71-.345 1.71-1.12 5.644h-1.827L18.083 4.7h.197l3.325 6.533.988 2.19.988-2.19L26.839 4.7h.181l2.6 12.095h-1.81l-1.218-5.644-.362-1.71-.658 1.71-2.93 5.644h-.098l-2.913-5.644zm14.836 5.81q-1.02 0-1.893-.478a3.8 3.8 0 0 1-1.381-1.382q-.51-.906-.51-2.106 0-1.185.444-2.074a3.36 3.36 0 0 1 1.3-1.382q.839-.494 1.974-.494a3.3 3.3 0 0 1 1.234.231 3.3 3.3 0 0 1 .97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02 1.053a3.17 3.17 0 0 1-1.662.444zm.296-1.482q.938 0 1.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2 2.2 0 0 0-.807-.872 2.1 2.1 0 0 0-1.119-.313q-1.053 0-1.629.692-.575.675-.575 1.76 0 1.103.559 1.795.577.675 1.645.675zm6.521-6.237h1.711v1.4q.906-1.597 2.83-1.597 1.596 0 2.584 1.02.988 1.005.988 2.914 0 1.185-.493 2.09a3.46 3.46 0 0 1-1.316 1.399 3.5 3.5 0 0 1-1.844.493q-.954 0-1.662-.329a2.67 2.67 0 0 1-1.086-.97l.017 5.134h-1.728zm4.048 6.22q1.07 0 1.645-.674.577-.69.576-1.762 0-1.119-.576-1.777-.558-.675-1.645-.675-.592 0-1.12.296-.51.28-.822.823-.296.527-.296 1.234v.115q0 .708.296 1.267.313.543.823.855.51.296 1.119.297z'/%3E%3Cpath fill='%23e1e3e9' d='M51.325 4.7h1.86v10.45h3.473v1.646h-5.333zm7.12 4.542h1.843v7.553h-1.843zm.905-1.415a1.16 1.16 0 0 1-.856-.346 1.17 1.17 0 0 1-.346-.856 1.05 1.05 0 0 1 .346-.79q.346-.329.856-.329.494 0 .839.33a1.05 1.05 0 0 1 .345.79 1.16 1.16 0 0 1-.345.855q-.33.346-.84.346zm7.875 9.133a3.17 3.17 0 0 1-1.662-.444q-.723-.46-1.004-1.053l-.033 1.332h-1.71V4.701h1.743v4.657l-.082 1.283q.279-.658 1.086-1.119a3.5 3.5 0 0 1 1.778-.477q1.119 0 1.942.51a3.24 3.24 0 0 1 1.283 1.4q.445.888.444 2.072 0 1.201-.526 2.09a3.5 3.5 0 0 1-1.382 1.366 3.8 3.8 0 0 1-1.876.477zm-.296-1.481q1.069 0 1.645-.675.577-.69.577-1.778 0-1.102-.577-1.776-.56-.691-1.645-.692a2.12 2.12 0 0 0-1.58.659q-.642.641-.642 1.694v.115q0 .71.296 1.267a2.4 2.4 0 0 0 .807.872 2.1 2.1 0 0 0 1.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14 2.14 0 0 1 1.349-.46q.527 0 .724.098l-.247 1.794q-.149-.099-.642-.099-.774 0-1.416.494-.626.493-.626 1.58v3.883h-1.777V9.242zm9.534 7.718q-1.35 0-2.255-.526-.904-.543-1.332-1.432a4.6 4.6 0 0 1-.428-1.975q0-1.2.493-2.106a3.46 3.46 0 0 1 1.4-1.382q.889-.495 2.007-.494 1.744 0 2.584.97.855.956.856 2.7 0 .444-.05.92h-5.43q.18 1.005.708 1.45.542.443 1.497.443.79 0 1.3-.131a4 4 0 0 0 .938-.362l.542 1.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728 0-1.991 1.86z'/%3E%3Cpath d='M5.074 15.948a.484.657 0 0 0-.486.659v1.84a.484.657 0 0 0 .486.659h4.101a.484.657 0 0 0 .486-.659v-1.84a.484.657 0 0 0-.486-.659zm3.56 1.16H5.617v.838h3.017z' style='fill:%23fff;fill-rule:evenodd;stroke-width:1.03600001'/%3E%3Cg style='stroke-width:1.12603545'%3E%3Cpath d='M-9.408-1.416c-3.833-.025-7.056 2.912-7.08 6.615-.02 3.08 1.653 4.832 3.107 6.268.903.892 1.721 1.74 2.32 2.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87 1.87 0 0 0-.362 1.121l-.011 1.877c-.003.402.104.787.347 1.125.244.338.688.653 1.23.656l4.142.028c.542.003.99-.306 1.238-.641a1.87 1.87 0 0 0 .363-1.121l.012-1.875a1.87 1.87 0 0 0-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145 1.425-1.983 2.348-2.87 1.473-1.414 3.18-3.149 3.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006 1.1v.002c3.274.02 5.92 2.532 5.9 5.6-.017 2.706-1.39 4.026-2.863 5.44-1.034.994-2.118 2.033-2.814 3.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34 0 0 1-.226.084.34.34 0 0 1-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067 2.7-5.545 5.975-5.523m-.02 2.826c-1.62-.01-2.944 1.315-2.955 2.96-.01 1.646 1.295 2.988 2.916 2.999h.002c1.621.01 2.943-1.316 2.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005 1.1c1.017.006 1.829.83 1.822 1.89s-.83 1.874-1.848 1.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874 1.848-1.868m-2.155 11.857 4.14.025c.271.002.49.305.487.676l-.013 1.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668' style='color:%23000;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:%23000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:evenodd;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:%23000;solid-opacity:1;vector-effect:none;fill:%23000;fill-opacity:.4;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-9.415-.316C-12.69-.338-15.37 2.14-15.39 5.207c-.017 2.716 1.326 4.041 2.78 5.477 1.013 1 2.081 2.055 2.78 3.67l.092.076a.34.34 0 0 0 .225.086.34.34 0 0 0 .227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6 1.78-2.64 2.814-3.634 1.473-1.414 2.847-2.733 2.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057 8.784c1.621.011 2.944-1.315 2.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945 1.315-2.955 2.96s1.295 2.989 2.916 3' style='clip-rule:evenodd;fill:%23e1e3e9;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3Cpath d='M-11.594 15.465c-.27-.002-.492.297-.494.668l-.012 1.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z' style='clip-rule:evenodd;fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.47727823;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:.4' transform='translate(15.553 2.85)scale(.88807)'/%3E%3C/g%3E%3C/svg%3E")}}.maplibregl-ctrl.maplibregl-ctrl-attrib{background-color:hsla(0,0%,100%,.5);margin:0;padding:0 5px}@media screen{.maplibregl-ctrl-attrib.maplibregl-compact{background-color:#fff;border-radius:12px;box-sizing:content-box;color:#000;margin:10px;min-height:20px;padding:2px 24px 2px 0;position:relative}.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 28px 2px 8px;visibility:visible}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact-show,.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact-show{border-radius:12px;padding:2px 8px 2px 28px}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}.maplibregl-ctrl-attrib-button{background-color:hsla(0,0%,100%,.5);background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill-rule='evenodd' viewBox='0 0 20 20'%3E%3Cpath d='M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0'/%3E%3C/svg%3E");border:0;border-radius:12px;box-sizing:border-box;cursor:pointer;display:none;height:24px;outline:none;position:absolute;right:0;top:0;width:24px}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;list-style:none}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button::-webkit-details-marker{display:none}.maplibregl-ctrl-bottom-left .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-top-left .maplibregl-ctrl-attrib-button{left:0}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-inner{display:block}.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-button{background-color:rgb(0 0 0/5%)}.maplibregl-ctrl-bottom-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;right:0}.maplibregl-ctrl-top-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{right:0;top:0}.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{left:0;top:0}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;left:0}}@media screen and (forced-colors:active){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff' fill-rule='evenodd' viewBox='0 0 20 20'%3E%3Cpath d='M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0'/%3E%3C/svg%3E")}}@media screen and (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill-rule='evenodd' viewBox='0 0 20 20'%3E%3Cpath d='M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0'/%3E%3C/svg%3E")}}.maplibregl-ctrl-attrib a{color:rgba(0,0,0,.75);text-decoration:none}.maplibregl-ctrl-attrib a:hover{color:inherit;text-decoration:underline}.maplibregl-attrib-empty{display:none}.maplibregl-ctrl-scale{background-color:hsla(0,0%,100%,.75);border:2px solid #333;border-top:#333;box-sizing:border-box;color:#333;font-size:10px;padding:0 5px}.maplibregl-popup{display:flex;left:0;pointer-events:none;position:absolute;top:0;will-change:transform}.maplibregl-popup-anchor-top,.maplibregl-popup-anchor-top-left,.maplibregl-popup-anchor-top-right{flex-direction:column}.maplibregl-popup-anchor-bottom,.maplibregl-popup-anchor-bottom-left,.maplibregl-popup-anchor-bottom-right{flex-direction:column-reverse}.maplibregl-popup-anchor-left{flex-direction:row}.maplibregl-popup-anchor-right{flex-direction:row-reverse}.maplibregl-popup-tip{border:10px solid transparent;height:0;width:0;z-index:1}.maplibregl-popup-anchor-top .maplibregl-popup-tip{align-self:center;border-bottom-color:#fff;border-top:none}.maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-start;border-bottom-color:#fff;border-left:none;border-top:none}.maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-end;border-bottom-color:#fff;border-right:none;border-top:none}.maplibregl-popup-anchor-bottom .maplibregl-popup-tip{align-self:center;border-bottom:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-start;border-bottom:none;border-left:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-end;border-bottom:none;border-right:none;border-top-color:#fff}.maplibregl-popup-anchor-left .maplibregl-popup-tip{align-self:center;border-left:none;border-right-color:#fff}.maplibregl-popup-anchor-right .maplibregl-popup-tip{align-self:center;border-left-color:#fff;border-right:none}.maplibregl-popup-close-button{background-color:transparent;border:0;border-radius:0 3px 0 0;cursor:pointer;position:absolute;right:0;top:0}.maplibregl-popup-close-button:hover{background-color:rgb(0 0 0/5%)}.maplibregl-popup-content{background:#fff;border-radius:3px;box-shadow:0 1px 2px rgba(0,0,0,.1);padding:15px 10px;pointer-events:auto;position:relative}.maplibregl-popup-anchor-top-left .maplibregl-popup-content{border-top-left-radius:0}.maplibregl-popup-anchor-top-right .maplibregl-popup-content{border-top-right-radius:0}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content{border-bottom-left-radius:0}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content{border-bottom-right-radius:0}.maplibregl-popup-track-pointer{display:none}.maplibregl-popup-track-pointer *{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-map:hover .maplibregl-popup-track-pointer{display:flex}.maplibregl-map:active .maplibregl-popup-track-pointer{display:none}.maplibregl-marker{left:0;position:absolute;top:0;transition:opacity .2s;will-change:transform}.maplibregl-user-location-dot,.maplibregl-user-location-dot:before{background-color:#1da1f2;border-radius:50%;height:15px;width:15px}.maplibregl-user-location-dot:before{animation:maplibregl-user-location-dot-pulse 2s infinite;content:"";position:absolute}.maplibregl-user-location-dot:after{border:2px solid #fff;border-radius:50%;box-shadow:0 0 3px rgba(0,0,0,.35);box-sizing:border-box;content:"";height:19px;left:-2px;position:absolute;top:-2px;width:19px}@keyframes maplibregl-user-location-dot-pulse{0%{opacity:1;transform:scale(1)}70%{opacity:0;transform:scale(3)}to{opacity:0;transform:scale(1)}}.maplibregl-user-location-dot-stale{background-color:#aaa}.maplibregl-user-location-dot-stale:after{display:none}.maplibregl-user-location-accuracy-circle{background-color:#1da1f233;border-radius:100%;height:1px;width:1px}.maplibregl-crosshair,.maplibregl-crosshair .maplibregl-interactive,.maplibregl-crosshair .maplibregl-interactive:active{cursor:crosshair}.maplibregl-boxzoom{background:#fff;border:2px dotted #202020;height:0;left:0;opacity:.5;position:absolute;top:0;width:0}.maplibregl-cooperative-gesture-screen{align-items:center;background:rgba(0,0,0,.4);color:#fff;display:flex;font-size:1.4em;inset:0;justify-content:center;line-height:1.2;opacity:0;padding:1rem;pointer-events:none;position:absolute;transition:opacity 1s ease 1s;z-index:99999}.maplibregl-cooperative-gesture-screen.maplibregl-show{opacity:1;transition:opacity .05s}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:none}@media (hover:none),(width <= 480px){.maplibregl-cooperative-gesture-screen .maplibregl-desktop-message{display:none}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:block}}.maplibregl-pseudo-fullscreen{height:100%!important;left:0!important;position:fixed!important;top:0!important;width:100%!important;z-index:99999}`, document.head.appendChild(L);
          }
        })();
      }), or = xe((L) => {
        var k = za(), n = uo(), e = Gl(), a = ka(), i = _i().addStyleRule, o = Br(), r = Pn(), s = Ka(), c = o.extendFlat, t = o.extendDeepAll;
        L.modules = {}, L.allCategories = {}, L.allTypes = [], L.subplotsRegistry = {}, L.componentsRegistry = {}, L.layoutArrayContainers = [], L.layoutArrayRegexes = [], L.traceLayoutAttributes = {}, L.localeRegistry = {}, L.apiMethodRegistry = {}, L.collectableSubplotTypes = null, L.register = function(d) {
          if (L.collectableSubplotTypes = null, d) d && !Array.isArray(d) && (d = [d]);
          else throw new Error("No argument passed to Plotly.register.");
          for (var y = 0; y < d.length; y++) {
            var _ = d[y];
            if (!_) throw new Error("Invalid module was attempted to be registered!");
            switch (_.moduleType) {
              case "trace":
                p(_);
                break;
              case "transform":
                v(_);
                break;
              case "component":
                f(_);
                break;
              case "locale":
                g(_);
                break;
              case "apiMethod":
                var T = _.name;
                L.apiMethodRegistry[T] = _.fn;
                break;
              default:
                throw new Error("Invalid module was attempted to be registered!");
            }
          }
        }, L.getModule = function(d) {
          var y = L.modules[u(d)];
          return y ? y._module : !1;
        }, L.traceIs = function(d, y) {
          if (d = u(d), d === "various") return !1;
          var _ = L.modules[d];
          return _ || (d && k.log("Unrecognized trace type " + d + "."), _ = L.modules[r.type.dflt]), !!_.categories[y];
        }, L.getComponentMethod = function(d, y) {
          var _ = L.componentsRegistry[d];
          return _ && _[y] || n;
        }, L.call = function() {
          var d = arguments[0], y = [].slice.call(arguments, 1);
          return L.apiMethodRegistry[d].apply(null, y);
        };
        function p(d) {
          var y = d.name, _ = d.categories, T = d.meta;
          if (L.modules[y]) {
            k.log("Type " + y + " already registered");
            return;
          }
          L.subplotsRegistry[d.basePlotModule.name] || l(d.basePlotModule);
          for (var R = {}, I = 0; I < _.length; I++) R[_[I]] = !0, L.allCategories[_[I]] = !0;
          L.modules[y] = { _module: d, categories: R }, T && Object.keys(T).length && (L.modules[y].meta = T), L.allTypes.push(y);
          for (var P in L.componentsRegistry) h(P, y);
          d.layoutAttributes && c(L.traceLayoutAttributes, d.layoutAttributes);
          var M = d.basePlotModule, B = M.name;
          if (B === "mapbox") {
            var z = M.constants.styleRules;
            for (var q in z) i(".js-plotly-plot .plotly .mapboxgl-" + q, z[q]);
          }
          B === "map" && td(), (B === "geo" || B === "mapbox" || B === "map") && window.PlotlyGeoAssets === void 0 && (window.PlotlyGeoAssets = { topojson: {} });
        }
        function l(d) {
          var y = d.name;
          if (L.subplotsRegistry[y]) {
            k.log("Plot type " + y + " already registered.");
            return;
          }
          x(d), L.subplotsRegistry[y] = d;
          for (var _ in L.componentsRegistry) m(_, d.name);
        }
        function f(d) {
          if (typeof d.name != "string") throw new Error("Component module *name* must be a string.");
          var y = d.name;
          L.componentsRegistry[y] = d, d.layoutAttributes && (d.layoutAttributes._isLinkedToArray && e(L.layoutArrayContainers, y), x(d));
          for (var _ in L.modules) h(y, _);
          for (var T in L.subplotsRegistry) m(y, T);
          d.schema && d.schema.layout && t(s, d.schema.layout);
        }
        function v(d) {
          if (typeof d.name != "string") throw new Error("Transform module *name* must be a string.");
          var y = "Transform module " + d.name, _ = typeof d.transform == "function", T = typeof d.calcTransform == "function";
          if (!_ && !T) throw new Error(y + " is missing a *transform* or *calcTransform* method.");
          _ && T && k.log([y + " has both a *transform* and *calcTransform* methods.", "Please note that all *transform* methods are executed", "before all *calcTransform* methods."].join(" ")), a(d.attributes) || k.log(y + " registered without an *attributes* object."), typeof d.supplyDefaults != "function" && k.log(y + " registered without a *supplyDefaults* method.");
        }
        function g(d) {
          var y = d.name, _ = y.split("-")[0], T = d.dictionary, R = d.format, I = T && Object.keys(T).length, P = R && Object.keys(R).length, M = L.localeRegistry, B = M[y];
          if (B || (M[y] = B = {}), _ !== y) {
            var z = M[_];
            z || (M[_] = z = {}), I && z.dictionary === B.dictionary && (z.dictionary = T), P && z.format === B.format && (z.format = R);
          }
          I && (B.dictionary = T), P && (B.format = R);
        }
        function x(d) {
          if (d.layoutAttributes) {
            var y = d.layoutAttributes._arrayAttrRegexps;
            if (y) for (var _ = 0; _ < y.length; _++) e(L.layoutArrayRegexes, y[_]);
          }
        }
        function h(d, y) {
          var _ = L.componentsRegistry[d].schema;
          if (!(!_ || !_.traces)) {
            var T = _.traces[y];
            T && t(L.modules[y]._module.attributes, T);
          }
        }
        function m(d, y) {
          var _ = L.componentsRegistry[d].schema;
          if (!(!_ || !_.subplots)) {
            var T = L.subplotsRegistry[y], R = T.layoutAttributes, I = T.attr === "subplot" ? T.name : T.attr;
            Array.isArray(I) && (I = I[0]);
            var P = _.subplots[I];
            R && P && t(R, P);
          }
        }
        function u(d) {
          return typeof d == "object" && (d = d.type), d;
        }
      }), rd = xe((L) => {
        var k = Wa().timeFormat, n = xr(), e = za(), a = Xa().mod, i = Yr(), o = i.BADNUM, r = i.ONEDAY, s = i.ONEHOUR, c = i.ONEMIN, t = i.ONESEC, p = i.EPOCHJD, l = or(), f = Wa().utcFormat, v = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, g = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, x = (/* @__PURE__ */ new Date()).getFullYear() - 70;
        function h(K) {
          return K && l.componentsRegistry.calendars && typeof K == "string" && K !== "gregorian";
        }
        L.dateTick0 = function(K, te) {
          var V = m(K, !!te);
          if (te < 2) return V;
          var Z = L.dateTime2ms(V, K);
          return Z += r * (te - 1), L.ms2DateTime(Z, 0, K);
        };
        function m(K, te) {
          return h(K) ? te ? l.getComponentMethod("calendars", "CANONICAL_SUNDAY")[K] : l.getComponentMethod("calendars", "CANONICAL_TICK")[K] : te ? "2000-01-02" : "2000-01-01";
        }
        L.dfltRange = function(K) {
          return h(K) ? l.getComponentMethod("calendars", "DFLTRANGE")[K] : ["2000-01-01", "2001-01-01"];
        }, L.isJSDate = function(K) {
          return typeof K == "object" && K !== null && typeof K.getTime == "function";
        };
        var u, d;
        L.dateTime2ms = function(K, te) {
          if (L.isJSDate(K)) {
            var V = K.getTimezoneOffset() * c, Z = (K.getUTCMinutes() - K.getMinutes()) * c + (K.getUTCSeconds() - K.getSeconds()) * t + (K.getUTCMilliseconds() - K.getMilliseconds());
            if (Z) {
              var Y = 3 * c;
              V = V - Y / 2 + a(Z - V + Y / 2, Y);
            }
            return K = Number(K) - V, K >= u && K <= d ? K : o;
          }
          if (typeof K != "string" && typeof K != "number") return o;
          K = String(K);
          var C = h(te), j = K.charAt(0);
          C && (j === "G" || j === "g") && (K = K.substr(1), te = "");
          var J = C && te.substr(0, 7) === "chinese", ne = K.match(J ? g : v);
          if (!ne) return o;
          var ae = ne[1], se = ne[3] || "1", O = Number(ne[5] || 1), F = Number(ne[7] || 0), S = Number(ne[9] || 0), $ = Number(ne[11] || 0);
          if (C) {
            if (ae.length === 2) return o;
            ae = Number(ae);
            var re;
            try {
              var E = l.getComponentMethod("calendars", "getCal")(te);
              if (J) {
                var w = se.charAt(se.length - 1) === "i";
                se = parseInt(se, 10), re = E.newDate(ae, E.toMonthIndex(ae, se, w), O);
              } else re = E.newDate(ae, Number(se), O);
            } catch {
              return o;
            }
            return re ? (re.toJD() - p) * r + F * s + S * c + $ * t : o;
          }
          ae.length === 2 ? ae = (Number(ae) + 2e3 - x) % 100 + x : ae = Number(ae), se -= 1;
          var N = new Date(Date.UTC(2e3, se, O, F, S));
          return N.setUTCFullYear(ae), N.getUTCMonth() !== se || N.getUTCDate() !== O ? o : N.getTime() + $ * t;
        }, u = L.MIN_MS = L.dateTime2ms("-9999"), d = L.MAX_MS = L.dateTime2ms("9999-12-31 23:59:59.9999"), L.isDateTime = function(K, te) {
          return L.dateTime2ms(K, te) !== o;
        };
        function y(K, te) {
          return String(K + Math.pow(10, te)).substr(1);
        }
        var _ = 90 * r, T = 3 * s, R = 5 * c;
        L.ms2DateTime = function(K, te, V) {
          if (typeof K != "number" || !(K >= u && K <= d)) return o;
          te || (te = 0);
          var Z = Math.floor(a(K + 0.05, 1) * 10), Y = Math.round(K - Z / 10), C, j, J, ne, ae, se;
          if (h(V)) {
            var O = Math.floor(Y / r) + p, F = Math.floor(a(K, r));
            try {
              C = l.getComponentMethod("calendars", "getCal")(V).fromJD(O).formatDate("yyyy-mm-dd");
            } catch {
              C = f("G%Y-%m-%d")(new Date(Y));
            }
            if (C.charAt(0) === "-") for (; C.length < 11; ) C = "-0" + C.substr(1);
            else for (; C.length < 10; ) C = "0" + C;
            j = te < _ ? Math.floor(F / s) : 0, J = te < _ ? Math.floor(F % s / c) : 0, ne = te < T ? Math.floor(F % c / t) : 0, ae = te < R ? F % t * 10 + Z : 0;
          } else se = new Date(Y), C = f("%Y-%m-%d")(se), j = te < _ ? se.getUTCHours() : 0, J = te < _ ? se.getUTCMinutes() : 0, ne = te < T ? se.getUTCSeconds() : 0, ae = te < R ? se.getUTCMilliseconds() * 10 + Z : 0;
          return I(C, j, J, ne, ae);
        }, L.ms2DateTimeLocal = function(K) {
          if (!(K >= u + r && K <= d - r)) return o;
          var te = Math.floor(a(K + 0.05, 1) * 10), V = new Date(Math.round(K - te / 10)), Z = k("%Y-%m-%d")(V), Y = V.getHours(), C = V.getMinutes(), j = V.getSeconds(), J = V.getUTCMilliseconds() * 10 + te;
          return I(Z, Y, C, j, J);
        };
        function I(K, te, V, Z, Y) {
          if ((te || V || Z || Y) && (K += " " + y(te, 2) + ":" + y(V, 2), (Z || Y) && (K += ":" + y(Z, 2), Y))) {
            for (var C = 4; Y % 10 === 0; ) C -= 1, Y /= 10;
            K += "." + y(Y, C);
          }
          return K;
        }
        L.cleanDate = function(K, te, V) {
          if (K === o) return te;
          if (L.isJSDate(K) || typeof K == "number" && isFinite(K)) {
            if (h(V)) return e.error("JS Dates and milliseconds are incompatible with world calendars", K), te;
            if (K = L.ms2DateTimeLocal(+K), !K && te !== void 0) return te;
          } else if (!L.isDateTime(K, V)) return e.error("unrecognized date", K), te;
          return K;
        };
        var P = /%\d?f/g, M = /%h/g, B = { 1: "1", 2: "1", 3: "2", 4: "2" };
        function z(K, te, V, Z) {
          K = K.replace(P, function(C) {
            var j = Math.min(+C.charAt(1) || 6, 6), J = (te / 1e3 % 1 + 2).toFixed(j).substr(2).replace(/0+$/, "") || "0";
            return J;
          });
          var Y = new Date(Math.floor(te + 0.05));
          if (K = K.replace(M, function() {
            return B[V("%q")(Y)];
          }), h(Z)) try {
            K = l.getComponentMethod("calendars", "worldCalFmt")(K, te, Z);
          } catch {
            return "Invalid";
          }
          return V(K)(Y);
        }
        var q = [59, 59.9, 59.99, 59.999, 59.9999];
        function U(K, te) {
          var V = a(K + 0.05, r), Z = y(Math.floor(V / s), 2) + ":" + y(a(Math.floor(V / c), 60), 2);
          if (te !== "M") {
            n(te) || (te = 0);
            var Y = Math.min(a(K / t, 60), q[te]), C = (100 + Y).toFixed(te).substr(1);
            te > 0 && (C = C.replace(/0+$/, "").replace(/[\.]$/, "")), Z += ":" + C;
          }
          return Z;
        }
        L.formatDate = function(K, te, V, Z, Y, C) {
          if (Y = h(Y) && Y, !te) if (V === "y") te = C.year;
          else if (V === "m") te = C.month;
          else if (V === "d") te = C.dayMonth + `
` + C.year;
          else return U(K, V) + `
` + z(C.dayMonthYear, K, Z, Y);
          return z(te, K, Z, Y);
        };
        var G = 3 * r;
        L.incrementMonth = function(K, te, V) {
          V = h(V) && V;
          var Z = a(K, r);
          if (K = Math.round(K - Z), V) try {
            var Y = Math.round(K / r) + p, C = l.getComponentMethod("calendars", "getCal")(V), j = C.fromJD(Y);
            return te % 12 ? C.add(j, te, "m") : C.add(j, te / 12, "y"), (j.toJD() - p) * r + Z;
          } catch {
            e.error("invalid ms " + K + " in calendar " + V);
          }
          var J = new Date(K + G);
          return J.setUTCMonth(J.getUTCMonth() + te) + Z - G;
        }, L.findExactDates = function(K, te) {
          for (var V = 0, Z = 0, Y = 0, C = 0, j, J, ne = h(te) && l.getComponentMethod("calendars", "getCal")(te), ae = 0; ae < K.length; ae++) {
            if (J = K[ae], !n(J)) {
              C++;
              continue;
            }
            if (!(J % r)) if (ne) try {
              j = ne.fromJD(J / r + p), j.day() === 1 ? j.month() === 1 ? V++ : Z++ : Y++;
            } catch {
            }
            else j = new Date(J), j.getUTCDate() === 1 ? j.getUTCMonth() === 0 ? V++ : Z++ : Y++;
          }
          Z += V, Y += Z;
          var se = K.length - C;
          return { exactYears: V / se, exactMonths: Z / se, exactDays: Y / se };
        };
      }), Jl = xe((L, k) => {
        k.exports = function(n) {
          return n;
        };
      }), $l = xe((L) => {
        var k = xr(), n = za(), e = Jl(), a = Yr().BADNUM, i = 1e-9;
        L.findBin = function(t, p, l) {
          if (k(p.start)) return l ? Math.ceil((t - p.start) / p.size - i) - 1 : Math.floor((t - p.start) / p.size + i);
          var f = 0, v = p.length, g = 0, x = v > 1 ? (p[v - 1] - p[0]) / (v - 1) : 1, h, m;
          for (x >= 0 ? m = l ? o : r : m = l ? c : s, t += x * i * (l ? -1 : 1) * (x >= 0 ? 1 : -1); f < v && g++ < 100; ) h = Math.floor((f + v) / 2), m(p[h], t) ? f = h + 1 : v = h;
          return g > 90 && n.log("Long binary search..."), f - 1;
        };
        function o(t, p) {
          return t < p;
        }
        function r(t, p) {
          return t <= p;
        }
        function s(t, p) {
          return t > p;
        }
        function c(t, p) {
          return t >= p;
        }
        L.sorterAsc = function(t, p) {
          return t - p;
        }, L.sorterDes = function(t, p) {
          return p - t;
        }, L.distinctVals = function(t) {
          var p = t.slice();
          p.sort(L.sorterAsc);
          var l;
          for (l = p.length - 1; l > -1 && p[l] === a; l--) ;
          for (var f = p[l] - p[0] || 1, v = f / (l || 1) / 1e4, g = [], x, h = 0; h <= l; h++) {
            var m = p[h], u = m - x;
            x === void 0 ? (g.push(m), x = m) : u > v && (f = Math.min(f, u), g.push(m), x = m);
          }
          return { vals: g, minDiff: f };
        }, L.roundUp = function(t, p, l) {
          for (var f = 0, v = p.length - 1, g, x = 0, h = l ? 0 : 1, m = l ? 1 : 0, u = l ? Math.ceil : Math.floor; f < v && x++ < 100; ) g = u((f + v) / 2), p[g] <= t ? f = g + h : v = g - m;
          return p[f];
        }, L.sort = function(t, p) {
          for (var l = 0, f = 0, v = 1; v < t.length; v++) {
            var g = p(t[v], t[v - 1]);
            if (g < 0 ? l = 1 : g > 0 && (f = 1), l && f) return t.sort(p);
          }
          return f ? t : t.reverse();
        }, L.findIndexOfMin = function(t, p) {
          p = p || e;
          for (var l = 1 / 0, f, v = 0; v < t.length; v++) {
            var g = p(t[v]);
            g < l && (l = g, f = v);
          }
          return f;
        };
      }), Kl = xe((L, k) => {
        k.exports = function(n) {
          return Object.keys(n).sort();
        };
      }), nd = xe((L) => {
        var k = xr(), n = Hn().isArrayOrTypedArray;
        L.aggNums = function(e, a, i, o) {
          var r, s;
          if ((!o || o > i.length) && (o = i.length), k(a) || (a = !1), n(i[0])) {
            for (s = new Array(o), r = 0; r < o; r++) s[r] = L.aggNums(e, a, i[r]);
            i = s;
          }
          for (r = 0; r < o; r++) k(a) ? k(i[r]) && (a = e(+a, +i[r])) : a = i[r];
          return a;
        }, L.len = function(e) {
          return L.aggNums(function(a) {
            return a + 1;
          }, 0, e);
        }, L.mean = function(e, a) {
          return a || (a = L.len(e)), L.aggNums(function(i, o) {
            return i + o;
          }, 0, e) / a;
        }, L.geometricMean = function(e, a) {
          return a || (a = L.len(e)), Math.pow(L.aggNums(function(i, o) {
            return i * o;
          }, 1, e), 1 / a);
        }, L.midRange = function(e) {
          if (!(e === void 0 || e.length === 0)) return (L.aggNums(Math.max, null, e) + L.aggNums(Math.min, null, e)) / 2;
        }, L.variance = function(e, a, i) {
          return a || (a = L.len(e)), k(i) || (i = L.mean(e, a)), L.aggNums(function(o, r) {
            return o + Math.pow(r - i, 2);
          }, 0, e) / a;
        }, L.stdev = function(e, a, i) {
          return Math.sqrt(L.variance(e, a, i));
        }, L.median = function(e) {
          var a = e.slice().sort();
          return L.interp(a, 0.5);
        }, L.interp = function(e, a) {
          if (!k(a)) throw "n should be a finite number";
          if (a = a * e.length - 0.5, a < 0) return e[0];
          if (a > e.length - 1) return e[e.length - 1];
          var i = a % 1;
          return i * e[Math.ceil(a)] + (1 - i) * e[Math.floor(a)];
        };
      }), ad = xe((L, k) => {
        var n = Xa(), e = n.mod, a = n.modHalf, i = Math.PI, o = 2 * i;
        function r(m) {
          return m / 180 * i;
        }
        function s(m) {
          return m / i * 180;
        }
        function c(m) {
          return Math.abs(m[1] - m[0]) > o - 1e-14;
        }
        function t(m, u) {
          return a(u - m, o);
        }
        function p(m, u) {
          return Math.abs(t(m, u));
        }
        function l(m, u) {
          if (c(u)) return !0;
          var d, y;
          u[0] < u[1] ? (d = u[0], y = u[1]) : (d = u[1], y = u[0]), d = e(d, o), y = e(y, o), d > y && (y += o);
          var _ = e(m, o), T = _ + o;
          return _ >= d && _ <= y || T >= d && T <= y;
        }
        function f(m, u, d, y) {
          if (!l(u, y)) return !1;
          var _, T;
          return d[0] < d[1] ? (_ = d[0], T = d[1]) : (_ = d[1], T = d[0]), m >= _ && m <= T;
        }
        function v(m, u, d, y, _, T, R) {
          _ = _ || 0, T = T || 0;
          var I = c([d, y]), P, M, B, z, q;
          I ? (P = 0, M = i, B = o) : d < y ? (P = d, B = y) : (P = y, B = d), m < u ? (z = m, q = u) : (z = u, q = m);
          function U(V, Z) {
            return [V * Math.cos(Z) + _, T - V * Math.sin(Z)];
          }
          var G = Math.abs(B - P) <= i ? 0 : 1;
          function K(V, Z, Y) {
            return "A" + [V, V] + " " + [0, G, Y] + " " + U(V, Z);
          }
          var te;
          return I ? z === null ? te = "M" + U(q, P) + K(q, M, 0) + K(q, B, 0) + "Z" : te = "M" + U(z, P) + K(z, M, 0) + K(z, B, 0) + "ZM" + U(q, P) + K(q, M, 1) + K(q, B, 1) + "Z" : z === null ? (te = "M" + U(q, P) + K(q, B, 0), R && (te += "L0,0Z")) : te = "M" + U(z, P) + "L" + U(q, P) + K(q, B, 0) + "L" + U(z, B) + K(z, P, 1) + "Z", te;
        }
        function g(m, u, d, y, _) {
          return v(null, m, u, d, y, _, 0);
        }
        function x(m, u, d, y, _) {
          return v(null, m, u, d, y, _, 1);
        }
        function h(m, u, d, y, _, T) {
          return v(m, u, d, y, _, T, 1);
        }
        k.exports = { deg2rad: r, rad2deg: s, angleDelta: t, angleDist: p, isFullCircle: c, isAngleInsideSector: l, isPtInsideSector: f, pathArc: g, pathSector: x, pathAnnulus: h };
      }), id = xe((L) => {
        L.isLeftAnchor = function(k) {
          return k.xanchor === "left" || k.xanchor === "auto" && k.x <= 1 / 3;
        }, L.isCenterAnchor = function(k) {
          return k.xanchor === "center" || k.xanchor === "auto" && k.x > 1 / 3 && k.x < 2 / 3;
        }, L.isRightAnchor = function(k) {
          return k.xanchor === "right" || k.xanchor === "auto" && k.x >= 2 / 3;
        }, L.isTopAnchor = function(k) {
          return k.yanchor === "top" || k.yanchor === "auto" && k.y >= 2 / 3;
        }, L.isMiddleAnchor = function(k) {
          return k.yanchor === "middle" || k.yanchor === "auto" && k.y > 1 / 3 && k.y < 2 / 3;
        }, L.isBottomAnchor = function(k) {
          return k.yanchor === "bottom" || k.yanchor === "auto" && k.y <= 1 / 3;
        };
      }), od = xe((L) => {
        var k = Xa().mod;
        L.segmentsIntersect = n;
        function n(r, s, c, t, p, l, f, v) {
          var g = c - r, x = p - r, h = f - p, m = t - s, u = l - s, d = v - l, y = g * d - h * m;
          if (y === 0) return null;
          var _ = (x * d - h * u) / y, T = (x * m - g * u) / y;
          return T < 0 || T > 1 || _ < 0 || _ > 1 ? null : { x: r + g * _, y: s + m * _ };
        }
        L.segmentDistance = function(r, s, c, t, p, l, f, v) {
          if (n(r, s, c, t, p, l, f, v)) return 0;
          var g = c - r, x = t - s, h = f - p, m = v - l, u = g * g + x * x, d = h * h + m * m, y = Math.min(e(g, x, u, p - r, l - s), e(g, x, u, f - r, v - s), e(h, m, d, r - p, s - l), e(h, m, d, c - p, t - l));
          return Math.sqrt(y);
        };
        function e(r, s, c, t, p) {
          var l = t * r + p * s;
          if (l < 0) return t * t + p * p;
          if (l > c) {
            var f = t - r, v = p - s;
            return f * f + v * v;
          } else {
            var g = t * s - p * r;
            return g * g / c;
          }
        }
        var a, i, o;
        L.getTextLocation = function(r, s, c, t) {
          if ((r !== i || t !== o) && (a = {}, i = r, o = t), a[c]) return a[c];
          var p = r.getPointAtLength(k(c - t / 2, s)), l = r.getPointAtLength(k(c + t / 2, s)), f = Math.atan((l.y - p.y) / (l.x - p.x)), v = r.getPointAtLength(k(c, s)), g = (v.x * 4 + p.x + l.x) / 6, x = (v.y * 4 + p.y + l.y) / 6, h = { x: g, y: x, theta: f };
          return a[c] = h, h;
        }, L.clearLocationCache = function() {
          i = null;
        }, L.getVisibleSegment = function(r, s, c) {
          var t = s.left, p = s.right, l = s.top, f = s.bottom, v = 0, g = r.getTotalLength(), x = g, h, m;
          function u(y) {
            var _ = r.getPointAtLength(y);
            y === 0 ? h = _ : y === g && (m = _);
            var T = _.x < t ? t - _.x : _.x > p ? _.x - p : 0, R = _.y < l ? l - _.y : _.y > f ? _.y - f : 0;
            return Math.sqrt(T * T + R * R);
          }
          for (var d = u(v); d; ) {
            if (v += d + c, v > x) return;
            d = u(v);
          }
          for (d = u(x); d; ) {
            if (x -= d + c, v > x) return;
            d = u(x);
          }
          return { min: v, max: x, len: x - v, total: g, isClosed: v === 0 && x === g && Math.abs(h.x - m.x) < 0.1 && Math.abs(h.y - m.y) < 0.1 };
        }, L.findPointOnPath = function(r, s, c, t) {
          t = t || {};
          for (var p = t.pathLength || r.getTotalLength(), l = t.tolerance || 1e-3, f = t.iterationLimit || 30, v = r.getPointAtLength(0)[c] > r.getPointAtLength(p)[c] ? -1 : 1, g = 0, x = 0, h = p, m, u, d; g < f; ) {
            if (m = (x + h) / 2, u = r.getPointAtLength(m), d = u[c] - s, Math.abs(d) < l) return u;
            v * d > 0 ? h = m : x = m, g++;
          }
          return u;
        };
      }), ho = xe((L) => {
        var k = {};
        L.throttle = function(e, a, i) {
          var o = k[e], r = Date.now();
          if (!o) {
            for (var s in k) k[s].ts < r - 6e4 && delete k[s];
            o = k[e] = { ts: 0, timer: null };
          }
          n(o);
          function c() {
            i(), o.ts = Date.now(), o.onDone && (o.onDone(), o.onDone = null);
          }
          if (r > o.ts + a) {
            c();
            return;
          }
          o.timer = setTimeout(function() {
            c(), o.timer = null;
          }, a);
        }, L.done = function(e) {
          var a = k[e];
          return !a || !a.timer ? Promise.resolve() : new Promise(function(i) {
            var o = a.onDone;
            a.onDone = function() {
              o && o(), i(), a.onDone = null;
            };
          });
        }, L.clear = function(e) {
          if (e) n(k[e]), delete k[e];
          else for (var a in k) L.clear(a);
        };
        function n(e) {
          e && e.timer !== null && (clearTimeout(e.timer), e.timer = null);
        }
      }), ld = xe((L, k) => {
        k.exports = function(n) {
          n._responsiveChartHandler && (window.removeEventListener("resize", n._responsiveChartHandler), delete n._responsiveChartHandler);
        };
      }), sd = xe((L, k) => {
        k.exports = i, k.exports.isMobile = i, k.exports.default = i;
        var n = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, e = /CrOS/, a = /android|ipad|playbook|silk/i;
        function i(o) {
          o || (o = {});
          let r = o.ua;
          if (!r && typeof navigator < "u" && (r = navigator.userAgent), r && r.headers && typeof r.headers["user-agent"] == "string" && (r = r.headers["user-agent"]), typeof r != "string") return !1;
          let s = n.test(r) && !e.test(r) || !!o.tablet && a.test(r);
          return !s && o.tablet && o.featureDetect && navigator && navigator.maxTouchPoints > 1 && r.indexOf("Macintosh") !== -1 && r.indexOf("Safari") !== -1 && (s = !0), s;
        }
      }), ud = xe((L, k) => {
        var n = xr(), e = sd();
        k.exports = function(i) {
          var o;
          if (i && i.hasOwnProperty("userAgent") ? o = i.userAgent : o = a(), typeof o != "string") return !0;
          var r = e({ ua: { headers: { "user-agent": o } }, tablet: !0, featureDetect: !1 });
          if (!r) for (var s = o.split(" "), c = 1; c < s.length; c++) {
            var t = s[c];
            if (t.indexOf("Safari") !== -1) for (var p = c - 1; p > -1; p--) {
              var l = s[p];
              if (l.substr(0, 8) === "Version/") {
                var f = l.substr(8).split(".")[0];
                if (n(f) && (f = +f), f >= 13) return !0;
              }
            }
          }
          return r;
        };
        function a() {
          var i;
          return typeof navigator < "u" && (i = navigator.userAgent), i && i.headers && typeof i.headers["user-agent"] == "string" && (i = i.headers["user-agent"]), i;
        }
      }), cd = xe((L, k) => {
        var n = vr();
        k.exports = function(e, a, i) {
          var o = e.selectAll("g." + i.replace(/\s/g, ".")).data(a, function(s) {
            return s[0].trace.uid;
          });
          o.exit().remove(), o.enter().append("g").attr("class", i), o.order();
          var r = e.classed("rangeplot") ? "nodeRangePlot3" : "node3";
          return o.each(function(s) {
            s[0][r] = n.select(this);
          }), o;
        };
      }), fd = xe((L, k) => {
        var n = or();
        k.exports = function(e, a) {
          for (var i = e._context.locale, o = 0; o < 2; o++) {
            for (var r = e._context.locales, s = 0; s < 2; s++) {
              var c = (r[i] || {}).dictionary;
              if (c) {
                var t = c[a];
                if (t) return t;
              }
              r = n.localeRegistry;
            }
            var p = i.split("-")[0];
            if (p === i) break;
            i = p;
          }
          return a;
        };
      }), dd = xe((L, k) => {
        k.exports = function(n) {
          for (var e = {}, a = [], i = 0, o = 0; o < n.length; o++) {
            var r = n[o];
            e[r] !== 1 && (e[r] = 1, a[i++] = r);
          }
          return a;
        };
      }), pd = xe((L, k) => {
        k.exports = function(i) {
          for (var o = a(i) ? e : n, r = [], s = 0; s < i.length; s++) {
            var c = i[s];
            o(c) && r.push(c);
          }
          return r;
        };
        function n(i) {
          return i.visible === !0;
        }
        function e(i) {
          var o = i[0].trace;
          return o.visible === !0 && o._length !== 0;
        }
        function a(i) {
          return Array.isArray(i) && Array.isArray(i[0]) && i[0][0] && i[0][0].trace;
        }
      }), hd = xe((L, k) => {
        k.exports = function(n, e) {
          if (!e) return n;
          var a = 1 / Math.abs(e), i = a > 1 ? (a * n + a * e) / a : n + e, o = String(i).length;
          if (o > 16) {
            var r = String(e).length, s = String(n).length;
            if (o >= s + r) {
              var c = parseFloat(i).toPrecision(12);
              c.indexOf("e+") === -1 && (i = +c);
            }
          }
          return i;
        };
      }), vd = xe((L, k) => {
        var n = xr(), e = Yr().BADNUM, a = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
        k.exports = function(i) {
          return typeof i == "string" && (i = i.replace(a, "")), n(i) ? Number(i) : e;
        };
      }), wt = xe((L, k) => {
        var n = vr(), e = Wa().utcFormat, a = Ul().format, i = xr(), o = Yr(), r = o.FP_SAFE, s = -r, c = o.BADNUM, t = k.exports = {};
        t.adjustFormat = function(E) {
          return !E || /^\d[.]\df/.test(E) || /[.]\d%/.test(E) ? E : E === "0.f" ? "~f" : /^\d%/.test(E) ? "~%" : /^\ds/.test(E) ? "~s" : !/^[~,.0$]/.test(E) && /[&fps]/.test(E) ? "~" + E : E;
        };
        var p = {};
        t.warnBadFormat = function(E) {
          var w = String(E);
          p[w] || (p[w] = 1, t.warn('encountered bad format: "' + w + '"'));
        }, t.noFormat = function(E) {
          return String(E);
        }, t.numberFormat = function(E) {
          var w;
          try {
            w = a(t.adjustFormat(E));
          } catch {
            return t.warnBadFormat(E), t.noFormat;
          }
          return w;
        }, t.nestedProperty = io(), t.keyedContainer = _f(), t.relativeAttr = wf(), t.isPlainObject = ka(), t.toLogRange = oo(), t.relinkPrivateKeys = Tf();
        var l = Hn();
        t.isArrayBuffer = l.isArrayBuffer, t.isTypedArray = l.isTypedArray, t.isArrayOrTypedArray = l.isArrayOrTypedArray, t.isArray1D = l.isArray1D, t.ensureArray = l.ensureArray, t.concat = l.concat, t.maxRowLength = l.maxRowLength, t.minRowLength = l.minRowLength;
        var f = Xa();
        t.mod = f.mod, t.modHalf = f.modHalf;
        var v = kf();
        t.valObjectMeta = v.valObjectMeta, t.coerce = v.coerce, t.coerce2 = v.coerce2, t.coerceFont = v.coerceFont, t.coercePattern = v.coercePattern, t.coerceHoverinfo = v.coerceHoverinfo, t.coerceSelectionMarkerOpacity = v.coerceSelectionMarkerOpacity, t.validate = v.validate;
        var g = rd();
        t.dateTime2ms = g.dateTime2ms, t.isDateTime = g.isDateTime, t.ms2DateTime = g.ms2DateTime, t.ms2DateTimeLocal = g.ms2DateTimeLocal, t.cleanDate = g.cleanDate, t.isJSDate = g.isJSDate, t.formatDate = g.formatDate, t.incrementMonth = g.incrementMonth, t.dateTick0 = g.dateTick0, t.dfltRange = g.dfltRange, t.findExactDates = g.findExactDates, t.MIN_MS = g.MIN_MS, t.MAX_MS = g.MAX_MS;
        var x = $l();
        t.findBin = x.findBin, t.sorterAsc = x.sorterAsc, t.sorterDes = x.sorterDes, t.distinctVals = x.distinctVals, t.roundUp = x.roundUp, t.sort = x.sort, t.findIndexOfMin = x.findIndexOfMin, t.sortObjectKeys = Kl();
        var h = nd();
        t.aggNums = h.aggNums, t.len = h.len, t.mean = h.mean, t.geometricMean = h.geometricMean, t.median = h.median, t.midRange = h.midRange, t.variance = h.variance, t.stdev = h.stdev, t.interp = h.interp;
        var m = co();
        t.init2dArray = m.init2dArray, t.transposeRagged = m.transposeRagged, t.dot = m.dot, t.translationMatrix = m.translationMatrix, t.rotationMatrix = m.rotationMatrix, t.rotationXYMatrix = m.rotationXYMatrix, t.apply3DTransform = m.apply3DTransform, t.apply2DTransform = m.apply2DTransform, t.apply2DTransform2 = m.apply2DTransform2, t.convertCssMatrix = m.convertCssMatrix, t.inverseTransformMatrix = m.inverseTransformMatrix;
        var u = ad();
        t.deg2rad = u.deg2rad, t.rad2deg = u.rad2deg, t.angleDelta = u.angleDelta, t.angleDist = u.angleDist, t.isFullCircle = u.isFullCircle, t.isAngleInsideSector = u.isAngleInsideSector, t.isPtInsideSector = u.isPtInsideSector, t.pathArc = u.pathArc, t.pathSector = u.pathSector, t.pathAnnulus = u.pathAnnulus;
        var d = id();
        t.isLeftAnchor = d.isLeftAnchor, t.isCenterAnchor = d.isCenterAnchor, t.isRightAnchor = d.isRightAnchor, t.isTopAnchor = d.isTopAnchor, t.isMiddleAnchor = d.isMiddleAnchor, t.isBottomAnchor = d.isBottomAnchor;
        var y = od();
        t.segmentsIntersect = y.segmentsIntersect, t.segmentDistance = y.segmentDistance, t.getTextLocation = y.getTextLocation, t.clearLocationCache = y.clearLocationCache, t.getVisibleSegment = y.getVisibleSegment, t.findPointOnPath = y.findPointOnPath;
        var _ = Br();
        t.extendFlat = _.extendFlat, t.extendDeep = _.extendDeep, t.extendDeepAll = _.extendDeepAll, t.extendDeepNoArrays = _.extendDeepNoArrays;
        var T = za();
        t.log = T.log, t.warn = T.warn, t.error = T.error;
        var R = $a();
        t.counterRegex = R.counter;
        var I = ho();
        t.throttle = I.throttle, t.throttleDone = I.done, t.clearThrottle = I.clear;
        var P = _i();
        t.getGraphDiv = P.getGraphDiv, t.isPlotDiv = P.isPlotDiv, t.removeElement = P.removeElement, t.addStyleRule = P.addStyleRule, t.addRelatedStyleRule = P.addRelatedStyleRule, t.deleteRelatedStyleRule = P.deleteRelatedStyleRule, t.setStyleOnHover = P.setStyleOnHover, t.getFullTransformMatrix = P.getFullTransformMatrix, t.getElementTransformMatrix = P.getElementTransformMatrix, t.getElementAndAncestors = P.getElementAndAncestors, t.equalDomRects = P.equalDomRects, t.clearResponsive = ld(), t.preserveDrawingBuffer = ud(), t.makeTraceGroups = cd(), t._ = fd(), t.notifier = Yl(), t.filterUnique = dd(), t.filterVisible = pd(), t.pushUnique = Gl(), t.increment = hd(), t.cleanNumber = vd(), t.ensureNumber = function(E) {
          return i(E) ? (E = Number(E), E > r || E < s ? c : E) : c;
        }, t.isIndex = function(E, w) {
          return w !== void 0 && E >= w ? !1 : i(E) && E >= 0 && E % 1 === 0;
        }, t.noop = uo(), t.identity = Jl(), t.repeat = function(E, w) {
          for (var N = new Array(w), W = 0; W < w; W++) N[W] = E;
          return N;
        }, t.swapAttrs = function(E, w, N, W) {
          N || (N = "x"), W || (W = "y");
          for (var ee = 0; ee < w.length; ee++) {
            var le = w[ee], ie = t.nestedProperty(E, le.replace("?", N)), pe = t.nestedProperty(E, le.replace("?", W)), _e = ie.get();
            ie.set(pe.get()), pe.set(_e);
          }
        }, t.raiseToTop = function(E) {
          E.parentNode.appendChild(E);
        }, t.cancelTransition = function(E) {
          return E.transition().duration(0);
        }, t.constrain = function(E, w, N) {
          return w > N ? Math.max(N, Math.min(w, E)) : Math.max(w, Math.min(N, E));
        }, t.bBoxIntersect = function(E, w, N) {
          return N = N || 0, E.left <= w.right + N && w.left <= E.right + N && E.top <= w.bottom + N && w.top <= E.bottom + N;
        }, t.simpleMap = function(E, w, N, W, ee) {
          for (var le = E.length, ie = new Array(le), pe = 0; pe < le; pe++) ie[pe] = w(E[pe], N, W, ee);
          return ie;
        }, t.randstr = function E(w, N, W, ee) {
          if (W || (W = 16), N === void 0 && (N = 24), N <= 0) return "0";
          var le = Math.log(Math.pow(2, N)) / Math.log(W), ie = "", pe, _e, Ae;
          for (pe = 2; le === 1 / 0; pe *= 2) le = Math.log(Math.pow(2, N / pe)) / Math.log(W) * pe;
          var Ce = le - Math.floor(le);
          for (pe = 0; pe < Math.floor(le); pe++) Ae = Math.floor(Math.random() * W).toString(W), ie = Ae + ie;
          Ce && (_e = Math.pow(W, Ce), Ae = Math.floor(Math.random() * _e).toString(W), ie = Ae + ie);
          var Ue = parseInt(ie, W);
          return w && w[ie] || Ue !== 1 / 0 && Ue >= Math.pow(2, N) ? ee > 10 ? (t.warn("randstr failed uniqueness"), ie) : E(w, N, W, (ee || 0) + 1) : ie;
        }, t.OptionControl = function(E, w) {
          E || (E = {}), w || (w = "opt");
          var N = {};
          return N.optionList = [], N._newoption = function(W) {
            W[w] = E, N[W.name] = W, N.optionList.push(W);
          }, N["_" + w] = E, N;
        }, t.smooth = function(E, w) {
          if (w = Math.round(w) || 0, w < 2) return E;
          var N = E.length, W = 2 * N, ee = 2 * w - 1, le = new Array(ee), ie = new Array(N), pe, _e, Ae, Ce;
          for (pe = 0; pe < ee; pe++) le[pe] = (1 - Math.cos(Math.PI * (pe + 1) / w)) / (2 * w);
          for (pe = 0; pe < N; pe++) {
            for (Ce = 0, _e = 0; _e < ee; _e++) Ae = pe + _e + 1 - w, Ae < -N ? Ae -= W * Math.round(Ae / W) : Ae >= W && (Ae -= W * Math.floor(Ae / W)), Ae < 0 ? Ae = -1 - Ae : Ae >= N && (Ae = W - 1 - Ae), Ce += E[Ae] * le[_e];
            ie[pe] = Ce;
          }
          return ie;
        }, t.syncOrAsync = function(E, w, N) {
          var W, ee;
          function le() {
            return t.syncOrAsync(E, w, N);
          }
          for (; E.length; ) if (ee = E.splice(0, 1)[0], W = ee(w), W && W.then) return W.then(le);
          return N && N(w);
        }, t.stripTrailingSlash = function(E) {
          return E.substr(-1) === "/" ? E.substr(0, E.length - 1) : E;
        }, t.noneOrAll = function(E, w, N) {
          if (E) {
            var W = !1, ee = !0, le, ie;
            for (le = 0; le < N.length; le++) ie = E[N[le]], ie != null ? W = !0 : ee = !1;
            if (W && !ee) for (le = 0; le < N.length; le++) E[N[le]] = w[N[le]];
          }
        }, t.mergeArray = function(E, w, N, W) {
          var ee = typeof W == "function";
          if (t.isArrayOrTypedArray(E)) for (var le = Math.min(E.length, w.length), ie = 0; ie < le; ie++) {
            var pe = E[ie];
            w[ie][N] = ee ? W(pe) : pe;
          }
        }, t.mergeArrayCastPositive = function(E, w, N) {
          return t.mergeArray(E, w, N, function(W) {
            var ee = +W;
            return isFinite(ee) && ee > 0 ? ee : 0;
          });
        }, t.fillArray = function(E, w, N, W) {
          if (W = W || t.identity, t.isArrayOrTypedArray(E)) for (var ee = 0; ee < w.length; ee++) w[ee][N] = W(E[ee]);
        }, t.castOption = function(E, w, N, W) {
          W = W || t.identity;
          var ee = t.nestedProperty(E, N).get();
          return t.isArrayOrTypedArray(ee) ? Array.isArray(w) && t.isArrayOrTypedArray(ee[w[0]]) ? W(ee[w[0]][w[1]]) : W(ee[w]) : ee;
        }, t.extractOption = function(E, w, N, W) {
          if (N in E) return E[N];
          var ee = t.nestedProperty(w, W).get();
          if (!Array.isArray(ee)) return ee;
        };
        function M(E) {
          var w = {};
          for (var N in E) for (var W = E[N], ee = 0; ee < W.length; ee++) w[W[ee]] = +N;
          return w;
        }
        t.tagSelected = function(E, w, N) {
          var W = w.selectedpoints, ee = w._indexToPoints, le;
          ee && (le = M(ee));
          function ie(Ue) {
            return Ue !== void 0 && Ue < E.length;
          }
          for (var pe = 0; pe < W.length; pe++) {
            var _e = W[pe];
            if (t.isIndex(_e) || t.isArrayOrTypedArray(_e) && t.isIndex(_e[0]) && t.isIndex(_e[1])) {
              var Ae = le ? le[_e] : _e, Ce = N ? N[Ae] : Ae;
              ie(Ce) && (E[Ce].selected = 1);
            }
          }
        }, t.selIndices2selPoints = function(E) {
          var w = E.selectedpoints, N = E._indexToPoints;
          if (N) {
            for (var W = M(N), ee = [], le = 0; le < w.length; le++) {
              var ie = w[le];
              if (t.isIndex(ie)) {
                var pe = W[ie];
                t.isIndex(pe) && ee.push(pe);
              }
            }
            return ee;
          } else return w;
        }, t.getTargetArray = function(E, w) {
          var N = w.target;
          if (typeof N == "string" && N) {
            var W = t.nestedProperty(E, N).get();
            return t.isArrayOrTypedArray(W) ? W : !1;
          } else if (t.isArrayOrTypedArray(N)) return N;
          return !1;
        };
        function B(E, w, N) {
          var W = {};
          typeof w != "object" && (w = {});
          var ee = N === "pieLike" ? -1 : 3, le = Object.keys(E), ie, pe, _e;
          for (ie = 0; ie < le.length; ie++) pe = le[ie], _e = E[pe], !(pe.charAt(0) === "_" || typeof _e == "function") && (pe === "module" ? W[pe] = _e : Array.isArray(_e) ? pe === "colorscale" || ee === -1 ? W[pe] = _e.slice() : W[pe] = _e.slice(0, ee) : t.isTypedArray(_e) ? ee === -1 ? W[pe] = _e.subarray() : W[pe] = _e.subarray(0, ee) : _e && typeof _e == "object" ? W[pe] = B(E[pe], w[pe], N) : W[pe] = _e);
          for (le = Object.keys(w), ie = 0; ie < le.length; ie++) pe = le[ie], _e = w[pe], (typeof _e != "object" || !(pe in W) || typeof W[pe] != "object") && (W[pe] = _e);
          return W;
        }
        t.minExtend = B, t.titleCase = function(E) {
          return E.charAt(0).toUpperCase() + E.substr(1);
        }, t.containsAny = function(E, w) {
          for (var N = 0; N < w.length; N++) if (E.indexOf(w[N]) !== -1) return !0;
          return !1;
        };
        var z = /Version\/[\d\.]+.*Safari/;
        t.isSafari = function() {
          return z.test(window.navigator.userAgent);
        };
        var q = /iPad|iPhone|iPod/;
        t.isIOS = function() {
          return q.test(window.navigator.userAgent);
        };
        var U = /Macintosh.+AppleWebKit.+Gecko\)$/;
        t.isMacWKWebView = () => U.test(window.navigator.userAgent);
        var G = /Firefox\/(\d+)\.\d+/;
        t.getFirefoxVersion = function() {
          var E = G.exec(window.navigator.userAgent);
          if (E && E.length === 2) {
            var w = parseInt(E[1]);
            if (!isNaN(w)) return w;
          }
          return null;
        }, t.isD3Selection = function(E) {
          return E instanceof n.selection;
        }, t.ensureSingle = function(E, w, N, W) {
          var ee = E.select(w + (N ? "." + N : ""));
          if (ee.size()) return ee;
          var le = E.append(w);
          return N && le.classed(N, !0), W && le.call(W), le;
        }, t.ensureSingleById = function(E, w, N, W) {
          var ee = E.select(w + "#" + N);
          if (ee.size()) return ee;
          var le = E.append(w).attr("id", N);
          return W && le.call(W), le;
        }, t.objectFromPath = function(E, w) {
          for (var N = E.split("."), W, ee = W = {}, le = 0; le < N.length; le++) {
            var ie = N[le], pe = null, _e = N[le].match(/(.*)\[([0-9]+)\]/);
            _e ? (ie = _e[1], pe = _e[2], W = W[ie] = [], le === N.length - 1 ? W[pe] = w : W[pe] = {}, W = W[pe]) : (le === N.length - 1 ? W[ie] = w : W[ie] = {}, W = W[ie]);
          }
          return ee;
        };
        var K = /^([^\[\.]+)\.(.+)?/, te = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
        function V(E) {
          return E.slice(0, 2) === "__";
        }
        t.expandObjectPaths = function(E) {
          var w, N, W, ee, le, ie, pe;
          if (typeof E == "object" && !Array.isArray(E)) {
            for (N in E) if (E.hasOwnProperty(N)) if (w = N.match(K)) {
              if (ee = E[N], W = w[1], V(W)) continue;
              delete E[N], E[W] = t.extendDeepNoArrays(E[W] || {}, t.objectFromPath(N, t.expandObjectPaths(ee))[W]);
            } else if (w = N.match(te)) {
              if (ee = E[N], W = w[1], V(W)) continue;
              if (le = parseInt(w[2]), delete E[N], E[W] = E[W] || [], w[3] === ".") pe = w[4], ie = E[W][le] = E[W][le] || {}, t.extendDeepNoArrays(ie, t.objectFromPath(pe, t.expandObjectPaths(ee)));
              else {
                if (V(W)) continue;
                E[W][le] = t.expandObjectPaths(ee);
              }
            } else {
              if (V(N)) continue;
              E[N] = t.expandObjectPaths(E[N]);
            }
          }
          return E;
        }, t.numSeparate = function(E, w, N) {
          if (N || (N = !1), typeof w != "string" || w.length === 0) throw new Error("Separator string required for formatting!");
          typeof E == "number" && (E = String(E));
          var W = /(\d+)(\d{3})/, ee = w.charAt(0), le = w.charAt(1), ie = E.split("."), pe = ie[0], _e = ie.length > 1 ? ee + ie[1] : "";
          if (le && (ie.length > 1 || pe.length > 4 || N)) for (; W.test(pe); ) pe = pe.replace(W, "$1" + le + "$2");
          return pe + _e;
        }, t.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
        var Z = /^\w*$/;
        t.templateString = function(E, w) {
          var N = {};
          return E.replace(t.TEMPLATE_STRING_REGEX, function(W, ee) {
            var le;
            return Z.test(ee) ? le = w[ee] : (N[ee] = N[ee] || t.nestedProperty(w, ee).get, le = N[ee](!0)), le !== void 0 ? le : "";
          });
        };
        var Y = { max: 10, count: 0, name: "hovertemplate" };
        t.hovertemplateString = (E) => se(no(Za({}, E), { opts: Y }));
        var C = { max: 10, count: 0, name: "texttemplate" };
        t.texttemplateString = (E) => se(no(Za({}, E), { opts: C }));
        var j = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/;
        function J(E) {
          var w = E.match(j);
          return w ? { key: w[1], op: w[2], number: Number(w[3]) } : { key: E, op: null, number: null };
        }
        var ne = { max: 10, count: 0, name: "texttemplate", parseMultDiv: !0 };
        t.texttemplateStringForShapes = (E) => se(no(Za({}, E), { opts: ne }));
        var ae = /^[:|\|]/;
        function se({ data: E = [], locale: w, fallback: N, labels: W = {}, opts: ee, template: le }) {
          return le.replace(t.TEMPLATE_STRING_REGEX, (ie, pe, _e) => {
            let Ae = ["xother", "yother"].includes(pe), Ce = ["_xother", "_yother"].includes(pe), Ue = ["_xother_", "_yother_"].includes(pe), Ne = ["xother_", "yother_"].includes(pe), ke = Ae || Ce || Ne || Ue;
            (Ce || Ue) && (pe = pe.substring(1)), (Ne || Ue) && (pe = pe.substring(0, pe.length - 1));
            let A = null, X = null;
            if (ee.parseMultDiv) {
              var H = J(pe);
              pe = H.key, A = H.op, X = H.number;
            }
            let ve;
            if (ke) {
              if (W[pe] === void 0) return "";
              ve = W[pe];
            } else for (let He of E) if (He) {
              if (He.hasOwnProperty(pe)) {
                ve = He[pe];
                break;
              }
              if (Z.test(pe) || (ve = t.nestedProperty(He, pe).get(!0)), ve !== void 0) break;
            }
            if (ve === void 0) {
              let { count: He, max: Ze, name: We } = ee, $e = N === !1 ? ie : N;
              return He < Ze && t.warn([`Variable '${pe}' in ${We} could not be found!`, "Please verify that the template is correct.", `Using value: '${$e}'.`].join(" ")), He === Ze && t.warn(`Too many '${We}' warnings - additional warnings will be suppressed.`), ee.count++, $e;
            }
            if (A === "*" && (ve *= X), A === "/" && (ve /= X), _e) {
              var be;
              if (_e[0] === ":" && (be = w ? w.numberFormat : t.numberFormat, ve !== "" && (ve = be(_e.replace(ae, ""))(ve))), _e[0] === "|") {
                be = w ? w.timeFormat : e;
                var Se = t.dateTime2ms(ve);
                ve = t.formatDate(Se, _e.replace(ae, ""), !1, be);
              }
            } else {
              var De = pe + "Label";
              W.hasOwnProperty(De) && (ve = W[De]);
            }
            return ke && (ve = "(" + ve + ")", (Ce || Ue) && (ve = " " + ve), (Ne || Ue) && (ve = ve + " ")), ve;
          });
        }
        var O = 48, F = 57;
        t.subplotSort = function(E, w) {
          for (var N = Math.min(E.length, w.length) + 1, W = 0, ee = 0, le = 0; le < N; le++) {
            var ie = E.charCodeAt(le) || 0, pe = w.charCodeAt(le) || 0, _e = ie >= O && ie <= F, Ae = pe >= O && pe <= F;
            if (_e && (W = 10 * W + ie - O), Ae && (ee = 10 * ee + pe - O), !_e || !Ae) {
              if (W !== ee) return W - ee;
              if (ie !== pe) return ie - pe;
            }
          }
          return ee - W;
        };
        var S = 2e9;
        t.seedPseudoRandom = function() {
          S = 2e9;
        }, t.pseudoRandom = function() {
          var E = S;
          return S = (69069 * S + 1) % 4294967296, Math.abs(S - E) < 429496729 ? t.pseudoRandom() : S / 4294967296;
        }, t.fillText = function(E, w, N) {
          var W = Array.isArray(N) ? function(ie) {
            N.push(ie);
          } : function(ie) {
            N.text = ie;
          }, ee = t.extractOption(E, w, "htx", "hovertext");
          if (t.isValidTextValue(ee)) return W(ee);
          var le = t.extractOption(E, w, "tx", "text");
          if (t.isValidTextValue(le)) return W(le);
        }, t.isValidTextValue = function(E) {
          return E || E === 0;
        }, t.formatPercent = function(E, w) {
          w = w || 0;
          for (var N = (Math.round(100 * E * Math.pow(10, w)) * Math.pow(0.1, w)).toFixed(w) + "%", W = 0; W < w; W++) N.indexOf(".") !== -1 && (N = N.replace("0%", "%"), N = N.replace(".%", "%"));
          return N;
        }, t.isHidden = function(E) {
          var w = window.getComputedStyle(E).display;
          return !w || w === "none";
        }, t.strTranslate = function(E, w) {
          return E || w ? "translate(" + E + "," + w + ")" : "";
        }, t.strRotate = function(E) {
          return E ? "rotate(" + E + ")" : "";
        }, t.strScale = function(E) {
          return E !== 1 ? "scale(" + E + ")" : "";
        }, t.getTextTransform = function(E) {
          var w = E.noCenter, N = E.textX, W = E.textY, ee = E.targetX, le = E.targetY, ie = E.anchorX || 0, pe = E.anchorY || 0, _e = E.rotate, Ae = E.scale;
          return Ae ? Ae > 1 && (Ae = 1) : Ae = 0, t.strTranslate(ee - Ae * (N + ie), le - Ae * (W + pe)) + t.strScale(Ae) + (_e ? "rotate(" + _e + (w ? "" : " " + N + " " + W) + ")" : "");
        }, t.setTransormAndDisplay = function(E, w) {
          E.attr("transform", t.getTextTransform(w)), E.style("display", w.scale ? null : "none");
        }, t.ensureUniformFontSize = function(E, w) {
          var N = t.extendFlat({}, w);
          return N.size = Math.max(w.size, E._fullLayout.uniformtext.minsize || 0), N;
        }, t.join2 = function(E, w, N) {
          var W = E.length;
          return W > 1 ? E.slice(0, -1).join(w) + N + E[W - 1] : E.join(w);
        }, t.bigFont = function(E) {
          return Math.round(1.2 * E);
        };
        var $ = t.getFirefoxVersion(), re = $ !== null && $ < 86;
        t.getPositionFromD3Event = function() {
          return re ? [n.event.layerX, n.event.layerY] : [n.event.offsetX, n.event.offsetY];
        };
      }), gd = xe(() => {
        var L = wt(), k = { "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;', "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;', "X input:focus,X button:focus": "outline:none;", "X a": "text-decoration:none;", "X a:hover": "text-decoration:none;", "X .crisp": "shape-rendering:crispEdges;", "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;", "X svg a": "fill:#447adb;", "X svg a:hover": "fill:#3c6dc5;", "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;", "X .main-svg .draglayer": "pointer-events:all;", "X .cursor-default": "cursor:default;", "X .cursor-pointer": "cursor:pointer;", "X .cursor-crosshair": "cursor:crosshair;", "X .cursor-move": "cursor:move;", "X .cursor-col-resize": "cursor:col-resize;", "X .cursor-row-resize": "cursor:row-resize;", "X .cursor-ns-resize": "cursor:ns-resize;", "X .cursor-ew-resize": "cursor:ew-resize;", "X .cursor-sw-resize": "cursor:sw-resize;", "X .cursor-s-resize": "cursor:s-resize;", "X .cursor-se-resize": "cursor:se-resize;", "X .cursor-w-resize": "cursor:w-resize;", "X .cursor-e-resize": "cursor:e-resize;", "X .cursor-nw-resize": "cursor:nw-resize;", "X .cursor-n-resize": "cursor:n-resize;", "X .cursor-ne-resize": "cursor:ne-resize;", "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;", "X .modebar": "position:absolute;top:2px;right:2px;", "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;", "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;", "X:hover .modebar--hover .modebar-group": "opacity:1;", "X:focus-within .modebar--hover .modebar-group": "opacity:1;", "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;", "X .modebar-group a": "display:grid;place-content:center;", "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;border:none;background:rgba(0,0,0,0);", "X .modebar-btn svg": "position:relative;", "X .modebar-btn:focus-visible": "outline:1px solid #000;outline-offset:1px;border-radius:3px;", "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;", "X .modebar.vertical svg": "top:-1px;", "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;", "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;", "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;", "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;", "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;', "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;", "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;", "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;", Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;', "Y p": "margin:0;", "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;", "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;", "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;" };
        for (e in k) n = e.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier"), L.addStyleRule(n, k[e]);
        var n, e;
      }), Ql = xe((L, k) => {
        k.exports = !0;
      }), es = xe((L, k) => {
        var n = Ql(), e;
        typeof window.matchMedia == "function" ? e = !window.matchMedia("(hover: none)").matches : e = n, k.exports = e;
      }), Ra = xe((L, k) => {
        var n = typeof Reflect == "object" ? Reflect : null, e = n && typeof n.apply == "function" ? n.apply : function(_, T, R) {
          return Function.prototype.apply.call(_, T, R);
        }, a;
        n && typeof n.ownKeys == "function" ? a = n.ownKeys : Object.getOwnPropertySymbols ? a = function(_) {
          return Object.getOwnPropertyNames(_).concat(Object.getOwnPropertySymbols(_));
        } : a = function(_) {
          return Object.getOwnPropertyNames(_);
        };
        function i(_) {
          console && console.warn && console.warn(_);
        }
        var o = Number.isNaN || function(_) {
          return _ !== _;
        };
        function r() {
          r.init.call(this);
        }
        k.exports = r, k.exports.once = u, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._eventsCount = 0, r.prototype._maxListeners = void 0;
        var s = 10;
        function c(_) {
          if (typeof _ != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof _);
        }
        Object.defineProperty(r, "defaultMaxListeners", { enumerable: !0, get: function() {
          return s;
        }, set: function(_) {
          if (typeof _ != "number" || _ < 0 || o(_)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + _ + ".");
          s = _;
        } }), r.init = function() {
          (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, r.prototype.setMaxListeners = function(_) {
          if (typeof _ != "number" || _ < 0 || o(_)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + _ + ".");
          return this._maxListeners = _, this;
        };
        function t(_) {
          return _._maxListeners === void 0 ? r.defaultMaxListeners : _._maxListeners;
        }
        r.prototype.getMaxListeners = function() {
          return t(this);
        }, r.prototype.emit = function(_) {
          for (var T = [], R = 1; R < arguments.length; R++) T.push(arguments[R]);
          var I = _ === "error", P = this._events;
          if (P !== void 0) I = I && P.error === void 0;
          else if (!I) return !1;
          if (I) {
            var M;
            if (T.length > 0 && (M = T[0]), M instanceof Error) throw M;
            var B = new Error("Unhandled error." + (M ? " (" + M.message + ")" : ""));
            throw B.context = M, B;
          }
          var z = P[_];
          if (z === void 0) return !1;
          if (typeof z == "function") e(z, this, T);
          else for (var q = z.length, U = x(z, q), R = 0; R < q; ++R) e(U[R], this, T);
          return !0;
        };
        function p(_, T, R, I) {
          var P, M, B;
          if (c(R), M = _._events, M === void 0 ? (M = _._events = /* @__PURE__ */ Object.create(null), _._eventsCount = 0) : (M.newListener !== void 0 && (_.emit("newListener", T, R.listener ? R.listener : R), M = _._events), B = M[T]), B === void 0) B = M[T] = R, ++_._eventsCount;
          else if (typeof B == "function" ? B = M[T] = I ? [R, B] : [B, R] : I ? B.unshift(R) : B.push(R), P = t(_), P > 0 && B.length > P && !B.warned) {
            B.warned = !0;
            var z = new Error("Possible EventEmitter memory leak detected. " + B.length + " " + String(T) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            z.name = "MaxListenersExceededWarning", z.emitter = _, z.type = T, z.count = B.length, i(z);
          }
          return _;
        }
        r.prototype.addListener = function(_, T) {
          return p(this, _, T, !1);
        }, r.prototype.on = r.prototype.addListener, r.prototype.prependListener = function(_, T) {
          return p(this, _, T, !0);
        };
        function l() {
          if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function f(_, T, R) {
          var I = { fired: !1, wrapFn: void 0, target: _, type: T, listener: R }, P = l.bind(I);
          return P.listener = R, I.wrapFn = P, P;
        }
        r.prototype.once = function(_, T) {
          return c(T), this.on(_, f(this, _, T)), this;
        }, r.prototype.prependOnceListener = function(_, T) {
          return c(T), this.prependListener(_, f(this, _, T)), this;
        }, r.prototype.removeListener = function(_, T) {
          var R, I, P, M, B;
          if (c(T), I = this._events, I === void 0) return this;
          if (R = I[_], R === void 0) return this;
          if (R === T || R.listener === T) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete I[_], I.removeListener && this.emit("removeListener", _, R.listener || T));
          else if (typeof R != "function") {
            for (P = -1, M = R.length - 1; M >= 0; M--) if (R[M] === T || R[M].listener === T) {
              B = R[M].listener, P = M;
              break;
            }
            if (P < 0) return this;
            P === 0 ? R.shift() : h(R, P), R.length === 1 && (I[_] = R[0]), I.removeListener !== void 0 && this.emit("removeListener", _, B || T);
          }
          return this;
        }, r.prototype.off = r.prototype.removeListener, r.prototype.removeAllListeners = function(_) {
          var T, R, I;
          if (R = this._events, R === void 0) return this;
          if (R.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : R[_] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete R[_]), this;
          if (arguments.length === 0) {
            var P = Object.keys(R), M;
            for (I = 0; I < P.length; ++I) M = P[I], M !== "removeListener" && this.removeAllListeners(M);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (T = R[_], typeof T == "function") this.removeListener(_, T);
          else if (T !== void 0) for (I = T.length - 1; I >= 0; I--) this.removeListener(_, T[I]);
          return this;
        };
        function v(_, T, R) {
          var I = _._events;
          if (I === void 0) return [];
          var P = I[T];
          return P === void 0 ? [] : typeof P == "function" ? R ? [P.listener || P] : [P] : R ? m(P) : x(P, P.length);
        }
        r.prototype.listeners = function(_) {
          return v(this, _, !0);
        }, r.prototype.rawListeners = function(_) {
          return v(this, _, !1);
        }, r.listenerCount = function(_, T) {
          return typeof _.listenerCount == "function" ? _.listenerCount(T) : g.call(_, T);
        }, r.prototype.listenerCount = g;
        function g(_) {
          var T = this._events;
          if (T !== void 0) {
            var R = T[_];
            if (typeof R == "function") return 1;
            if (R !== void 0) return R.length;
          }
          return 0;
        }
        r.prototype.eventNames = function() {
          return this._eventsCount > 0 ? a(this._events) : [];
        };
        function x(_, T) {
          for (var R = new Array(T), I = 0; I < T; ++I) R[I] = _[I];
          return R;
        }
        function h(_, T) {
          for (; T + 1 < _.length; T++) _[T] = _[T + 1];
          _.pop();
        }
        function m(_) {
          for (var T = new Array(_.length), R = 0; R < T.length; ++R) T[R] = _[R].listener || _[R];
          return T;
        }
        function u(_, T) {
          return new Promise(function(R, I) {
            function P(B) {
              _.removeListener(T, M), I(B);
            }
            function M() {
              typeof _.removeListener == "function" && _.removeListener("error", P), R([].slice.call(arguments));
            }
            y(_, T, M, { once: !0 }), T !== "error" && d(_, P, { once: !0 });
          });
        }
        function d(_, T, R) {
          typeof _.on == "function" && y(_, "error", T, R);
        }
        function y(_, T, R, I) {
          if (typeof _.on == "function") I.once ? _.once(T, R) : _.on(T, R);
          else if (typeof _.addEventListener == "function") _.addEventListener(T, function P(M) {
            I.once && _.removeEventListener(T, P), R(M);
          });
          else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof _);
        }
      }), Ti = xe((L, k) => {
        var n = Ra().EventEmitter, e = { init: function(a) {
          if (a._ev instanceof n) return a;
          var i = new n(), o = new n();
          return a._ev = i, a._internalEv = o, a.on = i.on.bind(i), a.once = i.once.bind(i), a.removeListener = i.removeListener.bind(i), a.removeAllListeners = i.removeAllListeners.bind(i), a._internalOn = o.on.bind(o), a._internalOnce = o.once.bind(o), a._removeInternalListener = o.removeListener.bind(o), a._removeAllInternalListeners = o.removeAllListeners.bind(o), a.emit = function(r, s) {
            i.emit(r, s), o.emit(r, s);
          }, typeof a.addEventListener == "function" && a.addEventListener("wheel", () => {
          }, { passive: !0 }), a;
        }, triggerHandler: function(a, i, o) {
          var r, s = a._ev;
          if (!s) return;
          var c = s._events[i];
          if (!c) return;
          function t(l) {
            if (l.listener) {
              if (s.removeListener(i, l.listener), !l.fired) return l.fired = !0, l.listener.apply(s, [o]);
            } else return l.apply(s, [o]);
          }
          c = Array.isArray(c) ? c : [c];
          var p;
          for (p = 0; p < c.length - 1; p++) t(c[p]);
          return r = t(c[p]), r;
        }, purge: function(a) {
          return delete a._ev, delete a.on, delete a.once, delete a.removeListener, delete a.removeAllListeners, delete a.emit, delete a._ev, delete a._internalEv, delete a._internalOn, delete a._internalOnce, delete a._removeInternalListener, delete a._removeAllInternalListeners, a;
        } };
        k.exports = e;
      }), yd = xe((L, k) => {
        var n = wt(), e = Ia().dfltConfig;
        function a(o, r) {
          for (var s = [], c, t = 0; t < r.length; t++) c = r[t], c === o ? s[t] = c : typeof c == "object" ? s[t] = Array.isArray(c) ? n.extendDeep([], c) : n.extendDeepAll({}, c) : s[t] = c;
          return s;
        }
        var i = {};
        i.add = function(o, r, s, c, t) {
          var p, l;
          if (o.undoQueue = o.undoQueue || { index: 0, queue: [], sequence: !1 }, l = o.undoQueue.index, o.autoplay) {
            o.undoQueue.inSequence || (o.autoplay = !1);
            return;
          }
          !o.undoQueue.sequence || o.undoQueue.beginSequence ? (p = { undo: { calls: [], args: [] }, redo: { calls: [], args: [] } }, o.undoQueue.queue.splice(l, o.undoQueue.queue.length - l, p), o.undoQueue.index += 1) : p = o.undoQueue.queue[l - 1], o.undoQueue.beginSequence = !1, p && (p.undo.calls.unshift(r), p.undo.args.unshift(s), p.redo.calls.push(c), p.redo.args.push(t)), o.undoQueue.queue.length > e.queueLength && (o.undoQueue.queue.shift(), o.undoQueue.index--);
        }, i.startSequence = function(o) {
          o.undoQueue = o.undoQueue || { index: 0, queue: [], sequence: !1 }, o.undoQueue.sequence = !0, o.undoQueue.beginSequence = !0;
        }, i.stopSequence = function(o) {
          o.undoQueue = o.undoQueue || { index: 0, queue: [], sequence: !1 }, o.undoQueue.sequence = !1, o.undoQueue.beginSequence = !1;
        }, i.undo = function(o) {
          var r, s;
          if (!(o.undoQueue === void 0 || isNaN(o.undoQueue.index) || o.undoQueue.index <= 0)) {
            for (o.undoQueue.index--, r = o.undoQueue.queue[o.undoQueue.index], o.undoQueue.inSequence = !0, s = 0; s < r.undo.calls.length; s++) i.plotDo(o, r.undo.calls[s], r.undo.args[s]);
            o.undoQueue.inSequence = !1, o.autoplay = !1;
          }
        }, i.redo = function(o) {
          var r, s;
          if (!(o.undoQueue === void 0 || isNaN(o.undoQueue.index) || o.undoQueue.index >= o.undoQueue.queue.length)) {
            for (r = o.undoQueue.queue[o.undoQueue.index], o.undoQueue.inSequence = !0, s = 0; s < r.redo.calls.length; s++) i.plotDo(o, r.redo.calls[s], r.redo.args[s]);
            o.undoQueue.inSequence = !1, o.autoplay = !1, o.undoQueue.index++;
          }
        }, i.plotDo = function(o, r, s) {
          o.autoplay = !0, s = a(o, s), r.apply(null, s);
        }, k.exports = i;
      }), ts = xe((L, k) => {
        k.exports = { _isLinkedToArray: "frames_entry", group: { valType: "string" }, name: { valType: "string" }, traces: { valType: "any" }, baseframe: { valType: "string" }, data: { valType: "any" }, layout: { valType: "any" } };
      }), Qa = xe((L) => {
        var k = or(), n = wt(), e = Pn(), a = Ka(), i = ts(), o = wi(), r = Ia().configAttributes, s = ra(), c = n.extendDeepAll, t = n.isPlainObject, p = n.isArrayOrTypedArray, l = n.nestedProperty, f = n.valObjectMeta, v = "_isSubplotObj", g = "_isLinkedToArray", x = "_arrayAttrRegexps", h = "_deprecated", m = [v, g, x, h];
        L.IS_SUBPLOT_OBJ = v, L.IS_LINKED_TO_ARRAY = g, L.DEPRECATED = h, L.UNDERSCORE_ATTRS = m, L.get = function() {
          var U = {};
          return k.allTypes.forEach(function(G) {
            U[G] = _(G);
          }), { defs: { valObjects: f, metaKeys: m.concat(["description", "role", "editType", "impliedEdits"]), editType: { traces: s.traces, layout: s.layout }, impliedEdits: {} }, traces: U, layout: T(), frames: R(), animation: I(o), config: I(r) };
        }, L.crawl = function(U, G, K, te) {
          var V = K || 0;
          te = te || "", Object.keys(U).forEach(function(Z) {
            var Y = U[Z];
            if (m.indexOf(Z) === -1) {
              var C = (te ? te + "." : "") + Z;
              G(Y, Z, U, V, C), !L.isValObject(Y) && t(Y) && Z !== "impliedEdits" && L.crawl(Y, G, V + 1, C);
            }
          });
        }, L.isValObject = function(U) {
          return U && U.valType !== void 0;
        }, L.findArrayAttributes = function(U) {
          var G = [], K = [], te = [], V, Z;
          function Y(j, J, ne, ae) {
            K = K.slice(0, ae).concat([J]), te = te.slice(0, ae).concat([j && j._isLinkedToArray]);
            var se = j && (j.valType === "data_array" || j.arrayOk === !0) && !(K[ae - 1] === "colorbar" && (J === "ticktext" || J === "tickvals"));
            se && C(V, 0, "");
          }
          function C(j, J, ne) {
            var ae = j[K[J]], se = ne + K[J];
            if (J === K.length - 1) p(ae) && G.push(Z + se);
            else if (te[J]) {
              if (Array.isArray(ae)) for (var O = 0; O < ae.length; O++) t(ae[O]) && C(ae[O], J + 1, se + "[" + O + "].");
            } else t(ae) && C(ae, J + 1, se + ".");
          }
          return V = U, Z = "", L.crawl(e, Y), U._module && U._module.attributes && L.crawl(U._module.attributes, Y), G;
        }, L.getTraceValObject = function(U, G) {
          var K = G[0], te = 1, V, Z, Y = U._module;
          if (Y || (Y = (k.modules[U.type || e.type.dflt] || {})._module), !Y) return !1;
          if (V = Y.attributes, Z = V && V[K], !Z) {
            var C = Y.basePlotModule;
            C && C.attributes && (Z = C.attributes[K]);
          }
          return Z || (Z = e[K]), d(Z, G, te);
        }, L.getLayoutValObject = function(U, G) {
          var K = u(U, G[0]);
          return d(K, G, 1);
        };
        function u(U, G) {
          var K, te, V, Z, Y = U._basePlotModules;
          if (Y) {
            var C;
            for (K = 0; K < Y.length; K++) {
              if (V = Y[K], V.attrRegex && V.attrRegex.test(G)) {
                if (V.layoutAttrOverrides) return V.layoutAttrOverrides;
                !C && V.layoutAttributes && (C = V.layoutAttributes);
              }
              var j = V.baseLayoutAttrOverrides;
              if (j && G in j) return j[G];
            }
            if (C) return C;
          }
          var J = U._modules;
          if (J) {
            for (K = 0; K < J.length; K++) if (Z = J[K].layoutAttributes, Z && G in Z) return Z[G];
          }
          for (te in k.componentsRegistry) {
            if (V = k.componentsRegistry[te], V.name === "colorscale" && G.indexOf("coloraxis") === 0) return V.layoutAttributes[G];
            if (!V.schema && G === V.name) return V.layoutAttributes;
          }
          return G in a ? a[G] : !1;
        }
        function d(U, G, K) {
          if (!U) return !1;
          if (U._isLinkedToArray) {
            if (y(G[K])) K++;
            else if (K < G.length) return !1;
          }
          for (; K < G.length; K++) {
            var te = U[G[K]];
            if (t(te)) U = te;
            else break;
            if (K === G.length - 1) break;
            if (U._isLinkedToArray) {
              if (K++, !y(G[K])) return !1;
            } else if (U.valType === "info_array") {
              K++;
              var V = G[K];
              if (!y(V)) return !1;
              var Z = U.items;
              if (Array.isArray(Z)) {
                if (V >= Z.length) return !1;
                if (U.dimensions === 2) {
                  if (K++, G.length === K) return U;
                  var Y = G[K];
                  if (!y(Y)) return !1;
                  U = Z[V][Y];
                } else U = Z[V];
              } else U = Z;
            }
          }
          return U;
        }
        function y(U) {
          return U === Math.round(U) && U >= 0;
        }
        function _(U) {
          var G, K;
          G = k.modules[U]._module, K = G.basePlotModule;
          var te = {};
          te.type = null;
          var V = c({}, e), Z = c({}, G.attributes);
          L.crawl(Z, function(j, J, ne, ae, se) {
            l(V, se).set(void 0), j === void 0 && l(Z, se).set(void 0);
          }), c(te, V), k.traceIs(U, "noOpacity") && delete te.opacity, k.traceIs(U, "showLegend") || (delete te.showlegend, delete te.legendgroup), k.traceIs(U, "noHover") && (delete te.hoverinfo, delete te.hoverlabel), G.selectPoints || delete te.selectedpoints, c(te, Z), K.attributes && c(te, K.attributes), te.type = U;
          var Y = { meta: G.meta || {}, categories: G.categories || {}, animatable: !!G.animatable, type: U, attributes: I(te) };
          if (G.layoutAttributes) {
            var C = {};
            c(C, G.layoutAttributes), Y.layoutAttributes = I(C);
          }
          return G.animatable || L.crawl(Y, function(j) {
            L.isValObject(j) && "anim" in j && delete j.anim;
          }), Y;
        }
        function T() {
          var U = {}, G, K;
          c(U, a);
          for (G in k.subplotsRegistry) if (K = k.subplotsRegistry[G], !!K.layoutAttributes) if (Array.isArray(K.attr)) for (var te = 0; te < K.attr.length; te++) z(U, K, K.attr[te]);
          else {
            var V = K.attr === "subplot" ? K.name : K.attr;
            z(U, K, V);
          }
          for (G in k.componentsRegistry) {
            K = k.componentsRegistry[G];
            var Z = K.schema;
            if (Z && (Z.subplots || Z.layout)) {
              var Y = Z.subplots;
              if (Y && Y.xaxis && !Y.yaxis) for (var C in Y.xaxis) delete U.yaxis[C];
              delete U.xaxis.shift, delete U.xaxis.autoshift;
            } else K.name === "colorscale" ? c(U, K.layoutAttributes) : K.layoutAttributes && q(U, K.layoutAttributes, K.name);
          }
          return { layoutAttributes: I(U) };
        }
        function R() {
          var U = { frames: c({}, i) };
          return I(U), U.frames;
        }
        function I(U) {
          return P(U), M(U), B(U), U;
        }
        function P(U) {
          function G(te) {
            return { valType: "string", editType: "none" };
          }
          function K(te, V, Z) {
            L.isValObject(te) ? (te.arrayOk === !0 || te.valType === "data_array") && (Z[V + "src"] = G()) : t(te) && (te.role = "object");
          }
          L.crawl(U, K);
        }
        function M(U) {
          function G(K, te, V) {
            if (K) {
              var Z = K[g];
              Z && (delete K[g], V[te] = { items: {} }, V[te].items[Z] = K, V[te].role = "object");
            }
          }
          L.crawl(U, G);
        }
        function B(U) {
          function G(K) {
            for (var te in K) if (t(K[te])) G(K[te]);
            else if (Array.isArray(K[te])) for (var V = 0; V < K[te].length; V++) G(K[te][V]);
            else K[te] instanceof RegExp && (K[te] = K[te].toString());
          }
          G(U);
        }
        function z(U, G, K) {
          var te = l(U, K), V = c({}, G.layoutAttributes);
          V[v] = !0, te.set(V);
        }
        function q(U, G, K) {
          var te = l(U, K);
          te.set(c(te.get() || {}, G));
        }
      }), qr = xe((L) => {
        var k = wt(), n = Pn(), e = "templateitemname", a = { name: { valType: "string", editType: "none" } };
        a[e] = { valType: "string", editType: "calc" }, L.templatedArray = function(r, s) {
          return s._isLinkedToArray = r, s.name = a.name, s[e] = a[e], s;
        }, L.traceTemplater = function(r) {
          var s = {}, c, t;
          for (c in r) t = r[c], Array.isArray(t) && t.length && (s[c] = 0);
          function p(l) {
            c = k.coerce(l, {}, n, "type");
            var f = { type: c, _template: null };
            if (c in s) {
              t = r[c];
              var v = s[c] % t.length;
              s[c]++, f._template = t[v];
            }
            return f;
          }
          return { newTrace: p };
        }, L.newContainer = function(r, s, c) {
          var t = r._template, p = t && (t[s] || c && t[c]);
          k.isPlainObject(p) || (p = null);
          var l = r[s] = { _template: p };
          return l;
        }, L.arrayTemplater = function(r, s, c) {
          var t = r._template, p = t && t[o(s)], l = t && t[s];
          (!Array.isArray(l) || !l.length) && (l = []);
          var f = {};
          function v(x) {
            var h = { name: x.name, _input: x }, m = h[e] = x[e];
            if (!i(m)) return h._template = p, h;
            for (var u = 0; u < l.length; u++) {
              var d = l[u];
              if (d.name === m) return f[m] = 1, h._template = d, h;
            }
            return h[c] = x[c] || !1, h._template = !1, h;
          }
          function g() {
            for (var x = [], h = 0; h < l.length; h++) {
              var m = l[h], u = m.name;
              if (i(u) && !f[u]) {
                var d = { _template: m, name: u, _input: { _templateitemname: u } };
                d[e] = m[e], x.push(d), f[u] = 1;
              }
            }
            return x;
          }
          return { newItem: v, defaultItems: g };
        };
        function i(r) {
          return r && typeof r == "string";
        }
        function o(r) {
          var s = r.length - 1;
          return r.charAt(s) !== "s" && k.warn("bad argument to arrayDefaultKey: " + r), r.substr(0, r.length - 1) + "defaults";
        }
        L.arrayDefaultKey = o, L.arrayEditor = function(r, s, c) {
          var t = (k.nestedProperty(r, s).get() || []).length, p = c._index, l = p >= t && (c._input || {})._templateitemname;
          l && (p = t);
          var f = s + "[" + p + "]", v;
          function g() {
            v = {}, l && (v[f] = {}, v[f][e] = l);
          }
          g();
          function x(d, y) {
            v[d] = y;
          }
          function h(d, y) {
            l ? k.nestedProperty(v[f], d).set(y) : v[f + "." + d] = y;
          }
          function m() {
            var d = v;
            return g(), d;
          }
          function u(d, y) {
            d && h(d, y);
            var _ = m();
            for (var T in _) k.nestedProperty(r, T).set(_[T]);
          }
          return { modifyBase: x, modifyItem: h, getUpdateObj: m, applyUpdate: u };
        };
      }), mn = xe((L, k) => {
        var n = $a().counter;
        k.exports = { idRegex: { x: n("x", "( domain)?"), y: n("y", "( domain)?") }, attrRegex: n("[xy]axis"), xAxisMatch: n("xaxis"), yAxisMatch: n("yaxis"), AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/, AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/, SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/, HOUR_PATTERN: "hour", WEEKDAY_PATTERN: "day of week", MINDRAG: 8, MINZOOM: 20, DRAGGERSIZE: 20, REDRAWDELAY: 50, DFLTRANGEX: [-1, 6], DFLTRANGEY: [-1, 4], traceLayerClasses: ["imagelayer", "heatmaplayer", "contourcarpetlayer", "contourlayer", "funnellayer", "waterfalllayer", "barlayer", "carpetlayer", "violinlayer", "boxlayer", "ohlclayer", "scattercarpetlayer", "scatterlayer"], clipOnAxisFalseQuery: [".scatterlayer", ".barlayer", ".funnellayer", ".waterfalllayer"], layerValue2layerClass: { "above traces": "above", "below traces": "below" }, zindexSeparator: "z" };
      }), sn = xe((L) => {
        var k = or(), n = mn();
        L.id2name = function(a) {
          if (!(typeof a != "string" || !a.match(n.AX_ID_PATTERN))) {
            var i = a.split(" ")[0].substr(1);
            return i === "1" && (i = ""), a.charAt(0) + "axis" + i;
          }
        }, L.name2id = function(a) {
          if (a.match(n.AX_NAME_PATTERN)) {
            var i = a.substr(5);
            return i === "1" && (i = ""), a.charAt(0) + i;
          }
        }, L.cleanId = function(a, i, o) {
          var r = /( domain)$/.test(a);
          if (!(typeof a != "string" || !a.match(n.AX_ID_PATTERN)) && !(i && a.charAt(0) !== i) && !(r && !o)) {
            var s = a.split(" ")[0].substr(1).replace(/^0+/, "");
            return s === "1" && (s = ""), a.charAt(0) + s + (r && o ? " domain" : "");
          }
        }, L.list = function(a, i, o) {
          var r = a._fullLayout;
          if (!r) return [];
          var s = L.listIds(a, i), c = new Array(s.length), t;
          for (t = 0; t < s.length; t++) {
            var p = s[t];
            c[t] = r[p.charAt(0) + "axis" + p.substr(1)];
          }
          if (!o) {
            var l = r._subplots.gl3d || [];
            for (t = 0; t < l.length; t++) {
              var f = r[l[t]];
              i ? c.push(f[i + "axis"]) : c.push(f.xaxis, f.yaxis, f.zaxis);
            }
          }
          return c;
        }, L.listIds = function(a, i) {
          var o = a._fullLayout;
          if (!o) return [];
          var r = o._subplots;
          return i ? r[i + "axis"] : r.xaxis.concat(r.yaxis);
        }, L.getFromId = function(a, i, o) {
          var r = a._fullLayout;
          return i = i === void 0 || typeof i != "string" ? i : i.replace(" domain", ""), o === "x" ? i = i.replace(/y[0-9]*/, "") : o === "y" && (i = i.replace(/x[0-9]*/, "")), r[L.id2name(i)];
        }, L.getFromTrace = function(a, i, o) {
          var r = a._fullLayout, s = null;
          if (k.traceIs(i, "gl3d")) {
            var c = i.scene;
            c.substr(0, 5) === "scene" && (s = r[c][o + "axis"]);
          } else s = L.getFromId(a, i[o + "axis"] || o);
          return s;
        }, L.idSort = function(a, i) {
          var o = a.charAt(0), r = i.charAt(0);
          return o !== r ? o > r ? 1 : -1 : +(a.substr(1) || 1) - +(i.substr(1) || 1);
        }, L.ref2id = function(a) {
          return /^[xyz]/.test(a) ? a.split(" ")[0] : !1;
        };
        function e(a, i) {
          if (i && i.length) {
            for (var o = 0; o < i.length; o++) if (i[o][a]) return !0;
          }
          return !1;
        }
        L.isLinked = function(a, i) {
          return e(i, a._axisMatchGroups) || e(i, a._axisConstraintGroups);
        };
      }), Ma = xe((L, k) => {
        function n(a) {
          var i = a._fullLayout._zoomlayer;
          i && i.selectAll(".outline-controllers").remove();
        }
        function e(a) {
          var i = a._fullLayout._zoomlayer;
          i && i.selectAll(".select-outline").remove(), a._fullLayout._outlining = !1;
        }
        k.exports = { clearOutlineControllers: n, clearOutline: e };
      }), vo = xe((L, k) => {
        k.exports = { scattermode: { valType: "enumerated", values: ["group", "overlay"], dflt: "overlay", editType: "calc" }, scattergap: { valType: "number", min: 0, max: 1, editType: "calc" } };
      }), go = xe((L) => {
        var k = or();
        mn().SUBPLOT_PATTERN, L.getSubplotCalcData = function(n, e, a) {
          var i = k.subplotsRegistry[e];
          if (!i) return [];
          for (var o = i.attr, r = [], s = 0; s < n.length; s++) {
            var c = n[s], t = c[0].trace;
            t[o] === a && r.push(c);
          }
          return r;
        }, L.getModuleCalcData = function(n, e, a) {
          var i = [], o = [], r;
          if (typeof e == "string" ? r = k.getModule(e).plot : typeof e == "function" ? r = e : r = e.plot, !r) return [i, n];
          for (var s = a, c = 0; c < n.length; c++) {
            var t = n[c], p = t[0].trace, l = p.zorder !== void 0;
            p.visible !== !0 || p._length === 0 || (p._module && p._module.plot === r && (!l || p.zorder === s) ? i.push(t) : o.push(t));
          }
          return [i, o];
        }, L.getSubplotData = function(n, e, a) {
          if (!k.subplotsRegistry[e]) return [];
          for (var i = k.subplotsRegistry[e].attr, o = [], r, s, c, t = 0; t < n.length; t++) r = n[t], r[i] === a && o.push(r);
          return o;
        };
      }), md = xe((L) => {
        var k = or(), n = wt();
        L.manageCommandObserver = function(s, c, t, p) {
          var l = {}, f = !0;
          c && c._commandObserver && (l = c._commandObserver), l.cache || (l.cache = {}), l.lookupTable = {};
          var v = L.hasSimpleAPICommandBindings(s, t, l.lookupTable);
          if (c && c._commandObserver) {
            if (v) return l;
            if (c._commandObserver.remove) return c._commandObserver.remove(), c._commandObserver = null, l;
          }
          if (v) {
            e(s, v, l.cache), l.check = function() {
              if (f) {
                var h = e(s, v, l.cache);
                return h.changed && p && l.lookupTable[h.value] !== void 0 && (l.disable(), Promise.resolve(p({ value: h.value, type: v.type, prop: v.prop, traces: v.traces, index: l.lookupTable[h.value] })).then(l.enable, l.enable)), h.changed;
              }
            };
            for (var g = ["plotly_relayout", "plotly_redraw", "plotly_restyle", "plotly_update", "plotly_animatingframe", "plotly_afterplot"], x = 0; x < g.length; x++) s._internalOn(g[x], l.check);
            l.remove = function() {
              for (var h = 0; h < g.length; h++) s._removeInternalListener(g[h], l.check);
            };
          } else n.log("Unable to automatically bind plot updates to API command"), l.lookupTable = {}, l.remove = function() {
          };
          return l.disable = function() {
            f = !1;
          }, l.enable = function() {
            f = !0;
          }, c && (c._commandObserver = l), l;
        }, L.hasSimpleAPICommandBindings = function(s, c, t) {
          var p, l = c.length, f;
          for (p = 0; p < l; p++) {
            var v, g = c[p], x = g.method, h = g.args;
            if (Array.isArray(h) || (h = []), !x) return !1;
            var m = L.computeAPICommandBindings(s, x, h);
            if (m.length !== 1) return !1;
            if (!f) f = m[0], Array.isArray(f.traces) && f.traces.sort();
            else {
              if (v = m[0], v.type !== f.type || v.prop !== f.prop) return !1;
              if (Array.isArray(f.traces)) if (Array.isArray(v.traces)) {
                v.traces.sort();
                for (var u = 0; u < f.traces.length; u++) if (f.traces[u] !== v.traces[u]) return !1;
              } else return !1;
              else if (v.prop !== f.prop) return !1;
            }
            v = m[0];
            var d = v.value;
            if (Array.isArray(d)) if (d.length === 1) d = d[0];
            else return !1;
            t && (t[d] = p);
          }
          return f;
        };
        function e(s, c, t) {
          var p, l, f, v = !1;
          if (c.type === "data") p = s._fullData[c.traces !== null ? c.traces[0] : 0];
          else if (c.type === "layout") p = s._fullLayout;
          else return !1;
          return l = n.nestedProperty(p, c.prop).get(), f = t[c.type] = t[c.type] || {}, f.hasOwnProperty(c.prop) && f[c.prop] !== l && (v = !0), f[c.prop] = l, { changed: v, value: l };
        }
        L.executeAPICommand = function(s, c, t) {
          if (c === "skip") return Promise.resolve();
          var p = k.apiMethodRegistry[c], l = [s];
          Array.isArray(t) || (t = []);
          for (var f = 0; f < t.length; f++) l.push(t[f]);
          return p.apply(null, l).catch(function(v) {
            return n.warn("API call to Plotly." + c + " rejected.", v), Promise.reject(v);
          });
        }, L.computeAPICommandBindings = function(s, c, t) {
          var p;
          switch (Array.isArray(t) || (t = []), c) {
            case "restyle":
              p = o(s, t);
              break;
            case "relayout":
              p = i(s, t);
              break;
            case "update":
              p = o(s, [t[0], t[2]]).concat(i(s, [t[1]]));
              break;
            case "animate":
              p = a(s, t);
              break;
            default:
              p = [];
          }
          return p;
        };
        function a(s, c) {
          return Array.isArray(c[0]) && c[0].length === 1 && ["string", "number"].indexOf(typeof c[0][0]) !== -1 ? [{ type: "layout", prop: "_currentFrame", value: c[0][0].toString() }] : [];
        }
        function i(s, c) {
          var t = [], p = c[0], l = {};
          if (typeof p == "string") l[p] = c[1];
          else if (n.isPlainObject(p)) l = p;
          else return t;
          return r(l, function(f, v, g) {
            t.push({ type: "layout", prop: f, value: g });
          }, "", 0), t;
        }
        function o(s, c) {
          var t, p, l, f, v = [];
          if (p = c[0], l = c[1], t = c[2], f = {}, typeof p == "string") f[p] = l;
          else if (n.isPlainObject(p)) f = p, t === void 0 && (t = l);
          else return v;
          return t === void 0 && (t = null), r(f, function(g, x, h) {
            var m, u;
            if (Array.isArray(h)) {
              u = h.slice();
              var d = Math.min(u.length, s.data.length);
              t && (d = Math.min(d, t.length)), m = [];
              for (var y = 0; y < d; y++) m[y] = t ? t[y] : y;
            } else u = h, m = t ? t.slice() : null;
            if (m === null) Array.isArray(u) && (u = u[0]);
            else if (Array.isArray(m)) {
              if (!Array.isArray(u)) {
                var _ = u;
                u = [];
                for (var T = 0; T < m.length; T++) u[T] = _;
              }
              u.length = Math.min(m.length, u.length);
            }
            v.push({ type: "data", prop: g, traces: m, value: u });
          }, "", 0), v;
        }
        function r(s, c, t, p) {
          Object.keys(s).forEach(function(l) {
            var f = s[l];
            if (l[0] !== "_") {
              var v = t + (p > 0 ? "." : "") + l;
              n.isPlainObject(f) ? r(f, c, v, p + 1) : c(v, l, f);
            }
          });
        }
      }), on = xe((L, k) => {
        var n = vr(), e = Wa().timeFormatLocale, a = Ul().formatLocale, i = xr(), o = Vl(), r = or(), s = Qa(), c = qr(), t = wt(), p = fr(), l = Yr().BADNUM, f = sn(), v = Ma().clearOutline, g = vo(), x = wi(), h = ts(), m = go().getModuleCalcData, u = t.relinkPrivateKeys, d = t._, y = k.exports = {};
        t.extendFlat(y, r), y.attributes = Pn(), y.attributes.type.values = y.allTypes, y.fontAttrs = hn(), y.layoutAttributes = Ka();
        var _ = md();
        y.executeAPICommand = _.executeAPICommand, y.computeAPICommandBindings = _.computeAPICommandBindings, y.manageCommandObserver = _.manageCommandObserver, y.hasSimpleAPICommandBindings = _.hasSimpleAPICommandBindings, y.redrawText = function(O) {
          return O = t.getGraphDiv(O), new Promise(function(F) {
            setTimeout(function() {
              O._fullLayout && (r.getComponentMethod("annotations", "draw")(O), r.getComponentMethod("legend", "draw")(O), r.getComponentMethod("colorbar", "draw")(O), F(y.previousPromises(O)));
            }, 300);
          });
        }, y.resize = function(O) {
          O = t.getGraphDiv(O);
          var F, S = new Promise(function($, re) {
            (!O || t.isHidden(O)) && re(new Error("Resize must be passed a displayed plot div element.")), O._redrawTimer && clearTimeout(O._redrawTimer), O._resolveResize && (F = O._resolveResize), O._resolveResize = $, O._redrawTimer = setTimeout(function() {
              if (!O.layout || O.layout.width && O.layout.height || t.isHidden(O)) {
                $(O);
                return;
              }
              delete O.layout.width, delete O.layout.height;
              var E = O.changed;
              O.autoplay = !0, r.call("relayout", O, { autosize: !0 }).then(function() {
                O.changed = E, O._resolveResize === $ && (delete O._resolveResize, $(O));
              });
            }, 100);
          });
          return F && F(S), S;
        }, y.previousPromises = function(O) {
          if ((O._promises || []).length) return Promise.all(O._promises).then(function() {
            O._promises = [];
          });
        }, y.addLinks = function(O) {
          if (!(!O._context.showLink && !O._context.showSources)) {
            var F = O._fullLayout, S = t.ensureSingle(F._paper, "text", "js-plot-link-container", function(W) {
              W.style({ "font-family": '"Open Sans", Arial, sans-serif', "font-size": "12px", fill: p.defaultLine, "pointer-events": "all" }).each(function() {
                var ee = n.select(this);
                ee.append("tspan").classed("js-link-to-tool", !0), ee.append("tspan").classed("js-link-spacer", !0), ee.append("tspan").classed("js-sourcelinks", !0);
              });
            }), $ = S.node(), re = { y: F._paper.attr("height") - 9 };
            document.body.contains($) && $.getComputedTextLength() >= F.width - 20 ? (re["text-anchor"] = "start", re.x = 5) : (re["text-anchor"] = "end", re.x = F._paper.attr("width") - 7), S.attr(re);
            var E = S.select(".js-link-to-tool"), w = S.select(".js-link-spacer"), N = S.select(".js-sourcelinks");
            O._context.showSources && O._context.showSources(O), O._context.showLink && T(O, E), w.text(E.text() && N.text() ? " - " : "");
          }
        };
        function T(O, F) {
          F.text("");
          var S = F.append("a").attr({ "xlink:xlink:href": "#", class: "link--impt link--embedview", "font-weight": "bold" }).text(O._context.linkText + " »");
          if (O._context.sendData) S.on("click", function() {
            y.sendDataToCloud(O);
          });
          else {
            var $ = window.location.pathname.split("/"), re = window.location.search;
            S.attr({ "xlink:xlink:show": "new", "xlink:xlink:href": "/" + $[2].split(".")[0] + "/" + $[1] + re });
          }
        }
        y.sendDataToCloud = function(O) {
          var F = (window.PLOTLYENV || {}).BASE_URL || O._context.plotlyServerURL;
          if (F) {
            O.emit("plotly_beforeexport");
            var S = n.select(O).append("div").attr("id", "hiddenform").style("display", "none"), $ = S.append("form").attr({ action: F + "/external", method: "post", target: "_blank" }), re = $.append("input").attr({ type: "text", name: "data" });
            return re.node().value = y.graphJson(O, !1, "keepdata"), $.node().submit(), S.remove(), O.emit("plotly_afterexport"), !1;
          }
        };
        var R = ["days", "shortDays", "months", "shortMonths", "periods", "dateTime", "date", "time", "decimal", "thousands", "grouping", "currency"], I = ["year", "month", "dayMonth", "dayMonthYear"];
        y.supplyDefaults = function(O, F) {
          var S = F && F.skipUpdateCalc, $ = O._fullLayout || {};
          if ($._skipDefaults) {
            delete $._skipDefaults;
            return;
          }
          var re = O._fullLayout = {}, E = O.layout || {}, w = O._fullData || [], N = O._fullData = [], W = O.data || [], ee = O.calcdata || [], le = O._context || {}, ie;
          O._transitionData || y.createTransitionData(O), re._dfltTitle = { plot: d(O, "Click to enter Plot title"), subtitle: d(O, "Click to enter Plot subtitle"), x: d(O, "Click to enter X axis title"), y: d(O, "Click to enter Y axis title"), colorbar: d(O, "Click to enter Colorscale title"), annotation: d(O, "new text") }, re._traceWord = d(O, "trace");
          var pe = B(O, R);
          if (re._mapboxAccessToken = le.mapboxAccessToken, $._initialAutoSizeIsDone) {
            var _e = $.width, Ae = $.height;
            y.supplyLayoutGlobalDefaults(E, re, pe), E.width || (re.width = _e), E.height || (re.height = Ae), y.sanitizeMargins(re);
          } else {
            y.supplyLayoutGlobalDefaults(E, re, pe);
            var Ce = !E.width || !E.height, Ue = re.autosize, Ne = le.autosizable, ke = Ce && (Ue || Ne);
            ke ? y.plotAutoSize(O, E, re) : Ce && y.sanitizeMargins(re), !Ue && Ce && (E.width = re.width, E.height = re.height);
          }
          re._d3locale = z(pe, re.separators), re._extraFormat = B(O, I), re._initialAutoSizeIsDone = !0, re._dataLength = W.length, re._modules = [], re._visibleModules = [], re._basePlotModules = [];
          var A = re._subplots = M(), X = re._splomAxes = { x: {}, y: {} }, H = re._splomSubplots = {};
          re._splomGridDflt = {}, re._scatterStackOpts = {}, re._firstScatter = {}, re._alignmentOpts = {}, re._colorAxes = {}, re._requestRangeslider = {}, re._traceUids = P(w, W), y.supplyDataDefaults(W, N, E, re);
          var ve = Object.keys(X.x), be = Object.keys(X.y);
          if (ve.length > 1 && be.length > 1) {
            for (r.getComponentMethod("grid", "sizeDefaults")(E, re), ie = 0; ie < ve.length; ie++) t.pushUnique(A.xaxis, ve[ie]);
            for (ie = 0; ie < be.length; ie++) t.pushUnique(A.yaxis, be[ie]);
            for (var Se in H) t.pushUnique(A.cartesian, Se);
          }
          if (re._has = y._hasPlotType.bind(re), w.length === N.length) for (ie = 0; ie < N.length; ie++) u(N[ie], w[ie]);
          y.supplyLayoutModuleDefaults(E, re, N, O._transitionData);
          var De = re._visibleModules, He = [];
          for (ie = 0; ie < De.length; ie++) {
            var Ze = De[ie].crossTraceDefaults;
            Ze && t.pushUnique(He, Ze);
          }
          for (ie = 0; ie < He.length; ie++) He[ie](N, re);
          re._hasOnlyLargeSploms = re._basePlotModules.length === 1 && re._basePlotModules[0].name === "splom" && ve.length > 15 && be.length > 15 && re.shapes.length === 0 && re.images.length === 0, y.linkSubplots(N, re, w, $), y.cleanPlot(N, re, w, $);
          var We = !!($._has && $._has("cartesian")), $e = !!(re._has && re._has("cartesian")), it = We, Ke = $e;
          it && !Ke ? $._bgLayer.remove() : Ke && !it && (re._shouldCreateBgLayer = !0), $._zoomlayer && !O._dragging && v({ _fullLayout: $ }), q(N, re), u(re, $), r.getComponentMethod("colorscale", "crossTraceDefaults")(N, re), re._preGUI || (re._preGUI = {}), re._tracePreGUI || (re._tracePreGUI = {});
          var ct = re._tracePreGUI, gt = {}, ht;
          for (ht in ct) gt[ht] = "old";
          for (ie = 0; ie < N.length; ie++) ht = N[ie]._fullInput.uid, gt[ht] || (ct[ht] = {}), gt[ht] = "new";
          for (ht in gt) gt[ht] === "old" && delete ct[ht];
          K(re), r.getComponentMethod("rangeslider", "makeData")(re), !S && ee.length === N.length && y.supplyDefaultsUpdateCalc(ee, N);
        }, y.supplyDefaultsUpdateCalc = function(O, F) {
          for (var S = 0; S < F.length; S++) {
            var $ = F[S], re = (O[S] || [])[0];
            if (re && re.trace) {
              var E = re.trace;
              if (E._hasCalcTransform) {
                var w = E._arrayAttrs, N, W, ee;
                for (N = 0; N < w.length; N++) W = w[N], ee = t.nestedProperty(E, W).get().slice(), t.nestedProperty($, W).set(ee);
              }
              re.trace = $;
            }
          }
        };
        function P(O, F) {
          var S = F.length, $ = [], re, E;
          for (re = 0; re < O.length; re++) {
            var w = O[re]._fullInput;
            w !== E && $.push(w), E = w;
          }
          var N = $.length, W = new Array(S), ee = {};
          function le(_e, Ae) {
            W[Ae] = _e, ee[_e] = 1;
          }
          function ie(_e, Ae) {
            if (_e && typeof _e == "string" && !ee[_e]) return le(_e, Ae), !0;
          }
          for (re = 0; re < S; re++) {
            var pe = F[re].uid;
            typeof pe == "number" && (pe = String(pe)), !ie(pe, re) && (re < N && ie($[re].uid, re) || le(t.randstr(ee), re));
          }
          return W;
        }
        function M() {
          var O = r.collectableSubplotTypes, F = {}, S, $;
          if (!O) {
            O = [];
            var re = r.subplotsRegistry;
            for (var E in re) {
              var w = re[E], N = w.attr;
              if (N && (O.push(E), Array.isArray(N))) for ($ = 0; $ < N.length; $++) t.pushUnique(O, N[$]);
            }
          }
          for (S = 0; S < O.length; S++) F[O[S]] = [];
          return F;
        }
        function B(O, F) {
          var S = O._context.locale;
          S || (S = "en-US");
          var $ = !1, re = {};
          function E(ie) {
            for (var pe = !0, _e = 0; _e < F.length; _e++) {
              var Ae = F[_e];
              re[Ae] || (ie[Ae] ? re[Ae] = ie[Ae] : pe = !1);
            }
            pe && ($ = !0);
          }
          for (var w = 0; w < 2; w++) {
            for (var N = O._context.locales, W = 0; W < 2; W++) {
              var ee = (N[S] || {}).format;
              if (ee && (E(ee), $)) break;
              N = r.localeRegistry;
            }
            var le = S.split("-")[0];
            if ($ || le === S) break;
            S = le;
          }
          return $ || E(r.localeRegistry.en.format), re;
        }
        function z(O, F) {
          return O.decimal = F.charAt(0), O.thousands = F.charAt(1), { numberFormat: function(S) {
            try {
              S = a(O).format(t.adjustFormat(S));
            } catch {
              return t.warnBadFormat(S), t.noFormat;
            }
            return S;
          }, timeFormat: e(O).utcFormat };
        }
        function q(O, F) {
          var S, $ = [];
          F.meta && (S = F._meta = { meta: F.meta, layout: { meta: F.meta } });
          for (var re = 0; re < O.length; re++) {
            var E = O[re];
            E.meta ? $[E.index] = E._meta = { meta: E.meta } : F.meta && (E._meta = { meta: F.meta }), F.meta && (E._meta.layout = { meta: F.meta });
          }
          $.length && (S || (S = F._meta = {}), S.data = $);
        }
        y.createTransitionData = function(O) {
          O._transitionData || (O._transitionData = {}), O._transitionData._frames || (O._transitionData._frames = []), O._transitionData._frameHash || (O._transitionData._frameHash = {}), O._transitionData._counter || (O._transitionData._counter = 0), O._transitionData._interruptCallbacks || (O._transitionData._interruptCallbacks = []);
        }, y._hasPlotType = function(O) {
          var F, S = this._basePlotModules || [];
          for (F = 0; F < S.length; F++) if (S[F].name === O) return !0;
          var $ = this._modules || [];
          for (F = 0; F < $.length; F++) {
            var re = $[F].name;
            if (re === O) return !0;
            var E = r.modules[re];
            if (E && E.categories[O]) return !0;
          }
          return !1;
        }, y.cleanPlot = function(O, F, S, $) {
          var re, E, w = $._basePlotModules || [];
          for (re = 0; re < w.length; re++) {
            var N = w[re];
            N.clean && N.clean(O, F, S, $);
          }
          var W = $._has && $._has("gl"), ee = F._has && F._has("gl");
          W && !ee && $._glcontainer !== void 0 && ($._glcontainer.selectAll(".gl-canvas").remove(), $._glcontainer.selectAll(".no-webgl").remove(), $._glcanvas = null);
          var le = !!$._infolayer;
          e: for (re = 0; re < S.length; re++) {
            var ie = S[re], pe = ie.uid;
            for (E = 0; E < O.length; E++) {
              var _e = O[E];
              if (pe === _e.uid) continue e;
            }
            le && $._infolayer.select(".cb" + pe).remove();
          }
        }, y.linkSubplots = function(O, F, S, $) {
          var re, E, w = $._plots || {}, N = F._plots = {}, W = F._subplots, ee = { _fullData: O, _fullLayout: F }, le = W.cartesian || [];
          for (re = 0; re < le.length; re++) {
            var ie = le[re], pe = w[ie], _e = f.getFromId(ee, ie, "x"), Ae = f.getFromId(ee, ie, "y"), Ce;
            for (pe ? Ce = N[ie] = pe : (Ce = N[ie] = {}, Ce.id = ie), _e._counterAxes.push(Ae._id), Ae._counterAxes.push(_e._id), _e._subplotsWith.push(ie), Ae._subplotsWith.push(ie), Ce.xaxis = _e, Ce.yaxis = Ae, Ce._hasClipOnAxisFalse = !1, E = 0; E < O.length; E++) {
              var Ue = O[E];
              if (Ue.xaxis === Ce.xaxis._id && Ue.yaxis === Ce.yaxis._id && Ue.cliponaxis === !1) {
                Ce._hasClipOnAxisFalse = !0;
                break;
              }
            }
          }
          var Ne = f.list(ee, null, !0), ke;
          for (re = 0; re < Ne.length; re++) {
            ke = Ne[re];
            var A = null;
            ke.overlaying && (A = f.getFromId(ee, ke.overlaying), A && A.overlaying && (ke.overlaying = !1, A = null)), ke._mainAxis = A || ke, A && (ke.domain = A.domain.slice()), ke._anchorAxis = ke.anchor === "free" ? null : f.getFromId(ee, ke.anchor);
          }
          for (re = 0; re < Ne.length; re++) if (ke = Ne[re], ke._counterAxes.sort(f.idSort), ke._subplotsWith.sort(t.subplotSort), ke._mainSubplot = U(ke, F), ke._counterAxes.length && (ke.spikemode && ke.spikemode.indexOf("across") !== -1 || ke.automargin && ke.mirror && ke.anchor !== "free" || r.getComponentMethod("rangeslider", "isVisible")(ke))) {
            var X = 1, H = 0;
            for (E = 0; E < ke._counterAxes.length; E++) {
              var ve = f.getFromId(ee, ke._counterAxes[E]);
              X = Math.min(X, ve.domain[0]), H = Math.max(H, ve.domain[1]);
            }
            X < H && (ke._counterDomainMin = X, ke._counterDomainMax = H);
          }
        };
        function U(O, F) {
          var S = { _fullLayout: F }, $ = O._id.charAt(0) === "x", re = O._mainAxis._anchorAxis, E = "", w = "", N = "";
          if (re && (N = re._mainAxis._id, E = $ ? O._id + N : N + O._id), !E || !F._plots[E]) {
            E = "";
            for (var W = O._counterAxes, ee = 0; ee < W.length; ee++) {
              var le = W[ee], ie = $ ? O._id + le : le + O._id;
              w || (w = ie);
              var pe = f.getFromId(S, le);
              if (N && pe.overlaying === N) {
                E = ie;
                break;
              }
            }
          }
          return E || w;
        }
        y.clearExpandedTraceDefaultColors = function(O) {
          var F, S, $;
          function re(w, N, W, ee) {
            S[ee] = N, S.length = ee + 1, w.valType === "color" && w.dflt === void 0 && F.push(S.join("."));
          }
          for (S = [], F = O._module._colorAttrs, F || (O._module._colorAttrs = F = [], s.crawl(O._module.attributes, re)), $ = 0; $ < F.length; $++) {
            var E = t.nestedProperty(O, "_input." + F[$]);
            E.get() || t.nestedProperty(O, F[$]).set(null);
          }
        }, y.supplyDataDefaults = function(O, F, S, $) {
          var re = $._modules, E = $._visibleModules, w = $._basePlotModules, N = 0, W, ee, le;
          $._transformModules = [];
          function ie(Ne) {
            F.push(Ne);
            var ke = Ne._module;
            ke && (t.pushUnique(re, ke), Ne.visible === !0 && t.pushUnique(E, ke), t.pushUnique(w, Ne._module.basePlotModule), Ne._input.visible !== !1 && N++);
          }
          var pe = {}, _e = [], Ae = (S.template || {}).data || {}, Ce = c.traceTemplater(Ae);
          for (W = 0; W < O.length; W++) le = O[W], ee = Ce.newTrace(le), ee.uid = $._traceUids[W], y.supplyTraceDefaults(le, ee, N, $, W), ee.index = W, ee._input = le, ee._fullInput = ee, ie(ee), r.traceIs(ee, "carpetAxis") && (pe[ee.carpet] = ee), r.traceIs(ee, "carpetDependent") && _e.push(W);
          for (W = 0; W < _e.length; W++) if (ee = F[_e[W]], !!ee.visible) {
            var Ue = pe[ee.carpet];
            if (ee._carpet = Ue, !Ue || !Ue.visible) {
              ee.visible = !1;
              continue;
            }
            ee.xaxis = Ue.xaxis, ee.yaxis = Ue.yaxis;
          }
        }, y.supplyAnimationDefaults = function(O) {
          O = O || {};
          var F, S = {};
          function $(re, E) {
            return t.coerce(O || {}, S, x, re, E);
          }
          if ($("mode"), $("direction"), $("fromcurrent"), Array.isArray(O.frame)) for (S.frame = [], F = 0; F < O.frame.length; F++) S.frame[F] = y.supplyAnimationFrameDefaults(O.frame[F] || {});
          else S.frame = y.supplyAnimationFrameDefaults(O.frame || {});
          if (Array.isArray(O.transition)) for (S.transition = [], F = 0; F < O.transition.length; F++) S.transition[F] = y.supplyAnimationTransitionDefaults(O.transition[F] || {});
          else S.transition = y.supplyAnimationTransitionDefaults(O.transition || {});
          return S;
        }, y.supplyAnimationFrameDefaults = function(O) {
          var F = {};
          function S($, re) {
            return t.coerce(O || {}, F, x.frame, $, re);
          }
          return S("duration"), S("redraw"), F;
        }, y.supplyAnimationTransitionDefaults = function(O) {
          var F = {};
          function S($, re) {
            return t.coerce(O || {}, F, x.transition, $, re);
          }
          return S("duration"), S("easing"), F;
        }, y.supplyFrameDefaults = function(O) {
          var F = {};
          function S($, re) {
            return t.coerce(O, F, h, $, re);
          }
          return S("group"), S("name"), S("traces"), S("baseframe"), S("data"), S("layout"), F;
        }, y.supplyTraceDefaults = function(O, F, S, $, re) {
          var E = $.colorway || p.defaults, w = E[S % E.length], N;
          function W(A, X) {
            return t.coerce(O, F, y.attributes, A, X);
          }
          var ee = W("visible");
          W("type"), W("name", $._traceWord + " " + re), W("uirevision", $.uirevision);
          var le = y.getModule(F);
          if (F._module = le, le) {
            var ie = le.basePlotModule, pe = ie.attr, _e = ie.attributes;
            if (pe && _e) {
              var Ae = $._subplots, Ce = "";
              if (Array.isArray(pe)) for (N = 0; N < pe.length; N++) {
                var Ue = pe[N], Ne = t.coerce(O, F, _e, Ue);
                Ae[Ue] && t.pushUnique(Ae[Ue], Ne), Ce += Ne;
              }
              else Ce = t.coerce(O, F, _e, pe);
              Ae[ie.name] && t.pushUnique(Ae[ie.name], Ce);
            }
          }
          if (ee && (W("customdata"), W("ids"), W("meta"), r.traceIs(F, "showLegend") ? (t.coerce(O, F, le.attributes.showlegend ? le.attributes : y.attributes, "showlegend"), W("legend"), W("legendwidth"), W("legendgroup"), W("legendgrouptitle.text"), W("legendrank"), F._dfltShowLegend = !0) : F._dfltShowLegend = !1, le && le.supplyDefaults(O, F, w, $), r.traceIs(F, "noOpacity") || W("opacity"), r.traceIs(F, "notLegendIsolatable") && (F.visible = !!F.visible), r.traceIs(F, "noHover") || (F.hovertemplate || t.coerceHoverinfo(O, F, $), F.type !== "parcats" && r.getComponentMethod("fx", "supplyDefaults")(O, F, w, $)), le && le.selectPoints)) {
            var ke = W("selectedpoints");
            t.isTypedArray(ke) && (F.selectedpoints = Array.from(ke));
          }
          return F;
        }, y.supplyLayoutGlobalDefaults = function(O, F, S) {
          function $(ie, pe) {
            return t.coerce(O, F, y.layoutAttributes, ie, pe);
          }
          var re = O.template;
          t.isPlainObject(re) && (F.template = re, F._template = re.layout, F._dataTemplate = re.data), $("autotypenumbers");
          var E = t.coerceFont($, "font"), w = E.size;
          t.coerceFont($, "title.font", E, { overrideDflt: { size: Math.round(w * 1.4) } }), $("title.text", F._dfltTitle.plot), $("title.xref");
          var N = $("title.yref");
          $("title.pad.t"), $("title.pad.r"), $("title.pad.b"), $("title.pad.l");
          var W = $("title.automargin");
          $("title.x"), $("title.xanchor"), $("title.y"), $("title.yanchor"), $("title.subtitle.text", F._dfltTitle.subtitle), t.coerceFont($, "title.subtitle.font", E, { overrideDflt: { size: Math.round(F.title.font.size * 0.7) } }), W && (N === "paper" && (F.title.y !== 0 && (F.title.y = 1), F.title.yanchor === "auto" && (F.title.yanchor = F.title.y === 0 ? "top" : "bottom")), N === "container" && (F.title.y === "auto" && (F.title.y = 1), F.title.yanchor === "auto" && (F.title.yanchor = F.title.y < 0.5 ? "bottom" : "top")));
          var ee = $("uniformtext.mode");
          ee && $("uniformtext.minsize"), $("autosize", !(O.width && O.height)), $("width"), $("height"), $("minreducedwidth"), $("minreducedheight"), $("margin.l"), $("margin.r"), $("margin.t"), $("margin.b"), $("margin.pad"), $("margin.autoexpand"), O.width && O.height && y.sanitizeMargins(F), r.getComponentMethod("grid", "sizeDefaults")(O, F), $("paper_bgcolor"), $("separators", S.decimal + S.thousands), $("hidesources"), $("colorway"), $("datarevision");
          var le = $("uirevision");
          $("editrevision", le), $("selectionrevision", le), r.getComponentMethod("modebar", "supplyLayoutDefaults")(O, F), r.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(O, F, $), r.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(O, F, $), $("meta"), t.isPlainObject(O.transition) && ($("transition.duration"), $("transition.easing"), $("transition.ordering")), r.getComponentMethod("calendars", "handleDefaults")(O, F, "calendar"), r.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(O, F, $), t.coerce(O, F, g, "scattermode");
        };
        function G(O) {
          return typeof O == "string" && O.substr(O.length - 2) === "px" && parseFloat(O);
        }
        y.plotAutoSize = function(O, F, S) {
          var $ = O._context || {}, re = $.frameMargins, E, w, N = t.isPlotDiv(O);
          if (N && O.emit("plotly_autosize"), $.fillFrame) E = window.innerWidth, w = window.innerHeight, document.body.style.overflow = "hidden";
          else {
            var W = N ? window.getComputedStyle(O) : {};
            if (E = G(W.width) || G(W.maxWidth) || S.width, w = G(W.height) || G(W.maxHeight) || S.height, i(re) && re > 0) {
              var ee = 1 - 2 * re;
              E = Math.round(ee * E), w = Math.round(ee * w);
            }
          }
          var le = y.layoutAttributes.width.min, ie = y.layoutAttributes.height.min;
          E < le && (E = le), w < ie && (w = ie);
          var pe = !F.width && Math.abs(S.width - E) > 1, _e = !F.height && Math.abs(S.height - w) > 1;
          (_e || pe) && (pe && (S.width = E), _e && (S.height = w)), O._initialAutoSize || (O._initialAutoSize = { width: E, height: w }), y.sanitizeMargins(S);
        }, y.supplyLayoutModuleDefaults = function(O, F, S, $) {
          var re = r.componentsRegistry, E = F._basePlotModules, w, N, W, ee = r.subplotsRegistry.cartesian;
          for (w in re) W = re[w], W.includeBasePlot && W.includeBasePlot(O, F);
          E.length || E.push(ee), F._has("cartesian") && (r.getComponentMethod("grid", "contentDefaults")(O, F), ee.finalizeSubplots(O, F));
          for (var le in F._subplots) F._subplots[le].sort(t.subplotSort);
          for (N = 0; N < E.length; N++) W = E[N], W.supplyLayoutDefaults && W.supplyLayoutDefaults(O, F, S);
          var ie = F._modules;
          for (N = 0; N < ie.length; N++) W = ie[N], W.supplyLayoutDefaults && W.supplyLayoutDefaults(O, F, S);
          var pe = F._transformModules;
          for (N = 0; N < pe.length; N++) W = pe[N], W.supplyLayoutDefaults && W.supplyLayoutDefaults(O, F, S, $);
          for (w in re) W = re[w], W.supplyLayoutDefaults && W.supplyLayoutDefaults(O, F, S);
        }, y.purge = function(O) {
          var F = O._fullLayout || {};
          F._glcontainer !== void 0 && (F._glcontainer.selectAll(".gl-canvas").remove(), F._glcontainer.remove(), F._glcanvas = null), F._modeBar && F._modeBar.destroy(), O._transitionData && (O._transitionData._interruptCallbacks && (O._transitionData._interruptCallbacks.length = 0), O._transitionData._animationRaf && window.cancelAnimationFrame(O._transitionData._animationRaf)), t.clearThrottle(), t.clearResponsive(O), delete O.data, delete O.layout, delete O._fullData, delete O._fullLayout, delete O.calcdata, delete O.empty, delete O.fid, delete O.undoqueue, delete O.undonum, delete O.autoplay, delete O.changed, delete O._promises, delete O._redrawTimer, delete O._hmlumcount, delete O._hmpixcount, delete O._transitionData, delete O._transitioning, delete O._initialAutoSize, delete O._transitioningWithDuration, delete O._dragging, delete O._dragged, delete O._dragdata, delete O._hoverdata, delete O._snapshotInProgress, delete O._editing, delete O._mouseDownTime, delete O._legendMouseDownTime, O.removeAllListeners && O.removeAllListeners();
        }, y.style = function(O) {
          var F = O._fullLayout._visibleModules, S = [], $;
          for ($ = 0; $ < F.length; $++) {
            var re = F[$];
            re.style && t.pushUnique(S, re.style);
          }
          for ($ = 0; $ < S.length; $++) S[$](O);
        }, y.sanitizeMargins = function(O) {
          if (!(!O || !O.margin)) {
            var F = O.width, S = O.height, $ = O.margin, re = F - ($.l + $.r), E = S - ($.t + $.b), w;
            re < 0 && (w = (F - 1) / ($.l + $.r), $.l = Math.floor(w * $.l), $.r = Math.floor(w * $.r)), E < 0 && (w = (S - 1) / ($.t + $.b), $.t = Math.floor(w * $.t), $.b = Math.floor(w * $.b));
          }
        }, y.clearAutoMarginIds = function(O) {
          O._fullLayout._pushmarginIds = {};
        }, y.allowAutoMargin = function(O, F) {
          O._fullLayout._pushmarginIds[F] = 1;
        };
        function K(O) {
          var F = O.margin;
          if (!O._size) {
            var S = O._size = { l: Math.round(F.l), r: Math.round(F.r), t: Math.round(F.t), b: Math.round(F.b), p: Math.round(F.pad) };
            S.w = Math.round(O.width) - S.l - S.r, S.h = Math.round(O.height) - S.t - S.b;
          }
          O._pushmargin || (O._pushmargin = {}), O._pushmarginIds || (O._pushmarginIds = {}), O._reservedMargin || (O._reservedMargin = {});
        }
        var te = 2, V = 2;
        y.autoMargin = function(O, F, S) {
          var $ = O._fullLayout, re = $.width, E = $.height, w = $.margin, N = $.minreducedwidth, W = $.minreducedheight, ee = t.constrain(re - w.l - w.r, te, N), le = t.constrain(E - w.t - w.b, V, W), ie = Math.max(0, re - ee), pe = Math.max(0, E - le), _e = $._pushmargin, Ae = $._pushmarginIds;
          if (w.autoexpand !== !1) {
            if (!S) delete _e[F], delete Ae[F];
            else {
              var Ce = S.pad;
              if (Ce === void 0 && (Ce = Math.min(12, w.l, w.r, w.t, w.b)), ie) {
                var Ue = (S.l + S.r) / ie;
                Ue > 1 && (S.l /= Ue, S.r /= Ue);
              }
              if (pe) {
                var Ne = (S.t + S.b) / pe;
                Ne > 1 && (S.t /= Ne, S.b /= Ne);
              }
              var ke = S.xl !== void 0 ? S.xl : S.x, A = S.xr !== void 0 ? S.xr : S.x, X = S.yt !== void 0 ? S.yt : S.y, H = S.yb !== void 0 ? S.yb : S.y;
              _e[F] = { l: { val: ke, size: S.l + Ce }, r: { val: A, size: S.r + Ce }, b: { val: H, size: S.b + Ce }, t: { val: X, size: S.t + Ce } }, Ae[F] = 1;
            }
            if (!$._replotting) return y.doAutoMargin(O);
          }
        };
        function Z(O) {
          if ("_redrawFromAutoMarginCount" in O._fullLayout) return !1;
          var F = f.list(O, "", !0);
          for (var S in F) if (F[S].autoshift || F[S].shift) return !0;
          return !1;
        }
        y.doAutoMargin = function(O) {
          var F = O._fullLayout, S = F.width, $ = F.height;
          F._size || (F._size = {}), K(F);
          var re = F._size, E = F.margin, w = { t: 0, b: 0, l: 0, r: 0 }, N = t.extendFlat({}, re), W = E.l, ee = E.r, le = E.t, ie = E.b, pe = F._pushmargin, _e = F._pushmarginIds, Ae = F.minreducedwidth, Ce = F.minreducedheight;
          if (E.autoexpand !== !1) {
            for (var Ue in pe) _e[Ue] || delete pe[Ue];
            var Ne = O._fullLayout._reservedMargin;
            for (var ke in Ne) for (var A in Ne[ke]) {
              var X = Ne[ke][A];
              w[A] = Math.max(w[A], X);
            }
            pe.base = { l: { val: 0, size: W }, r: { val: 1, size: ee }, t: { val: 1, size: le }, b: { val: 0, size: ie } };
            for (var H in w) {
              var ve = 0;
              for (var be in pe) be !== "base" && i(pe[be][H].size) && (ve = pe[be][H].size > ve ? pe[be][H].size : ve);
              var Se = Math.max(0, E[H] - ve);
              w[H] = Math.max(0, w[H] - Se);
            }
            for (var De in pe) {
              var He = pe[De].l || {}, Ze = pe[De].b || {}, We = He.val, $e = He.size, it = Ze.val, Ke = Ze.size, ct = S - w.r - w.l, gt = $ - w.t - w.b;
              for (var ht in pe) {
                if (i($e) && pe[ht].r) {
                  var _t = pe[ht].r.val, Te = pe[ht].r.size;
                  if (_t > We) {
                    var Ie = ($e * _t + (Te - ct) * We) / (_t - We), ce = (Te * (1 - We) + ($e - ct) * (1 - _t)) / (_t - We);
                    Ie + ce > W + ee && (W = Ie, ee = ce);
                  }
                }
                if (i(Ke) && pe[ht].t) {
                  var ge = pe[ht].t.val, ye = pe[ht].t.size;
                  if (ge > it) {
                    var Me = (Ke * ge + (ye - gt) * it) / (ge - it), Oe = (ye * (1 - it) + (Ke - gt) * (1 - ge)) / (ge - it);
                    Me + Oe > ie + le && (ie = Me, le = Oe);
                  }
                }
              }
            }
          }
          var je = t.constrain(S - E.l - E.r, te, Ae), qe = t.constrain($ - E.t - E.b, V, Ce), Qe = Math.max(0, S - je), Xe = Math.max(0, $ - qe);
          if (Qe) {
            var Je = (W + ee) / Qe;
            Je > 1 && (W /= Je, ee /= Je);
          }
          if (Xe) {
            var ot = (ie + le) / Xe;
            ot > 1 && (ie /= ot, le /= ot);
          }
          if (re.l = Math.round(W) + w.l, re.r = Math.round(ee) + w.r, re.t = Math.round(le) + w.t, re.b = Math.round(ie) + w.b, re.p = Math.round(E.pad), re.w = Math.round(S) - re.l - re.r, re.h = Math.round($) - re.t - re.b, !F._replotting && (y.didMarginChange(N, re) || Z(O))) {
            "_redrawFromAutoMarginCount" in F ? F._redrawFromAutoMarginCount++ : F._redrawFromAutoMarginCount = 1;
            var lt = 3 * (1 + Object.keys(_e).length);
            if (F._redrawFromAutoMarginCount < lt) return r.call("_doPlot", O);
            F._size = N, t.warn("Too many auto-margin redraws.");
          }
          Y(O);
        };
        function Y(O) {
          var F = f.list(O, "", !0);
          ["_adjustTickLabelsOverflow", "_hideCounterAxisInsideTickLabels"].forEach(function(S) {
            for (var $ = 0; $ < F.length; $++) {
              var re = F[$][S];
              re && re();
            }
          });
        }
        var C = ["l", "r", "t", "b", "p", "w", "h"];
        y.didMarginChange = function(O, F) {
          for (var S = 0; S < C.length; S++) {
            var $ = C[S], re = O[$], E = F[$];
            if (!i(re) || Math.abs(E - re) > 1) return !0;
          }
          return !1;
        }, y.graphJson = function(O, F, S, $, re, E) {
          (re && F && !O._fullData || re && !F && !O._fullLayout) && y.supplyDefaults(O);
          var w = re ? O._fullData : O.data, N = re ? O._fullLayout : O.layout, W = (O._transitionData || {})._frames;
          function ee(pe, _e) {
            if (typeof pe == "function") return _e ? "_function_" : null;
            if (t.isPlainObject(pe)) {
              var Ae = {}, Ce;
              return Object.keys(pe).sort().forEach(function(A) {
                if (["_", "["].indexOf(A.charAt(0)) === -1) {
                  if (typeof pe[A] == "function") {
                    _e && (Ae[A] = "_function");
                    return;
                  }
                  if (S === "keepdata") {
                    if (A.substr(A.length - 3) === "src") return;
                  } else if (S === "keepstream") {
                    if (Ce = pe[A + "src"], typeof Ce == "string" && Ce.indexOf(":") > 0 && !t.isPlainObject(pe.stream)) return;
                  } else if (S !== "keepall" && (Ce = pe[A + "src"], typeof Ce == "string" && Ce.indexOf(":") > 0)) return;
                  Ae[A] = ee(pe[A], _e);
                }
              }), Ae;
            }
            var Ue = Array.isArray(pe), Ne = t.isTypedArray(pe);
            if ((Ue || Ne) && pe.dtype && pe.shape) {
              var ke = pe.bdata;
              return ee({ dtype: pe.dtype, shape: pe.shape, bdata: t.isArrayBuffer(ke) ? o.encode(ke) : ke }, _e);
            }
            return Ue ? pe.map(function(A) {
              return ee(A, _e);
            }) : Ne ? t.simpleMap(pe, t.identity) : t.isJSDate(pe) ? t.ms2DateTimeLocal(+pe) : pe;
          }
          var le = { data: (w || []).map(function(pe) {
            var _e = ee(pe);
            return F && delete _e.fit, _e;
          }) };
          if (!F && (le.layout = ee(N), re)) {
            var ie = N._size;
            le.layout.computed = { margin: { b: ie.b, l: ie.l, r: ie.r, t: ie.t } };
          }
          return W && (le.frames = ee(W)), E && (le.config = ee(O._context, !0)), $ === "object" ? le : JSON.stringify(le);
        }, y.modifyFrames = function(O, F) {
          var S, $, re, E = O._transitionData._frames, w = O._transitionData._frameHash;
          for (S = 0; S < F.length; S++) switch ($ = F[S], $.type) {
            case "replace":
              re = $.value;
              var N = (E[$.index] || {}).name, W = re.name;
              E[$.index] = w[W] = re, W !== N && (delete w[N], w[W] = re);
              break;
            case "insert":
              re = $.value, w[re.name] = re, E.splice($.index, 0, re);
              break;
            case "delete":
              re = E[$.index], delete w[re.name], E.splice($.index, 1);
              break;
          }
          return Promise.resolve();
        }, y.computeFrame = function(O, F) {
          var S = O._transitionData._frameHash, $, re, E, w;
          if (!F) throw new Error("computeFrame must be given a string frame name");
          var N = S[F.toString()];
          if (!N) return !1;
          for (var W = [N], ee = [N.name]; N.baseframe && (N = S[N.baseframe.toString()]) && ee.indexOf(N.name) === -1; ) W.push(N), ee.push(N.name);
          for (var le = {}; N = W.pop(); ) if (N.layout && (le.layout = y.extendLayout(le.layout, N.layout)), N.data) {
            if (le.data || (le.data = []), re = N.traces, !re) for (re = [], $ = 0; $ < N.data.length; $++) re[$] = $;
            for (le.traces || (le.traces = []), $ = 0; $ < N.data.length; $++) E = re[$], E != null && (w = le.traces.indexOf(E), w === -1 && (w = le.data.length, le.traces[w] = E), le.data[w] = y.extendTrace(le.data[w], N.data[$]));
          }
          return le;
        }, y.recomputeFrameHash = function(O) {
          for (var F = O._transitionData._frameHash = {}, S = O._transitionData._frames, $ = 0; $ < S.length; $++) {
            var re = S[$];
            re && re.name && (F[re.name] = re);
          }
        }, y.extendObjectWithContainers = function(O, F, S) {
          var $, re, E, w, N, W, ee, le, ie = t.extendDeepNoArrays({}, F || {}), pe = t.expandObjectPaths(ie), _e = {};
          if (S && S.length) for (E = 0; E < S.length; E++) $ = t.nestedProperty(pe, S[E]), re = $.get(), re === void 0 ? t.nestedProperty(_e, S[E]).set(null) : ($.set(null), t.nestedProperty(_e, S[E]).set(re));
          if (O = t.extendDeepNoArrays(O || {}, pe), S && S.length) {
            for (E = 0; E < S.length; E++) if (N = t.nestedProperty(_e, S[E]), ee = N.get(), !!ee) {
              for (W = t.nestedProperty(O, S[E]), le = W.get(), Array.isArray(le) || (le = [], W.set(le)), w = 0; w < ee.length; w++) {
                var Ae = ee[w];
                Ae === null ? le[w] = null : le[w] = y.extendObjectWithContainers(le[w], Ae);
              }
              W.set(le);
            }
          }
          return O;
        }, y.dataArrayContainers = ["transforms", "dimensions"], y.layoutArrayContainers = r.layoutArrayContainers, y.extendTrace = function(O, F) {
          return y.extendObjectWithContainers(O, F, y.dataArrayContainers);
        }, y.extendLayout = function(O, F) {
          return y.extendObjectWithContainers(O, F, y.layoutArrayContainers);
        }, y.transition = function(O, F, S, $, re, E) {
          var w = { redraw: re.redraw }, N = {}, W = [];
          return w.prepareFn = function() {
            for (var ee = Array.isArray(F) ? F.length : 0, le = $.slice(0, ee), ie = 0; ie < le.length; ie++) {
              var pe = le[ie], _e = O._fullData[pe], Ae = _e._module;
              if (Ae) {
                if (Ae.animatable) {
                  var Ce = Ae.basePlotModule.name;
                  N[Ce] || (N[Ce] = []), N[Ce].push(pe);
                }
                O.data[le[ie]] = y.extendTrace(O.data[le[ie]], F[ie]);
              }
            }
            var Ue = t.expandObjectPaths(t.extendDeepNoArrays({}, S)), Ne = /^[xy]axis[0-9]*$/;
            for (var ke in Ue) Ne.test(ke) && delete Ue[ke].range;
            y.extendLayout(O.layout, Ue), delete O.calcdata, y.supplyDefaults(O), y.doCalcdata(O);
            var A = t.expandObjectPaths(S);
            if (A) {
              var X = O._fullLayout._plots;
              for (var H in X) {
                var ve = X[H], be = ve.xaxis, Se = ve.yaxis, De = be.range.slice(), He = Se.range.slice(), Ze = null, We = null, $e = null, it = null;
                Array.isArray(A[be._name + ".range"]) ? Ze = A[be._name + ".range"].slice() : Array.isArray((A[be._name] || {}).range) && (Ze = A[be._name].range.slice()), Array.isArray(A[Se._name + ".range"]) ? We = A[Se._name + ".range"].slice() : Array.isArray((A[Se._name] || {}).range) && (We = A[Se._name].range.slice()), De && Ze && (be.r2l(De[0]) !== be.r2l(Ze[0]) || be.r2l(De[1]) !== be.r2l(Ze[1])) && ($e = { xr0: De, xr1: Ze }), He && We && (Se.r2l(He[0]) !== Se.r2l(We[0]) || Se.r2l(He[1]) !== Se.r2l(We[1])) && (it = { yr0: He, yr1: We }), ($e || it) && W.push(t.extendFlat({ plotinfo: ve }, $e, it));
              }
            }
            return Promise.resolve();
          }, w.runFn = function(ee) {
            var le, ie = O._fullLayout._basePlotModules, pe = W.length, _e;
            if (S) for (_e = 0; _e < ie.length; _e++) ie[_e].transitionAxes && ie[_e].transitionAxes(O, W, E, ee);
            pe ? (le = t.extendFlat({}, E), le.duration = 0, delete N.cartesian) : le = E;
            for (var Ae in N) {
              var Ce = N[Ae], Ue = O._fullData[Ce[0]]._module;
              Ue.basePlotModule.plot(O, Ce, le, ee);
            }
          }, j(O, E, w);
        }, y.transitionFromReact = function(O, F, S, $) {
          var re = O._fullLayout, E = re.transition, w = {}, N = [];
          return w.prepareFn = function() {
            var W = re._plots;
            w.redraw = !1, F.anim === "some" && (w.redraw = !0), S.anim === "some" && (w.redraw = !0);
            for (var ee in W) {
              var le = W[ee], ie = le.xaxis, pe = le.yaxis, _e = $[ie._name].range.slice(), Ae = $[pe._name].range.slice(), Ce = ie.range.slice(), Ue = pe.range.slice();
              ie.setScale(), pe.setScale();
              var Ne = null, ke = null;
              (ie.r2l(_e[0]) !== ie.r2l(Ce[0]) || ie.r2l(_e[1]) !== ie.r2l(Ce[1])) && (Ne = { xr0: _e, xr1: Ce }), (pe.r2l(Ae[0]) !== pe.r2l(Ue[0]) || pe.r2l(Ae[1]) !== pe.r2l(Ue[1])) && (ke = { yr0: Ae, yr1: Ue }), (Ne || ke) && N.push(t.extendFlat({ plotinfo: le }, Ne, ke));
            }
            return Promise.resolve();
          }, w.runFn = function(W) {
            for (var ee = O._fullData, le = O._fullLayout, ie = le._basePlotModules, pe, _e, Ae, Ce = [], Ue = 0; Ue < ee.length; Ue++) Ce.push(Ue);
            function Ne() {
              if (O._fullLayout) for (var A = 0; A < ie.length; A++) ie[A].transitionAxes && ie[A].transitionAxes(O, N, pe, W);
            }
            function ke() {
              if (O._fullLayout) for (var A = 0; A < ie.length; A++) ie[A].plot(O, Ae, _e, W);
            }
            N.length && F.anim ? E.ordering === "traces first" ? (pe = t.extendFlat({}, E, { duration: 0 }), Ae = Ce, _e = E, setTimeout(Ne, E.duration), ke()) : (pe = E, Ae = null, _e = t.extendFlat({}, E, { duration: 0 }), setTimeout(ke, pe.duration), Ne()) : N.length ? (pe = E, Ne()) : F.anim && (Ae = Ce, _e = E, ke());
          }, j(O, E, w);
        };
        function j(O, F, S) {
          var $ = !1;
          function re(ie) {
            var pe = Promise.resolve();
            if (!ie) return pe;
            for (; ie.length; ) pe = pe.then(ie.shift());
            return pe;
          }
          function E(ie) {
            if (ie) for (; ie.length; ) ie.shift();
          }
          function w() {
            return O.emit("plotly_transitioning", []), new Promise(function(ie) {
              O._transitioning = !0, F.duration > 0 && (O._transitioningWithDuration = !0), O._transitionData._interruptCallbacks.push(function() {
                $ = !0;
              }), S.redraw && O._transitionData._interruptCallbacks.push(function() {
                return r.call("redraw", O);
              }), O._transitionData._interruptCallbacks.push(function() {
                O.emit("plotly_transitioninterrupted", []);
              });
              var pe = 0, _e = 0;
              function Ae() {
                return pe++, function() {
                  _e++, !$ && _e === pe && N(ie);
                };
              }
              S.runFn(Ae), setTimeout(Ae());
            });
          }
          function N(ie) {
            if (O._transitionData) return E(O._transitionData._interruptCallbacks), Promise.resolve().then(function() {
              if (S.redraw) return r.call("redraw", O);
            }).then(function() {
              O._transitioning = !1, O._transitioningWithDuration = !1, O.emit("plotly_transitioned", []);
            }).then(ie);
          }
          function W() {
            if (O._transitionData) return O._transitioning = !1, re(O._transitionData._interruptCallbacks);
          }
          var ee = [y.previousPromises, W, S.prepareFn, y.rehover, y.reselect, w], le = t.syncOrAsync(ee, O);
          return (!le || !le.then) && (le = Promise.resolve()), le.then(function() {
            return O;
          });
        }
        y.doCalcdata = function(O, F) {
          var S = f.list(O), $ = O._fullData, re = O._fullLayout, E, w, N, W, ee = new Array($.length), le = (O.calcdata || []).slice();
          for (O.calcdata = ee, re._numBoxes = 0, re._numViolins = 0, re._violinScaleGroupStats = {}, O._hmpixcount = 0, O._hmlumcount = 0, re._piecolormap = {}, re._sunburstcolormap = {}, re._treemapcolormap = {}, re._iciclecolormap = {}, re._funnelareacolormap = {}, N = 0; N < $.length; N++) if (Array.isArray(F) && F.indexOf(N) === -1) {
            ee[N] = le[N];
            continue;
          }
          for (N = 0; N < $.length; N++) E = $[N], E._arrayAttrs = s.findArrayAttributes(E), E._extremes = {};
          var ie = re._subplots.polar || [];
          for (N = 0; N < ie.length; N++) S.push(re[ie[N]].radialaxis, re[ie[N]].angularaxis);
          for (var pe in re._colorAxes) {
            var _e = re[pe];
            _e.cauto !== !1 && (delete _e.cmin, delete _e.cmax);
          }
          var Ae = !1;
          function Ce(ke) {
            if (E = $[ke], w = E._module, E.visible === !0 && E.transforms) {
              if (w && w.calc) {
                var A = w.calc(O, E);
                A[0] && A[0].t && A[0].t._scene && delete A[0].t._scene.dirty;
              }
              for (W = 0; W < E.transforms.length; W++) {
                var X = E.transforms[W];
                w = transformsRegistry[X.type], w && w.calcTransform && (E._hasCalcTransform = !0, Ae = !0, w.calcTransform(O, E, X));
              }
            }
          }
          function Ue(ke, A) {
            if (E = $[ke], w = E._module, !!w.isContainer === A) {
              var X = [];
              if (E.visible === !0 && E._length !== 0) {
                delete E._indexToPoints;
                var H = E.transforms || [];
                for (W = H.length - 1; W >= 0; W--) if (H[W].enabled) {
                  E._indexToPoints = H[W]._indexToPoints;
                  break;
                }
                w && w.calc && (X = w.calc(O, E));
              }
              (!Array.isArray(X) || !X[0]) && (X = [{ x: l, y: l }]), X[0].t || (X[0].t = {}), X[0].trace = E, ee[ke] = X;
            }
          }
          for (ae(S, $, re), N = 0; N < $.length; N++) Ue(N, !0);
          for (N = 0; N < $.length; N++) Ce(N);
          for (Ae && ae(S, $, re), N = 0; N < $.length; N++) Ue(N, !0);
          for (N = 0; N < $.length; N++) Ue(N, !1);
          se(O);
          var Ne = ne(S, O);
          if (Ne.length) {
            for (re._numBoxes = 0, re._numViolins = 0, N = 0; N < Ne.length; N++) Ue(Ne[N], !0);
            for (N = 0; N < Ne.length; N++) Ue(Ne[N], !1);
            se(O);
          }
          r.getComponentMethod("fx", "calc")(O), r.getComponentMethod("errorbars", "calc")(O);
        };
        var J = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
        function ne(O, F) {
          var S = [], $, re, E, w, N;
          function W(ht, _t, Te) {
            var Ie = _t._id.charAt(0);
            if (ht === "histogram2dcontour") {
              var ce = _t._counterAxes[0], ge = f.getFromId(F, ce), ye = Ie === "x" || ce === "x" && ge.type === "category", Me = Ie === "y" || ce === "y" && ge.type === "category";
              return function(Oe, je) {
                return Oe === 0 || je === 0 || ye && Oe === Te[je].length - 1 || Me && je === Te.length - 1 ? -1 : (Ie === "y" ? je : Oe) - 1;
              };
            } else return function(Oe, je) {
              return Ie === "y" ? je : Oe;
            };
          }
          var ee = { min: function(ht) {
            return t.aggNums(Math.min, null, ht);
          }, max: function(ht) {
            return t.aggNums(Math.max, null, ht);
          }, sum: function(ht) {
            return t.aggNums(function(_t, Te) {
              return _t + Te;
            }, null, ht);
          }, total: function(ht) {
            return t.aggNums(function(_t, Te) {
              return _t + Te;
            }, null, ht);
          }, mean: function(ht) {
            return t.mean(ht);
          }, "geometric mean": function(ht) {
            return t.geometricMean(ht);
          }, median: function(ht) {
            return t.median(ht);
          } };
          function le(ht, _t) {
            return ht[1] - _t[1];
          }
          function ie(ht, _t) {
            return _t[1] - ht[1];
          }
          for ($ = 0; $ < O.length; $++) {
            var pe = O[$];
            if (pe.type === "category") {
              var _e = pe.categoryorder.match(J);
              if (_e) {
                var Ae = _e[1], Ce = _e[2], Ue = pe._id.charAt(0), Ne = Ue === "x", ke = [];
                for (re = 0; re < pe._categories.length; re++) ke.push([pe._categories[re], []]);
                for (re = 0; re < pe._traceIndices.length; re++) {
                  var A = pe._traceIndices[re], X = F._fullData[A];
                  if (X.visible === !0) {
                    var H = X.type;
                    r.traceIs(X, "histogram") && (delete X._xautoBinFinished, delete X._yautoBinFinished);
                    var ve = H === "splom", be = H === "scattergl", Se = F.calcdata[A];
                    for (E = 0; E < Se.length; E++) {
                      var De = Se[E], He, Ze;
                      if (ve) {
                        var We = X._axesDim[pe._id];
                        if (!Ne) {
                          var $e = X._diag[We][0];
                          $e && (pe = F._fullLayout[f.id2name($e)]);
                        }
                        var it = De.trace.dimensions[We].values;
                        for (w = 0; w < it.length; w++) for (He = pe._categoriesMap[it[w]], N = 0; N < De.trace.dimensions.length; N++) if (N !== We) {
                          var Ke = De.trace.dimensions[N];
                          ke[He][1].push(Ke.values[w]);
                        }
                      } else if (be) {
                        for (w = 0; w < De.t.x.length; w++) Ne ? (He = De.t.x[w], Ze = De.t.y[w]) : (He = De.t.y[w], Ze = De.t.x[w]), ke[He][1].push(Ze);
                        De.t && De.t._scene && delete De.t._scene.dirty;
                      } else if (De.hasOwnProperty("z")) {
                        Ze = De.z;
                        var ct = W(X.type, pe, Ze);
                        for (w = 0; w < Ze.length; w++) for (N = 0; N < Ze[w].length; N++) He = ct(N, w), He + 1 && ke[He][1].push(Ze[w][N]);
                      } else for (He = De.p, He === void 0 && (He = De[Ue]), Ze = De.s, Ze === void 0 && (Ze = De.v), Ze === void 0 && (Ze = Ne ? De.y : De.x), Array.isArray(Ze) || (Ze === void 0 ? Ze = [] : Ze = [Ze]), w = 0; w < Ze.length; w++) ke[He][1].push(Ze[w]);
                    }
                  }
                }
                pe._categoriesValue = ke;
                var gt = [];
                for (re = 0; re < ke.length; re++) gt.push([ke[re][0], ee[Ae](ke[re][1])]);
                gt.sort(Ce === "descending" ? ie : le), pe._categoriesAggregatedValue = gt, pe._initialCategories = gt.map(function(ht) {
                  return ht[0];
                }), S = S.concat(pe.sortByInitialCategories());
              }
            }
          }
          return S;
        }
        function ae(O, F, S) {
          var $ = {};
          function re(W) {
            W.clearCalc(), W.type === "multicategory" && W.setupMultiCategory(F), $[W._id] = 1;
          }
          t.simpleMap(O, re);
          for (var E = S._axisMatchGroups || [], w = 0; w < E.length; w++) for (var N in E[w]) $[N] || re(S[f.id2name(N)]);
        }
        function se(O) {
          var F = O._fullLayout, S = F._visibleModules, $ = {}, re, E, w;
          for (E = 0; E < S.length; E++) {
            var N = S[E], W = N.crossTraceCalc;
            if (W) {
              var ee = N.basePlotModule.name;
              $[ee] ? t.pushUnique($[ee], W) : $[ee] = [W];
            }
          }
          for (w in $) {
            var le = $[w], ie = F._subplots[w];
            if (Array.isArray(ie)) for (re = 0; re < ie.length; re++) {
              var pe = ie[re], _e = w === "cartesian" ? F._plots[pe] : F[pe];
              for (E = 0; E < le.length; E++) le[E](O, _e, pe);
            }
            else for (E = 0; E < le.length; E++) le[E](O);
          }
        }
        y.rehover = function(O) {
          O._fullLayout._rehover && O._fullLayout._rehover();
        }, y.redrag = function(O) {
          O._fullLayout._redrag && O._fullLayout._redrag();
        }, y.reselect = function(O) {
          var F = O._fullLayout, S = (O.layout || {}).selections, $ = F._previousSelections;
          F._previousSelections = S;
          var re = F._reselect || JSON.stringify(S) !== JSON.stringify($);
          r.getComponentMethod("selections", "reselect")(O, re);
        }, y.generalUpdatePerTraceModule = function(O, F, S, $) {
          var re = F.traceHash, E = {}, w;
          for (w = 0; w < S.length; w++) {
            var N = S[w], W = N[0].trace;
            W.visible && (E[W.type] = E[W.type] || [], E[W.type].push(N));
          }
          for (var ee in re) if (!E[ee]) {
            var le = re[ee][0], ie = le[0].trace;
            ie.visible = !1, E[ee] = [le];
          }
          for (var pe in E) {
            var _e = E[pe], Ae = _e[0][0].trace._module;
            Ae.plot(O, F, t.filterVisible(_e), $);
          }
          F.traceHash = E;
        }, y.plotBasePlot = function(O, F, S, $, re) {
          var E = r.getModule(O), w = m(F.calcdata, E)[0];
          E.plot(F, w, $, re);
        }, y.cleanBasePlot = function(O, F, S, $, re) {
          var E = re._has && re._has(O), w = S._has && S._has(O);
          E && !w && re["_" + O + "layer"].selectAll("g.trace").remove();
        };
      }), va = xe((L) => {
        L.xmlns = "http://www.w3.org/2000/xmlns/", L.svg = "http://www.w3.org/2000/svg", L.xlink = "http://www.w3.org/1999/xlink", L.svgAttrs = { xmlns: L.svg, "xmlns:xlink": L.xlink };
      }), kn = xe((L, k) => {
        k.exports = { FROM_BL: { left: 0, center: 0.5, right: 1, bottom: 0, middle: 0.5, top: 1 }, FROM_TL: { left: 0, center: 0.5, right: 1, bottom: 1, middle: 0.5, top: 0 }, FROM_BR: { left: 1, center: 0.5, right: 0, bottom: 0, middle: 0.5, top: 1 }, LINE_SPACING: 1.3, CAP_SHIFT: 0.7, MID_SHIFT: 0.35, OPPOSITE_SIDE: { left: "right", right: "left", top: "bottom", bottom: "top" } };
      }), xn = xe((L) => {
        var k = vr(), n = wt(), e = n.strTranslate, a = va(), i = kn().LINE_SPACING, o = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
        L.convertToTspans = function(V, Z, Y) {
          var C = V.text(), j = !V.attr("data-notex") && Z && Z._context.typesetMath && typeof MathJax < "u" && C.match(o), J = k.select(V.node().parentNode);
          if (J.empty()) return;
          var ne = V.attr("class") ? V.attr("class").split(" ")[0] : "text";
          ne += "-math", J.selectAll("svg." + ne).remove(), J.selectAll("g." + ne + "-group").remove(), V.style("display", null).attr({ "data-unformatted": C, "data-math": "N" });
          function ae() {
            J.empty() || (ne = V.attr("class") + "-math", J.select("svg." + ne).remove()), V.text("").style("white-space", "pre");
            var se = U(V.node(), C);
            se && V.style("pointer-events", "all"), L.positionText(V), Y && Y.call(V);
          }
          return j ? (Z && Z._promises || []).push(new Promise(function(se) {
            V.style("display", "none");
            var O = parseInt(V.node().style.fontSize, 10), F = { fontSize: O };
            p(j[2], F, function(S, $, re) {
              J.selectAll("svg." + ne).remove(), J.selectAll("g." + ne + "-group").remove();
              var E = S && S.select("svg");
              if (!E || !E.node()) {
                ae(), se();
                return;
              }
              var w = J.append("g").classed(ne + "-group", !0).attr({ "pointer-events": "none", "data-unformatted": C, "data-math": "Y" });
              w.node().appendChild(E.node()), $ && $.node() && E.node().insertBefore($.node().cloneNode(!0), E.node().firstChild);
              var N = re.width, W = re.height;
              E.attr({ class: ne, height: W, preserveAspectRatio: "xMinYMin meet" }).style({ overflow: "visible", "pointer-events": "none" });
              var ee = V.node().style.fill || "black", le = E.select("g");
              le.attr({ fill: ee, stroke: ee });
              var ie = le.node().getBoundingClientRect(), pe = ie.width, _e = ie.height;
              (pe > N || _e > W) && (E.style("overflow", "hidden"), ie = E.node().getBoundingClientRect(), pe = ie.width, _e = ie.height);
              var Ae = +V.attr("x"), Ce = +V.attr("y"), Ue = O || V.node().getBoundingClientRect().height, Ne = -Ue / 4;
              if (ne[0] === "y") w.attr({ transform: "rotate(" + [-90, Ae, Ce] + ")" + e(-pe / 2, Ne - _e / 2) });
              else if (ne[0] === "l") Ce = Ne - _e / 2;
              else if (ne[0] === "a" && ne.indexOf("atitle") !== 0) Ae = 0, Ce = Ne;
              else {
                var ke = V.attr("text-anchor");
                Ae = Ae - pe * (ke === "middle" ? 0.5 : ke === "end" ? 1 : 0), Ce = Ce + Ne - _e / 2;
              }
              E.attr({ x: Ae, y: Ce }), Y && Y.call(V, w), se(w);
            });
          })) : ae(), V;
        };
        var r = /(<|&lt;|&#60;)/g, s = /(>|&gt;|&#62;)/g;
        function c(V) {
          return V.replace(r, "\\lt ").replace(s, "\\gt ");
        }
        var t = [["$", "$"], ["\\(", "\\)"]];
        function p(V, Z, Y) {
          var C = parseInt((MathJax.version || "").split(".")[0]);
          if (C !== 2 && C !== 3) {
            n.warn("No MathJax version:", MathJax.version);
            return;
          }
          var j, J, ne, ae, se = function() {
            return J = n.extendDeepAll({}, MathJax.Hub.config), ne = MathJax.Hub.processSectionDelay, MathJax.Hub.processSectionDelay !== void 0 && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({ messageStyle: "none", tex2jax: { inlineMath: t }, displayAlign: "left" });
          }, O = function() {
            J = n.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = t;
          }, F = function() {
            if (j = MathJax.Hub.config.menuSettings.renderer, j !== "SVG") return MathJax.Hub.setRenderer("SVG");
          }, S = function() {
            j = MathJax.config.startup.output, j !== "svg" && (MathJax.config.startup.output = "svg");
          }, $ = function() {
            var ee = "math-output-" + n.randstr({}, 64);
            ae = k.select("body").append("div").attr({ id: ee }).style({ visibility: "hidden", position: "absolute", "font-size": Z.fontSize + "px" }).text(c(V));
            var le = ae.node();
            return C === 2 ? MathJax.Hub.Typeset(le) : MathJax.typeset([le]);
          }, re = function() {
            var ee = ae.select(C === 2 ? ".MathJax_SVG" : ".MathJax"), le = !ee.empty() && ae.select("svg").node();
            if (!le) n.log("There was an error in the tex syntax.", V), Y();
            else {
              var ie = le.getBoundingClientRect(), pe;
              C === 2 ? pe = k.select("body").select("#MathJax_SVG_glyphs") : pe = ee.select("defs"), Y(ee, pe, ie);
            }
            ae.remove();
          }, E = function() {
            if (j !== "SVG") return MathJax.Hub.setRenderer(j);
          }, w = function() {
            j !== "svg" && (MathJax.config.startup.output = j);
          }, N = function() {
            return ne !== void 0 && (MathJax.Hub.processSectionDelay = ne), MathJax.Hub.Config(J);
          }, W = function() {
            MathJax.config = J;
          };
          C === 2 ? MathJax.Hub.Queue(se, F, $, re, E, N) : C === 3 && (O(), S(), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function() {
            $(), re(), w(), W();
          }));
        }
        var l = { sup: "font-size:70%", sub: "font-size:70%", s: "text-decoration:line-through", u: "text-decoration:underline", b: "font-weight:bold", i: "font-style:italic", a: "cursor:pointer", span: "", em: "font-style:italic;font-weight:bold" }, f = { sub: "0.3em", sup: "-0.6em" }, v = { sub: "-0.21em", sup: "0.42em" }, g = "​", x = ["http:", "https:", "mailto:", "", void 0, ":"], h = L.NEWLINES = /(\r\n?|\n)/g, m = /(<[^<>]*>)/, u = /<(\/?)([^ >]*)(\s+(.*))?>/i, d = /<br(\s+.*)?>/i;
        L.BR_TAG_ALL = /<br(\s+.*)?>/gi;
        var y = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i, _ = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i, T = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i, R = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
        function I(V, Z) {
          if (!V) return null;
          var Y = V.match(Z), C = Y && (Y[3] || Y[4]);
          return C && z(C);
        }
        var P = /(^|;)\s*color:/;
        L.plainText = function(V, Z) {
          Z = Z || {};
          for (var Y = Z.len !== void 0 && Z.len !== -1 ? Z.len : 1 / 0, C = Z.allowedTags !== void 0 ? Z.allowedTags : ["br"], j = "...", J = j.length, ne = V.split(m), ae = [], se = "", O = 0, F = 0; F < ne.length; F++) {
            var S = ne[F], $ = S.match(u), re = $ && $[2].toLowerCase();
            if (re) C.indexOf(re) !== -1 && (ae.push(S), se = re);
            else {
              var E = S.length;
              if (O + E < Y) ae.push(S), O += E;
              else if (O < Y) {
                var w = Y - O;
                se && (se !== "br" || w <= J || E <= J) && ae.pop(), Y > J ? ae.push(S.substr(0, w - J) + j) : ae.push(S.substr(0, w));
                break;
              }
              se = "";
            }
          }
          return ae.join("");
        };
        var M = { mu: "μ", amp: "&", lt: "<", gt: ">", nbsp: " ", times: "×", plusmn: "±", deg: "°" }, B = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
        function z(V) {
          return V.replace(B, function(Z, Y) {
            var C;
            return Y.charAt(0) === "#" ? C = q(Y.charAt(1) === "x" ? parseInt(Y.substr(2), 16) : parseInt(Y.substr(1), 10)) : C = M[Y], C || Z;
          });
        }
        L.convertEntities = z;
        function q(V) {
          if (!(V > 1114111)) {
            var Z = String.fromCodePoint;
            if (Z) return Z(V);
            var Y = String.fromCharCode;
            return V <= 65535 ? Y(V) : Y((V >> 10) + 55232, V % 1024 + 56320);
          }
        }
        function U(V, Z) {
          Z = Z.replace(h, " ");
          var Y = !1, C = [], j, J = -1;
          function ne() {
            J++;
            var _e = document.createElementNS(a.svg, "tspan");
            k.select(_e).attr({ class: "line", dy: J * i + "em" }), V.appendChild(_e), j = _e;
            var Ae = C;
            if (C = [{ node: _e }], Ae.length > 1) for (var Ce = 1; Ce < Ae.length; Ce++) ae(Ae[Ce]);
          }
          function ae(_e) {
            var Ae = _e.type, Ce = {}, Ue;
            if (Ae === "a") {
              Ue = "a";
              var Ne = _e.target, ke = _e.href, A = _e.popup;
              ke && (Ce = { "xlink:xlink:show": Ne === "_blank" || Ne.charAt(0) !== "_" ? "new" : "replace", target: Ne, "xlink:xlink:href": ke }, A && (Ce.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + A + '");return false;'));
            } else Ue = "tspan";
            _e.style && (Ce.style = _e.style);
            var X = document.createElementNS(a.svg, Ue);
            if (Ae === "sup" || Ae === "sub") {
              se(j, g), j.appendChild(X);
              var H = document.createElementNS(a.svg, "tspan");
              se(H, g), k.select(H).attr("dy", v[Ae]), Ce.dy = f[Ae], j.appendChild(X), j.appendChild(H);
            } else j.appendChild(X);
            k.select(X).attr(Ce), j = _e.node = X, C.push(_e);
          }
          function se(_e, Ae) {
            _e.appendChild(document.createTextNode(Ae));
          }
          function O(_e) {
            if (C.length === 1) {
              n.log("Ignoring unexpected end tag </" + _e + ">.", Z);
              return;
            }
            var Ae = C.pop();
            _e !== Ae.type && n.log("Start tag <" + Ae.type + "> doesnt match end tag <" + _e + ">. Pretending it did match.", Z), j = C[C.length - 1].node;
          }
          var F = d.test(Z);
          F ? ne() : (j = V, C = [{ node: V }]);
          for (var S = Z.split(m), $ = 0; $ < S.length; $++) {
            var re = S[$], E = re.match(u), w = E && E[2].toLowerCase(), N = l[w];
            if (w === "br") ne();
            else if (N === void 0) se(j, z(re));
            else if (E[1]) O(w);
            else {
              var W = E[4], ee = { type: w }, le = I(W, y);
              if (le ? (le = le.replace(P, "$1 fill:"), N && (le += ";" + N)) : N && (le = N), le && (ee.style = le), w === "a") {
                Y = !0;
                var ie = I(W, _);
                if (ie) {
                  var pe = G(ie);
                  pe && (ee.href = pe, ee.target = I(W, T) || "_blank", ee.popup = I(W, R));
                }
              }
              ae(ee);
            }
          }
          return Y;
        }
        function G(V) {
          var Z = encodeURI(decodeURI(V)), Y = document.createElement("a"), C = document.createElement("a");
          Y.href = V, C.href = Z;
          var j = Y.protocol, J = C.protocol;
          return x.indexOf(j) !== -1 && x.indexOf(J) !== -1 ? Z : "";
        }
        L.sanitizeHTML = function(V) {
          V = V.replace(h, " ");
          for (var Z = document.createElement("p"), Y = Z, C = [], j = V.split(m), J = 0; J < j.length; J++) {
            var ne = j[J], ae = ne.match(u), se = ae && ae[2].toLowerCase();
            if (se in l) if (ae[1]) C.length && (Y = C.pop());
            else {
              var O = ae[4], F = I(O, y), S = F ? { style: F } : {};
              if (se === "a") {
                var $ = I(O, _);
                if ($) {
                  var re = G($);
                  if (re) {
                    S.href = re;
                    var E = I(O, T);
                    E && (S.target = E);
                  }
                }
              }
              var w = document.createElement(se);
              Y.appendChild(w), k.select(w).attr(S), Y = w, C.push(w);
            }
            else Y.appendChild(document.createTextNode(z(ne)));
          }
          var N = "innerHTML";
          return Z[N];
        }, L.lineCount = function(V) {
          return V.selectAll("tspan.line").size() || 1;
        }, L.positionText = function(V, Z, Y) {
          return V.each(function() {
            var C = k.select(this);
            function j(ae, se) {
              return se === void 0 ? (se = C.attr(ae), se === null && (C.attr(ae, 0), se = 0)) : C.attr(ae, se), se;
            }
            var J = j("x", Z), ne = j("y", Y);
            this.nodeName === "text" && C.selectAll("tspan.line").attr({ x: J, y: ne });
          });
        };
        function K(V, Z, Y) {
          var C = Y.horizontalAlign, j = Y.verticalAlign || "top", J = V.node().getBoundingClientRect(), ne = Z.node().getBoundingClientRect(), ae, se, O;
          return j === "bottom" ? se = function() {
            return J.bottom - ae.height;
          } : j === "middle" ? se = function() {
            return J.top + (J.height - ae.height) / 2;
          } : se = function() {
            return J.top;
          }, C === "right" ? O = function() {
            return J.right - ae.width;
          } : C === "center" ? O = function() {
            return J.left + (J.width - ae.width) / 2;
          } : O = function() {
            return J.left;
          }, function() {
            ae = this.node().getBoundingClientRect();
            var F = O() - ne.left, S = se() - ne.top, $ = Y.gd || {};
            if (Y.gd) {
              $._fullLayout._calcInverseTransform($);
              var re = n.apply3DTransform($._fullLayout._invTransform)(F, S);
              F = re[0], S = re[1];
            }
            return this.style({ top: S + "px", left: F + "px", "z-index": 1e3 }), this;
          };
        }
        var te = "1px ";
        L.makeTextShadow = function(V) {
          var Z = te, Y = te, C = te;
          return Z + Y + C + V + ", -" + Z + "-" + Y + C + V + ", " + Z + "-" + Y + C + V + ", -" + Z + Y + C + V;
        }, L.makeEditable = function(V, Z) {
          var Y = Z.gd, C = Z.delegate, j = k.dispatch("edit", "input", "cancel"), J = C || V;
          if (V.style({ "pointer-events": C ? "none" : "all" }), V.size() !== 1) throw new Error("boo");
          function ne() {
            se(), V.style({ opacity: 0 });
            var O = J.attr("class"), F;
            O ? F = "." + O.split(" ")[0] + "-math-group" : F = "[class*=-math-group]", F && k.select(V.node().parentNode).select(F).style({ opacity: 0 });
          }
          function ae(O) {
            var F = O.node(), S = document.createRange();
            S.selectNodeContents(F);
            var $ = window.getSelection();
            $.removeAllRanges(), $.addRange(S), F.focus();
          }
          function se() {
            var O = k.select(Y), F = O.select(".svg-container"), S = F.append("div"), $ = V.node().style, re = parseFloat($.fontSize || 12), E = Z.text;
            E === void 0 && (E = V.attr("data-unformatted")), S.classed("plugin-editable editable", !0).style({ position: "absolute", "font-family": $.fontFamily || "Arial", "font-size": re, color: Z.fill || $.fill || "black", opacity: 1, "background-color": Z.background || "transparent", outline: "#ffffff33 1px solid", margin: [-re / 8 + 1, 0, 0, -1].join("px ") + "px", padding: "0", "box-sizing": "border-box" }).attr({ contenteditable: !0 }).text(E).call(K(V, F, Z)).on("blur", function() {
              Y._editing = !1, V.text(this.textContent).style({ opacity: 1 });
              var w = k.select(this).attr("class"), N;
              w ? N = "." + w.split(" ")[0] + "-math-group" : N = "[class*=-math-group]", N && k.select(V.node().parentNode).select(N).style({ opacity: 0 });
              var W = this.textContent;
              k.select(this).transition().duration(0).remove(), k.select(document).on("mouseup", null), j.edit.call(V, W);
            }).on("focus", function() {
              var w = this;
              Y._editing = !0, k.select(document).on("mouseup", function() {
                if (k.event.target === w) return !1;
                document.activeElement === S.node() && S.node().blur();
              });
            }).on("keyup", function() {
              k.event.which === 27 ? (Y._editing = !1, V.style({ opacity: 1 }), k.select(this).style({ opacity: 0 }).on("blur", function() {
                return !1;
              }).transition().remove(), j.cancel.call(V, this.textContent)) : (j.input.call(V, this.textContent), k.select(this).call(K(V, F, Z)));
            }).on("keydown", function() {
              k.event.which === 13 && this.blur();
            }).call(ae);
          }
          return Z.immediate ? ne() : J.on("click", ne), k.rebind(V, j, "on");
        };
      }), Un = xe((L, k) => {
        var n = vr(), e = Nn(), a = xr(), i = wt(), o = fr(), r = Pa().isValid;
        function s(h, m, u) {
          var d = m ? i.nestedProperty(h, m).get() || {} : h, y = d[u || "color"];
          y && y._inputArray && (y = y._inputArray);
          var _ = !1;
          if (i.isArrayOrTypedArray(y)) {
            for (var T = 0; T < y.length; T++) if (a(y[T])) {
              _ = !0;
              break;
            }
          }
          return i.isPlainObject(d) && (_ || d.showscale === !0 || a(d.cmin) && a(d.cmax) || r(d.colorscale) || i.isPlainObject(d.colorbar));
        }
        var c = ["showscale", "autocolorscale", "colorscale", "reversescale", "colorbar"], t = ["min", "max", "mid", "auto"];
        function p(h) {
          var m = h._colorAx, u = m || h, d = {}, y, _, T;
          for (_ = 0; _ < c.length; _++) T = c[_], d[T] = u[T];
          if (m) for (y = "c", _ = 0; _ < t.length; _++) T = t[_], d[T] = u["c" + T];
          else {
            var R;
            for (_ = 0; _ < t.length; _++) {
              if (T = t[_], R = "c" + T, R in u) {
                d[T] = u[R];
                continue;
              }
              R = "z" + T, R in u && (d[T] = u[R]);
            }
            y = R.charAt(0);
          }
          return d._sync = function(I, P) {
            var M = t.indexOf(I) !== -1 ? y + I : I;
            u[M] = u["_" + M] = P;
          }, d;
        }
        function l(h) {
          for (var m = p(h), u = m.min, d = m.max, y = m.reversescale ? f(m.colorscale) : m.colorscale, _ = y.length, T = new Array(_), R = new Array(_), I = 0; I < _; I++) {
            var P = y[I];
            T[I] = u + P[0] * (d - u), R[I] = P[1];
          }
          return { domain: T, range: R };
        }
        function f(h) {
          for (var m = h.length, u = new Array(m), d = m - 1, y = 0; d >= 0; d--, y++) {
            var _ = h[d];
            u[y] = [1 - _[0], _[1]];
          }
          return u;
        }
        function v(h, m) {
          m = m || {};
          for (var u = h.domain, d = h.range, y = d.length, _ = new Array(y), T = 0; T < y; T++) {
            var R = e(d[T]).toRgb();
            _[T] = [R.r, R.g, R.b, R.a];
          }
          var I = n.scale.linear().domain(u).range(_).clamp(!0), P = m.noNumericCheck, M = m.returnArray, B;
          return P && M ? B = I : P ? B = function(z) {
            return x(I(z));
          } : M ? B = function(z) {
            return a(z) ? I(z) : e(z).isValid() ? z : o.defaultLine;
          } : B = function(z) {
            return a(z) ? x(I(z)) : e(z).isValid() ? z : o.defaultLine;
          }, B.domain = I.domain, B.range = function() {
            return d;
          }, B;
        }
        function g(h, m) {
          return v(l(h), m);
        }
        function x(h) {
          var m = { r: h[0], g: h[1], b: h[2], a: h[3] };
          return e(m).toRgbString();
        }
        k.exports = { hasColorscale: s, extractOpts: p, extractScale: l, flipScale: f, makeColorScaleFunc: v, makeColorScaleFuncFromTrace: g };
      }), na = xe((L, k) => {
        var n = Xl(), e = n.FORMAT_LINK, a = n.DATE_FORMAT_LINK;
        function i(s, c) {
          return { valType: "string", dflt: "", editType: "none", description: (c ? o : r)("hover text", s) + ["By default the values are formatted using " + (c ? "generic number format" : "`" + s + "axis.hoverformat`") + "."].join(" ") };
        }
        function o(s, c) {
          return ["Sets the " + s + " formatting rule" + (c ? "for `" + c + "` " : ""), "using d3 formatting mini-languages", "which are very similar to those in Python. For numbers, see: " + e + "."].join(" ");
        }
        function r(s, c) {
          return o(s, c) + [" And for dates see: " + a + ".", "We add two items to d3's date formatter:", "*%h* for half of the year as a decimal number as well as", "*%{n}f* for fractional seconds", "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat", "*%H~%M~%S.%2f* would display *09~15~23.46*"].join(" ");
        }
        k.exports = { axisHoverFormat: i, descriptionOnlyNumbers: o, descriptionWithDates: r };
      }), Xn = xe((L, k) => {
        var n = hn(), e = Zn(), a = Wn().dash, i = Br().extendFlat, o = qr().templatedArray;
        qn().templateFormatStringDescription;
        var r = na().descriptionWithDates, s = Yr().ONEDAY, c = mn(), t = c.HOUR_PATTERN, p = c.WEEKDAY_PATTERN, l = { valType: "enumerated", values: ["auto", "linear", "array"], editType: "ticks", impliedEdits: { tick0: void 0, dtick: void 0 } }, f = i({}, l, { values: l.values.slice().concat(["sync"]) });
        function v(P) {
          return { valType: "integer", min: 0, dflt: P ? 5 : 0, editType: "ticks" };
        }
        var g = { valType: "any", editType: "ticks", impliedEdits: { tickmode: "linear" } }, x = { valType: "any", editType: "ticks", impliedEdits: { tickmode: "linear" } }, h = { valType: "data_array", editType: "ticks" }, m = { valType: "enumerated", values: ["outside", "inside", ""], editType: "ticks" };
        function u(P) {
          var M = { valType: "number", min: 0, editType: "ticks" };
          return P || (M.dflt = 5), M;
        }
        function d(P) {
          var M = { valType: "number", min: 0, editType: "ticks" };
          return P || (M.dflt = 1), M;
        }
        var y = { valType: "color", dflt: e.defaultLine, editType: "ticks" }, _ = { valType: "color", dflt: e.lightLine, editType: "ticks" };
        function T(P) {
          var M = { valType: "number", min: 0, editType: "ticks" };
          return P || (M.dflt = 1), M;
        }
        var R = i({}, a, { editType: "ticks" }), I = { valType: "boolean", editType: "ticks" };
        k.exports = { visible: { valType: "boolean", editType: "plot" }, color: { valType: "color", dflt: e.defaultLine, editType: "ticks" }, title: { text: { valType: "string", editType: "ticks" }, font: n({ editType: "ticks" }), standoff: { valType: "number", min: 0, editType: "ticks" }, editType: "ticks" }, type: { valType: "enumerated", values: ["-", "linear", "log", "date", "category", "multicategory"], dflt: "-", editType: "calc", _noTemplating: !0 }, autotypenumbers: { valType: "enumerated", values: ["convert types", "strict"], dflt: "convert types", editType: "calc" }, autorange: { valType: "enumerated", values: [!0, !1, "reversed", "min reversed", "max reversed", "min", "max"], dflt: !0, editType: "axrange", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, autorangeoptions: { minallowed: { valType: "any", editType: "plot", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, maxallowed: { valType: "any", editType: "plot", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, clipmin: { valType: "any", editType: "plot", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, clipmax: { valType: "any", editType: "plot", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, include: { valType: "any", arrayOk: !0, editType: "plot", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, editType: "plot" }, rangemode: { valType: "enumerated", values: ["normal", "tozero", "nonnegative"], dflt: "normal", editType: "plot" }, range: { valType: "info_array", items: [{ valType: "any", editType: "axrange", impliedEdits: { "^autorange": !1 }, anim: !0 }, { valType: "any", editType: "axrange", impliedEdits: { "^autorange": !1 }, anim: !0 }], editType: "axrange", impliedEdits: { autorange: !1 }, anim: !0 }, minallowed: { valType: "any", editType: "plot", impliedEdits: { "^autorange": !1 } }, maxallowed: { valType: "any", editType: "plot", impliedEdits: { "^autorange": !1 } }, fixedrange: { valType: "boolean", dflt: !1, editType: "calc" }, modebardisable: { valType: "flaglist", flags: ["autoscale", "zoominout"], extras: ["none"], dflt: "none", editType: "modebar" }, insiderange: { valType: "info_array", items: [{ valType: "any", editType: "plot" }, { valType: "any", editType: "plot" }], editType: "plot" }, scaleanchor: { valType: "enumerated", values: [c.idRegex.x.toString(), c.idRegex.y.toString(), !1], editType: "plot" }, scaleratio: { valType: "number", min: 0, dflt: 1, editType: "plot" }, constrain: { valType: "enumerated", values: ["range", "domain"], editType: "plot" }, constraintoward: { valType: "enumerated", values: ["left", "center", "right", "top", "middle", "bottom"], editType: "plot" }, matches: { valType: "enumerated", values: [c.idRegex.x.toString(), c.idRegex.y.toString()], editType: "calc" }, rangebreaks: o("rangebreak", { enabled: { valType: "boolean", dflt: !0, editType: "calc" }, bounds: { valType: "info_array", items: [{ valType: "any", editType: "calc" }, { valType: "any", editType: "calc" }], editType: "calc" }, pattern: { valType: "enumerated", values: [p, t, ""], editType: "calc" }, values: { valType: "info_array", freeLength: !0, editType: "calc", items: { valType: "any", editType: "calc" } }, dvalue: { valType: "number", editType: "calc", min: 0, dflt: s }, editType: "calc" }), tickmode: f, nticks: v(), tick0: g, dtick: x, ticklabelstep: { valType: "integer", min: 1, dflt: 1, editType: "ticks" }, tickvals: h, ticktext: { valType: "data_array", editType: "ticks" }, ticks: m, tickson: { valType: "enumerated", values: ["labels", "boundaries"], dflt: "labels", editType: "ticks" }, ticklabelmode: { valType: "enumerated", values: ["instant", "period"], dflt: "instant", editType: "ticks" }, ticklabelposition: { valType: "enumerated", values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"], dflt: "outside", editType: "calc" }, ticklabeloverflow: { valType: "enumerated", values: ["allow", "hide past div", "hide past domain"], editType: "calc" }, ticklabelshift: { valType: "integer", dflt: 0, editType: "ticks" }, ticklabelstandoff: { valType: "integer", dflt: 0, editType: "ticks" }, ticklabelindex: { valType: "integer", arrayOk: !0, editType: "calc" }, mirror: { valType: "enumerated", values: [!0, "ticks", !1, "all", "allticks"], dflt: !1, editType: "ticks+layoutstyle" }, ticklen: u(), tickwidth: d(), tickcolor: y, showticklabels: { valType: "boolean", dflt: !0, editType: "ticks" }, labelalias: { valType: "any", dflt: !1, editType: "ticks" }, automargin: { valType: "flaglist", flags: ["height", "width", "left", "right", "top", "bottom"], extras: [!0, !1], dflt: !1, editType: "ticks" }, showspikes: { valType: "boolean", dflt: !1, editType: "modebar" }, spikecolor: { valType: "color", dflt: null, editType: "none" }, spikethickness: { valType: "number", dflt: 3, editType: "none" }, spikedash: i({}, a, { dflt: "dash", editType: "none" }), spikemode: { valType: "flaglist", flags: ["toaxis", "across", "marker"], dflt: "toaxis", editType: "none" }, spikesnap: { valType: "enumerated", values: ["data", "cursor", "hovered data"], dflt: "hovered data", editType: "none" }, tickfont: n({ editType: "ticks" }), tickangle: { valType: "angle", dflt: "auto", editType: "ticks" }, autotickangles: { valType: "info_array", freeLength: !0, items: { valType: "angle" }, dflt: [0, 30, 90], editType: "ticks" }, tickprefix: { valType: "string", dflt: "", editType: "ticks" }, showtickprefix: { valType: "enumerated", values: ["all", "first", "last", "none"], dflt: "all", editType: "ticks" }, ticksuffix: { valType: "string", dflt: "", editType: "ticks" }, showticksuffix: { valType: "enumerated", values: ["all", "first", "last", "none"], dflt: "all", editType: "ticks" }, showexponent: { valType: "enumerated", values: ["all", "first", "last", "none"], dflt: "all", editType: "ticks" }, exponentformat: { valType: "enumerated", values: ["none", "e", "E", "power", "SI", "B", "SI extended"], dflt: "B", editType: "ticks" }, minexponent: { valType: "number", dflt: 3, min: 0, editType: "ticks" }, separatethousands: { valType: "boolean", dflt: !1, editType: "ticks" }, tickformat: { valType: "string", dflt: "", editType: "ticks", description: r("tick label") }, tickformatstops: o("tickformatstop", { enabled: { valType: "boolean", dflt: !0, editType: "ticks" }, dtickrange: { valType: "info_array", items: [{ valType: "any", editType: "ticks" }, { valType: "any", editType: "ticks" }], editType: "ticks" }, value: { valType: "string", dflt: "", editType: "ticks" }, editType: "ticks" }), hoverformat: { valType: "string", dflt: "", editType: "none", description: r("hover text") }, unifiedhovertitle: { text: { valType: "string", dflt: "", editType: "none" }, editType: "none" }, showline: { valType: "boolean", dflt: !1, editType: "ticks+layoutstyle" }, linecolor: { valType: "color", dflt: e.defaultLine, editType: "layoutstyle" }, linewidth: { valType: "number", min: 0, dflt: 1, editType: "ticks+layoutstyle" }, showgrid: I, gridcolor: _, gridwidth: T(), griddash: R, zeroline: { valType: "boolean", editType: "ticks" }, zerolinecolor: { valType: "color", dflt: e.defaultLine, editType: "ticks" }, zerolinelayer: { valType: "enumerated", values: ["above traces", "below traces"], dflt: "below traces", editType: "plot" }, zerolinewidth: { valType: "number", dflt: 1, editType: "ticks" }, showdividers: { valType: "boolean", dflt: !0, editType: "ticks" }, dividercolor: { valType: "color", dflt: e.defaultLine, editType: "ticks" }, dividerwidth: { valType: "number", dflt: 1, editType: "ticks" }, anchor: { valType: "enumerated", values: ["free", c.idRegex.x.toString(), c.idRegex.y.toString()], editType: "plot" }, side: { valType: "enumerated", values: ["top", "bottom", "left", "right"], editType: "plot" }, overlaying: { valType: "enumerated", values: ["free", c.idRegex.x.toString(), c.idRegex.y.toString()], editType: "plot" }, minor: { tickmode: l, nticks: v("minor"), tick0: g, dtick: x, tickvals: h, ticks: m, ticklen: u("minor"), tickwidth: d("minor"), tickcolor: y, gridcolor: _, gridwidth: T("minor"), griddash: R, showgrid: I, editType: "ticks" }, minorloglabels: { valType: "enumerated", values: ["small digits", "complete", "none"], dflt: "small digits", editType: "calc" }, layer: { valType: "enumerated", values: ["above traces", "below traces"], dflt: "above traces", editType: "plot" }, domain: { valType: "info_array", items: [{ valType: "number", min: 0, max: 1, editType: "plot" }, { valType: "number", min: 0, max: 1, editType: "plot" }], dflt: [0, 1], editType: "plot" }, position: { valType: "number", min: 0, max: 1, dflt: 0, editType: "plot" }, autoshift: { valType: "boolean", dflt: !1, editType: "plot" }, shift: { valType: "number", editType: "plot" }, categoryorder: { valType: "enumerated", values: ["trace", "category ascending", "category descending", "array", "total ascending", "total descending", "min ascending", "min descending", "max ascending", "max descending", "sum ascending", "sum descending", "mean ascending", "mean descending", "geometric mean ascending", "geometric mean descending", "median ascending", "median descending"], dflt: "trace", editType: "calc" }, categoryarray: { valType: "data_array", editType: "calc" }, uirevision: { valType: "any", editType: "none" }, editType: "calc" };
      }), yo = xe((L, k) => {
        var n = Xn(), e = hn(), a = Br().extendFlat, i = ra().overrideAll;
        k.exports = i({ orientation: { valType: "enumerated", values: ["h", "v"], dflt: "v" }, thicknessmode: { valType: "enumerated", values: ["fraction", "pixels"], dflt: "pixels" }, thickness: { valType: "number", min: 0, dflt: 30 }, lenmode: { valType: "enumerated", values: ["fraction", "pixels"], dflt: "fraction" }, len: { valType: "number", min: 0, dflt: 1 }, x: { valType: "number" }, xref: { valType: "enumerated", dflt: "paper", values: ["container", "paper"], editType: "layoutstyle" }, xanchor: { valType: "enumerated", values: ["left", "center", "right"] }, xpad: { valType: "number", min: 0, dflt: 10 }, y: { valType: "number" }, yref: { valType: "enumerated", dflt: "paper", values: ["container", "paper"], editType: "layoutstyle" }, yanchor: { valType: "enumerated", values: ["top", "middle", "bottom"] }, ypad: { valType: "number", min: 0, dflt: 10 }, outlinecolor: n.linecolor, outlinewidth: n.linewidth, bordercolor: n.linecolor, borderwidth: { valType: "number", min: 0, dflt: 0 }, bgcolor: { valType: "color", dflt: "rgba(0,0,0,0)" }, tickmode: n.minor.tickmode, nticks: n.nticks, tick0: n.tick0, dtick: n.dtick, tickvals: n.tickvals, ticktext: n.ticktext, ticks: a({}, n.ticks, { dflt: "" }), ticklabeloverflow: a({}, n.ticklabeloverflow, {}), ticklabelposition: { valType: "enumerated", values: ["outside", "inside", "outside top", "inside top", "outside left", "inside left", "outside right", "inside right", "outside bottom", "inside bottom"], dflt: "outside" }, ticklen: n.ticklen, tickwidth: n.tickwidth, tickcolor: n.tickcolor, ticklabelstep: n.ticklabelstep, showticklabels: n.showticklabels, labelalias: n.labelalias, tickfont: e({}), tickangle: n.tickangle, tickformat: n.tickformat, tickformatstops: n.tickformatstops, tickprefix: n.tickprefix, showtickprefix: n.showtickprefix, ticksuffix: n.ticksuffix, showticksuffix: n.showticksuffix, separatethousands: n.separatethousands, exponentformat: n.exponentformat, minexponent: n.minexponent, showexponent: n.showexponent, title: { text: { valType: "string" }, font: e({}), side: { valType: "enumerated", values: ["right", "top", "bottom"] } } }, "colorbars", "from-root");
      }), ca = xe((L, k) => {
        var n = yo(), e = $a().counter, a = Kl(), i = Pa().scales;
        a(i);
        function o(r) {
          return "`" + r + "`";
        }
        k.exports = function(r, s) {
          r = r || "", s = s || {};
          var c = s.cLetter || "c";
          "onlyIfNumerical" in s && s.onlyIfNumerical;
          var t = "noScale" in s ? s.noScale : r === "marker.line", p = "showScaleDflt" in s ? s.showScaleDflt : c === "z", l = typeof s.colorscaleDflt == "string" ? i[s.colorscaleDflt] : null, f = s.editTypeOverride || "", v = r ? r + "." : "", g;
          "colorAttr" in s ? (g = s.colorAttr, s.colorAttr) : (g = { z: "z", c: "color" }[c], "" + o(v + g));
          var x = c + "auto", h = c + "min", m = c + "max", u = c + "mid", d = {};
          d[h] = d[m] = void 0;
          var y = {};
          y[x] = !1;
          var _ = {};
          return g === "color" && (_.color = { valType: "color", arrayOk: !0, editType: f || "style" }, s.anim && (_.color.anim = !0)), _[x] = { valType: "boolean", dflt: !0, editType: "calc", impliedEdits: d }, _[h] = { valType: "number", dflt: null, editType: f || "plot", impliedEdits: y }, _[m] = { valType: "number", dflt: null, editType: f || "plot", impliedEdits: y }, _[u] = { valType: "number", dflt: null, editType: "calc", impliedEdits: d }, _.colorscale = { valType: "colorscale", editType: "calc", dflt: l, impliedEdits: { autocolorscale: !1 } }, _.autocolorscale = { valType: "boolean", dflt: s.autoColorDflt !== !1, editType: "calc", impliedEdits: { colorscale: void 0 } }, _.reversescale = { valType: "boolean", dflt: !1, editType: "plot" }, t || (_.showscale = { valType: "boolean", dflt: p, editType: "calc" }, _.colorbar = n), s.noColorAxis || (_.coloraxis = { valType: "subplotid", regex: e("coloraxis"), dflt: null, editType: "calc" }), _;
        };
      }), rs = xe((L, k) => {
        var n = Br().extendFlat, e = ca(), a = Pa().scales;
        k.exports = { editType: "calc", colorscale: { editType: "calc", sequential: { valType: "colorscale", dflt: a.Reds, editType: "calc" }, sequentialminus: { valType: "colorscale", dflt: a.Blues, editType: "calc" }, diverging: { valType: "colorscale", dflt: a.RdBu, editType: "calc" } }, coloraxis: n({ _isSubplotObj: !0, editType: "calc" }, e("", { colorAttr: "corresponding trace color array(s)", noColorAxis: !0, showScaleDflt: !0 })) };
      }), ns = xe((L, k) => {
        var n = wt();
        k.exports = function(e) {
          return n.isPlainObject(e.colorbar);
        };
      }), as = xe((L) => {
        var k = xr(), n = wt(), e = Yr(), a = e.ONEDAY, i = e.ONEWEEK;
        L.dtick = function(o, r) {
          var s = r === "log", c = r === "date", t = r === "category", p = c ? a : 1;
          if (!o) return p;
          if (k(o)) return o = Number(o), o <= 0 ? p : t ? Math.max(1, Math.round(o)) : c ? Math.max(0.1, o) : o;
          if (typeof o != "string" || !(c || s)) return p;
          var l = o.charAt(0), f = o.substr(1);
          return f = k(f) ? Number(f) : 0, f <= 0 || !(c && l === "M" && f === Math.round(f) || s && l === "L" || s && l === "D" && (f === 1 || f === 2)) ? p : o;
        }, L.tick0 = function(o, r, s, c) {
          if (r === "date") return n.cleanDate(o, n.dateTick0(s, c % i === 0 ? 1 : 0));
          if (!(c === "D1" || c === "D2")) return k(o) ? Number(o) : 0;
        };
      }), mo = xe((L, k) => {
        var n = as(), e = wt().isArrayOrTypedArray, a = Hn().isTypedArraySpec, i = Hn().decodeTypedArraySpec;
        k.exports = function(o, r, s, c, t) {
          t || (t = {});
          var p = t.isMinor, l = p ? o.minor || {} : o, f = p ? r.minor : r, v = p ? "minor." : "";
          function g(T) {
            var R = l[T];
            return a(R) && (R = i(R)), R !== void 0 ? R : (f._template || {})[T];
          }
          var x = g("tick0"), h = g("dtick"), m = g("tickvals"), u = e(m) ? "array" : h ? "linear" : "auto", d = s(v + "tickmode", u);
          if (d === "auto" || d === "sync") s(v + "nticks");
          else if (d === "linear") {
            var y = f.dtick = n.dtick(h, c);
            f.tick0 = n.tick0(x, c, r.calendar, y);
          } else if (c !== "multicategory") {
            var _ = s(v + "tickvals");
            _ === void 0 ? f.tickmode = "auto" : p || s("ticktext");
          }
        };
      }), xo = xe((L, k) => {
        var n = wt(), e = Xn();
        k.exports = function(a, i, o, r) {
          var s = r.isMinor, c = s ? a.minor || {} : a, t = s ? i.minor : i, p = s ? e.minor : e, l = s ? "minor." : "", f = n.coerce2(c, t, p, "ticklen", s ? (i.ticklen || 5) * 0.6 : void 0), v = n.coerce2(c, t, p, "tickwidth", s ? i.tickwidth || 1 : void 0), g = n.coerce2(c, t, p, "tickcolor", (s ? i.tickcolor : void 0) || t.color), x = o(l + "ticks", !s && r.outerTicks || f || v || g ? "outside" : "");
          x || (delete t.ticklen, delete t.tickwidth, delete t.tickcolor);
        };
      }), is = xe((L, k) => {
        k.exports = function(n) {
          var e = ["showexponent", "showtickprefix", "showticksuffix"], a = e.filter(function(o) {
            return n[o] !== void 0;
          }), i = function(o) {
            return n[o] === n[a[0]];
          };
          if (a.every(i) || a.length === 1) return n[a[0]];
        };
      }), aa = xe((L, k) => {
        var n = wt(), e = qr();
        k.exports = function(a, i, o) {
          var r = o.name, s = o.inclusionAttr || "visible", c = i[r], t = n.isArrayOrTypedArray(a[r]) ? a[r] : [], p = i[r] = [], l = e.arrayTemplater(i, r, s), f, v;
          for (f = 0; f < t.length; f++) {
            var g = t[f];
            n.isPlainObject(g) ? v = l.newItem(g) : (v = l.newItem({}), v[s] = !1), v._index = f, v[s] !== !1 && o.handleItemDefaults(g, v, i, o), p.push(v);
          }
          var x = l.defaultItems();
          for (f = 0; f < x.length; f++) v = x[f], v._index = p.length, o.handleItemDefaults({}, v, i, o, {}), p.push(v);
          if (n.isArrayOrTypedArray(c)) {
            var h = Math.min(c.length, p.length);
            for (f = 0; f < h; f++) n.relinkPrivateKeys(p[f], c[f]);
          }
          return p;
        };
      }), bo = xe((L, k) => {
        var n = wt(), e = fr().contrast, a = Xn(), i = is(), o = aa();
        k.exports = function(s, c, t, p, l) {
          l || (l = {});
          var f = t("labelalias");
          n.isPlainObject(f) || delete c.labelalias;
          var v = i(s), g = t("showticklabels");
          if (g) {
            l.noTicklabelshift || t("ticklabelshift"), l.noTicklabelstandoff || t("ticklabelstandoff");
            var x = l.font || {}, h = c.color, m = c.ticklabelposition || "", u = m.indexOf("inside") !== -1 ? e(l.bgColor) : h && h !== a.color.dflt ? h : x.color;
            if (n.coerceFont(t, "tickfont", x, { overrideDflt: { color: u } }), !l.noTicklabelstep && p !== "multicategory" && p !== "log" && t("ticklabelstep"), !l.noAng) {
              var d = t("tickangle");
              !l.noAutotickangles && d === "auto" && t("autotickangles");
            }
            if (p !== "category") {
              var y = t("tickformat");
              o(s, c, { name: "tickformatstops", inclusionAttr: "enabled", handleItemDefaults: r }), c.tickformatstops.length || delete c.tickformatstops, !l.noExp && !y && p !== "date" && (t("showexponent", v), t("exponentformat"), t("minexponent"), t("separatethousands"));
            }
            !l.noMinorloglabels && p === "log" && t("minorloglabels");
          }
        };
        function r(s, c) {
          function t(l, f) {
            return n.coerce(s, c, a.tickformatstops, l, f);
          }
          var p = t("enabled");
          p && (t("dtickrange"), t("value"));
        }
      }), _o = xe((L, k) => {
        var n = is();
        k.exports = function(e, a, i, o, r) {
          r || (r = {});
          var s = r.tickSuffixDflt, c = n(e), t = i("tickprefix");
          t && i("showtickprefix", c);
          var p = i("ticksuffix", s);
          p && i("showticksuffix", c);
        };
      }), os = xe((L, k) => {
        var n = wt(), e = qr(), a = mo(), i = xo(), o = bo(), r = _o(), s = yo();
        k.exports = function(c, t, p) {
          var l = e.newContainer(t, "colorbar"), f = c.colorbar || {};
          function v(V, Z) {
            return n.coerce(f, l, s, V, Z);
          }
          var g = p.margin || { t: 0, b: 0, l: 0, r: 0 }, x = p.width - g.l - g.r, h = p.height - g.t - g.b, m = v("orientation"), u = m === "v", d = v("thicknessmode");
          v("thickness", d === "fraction" ? 30 / (u ? x : h) : 30);
          var y = v("lenmode");
          v("len", y === "fraction" ? 1 : u ? h : x);
          var _ = v("yref"), T = v("xref"), R = _ === "paper", I = T === "paper", P, M, B, z = "left";
          u ? (B = "middle", z = I ? "left" : "right", P = I ? 1.02 : 1, M = 0.5) : (B = R ? "bottom" : "top", z = "center", P = 0.5, M = R ? 1.02 : 1), n.coerce(f, l, { x: { valType: "number", min: I ? -2 : 0, max: I ? 3 : 1, dflt: P } }, "x"), n.coerce(f, l, { y: { valType: "number", min: R ? -2 : 0, max: R ? 3 : 1, dflt: M } }, "y"), v("xanchor", z), v("xpad"), v("yanchor", B), v("ypad"), n.noneOrAll(f, l, ["x", "y"]), v("outlinecolor"), v("outlinewidth"), v("bordercolor"), v("borderwidth"), v("bgcolor");
          var q = n.coerce(f, l, { ticklabelposition: { valType: "enumerated", dflt: "outside", values: u ? ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"] : ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] } }, "ticklabelposition");
          v("ticklabeloverflow", q.indexOf("inside") !== -1 ? "hide past domain" : "hide past div"), a(f, l, v, "linear");
          var U = p.font, G = { noAutotickangles: !0, noTicklabelshift: !0, noTicklabelstandoff: !0, outerTicks: !1, font: U };
          q.indexOf("inside") !== -1 && (G.bgColor = "black"), r(f, l, v, "linear", G), o(f, l, v, "linear", G), i(f, l, v, "linear", G), v("title.text", p._dfltTitle.colorbar);
          var K = l.showticklabels ? l.tickfont : U, te = n.extendFlat({}, U, { family: K.family, size: n.bigFont(K.size) });
          n.coerceFont(v, "title.font", te), v("title.side", u ? "top" : "right");
        };
      }), ga = xe((L, k) => {
        var n = xr(), e = wt(), a = ns(), i = os(), o = Pa().isValid, r = or().traceIs;
        function s(c, t) {
          var p = t.slice(0, t.length - 1);
          return t ? e.nestedProperty(c, p).get() || {} : c;
        }
        k.exports = function c(t, p, l, f, v) {
          var g = v.prefix, x = v.cLetter, h = "_module" in p, m = s(t, g), u = s(p, g), d = s(p._template || {}, g) || {}, y = function() {
            return delete t.coloraxis, delete p.coloraxis, c(t, p, l, f, v);
          };
          if (h) {
            var _ = l._colorAxes || {}, T = f(g + "coloraxis");
            if (T) {
              var R = r(p, "contour") && e.nestedProperty(p, "contours.coloring").get() || "heatmap", I = _[T];
              I ? (I[2].push(y), I[0] !== R && (I[0] = !1, e.warn(["Ignoring coloraxis:", T, "setting", "as it is linked to incompatible colorscales."].join(" ")))) : _[T] = [R, p, [y]];
              return;
            }
          }
          var P = m[x + "min"], M = m[x + "max"], B = n(P) && n(M) && P < M, z = f(g + x + "auto", !B);
          z ? f(g + x + "mid") : (f(g + x + "min"), f(g + x + "max"));
          var q = m.colorscale, U = d.colorscale, G;
          if (q !== void 0 && (G = !o(q)), U !== void 0 && (G = !o(U)), f(g + "autocolorscale", G), f(g + "colorscale"), f(g + "reversescale"), g !== "marker.line.") {
            var K;
            g && h && (K = a(m));
            var te = f(g + "showscale", K);
            te && (g && d && (u._template = d), i(m, u, l));
          }
        };
      }), xd = xe((L, k) => {
        var n = wt(), e = qr(), a = rs(), i = ga();
        k.exports = function(o, r) {
          function s(x, h) {
            return n.coerce(o, r, a, x, h);
          }
          s("colorscale.sequential"), s("colorscale.sequentialminus"), s("colorscale.diverging");
          var c = r._colorAxes, t, p;
          function l(x, h) {
            return n.coerce(t, p, a.coloraxis, x, h);
          }
          for (var f in c) {
            var v = c[f];
            if (v[0]) t = o[f] || {}, p = e.newContainer(r, f, "coloraxis"), p._name = f, i(t, p, r, l, { prefix: "", cLetter: "c" });
            else {
              for (var g = 0; g < v[2].length; g++) v[2][g]();
              delete r._colorAxes[f];
            }
          }
        };
      }), bd = xe((L, k) => {
        var n = wt(), e = Un().hasColorscale, a = Un().extractOpts;
        k.exports = function(i, o) {
          function r(v, g) {
            var x = v["_" + g];
            x !== void 0 && (v[g] = x);
          }
          function s(v, g) {
            var x = g.container ? n.nestedProperty(v, g.container).get() : v;
            if (x) if (x.coloraxis) x._colorAx = o[x.coloraxis];
            else {
              var h = a(x), m = h.auto;
              (m || h.min === void 0) && r(x, g.min), (m || h.max === void 0) && r(x, g.max), h.autocolorscale && r(x, "colorscale");
            }
          }
          for (var c = 0; c < i.length; c++) {
            var t = i[c], p = t._module.colorbar;
            if (p) if (Array.isArray(p)) for (var l = 0; l < p.length; l++) s(t, p[l]);
            else s(t, p);
            e(t, "marker.line") && s(t, { container: "marker.line", min: "cmin", max: "cmax" });
          }
          for (var f in o._colorAxes) s(o[f], { min: "cmin", max: "cmax" });
        };
      }), ei = xe((L, k) => {
        var n = xr(), e = wt(), a = Un().extractOpts;
        k.exports = function(i, o, r) {
          var s = i._fullLayout, c = r.vals, t = r.containerStr, p = t ? e.nestedProperty(o, t).get() : o, l = a(p), f = l.auto !== !1, v = l.min, g = l.max, x = l.mid, h = function() {
            return e.aggNums(Math.min, null, c);
          }, m = function() {
            return e.aggNums(Math.max, null, c);
          };
          if (v === void 0 ? v = h() : f && (p._colorAx && n(v) ? v = Math.min(v, h()) : v = h()), g === void 0 ? g = m() : f && (p._colorAx && n(g) ? g = Math.max(g, m()) : g = m()), f && x !== void 0 && (g - x > x - v ? v = x - (g - x) : g - x < x - v && (g = x + (x - v))), v === g && (v -= 0.5, g += 0.5), l._sync("min", v), l._sync("max", g), l.autocolorscale) {
            var u;
            v * g < 0 ? u = s.colorscale.diverging : v >= 0 ? u = s.colorscale.sequential : u = s.colorscale.sequentialminus, l._sync("colorscale", u);
          }
        };
      }), fa = xe((L, k) => {
        var n = Pa(), e = Un();
        k.exports = { moduleType: "component", name: "colorscale", attributes: ca(), layoutAttributes: rs(), supplyLayoutDefaults: xd(), handleDefaults: ga(), crossTraceDefaults: bd(), calc: ei(), scales: n.scales, defaultScale: n.defaultScale, getScale: n.get, isValidScale: n.isValid, hasColorscale: e.hasColorscale, extractOpts: e.extractOpts, extractScale: e.extractScale, flipScale: e.flipScale, makeColorScaleFunc: e.makeColorScaleFunc, makeColorScaleFuncFromTrace: e.makeColorScaleFuncFromTrace };
      }), Fn = xe((L, k) => {
        var n = wt(), e = Hn().isTypedArraySpec;
        k.exports = { hasLines: function(a) {
          return a.visible && a.mode && a.mode.indexOf("lines") !== -1;
        }, hasMarkers: function(a) {
          return a.visible && (a.mode && a.mode.indexOf("markers") !== -1 || a.type === "splom");
        }, hasText: function(a) {
          return a.visible && a.mode && a.mode.indexOf("text") !== -1;
        }, isBubble: function(a) {
          var i = a.marker;
          return n.isPlainObject(i) && (n.isArrayOrTypedArray(i.size) || e(i.size));
        } };
      }), _d = xe((L, k) => {
        var n = xr();
        k.exports = function(e, a) {
          a || (a = 2);
          var i = e.marker, o = i.sizeref || 1, r = i.sizemin || 0, s = i.sizemode === "area" ? function(c) {
            return Math.sqrt(c / o);
          } : function(c) {
            return c / o;
          };
          return function(c) {
            var t = s(c / a);
            return n(t) && t > 0 ? Math.max(t, r) : 0;
          };
        };
      }), da = xe((L) => {
        var k = wt();
        L.getSubplot = function(r) {
          return r.subplot || r.xaxis + r.yaxis || r.geo;
        }, L.isTraceInSubplots = function(r, s) {
          if (r.type === "splom") {
            for (var c = r.xaxes || [], t = r.yaxes || [], p = 0; p < c.length; p++) for (var l = 0; l < t.length; l++) if (s.indexOf(c[p] + t[l]) !== -1) return !0;
            return !1;
          }
          return s.indexOf(L.getSubplot(r)) !== -1;
        }, L.flat = function(r, s) {
          for (var c = new Array(r.length), t = 0; t < r.length; t++) c[t] = s;
          return c;
        }, L.p2c = function(r, s) {
          for (var c = new Array(r.length), t = 0; t < r.length; t++) c[t] = r[t].p2c(s);
          return c;
        }, L.getDistanceFunction = function(r, s, c, t) {
          return r === "closest" ? t || L.quadrature(s, c) : r.charAt(0) === "x" ? s : c;
        }, L.getClosest = function(r, s, c) {
          if (c.index !== !1) c.index >= 0 && c.index < r.length ? c.distance = 0 : c.index = !1;
          else for (var t = 1 / 0, p = r.length, l = 0; l < p; l++) t = s(r[l]), t <= c.distance && (c.index = l, c.distance = t);
          return c;
        }, L.inbox = function(r, s, c) {
          return r * s < 0 || r === 0 ? c : 1 / 0;
        }, L.quadrature = function(r, s) {
          return function(c) {
            var t = r(c), p = s(c);
            return Math.sqrt(t * t + p * p);
          };
        }, L.makeEventData = function(r, s, c) {
          var t = "index" in r ? r.index : r.pointNumber, p = { data: s._input, fullData: s, curveNumber: s.index, pointNumber: t };
          if (s._indexToPoints) {
            var l = s._indexToPoints[t];
            l.length === 1 ? p.pointIndex = l[0] : p.pointIndices = l;
          } else p.pointIndex = t;
          return s._module.eventData ? p = s._module.eventData(p, r, s, c, t) : ("xVal" in r ? p.x = r.xVal : "x" in r && (p.x = r.x), "yVal" in r ? p.y = r.yVal : "y" in r && (p.y = r.y), r.xa && (p.xaxis = r.xa), r.ya && (p.yaxis = r.ya), r.zLabelVal !== void 0 && (p.z = r.zLabelVal)), L.appendArrayPointValue(p, s, t), p;
        }, L.appendArrayPointValue = function(r, s, c) {
          var t = s._arrayAttrs;
          if (t) for (var p = 0; p < t.length; p++) {
            var l = t[p], f = e(l);
            if (r[f] === void 0) {
              var v = k.nestedProperty(s, l).get(), g = a(v, c);
              g !== void 0 && (r[f] = g);
            }
          }
        }, L.appendArrayMultiPointValues = function(r, s, c) {
          var t = s._arrayAttrs;
          if (t) for (var p = 0; p < t.length; p++) {
            var l = t[p], f = e(l);
            if (r[f] === void 0) {
              for (var v = k.nestedProperty(s, l).get(), g = new Array(c.length), x = 0; x < c.length; x++) g[x] = a(v, c[x]);
              r[f] = g;
            }
          }
        };
        var n = { ids: "id", locations: "location", labels: "label", values: "value", "marker.colors": "color", parents: "parent" };
        function e(r) {
          return n[r] || r;
        }
        function a(r, s) {
          if (Array.isArray(s)) {
            if (k.isArrayOrTypedArray(r) && k.isArrayOrTypedArray(r[s[0]])) return r[s[0]][s[1]];
          } else return r[s];
        }
        var i = { x: !0, y: !0 }, o = { "x unified": !0, "y unified": !0 };
        L.isUnifiedHover = function(r) {
          return typeof r != "string" ? !1 : !!o[r];
        }, L.isXYhover = function(r) {
          return typeof r != "string" ? !1 : !!i[r];
        };
      }), ls = xe((L, k) => {
        k.exports = a;
        var n = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
        function a(r) {
          var s = [];
          return r.replace(e, function(c, t, p) {
            var l = t.toLowerCase();
            for (p = o(p), l == "m" && p.length > 2 && (s.push([t].concat(p.splice(0, 2))), l = "l", t = t == "m" ? "l" : "L"); ; ) {
              if (p.length == n[l]) return p.unshift(t), s.push(p);
              if (p.length < n[l]) throw new Error("malformed path data");
              s.push([t].concat(p.splice(0, n[l])));
            }
          }), s;
        }
        var i = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
        function o(r) {
          var s = r.match(i);
          return s ? s.map(Number) : [];
        }
      }), wd = xe((L, k) => {
        var n = ls(), e = function(x, h) {
          return h ? Math.round(x * (h = Math.pow(10, h))) / h : Math.round(x);
        }, a = "M0,0Z", i = Math.sqrt(2), o = Math.sqrt(3), r = Math.PI, s = Math.cos, c = Math.sin;
        k.exports = { circle: { n: 0, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = "M" + u + ",0A" + u + "," + u + " 0 1,1 0,-" + u + "A" + u + "," + u + " 0 0,1 " + u + ",0Z";
          return m ? g(h, m, d) : d;
        } }, square: { n: 1, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "H-" + u + "V-" + u + "H" + u + "Z");
        } }, diamond: { n: 2, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.3, 2);
          return g(h, m, "M" + u + ",0L0," + u + "L-" + u + ",0L0,-" + u + "Z");
        } }, cross: { n: 3, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.4, 2), d = e(x * 1.2, 2);
          return g(h, m, "M" + d + "," + u + "H" + u + "V" + d + "H-" + u + "V" + u + "H-" + d + "V-" + u + "H-" + u + "V-" + d + "H" + u + "V-" + u + "H" + d + "Z");
        } }, x: { n: 4, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.8 / i, 2), d = "l" + u + "," + u, y = "l" + u + ",-" + u, _ = "l-" + u + ",-" + u, T = "l-" + u + "," + u;
          return g(h, m, "M0," + u + d + y + _ + y + _ + T + _ + T + d + T + d + "Z");
        } }, "triangle-up": { n: 5, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2 / o, 2), d = e(x / 2, 2), y = e(x, 2);
          return g(h, m, "M-" + u + "," + d + "H" + u + "L0,-" + y + "Z");
        } }, "triangle-down": { n: 6, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2 / o, 2), d = e(x / 2, 2), y = e(x, 2);
          return g(h, m, "M-" + u + ",-" + d + "H" + u + "L0," + y + "Z");
        } }, "triangle-left": { n: 7, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2 / o, 2), d = e(x / 2, 2), y = e(x, 2);
          return g(h, m, "M" + d + ",-" + u + "V" + u + "L-" + y + ",0Z");
        } }, "triangle-right": { n: 8, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2 / o, 2), d = e(x / 2, 2), y = e(x, 2);
          return g(h, m, "M-" + d + ",-" + u + "V" + u + "L" + y + ",0Z");
        } }, "triangle-ne": { n: 9, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.6, 2), d = e(x * 1.2, 2);
          return g(h, m, "M-" + d + ",-" + u + "H" + u + "V" + d + "Z");
        } }, "triangle-se": { n: 10, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.6, 2), d = e(x * 1.2, 2);
          return g(h, m, "M" + u + ",-" + d + "V" + u + "H-" + d + "Z");
        } }, "triangle-sw": { n: 11, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.6, 2), d = e(x * 1.2, 2);
          return g(h, m, "M" + d + "," + u + "H-" + u + "V-" + d + "Z");
        } }, "triangle-nw": { n: 12, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.6, 2), d = e(x * 1.2, 2);
          return g(h, m, "M-" + u + "," + d + "V-" + u + "H" + d + "Z");
        } }, pentagon: { n: 13, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.951, 2), d = e(x * 0.588, 2), y = e(-x, 2), _ = e(x * -0.309, 2), T = e(x * 0.809, 2);
          return g(h, m, "M" + u + "," + _ + "L" + d + "," + T + "H-" + d + "L-" + u + "," + _ + "L0," + y + "Z");
        } }, hexagon: { n: 14, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x / 2, 2), y = e(x * o / 2, 2);
          return g(h, m, "M" + y + ",-" + d + "V" + d + "L0," + u + "L-" + y + "," + d + "V-" + d + "L0,-" + u + "Z");
        } }, hexagon2: { n: 15, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x / 2, 2), y = e(x * o / 2, 2);
          return g(h, m, "M-" + d + "," + y + "H" + d + "L" + u + ",0L" + d + ",-" + y + "H-" + d + "L-" + u + ",0Z");
        } }, octagon: { n: 16, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.924, 2), d = e(x * 0.383, 2);
          return g(h, m, "M-" + d + ",-" + u + "H" + d + "L" + u + ",-" + d + "V" + d + "L" + d + "," + u + "H-" + d + "L-" + u + "," + d + "V-" + d + "Z");
        } }, star: { n: 17, f: function(x, h, m) {
          if (t(h)) return a;
          var u = x * 1.4, d = e(u * 0.225, 2), y = e(u * 0.951, 2), _ = e(u * 0.363, 2), T = e(u * 0.588, 2), R = e(-u, 2), I = e(u * -0.309, 2), P = e(u * 0.118, 2), M = e(u * 0.809, 2), B = e(u * 0.382, 2);
          return g(h, m, "M" + d + "," + I + "H" + y + "L" + _ + "," + P + "L" + T + "," + M + "L0," + B + "L-" + T + "," + M + "L-" + _ + "," + P + "L-" + y + "," + I + "H-" + d + "L0," + R + "Z");
        } }, hexagram: { n: 18, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.66, 2), d = e(x * 0.38, 2), y = e(x * 0.76, 2);
          return g(h, m, "M-" + y + ",0l-" + d + ",-" + u + "h" + y + "l" + d + ",-" + u + "l" + d + "," + u + "h" + y + "l-" + d + "," + u + "l" + d + "," + u + "h-" + y + "l-" + d + "," + u + "l-" + d + ",-" + u + "h-" + y + "Z");
        } }, "star-triangle-up": { n: 19, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * o * 0.8, 2), d = e(x * 0.8, 2), y = e(x * 1.6, 2), _ = e(x * 4, 2), T = "A " + _ + "," + _ + " 0 0 1 ";
          return g(h, m, "M-" + u + "," + d + T + u + "," + d + T + "0,-" + y + T + "-" + u + "," + d + "Z");
        } }, "star-triangle-down": { n: 20, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * o * 0.8, 2), d = e(x * 0.8, 2), y = e(x * 1.6, 2), _ = e(x * 4, 2), T = "A " + _ + "," + _ + " 0 0 1 ";
          return g(h, m, "M" + u + ",-" + d + T + "-" + u + ",-" + d + T + "0," + y + T + u + ",-" + d + "Z");
        } }, "star-square": { n: 21, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.1, 2), d = e(x * 2, 2), y = "A " + d + "," + d + " 0 0 1 ";
          return g(h, m, "M-" + u + ",-" + u + y + "-" + u + "," + u + y + u + "," + u + y + u + ",-" + u + y + "-" + u + ",-" + u + "Z");
        } }, "star-diamond": { n: 22, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.4, 2), d = e(x * 1.9, 2), y = "A " + d + "," + d + " 0 0 1 ";
          return g(h, m, "M-" + u + ",0" + y + "0," + u + y + u + ",0" + y + "0,-" + u + y + "-" + u + ",0Z");
        } }, "diamond-tall": { n: 23, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 0.7, 2), d = e(x * 1.4, 2);
          return g(h, m, "M0," + d + "L" + u + ",0L0,-" + d + "L-" + u + ",0Z");
        } }, "diamond-wide": { n: 24, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.4, 2), d = e(x * 0.7, 2);
          return g(h, m, "M0," + d + "L" + u + ",0L0,-" + d + "L-" + u + ",0Z");
        } }, hourglass: { n: 25, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "H-" + u + "L" + u + ",-" + u + "H-" + u + "Z");
        }, noDot: !0 }, bowtie: { n: 26, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "V-" + u + "L-" + u + "," + u + "V-" + u + "Z");
        }, noDot: !0 }, "circle-cross": { n: 27, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M0," + u + "V-" + u + "M" + u + ",0H-" + u + "M" + u + ",0A" + u + "," + u + " 0 1,1 0,-" + u + "A" + u + "," + u + " 0 0,1 " + u + ",0Z");
        }, needLine: !0, noDot: !0 }, "circle-x": { n: 28, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x / i, 2);
          return g(h, m, "M" + d + "," + d + "L-" + d + ",-" + d + "M" + d + ",-" + d + "L-" + d + "," + d + "M" + u + ",0A" + u + "," + u + " 0 1,1 0,-" + u + "A" + u + "," + u + " 0 0,1 " + u + ",0Z");
        }, needLine: !0, noDot: !0 }, "square-cross": { n: 29, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M0," + u + "V-" + u + "M" + u + ",0H-" + u + "M" + u + "," + u + "H-" + u + "V-" + u + "H" + u + "Z");
        }, needLine: !0, noDot: !0 }, "square-x": { n: 30, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "L-" + u + ",-" + u + "M" + u + ",-" + u + "L-" + u + "," + u + "M" + u + "," + u + "H-" + u + "V-" + u + "H" + u + "Z");
        }, needLine: !0, noDot: !0 }, "diamond-cross": { n: 31, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.3, 2);
          return g(h, m, "M" + u + ",0L0," + u + "L-" + u + ",0L0,-" + u + "ZM0,-" + u + "V" + u + "M-" + u + ",0H" + u);
        }, needLine: !0, noDot: !0 }, "diamond-x": { n: 32, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.3, 2), d = e(x * 0.65, 2);
          return g(h, m, "M" + u + ",0L0," + u + "L-" + u + ",0L0,-" + u + "ZM-" + d + ",-" + d + "L" + d + "," + d + "M-" + d + "," + d + "L" + d + ",-" + d);
        }, needLine: !0, noDot: !0 }, "cross-thin": { n: 33, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.4, 2);
          return g(h, m, "M0," + u + "V-" + u + "M" + u + ",0H-" + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, "x-thin": { n: 34, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "L-" + u + ",-" + u + "M" + u + ",-" + u + "L-" + u + "," + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, asterisk: { n: 35, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.2, 2), d = e(x * 0.85, 2);
          return g(h, m, "M0," + u + "V-" + u + "M" + u + ",0H-" + u + "M" + d + "," + d + "L-" + d + ",-" + d + "M" + d + ",-" + d + "L-" + d + "," + d);
        }, needLine: !0, noDot: !0, noFill: !0 }, hash: { n: 36, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x / 2, 2), d = e(x, 2);
          return g(h, m, "M" + u + "," + d + "V-" + d + "M" + (u - d) + ",-" + d + "V" + d + "M" + d + "," + u + "H-" + d + "M-" + d + "," + (u - d) + "H" + d);
        }, needLine: !0, noFill: !0 }, "y-up": { n: 37, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.2, 2), d = e(x * 1.6, 2), y = e(x * 0.8, 2);
          return g(h, m, "M-" + u + "," + y + "L0,0M" + u + "," + y + "L0,0M0,-" + d + "L0,0");
        }, needLine: !0, noDot: !0, noFill: !0 }, "y-down": { n: 38, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.2, 2), d = e(x * 1.6, 2), y = e(x * 0.8, 2);
          return g(h, m, "M-" + u + ",-" + y + "L0,0M" + u + ",-" + y + "L0,0M0," + d + "L0,0");
        }, needLine: !0, noDot: !0, noFill: !0 }, "y-left": { n: 39, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.2, 2), d = e(x * 1.6, 2), y = e(x * 0.8, 2);
          return g(h, m, "M" + y + "," + u + "L0,0M" + y + ",-" + u + "L0,0M-" + d + ",0L0,0");
        }, needLine: !0, noDot: !0, noFill: !0 }, "y-right": { n: 40, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.2, 2), d = e(x * 1.6, 2), y = e(x * 0.8, 2);
          return g(h, m, "M-" + y + "," + u + "L0,0M-" + y + ",-" + u + "L0,0M" + d + ",0L0,0");
        }, needLine: !0, noDot: !0, noFill: !0 }, "line-ew": { n: 41, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.4, 2);
          return g(h, m, "M" + u + ",0H-" + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, "line-ns": { n: 42, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 1.4, 2);
          return g(h, m, "M0," + u + "V-" + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, "line-ne": { n: 43, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + ",-" + u + "L-" + u + "," + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, "line-nw": { n: 44, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2);
          return g(h, m, "M" + u + "," + u + "L-" + u + ",-" + u);
        }, needLine: !0, noDot: !0, noFill: !0 }, "arrow-up": { n: 45, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x * 2, 2);
          return g(h, m, "M0,0L-" + u + "," + d + "H" + u + "Z");
        }, backoff: 1, noDot: !0 }, "arrow-down": { n: 46, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x * 2, 2);
          return g(h, m, "M0,0L-" + u + ",-" + d + "H" + u + "Z");
        }, noDot: !0 }, "arrow-left": { n: 47, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2, 2), d = e(x, 2);
          return g(h, m, "M0,0L" + u + ",-" + d + "V" + d + "Z");
        }, noDot: !0 }, "arrow-right": { n: 48, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2, 2), d = e(x, 2);
          return g(h, m, "M0,0L-" + u + ",-" + d + "V" + d + "Z");
        }, noDot: !0 }, "arrow-bar-up": { n: 49, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x * 2, 2);
          return g(h, m, "M-" + u + ",0H" + u + "M0,0L-" + u + "," + d + "H" + u + "Z");
        }, backoff: 1, needLine: !0, noDot: !0 }, "arrow-bar-down": { n: 50, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x, 2), d = e(x * 2, 2);
          return g(h, m, "M-" + u + ",0H" + u + "M0,0L-" + u + ",-" + d + "H" + u + "Z");
        }, needLine: !0, noDot: !0 }, "arrow-bar-left": { n: 51, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2, 2), d = e(x, 2);
          return g(h, m, "M0,-" + d + "V" + d + "M0,0L" + u + ",-" + d + "V" + d + "Z");
        }, needLine: !0, noDot: !0 }, "arrow-bar-right": { n: 52, f: function(x, h, m) {
          if (t(h)) return a;
          var u = e(x * 2, 2), d = e(x, 2);
          return g(h, m, "M0,-" + d + "V" + d + "M0,0L-" + u + ",-" + d + "V" + d + "Z");
        }, needLine: !0, noDot: !0 }, arrow: { n: 53, f: function(x, h, m) {
          if (t(h)) return a;
          var u = r / 2.5, d = 2 * x * s(u), y = 2 * x * c(u);
          return g(h, m, "M0,0L" + -d + "," + y + "L" + d + "," + y + "Z");
        }, backoff: 0.9, noDot: !0 }, "arrow-wide": { n: 54, f: function(x, h, m) {
          if (t(h)) return a;
          var u = r / 4, d = 2 * x * s(u), y = 2 * x * c(u);
          return g(h, m, "M0,0L" + -d + "," + y + "A " + 2 * x + "," + 2 * x + " 0 0 1 " + d + "," + y + "Z");
        }, backoff: 0.4, noDot: !0 } };
        function t(x) {
          return x === null;
        }
        var p, l, f, v;
        function g(x, h, m) {
          if ((!x || x % 360 === 0) && !h) return m;
          if (f === x && v === h && p === m) return l;
          f = x, v = h, p = m;
          function u(G, K) {
            var te = s(G), V = c(G), Z = K[0], Y = K[1] + (h || 0);
            return [Z * te - Y * V, Z * V + Y * te];
          }
          for (var d = x / 180 * r, y = 0, _ = 0, T = n(m), R = "", I = 0; I < T.length; I++) {
            var P = T[I], M = P[0], B = y, z = _;
            if (M === "M" || M === "L") y = +P[1], _ = +P[2];
            else if (M === "m" || M === "l") y += +P[1], _ += +P[2];
            else if (M === "H") y = +P[1];
            else if (M === "h") y += +P[1];
            else if (M === "V") _ = +P[1];
            else if (M === "v") _ += +P[1];
            else if (M === "A") {
              y = +P[1], _ = +P[2];
              var q = u(d, [+P[6], +P[7]]);
              P[6] = q[0], P[7] = q[1], P[3] = +P[3] + x;
            }
            (M === "H" || M === "V") && (M = "L"), (M === "h" || M === "v") && (M = "l"), (M === "m" || M === "l") && (y -= B, _ -= z);
            var U = u(d, [y, _]);
            (M === "H" || M === "V") && (M = "L"), (M === "M" || M === "L" || M === "m" || M === "l") && (P[1] = U[0], P[2] = U[1]), P[0] = M, R += P[0] + P.slice(1).join(",");
          }
          return l = R, R;
        }
      }), Or = xe((L, k) => {
        var n = vr(), e = wt(), a = e.numberFormat, i = xr(), o = Nn(), r = or(), s = fr(), c = fa(), t = e.strTranslate, p = xn(), l = va(), f = kn(), v = f.LINE_SPACING, g = so().DESELECTDIM, x = Fn(), h = _d(), m = da().appendArrayPointValue, u = k.exports = {};
        u.font = function(A, X) {
          var H = X.variant, ve = X.style, be = X.weight, Se = X.color, De = X.size, He = X.family, Ze = X.shadow, We = X.lineposition, $e = X.textcase;
          He && A.style("font-family", He), De + 1 && A.style("font-size", De + "px"), Se && A.call(s.fill, Se), be && A.style("font-weight", be), ve && A.style("font-style", ve), H && A.style("font-variant", H), $e && A.style("text-transform", d(_($e))), Ze && A.style("text-shadow", Ze === "auto" ? p.makeTextShadow(s.contrast(Se)) : d(Ze)), We && A.style("text-decoration-line", d(T(We)));
        };
        function d(A) {
          return A === "none" ? void 0 : A;
        }
        var y = { normal: "none", lower: "lowercase", upper: "uppercase", "word caps": "capitalize" };
        function _(A) {
          return y[A];
        }
        function T(A) {
          return A.replace("under", "underline").replace("over", "overline").replace("through", "line-through").split("+").join(" ");
        }
        u.setPosition = function(A, X, H) {
          A.attr("x", X).attr("y", H);
        }, u.setSize = function(A, X, H) {
          A.attr("width", X).attr("height", H);
        }, u.setRect = function(A, X, H, ve, be) {
          A.call(u.setPosition, X, H).call(u.setSize, ve, be);
        }, u.translatePoint = function(A, X, H, ve) {
          var be = H.c2p(A.x), Se = ve.c2p(A.y);
          if (i(be) && i(Se) && X.node()) X.node().nodeName === "text" ? X.attr("x", be).attr("y", Se) : X.attr("transform", t(be, Se));
          else return !1;
          return !0;
        }, u.translatePoints = function(A, X, H) {
          A.each(function(ve) {
            var be = n.select(this);
            u.translatePoint(ve, be, X, H);
          });
        }, u.hideOutsideRangePoint = function(A, X, H, ve, be, Se) {
          X.attr("display", H.isPtWithinRange(A, be) && ve.isPtWithinRange(A, Se) ? null : "none");
        }, u.hideOutsideRangePoints = function(A, X) {
          if (X._hasClipOnAxisFalse) {
            var H = X.xaxis, ve = X.yaxis;
            A.each(function(be) {
              var Se = be[0].trace, De = Se.xcalendar, He = Se.ycalendar, Ze = r.traceIs(Se, "bar-like") ? ".bartext" : ".point,.textpoint";
              A.selectAll(Ze).each(function(We) {
                u.hideOutsideRangePoint(We, n.select(this), H, ve, De, He);
              });
            });
          }
        }, u.crispRound = function(A, X, H) {
          return !X || !i(X) ? H || 0 : A._context.staticPlot ? X : X < 1 ? 1 : Math.round(X);
        }, u.singleLineStyle = function(A, X, H, ve, be) {
          X.style("fill", "none");
          var Se = (((A || [])[0] || {}).trace || {}).line || {}, De = H || Se.width || 0, He = be || Se.dash || "";
          s.stroke(X, ve || Se.color), u.dashLine(X, He, De);
        }, u.lineGroupStyle = function(A, X, H, ve) {
          A.style("fill", "none").each(function(be) {
            var Se = (((be || [])[0] || {}).trace || {}).line || {}, De = X || Se.width || 0, He = ve || Se.dash || "";
            n.select(this).call(s.stroke, H || Se.color).call(u.dashLine, He, De);
          });
        }, u.dashLine = function(A, X, H) {
          H = +H || 0, X = u.dashStyle(X, H), A.style({ "stroke-dasharray": X, "stroke-width": H + "px" });
        }, u.dashStyle = function(A, X) {
          X = +X || 1;
          var H = Math.max(X, 3);
          return A === "solid" ? A = "" : A === "dot" ? A = H + "px," + H + "px" : A === "dash" ? A = 3 * H + "px," + 3 * H + "px" : A === "longdash" ? A = 5 * H + "px," + 5 * H + "px" : A === "dashdot" ? A = 3 * H + "px," + H + "px," + H + "px," + H + "px" : A === "longdashdot" && (A = 5 * H + "px," + 2 * H + "px," + H + "px," + 2 * H + "px"), A;
        };
        function R(A, X, H, ve) {
          var be = X.fillpattern, Se = X.fillgradient, De = u.getPatternAttr, He = be && (De(be.shape, 0, "") || De(be.path, 0, ""));
          if (He) {
            var Ze = De(be.bgcolor, 0, null), We = De(be.fgcolor, 0, null), $e = be.fgopacity, it = De(be.size, 0, 8), Ke = De(be.solidity, 0, 0.3), ct = X.uid;
            u.pattern(A, "point", H, ct, He, it, Ke, void 0, be.fillmode, Ze, We, $e);
          } else if (Se && Se.type !== "none") {
            var gt = Se.type, ht = "scatterfill-" + X.uid;
            if (ve && (ht = "legendfill-" + X.uid), !ve && (Se.start !== void 0 || Se.stop !== void 0)) {
              var _t, Te;
              gt === "horizontal" ? (_t = { x: Se.start, y: 0 }, Te = { x: Se.stop, y: 0 }) : gt === "vertical" && (_t = { x: 0, y: Se.start }, Te = { x: 0, y: Se.stop }), _t.x = X._xA.c2p(_t.x === void 0 ? X._extremes.x.min[0].val : _t.x, !0), _t.y = X._yA.c2p(_t.y === void 0 ? X._extremes.y.min[0].val : _t.y, !0), Te.x = X._xA.c2p(Te.x === void 0 ? X._extremes.x.max[0].val : Te.x, !0), Te.y = X._yA.c2p(Te.y === void 0 ? X._extremes.y.max[0].val : Te.y, !0), A.call(U, H, ht, "linear", Se.colorscale, "fill", _t, Te, !0, !1);
            } else gt === "horizontal" && (gt = gt + "reversed"), A.call(u.gradient, H, ht, gt, Se.colorscale, "fill");
          } else X.fillcolor && A.call(s.fill, X.fillcolor);
        }
        u.singleFillStyle = function(A, X) {
          var H = n.select(A.node()), ve = H.data(), be = ((ve[0] || [])[0] || {}).trace || {};
          R(A, be, X, !1);
        }, u.fillGroupStyle = function(A, X, H) {
          A.style("stroke-width", 0).each(function(ve) {
            var be = n.select(this);
            ve[0].trace && R(be, ve[0].trace, X, H);
          });
        };
        var I = wd();
        u.symbolNames = [], u.symbolFuncs = [], u.symbolBackOffs = [], u.symbolNeedLines = {}, u.symbolNoDot = {}, u.symbolNoFill = {}, u.symbolList = [], Object.keys(I).forEach(function(A) {
          var X = I[A], H = X.n;
          u.symbolList.push(H, String(H), A, H + 100, String(H + 100), A + "-open"), u.symbolNames[H] = A, u.symbolFuncs[H] = X.f, u.symbolBackOffs[H] = X.backoff || 0, X.needLine && (u.symbolNeedLines[H] = !0), X.noDot ? u.symbolNoDot[H] = !0 : u.symbolList.push(H + 200, String(H + 200), A + "-dot", H + 300, String(H + 300), A + "-open-dot"), X.noFill && (u.symbolNoFill[H] = !0);
        });
        var P = u.symbolNames.length, M = "M0,0.5L0.5,0L0,-0.5L-0.5,0Z";
        u.symbolNumber = function(A) {
          if (i(A)) A = +A;
          else if (typeof A == "string") {
            var X = 0;
            A.indexOf("-open") > 0 && (X = 100, A = A.replace("-open", "")), A.indexOf("-dot") > 0 && (X += 200, A = A.replace("-dot", "")), A = u.symbolNames.indexOf(A), A >= 0 && (A += X);
          }
          return A % 100 >= P || A >= 400 ? 0 : Math.floor(Math.max(A, 0));
        };
        function B(A, X, H, ve) {
          var be = A % 100;
          return u.symbolFuncs[be](X, H, ve) + (A >= 200 ? M : "");
        }
        var z = a("~f"), q = { radial: { type: "radial" }, radialreversed: { type: "radial", reversed: !0 }, horizontal: { type: "linear", start: { x: 1, y: 0 }, stop: { x: 0, y: 0 } }, horizontalreversed: { type: "linear", start: { x: 1, y: 0 }, stop: { x: 0, y: 0 }, reversed: !0 }, vertical: { type: "linear", start: { x: 0, y: 1 }, stop: { x: 0, y: 0 } }, verticalreversed: { type: "linear", start: { x: 0, y: 1 }, stop: { x: 0, y: 0 }, reversed: !0 } };
        u.gradient = function(A, X, H, ve, be, Se) {
          var De = q[ve];
          return U(A, X, H, De.type, be, Se, De.start, De.stop, !1, De.reversed);
        };
        function U(A, X, H, ve, be, Se, De, He, Ze, We) {
          var $e = be.length, it;
          ve === "linear" ? it = { node: "linearGradient", attrs: { x1: De.x, y1: De.y, x2: He.x, y2: He.y, gradientUnits: Ze ? "userSpaceOnUse" : "objectBoundingBox" }, reversed: We } : ve === "radial" && (it = { node: "radialGradient", reversed: We });
          for (var Ke = new Array($e), ct = 0; ct < $e; ct++) it.reversed ? Ke[$e - 1 - ct] = [z((1 - be[ct][0]) * 100), be[ct][1]] : Ke[ct] = [z(be[ct][0] * 100), be[ct][1]];
          var gt = X._fullLayout, ht = "g" + gt._uid + "-" + H, _t = gt._defs.select(".gradients").selectAll("#" + ht).data([ve + Ke.join(";")], e.identity);
          _t.exit().remove(), _t.enter().append(it.node).each(function() {
            var Te = n.select(this);
            it.attrs && Te.attr(it.attrs), Te.attr("id", ht);
            var Ie = Te.selectAll("stop").data(Ke);
            Ie.exit().remove(), Ie.enter().append("stop"), Ie.each(function(ce) {
              var ge = o(ce[1]);
              n.select(this).attr({ offset: ce[0] + "%", "stop-color": s.tinyRGB(ge), "stop-opacity": ge.getAlpha() });
            });
          }), A.style(Se, re(ht, X)).style(Se + "-opacity", null), A.classed("gradient_filled", !0);
        }
        u.pattern = function(A, X, H, ve, be, Se, De, He, Ze, We, $e, it) {
          var Ke = X === "legend";
          He && (Ze === "overlay" ? (We = He, $e = s.contrast(We)) : (We = void 0, $e = He));
          var ct = H._fullLayout, gt = "p" + ct._uid + "-" + ve, ht, _t, Te = function(ot, lt, st, xt, Et) {
            return xt + (Et - xt) * (ot - lt) / (st - lt);
          }, Ie, ce, ge, ye, Me = {}, Oe = o($e), je = s.tinyRGB(Oe), qe = Oe.getAlpha(), Qe = it * qe;
          switch (be) {
            case "/":
              ht = Se * Math.sqrt(2), _t = Se * Math.sqrt(2), Ie = "M-" + ht / 4 + "," + _t / 4 + "l" + ht / 2 + ",-" + _t / 2 + "M0," + _t + "L" + ht + ",0M" + ht / 4 * 3 + "," + _t / 4 * 5 + "l" + ht / 2 + ",-" + _t / 2, ce = De * Se, ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case "\\":
              ht = Se * Math.sqrt(2), _t = Se * Math.sqrt(2), Ie = "M" + ht / 4 * 3 + ",-" + _t / 4 + "l" + ht / 2 + "," + _t / 2 + "M0,0L" + ht + "," + _t + "M-" + ht / 4 + "," + _t / 4 * 3 + "l" + ht / 2 + "," + _t / 2, ce = De * Se, ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case "x":
              ht = Se * Math.sqrt(2), _t = Se * Math.sqrt(2), Ie = "M-" + ht / 4 + "," + _t / 4 + "l" + ht / 2 + ",-" + _t / 2 + "M0," + _t + "L" + ht + ",0M" + ht / 4 * 3 + "," + _t / 4 * 5 + "l" + ht / 2 + ",-" + _t / 2 + "M" + ht / 4 * 3 + ",-" + _t / 4 + "l" + ht / 2 + "," + _t / 2 + "M0,0L" + ht + "," + _t + "M-" + ht / 4 + "," + _t / 4 * 3 + "l" + ht / 2 + "," + _t / 2, ce = Se - Se * Math.sqrt(1 - De), ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case "|":
              ht = Se, _t = Se, ye = "path", Ie = "M" + ht / 2 + ",0L" + ht / 2 + "," + _t, ce = De * Se, ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case "-":
              ht = Se, _t = Se, ye = "path", Ie = "M0," + _t / 2 + "L" + ht + "," + _t / 2, ce = De * Se, ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case "+":
              ht = Se, _t = Se, ye = "path", Ie = "M" + ht / 2 + ",0L" + ht / 2 + "," + _t + "M0," + _t / 2 + "L" + ht + "," + _t / 2, ce = Se - Se * Math.sqrt(1 - De), ye = "path", Me = { d: Ie, opacity: Qe, stroke: je, "stroke-width": ce + "px" };
              break;
            case ".":
              ht = Se, _t = Se, De < Math.PI / 4 ? ge = Math.sqrt(De * Se * Se / Math.PI) : ge = Te(De, Math.PI / 4, 1, Se / 2, Se / Math.sqrt(2)), ye = "circle", Me = { cx: ht / 2, cy: _t / 2, r: ge, opacity: Qe, fill: je };
              break;
            default:
              ht = Se, _t = Se, ye = "path", Me = { d: be, opacity: Qe, fill: je };
              break;
          }
          var Xe = [be || "noSh", We || "noBg", $e || "noFg", Se, De].join(";"), Je = ct._defs.select(".patterns").selectAll("#" + gt).data([Xe], e.identity);
          Je.exit().remove(), Je.enter().append("pattern").each(function() {
            var ot = n.select(this);
            if (ot.attr({ id: gt, width: ht + "px", height: _t + "px", patternUnits: "userSpaceOnUse", patternTransform: Ke ? "scale(0.8)" : "" }), We) {
              var lt = o(We), st = s.tinyRGB(lt), xt = lt.getAlpha(), Et = ot.selectAll("rect").data([0]);
              Et.exit().remove(), Et.enter().append("rect").attr({ width: ht + "px", height: _t + "px", fill: st, "fill-opacity": xt });
            }
            var Bt = ot.selectAll(ye).data([0]);
            Bt.exit().remove(), Bt.enter().append(ye).attr(Me);
          }), A.style("fill", re(gt, H)).style("fill-opacity", null), A.classed("pattern_filled", !0);
        }, u.initGradients = function(A) {
          var X = A._fullLayout, H = e.ensureSingle(X._defs, "g", "gradients");
          H.selectAll("linearGradient,radialGradient").remove(), n.select(A).selectAll(".gradient_filled").classed("gradient_filled", !1);
        }, u.initPatterns = function(A) {
          var X = A._fullLayout, H = e.ensureSingle(X._defs, "g", "patterns");
          H.selectAll("pattern").remove(), n.select(A).selectAll(".pattern_filled").classed("pattern_filled", !1);
        }, u.getPatternAttr = function(A, X, H) {
          return A && e.isArrayOrTypedArray(A) ? X < A.length ? A[X] : H : A;
        }, u.pointStyle = function(A, X, H, ve) {
          if (A.size()) {
            var be = u.makePointStyleFns(X);
            A.each(function(Se) {
              u.singlePointStyle(Se, n.select(this), X, be, H, ve);
            });
          }
        }, u.singlePointStyle = function(A, X, H, ve, be, Se) {
          var De = H.marker, He = De.line;
          if (Se && Se.i >= 0 && A.i === void 0 && (A.i = Se.i), X.style("opacity", ve.selectedOpacityFn ? ve.selectedOpacityFn(A) : A.mo === void 0 ? De.opacity : A.mo), ve.ms2mrc) {
            var Ze;
            A.ms === "various" || De.size === "various" ? Ze = 3 : Ze = ve.ms2mrc(A.ms), A.mrc = Ze, ve.selectedSizeFn && (Ze = A.mrc = ve.selectedSizeFn(A));
            var We = u.symbolNumber(A.mx || De.symbol) || 0;
            A.om = We % 200 >= 100;
            var $e = ke(A, H), it = N(A, H);
            X.attr("d", B(We, Ze, $e, it));
          }
          var Ke = !1, ct, gt, ht;
          if (A.so) ht = He.outlierwidth, gt = He.outliercolor, ct = De.outliercolor;
          else {
            var _t = (He || {}).width;
            ht = (A.mlw + 1 || _t + 1 || (A.trace ? (A.trace.marker.line || {}).width : 0) + 1) - 1 || 0, "mlc" in A ? gt = A.mlcc = ve.lineScale(A.mlc) : e.isArrayOrTypedArray(He.color) ? gt = s.defaultLine : gt = He.color, e.isArrayOrTypedArray(De.color) && (ct = s.defaultLine, Ke = !0), "mc" in A ? ct = A.mcc = ve.markerScale(A.mc) : ct = De.color || De.colors || "rgba(0,0,0,0)", ve.selectedColorFn && (ct = ve.selectedColorFn(A));
          }
          if (A.om) X.call(s.stroke, ct).style({ "stroke-width": (ht || 1) + "px", fill: "none" });
          else {
            X.style("stroke-width", (A.isBlank ? 0 : ht) + "px");
            var Te = De.gradient, Ie = A.mgt;
            Ie ? Ke = !0 : Ie = Te && Te.type, e.isArrayOrTypedArray(Ie) && (Ie = Ie[0], q[Ie] || (Ie = 0));
            var ce = De.pattern, ge = u.getPatternAttr, ye = ce && (ge(ce.shape, A.i, "") || ge(ce.path, A.i, ""));
            if (Ie && Ie !== "none") {
              var Me = A.mgc;
              Me ? Ke = !0 : Me = Te.color;
              var Oe = H.uid;
              Ke && (Oe += "-" + A.i), u.gradient(X, be, Oe, Ie, [[0, Me], [1, ct]], "fill");
            } else if (ye) {
              var je = !1, qe = ce.fgcolor;
              !qe && Se && Se.color && (qe = Se.color, je = !0);
              var Qe = ge(qe, A.i, Se && Se.color || null), Xe = ge(ce.bgcolor, A.i, null), Je = ce.fgopacity, ot = ge(ce.size, A.i, 8), lt = ge(ce.solidity, A.i, 0.3);
              je = je || A.mcc || e.isArrayOrTypedArray(ce.shape) || e.isArrayOrTypedArray(ce.path) || e.isArrayOrTypedArray(ce.bgcolor) || e.isArrayOrTypedArray(ce.fgcolor) || e.isArrayOrTypedArray(ce.size) || e.isArrayOrTypedArray(ce.solidity);
              var st = H.uid;
              je && (st += "-" + A.i), u.pattern(X, "point", be, st, ye, ot, lt, A.mcc, ce.fillmode, Xe, Qe, Je);
            } else e.isArrayOrTypedArray(ct) ? s.fill(X, ct[A.i]) : s.fill(X, ct);
            ht && s.stroke(X, gt);
          }
        }, u.makePointStyleFns = function(A) {
          var X = {}, H = A.marker;
          return X.markerScale = u.tryColorscale(H, ""), X.lineScale = u.tryColorscale(H, "line"), r.traceIs(A, "symbols") && (X.ms2mrc = x.isBubble(A) ? h(A) : function() {
            return (H.size || 6) / 2;
          }), A.selectedpoints && e.extendFlat(X, u.makeSelectedPointStyleFns(A)), X;
        }, u.makeSelectedPointStyleFns = function(A) {
          var X = {}, H = A.selected || {}, ve = A.unselected || {}, be = A.marker || {}, Se = H.marker || {}, De = ve.marker || {}, He = be.opacity, Ze = Se.opacity, We = De.opacity, $e = Ze !== void 0, it = We !== void 0;
          (e.isArrayOrTypedArray(He) || $e || it) && (X.selectedOpacityFn = function(ge) {
            var ye = ge.mo === void 0 ? be.opacity : ge.mo;
            return ge.selected ? $e ? Ze : ye : it ? We : g * ye;
          });
          var Ke = be.color, ct = Se.color, gt = De.color;
          (ct || gt) && (X.selectedColorFn = function(ge) {
            var ye = ge.mcc || Ke;
            return ge.selected ? ct || ye : gt || ye;
          });
          var ht = be.size, _t = Se.size, Te = De.size, Ie = _t !== void 0, ce = Te !== void 0;
          return r.traceIs(A, "symbols") && (Ie || ce) && (X.selectedSizeFn = function(ge) {
            var ye = ge.mrc || ht / 2;
            return ge.selected ? Ie ? _t / 2 : ye : ce ? Te / 2 : ye;
          }), X;
        }, u.makeSelectedTextStyleFns = function(A) {
          var X = {}, H = A.selected || {}, ve = A.unselected || {}, be = A.textfont || {}, Se = H.textfont || {}, De = ve.textfont || {}, He = be.color, Ze = Se.color, We = De.color;
          return X.selectedTextColorFn = function($e) {
            var it = $e.tc || He;
            return $e.selected ? Ze || it : We || (Ze ? it : s.addOpacity(it, g));
          }, X;
        }, u.selectedPointStyle = function(A, X) {
          if (!(!A.size() || !X.selectedpoints)) {
            var H = u.makeSelectedPointStyleFns(X), ve = X.marker || {}, be = [];
            H.selectedOpacityFn && be.push(function(Se, De) {
              Se.style("opacity", H.selectedOpacityFn(De));
            }), H.selectedColorFn && be.push(function(Se, De) {
              s.fill(Se, H.selectedColorFn(De));
            }), H.selectedSizeFn && be.push(function(Se, De) {
              var He = De.mx || ve.symbol || 0, Ze = H.selectedSizeFn(De);
              Se.attr("d", B(u.symbolNumber(He), Ze, ke(De, X), N(De, X))), De.mrc2 = Ze;
            }), be.length && A.each(function(Se) {
              for (var De = n.select(this), He = 0; He < be.length; He++) be[He](De, Se);
            });
          }
        }, u.tryColorscale = function(A, X) {
          var H = X ? e.nestedProperty(A, X).get() : A;
          if (H) {
            var ve = H.color;
            if ((H.colorscale || H._colorAx) && e.isArrayOrTypedArray(ve)) return c.makeColorScaleFuncFromTrace(H);
          }
          return e.identity;
        };
        var G = { start: 1, end: -1, middle: 0, bottom: 1, top: -1 };
        function K(A, X, H, ve, be) {
          var Se = n.select(A.node().parentNode), De = X.indexOf("top") !== -1 ? "top" : X.indexOf("bottom") !== -1 ? "bottom" : "middle", He = X.indexOf("left") !== -1 ? "end" : X.indexOf("right") !== -1 ? "start" : "middle", Ze = ve ? ve / 0.8 + 1 : 0, We = (p.lineCount(A) - 1) * v + 1, $e = G[He] * Ze, it = H * 0.75 + G[De] * Ze + (G[De] - 1) * We * H / 2;
          A.attr("text-anchor", He), be || Se.attr("transform", t($e, it));
        }
        function te(A, X) {
          var H = A.ts || X.textfont.size;
          return i(H) && H > 0 ? H : 0;
        }
        u.textPointStyle = function(A, X, H) {
          if (A.size()) {
            var ve;
            if (X.selectedpoints) {
              var be = u.makeSelectedTextStyleFns(X);
              ve = be.selectedTextColorFn;
            }
            var Se = X.texttemplate, De = H._fullLayout;
            A.each(function(He) {
              var Ze = n.select(this), We = Se ? e.extractOption(He, X, "txt", "texttemplate") : e.extractOption(He, X, "tx", "text");
              if (!We && We !== 0) {
                Ze.remove();
                return;
              }
              if (Se) {
                var $e = X._module.formatLabels, it = $e ? $e(He, X, De) : {}, Ke = {};
                m(Ke, X, He.i), We = e.texttemplateString({ data: [Ke, He, X._meta], fallback: X.texttemplatefallback, labels: it, locale: De._d3locale, template: We });
              }
              var ct = He.tp || X.textposition, gt = te(He, X), ht = ve ? ve(He) : He.tc || X.textfont.color;
              Ze.call(u.font, { family: He.tf || X.textfont.family, weight: He.tw || X.textfont.weight, style: He.ty || X.textfont.style, variant: He.tv || X.textfont.variant, textcase: He.tC || X.textfont.textcase, lineposition: He.tE || X.textfont.lineposition, shadow: He.tS || X.textfont.shadow, size: gt, color: ht }).text(We).call(p.convertToTspans, H).call(K, ct, gt, He.mrc);
            });
          }
        }, u.selectedTextStyle = function(A, X) {
          if (!(!A.size() || !X.selectedpoints)) {
            var H = u.makeSelectedTextStyleFns(X);
            A.each(function(ve) {
              var be = n.select(this), Se = H.selectedTextColorFn(ve), De = ve.tp || X.textposition, He = te(ve, X);
              s.fill(be, Se);
              var Ze = r.traceIs(X, "bar-like");
              K(be, De, He, ve.mrc2 || ve.mrc, Ze);
            });
          }
        };
        var V = 0.5;
        u.smoothopen = function(A, X) {
          if (A.length < 3) return "M" + A.join("L");
          var H = "M" + A[0], ve = [], be;
          for (be = 1; be < A.length - 1; be++) ve.push(ne(A[be - 1], A[be], A[be + 1], X));
          for (H += "Q" + ve[0][0] + " " + A[1], be = 2; be < A.length - 1; be++) H += "C" + ve[be - 2][1] + " " + ve[be - 1][0] + " " + A[be];
          return H += "Q" + ve[A.length - 3][1] + " " + A[A.length - 1], H;
        }, u.smoothclosed = function(A, X) {
          if (A.length < 3) return "M" + A.join("L") + "Z";
          var H = "M" + A[0], ve = A.length - 1, be = [ne(A[ve], A[0], A[1], X)], Se;
          for (Se = 1; Se < ve; Se++) be.push(ne(A[Se - 1], A[Se], A[Se + 1], X));
          for (be.push(ne(A[ve - 1], A[ve], A[0], X)), Se = 1; Se <= ve; Se++) H += "C" + be[Se - 1][1] + " " + be[Se][0] + " " + A[Se];
          return H += "C" + be[ve][1] + " " + be[0][0] + " " + A[0] + "Z", H;
        };
        var Z, Y;
        function C(A, X, H) {
          return H && (A = O(A)), X ? J(A[1]) : j(A[0]);
        }
        function j(A) {
          var X = n.round(A, 2);
          return Z = X, X;
        }
        function J(A) {
          var X = n.round(A, 2);
          return Y = X, X;
        }
        function ne(A, X, H, ve) {
          var be = A[0] - X[0], Se = A[1] - X[1], De = H[0] - X[0], He = H[1] - X[1], Ze = Math.pow(be * be + Se * Se, V / 2), We = Math.pow(De * De + He * He, V / 2), $e = (We * We * be - Ze * Ze * De) * ve, it = (We * We * Se - Ze * Ze * He) * ve, Ke = 3 * We * (Ze + We), ct = 3 * Ze * (Ze + We);
          return [[j(X[0] + (Ke && $e / Ke)), J(X[1] + (Ke && it / Ke))], [j(X[0] - (ct && $e / ct)), J(X[1] - (ct && it / ct))]];
        }
        var ae = { hv: function(A, X, H) {
          return "H" + j(X[0]) + "V" + C(X, 1, H);
        }, vh: function(A, X, H) {
          return "V" + J(X[1]) + "H" + C(X, 0, H);
        }, hvh: function(A, X, H) {
          return "H" + j((A[0] + X[0]) / 2) + "V" + J(X[1]) + "H" + C(X, 0, H);
        }, vhv: function(A, X, H) {
          return "V" + J((A[1] + X[1]) / 2) + "H" + j(X[0]) + "V" + C(X, 1, H);
        } }, se = function(A, X, H) {
          return "L" + C(X, 0, H) + "," + C(X, 1, H);
        };
        u.steps = function(A) {
          var X = ae[A] || se;
          return function(H) {
            for (var ve = "M" + j(H[0][0]) + "," + J(H[0][1]), be = H.length, Se = 1; Se < be; Se++) ve += X(H[Se - 1], H[Se], Se === be - 1);
            return ve;
          };
        };
        function O(A, X) {
          var H = A.backoff, ve = A.trace, be = A.d, Se = A.i;
          if (H && ve && ve.marker && ve.marker.angle % 360 === 0 && ve.line && ve.line.shape !== "spline") {
            var De = e.isArrayOrTypedArray(H), He = A, Ze = X ? X[0] : Z || 0, We = X ? X[1] : Y || 0, $e = He[0], it = He[1], Ke = $e - Ze, ct = it - We, gt = Math.atan2(ct, Ke), ht = De ? H[Se] : H;
            if (ht === "auto") {
              var _t = He.i;
              ve.type === "scatter" && _t--;
              var Te = He.marker, Ie = Te.symbol;
              e.isArrayOrTypedArray(Ie) && (Ie = Ie[_t]);
              var ce = Te.size;
              e.isArrayOrTypedArray(ce) && (ce = ce[_t]), ht = Te ? u.symbolBackOffs[u.symbolNumber(Ie)] * ce : 0, ht += u.getMarkerStandoff(be[_t], ve) || 0;
            }
            var ge = $e - ht * Math.cos(gt), ye = it - ht * Math.sin(gt);
            (ge <= $e && ge >= Ze || ge >= $e && ge <= Ze) && (ye <= it && ye >= We || ye >= it && ye <= We) && (A = [ge, ye]);
          }
          return A;
        }
        u.applyBackoff = O, u.makeTester = function() {
          var A = e.ensureSingleById(n.select("body"), "svg", "js-plotly-tester", function(H) {
            H.attr(l.svgAttrs).style({ position: "absolute", left: "-10000px", top: "-10000px", width: "9000px", height: "9000px", "z-index": "1" });
          }), X = e.ensureSingle(A, "path", "js-reference-point", function(H) {
            H.attr("d", "M0,0H1V1H0Z").style({ "stroke-width": 0, fill: "black" });
          });
          u.tester = A, u.testref = X;
        }, u.savedBBoxes = {};
        var F = 0, S = 1e4;
        u.bBox = function(A, X, H) {
          H || (H = $(A));
          var ve;
          if (H) {
            if (ve = u.savedBBoxes[H], ve) return e.extendFlat({}, ve);
          } else if (A.childNodes.length === 1) {
            var be = A.childNodes[0];
            if (H = $(be), H) {
              var Se = +be.getAttribute("x") || 0, De = +be.getAttribute("y") || 0, He = be.getAttribute("transform");
              if (!He) {
                var Ze = u.bBox(be, !1, H);
                return Se && (Ze.left += Se, Ze.right += Se), De && (Ze.top += De, Ze.bottom += De), Ze;
              }
              if (H += "~" + Se + "~" + De + "~" + He, ve = u.savedBBoxes[H], ve) return e.extendFlat({}, ve);
            }
          }
          var We, $e;
          X ? We = A : ($e = u.tester.node(), We = A.cloneNode(!0), $e.appendChild(We)), n.select(We).attr("transform", null).call(p.positionText, 0, 0);
          var it = We.getBoundingClientRect(), Ke = u.testref.node().getBoundingClientRect();
          X || $e.removeChild(We);
          var ct = { height: it.height, width: it.width, left: it.left - Ke.left, top: it.top - Ke.top, right: it.right - Ke.left, bottom: it.bottom - Ke.top };
          return F >= S && (u.savedBBoxes = {}, F = 0), H && (u.savedBBoxes[H] = ct), F++, e.extendFlat({}, ct);
        };
        function $(A) {
          var X = A.getAttribute("data-unformatted");
          if (X !== null) return X + A.getAttribute("data-math") + A.getAttribute("text-anchor") + A.getAttribute("style");
        }
        u.setClipUrl = function(A, X, H) {
          A.attr("clip-path", re(X, H));
        };
        function re(A, X) {
          if (!A) return null;
          var H = X._context, ve = H._exportedPlot ? "" : H._baseUrl || "";
          return ve ? "url('" + ve + "#" + A + "')" : "url(#" + A + ")";
        }
        u.getTranslate = function(A) {
          var X = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, H = A.attr ? "attr" : "getAttribute", ve = A[H]("transform") || "", be = ve.replace(X, function(Se, De, He) {
            return [De, He].join(" ");
          }).split(" ");
          return { x: +be[0] || 0, y: +be[1] || 0 };
        }, u.setTranslate = function(A, X, H) {
          var ve = /(\btranslate\(.*?\);?)/, be = A.attr ? "attr" : "getAttribute", Se = A.attr ? "attr" : "setAttribute", De = A[be]("transform") || "";
          return X = X || 0, H = H || 0, De = De.replace(ve, "").trim(), De += t(X, H), De = De.trim(), A[Se]("transform", De), De;
        }, u.getScale = function(A) {
          var X = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, H = A.attr ? "attr" : "getAttribute", ve = A[H]("transform") || "", be = ve.replace(X, function(Se, De, He) {
            return [De, He].join(" ");
          }).split(" ");
          return { x: +be[0] || 1, y: +be[1] || 1 };
        }, u.setScale = function(A, X, H) {
          var ve = /(\bscale\(.*?\);?)/, be = A.attr ? "attr" : "getAttribute", Se = A.attr ? "attr" : "setAttribute", De = A[be]("transform") || "";
          return X = X || 1, H = H || 1, De = De.replace(ve, "").trim(), De += "scale(" + X + "," + H + ")", De = De.trim(), A[Se]("transform", De), De;
        };
        var E = /\s*sc.*/;
        u.setPointGroupScale = function(A, X, H) {
          if (X = X || 1, H = H || 1, !!A) {
            var ve = X === 1 && H === 1 ? "" : "scale(" + X + "," + H + ")";
            A.each(function() {
              var be = (this.getAttribute("transform") || "").replace(E, "");
              be += ve, be = be.trim(), this.setAttribute("transform", be);
            });
          }
        };
        var w = /translate\([^)]*\)\s*$/;
        u.setTextPointsScale = function(A, X, H) {
          A && A.each(function() {
            var ve, be = n.select(this), Se = be.select("text");
            if (Se.node()) {
              var De = parseFloat(Se.attr("x") || 0), He = parseFloat(Se.attr("y") || 0), Ze = (be.attr("transform") || "").match(w);
              X === 1 && H === 1 ? ve = [] : ve = [t(De, He), "scale(" + X + "," + H + ")", t(-De, -He)], Ze && ve.push(Ze), be.attr("transform", ve.join(""));
            }
          });
        };
        function N(A, X) {
          var H;
          return A && (H = A.mf), H === void 0 && (H = X.marker && X.marker.standoff || 0), !X._geo && !X._xA ? -H : H;
        }
        u.getMarkerStandoff = N;
        var W = Math.atan2, ee = Math.cos, le = Math.sin;
        function ie(A, X) {
          var H = X[0], ve = X[1];
          return [H * ee(A) - ve * le(A), H * le(A) + ve * ee(A)];
        }
        var pe, _e, Ae, Ce, Ue, Ne;
        function ke(A, X) {
          var H = A.ma;
          H === void 0 && (H = X.marker.angle, (!H || e.isArrayOrTypedArray(H)) && (H = 0));
          var ve, be, Se = X.marker.angleref;
          if (Se === "previous" || Se === "north") {
            if (X._geo) {
              var De = X._geo.project(A.lonlat);
              ve = De[0], be = De[1];
            } else {
              var He = X._xA, Ze = X._yA;
              if (He && Ze) ve = He.c2p(A.x), be = Ze.c2p(A.y);
              else return 90;
            }
            if (X._geo) {
              var We = A.lonlat[0], $e = A.lonlat[1], it = X._geo.project([We, $e + 1e-5]), Ke = X._geo.project([We + 1e-5, $e]), ct = W(Ke[1] - be, Ke[0] - ve), gt = W(it[1] - be, it[0] - ve), ht;
              if (Se === "north") ht = H / 180 * Math.PI;
              else if (Se === "previous") {
                var _t = We / 180 * Math.PI, Te = $e / 180 * Math.PI, Ie = pe / 180 * Math.PI, ce = _e / 180 * Math.PI, ge = Ie - _t, ye = ee(ce) * le(ge), Me = le(ce) * ee(Te) - ee(ce) * le(Te) * ee(ge);
                ht = -W(ye, Me) - Math.PI, pe = We, _e = $e;
              }
              var Oe = ie(ct, [ee(ht), 0]), je = ie(gt, [le(ht), 0]);
              H = W(Oe[1] + je[1], Oe[0] + je[0]) / Math.PI * 180, Se === "previous" && !(Ne === X.uid && A.i === Ue + 1) && (H = null);
            }
            if (Se === "previous" && !X._geo) if (Ne === X.uid && A.i === Ue + 1 && i(ve) && i(be)) {
              var qe = ve - Ae, Qe = be - Ce, Xe = X.line && X.line.shape || "", Je = Xe.slice(Xe.length - 1);
              Je === "h" && (Qe = 0), Je === "v" && (qe = 0), H += W(Qe, qe) / Math.PI * 180 + 90;
            } else H = null;
          }
          return Ae = ve, Ce = be, Ue = A.i, Ne = X.uid, H;
        }
        u.getMarkerAngle = ke;
      }), ti = xe((L, k) => {
        var n = vr(), e = xr(), a = on(), i = or(), o = wt(), r = o.strTranslate, s = Or(), c = fr(), t = xn(), p = so(), l = kn().OPPOSITE_SIDE, f = / [XY][0-9]* /, v = 1.6, g = 1.6;
        function x(h, m, u) {
          var d = h._fullLayout, y = u.propContainer, _ = u.propName, T = u.placeholder, R = u.traceIndex, I = u.avoid || {}, P = u.attributes, M = u.transform, B = u.containerGroup, z = 1, q = y.title, U = (q && q.text ? q.text : "").trim(), G = !1, K = q && q.font ? q.font : {}, te = K.family, V = K.size, Z = K.color, Y = K.weight, C = K.style, j = K.variant, J = K.textcase, ne = K.lineposition, ae = K.shadow, se = u.subtitlePropName, O = !!se, F = u.subtitlePlaceholder, S = (y.title || {}).subtitle || { text: "", font: {} }, $ = (S.text || "").trim(), re = !1, E = 1, w = S.font, N = w.family, W = w.size, ee = w.color, le = w.weight, ie = w.style, pe = w.variant, _e = w.textcase, Ae = w.lineposition, Ce = w.shadow, Ue;
          _ === "title.text" ? Ue = "titleText" : _.indexOf("axis") !== -1 ? Ue = "axisTitleText" : _.indexOf("colorbar") !== -1 && (Ue = "colorbarTitleText");
          var Ne = h._context.edits[Ue];
          function ke(Ke, ct) {
            return Ke === void 0 || ct === void 0 ? !1 : Ke.replace(f, " % ") === ct.replace(f, " % ");
          }
          U === "" ? z = 0 : ke(U, T) && (Ne || (U = ""), z = 0.2, G = !0), O && ($ === "" ? E = 0 : ke($, F) && (Ne || ($ = ""), E = 0.2, re = !0)), u._meta ? U = o.templateString(U, u._meta) : d._meta && (U = o.templateString(U, d._meta));
          var A = U || $ || Ne, X;
          B || (B = o.ensureSingle(d._infolayer, "g", "g-" + m), X = d._hColorbarMoveTitle);
          var H = B.selectAll("text." + m).data(A ? [0] : []);
          H.enter().append("text"), H.text(U).attr("class", m), H.exit().remove();
          var ve = null, be = m + "-subtitle", Se = $ || Ne;
          if (O && (ve = B.selectAll("text." + be).data(Se ? [0] : []), ve.enter().append("text"), ve.text($).attr("class", be), ve.exit().remove()), !A) return B;
          function De(Ke, ct) {
            o.syncOrAsync([He, Ze], { title: Ke, subtitle: ct });
          }
          function He(Ke) {
            var ct = Ke.title, gt = Ke.subtitle, ht;
            !M && X && (M = {}), M ? (ht = "", M.rotate && (ht += "rotate(" + [M.rotate, P.x, P.y] + ")"), (M.offset || X) && (ht += r(0, (M.offset || 0) - (X || 0)))) : ht = null, ct.attr("transform", ht);
            function _t(Me) {
              if (Me) {
                var Oe = n.select(Me.node().parentNode).select("." + be);
                if (!Oe.empty()) {
                  var je = Me.node().getBBox();
                  if (je.height) {
                    var qe = je.y + je.height + v * W;
                    Oe.attr("y", qe);
                  }
                }
              }
            }
            if (ct.style("opacity", z * c.opacity(Z)).call(s.font, { color: c.rgb(Z), size: n.round(V, 2), family: te, weight: Y, style: C, variant: j, textcase: J, shadow: ae, lineposition: ne }).attr(P).call(t.convertToTspans, h, _t), gt && !gt.empty()) {
              var Te = B.select("." + m + "-math-group"), Ie = ct.node().getBBox(), ce = Te.node() ? Te.node().getBBox() : void 0, ge = ce ? ce.y + ce.height + v * W : Ie.y + Ie.height + g * W, ye = o.extendFlat({}, P, { y: ge });
              gt.attr("transform", ht), gt.style("opacity", E * c.opacity(ee)).call(s.font, { color: c.rgb(ee), size: n.round(W, 2), family: N, weight: le, style: ie, variant: pe, textcase: _e, shadow: Ce, lineposition: Ae }).attr(ye).call(t.convertToTspans, h);
            }
            return a.previousPromises(h);
          }
          function Ze(Ke) {
            var ct = Ke.title, gt = n.select(ct.node().parentNode);
            if (I && I.selection && I.side && U) {
              gt.attr("transform", null);
              var ht = l[I.side], _t = I.side === "left" || I.side === "top" ? -1 : 1, Te = e(I.pad) ? I.pad : 2, Ie = s.bBox(gt.node()), ce = { t: 0, b: 0, l: 0, r: 0 }, ge = h._fullLayout._reservedMargin;
              for (var ye in ge) for (var Me in ge[ye]) {
                var Oe = ge[ye][Me];
                ce[Me] = Math.max(ce[Me], Oe);
              }
              var je = { left: ce.l, top: ce.t, right: d.width - ce.r, bottom: d.height - ce.b }, qe = I.maxShift || _t * (je[I.side] - Ie[I.side]), Qe = 0;
              if (qe < 0) Qe = qe;
              else {
                var Xe = I.offsetLeft || 0, Je = I.offsetTop || 0;
                Ie.left -= Xe, Ie.right -= Xe, Ie.top -= Je, Ie.bottom -= Je, I.selection.each(function() {
                  var lt = s.bBox(this);
                  o.bBoxIntersect(Ie, lt, Te) && (Qe = Math.max(Qe, _t * (lt[I.side] - Ie[ht]) + Te));
                }), Qe = Math.min(qe, Qe), y._titleScoot = Math.abs(Qe);
              }
              if (Qe > 0 || qe < 0) {
                var ot = { left: [-Qe, 0], right: [Qe, 0], top: [0, -Qe], bottom: [0, Qe] }[I.side];
                gt.attr("transform", r(ot[0], ot[1]));
              }
            }
          }
          H.call(De, ve);
          function We(Ke, ct) {
            Ke.text(ct).on("mouseover.opacity", function() {
              n.select(this).transition().duration(p.SHOW_PLACEHOLDER).style("opacity", 1);
            }).on("mouseout.opacity", function() {
              n.select(this).transition().duration(p.HIDE_PLACEHOLDER).style("opacity", 0);
            });
          }
          if (Ne && (U ? H.on(".opacity", null) : (We(H, T), G = !0), H.call(t.makeEditable, { gd: h }).on("edit", function(Ke) {
            R !== void 0 ? i.call("_guiRestyle", h, _, Ke, R) : i.call("_guiRelayout", h, _, Ke);
          }).on("cancel", function() {
            this.text(this.attr("data-unformatted")).call(De);
          }).on("input", function(Ke) {
            this.text(Ke || " ").call(t.positionText, P.x, P.y);
          }), O)) {
            if (O && !U) {
              var $e = H.node().getBBox(), it = $e.y + $e.height + g * W;
              ve.attr("y", it);
            }
            $ ? ve.on(".opacity", null) : (We(ve, F), re = !0), ve.call(t.makeEditable, { gd: h }).on("edit", function(Ke) {
              i.call("_guiRelayout", h, "title.subtitle.text", Ke);
            }).on("cancel", function() {
              this.text(this.attr("data-unformatted")).call(De);
            }).on("input", function(Ke) {
              this.text(Ke || " ").call(t.positionText, ve.attr("x"), ve.attr("y"));
            });
          }
          return H.classed("js-placeholder", G), ve && !ve.empty() && ve.classed("js-placeholder", re), B;
        }
        k.exports = { draw: x, SUBTITLE_PADDING_EM: g, SUBTITLE_PADDING_MATHJAX_EM: v };
      }), ri = xe((L, k) => {
        var n = vr(), e = Wa().utcFormat, a = wt(), i = a.numberFormat, o = xr(), r = a.cleanNumber, s = a.ms2DateTime, c = a.dateTime2ms, t = a.ensureNumber, p = a.isArrayOrTypedArray, l = Yr(), f = l.FP_SAFE, v = l.BADNUM, g = l.LOG_CLIP, x = l.ONEWEEK, h = l.ONEDAY, m = l.ONEHOUR, u = l.ONEMIN, d = l.ONESEC, y = sn(), _ = mn(), T = _.HOUR_PATTERN, R = _.WEEKDAY_PATTERN;
        function I(M) {
          return Math.pow(10, M);
        }
        function P(M) {
          return M != null;
        }
        k.exports = function(M, B) {
          B = B || {};
          var z = M._id || "x", q = z.charAt(0);
          function U(S, $) {
            if (S > 0) return Math.log(S) / Math.LN10;
            if (S <= 0 && $ && M.range && M.range.length === 2) {
              var re = M.range[0], E = M.range[1];
              return 0.5 * (re + E - 2 * g * Math.abs(re - E));
            } else return v;
          }
          function G(S, $, re, E) {
            if ((E || {}).msUTC && o(S)) return +S;
            var w = c(S, re || M.calendar);
            if (w === v) if (o(S)) {
              S = +S;
              var N = Math.floor(a.mod(S + 0.05, 1) * 10), W = Math.round(S - N / 10);
              w = c(new Date(W)) + N / 10;
            } else return v;
            return w;
          }
          function K(S, $, re) {
            return s(S, $, re || M.calendar);
          }
          function te(S) {
            return M._categories[Math.round(S)];
          }
          function V(S) {
            if (P(S)) {
              if (M._categoriesMap === void 0 && (M._categoriesMap = {}), M._categoriesMap[S] !== void 0) return M._categoriesMap[S];
              M._categories.push(typeof S == "number" ? String(S) : S);
              var $ = M._categories.length - 1;
              return M._categoriesMap[S] = $, $;
            }
            return v;
          }
          function Z(S, $) {
            for (var re = new Array($), E = 0; E < $; E++) {
              var w = (S[0] || [])[E], N = (S[1] || [])[E];
              re[E] = Y([w, N]);
            }
            return re;
          }
          function Y(S) {
            if (M._categoriesMap) return M._categoriesMap[S];
          }
          function C(S) {
            var $ = Y(S);
            if ($ !== void 0) return $;
            if (o(S)) return +S;
          }
          function j(S) {
            return o(S) ? +S : Y(S);
          }
          function J(S, $, re) {
            return n.round(re + $ * S, 2);
          }
          function ne(S, $, re) {
            return (S - re) / $;
          }
          var ae = function(S) {
            return o(S) ? J(S, M._m, M._b) : v;
          }, se = function(S) {
            return ne(S, M._m, M._b);
          };
          if (M.rangebreaks) {
            var O = q === "y";
            ae = function(S) {
              if (!o(S)) return v;
              var $ = M._rangebreaks.length;
              if (!$) return J(S, M._m, M._b);
              var re = O;
              M.range[0] > M.range[1] && (re = !re);
              for (var E = re ? -1 : 1, w = E * S, N = 0, W = 0; W < $; W++) {
                var ee = E * M._rangebreaks[W].min, le = E * M._rangebreaks[W].max;
                if (w < ee) break;
                if (w > le) N = W + 1;
                else {
                  N = w < (ee + le) / 2 ? W : W + 1;
                  break;
                }
              }
              var ie = M._B[N] || 0;
              return isFinite(ie) ? J(S, M._m2, ie) : 0;
            }, se = function(S) {
              var $ = M._rangebreaks.length;
              if (!$) return ne(S, M._m, M._b);
              for (var re = 0, E = 0; E < $ && !(S < M._rangebreaks[E].pmin); E++) S > M._rangebreaks[E].pmax && (re = E + 1);
              return ne(S, M._m2, M._B[re]);
            };
          }
          M.c2l = M.type === "log" ? U : t, M.l2c = M.type === "log" ? I : t, M.l2p = ae, M.p2l = se, M.c2p = M.type === "log" ? function(S, $) {
            return ae(U(S, $));
          } : ae, M.p2c = M.type === "log" ? function(S) {
            return I(se(S));
          } : se, ["linear", "-"].indexOf(M.type) !== -1 ? (M.d2r = M.r2d = M.d2c = M.r2c = M.d2l = M.r2l = r, M.c2d = M.c2r = M.l2d = M.l2r = t, M.d2p = M.r2p = function(S) {
            return M.l2p(r(S));
          }, M.p2d = M.p2r = se, M.cleanPos = t) : M.type === "log" ? (M.d2r = M.d2l = function(S, $) {
            return U(r(S), $);
          }, M.r2d = M.r2c = function(S) {
            return I(r(S));
          }, M.d2c = M.r2l = r, M.c2d = M.l2r = t, M.c2r = U, M.l2d = I, M.d2p = function(S, $) {
            return M.l2p(M.d2r(S, $));
          }, M.p2d = function(S) {
            return I(se(S));
          }, M.r2p = function(S) {
            return M.l2p(r(S));
          }, M.p2r = se, M.cleanPos = t) : M.type === "date" ? (M.d2r = M.r2d = a.identity, M.d2c = M.r2c = M.d2l = M.r2l = G, M.c2d = M.c2r = M.l2d = M.l2r = K, M.d2p = M.r2p = function(S, $, re) {
            return M.l2p(G(S, 0, re));
          }, M.p2d = M.p2r = function(S, $, re) {
            return K(se(S), $, re);
          }, M.cleanPos = function(S) {
            return a.cleanDate(S, v, M.calendar);
          }) : M.type === "category" ? (M.d2c = M.d2l = V, M.r2d = M.c2d = M.l2d = te, M.d2r = M.d2l_noadd = C, M.r2c = function(S) {
            var $ = j(S);
            return $ !== void 0 ? $ : M.fraction2r(0.5);
          }, M.l2r = M.c2r = t, M.r2l = j, M.d2p = function(S) {
            return M.l2p(M.r2c(S));
          }, M.p2d = function(S) {
            return te(se(S));
          }, M.r2p = M.d2p, M.p2r = se, M.cleanPos = function(S) {
            return typeof S == "string" && S !== "" ? S : t(S);
          }) : M.type === "multicategory" && (M.r2d = M.c2d = M.l2d = te, M.d2r = M.d2l_noadd = C, M.r2c = function(S) {
            var $ = C(S);
            return $ !== void 0 ? $ : M.fraction2r(0.5);
          }, M.r2c_just_indices = Y, M.l2r = M.c2r = t, M.r2l = C, M.d2p = function(S) {
            return M.l2p(M.r2c(S));
          }, M.p2d = function(S) {
            return te(se(S));
          }, M.r2p = M.d2p, M.p2r = se, M.cleanPos = function(S) {
            return Array.isArray(S) || typeof S == "string" && S !== "" ? S : t(S);
          }, M.setupMultiCategory = function(S) {
            var $ = M._traceIndices, re, E, w = M._matchGroup;
            if (w && M._categories.length === 0) {
              for (var N in w) if (N !== z) {
                var W = B[y.id2name(N)];
                $ = $.concat(W._traceIndices);
              }
            }
            var ee = [[0, {}], [0, {}]], le = [];
            for (re = 0; re < $.length; re++) {
              var ie = S[$[re]];
              if (q in ie) {
                var pe = ie[q], _e = ie._length || a.minRowLength(pe);
                if (p(pe[0]) && p(pe[1])) for (E = 0; E < _e; E++) {
                  var Ae = pe[0][E], Ce = pe[1][E];
                  P(Ae) && P(Ce) && (le.push([Ae, Ce]), Ae in ee[0][1] || (ee[0][1][Ae] = ee[0][0]++), Ce in ee[1][1] || (ee[1][1][Ce] = ee[1][0]++));
                }
              }
            }
            for (le.sort(function(Ue, Ne) {
              var ke = ee[0][1], A = ke[Ue[0]] - ke[Ne[0]];
              if (A) return A;
              var X = ee[1][1];
              return X[Ue[1]] - X[Ne[1]];
            }), re = 0; re < le.length; re++) V(le[re]);
          }), M.fraction2r = function(S) {
            var $ = M.r2l(M.range[0]), re = M.r2l(M.range[1]);
            return M.l2r($ + S * (re - $));
          }, M.r2fraction = function(S) {
            var $ = M.r2l(M.range[0]), re = M.r2l(M.range[1]);
            return (M.r2l(S) - $) / (re - $);
          }, M.limitRange = function(S) {
            var $ = M.minallowed, re = M.maxallowed;
            if (!($ === void 0 && re === void 0)) {
              S || (S = "range");
              var E = a.nestedProperty(M, S).get(), w = a.simpleMap(E, M.r2l), N = w[1] < w[0];
              N && w.reverse();
              var W = a.simpleMap([$, re], M.r2l);
              if ($ !== void 0 && w[0] < W[0] && (E[N ? 1 : 0] = $), re !== void 0 && w[1] > W[1] && (E[N ? 0 : 1] = re), E[0] === E[1]) {
                var ee = M.l2r($), le = M.l2r(re);
                if ($ !== void 0) {
                  var ie = ee + 1;
                  re !== void 0 && (ie = Math.min(ie, le)), E[N ? 1 : 0] = ie;
                }
                if (re !== void 0) {
                  var pe = le + 1;
                  $ !== void 0 && (pe = Math.max(pe, ee)), E[N ? 0 : 1] = pe;
                }
              }
            }
          }, M.cleanRange = function(S, $) {
            M._cleanRange(S, $), M.limitRange(S);
          }, M._cleanRange = function(S, $) {
            $ || ($ = {}), S || (S = "range");
            var re = a.nestedProperty(M, S).get(), E, w;
            if (M.type === "date" ? w = a.dfltRange(M.calendar) : q === "y" ? w = _.DFLTRANGEY : M._name === "realaxis" ? w = [0, 1] : w = $.dfltRange || _.DFLTRANGEX, w = w.slice(), (M.rangemode === "tozero" || M.rangemode === "nonnegative") && (w[0] = 0), !re || re.length !== 2) {
              a.nestedProperty(M, S).set(w);
              return;
            }
            var N = re[0] === null, W = re[1] === null;
            for (M.type === "date" && !M.autorange && (re[0] = a.cleanDate(re[0], v, M.calendar), re[1] = a.cleanDate(re[1], v, M.calendar)), E = 0; E < 2; E++) if (M.type === "date") {
              if (!a.isDateTime(re[E], M.calendar)) {
                M[S] = w;
                break;
              }
              if (M.r2l(re[0]) === M.r2l(re[1])) {
                var ee = a.constrain(M.r2l(re[0]), a.MIN_MS + 1e3, a.MAX_MS - 1e3);
                re[0] = M.l2r(ee - 1e3), re[1] = M.l2r(ee + 1e3);
                break;
              }
            } else {
              if (!o(re[E])) if (!(N || W) && o(re[1 - E])) re[E] = re[1 - E] * (E ? 10 : 0.1);
              else {
                M[S] = w;
                break;
              }
              if (re[E] < -f ? re[E] = -f : re[E] > f && (re[E] = f), re[0] === re[1]) {
                var le = Math.max(1, Math.abs(re[0] * 1e-6));
                re[0] -= le, re[1] += le;
              }
            }
          }, M.setScale = function(S) {
            var $ = B._size;
            if (M.overlaying) {
              var re = y.getFromId({ _fullLayout: B }, M.overlaying);
              M.domain = re.domain;
            }
            var E = S && M._r ? "_r" : "range", w = M.calendar;
            M.cleanRange(E);
            var N = M.r2l(M[E][0], w), W = M.r2l(M[E][1], w), ee = q === "y";
            if (ee ? (M._offset = $.t + (1 - M.domain[1]) * $.h, M._length = $.h * (M.domain[1] - M.domain[0]), M._m = M._length / (N - W), M._b = -M._m * W) : (M._offset = $.l + M.domain[0] * $.w, M._length = $.w * (M.domain[1] - M.domain[0]), M._m = M._length / (W - N), M._b = -M._m * N), M._rangebreaks = [], M._lBreaks = 0, M._m2 = 0, M._B = [], M.rangebreaks) {
              var le, ie;
              if (M._rangebreaks = M.locateBreaks(Math.min(N, W), Math.max(N, W)), M._rangebreaks.length) {
                for (le = 0; le < M._rangebreaks.length; le++) ie = M._rangebreaks[le], M._lBreaks += Math.abs(ie.max - ie.min);
                var pe = ee;
                N > W && (pe = !pe), pe && M._rangebreaks.reverse();
                var _e = pe ? -1 : 1;
                for (M._m2 = _e * M._length / (Math.abs(W - N) - M._lBreaks), M._B.push(-M._m2 * (ee ? W : N)), le = 0; le < M._rangebreaks.length; le++) ie = M._rangebreaks[le], M._B.push(M._B[M._B.length - 1] - _e * M._m2 * (ie.max - ie.min));
                for (le = 0; le < M._rangebreaks.length; le++) ie = M._rangebreaks[le], ie.pmin = ae(ie.min), ie.pmax = ae(ie.max);
              }
            }
            if (!isFinite(M._m) || !isFinite(M._b) || M._length < 0) throw B._replotting = !1, new Error("Something went wrong with axis scaling");
          }, M.maskBreaks = function(S) {
            var $ = M.rangebreaks || [], re, E, w, N, W;
            $._cachedPatterns || ($._cachedPatterns = $.map(function(ke) {
              return ke.enabled && ke.bounds ? a.simpleMap(ke.bounds, ke.pattern ? r : M.d2c) : null;
            })), $._cachedValues || ($._cachedValues = $.map(function(ke) {
              return ke.enabled && ke.values ? a.simpleMap(ke.values, M.d2c).sort(a.sorterAsc) : null;
            }));
            for (var ee = 0; ee < $.length; ee++) {
              var le = $[ee];
              if (le.enabled) {
                if (le.bounds) {
                  var ie = le.pattern;
                  switch (re = $._cachedPatterns[ee], E = re[0], w = re[1], ie) {
                    case R:
                      W = new Date(S), N = W.getUTCDay(), E > w && (w += 7, N < E && (N += 7));
                      break;
                    case T:
                      W = new Date(S);
                      var pe = W.getUTCHours(), _e = W.getUTCMinutes(), Ae = W.getUTCSeconds(), Ce = W.getUTCMilliseconds();
                      N = pe + (_e / 60 + Ae / 3600 + Ce / 36e5), E > w && (w += 24, N < E && (N += 24));
                      break;
                    case "":
                      N = S;
                      break;
                  }
                  if (N >= E && N < w) return v;
                } else for (var Ue = $._cachedValues[ee], Ne = 0; Ne < Ue.length; Ne++) if (E = Ue[Ne], w = E + le.dvalue, S >= E && S < w) return v;
              }
            }
            return S;
          }, M.locateBreaks = function(S, $) {
            var re, E, w, N, W = [];
            if (!M.rangebreaks) return W;
            var ee = M.rangebreaks.slice().sort(function(X, H) {
              return X.pattern === R && H.pattern === T ? -1 : H.pattern === R && X.pattern === T ? 1 : 0;
            }), le = function(X, H) {
              if (X = a.constrain(X, S, $), H = a.constrain(H, S, $), X !== H) {
                for (var ve = !0, be = 0; be < W.length; be++) {
                  var Se = W[be];
                  X < Se.max && H >= Se.min && (X < Se.min && (Se.min = X), H > Se.max && (Se.max = H), ve = !1);
                }
                ve && W.push({ min: X, max: H });
              }
            };
            for (re = 0; re < ee.length; re++) {
              var ie = ee[re];
              if (ie.enabled) if (ie.bounds) {
                var pe = S, _e = $;
                ie.pattern && (pe = Math.floor(pe)), E = a.simpleMap(ie.bounds, ie.pattern ? r : M.r2l), w = E[0], N = E[1];
                var Ae = new Date(pe), Ce, Ue;
                switch (ie.pattern) {
                  case R:
                    Ue = x, Ce = ((N < w ? 7 : 0) + (N - w)) * h, pe += w * h - (Ae.getUTCDay() * h + Ae.getUTCHours() * m + Ae.getUTCMinutes() * u + Ae.getUTCSeconds() * d + Ae.getUTCMilliseconds());
                    break;
                  case T:
                    Ue = h, Ce = ((N < w ? 24 : 0) + (N - w)) * m, pe += w * m - (Ae.getUTCHours() * m + Ae.getUTCMinutes() * u + Ae.getUTCSeconds() * d + Ae.getUTCMilliseconds());
                    break;
                  default:
                    pe = Math.min(E[0], E[1]), _e = Math.max(E[0], E[1]), Ue = _e - pe, Ce = Ue;
                }
                for (var Ne = pe; Ne < _e; Ne += Ue) le(Ne, Ne + Ce);
              } else for (var ke = a.simpleMap(ie.values, M.d2c), A = 0; A < ke.length; A++) w = ke[A], N = w + ie.dvalue, le(w, N);
            }
            return W.sort(function(X, H) {
              return X.min - H.min;
            }), W;
          }, M.makeCalcdata = function(S, $, re) {
            var E, w, N, W, ee = M.type, le = ee === "date" && S[$ + "calendar"];
            if ($ in S) {
              if (E = S[$], W = S._length || a.minRowLength(E), a.isTypedArray(E) && (ee === "linear" || ee === "log")) {
                if (W === E.length) return E;
                if (E.subarray) return E.subarray(0, W);
              }
              if (ee === "multicategory") return Z(E, W);
              for (w = new Array(W), N = 0; N < W; N++) w[N] = M.d2c(E[N], 0, le, re);
            } else {
              var ie = $ + "0" in S ? M.d2c(S[$ + "0"], 0, le) : 0, pe = S["d" + $] ? Number(S["d" + $]) : 1;
              for (E = S[{ x: "y", y: "x" }[$]], W = S._length || E.length, w = new Array(W), N = 0; N < W; N++) w[N] = ie + N * pe;
            }
            if (M.rangebreaks) for (N = 0; N < W; N++) w[N] = M.maskBreaks(w[N]);
            return w;
          }, M.isValidRange = function(S, $) {
            return Array.isArray(S) && S.length === 2 && ($ && S[0] === null || o(M.r2l(S[0]))) && ($ && S[1] === null || o(M.r2l(S[1])));
          }, M.getAutorangeDflt = function(S, $) {
            var re = !M.isValidRange(S, "nullOk");
            return re && $ && $.reverseDflt ? re = "reversed" : S && (S[0] === null && S[1] === null ? re = !0 : S[0] === null && S[1] !== null ? re = "min" : S[0] !== null && S[1] === null && (re = "max")), re;
          }, M.isReversed = function() {
            var S = M.autorange;
            return S === "reversed" || S === "min reversed" || S === "max reversed";
          }, M.isPtWithinRange = function(S, $) {
            var re = M.c2l(S[q], null, $), E = M.r2l(M.range[0]), w = M.r2l(M.range[1]);
            return E < w ? E <= re && re <= w : w <= re && re <= E;
          }, M._emptyCategories = function() {
            M._categories = [], M._categoriesMap = {};
          }, M.clearCalc = function() {
            var S = M._matchGroup;
            if (S) {
              var $ = null, re = null;
              for (var E in S) {
                var w = B[y.id2name(E)];
                if (w._categories) {
                  $ = w._categories, re = w._categoriesMap;
                  break;
                }
              }
              $ && re ? (M._categories = $, M._categoriesMap = re) : M._emptyCategories();
            } else M._emptyCategories();
            if (M._initialCategories) for (var N = 0; N < M._initialCategories.length; N++) V(M._initialCategories[N]);
          }, M.sortByInitialCategories = function() {
            var S = [];
            if (M._emptyCategories(), M._initialCategories) for (var $ = 0; $ < M._initialCategories.length; $++) V(M._initialCategories[$]);
            S = S.concat(M._traceIndices);
            var re = M._matchGroup;
            for (var E in re) if (z !== E) {
              var w = B[y.id2name(E)];
              w._categories = M._categories, w._categoriesMap = M._categoriesMap, S = S.concat(w._traceIndices);
            }
            return S;
          };
          var F = B._d3locale;
          M.type === "date" && (M._dateFormat = F ? F.timeFormat : e, M._extraFormat = B._extraFormat), M._separators = B.separators, M._numFormat = F ? F.numberFormat : i, delete M._minDtick, delete M._forceTick0;
        };
      }), wo = xe((L, k) => {
        var n = xr(), e = wt(), a = Yr().BADNUM, i = e.isArrayOrTypedArray, o = e.isDateTime, r = e.cleanNumber, s = Math.round;
        k.exports = function(g, x, h) {
          var m = g, u = h.noMultiCategory;
          if (i(m) && !m.length) return "-";
          if (!u && v(m)) return "multicategory";
          if (u && Array.isArray(m[0])) {
            for (var d = [], y = 0; y < m.length; y++) if (i(m[y])) for (var _ = 0; _ < m[y].length; _++) d.push(m[y][_]);
            m = d;
          }
          if (p(m, x)) return "date";
          var T = h.autotypenumbers !== "strict";
          return f(m, T) ? "category" : t(m, T) ? "linear" : "-";
        };
        function c(g, x) {
          return x ? n(g) : typeof g == "number";
        }
        function t(g, x) {
          for (var h = g.length, m = 0; m < h; m++) if (c(g[m], x)) return !0;
          return !1;
        }
        function p(g, x) {
          for (var h = g.length, m = l(h), u = 0, d = 0, y = {}, _ = 0; _ < h; _ += m) {
            var T = s(_), R = g[T], I = String(R);
            y[I] || (y[I] = 1, o(R, x) && u++, n(R) && d++);
          }
          return u > d * 2;
        }
        function l(g) {
          return Math.max(1, (g - 1) / 1e3);
        }
        function f(g, x) {
          for (var h = g.length, m = l(h), u = 0, d = 0, y = {}, _ = 0; _ < h; _ += m) {
            var T = s(_), R = g[T], I = String(R);
            if (!y[I]) {
              y[I] = 1;
              var P = typeof R;
              P === "boolean" ? d++ : (x ? r(R) !== a : P === "number") ? u++ : P === "string" && d++;
            }
          }
          return d > u * 2;
        }
        function v(g) {
          return i(g[0]) && i(g[1]);
        }
      }), ki = xe((L, k) => {
        var n = vr(), e = xr(), a = wt(), i = Yr().FP_SAFE, o = or(), r = Or(), s = sn(), c = s.getFromId, t = s.isLinked;
        k.exports = { applyAutorangeOptions: B, getAutoRange: p, makePadFn: f, doAutoRange: h, findExtremes: m, concatExtremes: x };
        function p(z, q) {
          var U, G, K = [], te = z._fullLayout, V = f(te, q, 0), Z = f(te, q, 1), Y = x(z, q), C = Y.min, j = Y.max;
          if (C.length === 0 || j.length === 0) return a.simpleMap(q.range, q.r2l);
          var J = C[0].val, ne = j[0].val;
          for (U = 1; U < C.length && J === ne; U++) J = Math.min(J, C[U].val);
          for (U = 1; U < j.length && J === ne; U++) ne = Math.max(ne, j[U].val);
          var ae = q.autorange, se = ae === "reversed" || ae === "min reversed" || ae === "max reversed";
          if (!se && q.range) {
            var O = a.simpleMap(q.range, q.r2l);
            se = O[1] < O[0];
          }
          q.autorange === "reversed" && (q.autorange = !0);
          var F = q.rangemode, S = F === "tozero", $ = F === "nonnegative", re = q._length, E = re / 10, w = 0, N, W, ee, le, ie, pe;
          for (U = 0; U < C.length; U++) for (N = C[U], G = 0; G < j.length; G++) W = j[G], pe = W.val - N.val - l(q, N.val, W.val), pe > 0 && (ie = re - V(N) - Z(W), ie > E ? pe / ie > w && (ee = N, le = W, w = pe / ie) : pe / re > w && (ee = { val: N.val, nopad: 1 }, le = { val: W.val, nopad: 1 }, w = pe / re));
          function _e(ke, A) {
            return Math.max(ke, Z(A));
          }
          if (J === ne) {
            var Ae = J - 1, Ce = J + 1;
            if (S) if (J === 0) K = [0, 1];
            else {
              var Ue = (J > 0 ? j : C).reduce(_e, 0), Ne = J / (1 - Math.min(0.5, Ue / re));
              K = J > 0 ? [0, Ne] : [Ne, 0];
            }
            else $ ? K = [Math.max(0, Ae), Math.max(1, Ce)] : K = [Ae, Ce];
          } else S ? (ee.val >= 0 && (ee = { val: 0, nopad: 1 }), le.val <= 0 && (le = { val: 0, nopad: 1 })) : $ && (ee.val - w * V(ee) < 0 && (ee = { val: 0, nopad: 1 }), le.val <= 0 && (le = { val: 1, nopad: 1 })), w = (le.val - ee.val - l(q, N.val, W.val)) / (re - V(ee) - Z(le)), K = [ee.val - w * V(ee), le.val + w * Z(le)];
          return K = B(K, q), q.limitRange && q.limitRange(), se && K.reverse(), a.simpleMap(K, q.l2r || Number);
        }
        function l(z, q, U) {
          var G = 0;
          if (z.rangebreaks) for (var K = z.locateBreaks(q, U), te = 0; te < K.length; te++) {
            var V = K[te];
            G += V.max - V.min;
          }
          return G;
        }
        function f(z, q, U) {
          var G = 0.05 * q._length, K = q._anchorAxis || {};
          if ((q.ticklabelposition || "").indexOf("inside") !== -1 || (K.ticklabelposition || "").indexOf("inside") !== -1) {
            var te = q.isReversed();
            if (!te) {
              var V = a.simpleMap(q.range, q.r2l);
              te = V[1] < V[0];
            }
            te && (U = !U);
          }
          var Z = 0;
          return t(z, q._id) || (Z = g(z, q, U)), G = Math.max(Z, G), q.constrain === "domain" && q._inputDomain && (G *= (q._inputDomain[1] - q._inputDomain[0]) / (q.domain[1] - q.domain[0])), function(Y) {
            return Y.nopad ? 0 : Y.pad + (Y.extrapad ? G : Z);
          };
        }
        var v = 3;
        function g(z, q, U) {
          var G = 0, K = q._id.charAt(0) === "x";
          for (var te in z._plots) {
            var V = z._plots[te];
            if (!(q._id !== V.xaxis._id && q._id !== V.yaxis._id)) {
              var Z = (K ? V.yaxis : V.xaxis) || {};
              if ((Z.ticklabelposition || "").indexOf("inside") !== -1 && (!U && (Z.side === "left" || Z.side === "bottom") || U && (Z.side === "top" || Z.side === "right"))) {
                if (Z._vals) {
                  var Y = a.deg2rad(Z._tickAngles[Z._id + "tick"] || 0), C = Math.abs(Math.cos(Y)), j = Math.abs(Math.sin(Y));
                  if (!Z._vals[0].bb) {
                    var J = Z._id + "tick", ne = Z._selections[J];
                    ne.each(function($) {
                      var re = n.select(this), E = re.select(".text-math-group");
                      E.empty() && ($.bb = r.bBox(re.node()));
                    });
                  }
                  for (var ae = 0; ae < Z._vals.length; ae++) {
                    var se = Z._vals[ae], O = se.bb;
                    if (O) {
                      var F = 2 * v + O.width, S = 2 * v + O.height;
                      G = Math.max(G, K ? Math.max(F * C, S * j) : Math.max(S * C, F * j));
                    }
                  }
                }
                Z.ticks === "inside" && Z.ticklabelposition === "inside" && (G += Z.ticklen || 0);
              }
            }
          }
          return G;
        }
        function x(z, q, U) {
          var G = q._id, K = z._fullData, te = z._fullLayout, V = [], Z = [], Y, C, j;
          function J(F, S) {
            for (Y = 0; Y < S.length; Y++) {
              var $ = F[S[Y]], re = ($._extremes || {})[G];
              if ($.visible === !0 && re) {
                for (C = 0; C < re.min.length; C++) j = re.min[C], u(V, j.val, j.pad, { extrapad: j.extrapad });
                for (C = 0; C < re.max.length; C++) j = re.max[C], d(Z, j.val, j.pad, { extrapad: j.extrapad });
              }
            }
          }
          if (J(K, q._traceIndices), J(te.annotations || [], q._annIndices || []), J(te.shapes || [], q._shapeIndices || []), q._matchGroup && !U) {
            for (var ne in q._matchGroup) if (ne !== q._id) {
              var ae = c(z, ne), se = x(z, ae, !0), O = q._length / ae._length;
              for (C = 0; C < se.min.length; C++) j = se.min[C], u(V, j.val, j.pad * O, { extrapad: j.extrapad });
              for (C = 0; C < se.max.length; C++) j = se.max[C], d(Z, j.val, j.pad * O, { extrapad: j.extrapad });
            }
          }
          return { min: V, max: Z };
        }
        function h(z, q, U) {
          if (q.setScale(), q.autorange) {
            q.range = U ? U.slice() : p(z, q), q._r = q.range.slice(), q._rl = a.simpleMap(q._r, q.r2l);
            var G = q._input, K = {};
            K[q._attr + ".range"] = q.range, K[q._attr + ".autorange"] = q.autorange, o.call("_storeDirectGUIEdit", z.layout, z._fullLayout._preGUI, K), G.range = q.range.slice(), G.autorange = q.autorange;
          }
          var te = q._anchorAxis;
          if (te && te.rangeslider) {
            var V = te.rangeslider[q._name];
            V && V.rangemode === "auto" && (V.range = p(z, q)), te._input.rangeslider[q._name] = a.extendFlat({}, V);
          }
        }
        function m(z, q, U) {
          U || (U = {}), z._m || z.setScale();
          var G = [], K = [], te = q.length, V = U.padded || !1, Z = U.tozero && (z.type === "linear" || z.type === "-"), Y = z.type === "log", C = !1, j = U.vpadLinearized || !1, J, ne, ae, se, O, F, S, $, re;
          function E(_e) {
            if (Array.isArray(_e)) return C = !0, function(Ce) {
              return Math.max(Number(_e[Ce] || 0), 0);
            };
            var Ae = Math.max(Number(_e || 0), 0);
            return function() {
              return Ae;
            };
          }
          var w = E((z._m > 0 ? U.ppadplus : U.ppadminus) || U.ppad || 0), N = E((z._m > 0 ? U.ppadminus : U.ppadplus) || U.ppad || 0), W = E(U.vpadplus || U.vpad), ee = E(U.vpadminus || U.vpad);
          if (!C) {
            if ($ = 1 / 0, re = -1 / 0, Y) for (J = 0; J < te; J++) ne = q[J], ne < $ && ne > 0 && ($ = ne), ne > re && ne < i && (re = ne);
            else for (J = 0; J < te; J++) ne = q[J], ne < $ && ne > -i && ($ = ne), ne > re && ne < i && (re = ne);
            q = [$, re], te = 2;
          }
          var le = { tozero: Z, extrapad: V };
          function ie(_e) {
            ae = q[_e], e(ae) && (F = w(_e), S = N(_e), j ? (se = z.c2l(ae) - ee(_e), O = z.c2l(ae) + W(_e)) : ($ = ae - ee(_e), re = ae + W(_e), Y && $ < re / 10 && ($ = re / 10), se = z.c2l($), O = z.c2l(re)), Z && (se = Math.min(0, se), O = Math.max(0, O)), _(se) && u(G, se, S, le), _(O) && d(K, O, F, le));
          }
          var pe = Math.min(6, te);
          for (J = 0; J < pe; J++) ie(J);
          for (J = te - 1; J >= pe; J--) ie(J);
          return { min: G, max: K, opts: U };
        }
        function u(z, q, U, G) {
          y(z, q, U, G, T);
        }
        function d(z, q, U, G) {
          y(z, q, U, G, R);
        }
        function y(z, q, U, G, K) {
          for (var te = G.tozero, V = G.extrapad, Z = !0, Y = 0; Y < z.length && Z; Y++) {
            var C = z[Y];
            if (K(C.val, q) && C.pad >= U && (C.extrapad || !V)) {
              Z = !1;
              break;
            } else K(q, C.val) && C.pad <= U && (V || !C.extrapad) && (z.splice(Y, 1), Y--);
          }
          if (Z) {
            var j = te && q === 0;
            z.push({ val: q, pad: j ? 0 : U, extrapad: j ? !1 : V });
          }
        }
        function _(z) {
          return e(z) && Math.abs(z) < i;
        }
        function T(z, q) {
          return z <= q;
        }
        function R(z, q) {
          return z >= q;
        }
        function I(z, q) {
          var U = q.autorangeoptions;
          return U && U.minallowed !== void 0 && M(q, U.minallowed, U.maxallowed) ? U.minallowed : U && U.clipmin !== void 0 && M(q, U.clipmin, U.clipmax) ? Math.max(z, q.d2l(U.clipmin)) : z;
        }
        function P(z, q) {
          var U = q.autorangeoptions;
          return U && U.maxallowed !== void 0 && M(q, U.minallowed, U.maxallowed) ? U.maxallowed : U && U.clipmax !== void 0 && M(q, U.clipmin, U.clipmax) ? Math.min(z, q.d2l(U.clipmax)) : z;
        }
        function M(z, q, U) {
          return q !== void 0 && U !== void 0 ? (q = z.d2l(q), U = z.d2l(U), q < U) : !0;
        }
        function B(z, q) {
          if (!q || !q.autorangeoptions) return z;
          var U = z[0], G = z[1], K = q.autorangeoptions.include;
          if (K !== void 0) {
            var te = q.d2l(U), V = q.d2l(G);
            a.isArrayOrTypedArray(K) || (K = [K]);
            for (var Z = 0; Z < K.length; Z++) {
              var Y = q.d2l(K[Z]);
              te >= Y && (te = Y, U = Y), V <= Y && (V = Y, G = Y);
            }
          }
          return U = I(U, q), G = P(G, q), [U, G];
        }
      }), Ar = xe((L, k) => {
        var n = vr(), e = xr(), a = on(), i = or(), o = wt(), r = o.strTranslate, s = xn(), c = ti(), t = fr(), p = Or(), l = Xn(), f = as(), v = Yr(), g = v.ONEMAXYEAR, x = v.ONEAVGYEAR, h = v.ONEMINYEAR, m = v.ONEMAXQUARTER, u = v.ONEAVGQUARTER, d = v.ONEMINQUARTER, y = v.ONEMAXMONTH, _ = v.ONEAVGMONTH, T = v.ONEMINMONTH, R = v.ONEWEEK, I = v.ONEDAY, P = I / 2, M = v.ONEHOUR, B = v.ONEMIN, z = v.ONESEC, q = v.ONEMILLI, U = v.ONEMICROSEC, G = v.MINUS_SIGN, K = v.BADNUM, te = { K: "zeroline" }, V = { K: "gridline", L: "path" }, Z = { K: "minor-gridline", L: "path" }, Y = { K: "tick", L: "path" }, C = { K: "tick", L: "text" }, j = { width: ["x", "r", "l", "xl", "xr"], height: ["y", "t", "b", "yt", "yb"], right: ["r", "xr"], left: ["l", "xl"], top: ["t", "yt"], bottom: ["b", "yb"] }, J = kn(), ne = J.MID_SHIFT, ae = J.CAP_SHIFT, se = J.LINE_SPACING, O = J.OPPOSITE_SIDE, F = 3, S = k.exports = {};
        S.setConvert = ri();
        var $ = wo(), re = sn(), E = re.idSort, w = re.isLinked;
        S.id2name = re.id2name, S.name2id = re.name2id, S.cleanId = re.cleanId, S.list = re.list, S.listIds = re.listIds, S.getFromId = re.getFromId, S.getFromTrace = re.getFromTrace;
        var N = ki();
        S.getAutoRange = N.getAutoRange, S.findExtremes = N.findExtremes;
        var W = 1e-4;
        function ee(he) {
          var fe = (he[1] - he[0]) * W;
          return [he[0] - fe, he[1] + fe];
        }
        S.coerceRef = function(he, fe, Pe, Re, Ye, Ee) {
          var ze = Re.charAt(Re.length - 1), Ge = Pe._fullLayout._subplots[ze + "axis"], Ve = Re + "ref", tt = {};
          return Ye || (Ye = Ge[0] || (typeof Ee == "string" ? Ee : Ee[0])), Ee || (Ee = Ye), Ge = Ge.concat(Ge.map(function(at) {
            return at + " domain";
          })), tt[Ve] = { valType: "enumerated", values: Ge.concat(Ee ? typeof Ee == "string" ? [Ee] : Ee : []), dflt: Ye }, o.coerce(he, fe, tt, Ve);
        }, S.getRefType = function(he) {
          return he === void 0 ? he : he === "paper" ? "paper" : he === "pixel" ? "pixel" : /( domain)$/.test(he) ? "domain" : "range";
        }, S.coercePosition = function(he, fe, Pe, Re, Ye, Ee) {
          var ze, Ge, Ve = S.getRefType(Re);
          if (Ve !== "range") ze = o.ensureNumber, Ge = Pe(Ye, Ee);
          else {
            var tt = S.getFromId(fe, Re);
            Ee = tt.fraction2r(Ee), Ge = Pe(Ye, Ee), ze = tt.cleanPos;
          }
          he[Ye] = ze(Ge);
        }, S.cleanPosition = function(he, fe, Pe) {
          var Re = Pe === "paper" || Pe === "pixel" ? o.ensureNumber : S.getFromId(fe, Pe).cleanPos;
          return Re(he);
        }, S.redrawComponents = function(he, fe) {
          fe = fe || S.listIds(he);
          var Pe = he._fullLayout;
          function Re(Ye, Ee, ze, Ge) {
            for (var Ve = i.getComponentMethod(Ye, Ee), tt = {}, at = 0; at < fe.length; at++) for (var vt = Pe[S.id2name(fe[at])], kt = vt[ze], At = 0; At < kt.length; At++) {
              var Nt = kt[At];
              if (!tt[Nt] && (Ve(he, Nt), tt[Nt] = 1, Ge)) return;
            }
          }
          Re("annotations", "drawOne", "_annIndices"), Re("shapes", "drawOne", "_shapeIndices"), Re("images", "draw", "_imgIndices", !0), Re("selections", "drawOne", "_selectionIndices");
        };
        var le = S.getDataConversions = function(he, fe, Pe, Re) {
          var Ye, Ee = Pe === "x" || Pe === "y" || Pe === "z" ? Pe : Re;
          if (o.isArrayOrTypedArray(Ee)) {
            if (Ye = { type: $(Re, void 0, { autotypenumbers: he._fullLayout.autotypenumbers }), _categories: [] }, S.setConvert(Ye), Ye.type === "category") for (var ze = 0; ze < Re.length; ze++) Ye.d2c(Re[ze]);
          } else Ye = S.getFromTrace(he, fe, Ee);
          return Ye ? { d2c: Ye.d2c, c2d: Ye.c2d } : Ee === "ids" ? { d2c: pe, c2d: pe } : { d2c: ie, c2d: ie };
        };
        function ie(he) {
          return +he;
        }
        function pe(he) {
          return String(he);
        }
        S.getDataToCoordFunc = function(he, fe, Pe, Re) {
          return le(he, fe, Pe, Re).d2c;
        }, S.counterLetter = function(he) {
          var fe = he.charAt(0);
          if (fe === "x") return "y";
          if (fe === "y") return "x";
        }, S.minDtick = function(he, fe, Pe, Re) {
          ["log", "category", "multicategory"].indexOf(he.type) !== -1 || !Re ? he._minDtick = 0 : he._minDtick === void 0 ? (he._minDtick = fe, he._forceTick0 = Pe) : he._minDtick && ((he._minDtick / fe + 1e-6) % 1 < 2e-6 && ((Pe - he._forceTick0) / fe % 1 + 1.000001) % 1 < 2e-6 ? (he._minDtick = fe, he._forceTick0 = Pe) : ((fe / he._minDtick + 1e-6) % 1 > 2e-6 || ((Pe - he._forceTick0) / he._minDtick % 1 + 1.000001) % 1 > 2e-6) && (he._minDtick = 0));
        }, S.saveRangeInitial = function(he, fe) {
          for (var Pe = S.list(he, "", !0), Re = !1, Ye = 0; Ye < Pe.length; Ye++) {
            var Ee = Pe[Ye], ze = Ee._rangeInitial0 === void 0 && Ee._rangeInitial1 === void 0, Ge = ze || Ee.range[0] !== Ee._rangeInitial0 || Ee.range[1] !== Ee._rangeInitial1, Ve = Ee.autorange;
            (ze && Ve !== !0 || fe && Ge) && (Ee._rangeInitial0 = Ve === "min" || Ve === "max reversed" ? void 0 : Ee.range[0], Ee._rangeInitial1 = Ve === "max" || Ve === "min reversed" ? void 0 : Ee.range[1], Ee._autorangeInitial = Ve, Re = !0);
          }
          return Re;
        }, S.saveShowSpikeInitial = function(he, fe) {
          for (var Pe = S.list(he, "", !0), Re = !1, Ye = "on", Ee = 0; Ee < Pe.length; Ee++) {
            var ze = Pe[Ee], Ge = ze._showSpikeInitial === void 0, Ve = Ge || ze.showspikes !== ze._showspikes;
            (Ge || fe && Ve) && (ze._showSpikeInitial = ze.showspikes, Re = !0), Ye === "on" && !ze.showspikes && (Ye = "off");
          }
          return he._fullLayout._cartesianSpikesEnabled = Ye, Re;
        }, S.autoBin = function(he, fe, Pe, Re, Ye, Ee) {
          var ze = o.aggNums(Math.min, null, he), Ge = o.aggNums(Math.max, null, he);
          if (fe.type === "category" || fe.type === "multicategory") return { start: ze - 0.5, end: Ge + 0.5, size: Math.max(1, Math.round(Ee) || 1), _dataSpan: Ge - ze };
          Ye || (Ye = fe.calendar);
          var Ve;
          if (fe.type === "log" ? Ve = { type: "linear", range: [ze, Ge] } : Ve = { type: fe.type, range: o.simpleMap([ze, Ge], fe.c2r, 0, Ye), calendar: Ye }, S.setConvert(Ve), Ee = Ee && f.dtick(Ee, Ve.type), Ee) Ve.dtick = Ee, Ve.tick0 = f.tick0(void 0, Ve.type, Ye);
          else {
            var tt;
            if (Pe) tt = (Ge - ze) / Pe;
            else {
              var at = o.distinctVals(he), vt = Math.pow(10, Math.floor(Math.log(at.minDiff) / Math.LN10)), kt = vt * o.roundUp(at.minDiff / vt, [0.9, 1.9, 4.9, 9.9], !0);
              tt = Math.max(kt, 2 * o.stdev(he) / Math.pow(he.length, Re ? 0.25 : 0.4)), e(tt) || (tt = 1);
            }
            S.autoTicks(Ve, tt);
          }
          var At = Ve.dtick, Nt = S.tickIncrement(S.tickFirst(Ve), At, "reverse", Ye), Mt, Pt;
          if (typeof At == "number") Nt = _e(Nt, he, Ve, ze, Ge), Pt = 1 + Math.floor((Ge - Nt) / At), Mt = Nt + Pt * At;
          else for (Ve.dtick.charAt(0) === "M" && (Nt = Ae(Nt, he, At, ze, Ye)), Mt = Nt, Pt = 0; Mt <= Ge; ) Mt = S.tickIncrement(Mt, At, !1, Ye), Pt++;
          return { start: fe.c2r(Nt, 0, Ye), end: fe.c2r(Mt, 0, Ye), size: At, _dataSpan: Ge - ze };
        };
        function _e(he, fe, Pe, Re, Ye) {
          var Ee = 0, ze = 0, Ge = 0, Ve = 0;
          function tt(At) {
            return (1 + (At - he) * 100 / Pe.dtick) % 100 < 2;
          }
          for (var at = 0; at < fe.length; at++) fe[at] % 1 === 0 ? Ge++ : e(fe[at]) || Ve++, tt(fe[at]) && Ee++, tt(fe[at] + Pe.dtick / 2) && ze++;
          var vt = fe.length - Ve;
          if (Ge === vt && Pe.type !== "date") Pe.dtick < 1 ? he = Re - 0.5 * Pe.dtick : (he -= 0.5, he + Pe.dtick < Re && (he += Pe.dtick));
          else if (ze < vt * 0.1 && (Ee > vt * 0.3 || tt(Re) || tt(Ye))) {
            var kt = Pe.dtick / 2;
            he += he + kt < Re ? kt : -kt;
          }
          return he;
        }
        function Ae(he, fe, Pe, Re, Ye) {
          var Ee = o.findExactDates(fe, Ye), ze = 0.8;
          if (Ee.exactDays > ze) {
            var Ge = Number(Pe.substr(1));
            Ee.exactYears > ze && Ge % 12 === 0 ? he = S.tickIncrement(he, "M6", "reverse") + I * 1.5 : Ee.exactMonths > ze ? he = S.tickIncrement(he, "M1", "reverse") + I * 15.5 : he -= P;
            var Ve = S.tickIncrement(he, Pe);
            if (Ve <= Re) return Ve;
          }
          return he;
        }
        S.prepMinorTicks = function(he, fe, Pe) {
          if (!fe.minor.dtick) {
            delete he.dtick;
            var Re = fe.dtick && e(fe._tmin), Ye;
            if (Re) {
              var Ee = S.tickIncrement(fe._tmin, fe.dtick, !0);
              Ye = [fe._tmin, Ee * 0.99 + fe._tmin * 0.01];
            } else {
              var ze = o.simpleMap(fe.range, fe.r2l);
              Ye = [ze[0], 0.8 * ze[0] + 0.2 * ze[1]];
            }
            if (he.range = o.simpleMap(Ye, fe.l2r), he._isMinor = !0, S.prepTicks(he, Pe), Re) {
              var Ge = e(fe.dtick), Ve = e(he.dtick), tt = Ge ? fe.dtick : +fe.dtick.substring(1), at = Ve ? he.dtick : +he.dtick.substring(1);
              Ge && Ve ? Ce(tt, at) ? tt === 2 * R && at === 2 * I && (he.dtick = R) : tt === 2 * R && at === 3 * I ? he.dtick = R : tt === R && !(fe._input.minor || {}).nticks ? he.dtick = I : Ue(tt / at, 2.5) ? he.dtick = tt / 2 : he.dtick = tt : String(fe.dtick).charAt(0) === "M" ? Ve ? he.dtick = "M1" : Ce(tt, at) ? tt >= 12 && at === 2 && (he.dtick = "M3") : he.dtick = fe.dtick : String(he.dtick).charAt(0) === "L" ? String(fe.dtick).charAt(0) === "L" ? Ce(tt, at) || (he.dtick = Ue(tt / at, 2.5) ? fe.dtick / 2 : fe.dtick) : he.dtick = "D1" : he.dtick === "D2" && +fe.dtick > 1 && (he.dtick = 1);
            }
            he.range = fe.range;
          }
          fe.minor._tick0Init === void 0 && (he.tick0 = fe.tick0);
        };
        function Ce(he, fe) {
          return Math.abs((he / fe + 0.5) % 1 - 0.5) < 1e-3;
        }
        function Ue(he, fe) {
          return Math.abs(he / fe - 1) < 1e-3;
        }
        S.prepTicks = function(he, fe) {
          var Pe = o.simpleMap(he.range, he.r2l, void 0, void 0, fe);
          if (he.tickmode === "auto" || !he.dtick) {
            var Re = he.nticks, Ye;
            Re || (he.type === "category" || he.type === "multicategory" ? (Ye = he.tickfont ? o.bigFont(he.tickfont.size || 12) : 15, Re = he._length / Ye) : (Ye = he._id.charAt(0) === "y" ? 40 : 80, Re = o.constrain(he._length / Ye, 4, 9) + 1), he._name === "radialaxis" && (Re *= 2)), he.minor && he.minor.tickmode !== "array" || he.tickmode === "array" && (Re *= 100), he._roughDTick = Math.abs(Pe[1] - Pe[0]) / Re, S.autoTicks(he, he._roughDTick), he._minDtick > 0 && he.dtick < he._minDtick * 2 && (he.dtick = he._minDtick, he.tick0 = he.l2r(he._forceTick0));
          }
          he.ticklabelmode === "period" && ke(he), he.tick0 || (he.tick0 = he.type === "date" ? "2000-01-01" : 0), he.type === "date" && he.dtick < 0.1 && (he.dtick = 0.1), Ke(he);
        };
        function Ne(he) {
          return +he.substring(1);
        }
        function ke(he) {
          var fe;
          function Pe() {
            return !(e(he.dtick) || he.dtick.charAt(0) !== "M");
          }
          var Re = Pe(), Ye = S.getTickFormat(he);
          if (Ye) {
            var Ee = he._dtickInit !== he.dtick;
            /%[fLQsSMX]/.test(Ye) || (/%[HI]/.test(Ye) ? (fe = M, Ee && !Re && he.dtick < M && (he.dtick = M)) : /%p/.test(Ye) ? (fe = P, Ee && !Re && he.dtick < P && (he.dtick = P)) : /%[Aadejuwx]/.test(Ye) ? (fe = I, Ee && !Re && he.dtick < I && (he.dtick = I)) : /%[UVW]/.test(Ye) ? (fe = R, Ee && !Re && he.dtick < R && (he.dtick = R)) : /%[Bbm]/.test(Ye) ? (fe = _, Ee && (Re ? Ne(he.dtick) < 1 : he.dtick < T) && (he.dtick = "M1")) : /%[q]/.test(Ye) ? (fe = u, Ee && (Re ? Ne(he.dtick) < 3 : he.dtick < d) && (he.dtick = "M3")) : /%[Yy]/.test(Ye) && (fe = x, Ee && (Re ? Ne(he.dtick) < 12 : he.dtick < h) && (he.dtick = "M12")));
          }
          Re = Pe(), Re && he.tick0 === he._dowTick0 && (he.tick0 = he._rawTick0), he._definedDelta = fe;
        }
        function A(he, fe, Pe) {
          for (var Re = 0; Re < he.length; Re++) {
            var Ye = he[Re].value, Ee = Re, ze = Re + 1;
            Re < he.length - 1 ? (Ee = Re, ze = Re + 1) : Re > 0 ? (Ee = Re - 1, ze = Re) : (Ee = Re, ze = Re);
            var Ge = he[Ee].value, Ve = he[ze].value, tt = Math.abs(Ve - Ge), at = Pe || tt, vt = 0;
            at >= h ? tt >= h && tt <= g ? vt = tt : vt = x : Pe === u && at >= d ? tt >= d && tt <= m ? vt = tt : vt = u : at >= T ? tt >= T && tt <= y ? vt = tt : vt = _ : Pe === R && at >= R ? vt = R : at >= I ? vt = I : Pe === P && at >= P ? vt = P : Pe === M && at >= M && (vt = M);
            var kt;
            vt >= tt && (vt = tt, kt = !0);
            var At = Ye + vt;
            if (fe.rangebreaks && vt > 0) {
              for (var Nt = 84, Mt = 0, Pt = 0; Pt < Nt; Pt++) {
                var Lt = (Pt + 0.5) / Nt;
                fe.maskBreaks(Ye * (1 - Lt) + Lt * At) !== K && Mt++;
              }
              vt *= Mt / Nt, vt || (he[Re].drop = !0), kt && tt > R && (vt = tt);
            }
            (vt > 0 || Re === 0) && (he[Re].periodX = Ye + vt / 2);
          }
        }
        S.calcTicks = function(he, fe) {
          for (var Pe = he.type, Re = he.calendar, Ye = he.ticklabelstep, Ee = he.ticklabelmode === "period", ze = he.range[0] > he.range[1], Ge = !he.ticklabelindex || o.isArrayOrTypedArray(he.ticklabelindex) ? he.ticklabelindex : [he.ticklabelindex], Ve = o.simpleMap(he.range, he.r2l, void 0, void 0, fe), tt = Ve[1] < Ve[0], at = Math.min(Ve[0], Ve[1]), vt = Math.max(Ve[0], Ve[1]), kt = Math.max(1e3, he._length || 0), At = [], Nt = [], Mt = [], Pt = [], Lt = [], ur = he.minor && (he.minor.ticks || he.minor.showgrid), Ht = 1; Ht >= (ur ? 0 : 1); Ht--) {
            var mr = !Ht;
            Ht ? (he._dtickInit = he.dtick, he._tick0Init = he.tick0) : (he.minor._dtickInit = he.minor.dtick, he.minor._tick0Init = he.minor.tick0);
            var ar = Ht ? he : o.extendFlat({}, he, he.minor);
            if (mr ? S.prepMinorTicks(ar, he, fe) : S.prepTicks(ar, fe), ar.tickmode === "array") {
              Ht ? (Mt = [], At = ve(he, !mr)) : (Pt = [], Nt = ve(he, !mr));
              continue;
            }
            if (ar.tickmode === "sync") {
              Mt = [], At = H(he);
              continue;
            }
            var kr = ee(Ve), _r = kr[0], Cr = kr[1], Yt = e(ar.dtick), Sr = Pe === "log" && !(Yt || ar.dtick.charAt(0) === "L"), Tr = S.tickFirst(ar, fe);
            if (Ht) {
              if (he._tmin = Tr, Tr < _r !== tt) break;
              (Pe === "category" || Pe === "multicategory") && (Cr = tt ? Math.max(-0.5, Cr) : Math.min(he._categories.length - 0.5, Cr));
            }
            var Gr = null, dr = Tr, Ir;
            if (Ht) {
              var Er;
              Yt ? Er = he.dtick : Pe === "date" ? typeof he.dtick == "string" && he.dtick.charAt(0) === "M" && (Er = _ * he.dtick.substring(1)) : Er = he._roughDTick, Ir = Math.round((he.r2l(dr) - he.r2l(he.tick0)) / Er) - 1;
            }
            var Zr = ar.dtick;
            for (ar.rangebreaks && ar._tick0Init !== ar.tick0 && (dr = lr(dr, he), tt || (dr = S.tickIncrement(dr, Zr, !tt, Re))), Ht && Ee && (dr = S.tickIncrement(dr, Zr, !tt, Re), Ir--); tt ? dr >= Cr : dr <= Cr; dr = S.tickIncrement(dr, Zr, tt, Re)) {
              if (Ht && Ir++, ar.rangebreaks && !tt) {
                if (dr < _r) continue;
                if (ar.maskBreaks(dr) === K && lr(dr, ar) >= vt) break;
              }
              if (Mt.length > kt || dr === Gr) break;
              Gr = dr;
              var ln = { value: dr };
              Ht ? (Sr && dr !== (dr | 0) && (ln.simpleLabel = !0), Ye > 1 && Ir % Ye && (ln.skipLabel = !0), Mt.push(ln)) : (ln.minor = !0, Pt.push(ln));
            }
          }
          if (!Pt || Pt.length < 2) Ge = !1;
          else {
            var un = (Pt[1].value - Pt[0].value) * (ze ? -1 : 1);
            hr(un, he.tickformat) || (Ge = !1);
          }
          if (!Ge) Lt = Mt;
          else {
            var br = Mt.concat(Pt);
            Ee && Mt.length && (br = br.slice(1)), br = br.sort(function(Pr, Vr) {
              return Pr.value - Vr.value;
            }).filter(function(Pr, Vr, Kr) {
              return Vr === 0 || Pr.value !== Kr[Vr - 1].value;
            });
            var Dr = br.map(function(Pr, Vr) {
              return Pr.minor === void 0 && !Pr.skipLabel ? Vr : null;
            }).filter(function(Pr) {
              return Pr !== null;
            });
            Dr.forEach(function(Pr) {
              Ge.map(function(Vr) {
                var Kr = Pr + Vr;
                Kr >= 0 && Kr < br.length && o.pushUnique(Lt, br[Kr]);
              });
            });
          }
          if (ur) {
            var Mr = he.minor.ticks === "inside" && he.ticks === "outside" || he.minor.ticks === "outside" && he.ticks === "inside";
            if (!Mr) {
              for (var Hr = Mt.map(function(Pr) {
                return Pr.value;
              }), Ur = [], Wr = 0; Wr < Pt.length; Wr++) {
                var en = Pt[Wr], Xr = en.value;
                if (Hr.indexOf(Xr) === -1) {
                  for (var cn = !1, Jr = 0; !cn && Jr < Mt.length; Jr++) 1e7 + Mt[Jr].value === 1e7 + Xr && (cn = !0);
                  cn || Ur.push(en);
                }
              }
              Pt = Ur;
            }
          }
          Ee && A(Lt, he, he._definedDelta);
          var Lr;
          if (he.rangebreaks) {
            var Sn = he._id.charAt(0) === "y", tn = 1;
            he.tickmode === "auto" && (tn = he.tickfont ? he.tickfont.size : 12);
            var vn = NaN;
            for (Lr = Mt.length - 1; Lr > -1; Lr--) {
              if (Mt[Lr].drop) {
                Mt.splice(Lr, 1);
                continue;
              }
              Mt[Lr].value = lr(Mt[Lr].value, he);
              var fn = he.c2p(Mt[Lr].value);
              (Sn ? vn > fn - tn : vn < fn + tn) ? Mt.splice(tt ? Lr + 1 : Lr, 1) : vn = fn;
            }
          }
          cr(he) && Math.abs(Ve[1] - Ve[0]) === 360 && Mt.pop(), he._tmax = (Mt[Mt.length - 1] || {}).value, he._prevDateHead = "", he._inCalcTicks = !0;
          var rn, In = function(Pr) {
            Pr.text = "", he._prevDateHead = rn;
          };
          Mt = Mt.concat(Pt);
          function wn(Pr, Vr) {
            var Kr = S.tickText(Pr, Vr.value, !1, Vr.simpleLabel), gn = Vr.periodX;
            return gn !== void 0 && (Kr.periodX = gn, (gn > vt || gn < at) && (gn > vt && (Kr.periodX = vt), gn < at && (Kr.periodX = at), In(Kr))), Kr;
          }
          var nn;
          for (Lr = 0; Lr < Mt.length; Lr++) {
            var En = Mt[Lr].minor, jn = Mt[Lr].value;
            En ? (Ge && Lt.indexOf(Mt[Lr]) !== -1 ? nn = wn(he, Mt[Lr]) : nn = { x: jn }, nn.minor = !0, Nt.push(nn)) : (rn = he._prevDateHead, nn = wn(he, Mt[Lr]), (Mt[Lr].skipLabel || Ge && Lt.indexOf(Mt[Lr]) === -1) && In(nn), At.push(nn));
          }
          return At = At.concat(Nt), he._inCalcTicks = !1, Ee && At.length && (At[0].noTick = !0), At;
        };
        function X(he, fe) {
          return he.rangebreaks && (fe = fe.filter(function(Pe) {
            return he.maskBreaks(Pe.x) !== K;
          })), fe;
        }
        function H(he) {
          var fe = he._mainAxis, Pe = [];
          if (fe._vals) {
            for (var Re = 0; Re < fe._vals.length; Re++) if (!fe._vals[Re].noTick) {
              var Ye = fe.l2p(fe._vals[Re].x), Ee = he.p2l(Ye), ze = S.tickText(he, Ee);
              fe._vals[Re].minor && (ze.minor = !0, ze.text = ""), Pe.push(ze);
            }
          }
          return Pe = X(he, Pe), Pe;
        }
        function ve(he, fe) {
          var Pe = o.simpleMap(he.range, he.r2l), Re = ee(Pe), Ye = Math.min(Re[0], Re[1]), Ee = Math.max(Re[0], Re[1]), ze = he.type === "category" ? he.d2l_noadd : he.d2l;
          he.type === "log" && String(he.dtick).charAt(0) !== "L" && (he.dtick = "L" + Math.pow(10, Math.floor(Math.min(he.range[0], he.range[1])) - 1));
          for (var Ge = [], Ve = 0; Ve <= 1; Ve++) if (!(fe !== void 0 && (fe && Ve || fe === !1 && !Ve)) && !(Ve && !he.minor)) {
            var tt = Ve ? he.minor.tickvals : he.tickvals, at = Ve ? [] : he.ticktext;
            if (tt) {
              o.isArrayOrTypedArray(at) || (at = []);
              for (var vt = 0; vt < tt.length; vt++) {
                var kt = ze(tt[vt]);
                if (kt > Ye && kt < Ee) {
                  var At = S.tickText(he, kt, !1, String(at[vt]));
                  Ve && (At.minor = !0, At.text = ""), Ge.push(At);
                }
              }
            }
          }
          return Ge = X(he, Ge), Ge;
        }
        var be = [2, 5, 10], Se = [1, 2, 3, 6, 12], De = [1, 2, 5, 10, 15, 30], He = [1, 2, 3, 7, 14], Ze = [-0.046, 0, 0.301, 0.477, 0.602, 0.699, 0.778, 0.845, 0.903, 0.954, 1], We = [-0.301, 0, 0.301, 0.699, 1], $e = [15, 30, 45, 90, 180];
        function it(he, fe, Pe) {
          return fe * o.roundUp(he / fe, Pe);
        }
        S.autoTicks = function(he, fe, Pe) {
          var Re;
          function Ye(vt) {
            return Math.pow(vt, Math.floor(Math.log(fe) / Math.LN10));
          }
          if (he.type === "date") {
            he.tick0 = o.dateTick0(he.calendar, 0);
            var Ee = 2 * fe;
            if (Ee > x) fe /= x, Re = Ye(10), he.dtick = "M" + 12 * it(fe, Re, be);
            else if (Ee > _) fe /= _, he.dtick = "M" + it(fe, 1, Se);
            else if (Ee > I) {
              if (he.dtick = it(fe, I, he._hasDayOfWeekBreaks ? [1, 2, 7, 14] : He), !Pe) {
                var ze = S.getTickFormat(he), Ge = he.ticklabelmode === "period";
                Ge && (he._rawTick0 = he.tick0), /%[uVW]/.test(ze) ? he.tick0 = o.dateTick0(he.calendar, 2) : he.tick0 = o.dateTick0(he.calendar, 1), Ge && (he._dowTick0 = he.tick0);
              }
            } else Ee > M ? he.dtick = it(fe, M, Se) : Ee > B ? he.dtick = it(fe, B, De) : Ee > z ? he.dtick = it(fe, z, De) : (Re = Ye(10), he.dtick = it(fe, Re, be));
          } else if (he.type === "log") {
            he.tick0 = 0;
            var Ve = o.simpleMap(he.range, he.r2l);
            if (he._isMinor && (fe *= 1.5), fe > 0.7) he.dtick = Math.ceil(fe);
            else if (Math.abs(Ve[1] - Ve[0]) < 1) {
              var tt = 1.5 * Math.abs((Ve[1] - Ve[0]) / fe);
              fe = Math.abs(Math.pow(10, Ve[1]) - Math.pow(10, Ve[0])) / tt, Re = Ye(10), he.dtick = "L" + it(fe, Re, be);
            } else he.dtick = fe > 0.3 ? "D2" : "D1";
          } else he.type === "category" || he.type === "multicategory" ? (he.tick0 = 0, he.dtick = Math.ceil(Math.max(fe, 1))) : cr(he) ? (he.tick0 = 0, Re = 1, he.dtick = it(fe, Re, $e)) : (he.tick0 = 0, Re = Ye(10), he.dtick = it(fe, Re, be));
          if (he.dtick === 0 && (he.dtick = 1), !e(he.dtick) && typeof he.dtick != "string") {
            var at = he.dtick;
            throw he.dtick = 1, "ax.dtick error: " + String(at);
          }
        };
        function Ke(he) {
          var fe = he.dtick;
          if (he._tickexponent = 0, !e(fe) && typeof fe != "string" && (fe = 1), (he.type === "category" || he.type === "multicategory") && (he._tickround = null), he.type === "date") {
            var Pe = he.r2l(he.tick0), Re = he.l2r(Pe).replace(/(^-|i)/g, ""), Ye = Re.length;
            if (String(fe).charAt(0) === "M") Ye > 10 || Re.substr(5) !== "01-01" ? he._tickround = "d" : he._tickround = +fe.substr(1) % 12 === 0 ? "y" : "m";
            else if (fe >= I && Ye <= 10 || fe >= I * 15) he._tickround = "d";
            else if (fe >= B && Ye <= 16 || fe >= M) he._tickround = "M";
            else if (fe >= z && Ye <= 19 || fe >= B) he._tickround = "S";
            else {
              var Ee = he.l2r(Pe + fe).replace(/^-/, "").length;
              he._tickround = Math.max(Ye, Ee) - 20, he._tickround < 0 && (he._tickround = 4);
            }
          } else if (e(fe) || fe.charAt(0) === "L") {
            var ze = he.range.map(he.r2d || Number);
            e(fe) || (fe = Number(fe.substr(1))), he._tickround = 2 - Math.floor(Math.log(fe) / Math.LN10 + 0.01);
            var Ge = Math.max(Math.abs(ze[0]), Math.abs(ze[1])), Ve = Math.floor(Math.log(Ge) / Math.LN10 + 0.01), tt = he.minexponent === void 0 ? 3 : he.minexponent;
            Math.abs(Ve) > tt && (Oe(he.exponentformat) && he.exponentformat !== "SI extended" && !je(Ve) || Oe(he.exponentformat) && he.exponentformat === "SI extended" && !qe(Ve) ? he._tickexponent = 3 * Math.round((Ve - 1) / 3) : he._tickexponent = Ve);
          } else he._tickround = null;
        }
        S.tickIncrement = function(he, fe, Pe, Re) {
          var Ye = Pe ? -1 : 1;
          if (e(fe)) return o.increment(he, Ye * fe);
          var Ee = fe.charAt(0), ze = Ye * Number(fe.substr(1));
          if (Ee === "M") return o.incrementMonth(he, ze, Re);
          if (Ee === "L") return Math.log(Math.pow(10, he) + ze) / Math.LN10;
          if (Ee === "D") {
            var Ge = fe === "D2" ? We : Ze, Ve = he + Ye * 0.01, tt = o.roundUp(o.mod(Ve, 1), Ge, Pe);
            return Math.floor(Ve) + Math.log(n.round(Math.pow(10, tt), 1)) / Math.LN10;
          }
          throw "unrecognized dtick " + String(fe);
        }, S.tickFirst = function(he, fe) {
          var Pe = he.r2l || Number, Re = o.simpleMap(he.range, Pe, void 0, void 0, fe), Ye = Re[1] < Re[0], Ee = Ye ? Math.floor : Math.ceil, ze = ee(Re)[0], Ge = he.dtick, Ve = Pe(he.tick0);
          if (e(Ge)) {
            var tt = Ee((ze - Ve) / Ge) * Ge + Ve;
            return (he.type === "category" || he.type === "multicategory") && (tt = o.constrain(tt, 0, he._categories.length - 1)), tt;
          }
          var at = Ge.charAt(0), vt = Number(Ge.substr(1));
          if (at === "M") {
            for (var kt = 0, At = Ve, Nt, Mt, Pt; kt < 10; ) {
              if (Nt = S.tickIncrement(At, Ge, Ye, he.calendar), (Nt - ze) * (At - ze) <= 0) return Ye ? Math.min(At, Nt) : Math.max(At, Nt);
              Mt = (ze - (At + Nt) / 2) / (Nt - At), Pt = at + (Math.abs(Math.round(Mt)) || 1) * vt, At = S.tickIncrement(At, Pt, Mt < 0 ? !Ye : Ye, he.calendar), kt++;
            }
            return o.error("tickFirst did not converge", he), At;
          } else {
            if (at === "L") return Math.log(Ee((Math.pow(10, ze) - Ve) / vt) * vt + Ve) / Math.LN10;
            if (at === "D") {
              var Lt = Ge === "D2" ? We : Ze, ur = o.roundUp(o.mod(ze, 1), Lt, Ye);
              return Math.floor(ze) + Math.log(n.round(Math.pow(10, ur), 1)) / Math.LN10;
            } else throw "unrecognized dtick " + String(Ge);
          }
        }, S.tickText = function(he, fe, Pe, Re) {
          var Ye = ct(he, fe), Ee = he.tickmode === "array", ze = Pe || Ee, Ge = he.type, Ve = Ge === "category" ? he.d2l_noadd : he.d2l, tt, at = function(Pt) {
            var Lt = he.l2p(Pt);
            return Lt >= 0 && Lt <= he._length ? Pt : null;
          };
          if (Ee && o.isArrayOrTypedArray(he.ticktext)) {
            var vt = o.simpleMap(he.range, he.r2l), kt = (Math.abs(vt[1] - vt[0]) - (he._lBreaks || 0)) / 1e4;
            for (tt = 0; tt < he.ticktext.length && !(Math.abs(fe - Ve(he.tickvals[tt])) < kt); tt++) ;
            if (tt < he.ticktext.length) return Ye.text = String(he.ticktext[tt]), Ye.xbnd = [at(Ye.x - 0.5), at(Ye.x + he.dtick - 0.5)], Ye;
          }
          function At(Pt) {
            if (Pt === void 0) return !0;
            if (Pe) return Pt === "none";
            var Lt = { first: he._tmin, last: he._tmax }[Pt];
            return Pt !== "all" && fe !== Lt;
          }
          var Nt = Pe ? "never" : he.exponentformat !== "none" && At(he.showexponent) ? "hide" : "";
          if (Ge === "date" ? gt(he, Ye, Pe, ze) : Ge === "log" ? ht(he, Ye, Pe, ze, Nt) : Ge === "category" ? _t(he, Ye) : Ge === "multicategory" ? Te(he, Ye, Pe) : cr(he) ? ce(he, Ye, Pe, ze, Nt) : Ie(he, Ye, Pe, ze, Nt), Re || (he.tickprefix && !At(he.showtickprefix) && (Ye.text = he.tickprefix + Ye.text), he.ticksuffix && !At(he.showticksuffix) && (Ye.text += he.ticksuffix)), he.labelalias && he.labelalias.hasOwnProperty(Ye.text)) {
            var Mt = he.labelalias[Ye.text];
            typeof Mt == "string" && (Ye.text = Mt);
          }
          return (he.tickson === "boundaries" || he.showdividers) && (Ye.xbnd = [at(Ye.x - 0.5), at(Ye.x + he.dtick - 0.5)]), Ye;
        }, S.hoverLabelText = function(he, fe, Pe) {
          Pe && (he = o.extendFlat({}, he, { hoverformat: Pe }));
          var Re = o.isArrayOrTypedArray(fe) ? fe[0] : fe, Ye = o.isArrayOrTypedArray(fe) ? fe[1] : void 0;
          if (Ye !== void 0 && Ye !== Re) return S.hoverLabelText(he, Re, Pe) + " - " + S.hoverLabelText(he, Ye, Pe);
          var Ee = he.type === "log" && Re <= 0, ze = S.tickText(he, he.c2l(Ee ? -Re : Re), "hover").text;
          return Ee ? Re === 0 ? "0" : G + ze : ze;
        };
        function ct(he, fe, Pe) {
          var Re = he.tickfont || {};
          return { x: fe, dx: 0, dy: 0, text: Pe || "", fontSize: Re.size, font: Re.family, fontWeight: Re.weight, fontStyle: Re.style, fontVariant: Re.variant, fontTextcase: Re.textcase, fontLineposition: Re.lineposition, fontShadow: Re.shadow, fontColor: Re.color };
        }
        function gt(he, fe, Pe, Re) {
          var Ye = he._tickround, Ee = Pe && he.hoverformat || S.getTickFormat(he);
          Re = !Ee && Re, Re && (e(Ye) ? Ye = 4 : Ye = { y: "m", m: "d", d: "M", M: "S", S: 4 }[Ye]);
          var ze = o.formatDate(fe.x, Ee, Ye, he._dateFormat, he.calendar, he._extraFormat), Ge, Ve = ze.indexOf(`
`);
          if (Ve !== -1 && (Ge = ze.substr(Ve + 1), ze = ze.substr(0, Ve)), Re && (Ge !== void 0 && (ze === "00:00:00" || ze === "00:00") ? (ze = Ge, Ge = "") : ze.length === 8 && (ze = ze.replace(/:00$/, ""))), Ge) if (Pe) Ye === "d" ? ze += ", " + Ge : ze = Ge + (ze ? ", " + ze : "");
          else if (!he._inCalcTicks || he._prevDateHead !== Ge) he._prevDateHead = Ge, ze += "<br>" + Ge;
          else {
            var tt = $t(he), at = he._trueSide || he.side;
            (!tt && at === "top" || tt && at === "bottom") && (ze += "<br> ");
          }
          fe.text = ze;
        }
        function ht(he, fe, Pe, Re, Ye) {
          var Ee = he.dtick, ze = fe.x, Ge = he.tickformat, Ve = typeof Ee == "string" && Ee.charAt(0);
          if (Ye === "never" && (Ye = ""), Re && Ve !== "L" && (Ee = "L3", Ve = "L"), Ge || Ve === "L") fe.text = Xe(Math.pow(10, ze), he, Ye, Re);
          else if (e(Ee) || Ve === "D" && (he.minorloglabels === "complete" || o.mod(ze + 0.01, 1) < 0.1)) {
            he.minorloglabels === "complete" && !(o.mod(ze + 0.01, 1) < 0.1) && (fe.fontSize *= 0.75);
            var tt = Math.pow(10, ze).toExponential(0), at = tt.split("e"), vt = +at[1], kt = Math.abs(vt), At = he.exponentformat;
            At === "power" || Oe(At) && At !== "SI extended" && je(vt) || Oe(At) && At === "SI extended" && qe(vt) ? (fe.text = at[0], kt > 0 && (fe.text += "x10"), fe.text === "1x10" && (fe.text = "10"), vt !== 0 && vt !== 1 && (fe.text += "<sup>" + (vt > 0 ? "" : G) + kt + "</sup>"), fe.fontSize *= 1.25) : (At === "e" || At === "E") && kt > 2 ? fe.text = at[0] + At + (vt > 0 ? "+" : G) + kt : (fe.text = Xe(Math.pow(10, ze), he, "", "fakehover"), Ee === "D1" && he._id.charAt(0) === "y" && (fe.dy -= fe.fontSize / 6));
          } else if (Ve === "D") fe.text = he.minorloglabels === "none" ? "" : String(Math.round(Math.pow(10, o.mod(ze, 1)))), fe.fontSize *= 0.75;
          else throw "unrecognized dtick " + String(Ee);
          if (he.dtick === "D1") {
            var Nt = String(fe.text).charAt(0);
            (Nt === "0" || Nt === "1") && (he._id.charAt(0) === "y" ? fe.dx -= fe.fontSize / 4 : (fe.dy += fe.fontSize / 2, fe.dx += (he.range[1] > he.range[0] ? 1 : -1) * fe.fontSize * (ze < 0 ? 0.5 : 0.25)));
          }
        }
        function _t(he, fe) {
          var Pe = he._categories[Math.round(fe.x)];
          Pe === void 0 && (Pe = ""), fe.text = String(Pe);
        }
        function Te(he, fe, Pe) {
          var Re = Math.round(fe.x), Ye = he._categories[Re] || [], Ee = Ye[1] === void 0 ? "" : String(Ye[1]), ze = Ye[0] === void 0 ? "" : String(Ye[0]);
          Pe ? fe.text = ze + " - " + Ee : (fe.text = Ee, fe.text2 = ze);
        }
        function Ie(he, fe, Pe, Re, Ye) {
          Ye === "never" ? Ye = "" : he.showexponent === "all" && Math.abs(fe.x / he.dtick) < 1e-6 && (Ye = "hide"), fe.text = Xe(fe.x, he, Ye, Re);
        }
        function ce(he, fe, Pe, Re, Ye) {
          if (he.thetaunit === "radians" && !Pe) {
            var Ee = fe.x / 180;
            if (Ee === 0) fe.text = "0";
            else {
              var ze = ge(Ee);
              if (ze[1] >= 100) fe.text = Xe(o.deg2rad(fe.x), he, Ye, Re);
              else {
                var Ge = fe.x < 0;
                ze[1] === 1 ? ze[0] === 1 ? fe.text = "π" : fe.text = ze[0] + "π" : fe.text = ["<sup>", ze[0], "</sup>", "⁄", "<sub>", ze[1], "</sub>", "π"].join(""), Ge && (fe.text = G + fe.text);
              }
            }
          } else fe.text = Xe(fe.x, he, Ye, Re);
        }
        function ge(he) {
          function fe(Ge, Ve) {
            return Math.abs(Ge - Ve) <= 1e-6;
          }
          function Pe(Ge, Ve) {
            return fe(Ve, 0) ? Ge : Pe(Ve, Ge % Ve);
          }
          function Re(Ge) {
            for (var Ve = 1; !fe(Math.round(Ge * Ve) / Ve, Ge); ) Ve *= 10;
            return Ve;
          }
          var Ye = Re(he), Ee = he * Ye, ze = Math.abs(Pe(Ee, Ye));
          return [Math.round(Ee / ze), Math.round(Ye / ze)];
        }
        var ye = ["f", "p", "n", "μ", "m", "", "k", "M", "G", "T"], Me = ["q", "r", "y", "z", "a", ...ye, "P", "E", "Z", "Y", "R", "Q"], Oe = (he) => ["SI", "SI extended", "B"].includes(he);
        function je(he) {
          return he > 14 || he < -15;
        }
        function qe(he) {
          return he > 32 || he < -30;
        }
        function Qe(he, fe) {
          return Oe(fe) ? !!(fe === "SI extended" && qe(he) || fe !== "SI extended" && je(he)) : !1;
        }
        function Xe(he, fe, Pe, Re) {
          var Ye = he < 0, Ee = fe._tickround, ze = Pe || fe.exponentformat || "B", Ge = fe._tickexponent, Ve = S.getTickFormat(fe), tt = fe.separatethousands;
          if (Re) {
            var at = { exponentformat: ze, minexponent: fe.minexponent, dtick: fe.showexponent === "none" ? fe.dtick : e(he) && Math.abs(he) || 1, range: fe.showexponent === "none" ? fe.range.map(fe.r2d) : [0, he || 1] };
            Ke(at), Ee = (Number(at._tickround) || 0) + 4, Ge = at._tickexponent, fe.hoverformat && (Ve = fe.hoverformat);
          }
          if (Ve) return fe._numFormat(Ve)(he).replace(/-/g, G);
          var vt = Math.pow(10, -Ee) / 2;
          if (ze === "none" && (Ge = 0), he = Math.abs(he), he < vt) he = "0", Ye = !1;
          else {
            if (he += vt, Ge && (he *= Math.pow(10, -Ge), Ee += Ge), Ee === 0) he = String(Math.floor(he));
            else if (Ee < 0) {
              he = String(Math.round(he)), he = he.substr(0, he.length + Ee);
              for (var kt = Ee; kt < 0; kt++) he += "0";
            } else {
              he = String(he);
              var At = he.indexOf(".") + 1;
              At && (he = he.substr(0, At + Ee).replace(/\.?0+$/, ""));
            }
            he = o.numSeparate(he, fe._separators, tt);
          }
          if (Ge && ze !== "hide") {
            Qe(Ge, ze) && (ze = "power");
            var Nt;
            Ge < 0 ? Nt = G + -Ge : ze !== "power" ? Nt = "+" + Ge : Nt = String(Ge), ze === "e" || ze === "E" ? he += ze + Nt : ze === "power" ? he += "×10<sup>" + Nt + "</sup>" : ze === "B" && Ge === 9 ? he += "B" : Oe(ze) && (he += ze === "SI extended" ? Me[Ge / 3 + 10] : ye[Ge / 3 + 5]);
          }
          return Ye ? G + he : he;
        }
        S.getTickFormat = function(he) {
          var fe;
          function Pe(Ve) {
            return typeof Ve != "string" ? Ve : Number(Ve.replace("M", "")) * _;
          }
          function Re(Ve, tt) {
            var at = ["L", "D"];
            if (typeof Ve == typeof tt) {
              if (typeof Ve == "number") return Ve - tt;
              var vt = at.indexOf(Ve.charAt(0)), kt = at.indexOf(tt.charAt(0));
              return vt === kt ? Number(Ve.replace(/(L|D)/g, "")) - Number(tt.replace(/(L|D)/g, "")) : vt - kt;
            } else return typeof Ve == "number" ? 1 : -1;
          }
          function Ye(Ve, tt, at) {
            var vt = at || function(Nt) {
              return Nt;
            }, kt = tt[0], At = tt[1];
            return (!kt && typeof kt != "number" || vt(kt) <= vt(Ve)) && (!At && typeof At != "number" || vt(At) >= vt(Ve));
          }
          function Ee(Ve, tt) {
            var at = tt[0] === null, vt = tt[1] === null, kt = Re(Ve, tt[0]) >= 0, At = Re(Ve, tt[1]) <= 0;
            return (at || kt) && (vt || At);
          }
          var ze, Ge;
          if (he.tickformatstops && he.tickformatstops.length > 0) switch (he.type) {
            case "date":
            case "linear": {
              for (fe = 0; fe < he.tickformatstops.length; fe++) if (Ge = he.tickformatstops[fe], Ge.enabled && Ye(he.dtick, Ge.dtickrange, Pe)) {
                ze = Ge;
                break;
              }
              break;
            }
            case "log": {
              for (fe = 0; fe < he.tickformatstops.length; fe++) if (Ge = he.tickformatstops[fe], Ge.enabled && Ee(he.dtick, Ge.dtickrange)) {
                ze = Ge;
                break;
              }
              break;
            }
          }
          return ze ? ze.value : he.tickformat;
        }, S.getSubplots = function(he, fe) {
          var Pe = he._fullLayout._subplots, Re = Pe.cartesian.concat(Pe.gl2d || []), Ye = fe ? S.findSubplotsWithAxis(Re, fe) : Re;
          return Ye.sort(function(Ee, ze) {
            var Ge = Ee.substr(1).split("y"), Ve = ze.substr(1).split("y");
            return Ge[0] === Ve[0] ? +Ge[1] - +Ve[1] : +Ge[0] - +Ve[0];
          }), Ye;
        }, S.findSubplotsWithAxis = function(he, fe) {
          for (var Pe = new RegExp(fe._id.charAt(0) === "x" ? "^" + fe._id + "y" : fe._id + "$"), Re = [], Ye = 0; Ye < he.length; Ye++) {
            var Ee = he[Ye];
            Pe.test(Ee) && Re.push(Ee);
          }
          return Re;
        }, S.makeClipPaths = function(he) {
          var fe = he._fullLayout;
          if (!fe._hasOnlyLargeSploms) {
            var Pe = { _offset: 0, _length: fe.width, _id: "" }, Re = { _offset: 0, _length: fe.height, _id: "" }, Ye = S.list(he, "x", !0), Ee = S.list(he, "y", !0), ze = [], Ge, Ve;
            for (Ge = 0; Ge < Ye.length; Ge++) for (ze.push({ x: Ye[Ge], y: Re }), Ve = 0; Ve < Ee.length; Ve++) Ge === 0 && ze.push({ x: Pe, y: Ee[Ve] }), ze.push({ x: Ye[Ge], y: Ee[Ve] });
            var tt = fe._clips.selectAll(".axesclip").data(ze, function(at) {
              return at.x._id + at.y._id;
            });
            tt.enter().append("clipPath").classed("axesclip", !0).attr("id", function(at) {
              return "clip" + fe._uid + at.x._id + at.y._id;
            }).append("rect"), tt.exit().remove(), tt.each(function(at) {
              n.select(this).select("rect").attr({ x: at.x._offset || 0, y: at.y._offset || 0, width: at.x._length || 1, height: at.y._length || 1 });
            });
          }
        }, S.draw = function(he, fe, Pe) {
          var Re = he._fullLayout;
          fe === "redraw" && Re._paper.selectAll("g.subplot").each(function(Ve) {
            var tt = Ve[0], at = Re._plots[tt];
            if (at) {
              var vt = at.xaxis, kt = at.yaxis;
              at.xaxislayer.selectAll("." + vt._id + "tick").remove(), at.yaxislayer.selectAll("." + kt._id + "tick").remove(), at.xaxislayer.selectAll("." + vt._id + "tick2").remove(), at.yaxislayer.selectAll("." + kt._id + "tick2").remove(), at.xaxislayer.selectAll("." + vt._id + "divider").remove(), at.yaxislayer.selectAll("." + kt._id + "divider").remove(), at.minorGridlayer && at.minorGridlayer.selectAll("path").remove(), at.gridlayer && at.gridlayer.selectAll("path").remove(), at.zerolinelayer && at.zerolinelayer.selectAll("path").remove(), at.zerolinelayerAbove && at.zerolinelayerAbove.selectAll("path").remove(), Re._infolayer.select(".g-" + vt._id + "title").remove(), Re._infolayer.select(".g-" + kt._id + "title").remove();
            }
          });
          var Ye = !fe || fe === "redraw" ? S.listIds(he) : fe, Ee = S.list(he), ze = Ee.filter(function(Ve) {
            return Ve.autoshift;
          }).map(function(Ve) {
            return Ve.overlaying;
          });
          Ye.map(function(Ve) {
            var tt = S.getFromId(he, Ve);
            if (tt.tickmode === "sync" && tt.overlaying) {
              var at = Ye.findIndex(function(vt) {
                return vt === tt.overlaying;
              });
              at >= 0 && Ye.unshift(Ye.splice(at, 1).shift());
            }
          });
          var Ge = { false: { left: 0, right: 0 } };
          return o.syncOrAsync(Ye.map(function(Ve) {
            return function() {
              if (Ve) {
                var tt = S.getFromId(he, Ve);
                Pe || (Pe = {}), Pe.axShifts = Ge, Pe.overlayingShiftedAx = ze;
                var at = S.drawOne(he, tt, Pe);
                return tt._shiftPusher && St(tt, tt._fullDepth || 0, Ge, !0), tt._r = tt.range.slice(), tt._rl = o.simpleMap(tt._r, tt.r2l), at;
              }
            };
          }));
        }, S.drawOne = function(he, fe, Pe) {
          Pe = Pe || {};
          var Re = Pe.axShifts || {}, Ye = Pe.overlayingShiftedAx || [], Ee, ze, Ge;
          fe.setScale();
          var Ve = he._fullLayout, tt = fe._id, at = tt.charAt(0), vt = S.counterLetter(tt), kt = Ve._plots[fe._mainSubplot], At = fe.zerolinelayer === "above traces";
          if (!kt) return;
          if (fe._shiftPusher = fe.autoshift || Ye.indexOf(fe._id) !== -1 || Ye.indexOf(fe.overlaying) !== -1, fe._shiftPusher & fe.anchor === "free") {
            var Nt = fe.linewidth / 2 || 0;
            fe.ticks === "inside" && (Nt += fe.ticklen), St(fe, Nt, Re, !0), St(fe, fe.shift || 0, Re, !1);
          }
          (Pe.skipTitle !== !0 || fe._shift === void 0) && (fe._shift = Kt(fe, Re));
          var Mt = kt[at + "axislayer"], Pt = fe._mainLinePosition, Lt = Pt += fe._shift, ur = fe._mainMirrorPosition, Ht = fe._vals = S.calcTicks(fe), mr = [fe.mirror, Lt, ur].join("_");
          for (Ee = 0; Ee < Ht.length; Ee++) Ht[Ee].axInfo = mr;
          fe._selections = {}, fe._tickAngles && (fe._prevTickAngles = fe._tickAngles), fe._tickAngles = {}, fe._depth = null;
          var ar = {};
          function kr(Pr) {
            var Vr = tt + (Pr || "tick");
            return ar[Vr] || (ar[Vr] = xt(fe, Vr, Lt)), ar[Vr];
          }
          if (fe.visible) {
            var _r = S.makeTransTickFn(fe), Cr = S.makeTransTickLabelFn(fe), Yt, Sr, Tr = fe.ticks === "inside", Gr = fe.ticks === "outside";
            if (fe.tickson === "boundaries") {
              var dr = ot(fe, Ht);
              Sr = S.clipEnds(fe, dr), Yt = Tr ? Sr : dr;
            } else Sr = S.clipEnds(fe, Ht), Yt = Tr && fe.ticklabelmode !== "period" ? Sr : Ht;
            var Ir = fe._gridVals = Sr, Er = st(fe, Ht);
            if (!Ve._hasOnlyLargeSploms) {
              var Zr = fe._subplotsWith, ln = {};
              for (Ee = 0; Ee < Zr.length; Ee++) {
                ze = Zr[Ee], Ge = Ve._plots[ze];
                var un = Ge[vt + "axis"], br = un._mainAxis._id;
                if (!ln[br]) {
                  ln[br] = 1;
                  var Dr = at === "x" ? "M0," + un._offset + "v" + un._length : "M" + un._offset + ",0h" + un._length;
                  S.drawGrid(he, fe, { vals: Ir, counterAxis: un, layer: Ge.gridlayer.select("." + tt), minorLayer: Ge.minorGridlayer.select("." + tt), path: Dr, transFn: _r }), S.drawZeroLine(he, fe, { counterAxis: un, layer: At ? Ge.zerolinelayerAbove : Ge.zerolinelayer, path: Dr, transFn: _r });
                }
              }
            }
            var Mr, Hr = S.getTickSigns(fe), Ur = S.getTickSigns(fe, "minor");
            if (fe.ticks || fe.minor && fe.minor.ticks) {
              var Wr = S.makeTickPath(fe, Lt, Hr[2]), en = S.makeTickPath(fe, Lt, Ur[2], { minor: !0 }), Xr, cn, Jr, Lr;
              if (fe._anchorAxis && fe.mirror && fe.mirror !== !0 ? (Xr = S.makeTickPath(fe, ur, Hr[3]), cn = S.makeTickPath(fe, ur, Ur[3], { minor: !0 }), Jr = Wr + Xr, Lr = en + cn) : (Xr = "", cn = "", Jr = Wr, Lr = en), fe.showdividers && Gr && fe.tickson === "boundaries") {
                var Sn = {};
                for (Ee = 0; Ee < Er.length; Ee++) Sn[Er[Ee].x] = 1;
                Mr = function(Pr) {
                  return Sn[Pr.x] ? Xr : Jr;
                };
              } else Mr = function(Pr) {
                return Pr.minor ? Lr : Jr;
              };
            }
            if (S.drawTicks(he, fe, { vals: Yt, layer: Mt, path: Mr, transFn: _r }), fe.mirror === "allticks") {
              var tn = Object.keys(fe._linepositions || {});
              for (Ee = 0; Ee < tn.length; Ee++) {
                ze = tn[Ee], Ge = Ve._plots[ze];
                var vn = fe._linepositions[ze] || [], fn = vn[0], rn = vn[1], In = vn[2], wn = S.makeTickPath(fe, fn, In ? Hr[0] : Ur[0], { minor: In }) + S.makeTickPath(fe, rn, In ? Hr[1] : Ur[1], { minor: In });
                S.drawTicks(he, fe, { vals: Yt, layer: Ge[at + "axislayer"], path: wn, transFn: _r });
              }
            }
            var nn = [];
            if (nn.push(function() {
              return S.drawLabels(he, fe, { vals: Ht, layer: Mt, plotinfo: Ge, transFn: Cr, labelFns: S.makeLabelFns(fe, Lt) });
            }), fe.type === "multicategory") {
              var En = { x: 2, y: 10 }[at];
              nn.push(function() {
                var Pr = { x: "height", y: "width" }[at], Vr = kr()[Pr] + En + (fe._tickAngles[tt + "tick"] ? fe.tickfont.size * se : 0);
                return S.drawLabels(he, fe, { vals: lt(fe, Ht), layer: Mt, cls: tt + "tick2", repositionOnUpdate: !0, secondary: !0, transFn: _r, labelFns: S.makeLabelFns(fe, Lt + Vr * Hr[4]) });
              }), nn.push(function() {
                return fe._depth = Hr[4] * (kr("tick2")[fe.side] - Lt), jt(he, fe, { vals: Er, layer: Mt, path: S.makeTickPath(fe, Lt, Hr[4], { len: fe._depth }), transFn: _r });
              });
            } else fe.title.hasOwnProperty("standoff") && nn.push(function() {
              fe._depth = Hr[4] * (kr()[fe.side] - Lt);
            });
            var jn = i.getComponentMethod("rangeslider", "isVisible")(fe);
            return !Pe.skipTitle && !(jn && fe.side === "bottom") && nn.push(function() {
              return Tt(he, fe);
            }), nn.push(function() {
              var Pr = fe.side.charAt(0), Vr = O[fe.side].charAt(0), Kr = S.getPxPosition(he, fe), gn = Gr ? fe.ticklen : 0, $r, Nr, yn, xa;
              (fe.automargin || jn || fe._shiftPusher) && (fe.type === "multicategory" ? $r = kr("tick2") : ($r = kr(), at === "x" && Pr === "b" && (fe._depth = Math.max($r.width > 0 ? $r.bottom - Kr : 0, gn))));
              var ia = 0, hi = 0;
              if (fe._shiftPusher && (ia = Math.max(gn, $r.height > 0 ? Pr === "l" ? Kr - $r.left : $r.right - Kr : 0), fe.title.text !== Ve._dfltTitle[at] && (hi = (fe._titleStandoff || 0) + (fe._titleScoot || 0), Pr === "l" && (hi += It(fe))), fe._fullDepth = Math.max(ia, hi)), fe.automargin) {
                Nr = { x: 0, y: 0, r: 0, l: 0, t: 0, b: 0 };
                var oa = [0, 1], Hi = typeof fe._shift == "number" ? fe._shift : 0;
                if (at === "x") {
                  if (Pr === "b" ? Nr[Pr] = fe._depth : (Nr[Pr] = fe._depth = Math.max($r.width > 0 ? Kr - $r.top : 0, gn), oa.reverse()), $r.width > 0) {
                    var qi = $r.right - (fe._offset + fe._length);
                    qi > 0 && (Nr.xr = 1, Nr.r = qi);
                    var Ui = fe._offset - $r.left;
                    Ui > 0 && (Nr.xl = 0, Nr.l = Ui);
                  }
                } else if (Pr === "l" ? (fe._depth = Math.max($r.height > 0 ? Kr - $r.left : 0, gn), Nr[Pr] = fe._depth - Hi) : (fe._depth = Math.max($r.height > 0 ? $r.right - Kr : 0, gn), Nr[Pr] = fe._depth + Hi, oa.reverse()), $r.height > 0) {
                  var vi = $r.bottom - (fe._offset + fe._length);
                  vi > 0 && (Nr.yb = 0, Nr.b = vi);
                  var ba = fe._offset - $r.top;
                  ba > 0 && (Nr.yt = 1, Nr.t = ba);
                }
                Nr[vt] = fe.anchor === "free" ? fe.position : fe._anchorAxis.domain[oa[0]], fe.title.text !== Ve._dfltTitle[at] && (Nr[Pr] += It(fe) + (fe.title.standoff || 0)), fe.mirror && fe.anchor !== "free" && (yn = { x: 0, y: 0, r: 0, l: 0, t: 0, b: 0 }, yn[Vr] = fe.linewidth, fe.mirror && fe.mirror !== !0 && (yn[Vr] += gn), fe.mirror === !0 || fe.mirror === "ticks" ? yn[vt] = fe._anchorAxis.domain[oa[1]] : (fe.mirror === "all" || fe.mirror === "allticks") && (yn[vt] = [fe._counterDomainMin, fe._counterDomainMax][oa[1]]));
              }
              jn && (xa = i.getComponentMethod("rangeslider", "autoMarginOpts")(he, fe)), typeof fe.automargin == "string" && (Je(Nr, fe.automargin), Je(yn, fe.automargin)), a.autoMargin(he, Ct(fe), Nr), a.autoMargin(he, Ot(fe), yn), a.autoMargin(he, Wt(fe), xa);
            }), o.syncOrAsync(nn);
          }
        };
        function Je(he, fe) {
          if (he) {
            var Pe = Object.keys(j).reduce(function(Re, Ye) {
              return fe.indexOf(Ye) !== -1 && j[Ye].forEach(function(Ee) {
                Re[Ee] = 1;
              }), Re;
            }, {});
            Object.keys(he).forEach(function(Re) {
              Pe[Re] || (Re.length === 1 ? he[Re] = 0 : delete he[Re]);
            });
          }
        }
        function ot(he, fe) {
          var Pe = [], Re, Ye = function(Ee, ze) {
            var Ge = Ee.xbnd[ze];
            Ge !== null && Pe.push(o.extendFlat({}, Ee, { x: Ge }));
          };
          if (fe.length) {
            for (Re = 0; Re < fe.length; Re++) Ye(fe[Re], 0);
            Ye(fe[Re - 1], 1);
          }
          return Pe;
        }
        function lt(he, fe) {
          for (var Pe = [], Re = {}, Ye = 0; Ye < fe.length; Ye++) {
            var Ee = fe[Ye];
            Re[Ee.text2] ? Re[Ee.text2].push(Ee.x) : Re[Ee.text2] = [Ee.x];
          }
          for (var ze in Re) Pe.push(ct(he, o.interp(Re[ze], 0.5), ze));
          return Pe;
        }
        function st(he, fe) {
          var Pe = [], Re, Ye, Ee = fe.length && fe[fe.length - 1].x < fe[0].x, ze = function(Ve, tt) {
            var at = Ve.xbnd[tt];
            at !== null && Pe.push(o.extendFlat({}, Ve, { x: at }));
          };
          if (he.showdividers && fe.length) {
            for (Re = 0; Re < fe.length; Re++) {
              var Ge = fe[Re];
              Ge.text2 !== Ye && ze(Ge, Ee ? 1 : 0), Ye = Ge.text2;
            }
            ze(fe[Re - 1], Ee ? 0 : 1);
          }
          return Pe;
        }
        function xt(he, fe, Pe) {
          var Re, Ye, Ee, ze;
          if (he._selections[fe].size()) Re = 1 / 0, Ye = -1 / 0, Ee = 1 / 0, ze = -1 / 0, he._selections[fe].each(function() {
            var Ve = Dt(this);
            if (Ve.node().style.display !== "none") {
              var tt = p.bBox(Ve.node().parentNode);
              Re = Math.min(Re, tt.top), Ye = Math.max(Ye, tt.bottom), Ee = Math.min(Ee, tt.left), ze = Math.max(ze, tt.right);
            }
          });
          else {
            var Ge = S.makeLabelFns(he, Pe);
            Re = Ye = Ge.yFn({ dx: 0, dy: 0, fontSize: 0 }), Ee = ze = Ge.xFn({ dx: 0, dy: 0, fontSize: 0 });
          }
          return { top: Re, bottom: Ye, left: Ee, right: ze, height: Ye - Re, width: ze - Ee };
        }
        S.getTickSigns = function(he, fe) {
          var Pe = he._id.charAt(0), Re = { x: "top", y: "right" }[Pe], Ye = he.side === Re ? 1 : -1, Ee = [-1, 1, Ye, -Ye], ze = fe ? (he.minor || {}).ticks : he.ticks;
          return ze !== "inside" == (Pe === "x") && (Ee = Ee.map(function(Ge) {
            return -Ge;
          })), he.side && Ee.push({ l: -1, t: -1, r: 1, b: 1 }[he.side.charAt(0)]), Ee;
        }, S.makeTransTickFn = function(he) {
          return he._id.charAt(0) === "x" ? function(fe) {
            return r(he._offset + he.l2p(fe.x), 0);
          } : function(fe) {
            return r(0, he._offset + he.l2p(fe.x));
          };
        }, S.makeTransTickLabelFn = function(he) {
          var fe = Bt(he), Pe = he.ticklabelshift || 0, Re = he.ticklabelstandoff || 0, Ye = fe[0], Ee = fe[1], ze = he.range[0] > he.range[1], Ge = he.ticklabelposition && he.ticklabelposition.indexOf("inside") !== -1, Ve = !Ge;
          if (Pe) {
            var tt = ze ? -1 : 1;
            Pe = Pe * tt;
          }
          if (Re) {
            var at = he.side, vt = Ge && (at === "top" || at === "left") || Ve && (at === "bottom" || at === "right") ? 1 : -1;
            Re = Re * vt;
          }
          return he._id.charAt(0) === "x" ? function(kt) {
            return r(Ye + he._offset + he.l2p(Et(kt)) + Pe, Ee + Re);
          } : function(kt) {
            return r(Ee + Re, Ye + he._offset + he.l2p(Et(kt)) + Pe);
          };
        };
        function Et(he) {
          return he.periodX !== void 0 ? he.periodX : he.x;
        }
        function Bt(he) {
          var fe = he.ticklabelposition || "", Pe = he.tickson || "", Re = function(Nt) {
            return fe.indexOf(Nt) !== -1;
          }, Ye = Re("top"), Ee = Re("left"), ze = Re("right"), Ge = Re("bottom"), Ve = Re("inside"), tt = Pe !== "boundaries" && (Ge || Ee || Ye || ze);
          if (!tt && !Ve) return [0, 0];
          var at = he.side, vt = tt ? (he.tickwidth || 0) / 2 : 0, kt = F, At = he.tickfont ? he.tickfont.size : 12;
          return (Ge || Ye) && (vt += At * ae, kt += (he.linewidth || 0) / 2), (Ee || ze) && (vt += (he.linewidth || 0) / 2, kt += F), Ve && at === "top" && (kt -= At * (1 - ae)), (Ee || Ye) && (vt = -vt), (at === "bottom" || at === "right") && (kt = -kt), [tt ? vt : 0, Ve ? kt : 0];
        }
        S.makeTickPath = function(he, fe, Pe, Re) {
          Re || (Re = {});
          var Ye = Re.minor;
          if (Ye && !he.minor) return "";
          var Ee = Re.len !== void 0 ? Re.len : Ye ? he.minor.ticklen : he.ticklen, ze = he._id.charAt(0), Ge = (he.linewidth || 1) / 2;
          return ze === "x" ? "M0," + (fe + Ge * Pe) + "v" + Ee * Pe : "M" + (fe + Ge * Pe) + ",0h" + Ee * Pe;
        }, S.makeLabelFns = function(he, fe, Pe) {
          var Re = he.ticklabelposition || "", Ye = he.tickson || "", Ee = function(dr) {
            return Re.indexOf(dr) !== -1;
          }, ze = Ee("top"), Ge = Ee("left"), Ve = Ee("right"), tt = Ee("bottom"), at = Ye !== "boundaries" && (tt || Ge || ze || Ve), vt = Ee("inside"), kt = Re === "inside" && he.ticks === "inside" || !vt && he.ticks === "outside" && Ye !== "boundaries", At = 0, Nt = 0, Mt = kt ? he.ticklen : 0;
          if (vt ? Mt *= -1 : at && (Mt = 0), kt && (At += Mt, Pe)) {
            var Pt = o.deg2rad(Pe);
            At = Mt * Math.cos(Pt) + 1, Nt = Mt * Math.sin(Pt);
          }
          he.showticklabels && (kt || he.showline) && (At += 0.2 * he.tickfont.size), At += (he.linewidth || 1) / 2 * (vt ? -1 : 1);
          var Lt = { labelStandoff: At, labelShift: Nt }, ur, Ht, mr, ar, kr = 0, _r = he.side, Cr = he._id.charAt(0), Yt = he.tickangle, Sr;
          if (Cr === "x") Sr = !vt && _r === "bottom" || vt && _r === "top", ar = Sr ? 1 : -1, vt && (ar *= -1), ur = Nt * ar, Ht = fe + At * ar, mr = Sr ? 1 : -0.2, Math.abs(Yt) === 90 && (vt ? mr += ne : Yt === -90 && _r === "bottom" ? mr = ae : Yt === 90 && _r === "top" ? mr = ne : mr = 0.5, kr = ne / 2 * (Yt / 90)), Lt.xFn = function(dr) {
            return dr.dx + ur + kr * dr.fontSize;
          }, Lt.yFn = function(dr) {
            return dr.dy + Ht + dr.fontSize * mr;
          }, Lt.anchorFn = function(dr, Ir) {
            if (at) {
              if (Ge) return "end";
              if (Ve) return "start";
            }
            return !e(Ir) || Ir === 0 || Ir === 180 ? "middle" : Ir * ar < 0 !== vt ? "end" : "start";
          }, Lt.heightFn = function(dr, Ir, Er) {
            return Ir < -60 || Ir > 60 ? -0.5 * Er : he.side === "top" !== vt ? -Er : 0;
          };
          else if (Cr === "y") {
            if (Sr = !vt && _r === "left" || vt && _r === "right", ar = Sr ? 1 : -1, vt && (ar *= -1), ur = At, Ht = Nt * ar, mr = 0, !vt && Math.abs(Yt) === 90 && (Yt === -90 && _r === "left" || Yt === 90 && _r === "right" ? mr = ae : mr = 0.5), vt) {
              var Tr = e(Yt) ? +Yt : 0;
              if (Tr !== 0) {
                var Gr = o.deg2rad(Tr);
                kr = Math.abs(Math.sin(Gr)) * ae * ar, mr = 0;
              }
            }
            Lt.xFn = function(dr) {
              return dr.dx + fe - (ur + dr.fontSize * mr) * ar + kr * dr.fontSize;
            }, Lt.yFn = function(dr) {
              return dr.dy + Ht + dr.fontSize * ne;
            }, Lt.anchorFn = function(dr, Ir) {
              return e(Ir) && Math.abs(Ir) === 90 ? "middle" : Sr ? "end" : "start";
            }, Lt.heightFn = function(dr, Ir, Er) {
              return he.side === "right" && (Ir *= -1), Ir < -30 ? -Er : Ir < 30 ? -0.5 * Er : 0;
            };
          }
          return Lt;
        };
        function qt(he) {
          return [he.text, he.x, he.axInfo, he.font, he.fontSize, he.fontColor].join("_");
        }
        S.drawTicks = function(he, fe, Pe) {
          Pe = Pe || {};
          var Re = fe._id + "tick", Ye = [].concat(fe.minor && fe.minor.ticks ? Pe.vals.filter(function(ze) {
            return ze.minor && !ze.noTick;
          }) : []).concat(fe.ticks ? Pe.vals.filter(function(ze) {
            return !ze.minor && !ze.noTick;
          }) : []), Ee = Pe.layer.selectAll("path." + Re).data(Ye, qt);
          Ee.exit().remove(), Ee.enter().append("path").classed(Re, 1).classed("ticks", 1).classed("crisp", Pe.crisp !== !1).each(function(ze) {
            return t.stroke(n.select(this), ze.minor ? fe.minor.tickcolor : fe.tickcolor);
          }).style("stroke-width", function(ze) {
            return p.crispRound(he, ze.minor ? fe.minor.tickwidth : fe.tickwidth, 1) + "px";
          }).attr("d", Pe.path).style("display", null), sr(fe, [Y]), Ee.attr("transform", Pe.transFn);
        }, S.drawGrid = function(he, fe, Pe) {
          if (Pe = Pe || {}, fe.tickmode !== "sync") {
            var Re = fe._id + "grid", Ye = fe.minor && fe.minor.showgrid, Ee = Ye ? Pe.vals.filter(function(Lt) {
              return Lt.minor;
            }) : [], ze = fe.showgrid ? Pe.vals.filter(function(Lt) {
              return !Lt.minor;
            }) : [], Ge = Pe.counterAxis;
            if (Ge && S.shouldShowZeroLine(he, fe, Ge)) for (var Ve = fe.tickmode === "array", tt = 0; tt < ze.length; tt++) {
              var at = ze[tt].x;
              if (Ve ? !at : Math.abs(at) < fe.dtick / 100) if (ze = ze.slice(0, tt).concat(ze.slice(tt + 1)), Ve) tt--;
              else break;
            }
            fe._gw = p.crispRound(he, fe.gridwidth, 1);
            for (var vt = Ye ? p.crispRound(he, fe.minor.gridwidth, 1) : 0, kt = Pe.layer, At = Pe.minorLayer, Nt = 1; Nt >= 0; Nt--) {
              var Mt = Nt ? kt : At;
              if (Mt) {
                var Pt = Mt.selectAll("path." + Re).data(Nt ? ze : Ee, qt);
                Pt.exit().remove(), Pt.enter().append("path").classed(Re, 1).classed("crisp", Pe.crisp !== !1), Pt.attr("transform", Pe.transFn).attr("d", Pe.path).each(function(Lt) {
                  return t.stroke(n.select(this), Lt.minor ? fe.minor.gridcolor : fe.gridcolor || "#ddd");
                }).style("stroke-dasharray", function(Lt) {
                  return p.dashStyle(Lt.minor ? fe.minor.griddash : fe.griddash, Lt.minor ? fe.minor.gridwidth : fe.gridwidth);
                }).style("stroke-width", function(Lt) {
                  return (Lt.minor ? vt : fe._gw) + "px";
                }).style("display", null), typeof Pe.path == "function" && Pt.attr("d", Pe.path);
              }
            }
            sr(fe, [V, Z]);
          }
        }, S.drawZeroLine = function(he, fe, Pe) {
          Pe = Pe || Pe;
          var Re = fe._id + "zl", Ye = S.shouldShowZeroLine(he, fe, Pe.counterAxis), Ee = Pe.layer.selectAll("path." + Re).data(Ye ? [{ x: 0, id: fe._id }] : []);
          Ee.exit().remove(), Ee.enter().append("path").classed(Re, 1).classed("zl", 1).classed("crisp", Pe.crisp !== !1).each(function() {
            Pe.layer.selectAll("path").sort(function(ze, Ge) {
              return E(ze.id, Ge.id);
            });
          }), Ee.attr("transform", Pe.transFn).attr("d", Pe.path).call(t.stroke, fe.zerolinecolor || t.defaultLine).style("stroke-width", p.crispRound(he, fe.zerolinewidth, fe._gw || 1) + "px").style("display", null), sr(fe, [te]);
        }, S.drawLabels = function(he, fe, Pe) {
          Pe = Pe || {};
          var Re = he._fullLayout, Ye = fe._id, Ee = fe.zerolinelayer === "above traces", ze = Pe.cls || Ye + "tick", Ge = Pe.vals.filter(function(br) {
            return br.text;
          }), Ve = Pe.labelFns, tt = Pe.secondary ? 0 : fe.tickangle, at = (fe._prevTickAngles || {})[ze], vt = Pe.layer.selectAll("g." + ze).data(fe.showticklabels ? Ge : [], qt), kt = [];
          vt.enter().append("g").classed(ze, 1).append("text").attr("text-anchor", "middle").each(function(br) {
            var Dr = n.select(this), Mr = he._promises.length;
            Dr.call(s.positionText, Ve.xFn(br), Ve.yFn(br)).call(p.font, { family: br.font, size: br.fontSize, color: br.fontColor, weight: br.fontWeight, style: br.fontStyle, variant: br.fontVariant, textcase: br.fontTextcase, lineposition: br.fontLineposition, shadow: br.fontShadow }).text(br.text).call(s.convertToTspans, he), he._promises[Mr] ? kt.push(he._promises.pop().then(function() {
              At(Dr, tt);
            })) : At(Dr, tt);
          }), sr(fe, [C]), vt.exit().remove(), Pe.repositionOnUpdate && vt.each(function(br) {
            n.select(this).select("text").call(s.positionText, Ve.xFn(br), Ve.yFn(br));
          });
          function At(br, Dr) {
            br.each(function(Mr) {
              var Hr = n.select(this), Ur = Hr.select(".text-math-group"), Wr = Ve.anchorFn(Mr, Dr), en = Pe.transFn.call(Hr.node(), Mr) + (e(Dr) && +Dr != 0 ? " rotate(" + Dr + "," + Ve.xFn(Mr) + "," + (Ve.yFn(Mr) - Mr.fontSize / 2) + ")" : ""), Xr = s.lineCount(Hr), cn = se * Mr.fontSize, Jr = Ve.heightFn(Mr, e(Dr) ? +Dr : 0, (Xr - 1) * cn);
              if (Jr && (en += r(0, Jr)), Ur.empty()) {
                var Lr = Hr.select("text");
                Lr.attr({ transform: en, "text-anchor": Wr }), Lr.style("display", null), fe._adjustTickLabelsOverflow && fe._adjustTickLabelsOverflow();
              } else {
                var Sn = p.bBox(Ur.node()).width, tn = Sn * { end: -0.5, start: 0.5 }[Wr];
                Ur.attr("transform", en + r(tn, 0));
              }
            });
          }
          fe._adjustTickLabelsOverflow = function() {
            var br = fe.ticklabeloverflow;
            if (!(!br || br === "allow")) {
              var Dr = br.indexOf("hide") !== -1, Mr = fe._id.charAt(0) === "x", Hr = 0, Ur = Mr ? he._fullLayout.width : he._fullLayout.height;
              if (br.indexOf("domain") !== -1) {
                var Wr = o.simpleMap(fe.range, fe.r2l);
                Hr = fe.l2p(Wr[0]) + fe._offset, Ur = fe.l2p(Wr[1]) + fe._offset;
              }
              var en = Math.min(Hr, Ur), Xr = Math.max(Hr, Ur), cn = fe.side, Jr = 1 / 0, Lr = -1 / 0;
              vt.each(function(fn) {
                var rn = n.select(this), In = rn.select(".text-math-group");
                if (In.empty()) {
                  var wn = p.bBox(rn.node()), nn = 0;
                  Mr ? (wn.right > Xr || wn.left < en) && (nn = 1) : (wn.bottom > Xr || wn.top + (fe.tickangle ? 0 : fn.fontSize / 4) < en) && (nn = 1);
                  var En = rn.select("text");
                  nn ? Dr && En.style("display", "none") : En.node().style.display !== "none" && (En.style("display", null), cn === "bottom" || cn === "right" ? Jr = Math.min(Jr, Mr ? wn.top : wn.left) : Jr = -1 / 0, cn === "top" || cn === "left" ? Lr = Math.max(Lr, Mr ? wn.bottom : wn.right) : Lr = 1 / 0);
                }
              });
              for (var Sn in Re._plots) {
                var tn = Re._plots[Sn];
                if (!(fe._id !== tn.xaxis._id && fe._id !== tn.yaxis._id)) {
                  var vn = Mr ? tn.yaxis : tn.xaxis;
                  vn && (vn["_visibleLabelMin_" + fe._id] = Jr, vn["_visibleLabelMax_" + fe._id] = Lr);
                }
              }
            }
          }, fe._hideCounterAxisInsideTickLabels = function(br) {
            var Dr = fe._id.charAt(0) === "x", Mr = [];
            for (var Hr in Re._plots) {
              var Ur = Re._plots[Hr];
              fe._id !== Ur.xaxis._id && fe._id !== Ur.yaxis._id || Mr.push(Dr ? Ur.yaxis : Ur.xaxis);
            }
            Mr.forEach(function(Wr, en) {
              Wr && $t(Wr) && (br || [te, Z, V, Y, C]).forEach(function(Xr) {
                var cn = Xr.K === "tick" && Xr.L === "text" && fe.ticklabelmode === "period", Jr = Re._plots[fe._mainSubplot], Lr;
                if (Xr.K === te.K) {
                  var Sn = Ee ? Jr.zerolinelayerAbove : Jr.zerolinelayer;
                  Lr = Sn.selectAll("." + fe._id + "zl");
                } else Xr.K === Z.K ? Lr = Jr.minorGridlayer.selectAll("." + fe._id) : Xr.K === V.K ? Lr = Jr.gridlayer.selectAll("." + fe._id) : Lr = Jr[fe._id.charAt(0) + "axislayer"];
                Lr.each(function() {
                  var tn = n.select(this);
                  Xr.L && (tn = tn.selectAll(Xr.L)), tn.each(function(vn) {
                    var fn = fe.l2p(cn ? Et(vn) : vn.x) + fe._offset, rn = n.select(this);
                    fn < fe["_visibleLabelMax_" + Wr._id] && fn > fe["_visibleLabelMin_" + Wr._id] ? rn.style("display", "none") : Xr.K === "tick" && !en && rn.node().style.display !== "none" && rn.style("display", null);
                  });
                });
              });
            });
          }, At(vt, at + 1 ? at : tt);
          function Nt() {
            return kt.length && Promise.all(kt);
          }
          var Mt = null;
          function Pt() {
            if (At(vt, tt), Ge.length && fe.autotickangles && (fe.type !== "log" || String(fe.dtick).charAt(0) !== "D")) {
              Mt = fe.autotickangles[0];
              var br = 0, Dr = [], Mr, Hr = 1;
              vt.each(function(Nr) {
                br = Math.max(br, Nr.fontSize);
                var yn = fe.l2p(Nr.x), xa = Dt(this), ia = p.bBox(xa.node());
                Hr = Math.max(Hr, s.lineCount(xa)), Dr.push({ top: 0, bottom: 10, height: 10, left: yn - ia.width / 2, right: yn + ia.width / 2 + 2, width: ia.width + 2 });
              });
              var Ur = (fe.tickson === "boundaries" || fe.showdividers) && !Pe.secondary, Wr = Ge.length, en = Math.abs((Ge[Wr - 1].x - Ge[0].x) * fe._m) / (Wr - 1), Xr = Ur ? en / 2 : en, cn = Ur ? fe.ticklen : br * 1.25 * Hr, Jr = Math.sqrt(Math.pow(Xr, 2) + Math.pow(cn, 2)), Lr = Xr / Jr, Sn = fe.autotickangles.map(function(Nr) {
                return Nr * Math.PI / 180;
              }), tn = Sn.find(function(Nr) {
                return Math.abs(Math.cos(Nr)) <= Lr;
              });
              tn === void 0 && (tn = Sn.reduce(function(Nr, yn) {
                return Math.abs(Math.cos(Nr)) < Math.abs(Math.cos(yn)) ? Nr : yn;
              }, Sn[0]));
              var vn = tn * (180 / Math.PI);
              if (Ur) {
                var fn = 2;
                for (fe.ticks && (fn += fe.tickwidth / 2), Mr = 0; Mr < Dr.length; Mr++) {
                  var rn = Ge[Mr].xbnd, In = Dr[Mr];
                  if (rn[0] !== null && In.left - fe.l2p(rn[0]) < fn || rn[1] !== null && fe.l2p(rn[1]) - In.right < fn) {
                    Mt = vn;
                    break;
                  }
                }
              } else {
                var wn = fe.ticklabelposition || "", nn = fe.tickson || "", En = function(Nr) {
                  return wn.indexOf(Nr) !== -1;
                }, jn = En("top"), Pr = En("left"), Vr = En("right"), Kr = En("bottom"), gn = nn !== "boundaries" && (Kr || Pr || jn || Vr), $r = gn ? (fe.tickwidth || 0) + 2 * F : 0;
                for (Mr = 0; Mr < Dr.length - 1; Mr++) if (o.bBoxIntersect(Dr[Mr], Dr[Mr + 1], $r)) {
                  Mt = vn;
                  break;
                }
              }
              Mt && At(vt, Mt);
            }
          }
          fe._selections && (fe._selections[ze] = vt);
          var Lt = [Nt];
          fe.automargin && Re._redrawFromAutoMarginCount && at === 90 ? (Mt = at, Lt.push(function() {
            At(vt, at);
          })) : Lt.push(Pt), fe._tickAngles && Lt.push(function() {
            fe._tickAngles[ze] = Mt === null ? e(tt) ? tt : 0 : Mt;
          });
          var ur = function() {
            var br = 0, Dr = 0;
            return vt.each(function(Mr, Hr) {
              var Ur = Dt(this), Wr = Ur.select(".text-math-group");
              if (Wr.empty()) {
                var en;
                fe._vals[Hr] && (en = fe._vals[Hr].bb || p.bBox(Ur.node()), fe._vals[Hr].bb = en), br = Math.max(br, en.width), Dr = Math.max(Dr, en.height);
              }
            }), { labelsMaxW: br, labelsMaxH: Dr };
          }, Ht = fe._anchorAxis;
          if (Ht && (Ht.autorange || Ht.insiderange) && $t(fe) && !w(Re, fe._id) && (Re._insideTickLabelsUpdaterange || (Re._insideTickLabelsUpdaterange = {}), Ht.autorange && (Re._insideTickLabelsUpdaterange[Ht._name + ".autorange"] = Ht.autorange, Lt.push(ur)), Ht.insiderange)) {
            var mr = ur(), ar = fe._id.charAt(0) === "y" ? mr.labelsMaxW : mr.labelsMaxH;
            ar += 2 * F, fe.ticklabelposition === "inside" && (ar += fe.ticklen || 0);
            var kr = fe.side === "right" || fe.side === "top" ? 1 : -1, _r = kr === 1 ? 1 : 0, Cr = kr === 1 ? 0 : 1, Yt = [];
            Yt[Cr] = Ht.range[Cr];
            var Sr = Ht.range, Tr = Ht.r2p(Sr[_r]), Gr = Ht.r2p(Sr[Cr]), dr = Re._insideTickLabelsUpdaterange[Ht._name + ".range"];
            if (dr) {
              var Ir = Ht.r2p(dr[_r]), Er = Ht.r2p(dr[Cr]), Zr = kr * (fe._id.charAt(0) === "y" ? 1 : -1);
              Zr * Tr < Zr * Ir && (Tr = Ir, Yt[_r] = Sr[_r] = dr[_r]), Zr * Gr > Zr * Er && (Gr = Er, Yt[Cr] = Sr[Cr] = dr[Cr]);
            }
            var ln = Math.abs(Gr - Tr);
            ln - ar > 0 ? (ln -= ar, ar *= 1 + ar / ln) : ar = 0, fe._id.charAt(0) !== "y" && (ar = -ar), Yt[_r] = Ht.p2r(Ht.r2p(Sr[_r]) + kr * ar), Ht.autorange === "min" || Ht.autorange === "max reversed" ? (Yt[0] = null, Ht._rangeInitial0 = void 0, Ht._rangeInitial1 = void 0) : (Ht.autorange === "max" || Ht.autorange === "min reversed") && (Yt[1] = null, Ht._rangeInitial0 = void 0, Ht._rangeInitial1 = void 0), Re._insideTickLabelsUpdaterange[Ht._name + ".range"] = Yt;
          }
          var un = o.syncOrAsync(Lt);
          return un && un.then && he._promises.push(un), un;
        };
        function jt(he, fe, Pe) {
          var Re = fe._id + "divider", Ye = Pe.vals, Ee = Pe.layer.selectAll("path." + Re).data(Ye, qt);
          Ee.exit().remove(), Ee.enter().insert("path", ":first-child").classed(Re, 1).classed("crisp", 1).call(t.stroke, fe.dividercolor).style("stroke-width", p.crispRound(he, fe.dividerwidth, 1) + "px"), Ee.attr("transform", Pe.transFn).attr("d", Pe.path);
        }
        S.getPxPosition = function(he, fe) {
          var Pe = he._fullLayout._size, Re = fe._id.charAt(0), Ye = fe.side, Ee;
          if (fe.anchor !== "free" ? Ee = fe._anchorAxis : Re === "x" ? Ee = { _offset: Pe.t + (1 - (fe.position || 0)) * Pe.h, _length: 0 } : Re === "y" && (Ee = { _offset: Pe.l + (fe.position || 0) * Pe.w + fe._shift, _length: 0 }), Ye === "top" || Ye === "left") return Ee._offset;
          if (Ye === "bottom" || Ye === "right") return Ee._offset + Ee._length;
        };
        function It(he) {
          var fe = he.title.font.size, Pe = (he.title.text.match(s.BR_TAG_ALL) || []).length;
          return he.title.hasOwnProperty("standoff") ? fe * (ae + Pe * se) : Pe ? fe * (Pe + 1) * se : fe;
        }
        function Tt(he, fe) {
          var Pe = he._fullLayout, Re = fe._id, Ye = Re.charAt(0), Ee = fe.title.font.size, ze, Ge = (fe.title.text.match(s.BR_TAG_ALL) || []).length;
          if (fe.title.hasOwnProperty("standoff")) fe.side === "bottom" || fe.side === "right" ? ze = fe._depth + fe.title.standoff + Ee * ae : (fe.side === "top" || fe.side === "left") && (ze = fe._depth + fe.title.standoff + Ee * (ne + Ge * se));
          else {
            var Ve = $t(fe);
            if (fe.type === "multicategory") ze = fe._depth;
            else {
              var tt = 1.5 * Ee;
              Ve && (tt = 0.5 * Ee, fe.ticks === "outside" && (tt += fe.ticklen)), ze = 10 + tt + (fe.linewidth ? fe.linewidth - 1 : 0);
            }
            Ve || (Ye === "x" ? ze += fe.side === "top" ? Ee * (fe.showticklabels ? 1 : 0) : Ee * (fe.showticklabels ? 1.5 : 0.5) : ze += fe.side === "right" ? Ee * (fe.showticklabels ? 1 : 0.5) : Ee * (fe.showticklabels ? 0.5 : 0));
          }
          var at = S.getPxPosition(he, fe), vt, kt, At;
          Ye === "x" ? (kt = fe._offset + fe._length / 2, At = fe.side === "top" ? at - ze : at + ze) : (At = fe._offset + fe._length / 2, kt = fe.side === "right" ? at + ze : at - ze, vt = { rotate: "-90", offset: 0 });
          var Nt;
          if (fe.type !== "multicategory") {
            var Mt = fe._selections[fe._id + "tick"];
            if (Nt = { selection: Mt, side: fe.side }, Mt && Mt.node() && Mt.node().parentNode) {
              var Pt = p.getTranslate(Mt.node().parentNode);
              Nt.offsetLeft = Pt.x, Nt.offsetTop = Pt.y;
            }
            fe.title.hasOwnProperty("standoff") && (Nt.pad = 0);
          }
          return fe._titleStandoff = ze, c.draw(he, Re + "title", { propContainer: fe, propName: fe._name + ".title.text", placeholder: Pe._dfltTitle[Ye], avoid: Nt, transform: vt, attributes: { x: kt, y: At, "text-anchor": "middle" } });
        }
        S.shouldShowZeroLine = function(he, fe, Pe) {
          var Re = o.simpleMap(fe.range, fe.r2l);
          return Re[0] * Re[1] <= 0 && fe.zeroline && (fe.type === "linear" || fe.type === "-") && !(fe.rangebreaks && fe.maskBreaks(0) === K) && (Rt(fe, 0) || !Vt(he, fe, Pe, Re) || Ft(he, fe));
        }, S.clipEnds = function(he, fe) {
          return fe.filter(function(Pe) {
            return Rt(he, Pe.x);
          });
        };
        function Rt(he, fe) {
          var Pe = he.l2p(fe);
          return Pe > 1 && Pe < he._length - 1;
        }
        function Vt(he, fe, Pe, Re) {
          var Ye = Pe._mainAxis;
          if (!Ye) return;
          var Ee = he._fullLayout, ze = fe._id.charAt(0), Ge = S.counterLetter(fe._id), Ve = fe._offset + (Math.abs(Re[0]) < Math.abs(Re[1]) == (ze === "x") ? 0 : fe._length);
          function tt(Nt) {
            if (!Nt.showline || !Nt.linewidth) return !1;
            var Mt = Math.max((Nt.linewidth + fe.zerolinewidth) / 2, 1);
            function Pt(Ht) {
              return typeof Ht == "number" && Math.abs(Ht - Ve) < Mt;
            }
            if (Pt(Nt._mainLinePosition) || Pt(Nt._mainMirrorPosition)) return !0;
            var Lt = Nt._linepositions || {};
            for (var ur in Lt) if (Pt(Lt[ur][0]) || Pt(Lt[ur][1])) return !0;
          }
          var at = Ee._plots[Pe._mainSubplot];
          if (!(at.mainplotinfo || at).overlays.length) return tt(Pe);
          for (var vt = S.list(he, Ge), kt = 0; kt < vt.length; kt++) {
            var At = vt[kt];
            if (At._mainAxis === Ye && tt(At)) return !0;
          }
        }
        function Ft(he, fe) {
          for (var Pe = he._fullData, Re = fe._mainSubplot, Ye = fe._id.charAt(0), Ee = 0; Ee < Pe.length; Ee++) {
            var ze = Pe[Ee];
            if (ze.visible === !0 && ze.xaxis + ze.yaxis === Re && (i.traceIs(ze, "bar-like") && ze.orientation === { x: "h", y: "v" }[Ye] || ze.fill && ze.fill.charAt(ze.fill.length - 1) === Ye)) return !0;
          }
          return !1;
        }
        function Dt(he) {
          var fe = n.select(he), Pe = fe.select(".text-math-group");
          return Pe.empty() ? fe.select("text") : Pe;
        }
        S.allowAutoMargin = function(he) {
          for (var fe = S.list(he, "", !0), Pe = 0; Pe < fe.length; Pe++) {
            var Re = fe[Pe];
            Re.automargin && (a.allowAutoMargin(he, Ct(Re)), Re.mirror && a.allowAutoMargin(he, Ot(Re))), i.getComponentMethod("rangeslider", "isVisible")(Re) && a.allowAutoMargin(he, Wt(Re));
          }
        };
        function Ct(he) {
          return he._id + ".automargin";
        }
        function Ot(he) {
          return Ct(he) + ".mirror";
        }
        function Wt(he) {
          return he._id + ".rangeslider";
        }
        S.swap = function(he, fe) {
          for (var Pe = rr(he, fe), Re = 0; Re < Pe.length; Re++) Qt(he, Pe[Re].x, Pe[Re].y);
        };
        function rr(he, fe) {
          var Pe = [], Re, Ye;
          for (Re = 0; Re < fe.length; Re++) {
            var Ee = [], ze = he._fullData[fe[Re]].xaxis, Ge = he._fullData[fe[Re]].yaxis;
            if (!(!ze || !Ge)) {
              for (Ye = 0; Ye < Pe.length; Ye++) (Pe[Ye].x.indexOf(ze) !== -1 || Pe[Ye].y.indexOf(Ge) !== -1) && Ee.push(Ye);
              if (!Ee.length) {
                Pe.push({ x: [ze], y: [Ge] });
                continue;
              }
              var Ve = Pe[Ee[0]], tt;
              if (Ee.length > 1) for (Ye = 1; Ye < Ee.length; Ye++) tt = Pe[Ee[Ye]], Ut(Ve.x, tt.x), Ut(Ve.y, tt.y);
              Ut(Ve.x, [ze]), Ut(Ve.y, [Ge]);
            }
          }
          return Pe;
        }
        function Ut(he, fe) {
          for (var Pe = 0; Pe < fe.length; Pe++) he.indexOf(fe[Pe]) === -1 && he.push(fe[Pe]);
        }
        function Qt(he, fe, Pe) {
          var Re = [], Ye = [], Ee = he.layout, ze, Ge;
          for (ze = 0; ze < fe.length; ze++) Re.push(S.getFromId(he, fe[ze]));
          for (ze = 0; ze < Pe.length; ze++) Ye.push(S.getFromId(he, Pe[ze]));
          var Ve = Object.keys(l), tt = ["anchor", "domain", "overlaying", "position", "side", "tickangle", "editType"], at = ["linear", "log"];
          for (ze = 0; ze < Ve.length; ze++) {
            var vt = Ve[ze], kt = Re[0][vt], At = Ye[0][vt], Nt = !0, Mt = !1, Pt = !1;
            if (!(vt.charAt(0) === "_" || typeof kt == "function" || tt.indexOf(vt) !== -1)) {
              for (Ge = 1; Ge < Re.length && Nt; Ge++) {
                var Lt = Re[Ge][vt];
                vt === "type" && at.indexOf(kt) !== -1 && at.indexOf(Lt) !== -1 && kt !== Lt ? Mt = !0 : Lt !== kt && (Nt = !1);
              }
              for (Ge = 1; Ge < Ye.length && Nt; Ge++) {
                var ur = Ye[Ge][vt];
                vt === "type" && at.indexOf(At) !== -1 && at.indexOf(ur) !== -1 && At !== ur ? Pt = !0 : Ye[Ge][vt] !== At && (Nt = !1);
              }
              Nt && (Mt && (Ee[Re[0]._name].type = "linear"), Pt && (Ee[Ye[0]._name].type = "linear"), nr(Ee, vt, Re, Ye, he._fullLayout._dfltTitle));
            }
          }
          for (ze = 0; ze < he._fullLayout.annotations.length; ze++) {
            var Ht = he._fullLayout.annotations[ze];
            fe.indexOf(Ht.xref) !== -1 && Pe.indexOf(Ht.yref) !== -1 && o.swapAttrs(Ee.annotations[ze], ["?"]);
          }
        }
        function nr(he, fe, Pe, Re, Ye) {
          var Ee = o.nestedProperty, ze = Ee(he[Pe[0]._name], fe).get(), Ge = Ee(he[Re[0]._name], fe).get(), Ve;
          for (fe === "title" && (ze && ze.text === Ye.x && (ze.text = Ye.y), Ge && Ge.text === Ye.y && (Ge.text = Ye.x)), Ve = 0; Ve < Pe.length; Ve++) Ee(he, Pe[Ve]._name + "." + fe).set(Ge);
          for (Ve = 0; Ve < Re.length; Ve++) Ee(he, Re[Ve]._name + "." + fe).set(ze);
        }
        function cr(he) {
          return he._id === "angularaxis";
        }
        function lr(he, fe) {
          for (var Pe = fe._rangebreaks.length, Re = 0; Re < Pe; Re++) {
            var Ye = fe._rangebreaks[Re];
            if (he >= Ye.min && he < Ye.max) return Ye.max;
          }
          return he;
        }
        function $t(he) {
          return (he.ticklabelposition || "").indexOf("inside") !== -1;
        }
        function sr(he, fe) {
          $t(he._anchorAxis || {}) && he._hideCounterAxisInsideTickLabels && he._hideCounterAxisInsideTickLabels(fe);
        }
        function St(he, fe, Pe, Re) {
          var Ye = he.anchor !== "free" && (he.overlaying === void 0 || he.overlaying === !1) ? he._id : he.overlaying, Ee;
          Re ? Ee = he.side === "right" ? fe : -fe : Ee = fe, Ye in Pe || (Pe[Ye] = {}), he.side in Pe[Ye] || (Pe[Ye][he.side] = 0), Pe[Ye][he.side] += Ee;
        }
        function Kt(he, fe) {
          return he.autoshift ? fe[he.overlaying][he.side] : he.shift || 0;
        }
        function hr(he, fe) {
          return /%f/.test(fe) ? he >= U : /%L/.test(fe) ? he >= q : /%[SX]/.test(fe) ? he >= z : /%M/.test(fe) ? he >= B : /%[HI]/.test(fe) ? he >= M : /%p/.test(fe) ? he >= P : /%[Aadejuwx]/.test(fe) ? he >= I : /%[UVW]/.test(fe) ? he >= R : /%[Bbm]/.test(fe) ? he >= T : /%[q]/.test(fe) ? he >= d : /%[Yy]/.test(fe) ? he >= h : !0;
        }
      }), Td = xe((L, k) => {
        k.exports = function(n, e, a) {
          var i, o;
          if (a) {
            var r = e === "reversed" || e === "min reversed" || e === "max reversed";
            i = a[r ? 1 : 0], o = a[r ? 0 : 1];
          }
          var s = n("autorangeoptions.minallowed", o === null ? i : void 0), c = n("autorangeoptions.maxallowed", i === null ? o : void 0);
          s === void 0 && n("autorangeoptions.clipmin"), c === void 0 && n("autorangeoptions.clipmax"), n("autorangeoptions.include");
        };
      }), ss = xe((L, k) => {
        var n = Td();
        k.exports = function(e, a, i, o) {
          var r = a._template || {}, s = a.type || r.type || "-";
          i("minallowed"), i("maxallowed");
          var c = i("range");
          if (!c) {
            var t;
            !o.noInsiderange && s !== "log" && (t = i("insiderange"), t && (t[0] === null || t[1] === null) && (a.insiderange = !1, t = void 0), t && (c = i("range", t)));
          }
          var p = a.getAutorangeDflt(c, o), l = i("autorange", p), f;
          c && (c[0] === null && c[1] === null || (c[0] === null || c[1] === null) && (l === "reversed" || l === !0) || c[0] !== null && (l === "min" || l === "max reversed") || c[1] !== null && (l === "max" || l === "min reversed")) && (c = void 0, delete a.range, a.autorange = !0, f = !0), f || (p = a.getAutorangeDflt(c, o), l = i("autorange", p)), l && (n(i, l, c), (s === "linear" || s === "-") && i("rangemode")), a.cleanRange();
        };
      }), kd = xe((L, k) => {
        var n = { left: 0, top: 0 };
        k.exports = e;
        function e(i, o, r) {
          o = o || i.currentTarget || i.srcElement, Array.isArray(r) || (r = [0, 0]);
          var s = i.clientX || 0, c = i.clientY || 0, t = a(o);
          return r[0] = s - t.left, r[1] = c - t.top, r;
        }
        function a(i) {
          return i === window || i === document || i === document.body ? n : i.getBoundingClientRect();
        }
      }), us = xe((L, k) => {
        var n = Ql();
        function e() {
          var a = !1;
          try {
            var i = Object.defineProperty({}, "passive", { get: function() {
              a = !0;
            } });
            window.addEventListener("test", null, i), window.removeEventListener("test", null, i);
          } catch {
            a = !1;
          }
          return a;
        }
        k.exports = n && e();
      }), Md = xe((L, k) => {
        k.exports = function(n, e, a, i, o) {
          var r = (n - a) / (i - a), s = r + e / (i - a), c = (r + s) / 2;
          return o === "left" || o === "bottom" ? r : o === "center" || o === "middle" ? c : o === "right" || o === "top" ? s : r < 2 / 3 - c ? r : s > 4 / 3 - c ? s : c;
        };
      }), Ad = xe((L, k) => {
        var n = wt(), e = [["sw-resize", "s-resize", "se-resize"], ["w-resize", "move", "e-resize"], ["nw-resize", "n-resize", "ne-resize"]];
        k.exports = function(a, i, o, r) {
          return o === "left" ? a = 0 : o === "center" ? a = 1 : o === "right" ? a = 2 : a = n.constrain(Math.floor(a * 3), 0, 2), r === "bottom" ? i = 0 : r === "middle" ? i = 1 : r === "top" ? i = 2 : i = n.constrain(Math.floor(i * 3), 0, 2), e[i][a];
        };
      }), Sd = xe((L, k) => {
        var n = Ti(), e = ho(), a = _i().getGraphDiv, i = bi(), o = k.exports = {};
        o.wrapped = function(r, s, c) {
          r = a(r), r._fullLayout && e.clear(r._fullLayout._uid + i.HOVERID), o.raw(r, s, c);
        }, o.raw = function(r, s) {
          var c = r._fullLayout, t = r._hoverdata;
          s || (s = {}), !(s.target && !r._dragged && n.triggerHandler(r, "plotly_beforehover", s) === !1) && (c._hoverlayer.selectAll("g").remove(), c._hoverlayer.selectAll("line").remove(), c._hoverlayer.selectAll("circle").remove(), r._hoverdata = void 0, s.target && t && r.emit("plotly_unhover", { event: s, points: t }));
        };
      }), Jn = xe((L, k) => {
        var n = kd(), e = es(), a = us(), i = wt().removeElement, o = mn(), r = k.exports = {};
        r.align = Md(), r.getCursor = Ad();
        var s = Sd();
        r.unhover = s.wrapped, r.unhoverRaw = s.raw, r.init = function(p) {
          var l = p.gd, f = 1, v = l._context.doubleClickDelay, g = p.element, x, h, m, u, d, y, _, T;
          l._mouseDownTime || (l._mouseDownTime = 0), g.style.pointerEvents = "all", g.onmousedown = P, a ? (g._ontouchstart && g.removeEventListener("touchstart", g._ontouchstart), g._ontouchstart = P, g.addEventListener("touchstart", P, { passive: !1 })) : g.ontouchstart = P;
          function R(z, q, U) {
            return Math.abs(z) < U && (z = 0), Math.abs(q) < U && (q = 0), [z, q];
          }
          var I = p.clampFn || R;
          function P(z) {
            l._dragged = !1, l._dragging = !0;
            var q = t(z);
            x = q[0], h = q[1], _ = z.target, y = z, T = z.buttons === 2 || z.ctrlKey, typeof z.clientX > "u" && typeof z.clientY > "u" && (z.clientX = x, z.clientY = h), m = (/* @__PURE__ */ new Date()).getTime(), m - l._mouseDownTime < v ? f += 1 : (f = 1, l._mouseDownTime = m), p.prepFn && p.prepFn(z, x, h), e && !T ? (d = c(), d.style.cursor = window.getComputedStyle(g).cursor) : e || (d = document, u = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(g).cursor), document.addEventListener("mouseup", B), document.addEventListener("touchend", B), p.dragmode !== !1 && (z.preventDefault(), document.addEventListener("mousemove", M), document.addEventListener("touchmove", M, { passive: !1 }));
          }
          function M(z) {
            z.preventDefault();
            var q = t(z), U = p.minDrag || o.MINDRAG, G = I(q[0] - x, q[1] - h, U), K = G[0], te = G[1];
            (K || te) && (l._dragged = !0, r.unhover(l, z)), l._dragged && p.moveFn && !T && (l._dragdata = { element: g, dx: K, dy: te }, p.moveFn(K, te));
          }
          function B(z) {
            if (delete l._dragdata, p.dragmode !== !1 && (z.preventDefault(), document.removeEventListener("mousemove", M), document.removeEventListener("touchmove", M)), document.removeEventListener("mouseup", B), document.removeEventListener("touchend", B), e ? i(d) : u && (d.documentElement.style.cursor = u, u = null), !l._dragging) {
              l._dragged = !1;
              return;
            }
            if (l._dragging = !1, (/* @__PURE__ */ new Date()).getTime() - l._mouseDownTime > v && (f = Math.max(f - 1, 1)), l._dragged) p.doneFn && p.doneFn();
            else {
              var q;
              y.target === _ ? q = y : (q = { target: _, srcElement: _, toElement: _ }, Object.keys(y).concat(Object.keys(y.__proto__)).forEach((U) => {
                var G = y[U];
                !q[U] && typeof G != "function" && (q[U] = G);
              })), p.clickFn && p.clickFn(f, q), T || _.dispatchEvent(new MouseEvent("click", z));
            }
            l._dragging = !1, l._dragged = !1;
          }
        };
        function c() {
          var p = document.createElement("div");
          p.className = "dragcover";
          var l = p.style;
          return l.position = "fixed", l.left = 0, l.right = 0, l.top = 0, l.bottom = 0, l.zIndex = 999999999, l.background = "none", document.body.appendChild(p), p;
        }
        r.coverSlip = c;
        function t(p) {
          return n(p.changedTouches ? p.changedTouches[0] : p, document.body);
        }
      }), Aa = xe((L, k) => {
        k.exports = function(n, e) {
          (n.attr("class") || "").split(" ").forEach(function(a) {
            a.indexOf("cursor-") === 0 && n.classed(a, !1);
          }), e && n.classed("cursor-" + e, !0);
        };
      }), Ld = xe((L, k) => {
        var n = Aa(), e = "data-savedcursor", a = "!!";
        k.exports = function(i, o) {
          var r = i.attr(e);
          if (o) {
            if (!r) {
              for (var s = (i.attr("class") || "").split(" "), c = 0; c < s.length; c++) {
                var t = s[c];
                t.indexOf("cursor-") === 0 && i.attr(e, t.substr(7)).classed(t, !1);
              }
              i.attr(e) || i.attr(e, a);
            }
            n(i, o);
          } else r && (i.attr(e, null), r === a ? n(i) : n(i, r));
        };
      }), cs = xe((L, k) => {
        var n = hn(), e = Zn();
        k.exports = { _isSubplotObj: !0, visible: { valType: "boolean", dflt: !0, editType: "legend" }, bgcolor: { valType: "color", editType: "legend" }, bordercolor: { valType: "color", dflt: e.defaultLine, editType: "legend" }, maxheight: { valType: "number", min: 0, editType: "legend" }, borderwidth: { valType: "number", min: 0, dflt: 0, editType: "legend" }, font: n({ editType: "legend" }), grouptitlefont: n({ editType: "legend" }), orientation: { valType: "enumerated", values: ["v", "h"], dflt: "v", editType: "legend" }, traceorder: { valType: "flaglist", flags: ["reversed", "grouped"], extras: ["normal"], editType: "legend" }, tracegroupgap: { valType: "number", min: 0, dflt: 10, editType: "legend" }, entrywidth: { valType: "number", min: 0, editType: "legend" }, entrywidthmode: { valType: "enumerated", values: ["fraction", "pixels"], dflt: "pixels", editType: "legend" }, indentation: { valType: "number", min: -15, dflt: 0, editType: "legend" }, itemsizing: { valType: "enumerated", values: ["trace", "constant"], dflt: "trace", editType: "legend" }, itemwidth: { valType: "number", min: 30, dflt: 30, editType: "legend" }, itemclick: { valType: "enumerated", values: ["toggle", "toggleothers", !1], dflt: "toggle", editType: "legend" }, itemdoubleclick: { valType: "enumerated", values: ["toggle", "toggleothers", !1], dflt: "toggleothers", editType: "legend" }, groupclick: { valType: "enumerated", values: ["toggleitem", "togglegroup"], dflt: "togglegroup", editType: "legend" }, x: { valType: "number", editType: "legend" }, xref: { valType: "enumerated", dflt: "paper", values: ["container", "paper"], editType: "layoutstyle" }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "left", editType: "legend" }, y: { valType: "number", editType: "legend" }, yref: { valType: "enumerated", dflt: "paper", values: ["container", "paper"], editType: "layoutstyle" }, yanchor: { valType: "enumerated", values: ["auto", "top", "middle", "bottom"], editType: "legend" }, uirevision: { valType: "any", editType: "none" }, valign: { valType: "enumerated", values: ["top", "middle", "bottom"], dflt: "middle", editType: "legend" }, title: { text: { valType: "string", dflt: "", editType: "legend" }, font: n({ editType: "legend" }), side: { valType: "enumerated", values: ["top", "left", "top left", "top center", "top right"], editType: "legend" }, editType: "legend" }, editType: "legend" };
      }), To = xe((L) => {
        L.isGrouped = function(k) {
          return (k.traceorder || "").indexOf("grouped") !== -1;
        }, L.isVertical = function(k) {
          return k.orientation !== "h";
        }, L.isReversed = function(k) {
          return (k.traceorder || "").indexOf("reversed") !== -1;
        };
      }), fs = xe((L, k) => {
        var n = or(), e = wt(), a = qr(), i = Pn(), o = cs(), r = Ka(), s = To();
        function c(t, p, l, f) {
          var v = p[t] || {}, g = a.newContainer(l, t);
          function x(se, O) {
            return e.coerce(v, g, o, se, O);
          }
          var h = e.coerceFont(x, "font", l.font);
          x("bgcolor", l.paper_bgcolor), x("bordercolor");
          var m = x("visible");
          if (m) {
            for (var u, d = function(se, O) {
              var F = u._input, S = u;
              return e.coerce(F, S, i, se, O);
            }, y = l.font || {}, _ = e.coerceFont(x, "grouptitlefont", y, { overrideDflt: { size: Math.round(y.size * 1.1) } }), T = 0, R = !1, I = "normal", P = (l.shapes || []).filter(function(se) {
              return se.showlegend;
            }), M = f.concat(P).filter(function(se) {
              return t === (se.legend || "legend");
            }), B = 0; B < M.length; B++) if (u = M[B], !!u.visible) {
              var z = u._isShape;
              (u.showlegend || u._dfltShowLegend && !(u._module && u._module.attributes && u._module.attributes.showlegend && u._module.attributes.showlegend.dflt === !1)) && (T++, u.showlegend && (R = !0, (!z && n.traceIs(u, "pie-like") || u._input.showlegend === !0) && T++), e.coerceFont(d, "legendgrouptitle.font", _)), (!z && n.traceIs(u, "bar") && l.barmode === "stack" || ["tonextx", "tonexty"].indexOf(u.fill) !== -1) && (I = s.isGrouped({ traceorder: I }) ? "grouped+reversed" : "reversed"), u.legendgroup !== void 0 && u.legendgroup !== "" && (I = s.isReversed({ traceorder: I }) ? "reversed+grouped" : "grouped");
            }
            var q = e.coerce(p, l, r, "showlegend", R && T > (t === "legend" ? 1 : 0));
            if (q === !1 && (l[t] = void 0), !(q === !1 && !v.uirevision) && (x("uirevision", l.uirevision), q !== !1)) {
              x("borderwidth");
              var U = x("orientation"), G = x("yref"), K = x("xref"), te = U === "h", V = G === "paper", Z = K === "paper", Y, C, j, J = "left";
              te ? (Y = 0, n.getComponentMethod("rangeslider", "isVisible")(p.xaxis) ? V ? (C = 1.1, j = "bottom") : (C = 1, j = "top") : V ? (C = -0.1, j = "top") : (C = 0, j = "bottom")) : (C = 1, j = "auto", Z ? Y = 1.02 : (Y = 1, J = "right")), e.coerce(v, g, { x: { valType: "number", editType: "legend", min: Z ? -2 : 0, max: Z ? 3 : 1, dflt: Y } }, "x"), e.coerce(v, g, { y: { valType: "number", editType: "legend", min: V ? -2 : 0, max: V ? 3 : 1, dflt: C } }, "y"), x("traceorder", I), s.isGrouped(l[t]) && x("tracegroupgap"), x("entrywidth"), x("entrywidthmode"), x("indentation"), x("itemsizing"), x("itemwidth"), x("itemclick"), x("itemdoubleclick"), x("groupclick"), x("xanchor", J), x("yanchor", j), x("maxheight"), x("valign"), e.noneOrAll(v, g, ["x", "y"]);
              var ne = x("title.text");
              if (ne) {
                x("title.side", te ? "left" : "top");
                var ae = e.extendFlat({}, h, { size: e.bigFont(h.size) });
                e.coerceFont(x, "title.font", ae);
              }
            }
          }
        }
        k.exports = function(t, p, l) {
          var f, v = l.slice(), g = p.shapes;
          if (g) for (f = 0; f < g.length; f++) {
            var x = g[f];
            if (x.showlegend) {
              var h = { _input: x._input, visible: x.visible, showlegend: x.showlegend, legend: x.legend };
              v.push(h);
            }
          }
          var m = ["legend"];
          for (f = 0; f < v.length; f++) e.pushUnique(m, v[f].legend);
          for (p._legends = [], f = 0; f < m.length; f++) {
            var u = m[f];
            c(u, t, p, v), p[u] && (p[u]._id = u), p._legends.push(u);
          }
        };
      }), Od = xe((L, k) => {
        var n = or(), e = wt(), a = e.pushUnique, i = !0;
        k.exports = function(o, r, s) {
          var c = r._fullLayout;
          if (r._dragged || r._editing) return;
          var t = c.legend.itemclick, p = c.legend.itemdoubleclick, l = c.legend.groupclick;
          s === 1 && t === "toggle" && p === "toggleothers" && i && r.data && r._context.showTips && e.notifier(e._(r, "Double-click on legend to isolate one trace"), "long"), i = !1;
          var f;
          if (s === 1 ? f = t : s === 2 && (f = p), !f) return;
          var v = l === "togglegroup", g = c.hiddenlabels ? c.hiddenlabels.slice() : [], x = o.data()[0][0];
          if (x.groupTitle && x.noClick) return;
          var h = r._fullData, m = (c.shapes || []).filter(function(ke) {
            return ke.showlegend;
          }), u = h.concat(m), d = x.trace;
          d._isShape && (d = d._fullInput);
          var y = d.legendgroup, _, T, R, I, P, M, B = {}, z = [], q = [], U = [];
          function G(ke, A) {
            var X = z.indexOf(ke), H = B.visible;
            return H || (H = B.visible = []), z.indexOf(ke) === -1 && (z.push(ke), X = z.length - 1), H[X] = A, X;
          }
          var K = (c.shapes || []).map(function(ke) {
            return ke._input;
          }), te = !1;
          function V(ke, A) {
            K[ke].visible = A, te = !0;
          }
          function Z(ke, A) {
            if (!(x.groupTitle && !v)) {
              var X = ke._fullInput || ke, H = X._isShape, ve = X.index;
              ve === void 0 && (ve = X._index);
              var be = X.visible === !1 ? !1 : A;
              H ? V(ve, be) : G(ve, be);
            }
          }
          var Y = d.legend, C = d._fullInput, j = C && C._isShape;
          if (!j && n.traceIs(d, "pie-like")) {
            var J = x.label, ne = g.indexOf(J);
            if (f === "toggle") ne === -1 ? g.push(J) : g.splice(ne, 1);
            else if (f === "toggleothers") {
              var ae = ne !== -1, se = [];
              for (_ = 0; _ < r.calcdata.length; _++) {
                var O = r.calcdata[_];
                for (T = 0; T < O.length; T++) {
                  var F = O[T], S = F.label;
                  Y === O[0].trace.legend && J !== S && (g.indexOf(S) === -1 && (ae = !0), a(g, S), se.push(S));
                }
              }
              if (!ae) for (var $ = 0; $ < se.length; $++) {
                var re = g.indexOf(se[$]);
                re !== -1 && g.splice(re, 1);
              }
            }
            n.call("_guiRelayout", r, "hiddenlabels", g);
          } else {
            var E = y && y.length, w = [], N;
            if (E) for (_ = 0; _ < u.length; _++) N = u[_], N.visible && N.legendgroup === y && w.push(_);
            if (f === "toggle") {
              var W;
              switch (d.visible) {
                case !0:
                  W = "legendonly";
                  break;
                case !1:
                  W = !1;
                  break;
                case "legendonly":
                  W = !0;
                  break;
              }
              if (E) if (v) for (_ = 0; _ < u.length; _++) {
                var ee = u[_];
                ee.visible !== !1 && ee.legendgroup === y && Z(ee, W);
              }
              else Z(d, W);
              else Z(d, W);
            } else if (f === "toggleothers") {
              var le, ie, pe, _e, Ae, Ce = !0;
              for (_ = 0; _ < u.length; _++) if (Ae = u[_], le = Ae === d, pe = Ae.showlegend !== !0, !(le || pe) && (ie = E && Ae.legendgroup === y, !ie && Ae.legend === Y && Ae.visible === !0 && !n.traceIs(Ae, "notLegendIsolatable"))) {
                Ce = !1;
                break;
              }
              for (_ = 0; _ < u.length; _++) if (Ae = u[_], !(Ae.visible === !1 || Ae.legend !== Y) && !n.traceIs(Ae, "notLegendIsolatable")) switch (d.visible) {
                case "legendonly":
                  Z(Ae, !0);
                  break;
                case !0:
                  _e = Ce ? !0 : "legendonly", le = Ae === d, pe = Ae.showlegend !== !0 && !Ae.legendgroup, ie = le || E && Ae.legendgroup === y, Z(Ae, ie || pe ? !0 : _e);
                  break;
              }
            }
            for (_ = 0; _ < q.length; _++) if (R = q[_], !!R) {
              var Ue = R.constructUpdate(), Ne = Object.keys(Ue);
              for (T = 0; T < Ne.length; T++) I = Ne[T], M = B[I] = B[I] || [], M[U[_]] = Ue[I];
            }
            for (P = Object.keys(B), _ = 0; _ < P.length; _++) for (I = P[_], T = 0; T < z.length; T++) B[I].hasOwnProperty(T) || (B[I][T] = void 0);
            te ? n.call("_guiUpdate", r, B, { shapes: K }, z) : n.call("_guiRestyle", r, B, z);
          }
        };
      }), ds = xe((L, k) => {
        k.exports = { scrollBarWidth: 6, scrollBarMinHeight: 20, scrollBarColor: "#808BA4", scrollBarMargin: 4, scrollBarEnterAttrs: { rx: 20, ry: 3, width: 0, height: 0 }, titlePad: 2, itemGap: 5 };
      }), Cd = xe((L, k) => {
        var n = or(), e = To();
        k.exports = function(a, i, o) {
          var r = i._inHover, s = e.isGrouped(i), c = e.isReversed(i), t = {}, p = [], l = !1, f = {}, v = 0, g = 0, x, h;
          function m(Z, Y, C) {
            if (i.visible !== !1 && !(o && Z !== i._id)) if (Y === "" || !e.isGrouped(i)) {
              var j = "~~i" + v;
              p.push(j), t[j] = [C], v++;
            } else p.indexOf(Y) === -1 ? (p.push(Y), l = !0, t[Y] = [C]) : t[Y].push(C);
          }
          for (x = 0; x < a.length; x++) {
            var u = a[x], d = u[0], y = d.trace, _ = y.legend, T = y.legendgroup;
            if (!(!r && (!y.visible || !y.showlegend))) if (n.traceIs(y, "pie-like")) for (f[T] || (f[T] = {}), h = 0; h < u.length; h++) {
              var R = u[h].label;
              f[T][R] || (m(_, T, { label: R, color: u[h].color, i: u[h].i, trace: y, pts: u[h].pts }), f[T][R] = !0, g = Math.max(g, (R || "").length));
            }
            else m(_, T, d), g = Math.max(g, (y.name || "").length);
          }
          if (!p.length) return [];
          var I = !l || !s, P = [];
          for (x = 0; x < p.length; x++) {
            var M = t[p[x]];
            I ? P.push(M[0]) : P.push(M);
          }
          for (I && (P = [P]), x = 0; x < P.length; x++) {
            var B = 1 / 0;
            for (h = 0; h < P[x].length; h++) {
              var z = P[x][h].trace.legendrank;
              B > z && (B = z);
            }
            P[x][0]._groupMinRank = B, P[x][0]._preGroupSort = x;
          }
          var q = function(Z, Y) {
            return Z[0]._groupMinRank - Y[0]._groupMinRank || Z[0]._preGroupSort - Y[0]._preGroupSort;
          }, U = function(Z, Y) {
            return Z.trace.legendrank - Y.trace.legendrank || Z._preSort - Y._preSort;
          };
          for (P.forEach(function(Z, Y) {
            Z[0]._preGroupSort = Y;
          }), P.sort(q), x = 0; x < P.length; x++) {
            P[x].forEach(function(Z, Y) {
              Z._preSort = Y;
            }), P[x].sort(U);
            var G = P[x][0].trace, K = null;
            for (h = 0; h < P[x].length; h++) {
              var te = P[x][h].trace.legendgrouptitle;
              if (te && te.text) {
                K = te, r && (te.font = i._groupTitleFont);
                break;
              }
            }
            if (c && P[x].reverse(), K) {
              var V = !1;
              for (h = 0; h < P[x].length; h++) if (n.traceIs(P[x][h].trace, "pie-like")) {
                V = !0;
                break;
              }
              P[x].unshift({ i: -1, groupTitle: K, noClick: V, trace: { showlegend: G.showlegend, legendgroup: G.legendgroup, visible: i.groupclick === "toggleitem" ? !0 : G.visible } });
            }
            for (h = 0; h < P[x].length; h++) P[x][h] = [P[x][h]];
          }
          return i._lgroupsLength = P.length, i._maxNameLength = g, P;
        };
      }), ko = xe((L) => {
        var k = wt();
        function n(e) {
          return e.indexOf("e") !== -1 ? e.replace(/[.]?0+e/, "e") : e.indexOf(".") !== -1 ? e.replace(/[.]?0+$/, "") : e;
        }
        L.formatPiePercent = function(e, a) {
          var i = n((e * 100).toPrecision(3));
          return k.numSeparate(i, a) + "%";
        }, L.formatPieValue = function(e, a) {
          var i = n(e.toPrecision(10));
          return k.numSeparate(i, a);
        }, L.getFirstFilled = function(e, a) {
          if (k.isArrayOrTypedArray(e)) for (var i = 0; i < a.length; i++) {
            var o = e[a[i]];
            if (o || o === 0 || o === "") return o;
          }
        }, L.castOption = function(e, a) {
          if (k.isArrayOrTypedArray(e)) return L.getFirstFilled(e, a);
          if (e) return e;
        }, L.getRotationAngle = function(e) {
          return (e === "auto" ? 0 : e) * Math.PI / 180;
        };
      }), Ed = xe((L, k) => {
        var n = Or(), e = fr();
        k.exports = function(a, i, o, r) {
          var s = o.marker.pattern;
          s && s.shape ? n.pointStyle(a, o, r, i) : e.fill(a, i.color);
        };
      }), Mo = xe((L, k) => {
        var n = fr(), e = ko().castOption, a = Ed();
        k.exports = function(i, o, r, s) {
          var c = r.marker.line, t = e(c.color, o.pts) || n.defaultLine, p = e(c.width, o.pts) || 0;
          i.call(a, o, r, s).style("stroke-width", p).call(n.stroke, t);
        };
      }), ps = xe((L, k) => {
        var n = vr(), e = or(), a = wt(), i = a.strTranslate, o = Or(), r = fr(), s = Un().extractOpts, c = Fn(), t = Mo(), p = ko().castOption, l = ds(), f = 12, v = 5, g = 2, x = 10, h = 5;
        k.exports = function(y, _, T) {
          var R = _._fullLayout;
          T || (T = R.legend);
          var I = T.itemsizing === "constant", P = T.itemwidth, M = (P + l.itemGap * 2) / 2, B = i(M, 0), z = function(se, O, F, S) {
            var $;
            if (se + 1) $ = se;
            else if (O && O.width > 0) $ = O.width;
            else return 0;
            return I ? S : Math.min($, F);
          };
          y.each(function(se) {
            var O = n.select(this), F = a.ensureSingle(O, "g", "layers");
            F.style("opacity", se[0].trace.opacity);
            var S = T.indentation, $ = T.valign, re = se[0].lineHeight, E = se[0].height;
            if ($ === "middle" && S === 0 || !re || !E) F.attr("transform", null);
            else {
              var w = { top: 1, bottom: -1 }[$], N = w * (0.5 * (re - E + 3)) || 0, W = T.indentation;
              F.attr("transform", i(W, N));
            }
            var ee = F.selectAll("g.legendfill").data([se]);
            ee.enter().append("g").classed("legendfill", !0);
            var le = F.selectAll("g.legendlines").data([se]);
            le.enter().append("g").classed("legendlines", !0);
            var ie = F.selectAll("g.legendsymbols").data([se]);
            ie.enter().append("g").classed("legendsymbols", !0), ie.selectAll("g.legendpoints").data([se]).enter().append("g").classed("legendpoints", !0);
          }).each(ae).each(G).each(te).each(K).each(Z).each(J).each(j).each(q).each(U).each(Y).each(C);
          function q(se) {
            var O = u(se), F = O.showFill, S = O.showLine, $ = O.showGradientLine, re = O.showGradientFill, E = O.anyFill, w = O.anyLine, N = se[0], W = N.trace, ee, le, ie = s(W), pe = ie.colorscale, _e = ie.reversescale, Ae = function(H) {
              if (H.size()) if (F) o.fillGroupStyle(H, _, !0);
              else {
                var ve = "legendfill-" + W.uid;
                o.gradient(H, _, ve, m(_e), pe, "fill");
              }
            }, Ce = function(H) {
              if (H.size()) {
                var ve = "legendline-" + W.uid;
                o.lineGroupStyle(H), o.gradient(H, _, ve, m(_e), pe, "stroke");
              }
            }, Ue = c.hasMarkers(W) || !E ? "M5,0" : w ? "M5,-2" : "M5,-3", Ne = n.select(this), ke = Ne.select(".legendfill").selectAll("path").data(F || re ? [se] : []);
            if (ke.enter().append("path").classed("js-fill", !0), ke.exit().remove(), ke.attr("d", Ue + "h" + P + "v6h-" + P + "z").call(Ae), S || $) {
              var A = z(void 0, W.line, x, v);
              le = a.minExtend(W, { line: { width: A } }), ee = [a.minExtend(N, { trace: le })];
            }
            var X = Ne.select(".legendlines").selectAll("path").data(S || $ ? [ee] : []);
            X.enter().append("path").classed("js-line", !0), X.exit().remove(), X.attr("d", Ue + ($ ? "l" + P + ",0.0001" : "h" + P)).call(S ? o.lineGroupStyle : Ce);
          }
          function U(se) {
            var O = u(se), F = O.anyFill, S = O.anyLine, $ = O.showLine, re = O.showMarker, E = se[0], w = E.trace, N = !re && !S && !F && c.hasText(w), W, ee;
            function le(ke, A, X, H) {
              var ve = a.nestedProperty(w, ke).get(), be = a.isArrayOrTypedArray(ve) && A ? A(ve) : ve;
              if (I && be && H !== void 0 && (be = H), X) {
                if (be < X[0]) return X[0];
                if (be > X[1]) return X[1];
              }
              return be;
            }
            function ie(ke) {
              return E._distinct && E.index && ke[E.index] ? ke[E.index] : ke[0];
            }
            if (re || N || $) {
              var pe = {}, _e = {};
              if (re) {
                pe.mc = le("marker.color", ie), pe.mx = le("marker.symbol", ie), pe.mo = le("marker.opacity", a.mean, [0.2, 1]), pe.mlc = le("marker.line.color", ie), pe.mlw = le("marker.line.width", a.mean, [0, 5], g), _e.marker = { sizeref: 1, sizemin: 1, sizemode: "diameter" };
                var Ae = le("marker.size", a.mean, [2, 16], f);
                pe.ms = Ae, _e.marker.size = Ae;
              }
              $ && (_e.line = { width: le("line.width", ie, [0, 10], v) }), N && (pe.tx = "Aa", pe.tp = le("textposition", ie), pe.ts = 10, pe.tc = le("textfont.color", ie), pe.tf = le("textfont.family", ie), pe.tw = le("textfont.weight", ie), pe.ty = le("textfont.style", ie), pe.tv = le("textfont.variant", ie), pe.tC = le("textfont.textcase", ie), pe.tE = le("textfont.lineposition", ie), pe.tS = le("textfont.shadow", ie)), W = [a.minExtend(E, pe)], ee = a.minExtend(w, _e), ee.selectedpoints = null, ee.texttemplate = null;
            }
            var Ce = n.select(this).select("g.legendpoints"), Ue = Ce.selectAll("path.scatterpts").data(re ? W : []);
            Ue.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", B), Ue.exit().remove(), Ue.call(o.pointStyle, ee, _), re && (W[0].mrc = 3);
            var Ne = Ce.selectAll("g.pointtext").data(N ? W : []);
            Ne.enter().append("g").classed("pointtext", !0).append("text").attr("transform", B), Ne.exit().remove(), Ne.selectAll("text").call(o.textPointStyle, ee, _);
          }
          function G(se) {
            var O = se[0].trace, F = O.type === "waterfall";
            if (se[0]._distinct && F) {
              var S = se[0].trace[se[0].dir].marker;
              return se[0].mc = S.color, se[0].mlw = S.line.width, se[0].mlc = S.line.color, V(se, this, "waterfall");
            }
            var $ = [];
            O.visible && F && ($ = se[0].hasTotals ? [["increasing", "M-6,-6V6H0Z"], ["totals", "M6,6H0L-6,-6H-0Z"], ["decreasing", "M6,6V-6H0Z"]] : [["increasing", "M-6,-6V6H6Z"], ["decreasing", "M6,6V-6H-6Z"]]);
            var re = n.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data($);
            re.enter().append("path").classed("legendwaterfall", !0).attr("transform", B).style("stroke-miterlimit", 1), re.exit().remove(), re.each(function(E) {
              var w = n.select(this), N = O[E[0]].marker, W = z(void 0, N.line, h, g);
              w.attr("d", E[1]).style("stroke-width", W + "px").call(r.fill, N.color), W && w.call(r.stroke, N.line.color);
            });
          }
          function K(se) {
            V(se, this);
          }
          function te(se) {
            V(se, this, "funnel");
          }
          function V(se, O, F) {
            var S = se[0].trace, $ = S.marker || {}, re = $.line || {}, E = $.cornerradius ? "M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z" : "M6,6H-6V-6H6Z", w = F ? S.visible && S.type === F : e.traceIs(S, "bar"), N = n.select(O).select("g.legendpoints").selectAll("path.legend" + F).data(w ? [se] : []);
            N.enter().append("path").classed("legend" + F, !0).attr("d", E).attr("transform", B), N.exit().remove(), N.each(function(W) {
              var ee = n.select(this), le = W[0], ie = z(le.mlw, $.line, h, g);
              ee.style("stroke-width", ie + "px");
              var pe = le.mcc;
              if (!T._inHover && "mc" in le) {
                var _e = s($), Ae = _e.mid;
                Ae === void 0 && (Ae = (_e.max + _e.min) / 2), pe = o.tryColorscale($, "")(Ae);
              }
              var Ce = pe || le.mc || $.color, Ue = $.pattern, Ne = o.getPatternAttr, ke = Ue && (Ne(Ue.shape, 0, "") || Ne(Ue.path, 0, ""));
              if (ke) {
                var A = Ne(Ue.bgcolor, 0, null), X = Ne(Ue.fgcolor, 0, null), H = Ue.fgopacity, ve = d(Ue.size, 8, 10), be = d(Ue.solidity, 0.5, 1), Se = "legend-" + S.uid;
                ee.call(o.pattern, "legend", _, Se, ke, ve, be, pe, Ue.fillmode, A, X, H);
              } else ee.call(r.fill, Ce);
              ie && r.stroke(ee, le.mlc || re.color);
            });
          }
          function Z(se) {
            var O = se[0].trace, F = n.select(this).select("g.legendpoints").selectAll("path.legendbox").data(O.visible && e.traceIs(O, "box-violin") ? [se] : []);
            F.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", B), F.exit().remove(), F.each(function() {
              var S = n.select(this);
              if ((O.boxpoints === "all" || O.points === "all") && r.opacity(O.fillcolor) === 0 && r.opacity((O.line || {}).color) === 0) {
                var $ = a.minExtend(O, { marker: { size: I ? f : a.constrain(O.marker.size, 2, 16), sizeref: 1, sizemin: 1, sizemode: "diameter" } });
                F.call(o.pointStyle, $, _);
              } else {
                var re = z(void 0, O.line, h, g);
                S.style("stroke-width", re + "px").call(r.fill, O.fillcolor), re && r.stroke(S, O.line.color);
              }
            });
          }
          function Y(se) {
            var O = se[0].trace, F = n.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(O.visible && O.type === "candlestick" ? [se, se] : []);
            F.enter().append("path").classed("legendcandle", !0).attr("d", function(S, $) {
              return $ ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
            }).attr("transform", B).style("stroke-miterlimit", 1), F.exit().remove(), F.each(function(S, $) {
              var re = n.select(this), E = O[$ ? "increasing" : "decreasing"], w = z(void 0, E.line, h, g);
              re.style("stroke-width", w + "px").call(r.fill, E.fillcolor), w && r.stroke(re, E.line.color);
            });
          }
          function C(se) {
            var O = se[0].trace, F = n.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(O.visible && O.type === "ohlc" ? [se, se] : []);
            F.enter().append("path").classed("legendohlc", !0).attr("d", function(S, $) {
              return $ ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
            }).attr("transform", B).style("stroke-miterlimit", 1), F.exit().remove(), F.each(function(S, $) {
              var re = n.select(this), E = O[$ ? "increasing" : "decreasing"], w = z(void 0, E.line, h, g);
              re.style("fill", "none").call(o.dashLine, E.line.dash, w), w && r.stroke(re, E.line.color);
            });
          }
          function j(se) {
            ne(se, this, "pie");
          }
          function J(se) {
            ne(se, this, "funnelarea");
          }
          function ne(se, O, F) {
            var S = se[0], $ = S.trace, re = F ? $.visible && $.type === F : e.traceIs($, F), E = n.select(O).select("g.legendpoints").selectAll("path.legend" + F).data(re ? [se] : []);
            if (E.enter().append("path").classed("legend" + F, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", B), E.exit().remove(), E.size()) {
              var w = $.marker || {}, N = z(p(w.line.width, S.pts), w.line, h, g), W = "pieLike", ee = a.minExtend($, { marker: { line: { width: N } } }, W), le = a.minExtend(S, { trace: ee }, W);
              t(E, le, ee, _);
            }
          }
          function ae(se) {
            var O = se[0].trace, F, S = [];
            if (O.visible) switch (O.type) {
              case "histogram2d":
              case "heatmap":
                S = [["M-15,-2V4H15V-2Z"]], F = !0;
                break;
              case "choropleth":
              case "choroplethmapbox":
              case "choroplethmap":
                S = [["M-6,-6V6H6V-6Z"]], F = !0;
                break;
              case "densitymapbox":
              case "densitymap":
                S = [["M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"]], F = "radial";
                break;
              case "cone":
                S = [["M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"], ["M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"]], F = !1;
                break;
              case "streamtube":
                S = [["M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"], ["M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"], ["M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"]], F = !1;
                break;
              case "surface":
                S = [["M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"], ["M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"]], F = !0;
                break;
              case "mesh3d":
                S = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], F = !1;
                break;
              case "volume":
                S = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6H6L0,6Z"]], F = !0;
                break;
              case "isosurface":
                S = [["M-6,6H0L-6,-6Z"], ["M6,6H0L6,-6Z"], ["M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"]], F = !1;
                break;
            }
            var $ = n.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(S);
            $.enter().append("path").classed("legend3dandfriends", !0).attr("transform", B).style("stroke-miterlimit", 1), $.exit().remove(), $.each(function(re, E) {
              var w = n.select(this), N = s(O), W = N.colorscale, ee = N.reversescale, le = function(Ae) {
                if (Ae.size()) {
                  var Ce = "legendfill-" + O.uid;
                  o.gradient(Ae, _, Ce, m(ee, F === "radial"), W, "fill");
                }
              }, ie;
              if (W) {
                if (!F) {
                  var pe = W.length;
                  ie = E === 0 ? W[ee ? pe - 1 : 0][1] : E === 1 ? W[ee ? 0 : pe - 1][1] : W[Math.floor((pe - 1) / 2)][1];
                }
              } else {
                var _e = O.vertexcolor || O.facecolor || O.color;
                ie = a.isArrayOrTypedArray(_e) ? _e[E] || _e[0] : _e;
              }
              w.attr("d", re[0]), ie ? w.call(r.fill, ie) : w.call(le);
            });
          }
        };
        function m(y, _) {
          var T = _ ? "radial" : "horizontal";
          return T + (y ? "" : "reversed");
        }
        function u(y) {
          var _ = y[0].trace, T = _.contours, R = c.hasLines(_), I = c.hasMarkers(_), P = _.visible && _.fill && _.fill !== "none", M = !1, B = !1;
          if (T) {
            var z = T.coloring;
            z === "lines" ? M = !0 : R = z === "none" || z === "heatmap" || T.showlines, T.type === "constraint" ? P = T._operation !== "=" : (z === "fill" || z === "heatmap") && (B = !0);
          }
          return { showMarker: I, showLine: R, showFill: P, showGradientLine: M, showGradientFill: B, anyLine: R || M, anyFill: P || B };
        }
        function d(y, _, T) {
          return y && a.isArrayOrTypedArray(y) ? _ : y > T ? T : y;
        }
      }), hs = xe((L, k) => {
        var n = vr(), e = wt(), a = on(), i = or(), o = Ti(), r = Jn(), s = Or(), c = fr(), t = xn(), p = Od(), l = ds(), f = kn(), v = f.LINE_SPACING, g = f.FROM_TL, x = f.FROM_BR, h = Cd(), m = ps(), u = To(), d = 1, y = /^legend[0-9]*$/;
        k.exports = function(Y, C) {
          if (C) T(Y, C);
          else {
            var j = Y._fullLayout, J = j._legends, ne = j._infolayer.selectAll('[class^="legend"]');
            ne.each(function() {
              var F = n.select(this), S = F.attr("class"), $ = S.split(" ")[0];
              $.match(y) && J.indexOf($) === -1 && F.remove();
            });
            for (var ae = 0; ae < J.length; ae++) {
              var se = J[ae], O = Y._fullLayout[se];
              T(Y, O);
            }
          }
        };
        function _(Y, C, j) {
          if (!(C.title.side !== "top center" && C.title.side !== "top right")) {
            var J = C.title.font, ne = J.size * v, ae = 0, se = Y.node(), O = s.bBox(se).width;
            C.title.side === "top center" ? ae = 0.5 * (C._width - 2 * j - 2 * l.titlePad - O) : C.title.side === "top right" && (ae = C._width - 2 * j - 2 * l.titlePad - O), t.positionText(Y, j + l.titlePad + ae, j + ne);
          }
        }
        function T(Y, C) {
          var j = C || {}, J = Y._fullLayout, ne = Z(j), ae, se, O = j._inHover;
          if (O ? (se = j.layer, ae = "hover") : (se = J._infolayer, ae = ne), !!se) {
            ae += J._uid, Y._legendMouseDownTime || (Y._legendMouseDownTime = 0);
            var F;
            if (O) {
              if (!j.entries) return;
              F = h(j.entries, j);
            } else {
              for (var S = (Y.calcdata || []).slice(), $ = J.shapes, re = 0; re < $.length; re++) {
                var E = $[re];
                if (E.showlegend) {
                  var w = { _isShape: !0, _fullInput: E, index: E._index, name: E.name || E.label.text || "shape " + E._index, legend: E.legend, legendgroup: E.legendgroup, legendgrouptitle: E.legendgrouptitle, legendrank: E.legendrank, legendwidth: E.legendwidth, showlegend: E.showlegend, visible: E.visible, opacity: E.opacity, mode: E.type === "line" ? "lines" : "markers", line: E.line, marker: { line: E.line, color: E.fillcolor, size: 12, symbol: E.type === "rect" ? "square" : E.type === "circle" ? "circle" : "hexagon2" } };
                  S.push([{ trace: w }]);
                }
              }
              F = J.showlegend && h(S, j, J._legends.length > 1);
            }
            var N = J.hiddenlabels || [];
            if (!O && (!J.showlegend || !F.length)) return se.selectAll("." + ne).remove(), J._topdefs.select("#" + ae).remove(), a.autoMargin(Y, ne);
            var W = e.ensureSingle(se, "g", ne, function(Ne) {
              O || Ne.attr("pointer-events", "all");
            }), ee = e.ensureSingleById(J._topdefs, "clipPath", ae, function(Ne) {
              Ne.append("rect");
            }), le = e.ensureSingle(W, "rect", "bg", function(Ne) {
              Ne.attr("shape-rendering", "crispEdges");
            });
            le.call(c.stroke, j.bordercolor).call(c.fill, j.bgcolor).style("stroke-width", j.borderwidth + "px");
            var ie = e.ensureSingle(W, "g", "scrollbox"), pe = j.title;
            j._titleWidth = 0, j._titleHeight = 0;
            var _e;
            pe.text ? (_e = e.ensureSingle(ie, "text", ne + "titletext"), _e.attr("text-anchor", "start").call(s.font, pe.font).text(pe.text), z(_e, ie, Y, j, d)) : ie.selectAll("." + ne + "titletext").remove();
            var Ae = e.ensureSingle(W, "rect", "scrollbar", function(Ne) {
              Ne.attr(l.scrollBarEnterAttrs).call(c.fill, l.scrollBarColor);
            }), Ce = ie.selectAll("g.groups").data(F);
            Ce.enter().append("g").attr("class", "groups"), Ce.exit().remove();
            var Ue = Ce.selectAll("g.traces").data(e.identity);
            Ue.enter().append("g").attr("class", "traces"), Ue.exit().remove(), Ue.style("opacity", function(Ne) {
              var ke = Ne[0].trace;
              return i.traceIs(ke, "pie-like") ? N.indexOf(Ne[0].label) !== -1 ? 0.5 : 1 : ke.visible === "legendonly" ? 0.5 : 1;
            }).each(function() {
              n.select(this).call(P, Y, j);
            }).call(m, Y, j).each(function() {
              O || n.select(this).call(B, Y, ne);
            }), e.syncOrAsync([a.previousPromises, function() {
              return G(Y, Ce, Ue, j);
            }, function() {
              var Ne = J._size, ke = j.borderwidth, A = j.xref === "paper", X = j.yref === "paper";
              if (pe.text && _(_e, j, ke), !O) {
                var H, ve;
                A ? H = Ne.l + Ne.w * j.x - g[te(j)] * j._width : H = J.width * j.x - g[te(j)] * j._width, X ? ve = Ne.t + Ne.h * (1 - j.y) - g[V(j)] * j._effHeight : ve = J.height * (1 - j.y) - g[V(j)] * j._effHeight;
                var be = K(Y, ne, H, ve);
                if (be) return;
                if (J.margin.autoexpand) {
                  var Se = H, De = ve;
                  H = A ? e.constrain(H, 0, J.width - j._width) : Se, ve = X ? e.constrain(ve, 0, J.height - j._effHeight) : De, H !== Se && e.log("Constrain " + ne + ".x to make legend fit inside graph"), ve !== De && e.log("Constrain " + ne + ".y to make legend fit inside graph");
                }
                s.setTranslate(W, H, ve);
              }
              if (Ae.on(".drag", null), W.on("wheel", null), O || j._height <= j._maxHeight || Y._context.staticPlot) {
                var He = j._effHeight;
                O && (He = j._height), le.attr({ width: j._width - ke, height: He - ke, x: ke / 2, y: ke / 2 }), s.setTranslate(ie, 0, 0), ee.select("rect").attr({ width: j._width - 2 * ke, height: He - 2 * ke, x: ke, y: ke }), s.setClipUrl(ie, ae, Y), s.setRect(Ae, 0, 0, 0, 0), delete j._scrollY;
              } else {
                var Ze = Math.max(l.scrollBarMinHeight, j._effHeight * j._effHeight / j._height), We = j._effHeight - Ze - 2 * l.scrollBarMargin, $e = j._height - j._effHeight, it = We / $e, Ke = Math.min(j._scrollY || 0, $e);
                le.attr({ width: j._width - 2 * ke + l.scrollBarWidth + l.scrollBarMargin, height: j._effHeight - ke, x: ke / 2, y: ke / 2 }), ee.select("rect").attr({ width: j._width - 2 * ke + l.scrollBarWidth + l.scrollBarMargin, height: j._effHeight - 2 * ke, x: ke, y: ke + Ke }), s.setClipUrl(ie, ae, Y), ge(Ke, Ze, it), W.on("wheel", function() {
                  Ke = e.constrain(j._scrollY + n.event.deltaY / $e * We, 0, $e), ge(Ke, Ze, it), Ke !== 0 && Ke !== $e && n.event.preventDefault();
                });
                var ct, gt, ht, _t = function(qe, Qe, Xe) {
                  var Je = (Xe - Qe) / it + qe;
                  return e.constrain(Je, 0, $e);
                }, Te = function(qe, Qe, Xe) {
                  var Je = (Qe - Xe) / it + qe;
                  return e.constrain(Je, 0, $e);
                }, Ie = n.behavior.drag().on("dragstart", function() {
                  var qe = n.event.sourceEvent;
                  qe.type === "touchstart" ? ct = qe.changedTouches[0].clientY : ct = qe.clientY, ht = Ke;
                }).on("drag", function() {
                  var qe = n.event.sourceEvent;
                  qe.buttons === 2 || qe.ctrlKey || (qe.type === "touchmove" ? gt = qe.changedTouches[0].clientY : gt = qe.clientY, Ke = _t(ht, ct, gt), ge(Ke, Ze, it));
                });
                Ae.call(Ie);
                var ce = n.behavior.drag().on("dragstart", function() {
                  var qe = n.event.sourceEvent;
                  qe.type === "touchstart" && (ct = qe.changedTouches[0].clientY, ht = Ke);
                }).on("drag", function() {
                  var qe = n.event.sourceEvent;
                  qe.type === "touchmove" && (gt = qe.changedTouches[0].clientY, Ke = Te(ht, ct, gt), ge(Ke, Ze, it));
                });
                ie.call(ce);
              }
              function ge(qe, Qe, Xe) {
                j._scrollY = Y._fullLayout[ne]._scrollY = qe, s.setTranslate(ie, 0, -qe), s.setRect(Ae, j._width, l.scrollBarMargin + qe * Xe, l.scrollBarWidth, Qe), ee.select("rect").attr("y", ke + qe);
              }
              if (Y._context.edits.legendPosition) {
                var ye, Me, Oe, je;
                W.classed("cursor-move", !0), r.init({ element: W.node(), gd: Y, prepFn: function(qe) {
                  if (qe.target !== Ae.node()) {
                    var Qe = s.getTranslate(W);
                    Oe = Qe.x, je = Qe.y;
                  }
                }, moveFn: function(qe, Qe) {
                  if (Oe !== void 0 && je !== void 0) {
                    var Xe = Oe + qe, Je = je + Qe;
                    s.setTranslate(W, Xe, Je), ye = r.align(Xe, j._width, Ne.l, Ne.l + Ne.w, j.xanchor), Me = r.align(Je + j._height, -j._height, Ne.t + Ne.h, Ne.t, j.yanchor);
                  }
                }, doneFn: function() {
                  if (ye !== void 0 && Me !== void 0) {
                    var qe = {};
                    qe[ne + ".x"] = ye, qe[ne + ".y"] = Me, i.call("_guiRelayout", Y, qe);
                  }
                }, clickFn: function(qe, Qe) {
                  var Xe = se.selectAll("g.traces").filter(function() {
                    var Je = this.getBoundingClientRect();
                    return Qe.clientX >= Je.left && Qe.clientX <= Je.right && Qe.clientY >= Je.top && Qe.clientY <= Je.bottom;
                  });
                  Xe.size() > 0 && I(Y, W, Xe, qe, Qe);
                } });
              }
            }], Y);
          }
        }
        function R(Y, C, j) {
          var J = Y[0], ne = J.width, ae = C.entrywidthmode, se = J.trace.legendwidth || C.entrywidth;
          return ae === "fraction" ? C._maxWidth * se : j + (se || ne);
        }
        function I(Y, C, j, J, ne) {
          var ae = j.data()[0][0].trace, se = { event: ne, node: j.node(), curveNumber: ae.index, expandedIndex: ae.index, data: Y.data, layout: Y.layout, frames: Y._transitionData._frames, config: Y._context, fullData: Y._fullData, fullLayout: Y._fullLayout };
          ae._group && (se.group = ae._group), i.traceIs(ae, "pie-like") && (se.label = j.datum()[0].label);
          var O = o.triggerHandler(Y, "plotly_legendclick", se);
          if (J === 1) {
            if (O === !1) return;
            C._clickTimeout = setTimeout(function() {
              Y._fullLayout && p(j, Y, J);
            }, Y._context.doubleClickDelay);
          } else if (J === 2) {
            C._clickTimeout && clearTimeout(C._clickTimeout), Y._legendMouseDownTime = 0;
            var F = o.triggerHandler(Y, "plotly_legenddoubleclick", se);
            F !== !1 && O !== !1 && p(j, Y, J);
          }
        }
        function P(Y, C, j) {
          var J = Z(j), ne = Y.data()[0][0], ae = ne.trace, se = i.traceIs(ae, "pie-like"), O = !j._inHover && C._context.edits.legendText && !se, F = j._maxNameLength, S, $;
          ne.groupTitle ? (S = ne.groupTitle.text, $ = ne.groupTitle.font) : ($ = j.font, j.entries ? S = ne.text : (S = se ? ne.label : ae.name, ae._meta && (S = e.templateString(S, ae._meta))));
          var re = e.ensureSingle(Y, "text", J + "text");
          re.attr("text-anchor", "start").call(s.font, $).text(O ? M(S, F) : S);
          var E = j.indentation + j.itemwidth + l.itemGap * 2;
          t.positionText(re, E, 0), O ? re.call(t.makeEditable, { gd: C, text: S }).call(z, Y, C, j).on("edit", function(w) {
            this.text(M(w, F)).call(z, Y, C, j);
            var N = ne.trace._fullInput || {}, W = {};
            return W.name = w, N._isShape ? i.call("_guiRelayout", C, "shapes[" + ae.index + "].name", W.name) : i.call("_guiRestyle", C, W, ae.index);
          }) : z(re, Y, C, j);
        }
        function M(Y, C) {
          var j = Math.max(4, C);
          if (Y && Y.trim().length >= j / 2) return Y;
          Y = Y || "";
          for (var J = j - Y.length; J > 0; J--) Y += " ";
          return Y;
        }
        function B(Y, C, j) {
          var J = C._context.doubleClickDelay, ne, ae = 1, se = e.ensureSingle(Y, "rect", j + "toggle", function(O) {
            C._context.staticPlot || O.style("cursor", "pointer").attr("pointer-events", "all"), O.call(c.fill, "rgba(0,0,0,0)");
          });
          C._context.staticPlot || (se.on("mousedown", function() {
            ne = (/* @__PURE__ */ new Date()).getTime(), ne - C._legendMouseDownTime < J ? ae += 1 : (ae = 1, C._legendMouseDownTime = ne);
          }), se.on("mouseup", function() {
            if (!(C._dragged || C._editing)) {
              var O = C._fullLayout[j];
              (/* @__PURE__ */ new Date()).getTime() - C._legendMouseDownTime > J && (ae = Math.max(ae - 1, 1)), I(C, O, Y, ae, n.event);
            }
          }));
        }
        function z(Y, C, j, J, ne) {
          J._inHover && Y.attr("data-notex", !0), t.convertToTspans(Y, j, function() {
            q(C, j, J, ne);
          });
        }
        function q(Y, C, j, J) {
          var ne = Y.data()[0][0];
          if (!j._inHover && ne && !ne.trace.showlegend) {
            Y.remove();
            return;
          }
          var ae = Y.select("g[class*=math-group]"), se = ae.node(), O = Z(j);
          j || (j = C._fullLayout[O]);
          var F = j.borderwidth, S;
          J === d ? S = j.title.font : ne.groupTitle ? S = ne.groupTitle.font : S = j.font;
          var $ = S.size * v, re, E;
          if (se) {
            var w = s.bBox(se);
            re = w.height, E = w.width, J === d ? s.setTranslate(ae, F, F + re * 0.75) : s.setTranslate(ae, 0, re * 0.25);
          } else {
            var N = "." + O + (J === d ? "title" : "") + "text", W = Y.select(N), ee = t.lineCount(W), le = W.node();
            if (re = $ * ee, E = le ? s.bBox(le).width : 0, J === d) j.title.side === "left" && (E += l.itemGap * 2), t.positionText(W, F + l.titlePad, F + $);
            else {
              var ie = l.itemGap * 2 + j.indentation + j.itemwidth;
              ne.groupTitle && (ie = l.itemGap, E -= j.indentation + j.itemwidth), t.positionText(W, ie, -$ * ((ee - 1) / 2 - 0.3));
            }
          }
          J === d ? (j._titleWidth = E, j._titleHeight = re) : (ne.lineHeight = $, ne.height = Math.max(re, 16) + 3, ne.width = E);
        }
        function U(Y) {
          var C = 0, j = 0, J = Y.title.side;
          return J && (J.indexOf("left") !== -1 && (C = Y._titleWidth), J.indexOf("top") !== -1 && (j = Y._titleHeight)), [C, j];
        }
        function G(Y, C, j, J) {
          var ne = Y._fullLayout, ae = Z(J);
          J || (J = ne[ae]);
          var se = ne._size, O = u.isVertical(J), F = u.isGrouped(J), S = J.entrywidthmode === "fraction", $ = J.borderwidth, re = 2 * $, E = l.itemGap, w = J.indentation + J.itemwidth + E * 2, N = 2 * ($ + E), W = V(J), ee = J.y < 0 || J.y === 0 && W === "top", le = J.y > 1 || J.y === 1 && W === "bottom", ie = J.tracegroupgap, pe = {};
          let { orientation: _e, yref: Ae } = J, { maxheight: Ce } = J, Ue = ee || le || _e !== "v" || Ae !== "paper";
          Ce || (Ce = Ue ? 0.5 : 1);
          let Ne = Ue ? ne.height : se.h;
          J._maxHeight = Math.max(Ce > 1 ? Ce : Ce * Ne, 30);
          var ke = 0;
          J._width = 0, J._height = 0;
          var A = U(J);
          if (O) j.each(function(ge) {
            var ye = ge[0].height;
            s.setTranslate(this, $ + A[0], $ + A[1] + J._height + ye / 2 + E), J._height += ye, J._width = Math.max(J._width, ge[0].width);
          }), ke = w + J._width, J._width += E + w + re, J._height += N, F && (C.each(function(ge, ye) {
            s.setTranslate(this, 0, ye * J.tracegroupgap);
          }), J._height += (J._lgroupsLength - 1) * J.tracegroupgap);
          else {
            var X = te(J), H = J.x < 0 || J.x === 0 && X === "right", ve = J.x > 1 || J.x === 1 && X === "left", be = le || ee, Se = ne.width / 2;
            J._maxWidth = Math.max(H ? be && X === "left" ? se.l + se.w : Se : ve ? be && X === "right" ? se.r + se.w : Se : se.w, 2 * w);
            var De = 0, He = 0;
            j.each(function(ge) {
              var ye = R(ge, J, w);
              De = Math.max(De, ye), He += ye;
            }), ke = null;
            var Ze = 0;
            if (F) {
              var We = 0, $e = 0, it = 0;
              C.each(function() {
                var ge = 0, ye = 0;
                n.select(this).selectAll("g.traces").each(function(Oe) {
                  var je = R(Oe, J, w), qe = Oe[0].height;
                  s.setTranslate(this, A[0], A[1] + $ + E + qe / 2 + ye), ye += qe, ge = Math.max(ge, je), pe[Oe[0].trace.legendgroup] = ge;
                });
                var Me = ge + E;
                $e > 0 && Me + $ + $e > J._maxWidth ? (Ze = Math.max(Ze, $e), $e = 0, it += We + ie, We = ye) : We = Math.max(We, ye), s.setTranslate(this, $e, it), $e += Me;
              }), J._width = Math.max(Ze, $e) + $, J._height = it + We + N;
            } else {
              var Ke = j.size(), ct = He + re + (Ke - 1) * E < J._maxWidth, gt = 0, ht = 0, _t = 0, Te = 0;
              j.each(function(ge) {
                var ye = ge[0].height, Me = R(ge, J, w), Oe = ct ? Me : De;
                S || (Oe += E), Oe + $ + ht - E >= J._maxWidth && (Ze = Math.max(Ze, Te), ht = 0, _t += gt, J._height += gt, gt = 0), s.setTranslate(this, A[0] + $ + ht, A[1] + $ + _t + ye / 2 + E), Te = ht + Me + E, ht += Oe, gt = Math.max(gt, ye);
              }), ct ? (J._width = ht + re, J._height = gt + N) : (J._width = Math.max(Ze, Te) + re, J._height += gt + N);
            }
          }
          J._width = Math.ceil(Math.max(J._width + A[0], J._titleWidth + 2 * ($ + l.titlePad))), J._height = Math.ceil(Math.max(J._height + A[1], J._titleHeight + 2 * ($ + l.itemGap))), J._effHeight = Math.min(J._height, J._maxHeight);
          var Ie = Y._context.edits, ce = Ie.legendText || Ie.legendPosition;
          j.each(function(ge) {
            var ye = n.select(this).select("." + ae + "toggle"), Me = ge[0].height, Oe = ge[0].trace.legendgroup, je = R(ge, J, w);
            F && Oe !== "" && (je = pe[Oe]);
            var qe = ce ? w : ke || je;
            !O && !S && (qe += E / 2), s.setRect(ye, 0, -Me / 2, qe, Me);
          });
        }
        function K(Y, C, j, J) {
          var ne = Y._fullLayout, ae = ne[C], se = te(ae), O = V(ae), F = ae.xref === "paper", S = ae.yref === "paper";
          Y._fullLayout._reservedMargin[C] = {};
          var $ = ae.y < 0.5 ? "b" : "t", re = ae.x < 0.5 ? "l" : "r", E = { r: ne.width - j, l: j + ae._width, b: ne.height - J, t: J + ae._effHeight };
          if (F && S) return a.autoMargin(Y, C, { x: ae.x, y: ae.y, l: ae._width * g[se], r: ae._width * x[se], b: ae._effHeight * x[O], t: ae._effHeight * g[O] });
          F ? Y._fullLayout._reservedMargin[C][$] = E[$] : S || ae.orientation === "v" ? Y._fullLayout._reservedMargin[C][re] = E[re] : Y._fullLayout._reservedMargin[C][$] = E[$];
        }
        function te(Y) {
          return e.isRightAnchor(Y) ? "right" : e.isCenterAnchor(Y) ? "center" : "left";
        }
        function V(Y) {
          return e.isBottomAnchor(Y) ? "bottom" : e.isMiddleAnchor(Y) ? "middle" : "top";
        }
        function Z(Y) {
          return Y._id || "legend";
        }
      }), vs = xe((L) => {
        var k = vr(), n = xr(), e = Nn(), a = wt(), i = a.pushUnique, o = a.strTranslate, r = a.strRotate, s = Ti(), c = xn(), t = Ld(), p = Or(), l = fr(), f = Jn(), v = Ar(), g = mn().zindexSeparator, x = or(), h = da(), m = bi(), u = fs(), d = hs(), y = m.YANGLE, _ = Math.PI * y / 180, T = 1 / Math.sin(_), R = Math.cos(_), I = Math.sin(_), P = m.HOVERARROWSIZE, M = m.HOVERTEXTPAD, B = { box: !0, ohlc: !0, violin: !0, candlestick: !0 }, z = { scatter: !0, scattergl: !0, splom: !0 };
        function q(w, N) {
          return w.distance - N.distance;
        }
        L.hover = function(w, N, W, ee) {
          w = a.getGraphDiv(w);
          var le = N.target;
          a.throttle(w._fullLayout._uid + m.HOVERID, m.HOVERMINTIME, function() {
            U(w, N, W, ee, le);
          });
        }, L.loneHover = function(w, N) {
          var W = !0;
          Array.isArray(w) || (W = !1, w = [w]);
          var ee = N.gd, le = $(ee), ie = re(ee), pe = w.map(function(H) {
            var ve = H._x0 || H.x0 || H.x || 0, be = H._x1 || H.x1 || H.x || 0, Se = H._y0 || H.y0 || H.y || 0, De = H._y1 || H.y1 || H.y || 0, He = H.eventData;
            if (He) {
              var Ze = Math.min(ve, be), We = Math.max(ve, be), $e = Math.min(Se, De), it = Math.max(Se, De), Ke = H.trace;
              if (x.traceIs(Ke, "gl3d")) {
                var ct = ee._fullLayout[Ke.scene]._scene.container, gt = ct.offsetLeft, ht = ct.offsetTop;
                Ze += gt, We += gt, $e += ht, it += ht;
              }
              He.bbox = { x0: Ze + ie, x1: We + ie, y0: $e + le, y1: it + le }, N.inOut_bbox && N.inOut_bbox.push(He.bbox);
            } else He = !1;
            return { color: H.color || l.defaultLine, x0: H.x0 || H.x || 0, x1: H.x1 || H.x || 0, y0: H.y0 || H.y || 0, y1: H.y1 || H.y || 0, xLabel: H.xLabel, yLabel: H.yLabel, zLabel: H.zLabel, text: H.text, name: H.name, idealAlign: H.idealAlign, borderColor: H.borderColor, fontFamily: H.fontFamily, fontSize: H.fontSize, fontColor: H.fontColor, fontWeight: H.fontWeight, fontStyle: H.fontStyle, fontVariant: H.fontVariant, nameLength: H.nameLength, textAlign: H.textAlign, trace: H.trace || { index: 0, hoverinfo: "" }, xa: { _offset: 0 }, ya: { _offset: 0 }, index: 0, hovertemplate: H.hovertemplate || !1, hovertemplateLabels: H.hovertemplateLabels || !1, eventData: He };
          }), _e = !1, Ae = te(pe, { gd: ee, hovermode: "closest", rotateLabels: _e, bgColor: N.bgColor || l.background, container: k.select(N.container), outerContainer: N.outerContainer || N.container }), Ce = Ae.hoverLabels, Ue = 5, Ne = 0, ke = 0;
          Ce.sort(function(H, ve) {
            return H.y0 - ve.y0;
          }).each(function(H, ve) {
            var be = H.y0 - H.by / 2;
            be - Ue < Ne ? H.offset = Ne - be + Ue : H.offset = 0, Ne = be + H.by + H.offset, ve === N.anchorIndex && (ke = H.offset);
          }).each(function(H) {
            H.offset -= ke;
          });
          var A = ee._fullLayout._invScaleX, X = ee._fullLayout._invScaleY;
          return j(Ce, _e, A, X), W ? Ce : Ce.node();
        };
        function U(w, N, W, ee, le) {
          W || (W = "xy"), typeof W == "string" && (W = W.split(g)[0]);
          var ie = Array.isArray(W) ? W : [W], pe, _e = w._fullLayout, Ae = _e.hoversubplots, Ce = _e._plots || [], Ue = Ce[W], Ne = _e._has("cartesian"), ke = N.hovermode || _e.hovermode, A = (ke || "").charAt(0) === "x", X = (ke || "").charAt(0) === "y", H, ve;
          if (Ne && (A || X) && Ae === "axis") {
            for (var be = ie.length, Se = 0; Se < be; Se++) if (pe = ie[Se], Ce[pe]) {
              H = v.getFromId(w, pe, "x"), ve = v.getFromId(w, pe, "y");
              var De = (A ? H : ve)._subplotsWith;
              if (De && De.length) for (var He = 0; He < De.length; He++) i(ie, De[He]);
            }
          }
          if (Ue && Ae !== "single") {
            var Ze = Ue.overlays.map(function(Yt) {
              return Yt.id;
            });
            ie = ie.concat(Ze);
          }
          for (var We = ie.length, $e = new Array(We), it = new Array(We), Ke = !1, ct = 0; ct < We; ct++) if (pe = ie[ct], Ce[pe]) Ke = !0, $e[ct] = Ce[pe].xaxis, it[ct] = Ce[pe].yaxis;
          else if (_e[pe] && _e[pe]._subplot) {
            var gt = _e[pe]._subplot;
            $e[ct] = gt.xaxis, it[ct] = gt.yaxis;
          } else {
            a.warn("Unrecognized subplot: " + pe);
            return;
          }
          if (ke && !Ke && (ke = "closest"), ["x", "y", "closest", "x unified", "y unified"].indexOf(ke) === -1 || !w.calcdata || w.querySelector(".zoombox") || w._dragging) return f.unhoverRaw(w, N);
          var ht = _e.hoverdistance;
          ht === -1 && (ht = 1 / 0);
          var _t = _e.spikedistance;
          _t === -1 && (_t = 1 / 0);
          var Te = [], Ie = [], ce, ge, ye, Me, Oe, je, qe, Qe, Xe, Je, ot, lt, st, xt = { hLinePoint: null, vLinePoint: null }, Et = !1;
          if (Array.isArray(N)) for (ke = "array", ye = 0; ye < N.length; ye++) Oe = w.calcdata[N[ye].curveNumber || 0], Oe && (je = Oe[0].trace, Oe[0].trace.hoverinfo !== "skip" && (Ie.push(Oe), je.orientation === "h" && (Et = !0)));
          else {
            var Bt = w.calcdata.slice();
            for (Bt.sort(function(Yt, Sr) {
              var Tr = Yt[0].trace.zorder || 0, Gr = Sr[0].trace.zorder || 0;
              return Tr - Gr;
            }), Me = 0; Me < Bt.length; Me++) Oe = Bt[Me], je = Oe[0].trace, je.hoverinfo !== "skip" && h.isTraceInSubplots(je, ie) && (Ie.push(Oe), je.orientation === "h" && (Et = !0));
            var qt = !le, jt, It;
            if (qt) "xpx" in N ? jt = N.xpx : jt = $e[0]._length / 2, "ypx" in N ? It = N.ypx : It = it[0]._length / 2;
            else {
              if (s.triggerHandler(w, "plotly_beforehover", N) === !1) return;
              var Tt = le.getBoundingClientRect();
              jt = N.clientX - Tt.left, It = N.clientY - Tt.top, _e._calcInverseTransform(w);
              var Rt = a.apply3DTransform(_e._invTransform)(jt, It);
              if (jt = Rt[0], It = Rt[1], jt < 0 || jt > $e[0]._length || It < 0 || It > it[0]._length) return f.unhoverRaw(w, N);
            }
            if (N.pointerX = jt + $e[0]._offset, N.pointerY = It + it[0]._offset, "xval" in N ? ce = h.flat(ie, N.xval) : ce = h.p2c($e, jt), "yval" in N ? ge = h.flat(ie, N.yval) : ge = h.p2c(it, It), !n(ce[0]) || !n(ge[0])) return a.warn("Fx.hover failed", N, w), f.unhoverRaw(w, N);
          }
          var Vt = 1 / 0;
          function Ft(Yt, Sr) {
            for (Me = 0; Me < Ie.length; Me++) if (Oe = Ie[Me], !(!Oe || !Oe[0] || !Oe[0].trace) && (je = Oe[0].trace, !(je.visible !== !0 || je._length === 0) && ["carpet", "contourcarpet"].indexOf(je._module.name) === -1)) {
              if (Xe = ke, h.isUnifiedHover(Xe) && (Xe = Xe.charAt(0)), je.type === "splom" ? (Qe = 0, qe = ie[Qe]) : (qe = h.getSubplot(je), Qe = ie.indexOf(qe)), lt = { cd: Oe, trace: je, xa: $e[Qe], ya: it[Qe], maxHoverDistance: ht, maxSpikeDistance: _t, index: !1, distance: Math.min(Vt, ht), spikeDistance: 1 / 0, xSpike: void 0, ySpike: void 0, color: l.defaultLine, name: je.name, x0: void 0, x1: void 0, y0: void 0, y1: void 0, xLabelVal: void 0, yLabelVal: void 0, zLabelVal: void 0, text: void 0 }, _e[qe] && (lt.subplot = _e[qe]._subplot), _e._splomScenes && _e._splomScenes[je.uid] && (lt.scene = _e._splomScenes[je.uid]), Xe === "array") {
                var Tr = N[Me];
                "pointNumber" in Tr ? (lt.index = Tr.pointNumber, Xe = "closest") : (Xe = "", "xval" in Tr && (Je = Tr.xval, Xe = "x"), "yval" in Tr && (ot = Tr.yval, Xe = Xe ? "closest" : "y"));
              } else Yt !== void 0 && Sr !== void 0 ? (Je = Yt, ot = Sr) : (Je = ce[Qe], ot = ge[Qe]);
              if (st = Te.length, ht !== 0) if (je._module && je._module.hoverPoints) {
                var Gr = je._module.hoverPoints(lt, Je, ot, Xe, { finiteRange: !0, hoverLayer: _e._hoverlayer, hoversubplots: Ae, gd: w });
                if (Gr) for (var dr, Ir = 0; Ir < Gr.length; Ir++) dr = Gr[Ir], n(dr.x0) && n(dr.y0) && Te.push(J(dr, ke));
              } else a.log("Unrecognized trace type in hover:", je);
              if (ke === "closest" && Te.length > st && (Te.splice(0, st), Vt = Te[0].distance), Ne && _t !== 0 && Te.length === 0) {
                lt.distance = _t, lt.index = !1;
                var Er = je._module.hoverPoints(lt, Je, ot, "closest", { hoverLayer: _e._hoverlayer });
                if (Er && (Er = Er.filter(function(Mr) {
                  return Mr.spikeDistance <= _t;
                })), Er && Er.length) {
                  var Zr, ln = Er.filter(function(Mr) {
                    return Mr.xa.showspikes && Mr.xa.spikesnap !== "hovered data";
                  });
                  if (ln.length) {
                    var un = ln[0];
                    n(un.x0) && n(un.y0) && (Zr = Ct(un), (!xt.vLinePoint || xt.vLinePoint.spikeDistance > Zr.spikeDistance) && (xt.vLinePoint = Zr));
                  }
                  var br = Er.filter(function(Mr) {
                    return Mr.ya.showspikes && Mr.ya.spikesnap !== "hovered data";
                  });
                  if (br.length) {
                    var Dr = br[0];
                    n(Dr.x0) && n(Dr.y0) && (Zr = Ct(Dr), (!xt.hLinePoint || xt.hLinePoint.spikeDistance > Zr.spikeDistance) && (xt.hLinePoint = Zr));
                  }
                }
              }
            }
          }
          Ft();
          function Dt(Yt, Sr, Tr) {
            for (var Gr = null, dr = 1 / 0, Ir, Er = 0; Er < Yt.length; Er++) H && H._id !== Yt[Er].xa._id || ve && ve._id !== Yt[Er].ya._id || (Ir = Yt[Er].spikeDistance, Tr && Er === 0 && (Ir = -1 / 0), Ir <= dr && Ir <= Sr && (Gr = Yt[Er], dr = Ir));
            return Gr;
          }
          function Ct(Yt) {
            return Yt ? { xa: Yt.xa, ya: Yt.ya, x: Yt.xSpike !== void 0 ? Yt.xSpike : (Yt.x0 + Yt.x1) / 2, y: Yt.ySpike !== void 0 ? Yt.ySpike : (Yt.y0 + Yt.y1) / 2, distance: Yt.distance, spikeDistance: Yt.spikeDistance, curveNumber: Yt.trace.index, color: Yt.color, pointNumber: Yt.index } : null;
          }
          var Ot = { fullLayout: _e, container: _e._hoverlayer, event: N };
          w._spikepoints;
          var Wt = { vLinePoint: xt.vLinePoint, hLinePoint: xt.hLinePoint };
          w._spikepoints = Wt;
          var rr = function() {
            var Yt = Te.filter(function(Tr) {
              return H && H._id === Tr.xa._id && ve && ve._id === Tr.ya._id;
            }), Sr = Te.filter(function(Tr) {
              return !(H && H._id === Tr.xa._id && ve && ve._id === Tr.ya._id);
            });
            Yt.sort(q), Sr.sort(q), Te = Yt.concat(Sr), Te = F(Te, ke);
          };
          rr();
          var Ut = ke.charAt(0), Qt = (Ut === "x" || Ut === "y") && Te[0] && z[Te[0].trace.type];
          if (Ne && _t !== 0 && Te.length !== 0) {
            var nr = Te.filter(function(Yt) {
              return Yt.ya.showspikes;
            }), cr = Dt(nr, _t, Qt);
            xt.hLinePoint = Ct(cr);
            var lr = Te.filter(function(Yt) {
              return Yt.xa.showspikes;
            }), $t = Dt(lr, _t, Qt);
            xt.vLinePoint = Ct($t);
          }
          if (Te.length === 0) {
            var sr = f.unhoverRaw(w, N);
            return Ne && (xt.hLinePoint !== null || xt.vLinePoint !== null) && se() && ne(w, xt, Ot), sr;
          }
          if (Ne && se() && ne(w, xt, Ot), h.isXYhover(Xe) && Te[0].length !== 0 && Te[0].trace.type !== "splom") {
            var St = Te[0];
            B[St.trace.type] ? Te = Te.filter((Yt) => Yt.trace.index === St.trace.index) : Te = [St];
            var Kt = Te.length, hr = S("x", St, _e), he = S("y", St, _e);
            Ft(hr, he);
            var fe = [], Pe = {}, Re = 0, Ye = function(Yt) {
              var Sr = B[Yt.trace.type] ? G(Yt) : Yt.trace.index;
              if (!Pe[Sr]) Re++, Pe[Sr] = Re, fe.push(Yt);
              else {
                var Tr = Pe[Sr] - 1, Gr = fe[Tr];
                Tr > 0 && Math.abs(Yt.distance) < Math.abs(Gr.distance) && (fe[Tr] = Yt);
              }
            }, Ee;
            for (Ee = 0; Ee < Kt; Ee++) Ye(Te[Ee]);
            for (Ee = Te.length - 1; Ee > Kt - 1; Ee--) Ye(Te[Ee]);
            Te = fe, rr();
          }
          var ze = w._hoverdata, Ge = [], Ve = $(w), tt = re(w);
          for (let Yt of Te) {
            var at = h.makeEventData(Yt, Yt.trace, Yt.cd);
            if (Yt.hovertemplate !== !1) {
              var vt = !1;
              Yt.cd[Yt.index] && Yt.cd[Yt.index].ht && (vt = Yt.cd[Yt.index].ht), Yt.hovertemplate = vt || Yt.trace.hovertemplate || !1;
            }
            if (Yt.xa && Yt.ya) {
              var kt = Yt.x0 + Yt.xa._offset, At = Yt.x1 + Yt.xa._offset, Nt = Yt.y0 + Yt.ya._offset, Mt = Yt.y1 + Yt.ya._offset, Pt = Math.min(kt, At), Lt = Math.max(kt, At), ur = Math.min(Nt, Mt), Ht = Math.max(Nt, Mt);
              at.bbox = { x0: Pt + tt, x1: Lt + tt, y0: ur + Ve, y1: Ht + Ve };
            }
            Yt.eventData = [at], Ge.push(at);
          }
          w._hoverdata = Ge;
          var mr = ke === "y" && (Ie.length > 1 || Te.length > 1) || ke === "closest" && Et && Te.length > 1, ar = l.combine(_e.plot_bgcolor || l.background, _e.paper_bgcolor), kr = te(Te, { gd: w, hovermode: ke, rotateLabels: mr, bgColor: ar, container: _e._hoverlayer, outerContainer: _e._paper.node(), commonLabelOpts: _e.hoverlabel, hoverdistance: _e.hoverdistance }), _r = kr.hoverLabels;
          if (h.isUnifiedHover(ke) || (Z(_r, mr, _e, kr.commonLabelBoundingBox), j(_r, mr, _e._invScaleX, _e._invScaleY)), le && le.tagName) {
            var Cr = x.getComponentMethod("annotations", "hasClickToShow")(w, Ge);
            t(k.select(le), Cr ? "pointer" : "");
          }
          !le || ee || !ae(w, N, ze) || (ze && w.emit("plotly_unhover", { event: N, points: ze }), w.emit("plotly_hover", { event: N, points: w._hoverdata, xaxes: $e, yaxes: it, xvals: ce, yvals: ge }));
        }
        function G(w) {
          return [w.trace.index, w.index, w.x0, w.y0, w.name, w.attr, w.xa ? w.xa._id : "", w.ya ? w.ya._id : ""].join(",");
        }
        var K = /<extra>([\s\S]*)<\/extra>/;
        function te(w, N) {
          var W = N.gd, ee = W._fullLayout, le = N.hovermode, ie = N.rotateLabels, pe = N.bgColor, _e = N.container, Ae = N.outerContainer, Ce = N.commonLabelOpts || {};
          if (w.length === 0) return [[]];
          var Ue = N.fontFamily || m.HOVERFONT, Ne = N.fontSize || m.HOVERFONTSIZE, ke = N.fontWeight || ee.font.weight, A = N.fontStyle || ee.font.style, X = N.fontVariant || ee.font.variant, H = N.fontTextcase || ee.font.textcase, ve = N.fontLineposition || ee.font.lineposition, be = N.fontShadow || ee.font.shadow, Se = w[0], De = Se.xa, He = Se.ya, Ze = le.charAt(0), We = Ze + "Label", $e = Se[We];
          if ($e === void 0 && De.type === "multicategory") for (var it = 0; it < w.length && ($e = w[it][We], $e === void 0); it++) ;
          var Ke = E(W, Ae), ct = Ke.top, gt = Ke.width, ht = Ke.height, _t = $e !== void 0 && Se.distance <= N.hoverdistance && (le === "x" || le === "y");
          if (_t) {
            var Te = !0, Ie, ce;
            for (Ie = 0; Ie < w.length; Ie++) if (Te && w[Ie].zLabel === void 0 && (Te = !1), ce = w[Ie].hoverinfo || w[Ie].trace.hoverinfo, ce) {
              var ge = Array.isArray(ce) ? ce : ce.split("+");
              if (ge.indexOf("all") === -1 && ge.indexOf(le) === -1) {
                _t = !1;
                break;
              }
            }
            Te && (_t = !1);
          }
          var ye = _e.selectAll("g.axistext").data(_t ? [0] : []);
          ye.enter().append("g").classed("axistext", !0), ye.exit().remove();
          var Me = { minX: 0, maxX: 0, minY: 0, maxY: 0 };
          if (ye.each(function() {
            var St = k.select(this), Kt = a.ensureSingle(St, "path", "", function(mr) {
              mr.style({ "stroke-width": "1px" });
            }), hr = a.ensureSingle(St, "text", "", function(mr) {
              mr.attr("data-notex", 1);
            }), he = Ce.bgcolor || l.defaultLine, fe = Ce.bordercolor || l.contrast(he), Pe = l.contrast(he), Re = Ce.font, Ye = { weight: Re.weight || ke, style: Re.style || A, variant: Re.variant || X, textcase: Re.textcase || H, lineposition: Re.lineposition || ve, shadow: Re.shadow || be, family: Re.family || Ue, size: Re.size || Ne, color: Re.color || Pe };
            Kt.style({ fill: he, stroke: fe }), hr.text($e).call(p.font, Ye).call(c.positionText, 0, 0).call(c.convertToTspans, W), St.attr("transform", "");
            var Ee = E(W, hr.node()), ze, Ge;
            if (le === "x") {
              var Ve = De.side === "top" ? "-" : "";
              hr.attr("text-anchor", "middle").call(c.positionText, 0, De.side === "top" ? ct - Ee.bottom - P - M : ct - Ee.top + P + M), ze = De._offset + (Se.x0 + Se.x1) / 2, Ge = He._offset + (De.side === "top" ? 0 : He._length);
              var tt = Ee.width / 2 + M, at = ze;
              ze < tt ? at = tt : ze > ee.width - tt && (at = ee.width - tt), Kt.attr("d", "M" + (ze - at) + ",0L" + (ze - at + P) + "," + Ve + P + "H" + tt + "v" + Ve + (M * 2 + Ee.height) + "H" + -tt + "V" + Ve + P + "H" + (ze - at - P) + "Z"), ze = at, Me.minX = ze - tt, Me.maxX = ze + tt, De.side === "top" ? (Me.minY = Ge - (M * 2 + Ee.height), Me.maxY = Ge - M) : (Me.minY = Ge + M, Me.maxY = Ge + (M * 2 + Ee.height));
            } else {
              var vt, kt, At;
              He.side === "right" ? (vt = "start", kt = 1, At = "", ze = De._offset + De._length) : (vt = "end", kt = -1, At = "-", ze = De._offset), Ge = He._offset + (Se.y0 + Se.y1) / 2, hr.attr("text-anchor", vt), Kt.attr("d", "M0,0L" + At + P + "," + P + "V" + (M + Ee.height / 2) + "h" + At + (M * 2 + Ee.width) + "V-" + (M + Ee.height / 2) + "H" + At + P + "V-" + P + "Z"), Me.minY = Ge - (M + Ee.height / 2), Me.maxY = Ge + (M + Ee.height / 2), He.side === "right" ? (Me.minX = ze + P, Me.maxX = ze + P + (M * 2 + Ee.width)) : (Me.minX = ze - P - (M * 2 + Ee.width), Me.maxX = ze - P);
              var Nt = Ee.height / 2, Mt = ct - Ee.top - Nt, Pt = "clip" + ee._uid + "commonlabel" + He._id, Lt;
              if (ze < Ee.width + 2 * M + P) {
                Lt = "M-" + (P + M) + "-" + Nt + "h-" + (Ee.width - M) + "V" + Nt + "h" + (Ee.width - M) + "Z";
                var ur = Ee.width - ze + M;
                c.positionText(hr, ur, Mt), vt === "end" && hr.selectAll("tspan").each(function() {
                  var mr = k.select(this), ar = p.tester.append("text").text(mr.text()).call(p.font, Ye), kr = E(W, ar.node());
                  Math.round(kr.width) < Math.round(Ee.width) && mr.attr("x", ur - kr.width), ar.remove();
                });
              } else c.positionText(hr, kt * (M + P), Mt), Lt = null;
              var Ht = ee._topclips.selectAll("#" + Pt).data(Lt ? [0] : []);
              Ht.enter().append("clipPath").attr("id", Pt).append("path"), Ht.exit().remove(), Ht.select("path").attr("d", Lt), p.setClipUrl(hr, Lt ? Pt : null, W);
            }
            St.attr("transform", o(ze, Ge));
          }), h.isUnifiedHover(le)) {
            _e.selectAll("g.hovertext").remove();
            let St = w.filter((Kt) => Kt.hoverinfo !== "none");
            if (St.length === 0) return [];
            var Oe = ee.hoverlabel, je = Oe.font, qe = St[0], Qe = ((le === "x unified" ? qe.xa : qe.ya).unifiedhovertitle || {}).text, Xe = Qe ? a.hovertemplateString({ data: le === "x unified" ? [{ xa: qe.xa, x: qe.xVal }] : [{ ya: qe.ya, y: qe.yVal }], fallback: qe.trace.hovertemplatefallback, locale: ee._d3locale, template: Qe }) : $e, Je = { showlegend: !0, legend: { title: { text: Xe, font: je }, font: je, bgcolor: Oe.bgcolor, bordercolor: Oe.bordercolor, borderwidth: 1, tracegroupgap: 7, traceorder: ee.legend ? ee.legend.traceorder : void 0, orientation: "v" } }, ot = { font: je };
            u(Je, ot, W._fullData);
            var lt = ot.legend;
            lt.entries = [];
            for (var st = 0; st < St.length; st++) {
              var xt = St[st];
              if (xt.hoverinfo !== "none") {
                var Et = V(xt, !0, le, ee, $e), Bt = Et[0], qt = Et[1];
                xt.name = qt, qt !== "" ? xt.text = qt + " : " + Bt : xt.text = Bt;
                var jt = xt.cd[xt.index];
                jt && (jt.mc && (xt.mc = jt.mc), jt.mcc && (xt.mc = jt.mcc), jt.mlc && (xt.mlc = jt.mlc), jt.mlcc && (xt.mlc = jt.mlcc), jt.mlw && (xt.mlw = jt.mlw), jt.mrc && (xt.mrc = jt.mrc), jt.dir && (xt.dir = jt.dir)), xt._distinct = !0, lt.entries.push([xt]);
              }
            }
            lt.entries.sort(function(Kt, hr) {
              return Kt[0].trace.index - hr[0].trace.index;
            }), lt.layer = _e, lt._inHover = !0, lt._groupTitleFont = Oe.grouptitlefont, d(W, lt);
            var It = _e.select("g.legend"), Tt = E(W, It.node()), Rt = Tt.width + 2 * M, Vt = Tt.height + 2 * M, Ft = St[0], Dt = (Ft.x0 + Ft.x1) / 2, Ct = (Ft.y0 + Ft.y1) / 2, Ot = !(x.traceIs(Ft.trace, "bar-like") || x.traceIs(Ft.trace, "box-violin")), Wt, rr;
            Ze === "y" ? Ot ? (rr = Ct - M, Wt = Ct + M) : (rr = Math.min.apply(null, St.map(function(Kt) {
              return Math.min(Kt.y0, Kt.y1);
            })), Wt = Math.max.apply(null, St.map(function(Kt) {
              return Math.max(Kt.y0, Kt.y1);
            }))) : rr = Wt = a.mean(St.map(function(Kt) {
              return (Kt.y0 + Kt.y1) / 2;
            })) - Vt / 2;
            var Ut, Qt;
            Ze === "x" ? Ot ? (Ut = Dt + M, Qt = Dt - M) : (Ut = Math.max.apply(null, St.map(function(Kt) {
              return Math.max(Kt.x0, Kt.x1);
            })), Qt = Math.min.apply(null, St.map(function(Kt) {
              return Math.min(Kt.x0, Kt.x1);
            }))) : Ut = Qt = a.mean(St.map(function(Kt) {
              return (Kt.x0 + Kt.x1) / 2;
            })) - Rt / 2;
            var nr = De._offset, cr = He._offset;
            Wt += cr, Ut += nr, Qt += nr - Rt, rr += cr - Vt;
            var lr, $t;
            return Ut + Rt < gt && Ut >= 0 ? lr = Ut : Qt + Rt < gt && Qt >= 0 ? lr = Qt : nr + Rt < gt ? lr = nr : Ut - Dt < Dt - Qt + Rt ? lr = gt - Rt : lr = 0, lr += M, Wt + Vt < ht && Wt >= 0 ? $t = Wt : rr + Vt < ht && rr >= 0 ? $t = rr : cr + Vt < ht ? $t = cr : Wt - Ct < Ct - rr + Vt ? $t = ht - Vt : $t = 0, $t += M, It.attr("transform", o(lr - 1, $t - 1)), It;
          }
          var sr = _e.selectAll("g.hovertext").data(w, function(St) {
            return G(St);
          });
          return sr.enter().append("g").classed("hovertext", !0).each(function() {
            var St = k.select(this);
            St.append("rect").call(l.fill, l.addOpacity(pe, 0.8)), St.append("text").classed("name", !0), St.append("path").style("stroke-width", "1px"), St.append("text").classed("nums", !0).call(p.font, { weight: ke, style: A, variant: X, textcase: H, lineposition: ve, shadow: be, family: Ue, size: Ne });
          }), sr.exit().remove(), sr.each(function(St) {
            var Kt = k.select(this).attr("transform", ""), hr = St.color;
            Array.isArray(hr) && (hr = hr[St.eventData[0].pointNumber]);
            var he = St.bgcolor || hr, fe = l.combine(l.opacity(he) ? he : l.defaultLine, pe), Pe = l.combine(l.opacity(hr) ? hr : l.defaultLine, pe), Re = St.borderColor || l.contrast(fe), Ye = V(St, _t, le, ee, $e, Kt), Ee = Ye[0], ze = Ye[1], Ge = Kt.select("text.nums").call(p.font, { family: St.fontFamily || Ue, size: St.fontSize || Ne, color: St.fontColor || Re, weight: St.fontWeight || ke, style: St.fontStyle || A, variant: St.fontVariant || X, textcase: St.fontTextcase || H, lineposition: St.fontLineposition || ve, shadow: St.fontShadow || be }).text(Ee).attr("data-notex", 1).call(c.positionText, 0, 0).call(c.convertToTspans, W), Ve = Kt.select("text.name"), tt = 0, at = 0;
            if (ze && ze !== Ee) {
              Ve.call(p.font, { family: St.fontFamily || Ue, size: St.fontSize || Ne, color: Pe, weight: St.fontWeight || ke, style: St.fontStyle || A, variant: St.fontVariant || X, textcase: St.fontTextcase || H, lineposition: St.fontLineposition || ve, shadow: St.fontShadow || be }).text(ze).attr("data-notex", 1).call(c.positionText, 0, 0).call(c.convertToTspans, W);
              var vt = E(W, Ve.node());
              tt = vt.width + 2 * M, at = vt.height + 2 * M;
            } else Ve.remove(), Kt.select("rect").remove();
            Kt.select("path").style({ fill: fe, stroke: Re });
            var kt = St.xa._offset + (St.x0 + St.x1) / 2, At = St.ya._offset + (St.y0 + St.y1) / 2, Nt = Math.abs(St.x1 - St.x0), Mt = Math.abs(St.y1 - St.y0), Pt = E(W, Ge.node()), Lt = Pt.width / ee._invScaleX, ur = Pt.height / ee._invScaleY;
            St.ty0 = (ct - Pt.top) / ee._invScaleY, St.bx = Lt + 2 * M, St.by = Math.max(ur + 2 * M, at), St.anchor = "start", St.txwidth = Lt, St.tx2width = tt, St.offset = 0;
            var Ht = (Lt + P + M + tt) * ee._invScaleX, mr, ar;
            if (ie) St.pos = kt, mr = At + Mt / 2 + Ht <= ht, ar = At - Mt / 2 - Ht >= 0, (St.idealAlign === "top" || !mr) && ar ? (At -= Mt / 2, St.anchor = "end") : mr ? (At += Mt / 2, St.anchor = "start") : St.anchor = "middle", St.crossPos = At;
            else {
              if (St.pos = At, mr = kt + Nt / 2 + Ht <= gt, ar = kt - Nt / 2 - Ht >= 0, (St.idealAlign === "left" || !mr) && ar) kt -= Nt / 2, St.anchor = "end";
              else if (mr) kt += Nt / 2, St.anchor = "start";
              else {
                St.anchor = "middle";
                var kr = Ht / 2, _r = kt + kr - gt, Cr = kt - kr;
                _r > 0 && (kt -= _r), Cr < 0 && (kt += -Cr);
              }
              St.crossPos = kt;
            }
            Ge.attr("text-anchor", St.anchor), tt && Ve.attr("text-anchor", St.anchor), Kt.attr("transform", o(kt, At) + (ie ? r(y) : ""));
          }), { hoverLabels: sr, commonLabelBoundingBox: Me };
        }
        function V(w, N, W, ee, le, ie) {
          var pe = "", _e = "";
          w.nameOverride !== void 0 && (w.name = w.nameOverride), w.name && (w.trace._meta && (w.name = a.templateString(w.name, w.trace._meta)), pe = O(w.name, w.nameLength));
          var Ae = W.charAt(0), Ce = Ae === "x" ? "y" : "x";
          w.zLabel !== void 0 ? (w.xLabel !== void 0 && (_e += "x: " + w.xLabel + "<br>"), w.yLabel !== void 0 && (_e += "y: " + w.yLabel + "<br>"), w.trace.type !== "choropleth" && w.trace.type !== "choroplethmapbox" && w.trace.type !== "choroplethmap" && (_e += (_e ? "z: " : "") + w.zLabel)) : N && w[Ae + "Label"] === le ? _e = w[Ce + "Label"] || "" : w.xLabel === void 0 ? w.yLabel !== void 0 && w.trace.type !== "scattercarpet" && (_e = w.yLabel) : w.yLabel === void 0 ? _e = w.xLabel : _e = "(" + w.xLabel + ", " + w.yLabel + ")", (w.text || w.text === 0) && !Array.isArray(w.text) && (_e += (_e ? "<br>" : "") + w.text), w.extraText !== void 0 && (_e += (_e ? "<br>" : "") + w.extraText), ie && _e === "" && !w.hovertemplate && (pe === "" && ie.remove(), _e = pe);
          let { hovertemplate: Ue = !1 } = w;
          if (Ue) {
            let Ne = w.hovertemplateLabels || w;
            w[Ae + "Label"] !== le && (Ne[Ae + "other"] = Ne[Ae + "Val"], Ne[Ae + "otherLabel"] = Ne[Ae + "Label"]), _e = a.hovertemplateString({ data: [w.eventData[0] || {}, w.trace._meta], fallback: w.trace.hovertemplatefallback, labels: Ne, locale: ee._d3locale, template: Ue }), _e = _e.replace(K, (ke, A) => (pe = O(A, w.nameLength), ""));
          }
          return [_e, pe];
        }
        function Z(w, N, W, ee) {
          var le = N ? "xa" : "ya", ie = N ? "ya" : "xa", pe = 0, _e = 1, Ae = w.size(), Ce = new Array(Ae), Ue = 0, Ne = ee.minX, ke = ee.maxX, A = ee.minY, X = ee.maxY, H = function(ce) {
            return ce * W._invScaleX;
          }, ve = function(ce) {
            return ce * W._invScaleY;
          };
          w.each(function(ce) {
            var ge = ce[le], ye = ce[ie], Me = ge._id.charAt(0) === "x", Oe = ge.range;
            Ue === 0 && Oe && Oe[0] > Oe[1] !== Me && (_e = -1);
            var je = 0, qe = Me ? W.width : W.height;
            if (W.hovermode === "x" || W.hovermode === "y") {
              var Qe = Y(ce, N), Xe = ce.anchor, Je = Xe === "end" ? -1 : 1, ot, lt;
              if (Xe === "middle") ot = ce.crossPos + (Me ? ve(Qe.y - ce.by / 2) : H(ce.bx / 2 + ce.tx2width / 2)), lt = ot + (Me ? ve(ce.by) : H(ce.bx));
              else if (Me) ot = ce.crossPos + ve(P + Qe.y) - ve(ce.by / 2 - P), lt = ot + ve(ce.by);
              else {
                var st = H(Je * P + Qe.x), xt = st + H(Je * ce.bx);
                ot = ce.crossPos + Math.min(st, xt), lt = ce.crossPos + Math.max(st, xt);
              }
              Me ? A !== void 0 && X !== void 0 && Math.min(lt, X) - Math.max(ot, A) > 1 && (ye.side === "left" ? (je = ye._mainLinePosition, qe = W.width) : qe = ye._mainLinePosition) : Ne !== void 0 && ke !== void 0 && Math.min(lt, ke) - Math.max(ot, Ne) > 1 && (ye.side === "top" ? (je = ye._mainLinePosition, qe = W.height) : qe = ye._mainLinePosition);
            }
            Ce[Ue++] = [{ datum: ce, traceIndex: ce.trace.index, dp: 0, pos: ce.pos, posref: ce.posref, size: ce.by * (Me ? T : 1) / 2, pmin: je, pmax: qe }];
          }), Ce.sort(function(ce, ge) {
            return ce[0].posref - ge[0].posref || _e * (ge[0].traceIndex - ce[0].traceIndex);
          });
          var be, Se, De, He, Ze, We, $e;
          function it(ce) {
            var ge = ce[0], ye = ce[ce.length - 1];
            if (Se = ge.pmin - ge.pos - ge.dp + ge.size, De = ye.pos + ye.dp + ye.size - ge.pmax, Se > 0.01) {
              for (Ze = ce.length - 1; Ze >= 0; Ze--) ce[Ze].dp += Se;
              be = !1;
            }
            if (!(De < 0.01)) {
              if (Se < -0.01) {
                for (Ze = ce.length - 1; Ze >= 0; Ze--) ce[Ze].dp -= De;
                be = !1;
              }
              if (be) {
                var Me = 0;
                for (He = 0; He < ce.length; He++) We = ce[He], We.pos + We.dp + We.size > ge.pmax && Me++;
                for (He = ce.length - 1; He >= 0 && !(Me <= 0); He--) We = ce[He], We.pos > ge.pmax - 1 && (We.del = !0, Me--);
                for (He = 0; He < ce.length && !(Me <= 0); He++) if (We = ce[He], We.pos < ge.pmin + 1) for (We.del = !0, Me--, De = We.size * 2, Ze = ce.length - 1; Ze >= 0; Ze--) ce[Ze].dp -= De;
                for (He = ce.length - 1; He >= 0 && !(Me <= 0); He--) We = ce[He], We.pos + We.dp + We.size > ge.pmax && (We.del = !0, Me--);
              }
            }
          }
          for (; !be && pe <= Ae; ) {
            for (pe++, be = !0, He = 0; He < Ce.length - 1; ) {
              var Ke = Ce[He], ct = Ce[He + 1], gt = Ke[Ke.length - 1], ht = ct[0];
              if (Se = gt.pos + gt.dp + gt.size - ht.pos - ht.dp + ht.size, Se > 0.01) {
                for (Ze = ct.length - 1; Ze >= 0; Ze--) ct[Ze].dp += Se;
                for (Ke.push.apply(Ke, ct), Ce.splice(He + 1, 1), $e = 0, Ze = Ke.length - 1; Ze >= 0; Ze--) $e += Ke[Ze].dp;
                for (De = $e / Ke.length, Ze = Ke.length - 1; Ze >= 0; Ze--) Ke[Ze].dp -= De;
                be = !1;
              } else He++;
            }
            Ce.forEach(it);
          }
          for (He = Ce.length - 1; He >= 0; He--) {
            var _t = Ce[He];
            for (Ze = _t.length - 1; Ze >= 0; Ze--) {
              var Te = _t[Ze], Ie = Te.datum;
              Ie.offset = Te.dp, Ie.del = Te.del;
            }
          }
        }
        function Y(w, N) {
          var W = 0, ee = w.offset;
          return N && (ee *= -I, W = w.offset * R), { x: W, y: ee };
        }
        function C(w) {
          var N = { start: 1, end: -1, middle: 0 }[w.anchor], W = N * (P + M), ee = W + N * (w.txwidth + M), le = w.anchor === "middle";
          return le && (W -= w.tx2width / 2, ee += w.txwidth / 2 + M), { alignShift: N, textShiftX: W, text2ShiftX: ee };
        }
        function j(w, N, W, ee) {
          var le = function(pe) {
            return pe * W;
          }, ie = function(pe) {
            return pe * ee;
          };
          w.each(function(pe) {
            var _e = k.select(this);
            if (pe.del) return _e.remove();
            var Ae = _e.select("text.nums"), Ce = pe.anchor, Ue = Ce === "end" ? -1 : 1, Ne = C(pe), ke = Y(pe, N), A = ke.x, X = ke.y, H = Ce === "middle", ve = "hoverlabel" in pe.trace ? pe.trace.hoverlabel.showarrow : !0, be;
            H ? be = "M-" + le(pe.bx / 2 + pe.tx2width / 2) + "," + ie(X - pe.by / 2) + "h" + le(pe.bx) + "v" + ie(pe.by) + "h-" + le(pe.bx) + "Z" : ve ? be = "M0,0L" + le(Ue * P + A) + "," + ie(P + X) + "v" + ie(pe.by / 2 - P) + "h" + le(Ue * pe.bx) + "v-" + ie(pe.by) + "H" + le(Ue * P + A) + "V" + ie(X - P) + "Z" : be = "M" + le(Ue * P + A) + "," + ie(X - pe.by / 2) + "h" + le(Ue * pe.bx) + "v" + ie(pe.by) + "h" + le(-Ue * pe.bx) + "Z", _e.select("path").attr("d", be);
            var Se = A + Ne.textShiftX, De = X + pe.ty0 - pe.by / 2 + M, He = pe.textAlign || "auto";
            He !== "auto" && (He === "left" && Ce !== "start" ? (Ae.attr("text-anchor", "start"), Se = H ? -pe.bx / 2 - pe.tx2width / 2 + M : -pe.bx - M) : He === "right" && Ce !== "end" && (Ae.attr("text-anchor", "end"), Se = H ? pe.bx / 2 - pe.tx2width / 2 - M : pe.bx + M)), Ae.call(c.positionText, le(Se), ie(De)), pe.tx2width && (_e.select("text.name").call(c.positionText, le(Ne.text2ShiftX + Ne.alignShift * M + A), ie(X + pe.ty0 - pe.by / 2 + M)), _e.select("rect").call(p.setRect, le(Ne.text2ShiftX + (Ne.alignShift - 1) * pe.tx2width / 2 + A), ie(X - pe.by / 2 - 1), le(pe.tx2width), ie(pe.by + 2)));
          });
        }
        function J(w, N) {
          var W = w.index, ee = w.trace || {}, le = w.cd[0], ie = w.cd[W] || {};
          function pe(ke) {
            return ke || n(ke) && ke === 0;
          }
          var _e = Array.isArray(W) ? function(ke, A) {
            var X = a.castOption(le, W, ke);
            return pe(X) ? X : a.extractOption({}, ee, "", A);
          } : function(ke, A) {
            return a.extractOption(ie, ee, ke, A);
          };
          function Ae(ke, A, X) {
            var H = _e(A, X);
            pe(H) && (w[ke] = H);
          }
          if (Ae("hoverinfo", "hi", "hoverinfo"), Ae("bgcolor", "hbg", "hoverlabel.bgcolor"), Ae("borderColor", "hbc", "hoverlabel.bordercolor"), Ae("fontFamily", "htf", "hoverlabel.font.family"), Ae("fontSize", "hts", "hoverlabel.font.size"), Ae("fontColor", "htc", "hoverlabel.font.color"), Ae("fontWeight", "htw", "hoverlabel.font.weight"), Ae("fontStyle", "hty", "hoverlabel.font.style"), Ae("fontVariant", "htv", "hoverlabel.font.variant"), Ae("nameLength", "hnl", "hoverlabel.namelength"), Ae("textAlign", "hta", "hoverlabel.align"), w.posref = N === "y" || N === "closest" && ee.orientation === "h" ? w.xa._offset + (w.x0 + w.x1) / 2 : w.ya._offset + (w.y0 + w.y1) / 2, w.x0 = a.constrain(w.x0, 0, w.xa._length), w.x1 = a.constrain(w.x1, 0, w.xa._length), w.y0 = a.constrain(w.y0, 0, w.ya._length), w.y1 = a.constrain(w.y1, 0, w.ya._length), w.xLabelVal !== void 0 && (w.xLabel = "xLabel" in w ? w.xLabel : v.hoverLabelText(w.xa, w.xLabelVal, ee.xhoverformat), w.xVal = w.xa.c2d(w.xLabelVal)), w.yLabelVal !== void 0 && (w.yLabel = "yLabel" in w ? w.yLabel : v.hoverLabelText(w.ya, w.yLabelVal, ee.yhoverformat), w.yVal = w.ya.c2d(w.yLabelVal)), w.zLabelVal !== void 0 && w.zLabel === void 0 && (w.zLabel = String(w.zLabelVal)), !isNaN(w.xerr) && !(w.xa.type === "log" && w.xerr <= 0)) {
            var Ce = v.tickText(w.xa, w.xa.c2l(w.xerr), "hover").text;
            w.xerrneg !== void 0 ? w.xLabel += " +" + Ce + " / -" + v.tickText(w.xa, w.xa.c2l(w.xerrneg), "hover").text : w.xLabel += " ± " + Ce, N === "x" && (w.distance += 1);
          }
          if (!isNaN(w.yerr) && !(w.ya.type === "log" && w.yerr <= 0)) {
            var Ue = v.tickText(w.ya, w.ya.c2l(w.yerr), "hover").text;
            w.yerrneg !== void 0 ? w.yLabel += " +" + Ue + " / -" + v.tickText(w.ya, w.ya.c2l(w.yerrneg), "hover").text : w.yLabel += " ± " + Ue, N === "y" && (w.distance += 1);
          }
          var Ne = w.hoverinfo || w.trace.hoverinfo;
          return Ne && Ne !== "all" && (Ne = Array.isArray(Ne) ? Ne : Ne.split("+"), Ne.indexOf("x") === -1 && (w.xLabel = void 0), Ne.indexOf("y") === -1 && (w.yLabel = void 0), Ne.indexOf("z") === -1 && (w.zLabel = void 0), Ne.indexOf("text") === -1 && (w.text = void 0), Ne.indexOf("name") === -1 && (w.name = void 0)), w;
        }
        function ne(w, N, W) {
          var ee = W.container, le = W.fullLayout, ie = le._size, pe = W.event, _e = !!N.hLinePoint, Ae = !!N.vLinePoint, Ce, Ue;
          if (ee.selectAll(".spikeline").remove(), !!(Ae || _e)) {
            var Ne = l.combine(le.plot_bgcolor, le.paper_bgcolor);
            if (_e) {
              var ke = N.hLinePoint, A, X;
              Ce = ke && ke.xa, Ue = ke && ke.ya;
              var H = Ue.spikesnap;
              H === "cursor" ? (A = pe.pointerX, X = pe.pointerY) : (A = Ce._offset + ke.x, X = Ue._offset + ke.y);
              var ve = e.readability(ke.color, Ne) < 1.5 ? l.contrast(Ne) : ke.color, be = Ue.spikemode, Se = Ue.spikethickness, De = Ue.spikecolor || ve, He = v.getPxPosition(w, Ue), Ze, We;
              if (be.indexOf("toaxis") !== -1 || be.indexOf("across") !== -1) {
                if (be.indexOf("toaxis") !== -1 && (Ze = He, We = A), be.indexOf("across") !== -1) {
                  var $e = Ue._counterDomainMin, it = Ue._counterDomainMax;
                  Ue.anchor === "free" && ($e = Math.min($e, Ue.position), it = Math.max(it, Ue.position)), Ze = ie.l + $e * ie.w, We = ie.l + it * ie.w;
                }
                ee.insert("line", ":first-child").attr({ x1: Ze, x2: We, y1: X, y2: X, "stroke-width": Se, stroke: De, "stroke-dasharray": p.dashStyle(Ue.spikedash, Se) }).classed("spikeline", !0).classed("crisp", !0), ee.insert("line", ":first-child").attr({ x1: Ze, x2: We, y1: X, y2: X, "stroke-width": Se + 2, stroke: Ne }).classed("spikeline", !0).classed("crisp", !0);
              }
              be.indexOf("marker") !== -1 && ee.insert("circle", ":first-child").attr({ cx: He + (Ue.side !== "right" ? Se : -Se), cy: X, r: Se, fill: De }).classed("spikeline", !0);
            }
            if (Ae) {
              var Ke = N.vLinePoint, ct, gt;
              Ce = Ke && Ke.xa, Ue = Ke && Ke.ya;
              var ht = Ce.spikesnap;
              ht === "cursor" ? (ct = pe.pointerX, gt = pe.pointerY) : (ct = Ce._offset + Ke.x, gt = Ue._offset + Ke.y);
              var _t = e.readability(Ke.color, Ne) < 1.5 ? l.contrast(Ne) : Ke.color, Te = Ce.spikemode, Ie = Ce.spikethickness, ce = Ce.spikecolor || _t, ge = v.getPxPosition(w, Ce), ye, Me;
              if (Te.indexOf("toaxis") !== -1 || Te.indexOf("across") !== -1) {
                if (Te.indexOf("toaxis") !== -1 && (ye = ge, Me = gt), Te.indexOf("across") !== -1) {
                  var Oe = Ce._counterDomainMin, je = Ce._counterDomainMax;
                  Ce.anchor === "free" && (Oe = Math.min(Oe, Ce.position), je = Math.max(je, Ce.position)), ye = ie.t + (1 - je) * ie.h, Me = ie.t + (1 - Oe) * ie.h;
                }
                ee.insert("line", ":first-child").attr({ x1: ct, x2: ct, y1: ye, y2: Me, "stroke-width": Ie, stroke: ce, "stroke-dasharray": p.dashStyle(Ce.spikedash, Ie) }).classed("spikeline", !0).classed("crisp", !0), ee.insert("line", ":first-child").attr({ x1: ct, x2: ct, y1: ye, y2: Me, "stroke-width": Ie + 2, stroke: Ne }).classed("spikeline", !0).classed("crisp", !0);
              }
              Te.indexOf("marker") !== -1 && ee.insert("circle", ":first-child").attr({ cx: ct, cy: ge - (Ce.side !== "top" ? Ie : -Ie), r: Ie, fill: ce }).classed("spikeline", !0);
            }
          }
        }
        function ae(w, N, W) {
          if (!W || W.length !== w._hoverdata.length) return !0;
          for (var ee = W.length - 1; ee >= 0; ee--) {
            var le = W[ee], ie = w._hoverdata[ee];
            if (le.curveNumber !== ie.curveNumber || String(le.pointNumber) !== String(ie.pointNumber) || String(le.pointNumbers) !== String(ie.pointNumbers) || le.binNumber !== ie.binNumber) return !0;
          }
          return !1;
        }
        function se(w, N) {
          return !0;
        }
        function O(w, N) {
          return c.plainText(w || "", { len: N, allowedTags: ["br", "sub", "sup", "b", "i", "em", "s", "u"] });
        }
        function F(w, N) {
          for (var W = N.charAt(0), ee = [], le = [], ie = [], pe = 0; pe < w.length; pe++) {
            var _e = w[pe];
            x.traceIs(_e.trace, "bar-like") || x.traceIs(_e.trace, "box-violin") ? ie.push(_e) : _e.trace[W + "period"] ? le.push(_e) : ee.push(_e);
          }
          return ee.concat(le).concat(ie);
        }
        function S(w, N, W) {
          var ee = N[w + "a"], le = N[w + "Val"], ie = N.cd[0];
          if (ee.type === "category" || ee.type === "multicategory") le = ee._categoriesMap[le];
          else if (ee.type === "date") {
            var pe = N.trace[w + "periodalignment"];
            if (pe) {
              var _e = N.cd[N.index], Ae = _e[w + "Start"];
              Ae === void 0 && (Ae = _e[w]);
              var Ce = _e[w + "End"];
              Ce === void 0 && (Ce = _e[w]);
              var Ue = Ce - Ae;
              pe === "end" ? le += Ue : pe === "middle" && (le += Ue / 2);
            }
            le = ee.d2c(le);
          }
          return ie && ie.t && ie.t.posLetter === ee._id && (W.boxmode === "group" || W.violinmode === "group") && (le += ie.t.dPos), le;
        }
        var $ = (w) => w.offsetTop + w.clientTop, re = (w) => w.offsetLeft + w.clientLeft;
        function E(w, N) {
          var W = w._fullLayout, ee = N.getBoundingClientRect(), le = ee.left, ie = ee.top, pe = le + ee.width, _e = ie + ee.height, Ae = a.apply3DTransform(W._invTransform)(le, ie), Ce = a.apply3DTransform(W._invTransform)(pe, _e), Ue = Ae[0], Ne = Ae[1], ke = Ce[0], A = Ce[1];
          return { x: Ue, y: Ne, width: ke - Ue, height: A - Ne, top: Math.min(Ne, A), left: Math.min(Ue, ke), right: Math.max(Ue, ke), bottom: Math.max(Ne, A) };
        }
      }), Ao = xe((L, k) => {
        var n = wt(), e = fr(), a = da().isUnifiedHover;
        k.exports = function(i, o, r, s) {
          s = s || {};
          var c = o.legend;
          function t(p) {
            s.font[p] || (s.font[p] = c ? o.legend.font[p] : o.font[p]);
          }
          o && a(o.hovermode) && (s.font || (s.font = {}), t("size"), t("family"), t("color"), t("weight"), t("style"), t("variant"), c ? (s.bgcolor || (s.bgcolor = e.combine(o.legend.bgcolor, o.paper_bgcolor)), s.bordercolor || (s.bordercolor = o.legend.bordercolor)) : s.bgcolor || (s.bgcolor = o.paper_bgcolor)), r("hoverlabel.bgcolor", s.bgcolor), r("hoverlabel.bordercolor", s.bordercolor), r("hoverlabel.namelength", s.namelength), r("hoverlabel.showarrow", s.showarrow), n.coerceFont(r, "hoverlabel.font", s.font), r("hoverlabel.align", s.align);
        };
      }), Dd = xe((L, k) => {
        var n = wt(), e = Ao(), a = Ja();
        k.exports = function(i, o) {
          function r(s, c) {
            return n.coerce(i, o, a, s, c);
          }
          e(i, o, r);
        };
      }), Pd = xe((L, k) => {
        var n = wt(), e = lo(), a = Ao();
        k.exports = function(i, o, r, s) {
          function c(p, l) {
            return n.coerce(i, o, e, p, l);
          }
          var t = n.extendFlat({}, s.hoverlabel);
          o.hovertemplate && (t.namelength = -1), a(i, o, c, t);
        };
      }), gs = xe((L, k) => {
        var n = wt(), e = Ja();
        k.exports = function(a, i) {
          function o(r, s) {
            return i[r] !== void 0 ? i[r] : n.coerce(a, i, e, r, s);
          }
          return o("clickmode"), o("hoversubplots"), o("hovermode");
        };
      }), Id = xe((L, k) => {
        var n = wt(), e = Ja(), a = gs(), i = Ao();
        k.exports = function(o, r) {
          function s(g, x) {
            return n.coerce(o, r, e, g, x);
          }
          var c = a(o, r);
          c && (s("hoverdistance"), s("spikedistance"));
          var t = s("dragmode");
          t === "select" && s("selectdirection");
          var p = r._has("mapbox"), l = r._has("map"), f = r._has("geo"), v = r._basePlotModules.length;
          r.dragmode === "zoom" && ((p || l || f) && v === 1 || (p || l) && f && v === 2) && (r.dragmode = "pan"), i(o, r, s), n.coerceFont(s, "hoverlabel.grouptitlefont", r.hoverlabel.font);
        };
      }), zd = xe((L, k) => {
        var n = wt(), e = or();
        k.exports = function(i) {
          var o = i.calcdata, r = i._fullLayout;
          function s(f) {
            return function(v) {
              return n.coerceHoverinfo({ hoverinfo: v }, { _module: f._module }, r);
            };
          }
          for (var c = 0; c < o.length; c++) {
            var t = o[c], p = t[0].trace;
            if (!e.traceIs(p, "pie-like")) {
              var l = e.traceIs(p, "2dMap") ? a : n.fillArray;
              l(p.hoverinfo, t, "hi", s(p)), p.hovertemplate && l(p.hovertemplate, t, "ht"), p.hoverlabel && (l(p.hoverlabel.bgcolor, t, "hbg"), l(p.hoverlabel.bordercolor, t, "hbc"), l(p.hoverlabel.font.size, t, "hts"), l(p.hoverlabel.font.color, t, "htc"), l(p.hoverlabel.font.family, t, "htf"), l(p.hoverlabel.font.weight, t, "htw"), l(p.hoverlabel.font.style, t, "hty"), l(p.hoverlabel.font.variant, t, "htv"), l(p.hoverlabel.namelength, t, "hnl"), l(p.hoverlabel.align, t, "hta"), l(p.hoverlabel.showarrow, t, "htsa"));
            }
          }
        };
        function a(i, o, r, s) {
          s = s || n.identity, Array.isArray(i) && (o[0][r] = s(i));
        }
      }), Rd = xe((L, k) => {
        var n = or(), e = vs().hover;
        k.exports = function(a, i, o) {
          var r = n.getComponentMethod("annotations", "onClick")(a, a._hoverdata);
          o !== void 0 && e(a, i, o, !0);
          function s() {
            a.emit("plotly_click", { points: a._hoverdata, event: i });
          }
          a._hoverdata && i && i.target && (r && r.then ? r.then(s) : s(), i.stopImmediatePropagation && i.stopImmediatePropagation());
        };
      }), Bn = xe((L, k) => {
        var n = vr(), e = wt(), a = Jn(), i = da(), o = Ja(), r = vs();
        k.exports = { moduleType: "component", name: "fx", constants: bi(), schema: { layout: o }, attributes: lo(), layoutAttributes: o, supplyLayoutGlobalDefaults: Dd(), supplyDefaults: Pd(), supplyLayoutDefaults: Id(), calc: zd(), getDistanceFunction: i.getDistanceFunction, getClosest: i.getClosest, inbox: i.inbox, quadrature: i.quadrature, appendArrayPointValue: i.appendArrayPointValue, castHoverOption: c, castHoverinfo: t, hover: r.hover, unhover: a.unhover, loneHover: r.loneHover, loneUnhover: s, click: Rd() };
        function s(p) {
          var l = e.isD3Selection(p) ? p : n.select(p);
          l.selectAll("g.hovertext").remove(), l.selectAll(".spikeline").remove();
        }
        function c(p, l, f) {
          return e.castOption(p, l, "hoverlabel." + f);
        }
        function t(p, l, f) {
          function v(g) {
            return e.coerceHoverinfo({ hoverinfo: g }, { _module: p._module }, l);
          }
          return e.castOption(p, f, "hoverinfo", v);
        }
      }), Na = xe((L) => {
        L.selectMode = function(k) {
          return k === "lasso" || k === "select";
        }, L.drawMode = function(k) {
          return k === "drawclosedpath" || k === "drawopenpath" || k === "drawline" || k === "drawrect" || k === "drawcircle";
        }, L.openMode = function(k) {
          return k === "drawline" || k === "drawopenpath";
        }, L.rectMode = function(k) {
          return k === "select" || k === "drawline" || k === "drawrect" || k === "drawcircle";
        }, L.freeMode = function(k) {
          return k === "lasso" || k === "drawclosedpath" || k === "drawopenpath";
        }, L.selectingOrDrawing = function(k) {
          return L.freeMode(k) || L.rectMode(k);
        };
      }), So = xe((L, k) => {
        k.exports = function(n) {
          var e = n._fullLayout;
          e._glcanvas && e._glcanvas.size() && e._glcanvas.each(function(a) {
            a.regl && a.regl.clear({ color: !0, depth: !0 });
          });
        };
      }), Lo = xe((L, k) => {
        k.exports = { undo: { width: 857.1, height: 1e3, path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z", transform: "matrix(1 0 0 -1 0 850)" }, home: { width: 928.6, height: 1e3, path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z", transform: "matrix(1 0 0 -1 0 850)" }, "camera-retro": { width: 1e3, height: 1e3, path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z", transform: "matrix(1 0 0 -1 0 850)" }, zoombox: { width: 1e3, height: 1e3, path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z", transform: "matrix(1 0 0 -1 0 850)" }, pan: { width: 1e3, height: 1e3, path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z", transform: "matrix(1 0 0 -1 0 850)" }, zoom_plus: { width: 875, height: 1e3, path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z", transform: "matrix(1 0 0 -1 0 850)" }, zoom_minus: { width: 875, height: 1e3, path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z", transform: "matrix(1 0 0 -1 0 850)" }, autoscale: { width: 1e3, height: 1e3, path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z", transform: "matrix(1 0 0 -1 0 850)" }, tooltip_basic: { width: 1500, height: 1e3, path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z", transform: "matrix(1 0 0 -1 0 850)" }, tooltip_compare: { width: 1125, height: 1e3, path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z", transform: "matrix(1 0 0 -1 0 850)" }, plotlylogo: { width: 1542, height: 1e3, path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z", transform: "matrix(1 0 0 -1 0 850)" }, "z-axis": { width: 1e3, height: 1e3, path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z", transform: "matrix(1 0 0 -1 0 850)" }, "3d_rotate": { width: 1e3, height: 1e3, path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z", transform: "matrix(1 0 0 -1 0 850)" }, camera: { width: 1e3, height: 1e3, path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z", transform: "matrix(1 0 0 -1 0 850)" }, movie: { width: 1e3, height: 1e3, path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z", transform: "matrix(1 0 0 -1 0 850)" }, question: { width: 857.1, height: 1e3, path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z", transform: "matrix(1 0 0 -1 0 850)" }, disk: { width: 857.1, height: 1e3, path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z", transform: "matrix(1 0 0 -1 0 850)" }, drawopenpath: { width: 70, height: 70, path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z", transform: "matrix(1 0 0 1 -15 -15)" }, drawclosedpath: { width: 90, height: 90, path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z", transform: "matrix(1 0 0 1 -5 -5)" }, lasso: { width: 1031, height: 1e3, path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z", transform: "matrix(1 0 0 -1 0 850)" }, selectbox: { width: 1e3, height: 1e3, path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z", transform: "matrix(1 0 0 -1 0 850)" }, drawline: { width: 70, height: 70, path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z", transform: "matrix(1 0 0 1 -15 -15)" }, drawrect: { width: 80, height: 80, path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z", transform: "matrix(1 0 0 1 -10 -10)" }, drawcircle: { width: 80, height: 80, path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z", transform: "matrix(1 0 0 1 -10 -10)" }, eraseshape: { width: 80, height: 80, path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z", transform: "matrix(1 0 0 1 -10 -10)" }, spikeline: { width: 1e3, height: 1e3, path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z", transform: "matrix(1.5 0 0 -1.5 0 850)" }, pencil: { width: 1792, height: 1792, path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z", transform: "matrix(1 0 0 1 0 1)" }, newplotlylogo: { name: "newplotlylogo", svg: ["<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>", " <title>plotly-logomark</title>", " <g id='symbol'>", "  <rect fill='#000' x='0' y='0' width='132' height='132' rx='18' ry='18'/>", "  <circle fill='#9EF' cx='102' cy='30' r='6'/>", "  <circle fill='#BAC' cx='78' cy='30' r='6'/>", "  <circle fill='#BAC' cx='78' cy='54' r='6'/>", "  <circle fill='#D69' cx='54' cy='30' r='6'/>", "  <circle fill='#F26' cx='30' cy='30' r='6'/>", "  <circle fill='#F26' cx='30' cy='54' r='6'/>", "  <path fill='#FFF' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>", "  <path fill='#FFF' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>", "  <path fill='#FFF' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>", "  <path fill='#FFF' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>", " </g>", "</svg>"].join("") } };
      }), Oo = xe((L, k) => {
        var n = 32;
        k.exports = { CIRCLE_SIDES: n, i000: 0, i090: n / 4, i180: n / 2, i270: n / 4 * 3, cos45: Math.cos(Math.PI / 4), sin45: Math.sin(Math.PI / 4), SQRT2: Math.sqrt(2) };
      }), Co = xe((L, k) => {
        var n = wt().strTranslate;
        function e(r, s) {
          switch (r.type) {
            case "log":
              return r.p2d(s);
            case "date":
              return r.p2r(s, 0, r.calendar);
            default:
              return r.p2r(s);
          }
        }
        function a(r, s) {
          switch (r.type) {
            case "log":
              return r.d2p(s);
            case "date":
              return r.r2p(s, 0, r.calendar);
            default:
              return r.r2p(s);
          }
        }
        function i(r) {
          var s = r._id.charAt(0) === "y" ? 1 : 0;
          return function(c) {
            return e(r, c[s]);
          };
        }
        function o(r) {
          return n(r.xaxis._offset, r.yaxis._offset);
        }
        k.exports = { p2r: e, r2p: a, axValue: i, getTransform: o };
      }), Sa = xe((L) => {
        var k = ls(), n = Oo(), e = n.CIRCLE_SIDES, a = n.SQRT2, i = Co(), o = i.p2r, r = i.r2p, s = [0, 3, 4, 5, 6, 1, 2], c = [0, 3, 4, 1, 2];
        L.writePaths = function(l) {
          var f = l.length;
          if (!f) return "M0,0Z";
          for (var v = "", g = 0; g < f; g++) for (var x = l[g].length, h = 0; h < x; h++) {
            var m = l[g][h][0];
            if (m === "Z") v += "Z";
            else for (var u = l[g][h].length, d = 0; d < u; d++) {
              var y = d;
              m === "Q" || m === "S" ? y = c[d] : m === "C" && (y = s[d]), v += l[g][h][y], d > 0 && d < u - 1 && (v += ",");
            }
          }
          return v;
        }, L.readPaths = function(l, f, v, g) {
          var x = k(l), h = [], m = -1, u = function() {
            m++, h[m] = [];
          }, d, y = 0, _ = 0, T, R, I = function() {
            T = y, R = _;
          };
          I();
          for (var P = 0; P < x.length; P++) {
            var M = [], B, z, q, U, G = x[P][0], K = G;
            switch (G) {
              case "M":
                u(), y = +x[P][1], _ = +x[P][2], M.push([K, y, _]), I();
                break;
              case "Q":
              case "S":
                B = +x[P][1], q = +x[P][2], y = +x[P][3], _ = +x[P][4], M.push([K, y, _, B, q]);
                break;
              case "C":
                B = +x[P][1], q = +x[P][2], z = +x[P][3], U = +x[P][4], y = +x[P][5], _ = +x[P][6], M.push([K, y, _, B, q, z, U]);
                break;
              case "T":
              case "L":
                y = +x[P][1], _ = +x[P][2], M.push([K, y, _]);
                break;
              case "H":
                K = "L", y = +x[P][1], M.push([K, y, _]);
                break;
              case "V":
                K = "L", _ = +x[P][1], M.push([K, y, _]);
                break;
              case "A":
                K = "L";
                var te = +x[P][1], V = +x[P][2];
                +x[P][4] || (te = -te, V = -V);
                var Z = y - te, Y = _;
                for (d = 1; d <= e / 2; d++) {
                  var C = 2 * Math.PI * d / e;
                  M.push([K, Z + te * Math.cos(C), Y + V * Math.sin(C)]);
                }
                break;
              case "Z":
                (y !== T || _ !== R) && (y = T, _ = R, M.push([K, y, _]));
                break;
            }
            for (var j = (v || {}).domain, J = f._fullLayout._size, ne = v && v.xsizemode === "pixel", ae = v && v.ysizemode === "pixel", se = g === !1, O = 0; O < M.length; O++) {
              for (d = 0; d + 2 < 7; d += 2) {
                var F = M[O][d + 1], S = M[O][d + 2];
                F === void 0 || S === void 0 || (y = F, _ = S, v && (v.xaxis && v.xaxis.p2r ? (se && (F -= v.xaxis._offset), ne ? F = r(v.xaxis, v.xanchor) + F : F = o(v.xaxis, F)) : (se && (F -= J.l), j ? F = j.x[0] + F / J.w : F = F / J.w), v.yaxis && v.yaxis.p2r ? (se && (S -= v.yaxis._offset), ae ? S = r(v.yaxis, v.yanchor) - S : S = o(v.yaxis, S)) : (se && (S -= J.t), j ? S = j.y[1] - S / J.h : S = 1 - S / J.h)), M[O][d + 1] = F, M[O][d + 2] = S);
              }
              h[m].push(M[O].slice());
            }
          }
          return h;
        };
        function t(l, f) {
          return Math.abs(l - f) <= 1e-6;
        }
        function p(l, f) {
          var v = f[1] - l[1], g = f[2] - l[2];
          return Math.sqrt(v * v + g * g);
        }
        L.pointsOnRectangle = function(l) {
          var f = l.length;
          if (f !== 5) return !1;
          for (var v = 1; v < 3; v++) {
            var g = l[0][v] - l[1][v], x = l[3][v] - l[2][v];
            if (!t(g, x)) return !1;
            var h = l[0][v] - l[3][v], m = l[1][v] - l[2][v];
            if (!t(h, m)) return !1;
          }
          return !t(l[0][1], l[1][1]) && !t(l[0][1], l[3][1]) ? !1 : !!(p(l[0], l[1]) * p(l[0], l[3]));
        }, L.pointsOnEllipse = function(l) {
          var f = l.length;
          if (f !== e + 1) return !1;
          f = e;
          for (var v = 0; v < f; v++) {
            var g = (f * 2 - v) % f, x = (f / 2 + g) % f, h = (f / 2 + v) % f;
            if (!t(p(l[v], l[h]), p(l[g], l[x]))) return !1;
          }
          return !0;
        }, L.handleEllipse = function(l, f, v) {
          if (!l) return [f, v];
          var g = L.ellipseOver({ x0: f[0], y0: f[1], x1: v[0], y1: v[1] }), x = (g.x1 + g.x0) / 2, h = (g.y1 + g.y0) / 2, m = (g.x1 - g.x0) / 2, u = (g.y1 - g.y0) / 2;
          m || (m = u = u / a), u || (u = m = m / a);
          for (var d = [], y = 0; y < e; y++) {
            var _ = y * 2 * Math.PI / e;
            d.push([x + m * Math.cos(_), h + u * Math.sin(_)]);
          }
          return d;
        }, L.ellipseOver = function(l) {
          var f = l.x0, v = l.y0, g = l.x1, x = l.y1, h = g - f, m = x - v;
          f -= h, v -= m;
          var u = (f + g) / 2, d = (v + x) / 2, y = a;
          return h *= y, m *= y, { x0: u - h, y0: d - m, x1: u + h, y1: d + m };
        }, L.fixDatesForPaths = function(l, f, v) {
          var g = f.type === "date", x = v.type === "date";
          if (!g && !x) return l;
          for (var h = 0; h < l.length; h++) for (var m = 0; m < l[h].length; m++) for (var u = 0; u + 2 < l[h][m].length; u += 2) g && (l[h][m][u + 1] = l[h][m][u + 1].replace(" ", "_")), x && (l[h][m][u + 2] = l[h][m][u + 2].replace(" ", "_"));
          return l;
        };
      }), Eo = xe((L, k) => {
        var n = sn(), e = Na(), a = e.drawMode, i = e.openMode, o = Oo(), r = o.i000, s = o.i090, c = o.i180, t = o.i270, p = o.cos45, l = o.sin45, f = Co(), v = f.p2r, g = f.r2p, x = Ma(), h = x.clearOutline, m = Sa(), u = m.readPaths, d = m.writePaths, y = m.ellipseOver, _ = m.fixDatesForPaths;
        function T(I, P) {
          if (I.length) {
            var M = I[0][0];
            if (M) {
              var B = P.gd, z = P.isActiveShape, q = P.dragmode, U = (B.layout || {}).shapes || [];
              if (!a(q) && z !== void 0) {
                var G = B._fullLayout._activeShapeIndex;
                if (G < U.length) switch (B._fullLayout.shapes[G].type) {
                  case "rect":
                    q = "drawrect";
                    break;
                  case "circle":
                    q = "drawcircle";
                    break;
                  case "line":
                    q = "drawline";
                    break;
                  case "path":
                    var K = U[G].path || "";
                    K[K.length - 1] === "Z" ? q = "drawclosedpath" : q = "drawopenpath";
                    break;
                }
              }
              var te = R(I, P, q);
              h(B);
              for (var V = P.editHelpers, Z = (V || {}).modifyItem, Y = [], C = 0; C < U.length; C++) {
                var j = B._fullLayout.shapes[C];
                if (Y[C] = j._input, z !== void 0 && C === B._fullLayout._activeShapeIndex) {
                  var J = te;
                  switch (j.type) {
                    case "line":
                    case "rect":
                    case "circle":
                      var ne = n.getFromId(B, j.xref);
                      j.xref.charAt(0) === "x" && ne.type.includes("category") ? (Z("x0", J.x0 - (j.x0shift || 0)), Z("x1", J.x1 - (j.x1shift || 0))) : (Z("x0", J.x0), Z("x1", J.x1));
                      var ae = n.getFromId(B, j.yref);
                      j.yref.charAt(0) === "y" && ae.type.includes("category") ? (Z("y0", J.y0 - (j.y0shift || 0)), Z("y1", J.y1 - (j.y1shift || 0))) : (Z("y0", J.y0), Z("y1", J.y1));
                      break;
                    case "path":
                      Z("path", J.path);
                      break;
                  }
                }
              }
              return z === void 0 ? (Y.push(te), Y) : V ? V.getUpdateObj() : {};
            }
          }
        }
        function R(I, P, M) {
          var B = I[0][0], z = P.gd, q = B.getAttribute("d"), U = z._fullLayout.newshape, G = P.plotinfo, K = P.isActiveShape, te = G.xaxis, V = G.yaxis, Z = !!G.domain || !G.xaxis, Y = !!G.domain || !G.yaxis, C = i(M), j = u(q, z, G, K), J = { editable: !0, visible: U.visible, name: U.name, showlegend: U.showlegend, legend: U.legend, legendwidth: U.legendwidth, legendgroup: U.legendgroup, legendgrouptitle: { text: U.legendgrouptitle.text, font: U.legendgrouptitle.font }, legendrank: U.legendrank, label: U.label, xref: Z ? "paper" : te._id, yref: Y ? "paper" : V._id, layer: U.layer, opacity: U.opacity, line: { color: U.line.color, width: U.line.width, dash: U.line.dash } };
          C || (J.fillcolor = U.fillcolor, J.fillrule = U.fillrule);
          var ne;
          if (j.length === 1 && (ne = j[0]), ne && ne.length === 5 && M === "drawrect") J.type = "rect", J.x0 = ne[0][1], J.y0 = ne[0][2], J.x1 = ne[2][1], J.y1 = ne[2][2];
          else if (ne && M === "drawline") J.type = "line", J.x0 = ne[0][1], J.y0 = ne[0][2], J.x1 = ne[1][1], J.y1 = ne[1][2];
          else if (ne && M === "drawcircle") {
            J.type = "circle";
            var ae = ne[r][1], se = ne[s][1], O = ne[c][1], F = ne[t][1], S = ne[r][2], $ = ne[s][2], re = ne[c][2], E = ne[t][2], w = G.xaxis && (G.xaxis.type === "date" || G.xaxis.type === "log"), N = G.yaxis && (G.yaxis.type === "date" || G.yaxis.type === "log");
            w && (ae = g(G.xaxis, ae), se = g(G.xaxis, se), O = g(G.xaxis, O), F = g(G.xaxis, F)), N && (S = g(G.yaxis, S), $ = g(G.yaxis, $), re = g(G.yaxis, re), E = g(G.yaxis, E));
            var W = (se + F) / 2, ee = (S + re) / 2, le = (F - se + O - ae) / 2, ie = (E - $ + re - S) / 2, pe = y({ x0: W, y0: ee, x1: W + le * p, y1: ee + ie * l });
            w && (pe.x0 = v(G.xaxis, pe.x0), pe.x1 = v(G.xaxis, pe.x1)), N && (pe.y0 = v(G.yaxis, pe.y0), pe.y1 = v(G.yaxis, pe.y1)), J.x0 = pe.x0, J.y0 = pe.y0, J.x1 = pe.x1, J.y1 = pe.y1;
          } else J.type = "path", te && V && _(j, te, V), J.path = d(j), ne = null;
          return J;
        }
        k.exports = { newShapes: T, createShapeObj: R };
      }), ys = xe((L, k) => {
        var n = Na(), e = n.selectMode, a = Ma(), i = a.clearOutline, o = Sa(), r = o.readPaths, s = o.writePaths, c = o.fixDatesForPaths;
        k.exports = function(t, p) {
          if (t.length) {
            var l = t[0][0];
            if (l) {
              var f = l.getAttribute("d"), v = p.gd, g = v._fullLayout.newselection, x = p.plotinfo, h = x.xaxis, m = x.yaxis, u = p.isActiveSelection, d = p.dragmode, y = (v.layout || {}).selections || [];
              if (!e(d) && u !== void 0) {
                var _ = v._fullLayout._activeSelectionIndex;
                if (_ < y.length) switch (v._fullLayout.selections[_].type) {
                  case "rect":
                    d = "select";
                    break;
                  case "path":
                    d = "lasso";
                    break;
                }
              }
              var T = r(f, v, x, u), R = { xref: h._id, yref: m._id, opacity: g.opacity, line: { color: g.line.color, width: g.line.width, dash: g.line.dash } }, I;
              T.length === 1 && (I = T[0]), I && I.length === 5 && d === "select" ? (R.type = "rect", R.x0 = I[0][1], R.y0 = I[0][2], R.x1 = I[2][1], R.y1 = I[2][2]) : (R.type = "path", h && m && c(T, h, m), R.path = s(T), I = null), i(v);
              for (var P = p.editHelpers, M = (P || {}).modifyItem, B = [], z = 0; z < y.length; z++) {
                var q = v._fullLayout.selections[z];
                if (!q) {
                  B[z] = q;
                  continue;
                }
                if (B[z] = q._input, u !== void 0 && z === v._fullLayout._activeSelectionIndex) {
                  var U = R;
                  switch (q.type) {
                    case "rect":
                      M("x0", U.x0), M("x1", U.x1), M("y0", U.y0), M("y1", U.y1);
                      break;
                    case "path":
                      M("path", U.path);
                      break;
                  }
                }
              }
              return u === void 0 ? (B.push(R), B) : P ? P.getUpdateObj() : {};
            }
          }
        };
      }), Mi = xe((L, k) => {
        k.exports = { segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g, paramRE: /[^\s,]+/g, paramIsX: { M: { 0: !0, drawn: 0 }, L: { 0: !0, drawn: 0 }, H: { 0: !0, drawn: 0 }, V: {}, Q: { 0: !0, 2: !0, drawn: 2 }, C: { 0: !0, 2: !0, 4: !0, drawn: 4 }, T: { 0: !0, drawn: 0 }, S: { 0: !0, 2: !0, drawn: 2 }, Z: {} }, paramIsY: { M: { 1: !0, drawn: 1 }, L: { 1: !0, drawn: 1 }, H: {}, V: { 0: !0, drawn: 0 }, Q: { 1: !0, 3: !0, drawn: 3 }, C: { 1: !0, 3: !0, 5: !0, drawn: 5 }, T: { 1: !0, drawn: 1 }, S: { 1: !0, 3: !0, drawn: 5 }, Z: {} }, numParams: { M: 2, L: 2, H: 1, V: 1, Q: 4, C: 6, T: 2, S: 4, Z: 0 } };
      }), La = xe((L) => {
        var k = Mi(), n = wt(), e = Ar();
        L.rangeToShapePosition = function(o) {
          return o.type === "log" ? o.r2d : function(r) {
            return r;
          };
        }, L.shapePositionToRange = function(o) {
          return o.type === "log" ? o.d2r : function(r) {
            return r;
          };
        }, L.decodeDate = function(o) {
          return function(r) {
            return r.replace && (r = r.replace("_", " ")), o(r);
          };
        }, L.encodeDate = function(o) {
          return function(r) {
            return o(r).replace(" ", "_");
          };
        }, L.extractPathCoords = function(o, r, s) {
          var c = [], t = o.match(k.segmentRE);
          return t.forEach(function(p) {
            var l = r[p.charAt(0)].drawn;
            if (l !== void 0) {
              var f = p.substr(1).match(k.paramRE);
              if (!(!f || f.length < l)) {
                var v = f[l], g = s ? v : n.cleanNumber(v);
                c.push(g);
              }
            }
          }), c;
        }, L.getDataToPixel = function(o, r, s, c, t) {
          var p = o._fullLayout._size, l;
          if (r) if (t === "domain") l = function(v) {
            return r._length * (c ? 1 - v : v) + r._offset;
          };
          else {
            var f = L.shapePositionToRange(r);
            l = function(v) {
              var g = i(r, s);
              return r._offset + r.r2p(f(v, !0)) + g;
            }, r.type === "date" && (l = L.decodeDate(l));
          }
          else c ? l = function(v) {
            return p.t + p.h * (1 - v);
          } : l = function(v) {
            return p.l + p.w * v;
          };
          return l;
        }, L.getPixelToData = function(o, r, s, c) {
          var t = o._fullLayout._size, p;
          if (r) if (c === "domain") p = function(f) {
            var v = (f - r._offset) / r._length;
            return s ? 1 - v : v;
          };
          else {
            var l = L.rangeToShapePosition(r);
            p = function(f) {
              return l(r.p2r(f - r._offset));
            };
          }
          else s ? p = function(f) {
            return 1 - (f - t.t) / t.h;
          } : p = function(f) {
            return (f - t.l) / t.w;
          };
          return p;
        }, L.roundPositionForSharpStrokeRendering = function(o, r) {
          var s = Math.round(r % 2) === 1, c = Math.round(o);
          return s ? c + 0.5 : c;
        }, L.makeShapesOptionsAndPlotinfo = function(o, r) {
          var s = o._fullLayout.shapes[r] || {}, c = o._fullLayout._plots[s.xref + s.yref], t = !!c;
          return t ? c._hadPlotinfo = !0 : (c = {}, s.xref && s.xref !== "paper" && (c.xaxis = o._fullLayout[s.xref + "axis"]), s.yref && s.yref !== "paper" && (c.yaxis = o._fullLayout[s.yref + "axis"])), c.xsizemode = s.xsizemode, c.ysizemode = s.ysizemode, c.xanchor = s.xanchor, c.yanchor = s.yanchor, { options: s, plotinfo: c };
        }, L.makeSelectionsOptionsAndPlotinfo = function(o, r) {
          var s = o._fullLayout.selections[r] || {}, c = o._fullLayout._plots[s.xref + s.yref], t = !!c;
          return t ? c._hadPlotinfo = !0 : (c = {}, s.xref && (c.xaxis = o._fullLayout[s.xref + "axis"]), s.yref && (c.yaxis = o._fullLayout[s.yref + "axis"])), { options: s, plotinfo: c };
        }, L.getPathString = function(o, r) {
          var s = r.type, c = e.getRefType(r.xref), t = e.getRefType(r.yref), p = e.getFromId(o, r.xref), l = e.getFromId(o, r.yref), f = o._fullLayout._size, v, g, x, h, m = i(p, r.x0shift), u = i(p, r.x1shift), d = i(l, r.y0shift), y = i(l, r.y1shift), _, T, R, I;
          if (p ? c === "domain" ? g = function(V) {
            return p._offset + p._length * V;
          } : (v = L.shapePositionToRange(p), g = function(V) {
            return p._offset + p.r2p(v(V, !0));
          }) : g = function(V) {
            return f.l + f.w * V;
          }, l ? t === "domain" ? h = function(V) {
            return l._offset + l._length * (1 - V);
          } : (x = L.shapePositionToRange(l), h = function(V) {
            return l._offset + l.r2p(x(V, !0));
          }) : h = function(V) {
            return f.t + f.h * (1 - V);
          }, s === "path") return p && p.type === "date" && (g = L.decodeDate(g)), l && l.type === "date" && (h = L.decodeDate(h)), a(r, g, h);
          if (r.xsizemode === "pixel") {
            var P = g(r.xanchor);
            _ = P + r.x0 + m, T = P + r.x1 + u;
          } else _ = g(r.x0) + m, T = g(r.x1) + u;
          if (r.ysizemode === "pixel") {
            var M = h(r.yanchor);
            R = M - r.y0 + d, I = M - r.y1 + y;
          } else R = h(r.y0) + d, I = h(r.y1) + y;
          if (s === "line") return "M" + _ + "," + R + "L" + T + "," + I;
          if (s === "rect") return "M" + _ + "," + R + "H" + T + "V" + I + "H" + _ + "Z";
          var B = (_ + T) / 2, z = (R + I) / 2, q = Math.abs(B - _), U = Math.abs(z - R), G = "A" + q + "," + U, K = B + q + "," + z, te = B + "," + (z - U);
          return "M" + K + G + " 0 1,1 " + te + G + " 0 0,1 " + K + "Z";
        };
        function a(o, r, s) {
          var c = o.path, t = o.xsizemode, p = o.ysizemode, l = o.xanchor, f = o.yanchor;
          return c.replace(k.segmentRE, function(v) {
            var g = 0, x = v.charAt(0), h = k.paramIsX[x], m = k.paramIsY[x], u = k.numParams[x], d = v.substr(1).replace(k.paramRE, function(y) {
              return h[g] ? t === "pixel" ? y = r(l) + Number(y) : y = r(y) : m[g] && (p === "pixel" ? y = s(f) - Number(y) : y = s(y)), g++, g > u && (y = "X"), y;
            });
            return g > u && (d = d.replace(/[\s,]*X.*/, ""), n.log("Ignoring extra params in segment " + v)), x + d;
          });
        }
        function i(o, r) {
          r = r || 0;
          var s = 0;
          return r && o && (o.type === "category" || o.type === "multicategory") && (s = (o.r2p(1) - o.r2p(0)) * r), s;
        }
      }), ms = xe((L, k) => {
        var n = wt(), e = Ar(), a = xn(), i = Or(), o = Sa().readPaths, r = La(), s = r.getPathString, c = fo(), t = kn().FROM_TL;
        k.exports = function(f, v, g, x) {
          if (x.selectAll(".shape-label").remove(), !!(g.label.text || g.label.texttemplate)) {
            var h;
            if (g.label.texttemplate) {
              var m = {};
              if (g.type !== "path") {
                var u = e.getFromId(f, g.xref), d = e.getFromId(f, g.yref);
                for (var y in c) {
                  var _ = c[y](g, u, d);
                  _ !== void 0 && (m[y] = _);
                }
              }
              h = n.texttemplateStringForShapes({ data: [m], fallback: g.label.texttemplatefallback, locale: f._fullLayout._d3locale, template: g.label.texttemplate });
            } else h = g.label.text;
            var T = { "data-index": v }, R = g.label.font, I = { "data-notex": 1 }, P = x.append("g").attr(T).classed("shape-label", !0), M = P.append("text").attr(I).classed("shape-label-text", !0).text(h), B, z, q, U;
            if (g.path) {
              var G = s(f, g), K = o(G, f);
              B = 1 / 0, q = 1 / 0, z = -1 / 0, U = -1 / 0;
              for (var te = 0; te < K.length; te++) for (var V = 0; V < K[te].length; V++) for (var Z = K[te][V], Y = 1; Y < Z.length; Y += 2) {
                var C = Z[Y], j = Z[Y + 1];
                B = Math.min(B, C), z = Math.max(z, C), q = Math.min(q, j), U = Math.max(U, j);
              }
            } else {
              var J = e.getFromId(f, g.xref), ne = g.x0shift, ae = g.x1shift, se = e.getRefType(g.xref), O = e.getFromId(f, g.yref), F = g.y0shift, S = g.y1shift, $ = e.getRefType(g.yref), re = function(pe, _e) {
                var Ae = r.getDataToPixel(f, J, _e, !1, se);
                return Ae(pe);
              }, E = function(pe, _e) {
                var Ae = r.getDataToPixel(f, O, _e, !0, $);
                return Ae(pe);
              };
              B = re(g.x0, ne), z = re(g.x1, ae), q = E(g.y0, F), U = E(g.y1, S);
            }
            var w = g.label.textangle;
            w === "auto" && (g.type === "line" ? w = p(B, q, z, U) : w = 0), M.call(function(pe) {
              return pe.call(i.font, R).attr({}), a.convertToTspans(pe, f), pe;
            });
            var N = i.bBox(M.node()), W = l(B, q, z, U, g, w, N), ee = W.textx, le = W.texty, ie = W.xanchor;
            M.attr({ "text-anchor": { left: "start", center: "middle", right: "end" }[ie], y: le, x: ee, transform: "rotate(" + w + "," + ee + "," + le + ")" }).call(a.positionText, ee, le);
          }
        };
        function p(f, v, g, x) {
          var h, m;
          return m = Math.abs(g - f), g >= f ? h = v - x : h = x - v, -180 / Math.PI * Math.atan2(h, m);
        }
        function l(f, v, g, x, h, m, u) {
          var d = h.label.textposition, y = h.label.textangle, _ = h.label.padding, T = h.type, R = Math.PI / 180 * m, I = Math.sin(R), P = Math.cos(R), M = h.label.xanchor, B = h.label.yanchor, z, q, U, G;
          if (T === "line") {
            d === "start" ? (z = f, q = v) : d === "end" ? (z = g, q = x) : (z = (f + g) / 2, q = (v + x) / 2), M === "auto" && (d === "start" ? y === "auto" ? g > f ? M = "left" : g < f ? M = "right" : M = "center" : g > f ? M = "right" : g < f ? M = "left" : M = "center" : d === "end" ? y === "auto" ? g > f ? M = "right" : g < f ? M = "left" : M = "center" : g > f ? M = "left" : g < f ? M = "right" : M = "center" : M = "center");
            var K = { left: 1, center: 0, right: -1 }, te = { bottom: -1, middle: 0, top: 1 };
            if (y === "auto") {
              var V = te[B];
              U = -_ * I * V, G = _ * P * V;
            } else {
              var Z = K[M], Y = te[B];
              U = _ * Z, G = _ * Y;
            }
            z = z + U, q = q + G;
          } else U = _ + 3, d.indexOf("right") !== -1 ? (z = Math.max(f, g) - U, M === "auto" && (M = "right")) : d.indexOf("left") !== -1 ? (z = Math.min(f, g) + U, M === "auto" && (M = "left")) : (z = (f + g) / 2, M === "auto" && (M = "center")), d.indexOf("top") !== -1 ? q = Math.min(v, x) : d.indexOf("bottom") !== -1 ? q = Math.max(v, x) : q = (v + x) / 2, G = _, B === "bottom" ? q = q - G : B === "top" && (q = q + G);
          var C = t[B], j = h.label.font.size, J = u.height, ne = (J * C - j) * I, ae = -(J * C - j) * P;
          return { textx: z + ne, texty: q + ae, xanchor: M };
        }
      }), Do = xe((L, k) => {
        var n = wt(), e = n.strTranslate, a = Jn(), i = Na(), o = i.drawMode, r = i.selectMode, s = or(), c = fr(), t = Oo(), p = t.i000, l = t.i090, f = t.i180, v = t.i270, g = Ma(), x = g.clearOutlineControllers, h = Sa(), m = h.pointsOnRectangle, u = h.pointsOnEllipse, d = h.writePaths, y = Eo().newShapes, _ = Eo().createShapeObj, T = ys(), R = ms();
        k.exports = function B(z, q, U, G) {
          G || (G = 0);
          var K = U.gd;
          function te() {
            B(z, q, U, G++), (u(z[0]) || U.hasText) && V({ redrawing: !0 });
          }
          function V(Ne) {
            var ke = {};
            U.isActiveShape !== void 0 && (U.isActiveShape = !1, ke = y(q, U)), U.isActiveSelection !== void 0 && (U.isActiveSelection = !1, ke = T(q, U), K._fullLayout._reselect = !0), Object.keys(ke).length && s.call((Ne || {}).redrawing ? "relayout" : "_guiRelayout", K, ke);
          }
          var Z = K._fullLayout, Y = Z._zoomlayer, C = U.dragmode, j = o(C), J = r(C);
          (j || J) && (K._fullLayout._outlining = !0), x(K), q.attr("d", d(z));
          var ne, ae, se, O, F;
          if (!G && (U.isActiveShape || U.isActiveSelection)) {
            F = I([], z);
            var S = Y.append("g").attr("class", "outline-controllers");
            le(S), Ue();
          }
          if (j && U.hasText) {
            var $ = Y.select(".label-temp"), re = _(q, U, U.dragmode);
            R(K, "label-temp", re, $);
          }
          function E(Ne) {
            se = +Ne.srcElement.getAttribute("data-i"), O = +Ne.srcElement.getAttribute("data-j"), ne[se][O].moveFn = w;
          }
          function w(Ne, ke) {
            if (z.length) {
              var A = F[se][O][1], X = F[se][O][2], H = z[se], ve = H.length;
              if (m(H)) {
                var be = Ne, Se = ke;
                if (U.isActiveSelection) {
                  var De = P(H, O);
                  De[1] === H[O][1] ? Se = 0 : be = 0;
                }
                for (var He = 0; He < ve; He++) if (He !== O) {
                  var Ze = H[He];
                  Ze[1] === H[O][1] && (Ze[1] = A + be), Ze[2] === H[O][2] && (Ze[2] = X + Se);
                }
                if (H[O][1] = A + be, H[O][2] = X + Se, !m(H)) for (var We = 0; We < ve; We++) for (var $e = 0; $e < H[We].length; $e++) H[We][$e] = F[se][We][$e];
              } else H[O][1] = A + Ne, H[O][2] = X + ke;
              te();
            }
          }
          function N() {
            V();
          }
          function W() {
            if (z.length && z[se] && z[se].length) {
              for (var Ne = [], ke = 0; ke < z[se].length; ke++) ke !== O && Ne.push(z[se][ke]);
              Ne.length > 1 && !(Ne.length === 2 && Ne[1][0] === "Z") && (O === 0 && (Ne[0][0] = "M"), z[se] = Ne, te(), V());
            }
          }
          function ee(Ne, ke) {
            if (Ne === 2) {
              se = +ke.srcElement.getAttribute("data-i"), O = +ke.srcElement.getAttribute("data-j");
              var A = z[se];
              !m(A) && !u(A) && W();
            }
          }
          function le(Ne) {
            ne = [];
            for (var ke = 0; ke < z.length; ke++) {
              var A = z[ke], X = m(A), H = !X && u(A);
              ne[ke] = [];
              for (var ve = A.length, be = 0; be < ve; be++) if (A[be][0] !== "Z" && !(H && be !== p && be !== l && be !== f && be !== v)) {
                var Se = X && U.isActiveSelection, De;
                Se && (De = P(A, be));
                var He = A[be][1], Ze = A[be][2], We = Ne.append(Se ? "rect" : "circle").attr("data-i", ke).attr("data-j", be).style({ fill: c.background, stroke: c.defaultLine, "stroke-width": 1, "shape-rendering": "crispEdges" });
                if (Se) {
                  var $e = De[1] - He, it = De[2] - Ze, Ke = it ? 5 : Math.max(Math.min(25, Math.abs($e) - 5), 5), ct = $e ? 5 : Math.max(Math.min(25, Math.abs(it) - 5), 5);
                  We.classed(it ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", Ke).attr("height", ct).attr("x", He - Ke / 2).attr("y", Ze - ct / 2).attr("transform", e($e / 2, it / 2));
                } else We.classed("cursor-grab", !0).attr("r", 5).attr("cx", He).attr("cy", Ze);
                ne[ke][be] = { element: We.node(), gd: K, prepFn: E, doneFn: N, clickFn: ee }, a.init(ne[ke][be]);
              }
            }
          }
          function ie(Ne, ke) {
            if (z.length) for (var A = 0; A < z.length; A++) for (var X = 0; X < z[A].length; X++) for (var H = 0; H + 2 < z[A][X].length; H += 2) z[A][X][H + 1] = F[A][X][H + 1] + Ne, z[A][X][H + 2] = F[A][X][H + 2] + ke;
          }
          function pe(Ne, ke) {
            ie(Ne, ke), te();
          }
          function _e(Ne) {
            se = +Ne.srcElement.getAttribute("data-i"), se || (se = 0), ae[se].moveFn = pe;
          }
          function Ae() {
            V();
          }
          function Ce(Ne) {
            Ne === 2 && M(K);
          }
          function Ue() {
            if (ae = [], !!z.length) {
              var Ne = 0;
              ae[Ne] = { element: q[0][0], gd: K, prepFn: _e, doneFn: Ae, clickFn: Ce }, a.init(ae[Ne]);
            }
          }
        };
        function I(B, z) {
          for (var q = 0; q < z.length; q++) {
            var U = z[q];
            B[q] = [];
            for (var G = 0; G < U.length; G++) {
              B[q][G] = [];
              for (var K = 0; K < U[G].length; K++) B[q][G][K] = U[G][K];
            }
          }
          return B;
        }
        function P(B, z) {
          var q = B[z][1], U = B[z][2], G = B.length, K, te, V;
          return K = (z + 1) % G, te = B[K][1], V = B[K][2], te === q && V === U && (K = (z + 2) % G, te = B[K][1], V = B[K][2]), [K, te, V];
        }
        function M(B) {
          if (r(B._fullLayout.dragmode)) {
            x(B);
            var z = B._fullLayout._activeSelectionIndex, q = (B.layout || {}).selections || [];
            if (z < q.length) {
              for (var U = [], G = 0; G < q.length; G++) G !== z && U.push(q[G]);
              delete B._fullLayout._activeSelectionIndex;
              var K = B._fullLayout.selections[z];
              B._fullLayout._deselect = { xref: K.xref, yref: K.yref }, s.call("_guiRelayout", B, { selections: U });
            }
          }
        }
      }), Po = xe((L, k) => {
        var n = vr(), e = or(), a = wt(), i = Ar(), o = Sa().readPaths, r = Do(), s = ms(), c = Ma().clearOutlineControllers, t = fr(), p = Or(), l = qr().arrayEditor, f = Jn(), v = Aa(), g = Mi(), x = La(), h = x.getPathString;
        k.exports = { draw: m, drawOne: y, eraseActiveShape: M, drawLabel: s };
        function m(B) {
          var z = B._fullLayout;
          z._shapeUpperLayer.selectAll("path").remove(), z._shapeLowerLayer.selectAll("path").remove(), z._shapeUpperLayer.selectAll("text").remove(), z._shapeLowerLayer.selectAll("text").remove();
          for (var q in z._plots) {
            var U = z._plots[q].shapelayer;
            U && (U.selectAll("path").remove(), U.selectAll("text").remove());
          }
          for (var G = 0; G < z.shapes.length; G++) z.shapes[G].visible === !0 && y(B, G);
        }
        function u(B) {
          return !!B._fullLayout._outlining;
        }
        function d(B) {
          return !B._context.edits.shapePosition;
        }
        function y(B, z) {
          B._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + z + '"]').remove();
          var q = x.makeShapesOptionsAndPlotinfo(B, z), U = q.options, G = q.plotinfo;
          if (!U._input || U.visible !== !0) return;
          if (U.layer === "above") te(B._fullLayout._shapeUpperLayer);
          else if (U.xref === "paper" || U.yref === "paper") te(B._fullLayout._shapeLowerLayer);
          else if (U.layer === "between") te(G.shapelayerBetween);
          else if (G._hadPlotinfo) {
            var K = G.mainplotinfo || G;
            te(K.shapelayer);
          } else te(B._fullLayout._shapeLowerLayer);
          function te(V) {
            var Z = h(B, U), Y = { "data-index": z, "fill-rule": U.fillrule, d: Z }, C = U.opacity, j = U.fillcolor, J = U.line.width ? U.line.color : "rgba(0,0,0,0)", ne = U.line.width, ae = U.line.dash;
            !ne && U.editable === !0 && (ne = 5, ae = "solid");
            var se = Z[Z.length - 1] !== "Z", O = d(B) && U.editable && B._fullLayout._activeShapeIndex === z;
            O && (j = se ? "rgba(0,0,0,0)" : B._fullLayout.activeshape.fillcolor, C = B._fullLayout.activeshape.opacity);
            var F = V.append("g").classed("shape-group", !0).attr({ "data-index": z }), S = F.append("path").attr(Y).style("opacity", C).call(t.stroke, J).call(t.fill, j).call(p.dashLine, ae, ne);
            _(F, B, U), s(B, z, U, F);
            var $;
            if ((O || B._context.edits.shapePosition) && ($ = l(B.layout, "shapes", U)), O) {
              S.style({ cursor: "move" });
              var re = { element: S.node(), plotinfo: G, gd: B, editHelpers: $, hasText: U.label.text || U.label.texttemplate, isActiveShape: !0 }, E = o(Z, B);
              r(E, S, re);
            } else B._context.edits.shapePosition ? T(B, S, U, z, V, $) : U.editable === !0 && S.style("pointer-events", se || t.opacity(j) * C <= 0.5 ? "stroke" : "all");
            S.node().addEventListener("click", function() {
              return I(B, S);
            });
          }
        }
        function _(B, z, q) {
          var U = (q.xref + q.yref).replace(/paper/g, "").replace(/[xyz][0-9]* *domain/g, "");
          p.setClipUrl(B, U ? "clip" + z._fullLayout._uid + U : null, z);
        }
        function T(B, z, q, U, G, K) {
          var te = 10, V = 10, Z = q.xsizemode === "pixel", Y = q.ysizemode === "pixel", C = q.type === "line", j = q.type === "path", J = K.modifyItem, ne, ae, se, O, F, S, $, re, E, w, N, W, ee, le, ie, pe = n.select(z.node().parentNode), _e = i.getFromId(B, q.xref), Ae = i.getRefType(q.xref), Ce = i.getFromId(B, q.yref), Ue = i.getRefType(q.yref), Ne = q.x0shift, ke = q.x1shift, A = q.y0shift, X = q.y1shift, H = function(ge, ye) {
            var Me = x.getDataToPixel(B, _e, ye, !1, Ae);
            return Me(ge);
          }, ve = function(ge, ye) {
            var Me = x.getDataToPixel(B, Ce, ye, !0, Ue);
            return Me(ge);
          }, be = x.getPixelToData(B, _e, !1, Ae), Se = x.getPixelToData(B, Ce, !0, Ue), De = We(), He = { element: De.node(), gd: B, prepFn: Ke, doneFn: ct, clickFn: gt }, Ze;
          f.init(He), De.node().onmousemove = it;
          function We() {
            return C ? $e() : z;
          }
          function $e() {
            var ge = 10, ye = Math.max(q.line.width, ge), Me = G.append("g").attr("data-index", U).attr("drag-helper", !0);
            Me.append("path").attr("d", z.attr("d")).style({ cursor: "move", "stroke-width": ye, "stroke-opacity": "0" });
            var Oe = { "fill-opacity": "0" }, je = Math.max(ye / 2, ge);
            return Me.append("circle").attr({ "data-line-point": "start-point", cx: Z ? H(q.xanchor) + q.x0 : H(q.x0, Ne), cy: Y ? ve(q.yanchor) - q.y0 : ve(q.y0, A), r: je }).style(Oe).classed("cursor-grab", !0), Me.append("circle").attr({ "data-line-point": "end-point", cx: Z ? H(q.xanchor) + q.x1 : H(q.x1, ke), cy: Y ? ve(q.yanchor) - q.y1 : ve(q.y1, X), r: je }).style(Oe).classed("cursor-grab", !0), Me;
          }
          function it(ge) {
            if (u(B)) {
              Ze = null;
              return;
            }
            if (C) ge.target.tagName === "path" ? Ze = "move" : Ze = ge.target.attributes["data-line-point"].value === "start-point" ? "resize-over-start-point" : "resize-over-end-point";
            else {
              var ye = He.element.getBoundingClientRect(), Me = ye.right - ye.left, Oe = ye.bottom - ye.top, je = ge.clientX - ye.left, qe = ge.clientY - ye.top, Qe = !j && Me > te && Oe > V && !ge.shiftKey ? f.getCursor(je / Me, 1 - qe / Oe) : "move";
              v(z, Qe), Ze = Qe.split("-")[0];
            }
          }
          function Ke(ge) {
            u(B) || (Z && (F = H(q.xanchor)), Y && (S = ve(q.yanchor)), q.type === "path" ? ie = q.path : (ne = Z ? q.x0 : H(q.x0), ae = Y ? q.y0 : ve(q.y0), se = Z ? q.x1 : H(q.x1), O = Y ? q.y1 : ve(q.y1)), ne < se ? (E = ne, ee = "x0", w = se, le = "x1") : (E = se, ee = "x1", w = ne, le = "x0"), !Y && ae < O || Y && ae > O ? ($ = ae, N = "y0", re = O, W = "y1") : ($ = O, N = "y1", re = ae, W = "y0"), it(ge), Te(G, q), ce(z, q, B), He.moveFn = Ze === "move" ? ht : _t, He.altKey = ge.altKey);
          }
          function ct() {
            u(B) || (v(z), Ie(G), _(z, B, q), e.call("_guiRelayout", B, K.getUpdateObj()));
          }
          function gt() {
            u(B) || Ie(G);
          }
          function ht(ge, ye) {
            if (q.type === "path") {
              var Me = function(qe) {
                return qe;
              }, Oe = Me, je = Me;
              Z ? J("xanchor", q.xanchor = be(F + ge)) : (Oe = function(qe) {
                return be(H(qe) + ge);
              }, _e && _e.type === "date" && (Oe = x.encodeDate(Oe))), Y ? J("yanchor", q.yanchor = Se(S + ye)) : (je = function(qe) {
                return Se(ve(qe) + ye);
              }, Ce && Ce.type === "date" && (je = x.encodeDate(je))), J("path", q.path = R(ie, Oe, je));
            } else Z ? J("xanchor", q.xanchor = be(F + ge)) : (J("x0", q.x0 = be(ne + ge)), J("x1", q.x1 = be(se + ge))), Y ? J("yanchor", q.yanchor = Se(S + ye)) : (J("y0", q.y0 = Se(ae + ye)), J("y1", q.y1 = Se(O + ye)));
            z.attr("d", h(B, q)), Te(G, q), s(B, U, q, pe);
          }
          function _t(ge, ye) {
            if (j) {
              var Me = function(Tt) {
                return Tt;
              }, Oe = Me, je = Me;
              Z ? J("xanchor", q.xanchor = be(F + ge)) : (Oe = function(Tt) {
                return be(H(Tt) + ge);
              }, _e && _e.type === "date" && (Oe = x.encodeDate(Oe))), Y ? J("yanchor", q.yanchor = Se(S + ye)) : (je = function(Tt) {
                return Se(ve(Tt) + ye);
              }, Ce && Ce.type === "date" && (je = x.encodeDate(je))), J("path", q.path = R(ie, Oe, je));
            } else if (C) {
              if (Ze === "resize-over-start-point") {
                var qe = ne + ge, Qe = Y ? ae - ye : ae + ye;
                J("x0", q.x0 = Z ? qe : be(qe)), J("y0", q.y0 = Y ? Qe : Se(Qe));
              } else if (Ze === "resize-over-end-point") {
                var Xe = se + ge, Je = Y ? O - ye : O + ye;
                J("x1", q.x1 = Z ? Xe : be(Xe)), J("y1", q.y1 = Y ? Je : Se(Je));
              }
            } else {
              var ot = function(Tt) {
                return Ze.indexOf(Tt) !== -1;
              }, lt = ot("n"), st = ot("s"), xt = ot("w"), Et = ot("e"), Bt = lt ? $ + ye : $, qt = st ? re + ye : re, jt = xt ? E + ge : E, It = Et ? w + ge : w;
              Y && (lt && (Bt = $ - ye), st && (qt = re - ye)), (!Y && qt - Bt > V || Y && Bt - qt > V) && (J(N, q[N] = Y ? Bt : Se(Bt)), J(W, q[W] = Y ? qt : Se(qt))), It - jt > te && (J(ee, q[ee] = Z ? jt : be(jt)), J(le, q[le] = Z ? It : be(It)));
            }
            z.attr("d", h(B, q)), Te(G, q), s(B, U, q, pe);
          }
          function Te(ge, ye) {
            (Z || Y) && Me();
            function Me() {
              var Oe = ye.type !== "path", je = ge.selectAll(".visual-cue").data([0]), qe = 1;
              je.enter().append("path").attr({ fill: "#fff", "fill-rule": "evenodd", stroke: "#000", "stroke-width": qe }).classed("visual-cue", !0);
              var Qe = H(Z ? ye.xanchor : a.midRange(Oe ? [ye.x0, ye.x1] : x.extractPathCoords(ye.path, g.paramIsX))), Xe = ve(Y ? ye.yanchor : a.midRange(Oe ? [ye.y0, ye.y1] : x.extractPathCoords(ye.path, g.paramIsY)));
              if (Qe = x.roundPositionForSharpStrokeRendering(Qe, qe), Xe = x.roundPositionForSharpStrokeRendering(Xe, qe), Z && Y) {
                var Je = "M" + (Qe - 1 - qe) + "," + (Xe - 1 - qe) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                je.attr("d", Je);
              } else if (Z) {
                var ot = "M" + (Qe - 1 - qe) + "," + (Xe - 9 - qe) + "v18 h2 v-18 Z";
                je.attr("d", ot);
              } else {
                var lt = "M" + (Qe - 9 - qe) + "," + (Xe - 1 - qe) + "h18 v2 h-18 Z";
                je.attr("d", lt);
              }
            }
          }
          function Ie(ge) {
            ge.selectAll(".visual-cue").remove();
          }
          function ce(ge, ye, Me) {
            var Oe = ye.xref, je = ye.yref, qe = i.getFromId(Me, Oe), Qe = i.getFromId(Me, je), Xe = "";
            Oe !== "paper" && !qe.autorange && (Xe += Oe), je !== "paper" && !Qe.autorange && (Xe += je), p.setClipUrl(ge, Xe ? "clip" + Me._fullLayout._uid + Xe : null, Me);
          }
        }
        function R(B, z, q) {
          return B.replace(g.segmentRE, function(U) {
            var G = 0, K = U.charAt(0), te = g.paramIsX[K], V = g.paramIsY[K], Z = g.numParams[K], Y = U.substr(1).replace(g.paramRE, function(C) {
              return G >= Z || (te[G] ? C = z(C) : V[G] && (C = q(C)), G++), C;
            });
            return K + Y;
          });
        }
        function I(B, z) {
          if (d(B)) {
            var q = z.node(), U = +q.getAttribute("data-index");
            if (U >= 0) {
              if (U === B._fullLayout._activeShapeIndex) {
                P(B);
                return;
              }
              B._fullLayout._activeShapeIndex = U, B._fullLayout._deactivateShape = P, m(B);
            }
          }
        }
        function P(B) {
          if (d(B)) {
            var z = B._fullLayout._activeShapeIndex;
            z >= 0 && (c(B), delete B._fullLayout._activeShapeIndex, m(B));
          }
        }
        function M(B) {
          if (d(B)) {
            c(B);
            var z = B._fullLayout._activeShapeIndex, q = (B.layout || {}).shapes || [];
            if (z < q.length) {
              for (var U = [], G = 0; G < q.length; G++) G !== z && U.push(q[G]);
              return delete B._fullLayout._activeShapeIndex, e.call("_guiRelayout", B, { shapes: U });
            }
          }
        }
      }), xs = xe((L, k) => {
        var n = or(), e = on(), a = sn(), i = Lo(), o = Po().eraseActiveShape, r = wt(), s = r._, c = k.exports = {};
        c.toImage = { name: "toImage", title: function(T) {
          var R = T._context.toImageButtonOptions || {}, I = R.format || "png";
          return I === "png" ? s(T, "Download plot as a PNG") : s(T, "Download plot");
        }, icon: i.camera, click: function(T) {
          var R = T._context.toImageButtonOptions, I = { format: R.format || "png" };
          r.notifier(s(T, "Taking snapshot - this may take a few seconds"), "long"), ["filename", "width", "height", "scale"].forEach(function(P) {
            P in R && (I[P] = R[P]);
          }), n.call("downloadImage", T, I).then(function(P) {
            r.notifier(s(T, "Snapshot succeeded") + " - " + P, "long");
          }).catch(function() {
            r.notifier(s(T, "Sorry, there was a problem downloading your snapshot!"), "long");
          });
        } }, c.sendDataToCloud = { name: "sendDataToCloud", title: function(T) {
          return s(T, "Edit in Chart Studio");
        }, icon: i.disk, click: function(T) {
          e.sendDataToCloud(T);
        } }, c.editInChartStudio = { name: "editInChartStudio", title: function(T) {
          return s(T, "Edit in Chart Studio");
        }, icon: i.pencil, click: function(T) {
          e.sendDataToCloud(T);
        } }, c.zoom2d = { name: "zoom2d", _cat: "zoom", title: function(T) {
          return s(T, "Zoom");
        }, attr: "dragmode", val: "zoom", icon: i.zoombox, click: t }, c.pan2d = { name: "pan2d", _cat: "pan", title: function(T) {
          return s(T, "Pan");
        }, attr: "dragmode", val: "pan", icon: i.pan, click: t }, c.select2d = { name: "select2d", _cat: "select", title: function(T) {
          return s(T, "Box Select");
        }, attr: "dragmode", val: "select", icon: i.selectbox, click: t }, c.lasso2d = { name: "lasso2d", _cat: "lasso", title: function(T) {
          return s(T, "Lasso Select");
        }, attr: "dragmode", val: "lasso", icon: i.lasso, click: t }, c.drawclosedpath = { name: "drawclosedpath", title: function(T) {
          return s(T, "Draw closed freeform");
        }, attr: "dragmode", val: "drawclosedpath", icon: i.drawclosedpath, click: t }, c.drawopenpath = { name: "drawopenpath", title: function(T) {
          return s(T, "Draw open freeform");
        }, attr: "dragmode", val: "drawopenpath", icon: i.drawopenpath, click: t }, c.drawline = { name: "drawline", title: function(T) {
          return s(T, "Draw line");
        }, attr: "dragmode", val: "drawline", icon: i.drawline, click: t }, c.drawrect = { name: "drawrect", title: function(T) {
          return s(T, "Draw rectangle");
        }, attr: "dragmode", val: "drawrect", icon: i.drawrect, click: t }, c.drawcircle = { name: "drawcircle", title: function(T) {
          return s(T, "Draw circle");
        }, attr: "dragmode", val: "drawcircle", icon: i.drawcircle, click: t }, c.eraseshape = { name: "eraseshape", title: function(T) {
          return s(T, "Erase active shape");
        }, icon: i.eraseshape, click: o }, c.zoomIn2d = { name: "zoomIn2d", _cat: "zoomin", title: function(T) {
          return s(T, "Zoom in");
        }, attr: "zoom", val: "in", icon: i.zoom_plus, click: t }, c.zoomOut2d = { name: "zoomOut2d", _cat: "zoomout", title: function(T) {
          return s(T, "Zoom out");
        }, attr: "zoom", val: "out", icon: i.zoom_minus, click: t }, c.autoScale2d = { name: "autoScale2d", _cat: "autoscale", title: function(T) {
          return s(T, "Autoscale");
        }, attr: "zoom", val: "auto", icon: i.autoscale, click: t }, c.resetScale2d = { name: "resetScale2d", _cat: "resetscale", title: function(T) {
          return s(T, "Reset axes");
        }, attr: "zoom", val: "reset", icon: i.home, click: t }, c.hoverClosestCartesian = { name: "hoverClosestCartesian", _cat: "hoverclosest", title: function(T) {
          return s(T, "Show closest data on hover");
        }, attr: "hovermode", val: "closest", icon: i.tooltip_basic, gravity: "ne", click: t }, c.hoverCompareCartesian = { name: "hoverCompareCartesian", _cat: "hoverCompare", title: function(T) {
          return s(T, "Compare data on hover");
        }, attr: "hovermode", val: function(T) {
          return T._fullLayout._isHoriz ? "y" : "x";
        }, icon: i.tooltip_compare, gravity: "ne", click: t };
        function t(T, R) {
          var I = R.currentTarget, P = I.getAttribute("data-attr"), M = I.getAttribute("data-val") || !0, B = T._fullLayout, z = {}, q = a.list(T, null, !0), U = B._cartesianSpikesEnabled, G, K;
          if (P === "zoom") {
            var te = M === "in" ? 0.5 : 2, V = (1 + te) / 2, Z = (1 - te) / 2, Y, C;
            for (K = 0; K < q.length; K++) if (G = q[K], C = G.modebardisable === "none" || G.modebardisable.indexOf(M === "auto" || M === "reset" ? "autoscale" : "zoominout") === -1, C && !G.fixedrange) if (Y = G._name, M === "auto") z[Y + ".autorange"] = !0;
            else if (M === "reset") G._rangeInitial0 === void 0 && G._rangeInitial1 === void 0 ? z[Y + ".autorange"] = !0 : G._rangeInitial0 === void 0 ? (z[Y + ".autorange"] = G._autorangeInitial, z[Y + ".range"] = [null, G._rangeInitial1]) : G._rangeInitial1 === void 0 ? (z[Y + ".range"] = [G._rangeInitial0, null], z[Y + ".autorange"] = G._autorangeInitial) : z[Y + ".range"] = [G._rangeInitial0, G._rangeInitial1], G._showSpikeInitial !== void 0 && (z[Y + ".showspikes"] = G._showSpikeInitial, U === "on" && !G._showSpikeInitial && (U = "off"));
            else {
              var j = [G.r2l(G.range[0]), G.r2l(G.range[1])], J = [V * j[0] + Z * j[1], V * j[1] + Z * j[0]];
              z[Y + ".range[0]"] = G.l2r(J[0]), z[Y + ".range[1]"] = G.l2r(J[1]);
            }
          } else P === "hovermode" && (M === "x" || M === "y") && (M = B._isHoriz ? "y" : "x", I.setAttribute("data-val", M)), z[P] = M;
          B._cartesianSpikesEnabled = U, n.call("_guiRelayout", T, z);
        }
        c.zoom3d = { name: "zoom3d", _cat: "zoom", title: function(T) {
          return s(T, "Zoom");
        }, attr: "scene.dragmode", val: "zoom", icon: i.zoombox, click: p }, c.pan3d = { name: "pan3d", _cat: "pan", title: function(T) {
          return s(T, "Pan");
        }, attr: "scene.dragmode", val: "pan", icon: i.pan, click: p }, c.orbitRotation = { name: "orbitRotation", title: function(T) {
          return s(T, "Orbital rotation");
        }, attr: "scene.dragmode", val: "orbit", icon: i["3d_rotate"], click: p }, c.tableRotation = { name: "tableRotation", title: function(T) {
          return s(T, "Turntable rotation");
        }, attr: "scene.dragmode", val: "turntable", icon: i["z-axis"], click: p };
        function p(T, R) {
          for (var I = R.currentTarget, P = I.getAttribute("data-attr"), M = I.getAttribute("data-val") || !0, B = T._fullLayout._subplots.gl3d || [], z = {}, q = P.split("."), U = 0; U < B.length; U++) z[B[U] + "." + q[1]] = M;
          var G = M === "pan" ? M : "zoom";
          z.dragmode = G, n.call("_guiRelayout", T, z);
        }
        c.resetCameraDefault3d = { name: "resetCameraDefault3d", _cat: "resetCameraDefault", title: function(T) {
          return s(T, "Reset camera to default");
        }, attr: "resetDefault", icon: i.home, click: l }, c.resetCameraLastSave3d = { name: "resetCameraLastSave3d", _cat: "resetCameraLastSave", title: function(T) {
          return s(T, "Reset camera to last save");
        }, attr: "resetLastSave", icon: i.movie, click: l };
        function l(T, R) {
          for (var I = R.currentTarget, P = I.getAttribute("data-attr"), M = P === "resetLastSave", B = P === "resetDefault", z = T._fullLayout, q = z._subplots.gl3d || [], U = {}, G = 0; G < q.length; G++) {
            var K = q[G], te = K + ".camera", V = K + ".aspectratio", Z = K + ".aspectmode", Y = z[K]._scene, C;
            M ? (U[te + ".up"] = Y.viewInitial.up, U[te + ".eye"] = Y.viewInitial.eye, U[te + ".center"] = Y.viewInitial.center, C = !0) : B && (U[te + ".up"] = null, U[te + ".eye"] = null, U[te + ".center"] = null, C = !0), C && (U[V + ".x"] = Y.viewInitial.aspectratio.x, U[V + ".y"] = Y.viewInitial.aspectratio.y, U[V + ".z"] = Y.viewInitial.aspectratio.z, U[Z] = Y.viewInitial.aspectmode);
          }
          n.call("_guiRelayout", T, U);
        }
        c.hoverClosest3d = { name: "hoverClosest3d", _cat: "hoverclosest", title: function(T) {
          return s(T, "Toggle show closest data on hover");
        }, attr: "hovermode", val: null, toggle: !0, icon: i.tooltip_basic, gravity: "ne", click: v };
        function f(T, R) {
          var I = R.currentTarget, P = I._previousVal, M = T._fullLayout, B = M._subplots.gl3d || [], z = ["xaxis", "yaxis", "zaxis"], q = {}, U = {};
          if (P) U = P, I._previousVal = null;
          else {
            for (var G = 0; G < B.length; G++) {
              var K = B[G], te = M[K], V = K + ".hovermode";
              q[V] = te.hovermode, U[V] = !1;
              for (var Z = 0; Z < 3; Z++) {
                var Y = z[Z], C = K + "." + Y + ".showspikes";
                U[C] = !1, q[C] = te[Y].showspikes;
              }
            }
            I._previousVal = q;
          }
          return U;
        }
        function v(T, R) {
          var I = f(T, R);
          n.call("_guiRelayout", T, I);
        }
        c.zoomInGeo = { name: "zoomInGeo", _cat: "zoomin", title: function(T) {
          return s(T, "Zoom in");
        }, attr: "zoom", val: "in", icon: i.zoom_plus, click: g }, c.zoomOutGeo = { name: "zoomOutGeo", _cat: "zoomout", title: function(T) {
          return s(T, "Zoom out");
        }, attr: "zoom", val: "out", icon: i.zoom_minus, click: g }, c.resetGeo = { name: "resetGeo", _cat: "reset", title: function(T) {
          return s(T, "Reset");
        }, attr: "reset", val: null, icon: i.autoscale, click: g }, c.hoverClosestGeo = { name: "hoverClosestGeo", _cat: "hoverclosest", title: function(T) {
          return s(T, "Toggle show closest data on hover");
        }, attr: "hovermode", val: null, toggle: !0, icon: i.tooltip_basic, gravity: "ne", click: h };
        function g(T, R) {
          for (var I = R.currentTarget, P = I.getAttribute("data-attr"), M = I.getAttribute("data-val") || !0, B = T._fullLayout, z = B._subplots.geo || [], q = 0; q < z.length; q++) {
            var U = z[q], G = B[U];
            if (P === "zoom") {
              var K = G.projection.scale, te = M === "in" ? 2 * K : 0.5 * K;
              n.call("_guiRelayout", T, U + ".projection.scale", te);
            }
          }
          P === "reset" && _(T, "geo");
        }
        c.hoverClosestPie = { name: "hoverClosestPie", _cat: "hoverclosest", title: function(T) {
          return s(T, "Toggle show closest data on hover");
        }, attr: "hovermode", val: "closest", icon: i.tooltip_basic, gravity: "ne", click: h };
        function x(T) {
          var R = T._fullLayout;
          return R.hovermode ? !1 : R._has("cartesian") ? R._isHoriz ? "y" : "x" : "closest";
        }
        function h(T) {
          var R = x(T);
          n.call("_guiRelayout", T, "hovermode", R);
        }
        c.resetViewSankey = { name: "resetSankeyGroup", title: function(T) {
          return s(T, "Reset view");
        }, icon: i.home, click: function(T) {
          for (var R = { "node.groups": [], "node.x": [], "node.y": [] }, I = 0; I < T._fullData.length; I++) {
            var P = T._fullData[I]._viewInitial;
            R["node.groups"].push(P.node.groups.slice()), R["node.x"].push(P.node.x.slice()), R["node.y"].push(P.node.y.slice());
          }
          n.call("restyle", T, R);
        } }, c.toggleHover = { name: "toggleHover", title: function(T) {
          return s(T, "Toggle show closest data on hover");
        }, attr: "hovermode", val: null, toggle: !0, icon: i.tooltip_basic, gravity: "ne", click: function(T, R) {
          var I = f(T, R);
          I.hovermode = x(T), n.call("_guiRelayout", T, I);
        } }, c.resetViews = { name: "resetViews", title: function(T) {
          return s(T, "Reset views");
        }, icon: i.home, click: function(T, R) {
          var I = R.currentTarget;
          I.setAttribute("data-attr", "zoom"), I.setAttribute("data-val", "reset"), t(T, R), I.setAttribute("data-attr", "resetLastSave"), l(T, R), _(T, "geo"), _(T, "mapbox"), _(T, "map");
        } }, c.toggleSpikelines = { name: "toggleSpikelines", title: function(T) {
          return s(T, "Toggle Spike Lines");
        }, icon: i.spikeline, attr: "_cartesianSpikesEnabled", val: "on", click: function(T) {
          var R = T._fullLayout, I = R._cartesianSpikesEnabled;
          R._cartesianSpikesEnabled = I === "on" ? "off" : "on", n.call("_guiRelayout", T, m(T));
        } };
        function m(T) {
          for (var R = T._fullLayout, I = R._cartesianSpikesEnabled === "on", P = a.list(T, null, !0), M = {}, B = 0; B < P.length; B++) {
            var z = P[B];
            M[z._name + ".showspikes"] = I ? !0 : z._showSpikeInitial;
          }
          return M;
        }
        c.resetViewMapbox = { name: "resetViewMapbox", _cat: "resetView", title: function(T) {
          return s(T, "Reset view");
        }, attr: "reset", icon: i.home, click: function(T) {
          _(T, "mapbox");
        } }, c.resetViewMap = { name: "resetViewMap", _cat: "resetView", title: function(T) {
          return s(T, "Reset view");
        }, attr: "reset", icon: i.home, click: function(T) {
          _(T, "map");
        } }, c.zoomInMapbox = { name: "zoomInMapbox", _cat: "zoomin", title: function(T) {
          return s(T, "Zoom in");
        }, attr: "zoom", val: "in", icon: i.zoom_plus, click: u }, c.zoomInMap = { name: "zoomInMap", _cat: "zoomin", title: function(T) {
          return s(T, "Zoom in");
        }, attr: "zoom", val: "in", icon: i.zoom_plus, click: d }, c.zoomOutMapbox = { name: "zoomOutMapbox", _cat: "zoomout", title: function(T) {
          return s(T, "Zoom out");
        }, attr: "zoom", val: "out", icon: i.zoom_minus, click: u }, c.zoomOutMap = { name: "zoomOutMap", _cat: "zoomout", title: function(T) {
          return s(T, "Zoom out");
        }, attr: "zoom", val: "out", icon: i.zoom_minus, click: d };
        function u(T, R) {
          y(T, R, "mapbox");
        }
        function d(T, R) {
          y(T, R, "map");
        }
        function y(T, R, I) {
          for (var P = R.currentTarget, M = P.getAttribute("data-val"), B = T._fullLayout, z = B._subplots[I] || [], q = 1.05, U = {}, G = 0; G < z.length; G++) {
            var K = z[G], te = B[K].zoom, V = M === "in" ? q * te : te / q;
            U[K + ".zoom"] = V;
          }
          n.call("_guiRelayout", T, U);
        }
        function _(T, R) {
          for (var I = T._fullLayout, P = I._subplots[R] || [], M = {}, B = 0; B < P.length; B++) for (var z = P[B], q = I[z]._subplot, U = q.viewInitial, G = Object.keys(U), K = 0; K < G.length; K++) {
            var te = G[K];
            M[z + "." + te] = U[te];
          }
          n.call("_guiRelayout", T, M);
        }
      }), bs = xe((L, k) => {
        var n = xs(), e = Object.keys(n), a = ["drawline", "drawopenpath", "drawclosedpath", "drawcircle", "drawrect", "eraseshape"], i = ["v1hovermode", "hoverclosest", "hovercompare", "togglehover", "togglespikelines"].concat(a), o = [], r = function(s) {
          if (i.indexOf(s._cat || s.name) === -1) {
            var c = s.name, t = (s._cat || s.name).toLowerCase();
            o.indexOf(c) === -1 && o.push(c), o.indexOf(t) === -1 && o.push(t);
          }
        };
        e.forEach(function(s) {
          r(n[s]);
        }), o.sort(), k.exports = { DRAW_MODES: a, backButtons: i, foreButtons: o };
      }), _s = xe((L, k) => {
        bs(), k.exports = { editType: "modebar", orientation: { valType: "enumerated", values: ["v", "h"], dflt: "h", editType: "modebar" }, bgcolor: { valType: "color", editType: "modebar" }, color: { valType: "color", editType: "modebar" }, activecolor: { valType: "color", editType: "modebar" }, uirevision: { valType: "any", editType: "none" }, add: { valType: "string", arrayOk: !0, dflt: "", editType: "modebar" }, remove: { valType: "string", arrayOk: !0, dflt: "", editType: "modebar" } };
      }), Nd = xe((L, k) => {
        var n = wt(), e = fr(), a = qr(), i = _s();
        k.exports = function(o, r) {
          var s = o.modebar || {}, c = a.newContainer(r, "modebar");
          function t(l, f) {
            return n.coerce(s, c, i, l, f);
          }
          t("orientation"), t("bgcolor", e.addOpacity(r.paper_bgcolor, 0.5));
          var p = e.contrast(e.rgb(r.modebar.bgcolor));
          t("color", e.addOpacity(p, 0.3)), t("activecolor", e.addOpacity(p, 0.7)), t("uirevision", r.uirevision), t("add"), t("remove");
        };
      }), Fd = xe((L, k) => {
        var n = vr(), e = xr(), a = wt(), i = Lo(), o = ao().version, r = new DOMParser();
        function s(l) {
          this.container = l.container, this.element = document.createElement("div"), this.update(l.graphInfo, l.buttons), this.container.appendChild(this.element);
        }
        var c = s.prototype;
        c.update = function(l, f) {
          this.graphInfo = l;
          var v = this.graphInfo._context, g = this.graphInfo._fullLayout, x = "modebar-" + g._uid;
          this.element.setAttribute("id", x), this.element.setAttribute("role", "toolbar"), this._uid = x, this.element.className = "modebar modebar--custom", v.displayModeBar === "hover" && (this.element.className += " modebar--hover ease-bg"), g.modebar.orientation === "v" && (this.element.className += " vertical", f = f.reverse());
          var h = g.modebar, m = "#" + x + " .modebar-group";
          document.querySelectorAll(m).forEach(function(T) {
            T.style.backgroundColor = h.bgcolor;
          });
          var u = !this.hasButtons(f), d = this.hasLogo !== v.displaylogo, y = this.locale !== v.locale;
          if (this.locale = v.locale, (u || d || y) && (this.removeAllButtons(), this.updateButtons(f), v.watermark || v.displaylogo)) {
            var _ = this.getLogo();
            v.watermark && (_.className = _.className + " watermark"), g.modebar.orientation === "v" ? this.element.insertBefore(_, this.element.childNodes[0]) : this.element.appendChild(_), this.hasLogo = !0;
          }
          this.updateActiveButton(), a.setStyleOnHover("#" + x + " .modebar-btn", ".active", ".icon path", "fill: " + h.activecolor, "fill: " + h.color, this.element);
        }, c.updateButtons = function(l) {
          var f = this;
          this.buttons = l, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function(v) {
            var g = f.createGroup();
            v.forEach(function(x) {
              var h = x.name;
              if (!h) throw new Error("must provide button 'name' in button config");
              if (f.buttonsNames.indexOf(h) !== -1) throw new Error("button name '" + h + "' is taken");
              f.buttonsNames.push(h);
              var m = f.createButton(x);
              f.buttonElements.push(m), g.appendChild(m);
            }), f.element.appendChild(g);
          });
        }, c.createGroup = function() {
          var l = document.createElement("div");
          l.className = "modebar-group";
          var f = this.graphInfo._fullLayout.modebar;
          return l.style.backgroundColor = f.bgcolor, l;
        }, c.createButton = function(l) {
          var f = this, v = document.createElement("button");
          v.setAttribute("type", "button"), v.setAttribute("rel", "tooltip"), v.className = "modebar-btn";
          var g = l.title;
          g === void 0 ? g = l.name : typeof g == "function" && (g = g(this.graphInfo)), (g || g === 0) && (v.setAttribute("data-title", g), v.setAttribute("aria-label", g)), l.attr !== void 0 && v.setAttribute("data-attr", l.attr);
          var x = l.val;
          x !== void 0 && (typeof x == "function" && (x = x(this.graphInfo)), v.setAttribute("data-val", x));
          var h = l.click;
          if (typeof h != "function") throw new Error("must provide button 'click' function in button config");
          v.addEventListener("click", function(u) {
            l.click(f.graphInfo, u), f.updateActiveButton(u.currentTarget);
          }), v.setAttribute("data-toggle", l.toggle || !1), l.toggle && n.select(v).classed("active", !0);
          var m = l.icon;
          return typeof m == "function" ? v.appendChild(m()) : v.appendChild(this.createIcon(m || i.question)), v.setAttribute("data-gravity", l.gravity || "n"), v;
        }, c.createIcon = function(l) {
          var f = e(l.height) ? Number(l.height) : l.ascent - l.descent, v = "http://www.w3.org/2000/svg", g;
          if (l.path) {
            g = document.createElementNS(v, "svg"), g.setAttribute("viewBox", [0, 0, l.width, f].join(" ")), g.setAttribute("class", "icon");
            var x = document.createElementNS(v, "path");
            x.setAttribute("d", l.path), l.transform ? x.setAttribute("transform", l.transform) : l.ascent !== void 0 && x.setAttribute("transform", "matrix(1 0 0 -1 0 " + l.ascent + ")"), g.appendChild(x);
          }
          if (l.svg) {
            var h = r.parseFromString(l.svg, "application/xml");
            g = h.childNodes[0];
          }
          return g.setAttribute("height", "1em"), g.setAttribute("width", "1em"), g;
        }, c.updateActiveButton = function(l) {
          var f = this.graphInfo._fullLayout, v = l !== void 0 ? l.getAttribute("data-attr") : null;
          this.buttonElements.forEach(function(g) {
            var x = g.getAttribute("data-val") || !0, h = g.getAttribute("data-attr"), m = g.getAttribute("data-toggle") === "true", u = n.select(g), d = function(T, R) {
              var I = f.modebar, P = T.querySelector(".icon path");
              P && (R || T.matches(":hover") ? P.style.fill = I.activecolor : P.style.fill = I.color);
            };
            if (m) {
              if (h === v) {
                var y = !u.classed("active");
                u.classed("active", y), d(g, y);
              }
            } else {
              var _ = h === null ? h : a.nestedProperty(f, h).get();
              u.classed("active", _ === x), d(g, _ === x);
            }
          });
        }, c.hasButtons = function(l) {
          var f = this.buttons;
          if (!f || l.length !== f.length) return !1;
          for (var v = 0; v < l.length; ++v) {
            if (l[v].length !== f[v].length) return !1;
            for (var g = 0; g < l[v].length; g++) if (l[v][g].name !== f[v][g].name) return !1;
          }
          return !0;
        };
        function t(l) {
          return l + " (v" + o + ")";
        }
        c.getLogo = function() {
          var l = this.createGroup(), f = document.createElement("a");
          return f.href = "https://plotly.com/", f.target = "_blank", f.setAttribute("data-title", t(a._(this.graphInfo, "Produced with Plotly.js"))), f.className = "modebar-btn plotlyjsicon modebar-btn--logo", f.appendChild(this.createIcon(i.newplotlylogo)), l.appendChild(f), l;
        }, c.removeAllButtons = function() {
          for (; this.element.firstChild; ) this.element.removeChild(this.element.firstChild);
          this.hasLogo = !1;
        }, c.destroy = function() {
          a.removeElement(this.container.querySelector(".modebar"));
        };
        function p(l, f) {
          var v = l._fullLayout, g = new s({ graphInfo: l, container: v._modebardiv.node(), buttons: f });
          return v._privateplot && n.select(g.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), g;
        }
        k.exports = p;
      }), Bd = xe((L, k) => {
        var n = sn(), e = Fn(), a = or(), i = da().isUnifiedHover, o = Fd(), r = xs(), s = bs().DRAW_MODES, c = wt().extendDeep;
        k.exports = function(x) {
          var h = x._fullLayout, m = x._context, u = h._modeBar;
          if (!m.displayModeBar && !m.watermark) {
            u && (u.destroy(), delete h._modeBar);
            return;
          }
          if (!Array.isArray(m.modeBarButtonsToRemove)) throw new Error(["*modeBarButtonsToRemove* configuration options", "must be an array."].join(" "));
          if (!Array.isArray(m.modeBarButtonsToAdd)) throw new Error(["*modeBarButtonsToAdd* configuration options", "must be an array."].join(" "));
          var d = m.modeBarButtons, y;
          Array.isArray(d) && d.length ? y = g(d) : !m.displayModeBar && m.watermark ? y = [] : y = t(x), u ? u.update(x, y) : h._modeBar = o(x, y);
        };
        function t(x) {
          var h = x._fullLayout, m = x._fullData, u = x._context;
          function d(w, N) {
            if (typeof N == "string") {
              if (N.toLowerCase() === w.toLowerCase()) return !0;
            } else {
              var W = N.name, ee = N._cat || N.name;
              if (W === w || ee === w.toLowerCase()) return !0;
            }
            return !1;
          }
          var y = h.modebar.add;
          typeof y == "string" && (y = [y]);
          var _ = h.modebar.remove;
          typeof _ == "string" && (_ = [_]);
          var T = u.modeBarButtonsToAdd.concat(y.filter(function(w) {
            for (var N = 0; N < u.modeBarButtonsToRemove.length; N++) if (d(w, u.modeBarButtonsToRemove[N])) return !1;
            return !0;
          })), R = u.modeBarButtonsToRemove.concat(_.filter(function(w) {
            for (var N = 0; N < u.modeBarButtonsToAdd.length; N++) if (d(w, u.modeBarButtonsToAdd[N])) return !1;
            return !0;
          })), I = h._has("cartesian"), P = h._has("gl3d"), M = h._has("geo"), B = h._has("pie"), z = h._has("funnelarea"), q = h._has("ternary"), U = h._has("mapbox"), G = h._has("map"), K = h._has("polar"), te = h._has("smith"), V = h._has("sankey"), Z = p(h), Y = i(h.hovermode), C = [];
          function j(w) {
            if (w.length) {
              for (var N = [], W = 0; W < w.length; W++) {
                for (var ee = w[W], le = r[ee], ie = le.name.toLowerCase(), pe = (le._cat || le.name).toLowerCase(), _e = !1, Ae = 0; Ae < R.length; Ae++) {
                  var Ce = R[Ae].toLowerCase();
                  if (Ce === ie || Ce === pe) {
                    _e = !0;
                    break;
                  }
                }
                _e || N.push(r[ee]);
              }
              C.push(N);
            }
          }
          var J = ["toImage"];
          u.showEditInChartStudio ? J.push("editInChartStudio") : u.showSendToCloud && J.push("sendDataToCloud"), j(J);
          var ne = [], ae = [], se = [], O = [];
          (I || B || z || q) + M + P + U + G + K + te > 1 ? (ae = ["toggleHover"], se = ["resetViews"]) : M ? (ne = ["zoomInGeo", "zoomOutGeo"], ae = ["hoverClosestGeo"], se = ["resetGeo"]) : P ? (ae = ["hoverClosest3d"], se = ["resetCameraDefault3d", "resetCameraLastSave3d"]) : U ? (ne = ["zoomInMapbox", "zoomOutMapbox"], ae = ["toggleHover"], se = ["resetViewMapbox"]) : G ? (ne = ["zoomInMap", "zoomOutMap"], ae = ["toggleHover"], se = ["resetViewMap"]) : B ? ae = ["hoverClosestPie"] : V ? (ae = ["hoverClosestCartesian", "hoverCompareCartesian"], se = ["resetViewSankey"]) : ae = ["toggleHover"], I && ae.push("toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"), (f(m) || Y) && (ae = []), I && !Z && (ne = ["zoomIn2d", "zoomOut2d", "autoScale2d"], se[0] !== "resetViews" && (se = ["resetScale2d"])), P ? O = ["zoom3d", "pan3d", "orbitRotation", "tableRotation"] : I && !Z || q ? O = ["zoom2d", "pan2d"] : U || G || M ? O = ["pan2d"] : K && (O = ["zoom2d"]), l(m) && O.push("select2d", "lasso2d");
          var F = [], S = function(w) {
            F.indexOf(w) === -1 && ae.indexOf(w) !== -1 && F.push(w);
          };
          if (Array.isArray(T)) {
            for (var $ = [], re = 0; re < T.length; re++) {
              var E = T[re];
              typeof E == "string" ? (E = E.toLowerCase(), s.indexOf(E) !== -1 ? (h._has("mapbox") || h._has("map") || h._has("cartesian")) && O.push(E) : E === "togglespikelines" ? S("toggleSpikelines") : E === "togglehover" ? S("toggleHover") : E === "hovercompare" ? S("hoverCompareCartesian") : E === "hoverclosest" ? (S("hoverClosestCartesian"), S("hoverClosestGeo"), S("hoverClosest3d"), S("hoverClosestPie")) : E === "v1hovermode" && (S("hoverClosestCartesian"), S("hoverCompareCartesian"), S("hoverClosestGeo"), S("hoverClosest3d"), S("hoverClosestPie"))) : $.push(E);
            }
            T = $;
          }
          return j(O), j(ne.concat(se)), j(F), v(C, T);
        }
        function p(x) {
          for (var h = n.list({ _fullLayout: x }, null, !0), m = 0; m < h.length; m++) {
            var u = h[m].modebardisable;
            if (!h[m].fixedrange && u !== "autoscale+zoominout" && u !== "zoominout+autoscale") return !1;
          }
          return !0;
        }
        function l(x) {
          for (var h = !1, m = 0; m < x.length && !h; m++) {
            var u = x[m];
            !u._module || !u._module.selectPoints || (a.traceIs(u, "scatter-like") ? (e.hasMarkers(u) || e.hasText(u)) && (h = !0) : a.traceIs(u, "box-violin") ? (u.boxpoints === "all" || u.points === "all") && (h = !0) : h = !0);
          }
          return h;
        }
        function f(x) {
          for (var h = 0; h < x.length; h++) if (!a.traceIs(x[h], "noHover")) return !1;
          return !0;
        }
        function v(x, h) {
          if (h.length) if (Array.isArray(h[0])) for (var m = 0; m < h.length; m++) x.push(h[m]);
          else x.push(h);
          return x;
        }
        function g(x) {
          for (var h = c([], x), m = 0; m < h.length; m++) for (var u = h[m], d = 0; d < u.length; d++) {
            var y = u[d];
            if (typeof y == "string") if (r[y] !== void 0) h[m][d] = r[y];
            else throw new Error(["*modeBarButtons* configuration options", "invalid button name"].join(" "));
          }
          return h;
        }
      }), ws = xe((L, k) => {
        k.exports = { moduleType: "component", name: "modebar", layoutAttributes: _s(), supplyLayoutDefaults: Nd(), manage: Bd() };
      }), Ts = xe((L, k) => {
        var n = kn().FROM_BL;
        k.exports = function(e, a, i) {
          i === void 0 && (i = n[e.constraintoward || "center"]);
          var o = [e.r2l(e.range[0]), e.r2l(e.range[1])], r = o[0] + (o[1] - o[0]) * i;
          e.range = e._input.range = [e.l2r(r + (o[0] - r) * a), e.l2r(r + (o[1] - r) * a)], e.setScale();
        };
      }), Fa = xe((L) => {
        var k = wt(), n = ki(), e = sn().id2name, a = Xn(), i = Ts(), o = ri(), r = Yr().ALMOST_EQUAL, s = kn().FROM_BL;
        L.handleDefaults = function(x, h, m) {
          var u = m.axIds, d = m.axHasImage, y = h._axisConstraintGroups = [], _ = h._axisMatchGroups = [], T, R, I, P, M, B, z, q;
          for (T = 0; T < u.length; T++) P = e(u[T]), M = x[P], B = h[P], c(M, B, { axIds: u, layoutOut: h, hasImage: d[P] });
          function U(J, ne) {
            for (T = 0; T < J.length; T++) {
              R = J[T];
              for (I in R) h[e(I)][ne] = R;
            }
          }
          for (U(_, "_matchGroup"), T = 0; T < y.length; T++) {
            R = y[T];
            for (I in R) if (B = h[e(I)], B.fixedrange) {
              for (var G in R) {
                var K = e(G);
                (x[K] || {}).fixedrange === !1 && k.warn("fixedrange was specified as false for axis " + K + " but was overridden because another axis in its constraint group has fixedrange true"), h[K].fixedrange = !0;
              }
              break;
            }
          }
          for (T = 0; T < y.length; ) {
            R = y[T];
            for (I in R) {
              B = h[e(I)], B._matchGroup && Object.keys(B._matchGroup).length === Object.keys(R).length && (y.splice(T, 1), T--);
              break;
            }
            T++;
          }
          U(y, "_constraintGroup");
          var te = ["constrain", "range", "autorange", "rangemode", "rangebreaks", "categoryorder", "categoryarray"], V = !1, Z = !1;
          function Y() {
            q = B[z], z === "rangebreaks" && (Z = B._hasDayOfWeekBreaks);
          }
          for (T = 0; T < _.length; T++) {
            R = _[T];
            for (var C = 0; C < te.length; C++) {
              z = te[C], q = null;
              var j;
              for (I in R) if (P = e(I), M = x[P], B = h[P], z in B) {
                if (!B.matches && (j = B, z in M)) {
                  Y();
                  break;
                }
                q === null && z in M && Y();
              }
              if (z === "range" && q && M.range && M.range.length === 2 && M.range[0] !== null && M.range[1] !== null && (V = !0), z === "autorange" && q === null && V && (q = !1), q === null && z in j && (q = j[z]), q !== null) for (I in R) B = h[e(I)], B[z] = z === "range" ? q.slice() : q, z === "rangebreaks" && (B._hasDayOfWeekBreaks = Z, o(B, h));
            }
          }
        };
        function c(x, h, m) {
          var u = m.axIds, d = m.layoutOut, y = m.hasImage, _ = d._axisConstraintGroups, T = d._axisMatchGroups, R = h._id, I = R.charAt(0), P = ((d._splomAxes || {})[I] || {})[R] || {}, M = h._id, B = M.charAt(0) === "x";
          h._matchGroup = null, h._constraintGroup = null;
          function z(O, F) {
            return k.coerce(x, h, a, O, F);
          }
          z("constrain", y ? "domain" : "range"), k.coerce(x, h, { constraintoward: { valType: "enumerated", values: B ? ["left", "center", "right"] : ["bottom", "middle", "top"], dflt: B ? "center" : "middle" } }, "constraintoward");
          var q = h.type, U, G, K = [];
          for (U = 0; U < u.length; U++) if (G = u[U], G !== M) {
            var te = d[e(G)];
            te.type === q && K.push(G);
          }
          var V = p(_, M);
          if (V) {
            var Z = [];
            for (U = 0; U < K.length; U++) G = K[U], V[G] || Z.push(G);
            K = Z;
          }
          var Y = K.length, C, j;
          Y && (x.matches || P.matches) && (C = k.coerce(x, h, { matches: { valType: "enumerated", values: K, dflt: K.indexOf(P.matches) !== -1 ? P.matches : void 0 } }, "matches"));
          var J = y && !B ? h.anchor : void 0;
          if (Y && !C && (x.scaleanchor || J) && (j = k.coerce(x, h, { scaleanchor: { valType: "enumerated", values: K.concat([!1]) } }, "scaleanchor", J)), C) {
            h._matchGroup = l(T, M, C, 1);
            var ne = d[e(C)], ae = t(d, h) / t(d, ne);
            B !== (C.charAt(0) === "x") && (ae = (B ? "x" : "y") + ae), l(_, M, C, ae);
          } else x.matches && u.indexOf(x.matches) !== -1 && k.warn("ignored " + h._name + '.matches: "' + x.matches + '" to avoid an infinite loop');
          if (j) {
            var se = z("scaleratio");
            se || (se = h.scaleratio = 1), l(_, M, j, se);
          } else x.scaleanchor && u.indexOf(x.scaleanchor) !== -1 && k.warn("ignored " + h._name + '.scaleanchor: "' + x.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
        }
        function t(x, h) {
          var m = h.domain;
          return m || (m = x[e(h.overlaying)].domain), m[1] - m[0];
        }
        function p(x, h) {
          for (var m = 0; m < x.length; m++) if (x[m][h]) return x[m];
          return null;
        }
        function l(x, h, m, u) {
          var d, y, _, T, R, I = p(x, h);
          I === null ? (I = {}, I[h] = 1, R = x.length, x.push(I)) : R = x.indexOf(I);
          var P = Object.keys(I);
          for (d = 0; d < x.length; d++) if (_ = x[d], d !== R && _[m]) {
            var M = _[m];
            for (y = 0; y < P.length; y++) T = P[y], _[T] = f(M, f(u, I[T]));
            x.splice(R, 1);
            return;
          }
          if (u !== 1) for (y = 0; y < P.length; y++) {
            var B = P[y];
            I[B] = f(u, I[B]);
          }
          I[m] = 1;
        }
        function f(x, h) {
          var m = "", u = "", d, y;
          typeof x == "string" && (m = x.match(/^[xy]*/)[0], d = m.length, x = +x.substr(d)), typeof h == "string" && (u = h.match(/^[xy]*/)[0], y = u.length, h = +h.substr(y));
          var _ = x * h;
          return !d && !y ? _ : !d || !y || m.charAt(0) === u.charAt(0) ? m + u + x * h : d === y ? _ : (d > y ? m.substr(y) : u.substr(d)) + _;
        }
        function v(x, h) {
          for (var m = h._size, u = m.h / m.w, d = {}, y = Object.keys(x), _ = 0; _ < y.length; _++) {
            var T = y[_], R = x[T];
            if (typeof R == "string") {
              var I = R.match(/^[xy]*/)[0], P = I.length;
              R = +R.substr(P);
              for (var M = I.charAt(0) === "y" ? u : 1 / u, B = 0; B < P; B++) R *= M;
            }
            d[T] = R;
          }
          return d;
        }
        L.enforce = function(x) {
          var h = x._fullLayout, m = h._axisConstraintGroups || [], u, d, y, _, T, R, I, P;
          for (u = 0; u < m.length; u++) {
            y = v(m[u], h);
            var M = Object.keys(y), B = 1 / 0, z = 0, q = 1 / 0, U = {}, G = {}, K = !1;
            for (d = 0; d < M.length; d++) _ = M[d], G[_] = T = h[e(_)], T._inputDomain ? T.domain = T._inputDomain.slice() : T._inputDomain = T.domain.slice(), T._inputRange || (T._inputRange = T.range.slice()), T.setScale(), U[_] = R = Math.abs(T._m) / y[_], B = Math.min(B, R), (T.constrain === "domain" || !T._constraintShrinkable) && (q = Math.min(q, R)), delete T._constraintShrinkable, z = Math.max(z, R), T.constrain === "domain" && (K = !0);
            if (!(B > r * z && !K)) {
              for (d = 0; d < M.length; d++) if (_ = M[d], R = U[_], T = G[_], I = T.constrain, R !== q || I === "domain") if (P = R / q, I === "range") i(T, P);
              else {
                var te = T._inputDomain, V = (T.domain[1] - T.domain[0]) / (te[1] - te[0]), Z = (T.r2l(T.range[1]) - T.r2l(T.range[0])) / (T.r2l(T._inputRange[1]) - T.r2l(T._inputRange[0]));
                if (P /= V, P * Z < 1) {
                  T.domain = T._input.domain = te.slice(), i(T, P);
                  continue;
                }
                if (Z < 1 && (T.range = T._input.range = T._inputRange.slice(), P *= Z), T.autorange) {
                  var Y = T.r2l(T.range[0]), C = T.r2l(T.range[1]), j = (Y + C) / 2, J = j, ne = j, ae = Math.abs(C - j), se = j - ae * P * 1.0001, O = j + ae * P * 1.0001, F = n.makePadFn(h, T, 0), S = n.makePadFn(h, T, 1);
                  g(T, P);
                  var $ = Math.abs(T._m), re = n.concatExtremes(x, T), E = re.min, w = re.max, N, W;
                  for (W = 0; W < E.length; W++) N = E[W].val - F(E[W]) / $, N > se && N < J && (J = N);
                  for (W = 0; W < w.length; W++) N = w[W].val + S(w[W]) / $, N < O && N > ne && (ne = N);
                  var ee = (ne - J) / (2 * ae);
                  P /= ee, J = T.l2r(J), ne = T.l2r(ne), T.range = T._input.range = Y < C ? [J, ne] : [ne, J];
                }
                g(T, P);
              }
            }
          }
        }, L.getAxisGroup = function(x, h) {
          for (var m = x._axisMatchGroups, u = 0; u < m.length; u++) {
            var d = m[u];
            if (d[h]) return "g" + u;
          }
          return h;
        }, L.clean = function(x, h) {
          if (h._inputDomain) {
            for (var m = !1, u = h._id, d = x._fullLayout._axisConstraintGroups, y = 0; y < d.length; y++) if (d[y][u]) {
              m = !0;
              break;
            }
            (!m || h.constrain !== "domain") && (h._input.domain = h.domain = h._inputDomain, delete h._inputDomain);
          }
        };
        function g(x, h) {
          var m = x._inputDomain, u = s[x.constraintoward], d = m[0] + (m[1] - m[0]) * u;
          x.domain = x._input.domain = [d + (m[0] - d) / h, d + (m[1] - d) / h], x.setScale();
        }
      }), Io = xe((L) => {
        var k = vr(), n = or(), e = on(), a = wt(), i = xn(), o = So(), r = fr(), s = Or(), c = ti(), t = ws(), p = Ar(), l = kn(), f = Fa(), v = f.enforce, g = f.clean, x = ki().doAutoRange, h = "start", m = "middle", u = "end", d = mn().zindexSeparator;
        L.layoutStyles = function(V) {
          return a.syncOrAsync([e.doAutoMargin, _], V);
        };
        function y(V, Z, Y) {
          for (var C = 0; C < Y.length; C++) {
            var j = Y[C][0], J = Y[C][1];
            if (!(j[0] >= V[1] || j[1] <= V[0]) && J[0] < Z[1] && J[1] > Z[0]) return !0;
          }
          return !1;
        }
        function _(V) {
          var Z = V._fullLayout, Y = Z._size, C = Y.p, j = p.list(V, "", !0), J, ne, ae, se, O, F;
          if (Z._paperdiv.style({ width: V._context.responsive && Z.autosize && !V._context._hasZeroWidth && !V.layout.width ? "100%" : Z.width + "px", height: V._context.responsive && Z.autosize && !V._context._hasZeroHeight && !V.layout.height ? "100%" : Z.height + "px" }).selectAll(".main-svg").call(s.setSize, Z.width, Z.height), V._context.setBackground(V, Z.paper_bgcolor), L.drawMainTitle(V), t.manage(V), !Z._has("cartesian")) return e.previousPromises(V);
          function S(ce, ge, ye) {
            var Me = ce._lw / 2;
            if (ce._id.charAt(0) === "x") {
              if (ge) {
                if (ye === "top") return ge._offset - C - Me;
              } else return Y.t + Y.h * (1 - (ce.position || 0)) + Me % 1;
              return ge._offset + ge._length + C + Me;
            }
            if (ge) {
              if (ye === "right") return ge._offset + ge._length + C + Me;
            } else return Y.l + Y.w * (ce.position || 0) + Me % 1;
            return ge._offset - C - Me;
          }
          for (J = 0; J < j.length; J++) {
            se = j[J];
            var $ = se._anchorAxis;
            se._linepositions = {}, se._lw = s.crispRound(V, se.linewidth, 1), se._mainLinePosition = S(se, $, se.side), se._mainMirrorPosition = se.mirror && $ ? S(se, $, l.OPPOSITE_SIDE[se.side]) : null;
          }
          var re = [], E = [], w = [], N = r.opacity(Z.paper_bgcolor) === 1 && r.opacity(Z.plot_bgcolor) === 1 && Z.paper_bgcolor === Z.plot_bgcolor;
          for (ne in Z._plots) if (ae = Z._plots[ne], ae.mainplot) ae.bg && ae.bg.remove(), ae.bg = void 0;
          else {
            var W = ae.xaxis.domain, ee = ae.yaxis.domain, le = ae.plotgroup;
            if (y(W, ee, w) && ne.indexOf(d) === -1) {
              var ie = le.node(), pe = ae.bg = a.ensureSingle(le, "rect", "bg");
              ie.insertBefore(pe.node(), ie.childNodes[0]), E.push(ne);
            } else le.select("rect.bg").remove(), w.push([W, ee]), N || (re.push(ne), E.push(ne));
          }
          var _e = Z._bgLayer.selectAll(".bg").data(re);
          for (_e.enter().append("rect").classed("bg", !0), _e.exit().remove(), _e.each(function(ce) {
            Z._plots[ce].bg = k.select(this);
          }), J = 0; J < E.length; J++) ae = Z._plots[E[J]], O = ae.xaxis, F = ae.yaxis, ae.bg && O._offset !== void 0 && F._offset !== void 0 && ae.bg.call(s.setRect, O._offset - C, F._offset - C, O._length + 2 * C, F._length + 2 * C).call(r.fill, Z.plot_bgcolor).style("stroke-width", 0);
          if (!Z._hasOnlyLargeSploms) for (ne in Z._plots) {
            ae = Z._plots[ne], O = ae.xaxis, F = ae.yaxis;
            var Ae = ae.clipId = "clip" + Z._uid + ne + "plot", Ce = a.ensureSingleById(Z._clips, "clipPath", Ae, function(ce) {
              ce.classed("plotclip", !0).append("rect");
            });
            ae.clipRect = Ce.select("rect").attr({ width: O._length, height: F._length }), s.setTranslate(ae.plot, O._offset, F._offset);
            var Ue, Ne;
            ae._hasClipOnAxisFalse ? (Ue = null, Ne = Ae) : (Ue = Ae, Ne = null), s.setClipUrl(ae.plot, Ue, V), ae.layerClipId = Ne;
          }
          var ke, A, X, H, ve, be, Se, De, He, Ze, We, $e, it;
          function Ke(ce) {
            return "M" + ke + "," + ce + "H" + A;
          }
          function ct(ce) {
            return "M" + O._offset + "," + ce + "h" + O._length;
          }
          function gt(ce) {
            return "M" + ce + "," + De + "V" + Se;
          }
          function ht(ce) {
            return F._shift !== void 0 && (ce += F._shift), "M" + ce + "," + F._offset + "v" + F._length;
          }
          function _t(ce, ge, ye) {
            if (!ce.showline || ne !== ce._mainSubplot) return "";
            if (!ce._anchorAxis) return ye(ce._mainLinePosition);
            var Me = ge(ce._mainLinePosition);
            return ce.mirror && (Me += ge(ce._mainMirrorPosition)), Me;
          }
          for (ne in Z._plots) {
            ae = Z._plots[ne], O = ae.xaxis, F = ae.yaxis;
            var Te = "M0,0";
            T(O, ne) && (ve = I(O, "left", F, j), ke = O._offset - (ve ? C + ve : 0), be = I(O, "right", F, j), A = O._offset + O._length + (be ? C + be : 0), X = S(O, F, "bottom"), H = S(O, F, "top"), it = !O._anchorAxis || ne !== O._mainSubplot, it && (O.mirror === "allticks" || O.mirror === "all") && (O._linepositions[ne] = [X, H]), Te = _t(O, Ke, ct), it && O.showline && (O.mirror === "all" || O.mirror === "allticks") && (Te += Ke(X) + Ke(H)), ae.xlines.style("stroke-width", O._lw + "px").call(r.stroke, O.showline ? O.linecolor : "rgba(0,0,0,0)")), ae.xlines.attr("d", Te);
            var Ie = "M0,0";
            T(F, ne) && (We = I(F, "bottom", O, j), Se = F._offset + F._length + (We ? C : 0), $e = I(F, "top", O, j), De = F._offset - ($e ? C : 0), He = S(F, O, "left"), Ze = S(F, O, "right"), it = !F._anchorAxis || ne !== F._mainSubplot, it && (F.mirror === "allticks" || F.mirror === "all") && (F._linepositions[ne] = [He, Ze]), Ie = _t(F, gt, ht), it && F.showline && (F.mirror === "all" || F.mirror === "allticks") && (Ie += gt(He) + gt(Ze)), ae.ylines.style("stroke-width", F._lw + "px").call(r.stroke, F.showline ? F.linecolor : "rgba(0,0,0,0)")), ae.ylines.attr("d", Ie);
          }
          return p.makeClipPaths(V), e.previousPromises(V);
        }
        function T(V, Z) {
          return (V.ticks || V.showline) && (Z === V._mainSubplot || V.mirror === "all" || V.mirror === "allticks");
        }
        function R(V, Z, Y) {
          if (!Y.showline || !Y._lw) return !1;
          if (Y.mirror === "all" || Y.mirror === "allticks") return !0;
          var C = Y._anchorAxis;
          if (!C) return !1;
          var j = l.FROM_BL[Z];
          return Y.side === Z ? C.domain[j] === V.domain[j] : Y.mirror && C.domain[1 - j] === V.domain[1 - j];
        }
        function I(V, Z, Y, C) {
          if (R(V, Z, Y)) return Y._lw;
          for (var j = 0; j < C.length; j++) {
            var J = C[j];
            if (J._mainAxis === Y._mainAxis && R(V, Z, J)) return J._lw;
          }
          return 0;
        }
        L.drawMainTitle = function(V) {
          var Z = V._fullLayout.title, Y = V._fullLayout, C = K(Y), j = te(Y), J = U(Y, j), ne = q(Y, C);
          if (c.draw(V, "gtitle", { propContainer: Y, propName: "title.text", subtitlePropName: "title.subtitle.text", placeholder: Y._dfltTitle.plot, subtitlePlaceholder: Y._dfltTitle.subtitle, attributes: { x: ne, y: J, "text-anchor": C, dy: j } }), Z.text && Z.automargin) {
            var ae = k.select(V).selectAll(".gtitle"), se = s.bBox(k.select(V).selectAll(".g-gtitle").node()).height, O = B(V, Z, se);
            if (O > 0) {
              z(V, J, O, se), ae.attr({ x: ne, y: J, "text-anchor": C, dy: G(Z.yanchor) }).call(i.positionText, ne, J);
              var F = (Z.text.match(i.BR_TAG_ALL) || []).length;
              if (F) {
                var S = l.LINE_SPACING * F + l.MID_SHIFT;
                Z.y === 0 && (S = -S), ae.selectAll(".line").each(function() {
                  var N = +this.getAttribute("dy").slice(0, -2) - S + "em";
                  this.setAttribute("dy", N);
                });
              }
              var $ = k.select(V).selectAll(".gtitle-subtitle");
              if ($.node()) {
                var re = ae.node().getBBox(), E = re.y + re.height, w = E + c.SUBTITLE_PADDING_EM * Z.subtitle.font.size;
                $.attr({ x: ne, y: w, "text-anchor": C, dy: G(Z.yanchor) }).call(i.positionText, ne, w);
              }
            }
          }
        };
        function P(V, Z, Y, C, j) {
          var J = Z.yref === "paper" ? V._fullLayout._size.h : V._fullLayout.height, ne = a.isTopAnchor(Z) ? C : C - j, ae = Y === "b" ? J - ne : ne;
          return a.isTopAnchor(Z) && Y === "t" || a.isBottomAnchor(Z) && Y === "b" ? !1 : ae < j;
        }
        function M(V, Z, Y, C, j) {
          var J = 0;
          return Y === "middle" && (J += j / 2), V === "t" ? (Y === "top" && (J += j), J += C - Z * C) : (Y === "bottom" && (J += j), J += Z * C), J;
        }
        function B(V, Z, Y) {
          var C = Z.y, j = Z.yanchor, J = C > 0.5 ? "t" : "b", ne = V._fullLayout.margin[J], ae = 0;
          return Z.yref === "paper" ? ae = Y + Z.pad.t + Z.pad.b : Z.yref === "container" && (ae = M(J, C, j, V._fullLayout.height, Y) + Z.pad.t + Z.pad.b), ae > ne ? ae : 0;
        }
        function z(V, Z, Y, C) {
          var j = "title.automargin", J = V._fullLayout.title, ne = J.y > 0.5 ? "t" : "b", ae = { x: J.x, y: J.y, t: 0, b: 0 }, se = {};
          J.yref === "paper" && P(V, J, ne, Z, C) ? ae[ne] = Y : J.yref === "container" && (se[ne] = Y, V._fullLayout._reservedMargin[j] = se), e.allowAutoMargin(V, j), e.autoMargin(V, j, ae);
        }
        function q(V, Z) {
          var Y = V.title, C = V._size, j = 0;
          switch (Z === h ? j = Y.pad.l : Z === u && (j = -Y.pad.r), Y.xref) {
            case "paper":
              return C.l + C.w * Y.x + j;
            case "container":
            default:
              return V.width * Y.x + j;
          }
        }
        function U(V, Z) {
          var Y = V.title, C = V._size, j = 0;
          if (Z === "0em" || !Z ? j = -Y.pad.b : Z === l.CAP_SHIFT + "em" && (j = Y.pad.t), Y.y === "auto") return C.t / 2;
          switch (Y.yref) {
            case "paper":
              return C.t + C.h - C.h * Y.y + j;
            case "container":
            default:
              return V.height - V.height * Y.y + j;
          }
        }
        function G(V) {
          return V === "top" ? l.CAP_SHIFT + 0.3 + "em" : V === "bottom" ? "-0.3em" : l.MID_SHIFT + "em";
        }
        function K(V) {
          var Z = V.title, Y = m;
          return a.isRightAnchor(Z) ? Y = u : a.isLeftAnchor(Z) && (Y = h), Y;
        }
        function te(V) {
          var Z = V.title, Y = "0em";
          return a.isTopAnchor(Z) ? Y = l.CAP_SHIFT + "em" : a.isMiddleAnchor(Z) && (Y = l.MID_SHIFT + "em"), Y;
        }
        L.doTraceStyle = function(V) {
          var Z = V.calcdata, Y = [], C;
          for (C = 0; C < Z.length; C++) {
            var j = Z[C], J = j[0] || {}, ne = J.trace || {}, ae = ne._module || {}, se = ae.arraysToCalcdata;
            se && se(j, ne);
            var O = ae.editStyle;
            O && Y.push({ fn: O, cd0: J });
          }
          if (Y.length) {
            for (C = 0; C < Y.length; C++) {
              var F = Y[C];
              F.fn(V, F.cd0);
            }
            o(V), L.redrawReglTraces(V);
          }
          return e.style(V), n.getComponentMethod("legend", "draw")(V), e.previousPromises(V);
        }, L.doColorBars = function(V) {
          return n.getComponentMethod("colorbar", "draw")(V), e.previousPromises(V);
        }, L.layoutReplot = function(V) {
          var Z = V.layout;
          return V.layout = void 0, n.call("_doPlot", V, "", Z);
        }, L.doLegend = function(V) {
          return n.getComponentMethod("legend", "draw")(V), e.previousPromises(V);
        }, L.doTicksRelayout = function(V) {
          return p.draw(V, "redraw"), V._fullLayout._hasOnlyLargeSploms && (n.subplotsRegistry.splom.updateGrid(V), o(V), L.redrawReglTraces(V)), L.drawMainTitle(V), e.previousPromises(V);
        }, L.doModeBar = function(V) {
          var Z = V._fullLayout;
          t.manage(V);
          for (var Y = 0; Y < Z._basePlotModules.length; Y++) {
            var C = Z._basePlotModules[Y].updateFx;
            C && C(V);
          }
          return e.previousPromises(V);
        }, L.doCamera = function(V) {
          for (var Z = V._fullLayout, Y = Z._subplots.gl3d, C = 0; C < Y.length; C++) {
            var j = Z[Y[C]], J = j._scene;
            J.setViewport(j);
          }
        }, L.drawData = function(V) {
          var Z = V._fullLayout;
          o(V);
          for (var Y = Z._basePlotModules, C = 0; C < Y.length; C++) Y[C].plot(V);
          return L.redrawReglTraces(V), e.style(V), n.getComponentMethod("selections", "draw")(V), n.getComponentMethod("shapes", "draw")(V), n.getComponentMethod("annotations", "draw")(V), n.getComponentMethod("images", "draw")(V), Z._replotting = !1, e.previousPromises(V);
        }, L.redrawReglTraces = function(V) {
          var Z = V._fullLayout;
          if (Z._has("regl")) {
            var Y = V._fullData, C = [], j = [], J, ne;
            for (Z._hasOnlyLargeSploms && Z._splomGrid.draw(), J = 0; J < Y.length; J++) {
              var ae = Y[J];
              ae.visible === !0 && ae._length !== 0 && (ae.type === "splom" ? Z._splomScenes[ae.uid].draw() : ae.type === "scattergl" ? a.pushUnique(C, ae.xaxis + ae.yaxis) : ae.type === "scatterpolargl" && a.pushUnique(j, ae.subplot));
            }
            for (J = 0; J < C.length; J++) ne = Z._plots[C[J]], ne._scene && ne._scene.draw();
            for (J = 0; J < j.length; J++) ne = Z[j[J]]._subplot, ne._scene && ne._scene.draw();
          }
        }, L.doAutoRangeAndConstraints = function(V) {
          for (var Z = p.list(V, "", !0), Y, C = {}, j = 0; j < Z.length; j++) if (Y = Z[j], !C[Y._id]) {
            C[Y._id] = 1, g(V, Y), x(V, Y);
            var J = Y._matchGroup;
            if (J) for (var ne in J) {
              var ae = p.getFromId(V, ne);
              x(V, ae, Y.range), C[ne] = 1;
            }
          }
          v(V);
        }, L.finalDraw = function(V) {
          n.getComponentMethod("rangeslider", "draw")(V), n.getComponentMethod("rangeselector", "draw")(V);
        }, L.drawMarginPushers = function(V) {
          n.getComponentMethod("legend", "draw")(V), n.getComponentMethod("rangeselector", "draw")(V), n.getComponentMethod("sliders", "draw")(V), n.getComponentMethod("updatemenus", "draw")(V), n.getComponentMethod("colorbar", "draw")(V);
        };
      }), ks = xe((L, k) => {
        var n = Sa().readPaths, e = Do(), a = Ma().clearOutlineControllers, i = fr(), o = Or(), r = qr().arrayEditor, s = La(), c = s.getPathString;
        k.exports = { draw: t, drawOne: l, activateLastSelection: g };
        function t(h) {
          var m = h._fullLayout;
          a(h), m._selectionLayer.selectAll("path").remove();
          for (var u in m._plots) {
            var d = m._plots[u].selectionLayer;
            d && d.selectAll("path").remove();
          }
          for (var y = 0; y < m.selections.length; y++) l(h, y);
        }
        function p(h) {
          return h._context.editSelection;
        }
        function l(h, m) {
          h._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + m + '"]').remove();
          var u = s.makeSelectionsOptionsAndPlotinfo(h, m), d = u.options, y = u.plotinfo;
          if (!d._input) return;
          _(h._fullLayout._selectionLayer);
          function _(T) {
            var R = c(h, d), I = { "data-index": m, "fill-rule": "evenodd", d: R }, P = d.opacity, M = "rgba(0,0,0,0)", B = d.line.color || i.contrast(h._fullLayout.plot_bgcolor), z = d.line.width, q = d.line.dash;
            z || (z = 5, q = "solid");
            var U = p(h) && h._fullLayout._activeSelectionIndex === m;
            U && (M = h._fullLayout.activeselection.fillcolor, P = h._fullLayout.activeselection.opacity);
            for (var G = [], K = 1; K >= 0; K--) {
              var te = T.append("path").attr(I).style("opacity", K ? 0.1 : P).call(i.stroke, B).call(i.fill, M).call(o.dashLine, K ? "solid" : q, K ? 4 + z : z);
              if (f(te, h, d), U) {
                var V = r(h.layout, "selections", d);
                te.style({ cursor: "move" });
                var Z = { element: te.node(), plotinfo: y, gd: h, editHelpers: V, isActiveSelection: !0 }, Y = n(R, h);
                e(Y, te, Z);
              } else te.style("pointer-events", K ? "all" : "none");
              G[K] = te;
            }
            var C = G[0], j = G[1];
            j.node().addEventListener("click", function() {
              return v(h, C);
            });
          }
        }
        function f(h, m, u) {
          var d = u.xref + u.yref;
          o.setClipUrl(h, "clip" + m._fullLayout._uid + d, m);
        }
        function v(h, m) {
          if (p(h)) {
            var u = m.node(), d = +u.getAttribute("data-index");
            if (d >= 0) {
              if (d === h._fullLayout._activeSelectionIndex) {
                x(h);
                return;
              }
              h._fullLayout._activeSelectionIndex = d, h._fullLayout._deactivateSelection = x, t(h);
            }
          }
        }
        function g(h) {
          if (p(h)) {
            var m = h._fullLayout.selections.length - 1;
            h._fullLayout._activeSelectionIndex = m, h._fullLayout._deactivateSelection = x, t(h);
          }
        }
        function x(h) {
          if (p(h)) {
            var m = h._fullLayout._activeSelectionIndex;
            m >= 0 && (a(h), delete h._fullLayout._activeSelectionIndex, t(h));
          }
        }
      }), jd = xe((L, k) => {
        function n() {
          var e, a = 0, i = !1;
          function o(r, s) {
            return e.list.push({ type: r, data: s ? JSON.parse(JSON.stringify(s)) : void 0 }), e;
          }
          return e = { list: [], segmentId: function() {
            return a++;
          }, checkIntersection: function(r, s) {
            return o("check", { seg1: r, seg2: s });
          }, segmentChop: function(r, s) {
            return o("div_seg", { seg: r, pt: s }), o("chop", { seg: r, pt: s });
          }, statusRemove: function(r) {
            return o("pop_seg", { seg: r });
          }, segmentUpdate: function(r) {
            return o("seg_update", { seg: r });
          }, segmentNew: function(r, s) {
            return o("new_seg", { seg: r, primary: s });
          }, segmentRemove: function(r) {
            return o("rem_seg", { seg: r });
          }, tempStatus: function(r, s, c) {
            return o("temp_status", { seg: r, above: s, below: c });
          }, rewind: function(r) {
            return o("rewind", { seg: r });
          }, status: function(r, s, c) {
            return o("status", { seg: r, above: s, below: c });
          }, vert: function(r) {
            return r === i ? e : (i = r, o("vert", { x: r }));
          }, log: function(r) {
            return typeof r != "string" && (r = JSON.stringify(r, !1, "  ")), o("log", { txt: r });
          }, reset: function() {
            return o("reset");
          }, selected: function(r) {
            return o("selected", { segs: r });
          }, chainStart: function(r) {
            return o("chain_start", { seg: r });
          }, chainRemoveHead: function(r, s) {
            return o("chain_rem_head", { index: r, pt: s });
          }, chainRemoveTail: function(r, s) {
            return o("chain_rem_tail", { index: r, pt: s });
          }, chainNew: function(r, s) {
            return o("chain_new", { pt1: r, pt2: s });
          }, chainMatch: function(r) {
            return o("chain_match", { index: r });
          }, chainClose: function(r) {
            return o("chain_close", { index: r });
          }, chainAddHead: function(r, s) {
            return o("chain_add_head", { index: r, pt: s });
          }, chainAddTail: function(r, s) {
            return o("chain_add_tail", { index: r, pt: s });
          }, chainConnect: function(r, s) {
            return o("chain_con", { index1: r, index2: s });
          }, chainReverse: function(r) {
            return o("chain_rev", { index: r });
          }, chainJoin: function(r, s) {
            return o("chain_join", { index1: r, index2: s });
          }, done: function() {
            return o("done");
          } }, e;
        }
        k.exports = n;
      }), Hd = xe((L, k) => {
        function n(e) {
          typeof e != "number" && (e = 1e-10);
          var a = { epsilon: function(i) {
            return typeof i == "number" && (e = i), e;
          }, pointAboveOrOnLine: function(i, o, r) {
            var s = o[0], c = o[1], t = r[0], p = r[1], l = i[0], f = i[1];
            return (t - s) * (f - c) - (p - c) * (l - s) >= -e;
          }, pointBetween: function(i, o, r) {
            var s = i[1] - o[1], c = r[0] - o[0], t = i[0] - o[0], p = r[1] - o[1], l = t * c + s * p;
            if (l < e) return !1;
            var f = c * c + p * p;
            return !(l - f > -e);
          }, pointsSameX: function(i, o) {
            return Math.abs(i[0] - o[0]) < e;
          }, pointsSameY: function(i, o) {
            return Math.abs(i[1] - o[1]) < e;
          }, pointsSame: function(i, o) {
            return a.pointsSameX(i, o) && a.pointsSameY(i, o);
          }, pointsCompare: function(i, o) {
            return a.pointsSameX(i, o) ? a.pointsSameY(i, o) ? 0 : i[1] < o[1] ? -1 : 1 : i[0] < o[0] ? -1 : 1;
          }, pointsCollinear: function(i, o, r) {
            var s = i[0] - o[0], c = i[1] - o[1], t = o[0] - r[0], p = o[1] - r[1];
            return Math.abs(s * p - t * c) < e;
          }, linesIntersect: function(i, o, r, s) {
            var c = o[0] - i[0], t = o[1] - i[1], p = s[0] - r[0], l = s[1] - r[1], f = c * l - t * p;
            if (Math.abs(f) < e) return !1;
            var v = i[0] - r[0], g = i[1] - r[1], x = (p * g - l * v) / f, h = (c * g - t * v) / f, m = { alongA: 0, alongB: 0, pt: [i[0] + x * c, i[1] + x * t] };
            return x <= -e ? m.alongA = -2 : x < e ? m.alongA = -1 : x - 1 <= -e ? m.alongA = 0 : x - 1 < e ? m.alongA = 1 : m.alongA = 2, h <= -e ? m.alongB = -2 : h < e ? m.alongB = -1 : h - 1 <= -e ? m.alongB = 0 : h - 1 < e ? m.alongB = 1 : m.alongB = 2, m;
          }, pointInsideRegion: function(i, o) {
            for (var r = i[0], s = i[1], c = o[o.length - 1][0], t = o[o.length - 1][1], p = !1, l = 0; l < o.length; l++) {
              var f = o[l][0], v = o[l][1];
              v - s > e != t - s > e && (c - f) * (s - v) / (t - v) + f - r > e && (p = !p), c = f, t = v;
            }
            return p;
          } };
          return a;
        }
        k.exports = n;
      }), qd = xe((L, k) => {
        var n = { create: function() {
          var e = { root: { root: !0, next: null }, exists: function(a) {
            return !(a === null || a === e.root);
          }, isEmpty: function() {
            return e.root.next === null;
          }, getHead: function() {
            return e.root.next;
          }, insertBefore: function(a, i) {
            for (var o = e.root, r = e.root.next; r !== null; ) {
              if (i(r)) {
                a.prev = r.prev, a.next = r, r.prev.next = a, r.prev = a;
                return;
              }
              o = r, r = r.next;
            }
            o.next = a, a.prev = o, a.next = null;
          }, findTransition: function(a) {
            for (var i = e.root, o = e.root.next; o !== null && !a(o); ) i = o, o = o.next;
            return { before: i === e.root ? null : i, after: o, insert: function(r) {
              return r.prev = i, r.next = o, i.next = r, o !== null && (o.prev = r), r;
            } };
          } };
          return e;
        }, node: function(e) {
          return e.prev = null, e.next = null, e.remove = function() {
            e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
          }, e;
        } };
        k.exports = n;
      }), Ud = xe((L, k) => {
        var n = qd();
        function e(a, i, o) {
          function r(m, u) {
            return { id: o ? o.segmentId() : -1, start: m, end: u, myFill: { above: null, below: null }, otherFill: null };
          }
          function s(m, u, d) {
            return { id: o ? o.segmentId() : -1, start: m, end: u, myFill: { above: d.myFill.above, below: d.myFill.below }, otherFill: null };
          }
          var c = n.create();
          function t(m, u, d, y, _, T) {
            var R = i.pointsCompare(u, _);
            return R !== 0 ? R : i.pointsSame(d, T) ? 0 : m !== y ? m ? 1 : -1 : i.pointAboveOrOnLine(d, y ? _ : T, y ? T : _) ? 1 : -1;
          }
          function p(m, u) {
            c.insertBefore(m, function(d) {
              var y = t(m.isStart, m.pt, u, d.isStart, d.pt, d.other.pt);
              return y < 0;
            });
          }
          function l(m, u) {
            var d = n.node({ isStart: !0, pt: m.start, seg: m, primary: u, other: null, status: null });
            return p(d, m.end), d;
          }
          function f(m, u, d) {
            var y = n.node({ isStart: !1, pt: u.end, seg: u, primary: d, other: m, status: null });
            m.other = y, p(y, m.pt);
          }
          function v(m, u) {
            var d = l(m, u);
            return f(d, m, u), d;
          }
          function g(m, u) {
            o && o.segmentChop(m.seg, u), m.other.remove(), m.seg.end = u, m.other.pt = u, p(m.other, m.pt);
          }
          function x(m, u) {
            var d = s(u, m.seg.end, m.seg);
            return g(m, u), v(d, m.primary);
          }
          function h(m, u) {
            var d = n.create();
            function y(te, V) {
              var Z = te.seg.start, Y = te.seg.end, C = V.seg.start, j = V.seg.end;
              return i.pointsCollinear(Z, C, j) ? i.pointsCollinear(Y, C, j) || i.pointAboveOrOnLine(Y, C, j) ? 1 : -1 : i.pointAboveOrOnLine(Z, C, j) ? 1 : -1;
            }
            function _(te) {
              return d.findTransition(function(V) {
                var Z = y(te, V.ev);
                return Z > 0;
              });
            }
            function T(te, V) {
              var Z = te.seg, Y = V.seg, C = Z.start, j = Z.end, J = Y.start, ne = Y.end;
              o && o.checkIntersection(Z, Y);
              var ae = i.linesIntersect(C, j, J, ne);
              if (ae === !1) {
                if (!i.pointsCollinear(C, j, J) || i.pointsSame(C, ne) || i.pointsSame(j, J)) return !1;
                var se = i.pointsSame(C, J), O = i.pointsSame(j, ne);
                if (se && O) return V;
                var F = !se && i.pointBetween(C, J, ne), S = !O && i.pointBetween(j, J, ne);
                if (se) return S ? x(V, j) : x(te, ne), V;
                F && (O || (S ? x(V, j) : x(te, ne)), x(V, C));
              } else ae.alongA === 0 && (ae.alongB === -1 ? x(te, J) : ae.alongB === 0 ? x(te, ae.pt) : ae.alongB === 1 && x(te, ne)), ae.alongB === 0 && (ae.alongA === -1 ? x(V, C) : ae.alongA === 0 ? x(V, ae.pt) : ae.alongA === 1 && x(V, j));
              return !1;
            }
            for (var R = []; !c.isEmpty(); ) {
              var I = c.getHead();
              if (o && o.vert(I.pt[0]), I.isStart) {
                let te = function() {
                  if (M) {
                    var V = T(I, M);
                    if (V) return V;
                  }
                  return B ? T(I, B) : !1;
                };
                o && o.segmentNew(I.seg, I.primary);
                var P = _(I), M = P.before ? P.before.ev : null, B = P.after ? P.after.ev : null;
                o && o.tempStatus(I.seg, M ? M.seg : !1, B ? B.seg : !1);
                var z = te();
                if (z) {
                  if (a) {
                    var q;
                    I.seg.myFill.below === null ? q = !0 : q = I.seg.myFill.above !== I.seg.myFill.below, q && (z.seg.myFill.above = !z.seg.myFill.above);
                  } else z.seg.otherFill = I.seg.myFill;
                  o && o.segmentUpdate(z.seg), I.other.remove(), I.remove();
                }
                if (c.getHead() !== I) {
                  o && o.rewind(I.seg);
                  continue;
                }
                if (a) {
                  var q;
                  I.seg.myFill.below === null ? q = !0 : q = I.seg.myFill.above !== I.seg.myFill.below, B ? I.seg.myFill.below = B.seg.myFill.above : I.seg.myFill.below = m, q ? I.seg.myFill.above = !I.seg.myFill.below : I.seg.myFill.above = I.seg.myFill.below;
                } else if (I.seg.otherFill === null) {
                  var U;
                  B ? I.primary === B.primary ? U = B.seg.otherFill.above : U = B.seg.myFill.above : U = I.primary ? u : m, I.seg.otherFill = { above: U, below: U };
                }
                o && o.status(I.seg, M ? M.seg : !1, B ? B.seg : !1), I.other.status = P.insert(n.node({ ev: I }));
              } else {
                var G = I.status;
                if (G === null) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                if (d.exists(G.prev) && d.exists(G.next) && T(G.prev.ev, G.next.ev), o && o.statusRemove(G.ev.seg), G.remove(), !I.primary) {
                  var K = I.seg.myFill;
                  I.seg.myFill = I.seg.otherFill, I.seg.otherFill = K;
                }
                R.push(I.seg);
              }
              c.getHead().remove();
            }
            return o && o.done(), R;
          }
          return a ? { addRegion: function(m) {
            for (var u, d = m[m.length - 1], y = 0; y < m.length; y++) {
              u = d, d = m[y];
              var _ = i.pointsCompare(u, d);
              _ !== 0 && v(r(_ < 0 ? u : d, _ < 0 ? d : u), !0);
            }
          }, calculate: function(m) {
            return h(m, !1);
          } } : { calculate: function(m, u, d, y) {
            return m.forEach(function(_) {
              v(s(_.start, _.end, _), !0);
            }), d.forEach(function(_) {
              v(s(_.start, _.end, _), !1);
            }), h(u, y);
          } };
        }
        k.exports = e;
      }), Vd = xe((L, k) => {
        function n(e, a, i) {
          var o = [], r = [];
          return e.forEach(function(s) {
            var c = s.start, t = s.end;
            if (a.pointsSame(c, t)) {
              console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
              return;
            }
            i && i.chainStart(s);
            var p = { index: 0, matches_head: !1, matches_pt1: !1 }, l = { index: 0, matches_head: !1, matches_pt1: !1 }, f = p;
            function v(U, G, K) {
              return f.index = U, f.matches_head = G, f.matches_pt1 = K, f === p ? (f = l, !1) : (f = null, !0);
            }
            for (var g = 0; g < o.length; g++) {
              var x = o[g], h = x[0];
              x[1];
              var m = x[x.length - 1];
              if (x[x.length - 2], a.pointsSame(h, c)) {
                if (v(g, !0, !0)) break;
              } else if (a.pointsSame(h, t)) {
                if (v(g, !0, !1)) break;
              } else if (a.pointsSame(m, c)) {
                if (v(g, !1, !0)) break;
              } else if (a.pointsSame(m, t) && v(g, !1, !1)) break;
            }
            if (f === p) {
              o.push([c, t]), i && i.chainNew(c, t);
              return;
            }
            if (f === l) {
              i && i.chainMatch(p.index);
              var u = p.index, d = p.matches_pt1 ? t : c, y = p.matches_head, x = o[u], _ = y ? x[0] : x[x.length - 1], T = y ? x[1] : x[x.length - 2], R = y ? x[x.length - 1] : x[0], I = y ? x[x.length - 2] : x[1];
              if (a.pointsCollinear(T, _, d) && (y ? (i && i.chainRemoveHead(p.index, d), x.shift()) : (i && i.chainRemoveTail(p.index, d), x.pop()), _ = T), a.pointsSame(R, d)) {
                o.splice(u, 1), a.pointsCollinear(I, R, _) && (y ? (i && i.chainRemoveTail(p.index, _), x.pop()) : (i && i.chainRemoveHead(p.index, _), x.shift())), i && i.chainClose(p.index), r.push(x);
                return;
              }
              y ? (i && i.chainAddHead(p.index, d), x.unshift(d)) : (i && i.chainAddTail(p.index, d), x.push(d));
              return;
            }
            function P(U) {
              i && i.chainReverse(U), o[U].reverse();
            }
            function M(U, G) {
              var K = o[U], te = o[G], V = K[K.length - 1], Z = K[K.length - 2], Y = te[0], C = te[1];
              a.pointsCollinear(Z, V, Y) && (i && i.chainRemoveTail(U, V), K.pop(), V = Z), a.pointsCollinear(V, Y, C) && (i && i.chainRemoveHead(G, Y), te.shift()), i && i.chainJoin(U, G), o[U] = K.concat(te), o.splice(G, 1);
            }
            var B = p.index, z = l.index;
            i && i.chainConnect(B, z);
            var q = o[B].length < o[z].length;
            p.matches_head ? l.matches_head ? q ? (P(B), M(B, z)) : (P(z), M(z, B)) : M(z, B) : l.matches_head ? M(B, z) : q ? (P(B), M(z, B)) : (P(z), M(B, z));
          }), r;
        }
        k.exports = n;
      }), Yd = xe((L, k) => {
        function n(a, i, o) {
          var r = [];
          return a.forEach(function(s) {
            var c = (s.myFill.above ? 8 : 0) + (s.myFill.below ? 4 : 0) + (s.otherFill && s.otherFill.above ? 2 : 0) + (s.otherFill && s.otherFill.below ? 1 : 0);
            i[c] !== 0 && r.push({ id: o ? o.segmentId() : -1, start: s.start, end: s.end, myFill: { above: i[c] === 1, below: i[c] === 2 }, otherFill: null });
          }), o && o.selected(r), r;
        }
        var e = { union: function(a, i) {
          return n(a, [0, 2, 1, 0, 2, 2, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0], i);
        }, intersect: function(a, i) {
          return n(a, [0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 1, 1, 0, 2, 1, 0], i);
        }, difference: function(a, i) {
          return n(a, [0, 0, 0, 0, 2, 0, 2, 0, 1, 1, 0, 0, 0, 1, 2, 0], i);
        }, differenceRev: function(a, i) {
          return n(a, [0, 2, 1, 0, 0, 0, 1, 1, 0, 2, 0, 2, 0, 0, 0, 0], i);
        }, xor: function(a, i) {
          return n(a, [0, 2, 1, 0, 2, 0, 0, 1, 1, 0, 0, 2, 0, 1, 2, 0], i);
        } };
        k.exports = e;
      }), Gd = xe((L, k) => {
        var n = { toPolygon: function(e, a) {
          function i(s) {
            if (s.length <= 0) return e.segments({ inverted: !1, regions: [] });
            function c(l) {
              var f = l.slice(0, l.length - 1);
              return e.segments({ inverted: !1, regions: [f] });
            }
            for (var t = c(s[0]), p = 1; p < s.length; p++) t = e.selectDifference(e.combine(t, c(s[p])));
            return t;
          }
          if (a.type === "Polygon") return e.polygon(i(a.coordinates));
          if (a.type === "MultiPolygon") {
            for (var o = e.segments({ inverted: !1, regions: [] }), r = 0; r < a.coordinates.length; r++) o = e.selectUnion(e.combine(o, i(a.coordinates[r])));
            return e.polygon(o);
          }
          throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
        }, fromPolygon: function(e, a, i) {
          i = e.polygon(e.segments(i));
          function o(x, h) {
            return a.pointInsideRegion([(x[0][0] + x[1][0]) * 0.5, (x[0][1] + x[1][1]) * 0.5], h);
          }
          function r(x) {
            return { region: x, children: [] };
          }
          var s = r(null);
          function c(x, h) {
            for (var m = 0; m < x.children.length; m++) {
              var u = x.children[m];
              if (o(h, u.region)) {
                c(u, h);
                return;
              }
            }
            for (var d = r(h), m = 0; m < x.children.length; m++) {
              var u = x.children[m];
              o(u.region, h) && (d.children.push(u), x.children.splice(m, 1), m--);
            }
            x.children.push(d);
          }
          for (var t = 0; t < i.regions.length; t++) {
            var p = i.regions[t];
            p.length < 3 || c(s, p);
          }
          function l(x, h) {
            for (var m = 0, u = x[x.length - 1][0], d = x[x.length - 1][1], y = [], _ = 0; _ < x.length; _++) {
              var T = x[_][0], R = x[_][1];
              y.push([T, R]), m += R * u - T * d, u = T, d = R;
            }
            var I = m < 0;
            return I !== h && y.reverse(), y.push([y[0][0], y[0][1]]), y;
          }
          var f = [];
          function v(x) {
            var h = [l(x.region, !1)];
            f.push(h);
            for (var m = 0; m < x.children.length; m++) h.push(g(x.children[m]));
          }
          function g(x) {
            for (var h = 0; h < x.children.length; h++) v(x.children[h]);
            return l(x.region, !0);
          }
          for (var t = 0; t < s.children.length; t++) v(s.children[t]);
          return f.length <= 0 ? { type: "Polygon", coordinates: [] } : f.length == 1 ? { type: "Polygon", coordinates: f[0] } : { type: "MultiPolygon", coordinates: f };
        } };
        k.exports = n;
      }), Zd = xe((L, k) => {
        var n = jd(), e = Hd(), a = Ud(), i = Vd(), o = Yd(), r = Gd(), s = !1, c = e(), t;
        t = { buildLog: function(l) {
          return l === !0 ? s = n() : l === !1 && (s = !1), s === !1 ? !1 : s.list;
        }, epsilon: function(l) {
          return c.epsilon(l);
        }, segments: function(l) {
          var f = a(!0, c, s);
          return l.regions.forEach(f.addRegion), { segments: f.calculate(l.inverted), inverted: l.inverted };
        }, combine: function(l, f) {
          var v = a(!1, c, s);
          return { combined: v.calculate(l.segments, l.inverted, f.segments, f.inverted), inverted1: l.inverted, inverted2: f.inverted };
        }, selectUnion: function(l) {
          return { segments: o.union(l.combined, s), inverted: l.inverted1 || l.inverted2 };
        }, selectIntersect: function(l) {
          return { segments: o.intersect(l.combined, s), inverted: l.inverted1 && l.inverted2 };
        }, selectDifference: function(l) {
          return { segments: o.difference(l.combined, s), inverted: l.inverted1 && !l.inverted2 };
        }, selectDifferenceRev: function(l) {
          return { segments: o.differenceRev(l.combined, s), inverted: !l.inverted1 && l.inverted2 };
        }, selectXor: function(l) {
          return { segments: o.xor(l.combined, s), inverted: l.inverted1 !== l.inverted2 };
        }, polygon: function(l) {
          return { regions: i(l.segments, c, s), inverted: l.inverted };
        }, polygonFromGeoJSON: function(l) {
          return r.toPolygon(t, l);
        }, polygonToGeoJSON: function(l) {
          return r.fromPolygon(t, c, l);
        }, union: function(l, f) {
          return p(l, f, t.selectUnion);
        }, intersect: function(l, f) {
          return p(l, f, t.selectIntersect);
        }, difference: function(l, f) {
          return p(l, f, t.selectDifference);
        }, differenceRev: function(l, f) {
          return p(l, f, t.selectDifferenceRev);
        }, xor: function(l, f) {
          return p(l, f, t.selectXor);
        } };
        function p(l, f, v) {
          var g = t.segments(l), x = t.segments(f), h = t.combine(g, x), m = v(h);
          return t.polygon(m);
        }
        typeof window == "object" && (window.PolyBool = t), k.exports = t;
      }), Wd = xe((L, k) => {
        k.exports = function(n, e, a, i) {
          var o = n[0], r = n[1], s = !1;
          a === void 0 && (a = 0), i === void 0 && (i = e.length);
          for (var c = i - a, t = 0, p = c - 1; t < c; p = t++) {
            var l = e[t + a][0], f = e[t + a][1], v = e[p + a][0], g = e[p + a][1], x = f > r != g > r && o < (v - l) * (r - f) / (g - f) + l;
            x && (s = !s);
          }
          return s;
        };
      }), Ms = xe((L, k) => {
        var n = co().dot, e = Yr().BADNUM, a = k.exports = {};
        a.tester = function(i) {
          var o = i.slice(), r = o[0][0], s = r, c = o[0][1], t = c, p;
          for ((o[o.length - 1][0] !== o[0][0] || o[o.length - 1][1] !== o[0][1]) && o.push(o[0]), p = 1; p < o.length; p++) r = Math.min(r, o[p][0]), s = Math.max(s, o[p][0]), c = Math.min(c, o[p][1]), t = Math.max(t, o[p][1]);
          var l = !1, f;
          o.length === 5 && (o[0][0] === o[1][0] ? o[2][0] === o[3][0] && o[0][1] === o[3][1] && o[1][1] === o[2][1] && (l = !0, f = function(m) {
            return m[0] === o[0][0];
          }) : o[0][1] === o[1][1] && o[2][1] === o[3][1] && o[0][0] === o[3][0] && o[1][0] === o[2][0] && (l = !0, f = function(m) {
            return m[1] === o[0][1];
          }));
          function v(m, u) {
            var d = m[0], y = m[1];
            return !(d === e || d < r || d > s || y === e || y < c || y > t || u && f(m));
          }
          function g(m, u) {
            var d = m[0], y = m[1];
            if (d === e || d < r || d > s || y === e || y < c || y > t) return !1;
            var _ = o.length, T = o[0][0], R = o[0][1], I = 0, P, M, B, z, q;
            for (P = 1; P < _; P++) if (M = T, B = R, T = o[P][0], R = o[P][1], z = Math.min(M, T), !(d < z || d > Math.max(M, T) || y > Math.max(B, R))) if (y < Math.min(B, R)) d !== z && I++;
            else {
              if (T === M ? q = y : q = B + (d - M) * (R - B) / (T - M), y === q) return !(P === 1 && u);
              y <= q && d !== z && I++;
            }
            return I % 2 === 1;
          }
          var x = !0, h = o[0];
          for (p = 1; p < o.length; p++) if (h[0] !== o[p][0] || h[1] !== o[p][1]) {
            x = !1;
            break;
          }
          return { xmin: r, xmax: s, ymin: c, ymax: t, pts: o, contains: l ? v : g, isRect: l, degenerate: x };
        }, a.isSegmentBent = function(i, o, r, s) {
          var c = i[o], t = [i[r][0] - c[0], i[r][1] - c[1]], p = n(t, t), l = Math.sqrt(p), f = [-t[1] / l, t[0] / l], v, g, x;
          for (v = o + 1; v < r; v++) if (g = [i[v][0] - c[0], i[v][1] - c[1]], x = n(g, t), x < 0 || x > p || Math.abs(n(g, f)) > s) return !0;
          return !1;
        }, a.filter = function(i, o) {
          var r = [i[0]], s = 0, c = 0;
          function t(l) {
            i.push(l);
            var f = r.length, v = s;
            r.splice(c + 1);
            for (var g = v + 1; g < i.length; g++) (g === i.length - 1 || a.isSegmentBent(i, v, g + 1, o)) && (r.push(i[g]), r.length < f - 2 && (s = g, c = r.length - 1), v = g);
          }
          if (i.length > 1) {
            var p = i.pop();
            t(p);
          }
          return { addPt: t, raw: i, filtered: r };
        };
      }), Xd = xe((L, k) => {
        k.exports = { BENDPX: 1.5, MINSELECT: 12, SELECTDELAY: 100, SELECTID: "-select" };
      }), Jd = xe((L, k) => {
        var n = Zd(), e = Wd(), a = or(), i = Or().dashStyle, o = fr(), r = Bn(), s = da().makeEventData, c = Na(), t = c.freeMode, p = c.rectMode, l = c.drawMode, f = c.openMode, v = c.selectMode, g = La(), x = Mi(), h = Do(), m = Ma().clearOutline, u = Sa(), d = u.handleEllipse, y = u.readPaths, _ = Eo().newShapes, T = ys(), R = ks().activateLastSelection, I = wt(), P = I.sorterAsc, M = Ms(), B = ho(), z = sn().getFromId, q = So(), U = Io().redrawReglTraces, G = Xd(), K = G.MINSELECT, te = M.filter, V = M.tester, Z = Co(), Y = Z.p2r, C = Z.axValue, j = Z.getTransform;
        function J(Te) {
          return Te.subplot !== void 0;
        }
        function ne(Te, Ie, ce, ge, ye) {
          var Me = !J(ge), Oe = t(ye), je = p(ye), qe = f(ye), Qe = l(ye), Xe = v(ye), Je = ye === "drawline", ot = ye === "drawcircle", lt = Je || ot, st = ge.gd, xt = st._fullLayout, Et = Xe && xt.newselection.mode === "immediate" && Me, Bt = xt._zoomlayer, qt = ge.element.getBoundingClientRect(), jt = ge.plotinfo, It = j(jt), Tt = Ie - qt.left, Rt = ce - qt.top;
          xt._calcInverseTransform(st);
          var Vt = I.apply3DTransform(xt._invTransform)(Tt, Rt);
          Tt = Vt[0], Rt = Vt[1];
          var Ft = xt._invScaleX, Dt = xt._invScaleY, Ct = Tt, Ot = Rt, Wt = "M" + Tt + "," + Rt, rr = ge.xaxes[0], Ut = ge.yaxes[0], Qt = rr._length, nr = Ut._length, cr = Te.altKey && !(l(ye) && qe), lr, $t, sr, St, Kt, hr, he;
          $(Te, st, ge), Oe && (lr = te([[Tt, Rt]], G.BENDPX));
          var fe = Bt.selectAll("path.select-outline-" + jt.id).data([1]), Pe = Qe ? xt.newshape : xt.newselection;
          Qe && (ge.hasText = Pe.label.text || Pe.label.texttemplate);
          var Re = Qe && !qe ? Pe.fillcolor : "rgba(0,0,0,0)", Ye = Pe.line.color || (Me ? o.contrast(st._fullLayout.plot_bgcolor) : "#7f7f7f");
          fe.enter().append("path").attr("class", "select-outline select-outline-" + jt.id).style({ opacity: Qe ? Pe.opacity / 2 : 1, "stroke-dasharray": i(Pe.line.dash, Pe.line.width), "stroke-width": Pe.line.width + "px", "shape-rendering": "crispEdges" }).call(o.stroke, Ye).call(o.fill, Re).attr("fill-rule", "evenodd").classed("cursor-move", !!Qe).attr("transform", It).attr("d", Wt + "Z");
          var Ee = Bt.append("path").attr("class", "zoombox-corners").style({ fill: o.background, stroke: o.defaultLine, "stroke-width": 1 }).attr("transform", It).attr("d", "M0,0Z");
          if (Qe && ge.hasText) {
            var ze = Bt.select(".label-temp");
            ze.empty() && (ze = Bt.append("g").classed("label-temp", !0).classed("select-outline", !0).style({ opacity: 0.8 }));
          }
          var Ge = xt._uid + G.SELECTID, Ve = [], tt = W(st, ge.xaxes, ge.yaxes, ge.subplot);
          Et && !Te.shiftKey && (ge._clearSubplotSelections = function() {
            if (Me) {
              var vt = rr._id, kt = Ut._id;
              Se(st, vt, kt, tt);
              for (var At = (st.layout || {}).selections || [], Nt = [], Mt = !1, Pt = 0; Pt < At.length; Pt++) {
                var Lt = xt.selections[Pt];
                !Lt || Lt.xref !== vt || Lt.yref !== kt ? Nt.push(At[Pt]) : Mt = !0;
              }
              Mt && (st._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", st, { selections: Nt }));
            }
          });
          var at = ct(ge);
          ge.moveFn = function(vt, kt) {
            ge._clearSubplotSelections && (ge._clearSubplotSelections(), ge._clearSubplotSelections = void 0), Ct = Math.max(0, Math.min(Qt, Ft * vt + Tt)), Ot = Math.max(0, Math.min(nr, Dt * kt + Rt));
            var At = Math.abs(Ct - Tt), Nt = Math.abs(Ot - Rt);
            if (je) {
              var Mt, Pt, Lt;
              if (Xe) {
                var ur = xt.selectdirection;
                switch (ur === "any" ? Nt < Math.min(At * 0.6, K) ? Mt = "h" : At < Math.min(Nt * 0.6, K) ? Mt = "v" : Mt = "d" : Mt = ur, Mt) {
                  case "h":
                    Pt = ot ? nr / 2 : 0, Lt = nr;
                    break;
                  case "v":
                    Pt = ot ? Qt / 2 : 0, Lt = Qt;
                    break;
                }
              }
              if (Qe) switch (xt.newshape.drawdirection) {
                case "vertical":
                  Mt = "h", Pt = ot ? nr / 2 : 0, Lt = nr;
                  break;
                case "horizontal":
                  Mt = "v", Pt = ot ? Qt / 2 : 0, Lt = Qt;
                  break;
                case "ortho":
                  At < Nt ? (Mt = "h", Pt = Rt, Lt = Ot) : (Mt = "v", Pt = Tt, Lt = Ct);
                  break;
                default:
                  Mt = "d";
              }
              Mt === "h" ? (St = lt ? d(ot, [Ct, Pt], [Ct, Lt]) : [[Tt, Pt], [Tt, Lt], [Ct, Lt], [Ct, Pt]], St.xmin = lt ? Ct : Math.min(Tt, Ct), St.xmax = lt ? Ct : Math.max(Tt, Ct), St.ymin = Math.min(Pt, Lt), St.ymax = Math.max(Pt, Lt), Ee.attr("d", "M" + St.xmin + "," + (Rt - K) + "h-4v" + 2 * K + "h4ZM" + (St.xmax - 1) + "," + (Rt - K) + "h4v" + 2 * K + "h-4Z")) : Mt === "v" ? (St = lt ? d(ot, [Pt, Ot], [Lt, Ot]) : [[Pt, Rt], [Pt, Ot], [Lt, Ot], [Lt, Rt]], St.xmin = Math.min(Pt, Lt), St.xmax = Math.max(Pt, Lt), St.ymin = lt ? Ot : Math.min(Rt, Ot), St.ymax = lt ? Ot : Math.max(Rt, Ot), Ee.attr("d", "M" + (Tt - K) + "," + St.ymin + "v-4h" + 2 * K + "v4ZM" + (Tt - K) + "," + (St.ymax - 1) + "v4h" + 2 * K + "v-4Z")) : Mt === "d" && (St = lt ? d(ot, [Tt, Rt], [Ct, Ot]) : [[Tt, Rt], [Tt, Ot], [Ct, Ot], [Ct, Rt]], St.xmin = Math.min(Tt, Ct), St.xmax = Math.max(Tt, Ct), St.ymin = Math.min(Rt, Ot), St.ymax = Math.max(Rt, Ot), Ee.attr("d", "M0,0Z"));
            } else Oe && (lr.addPt([Ct, Ot]), St = lr.filtered);
            if (ge.selectionDefs && ge.selectionDefs.length ? (sr = Ne(ge.mergedPolygons, St, cr), St.subtract = cr, $t = S(ge.selectionDefs.concat([St]))) : (sr = [St], $t = V(St)), h(A(sr, qe), fe, ge), Xe) {
              var Ht = H(st, !1), mr = Ht.eventData ? Ht.eventData.points.slice() : [];
              Ht = H(st, !1, $t, tt, ge), $t = Ht.selectionTesters, he = Ht.eventData;
              var ar;
              lr ? ar = lr.filtered : ar = $e(sr), B.throttle(Ge, G.SELECTDELAY, function() {
                Ve = X($t, tt);
                for (var kr = Ve.slice(), _r = 0; _r < mr.length; _r++) {
                  for (var Cr = mr[_r], Yt = !1, Sr = 0; Sr < kr.length; Sr++) if (kr[Sr].curveNumber === Cr.curveNumber && kr[Sr].pointNumber === Cr.pointNumber) {
                    Yt = !0;
                    break;
                  }
                  Yt || kr.push(Cr);
                }
                kr.length && (he || (he = {}), he.points = kr), at(he, ar), gt(st, he);
              });
            }
          }, ge.clickFn = function(vt, kt) {
            if (Ee.remove(), st._fullLayout._activeShapeIndex >= 0) {
              st._fullLayout._deactivateShape(st);
              return;
            }
            if (!Qe) {
              var At = xt.clickmode;
              B.done(Ge).then(function() {
                if (B.clear(Ge), vt === 2) {
                  for (fe.remove(), Kt = 0; Kt < tt.length; Kt++) hr = tt[Kt], hr._module.selectPoints(hr, !1);
                  if (Ce(st, tt), w(ge), _t(st), tt.length) {
                    var Nt = tt[0].xaxis, Mt = tt[0].yaxis;
                    if (Nt && Mt) {
                      for (var Pt = [], Lt = st._fullLayout.selections, ur = 0; ur < Lt.length; ur++) {
                        var Ht = Lt[ur];
                        Ht && (Ht.xref !== Nt._id || Ht.yref !== Mt._id) && Pt.push(Ht);
                      }
                      Pt.length < Lt.length && (st._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", st, { selections: Pt }));
                    }
                  }
                } else At.indexOf("select") > -1 && ae(kt, st, ge.xaxes, ge.yaxes, ge.subplot, ge, fe), At === "event" && ht(st, void 0);
                r.click(st, kt, jt.id);
              }).catch(I.error);
            }
          }, ge.doneFn = function() {
            Ee.remove(), B.done(Ge).then(function() {
              B.clear(Ge), !Et && St && ge.selectionDefs && (St.subtract = cr, ge.selectionDefs.push(St), ge.mergedPolygons.length = 0, [].push.apply(ge.mergedPolygons, sr)), (Et || Qe) && w(ge, Et), ge.doneFnCompleted && ge.doneFnCompleted(Ve), Xe && ht(st, he);
            }).catch(I.error);
          };
        }
        function ae(Te, Ie, ce, ge, ye, Me, Oe) {
          var je = Ie._hoverdata, qe = Ie._fullLayout, Qe = qe.clickmode, Xe = Qe.indexOf("event") > -1, Je = [], ot, lt, st, xt, Et, Bt, qt, jt, It, Tt;
          if (le(je)) {
            $(Te, Ie, Me), ot = W(Ie, ce, ge, ye);
            var Rt = ie(je, ot), Vt = Rt.pointNumbers.length > 0;
            if (Vt ? _e(ot, Rt) : Ae(ot) && (qt = pe(Rt))) {
              for (Oe && Oe.remove(), Tt = 0; Tt < ot.length; Tt++) lt = ot[Tt], lt._module.selectPoints(lt, !1);
              Ce(Ie, ot), w(Me), Xe && _t(Ie);
            } else {
              jt = Te.shiftKey && (qt !== void 0 ? qt : pe(Rt)), st = se(Rt.pointNumber, Rt.searchInfo, jt);
              var Ft = Me.selectionDefs.concat([st]);
              for (xt = S(Ft), Tt = 0; Tt < ot.length; Tt++) if (Et = ot[Tt]._module.selectPoints(ot[Tt], xt), Bt = ke(Et, ot[Tt]), Je.length) for (var Dt = 0; Dt < Bt.length; Dt++) Je.push(Bt[Dt]);
              else Je = Bt;
              if (It = { points: Je }, Ce(Ie, ot, It), st && Me && Me.selectionDefs.push(st), Oe) {
                var Ct = Me.mergedPolygons, Ot = f(Me.dragmode);
                h(A(Ct, Ot), Oe, Me);
              }
              Xe && ht(Ie, It);
            }
          }
        }
        function se(Te, Ie, ce) {
          return { pointNumber: Te, searchInfo: Ie, subtract: !!ce };
        }
        function O(Te) {
          return "pointNumber" in Te && "searchInfo" in Te;
        }
        function F(Te) {
          return { xmin: 0, xmax: 0, ymin: 0, ymax: 0, pts: [], contains: function(Ie, ce, ge, ye) {
            var Me = Te.searchInfo.cd[0].trace.index, Oe = ye.cd[0].trace.index;
            return Oe === Me && ge === Te.pointNumber;
          }, isRect: !1, degenerate: !1, subtract: !!Te.subtract };
        }
        function S(Te) {
          if (!Te.length) return;
          for (var Ie = [], ce = O(Te[0]) ? 0 : Te[0][0][0], ge = ce, ye = O(Te[0]) ? 0 : Te[0][0][1], Me = ye, Oe = 0; Oe < Te.length; Oe++) if (O(Te[Oe])) Ie.push(F(Te[Oe]));
          else {
            var je = V(Te[Oe]);
            je.subtract = !!Te[Oe].subtract, Ie.push(je), ce = Math.min(ce, je.xmin), ge = Math.max(ge, je.xmax), ye = Math.min(ye, je.ymin), Me = Math.max(Me, je.ymax);
          }
          function qe(Qe, Xe, Je, ot) {
            for (var lt = !1, st = 0; st < Ie.length; st++) Ie[st].contains(Qe, Xe, Je, ot) && (lt = !Ie[st].subtract);
            return lt;
          }
          return { xmin: ce, xmax: ge, ymin: ye, ymax: Me, pts: [], contains: qe, isRect: !1, degenerate: !1 };
        }
        function $(Te, Ie, ce) {
          var ge = Ie._fullLayout, ye = ce.plotinfo, Me = ce.dragmode, Oe = ge._lastSelectedSubplot && ge._lastSelectedSubplot === ye.id, je = (Te.shiftKey || Te.altKey) && !(l(Me) && f(Me));
          Oe && je && ye.selection && ye.selection.selectionDefs && !ce.selectionDefs ? (ce.selectionDefs = ye.selection.selectionDefs, ce.mergedPolygons = ye.selection.mergedPolygons) : (!je || !ye.selection) && w(ce), Oe || (m(Ie), ge._lastSelectedSubplot = ye.id);
        }
        function re(Te) {
          return Te._fullLayout._activeShapeIndex >= 0;
        }
        function E(Te) {
          return Te._fullLayout._activeSelectionIndex >= 0;
        }
        function w(Te, Ie) {
          var ce = Te.dragmode, ge = Te.plotinfo, ye = Te.gd;
          re(ye) && ye._fullLayout._deactivateShape(ye), E(ye) && ye._fullLayout._deactivateSelection(ye);
          var Me = ye._fullLayout, Oe = Me._zoomlayer, je = l(ce), qe = v(ce);
          if (je || qe) {
            var Qe = Oe.selectAll(".select-outline-" + ge.id);
            if (Qe && ye._fullLayout._outlining) {
              var Xe;
              je && (Xe = _(Qe, Te)), Xe && a.call("_guiRelayout", ye, { shapes: Xe });
              var Je;
              qe && !J(Te) && (Je = T(Qe, Te)), Je && (ye._fullLayout._noEmitSelectedAtStart = !0, a.call("_guiRelayout", ye, { selections: Je }).then(function() {
                Ie && R(ye);
              })), ye._fullLayout._outlining = !1;
            }
          }
          ge.selection = {}, ge.selection.selectionDefs = Te.selectionDefs = [], ge.selection.mergedPolygons = Te.mergedPolygons = [];
        }
        function N(Te) {
          return Te._id;
        }
        function W(Te, Ie, ce, ge) {
          if (!Te.calcdata) return [];
          var ye = [], Me = Ie.map(N), Oe = ce.map(N), je, qe, Qe;
          for (Qe = 0; Qe < Te.calcdata.length; Qe++) if (je = Te.calcdata[Qe], qe = je[0].trace, !(qe.visible !== !0 || !qe._module || !qe._module.selectPoints)) if (J({ subplot: ge }) && (qe.subplot === ge || qe.geo === ge)) ye.push(ee(qe._module, je, Ie[0], ce[0]));
          else if (qe.type === "splom") {
            if (qe._xaxes[Me[0]] && qe._yaxes[Oe[0]]) {
              var Xe = ee(qe._module, je, Ie[0], ce[0]);
              Xe.scene = Te._fullLayout._splomScenes[qe.uid], ye.push(Xe);
            }
          } else if (qe.type === "sankey") {
            var Je = ee(qe._module, je, Ie[0], ce[0]);
            ye.push(Je);
          } else {
            if (Me.indexOf(qe.xaxis) === -1 && (!qe._xA || !qe._xA.overlaying) || Oe.indexOf(qe.yaxis) === -1 && (!qe._yA || !qe._yA.overlaying)) continue;
            ye.push(ee(qe._module, je, z(Te, qe.xaxis), z(Te, qe.yaxis)));
          }
          return ye;
        }
        function ee(Te, Ie, ce, ge) {
          return { _module: Te, cd: Ie, xaxis: ce, yaxis: ge };
        }
        function le(Te) {
          return Te && Array.isArray(Te) && Te[0].hoverOnBox !== !0;
        }
        function ie(Te, Ie) {
          var ce = Te[0], ge = -1, ye = [], Me, Oe;
          for (Oe = 0; Oe < Ie.length; Oe++) if (Me = Ie[Oe], ce.fullData.index === Me.cd[0].trace.index) {
            if (ce.hoverOnBox === !0) break;
            ce.pointNumber !== void 0 ? ge = ce.pointNumber : ce.binNumber !== void 0 && (ge = ce.binNumber, ye = ce.pointNumbers);
            break;
          }
          return { pointNumber: ge, pointNumbers: ye, searchInfo: Me };
        }
        function pe(Te) {
          var Ie = Te.searchInfo.cd[0].trace, ce = Te.pointNumber, ge = Te.pointNumbers, ye = ge.length > 0, Me = ye ? ge[0] : ce;
          return Ie.selectedpoints ? Ie.selectedpoints.indexOf(Me) > -1 : !1;
        }
        function _e(Te, Ie) {
          var ce = [], ge, ye, Me, Oe;
          for (Oe = 0; Oe < Te.length; Oe++) ge = Te[Oe], ge.cd[0].trace.selectedpoints && ge.cd[0].trace.selectedpoints.length > 0 && ce.push(ge);
          if (ce.length === 1 && (Me = ce[0] === Ie.searchInfo, Me && (ye = Ie.searchInfo.cd[0].trace, ye.selectedpoints.length === Ie.pointNumbers.length))) {
            for (Oe = 0; Oe < Ie.pointNumbers.length; Oe++) if (ye.selectedpoints.indexOf(Ie.pointNumbers[Oe]) < 0) return !1;
            return !0;
          }
          return !1;
        }
        function Ae(Te) {
          var Ie = 0, ce, ge, ye;
          for (ye = 0; ye < Te.length; ye++) if (ce = Te[ye], ge = ce.cd[0].trace, ge.selectedpoints && (ge.selectedpoints.length > 1 || (Ie += ge.selectedpoints.length, Ie > 1))) return !1;
          return Ie === 1;
        }
        function Ce(Te, Ie, ce) {
          var ge;
          for (ge = 0; ge < Ie.length; ge++) {
            var ye = Ie[ge].cd[0].trace._fullInput, Me = Te._fullLayout._tracePreGUI[ye.uid] || {};
            Me.selectedpoints === void 0 && (Me.selectedpoints = ye._input.selectedpoints || null);
          }
          var Oe;
          if (ce) {
            var je = ce.points || [];
            for (ge = 0; ge < Ie.length; ge++) Oe = Ie[ge].cd[0].trace, Oe._input.selectedpoints = Oe._fullInput.selectedpoints = [], Oe._fullInput !== Oe && (Oe.selectedpoints = []);
            for (var qe = 0; qe < je.length; qe++) {
              var Qe = je[qe], Xe = Qe.data, Je = Qe.fullData, ot = Qe.pointIndex, lt = Qe.pointIndices;
              lt ? ([].push.apply(Xe.selectedpoints, lt), Oe._fullInput !== Oe && [].push.apply(Je.selectedpoints, lt)) : (Xe.selectedpoints.push(ot), Oe._fullInput !== Oe && Je.selectedpoints.push(ot));
            }
          } else for (ge = 0; ge < Ie.length; ge++) Oe = Ie[ge].cd[0].trace, delete Oe.selectedpoints, delete Oe._input.selectedpoints, Oe._fullInput !== Oe && delete Oe._fullInput.selectedpoints;
          Ue(Te, Ie);
        }
        function Ue(Te, Ie) {
          for (var ce = !1, ge = 0; ge < Ie.length; ge++) {
            var ye = Ie[ge], Me = ye.cd;
            a.traceIs(Me[0].trace, "regl") && (ce = !0);
            var Oe = ye._module, je = Oe.styleOnSelect || Oe.style;
            je && (je(Te, Me, Me[0].node3), Me[0].nodeRangePlot3 && je(Te, Me, Me[0].nodeRangePlot3));
          }
          ce && (q(Te), U(Te));
        }
        function Ne(Te, Ie, ce) {
          for (var ge = ce ? n.difference : n.union, ye = ge({ regions: Te }, { regions: [Ie] }), Me = ye.regions.reverse(), Oe = 0; Oe < Me.length; Oe++) {
            var je = Me[Oe];
            je.subtract = Ze(je, Me.slice(0, Oe));
          }
          return Me;
        }
        function ke(Te, Ie) {
          if (Array.isArray(Te)) for (var ce = Ie.cd, ge = Ie.cd[0].trace, ye = 0; ye < Te.length; ye++) Te[ye] = s(Te[ye], ge, ce);
          return Te;
        }
        function A(Te, Ie) {
          for (var ce = [], ge = 0; ge < Te.length; ge++) {
            ce[ge] = [];
            for (var ye = 0; ye < Te[ge].length; ye++) {
              ce[ge][ye] = [], ce[ge][ye][0] = ye ? "L" : "M";
              for (var Me = 0; Me < Te[ge][ye].length; Me++) ce[ge][ye].push(Te[ge][ye][Me]);
            }
            Ie || ce[ge].push(["Z", ce[ge][0][1], ce[ge][0][2]]);
          }
          return ce;
        }
        function X(Te, Ie) {
          for (var ce = [], ge, ye = [], Me, Oe = 0; Oe < Ie.length; Oe++) {
            var je = Ie[Oe];
            Me = je._module.selectPoints(je, Te), ye.push(Me), ge = ke(Me, je), ce = ce.concat(ge);
          }
          return ce;
        }
        function H(Te, Ie, ce, ge, ye) {
          var Me = !!ge, Oe, je, qe;
          ye && (Oe = ye.plotinfo, je = ye.xaxes[0]._id, qe = ye.yaxes[0]._id);
          var Qe = [], Xe = [], Je = He(Te), ot = Te._fullLayout;
          if (Oe) {
            var lt = ot._zoomlayer, st = ot.dragmode, xt = l(st), Et = v(st);
            if (xt || Et) {
              var Bt = z(Te, je, "x"), qt = z(Te, qe, "y");
              if (Bt && qt) {
                var jt = lt.selectAll(".select-outline-" + Oe.id);
                if (jt && Te._fullLayout._outlining && jt.length) {
                  for (var It = jt[0][0], Tt = It.getAttribute("d"), Rt = y(Tt, Te, Oe), Vt = [], Ft = 0; Ft < Rt.length; Ft++) {
                    for (var Dt = Rt[Ft], Ct = [], Ot = 0; Ot < Dt.length; Ot++) Ct.push([We(Bt, Dt[Ot][1]), We(qt, Dt[Ot][2])]);
                    Ct.xref = je, Ct.yref = qe, Ct.subtract = Ze(Ct, Vt), Vt.push(Ct);
                  }
                  Je = Je.concat(Vt);
                }
              }
            }
          }
          var Wt = je && qe ? [je + qe] : ot._subplots.cartesian;
          ve(Te);
          for (var rr = {}, Ut = 0; Ut < Wt.length; Ut++) {
            var Qt = Wt[Ut], nr = Qt.indexOf("y"), cr = Qt.slice(0, nr), lr = Qt.slice(nr), $t = je && qe ? ce : void 0;
            if ($t = De(Je, cr, lr, $t), $t) {
              var sr = ge;
              if (!Me) {
                var St = z(Te, cr, "x"), Kt = z(Te, lr, "y");
                sr = W(Te, [St], [Kt], Qt);
                for (var hr = 0; hr < sr.length; hr++) {
                  var he = sr[hr], fe = he.cd[0], Pe = fe.trace;
                  if (he._module.name === "scattergl" && !fe.t.xpx) {
                    var Re = Pe.x, Ye = Pe.y, Ee = Pe._length;
                    fe.t.xpx = [], fe.t.ypx = [];
                    for (var ze = 0; ze < Ee; ze++) fe.t.xpx[ze] = St.c2p(Re[ze]), fe.t.ypx[ze] = Kt.c2p(Ye[ze]);
                  }
                  he._module.name === "splom" && (rr[Pe.uid] || (rr[Pe.uid] = !0));
                }
              }
              var Ge = X($t, sr);
              Qe = Qe.concat(Ge), Xe = Xe.concat(sr);
            }
          }
          var Ve = { points: Qe };
          Ce(Te, Xe, Ve);
          var tt = ot.clickmode, at = tt.indexOf("event") > -1 && Ie;
          if (!Oe && Ie) {
            var vt = He(Te, !0);
            if (vt.length) {
              var kt = vt[0].xref, At = vt[0].yref;
              if (kt && At) {
                var Nt = $e(vt), Mt = Ke([z(Te, kt, "x"), z(Te, At, "y")]);
                Mt(Ve, Nt);
              }
            }
            Te._fullLayout._noEmitSelectedAtStart ? Te._fullLayout._noEmitSelectedAtStart = !1 : at && ht(Te, Ve), ot._reselect = !1;
          }
          if (!Oe && ot._deselect) {
            var Pt = ot._deselect;
            je = Pt.xref, qe = Pt.yref, be(je, qe, Xe) || Se(Te, je, qe, ge), at && (Ve.points.length ? ht(Te, Ve) : _t(Te)), ot._deselect = !1;
          }
          return { eventData: Ve, selectionTesters: ce };
        }
        function ve(Te) {
          var Ie = Te.calcdata;
          if (Ie) for (var ce = 0; ce < Ie.length; ce++) {
            var ge = Ie[ce][0], ye = ge.trace, Me = Te._fullLayout._splomScenes;
            if (Me) {
              var Oe = Me[ye.uid];
              Oe && (Oe.selectBatch = []);
            }
          }
        }
        function be(Te, Ie, ce) {
          for (var ge = 0; ge < ce.length; ge++) {
            var ye = ce[ge];
            if (ye.xaxis && ye.xaxis._id === Te && ye.yaxis && ye.yaxis._id === Ie) return !0;
          }
          return !1;
        }
        function Se(Te, Ie, ce, ge) {
          ge = W(Te, [z(Te, Ie, "x")], [z(Te, ce, "y")], Ie + ce);
          for (var ye = 0; ye < ge.length; ye++) {
            var Me = ge[ye];
            Me._module.selectPoints(Me, !1);
          }
          Ce(Te, ge);
        }
        function De(Te, Ie, ce, ge) {
          for (var ye, Me = 0; Me < Te.length; Me++) {
            var Oe = Te[Me];
            if (!(Ie !== Oe.xref || ce !== Oe.yref)) if (ye) {
              var je = !!Oe.subtract;
              ye = Ne(ye, Oe, je), ge = S(ye);
            } else ye = [Oe], ge = V(Oe);
          }
          return ge;
        }
        function He(Te, Ie) {
          for (var ce = [], ge = Te._fullLayout, ye = ge.selections, Me = ye.length, Oe = 0; Oe < Me; Oe++) if (!(Ie && Oe !== ge._activeSelectionIndex)) {
            var je = ye[Oe];
            if (je) {
              var qe = je.xref, Qe = je.yref, Xe = z(Te, qe, "x"), Je = z(Te, Qe, "y"), ot, lt, st, xt, Et;
              if (je.type === "rect") {
                Et = [];
                var Bt = We(Xe, je.x0), qt = We(Xe, je.x1), jt = We(Je, je.y0), It = We(Je, je.y1);
                Et = [[Bt, jt], [Bt, It], [qt, It], [qt, jt]], ot = Math.min(Bt, qt), lt = Math.max(Bt, qt), st = Math.min(jt, It), xt = Math.max(jt, It), Et.xmin = ot, Et.xmax = lt, Et.ymin = st, Et.ymax = xt, Et.xref = qe, Et.yref = Qe, Et.subtract = !1, Et.isRect = !0, ce.push(Et);
              } else if (je.type === "path") for (var Tt = je.path.split("Z"), Rt = [], Vt = 0; Vt < Tt.length; Vt++) {
                var Ft = Tt[Vt];
                if (Ft) {
                  Ft += "Z";
                  var Dt = g.extractPathCoords(Ft, x.paramIsX, "raw"), Ct = g.extractPathCoords(Ft, x.paramIsY, "raw");
                  ot = 1 / 0, lt = -1 / 0, st = 1 / 0, xt = -1 / 0, Et = [];
                  for (var Ot = 0; Ot < Dt.length; Ot++) {
                    var Wt = We(Xe, Dt[Ot]), rr = We(Je, Ct[Ot]);
                    Et.push([Wt, rr]), ot = Math.min(Wt, ot), lt = Math.max(Wt, lt), st = Math.min(rr, st), xt = Math.max(rr, xt);
                  }
                  Et.xmin = ot, Et.xmax = lt, Et.ymin = st, Et.ymax = xt, Et.xref = qe, Et.yref = Qe, Et.subtract = Ze(Et, Rt), Rt.push(Et), ce.push(Et);
                }
              }
            }
          }
          return ce;
        }
        function Ze(Te, Ie) {
          for (var ce = !1, ge = 0; ge < Ie.length; ge++) for (var ye = Ie[ge], Me = 0; Me < Te.length; Me++) if (e(Te[Me], ye)) {
            ce = !ce;
            break;
          }
          return ce;
        }
        function We(Te, Ie) {
          return Te.type === "date" && (Ie = Ie.replace("_", " ")), Te.type === "log" ? Te.c2p(Ie) : Te.r2p(Ie, null, Te.calendar);
        }
        function $e(Te) {
          for (var Ie = Te.length, ce = [], ge = 0; ge < Ie; ge++) {
            var ye = Te[ge];
            ce = ce.concat(ye), ce = ce.concat([ye[0]]);
          }
          return it(ce);
        }
        function it(Te) {
          return Te.isRect = Te.length === 5 && Te[0][0] === Te[4][0] && Te[0][1] === Te[4][1] && Te[0][0] === Te[1][0] && Te[2][0] === Te[3][0] && Te[0][1] === Te[3][1] && Te[1][1] === Te[2][1] || Te[0][1] === Te[1][1] && Te[2][1] === Te[3][1] && Te[0][0] === Te[3][0] && Te[1][0] === Te[2][0], Te.isRect && (Te.xmin = Math.min(Te[0][0], Te[2][0]), Te.xmax = Math.max(Te[0][0], Te[2][0]), Te.ymin = Math.min(Te[0][1], Te[2][1]), Te.ymax = Math.max(Te[0][1], Te[2][1])), Te;
        }
        function Ke(Te) {
          return function(Ie, ce) {
            for (var ge, ye, Me = 0; Me < Te.length; Me++) {
              var Oe = Te[Me], je = Oe._id, qe = je.charAt(0);
              if (ce.isRect) {
                ge || (ge = {});
                var Qe = ce[qe + "min"], Xe = ce[qe + "max"];
                Qe !== void 0 && Xe !== void 0 && (ge[je] = [Y(Oe, Qe), Y(Oe, Xe)].sort(P));
              } else ye || (ye = {}), ye[je] = ce.map(C(Oe));
            }
            ge && (Ie.range = ge), ye && (Ie.lassoPoints = ye);
          };
        }
        function ct(Te) {
          var Ie = Te.plotinfo;
          return Ie.fillRangeItems || Ke(Te.xaxes.concat(Te.yaxes));
        }
        function gt(Te, Ie) {
          Te.emit("plotly_selecting", Ie);
        }
        function ht(Te, Ie) {
          Ie && (Ie.selections = (Te.layout || {}).selections || []), Te.emit("plotly_selected", Ie);
        }
        function _t(Te) {
          Te.emit("plotly_deselect", null);
        }
        k.exports = { reselect: H, prepSelect: ne, clearOutline: m, clearSelectionsCache: w, selectOnClick: ae };
      }), As = xe((L, k) => {
        k.exports = [{ path: "", backoff: 0 }, { path: "M-2.4,-3V3L0.6,0Z", backoff: 0.6 }, { path: "M-3.7,-2.5V2.5L1.3,0Z", backoff: 1.3 }, { path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z", backoff: 1.55 }, { path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z", backoff: 1.6 }, { path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z", backoff: 2 }, { path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z", backoff: 0, noRotate: !0 }, { path: "M2,2V-2H-2V2Z", backoff: 0, noRotate: !0 }];
      }), Ai = xe((L, k) => {
        k.exports = { axisRefDescription: function(n, e, a) {
          return ["If set to a", n, "axis id (e.g. *" + n + "* or", "*" + n + "2*), the `" + n + "` position refers to a", n, "coordinate. If set to *paper*, the `" + n + "`", "position refers to the distance from the", e, "of the plotting", "area in normalized coordinates where *0* (*1*) corresponds to the", e, "(" + a + "). If set to a", n, "axis ID followed by", "*domain* (separated by a space), the position behaves like for", "*paper*, but refers to the distance in fractions of the domain", "length from the", e, "of the domain of that axis: e.g.,", "*" + n + "2 domain* refers to the domain of the second", n, " axis and a", n, "position of 0.5 refers to the", "point between the", e, "and the", a, "of the domain of the", "second", n, "axis."].join(" ");
        } };
      }), ni = xe((L, k) => {
        var n = As(), e = hn(), a = mn(), i = qr().templatedArray;
        Ai(), k.exports = i("annotation", { visible: { valType: "boolean", dflt: !0, editType: "calc+arraydraw" }, text: { valType: "string", editType: "calc+arraydraw" }, textangle: { valType: "angle", dflt: 0, editType: "calc+arraydraw" }, font: e({ editType: "calc+arraydraw", colorEditType: "arraydraw" }), width: { valType: "number", min: 1, dflt: null, editType: "calc+arraydraw" }, height: { valType: "number", min: 1, dflt: null, editType: "calc+arraydraw" }, opacity: { valType: "number", min: 0, max: 1, dflt: 1, editType: "arraydraw" }, align: { valType: "enumerated", values: ["left", "center", "right"], dflt: "center", editType: "arraydraw" }, valign: { valType: "enumerated", values: ["top", "middle", "bottom"], dflt: "middle", editType: "arraydraw" }, bgcolor: { valType: "color", dflt: "rgba(0,0,0,0)", editType: "arraydraw" }, bordercolor: { valType: "color", dflt: "rgba(0,0,0,0)", editType: "arraydraw" }, borderpad: { valType: "number", min: 0, dflt: 1, editType: "calc+arraydraw" }, borderwidth: { valType: "number", min: 0, dflt: 1, editType: "calc+arraydraw" }, showarrow: { valType: "boolean", dflt: !0, editType: "calc+arraydraw" }, arrowcolor: { valType: "color", editType: "arraydraw" }, arrowhead: { valType: "integer", min: 0, max: n.length, dflt: 1, editType: "arraydraw" }, startarrowhead: { valType: "integer", min: 0, max: n.length, dflt: 1, editType: "arraydraw" }, arrowside: { valType: "flaglist", flags: ["end", "start"], extras: ["none"], dflt: "end", editType: "arraydraw" }, arrowsize: { valType: "number", min: 0.3, dflt: 1, editType: "calc+arraydraw" }, startarrowsize: { valType: "number", min: 0.3, dflt: 1, editType: "calc+arraydraw" }, arrowwidth: { valType: "number", min: 0.1, editType: "calc+arraydraw" }, standoff: { valType: "number", min: 0, dflt: 0, editType: "calc+arraydraw" }, startstandoff: { valType: "number", min: 0, dflt: 0, editType: "calc+arraydraw" }, ax: { valType: "any", editType: "calc+arraydraw" }, ay: { valType: "any", editType: "calc+arraydraw" }, axref: { valType: "enumerated", dflt: "pixel", values: ["pixel", a.idRegex.x.toString()], editType: "calc" }, ayref: { valType: "enumerated", dflt: "pixel", values: ["pixel", a.idRegex.y.toString()], editType: "calc" }, xref: { valType: "enumerated", values: ["paper", a.idRegex.x.toString()], editType: "calc" }, x: { valType: "any", editType: "calc+arraydraw" }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "auto", editType: "calc+arraydraw" }, xshift: { valType: "number", dflt: 0, editType: "calc+arraydraw" }, yref: { valType: "enumerated", values: ["paper", a.idRegex.y.toString()], editType: "calc" }, y: { valType: "any", editType: "calc+arraydraw" }, yanchor: { valType: "enumerated", values: ["auto", "top", "middle", "bottom"], dflt: "auto", editType: "calc+arraydraw" }, yshift: { valType: "number", dflt: 0, editType: "calc+arraydraw" }, clicktoshow: { valType: "enumerated", values: [!1, "onoff", "onout"], dflt: !1, editType: "arraydraw" }, xclick: { valType: "any", editType: "arraydraw" }, yclick: { valType: "any", editType: "arraydraw" }, hovertext: { valType: "string", editType: "arraydraw" }, hoverlabel: { bgcolor: { valType: "color", editType: "arraydraw" }, bordercolor: { valType: "color", editType: "arraydraw" }, font: e({ editType: "arraydraw" }), editType: "arraydraw" }, captureevents: { valType: "boolean", editType: "arraydraw" }, editType: "calc" });
      }), Si = xe((L, k) => {
        k.exports = { PTS_LINESONLY: 20, minTolerance: 0.2, toleranceGrowth: 10, maxScreensAway: 20, eventDataKeys: [] };
      }), zo = xe((L, k) => {
        k.exports = function(n) {
          return { valType: "color", editType: "style", anim: !0 };
        };
      }), $n = xe((L, k) => {
        var n = na().axisHoverFormat, { hovertemplateAttrs: e, texttemplateAttrs: a, templatefallbackAttrs: i } = qn(), o = ca(), r = hn(), s = Wn().dash, c = Wn().pattern, t = Or(), p = Si(), l = Br().extendFlat, f = zo();
        function v(h) {
          return { valType: "any", dflt: 0, editType: "calc" };
        }
        function g(h) {
          return { valType: "any", editType: "calc" };
        }
        function x(h) {
          return { valType: "enumerated", values: ["start", "middle", "end"], dflt: "middle", editType: "calc" };
        }
        k.exports = { x: { valType: "data_array", editType: "calc+clearAxisTypes", anim: !0 }, x0: { valType: "any", dflt: 0, editType: "calc+clearAxisTypes", anim: !0 }, dx: { valType: "number", dflt: 1, editType: "calc", anim: !0 }, y: { valType: "data_array", editType: "calc+clearAxisTypes", anim: !0 }, y0: { valType: "any", dflt: 0, editType: "calc+clearAxisTypes", anim: !0 }, dy: { valType: "number", dflt: 1, editType: "calc", anim: !0 }, xperiod: v(), yperiod: v(), xperiod0: g(), yperiod0: g(), xperiodalignment: x(), yperiodalignment: x(), xhoverformat: n("x"), yhoverformat: n("y"), offsetgroup: { valType: "string", dflt: "", editType: "calc" }, alignmentgroup: { valType: "string", dflt: "", editType: "calc" }, stackgroup: { valType: "string", dflt: "", editType: "calc" }, orientation: { valType: "enumerated", values: ["v", "h"], editType: "calc" }, groupnorm: { valType: "enumerated", values: ["", "fraction", "percent"], dflt: "", editType: "calc" }, stackgaps: { valType: "enumerated", values: ["infer zero", "interpolate"], dflt: "infer zero", editType: "calc" }, text: { valType: "string", dflt: "", arrayOk: !0, editType: "calc" }, texttemplate: a(), texttemplatefallback: i({ editType: "calc" }), hovertext: { valType: "string", dflt: "", arrayOk: !0, editType: "style" }, mode: { valType: "flaglist", flags: ["lines", "markers", "text"], extras: ["none"], editType: "calc" }, hoveron: { valType: "flaglist", flags: ["points", "fills"], editType: "style" }, hovertemplate: e({}, { keys: p.eventDataKeys }), hovertemplatefallback: i(), line: { color: { valType: "color", editType: "style", anim: !0 }, width: { valType: "number", min: 0, dflt: 2, editType: "style", anim: !0 }, shape: { valType: "enumerated", values: ["linear", "spline", "hv", "vh", "hvh", "vhv"], dflt: "linear", editType: "plot" }, smoothing: { valType: "number", min: 0, max: 1.3, dflt: 1, editType: "plot" }, dash: l({}, s, { editType: "style" }), backoff: { valType: "number", min: 0, dflt: "auto", arrayOk: !0, editType: "plot" }, simplify: { valType: "boolean", dflt: !0, editType: "plot" }, editType: "plot" }, connectgaps: { valType: "boolean", dflt: !1, editType: "calc" }, cliponaxis: { valType: "boolean", dflt: !0, editType: "plot" }, fill: { valType: "enumerated", values: ["none", "tozeroy", "tozerox", "tonexty", "tonextx", "toself", "tonext"], editType: "calc" }, fillcolor: f(!0), fillgradient: l({ type: { valType: "enumerated", values: ["radial", "horizontal", "vertical", "none"], dflt: "none", editType: "calc" }, start: { valType: "number", editType: "calc" }, stop: { valType: "number", editType: "calc" }, colorscale: { valType: "colorscale", editType: "style" }, editType: "calc" }), fillpattern: c, marker: l({ symbol: { valType: "enumerated", values: t.symbolList, dflt: "circle", arrayOk: !0, editType: "style" }, opacity: { valType: "number", min: 0, max: 1, arrayOk: !0, editType: "style", anim: !0 }, angle: { valType: "angle", dflt: 0, arrayOk: !0, editType: "plot", anim: !1 }, angleref: { valType: "enumerated", values: ["previous", "up"], dflt: "up", editType: "plot", anim: !1 }, standoff: { valType: "number", min: 0, dflt: 0, arrayOk: !0, editType: "plot", anim: !0 }, size: { valType: "number", min: 0, dflt: 6, arrayOk: !0, editType: "calc", anim: !0 }, maxdisplayed: { valType: "number", min: 0, dflt: 0, editType: "plot" }, sizeref: { valType: "number", dflt: 1, editType: "calc" }, sizemin: { valType: "number", min: 0, dflt: 0, editType: "calc" }, sizemode: { valType: "enumerated", values: ["diameter", "area"], dflt: "diameter", editType: "calc" }, line: l({ width: { valType: "number", min: 0, arrayOk: !0, editType: "style", anim: !0 }, editType: "calc" }, o("marker.line", { anim: !0 })), gradient: { type: { valType: "enumerated", values: ["radial", "horizontal", "vertical", "none"], arrayOk: !0, dflt: "none", editType: "calc" }, color: { valType: "color", arrayOk: !0, editType: "calc" }, editType: "calc" }, editType: "calc" }, o("marker", { anim: !0 })), selected: { marker: { opacity: { valType: "number", min: 0, max: 1, editType: "style" }, color: { valType: "color", editType: "style" }, size: { valType: "number", min: 0, editType: "style" }, editType: "style" }, textfont: { color: { valType: "color", editType: "style" }, editType: "style" }, editType: "style" }, unselected: { marker: { opacity: { valType: "number", min: 0, max: 1, editType: "style" }, color: { valType: "color", editType: "style" }, size: { valType: "number", min: 0, editType: "style" }, editType: "style" }, textfont: { color: { valType: "color", editType: "style" }, editType: "style" }, editType: "style" }, textposition: { valType: "enumerated", values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right"], dflt: "middle center", arrayOk: !0, editType: "calc" }, textfont: r({ editType: "calc", colorEditType: "style", arrayOk: !0 }), zorder: { valType: "integer", dflt: 0, editType: "plot" } };
      }), Ss = xe((L, k) => {
        var n = ni(), e = $n().line, a = Wn().dash, i = Br().extendFlat, o = ra().overrideAll, r = qr().templatedArray;
        Ai(), k.exports = o(r("selection", { type: { valType: "enumerated", values: ["rect", "path"] }, xref: i({}, n.xref, {}), yref: i({}, n.yref, {}), x0: { valType: "any" }, x1: { valType: "any" }, y0: { valType: "any" }, y1: { valType: "any" }, path: { valType: "string", editType: "arraydraw" }, opacity: { valType: "number", min: 0, max: 1, dflt: 0.7, editType: "arraydraw" }, line: { color: e.color, width: i({}, e.width, { min: 1, dflt: 1 }), dash: i({}, a, { dflt: "dot" }) } }), "arraydraw", "from-root");
      }), $d = xe((L, k) => {
        var n = wt(), e = Ar(), a = aa(), i = Ss(), o = La();
        k.exports = function(s, c) {
          a(s, c, { name: "selections", handleItemDefaults: r });
          for (var t = c.selections, p = 0; p < t.length; p++) {
            var l = t[p];
            l && l.path === void 0 && (l.x0 === void 0 || l.x1 === void 0 || l.y0 === void 0 || l.y1 === void 0) && (c.selections[p] = null);
          }
        };
        function r(s, c, t) {
          function p(q, U) {
            return n.coerce(s, c, i, q, U);
          }
          var l = p("path"), f = l ? "path" : "rect", v = p("type", f), g = v !== "path";
          g && delete c.path, p("opacity"), p("line.color"), p("line.width"), p("line.dash");
          for (var x = ["x", "y"], h = 0; h < 2; h++) {
            var m = x[h], u = { _fullLayout: t }, d, y, _, T = e.coerceRef(s, c, u, m);
            if (d = e.getFromId(u, T), d._selectionIndices.push(c._index), _ = o.rangeToShapePosition(d), y = o.shapePositionToRange(d), g) {
              var R = m + "0", I = m + "1", P = s[R], M = s[I];
              s[R] = y(s[R], !0), s[I] = y(s[I], !0), e.coercePosition(c, u, p, T, R), e.coercePosition(c, u, p, T, I);
              var B = c[R], z = c[I];
              B !== void 0 && z !== void 0 && (c[R] = _(B), c[I] = _(z), s[R] = P, s[I] = M);
            }
          }
          g && n.noneOrAll(s, c, ["x0", "x1", "y0", "y1"]);
        }
      }), Kd = xe((L, k) => {
        k.exports = function(n, e, a) {
          a("newselection.mode");
          var i = a("newselection.line.width");
          i && (a("newselection.line.color"), a("newselection.line.dash")), a("activeselection.fillcolor"), a("activeselection.opacity");
        };
      }), Li = xe((L, k) => {
        var n = or(), e = wt(), a = sn();
        k.exports = function(i) {
          return function(o, r) {
            var s = o[i];
            if (Array.isArray(s)) for (var c = n.subplotsRegistry.cartesian, t = c.idRegex, p = r._subplots, l = p.xaxis, f = p.yaxis, v = p.cartesian, g = r._has("cartesian"), x = 0; x < s.length; x++) {
              var h = s[x];
              if (e.isPlainObject(h)) {
                var m = a.cleanId(h.xref, "x", !1), u = a.cleanId(h.yref, "y", !1), d = t.x.test(m), y = t.y.test(u);
                if (d || y) {
                  g || e.pushUnique(r._basePlotModules, c);
                  var _ = !1;
                  d && l.indexOf(m) === -1 && (l.push(m), _ = !0), y && f.indexOf(u) === -1 && (f.push(u), _ = !0), _ && d && y && v.push(m + u);
                }
              }
            }
          };
        };
      }), pa = xe((L, k) => {
        var n = ks(), e = Jd();
        k.exports = { moduleType: "component", name: "selections", layoutAttributes: Ss(), supplyLayoutDefaults: $d(), supplyDrawNewSelectionDefaults: Kd(), includeBasePlot: Li()("selections"), draw: n.draw, drawOne: n.drawOne, reselect: e.reselect, prepSelect: e.prepSelect, clearOutline: e.clearOutline, clearSelectionsCache: e.clearSelectionsCache, selectOnClick: e.selectOnClick };
      }), Qd = xe((L, k) => {
        var n = vr(), e = wt(), a = e.numberFormat, i = Nn(), o = us(), r = or(), s = e.strTranslate, c = xn(), t = fr(), p = Or(), l = Bn(), f = Ar(), v = Aa(), g = Jn(), x = Na(), h = x.selectingOrDrawing, m = x.freeMode, u = kn().FROM_TL, d = So(), y = Io().redrawReglTraces, _ = on(), T = sn().getFromId, R = pa().prepSelect, I = pa().clearOutline, P = pa().selectOnClick, M = Ts(), B = mn(), z = B.MINDRAG, q = B.MINZOOM, U = !0;
        function G(ee, le, ie, pe, _e, Ae, Ce, Ue) {
          var Ne = ee._fullLayout._zoomlayer, ke = Ce + Ue === "nsew", A = (Ce + Ue).length === 1, X, H, ve, be, Se, De, He, Ze, We, $e, it, Ke, ct, gt, ht, _t, Te, Ie, ce, ge, ye, Me, Oe;
          ie += le.yaxis._shift;
          function je() {
            if (X = le.xaxis, H = le.yaxis, We = X._length, $e = H._length, He = X._offset, Ze = H._offset, ve = {}, ve[X._id] = X, be = {}, be[H._id] = H, Ce && Ue) for (var fe = le.overlays, Pe = 0; Pe < fe.length; Pe++) {
              var Re = fe[Pe].xaxis;
              ve[Re._id] = Re;
              var Ye = fe[Pe].yaxis;
              be[Ye._id] = Ye;
            }
            Se = W(ve), De = W(be), ct = V(Se, Ue), gt = V(De, Ce), ht = !gt && !ct, Ke = w(ee, ee._fullLayout._axisMatchGroups, ve, be), it = w(ee, ee._fullLayout._axisConstraintGroups, ve, be, Ke);
            var Ee = it.isSubplotConstrained || Ke.isSubplotConstrained;
            _t = Ue || Ee, Te = Ce || Ee;
            var ze = ee._fullLayout;
            Ie = ze._has("scattergl"), ce = ze._has("splom"), ge = ze._has("svg");
          }
          je();
          var qe = J(gt + ct, ee._fullLayout.dragmode, ke), Qe = te(le, Ce + Ue + "drag", qe, ie, pe, _e, Ae);
          if (ht && !ke) return Qe.onmousedown = null, Qe.style.pointerEvents = "none", Qe;
          var Xe = { element: Qe, gd: ee, plotinfo: le };
          Xe.prepFn = function(fe, Pe, Re) {
            var Ye = Xe.dragmode, Ee = ee._fullLayout.dragmode;
            Ee !== Ye && (Xe.dragmode = Ee), je(), Me = ee._fullLayout._invScaleX, Oe = ee._fullLayout._invScaleY, ht || (ke ? fe.shiftKey ? Ee === "pan" ? Ee = "zoom" : h(Ee) || (Ee = "pan") : fe.ctrlKey && (Ee = "pan") : Ee = "pan"), m(Ee) ? Xe.minDrag = 1 : Xe.minDrag = void 0, h(Ee) ? (Xe.xaxes = Se, Xe.yaxes = De, R(fe, Pe, Re, Xe, Ee)) : (Xe.clickFn = ot, h(Ye) && Je(), ht || (Ee === "zoom" ? (Xe.moveFn = Ft, Xe.doneFn = Ct, Xe.minDrag = 1, Vt(fe, Pe, Re)) : Ee === "pan" && (Xe.moveFn = nr, Xe.doneFn = sr))), ee._fullLayout._redrag = function() {
              var ze = ee._dragdata;
              if (ze && ze.element === Qe) {
                var Ge = ee._fullLayout.dragmode;
                h(Ge) || (je(), St([0, 0, We, $e]), Xe.moveFn(ze.dx, ze.dy));
              }
            };
          };
          function Je() {
            Xe.plotinfo.selection = !1, I(ee);
          }
          function ot(fe, Pe) {
            var Re = Xe.gd;
            if (Re._fullLayout._activeShapeIndex >= 0) {
              Re._fullLayout._deactivateShape(Re);
              return;
            }
            var Ye = Re._fullLayout.clickmode;
            if (F(Re), fe === 2 && !A && $t(), ke) Ye.indexOf("select") > -1 && P(Pe, Re, Se, De, le.id, Xe), Ye.indexOf("event") > -1 && l.click(Re, Pe, le.id);
            else if (fe === 1 && A) {
              var Ee = Ce ? H : X, ze = Ce === "s" || Ue === "w" ? 0 : 1, Ge = Ee._name + ".range[" + ze + "]", Ve = Z(Ee, ze), tt = "left", at = "middle";
              if (Ee.fixedrange) return;
              Ce ? (at = Ce === "n" ? "top" : "bottom", Ee.side === "right" && (tt = "right")) : Ue === "e" && (tt = "right"), Re._context.showAxisRangeEntryBoxes && n.select(Qe).call(c.makeEditable, { gd: Re, immediate: !0, background: Re._fullLayout.paper_bgcolor, text: String(Ve), fill: Ee.tickfont ? Ee.tickfont.color : "#444", horizontalAlign: tt, verticalAlign: at }).on("edit", function(vt) {
                var kt = Ee.d2r(vt);
                kt !== void 0 && r.call("_guiRelayout", Re, Ge, kt);
              });
            }
          }
          g.init(Xe);
          var lt, st, xt, Et, Bt, qt, jt, It, Tt, Rt;
          function Vt(fe, Pe, Re) {
            var Ye = Qe.getBoundingClientRect();
            lt = Pe - Ye.left, st = Re - Ye.top, ee._fullLayout._calcInverseTransform(ee);
            var Ee = e.apply3DTransform(ee._fullLayout._invTransform)(lt, st);
            lt = Ee[0], st = Ee[1], xt = { l: lt, r: lt, w: 0, t: st, b: st, h: 0 }, Et = ee._hmpixcount ? ee._hmlumcount / ee._hmpixcount : i(ee._fullLayout.plot_bgcolor).getLuminance(), Bt = "M0,0H" + We + "V" + $e + "H0V0", qt = !1, jt = "xy", Rt = !1, It = ne(Ne, Et, He, Ze, Bt), Tt = ae(Ne, He, Ze);
          }
          function Ft(fe, Pe) {
            if (ee._transitioningWithDuration) return !1;
            var Re = Math.max(0, Math.min(We, Me * fe + lt)), Ye = Math.max(0, Math.min($e, Oe * Pe + st)), Ee = Math.abs(Re - lt), ze = Math.abs(Ye - st);
            xt.l = Math.min(lt, Re), xt.r = Math.max(lt, Re), xt.t = Math.min(st, Ye), xt.b = Math.max(st, Ye);
            function Ge() {
              jt = "", xt.r = xt.l, xt.t = xt.b, Tt.attr("d", "M0,0Z");
            }
            if (it.isSubplotConstrained) Ee > q || ze > q ? (jt = "xy", Ee / We > ze / $e ? (ze = Ee * $e / We, st > Ye ? xt.t = st - ze : xt.b = st + ze) : (Ee = ze * We / $e, lt > Re ? xt.l = lt - Ee : xt.r = lt + Ee), Tt.attr("d", E(xt))) : Ge();
            else if (Ke.isSubplotConstrained) if (Ee > q || ze > q) {
              jt = "xy";
              var Ve = Math.min(xt.l / We, ($e - xt.b) / $e), tt = Math.max(xt.r / We, ($e - xt.t) / $e);
              xt.l = Ve * We, xt.r = tt * We, xt.b = (1 - Ve) * $e, xt.t = (1 - tt) * $e, Tt.attr("d", E(xt));
            } else Ge();
            else !gt || ze < Math.min(Math.max(Ee * 0.6, z), q) ? Ee < z || !ct ? Ge() : (xt.t = 0, xt.b = $e, jt = "x", Tt.attr("d", $(xt, st))) : !ct || Ee < Math.min(ze * 0.6, q) ? (xt.l = 0, xt.r = We, jt = "y", Tt.attr("d", re(xt, lt))) : (jt = "xy", Tt.attr("d", E(xt)));
            xt.w = xt.r - xt.l, xt.h = xt.b - xt.t, jt && (Rt = !0), ee._dragged = Rt, se(It, Tt, xt, Bt, qt, Et), Dt(), ee.emit("plotly_relayouting", ye), qt = !0;
          }
          function Dt() {
            ye = {}, (jt === "xy" || jt === "x") && (Y(Se, xt.l / We, xt.r / We, ye, it.xaxes), cr("x", ye)), (jt === "xy" || jt === "y") && (Y(De, ($e - xt.b) / $e, ($e - xt.t) / $e, ye, it.yaxes), cr("y", ye));
          }
          function Ct() {
            Dt(), F(ee), sr(), S(ee);
          }
          var Ot = [0, 0, We, $e], Wt = null, rr = B.REDRAWDELAY, Ut = le.mainplot ? ee._fullLayout._plots[le.mainplot] : le;
          function Qt(fe) {
            if (!ee._context._scrollZoom.cartesian && !ee._fullLayout._enablescrollzoom) return;
            if (Je(), ee._transitioningWithDuration) {
              fe.preventDefault(), fe.stopPropagation();
              return;
            }
            je(), clearTimeout(Wt);
            var Pe = -fe.deltaY;
            if (isFinite(Pe) || (Pe = fe.wheelDelta / 10), !isFinite(Pe)) {
              e.log("Did not find wheel motion attributes: ", fe);
              return;
            }
            var Re = Math.exp(-Math.min(Math.max(Pe, -20), 20) / 200), Ye = Ut.draglayer.select(".nsewdrag").node().getBoundingClientRect(), Ee = (fe.clientX - Ye.left) / Ye.width, ze = (Ye.bottom - fe.clientY) / Ye.height, Ge;
            function Ve(tt, at, vt) {
              if (tt.fixedrange) return;
              var kt = e.simpleMap(tt.range, tt.r2l), At = kt[0] + (kt[1] - kt[0]) * at;
              function Nt(Mt) {
                return tt.l2r(At + (Mt - At) * vt);
              }
              tt.range = kt.map(Nt);
            }
            if (_t) {
              for (Ue || (Ee = 0.5), Ge = 0; Ge < Se.length; Ge++) Ve(Se[Ge], Ee, Re);
              cr("x"), Ot[2] *= Re, Ot[0] += Ot[2] * Ee * (1 / Re - 1);
            }
            if (Te) {
              for (Ce || (ze = 0.5), Ge = 0; Ge < De.length; Ge++) Ve(De[Ge], ze, Re);
              cr("y"), Ot[3] *= Re, Ot[1] += Ot[3] * (1 - ze) * (1 / Re - 1);
            }
            St(Ot), lr(), ee.emit("plotly_relayouting", ye), Wt = setTimeout(function() {
              ee._fullLayout && (Ot = [0, 0, We, $e], sr());
            }, rr), fe.preventDefault();
          }
          Ce.length * Ue.length !== 1 && N(Qe, Qt);
          function nr(fe, Pe) {
            if (fe = fe * Me, Pe = Pe * Oe, ee._transitioningWithDuration) return;
            if (ee._fullLayout._replotting = !0, ct === "ew" || gt === "ns") {
              var Re = ct ? -fe : 0, Ye = gt ? -Pe : 0;
              if (Ke.isSubplotConstrained) {
                if (ct && gt) {
                  var Ee = (fe / We - Pe / $e) / 2;
                  fe = Ee * We, Pe = -Ee * $e, Re = -fe, Ye = -Pe;
                }
                gt ? Re = -Ye * We / $e : Ye = -Re * $e / We;
              }
              ct && (C(Se, fe), cr("x")), gt && (C(De, Pe), cr("y")), St([Re, Ye, We, $e]), lr(), ee.emit("plotly_relayouting", ye);
              return;
            }
            function ze(Nt, Mt, Pt) {
              for (var Lt = 1 - Mt, ur, Ht, mr = 0; mr < Nt.length; mr++) {
                var ar = Nt[mr];
                if (!ar.fixedrange) {
                  ur = ar, Ht = ar._rl[Lt] + (ar._rl[Mt] - ar._rl[Lt]) / j(Pt / ar._length);
                  var kr = ar.l2r(Ht);
                  kr !== !1 && kr !== void 0 && (ar.range[Mt] = kr);
                }
              }
              return ur._length * (ur._rl[Mt] - Ht) / (ur._rl[Mt] - ur._rl[Lt]);
            }
            var Ge = ct === "w" == (gt === "n") ? 1 : -1;
            if (ct && gt && (it.isSubplotConstrained || Ke.isSubplotConstrained)) {
              var Ve = (fe / We + Ge * Pe / $e) / 2;
              fe = Ve * We, Pe = Ge * Ve * $e;
            }
            var tt, at;
            if (ct === "w" ? fe = ze(Se, 0, fe) : ct === "e" ? fe = ze(Se, 1, -fe) : ct || (fe = 0), gt === "n" ? Pe = ze(De, 1, Pe) : gt === "s" ? Pe = ze(De, 0, -Pe) : gt || (Pe = 0), tt = ct === "w" ? fe : 0, at = gt === "n" ? Pe : 0, it.isSubplotConstrained && !Ke.isSubplotConstrained || Ke.isSubplotConstrained && ct && gt && Ge > 0) {
              var vt;
              if (Ke.isSubplotConstrained || !ct && gt.length === 1) {
                for (vt = 0; vt < Se.length; vt++) Se[vt].range = Se[vt]._r.slice(), M(Se[vt], 1 - Pe / $e);
                fe = Pe * We / $e, tt = fe / 2;
              }
              if (Ke.isSubplotConstrained || !gt && ct.length === 1) {
                for (vt = 0; vt < De.length; vt++) De[vt].range = De[vt]._r.slice(), M(De[vt], 1 - fe / We);
                Pe = fe * $e / We, at = Pe / 2;
              }
            }
            (!Ke.isSubplotConstrained || !gt) && cr("x"), (!Ke.isSubplotConstrained || !ct) && cr("y");
            var kt = We - fe, At = $e - Pe;
            Ke.isSubplotConstrained && !(ct && gt) && (ct ? (at = tt ? 0 : fe * $e / We, At = kt * $e / We) : (tt = at ? 0 : Pe * We / $e, kt = At * We / $e)), St([tt, at, kt, At]), lr(), ee.emit("plotly_relayouting", ye);
          }
          function cr(fe, Pe) {
            for (var Re = Ke.isSubplotConstrained ? { x: De, y: Se }[fe] : Ke[fe + "axes"], Ye = Ke.isSubplotConstrained ? { x: Se, y: De }[fe] : [], Ee = 0; Ee < Re.length; Ee++) {
              var ze = Re[Ee], Ge = ze._id, Ve = Ke.xLinks[Ge] || Ke.yLinks[Ge], tt = Ye[0] || ve[Ve] || be[Ve];
              tt && (Pe ? (Pe[ze._name + ".range[0]"] = Pe[tt._name + ".range[0]"], Pe[ze._name + ".range[1]"] = Pe[tt._name + ".range[1]"]) : ze.range = tt.range.slice());
            }
          }
          function lr() {
            var fe = [], Pe;
            function Re(Ge) {
              for (Pe = 0; Pe < Ge.length; Pe++) Ge[Pe].fixedrange || fe.push(Ge[Pe]._id);
            }
            function Ye(Ge, Ve) {
              for (Pe = 0; Pe < Ge.length; Pe++) {
                var tt = Ge[Pe], at = tt[Ve];
                !tt.fixedrange && at.tickmode === "sync" && fe.push(at._id);
              }
            }
            for (_t && (Re(Se), Re(it.xaxes), Re(Ke.xaxes), Ye(le.overlays, "xaxis")), Te && (Re(De), Re(it.yaxes), Re(Ke.yaxes), Ye(le.overlays, "yaxis")), ye = {}, Pe = 0; Pe < fe.length; Pe++) {
              var Ee = fe[Pe], ze = T(ee, Ee);
              f.drawOne(ee, ze, { skipTitle: !0 }), ye[ze._name + ".range[0]"] = ze.range[0], ye[ze._name + ".range[1]"] = ze.range[1];
            }
            f.redrawComponents(ee, fe);
          }
          function $t() {
            if (!ee._transitioningWithDuration) {
              var fe = ee._context.doubleClick, Pe = [];
              ct && (Pe = Pe.concat(Se)), gt && (Pe = Pe.concat(De)), Ke.xaxes && (Pe = Pe.concat(Ke.xaxes)), Ke.yaxes && (Pe = Pe.concat(Ke.yaxes));
              var Re = {}, Ye, Ee;
              if (fe === "reset+autosize") for (fe = "autosize", Ee = 0; Ee < Pe.length; Ee++) {
                Ye = Pe[Ee];
                var ze = Ye._rangeInitial0, Ge = Ye._rangeInitial1, Ve = ze !== void 0 || Ge !== void 0;
                if (Ve && (ze !== void 0 && ze !== Ye.range[0] || Ge !== void 0 && Ge !== Ye.range[1]) || !Ve && Ye.autorange !== !0) {
                  fe = "reset";
                  break;
                }
              }
              if (fe === "autosize") for (Ee = 0; Ee < Pe.length; Ee++) Ye = Pe[Ee], Ye.fixedrange || (Re[Ye._name + ".autorange"] = !0);
              else if (fe === "reset") {
                for ((ct || it.isSubplotConstrained) && (Pe = Pe.concat(it.xaxes)), gt && !it.isSubplotConstrained && (Pe = Pe.concat(it.yaxes)), it.isSubplotConstrained && (ct ? gt || (Pe = Pe.concat(De)) : Pe = Pe.concat(Se)), Ee = 0; Ee < Pe.length; Ee++) if (Ye = Pe[Ee], !Ye.fixedrange) {
                  var tt = Ye._name, at = Ye._autorangeInitial;
                  Ye._rangeInitial0 === void 0 && Ye._rangeInitial1 === void 0 ? Re[tt + ".autorange"] = !0 : Ye._rangeInitial0 === void 0 ? (Re[tt + ".autorange"] = at, Re[tt + ".range"] = [null, Ye._rangeInitial1]) : Ye._rangeInitial1 === void 0 ? (Re[tt + ".range"] = [Ye._rangeInitial0, null], Re[tt + ".autorange"] = at) : Re[tt + ".range"] = [Ye._rangeInitial0, Ye._rangeInitial1];
                }
              }
              ee.emit("plotly_doubleclick", null), r.call("_guiRelayout", ee, Re);
            }
          }
          function sr() {
            St([0, 0, We, $e]), e.syncOrAsync([_.previousPromises, function() {
              ee._fullLayout._replotting = !1, r.call("_guiRelayout", ee, ye);
            }], ee);
          }
          function St(fe) {
            var Pe = ee._fullLayout, Re = Pe._plots, Ye = Pe._subplots.cartesian, Ee, ze, Ge, Ve;
            if (ce && r.subplotsRegistry.splom.drag(ee), Ie) {
              for (Ee = 0; Ee < Ye.length; Ee++) if (ze = Re[Ye[Ee]], Ge = ze.xaxis, Ve = ze.yaxis, ze._scene) {
                Ge.limitRange && Ge.limitRange(), Ve.limitRange && Ve.limitRange();
                var tt = e.simpleMap(Ge.range, Ge.r2l), at = e.simpleMap(Ve.range, Ve.r2l);
                ze._scene.update({ range: [tt[0], at[0], tt[1], at[1]] });
              }
            }
            if ((ce || Ie) && (d(ee), y(ee)), ge) {
              var vt = fe[2] / X._length, kt = fe[3] / H._length;
              for (Ee = 0; Ee < Ye.length; Ee++) {
                ze = Re[Ye[Ee]], Ge = ze.xaxis, Ve = ze.yaxis;
                var At = (_t || Ke.isSubplotConstrained) && !Ge.fixedrange && ve[Ge._id], Nt = (Te || Ke.isSubplotConstrained) && !Ve.fixedrange && be[Ve._id], Mt, Pt, Lt, ur;
                if (At ? (Mt = vt, Lt = Ue || Ke.isSubplotConstrained ? fe[0] : he(Ge, Mt)) : Ke.xaHash[Ge._id] ? (Mt = vt, Lt = fe[0] * Ge._length / X._length) : Ke.yaHash[Ge._id] ? (Mt = kt, Lt = gt === "ns" ? -fe[1] * Ge._length / H._length : he(Ge, Mt, { n: "top", s: "bottom" }[gt])) : (Mt = Kt(Ge, vt, kt), Lt = hr(Ge, Mt)), Mt > 1 && (Ge.maxallowed !== void 0 && _t === (Ge.range[0] < Ge.range[1] ? "e" : "w") || Ge.minallowed !== void 0 && _t === (Ge.range[0] < Ge.range[1] ? "w" : "e")) && (Mt = 1, Lt = 0), Nt ? (Pt = kt, ur = Ce || Ke.isSubplotConstrained ? fe[1] : he(Ve, Pt)) : Ke.yaHash[Ve._id] ? (Pt = kt, ur = fe[1] * Ve._length / H._length) : Ke.xaHash[Ve._id] ? (Pt = vt, ur = ct === "ew" ? -fe[0] * Ve._length / X._length : he(Ve, Pt, { e: "right", w: "left" }[ct])) : (Pt = Kt(Ve, vt, kt), ur = hr(Ve, Pt)), Pt > 1 && (Ve.maxallowed !== void 0 && Te === (Ve.range[0] < Ve.range[1] ? "n" : "s") || Ve.minallowed !== void 0 && Te === (Ve.range[0] < Ve.range[1] ? "s" : "n")) && (Pt = 1, ur = 0), !(!Mt && !Pt)) {
                  Mt || (Mt = 1), Pt || (Pt = 1);
                  var Ht = Ge._offset - Lt / Mt, mr = Ve._offset - ur / Pt;
                  ze.clipRect.call(p.setTranslate, Lt, ur).call(p.setScale, Mt, Pt), ze.plot.call(p.setTranslate, Ht, mr).call(p.setScale, 1 / Mt, 1 / Pt), (Mt !== ze.xScaleFactor || Pt !== ze.yScaleFactor) && (p.setPointGroupScale(ze.zoomScalePts, Mt, Pt), p.setTextPointsScale(ze.zoomScaleTxt, Mt, Pt)), p.hideOutsideRangePoints(ze.clipOnAxisFalseTraces, ze), ze.xScaleFactor = Mt, ze.yScaleFactor = Pt;
                }
              }
            }
          }
          function Kt(fe, Pe, Re) {
            return fe.fixedrange ? 0 : _t && it.xaHash[fe._id] ? Pe : Te && (it.isSubplotConstrained ? it.xaHash : it.yaHash)[fe._id] ? Re : 0;
          }
          function hr(fe, Pe) {
            return Pe ? (fe.range = fe._r.slice(), M(fe, Pe), he(fe, Pe)) : 0;
          }
          function he(fe, Pe, Re) {
            return fe._length * (1 - Pe) * u[Re || fe.constraintoward || "middle"];
          }
          return Qe;
        }
        function K(ee, le, ie, pe) {
          var _e = e.ensureSingle(ee.draglayer, le, ie, function(Ae) {
            Ae.classed("drag", !0).style({ fill: "transparent", "stroke-width": 0 }).attr("data-subplot", ee.id);
          });
          return _e.call(v, pe), _e.node();
        }
        function te(ee, le, ie, pe, _e, Ae, Ce) {
          var Ue = K(ee, "rect", le, ie);
          return n.select(Ue).call(p.setRect, pe, _e, Ae, Ce), Ue;
        }
        function V(ee, le) {
          for (var ie = 0; ie < ee.length; ie++) if (!ee[ie].fixedrange) return le;
          return "";
        }
        function Z(ee, le) {
          var ie = ee.range[le], pe = Math.abs(ie - ee.range[1 - le]), _e;
          return ee.type === "date" ? ie : ee.type === "log" ? (_e = Math.ceil(Math.max(0, -Math.log(pe) / Math.LN10)) + 3, a("." + _e + "g")(Math.pow(10, ie))) : (_e = Math.floor(Math.log(Math.abs(ie)) / Math.LN10) - Math.floor(Math.log(pe) / Math.LN10) + 4, a("." + String(_e) + "g")(ie));
        }
        function Y(ee, le, ie, pe, _e) {
          for (var Ae = 0; Ae < ee.length; Ae++) {
            var Ce = ee[Ae];
            if (!Ce.fixedrange) if (Ce.rangebreaks) {
              var Ue = Ce._id.charAt(0) === "y", Ne = Ue ? 1 - le : le, ke = Ue ? 1 - ie : ie;
              pe[Ce._name + ".range[0]"] = Ce.l2r(Ce.p2l(Ne * Ce._length)), pe[Ce._name + ".range[1]"] = Ce.l2r(Ce.p2l(ke * Ce._length));
            } else {
              var A = Ce._rl[0], X = Ce._rl[1] - A;
              pe[Ce._name + ".range[0]"] = Ce.l2r(A + X * le), pe[Ce._name + ".range[1]"] = Ce.l2r(A + X * ie);
            }
          }
          if (_e && _e.length) {
            var H = (le + (1 - ie)) / 2;
            Y(_e, H, 1 - H, pe, []);
          }
        }
        function C(ee, le) {
          for (var ie = 0; ie < ee.length; ie++) {
            var pe = ee[ie];
            if (!pe.fixedrange) {
              if (pe.rangebreaks) {
                var _e = 0, Ae = pe._length, Ce = pe.p2l(_e + le) - pe.p2l(_e), Ue = pe.p2l(Ae + le) - pe.p2l(Ae), Ne = (Ce + Ue) / 2;
                pe.range = [pe.l2r(pe._rl[0] - Ne), pe.l2r(pe._rl[1] - Ne)];
              } else pe.range = [pe.l2r(pe._rl[0] - le / pe._m), pe.l2r(pe._rl[1] - le / pe._m)];
              pe.limitRange && pe.limitRange();
            }
          }
        }
        function j(ee) {
          return 1 - (ee >= 0 ? Math.min(ee, 0.9) : 1 / (1 / Math.max(ee, -0.3) + 3.222));
        }
        function J(ee, le, ie) {
          return ee ? ee === "nsew" ? ie ? "" : le === "pan" ? "move" : "crosshair" : ee.toLowerCase() + "-resize" : "pointer";
        }
        function ne(ee, le, ie, pe, _e) {
          return ee.append("path").attr("class", "zoombox").style({ fill: le > 0.2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)", "stroke-width": 0 }).attr("transform", s(ie, pe)).attr("d", _e + "Z");
        }
        function ae(ee, le, ie) {
          return ee.append("path").attr("class", "zoombox-corners").style({ fill: t.background, stroke: t.defaultLine, "stroke-width": 1, opacity: 0 }).attr("transform", s(le, ie)).attr("d", "M0,0Z");
        }
        function se(ee, le, ie, pe, _e, Ae) {
          ee.attr("d", pe + "M" + ie.l + "," + ie.t + "v" + ie.h + "h" + ie.w + "v-" + ie.h + "h-" + ie.w + "Z"), O(ee, le, _e, Ae);
        }
        function O(ee, le, ie, pe) {
          ie || (ee.transition().style("fill", pe > 0.2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), le.transition().style("opacity", 1).duration(200));
        }
        function F(ee) {
          n.select(ee).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
        }
        function S(ee) {
          U && ee.data && ee._context.showTips && (e.notifier(e._(ee, "Double-click to zoom back out"), "long"), U = !1);
        }
        function $(ee, le) {
          return "M" + (ee.l - 0.5) + "," + (le - q - 0.5) + "h-3v" + (2 * q + 1) + "h3ZM" + (ee.r + 0.5) + "," + (le - q - 0.5) + "h3v" + (2 * q + 1) + "h-3Z";
        }
        function re(ee, le) {
          return "M" + (le - q - 0.5) + "," + (ee.t - 0.5) + "v-3h" + (2 * q + 1) + "v3ZM" + (le - q - 0.5) + "," + (ee.b + 0.5) + "v3h" + (2 * q + 1) + "v-3Z";
        }
        function E(ee) {
          var le = Math.floor(Math.min(ee.b - ee.t, ee.r - ee.l, q) / 2);
          return "M" + (ee.l - 3.5) + "," + (ee.t - 0.5 + le) + "h3v" + -le + "h" + le + "v-3h-" + (le + 3) + "ZM" + (ee.r + 3.5) + "," + (ee.t - 0.5 + le) + "h-3v" + -le + "h" + -le + "v-3h" + (le + 3) + "ZM" + (ee.r + 3.5) + "," + (ee.b + 0.5 - le) + "h-3v" + le + "h" + -le + "v3h" + (le + 3) + "ZM" + (ee.l - 3.5) + "," + (ee.b + 0.5 - le) + "h3v" + le + "h" + le + "v3h-" + (le + 3) + "Z";
        }
        function w(ee, le, ie, pe, _e) {
          for (var Ae = !1, Ce = {}, Ue = {}, Ne, ke, A, X, H = (_e || {}).xaHash, ve = (_e || {}).yaHash, be = 0; be < le.length; be++) {
            var Se = le[be];
            for (Ne in ie) if (Se[Ne]) {
              for (A in Se) !(_e && (H[A] || ve[A])) && !(A.charAt(0) === "x" ? ie : pe)[A] && (Ce[A] = Ne);
              for (ke in pe) !(_e && (H[ke] || ve[ke])) && Se[ke] && (Ae = !0);
            }
            for (ke in pe) if (Se[ke]) for (X in Se) !(_e && (H[X] || ve[X])) && !(X.charAt(0) === "x" ? ie : pe)[X] && (Ue[X] = ke);
          }
          Ae && (e.extendFlat(Ce, Ue), Ue = {});
          var De = {}, He = [];
          for (A in Ce) {
            var Ze = T(ee, A);
            He.push(Ze), De[Ze._id] = Ze;
          }
          var We = {}, $e = [];
          for (X in Ue) {
            var it = T(ee, X);
            $e.push(it), We[it._id] = it;
          }
          return { xaHash: De, yaHash: We, xaxes: He, yaxes: $e, xLinks: Ce, yLinks: Ue, isSubplotConstrained: Ae };
        }
        function N(ee, le) {
          if (!o) ee.onwheel !== void 0 ? ee.onwheel = le : ee.onmousewheel !== void 0 ? ee.onmousewheel = le : ee.isAddedWheelEvent || (ee.isAddedWheelEvent = !0, ee.addEventListener("wheel", le, { passive: !1 }));
          else {
            var ie = ee.onwheel !== void 0 ? "wheel" : "mousewheel";
            ee._onwheel && ee.removeEventListener(ie, ee._onwheel), ee._onwheel = le, ee.addEventListener(ie, le, { passive: !1 });
          }
        }
        function W(ee) {
          var le = [];
          for (var ie in ee) le.push(ee[ie]);
          return le;
        }
        k.exports = { makeDragBox: G, makeDragger: K, makeRectDragger: te, makeZoombox: ne, makeCorners: ae, updateZoombox: se, xyCorners: E, transitionZoombox: O, removeZoombox: F, showDoubleClickNotifier: S, attachWheelEventHandler: N };
      }), Ls = xe((L) => {
        var k = vr(), n = Bn(), e = Jn(), a = Aa(), i = Qd().makeDragBox, o = mn().DRAGGERSIZE;
        L.initInteractions = function(r) {
          var s = r._fullLayout;
          if (r._context.staticPlot) {
            k.select(r).selectAll(".drag").remove();
            return;
          }
          if (!(!s._has("cartesian") && !s._has("splom"))) {
            var c = Object.keys(s._plots || {}).sort(function(p, l) {
              if ((s._plots[p].mainplot && !0) === (s._plots[l].mainplot && !0)) {
                var f = p.split("y"), v = l.split("y");
                return f[0] === v[0] ? Number(f[1] || 1) - Number(v[1] || 1) : Number(f[0] || 1) - Number(v[0] || 1);
              }
              return s._plots[p].mainplot ? 1 : -1;
            });
            c.forEach(function(p) {
              var l = s._plots[p], f = l.xaxis, v = l.yaxis;
              if (!l.mainplot) {
                var g = i(r, l, f._offset, v._offset, f._length, v._length, "ns", "ew");
                g.onmousemove = function(m) {
                  r._fullLayout._rehover = function() {
                    r._fullLayout._hoversubplot === p && r._fullLayout._plots[p] && n.hover(r, m, p);
                  }, n.hover(r, m, p), r._fullLayout._lasthover = g, r._fullLayout._hoversubplot = p;
                }, g.onmouseout = function(m) {
                  r._dragging || (r._fullLayout._hoversubplot = null, e.unhover(r, m));
                }, r._context.showAxisDragHandles && (i(r, l, f._offset - o, v._offset - o, o, o, "n", "w"), i(r, l, f._offset + f._length, v._offset - o, o, o, "n", "e"), i(r, l, f._offset - o, v._offset + v._length, o, o, "s", "w"), i(r, l, f._offset + f._length, v._offset + v._length, o, o, "s", "e"));
              }
              if (r._context.showAxisDragHandles) {
                if (p === f._mainSubplot) {
                  var x = f._mainLinePosition;
                  f.side === "top" && (x -= o), i(r, l, f._offset + f._length * 0.1, x, f._length * 0.8, o, "", "ew"), i(r, l, f._offset, x, f._length * 0.1, o, "", "w"), i(r, l, f._offset + f._length * 0.9, x, f._length * 0.1, o, "", "e");
                }
                if (p === v._mainSubplot) {
                  var h = v._mainLinePosition;
                  v.side !== "right" && (h -= o), i(r, l, h, v._offset + v._length * 0.1, o, v._length * 0.8, "ns", ""), i(r, l, h, v._offset + v._length * 0.9, o, v._length * 0.1, "s", ""), i(r, l, h, v._offset, o, v._length * 0.1, "n", "");
                }
              }
            });
            var t = s._hoverlayer.node();
            t.onmousemove = function(p) {
              p.target = r._fullLayout._lasthover, n.hover(r, p, s._hoversubplot);
            }, t.onclick = function(p) {
              p.target = r._fullLayout._lasthover, n.click(r, p);
            }, t.onmousedown = function(p) {
              r._fullLayout._lasthover.onmousedown(p);
            }, L.updateFx(r);
          }
        }, L.updateFx = function(r) {
          var s = r._fullLayout, c = s.dragmode === "pan" ? "move" : "crosshair";
          a(s._draggers, c);
        };
      }), ep = xe((L, k) => {
        var n = or();
        k.exports = function(e) {
          for (var a = n.layoutArrayContainers, i = n.layoutArrayRegexes, o = e.split("[")[0], r, s, c = 0; c < i.length; c++) if (s = e.match(i[c]), s && s.index === 0) {
            r = s[0];
            break;
          }
          if (r || (r = a[a.indexOf(o)]), !r) return !1;
          var t = e.substr(r.length);
          return t ? (s = t.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/), s ? { array: r, index: Number(s[1]), property: s[3] || "" } : !1) : { array: r, index: "", property: "" };
        };
      }), tp = xe((L) => {
        var k = ka(), n = uo(), e = za(), a = $l().sorterAsc, i = or();
        L.containerArrayMatch = ep();
        var o = L.isAddVal = function(s) {
          return s === "add" || k(s);
        }, r = L.isRemoveVal = function(s) {
          return s === null || s === "remove";
        };
        L.applyContainerArrayChanges = function(s, c, t, p, l) {
          var f = c.astr, v = i.getComponentMethod(f, "supplyLayoutDefaults"), g = i.getComponentMethod(f, "draw"), x = i.getComponentMethod(f, "drawOne"), h = p.replot || p.recalc || v === n || g === n, m = s.layout, u = s._fullLayout;
          if (t[""]) {
            Object.keys(t).length > 1 && e.warn("Full array edits are incompatible with other edits", f);
            var d = t[""][""];
            if (r(d)) c.set(null);
            else if (Array.isArray(d)) c.set(d);
            else return e.warn("Unrecognized full array edit value", f, d), !0;
            return h ? !1 : (v(m, u), g(s), !0);
          }
          var y = Object.keys(t).map(Number).sort(a), _ = c.get(), T = _ || [], R = l(u, f).get(), I = [], P = -1, M = T.length, B, z, q, U, G, K, te, V;
          for (B = 0; B < y.length; B++) {
            if (q = y[B], U = t[q], G = Object.keys(U), K = U[""], te = o(K), q < 0 || q > T.length - (te ? 0 : 1)) {
              e.warn("index out of range", f, q);
              continue;
            }
            if (K !== void 0) G.length > 1 && e.warn("Insertion & removal are incompatible with edits to the same index.", f, q), r(K) ? I.push(q) : te ? (K === "add" && (K = {}), T.splice(q, 0, K), R && R.splice(q, 0, {})) : e.warn("Unrecognized full object edit value", f, q, K), P === -1 && (P = q);
            else for (z = 0; z < G.length; z++) V = f + "[" + q + "].", l(T[q], G[z], V).set(U[G[z]]);
          }
          for (B = I.length - 1; B >= 0; B--) T.splice(I[B], 1), R && R.splice(I[B], 1);
          if (T.length ? _ || c.set(T) : c.set(null), h) return !1;
          if (v(m, u), x !== n) {
            var Z;
            if (P === -1) Z = y;
            else {
              for (M = Math.max(T.length, M), Z = [], B = 0; B < y.length && (q = y[B], !(q >= P)); B++) Z.push(q);
              for (B = P; B < M; B++) Z.push(B);
            }
            for (B = 0; B < Z.length; B++) x(s, Z[B]);
          } else g(s);
          return !0;
        };
      }), rp = xe((L) => {
        var k = xr(), n = or(), e = wt(), a = on(), i = sn(), o = fr(), r = i.cleanId, s = i.getFromTrace, c = n.traceIs, t = ["x", "y", "z"];
        L.clearPromiseQueue = function(u) {
          Array.isArray(u._promises) && u._promises.length > 0 && e.log("Clearing previous rejected promises from queue."), u._promises = [];
        }, L.cleanLayout = function(u) {
          var d;
          u || (u = {}), u.xaxis1 && (u.xaxis || (u.xaxis = u.xaxis1), delete u.xaxis1), u.yaxis1 && (u.yaxis || (u.yaxis = u.yaxis1), delete u.yaxis1), u.scene1 && (u.scene || (u.scene = u.scene1), delete u.scene1);
          var y = (a.subplotsRegistry.cartesian || {}).attrRegex;
          (a.subplotsRegistry.polar || {}).attrRegex, (a.subplotsRegistry.ternary || {}).attrRegex, (a.subplotsRegistry.gl3d || {}).attrRegex;
          var _ = Object.keys(u);
          for (d = 0; d < _.length; d++) {
            var T = _[d];
            if (y && y.test(T)) {
              var R = u[T];
              R.anchor && R.anchor !== "free" && (R.anchor = r(R.anchor)), R.overlaying && (R.overlaying = r(R.overlaying)), R.type || (R.isdate ? R.type = "date" : R.islog ? R.type = "log" : R.isdate === !1 && R.islog === !1 && (R.type = "linear")), (R.autorange === "withzero" || R.autorange === "tozero") && (R.autorange = !0, R.rangemode = "tozero"), R.insiderange && delete R.range, delete R.islog, delete R.isdate, delete R.categories, g(R, "domain") && delete R.domain;
            }
          }
          var I = Array.isArray(u.annotations) ? u.annotations.length : 0;
          for (d = 0; d < I; d++) {
            var P = u.annotations[d];
            e.isPlainObject(P) && (p(P, "xref"), p(P, "yref"));
          }
          var M = Array.isArray(u.shapes) ? u.shapes.length : 0;
          for (d = 0; d < M; d++) {
            var B = u.shapes[d];
            e.isPlainObject(B) && (p(B, "xref"), p(B, "yref"));
          }
          var z = Array.isArray(u.images) ? u.images.length : 0;
          for (d = 0; d < z; d++) {
            var q = u.images[d];
            e.isPlainObject(q) && (p(q, "xref"), p(q, "yref"));
          }
          var U = u.legend;
          return U && (U.x > 3 ? (U.x = 1.02, U.xanchor = "left") : U.x < -2 && (U.x = -0.02, U.xanchor = "right"), U.y > 3 ? (U.y = 1.02, U.yanchor = "bottom") : U.y < -2 && (U.y = -0.02, U.yanchor = "top")), u.dragmode === "rotate" && (u.dragmode = "orbit"), o.clean(u), u.template && u.template.layout && L.cleanLayout(u.template.layout), u;
        };
        function p(u, d) {
          var y = u[d], _ = d.charAt(0);
          y && y !== "paper" && (u[d] = r(y, _, !0));
        }
        L.cleanData = function(u) {
          for (var d = 0; d < u.length; d++) {
            var y = u[d], _;
            if (y.type === "histogramy" && "xbins" in y && !("ybins" in y) && (y.ybins = y.xbins, delete y.xbins), y.type === "histogramy" && L.swapXYData(y), (y.type === "histogramx" || y.type === "histogramy") && (y.type = "histogram"), "scl" in y && !("colorscale" in y) && (y.colorscale = y.scl, delete y.scl), "reversescl" in y && !("reversescale" in y) && (y.reversescale = y.reversescl, delete y.reversescl), y.xaxis && (y.xaxis = r(y.xaxis, "x")), y.yaxis && (y.yaxis = r(y.yaxis, "y")), c(y, "gl3d") && y.scene && (y.scene = a.subplotsRegistry.gl3d.cleanId(y.scene)), !c(y, "pie-like") && !c(y, "bar-like")) if (Array.isArray(y.textposition)) for (_ = 0; _ < y.textposition.length; _++) y.textposition[_] = v(y.textposition[_]);
            else y.textposition && (y.textposition = v(y.textposition));
            var T = n.getModule(y);
            if (T && T.colorbar) {
              var R = T.colorbar.container, I = R ? y[R] : y;
              I && I.colorscale && (I.colorscale === "YIGnBu" && (I.colorscale = "YlGnBu"), I.colorscale === "YIOrRd" && (I.colorscale = "YlOrRd"));
            }
            if (y.type === "surface" && e.isPlainObject(y.contours)) {
              var P = ["x", "y", "z"];
              for (_ = 0; _ < P.length; _++) {
                var M = y.contours[P[_]];
                e.isPlainObject(M) && (M.highlightColor && (M.highlightcolor = M.highlightColor, delete M.highlightColor), M.highlightWidth && (M.highlightwidth = M.highlightWidth, delete M.highlightWidth));
              }
            }
            if (y.type === "candlestick" || y.type === "ohlc") {
              var B = (y.increasing || {}).showlegend !== !1, z = (y.decreasing || {}).showlegend !== !1, q = l(y.increasing), U = l(y.decreasing);
              if (q !== !1 && U !== !1) {
                var G = f(q, U, B, z);
                G && (y.name = G);
              } else (q || U) && !y.name && (y.name = q || U);
            }
            g(y, "line") && delete y.line, "marker" in y && (g(y.marker, "line") && delete y.marker.line, g(y, "marker") && delete y.marker), o.clean(y), y.autobinx && (delete y.autobinx, delete y.xbins), y.autobiny && (delete y.autobiny, delete y.ybins);
          }
        };
        function l(u) {
          if (!e.isPlainObject(u)) return !1;
          var d = u.name;
          return delete u.name, delete u.showlegend, (typeof d == "string" || typeof d == "number") && String(d);
        }
        function f(u, d, y, _) {
          if (y && !_) return u;
          if (_ && !y || !u.trim()) return d;
          if (!d.trim()) return u;
          var T = Math.min(u.length, d.length), R;
          for (R = 0; R < T && u.charAt(R) === d.charAt(R); R++) ;
          var I = u.substr(0, R);
          return I.trim();
        }
        function v(u) {
          var d = "middle", y = "center";
          return typeof u == "string" && (u.indexOf("top") !== -1 ? d = "top" : u.indexOf("bottom") !== -1 && (d = "bottom"), u.indexOf("left") !== -1 ? y = "left" : u.indexOf("right") !== -1 && (y = "right")), d + " " + y;
        }
        function g(u, d) {
          return d in u && typeof u[d] == "object" && Object.keys(u[d]).length === 0;
        }
        L.swapXYData = function(u) {
          var d;
          if (e.swapAttrs(u, ["?", "?0", "d?", "?bins", "nbins?", "autobin?", "?src", "error_?"]), Array.isArray(u.z) && Array.isArray(u.z[0]) && (u.transpose ? delete u.transpose : u.transpose = !0), u.error_x && u.error_y) {
            var y = u.error_y, _ = "copy_ystyle" in y ? y.copy_ystyle : !(y.color || y.thickness || y.width);
            e.swapAttrs(u, ["error_?.copy_ystyle"]), _ && e.swapAttrs(u, ["error_?.color", "error_?.thickness", "error_?.width"]);
          }
          if (typeof u.hoverinfo == "string") {
            var T = u.hoverinfo.split("+");
            for (d = 0; d < T.length; d++) T[d] === "x" ? T[d] = "y" : T[d] === "y" && (T[d] = "x");
            u.hoverinfo = T.join("+");
          }
        }, L.coerceTraceIndices = function(u, d) {
          if (k(d)) return [d];
          if (!Array.isArray(d) || !d.length) return u.data.map(function(T, R) {
            return R;
          });
          if (Array.isArray(d)) {
            for (var y = [], _ = 0; _ < d.length; _++) e.isIndex(d[_], u.data.length) ? y.push(d[_]) : e.warn("trace index (", d[_], ") is not a number or is out of bounds");
            return y;
          }
          return d;
        }, L.manageArrayContainers = function(u, d, y) {
          var _ = u.obj, T = u.parts, R = T.length, I = T[R - 1], P = k(I);
          if (P && d === null) {
            var M = T.slice(0, R - 1).join("."), B = e.nestedProperty(_, M).get();
            B.splice(I, 1);
          } else P && u.get() === void 0 && u.get() === void 0 && (y[u.astr] = null), u.set(d);
        };
        var x = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
        function h(u) {
          var d = u.search(x);
          if (d > 0) return u.substr(0, d);
        }
        L.hasParent = function(u, d) {
          for (var y = h(d); y; ) {
            if (y in u) return !0;
            y = h(y);
          }
          return !1;
        }, L.clearAxisTypes = function(u, d, y) {
          for (var _ = 0; _ < d.length; _++) for (var T = u._fullData[_], R = 0; R < 3; R++) {
            var I = s(u, T, t[R]);
            if (I && I.type !== "log") {
              var P = I._name, M = I._id.substr(1);
              if (M.substr(0, 5) === "scene") {
                if (y[M] !== void 0) continue;
                P = M + "." + P;
              }
              var B = P + ".type";
              y[P] === void 0 && y[B] === void 0 && e.nestedProperty(u.layout, B).set(null);
            }
          }
        };
        var m = (u, d) => {
          let y = (..._) => _.every((T) => e.isPlainObject(T)) || _.every((T) => Array.isArray(T));
          if ([u, d].every((_) => Array.isArray(_))) {
            if (u.length !== d.length) return !1;
            for (let _ = 0; _ < u.length; _++) {
              let T = u[_], R = d[_];
              if (T !== R && !(y(T, R) && m(T, R))) return !1;
            }
            return !0;
          } else if ([u, d].every((_) => e.isPlainObject(_))) {
            if (Object.keys(u).length !== Object.keys(d).length) return !1;
            for (let _ in u) {
              if (_.startsWith("_")) continue;
              let T = u[_], R = d[_];
              if (T !== R && !(y(T, R) && m(T, R))) return !1;
            }
            return !0;
          }
          return !1;
        };
        L.collectionsAreEqual = m;
      }), Os = xe((L) => {
        var k = vr(), n = xr(), e = es(), a = wt(), i = a.nestedProperty, o = Ti(), r = yd(), s = or(), c = Qa(), t = on(), p = Ar(), l = ss(), f = Xn(), v = Or(), g = fr(), x = Ls().initInteractions, h = va(), m = pa().clearOutline, u = Ia().dfltConfig, d = tp(), y = rp(), _ = Io(), T = ra(), R = mn().AX_NAME_PATTERN, I = 0, P = 5;
        function M(ce, ge, ye, Me) {
          var Oe;
          if (ce = a.getGraphDiv(ce), o.init(ce), a.isPlainObject(ge)) {
            var je = ge;
            ge = je.data, ye = je.layout, Me = je.config, Oe = je.frames;
          }
          var qe = o.triggerHandler(ce, "plotly_beforeplot", [ge, ye, Me]);
          if (qe === !1) return Promise.reject();
          !ge && !ye && !a.isPlotDiv(ce) && a.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", ce);
          function Qe() {
            if (Oe) return L.addFrames(ce, Oe);
          }
          G(ce, Me), ye || (ye = {}), k.select(ce).classed("js-plotly-plot", !0), v.makeTester(), Array.isArray(ce._promises) || (ce._promises = []);
          var Xe = (ce.data || []).length === 0 && Array.isArray(ge);
          Array.isArray(ge) && (y.cleanData(ge), Xe ? ce.data = ge : ce.data.push.apply(ce.data, ge), ce.empty = !1), (!ce.layout || Xe) && (ce.layout = y.cleanLayout(ye)), t.supplyDefaults(ce);
          var Je = ce._fullLayout, ot = Je._has("cartesian");
          Je._replotting = !0, (Xe || Je._shouldCreateBgLayer) && (Ie(ce), Je._shouldCreateBgLayer && delete Je._shouldCreateBgLayer), v.initGradients(ce), v.initPatterns(ce), Xe && p.saveShowSpikeInitial(ce);
          var lt = !ce.calcdata || ce.calcdata.length !== (ce._fullData || []).length;
          lt && t.doCalcdata(ce);
          for (var st = 0; st < ce.calcdata.length; st++) ce.calcdata[st][0].trace = ce._fullData[st];
          ce._context.responsive ? ce._responsiveChartHandler || (ce._responsiveChartHandler = function() {
            a.isHidden(ce) || t.resize(ce);
          }, window.addEventListener("resize", ce._responsiveChartHandler)) : a.clearResponsive(ce);
          var xt = a.extendFlat({}, Je._size), Et = 0;
          function Bt() {
            for (var Dt = Je._basePlotModules, Ct = 0; Ct < Dt.length; Ct++) Dt[Ct].drawFramework && Dt[Ct].drawFramework(ce);
            !Je._glcanvas && Je._has("gl") && (Je._glcanvas = Je._glcontainer.selectAll(".gl-canvas").data([{ key: "contextLayer", context: !0, pick: !1 }, { key: "focusLayer", context: !1, pick: !1 }, { key: "pickLayer", context: !1, pick: !0 }], function(Ut) {
              return Ut.key;
            }), Je._glcanvas.enter().append("canvas").attr("class", function(Ut) {
              return "gl-canvas gl-canvas-" + Ut.key.replace("Layer", "");
            }).style({ position: "absolute", top: 0, left: 0, overflow: "visible", "pointer-events": "none" }));
            var Ot = ce._context.plotGlPixelRatio;
            if (Je._glcanvas) {
              Je._glcanvas.attr("width", Je.width * Ot).attr("height", Je.height * Ot).style("width", Je.width + "px").style("height", Je.height + "px");
              var Wt = Je._glcanvas.data()[0].regl;
              if (Wt && (Math.floor(Je.width * Ot) !== Wt._gl.drawingBufferWidth || Math.floor(Je.height * Ot) !== Wt._gl.drawingBufferHeight)) {
                var rr = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                if (Et) a.error(rr);
                else return a.log(rr + " Clearing graph and plotting again."), t.cleanPlot([], {}, ce._fullData, Je), t.supplyDefaults(ce), Je = ce._fullLayout, t.doCalcdata(ce), Et++, Bt();
              }
            }
            return Je.modebar.orientation === "h" ? Je._modebardiv.style("height", null).style("width", "100%") : Je._modebardiv.style("width", null).style("height", Je.height + "px"), t.previousPromises(ce);
          }
          function qt() {
            if (t.clearAutoMarginIds(ce), _.drawMarginPushers(ce), p.allowAutoMargin(ce), ce._fullLayout.title.text && ce._fullLayout.title.automargin && t.allowAutoMargin(ce, "title.automargin"), Je._has("pie")) for (var Dt = ce._fullData, Ct = 0; Ct < Dt.length; Ct++) {
              var Ot = Dt[Ct];
              Ot.type === "pie" && Ot.automargin && t.allowAutoMargin(ce, "pie." + Ot.uid + ".automargin");
            }
            return t.doAutoMargin(ce), t.previousPromises(ce);
          }
          function jt() {
            if (t.didMarginChange(xt, Je._size)) return a.syncOrAsync([qt, _.layoutStyles], ce);
          }
          function It() {
            if (!lt) {
              Tt();
              return;
            }
            return a.syncOrAsync([s.getComponentMethod("shapes", "calcAutorange"), s.getComponentMethod("annotations", "calcAutorange"), Tt], ce);
          }
          function Tt() {
            ce._transitioning || (_.doAutoRangeAndConstraints(ce), Xe && p.saveRangeInitial(ce), s.getComponentMethod("rangeslider", "calcAutorange")(ce));
          }
          function Rt() {
            return p.draw(ce, Xe ? "" : "redraw");
          }
          var Vt = [t.previousPromises, Qe, Bt, qt, jt];
          ot && Vt.push(It), Vt.push(_.layoutStyles), ot && Vt.push(Rt, function(Dt) {
            var Ct = Dt._fullLayout._insideTickLabelsUpdaterange;
            if (Ct) return Dt._fullLayout._insideTickLabelsUpdaterange = void 0, le(Dt, Ct).then(function() {
              p.saveRangeInitial(Dt, !0);
            });
          }), Vt.push(_.drawData, _.finalDraw, x, t.addLinks, t.rehover, t.redrag, t.reselect, t.doAutoMargin, t.previousPromises);
          var Ft = a.syncOrAsync(Vt, ce);
          return (!Ft || !Ft.then) && (Ft = Promise.resolve()), Ft.then(function() {
            return B(ce), ce;
          });
        }
        function B(ce) {
          var ge = ce._fullLayout;
          ge._redrawFromAutoMarginCount ? ge._redrawFromAutoMarginCount-- : ce.emit("plotly_afterplot");
        }
        function z(ce) {
          return a.extendFlat(u, ce);
        }
        function q(ce, ge) {
          try {
            ce._fullLayout._paper.style("background", ge);
          } catch (ye) {
            a.error(ye);
          }
        }
        function U(ce, ge) {
          var ye = g.combine(ge, "white");
          q(ce, ye);
        }
        function G(ce, ge) {
          if (!ce._context) {
            ce._context = a.extendDeep({}, u);
            var ye = k.select("base");
            ce._context._baseUrl = ye.size() && ye.attr("href") ? window.location.href.split("#")[0] : "";
          }
          var Me = ce._context, Oe, je, qe;
          if (ge) {
            for (je = Object.keys(ge), Oe = 0; Oe < je.length; Oe++) qe = je[Oe], !(qe === "editable" || qe === "edits") && qe in Me && (qe === "setBackground" && ge[qe] === "opaque" ? Me[qe] = U : Me[qe] = ge[qe]);
            var Qe = ge.editable;
            if (Qe !== void 0) for (Me.editable = Qe, je = Object.keys(Me.edits), Oe = 0; Oe < je.length; Oe++) Me.edits[je[Oe]] = Qe;
            if (ge.edits) for (je = Object.keys(ge.edits), Oe = 0; Oe < je.length; Oe++) qe = je[Oe], qe in Me.edits && (Me.edits[qe] = ge.edits[qe]);
            Me._exportedPlot = ge._exportedPlot;
          }
          Me.staticPlot && (Me.editable = !1, Me.edits = {}, Me.autosizable = !1, Me.scrollZoom = !1, Me.doubleClick = !1, Me.showTips = !1, Me.showLink = !1, Me.displayModeBar = !1), Me.displayModeBar === "hover" && !e && (Me.displayModeBar = !0), (Me.setBackground === "transparent" || typeof Me.setBackground != "function") && (Me.setBackground = q), Me._hasZeroHeight = Me._hasZeroHeight || ce.clientHeight === 0, Me._hasZeroWidth = Me._hasZeroWidth || ce.clientWidth === 0;
          var Xe = Me.scrollZoom, Je = Me._scrollZoom = {};
          if (Xe === !0) Je.cartesian = 1, Je.gl3d = 1, Je.geo = 1, Je.mapbox = 1, Je.map = 1;
          else if (typeof Xe == "string") {
            var ot = Xe.split("+");
            for (Oe = 0; Oe < ot.length; Oe++) Je[ot[Oe]] = 1;
          } else Xe !== !1 && (Je.gl3d = 1, Je.geo = 1, Je.mapbox = 1, Je.map = 1);
        }
        function K(ce) {
          if (ce = a.getGraphDiv(ce), !a.isPlotDiv(ce)) throw new Error("This element is not a Plotly plot: " + ce);
          return y.cleanData(ce.data), y.cleanLayout(ce.layout), ce.calcdata = void 0, L._doPlot(ce).then(function() {
            return ce.emit("plotly_redraw"), ce;
          });
        }
        function te(ce, ge, ye, Me) {
          return ce = a.getGraphDiv(ce), t.cleanPlot([], {}, ce._fullData || [], ce._fullLayout || {}), t.purge(ce), L._doPlot(ce, ge, ye, Me);
        }
        function V(ce, ge) {
          var ye = ge + 1, Me = [], Oe, je;
          for (Oe = 0; Oe < ce.length; Oe++) je = ce[Oe], je < 0 ? Me.push(ye + je) : Me.push(je);
          return Me;
        }
        function Z(ce, ge, ye) {
          var Me, Oe;
          for (Me = 0; Me < ge.length; Me++) {
            if (Oe = ge[Me], Oe !== parseInt(Oe, 10)) throw new Error("all values in " + ye + " must be integers");
            if (Oe >= ce.data.length || Oe < -ce.data.length) throw new Error(ye + " must be valid indices for gd.data.");
            if (ge.indexOf(Oe, Me + 1) > -1 || Oe >= 0 && ge.indexOf(-ce.data.length + Oe) > -1 || Oe < 0 && ge.indexOf(ce.data.length + Oe) > -1) throw new Error("each index in " + ye + " must be unique.");
          }
        }
        function Y(ce, ge, ye) {
          if (!Array.isArray(ce.data)) throw new Error("gd.data must be an array.");
          if (typeof ge > "u") throw new Error("currentIndices is a required argument.");
          if (Array.isArray(ge) || (ge = [ge]), Z(ce, ge, "currentIndices"), typeof ye < "u" && !Array.isArray(ye) && (ye = [ye]), typeof ye < "u" && Z(ce, ye, "newIndices"), typeof ye < "u" && ge.length !== ye.length) throw new Error("current and new indices must be of equal length.");
        }
        function C(ce, ge, ye) {
          var Me, Oe;
          if (!Array.isArray(ce.data)) throw new Error("gd.data must be an array.");
          if (typeof ge > "u") throw new Error("traces must be defined.");
          for (Array.isArray(ge) || (ge = [ge]), Me = 0; Me < ge.length; Me++) if (Oe = ge[Me], typeof Oe != "object" || Array.isArray(Oe) || Oe === null) throw new Error("all values in traces array must be non-array objects");
          if (typeof ye < "u" && !Array.isArray(ye) && (ye = [ye]), typeof ye < "u" && ye.length !== ge.length) throw new Error("if indices is specified, traces.length must equal indices.length");
        }
        function j(ce, ge, ye, Me) {
          var Oe = a.isPlainObject(Me);
          if (!Array.isArray(ce.data)) throw new Error("gd.data must be an array");
          if (!a.isPlainObject(ge)) throw new Error("update must be a key:value object");
          if (typeof ye > "u") throw new Error("indices must be an integer or array of integers");
          Z(ce, ye, "indices");
          for (var je in ge) {
            if (!Array.isArray(ge[je]) || ge[je].length !== ye.length) throw new Error("attribute " + je + " must be an array of length equal to indices array length");
            if (Oe && (!(je in Me) || !Array.isArray(Me[je]) || Me[je].length !== ge[je].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 correspondence with the keys and number of traces in the update object");
          }
        }
        function J(ce, ge, ye, Me) {
          var Oe = a.isPlainObject(Me), je = [], qe, Qe, Xe, Je, ot;
          Array.isArray(ye) || (ye = [ye]), ye = V(ye, ce.data.length - 1);
          for (var lt in ge) for (var st = 0; st < ye.length; st++) {
            if (qe = ce.data[ye[st]], Xe = i(qe, lt), Qe = Xe.get(), Je = ge[lt][st], !a.isArrayOrTypedArray(Je)) throw new Error("attribute: " + lt + " index: " + st + " must be an array");
            if (!a.isArrayOrTypedArray(Qe)) throw new Error("cannot extend missing or non-array attribute: " + lt);
            if (Qe.constructor !== Je.constructor) throw new Error("cannot extend array with an array of a different type: " + lt);
            ot = Oe ? Me[lt][st] : Me, n(ot) || (ot = -1), je.push({ prop: Xe, target: Qe, insert: Je, maxp: Math.floor(ot) });
          }
          return je;
        }
        function ne(ce, ge, ye, Me, Oe) {
          j(ce, ge, ye, Me);
          for (var je = J(ce, ge, ye, Me), qe = {}, Qe = {}, Xe = 0; Xe < je.length; Xe++) {
            var Je = je[Xe].prop, ot = je[Xe].maxp, lt = Oe(je[Xe].target, je[Xe].insert, ot);
            Je.set(lt[0]), Array.isArray(qe[Je.astr]) || (qe[Je.astr] = []), qe[Je.astr].push(lt[1]), Array.isArray(Qe[Je.astr]) || (Qe[Je.astr] = []), Qe[Je.astr].push(je[Xe].target.length);
          }
          return { update: qe, maxPoints: Qe };
        }
        function ae(ce, ge) {
          var ye = new ce.constructor(ce.length + ge.length);
          return ye.set(ce), ye.set(ge, ce.length), ye;
        }
        function se(ce, ge, ye, Me) {
          ce = a.getGraphDiv(ce);
          function Oe(Xe, Je, ot) {
            var lt, st;
            if (a.isTypedArray(Xe)) if (ot < 0) {
              var xt = new Xe.constructor(0), Et = ae(Xe, Je);
              ot < 0 ? (lt = Et, st = xt) : (lt = xt, st = Et);
            } else if (lt = new Xe.constructor(ot), st = new Xe.constructor(Xe.length + Je.length - ot), ot === Je.length) lt.set(Je), st.set(Xe);
            else if (ot < Je.length) {
              var Bt = Je.length - ot;
              lt.set(Je.subarray(Bt)), st.set(Xe), st.set(Je.subarray(0, Bt), Xe.length);
            } else {
              var qt = ot - Je.length, jt = Xe.length - qt;
              lt.set(Xe.subarray(jt)), lt.set(Je, qt), st.set(Xe.subarray(0, jt));
            }
            else lt = Xe.concat(Je), st = ot >= 0 && ot < lt.length ? lt.splice(0, lt.length - ot) : [];
            return [lt, st];
          }
          var je = ne(ce, ge, ye, Me, Oe), qe = L.redraw(ce), Qe = [ce, je.update, ye, je.maxPoints];
          return r.add(ce, L.prependTraces, Qe, se, arguments), qe;
        }
        function O(ce, ge, ye, Me) {
          ce = a.getGraphDiv(ce);
          function Oe(Xe, Je, ot) {
            var lt, st;
            if (a.isTypedArray(Xe)) if (ot <= 0) {
              var xt = new Xe.constructor(0), Et = ae(Je, Xe);
              ot < 0 ? (lt = Et, st = xt) : (lt = xt, st = Et);
            } else if (lt = new Xe.constructor(ot), st = new Xe.constructor(Xe.length + Je.length - ot), ot === Je.length) lt.set(Je), st.set(Xe);
            else if (ot < Je.length) {
              var Bt = Je.length - ot;
              lt.set(Je.subarray(0, Bt)), st.set(Je.subarray(Bt)), st.set(Xe, Bt);
            } else {
              var qt = ot - Je.length;
              lt.set(Je), lt.set(Xe.subarray(0, qt), Je.length), st.set(Xe.subarray(qt));
            }
            else lt = Je.concat(Xe), st = ot >= 0 && ot < lt.length ? lt.splice(ot, lt.length) : [];
            return [lt, st];
          }
          var je = ne(ce, ge, ye, Me, Oe), qe = L.redraw(ce), Qe = [ce, je.update, ye, je.maxPoints];
          return r.add(ce, L.extendTraces, Qe, O, arguments), qe;
        }
        function F(ce, ge, ye) {
          ce = a.getGraphDiv(ce);
          var Me = [], Oe = L.deleteTraces, je = F, qe = [ce, Me], Qe = [ce, ge], Xe, Je;
          for (C(ce, ge, ye), Array.isArray(ge) || (ge = [ge]), ge = ge.map(function(ot) {
            return a.extendFlat({}, ot);
          }), y.cleanData(ge), Xe = 0; Xe < ge.length; Xe++) ce.data.push(ge[Xe]);
          for (Xe = 0; Xe < ge.length; Xe++) Me.push(-ge.length + Xe);
          if (typeof ye > "u") return Je = L.redraw(ce), r.add(ce, Oe, qe, je, Qe), Je;
          Array.isArray(ye) || (ye = [ye]);
          try {
            Y(ce, Me, ye);
          } catch (ot) {
            throw ce.data.splice(ce.data.length - ge.length, ge.length), ot;
          }
          return r.startSequence(ce), r.add(ce, Oe, qe, je, Qe), Je = L.moveTraces(ce, Me, ye), r.stopSequence(ce), Je;
        }
        function S(ce, ge) {
          ce = a.getGraphDiv(ce);
          var ye = [], Me = L.addTraces, Oe = S, je = [ce, ye, ge], qe = [ce, ge], Qe, Xe;
          if (typeof ge > "u") throw new Error("indices must be an integer or array of integers.");
          for (Array.isArray(ge) || (ge = [ge]), Z(ce, ge, "indices"), ge = V(ge, ce.data.length - 1), ge.sort(a.sorterDes), Qe = 0; Qe < ge.length; Qe += 1) Xe = ce.data.splice(ge[Qe], 1)[0], ye.push(Xe);
          var Je = L.redraw(ce);
          return r.add(ce, Me, je, Oe, qe), Je;
        }
        function $(ce, ge, ye) {
          ce = a.getGraphDiv(ce);
          var Me = [], Oe = [], je = $, qe = $, Qe = [ce, ye, ge], Xe = [ce, ge, ye], Je;
          if (Y(ce, ge, ye), ge = Array.isArray(ge) ? ge : [ge], typeof ye > "u") for (ye = [], Je = 0; Je < ge.length; Je++) ye.push(-ge.length + Je);
          for (ye = Array.isArray(ye) ? ye : [ye], ge = V(ge, ce.data.length - 1), ye = V(ye, ce.data.length - 1), Je = 0; Je < ce.data.length; Je++) ge.indexOf(Je) === -1 && Me.push(ce.data[Je]);
          for (Je = 0; Je < ge.length; Je++) Oe.push({ newIndex: ye[Je], trace: ce.data[ge[Je]] });
          for (Oe.sort(function(lt, st) {
            return lt.newIndex - st.newIndex;
          }), Je = 0; Je < Oe.length; Je += 1) Me.splice(Oe[Je].newIndex, 0, Oe[Je].trace);
          ce.data = Me;
          var ot = L.redraw(ce);
          return r.add(ce, je, Qe, qe, Xe), ot;
        }
        function re(ce, ge, ye, Me) {
          ce = a.getGraphDiv(ce), y.clearPromiseQueue(ce);
          var Oe = {};
          if (typeof ge == "string") Oe[ge] = ye;
          else if (a.isPlainObject(ge)) Oe = a.extendFlat({}, ge), Me === void 0 && (Me = ye);
          else return a.warn("Restyle fail.", ge, ye, Me), Promise.reject();
          Object.keys(Oe).length && (ce.changed = !0);
          var je = y.coerceTraceIndices(ce, Me), qe = ee(ce, Oe, je), Qe = qe.flags;
          Qe.calc && (ce.calcdata = void 0), Qe.clearAxisTypes && y.clearAxisTypes(ce, je, {});
          var Xe = [];
          Qe.fullReplot ? Xe.push(L._doPlot) : (Xe.push(t.previousPromises), t.supplyDefaults(ce), Qe.markerSize && (t.doCalcdata(ce), pe(Xe)), Qe.style && Xe.push(_.doTraceStyle), Qe.colorbars && Xe.push(_.doColorBars), Xe.push(B)), Xe.push(t.rehover, t.redrag, t.reselect), r.add(ce, re, [ce, qe.undoit, qe.traces], re, [ce, qe.redoit, qe.traces]);
          var Je = a.syncOrAsync(Xe, ce);
          return (!Je || !Je.then) && (Je = Promise.resolve()), Je.then(function() {
            return ce.emit("plotly_restyle", qe.eventData), ce;
          });
        }
        function E(ce) {
          return ce === void 0 ? null : ce;
        }
        function w(ce, ge) {
          return ge ? function(ye, Me, Oe) {
            var je = i(ye, Me), qe = je.set;
            return je.set = function(Qe) {
              var Xe = (Oe || "") + Me;
              N(Xe, je.get(), Qe, ce), qe(Qe);
            }, je;
          } : i;
        }
        function N(ce, ge, ye, Me) {
          if (Array.isArray(ge) || Array.isArray(ye)) for (var Oe = Array.isArray(ge) ? ge : [], je = Array.isArray(ye) ? ye : [], qe = Math.max(Oe.length, je.length), Qe = 0; Qe < qe; Qe++) N(ce + "[" + Qe + "]", Oe[Qe], je[Qe], Me);
          else if (a.isPlainObject(ge) || a.isPlainObject(ye)) {
            var Xe = a.isPlainObject(ge) ? ge : {}, Je = a.isPlainObject(ye) ? ye : {}, ot = a.extendFlat({}, Xe, Je);
            for (var lt in ot) N(ce + "." + lt, Xe[lt], Je[lt], Me);
          } else Me[ce] === void 0 && (Me[ce] = E(ge));
        }
        function W(ce, ge, ye) {
          for (var Me in ye) {
            var Oe = i(ce, Me);
            N(Me, Oe.get(), ye[Me], ge);
          }
        }
        function ee(ce, ge, ye) {
          var Me = ce._fullLayout, Oe = ce._fullData, je = ce.data, qe = Me._guiEditing, Qe = w(Me._preGUI, qe), Xe = a.extendDeepAll({}, ge), Je, ot = T.traceFlags(), lt = {}, st = {}, xt;
          function Et() {
            return ye.map(function() {
            });
          }
          function Bt(at) {
            var vt = p.id2name(at);
            xt.indexOf(vt) === -1 && xt.push(vt);
          }
          function qt(at) {
            return "LAYOUT" + at + ".autorange";
          }
          function jt(at) {
            return "LAYOUT" + at + ".range";
          }
          function It(at) {
            for (var vt = at; vt < Oe.length; vt++) if (Oe[vt]._input === je[at]) return Oe[vt];
          }
          function Tt(at, vt, kt) {
            if (Array.isArray(at)) {
              at.forEach(function(Pt) {
                Tt(Pt, vt, kt);
              });
              return;
            }
            if (!(at in ge || y.hasParent(ge, at))) {
              var At;
              if (at.substr(0, 6) === "LAYOUT") At = Qe(ce.layout, at.replace("LAYOUT", ""));
              else {
                var Nt = ye[kt], Mt = Me._tracePreGUI[It(Nt)._fullInput.uid];
                At = w(Mt, qe)(je[Nt], at);
              }
              at in st || (st[at] = Et()), st[at][kt] === void 0 && (st[at][kt] = E(At.get())), vt !== void 0 && At.set(vt);
            }
          }
          function Rt(at) {
            return function(vt) {
              return Oe[vt][at];
            };
          }
          function Vt(at) {
            return function(vt, kt) {
              return vt === !1 ? Oe[ye[kt]][at] : null;
            };
          }
          for (var Ft in ge) {
            if (y.hasParent(ge, Ft)) throw new Error("cannot set " + Ft + " and a parent attribute simultaneously");
            var Dt = ge[Ft], Ct, Ot, Wt, rr, Ut, Qt;
            if ((Ft === "autobinx" || Ft === "autobiny") && (Ft = Ft.charAt(Ft.length - 1) + "bins", Array.isArray(Dt) ? Dt = Dt.map(Vt(Ft)) : Dt === !1 ? Dt = ye.map(Rt(Ft)) : Dt = null), lt[Ft] = Dt, Ft.substr(0, 6) === "LAYOUT") {
              Wt = Qe(ce.layout, Ft.replace("LAYOUT", "")), st[Ft] = [E(Wt.get())], Wt.set(Array.isArray(Dt) ? Dt[0] : Dt), ot.calc = !0;
              continue;
            }
            for (st[Ft] = Et(), Je = 0; Je < ye.length; Je++) {
              Ct = je[ye[Je]], Ot = It(ye[Je]);
              var nr = Me._tracePreGUI[Ot._fullInput.uid];
              if (Wt = w(nr, qe)(Ct, Ft), rr = Wt.get(), Ut = Array.isArray(Dt) ? Dt[Je % Dt.length] : Dt, Ut !== void 0) {
                var cr = Wt.parts[Wt.parts.length - 1], lr = Ft.substr(0, Ft.length - cr.length - 1), $t = lr ? lr + "." : "", sr = lr ? i(Ot, lr).get() : Ot;
                if (Qt = c.getTraceValObject(Ot, Wt.parts), Qt && Qt.impliedEdits && Ut !== null) for (var St in Qt.impliedEdits) Tt(a.relativeAttr(Ft, St), Qt.impliedEdits[St], Je);
                else if ((cr === "thicknessmode" || cr === "lenmode") && rr !== Ut && (Ut === "fraction" || Ut === "pixels") && sr) {
                  var Kt = Me._size, hr = sr.orient, he = hr === "top" || hr === "bottom";
                  if (cr === "thicknessmode") {
                    var fe = he ? Kt.h : Kt.w;
                    Tt($t + "thickness", sr.thickness * (Ut === "fraction" ? 1 / fe : fe), Je);
                  } else {
                    var Pe = he ? Kt.w : Kt.h;
                    Tt($t + "len", sr.len * (Ut === "fraction" ? 1 / Pe : Pe), Je);
                  }
                } else if (Ft === "type" && (Ut === "pie" != (rr === "pie") || Ut === "funnelarea" != (rr === "funnelarea"))) {
                  var Re = "x", Ye = "y";
                  (Ut === "bar" || rr === "bar") && Ct.orientation === "h" && (Re = "y", Ye = "x"), a.swapAttrs(Ct, ["?", "?src"], "labels", Re), a.swapAttrs(Ct, ["d?", "?0"], "label", Re), a.swapAttrs(Ct, ["?", "?src"], "values", Ye), rr === "pie" || rr === "funnelarea" ? (i(Ct, "marker.color").set(i(Ct, "marker.colors").get()), Me._pielayer.selectAll("g.trace").remove()) : s.traceIs(Ct, "cartesian") && i(Ct, "marker.colors").set(i(Ct, "marker.color").get());
                }
                st[Ft][Je] = E(rr);
                var Ee = ["swapxy", "swapxyaxes", "orientation", "orientationaxes"];
                if (Ee.indexOf(Ft) !== -1) {
                  if (Ft === "orientation") {
                    Wt.set(Ut);
                    var ze = Ct.x && !Ct.y ? "h" : "v";
                    if ((Wt.get() || ze) === Ot.orientation) continue;
                  } else Ft === "orientationaxes" && (Ct.orientation = { v: "h", h: "v" }[Ot.orientation]);
                  y.swapXYData(Ct), ot.calc = ot.clearAxisTypes = !0;
                } else t.dataArrayContainers.indexOf(Wt.parts[0]) !== -1 ? (y.manageArrayContainers(Wt, Ut, st), ot.calc = !0) : (Qt ? Qt.arrayOk && !s.traceIs(Ot, "regl") && (a.isArrayOrTypedArray(Ut) || a.isArrayOrTypedArray(rr)) ? ot.calc = !0 : T.update(ot, Qt) : ot.calc = !0, Wt.set(Ut));
              }
            }
            if (["swapxyaxes", "orientationaxes"].indexOf(Ft) !== -1 && p.swap(ce, ye), Ft === "orientationaxes") {
              var Ge = i(ce.layout, "hovermode"), Ve = Ge.get();
              Ve === "x" ? Ge.set("y") : Ve === "y" ? Ge.set("x") : Ve === "x unified" ? Ge.set("y unified") : Ve === "y unified" && Ge.set("x unified");
            }
            if (["orientation", "type"].indexOf(Ft) !== -1) {
              for (xt = [], Je = 0; Je < ye.length; Je++) {
                var tt = je[ye[Je]];
                s.traceIs(tt, "cartesian") && (Bt(tt.xaxis || "x"), Bt(tt.yaxis || "y"));
              }
              Tt(xt.map(qt), !0, 0), Tt(xt.map(jt), [0, 1], 0);
            }
          }
          return (ot.calc || ot.plot) && (ot.fullReplot = !0), { flags: ot, undoit: st, redoit: lt, traces: ye, eventData: a.extendDeepNoArrays([], [Xe, ye]) };
        }
        function le(ce, ge, ye) {
          ce = a.getGraphDiv(ce), y.clearPromiseQueue(ce);
          var Me = {};
          if (typeof ge == "string") Me[ge] = ye;
          else if (a.isPlainObject(ge)) Me = a.extendFlat({}, ge);
          else return a.warn("Relayout fail.", ge, ye), Promise.reject();
          Object.keys(Me).length && (ce.changed = !0);
          var Oe = Ue(ce, Me), je = Oe.flags;
          je.calc && (ce.calcdata = void 0);
          var qe = [t.previousPromises];
          je.layoutReplot ? qe.push(_.layoutReplot) : Object.keys(Me).length && (ie(ce, je, Oe) || t.supplyDefaults(ce), je.legend && qe.push(_.doLegend), je.layoutstyle && qe.push(_.layoutStyles), je.axrange && pe(qe, Oe.rangesAltered), je.ticks && qe.push(_.doTicksRelayout), je.modebar && qe.push(_.doModeBar), je.camera && qe.push(_.doCamera), je.colorbars && qe.push(_.doColorBars), qe.push(B)), qe.push(t.rehover, t.redrag, t.reselect), r.add(ce, le, [ce, Oe.undoit], le, [ce, Oe.redoit]);
          var Qe = a.syncOrAsync(qe, ce);
          return (!Qe || !Qe.then) && (Qe = Promise.resolve(ce)), Qe.then(function() {
            return ce.emit("plotly_relayout", Oe.eventData), ce;
          });
        }
        function ie(ce, ge, ye) {
          var Me = ce._fullLayout;
          if (!ge.axrange) return !1;
          for (var Oe in ge) if (Oe !== "axrange" && ge[Oe]) return !1;
          var je, qe, Qe = function(xt, Et) {
            return a.coerce(je, qe, f, xt, Et);
          }, Xe = {};
          for (var Je in ye.rangesAltered) {
            var ot = p.id2name(Je);
            if (je = ce.layout[ot], qe = Me[ot], l(je, qe, Qe, Xe), qe._matchGroup) {
              for (var lt in qe._matchGroup) if (lt !== Je) {
                var st = Me[p.id2name(lt)];
                st.autorange = qe.autorange, st.range = qe.range.slice(), st._input.range = qe.range.slice();
              }
            }
          }
          return !0;
        }
        function pe(ce, ge) {
          var ye = ge ? function(Me) {
            var Oe = [], je = !0;
            for (var qe in ge) {
              var Qe = p.getFromId(Me, qe);
              if (Oe.push(qe), (Qe.ticklabelposition || "").indexOf("inside") !== -1 && Qe._anchorAxis && Oe.push(Qe._anchorAxis._id), Qe._matchGroup) for (var Xe in Qe._matchGroup) ge[Xe] || Oe.push(Xe);
            }
            return p.draw(Me, Oe, { skipTitle: je });
          } : function(Me) {
            return p.draw(Me, "redraw");
          };
          ce.push(m, _.doAutoRangeAndConstraints, ye, _.drawData, _.finalDraw);
        }
        var _e = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/, Ae = /^[xyz]axis[0-9]*\.autorange$/, Ce = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
        function Ue(ce, ge) {
          var ye = ce.layout, Me = ce._fullLayout, Oe = Me._guiEditing, je = w(Me._preGUI, Oe), qe = Object.keys(ge), Qe = p.list(ce), Xe = a.extendDeepAll({}, ge), Je = {}, ot, lt, st;
          for (qe = Object.keys(ge), lt = 0; lt < qe.length; lt++) if (qe[lt].indexOf("allaxes") === 0) {
            for (st = 0; st < Qe.length; st++) {
              var xt = Qe[st]._id.substr(1), Et = xt.indexOf("scene") !== -1 ? xt + "." : "", Bt = qe[lt].replace("allaxes", Et + Qe[st]._name);
              ge[Bt] || (ge[Bt] = ge[qe[lt]]);
            }
            delete ge[qe[lt]];
          }
          var qt = T.layoutFlags(), jt = {}, It = {};
          function Tt(Mt, Pt) {
            if (Array.isArray(Mt)) {
              Mt.forEach(function(ur) {
                Tt(ur, Pt);
              });
              return;
            }
            if (!(Mt in ge || y.hasParent(ge, Mt))) {
              var Lt = je(ye, Mt);
              Mt in It || (It[Mt] = E(Lt.get())), Pt !== void 0 && Lt.set(Pt);
            }
          }
          var Rt = {}, Vt;
          function Ft(Mt) {
            var Pt = p.name2id(Mt.split(".")[0]);
            return Rt[Pt] = 1, Pt;
          }
          for (var Dt in ge) {
            if (y.hasParent(ge, Dt)) throw new Error("cannot set " + Dt + " and a parent attribute simultaneously");
            for (var Ct = je(ye, Dt), Ot = ge[Dt], Wt = Ct.parts.length, rr = Wt - 1; rr > 0 && typeof Ct.parts[rr] != "string"; ) rr--;
            var Ut = Ct.parts[rr], Qt = Ct.parts[rr - 1] + "." + Ut, nr = Ct.parts.slice(0, rr).join("."), cr = i(ce.layout, nr).get(), lr = i(Me, nr).get(), $t = Ct.get();
            if (Ot !== void 0) {
              jt[Dt] = Ot, It[Dt] = Ut === "reverse" ? Ot : E($t);
              var sr = c.getLayoutValObject(Me, Ct.parts);
              if (sr && sr.impliedEdits && Ot !== null) for (var St in sr.impliedEdits) Tt(a.relativeAttr(Dt, St), sr.impliedEdits[St]);
              if (["width", "height"].indexOf(Dt) !== -1) if (Ot) {
                Tt("autosize", null);
                var Kt = Dt === "height" ? "width" : "height";
                Tt(Kt, Me[Kt]);
              } else Me[Dt] = ce._initialAutoSize[Dt];
              else if (Dt === "autosize") Tt("width", Ot ? null : Me.width), Tt("height", Ot ? null : Me.height);
              else if (Qt.match(_e)) Ft(Qt), i(Me, nr + "._inputRange").set(null);
              else if (Qt.match(Ae)) {
                Ft(Qt), i(Me, nr + "._inputRange").set(null);
                var hr = i(Me, nr).get();
                hr._inputDomain && (hr._input.domain = hr._inputDomain.slice());
              } else Qt.match(Ce) && i(Me, nr + "._inputDomain").set(null);
              if (Ut === "type") {
                Vt = cr;
                var he = lr.type === "linear" && Ot === "log", fe = lr.type === "log" && Ot === "linear";
                if (he || fe) {
                  if (!Vt || !Vt.range) Tt(nr + ".autorange", !0);
                  else if (lr.autorange) he && (Vt.range = Vt.range[1] > Vt.range[0] ? [1, 2] : [2, 1]);
                  else {
                    var Pe = Vt.range[0], Re = Vt.range[1];
                    he ? (Pe <= 0 && Re <= 0 && Tt(nr + ".autorange", !0), Pe <= 0 ? Pe = Re / 1e6 : Re <= 0 && (Re = Pe / 1e6), Tt(nr + ".range[0]", Math.log(Pe) / Math.LN10), Tt(nr + ".range[1]", Math.log(Re) / Math.LN10)) : (Tt(nr + ".range[0]", Math.pow(10, Pe)), Tt(nr + ".range[1]", Math.pow(10, Re)));
                  }
                  Array.isArray(Me._subplots.polar) && Me._subplots.polar.length && Me[Ct.parts[0]] && Ct.parts[1] === "radialaxis" && delete Me[Ct.parts[0]]._subplot.viewInitial["radialaxis.range"], s.getComponentMethod("annotations", "convertCoords")(ce, lr, Ot, Tt), s.getComponentMethod("images", "convertCoords")(ce, lr, Ot, Tt);
                } else Tt(nr + ".autorange", !0), Tt(nr + ".range", null);
                i(Me, nr + "._inputRange").set(null);
              } else if (Ut.match(R)) {
                var Ye = i(Me, Dt).get(), Ee = (Ot || {}).type;
                (!Ee || Ee === "-") && (Ee = "linear"), s.getComponentMethod("annotations", "convertCoords")(ce, Ye, Ee, Tt), s.getComponentMethod("images", "convertCoords")(ce, Ye, Ee, Tt);
              }
              var ze = d.containerArrayMatch(Dt);
              if (ze) {
                ot = ze.array, lt = ze.index;
                var Ge = ze.property, Ve = sr || { editType: "calc" };
                lt !== "" && Ge === "" && (d.isAddVal(Ot) ? It[Dt] = null : d.isRemoveVal(Ot) ? It[Dt] = (i(ye, ot).get() || [])[lt] : a.warn("unrecognized full object value", ge)), T.update(qt, Ve), Je[ot] || (Je[ot] = {});
                var tt = Je[ot][lt];
                tt || (tt = Je[ot][lt] = {}), tt[Ge] = Ot, delete ge[Dt];
              } else Ut === "reverse" ? (cr.range ? cr.range.reverse() : (Tt(nr + ".autorange", !0), cr.range = [1, 0]), lr.autorange ? qt.calc = !0 : qt.plot = !0) : (Dt === "dragmode" && (Ot === !1 && $t !== !1 || Ot !== !1 && $t === !1) || Me._has("scatter-like") && Me._has("regl") && Dt === "dragmode" && (Ot === "lasso" || Ot === "select") && !($t === "lasso" || $t === "select") ? qt.plot = !0 : sr ? T.update(qt, sr) : qt.calc = !0, Ct.set(Ot));
            }
          }
          for (ot in Je) {
            var at = d.applyContainerArrayChanges(ce, je(ye, ot), Je[ot], qt, je);
            at || (qt.plot = !0);
          }
          for (var vt in Rt) {
            Vt = p.getFromId(ce, vt);
            var kt = Vt && Vt._constraintGroup;
            if (kt) {
              qt.calc = !0;
              for (var At in kt) Rt[At] || (p.getFromId(ce, At)._constraintShrinkable = !0);
            }
          }
          (Ne(ce) || ge.height || ge.width) && (qt.plot = !0);
          var Nt = Me.shapes;
          for (lt = 0; lt < Nt.length; lt++) if (Nt[lt].showlegend) {
            qt.calc = !0;
            break;
          }
          return (qt.plot || qt.calc) && (qt.layoutReplot = !0), { flags: qt, rangesAltered: Rt, undoit: It, redoit: jt, eventData: Xe };
        }
        function Ne(ce) {
          var ge = ce._fullLayout, ye = ge.width, Me = ge.height;
          return ce.layout.autosize && t.plotAutoSize(ce, ce.layout, ge), ge.width !== ye || ge.height !== Me;
        }
        function ke(ce, ge, ye, Me) {
          ce = a.getGraphDiv(ce), y.clearPromiseQueue(ce), a.isPlainObject(ge) || (ge = {}), a.isPlainObject(ye) || (ye = {}), Object.keys(ge).length && (ce.changed = !0), Object.keys(ye).length && (ce.changed = !0);
          var Oe = y.coerceTraceIndices(ce, Me), je = ee(ce, a.extendFlat({}, ge), Oe), qe = je.flags, Qe = Ue(ce, a.extendFlat({}, ye)), Xe = Qe.flags;
          (qe.calc || Xe.calc) && (ce.calcdata = void 0), qe.clearAxisTypes && y.clearAxisTypes(ce, Oe, ye);
          var Je = [];
          Xe.layoutReplot ? Je.push(_.layoutReplot) : qe.fullReplot ? Je.push(L._doPlot) : (Je.push(t.previousPromises), ie(ce, Xe, Qe) || t.supplyDefaults(ce), qe.style && Je.push(_.doTraceStyle), (qe.colorbars || Xe.colorbars) && Je.push(_.doColorBars), Xe.legend && Je.push(_.doLegend), Xe.layoutstyle && Je.push(_.layoutStyles), Xe.axrange && pe(Je, Qe.rangesAltered), Xe.ticks && Je.push(_.doTicksRelayout), Xe.modebar && Je.push(_.doModeBar), Xe.camera && Je.push(_.doCamera), Je.push(B)), Je.push(t.rehover, t.redrag, t.reselect), r.add(ce, ke, [ce, je.undoit, Qe.undoit, je.traces], ke, [ce, je.redoit, Qe.redoit, je.traces]);
          var ot = a.syncOrAsync(Je, ce);
          return (!ot || !ot.then) && (ot = Promise.resolve(ce)), ot.then(function() {
            return ce.emit("plotly_update", { data: je.eventData, layout: Qe.eventData }), ce;
          });
        }
        function A(ce) {
          return function(ge) {
            ge._fullLayout._guiEditing = !0;
            var ye = ce.apply(null, arguments);
            return ge._fullLayout._guiEditing = !1, ye;
          };
        }
        var X = [{ pattern: /^hiddenlabels/, attr: "legend.uirevision" }, { pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/ }, { pattern: /axis\d*\.showspikes$/, attr: "modebar.uirevision" }, { pattern: /(hover|drag)mode$/, attr: "modebar.uirevision" }, { pattern: /^(scene\d*)\.camera/ }, { pattern: /^(geo\d*)\.(projection|center|fitbounds)/ }, { pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/ }, { pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/ }, { pattern: /^(polar\d*\.angularaxis)\.rotation/ }, { pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/ }, { pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/ }, { pattern: /^legend\.(x|y)$/, attr: "editrevision" }, { pattern: /^(shapes|annotations)/, attr: "editrevision" }, { pattern: /^title\.text$/, attr: "editrevision" }], H = [{ pattern: /^selectedpoints$/, attr: "selectionrevision" }, { pattern: /(^|value\.)visible$/, attr: "legend.uirevision" }, { pattern: /^dimensions\[\d+\]\.constraintrange/ }, { pattern: /^node\.(x|y|groups)/ }, { pattern: /^level$/ }, { pattern: /(^|value\.)name$/ }, { pattern: /colorbar\.title\.text$/ }, { pattern: /colorbar\.(x|y)$/, attr: "editrevision" }];
        function ve(ce, ge) {
          for (var ye = 0; ye < ge.length; ye++) {
            var Me = ge[ye], Oe = ce.match(Me.pattern);
            if (Oe) {
              var je = Oe[1] || "";
              return { head: je, tail: ce.substr(je.length + 1), attr: Me.attr };
            }
          }
        }
        function be(ce, ge) {
          var ye = i(ge, ce).get();
          if (ye !== void 0) return ye;
          var Me = ce.split(".");
          for (Me.pop(); Me.length > 1; ) if (Me.pop(), ye = i(ge, Me.join(".") + ".uirevision").get(), ye !== void 0) return ye;
          return ge.uirevision;
        }
        function Se(ce, ge) {
          for (var ye = 0; ye < ge.length; ye++) if (ge[ye]._fullInput.uid === ce) return ye;
          return -1;
        }
        function De(ce, ge, ye) {
          for (var Me = 0; Me < ge.length; Me++) if (ge[Me].uid === ce) return Me;
          return !ge[ye] || ge[ye].uid ? -1 : ye;
        }
        function He(ce, ge) {
          var ye = a.isPlainObject(ce), Me = Array.isArray(ce);
          return ye || Me ? (ye && a.isPlainObject(ge) || Me && Array.isArray(ge)) && JSON.stringify(ce) === JSON.stringify(ge) : ce === ge;
        }
        function Ze(ce, ge, ye, Me) {
          var Oe = Me._preGUI, je, qe, Qe, Xe, Je, ot, lt, st, xt, Et, Bt = [], qt = {}, jt = {};
          for (je in Oe) {
            if (Je = ve(je, X), Je) {
              if (xt = Je.head, Et = Je.tail, qe = Je.attr || xt + ".uirevision", Qe = i(Me, qe).get(), Xe = Qe && be(qe, ge), Xe && Xe === Qe) {
                if (ot = Oe[je], ot === null && (ot = void 0), lt = i(ge, je), st = lt.get(), He(st, ot)) {
                  st === void 0 && Et === "autorange" && Bt.push(xt), lt.set(E(i(Me, je).get()));
                  continue;
                } else if (Et === "autorange" || Et.substr(0, 6) === "range[") {
                  var It = Oe[xt + ".range[0]"], Tt = Oe[xt + ".range[1]"], Rt = Oe[xt + ".autorange"];
                  if (Rt || Rt === null && It === null && Tt === null) {
                    if (!(xt in qt)) {
                      var Vt = i(ge, xt).get();
                      qt[xt] = Vt && (Vt.autorange || Vt.autorange !== !1 && (!Vt.range || Vt.range.length !== 2));
                    }
                    if (qt[xt]) {
                      lt.set(E(i(Me, je).get()));
                      continue;
                    }
                  }
                }
              }
            } else a.warn("unrecognized GUI edit: " + je);
            delete Oe[je], Je && Je.tail.substr(0, 6) === "range[" && (jt[Je.head] = 1);
          }
          for (var Ft = 0; Ft < Bt.length; Ft++) {
            var Dt = Bt[Ft];
            if (jt[Dt]) {
              var Ct = i(ge, Dt).get();
              Ct && delete Ct.autorange;
            }
          }
          var Ot = Me._tracePreGUI;
          for (var Wt in Ot) {
            var rr = Ot[Wt], Ut = null, Qt;
            for (je in rr) {
              if (!Ut) {
                var nr = Se(Wt, ye);
                if (nr < 0) {
                  delete Ot[Wt];
                  break;
                }
                var cr = ye[nr];
                Qt = cr._fullInput;
                var lr = De(Wt, ce, Qt.index);
                if (lr < 0) {
                  delete Ot[Wt];
                  break;
                }
                Ut = ce[lr];
              }
              if (Je = ve(je, H), Je) {
                if (Je.attr ? (Qe = i(Me, Je.attr).get(), Xe = Qe && be(Je.attr, ge)) : (Qe = Qt.uirevision, Xe = Ut.uirevision, Xe === void 0 && (Xe = ge.uirevision)), Xe && Xe === Qe && (ot = rr[je], ot === null && (ot = void 0), lt = i(Ut, je), st = lt.get(), He(st, ot))) {
                  lt.set(E(i(Qt, je).get()));
                  continue;
                }
              } else a.warn("unrecognized GUI edit: " + je + " in trace uid " + Wt);
              delete rr[je];
            }
          }
        }
        function We(ce, ge, ye, Me) {
          var Oe, je;
          function qe() {
            return L.addFrames(ce, Oe);
          }
          ce = a.getGraphDiv(ce), y.clearPromiseQueue(ce);
          var Qe = ce._fullData, Xe = ce._fullLayout;
          if (!a.isPlotDiv(ce) || !Qe || !Xe) je = L.newPlot(ce, ge, ye, Me);
          else {
            if (a.isPlainObject(ge)) {
              var Je = ge;
              ge = Je.data, ye = Je.layout, Me = Je.config, Oe = Je.frames;
            }
            var ot = !1;
            if (Me) {
              let Qt = a.extendDeepAll({}, ce._context);
              ce._context = void 0, G(ce, Me), ot = !y.collectionsAreEqual(Qt, ce._context);
            }
            if (ot) {
              let Qt = ce._ev.eventNames().map((nr) => [nr, ce._ev.listeners(nr)]);
              je = L.newPlot(ce, ge, ye, Me).then(() => {
                for (let [nr, cr] of Qt) cr.forEach((lr) => ce.on(nr, lr));
                return L.react(ce, ge, ye, Me);
              });
            } else {
              ce.data = ge || [], y.cleanData(ce.data), ce.layout = ye || {}, y.cleanLayout(ce.layout), Ze(ce.data, ce.layout, Qe, Xe), t.supplyDefaults(ce, { skipUpdateCalc: !0 });
              var lt = ce._fullData, st = ce._fullLayout, xt = st.datarevision === void 0, Et = st.transition, Bt = it(ce, Xe, st, xt, Et), qt = Bt.newDataRevision, jt = $e(ce, Qe, lt, xt, Et, qt);
              if (Ne(ce) && (Bt.layoutReplot = !0), jt.calc || Bt.calc) {
                ce.calcdata = void 0;
                for (var It = Object.getOwnPropertyNames(st), Tt = 0; Tt < It.length; Tt++) {
                  var Rt = It[Tt], Vt = Rt.substring(0, 5);
                  if (Vt === "xaxis" || Vt === "yaxis") {
                    var Ft = st[Rt]._emptyCategories;
                    Ft && Ft();
                  }
                }
              } else t.supplyDefaultsUpdateCalc(ce.calcdata, lt);
              var Dt = [];
              if (Oe && (ce._transitionData = {}, t.createTransitionData(ce), Dt.push(qe)), st.transition && (jt.anim || Bt.anim)) Bt.ticks && Dt.push(_.doTicksRelayout), t.doCalcdata(ce), _.doAutoRangeAndConstraints(ce), Dt.push(function() {
                return t.transitionFromReact(ce, jt, Bt, Xe);
              });
              else if (jt.fullReplot || Bt.layoutReplot) ce._fullLayout._skipDefaults = !0, Dt.push(L._doPlot);
              else {
                for (var Ct in Bt.arrays) {
                  var Ot = Bt.arrays[Ct];
                  if (Ot.length) {
                    var Wt = s.getComponentMethod(Ct, "drawOne");
                    if (Wt !== a.noop) for (var rr = 0; rr < Ot.length; rr++) Wt(ce, Ot[rr]);
                    else {
                      var Ut = s.getComponentMethod(Ct, "draw");
                      if (Ut === a.noop) throw new Error("cannot draw components: " + Ct);
                      Ut(ce);
                    }
                  }
                }
                Dt.push(t.previousPromises), jt.style && Dt.push(_.doTraceStyle), (jt.colorbars || Bt.colorbars) && Dt.push(_.doColorBars), Bt.legend && Dt.push(_.doLegend), Bt.layoutstyle && Dt.push(_.layoutStyles), Bt.axrange && pe(Dt), Bt.ticks && Dt.push(_.doTicksRelayout), Bt.modebar && Dt.push(_.doModeBar), Bt.camera && Dt.push(_.doCamera), Dt.push(B);
              }
              Dt.push(t.rehover, t.redrag, t.reselect), je = a.syncOrAsync(Dt, ce), (!je || !je.then) && (je = Promise.resolve(ce));
            }
          }
          return je.then(() => (ot || ce.emit("plotly_react", { config: Me, data: ge, layout: ye }), ce));
        }
        function $e(ce, ge, ye, Me, Oe, je) {
          var qe = ge.length === ye.length;
          if (!Oe && !qe) return { fullReplot: !0, calc: !0 };
          var Qe = T.traceFlags();
          Qe.arrays = {}, Qe.nChanges = 0, Qe.nChangesAnim = 0;
          var Xe, Je;
          function ot(xt) {
            var Et = c.getTraceValObject(Je, xt);
            return !Je._module.animatable && Et.anim && (Et.anim = !1), Et;
          }
          var lt = { getValObject: ot, flags: Qe, immutable: Me, transition: Oe, newDataRevision: je, gd: ce }, st = {};
          for (Xe = 0; Xe < ge.length; Xe++) if (ye[Xe]) {
            if (Je = ye[Xe]._fullInput, st[Je.uid]) continue;
            st[Je.uid] = 1, Ke(ge[Xe]._fullInput, Je, [], lt);
          }
          return (Qe.calc || Qe.plot) && (Qe.fullReplot = !0), Oe && Qe.nChanges && Qe.nChangesAnim && (Qe.anim = Qe.nChanges === Qe.nChangesAnim && qe ? "all" : "some"), Qe;
        }
        function it(ce, ge, ye, Me, Oe) {
          var je = T.layoutFlags();
          je.arrays = {}, je.rangesAltered = {}, je.nChanges = 0, je.nChangesAnim = 0;
          function qe(st) {
            return c.getLayoutValObject(ye, st);
          }
          for (var Qe in ye) if (!(!Qe.startsWith("xaxis") && !Qe.startsWith("yaxis")) && ge[Qe]) {
            var Xe = ye[Qe].domain, Je = ge[Qe].domain, ot = ge[Qe]._inputDomain;
            ge[Qe]._inputDomain && (Xe[0] === ot[0] && Xe[1] === ot[1] ? ye[Qe].domain = ge[Qe].domain : (Xe[0] !== Je[0] || Xe[1] !== Je[1]) && (ye[Qe]._inputDomain = null));
          }
          var lt = { getValObject: qe, flags: je, immutable: Me, transition: Oe, gd: ce };
          return Ke(ge, ye, [], lt), (je.plot || je.calc) && (je.layoutReplot = !0), Oe && je.nChanges && je.nChangesAnim && (je.anim = je.nChanges === je.nChangesAnim ? "all" : "some"), je;
        }
        function Ke(ce, ge, ye, Me) {
          var Oe, je, qe, Qe = Me.getValObject, Xe = Me.flags, Je = Me.immutable, ot = Me.inArray, lt = Me.arrayIndex;
          function st() {
            var nr = Oe.editType;
            if (ot && nr.indexOf("arraydraw") !== -1) {
              a.pushUnique(Xe.arrays[ot], lt);
              return;
            }
            T.update(Xe, Oe), nr !== "none" && Xe.nChanges++, Me.transition && Oe.anim && Xe.nChangesAnim++, (_e.test(qe) || Ae.test(qe)) && (Xe.rangesAltered[ye[0]] = 1), je === "datarevision" && (Xe.newDataRevision = 1);
          }
          function xt(nr) {
            return nr.valType === "data_array" || nr.arrayOk;
          }
          for (je in ce) {
            if (Xe.calc && !Me.transition) return;
            var Et = ce[je], Bt = ge[je], qt = ye.concat(je);
            if (qe = qt.join("."), !(je.charAt(0) === "_" || typeof Et == "function" || Et === Bt)) {
              if ((je === "tick0" || je === "dtick") && ye[0] !== "geo") {
                var jt = ge.tickmode;
                if (jt === "auto" || jt === "array" || !jt) continue;
              }
              if (!(je === "range" && ge.autorange) && !((je === "zmin" || je === "zmax") && ge.type === "contourcarpet") && (Oe = Qe(qt), !!Oe && !(Oe._compareAsJSON && JSON.stringify(Et) === JSON.stringify(Bt)))) {
                var It = Oe.valType, Tt, Rt = xt(Oe), Vt = Array.isArray(Et), Ft = Array.isArray(Bt);
                if (Vt && Ft) {
                  var Dt = "_input_" + je, Ct = ce[Dt], Ot = ge[Dt];
                  if (Array.isArray(Ct) && Ct === Ot) continue;
                }
                if (Bt === void 0) Rt && Vt ? Xe.calc = !0 : st();
                else if (Oe._isLinkedToArray) {
                  var Wt = [], rr = !1;
                  ot || (Xe.arrays[je] = Wt);
                  var Ut = Math.min(Et.length, Bt.length), Qt = Math.max(Et.length, Bt.length);
                  if (Ut !== Qt) if (Oe.editType === "arraydraw") rr = !0;
                  else {
                    st();
                    continue;
                  }
                  for (Tt = 0; Tt < Ut; Tt++) Ke(Et[Tt], Bt[Tt], qt.concat(Tt), a.extendFlat({ inArray: je, arrayIndex: Tt }, Me));
                  if (rr) for (Tt = Ut; Tt < Qt; Tt++) Wt.push(Tt);
                } else !It && a.isPlainObject(Et) ? Ke(Et, Bt, qt, Me) : Rt ? Vt && Ft ? (Je && (Xe.calc = !0), (Je || Me.newDataRevision) && st()) : Vt !== Ft ? Xe.calc = !0 : st() : Vt && Ft ? (Et.length !== Bt.length || String(Et) !== String(Bt)) && st() : st();
              }
            }
          }
          for (je in ge) if (!(je in ce || je.charAt(0) === "_" || typeof ge[je] == "function")) if (Oe = Qe(ye.concat(je)), xt(Oe) && Array.isArray(ge[je])) {
            Xe.calc = !0;
            return;
          } else st();
        }
        function ct(ce, ge, ye) {
          if (ce = a.getGraphDiv(ce), !a.isPlotDiv(ce)) throw new Error("This element is not a Plotly plot: " + ce + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
          var Me = ce._transitionData;
          Me._frameQueue || (Me._frameQueue = []), ye = t.supplyAnimationDefaults(ye);
          var Oe = ye.transition, je = ye.frame;
          Me._frameWaitingCnt === void 0 && (Me._frameWaitingCnt = 0);
          function qe(Je) {
            return Array.isArray(Oe) ? Je >= Oe.length ? Oe[0] : Oe[Je] : Oe;
          }
          function Qe(Je) {
            return Array.isArray(je) ? Je >= je.length ? je[0] : je[Je] : je;
          }
          function Xe(Je, ot) {
            var lt = 0;
            return function() {
              if (Je && ++lt === ot) return Je();
            };
          }
          return new Promise(function(Je, ot) {
            function lt() {
              if (Me._frameQueue.length !== 0) {
                for (; Me._frameQueue.length; ) {
                  var Ut = Me._frameQueue.pop();
                  Ut.onInterrupt && Ut.onInterrupt();
                }
                ce.emit("plotly_animationinterrupted", []);
              }
            }
            function st(Ut) {
              if (Ut.length !== 0) {
                for (var Qt = 0; Qt < Ut.length; Qt++) {
                  var nr;
                  Ut[Qt].type === "byname" ? nr = t.computeFrame(ce, Ut[Qt].name) : nr = Ut[Qt].data;
                  var cr = Qe(Qt), lr = qe(Qt);
                  lr.duration = Math.min(lr.duration, cr.duration);
                  var $t = { frame: nr, name: Ut[Qt].name, frameOpts: cr, transitionOpts: lr };
                  Qt === Ut.length - 1 && ($t.onComplete = Xe(Je, 2), $t.onInterrupt = ot), Me._frameQueue.push($t);
                }
                ye.mode === "immediate" && (Me._lastFrameAt = -1 / 0), Me._animationRaf || Bt();
              }
            }
            function xt() {
              ce.emit("plotly_animated"), window.cancelAnimationFrame(Me._animationRaf), Me._animationRaf = null;
            }
            function Et() {
              Me._currentFrame && Me._currentFrame.onComplete && Me._currentFrame.onComplete();
              var Ut = Me._currentFrame = Me._frameQueue.shift();
              if (Ut) {
                var Qt = Ut.name ? Ut.name.toString() : null;
                ce._fullLayout._currentFrame = Qt, Me._lastFrameAt = Date.now(), Me._timeToNext = Ut.frameOpts.duration, t.transition(ce, Ut.frame.data, Ut.frame.layout, y.coerceTraceIndices(ce, Ut.frame.traces), Ut.frameOpts, Ut.transitionOpts).then(function() {
                  Ut.onComplete && Ut.onComplete();
                }), ce.emit("plotly_animatingframe", { name: Qt, frame: Ut.frame, animation: { frame: Ut.frameOpts, transition: Ut.transitionOpts } });
              } else xt();
            }
            function Bt() {
              ce.emit("plotly_animating"), Me._lastFrameAt = -1 / 0, Me._timeToNext = 0, Me._runningTransitions = 0, Me._currentFrame = null;
              var Ut = function() {
                Me._animationRaf = window.requestAnimationFrame(Ut), Date.now() - Me._lastFrameAt > Me._timeToNext && Et();
              };
              Ut();
            }
            var qt = 0;
            function jt(Ut) {
              return Array.isArray(Oe) ? qt >= Oe.length ? Ut.transitionOpts = Oe[qt] : Ut.transitionOpts = Oe[0] : Ut.transitionOpts = Oe, qt++, Ut;
            }
            var It, Tt, Rt = [], Vt = ge == null, Ft = Array.isArray(ge), Dt = !Vt && !Ft && a.isPlainObject(ge);
            if (Dt) Rt.push({ type: "object", data: jt(a.extendFlat({}, ge)) });
            else if (Vt || ["string", "number"].indexOf(typeof ge) !== -1) for (It = 0; It < Me._frames.length; It++) Tt = Me._frames[It], Tt && (Vt || String(Tt.group) === String(ge)) && Rt.push({ type: "byname", name: String(Tt.name), data: jt({ name: Tt.name }) });
            else if (Ft) for (It = 0; It < ge.length; It++) {
              var Ct = ge[It];
              ["number", "string"].indexOf(typeof Ct) !== -1 ? (Ct = String(Ct), Rt.push({ type: "byname", name: Ct, data: jt({ name: Ct }) })) : a.isPlainObject(Ct) && Rt.push({ type: "object", data: jt(a.extendFlat({}, Ct)) });
            }
            for (It = 0; It < Rt.length; It++) if (Tt = Rt[It], Tt.type === "byname" && !Me._frameHash[Tt.data.name]) {
              a.warn('animate failure: frame not found: "' + Tt.data.name + '"'), ot();
              return;
            }
            ["next", "immediate"].indexOf(ye.mode) !== -1 && lt(), ye.direction === "reverse" && Rt.reverse();
            var Ot = ce._fullLayout._currentFrame;
            if (Ot && ye.fromcurrent) {
              var Wt = -1;
              for (It = 0; It < Rt.length; It++) if (Tt = Rt[It], Tt.type === "byname" && Tt.name === Ot) {
                Wt = It;
                break;
              }
              if (Wt > 0 && Wt < Rt.length - 1) {
                var rr = [];
                for (It = 0; It < Rt.length; It++) Tt = Rt[It], (Rt[It].type !== "byname" || It > Wt) && rr.push(Tt);
                Rt = rr;
              }
            }
            Rt.length > 0 ? st(Rt) : (ce.emit("plotly_animated"), Je());
          });
        }
        function gt(ce, ge, ye) {
          if (ce = a.getGraphDiv(ce), ge == null) return Promise.resolve();
          if (!a.isPlotDiv(ce)) throw new Error("This element is not a Plotly plot: " + ce + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
          var Me, Oe, je, qe, Qe = ce._transitionData._frames, Xe = ce._transitionData._frameHash;
          if (!Array.isArray(ge)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + ge);
          var Je = Qe.length + ge.length * 2, ot = [], lt = {};
          for (Me = ge.length - 1; Me >= 0; Me--) if (a.isPlainObject(ge[Me])) {
            var st = ge[Me].name, xt = (Xe[st] || lt[st] || {}).name, Et = ge[Me].name, Bt = Xe[xt] || lt[xt];
            xt && Et && typeof Et == "number" && Bt && I < P && (I++, a.warn('addFrames: overwriting frame "' + (Xe[xt] || lt[xt]).name + '" with a frame whose name of type "number" also equates to "' + xt + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), I === P && a.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), lt[st] = { name: st }, ot.push({ frame: t.supplyFrameDefaults(ge[Me]), index: ye && ye[Me] !== void 0 && ye[Me] !== null ? ye[Me] : Je + Me });
          }
          ot.sort(function(Dt, Ct) {
            return Dt.index > Ct.index ? -1 : Dt.index < Ct.index ? 1 : 0;
          });
          var qt = [], jt = [], It = Qe.length;
          for (Me = ot.length - 1; Me >= 0; Me--) {
            if (Oe = ot[Me].frame, typeof Oe.name == "number" && a.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !Oe.name) for (; Xe[Oe.name = "frame " + ce._transitionData._counter++]; ) ;
            if (Xe[Oe.name]) {
              for (je = 0; je < Qe.length && (Qe[je] || {}).name !== Oe.name; je++) ;
              qt.push({ type: "replace", index: je, value: Oe }), jt.unshift({ type: "replace", index: je, value: Qe[je] });
            } else qe = Math.max(0, Math.min(ot[Me].index, It)), qt.push({ type: "insert", index: qe, value: Oe }), jt.unshift({ type: "delete", index: qe }), It++;
          }
          var Tt = t.modifyFrames, Rt = t.modifyFrames, Vt = [ce, jt], Ft = [ce, qt];
          return r && r.add(ce, Tt, Vt, Rt, Ft), t.modifyFrames(ce, qt);
        }
        function ht(ce, ge) {
          if (ce = a.getGraphDiv(ce), !a.isPlotDiv(ce)) throw new Error("This element is not a Plotly plot: " + ce);
          var ye, Me, Oe = ce._transitionData._frames, je = [], qe = [];
          if (!ge) for (ge = [], ye = 0; ye < Oe.length; ye++) ge.push(ye);
          for (ge = ge.slice(), ge.sort(), ye = ge.length - 1; ye >= 0; ye--) Me = ge[ye], je.push({ type: "delete", index: Me }), qe.unshift({ type: "insert", index: Me, value: Oe[Me] });
          var Qe = t.modifyFrames, Xe = t.modifyFrames, Je = [ce, qe], ot = [ce, je];
          return r && r.add(ce, Qe, Je, Xe, ot), t.modifyFrames(ce, je);
        }
        function _t(ce) {
          ce = a.getGraphDiv(ce);
          var ge = ce._fullLayout || {}, ye = ce._fullData || [];
          return t.cleanPlot([], {}, ye, ge), t.purge(ce), o.purge(ce), ge._container && ge._container.remove(), delete ce._context, ce;
        }
        function Te(ce) {
          var ge = ce._fullLayout, ye = ce.getBoundingClientRect();
          if (!a.equalDomRects(ye, ge._lastBBox)) {
            var Me = ge._invTransform = a.inverseTransformMatrix(a.getFullTransformMatrix(ce));
            ge._invScaleX = Math.sqrt(Me[0][0] * Me[0][0] + Me[0][1] * Me[0][1] + Me[0][2] * Me[0][2]), ge._invScaleY = Math.sqrt(Me[1][0] * Me[1][0] + Me[1][1] * Me[1][1] + Me[1][2] * Me[1][2]), ge._lastBBox = ye;
          }
        }
        function Ie(ce) {
          var ge = k.select(ce), ye = ce._fullLayout;
          if (ye._calcInverseTransform = Te, ye._calcInverseTransform(ce), ye._container = ge.selectAll(".plot-container").data([0]), ye._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0).style({ width: "100%", height: "100%" }), ye._paperdiv = ye._container.selectAll(".svg-container").data([0]), ye._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), ye._glcontainer = ye._paperdiv.selectAll(".gl-container").data([{}]), ye._glcontainer.enter().append("div").classed("gl-container", !0), ye._paperdiv.selectAll(".main-svg").remove(), ye._paperdiv.select(".modebar-container").remove(), ye._paper = ye._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), ye._toppaper = ye._paperdiv.append("svg").classed("main-svg", !0), ye._modebardiv = ye._paperdiv.append("div"), delete ye._modeBar, ye._hoverpaper = ye._paperdiv.append("svg").classed("main-svg", !0), !ye._uid) {
            var Me = {};
            k.selectAll("defs").each(function() {
              this.id && (Me[this.id.split("-")[1]] = 1);
            }), ye._uid = a.randstr(Me);
          }
          ye._paperdiv.selectAll(".main-svg").attr(h.svgAttrs), ye._defs = ye._paper.append("defs").attr("id", "defs-" + ye._uid), ye._clips = ye._defs.append("g").classed("clips", !0), ye._topdefs = ye._toppaper.append("defs").attr("id", "topdefs-" + ye._uid), ye._topclips = ye._topdefs.append("g").classed("clips", !0), ye._bgLayer = ye._paper.append("g").classed("bglayer", !0), ye._draggers = ye._paper.append("g").classed("draglayer", !0);
          var Oe = ye._paper.append("g").classed("layer-below", !0);
          ye._imageLowerLayer = Oe.append("g").classed("imagelayer", !0), ye._shapeLowerLayer = Oe.append("g").classed("shapelayer", !0), ye._cartesianlayer = ye._paper.append("g").classed("cartesianlayer", !0), ye._polarlayer = ye._paper.append("g").classed("polarlayer", !0), ye._smithlayer = ye._paper.append("g").classed("smithlayer", !0), ye._ternarylayer = ye._paper.append("g").classed("ternarylayer", !0), ye._geolayer = ye._paper.append("g").classed("geolayer", !0), ye._funnelarealayer = ye._paper.append("g").classed("funnelarealayer", !0), ye._pielayer = ye._paper.append("g").classed("pielayer", !0), ye._iciclelayer = ye._paper.append("g").classed("iciclelayer", !0), ye._treemaplayer = ye._paper.append("g").classed("treemaplayer", !0), ye._sunburstlayer = ye._paper.append("g").classed("sunburstlayer", !0), ye._indicatorlayer = ye._toppaper.append("g").classed("indicatorlayer", !0), ye._glimages = ye._paper.append("g").classed("glimages", !0);
          var je = ye._toppaper.append("g").classed("layer-above", !0);
          ye._imageUpperLayer = je.append("g").classed("imagelayer", !0), ye._shapeUpperLayer = je.append("g").classed("shapelayer", !0), ye._selectionLayer = ye._toppaper.append("g").classed("selectionlayer", !0), ye._infolayer = ye._toppaper.append("g").classed("infolayer", !0), ye._menulayer = ye._toppaper.append("g").classed("menulayer", !0), ye._zoomlayer = ye._toppaper.append("g").classed("zoomlayer", !0), ye._hoverlayer = ye._hoverpaper.append("g").classed("hoverlayer", !0), ye._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), ce.emit("plotly_framework");
        }
        L.animate = ct, L.addFrames = gt, L.deleteFrames = ht, L.addTraces = F, L.deleteTraces = S, L.extendTraces = se, L.moveTraces = $, L.prependTraces = O, L.newPlot = te, L._doPlot = M, L.purge = _t, L.react = We, L.redraw = K, L.relayout = le, L.restyle = re, L.setPlotConfig = z, L.update = ke, L._guiRelayout = A(le), L._guiRestyle = A(re), L._guiUpdate = A(ke), L._storeDirectGUIEdit = W;
      }), ya = xe((L) => {
        var k = or();
        L.getDelay = function(a) {
          return a._has && (a._has("gl3d") || a._has("mapbox") || a._has("map")) ? 500 : 0;
        }, L.getRedrawFunc = function(a) {
          return function() {
            k.getComponentMethod("colorbar", "draw")(a);
          };
        }, L.encodeSVG = function(a) {
          return "data:image/svg+xml," + encodeURIComponent(a);
        }, L.encodeJSON = function(a) {
          return "data:application/json," + encodeURIComponent(a);
        };
        var n = window.URL || window.webkitURL;
        L.createObjectURL = function(a) {
          return n.createObjectURL(a);
        }, L.revokeObjectURL = function(a) {
          return n.revokeObjectURL(a);
        }, L.createBlob = function(a, i) {
          if (i === "svg") return new window.Blob([a], { type: "image/svg+xml;charset=utf-8" });
          if (i === "full-json") return new window.Blob([a], { type: "application/json;charset=utf-8" });
          var o = e(window.atob(a));
          return new window.Blob([o], { type: "image/" + i });
        }, L.octetStream = function(a) {
          document.location.href = "data:application/octet-stream" + a;
        };
        function e(a) {
          for (var i = a.length, o = new ArrayBuffer(i), r = new Uint8Array(o), s = 0; s < i; s++) r[s] = a.charCodeAt(s);
          return o;
        }
        L.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
      }), Ro = xe((L, k) => {
        var n = vr();
        wt();
        var e = Or(), a = fr();
        va();
        var i = /"/g, o = "TOBESTRIPPED", r = new RegExp('("' + o + ")|(" + o + '")', "g");
        function s(t) {
          var p = n.select("body").append("div").style({ display: "none" }).html(""), l = t.replace(/(&[^;]*;)/gi, function(f) {
            return f === "&lt;" ? "&#60;" : f === "&rt;" ? "&#62;" : f.indexOf("<") !== -1 || f.indexOf(">") !== -1 ? "" : p.html(f).text();
          });
          return p.remove(), l;
        }
        function c(t) {
          return t.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;");
        }
        k.exports = function(t, p, l) {
          var f = t._fullLayout, v = f._paper, g = f._toppaper, x = f.width, h = f.height, m;
          v.insert("rect", ":first-child").call(e.setRect, 0, 0, x, h).call(a.fill, f.paper_bgcolor);
          var u = f._basePlotModules || [];
          for (m = 0; m < u.length; m++) {
            var d = u[m];
            d.toSVG && d.toSVG(t);
          }
          if (g) {
            var y = g.node().childNodes, _ = Array.prototype.slice.call(y);
            for (m = 0; m < _.length; m++) {
              var T = _[m];
              T.childNodes.length && v.node().appendChild(T);
            }
          }
          f._draggers && f._draggers.remove(), v.node().style.background = "", v.selectAll("text").attr({ "data-unformatted": null, "data-math": null }).each(function() {
            var I = n.select(this);
            if (this.style.visibility === "hidden" || this.style.display === "none") {
              I.remove();
              return;
            } else I.style({ visibility: null, display: null });
            var P = this.style.fontFamily;
            P && P.indexOf('"') !== -1 && I.style("font-family", P.replace(i, o));
            var M = this.style.fontWeight;
            M && (M === "normal" || M === "400") && I.style("font-weight", void 0);
            var B = this.style.fontStyle;
            B && B === "normal" && I.style("font-style", void 0);
            var z = this.style.fontVariant;
            z && z === "normal" && I.style("font-variant", void 0);
          }), v.selectAll(".gradient_filled,.pattern_filled").each(function() {
            var I = n.select(this), P = this.style.fill;
            P && P.indexOf("url(") !== -1 && I.style("fill", P.replace(i, o));
            var M = this.style.stroke;
            M && M.indexOf("url(") !== -1 && I.style("stroke", M.replace(i, o));
          }), (p === "pdf" || p === "eps") && v.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), p === "svg" && l && (v.attr("width", l * x), v.attr("height", l * h), v.attr("viewBox", "0 0 " + x + " " + h));
          var R = new window.XMLSerializer().serializeToString(v.node());
          return R = s(R), R = c(R), R = R.replace(r, "'"), R;
        };
      }), No = xe((L, k) => {
        var n = wt(), e = Ra().EventEmitter, a = ya();
        function i(o) {
          var r = o.emitter || new e(), s = new Promise(function(c, t) {
            var p = window.Image, l = o.svg, f = o.format || "png", v = o.canvas, g = o.scale || 1, x = o.width || 300, h = o.height || 150, m = g * x, u = g * h, d = v.getContext("2d", { willReadFrequently: !0 }), y = new p(), _, T;
            f === "svg" || n.isSafari() ? T = a.encodeSVG(l) : (_ = a.createBlob(l, "svg"), T = a.createObjectURL(_)), v.width = m, v.height = u, y.onload = function() {
              var R;
              switch (_ = null, a.revokeObjectURL(T), f !== "svg" && d.drawImage(y, 0, 0, m, u), f) {
                case "jpeg":
                  R = v.toDataURL("image/jpeg");
                  break;
                case "png":
                  R = v.toDataURL("image/png");
                  break;
                case "webp":
                  R = v.toDataURL("image/webp");
                  break;
                case "svg":
                  R = T;
                  break;
                default:
                  var I = "Image format is not jpeg, png, svg or webp.";
                  if (t(new Error(I)), !o.promise) return r.emit("error", I);
              }
              c(R), o.promise || r.emit("success", R);
            }, y.onerror = function(R) {
              if (_ = null, a.revokeObjectURL(T), t(R), !o.promise) return r.emit("error", R);
            }, y.src = T;
          });
          return o.promise ? s : r;
        }
        k.exports = i;
      }), Cs = xe((L, k) => {
        var n = xr(), e = Os(), a = on(), i = wt(), o = ya(), r = Ro(), s = No(), c = ao().version, t = { format: { valType: "enumerated", values: ["png", "jpeg", "webp", "svg", "full-json"], dflt: "png" }, width: { valType: "number", min: 1 }, height: { valType: "number", min: 1 }, scale: { valType: "number", min: 0, dflt: 1 }, setBackground: { valType: "any", dflt: !1 }, imageDataOnly: { valType: "boolean", dflt: !1 } };
        function p(l, f) {
          f = f || {};
          var v, g, x, h;
          i.isPlainObject(l) ? (v = l.data || [], g = l.layout || {}, x = l.config || {}, h = {}) : (l = i.getGraphDiv(l), v = i.extendDeep([], l.data), g = i.extendDeep({}, l.layout), x = l._context, h = l._fullLayout || {});
          function m(te) {
            return !(te in f) || i.validate(f[te], t[te]);
          }
          if (!m("width") && f.width !== null || !m("height") && f.height !== null) throw new Error("Height and width should be pixel values.");
          if (!m("format")) throw new Error("Export format is not " + i.join2(t.format.values, ", ", " or ") + ".");
          var u = {};
          function d(te, V) {
            return i.coerce(f, u, t, te, V);
          }
          var y = d("format"), _ = d("width"), T = d("height"), R = d("scale"), I = d("setBackground"), P = d("imageDataOnly"), M = document.createElement("div");
          M.style.position = "absolute", M.style.left = "-5000px", document.body.appendChild(M);
          var B = i.extendFlat({}, g);
          _ ? B.width = _ : f.width === null && n(h.width) && (B.width = h.width), T ? B.height = T : f.height === null && n(h.height) && (B.height = h.height);
          var z = i.extendFlat({}, x, { _exportedPlot: !0, staticPlot: !0, setBackground: I }), q = o.getRedrawFunc(M);
          function U() {
            return new Promise(function(te) {
              setTimeout(te, o.getDelay(M._fullLayout));
            });
          }
          function G() {
            return new Promise(function(te, V) {
              var Z = r(M, y, R), Y = M._fullLayout.width, C = M._fullLayout.height;
              function j() {
                e.purge(M), document.body.removeChild(M);
              }
              if (y === "full-json") {
                var J = a.graphJson(M, !1, "keepdata", "object", !0, !0);
                return J.version = c, J = JSON.stringify(J), j(), te(P ? J : o.encodeJSON(J));
              }
              if (j(), y === "svg") return te(P ? Z : o.encodeSVG(Z));
              var ne = document.createElement("canvas");
              ne.id = i.randstr(), s({ format: y, width: Y, height: C, scale: R, canvas: ne, svg: Z, promise: !0 }).then(te).catch(V);
            });
          }
          function K(te) {
            return P ? te.replace(o.IMAGE_URL_PREFIX, "") : te;
          }
          return new Promise(function(te, V) {
            e.newPlot(M, v, B, z).then(q).then(U).then(G).then(function(Z) {
              te(K(Z));
            }).catch(function(Z) {
              V(Z);
            });
          });
        }
        k.exports = p;
      }), np = xe((L, k) => {
        var n = wt(), e = on(), a = Qa(), i = Ia().dfltConfig, o = n.isPlainObject, r = Array.isArray, s = n.isArrayOrTypedArray;
        k.exports = function(u, d) {
          u === void 0 && (u = []), d === void 0 && (d = {});
          var y = a.get(), _ = [], T = { _context: n.extendFlat({}, i) }, R, I;
          r(u) ? (T.data = n.extendDeep([], u), R = u) : (T.data = [], R = [], _.push(f("array", "data"))), o(d) ? (T.layout = n.extendDeep({}, d), I = d) : (T.layout = {}, I = {}, arguments.length > 1 && _.push(f("object", "layout"))), e.supplyDefaults(T);
          for (var P = T._fullData, M = R.length, B = 0; B < M; B++) {
            var z = R[B], q = ["data", B];
            if (!o(z)) {
              _.push(f("object", q));
              continue;
            }
            var U = P[B], G = U.type, K = y.traces[G].attributes;
            K.type = { valType: "enumerated", values: [G] }, U.visible === !1 && z.visible !== !1 && _.push(f("invisible", q)), c(z, U, K, _, q);
          }
          var te = T._fullLayout, V = t(y, P);
          return c(I, te, V, _, "layout"), _.length === 0 ? void 0 : _;
        };
        function c(u, d, y, _, T, R) {
          R = R || [];
          for (var I = Object.keys(u), P = 0; P < I.length; P++) {
            var M = I[P], B = R.slice();
            B.push(M);
            var z = u[M], q = d[M], U = g(y, M), G = (U || {}).valType, K = G === "info_array", te = G === "colorscale", V = (U || {}).items;
            if (!v(y, M)) _.push(f("schema", T, B));
            else if (o(z) && o(q) && G !== "any") c(z, q, U, _, T, B);
            else if (K && r(z)) {
              z.length > q.length && _.push(f("unused", T, B.concat(q.length)));
              var Z = q.length, Y = Array.isArray(V);
              Y && (Z = Math.min(Z, V.length));
              var C, j, J, ne, ae;
              if (U.dimensions === 2) for (j = 0; j < Z; j++) if (r(z[j])) {
                z[j].length > q[j].length && _.push(f("unused", T, B.concat(j, q[j].length)));
                var se = q[j].length;
                for (C = 0; C < (Y ? Math.min(se, V[j].length) : se); C++) J = Y ? V[j][C] : V, ne = z[j][C], ae = q[j][C], n.validate(ne, J) ? ae !== ne && ae !== +ne && _.push(f("dynamic", T, B.concat(j, C), ne, ae)) : _.push(f("value", T, B.concat(j, C), ne));
              } else _.push(f("array", T, B.concat(j), z[j]));
              else for (j = 0; j < Z; j++) J = Y ? V[j] : V, ne = z[j], ae = q[j], n.validate(ne, J) ? ae !== ne && ae !== +ne && _.push(f("dynamic", T, B.concat(j), ne, ae)) : _.push(f("value", T, B.concat(j), ne));
            } else if (U.items && !K && r(z)) {
              var O = V[Object.keys(V)[0]], F = [], S, $;
              for (S = 0; S < q.length; S++) {
                var re = q[S]._index || S;
                if ($ = B.slice(), $.push(re), o(z[re]) && o(q[S])) {
                  F.push(re);
                  var E = z[re], w = q[S];
                  o(E) && E.visible !== !1 && w.visible === !1 ? _.push(f("invisible", T, $)) : c(E, w, O, _, T, $);
                }
              }
              for (S = 0; S < z.length; S++) $ = B.slice(), $.push(S), o(z[S]) ? F.indexOf(S) === -1 && _.push(f("unused", T, $)) : _.push(f("object", T, $, z[S]));
            } else !o(z) && o(q) ? _.push(f("object", T, B, z)) : !s(z) && s(q) && !K && !te ? _.push(f("array", T, B, z)) : M in d ? n.validate(z, U) ? U.valType === "enumerated" && (U.coerceNumber && z !== +q || !s(z) && z !== q || String(z) !== String(q)) && _.push(f("dynamic", T, B, z, q)) : _.push(f("value", T, B, z)) : _.push(f("unused", T, B, z));
          }
          return _;
        }
        function t(u, d) {
          for (var y = u.layout.layoutAttributes, _ = 0; _ < d.length; _++) {
            var T = d[_], R = u.traces[T.type], I = R.layoutAttributes;
            I && (T.subplot ? n.extendFlat(y[R.attributes.subplot.dflt], I) : n.extendFlat(y, I));
          }
          return y;
        }
        var p = { object: function(u, d) {
          var y;
          return u === "layout" && d === "" ? y = "The layout argument" : u[0] === "data" && d === "" ? y = "Trace " + u[1] + " in the data argument" : y = l(u) + "key " + d, y + " must be linked to an object container";
        }, array: function(u, d) {
          var y;
          return u === "data" ? y = "The data argument" : y = l(u) + "key " + d, y + " must be linked to an array container";
        }, schema: function(u, d) {
          return l(u) + "key " + d + " is not part of the schema";
        }, unused: function(u, d, y) {
          var _ = o(y) ? "container" : "key";
          return l(u) + _ + " " + d + " did not get coerced";
        }, dynamic: function(u, d, y, _) {
          return [l(u) + "key", d, "(set to '" + y + "')", "got reset to", "'" + _ + "'", "during defaults."].join(" ");
        }, invisible: function(u, d) {
          return (d ? l(u) + "item " + d : "Trace " + u[1]) + " got defaulted to be not visible";
        }, value: function(u, d, y) {
          return [l(u) + "key " + d, "is set to an invalid value (" + y + ")"].join(" ");
        } };
        function l(u) {
          return r(u) ? "In data trace " + u[1] + ", " : "In " + u + ", ";
        }
        function f(u, d, y, _, T) {
          y = y || "";
          var R, I;
          r(d) ? (R = d[0], I = d[1]) : (R = d, I = null);
          var P = m(y), M = p[u](d, P, _, T);
          return n.log(M), { code: u, container: R, trace: I, path: y, astr: P, msg: M };
        }
        function v(u, d) {
          var y = h(d), _ = y.keyMinusId, T = y.id;
          return _ in u && u[_]._isSubplotObj && T ? !0 : d in u;
        }
        function g(u, d) {
          if (d in u) return u[d];
          var y = h(d);
          return u[y.keyMinusId];
        }
        var x = n.counterRegex("([a-z]+)");
        function h(u) {
          var d = u.match(x);
          return { keyMinusId: d && d[1], id: d && d[2] };
        }
        function m(u) {
          if (!r(u)) return String(u);
          for (var d = "", y = 0; y < u.length; y++) {
            var _ = u[y];
            typeof _ == "number" ? d = d.substr(0, d.length - 1) + "[" + _ + "]" : d += _, y < u.length - 1 && (d += ".");
          }
          return d;
        }
      }), ap = xe((L, k) => {
        var n = wt(), e = ya();
        function a(i, o, r) {
          var s = document.createElement("a"), c = "download" in s, t = new Promise(function(p, l) {
            var f, v;
            if (c) return f = e.createBlob(i, r), v = e.createObjectURL(f), s.href = v, s.download = o, document.body.appendChild(s), s.click(), document.body.removeChild(s), e.revokeObjectURL(v), f = null, p(o);
            if (n.isSafari()) {
              var g = r === "svg" ? "," : ";base64,";
              return e.octetStream(g + encodeURIComponent(i)), p(o);
            }
            l(new Error("download error"));
          });
          return t;
        }
        k.exports = a;
      }), Es = xe((L, k) => {
        var n = wt(), e = Cs(), a = ap();
        ya();
        function i(o, r) {
          var s;
          return n.isPlainObject(o) || (s = n.getGraphDiv(o)), r = r || {}, r.format = r.format || "png", r.width = r.width || null, r.height = r.height || null, r.imageDataOnly = !0, new Promise(function(c, t) {
            s && s._snapshotInProgress && t(new Error("Snapshotting already in progress.")), s && (s._snapshotInProgress = !0);
            var p = e(o, r), l = r.filename || o.fn || "newplot";
            l += "." + r.format.replace("-", "."), p.then(function(f) {
              return s && (s._snapshotInProgress = !1), a(f, l, r.format);
            }).then(function(f) {
              c(f);
            }).catch(function(f) {
              s && (s._snapshotInProgress = !1), t(f);
            });
          });
        }
        k.exports = i;
      }), ip = xe((L) => {
        var k = wt(), n = k.isPlainObject, e = Qa(), a = on(), i = Pn(), o = qr(), r = Ia().dfltConfig;
        L.makeTemplate = function(x) {
          x = k.isPlainObject(x) ? x : k.getGraphDiv(x), x = k.extendDeep({ _context: r }, { data: x.data, layout: x.layout }), a.supplyDefaults(x);
          var h = x.data || [], m = x.layout || {};
          m._basePlotModules = x._fullLayout._basePlotModules, m._modules = x._fullLayout._modules;
          var u = { data: {}, layout: {} };
          h.forEach(function(z) {
            var q = {};
            t(z, q, l.bind(null, z));
            var U = k.coerce(z, {}, i, "type"), G = u.data[U];
            G || (G = u.data[U] = []), G.push(q);
          }), t(m, u.layout, p.bind(null, m)), delete u.layout.template;
          var d = m.template;
          if (n(d)) {
            var y = d.layout, _, T, R, I, P, M;
            n(y) && s(y, u.layout);
            var B = d.data;
            if (n(B)) {
              for (T in u.data) if (R = B[T], Array.isArray(R)) {
                for (P = u.data[T], M = P.length, I = R.length, _ = 0; _ < M; _++) s(R[_ % I], P[_]);
                for (_ = M; _ < I; _++) P.push(k.extendDeep({}, R[_]));
              }
              for (T in B) T in u.data || (u.data[T] = k.extendDeep([], B[T]));
            }
          }
          return u;
        };
        function s(x, h) {
          x = k.extendDeep({}, x);
          var m = Object.keys(x).sort(), u, d;
          function y(P, M, B) {
            if (n(M) && n(P)) s(P, M);
            else if (Array.isArray(M) && Array.isArray(P)) {
              var z = o.arrayTemplater({ _template: x }, B);
              for (d = 0; d < M.length; d++) {
                var q = M[d], U = z.newItem(q)._template;
                U && s(U, q);
              }
              var G = z.defaultItems();
              for (d = 0; d < G.length; d++) M.push(G[d]._template);
              for (d = 0; d < M.length; d++) delete M[d].templateitemname;
            }
          }
          for (u = 0; u < m.length; u++) {
            var _ = m[u], T = x[_];
            if (_ in h ? y(T, h[_], _) : h[_] = T, c(_) === _) for (var R in h) {
              var I = c(R);
              R !== I && I === _ && !(R in x) && y(T, h[R], _);
            }
          }
        }
        function c(x) {
          return x.replace(/[0-9]+$/, "");
        }
        function t(x, h, m, u, d) {
          var y = d && m(d);
          for (var _ in x) {
            var T = x[_], R = f(x, _, u), I = f(x, _, d), P = m(I);
            if (!P) {
              var M = c(_);
              M !== _ && (I = f(x, M, d), P = m(I));
            }
            if (!(y && y === P) && !(!P || P._noTemplating || P.valType === "data_array" || P.arrayOk && Array.isArray(T))) if (!P.valType && n(T)) t(T, h, m, R, I);
            else if (P._isLinkedToArray && Array.isArray(T)) for (var B = !1, z = 0, q = {}, U = 0; U < T.length; U++) {
              var G = T[U];
              if (n(G)) {
                var K = G.name;
                if (K) q[K] || (t(G, h, m, f(T, z, R), f(T, z, I)), z++, q[K] = 1);
                else if (!B) {
                  var te = o.arrayDefaultKey(_), V = f(x, te, u), Z = f(T, z, R);
                  t(G, h, m, Z, f(T, z, I));
                  var Y = k.nestedProperty(h, Z), C = k.nestedProperty(h, V);
                  C.set(Y.get()), Y.set(null), B = !0;
                }
              }
            }
            else {
              var j = k.nestedProperty(h, R);
              j.set(T);
            }
          }
        }
        function p(x, h) {
          return e.getLayoutValObject(x, k.nestedProperty({}, h).parts);
        }
        function l(x, h) {
          return e.getTraceValObject(x, k.nestedProperty({}, h).parts);
        }
        function f(x, h, m) {
          var u;
          return m ? Array.isArray(x) ? u = m + "[" + h + "]" : u = m + "." + h : u = h, u;
        }
        L.validateTemplate = function(x, h) {
          var m = k.extendDeep({}, { _context: r, data: x.data, layout: x.layout }), u = m.layout || {};
          n(h) || (h = u.template || {});
          var d = h.layout, y = h.data, _ = [];
          m.layout = u, m.layout.template = h, a.supplyDefaults(m);
          var T = m._fullLayout, R = m._fullData, I = {};
          function P(V, Z) {
            for (var Y in V) if (Y.charAt(0) !== "_" && n(V[Y])) {
              var C = c(Y), j = [], J;
              for (J = 0; J < Z.length; J++) j.push(f(V, Y, Z[J])), C !== Y && j.push(f(V, C, Z[J]));
              for (J = 0; J < j.length; J++) I[j[J]] = 1;
              P(V[Y], j);
            }
          }
          function M(V, Z) {
            for (var Y in V) if (Y.indexOf("defaults") === -1 && n(V[Y])) {
              var C = f(V, Y, Z);
              I[C] ? M(V[Y], C) : _.push({ code: "unused", path: C });
            }
          }
          if (n(d) ? (P(T, ["layout"]), M(d, "layout")) : _.push({ code: "layout" }), !n(y)) _.push({ code: "data" });
          else {
            for (var B = {}, z, q = 0; q < R.length; q++) {
              var U = R[q];
              z = U.type, B[z] = (B[z] || 0) + 1, U._fullInput._template || _.push({ code: "missing", index: U.index, traceType: z });
            }
            for (z in y) {
              var G = y[z].length, K = B[z] || 0;
              G > K ? _.push({ code: "unused", traceType: z, templateCount: G, dataCount: K }) : K > G && _.push({ code: "reused", traceType: z, templateCount: G, dataCount: K });
            }
          }
          function te(V, Z) {
            for (var Y in V) if (Y.charAt(0) !== "_") {
              var C = V[Y], j = f(V, Y, Z);
              n(C) ? (Array.isArray(V) && C._template === !1 && C.templateitemname && _.push({ code: "missing", path: j, templateitemname: C.templateitemname }), te(C, j)) : Array.isArray(C) && v(C) && te(C, j);
            }
          }
          if (te({ data: R, layout: T }, ""), _.length) return _.map(g);
        };
        function v(x) {
          for (var h = 0; h < x.length; h++) if (n(x[h])) return !0;
        }
        function g(x) {
          var h;
          switch (x.code) {
            case "data":
              h = "The template has no key data.";
              break;
            case "layout":
              h = "The template has no key layout.";
              break;
            case "missing":
              x.path ? h = "There are no templates for item " + x.path + " with name " + x.templateitemname : h = "There are no templates for trace " + x.index + ", of type " + x.traceType + ".";
              break;
            case "unused":
              x.path ? h = "The template item at " + x.path + " was not used in constructing the plot." : x.dataCount ? h = "Some of the templates of type " + x.traceType + " were not used. The template has " + x.templateCount + " traces, the data only has " + x.dataCount + " of this type." : h = "The template has " + x.templateCount + " traces of type " + x.traceType + " but there are none in the data.";
              break;
            case "reused":
              h = "Some of the templates of type " + x.traceType + " were used more than once. The template has " + x.templateCount + " traces, the data has " + x.dataCount + " of this type.";
              break;
          }
          return x.msg = h, x;
        }
      }), op = xe((L) => {
        var k = Os();
        L._doPlot = k._doPlot, L.newPlot = k.newPlot, L.restyle = k.restyle, L.relayout = k.relayout, L.redraw = k.redraw, L.update = k.update, L._guiRestyle = k._guiRestyle, L._guiRelayout = k._guiRelayout, L._guiUpdate = k._guiUpdate, L._storeDirectGUIEdit = k._storeDirectGUIEdit, L.react = k.react, L.extendTraces = k.extendTraces, L.prependTraces = k.prependTraces, L.addTraces = k.addTraces, L.deleteTraces = k.deleteTraces, L.moveTraces = k.moveTraces, L.purge = k.purge, L.addFrames = k.addFrames, L.deleteFrames = k.deleteFrames, L.animate = k.animate, L.setPlotConfig = k.setPlotConfig;
        var n = _i().getGraphDiv, e = Po().eraseActiveShape;
        L.deleteActiveShape = function(i) {
          return e(n(i));
        }, L.toImage = Cs(), L.validate = np(), L.downloadImage = Es();
        var a = ip();
        L.makeTemplate = a.makeTemplate, L.validateTemplate = a.validateTemplate;
      }), Ds = xe((L, k) => {
        var n = wt(), e = or();
        k.exports = function(a, i, o, r) {
          var s = r("x"), c = r("y"), t, p = e.getComponentMethod("calendars", "handleTraceDefaults");
          if (p(a, i, ["x", "y"], o), s) {
            var l = n.minRowLength(s);
            c ? t = Math.min(l, n.minRowLength(c)) : (t = l, r("y0"), r("dy"));
          } else {
            if (!c) return 0;
            t = n.minRowLength(c), r("x0"), r("dx");
          }
          return i._length = t, t;
        };
      }), ai = xe((L, k) => {
        var n = wt().dateTick0, e = Yr(), a = e.ONEWEEK;
        function i(o, r) {
          return o % a === 0 ? n(r, 1) : n(r, 0);
        }
        k.exports = function(o, r, s, c, t) {
          if (t || (t = { x: !0, y: !0 }), t.x) {
            var p = c("xperiod");
            p && (c("xperiod0", i(p, r.xcalendar)), c("xperiodalignment"));
          }
          if (t.y) {
            var l = c("yperiod");
            l && (c("yperiod0", i(l, r.ycalendar)), c("yperiodalignment"));
          }
        };
      }), lp = xe((L, k) => {
        var n = ["orientation", "groupnorm", "stackgaps"];
        k.exports = function(e, a, i, o) {
          var r = i._scatterStackOpts, s = o("stackgroup");
          if (s) {
            var c = a.xaxis + a.yaxis, t = r[c];
            t || (t = r[c] = {});
            var p = t[s], l = !1;
            p ? p.traces.push(a) : (p = t[s] = { traceIndices: [], traces: [a] }, l = !0);
            for (var f = { orientation: a.x && !a.y ? "h" : "v" }, v = 0; v < n.length; v++) {
              var g = n[v], x = g + "Found";
              if (!p[x]) {
                var h = e[g] !== void 0, m = g === "orientation";
                if ((h || l) && (p[g] = o(g, f[g]), m && (p.fillDflt = p[g] === "h" ? "tonextx" : "tonexty"), h && (p[x] = !0, !l && (delete p.traces[0][g], m)))) for (var u = 0; u < p.traces.length - 1; u++) {
                  var d = p.traces[u];
                  d._input.fill !== d.fill && (d.fill = p.fillDflt);
                }
              }
            }
            return p;
          }
        };
      }), Ps = xe((L, k) => {
        var n = fr(), e = Un().hasColorscale, a = ga(), i = Fn();
        k.exports = function(o, r, s, c, t, p) {
          var l = i.isBubble(o), f = (o.line || {}).color, v;
          if (p = p || {}, f && (s = f), t("marker.symbol"), t("marker.opacity", l ? 0.7 : 1), t("marker.size"), p.noAngle || (t("marker.angle"), p.noAngleRef || t("marker.angleref"), p.noStandOff || t("marker.standoff")), t("marker.color", s), e(o, "marker") && a(o, r, c, t, { prefix: "marker.", cLetter: "c" }), p.noSelect || (t("selected.marker.color"), t("unselected.marker.color"), t("selected.marker.size"), t("unselected.marker.size")), p.noLine || (f && !Array.isArray(f) && r.marker.color !== f ? v = f : l ? v = n.background : v = n.defaultLine, t("marker.line.color", v), e(o, "marker.line") && a(o, r, c, t, { prefix: "marker.line.", cLetter: "c" }), t("marker.line.width", l ? 1 : 0)), l && (t("marker.sizeref"), t("marker.sizemin"), t("marker.sizemode")), p.gradient) {
            var g = t("marker.gradient.type");
            g !== "none" && t("marker.gradient.color");
          }
        };
      }), Is = xe((L, k) => {
        var n = wt().isArrayOrTypedArray, e = Un().hasColorscale, a = ga();
        k.exports = function(i, o, r, s, c, t) {
          t || (t = {});
          var p = (i.marker || {}).color;
          if (p && p._inputArray && (p = p._inputArray), c("line.color", r), e(i, "line")) a(i, o, s, c, { prefix: "line.", cLetter: "c" });
          else {
            var l = (n(p) ? !1 : p) || r;
            c("line.color", l);
          }
          c("line.width"), t.noDash || c("line.dash"), t.backoff && c("line.backoff");
        };
      }), zs = xe((L, k) => {
        k.exports = function(n, e, a) {
          var i = a("line.shape");
          i === "spline" && a("line.smoothing");
        };
      }), Rs = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a, i, o, r) {
          r = r || {}, o("textposition"), n.coerceFont(o, "textfont", r.font || i.font, r), r.noSelect || (o("selected.textfont.color"), o("unselected.textfont.color"));
        };
      }), Ns = xe((L, k) => {
        var n = fr(), e = wt().isArrayOrTypedArray;
        function a(i) {
          for (var o = n.interpolate(i[0][1], i[1][1], 0.5), r = 2; r < i.length; r++) {
            var s = n.interpolate(i[r - 1][1], i[r][1], 0.5);
            o = n.interpolate(o, s, i[r - 1][0] / i[r][0]);
          }
          return o;
        }
        k.exports = function(i, o, r, s, c) {
          c || (c = {});
          var t = !1;
          if (o.marker) {
            var p = o.marker.color, l = (o.marker.line || {}).color;
            p && !e(p) ? t = p : l && !e(l) && (t = l);
          }
          var f;
          if (c.moduleHasFillgradient) {
            var v = s("fillgradient.type");
            if (v !== "none") {
              s("fillgradient.start"), s("fillgradient.stop");
              var g = s("fillgradient.colorscale");
              g && (f = a(g));
            }
          }
          s("fillcolor", n.addOpacity((o.line || {}).color || t || f || r, 0.5));
        };
      }), sp = xe((L, k) => {
        var n = wt(), e = or(), a = $n(), i = Si(), o = Fn(), r = Ds(), s = ai(), c = lp(), t = Ps(), p = Is(), l = zs(), f = Rs(), v = Ns(), g = wt().coercePattern;
        k.exports = function(x, h, m, u) {
          function d(B, z) {
            return n.coerce(x, h, a, B, z);
          }
          var y = r(x, h, u, d);
          if (y || (h.visible = !1), !!h.visible) {
            s(x, h, u, d), d("xhoverformat"), d("yhoverformat"), d("zorder");
            var _ = c(x, h, u, d);
            u.scattermode === "group" && h.orientation === void 0 && d("orientation", "v");
            var T = !_ && y < i.PTS_LINESONLY ? "lines+markers" : "lines";
            d("text"), d("hovertext"), d("mode", T), o.hasMarkers(h) && t(x, h, m, u, d, { gradient: !0 }), o.hasLines(h) && (p(x, h, m, u, d, { backoff: !0 }), l(x, h, d), d("connectgaps"), d("line.simplify")), o.hasText(h) && (d("texttemplate"), d("texttemplatefallback"), f(x, h, u, d));
            var R = [];
            (o.hasMarkers(h) || o.hasText(h)) && (d("cliponaxis"), d("marker.maxdisplayed"), R.push("points")), d("fill", _ ? _.fillDflt : "none"), h.fill !== "none" && (v(x, h, m, d, { moduleHasFillgradient: !0 }), o.hasLines(h) || l(x, h, d), g(d, "fillpattern", h.fillcolor, !1));
            var I = (h.line || {}).color, P = (h.marker || {}).color;
            (h.fill === "tonext" || h.fill === "toself") && R.push("fills"), d("hoveron", R.join("+") || "points"), h.hoveron !== "fills" && (d("hovertemplate"), d("hovertemplatefallback"));
            var M = e.getComponentMethod("errorbars", "supplyDefaults");
            M(x, h, I || P || m, { axis: "y" }), M(x, h, I || P || m, { axis: "x", inherit: "y" }), n.coerceSelectionMarkerOpacity(h, d);
          }
        };
      }), Oi = xe((L, k) => {
        var n = Fa().getAxisGroup;
        k.exports = function(e, a, i, o, r) {
          var s = a.orientation, c = a[{ v: "x", h: "y" }[s] + "axis"], t = n(i, c) + s, p = i._alignmentOpts || {}, l = o("alignmentgroup"), f = p[t];
          f || (f = p[t] = {});
          var v = f[l];
          v ? v.traces.push(a) : v = f[l] = { traces: [a], alignmentIndex: Object.keys(f).length, offsetGroups: {} };
          var g = o("offsetgroup") || "", x = v.offsetGroups, h = x[g];
          a._offsetIndex = 0, (r !== "group" || g) && (h || (h = x[g] = { offsetIndex: Object.keys(x).length }), a._offsetIndex = h.offsetIndex);
        };
      }), up = xe((L, k) => {
        var n = wt(), e = Oi(), a = $n();
        k.exports = function(i, o) {
          var r, s, c, t = o.scattermode;
          function p(x) {
            return n.coerce(s._input, s, a, x);
          }
          if (o.scattermode === "group") for (c = 0; c < i.length; c++) s = i[c], s.type === "scatter" && (r = s._input, e(r, s, o, p, t));
          for (c = 0; c < i.length; c++) {
            var l = i[c];
            if (l.type === "scatter") {
              var f = l.fill;
              if (!(f === "none" || f === "toself") && (l.opacity = void 0, f === "tonexty" || f === "tonextx")) for (var v = c - 1; v >= 0; v--) {
                var g = i[v];
                if (g.type === "scatter" && g.xaxis === l.xaxis && g.yaxis === l.yaxis) {
                  g.opacity = void 0;
                  break;
                }
              }
            }
          }
        };
      }), cp = xe((L, k) => {
        var n = wt(), e = vo();
        k.exports = function(a, i) {
          function o(s, c) {
            return n.coerce(a, i, e, s, c);
          }
          var r = i.barmode === "group";
          i.scattermode === "group" && o("scattergap", r ? i.bargap : 0.2);
        };
      }), ii = xe((L, k) => {
        var n = xr(), e = wt(), a = e.dateTime2ms, i = e.incrementMonth, o = Yr(), r = o.ONEAVGMONTH;
        k.exports = function(s, c, t, p) {
          if (c.type !== "date") return { vals: p };
          var l = s[t + "periodalignment"];
          if (!l) return { vals: p };
          var f = s[t + "period"], v;
          if (n(f)) {
            if (f = +f, f <= 0) return { vals: p };
          } else if (typeof f == "string" && f.charAt(0) === "M") {
            var g = +f.substring(1);
            if (g > 0 && Math.round(g) === g) v = g;
            else return { vals: p };
          }
          for (var x = c.calendar, h = l === "start", m = l === "end", u = s[t + "period0"], d = a(u, x) || 0, y = [], _ = [], T = [], R = p.length, I = 0; I < R; I++) {
            var P = p[I], M, B, z;
            if (v) {
              for (M = Math.round((P - d) / (v * r)), z = i(d, v * M, x); z > P; ) z = i(z, -v, x);
              for (; z <= P; ) z = i(z, v, x);
              B = i(z, -v, x);
            } else {
              for (M = Math.round((P - d) / f), z = d + M * f; z > P; ) z -= f;
              for (; z <= P; ) z += f;
              B = z - f;
            }
            y[I] = h ? B : m ? z : (B + z) / 2, _[I] = B, T[I] = z;
          }
          return { vals: y, starts: _, ends: T };
        };
      }), Fs = xe((L, k) => {
        var n = Un().hasColorscale, e = ei(), a = Fn();
        k.exports = function(i, o) {
          a.hasLines(o) && n(o, "line") && e(i, o, { vals: o.line.color, containerStr: "line", cLetter: "c" }), a.hasMarkers(o) && (n(o, "marker") && e(i, o, { vals: o.marker.color, containerStr: "marker", cLetter: "c" }), n(o, "marker.line") && e(i, o, { vals: o.marker.line.color, containerStr: "marker.line", cLetter: "c" }));
        };
      }), Fo = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a) {
          for (var i = 0; i < e.length; i++) e[i].i = i;
          n.mergeArray(a.text, e, "tx"), n.mergeArray(a.texttemplate, e, "txt"), n.mergeArray(a.hovertext, e, "htx"), n.mergeArray(a.customdata, e, "data"), n.mergeArray(a.textposition, e, "tp"), a.textfont && (n.mergeArrayCastPositive(a.textfont.size, e, "ts"), n.mergeArray(a.textfont.color, e, "tc"), n.mergeArray(a.textfont.family, e, "tf"), n.mergeArray(a.textfont.weight, e, "tw"), n.mergeArray(a.textfont.style, e, "ty"), n.mergeArray(a.textfont.variant, e, "tv"), n.mergeArray(a.textfont.textcase, e, "tC"), n.mergeArray(a.textfont.lineposition, e, "tE"), n.mergeArray(a.textfont.shadow, e, "tS"));
          var o = a.marker;
          if (o) {
            n.mergeArrayCastPositive(o.size, e, "ms"), n.mergeArrayCastPositive(o.opacity, e, "mo"), n.mergeArray(o.symbol, e, "mx"), n.mergeArray(o.angle, e, "ma"), n.mergeArray(o.standoff, e, "mf"), n.mergeArray(o.color, e, "mc");
            var r = o.line;
            o.line && (n.mergeArray(r.color, e, "mlc"), n.mergeArrayCastPositive(r.width, e, "mlw"));
            var s = o.gradient;
            s && s.type !== "none" && (n.mergeArray(s.type, e, "mgt"), n.mergeArray(s.color, e, "mgc"));
          }
        };
      }), Bo = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a) {
          n.isArrayOrTypedArray(a.selectedpoints) && n.tagSelected(e, a);
        };
      }), jo = xe((L, k) => {
        var n = xr(), e = wt(), a = Ar(), i = ii(), o = Yr().BADNUM, r = Fn(), s = Fs(), c = Fo(), t = Bo();
        function p(h, m) {
          var u = h._fullLayout, d = m._xA = a.getFromId(h, m.xaxis || "x", "x"), y = m._yA = a.getFromId(h, m.yaxis || "y", "y"), _ = d.makeCalcdata(m, "x"), T = y.makeCalcdata(m, "y"), R = i(m, d, "x", _), I = i(m, y, "y", T), P = R.vals, M = I.vals, B = m._length, z = new Array(B), q = m.ids, U = x(m, u, d, y), G = !1, K, te, V, Z, Y, C;
          v(u, m);
          var j = "x", J = "y", ne;
          if (U) e.pushUnique(U.traceIndices, m.index), K = U.orientation === "v", K ? (J = "s", ne = "x") : (j = "s", ne = "y"), Y = U.stackgaps === "interpolate";
          else {
            var ae = f(m, B);
            l(h, m, d, y, P, M, ae);
          }
          var se = !!m.xperiodalignment, O = !!m.yperiodalignment;
          for (te = 0; te < B; te++) {
            var F = z[te] = {}, S = n(P[te]), $ = n(M[te]);
            S && $ ? (F[j] = P[te], F[J] = M[te], se && (F.orig_x = _[te], F.xEnd = R.ends[te], F.xStart = R.starts[te]), O && (F.orig_y = T[te], F.yEnd = I.ends[te], F.yStart = I.starts[te])) : U && (K ? S : $) ? (F[ne] = K ? P[te] : M[te], F.gap = !0, Y ? (F.s = o, G = !0) : F.s = 0) : F[j] = F[J] = o, q && (F.id = String(q[te]));
          }
          if (c(z, m), s(h, m), t(z, m), U) {
            for (te = 0; te < z.length; ) z[te][ne] === o ? z.splice(te, 1) : te++;
            if (e.sort(z, function(N, W) {
              return N[ne] - W[ne] || N.i - W.i;
            }), G) {
              for (te = 0; te < z.length - 1 && z[te].gap; ) te++;
              for (C = z[te].s, C || (C = z[te].s = 0), V = 0; V < te; V++) z[V].s = C;
              for (Z = z.length - 1; Z > te && z[Z].gap; ) Z--;
              for (C = z[Z].s, V = z.length - 1; V > Z; V--) z[V].s = C;
              for (; te < Z; ) if (te++, z[te].gap) {
                for (V = te + 1; z[V].gap; ) V++;
                for (var re = z[te - 1][ne], E = z[te - 1].s, w = (z[V].s - E) / (z[V][ne] - re); te < V; ) z[te].s = E + (z[te][ne] - re) * w, te++;
              }
            }
          }
          return z;
        }
        function l(h, m, u, d, y, _, T) {
          var R = m._length, I = h._fullLayout, P = u._id, M = d._id, B = I._firstScatter[g(m)] === m.uid, z = (x(m, I, u, d) || {}).orientation, q = m.fill;
          u._minDtick = 0, d._minDtick = 0;
          var U = { padded: !0 }, G = { padded: !0 };
          T && (U.ppad = G.ppad = T);
          var K = R < 2 || y[0] !== y[R - 1] || _[0] !== _[R - 1];
          K && (q === "tozerox" || q === "tonextx" && (B || z === "h")) ? U.tozero = !0 : !(m.error_y || {}).visible && (q === "tonexty" || q === "tozeroy" || !r.hasMarkers(m) && !r.hasText(m)) && (U.padded = !1, U.ppad = 0), K && (q === "tozeroy" || q === "tonexty" && (B || z === "v")) ? G.tozero = !0 : (q === "tonextx" || q === "tozerox") && (G.padded = !1), P && (m._extremes[P] = a.findExtremes(u, y, U)), M && (m._extremes[M] = a.findExtremes(d, _, G));
        }
        function f(h, m) {
          if (r.hasMarkers(h)) {
            var u = h.marker, d = 1.6 * (h.marker.sizeref || 1), y;
            if (h.marker.sizemode === "area" ? y = function(P) {
              return Math.max(Math.sqrt((P || 0) / d), 3);
            } : y = function(P) {
              return Math.max((P || 0) / d, 3);
            }, e.isArrayOrTypedArray(u.size)) {
              var _ = { type: "linear" };
              a.setConvert(_);
              for (var T = _.makeCalcdata(h.marker, "size"), R = new Array(m), I = 0; I < m; I++) R[I] = y(T[I]);
              return R;
            } else return y(u.size);
          }
        }
        function v(h, m) {
          var u = g(m), d = h._firstScatter;
          d[u] || (d[u] = m.uid);
        }
        function g(h) {
          var m = h.stackgroup;
          return h.xaxis + h.yaxis + h.type + (m ? "-" + m : "");
        }
        function x(h, m, u, d) {
          var y = h.stackgroup;
          if (y) {
            var _ = m._scatterStackOpts[u._id + d._id][y], T = _.orientation === "v" ? d : u;
            if (T.type === "linear" || T.type === "log") return _;
          }
        }
        k.exports = { calc: p, calcMarkerSize: f, calcAxisExpansion: l, setFirstScatter: v, getStackOpts: x };
      }), fp = xe((L, k) => {
        k.exports = e;
        var n = wt().distinctVals;
        function e(a, i) {
          this.traces = a, this.sepNegVal = i.sepNegVal, this.overlapNoMerge = i.overlapNoMerge;
          for (var o = 1 / 0, r = i.posAxis._id.charAt(0), s = [], c = 0; c < a.length; c++) {
            for (var t = a[c], p = 0; p < t.length; p++) {
              var l = t[p], f = l.p;
              f === void 0 && (f = l[r]), f !== void 0 && s.push(f);
            }
            t[0] && t[0].width1 && (o = Math.min(t[0].width1, o));
          }
          this.positions = s;
          var v = n(s);
          this.distinctPositions = v.vals, v.vals.length === 1 && o !== 1 / 0 ? this.minDiff = o : this.minDiff = Math.min(v.minDiff, o);
          var g = (i.posAxis || {}).type;
          (g === "category" || g === "multicategory") && (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
        }
        e.prototype.put = function(a, i, o) {
          var r = this.getLabel(a, i, o), s = this.bins[r] || 0;
          return this.bins[r] = s + o, s;
        }, e.prototype.get = function(a, i, o) {
          var r = this.getLabel(a, i, o);
          return this.bins[r] || 0;
        }, e.prototype.getLabel = function(a, i, o) {
          var r = o < 0 && this.sepNegVal ? "v" : "^", s = this.overlapNoMerge ? a : Math.round(a / this.binWidth);
          return r + s + "g" + i;
        };
      }), Ho = xe((L, k) => {
        var n = xr(), e = wt().isArrayOrTypedArray, a = Yr().BADNUM, i = or(), o = Ar(), r = Fa().getAxisGroup, s = fp();
        function c(z, q) {
          for (var U = q.xaxis, G = q.yaxis, K = z._fullLayout, te = z._fullData, V = z.calcdata, Z = [], Y = [], C = 0; C < te.length; C++) {
            var j = te[C];
            if (j.visible === !0 && i.traceIs(j, "bar") && j.xaxis === U._id && j.yaxis === G._id && (j.orientation === "h" ? Z.push(V[C]) : Y.push(V[C]), j._computePh)) for (var J = z.calcdata[C], ne = 0; ne < J.length; ne++) typeof J[ne].ph0 == "function" && (J[ne].ph0 = J[ne].ph0()), typeof J[ne].ph1 == "function" && (J[ne].ph1 = J[ne].ph1());
          }
          var ae = { xCat: U.type === "category" || U.type === "multicategory", yCat: G.type === "category" || G.type === "multicategory", mode: K.barmode, norm: K.barnorm, gap: K.bargap, groupgap: K.bargroupgap };
          t(z, U, G, Y, ae), t(z, G, U, Z, ae);
        }
        function t(z, q, U, G, K) {
          if (G.length) {
            var te, V, Z, Y, C;
            switch (f(U, G), K.mode) {
              case "overlay":
                v(z, q, U, G, K);
                break;
              case "group":
                for (te = [], V = [], Z = 0; Z < G.length; Z++) Y = G[Z], C = Y[0].trace, C.offset === void 0 ? V.push(Y) : te.push(Y);
                V.length && g(z, q, U, V, K), te.length && v(z, q, U, te, K);
                break;
              case "stack":
              case "relative":
                for (te = [], V = [], Z = 0; Z < G.length; Z++) Y = G[Z], C = Y[0].trace, C.base === void 0 ? V.push(Y) : te.push(Y);
                l(V), V.length && x(z, q, U, V, K), te.length && v(z, q, U, te, K);
                break;
            }
            p(G), M(G, q);
          }
        }
        function p(z) {
          var q, U, G, K, te, V, Z;
          for (q = 0; q < z.length; q++) U = z[q], G = U[0].trace, K = U[0].t, K.cornerradiusvalue === void 0 && (te = G.marker ? G.marker.cornerradius : void 0, te !== void 0 && (V = n(te) ? +te : +te.slice(0, -1), Z = n(te) ? "px" : "%", K.cornerradiusvalue = V, K.cornerradiusform = Z));
        }
        function l(z) {
          if (!(z.length < 2)) {
            var q, U, G, K, te, V, Z;
            for (q = 0; q < z.length && (U = z[q], G = U[0].trace, te = G.marker ? G.marker.cornerradius : void 0, te === void 0); q++) ;
            if (te !== void 0) for (V = n(te) ? +te : +te.slice(0, -1), Z = n(te) ? "px" : "%", q = 0; q < z.length; q++) U = z[q], K = U[0].t, K.cornerradiusvalue = V, K.cornerradiusform = Z;
          }
        }
        function f(z, q) {
          var U, G;
          for (U = 0; U < q.length; U++) {
            var K = q[U], te = K[0].trace, V = te.type === "funnel" ? te._base : te.base, Z, Y = te.orientation === "h" ? te.xcalendar : te.ycalendar, C = z.type === "category" || z.type === "multicategory" ? function() {
              return null;
            } : z.d2c;
            if (e(V)) {
              for (G = 0; G < Math.min(V.length, K.length); G++) Z = C(V[G], 0, Y), n(Z) ? (K[G].b = +Z, K[G].hasB = 1) : K[G].b = 0;
              for (; G < K.length; G++) K[G].b = 0;
            } else {
              Z = C(V, 0, Y);
              var j = n(Z);
              for (Z = j ? Z : 0, G = 0; G < K.length; G++) K[G].b = Z, j && (K[G].hasB = 1);
            }
          }
        }
        function v(z, q, U, G, K) {
          for (var te = 0; te < G.length; te++) {
            var V = G[te], Z = new s([V], { posAxis: q, sepNegVal: !1, overlapNoMerge: !K.norm });
            h(z, q, Z, K), K.norm ? (T(Z), I(U, Z, K)) : y(U, Z);
          }
        }
        function g(z, q, U, G, K) {
          var te = new s(G, { posAxis: q, sepNegVal: !1, overlapNoMerge: !K.norm });
          h(z, q, te, K), R(te, q), K.norm ? (T(te), I(U, te, K)) : y(U, te);
        }
        function x(z, q, U, G, K) {
          var te = new s(G, { posAxis: q, sepNegVal: K.mode === "relative", overlapNoMerge: !(K.norm || K.mode === "stack" || K.mode === "relative") });
          h(z, q, te, K), _(U, te, K);
          for (var V = 0; V < G.length; V++) for (var Z = G[V], Y = Z[0].t.offsetindex, C = 0; C < Z.length; C++) {
            var j = Z[C];
            if (j.s !== a) {
              var J = j.b + j.s === te.get(j.p, Y, j.s);
              J && (j._outmost = !0);
            }
          }
          K.norm && I(U, te, K);
        }
        function h(z, q, U, G) {
          var K = z._fullLayout, te = U.positions, V = U.distinctPositions, Z = U.minDiff, Y = U.traces, C = Y.length, j = te.length !== V.length, J = Z * (1 - G.gap), ne, ae, se, O;
          if (q._id === "angularaxis") ne = J, ae = ne * (1 - (G.groupgap || 0)), se = -ae / 2;
          else {
            var F = r(K, q._id) + Y[0][0].trace.orientation;
            O = K._alignmentOpts[F] || {};
          }
          for (var S = 0; S < C; S++) {
            var $ = Y[S], re = $[0].trace;
            if (q._id !== "angularaxis") {
              var E = O[re.alignmentgroup] || {}, w = Object.keys(E.offsetGroups || {}).length;
              w ? ne = J / w : ne = j ? J / C : J, ae = ne * (1 - (G.groupgap || 0)), w ? se = ((2 * re._offsetIndex + 1 - w) * ne - ae) / 2 : se = j ? ((2 * S + 1 - C) * ne - ae) / 2 : -ae / 2;
            }
            var N = $[0].t;
            N.barwidth = ae, N.offsetindex = re._offsetIndex || 0, N.poffset = se, N.bargroupwidth = J, N.bardelta = Z;
          }
          U.binWidth = Y[0][0].t.barwidth / 100, m(U), u(q, U), q._id === "angularaxis" ? d(q, U) : d(q, U, j);
        }
        function m(z) {
          var q = z.traces, U, G;
          for (U = 0; U < q.length; U++) {
            var K = q[U], te = K[0], V = te.trace, Z = te.t, Y = V._offset || V.offset, C = Z.poffset, j;
            if (e(Y)) {
              for (j = Array.prototype.slice.call(Y, 0, K.length), G = 0; G < j.length; G++) n(j[G]) || (j[G] = C);
              for (G = j.length; G < K.length; G++) j.push(C);
              Z.poffset = j;
            } else Y !== void 0 && (Z.poffset = Y);
            var J = V._width || V.width, ne = Z.barwidth;
            if (e(J)) {
              var ae = Array.prototype.slice.call(J, 0, K.length);
              for (G = 0; G < ae.length; G++) n(ae[G]) || (ae[G] = ne);
              for (G = ae.length; G < K.length; G++) ae.push(ne);
              if (Z.barwidth = ae, Y === void 0) {
                for (j = [], G = 0; G < K.length; G++) j.push(C + (ne - ae[G]) / 2);
                Z.poffset = j;
              }
            } else J !== void 0 && (Z.barwidth = J, Y === void 0 && (Z.poffset = C + (ne - J) / 2));
          }
        }
        function u(z, q) {
          for (var U = q.traces, G = B(z), K = 0; K < U.length; K++) for (var te = U[K], V = te[0].t, Z = V.poffset, Y = e(Z), C = V.barwidth, j = e(C), J = 0; J < te.length; J++) {
            var ne = te[J], ae = ne.w = j ? C[J] : C;
            ne.p === void 0 && (ne.p = ne[G], ne["orig_" + G] = ne[G]);
            var se = (Y ? Z[J] : Z) + ae / 2;
            ne[G] = ne.p + se;
          }
        }
        function d(z, q, U) {
          var G = q.traces, K = q.minDiff, te = K / 2;
          o.minDtick(z, q.minDiff, q.distinctPositions[0], U);
          for (var V = 0; V < G.length; V++) {
            var Z = G[V], Y = Z[0], C = Y.trace, j = [], J, ne, ae, se;
            for (se = 0; se < Z.length; se++) J = Z[se], ne = J.p - te, ae = J.p + te, j.push(ne, ae);
            if (C.width || C.offset) {
              var O = Y.t, F = O.poffset, S = O.barwidth, $ = e(F), re = e(S);
              for (se = 0; se < Z.length; se++) {
                J = Z[se];
                var E = $ ? F[se] : F, w = re ? S[se] : S;
                ne = J.p + E, ae = ne + w, j.push(ne, ae);
              }
            }
            C._extremes[z._id] = o.findExtremes(z, j, { padded: !1 });
          }
        }
        function y(z, q) {
          for (var U = q.traces, G = B(z), K = 0; K < U.length; K++) {
            for (var te = U[K], V = te[0].trace, Z = V.type === "scatter", Y = V.orientation === "v", C = [], j = !1, J = 0; J < te.length; J++) {
              var ne = te[J], ae = Z ? 0 : ne.b, se = Z ? Y ? ne.y : ne.x : ae + ne.s;
              ne[G] = se, C.push(se), ne.hasB && C.push(ae), (!ne.hasB || !ne.b) && (j = !0);
            }
            V._extremes[z._id] = o.findExtremes(z, C, { tozero: j, padded: !0 });
          }
        }
        function _(z, q, U) {
          var G = B(z), K = q.traces, te, V, Z, Y, C, j, J;
          for (Y = 0; Y < K.length; Y++) if (te = K[Y], V = te[0].trace, V.type === "funnel") for (J = te[0].t.offsetindex, C = 0; C < te.length; C++) j = te[C], j.s !== a && q.put(j.p, J, -0.5 * j.s);
          for (Y = 0; Y < K.length; Y++) {
            te = K[Y], V = te[0].trace, Z = V.type === "funnel", J = V.type === "barpolar" ? 0 : te[0].t.offsetindex;
            var ne = [];
            for (C = 0; C < te.length; C++) if (j = te[C], j.s !== a) {
              var ae;
              Z ? ae = j.s : ae = j.s + j.b;
              var se = q.put(j.p, J, ae), O = se + ae;
              j.b = se, j[G] = O, U.norm || (ne.push(O), j.hasB && ne.push(se));
            }
            U.norm || (V._extremes[z._id] = o.findExtremes(z, ne, { tozero: !0, padded: !0 }));
          }
        }
        function T(z) {
          for (var q = z.traces, U = 0; U < q.length; U++) for (var G = q[U], K = G[0].t.offsetindex, te = 0; te < G.length; te++) {
            var V = G[te];
            V.s !== a && z.put(V.p, K, V.b + V.s);
          }
        }
        function R(z, q) {
          for (var U = z.traces, G = 0; G < U.length; G++) {
            var K = U[G], te = K[0].trace, V = K[0].t.offsetindex;
            if (te.base === void 0) for (var Z = new s([K], { posAxis: q, sepNegVal: !0, overlapNoMerge: !0 }), Y = 0; Y < K.length; Y++) {
              var C = K[Y];
              if (C.p !== a) {
                var j = Z.put(C.p, V, C.b + C.s);
                j && (C.b = j);
              }
            }
          }
        }
        function I(z, q, U) {
          var G = q.traces, K = B(z), te = U.norm === "fraction" ? 1 : 100, V = te / 1e9, Z = z.l2c(z.c2l(0)), Y = U.mode === "stack" ? te : Z;
          function C(N) {
            return n(z.c2l(N)) && (N < Z - V || N > Y + V || !n(Z));
          }
          for (var j = 0; j < G.length; j++) {
            for (var J = G[j], ne = J[0].t.offsetindex, ae = J[0].trace, se = [], O = !1, F = !1, S = 0; S < J.length; S++) {
              var $ = J[S];
              if ($.s !== a) {
                var re = Math.abs(te / q.get($.p, ne, $.s));
                $.b *= re, $.s *= re;
                var E = $.b, w = E + $.s;
                $[K] = w, se.push(w), F = F || C(w), $.hasB && (se.push(E), F = F || C(E)), (!$.hasB || !$.b) && (O = !0);
              }
            }
            ae._extremes[z._id] = o.findExtremes(z, se, { tozero: O, padded: F });
          }
        }
        function P(z, q, U, G) {
          for (var K = B(G), te = 0; te < z.length; te++) for (var V = z[te], Z = 0; Z < V.length; Z++) {
            var Y = V[Z], C = Y[K];
            Y._sMin = q[C], Y._sMax = U[C];
          }
        }
        function M(z, q) {
          var U = B(q), G = {}, K, te, V, Z = 1 / 0, Y = -1 / 0;
          for (K = 0; K < z.length; K++) for (V = z[K], te = 0; te < V.length; te++) {
            var C = V[te].p;
            n(C) && (Z = Math.min(Z, C), Y = Math.max(Y, C));
          }
          var j = 1e4 / (Y - Z), J = G.round = function(ee) {
            return String(Math.round(j * (ee - Z)));
          }, ne = {}, ae = {}, se = z.some(function(ee) {
            var le = ee[0].trace;
            return "marker" in le && le.marker.cornerradius;
          });
          for (K = 0; K < z.length; K++) {
            V = z[K], V[0].t.extents = G;
            var O = V[0].t.poffset, F = e(O);
            for (te = 0; te < V.length; te++) {
              var S = V[te], $ = S[U] - S.w / 2;
              if (n($)) {
                var re = S[U] + S.w / 2, E = J(S.p);
                G[E] ? G[E] = [Math.min($, G[E][0]), Math.max(re, G[E][1])] : G[E] = [$, re];
              }
              if (S.p0 = S.p + (F ? O[te] : O), S.p1 = S.p0 + S.w, S.s0 = S.b, S.s1 = S.s0 + S.s, se) {
                var w = Math.min(S.s0, S.s1) || 0, N = Math.max(S.s0, S.s1) || 0, W = S[U];
                ne[W] = W in ne ? Math.min(ne[W], w) : w, ae[W] = W in ae ? Math.max(ae[W], N) : N;
              }
            }
          }
          se && P(z, ne, ae, q);
        }
        function B(z) {
          return z._id.charAt(0);
        }
        k.exports = { crossTraceCalc: c, setGroupPositions: t };
      }), dp = xe((L, k) => {
        var n = jo(), e = Ho().setGroupPositions;
        function a(r, s) {
          for (var c = s.xaxis, t = s.yaxis, p = r._fullLayout, l = r._fullData, f = r.calcdata, v = [], g = [], x = 0; x < l.length; x++) {
            var h = l[x];
            h.visible === !0 && h.type === "scatter" && h.xaxis === c._id && h.yaxis === t._id && (h.orientation === "h" ? v.push(f[x]) : h.orientation === "v" && g.push(f[x]));
          }
          var m = { mode: p.scattermode, gap: p.scattergap };
          e(r, c, t, g, m), e(r, t, c, v, m);
        }
        k.exports = function(r, s) {
          r._fullLayout.scattermode === "group" && a(r, s);
          var c = s.xaxis, t = s.yaxis, p = c._id + t._id, l = r._fullLayout._scatterStackOpts[p];
          if (l) {
            var f = r.calcdata, v, g, x, h, m, u, d, y, _, T, R, I, P, M, B;
            for (var z in l) {
              T = l[z];
              var q = T.traceIndices;
              if (q.length) {
                for (R = T.stackgaps === "interpolate", I = T.groupnorm, T.orientation === "v" ? (P = "x", M = "y") : (P = "y", M = "x"), B = new Array(q.length), v = 0; v < B.length; v++) B[v] = !1;
                u = f[q[0]];
                var U = new Array(u.length);
                for (v = 0; v < u.length; v++) U[v] = u[v][P];
                for (v = 1; v < q.length; v++) {
                  for (m = f[q[v]], g = x = 0; g < m.length; g++) {
                    for (d = m[g][P]; d > U[x] && x < U.length; x++) i(m, g, U[x], v, B, R, P), g++;
                    if (d !== U[x]) {
                      for (h = 0; h < v; h++) i(f[q[h]], x, d, h, B, R, P);
                      U.splice(x, 0, d);
                    }
                    x++;
                  }
                  for (; x < U.length; x++) i(m, g, U[x], v, B, R, P), g++;
                }
                var G = U.length;
                for (g = 0; g < u.length; g++) {
                  for (y = u[g][M] = u[g].s, v = 1; v < q.length; v++) m = f[q[v]], m[0].trace._rawLength = m[0].trace._length, m[0].trace._length = G, y += m[g].s, m[g][M] = y;
                  if (I) for (_ = (I === "fraction" ? y : y / 100) || 1, v = 0; v < q.length; v++) {
                    var K = f[q[v]][g];
                    K[M] /= _, K.sNorm = K.s / _;
                  }
                }
                for (v = 0; v < q.length; v++) {
                  m = f[q[v]];
                  var te = m[0].trace, V = n.calcMarkerSize(te, te._rawLength), Z = Array.isArray(V);
                  if (V && B[v] || Z) {
                    var Y = V;
                    for (V = new Array(G), g = 0; g < G; g++) V[g] = m[g].gap ? 0 : Z ? Y[m[g].i] : Y;
                  }
                  var C = new Array(G), j = new Array(G);
                  for (g = 0; g < G; g++) C[g] = m[g].x, j[g] = m[g].y;
                  n.calcAxisExpansion(r, te, c, t, C, j, V), m[0].t.orientation = T.orientation;
                }
              }
            }
          }
        };
        function i(r, s, c, t, p, l, f) {
          p[t] = !0;
          var v = { i: null, gap: !0, s: 0 };
          if (v[f] = c, r.splice(s, 0, v), s && c === r[s - 1][f]) {
            var g = r[s - 1];
            v.s = g.s, v.i = g.i, v.gap = g.gap;
          } else l && (v.s = o(r, s, c, f));
          s || (r[0].t = r[1].t, r[0].trace = r[1].trace, delete r[1].t, delete r[1].trace);
        }
        function o(r, s, c, t) {
          var p = r[s - 1], l = r[s + 1];
          return l ? p ? p.s + (l.s - p.s) * (c - p[t]) / (l[t] - p[t]) : l.s : p.s;
        }
      }), Bs = xe((L, k) => {
        var n = Or(), e = Yr(), a = e.BADNUM, i = e.LOG_CLIP, o = i + 0.5, r = i - 0.5, s = wt(), c = s.segmentsIntersect, t = s.constrain, p = Si();
        k.exports = function(l, f) {
          var v = f.trace || {}, g = f.xaxis, x = f.yaxis, h = g.type === "log", m = x.type === "log", u = g._length, d = x._length, y = f.backoff, _ = v.marker, T = f.connectGaps, R = f.baseTolerance, I = f.shape, P = I === "linear", M = v.fill && v.fill !== "none", B = [], z = p.minTolerance, q = l.length, U = new Array(q), G = 0, K, te, V, Z, Y, C, j, J, ne, ae, se, O, F, S, $, re;
          function E(qe) {
            var Qe = l[qe];
            if (!Qe) return !1;
            var Xe = f.linearized ? g.l2p(Qe.x) : g.c2p(Qe.x), Je = f.linearized ? x.l2p(Qe.y) : x.c2p(Qe.y);
            if (Xe === a) {
              if (h && (Xe = g.c2p(Qe.x, !0)), Xe === a) return !1;
              m && Je === a && (Xe *= Math.abs(g._m * d * (g._m > 0 ? o : r) / (x._m * u * (x._m > 0 ? o : r)))), Xe *= 1e3;
            }
            if (Je === a) {
              if (m && (Je = x.c2p(Qe.y, !0)), Je === a) return !1;
              Je *= 1e3;
            }
            return [Xe, Je];
          }
          function w(qe, Qe, Xe, Je) {
            var ot = Xe - qe, lt = Je - Qe, st = 0.5 - qe, xt = 0.5 - Qe, Et = ot * ot + lt * lt, Bt = ot * st + lt * xt;
            if (Bt > 0 && Bt < Et) {
              var qt = st * lt - xt * ot;
              if (qt * qt < Et) return !0;
            }
          }
          var N, W;
          function ee(qe, Qe) {
            var Xe = qe[0] / u, Je = qe[1] / d, ot = Math.max(0, -Xe, Xe - 1, -Je, Je - 1);
            return ot && N !== void 0 && w(Xe, Je, N, W) && (ot = 0), ot && Qe && w(Xe, Je, Qe[0] / u, Qe[1] / d) && (ot = 0), (1 + p.toleranceGrowth * ot) * R;
          }
          function le(qe, Qe) {
            var Xe = qe[0] - Qe[0], Je = qe[1] - Qe[1];
            return Math.sqrt(Xe * Xe + Je * Je);
          }
          var ie = p.maxScreensAway, pe = -u * ie, _e = u * (1 + ie), Ae = -d * ie, Ce = d * (1 + ie), Ue = [[pe, Ae, _e, Ae], [_e, Ae, _e, Ce], [_e, Ce, pe, Ce], [pe, Ce, pe, Ae]], Ne, ke, A, X, H, ve;
          function be(qe, Qe) {
            for (var Xe = [], Je = 0, ot = 0; ot < 4; ot++) {
              var lt = Ue[ot], st = c(qe[0], qe[1], Qe[0], Qe[1], lt[0], lt[1], lt[2], lt[3]);
              st && (!Je || Math.abs(st.x - Xe[0][0]) > 1 || Math.abs(st.y - Xe[0][1]) > 1) && (st = [st.x, st.y], Je && le(st, qe) < le(Xe[0], qe) ? Xe.unshift(st) : Xe.push(st), Je++);
            }
            return Xe;
          }
          function Se(qe) {
            if (qe[0] < pe || qe[0] > _e || qe[1] < Ae || qe[1] > Ce) return [t(qe[0], pe, _e), t(qe[1], Ae, Ce)];
          }
          function De(qe, Qe) {
            if (qe[0] === Qe[0] && (qe[0] === pe || qe[0] === _e) || qe[1] === Qe[1] && (qe[1] === Ae || qe[1] === Ce)) return !0;
          }
          function He(qe, Qe) {
            var Xe = [], Je = Se(qe), ot = Se(Qe);
            return Je && ot && De(Je, ot) || (Je && Xe.push(Je), ot && Xe.push(ot)), Xe;
          }
          function Ze(qe, Qe, Xe) {
            return function(Je, ot) {
              var lt = Se(Je), st = Se(ot), xt = [];
              if (lt && st && De(lt, st)) return xt;
              lt && xt.push(lt), st && xt.push(st);
              var Et = 2 * s.constrain((Je[qe] + ot[qe]) / 2, Qe, Xe) - ((lt || Je)[qe] + (st || ot)[qe]);
              if (Et) {
                var Bt;
                lt && st ? Bt = Et > 0 == lt[qe] > st[qe] ? lt : st : Bt = lt || st, Bt[qe] += Et;
              }
              return xt;
            };
          }
          var We;
          I === "linear" || I === "spline" ? We = be : I === "hv" || I === "vh" ? We = He : I === "hvh" ? We = Ze(0, pe, _e) : I === "vhv" && (We = Ze(1, Ae, Ce));
          function $e(qe, Qe) {
            var Xe = Qe[0] - qe[0], Je = (Qe[1] - qe[1]) / Xe, ot = (qe[1] * Qe[0] - Qe[1] * qe[0]) / Xe;
            return ot > 0 ? [Je > 0 ? pe : _e, Ce] : [Je > 0 ? _e : pe, Ae];
          }
          function it(qe) {
            var Qe = qe[0], Xe = qe[1], Je = Qe === U[G - 1][0], ot = Xe === U[G - 1][1];
            if (!(Je && ot)) if (G > 1) {
              var lt = Qe === U[G - 2][0], st = Xe === U[G - 2][1];
              Je && (Qe === pe || Qe === _e) && lt ? st ? G-- : U[G - 1] = qe : ot && (Xe === Ae || Xe === Ce) && st ? lt ? G-- : U[G - 1] = qe : U[G++] = qe;
            } else U[G++] = qe;
          }
          function Ke(qe) {
            U[G - 1][0] !== qe[0] && U[G - 1][1] !== qe[1] && it([A, X]), it(qe), H = null, A = X = 0;
          }
          var ct = s.isArrayOrTypedArray(_);
          function gt(qe) {
            if (qe && y && (qe.i = K, qe.d = l, qe.trace = v, qe.marker = ct ? _[qe.i] : _, qe.backoff = y), N = qe[0] / u, W = qe[1] / d, Ne = qe[0] < pe ? pe : qe[0] > _e ? _e : 0, ke = qe[1] < Ae ? Ae : qe[1] > Ce ? Ce : 0, Ne || ke) {
              if (!G) U[G++] = [Ne || qe[0], ke || qe[1]];
              else if (H) {
                var Qe = We(H, qe);
                Qe.length > 1 && (Ke(Qe[0]), U[G++] = Qe[1]);
              } else ve = We(U[G - 1], qe)[0], U[G++] = ve;
              var Xe = U[G - 1];
              Ne && ke && (Xe[0] !== Ne || Xe[1] !== ke) ? (H && (A !== Ne && X !== ke ? it(A && X ? $e(H, qe) : [A || Ne, X || ke]) : A && X && it([A, X])), it([Ne, ke])) : A - Ne && X - ke && it([Ne || A, ke || X]), H = qe, A = Ne, X = ke;
            } else H && Ke(We(H, qe)[0]), U[G++] = qe;
          }
          for (K = 0; K < q; K++) if (te = E(K), !!te) {
            for (G = 0, H = null, gt(te), K++; K < q; K++) {
              if (Z = E(K), !Z) {
                if (T) continue;
                break;
              }
              if (!P || !f.simplify) {
                gt(Z);
                continue;
              }
              var ht = E(K + 1);
              if (ae = le(Z, te), !(!(M && (G === 0 || G === q - 1)) && ae < ee(Z, ht) * z)) {
                for (J = [(Z[0] - te[0]) / ae, (Z[1] - te[1]) / ae], Y = te, se = ae, O = S = $ = 0, j = !1, V = Z, K++; K < l.length; K++) {
                  if (C = ht, ht = E(K + 1), !C) {
                    if (T) continue;
                    break;
                  }
                  if (ne = [C[0] - te[0], C[1] - te[1]], re = ne[0] * J[1] - ne[1] * J[0], S = Math.min(S, re), $ = Math.max($, re), $ - S > ee(C, ht)) break;
                  V = C, F = ne[0] * J[0] + ne[1] * J[1], F > se ? (se = F, Z = C, j = !1) : F < O && (O = F, Y = C, j = !0);
                }
                if (j ? (gt(Z), V !== Y && gt(Y)) : (Y !== te && gt(Y), V !== Z && gt(Z)), gt(V), K >= l.length || !C) break;
                gt(C), te = C;
              }
            }
            H && it([A || H[0], X || H[1]]), B.push(U.slice(0, G));
          }
          var _t = I.slice(I.length - 1);
          if (y && _t !== "h" && _t !== "v") {
            for (var Te = !1, Ie = -1, ce = [], ge = 0; ge < B.length; ge++) for (var ye = 0; ye < B[ge].length - 1; ye++) {
              var Me = B[ge][ye], Oe = B[ge][ye + 1], je = n.applyBackoff(Oe, Me);
              (je[0] !== Oe[0] || je[1] !== Oe[1]) && (Te = !0), ce[Ie + 1] || (Ie++, ce[Ie] = [Me, [je[0], je[1]]]);
            }
            return Te ? ce : B;
          }
          return B;
        };
      }), pp = xe((L, k) => {
        var n = { tonextx: 1, tonexty: 1, tonext: 1 };
        k.exports = function(e, a, i) {
          var o, r, s, c, t, p = {}, l = !1, f = -1, v = 0, g = -1;
          for (r = 0; r < i.length; r++) o = i[r][0].trace, s = o.stackgroup || "", s ? s in p ? t = p[s] : (t = p[s] = v, v++) : o.fill in n && g >= 0 ? t = g : (t = g = v, v++), t < f && (l = !0), o._groupIndex = f = t;
          var x = i.slice();
          l && x.sort(function(m, u) {
            var d = m[0].trace, y = u[0].trace;
            return d._groupIndex - y._groupIndex || d.index - y.index;
          });
          var h = {};
          for (r = 0; r < x.length; r++) o = x[r][0].trace, s = o.stackgroup || "", o.visible === !0 ? (o._nexttrace = null, o.fill in n && (c = h[s], o._prevtrace = c || null, c && (c._nexttrace = o)), o._ownfill = o.fill && (o.fill.substr(0, 6) === "tozero" || o.fill === "toself" || o.fill.substr(0, 2) === "to" && !o._prevtrace), h[s] = o) : o._prevtrace = o._nexttrace = o._ownfill = null;
          return x;
        };
      }), js = xe((L, k) => {
        var n = vr(), e = or(), a = wt(), i = a.ensureSingle, o = a.identity, r = Or(), s = Fn(), c = Bs(), t = pp(), p = Ms().tester;
        k.exports = function(g, x, h, m, u, d) {
          var y, _, T = !u, R = !!u && u.duration > 0, I = t(g, x, h);
          if (y = m.selectAll("g.trace").data(I, function(M) {
            return M[0].trace.uid;
          }), y.enter().append("g").attr("class", function(M) {
            return "trace scatter trace" + M[0].trace.uid;
          }).style("stroke-miterlimit", 2), y.order(), l(g, y, x), R) {
            d && (_ = d());
            var P = n.transition().duration(u.duration).ease(u.easing).each("end", function() {
              _ && _();
            }).each("interrupt", function() {
              _ && _();
            });
            P.each(function() {
              m.selectAll("g.trace").each(function(M, B) {
                f(g, B, x, M, I, this, u);
              });
            });
          } else y.each(function(M, B) {
            f(g, B, x, M, I, this, u);
          });
          T && y.exit().remove(), m.selectAll("path:not([d])").remove();
        };
        function l(g, x, h) {
          x.each(function(m) {
            var u = i(n.select(this), "g", "fills");
            r.setClipUrl(u, h.layerClipId, g);
            var d = m[0].trace, y = [];
            d._ownfill && y.push("_ownFill"), d._nexttrace && y.push("_nextFill");
            var _ = u.selectAll("g").data(y, o);
            _.enter().append("g"), _.exit().each(function(T) {
              d[T] = null;
            }).remove(), _.order().each(function(T) {
              d[T] = i(n.select(this), "path", "js-fill");
            });
          });
        }
        function f(g, x, h, m, u, d, y) {
          var _ = g._context.staticPlot, T;
          v(g, x, h, m, u);
          var R = !!y && y.duration > 0;
          function I(Ke) {
            return R ? Ke.transition() : Ke;
          }
          var P = h.xaxis, M = h.yaxis, B = m[0].trace, z = B.line, q = n.select(d), U = i(q, "g", "errorbars"), G = i(q, "g", "lines"), K = i(q, "g", "points"), te = i(q, "g", "text");
          if (e.getComponentMethod("errorbars", "plot")(g, U, h, y), B.visible !== !0) return;
          I(q).style("opacity", B.opacity);
          var V, Z, Y = B.fill.charAt(B.fill.length - 1);
          Y !== "x" && Y !== "y" && (Y = "");
          var C, j;
          Y === "y" ? (C = 1, j = M.c2p(0, !0)) : Y === "x" && (C = 0, j = P.c2p(0, !0)), m[0][h.isRangePlot ? "nodeRangePlot3" : "node3"] = q;
          var J = "", ne = [], ae = B._prevtrace, se = null, O = null;
          ae && (J = ae._prevRevpath || "", Z = ae._nextFill, ne = ae._ownPolygons, se = ae._fillsegments, O = ae._fillElement);
          var F, S, $ = "", re = "", E, w, N, W, ee, le, ie = [];
          B._polygons = [];
          var pe = [], _e = [], Ae = a.noop;
          if (V = B._ownFill, s.hasLines(B) || B.fill !== "none") {
            Z && Z.datum(m), ["hv", "vh", "hvh", "vhv"].indexOf(z.shape) !== -1 ? (E = r.steps(z.shape), w = r.steps(z.shape.split("").reverse().join(""))) : z.shape === "spline" ? E = w = function(Ke) {
              var ct = Ke[Ke.length - 1];
              return Ke.length > 1 && Ke[0][0] === ct[0] && Ke[0][1] === ct[1] ? r.smoothclosed(Ke.slice(1), z.smoothing) : r.smoothopen(Ke, z.smoothing);
            } : E = w = function(Ke) {
              return "M" + Ke.join("L");
            }, N = function(Ke) {
              return w(Ke.reverse());
            }, _e = c(m, { xaxis: P, yaxis: M, trace: B, connectGaps: B.connectgaps, baseTolerance: Math.max(z.width || 1, 3) / 4, shape: z.shape, backoff: z.backoff, simplify: z.simplify, fill: B.fill }), pe = new Array(_e.length);
            var Ce = 0;
            for (T = 0; T < _e.length; T++) {
              var Ue, Ne = _e[T];
              !Ue || !Y ? (Ue = Ne.slice(), pe[Ce] = Ue, Ce++) : Ue.push.apply(Ue, Ne);
            }
            B._fillElement = null, B._fillExclusionElement = O, B._fillsegments = pe.slice(0, Ce), pe = B._fillsegments, _e.length && (W = _e[0][0].slice(), ee = _e[_e.length - 1], le = ee[ee.length - 1].slice()), Ae = function(Ke) {
              return function(ct) {
                if (F = E(ct), S = N(ct), $ ? Y ? ($ += "L" + F.substr(1), re = S + ("L" + re.substr(1))) : ($ += "Z" + F, re = S + "Z" + re) : ($ = F, re = S), s.hasLines(B)) {
                  var gt = n.select(this);
                  if (gt.datum(m), Ke) I(gt.style("opacity", 0).attr("d", F).call(r.lineGroupStyle)).style("opacity", 1);
                  else {
                    var ht = I(gt);
                    ht.attr("d", F), r.singleLineStyle(m, ht);
                  }
                }
              };
            };
          }
          var ke = G.selectAll(".js-line").data(_e);
          I(ke.exit()).style("opacity", 0).remove(), ke.each(Ae(!1)), ke.enter().append("path").classed("js-line", !0).style("vector-effect", _ ? "none" : "non-scaling-stroke").call(r.lineGroupStyle).each(Ae(!0)), r.setClipUrl(ke, h.layerClipId, g);
          function A(Ke) {
            I(Ke).attr("d", "M0,0Z");
          }
          var X = function() {
            var Ke = new Array(pe.length);
            for (T = 0; T < pe.length; T++) Ke[T] = p(pe[T]);
            return Ke;
          }, H = function(Ke) {
            var ct, gt;
            if (!Ke || Ke.length === 0) for (ct = new Array(pe.length), gt = 0; gt < pe.length; gt++) {
              var ht = pe[gt][0].slice(), _t = pe[gt][pe[gt].length - 1].slice();
              ht[C] = _t[C] = j;
              var Te = [_t, ht], Ie = Te.concat(pe[gt]);
              ct[gt] = p(Ie);
            }
            else {
              for (ct = new Array(Ke.length - 1 + pe.length), gt = 0; gt < Ke.length - 1; gt++) ct[gt] = p(Ke[gt]);
              var ce = Ke[Ke.length - 1].slice();
              for (ce.reverse(), gt = 0; gt < pe.length; gt++) ct[Ke.length - 1 + gt] = p(pe[gt].concat(ce));
            }
            return ct;
          };
          _e.length ? (V ? (V.datum(m), W && le && (Y ? (W[C] = le[C] = j, I(V).attr("d", "M" + le + "L" + W + "L" + $.substr(1)).call(r.singleFillStyle, g), ie = H(null)) : (I(V).attr("d", $ + "Z").call(r.singleFillStyle, g), ie = X())), B._polygons = ie, B._fillElement = V) : Z && (B.fill.substr(0, 6) === "tonext" && $ && J ? (B.fill === "tonext" ? (I(Z).attr("d", $ + "Z" + J + "Z").call(r.singleFillStyle, g), ie = X(), B._polygons = ie.concat(ne)) : (I(Z).attr("d", $ + "L" + J.substr(1) + "Z").call(r.singleFillStyle, g), ie = H(se), B._polygons = ie), B._fillElement = Z) : A(Z)), B._prevRevpath = re) : (V ? A(V) : Z && A(Z), B._prevRevpath = null), B._ownPolygons = ie;
          function ve(Ke) {
            return Ke.filter(function(ct) {
              return !ct.gap && ct.vis;
            });
          }
          function be(Ke) {
            return Ke.filter(function(ct) {
              return ct.vis;
            });
          }
          function Se(Ke) {
            return Ke.filter(function(ct) {
              return !ct.gap;
            });
          }
          function De(Ke) {
            return Ke.id;
          }
          function He(Ke) {
            if (Ke.ids) return De;
          }
          function Ze() {
            return !1;
          }
          function We(Ke, ct, gt) {
            var ht, _t, Te, Ie = gt[0].trace, ce = s.hasMarkers(Ie), ge = s.hasText(Ie), ye = He(Ie), Me = Ze, Oe = Ze;
            if (ce || ge) {
              var je = o, qe = Ie.stackgroup, Qe = qe && g._fullLayout._scatterStackOpts[P._id + M._id][qe].stackgaps === "infer zero";
              Ie.marker.maxdisplayed || Ie._needsCull ? je = Qe ? be : ve : qe && !Qe && (je = Se), ce && (Me = je), ge && (Oe = je);
            }
            _t = Ke.selectAll("path.point"), ht = _t.data(Me, ye);
            var Xe = ht.enter().append("path").classed("point", !0);
            R && Xe.call(r.pointStyle, Ie, g).call(r.translatePoints, P, M).style("opacity", 0).transition().style("opacity", 1), ht.order();
            var Je;
            ce && (Je = r.makePointStyleFns(Ie)), ht.each(function(ot) {
              var lt = n.select(this), st = I(lt);
              Te = r.translatePoint(ot, st, P, M), Te ? (r.singlePointStyle(ot, st, Ie, Je, g), h.layerClipId && r.hideOutsideRangePoint(ot, st, P, M, Ie.xcalendar, Ie.ycalendar), Ie.customdata && lt.classed("plotly-customdata", ot.data !== null && ot.data !== void 0)) : st.remove();
            }), R ? ht.exit().transition().style("opacity", 0).remove() : ht.exit().remove(), _t = ct.selectAll("g"), ht = _t.data(Oe, ye), ht.enter().append("g").classed("textpoint", !0).append("text"), ht.order(), ht.each(function(ot) {
              var lt = n.select(this), st = I(lt.select("text"));
              Te = r.translatePoint(ot, st, P, M), Te ? h.layerClipId && r.hideOutsideRangePoint(ot, lt, P, M, Ie.xcalendar, Ie.ycalendar) : lt.remove();
            }), ht.selectAll("text").call(r.textPointStyle, Ie, g).each(function(ot) {
              var lt = P.c2p(ot.x), st = M.c2p(ot.y);
              n.select(this).selectAll("tspan.line").each(function() {
                I(n.select(this)).attr({ x: lt, y: st });
              });
            }), ht.exit().remove();
          }
          K.datum(m), te.datum(m), We(K, te, m);
          var $e = B.cliponaxis === !1, it = $e ? null : h.layerClipId;
          r.setClipUrl(K, it, g), r.setClipUrl(te, it, g);
        }
        function v(g, x, h, m, u) {
          var d = h.xaxis, y = h.yaxis, _ = n.extent(a.simpleMap(d.range, d.r2c)), T = n.extent(a.simpleMap(y.range, y.r2c)), R = m[0].trace;
          if (s.hasMarkers(R)) {
            var I = R.marker.maxdisplayed;
            if (I !== 0) {
              var P = m.filter(function(q) {
                return q.x >= _[0] && q.x <= _[1] && q.y >= T[0] && q.y <= T[1];
              }), M = Math.ceil(P.length / I), B = 0;
              u.forEach(function(q, U) {
                var G = q[0].trace;
                s.hasMarkers(G) && G.marker.maxdisplayed > 0 && U < x && B++;
              });
              var z = Math.round(B * M / 3 + Math.floor(B / 3) * M / 7.1);
              m.forEach(function(q) {
                delete q.vis;
              }), P.forEach(function(q, U) {
                Math.round((U + z) % M) === 0 && (q.vis = !0);
              });
            }
          }
        }
      }), Ci = xe((L, k) => {
        k.exports = { container: "marker", min: "cmin", max: "cmax" };
      }), Hs = xe((L, k) => {
        var n = Ar();
        k.exports = function(e, a, i) {
          var o = {}, r = { _fullLayout: i }, s = n.getFromTrace(r, a, "x"), c = n.getFromTrace(r, a, "y"), t = e.orig_x;
          t === void 0 && (t = e.x);
          var p = e.orig_y;
          return p === void 0 && (p = e.y), o.xLabel = n.tickText(s, s.c2l(t), !0).text, o.yLabel = n.tickText(c, c.c2l(p), !0).text, o;
        };
      }), Ba = xe((L, k) => {
        var n = vr(), e = Or(), a = or();
        function i(c) {
          var t = n.select(c).selectAll("g.trace.scatter");
          t.style("opacity", function(p) {
            return p[0].trace.opacity;
          }), t.selectAll("g.points").each(function(p) {
            var l = n.select(this), f = p.trace || p[0].trace;
            o(l, f, c);
          }), t.selectAll("g.text").each(function(p) {
            var l = n.select(this), f = p.trace || p[0].trace;
            r(l, f, c);
          }), t.selectAll("g.trace path.js-line").call(e.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(e.fillGroupStyle, c, !1), a.getComponentMethod("errorbars", "style")(t);
        }
        function o(c, t, p) {
          e.pointStyle(c.selectAll("path.point"), t, p);
        }
        function r(c, t, p) {
          e.textPointStyle(c.selectAll("text"), t, p);
        }
        function s(c, t, p) {
          var l = t[0].trace;
          l.selectedpoints ? (e.selectedPointStyle(p.selectAll("path.point"), l), e.selectedTextStyle(p.selectAll("text"), l)) : (o(p, l, c), r(p, l, c));
        }
        k.exports = { style: i, stylePoints: o, styleText: r, styleOnSelect: s };
      }), hp = xe((L, k) => {
        var n = fr(), e = Fn();
        k.exports = function(a, i) {
          var o, r;
          if (a.mode === "lines") return o = a.line.color, o && n.opacity(o) ? o : a.fillcolor;
          if (a.mode === "none") return a.fill ? a.fillcolor : "";
          var s = i.mcc || (a.marker || {}).color, c = i.mlcc || ((a.marker || {}).line || {}).color;
          return r = s && n.opacity(s) ? s : c && n.opacity(c) && (i.mlw || ((a.marker || {}).line || {}).width) ? c : "", r ? n.opacity(r) < 0.3 ? n.addOpacity(r, 0.3) : r : (o = (a.line || {}).color, o && n.opacity(o) && e.hasLines(a) && a.line.width ? o : a.fillcolor);
        };
      }), qs = xe((L, k) => {
        var n = wt(), e = Bn(), a = or(), i = hp(), o = fr(), r = n.fillText;
        k.exports = function(s, c, t, p) {
          var l = s.cd, f = l[0].trace, v = s.xa, g = s.ya, x = v.c2p(c), h = g.c2p(t), m = [x, h], u = f.hoveron || "", d = f.mode.indexOf("markers") !== -1 ? 3 : 0.5, y = !!f.xperiodalignment, _ = !!f.yperiodalignment;
          if (u.indexOf("points") !== -1) {
            var T = function(J) {
              if (y) {
                var ne = v.c2p(J.xStart), ae = v.c2p(J.xEnd);
                return x >= Math.min(ne, ae) && x <= Math.max(ne, ae) ? 0 : 1 / 0;
              }
              var se = Math.max(3, J.mrc || 0), O = 1 - 1 / se, F = Math.abs(v.c2p(J.x) - x);
              return F < se ? O * F / se : F - se + O;
            }, R = function(J) {
              if (_) {
                var ne = g.c2p(J.yStart), ae = g.c2p(J.yEnd);
                return h >= Math.min(ne, ae) && h <= Math.max(ne, ae) ? 0 : 1 / 0;
              }
              var se = Math.max(3, J.mrc || 0), O = 1 - 1 / se, F = Math.abs(g.c2p(J.y) - h);
              return F < se ? O * F / se : F - se + O;
            }, I = function(J) {
              var ne = Math.max(d, J.mrc || 0), ae = v.c2p(J.x) - x, se = g.c2p(J.y) - h;
              return Math.max(Math.sqrt(ae * ae + se * se) - ne, 1 - d / ne);
            }, P = e.getDistanceFunction(p, T, R, I);
            if (e.getClosest(l, P, s), s.index !== !1) {
              var M = l[s.index], B = v.c2p(M.x, !0), z = g.c2p(M.y, !0), q = M.mrc || 1;
              s.index = M.i;
              var U = l[0].t.orientation, G = U && (M.sNorm || M.s), K = U === "h" ? G : M.orig_x !== void 0 ? M.orig_x : M.x, te = U === "v" ? G : M.orig_y !== void 0 ? M.orig_y : M.y;
              return n.extendFlat(s, { color: i(f, M), x0: B - q, x1: B + q, xLabelVal: K, y0: z - q, y1: z + q, yLabelVal: te, spikeDistance: I(M), hovertemplate: f.hovertemplate }), r(M, f, s), a.getComponentMethod("errorbars", "hoverInfo")(M, f, s), [s];
            }
          }
          function V(J) {
            if (!J) return !1;
            var ne = J.node();
            try {
              var ae = new DOMPoint(m[0], m[1]);
              return ne.isPointInFill(ae);
            } catch {
              var se = ne.ownerSVGElement.createSVGPoint();
              return se.x = m[0], se.y = m[1], ne.isPointInFill(se);
            }
          }
          function Z(J) {
            var ne, ae = [], se = 1 / 0, O = -1 / 0, F = 1 / 0, S = -1 / 0, $;
            for (ne = 0; ne < J.length; ne++) {
              var re = J[ne];
              re.contains(m) && (ae.push(re), F = Math.min(F, re.ymin), S = Math.max(S, re.ymax));
            }
            if (ae.length === 0) return null;
            F = Math.max(F, 0), S = Math.min(S, g._length), $ = (F + S) / 2;
            var E, w, N, W, ee, le, ie;
            for (ne = 0; ne < ae.length; ne++) for (w = ae[ne].pts, E = 1; E < w.length; E++) le = w[E - 1][1], ie = w[E][1], le > $ != ie >= $ && (W = w[E - 1][0], ee = w[E][0], ie - le && (N = W + (ee - W) * ($ - le) / (ie - le), se = Math.min(se, N), O = Math.max(O, N)));
            return se = Math.max(se, 0), O = Math.min(O, v._length), { x0: se, x1: O, y0: $, y1: $ };
          }
          if (u.indexOf("fills") !== -1 && f._fillElement) {
            var Y = V(f._fillElement) && !V(f._fillExclusionElement);
            if (Y) {
              var C = Z(f._polygons);
              C === null && (C = { x0: m[0], x1: m[0], y0: m[1], y1: m[1] });
              var j = o.defaultLine;
              return o.opacity(f.fillcolor) ? j = f.fillcolor : o.opacity((f.line || {}).color) && (j = f.line.color), n.extendFlat(s, { distance: s.maxHoverDistance, x0: C.x0, x1: C.x1, y0: C.y0, y1: C.y1, color: j, hovertemplate: !1 }), delete s.index, f.text && !n.isArrayOrTypedArray(f.text) ? s.text = String(f.text) : s.text = f.name, [s];
            }
          }
        };
      }), Us = xe((L, k) => {
        var n = Fn();
        k.exports = function(e, a) {
          var i = e.cd, o = e.xaxis, r = e.yaxis, s = [], c = i[0].trace, t, p, l, f, v = !n.hasMarkers(c) && !n.hasText(c);
          if (v) return [];
          if (a === !1) for (t = 0; t < i.length; t++) i[t].selected = 0;
          else for (t = 0; t < i.length; t++) p = i[t], l = o.c2p(p.x), f = r.c2p(p.y), p.i !== null && a.contains([l, f], !1, t, e) ? (s.push({ pointNumber: p.i, x: o.c2d(p.x), y: r.c2d(p.y) }), p.selected = 1) : p.selected = 0;
          return s;
        };
      }), vp = xe((L, k) => {
        k.exports = { xaxis: { valType: "subplotid", dflt: "x", editType: "calc+clearAxisTypes" }, yaxis: { valType: "subplotid", dflt: "y", editType: "calc+clearAxisTypes" } };
      }), gp = xe((L, k) => {
        var n = or().traceIs, e = wo();
        k.exports = function(s, c, t, p) {
          t("autotypenumbers", p.autotypenumbersDflt);
          var l = t("type", (p.splomStash || {}).type);
          l === "-" && (a(c, p.data), c.type === "-" ? c.type = "linear" : s.type = c.type);
        };
        function a(s, c) {
          if (s.type === "-") {
            var t = s._id, p = t.charAt(0), l;
            t.indexOf("scene") !== -1 && (t = p);
            var f = i(c, t, p);
            if (f) {
              if (f.type === "histogram" && p === { v: "y", h: "x" }[f.orientation || "v"]) {
                s.type = "linear";
                return;
              }
              var v = p + "calendar", g = f[v], x = { noMultiCategory: !n(f, "cartesian") || n(f, "noMultiCategory") };
              if (f.type === "box" && f._hasPreCompStats && p === { h: "x", v: "y" }[f.orientation || "v"] && (x.noMultiCategory = !0), x.autotypenumbers = s.autotypenumbers, r(f, p)) {
                var h = o(f), m = [];
                for (l = 0; l < c.length; l++) {
                  var u = c[l];
                  !n(u, "box-violin") || (u[p + "axis"] || p) !== t || (u[h] !== void 0 ? m.push(u[h][0]) : u.name !== void 0 ? m.push(u.name) : m.push("text"), u[v] !== g && (g = void 0));
                }
                s.type = e(m, g, x);
              } else if (f.type === "splom") {
                var d = f.dimensions, y = d[f._axesDim[t]];
                y.visible && (s.type = e(y.values, g, x));
              } else s.type = e(f[p] || [f[p + "0"]], g, x);
            }
          }
        }
        function i(s, c, t) {
          for (var p = 0; p < s.length; p++) {
            var l = s[p];
            if (l.type === "splom" && l._length > 0 && (l["_" + t + "axes"] || {})[c] || (l[t + "axis"] || t) === c && (r(l, t) || (l[t] || []).length || l[t + "0"]))
              return l;
          }
        }
        function o(s) {
          return { v: "x", h: "y" }[s.orientation || "v"];
        }
        function r(s, c) {
          var t = o(s), p = n(s, "box-violin"), l = n(s._fullInput || {}, "candlestick");
          return p && !l && c === t && s[t] === void 0 && s[t + "0"] === void 0;
        }
      }), yp = xe((L, k) => {
        var n = Hn().isTypedArraySpec;
        function e(a, i) {
          var o = i.dataAttr || a._id.charAt(0), r = {}, s, c, t;
          if (i.axData) s = i.axData;
          else for (s = [], c = 0; c < i.data.length; c++) {
            var p = i.data[c];
            p[o + "axis"] === a._id && s.push(p);
          }
          for (c = 0; c < s.length; c++) {
            var l = s[c][o];
            for (t = 0; t < l.length; t++) {
              var f = l[t];
              f != null && (r[f] = 1);
            }
          }
          return Object.keys(r);
        }
        k.exports = function(a, i, o, r) {
          if (i.type === "category") {
            var s = a.categoryarray, c = Array.isArray(s) && s.length > 0 || n(s), t;
            c && (t = "array");
            var p = o("categoryorder", t), l;
            p === "array" && (l = o("categoryarray")), !c && p === "array" && (p = i.categoryorder = "trace"), p === "trace" ? i._initialCategories = [] : p === "array" ? i._initialCategories = l.slice() : (l = e(i, r).sort(), p === "category ascending" ? i._initialCategories = l : p === "category descending" && (i._initialCategories = l.reverse()));
          }
        };
      }), Vs = xe((L, k) => {
        var n = Nn().mix, e = Zn(), a = wt();
        k.exports = function(i, o, r, s) {
          s = s || {};
          var c = s.dfltColor;
          function t(M, B) {
            return a.coerce2(i, o, s.attributes, M, B);
          }
          var p = t("linecolor", c), l = t("linewidth"), f = r("showline", s.showLine || !!p || !!l);
          f || (delete o.linecolor, delete o.linewidth);
          var v = n(c, s.bgColor, s.blend || e.lightFraction).toRgbString(), g = t("gridcolor", v), x = t("gridwidth"), h = t("griddash"), m = r("showgrid", s.showGrid || !!g || !!x || !!h);
          if (m || (delete o.gridcolor, delete o.gridwidth, delete o.griddash), s.hasMinor) {
            var u = n(o.gridcolor, s.bgColor, 67).toRgbString(), d = t("minor.gridcolor", u), y = t("minor.gridwidth", o.gridwidth || 1), _ = t("minor.griddash", o.griddash || "solid"), T = r("minor.showgrid", !!d || !!y || !!_);
            T || (delete o.minor.gridcolor, delete o.minor.gridwidth, delete o.minor.griddash);
          }
          if (!s.noZeroLine) {
            t("zerolinelayer");
            var R = t("zerolinecolor", c), I = t("zerolinewidth"), P = r("zeroline", s.showGrid || !!R || !!I);
            P || (delete o.zerolinelayer, delete o.zerolinecolor, delete o.zerolinewidth);
          }
        };
      }), Ys = xe((L, k) => {
        var n = xr(), e = or(), a = wt(), i = qr(), o = aa(), r = Xn(), s = mo(), c = xo(), t = bo(), p = _o(), l = yp(), f = Vs(), v = ss(), g = ri(), x = mn().WEEKDAY_PATTERN, h = mn().HOUR_PATTERN;
        k.exports = function(y, _, T, R, I) {
          var P = R.letter, M = R.font || {}, B = R.splomStash || {}, z = T("visible", !R.visibleDflt), q = _._template || {}, U = _.type || q.type || "-", G;
          if (U === "date") {
            var K = e.getComponentMethod("calendars", "handleDefaults");
            K(y, _, "calendar", R.calendar), R.noTicklabelmode || (G = T("ticklabelmode"));
          }
          !R.noTicklabelindex && (U === "date" || U === "linear") && T("ticklabelindex");
          var te = "";
          (!R.noTicklabelposition || U === "multicategory") && (te = a.coerce(y, _, { ticklabelposition: { valType: "enumerated", dflt: "outside", values: G === "period" ? ["outside", "inside"] : P === "x" ? ["outside", "inside", "outside left", "inside left", "outside right", "inside right"] : ["outside", "inside", "outside top", "inside top", "outside bottom", "inside bottom"] } }, "ticklabelposition")), R.noTicklabeloverflow || T("ticklabeloverflow", te.indexOf("inside") !== -1 ? "hide past domain" : U === "category" || U === "multicategory" ? "allow" : "hide past div"), g(_, I), v(y, _, T, R), l(y, _, T, R), R.noHover || (U !== "category" && T("hoverformat"), R.noUnifiedhovertitle || T("unifiedhovertitle.text"));
          var V = T("color"), Z = V !== r.color.dflt ? V : M.color, Y = B.label || I._dfltTitle[P];
          if (p(y, _, T, U, R), !z) return _;
          T("title.text", Y), a.coerceFont(T, "title.font", M, { overrideDflt: { size: a.bigFont(M.size), color: Z } }), s(y, _, T, U);
          var C = R.hasMinor;
          if (C && (i.newContainer(_, "minor"), s(y, _, T, U, { isMinor: !0 })), t(y, _, T, U, R), c(y, _, T, R), C) {
            var j = R.isMinor;
            R.isMinor = !0, c(y, _, T, R), R.isMinor = j;
          }
          f(y, _, T, { dfltColor: V, bgColor: R.bgColor, showGrid: R.showGrid, hasMinor: C, attributes: r }), C && !_.minor.ticks && !_.minor.showgrid && delete _.minor, (_.showline || _.ticks) && T("mirror");
          var J = U === "multicategory";
          if (!R.noTickson && (U === "category" || J) && (_.ticks || _.showgrid) && (J ? (T("tickson", "boundaries"), delete _.ticklabelposition) : T("tickson")), J) {
            var ne = T("showdividers");
            ne && (T("dividercolor"), T("dividerwidth"));
          }
          if (U === "date") if (o(y, _, { name: "rangebreaks", inclusionAttr: "enabled", handleItemDefaults: m }), !_.rangebreaks.length) delete _.rangebreaks;
          else {
            for (var ae = 0; ae < _.rangebreaks.length; ae++) if (_.rangebreaks[ae].pattern === x) {
              _._hasDayOfWeekBreaks = !0;
              break;
            }
            if (g(_, I), I._has("scattergl") || I._has("splom")) for (var se = 0; se < R.data.length; se++) {
              var O = R.data[se];
              (O.type === "scattergl" || O.type === "splom") && (O.visible = !1, a.warn(O.type + " traces do not work on axes with rangebreaks. Setting trace " + O.index + " to `visible: false`."));
            }
          }
          return _;
        };
        function m(y, _, T) {
          function R(K, te) {
            return a.coerce(y, _, r.rangebreaks, K, te);
          }
          var I = R("enabled");
          if (I) {
            var P = R("bounds");
            if (P && P.length >= 2) {
              var M = "", B, z;
              if (P.length === 2) {
                for (B = 0; B < 2; B++) if (z = d(P[B]), z) {
                  M = x;
                  break;
                }
              }
              var q = R("pattern", M);
              if (q === x) for (B = 0; B < 2; B++) z = d(P[B]), z && (_.bounds[B] = P[B] = z - 1);
              if (q) for (B = 0; B < 2; B++) switch (z = P[B], q) {
                case x:
                  if (!n(z)) {
                    _.enabled = !1;
                    return;
                  }
                  if (z = +z, z !== Math.floor(z) || z < 0 || z >= 7) {
                    _.enabled = !1;
                    return;
                  }
                  _.bounds[B] = P[B] = z;
                  break;
                case h:
                  if (!n(z)) {
                    _.enabled = !1;
                    return;
                  }
                  if (z = +z, z < 0 || z > 24) {
                    _.enabled = !1;
                    return;
                  }
                  _.bounds[B] = P[B] = z;
                  break;
              }
              if (T.autorange === !1) {
                var U = T.range;
                if (U[0] < U[1]) {
                  if (P[0] < U[0] && P[1] > U[1]) {
                    _.enabled = !1;
                    return;
                  }
                } else if (P[0] > U[0] && P[1] < U[1]) {
                  _.enabled = !1;
                  return;
                }
              }
            } else {
              var G = R("values");
              if (G && G.length) R("dvalue");
              else {
                _.enabled = !1;
                return;
              }
            }
          }
        }
        var u = { sun: 1, mon: 2, tue: 3, wed: 4, thu: 5, fri: 6, sat: 7 };
        function d(y) {
          if (typeof y == "string") return u[y.substr(0, 3).toLowerCase()];
        }
      }), Gs = xe((L, k) => {
        var n = xr(), e = wt();
        k.exports = function(a, i, o, r) {
          var s = r.counterAxes || [], c = r.overlayableAxes || [], t = r.letter, p = r.grid, l = r.overlayingDomain, f, v, g, x, h, m;
          p && (v = p._domains[t][p._axisMap[i._id]], f = p._anchors[i._id], v && (g = p[t + "side"].split(" ")[0], x = p.domain[t][g === "right" || g === "top" ? 1 : 0])), v = v || [0, 1], f = f || (n(a.position) ? "free" : s[0] || "free"), g = g || (t === "x" ? "bottom" : "left"), x = x || 0, h = 0, m = !1;
          var u = e.coerce(a, i, { anchor: { valType: "enumerated", values: ["free"].concat(s), dflt: f } }, "anchor"), d = e.coerce(a, i, { side: { valType: "enumerated", values: t === "x" ? ["bottom", "top"] : ["left", "right"], dflt: g } }, "side");
          if (u === "free") {
            if (t === "y") {
              var y = o("autoshift");
              y && (x = d === "left" ? l[0] : l[1], m = i.automargin ? i.automargin : !0, h = d === "left" ? -3 : 3), o("shift", h);
            }
            o("position", x);
          }
          o("automargin", m);
          var _ = !1;
          if (c.length && (_ = e.coerce(a, i, { overlaying: { valType: "enumerated", values: [!1].concat(c), dflt: !1 } }, "overlaying")), !_) {
            var T = o("domain", v);
            T[0] > T[1] - 1 / 4096 && (i.domain = v), e.noneOrAll(a.domain, i.domain, v), i.tickmode === "sync" && (i.tickmode = "auto");
          }
          return o("layer"), i;
        };
      }), mp = xe((L, k) => {
        var n = wt(), e = fr(), a = da().isUnifiedHover, i = gs(), o = qr(), r = Ka(), s = Xn(), c = gp(), t = Ys(), p = Fa(), l = Gs(), f = sn(), v = f.id2name, g = f.name2id, x = mn().AX_ID_PATTERN, h = or(), m = h.traceIs, u = h.getComponentMethod;
        function d(y, _, T) {
          Array.isArray(y[_]) ? y[_].push(T) : y[_] = [T];
        }
        k.exports = function(y, _, T) {
          var R = _.autotypenumbers, I = {}, P = {}, M = {}, B = {}, z = {}, q = {}, U = {}, G = {}, K = {}, te = {}, V, Z;
          for (V = 0; V < T.length; V++) {
            var Y = T[V];
            if (m(Y, "cartesian")) {
              var C;
              if (Y.xaxis) C = v(Y.xaxis), d(I, C, Y);
              else if (Y.xaxes) for (Z = 0; Z < Y.xaxes.length; Z++) d(I, v(Y.xaxes[Z]), Y);
              var j;
              if (Y.yaxis) j = v(Y.yaxis), d(I, j, Y);
              else if (Y.yaxes) for (Z = 0; Z < Y.yaxes.length; Z++) d(I, v(Y.yaxes[Z]), Y);
              if (Y.type === "funnel" ? Y.orientation === "h" ? (C && (P[C] = !0), j && (U[j] = !0)) : j && (M[j] = !0) : Y.type === "image" ? (j && (G[j] = !0), C && (G[C] = !0)) : (j && (z[j] = !0, q[j] = !0), (!m(Y, "carpet") || Y.type === "carpet" && !Y._cheater) && C && (B[C] = !0)), Y.type === "carpet" && Y._cheater && C && (P[C] = !0), m(Y, "2dMap") && (K[C] = !0, K[j] = !0), m(Y, "oriented")) {
                var J = Y.orientation === "h" ? j : C;
                te[J] = !0;
              }
            }
          }
          var ne = _._subplots, ae = ne.xaxis, se = ne.yaxis, O = n.simpleMap(ae, v), F = n.simpleMap(se, v), S = O.concat(F), $ = e.background;
          ae.length && se.length && ($ = n.coerce(y, _, r, "plot_bgcolor"));
          var re = e.combine($, _.paper_bgcolor), E, w, N, W, ee;
          function le() {
            var ye = I[E] || [];
            ee._traceIndices = ye.map(function(Me) {
              return Me.index;
            }), ee._annIndices = [], ee._shapeIndices = [], ee._selectionIndices = [], ee._imgIndices = [], ee._subplotsWith = [], ee._counterAxes = [], ee._name = ee._attr = E, ee._id = w;
          }
          function ie(ye, Me) {
            return n.coerce(W, ee, s, ye, Me);
          }
          function pe(ye, Me) {
            return n.coerce2(W, ee, s, ye, Me);
          }
          function _e(ye) {
            return ye === "x" ? se : ae;
          }
          function Ae(ye, Me) {
            for (var Oe = ye === "x" ? O : F, je = [], qe = 0; qe < Oe.length; qe++) {
              var Qe = Oe[qe];
              Qe !== Me && !(y[Qe] || {}).overlaying && je.push(g(Qe));
            }
            return je;
          }
          var Ce = { x: _e("x"), y: _e("y") }, Ue = Ce.x.concat(Ce.y), Ne = {}, ke = [];
          function A() {
            var ye = W.matches;
            x.test(ye) && Ue.indexOf(ye) === -1 && (Ne[ye] = W.type, ke = Object.keys(Ne));
          }
          var X = i(y, _), H = a(X);
          for (V = 0; V < S.length; V++) {
            E = S[V], w = g(E), N = E.charAt(0), n.isPlainObject(y[E]) || (y[E] = {}), W = y[E], ee = o.newContainer(_, E, N + "axis"), le();
            var ve = N === "x" && !B[E] && P[E] || N === "y" && !z[E] && M[E], be = N === "y" && (!q[E] && U[E] || G[E]), Se = { hasMinor: !0, letter: N, font: _.font, outerTicks: K[E], showGrid: !te[E], data: I[E] || [], bgColor: re, calendar: _.calendar, automargin: !0, visibleDflt: ve, reverseDflt: be, autotypenumbersDflt: R, splomStash: ((_._splomAxes || {})[N] || {})[w], noAutotickangles: N === "y" };
            ie("uirevision", _.uirevision), c(W, ee, ie, Se), t(W, ee, ie, Se, _);
            var De = H && N === X.charAt(0), He = pe("spikecolor", H ? ee.color : void 0), Ze = pe("spikethickness", H ? 1.5 : void 0), We = pe("spikedash", H ? "dot" : void 0), $e = pe("spikemode", H ? "across" : void 0), it = pe("spikesnap"), Ke = ie("showspikes", !!De || !!He || !!Ze || !!We || !!$e || !!it);
            Ke || (delete ee.spikecolor, delete ee.spikethickness, delete ee.spikedash, delete ee.spikemode, delete ee.spikesnap);
            var ct = v(W.overlaying), gt = [0, 1];
            if (_[ct] !== void 0) {
              var ht = v(_[ct].anchor);
              _[ht] !== void 0 && (gt = _[ht].domain);
            }
            l(W, ee, ie, { letter: N, counterAxes: Ce[N], overlayableAxes: Ae(N, E), grid: _.grid, overlayingDomain: gt }), ie("title.standoff"), A(), ee._input = W;
          }
          for (V = 0; V < ke.length; ) {
            w = ke[V++], E = v(w), N = E.charAt(0), n.isPlainObject(y[E]) || (y[E] = {}), W = y[E], ee = o.newContainer(_, E, N + "axis"), le();
            var _t = { letter: N, font: _.font, outerTicks: K[E], showGrid: !te[E], data: [], bgColor: re, calendar: _.calendar, automargin: !0, visibleDflt: !1, reverseDflt: !1, autotypenumbersDflt: R, splomStash: ((_._splomAxes || {})[N] || {})[w] };
            ie("uirevision", _.uirevision), ee.type = Ne[w] || "linear", t(W, ee, ie, _t, _), l(W, ee, ie, { letter: N, counterAxes: Ce[N], overlayableAxes: Ae(N, E), grid: _.grid }), ie("fixedrange"), ie("modebardisable"), A(), ee._input = W;
          }
          var Te = u("rangeslider", "handleDefaults"), Ie = u("rangeselector", "handleDefaults");
          for (V = 0; V < O.length; V++) E = O[V], W = y[E], ee = _[E], Te(y, _, E), ee.type === "date" && Ie(W, ee, _, F, ee.calendar), ie("fixedrange"), ie("modebardisable");
          for (V = 0; V < F.length; V++) {
            E = F[V], W = y[E], ee = _[E];
            var ce = _[v(ee.anchor)], ge = u("rangeslider", "isVisible")(ce);
            ie("fixedrange", ge), ie("modebardisable");
          }
          p.handleDefaults(y, _, { axIds: Ue.concat(ke).sort(f.idSort), axHasImage: G });
        };
      }), xp = xe((L, k) => {
        var n = vr(), e = or(), a = wt(), i = Or(), o = Ar();
        k.exports = function(r, s, c, t) {
          var p = r._fullLayout;
          if (s.length === 0) {
            o.redrawComponents(r);
            return;
          }
          function l(_) {
            var T = _.xaxis, R = _.yaxis;
            p._defs.select("#" + _.clipId + "> rect").call(i.setTranslate, 0, 0).call(i.setScale, 1, 1), _.plot.call(i.setTranslate, T._offset, R._offset).call(i.setScale, 1, 1);
            var I = _.plot.selectAll(".scatterlayer .trace");
            I.selectAll(".point").call(i.setPointGroupScale, 1, 1), I.selectAll(".textpoint").call(i.setTextPointsScale, 1, 1), I.call(i.hideOutsideRangePoints, _);
          }
          function f(_, T) {
            var R = _.plotinfo, I = R.xaxis, P = R.yaxis, M = I._length, B = P._length, z = !!_.xr1, q = !!_.yr1, U = [];
            if (z) {
              var G = a.simpleMap(_.xr0, I.r2l), K = a.simpleMap(_.xr1, I.r2l), te = G[1] - G[0], V = K[1] - K[0];
              U[0] = (G[0] * (1 - T) + T * K[0] - G[0]) / (G[1] - G[0]) * M, U[2] = M * (1 - T + T * V / te), I.range[0] = I.l2r(G[0] * (1 - T) + T * K[0]), I.range[1] = I.l2r(G[1] * (1 - T) + T * K[1]);
            } else U[0] = 0, U[2] = M;
            if (q) {
              var Z = a.simpleMap(_.yr0, P.r2l), Y = a.simpleMap(_.yr1, P.r2l), C = Z[1] - Z[0], j = Y[1] - Y[0];
              U[1] = (Z[1] * (1 - T) + T * Y[1] - Z[1]) / (Z[0] - Z[1]) * B, U[3] = B * (1 - T + T * j / C), P.range[0] = I.l2r(Z[0] * (1 - T) + T * Y[0]), P.range[1] = P.l2r(Z[1] * (1 - T) + T * Y[1]);
            } else U[1] = 0, U[3] = B;
            o.drawOne(r, I, { skipTitle: !0 }), o.drawOne(r, P, { skipTitle: !0 }), o.redrawComponents(r, [I._id, P._id]);
            var J = z ? M / U[2] : 1, ne = q ? B / U[3] : 1, ae = z ? U[0] : 0, se = q ? U[1] : 0, O = z ? U[0] / U[2] * M : 0, F = q ? U[1] / U[3] * B : 0, S = I._offset - O, $ = P._offset - F;
            R.clipRect.call(i.setTranslate, ae, se).call(i.setScale, 1 / J, 1 / ne), R.plot.call(i.setTranslate, S, $).call(i.setScale, J, ne), i.setPointGroupScale(R.zoomScalePts, 1 / J, 1 / ne), i.setTextPointsScale(R.zoomScaleTxt, 1 / J, 1 / ne);
          }
          var v;
          t && (v = t());
          function g() {
            for (var _ = {}, T = 0; T < s.length; T++) {
              var R = s[T], I = R.plotinfo.xaxis, P = R.plotinfo.yaxis;
              R.xr1 && (_[I._name + ".range"] = R.xr1.slice()), R.yr1 && (_[P._name + ".range"] = R.yr1.slice());
            }
            return v && v(), e.call("relayout", r, _).then(function() {
              for (var M = 0; M < s.length; M++) l(s[M].plotinfo);
            });
          }
          function x() {
            for (var _ = {}, T = 0; T < s.length; T++) {
              var R = s[T], I = R.plotinfo.xaxis, P = R.plotinfo.yaxis;
              R.xr0 && (_[I._name + ".range"] = R.xr0.slice()), R.yr0 && (_[P._name + ".range"] = R.yr0.slice());
            }
            return e.call("relayout", r, _).then(function() {
              for (var M = 0; M < s.length; M++) l(s[M].plotinfo);
            });
          }
          var h, m, u, d = n.ease(c.easing);
          r._transitionData._interruptCallbacks.push(function() {
            return window.cancelAnimationFrame(u), u = null, x();
          });
          function y() {
            m = Date.now();
            for (var _ = Math.min(1, (m - h) / c.duration), T = d(_), R = 0; R < s.length; R++) f(s[R], T);
            m - h > c.duration ? (g(), u = window.cancelAnimationFrame(y)) : u = window.requestAnimationFrame(y);
          }
          return h = Date.now(), u = window.requestAnimationFrame(y), Promise.resolve();
        };
      }), Kn = xe((L) => {
        var k = vr(), n = or(), e = wt(), a = on(), i = Or(), o = go().getModuleCalcData, r = sn(), s = mn(), c = va(), t = e.ensureSingle;
        function p(m, u, d) {
          return e.ensureSingle(m, u, d, function(y) {
            y.datum(d);
          });
        }
        var l = s.zindexSeparator;
        L.name = "cartesian", L.attr = ["xaxis", "yaxis"], L.idRoot = ["x", "y"], L.idRegex = s.idRegex, L.attrRegex = s.attrRegex, L.attributes = vp(), L.layoutAttributes = Xn(), L.supplyLayoutDefaults = mp(), L.transitionAxes = xp(), L.finalizeSubplots = function(m, u) {
          var d = u._subplots, y = d.xaxis, _ = d.yaxis, T = d.cartesian, R = T, I = {}, P = {}, M, B, z;
          for (M = 0; M < R.length; M++) {
            var q = R[M].split("y");
            I[q[0]] = 1, P["y" + q[1]] = 1;
          }
          for (M = 0; M < y.length; M++) B = y[M], I[B] || (z = (m[r.id2name(B)] || {}).anchor, s.idRegex.y.test(z) || (z = "y"), T.push(B + z), R.push(B + z), P[z] || (P[z] = 1, e.pushUnique(_, z)));
          for (M = 0; M < _.length; M++) z = _[M], P[z] || (B = (m[r.id2name(z)] || {}).anchor, s.idRegex.x.test(B) || (B = "x"), T.push(B + z), R.push(B + z), I[B] || (I[B] = 1, e.pushUnique(y, B)));
          if (!R.length) {
            B = "", z = "";
            for (var U in m) if (s.attrRegex.test(U)) {
              var G = U.charAt(0);
              G === "x" ? (!B || +U.substr(5) < +B.substr(5)) && (B = U) : (!z || +U.substr(5) < +z.substr(5)) && (z = U);
            }
            B = B ? r.name2id(B) : "x", z = z ? r.name2id(z) : "y", y.push(B), _.push(z), T.push(B + z);
          }
        }, L.plot = function(m, u, d, y) {
          var _ = m._fullLayout, T = _._subplots.cartesian, R = m.calcdata, I;
          if (!Array.isArray(u)) for (u = [], I = 0; I < R.length; I++) u.push(I);
          for (var P = _._zindices, M = 0; M < P.length; M++) {
            var B = P[M];
            for (I = 0; I < T.length; I++) {
              var z = T[I], q = _._plots[z];
              if (M > 0) {
                var U = q.id;
                if (U.indexOf(l) !== -1) continue;
                U += l + (M + 1), q = e.extendFlat({}, q, { id: U, plot: _._cartesianlayer.selectAll(".subplot").select("." + U) });
              }
              for (var G = [], K, te = 0; te < R.length; te++) {
                var V = R[te], Z = V[0].trace;
                B === (Z.zorder || 0) && Z.xaxis + Z.yaxis === z && ((u.indexOf(Z.index) !== -1 || Z.carpet) && (K && K[0].trace.xaxis + K[0].trace.yaxis === z && ["tonextx", "tonexty", "tonext"].indexOf(Z.fill) !== -1 && G.indexOf(K) === -1 && G.push(K), G.push(V)), K = V);
              }
              f(m, q, G, d, y);
            }
          }
        };
        function f(m, u, d, y, _) {
          for (var T = s.traceLayerClasses, R = m._fullLayout, I = R._zindices, P = R._modules, M, B, z, q = [], U = [], G = 0; G < I.length; G++) for (var K = I[G], te = 0; te < P.length; te++) {
            M = P[te];
            var V = M.name, Z = n.modules[V].categories;
            if (Z.svg) {
              var Y = M.layerName || V + "layer", C = Y + (G ? Number(G) + 1 : ""), j = M.plot;
              B = o(d, j, K), z = B[0], d = B[1], z.length && q.push({ i: T.indexOf(Y), zindex: G, className: C, plotMethod: j, cdModule: z }), Z.zoomScale && U.push("." + C);
            }
          }
          q.sort(function(ae, se) {
            return (ae.zindex || 0) - (se.zindex || 0) || ae.i - se.i;
          });
          var J = u.plot.selectAll("g.mlayer").data(q, function(ae) {
            return ae.className;
          });
          if (J.enter().append("g").attr("class", function(ae) {
            return ae.className;
          }).classed("mlayer", !0).classed("rangeplot", u.isRangePlot), J.exit().remove(), J.order(), J.each(function(ae) {
            var se = k.select(this), O = ae.className;
            ae.plotMethod(m, u, ae.cdModule, se, y, _), s.clipOnAxisFalseQuery.indexOf("." + O) === -1 && i.setClipUrl(se, u.layerClipId, m);
          }), R._has("scattergl") && (M = n.getModule("scattergl"), z = o(d, M)[0], M.plot(m, u, z)), !m._context.staticPlot && (u._hasClipOnAxisFalse && (u.clipOnAxisFalseTraces = u.plot.selectAll(s.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), U.length)) {
            var ne = u.plot.selectAll(U.join(",")).selectAll(".trace");
            u.zoomScalePts = ne.selectAll("path.point"), u.zoomScaleTxt = ne.selectAll(".textpoint");
          }
        }
        L.clean = function(m, u, d, y) {
          var _ = y._plots || {}, T = u._plots || {}, R = y._subplots || {}, I, P, M;
          if (y._hasOnlyLargeSploms && !u._hasOnlyLargeSploms) for (M in _) I = _[M], I.plotgroup && I.plotgroup.remove();
          var B = y._has && y._has("gl"), z = u._has && u._has("gl");
          if (B && !z) for (M in _) I = _[M], I._scene && I._scene.destroy();
          if (R.xaxis && R.yaxis) {
            var q = r.listIds({ _fullLayout: y });
            for (P = 0; P < q.length; P++) {
              var U = q[P];
              u[r.id2name(U)] || y._infolayer.selectAll(".g-" + U + "title").remove();
            }
          }
          var G = y._has && y._has("cartesian"), K = u._has && u._has("cartesian");
          if (G && !K) x(y._cartesianlayer.selectAll(".subplot"), y), y._defs.selectAll(".axesclip").remove(), delete y._axisConstraintGroups, delete y._axisMatchGroups;
          else if (R.cartesian) for (P = 0; P < R.cartesian.length; P++) {
            var te = R.cartesian[P];
            if (te.indexOf(l) === -1 && !T[te]) {
              var V = "." + te + ",." + te + "-x,." + te + "-y";
              y._cartesianlayer.selectAll(V).remove(), h(te, y);
            }
          }
        }, L.drawFramework = function(m) {
          var u = m._fullLayout, d = m.calcdata, y, _ = {};
          for (y = 0; y < d.length; y++) {
            var T = d[y][0], R = T.trace, I = R.zorder || 0;
            _[I] || (_[I] = []), _[I].push(T);
          }
          var P = Object.keys(_).map(Number).sort(e.sorterAsc);
          P.length || (P = [0]), u._zindices = P;
          var M = v(m), B = M.length, z = [];
          for (y = 0; y < B; y++) z[y] = M[y].slice();
          for (var q = 1; q < P.length; q++) {
            var U = [];
            for (y = 0; y < B; y++) U[y] = M[y].slice(), U[y][0] += l + (q + 1);
            z = z.concat(U);
          }
          var G = u._cartesianlayer.selectAll(".subplot").data(z, String);
          G.enter().append("g").attr("class", function(K) {
            return "subplot " + K[0];
          }), G.order(), G.exit().call(x, u), G.each(function(K) {
            var te = K[0], V = te.indexOf(l), Z = V !== -1, Y = Z ? te.slice(0, V) : te, C = u._plots[te];
            C || (C = e.extendFlat({}, u._plots[Y]), C && (C.id = te, u._plots[te] = C, u._subplots.cartesian.push(te))), C && (C.plotgroup = k.select(this), g(m, C), Z || (C.draglayer = t(u._draggers, "g", te)));
          });
        }, L.rangePlot = function(m, u, d) {
          g(m, u), f(m, u, d), a.style(m);
        };
        function v(m) {
          var u = m._fullLayout, d = u._zindices.length, y = u._subplots.cartesian, _ = y.length, T, R, I, P, M, B, z = [], q = [];
          for (T = 0; T < _; T++) {
            I = y[T], P = u._plots[I], M = P.xaxis, B = P.yaxis;
            var U = M._mainAxis, G = B._mainAxis, K = U._id + G._id, te = u._plots[K];
            P.overlays = [], K !== I && te ? (P.mainplot = K, P.mainplotinfo = te, q.push(I)) : (P.mainplot = void 0, P.mainplotinfo = void 0, z.push(I));
          }
          for (T = 0; T < q.length; T++) I = q[T], P = u._plots[I], P.mainplotinfo.overlays.push(P);
          var V = z.concat(q), Z = [];
          for (T = 0; T < _; T++) {
            I = V[T], P = u._plots[I], M = P.xaxis, B = P.yaxis;
            for (var Y = [], C = 1; C <= d; C++) {
              var j = "";
              for (C > 1 && (j += l + C), Y.push(I + j), R = 0; R < P.overlays.length; R++) Y.push(P.overlays[R].id + j);
            }
            Y = Y.concat([M.layer, B.layer, M.overlaying || "", B.overlaying || ""]), Z.push(Y);
          }
          return Z;
        }
        function g(m, u) {
          var d = m._fullLayout, y = u.plotgroup, _ = u.id, T = _.indexOf(l), R = T !== -1, I = s.layerValue2layerClass[u.xaxis.layer], P = s.layerValue2layerClass[u.yaxis.layer], M = d._hasOnlyLargeSploms, B = d._zindices.length > 1, z = u.mainplotinfo;
          if (!u.mainplot || B) if (M) u.xlines = t(y, "path", "xlines-above"), u.ylines = t(y, "path", "ylines-above"), u.xaxislayer = t(y, "g", "xaxislayer-above"), u.yaxislayer = t(y, "g", "yaxislayer-above");
          else {
            if (!R) {
              var q = t(y, "g", "layer-subplot");
              u.shapelayer = t(q, "g", "shapelayer"), u.imagelayer = t(q, "g", "imagelayer"), z && B ? (u.minorGridlayer = z.minorGridlayer, u.gridlayer = z.gridlayer, u.zerolinelayer = z.zerolinelayer) : (u.minorGridlayer = t(y, "g", "minor-gridlayer"), u.gridlayer = t(y, "g", "gridlayer"), u.zerolinelayer = t(y, "g", "zerolinelayer"));
              var U = t(y, "g", "layer-between");
              u.shapelayerBetween = t(U, "g", "shapelayer"), u.imagelayerBetween = t(U, "g", "imagelayer"), t(y, "path", "xlines-below"), t(y, "path", "ylines-below"), u.overlinesBelow = t(y, "g", "overlines-below"), t(y, "g", "xaxislayer-below"), t(y, "g", "yaxislayer-below"), u.overaxesBelow = t(y, "g", "overaxes-below");
            }
            u.overplot = t(y, "g", "overplot"), u.plot = t(u.overplot, "g", _), z && B ? u.zerolinelayerAbove = z.zerolinelayerAbove : u.zerolinelayerAbove = t(y, "g", "zerolinelayer-above"), R || (u.xlines = t(y, "path", "xlines-above"), u.ylines = t(y, "path", "ylines-above"), u.overlinesAbove = t(y, "g", "overlines-above"), t(y, "g", "xaxislayer-above"), t(y, "g", "yaxislayer-above"), u.overaxesAbove = t(y, "g", "overaxes-above"), u.xlines = y.select(".xlines-" + I), u.ylines = y.select(".ylines-" + P), u.xaxislayer = y.select(".xaxislayer-" + I), u.yaxislayer = y.select(".yaxislayer-" + P));
          }
          else {
            var G = z.plotgroup, K = _ + "-x", te = _ + "-y";
            u.minorGridlayer = z.minorGridlayer, u.gridlayer = z.gridlayer, u.zerolinelayer = z.zerolinelayer, u.zerolinelayerAbove = z.zerolinelayerAbove, t(z.overlinesBelow, "path", K), t(z.overlinesBelow, "path", te), t(z.overaxesBelow, "g", K), t(z.overaxesBelow, "g", te), u.plot = t(z.overplot, "g", _), t(z.overlinesAbove, "path", K), t(z.overlinesAbove, "path", te), t(z.overaxesAbove, "g", K), t(z.overaxesAbove, "g", te), u.xlines = G.select(".overlines-" + I).select("." + K), u.ylines = G.select(".overlines-" + P).select("." + te), u.xaxislayer = G.select(".overaxes-" + I).select("." + K), u.yaxislayer = G.select(".overaxes-" + P).select("." + te);
          }
          R || (M || (p(u.minorGridlayer, "g", u.xaxis._id), p(u.minorGridlayer, "g", u.yaxis._id), u.minorGridlayer.selectAll("g").map(function(V) {
            return V[0];
          }).sort(r.idSort), p(u.gridlayer, "g", u.xaxis._id), p(u.gridlayer, "g", u.yaxis._id), u.gridlayer.selectAll("g").map(function(V) {
            return V[0];
          }).sort(r.idSort)), u.xlines.style("fill", "none").classed("crisp", !0), u.ylines.style("fill", "none").classed("crisp", !0));
        }
        function x(m, u) {
          if (m) {
            var d = {};
            m.each(function(P) {
              var M = P[0], B = k.select(this);
              B.remove(), h(M, u), d[M] = !0;
            });
            for (var y in u._plots) for (var _ = u._plots[y], T = _.overlays || [], R = 0; R < T.length; R++) {
              var I = T[R];
              d[I.id] && I.plot.selectAll(".trace").remove();
            }
          }
        }
        function h(m, u) {
          u._draggers.selectAll("g." + m).remove(), u._defs.select("#clip" + u._uid + m + "plot").remove();
        }
        L.toSVG = function(m) {
          var u = m._fullLayout._glimages, d = k.select(m).selectAll(".svg-container"), y = d.filter(function(T, R) {
            return R === d.size() - 1;
          }).selectAll(".gl-canvas-context, .gl-canvas-focus");
          function _() {
            var T = this, R = T.toDataURL("image/png"), I = u.append("svg:image");
            I.attr({ xmlns: c.svg, "xlink:href": R, preserveAspectRatio: "none", x: 0, y: 0, width: T.style.width, height: T.style.height });
          }
          y.each(_);
        }, L.updateFx = Ls().updateFx;
      }), bp = xe((L, k) => {
        var n = Fn();
        k.exports = { hasLines: n.hasLines, hasMarkers: n.hasMarkers, hasText: n.hasText, isBubble: n.isBubble, attributes: $n(), layoutAttributes: vo(), supplyDefaults: sp(), crossTraceDefaults: up(), supplyLayoutDefaults: cp(), calc: jo().calc, crossTraceCalc: dp(), arraysToCalcdata: Fo(), plot: js(), colorbar: Ci(), formatLabels: Hs(), style: Ba().style, styleOnSelect: Ba().styleOnSelect, hoverPoints: qs(), selectPoints: Us(), animatable: !0, moduleType: "trace", name: "scatter", basePlotModule: Kn(), categories: ["cartesian", "svg", "symbols", "errorBarsOK", "showLegend", "scatter-like", "zoomScale"], meta: {} };
      }), _p = xe((L, k) => {
        var n = vr(), e = fr(), a = As(), i = wt(), o = i.strScale, r = i.strRotate, s = i.strTranslate;
        k.exports = function(c, t, p) {
          var l = c.node(), f = a[p.arrowhead || 0], v = a[p.startarrowhead || 0], g = (p.arrowwidth || 1) * (p.arrowsize || 1), x = (p.arrowwidth || 1) * (p.startarrowsize || 1), h = t.indexOf("start") >= 0, m = t.indexOf("end") >= 0, u = f.backoff * g + p.standoff, d = v.backoff * x + p.startstandoff, y, _, T, R;
          if (l.nodeName === "line") {
            y = { x: +c.attr("x1"), y: +c.attr("y1") }, _ = { x: +c.attr("x2"), y: +c.attr("y2") };
            var I = y.x - _.x, P = y.y - _.y;
            if (T = Math.atan2(P, I), R = T + Math.PI, u && d && u + d > Math.sqrt(I * I + P * P)) {
              C();
              return;
            }
            if (u) {
              if (u * u > I * I + P * P) {
                C();
                return;
              }
              var M = u * Math.cos(T), B = u * Math.sin(T);
              _.x += M, _.y += B, c.attr({ x2: _.x, y2: _.y });
            }
            if (d) {
              if (d * d > I * I + P * P) {
                C();
                return;
              }
              var z = d * Math.cos(T), q = d * Math.sin(T);
              y.x -= z, y.y -= q, c.attr({ x1: y.x, y1: y.y });
            }
          } else if (l.nodeName === "path") {
            var U = l.getTotalLength(), G = "";
            if (U < u + d) {
              C();
              return;
            }
            var K = l.getPointAtLength(0), te = l.getPointAtLength(0.1);
            T = Math.atan2(K.y - te.y, K.x - te.x), y = l.getPointAtLength(Math.min(d, U)), G = "0px," + d + "px,";
            var V = l.getPointAtLength(U), Z = l.getPointAtLength(U - 0.1);
            R = Math.atan2(V.y - Z.y, V.x - Z.x), _ = l.getPointAtLength(Math.max(0, U - u));
            var Y = G ? d + u : u;
            G += U - Y + "px," + U + "px", c.style("stroke-dasharray", G);
          }
          function C() {
            c.style("stroke-dasharray", "0px,100px");
          }
          function j(J, ne, ae, se) {
            J.path && (J.noRotate && (ae = 0), n.select(l.parentNode).append("path").attr({ class: c.attr("class"), d: J.path, transform: s(ne.x, ne.y) + r(ae * 180 / Math.PI) + o(se) }).style({ fill: e.rgb(p.arrowcolor), "stroke-width": 0 }));
          }
          h && j(v, y, T, x), m && j(f, _, R, g);
        };
      }), qo = xe((L, k) => {
        var n = vr(), e = or(), a = on(), i = wt(), o = i.strTranslate, r = Ar(), s = fr(), c = Or(), t = Bn(), p = xn(), l = Aa(), f = Jn(), v = qr().arrayEditor, g = _p();
        k.exports = { draw: x, drawOne: h, drawRaw: u };
        function x(d) {
          var y = d._fullLayout;
          y._infolayer.selectAll(".annotation").remove();
          for (var _ = 0; _ < y.annotations.length; _++) y.annotations[_].visible && h(d, _);
          return a.previousPromises(d);
        }
        function h(d, y) {
          var _ = d._fullLayout, T = _.annotations[y] || {}, R = r.getFromId(d, T.xref), I = r.getFromId(d, T.yref);
          R && R.setScale(), I && I.setScale(), u(d, T, y, !1, R, I);
        }
        function m(d, y, _, T, R) {
          var I = R[_], P = R[_ + "ref"], M = _.indexOf("y") !== -1, B = r.getRefType(P) === "domain", z = M ? T.h : T.w;
          return d ? B ? I + (M ? -y : y) / d._length : d.p2r(d.r2p(I) + y) : I + (M ? -y : y) / z;
        }
        function u(d, y, _, T, R, I) {
          var P = d._fullLayout, M = d._fullLayout._size, B = d._context.edits, z, q;
          T ? (z = "annotation-" + T, q = T + ".annotations") : (z = "annotation", q = "annotations");
          var U = v(d.layout, q, y), G = U.modifyBase, K = U.modifyItem, te = U.getUpdateObj;
          P._infolayer.selectAll("." + z + '[data-index="' + _ + '"]').remove();
          var V = "clip" + P._uid + "_ann" + _;
          if (!y._input || y.visible === !1) {
            n.selectAll("#" + V).remove();
            return;
          }
          var Z = { x: {}, y: {} }, Y = +y.textangle || 0, C = P._infolayer.append("g").classed(z, !0).attr("data-index", String(_)).style("opacity", y.opacity), j = C.append("g").classed("annotation-text-g", !0), J = B[y.showarrow ? "annotationTail" : "annotationPosition"], ne = y.captureevents || B.annotationText || J;
          function ae(ie) {
            var pe = { index: _, annotation: y._input, fullAnnotation: y, event: ie };
            return T && (pe.subplotId = T), pe;
          }
          var se = j.append("g").style("pointer-events", ne ? "all" : null).call(l, "pointer").on("click", function() {
            d._dragging = !1, d.emit("plotly_clickannotation", ae(n.event));
          });
          y.hovertext && se.on("mouseover", function() {
            var ie = y.hoverlabel, pe = ie.font, _e = this.getBoundingClientRect(), Ae = d.getBoundingClientRect();
            t.loneHover({ x0: _e.left - Ae.left, x1: _e.right - Ae.left, y: (_e.top + _e.bottom) / 2 - Ae.top, text: y.hovertext, color: ie.bgcolor, borderColor: ie.bordercolor, fontFamily: pe.family, fontSize: pe.size, fontColor: pe.color, fontWeight: pe.weight, fontStyle: pe.style, fontVariant: pe.variant, fontShadow: pe.fontShadow, fontLineposition: pe.fontLineposition, fontTextcase: pe.fontTextcase }, { container: P._hoverlayer.node(), outerContainer: P._paper.node(), gd: d });
          }).on("mouseout", function() {
            t.loneUnhover(P._hoverlayer.node());
          });
          var O = y.borderwidth, F = y.borderpad, S = O + F, $ = se.append("rect").attr("class", "bg").style("stroke-width", O + "px").call(s.stroke, y.bordercolor).call(s.fill, y.bgcolor), re = y.width || y.height, E = P._topclips.selectAll("#" + V).data(re ? [0] : []);
          E.enter().append("clipPath").classed("annclip", !0).attr("id", V).append("rect"), E.exit().remove();
          var w = y.font, N = P._meta ? i.templateString(y.text, P._meta) : y.text, W = se.append("text").classed("annotation-text", !0).text(N);
          function ee(ie) {
            return ie.call(c.font, w).attr({ "text-anchor": { left: "start", right: "end" }[y.align] || "middle" }), p.convertToTspans(ie, d, le), ie;
          }
          function le() {
            var ie = W.selectAll("a");
            if (ie.size() === 1 && ie.text() === W.text()) {
              var pe = se.insert("a", ":first-child").attr({ "xlink:xlink:href": ie.attr("xlink:href"), "xlink:xlink:show": ie.attr("xlink:show") }).style({ cursor: "pointer" });
              pe.node().appendChild($.node());
            }
            var _e = se.select(".annotation-text-math-group"), Ae = !_e.empty(), Ce = c.bBox((Ae ? _e : W).node()), Ue = Ce.width, Ne = Ce.height, ke = y.width || Ue, A = y.height || Ne, X = Math.round(ke + 2 * S), H = Math.round(A + 2 * S);
            function ve(It, Tt) {
              return Tt === "auto" && (It < 1 / 3 ? Tt = "left" : It > 2 / 3 ? Tt = "right" : Tt = "center"), { center: 0, middle: 0, left: 0.5, bottom: -0.5, right: -0.5, top: 0.5 }[Tt];
            }
            for (var be = !1, Se = ["x", "y"], De = 0; De < Se.length; De++) {
              var He = Se[De], Ze = y[He + "ref"] || He, We = y["a" + He + "ref"], $e = { x: R, y: I }[He], it = (Y + (He === "x" ? 0 : -90)) * Math.PI / 180, Ke = X * Math.cos(it), ct = H * Math.sin(it), gt = Math.abs(Ke) + Math.abs(ct), ht = y[He + "anchor"], _t = y[He + "shift"] * (He === "x" ? 1 : -1), Te = Z[He], Ie, ce, ge, ye, Me, Oe = r.getRefType(Ze);
              if ($e && Oe !== "domain") {
                var je = $e.r2fraction(y[He]);
                (je < 0 || je > 1) && (We === Ze ? (je = $e.r2fraction(y["a" + He]), (je < 0 || je > 1) && (be = !0)) : be = !0), Ie = $e._offset + $e.r2p(y[He]), ye = 0.5;
              } else {
                var qe = Oe === "domain";
                He === "x" ? (ge = y[He], Ie = qe ? $e._offset + $e._length * ge : Ie = M.l + M.w * ge) : (ge = 1 - y[He], Ie = qe ? $e._offset + $e._length * ge : Ie = M.t + M.h * ge), ye = y.showarrow ? 0.5 : ge;
              }
              if (y.showarrow) {
                Te.head = Ie;
                var Qe = y["a" + He];
                if (Me = Ke * ve(0.5, y.xanchor) - ct * ve(0.5, y.yanchor), We === Ze) {
                  var Xe = r.getRefType(We);
                  Xe === "domain" ? (He === "y" && (Qe = 1 - Qe), Te.tail = $e._offset + $e._length * Qe) : Xe === "paper" ? He === "y" ? (Qe = 1 - Qe, Te.tail = M.t + M.h * Qe) : Te.tail = M.l + M.w * Qe : Te.tail = $e._offset + $e.r2p(Qe), ce = Me;
                } else Te.tail = Ie + Qe, ce = Me + Qe;
                Te.text = Te.tail + Me;
                var Je = P[He === "x" ? "width" : "height"];
                if (Ze === "paper" && (Te.head = i.constrain(Te.head, 1, Je - 1)), We === "pixel") {
                  var ot = -Math.max(Te.tail - 3, Te.text), lt = Math.min(Te.tail + 3, Te.text) - Je;
                  ot > 0 ? (Te.tail += ot, Te.text += ot) : lt > 0 && (Te.tail -= lt, Te.text -= lt);
                }
                Te.tail += _t, Te.head += _t;
              } else Me = gt * ve(ye, ht), ce = Me, Te.text = Ie + Me;
              Te.text += _t, Me += _t, ce += _t, y["_" + He + "padplus"] = gt / 2 + ce, y["_" + He + "padminus"] = gt / 2 - ce, y["_" + He + "size"] = gt, y["_" + He + "shift"] = Me;
            }
            if (be) {
              se.remove();
              return;
            }
            var st = 0, xt = 0;
            if (y.align !== "left" && (st = (ke - Ue) * (y.align === "center" ? 0.5 : 1)), y.valign !== "top" && (xt = (A - Ne) * (y.valign === "middle" ? 0.5 : 1)), Ae) _e.select("svg").attr({ x: S + st - 1, y: S + xt }).call(c.setClipUrl, re ? V : null, d);
            else {
              var Et = S + xt - Ce.top, Bt = S + st - Ce.left;
              W.call(p.positionText, Bt, Et).call(c.setClipUrl, re ? V : null, d);
            }
            E.select("rect").call(c.setRect, S, S, ke, A), $.call(c.setRect, O / 2, O / 2, X - O, H - O), se.call(c.setTranslate, Math.round(Z.x.text - X / 2), Math.round(Z.y.text - H / 2)), j.attr({ transform: "rotate(" + Y + "," + Z.x.text + "," + Z.y.text + ")" });
            var qt = function(It, Tt) {
              C.selectAll(".annotation-arrow-g").remove();
              var Rt = Z.x.head, Vt = Z.y.head, Ft = Z.x.tail + It, Dt = Z.y.tail + Tt, Ct = Z.x.text + It, Ot = Z.y.text + Tt, Wt = i.rotationXYMatrix(Y, Ct, Ot), rr = i.apply2DTransform(Wt), Ut = i.apply2DTransform2(Wt), Qt = +$.attr("width"), nr = +$.attr("height"), cr = Ct - 0.5 * Qt, lr = cr + Qt, $t = Ot - 0.5 * nr, sr = $t + nr, St = [[cr, $t, cr, sr], [cr, sr, lr, sr], [lr, sr, lr, $t], [lr, $t, cr, $t]].map(Ut);
              if (!St.reduce(function(tt, at) {
                return tt ^ !!i.segmentsIntersect(Rt, Vt, Rt + 1e6, Vt + 1e6, at[0], at[1], at[2], at[3]);
              }, !1)) {
                St.forEach(function(tt) {
                  var at = i.segmentsIntersect(Ft, Dt, Rt, Vt, tt[0], tt[1], tt[2], tt[3]);
                  at && (Ft = at.x, Dt = at.y);
                });
                var Kt = y.arrowwidth, hr = y.arrowcolor, he = y.arrowside, fe = C.append("g").style({ opacity: s.opacity(hr) }).classed("annotation-arrow-g", !0), Pe = fe.append("path").attr("d", "M" + Ft + "," + Dt + "L" + Rt + "," + Vt).style("stroke-width", Kt + "px").call(s.stroke, s.rgb(hr));
                if (g(Pe, he, y), B.annotationPosition && Pe.node().parentNode && !T) {
                  var Re = Rt, Ye = Vt;
                  if (y.standoff) {
                    var Ee = Math.sqrt(Math.pow(Rt - Ft, 2) + Math.pow(Vt - Dt, 2));
                    Re += y.standoff * (Ft - Rt) / Ee, Ye += y.standoff * (Dt - Vt) / Ee;
                  }
                  var ze = fe.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({ d: "M3,3H-3V-3H3ZM0,0L" + (Ft - Re) + "," + (Dt - Ye), transform: o(Re, Ye) }).style("stroke-width", Kt + 6 + "px").call(s.stroke, "rgba(0,0,0,0)").call(s.fill, "rgba(0,0,0,0)"), Ge, Ve;
                  f.init({ element: ze.node(), gd: d, prepFn: function() {
                    var tt = c.getTranslate(se);
                    Ge = tt.x, Ve = tt.y, R && R.autorange && G(R._name + ".autorange", !0), I && I.autorange && G(I._name + ".autorange", !0);
                  }, moveFn: function(tt, at) {
                    var vt = rr(Ge, Ve), kt = vt[0] + tt, At = vt[1] + at;
                    se.call(c.setTranslate, kt, At), K("x", m(R, tt, "x", M, y)), K("y", m(I, at, "y", M, y)), y.axref === y.xref && K("ax", m(R, tt, "ax", M, y)), y.ayref === y.yref && K("ay", m(I, at, "ay", M, y)), fe.attr("transform", o(tt, at)), j.attr({ transform: "rotate(" + Y + "," + kt + "," + At + ")" });
                  }, doneFn: function() {
                    e.call("_guiRelayout", d, te());
                    var tt = document.querySelector(".js-notes-box-panel");
                    tt && tt.redraw(tt.selectedObj);
                  } });
                }
              }
            };
            if (y.showarrow && qt(0, 0), J) {
              var jt;
              f.init({ element: se.node(), gd: d, prepFn: function() {
                jt = j.attr("transform");
              }, moveFn: function(It, Tt) {
                var Rt = "pointer";
                if (y.showarrow) y.axref === y.xref ? K("ax", m(R, It, "ax", M, y)) : K("ax", y.ax + It), y.ayref === y.yref ? K("ay", m(I, Tt, "ay", M.w, y)) : K("ay", y.ay + Tt), qt(It, Tt);
                else {
                  if (T) return;
                  var Vt, Ft;
                  if (R) Vt = m(R, It, "x", M, y);
                  else {
                    var Dt = y._xsize / M.w, Ct = y.x + (y._xshift - y.xshift) / M.w - Dt / 2;
                    Vt = f.align(Ct + It / M.w, Dt, 0, 1, y.xanchor);
                  }
                  if (I) Ft = m(I, Tt, "y", M, y);
                  else {
                    var Ot = y._ysize / M.h, Wt = y.y - (y._yshift + y.yshift) / M.h - Ot / 2;
                    Ft = f.align(Wt - Tt / M.h, Ot, 0, 1, y.yanchor);
                  }
                  K("x", Vt), K("y", Ft), (!R || !I) && (Rt = f.getCursor(R ? 0.5 : Vt, I ? 0.5 : Ft, y.xanchor, y.yanchor));
                }
                j.attr({ transform: o(It, Tt) + jt }), l(se, Rt);
              }, clickFn: function(It, Tt) {
                y.captureevents && d.emit("plotly_clickannotation", ae(Tt));
              }, doneFn: function() {
                l(se), e.call("_guiRelayout", d, te());
                var It = document.querySelector(".js-notes-box-panel");
                It && It.redraw(It.selectedObj);
              } });
            }
          }
          B.annotationText ? W.call(p.makeEditable, { delegate: se, gd: d }).call(ee).on("edit", function(ie) {
            y.text = ie, this.call(ee), K("text", ie), R && R.autorange && G(R._name + ".autorange", !0), I && I.autorange && G(I._name + ".autorange", !0), e.call("_guiRelayout", d, te());
          }) : W.call(ee);
        }
      }), wp = xe((L, k) => {
        var n = wt(), e = or(), a = qr().arrayEditor;
        k.exports = { hasClickToShow: i, onClick: o };
        function i(c, t) {
          var p = r(c, t);
          return p.on.length > 0 || p.explicitOff.length > 0;
        }
        function o(c, t) {
          var p = r(c, t), l = p.on, f = p.off.concat(p.explicitOff), v = {}, g = c._fullLayout.annotations, x, h;
          if (l.length || f.length) {
            for (x = 0; x < l.length; x++) h = a(c.layout, "annotations", g[l[x]]), h.modifyItem("visible", !0), n.extendFlat(v, h.getUpdateObj());
            for (x = 0; x < f.length; x++) h = a(c.layout, "annotations", g[f[x]]), h.modifyItem("visible", !1), n.extendFlat(v, h.getUpdateObj());
            return e.call("update", c, {}, v);
          }
        }
        function r(c, t) {
          var p = c._fullLayout.annotations, l = [], f = [], v = [], g = (t || []).length, x, h, m, u, d, y, _, T;
          for (x = 0; x < p.length; x++) if (m = p[x], u = m.clicktoshow, u) {
            for (h = 0; h < g; h++) if (d = t[h], y = d.xaxis, _ = d.yaxis, y._id === m.xref && _._id === m.yref && y.d2r(d.x) === s(m._xclick, y) && _.d2r(d.y) === s(m._yclick, _)) {
              m.visible ? u === "onout" ? T = f : T = v : T = l, T.push(x);
              break;
            }
            h === g && m.visible && u === "onout" && f.push(x);
          }
          return { on: l, off: f, explicitOff: v };
        }
        function s(c, t) {
          return t.type === "log" ? t.l2r(c) : t.d2r(c);
        }
      }), Zs = xe((L, k) => {
        var n = wt(), e = fr();
        k.exports = function(a, i, o, r) {
          r("opacity");
          var s = r("bgcolor"), c = r("bordercolor"), t = e.opacity(c);
          r("borderpad");
          var p = r("borderwidth"), l = r("showarrow");
          r("text", l ? " " : o._dfltTitle.annotation), r("textangle"), n.coerceFont(r, "font", o.font), r("width"), r("align");
          var f = r("height");
          if (f && r("valign"), l) {
            var v = r("arrowside"), g, x;
            v.indexOf("end") !== -1 && (g = r("arrowhead"), x = r("arrowsize")), v.indexOf("start") !== -1 && (r("startarrowhead", g), r("startarrowsize", x)), r("arrowcolor", t ? i.bordercolor : e.defaultLine), r("arrowwidth", (t && p || 1) * 2), r("standoff"), r("startstandoff");
          }
          var h = r("hovertext"), m = o.hoverlabel || {};
          if (h) {
            var u = r("hoverlabel.bgcolor", m.bgcolor || (e.opacity(s) ? e.rgb(s) : e.defaultLine)), d = r("hoverlabel.bordercolor", m.bordercolor || e.contrast(u)), y = n.extendFlat({}, m.font);
            y.color || (y.color = d), n.coerceFont(r, "hoverlabel.font", y);
          }
          r("captureevents", !!h);
        };
      }), Tp = xe((L, k) => {
        var n = wt(), e = Ar(), a = aa(), i = Zs(), o = ni();
        k.exports = function(s, c) {
          a(s, c, { name: "annotations", handleItemDefaults: r });
        };
        function r(s, c, t) {
          function p(M, B) {
            return n.coerce(s, c, o, M, B);
          }
          var l = p("visible"), f = p("clicktoshow");
          if (l || f) {
            i(s, c, t, p);
            for (var v = c.showarrow, g = ["x", "y"], x = [-10, -30], h = { _fullLayout: t }, m = 0; m < 2; m++) {
              var u = g[m], d = e.coerceRef(s, c, h, u, "", "paper");
              if (d !== "paper") {
                var y = e.getFromId(h, d);
                y._annIndices.push(c._index);
              }
              if (e.coercePosition(c, h, p, d, u, 0.5), v) {
                var _ = "a" + u, T = e.coerceRef(s, c, h, _, "pixel", ["pixel", "paper"]);
                T !== "pixel" && T !== d && (T = c[_] = "pixel");
                var R = T === "pixel" ? x[m] : 0.4;
                e.coercePosition(c, h, p, T, _, R);
              }
              p(u + "anchor"), p(u + "shift");
            }
            if (n.noneOrAll(s, c, ["x", "y"]), v && n.noneOrAll(s, c, ["ax", "ay"]), f) {
              var I = p("xclick"), P = p("yclick");
              c._xclick = I === void 0 ? c.x : e.cleanPosition(I, h, c.xref), c._yclick = P === void 0 ? c.y : e.cleanPosition(P, h, c.yref);
            }
          }
        }
      }), kp = xe((L, k) => {
        var n = wt(), e = Ar(), a = qo().draw;
        k.exports = function(r) {
          var s = r._fullLayout, c = n.filterVisible(s.annotations);
          if (c.length && r._fullData.length) return n.syncOrAsync([a, i], r);
        };
        function i(r) {
          var s = r._fullLayout;
          n.filterVisible(s.annotations).forEach(function(c) {
            var t = e.getFromId(r, c.xref), p = e.getFromId(r, c.yref), l = e.getRefType(c.xref), f = e.getRefType(c.yref);
            c._extremes = {}, l === "range" && o(c, t), f === "range" && o(c, p);
          });
        }
        function o(r, s) {
          var c = s._id, t = c.charAt(0), p = r[t], l = r["a" + t], f = r[t + "ref"], v = r["a" + t + "ref"], g = r["_" + t + "padplus"], x = r["_" + t + "padminus"], h = { x: 1, y: -1 }[t] * r[t + "shift"], m = 3 * r.arrowsize * r.arrowwidth || 0, u = m + h, d = m - h, y = 3 * r.startarrowsize * r.arrowwidth || 0, _ = y + h, T = y - h, R;
          if (v === f) {
            var I = e.findExtremes(s, [s.r2c(p)], { ppadplus: u, ppadminus: d }), P = e.findExtremes(s, [s.r2c(l)], { ppadplus: Math.max(g, _), ppadminus: Math.max(x, T) });
            R = { min: [I.min[0], P.min[0]], max: [I.max[0], P.max[0]] };
          } else _ = l ? _ + l : _, T = l ? T - l : T, R = e.findExtremes(s, [s.r2c(p)], { ppadplus: Math.max(g, u, _), ppadminus: Math.max(x, d, T) });
          r._extremes[c] = R;
        }
      }), Mp = xe((L, k) => {
        var n = xr(), e = oo();
        k.exports = function(a, i, o, r) {
          i = i || {};
          var s = o === "log" && i.type === "linear", c = o === "linear" && i.type === "log";
          if (!(s || c)) return;
          var t = a._fullLayout.annotations, p = i._id.charAt(0), l, f;
          function v(x) {
            var h = l[x], m = null;
            s ? m = e(h, i.range) : m = Math.pow(10, h), n(m) || (m = null), r(f + x, m);
          }
          for (var g = 0; g < t.length; g++) l = t[g], f = "annotations[" + g + "].", l[p + "ref"] === i._id && v(p), l["a" + p + "ref"] === i._id && v("a" + p);
        };
      }), Ap = xe((L, k) => {
        var n = qo(), e = wp();
        k.exports = { moduleType: "component", name: "annotations", layoutAttributes: ni(), supplyLayoutDefaults: Tp(), includeBasePlot: Li()("annotations"), calcAutorange: kp(), draw: n.draw, drawOne: n.drawOne, drawRaw: n.drawRaw, hasClickToShow: e.hasClickToShow, onClick: e.onClick, convertCoords: Mp() };
      }), Uo = xe((L, k) => {
        var n = ni(), e = ra().overrideAll, a = qr().templatedArray;
        k.exports = e(a("annotation", { visible: n.visible, x: { valType: "any" }, y: { valType: "any" }, z: { valType: "any" }, ax: { valType: "number" }, ay: { valType: "number" }, xanchor: n.xanchor, xshift: n.xshift, yanchor: n.yanchor, yshift: n.yshift, text: n.text, textangle: n.textangle, font: n.font, width: n.width, height: n.height, opacity: n.opacity, align: n.align, valign: n.valign, bgcolor: n.bgcolor, bordercolor: n.bordercolor, borderpad: n.borderpad, borderwidth: n.borderwidth, showarrow: n.showarrow, arrowcolor: n.arrowcolor, arrowhead: n.arrowhead, startarrowhead: n.startarrowhead, arrowside: n.arrowside, arrowsize: n.arrowsize, startarrowsize: n.startarrowsize, arrowwidth: n.arrowwidth, standoff: n.standoff, startstandoff: n.startstandoff, hovertext: n.hovertext, hoverlabel: n.hoverlabel, captureevents: n.captureevents }), "calc", "from-root");
      }), Sp = xe((L, k) => {
        var n = wt(), e = Ar(), a = aa(), i = Zs(), o = Uo();
        k.exports = function(s, c, t) {
          a(s, c, { name: "annotations", handleItemDefaults: r, fullLayout: t.fullLayout });
        };
        function r(s, c, t, p) {
          function l(g, x) {
            return n.coerce(s, c, o, g, x);
          }
          function f(g) {
            var x = g + "axis", h = { _fullLayout: {} };
            return h._fullLayout[x] = t[x], e.coercePosition(c, h, l, g, g, 0.5);
          }
          var v = l("visible");
          v && (i(s, c, p.fullLayout, l), f("x"), f("y"), f("z"), n.noneOrAll(s, c, ["x", "y", "z"]), c.xref = "x", c.yref = "y", c.zref = "z", l("xanchor"), l("yanchor"), l("xshift"), l("yshift"), c.showarrow && (c.axref = "pixel", c.ayref = "pixel", l("ax", -10), l("ay", -30), n.noneOrAll(s, c, ["ax", "ay"])));
        }
      }), Lp = xe((L, k) => {
        var n = wt(), e = Ar();
        k.exports = function(i) {
          for (var o = i.fullSceneLayout, r = o.annotations, s = 0; s < r.length; s++) a(r[s], i);
          i.fullLayout._infolayer.selectAll(".annotation-" + i.id).remove();
        };
        function a(i, o) {
          var r = o.fullSceneLayout, s = r.domain, c = o.fullLayout._size, t = { pdata: null, type: "linear", autorange: !1, range: [-1 / 0, 1 / 0] };
          i._xa = {}, n.extendFlat(i._xa, t), e.setConvert(i._xa), i._xa._offset = c.l + s.x[0] * c.w, i._xa.l2p = function() {
            return 0.5 * (1 + i._pdata[0] / i._pdata[3]) * c.w * (s.x[1] - s.x[0]);
          }, i._ya = {}, n.extendFlat(i._ya, t), e.setConvert(i._ya), i._ya._offset = c.t + (1 - s.y[1]) * c.h, i._ya.l2p = function() {
            return 0.5 * (1 - i._pdata[1] / i._pdata[3]) * c.h * (s.y[1] - s.y[0]);
          };
        }
      }), Op = xe((L, k) => {
        function n(a, i) {
          var o = [0, 0, 0, 0], r, s;
          for (r = 0; r < 4; ++r) for (s = 0; s < 4; ++s) o[s] += a[4 * r + s] * i[r];
          return o;
        }
        function e(a, i) {
          var o = n(a.projection, n(a.view, n(a.model, [i[0], i[1], i[2], 1])));
          return o;
        }
        k.exports = e;
      }), Cp = xe((L, k) => {
        var n = qo().drawRaw, e = Op(), a = ["x", "y", "z"];
        k.exports = function(i) {
          for (var o = i.fullSceneLayout, r = i.dataScale, s = o.annotations, c = 0; c < s.length; c++) {
            for (var t = s[c], p = !1, l = 0; l < 3; l++) {
              var f = a[l], v = t[f], g = o[f + "axis"], x = g.r2fraction(v);
              if (x < 0 || x > 1) {
                p = !0;
                break;
              }
            }
            p ? i.fullLayout._infolayer.select(".annotation-" + i.id + '[data-index="' + c + '"]').remove() : (t._pdata = e(i.glplot.cameraParams, [o.xaxis.r2l(t.x) * r[0], o.yaxis.r2l(t.y) * r[1], o.zaxis.r2l(t.z) * r[2]]), n(i.graphDiv, t, c, i.id, t._xa, t._ya));
          }
        };
      }), Ep = xe((L, k) => {
        var n = or(), e = wt();
        k.exports = { moduleType: "component", name: "annotations3d", schema: { subplots: { scene: { annotations: Uo() } } }, layoutAttributes: Uo(), handleDefaults: Sp(), includeBasePlot: a, convert: Lp(), draw: Cp() };
        function a(i, o) {
          var r = n.subplotsRegistry.gl3d;
          if (r) for (var s = r.attrRegex, c = Object.keys(i), t = 0; t < c.length; t++) {
            var p = c[t];
            s.test(p) && (i[p].annotations || []).length && (e.pushUnique(o._basePlotModules, r), e.pushUnique(o._subplots.gl3d, p));
          }
        }
      }), Ws = xe((L, k) => {
        var n = ni(), e = hn(), a = $n().line, i = Wn().dash, o = Br().extendFlat, r = qr().templatedArray;
        Ai();
        var s = Pn(), { shapeTexttemplateAttrs: c, templatefallbackAttrs: t } = qn(), p = fo();
        k.exports = r("shape", { visible: o({}, s.visible, { editType: "calc+arraydraw" }), showlegend: { valType: "boolean", dflt: !1, editType: "calc+arraydraw" }, legend: o({}, s.legend, { editType: "calc+arraydraw" }), legendgroup: o({}, s.legendgroup, { editType: "calc+arraydraw" }), legendgrouptitle: { text: o({}, s.legendgrouptitle.text, { editType: "calc+arraydraw" }), font: e({ editType: "calc+arraydraw" }), editType: "calc+arraydraw" }, legendrank: o({}, s.legendrank, { editType: "calc+arraydraw" }), legendwidth: o({}, s.legendwidth, { editType: "calc+arraydraw" }), type: { valType: "enumerated", values: ["circle", "rect", "path", "line"], editType: "calc+arraydraw" }, layer: { valType: "enumerated", values: ["below", "above", "between"], dflt: "above", editType: "arraydraw" }, xref: o({}, n.xref, {}), xsizemode: { valType: "enumerated", values: ["scaled", "pixel"], dflt: "scaled", editType: "calc+arraydraw" }, xanchor: { valType: "any", editType: "calc+arraydraw" }, x0: { valType: "any", editType: "calc+arraydraw" }, x1: { valType: "any", editType: "calc+arraydraw" }, x0shift: { valType: "number", dflt: 0, min: -1, max: 1, editType: "calc" }, x1shift: { valType: "number", dflt: 0, min: -1, max: 1, editType: "calc" }, yref: o({}, n.yref, {}), ysizemode: { valType: "enumerated", values: ["scaled", "pixel"], dflt: "scaled", editType: "calc+arraydraw" }, yanchor: { valType: "any", editType: "calc+arraydraw" }, y0: { valType: "any", editType: "calc+arraydraw" }, y1: { valType: "any", editType: "calc+arraydraw" }, y0shift: { valType: "number", dflt: 0, min: -1, max: 1, editType: "calc" }, y1shift: { valType: "number", dflt: 0, min: -1, max: 1, editType: "calc" }, path: { valType: "string", editType: "calc+arraydraw" }, opacity: { valType: "number", min: 0, max: 1, dflt: 1, editType: "arraydraw" }, line: { color: o({}, a.color, { editType: "arraydraw" }), width: o({}, a.width, { editType: "calc+arraydraw" }), dash: o({}, i, { editType: "arraydraw" }), editType: "calc+arraydraw" }, fillcolor: { valType: "color", dflt: "rgba(0,0,0,0)", editType: "arraydraw" }, fillrule: { valType: "enumerated", values: ["evenodd", "nonzero"], dflt: "evenodd", editType: "arraydraw" }, editable: { valType: "boolean", dflt: !1, editType: "calc+arraydraw" }, label: { text: { valType: "string", dflt: "", editType: "arraydraw" }, texttemplate: c({}, { keys: Object.keys(p) }), texttemplatefallback: t({ editType: "arraydraw" }), font: e({ editType: "calc+arraydraw", colorEditType: "arraydraw" }), textposition: { valType: "enumerated", values: ["top left", "top center", "top right", "middle left", "middle center", "middle right", "bottom left", "bottom center", "bottom right", "start", "middle", "end"], editType: "arraydraw" }, textangle: { valType: "angle", dflt: "auto", editType: "calc+arraydraw" }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "auto", editType: "calc+arraydraw" }, yanchor: { valType: "enumerated", values: ["top", "middle", "bottom"], editType: "calc+arraydraw" }, padding: { valType: "number", dflt: 3, min: 0, editType: "arraydraw" }, editType: "arraydraw" }, editType: "arraydraw" });
      }), Dp = xe((L, k) => {
        var n = wt(), e = Ar(), a = aa(), i = Ws(), o = La();
        k.exports = function(c, t) {
          a(c, t, { name: "shapes", handleItemDefaults: s });
        };
        function r(c, t) {
          return c ? "bottom" : t.indexOf("top") !== -1 ? "top" : t.indexOf("bottom") !== -1 ? "bottom" : "middle";
        }
        function s(c, t, p) {
          function l(O, F) {
            return n.coerce(c, t, i, O, F);
          }
          t._isShape = !0;
          var f = l("visible");
          if (f) {
            var v = l("showlegend");
            v && (l("legend"), l("legendwidth"), l("legendgroup"), l("legendgrouptitle.text"), n.coerceFont(l, "legendgrouptitle.font"), l("legendrank"));
            var g = l("path"), x = g ? "path" : "rect", h = l("type", x), m = h !== "path";
            m && delete t.path, l("editable"), l("layer"), l("opacity"), l("fillcolor"), l("fillrule");
            var u = l("line.width");
            u && (l("line.color"), l("line.dash"));
            for (var d = l("xsizemode"), y = l("ysizemode"), _ = ["x", "y"], T = 0; T < 2; T++) {
              var R = _[T], I = R + "anchor", P = R === "x" ? d : y, M = { _fullLayout: p }, B, z, q, U = e.coerceRef(c, t, M, R, void 0, "paper"), G = e.getRefType(U);
              if (G === "range" ? (B = e.getFromId(M, U), B._shapeIndices.push(t._index), q = o.rangeToShapePosition(B), z = o.shapePositionToRange(B), (B.type === "category" || B.type === "multicategory") && (l(R + "0shift"), l(R + "1shift"))) : z = q = n.identity, m) {
                var K = 0.25, te = 0.75, V = R + "0", Z = R + "1", Y = c[V], C = c[Z];
                c[V] = z(c[V], !0), c[Z] = z(c[Z], !0), P === "pixel" ? (l(V, 0), l(Z, 10)) : (e.coercePosition(t, M, l, U, V, K), e.coercePosition(t, M, l, U, Z, te)), t[V] = q(t[V]), t[Z] = q(t[Z]), c[V] = Y, c[Z] = C;
              }
              if (P === "pixel") {
                var j = c[I];
                c[I] = z(c[I], !0), e.coercePosition(t, M, l, U, I, 0.25), t[I] = q(t[I]), c[I] = j;
              }
            }
            m && n.noneOrAll(c, t, ["x0", "x1", "y0", "y1"]);
            var J = h === "line", ne, ae;
            if (m && (ne = l("label.texttemplate"), l("label.texttemplatefallback")), ne || (ae = l("label.text")), ae || ne) {
              l("label.textangle");
              var se = l("label.textposition", J ? "middle" : "middle center");
              l("label.xanchor"), l("label.yanchor", r(J, se)), l("label.padding"), n.coerceFont(l, "label.font", p.font);
            }
          }
        }
      }), Pp = xe((L, k) => {
        var n = fr(), e = wt();
        function a(i, o) {
          return i ? "bottom" : o.indexOf("top") !== -1 ? "top" : o.indexOf("bottom") !== -1 ? "bottom" : "middle";
        }
        k.exports = function(i, o, r) {
          r("newshape.visible"), r("newshape.name"), r("newshape.showlegend"), r("newshape.legend"), r("newshape.legendwidth"), r("newshape.legendgroup"), r("newshape.legendgrouptitle.text"), e.coerceFont(r, "newshape.legendgrouptitle.font"), r("newshape.legendrank"), r("newshape.drawdirection"), r("newshape.layer"), r("newshape.fillcolor"), r("newshape.fillrule"), r("newshape.opacity");
          var s = r("newshape.line.width");
          if (s) {
            var c = (i || {}).plot_bgcolor || "#FFF";
            r("newshape.line.color", n.contrast(c)), r("newshape.line.dash");
          }
          var t = i.dragmode === "drawline", p = r("newshape.label.text"), l = r("newshape.label.texttemplate");
          if (r("newshape.label.texttemplatefallback"), p || l) {
            r("newshape.label.textangle");
            var f = r("newshape.label.textposition", t ? "middle" : "middle center");
            r("newshape.label.xanchor"), r("newshape.label.yanchor", a(t, f)), r("newshape.label.padding"), e.coerceFont(r, "newshape.label.font", o.font);
          }
          r("activeshape.fillcolor"), r("activeshape.opacity");
        };
      }), Ip = xe((L, k) => {
        var n = wt(), e = Ar(), a = Mi(), i = La();
        k.exports = function(t) {
          var p = t._fullLayout, l = n.filterVisible(p.shapes);
          if (!(!l.length || !t._fullData.length)) for (var f = 0; f < l.length; f++) {
            var v = l[f];
            v._extremes = {};
            var g, x, h = e.getRefType(v.xref), m = e.getRefType(v.yref);
            v.xref !== "paper" && h !== "domain" && (g = e.getFromId(t, v.xref), x = c(g, v, a.paramIsX), x && (v._extremes[g._id] = e.findExtremes(g, x, o(v)))), v.yref !== "paper" && m !== "domain" && (g = e.getFromId(t, v.yref), x = c(g, v, a.paramIsY), x && (v._extremes[g._id] = e.findExtremes(g, x, r(v))));
          }
        };
        function o(t) {
          return s(t.line.width, t.xsizemode, t.x0, t.x1, t.path, !1);
        }
        function r(t) {
          return s(t.line.width, t.ysizemode, t.y0, t.y1, t.path, !0);
        }
        function s(t, p, l, f, v, g) {
          var x = t / 2, h = g;
          if (p === "pixel") {
            var m = v ? i.extractPathCoords(v, g ? a.paramIsY : a.paramIsX) : [l, f], u = n.aggNums(Math.max, null, m), d = n.aggNums(Math.min, null, m), y = d < 0 ? Math.abs(d) + x : x, _ = u > 0 ? u + x : x;
            return { ppad: x, ppadplus: h ? y : _, ppadminus: h ? _ : y };
          } else return { ppad: x };
        }
        function c(t, p, l) {
          var f = t._id.charAt(0) === "x" ? "x" : "y", v = t.type === "category" || t.type === "multicategory", g, x, h = 0, m = 0, u = v ? t.r2c : t.d2c, d = p[f + "sizemode"] === "scaled";
          if (d ? (g = p[f + "0"], x = p[f + "1"], v && (h = p[f + "0shift"], m = p[f + "1shift"])) : (g = p[f + "anchor"], x = p[f + "anchor"]), g !== void 0) return [u(g) + h, u(x) + m];
          if (p.path) {
            var y = 1 / 0, _ = -1 / 0, T = p.path.match(a.segmentRE), R, I, P, M, B;
            for (t.type === "date" && (u = i.decodeDate(u)), R = 0; R < T.length; R++) I = T[R], P = l[I.charAt(0)].drawn, P !== void 0 && (M = T[R].substr(1).match(a.paramRE), !(!M || M.length < P) && (B = u(M[P]), B < y && (y = B), B > _ && (_ = B)));
            if (_ >= y) return [y, _];
          }
        }
      }), zp = xe((L, k) => {
        var n = Po();
        k.exports = { moduleType: "component", name: "shapes", layoutAttributes: Ws(), supplyLayoutDefaults: Dp(), supplyDrawNewShapeDefaults: Pp(), includeBasePlot: Li()("shapes"), calcAutorange: Ip(), draw: n.draw, drawOne: n.drawOne };
      }), Xs = xe((L, k) => {
        var n = mn(), e = qr().templatedArray;
        Ai(), k.exports = e("image", { visible: { valType: "boolean", dflt: !0, editType: "arraydraw" }, source: { valType: "string", editType: "arraydraw" }, layer: { valType: "enumerated", values: ["below", "above"], dflt: "above", editType: "arraydraw" }, sizex: { valType: "number", dflt: 0, editType: "arraydraw" }, sizey: { valType: "number", dflt: 0, editType: "arraydraw" }, sizing: { valType: "enumerated", values: ["fill", "contain", "stretch"], dflt: "contain", editType: "arraydraw" }, opacity: { valType: "number", min: 0, max: 1, dflt: 1, editType: "arraydraw" }, x: { valType: "any", dflt: 0, editType: "arraydraw" }, y: { valType: "any", dflt: 0, editType: "arraydraw" }, xanchor: { valType: "enumerated", values: ["left", "center", "right"], dflt: "left", editType: "arraydraw" }, yanchor: { valType: "enumerated", values: ["top", "middle", "bottom"], dflt: "top", editType: "arraydraw" }, xref: { valType: "enumerated", values: ["paper", n.idRegex.x.toString()], dflt: "paper", editType: "arraydraw" }, yref: { valType: "enumerated", values: ["paper", n.idRegex.y.toString()], dflt: "paper", editType: "arraydraw" }, editType: "arraydraw" });
      }), Rp = xe((L, k) => {
        var n = wt(), e = Ar(), a = aa(), i = Xs(), o = "images";
        k.exports = function(s, c) {
          var t = { name: o, handleItemDefaults: r };
          a(s, c, t);
        };
        function r(s, c, t) {
          function p(d, y) {
            return n.coerce(s, c, i, d, y);
          }
          var l = p("source"), f = p("visible", !!l);
          if (!f) return c;
          p("layer"), p("xanchor"), p("yanchor"), p("sizex"), p("sizey"), p("sizing"), p("opacity");
          for (var v = { _fullLayout: t }, g = ["x", "y"], x = 0; x < 2; x++) {
            var h = g[x], m = e.coerceRef(s, c, v, h, "paper", void 0);
            if (m !== "paper") {
              var u = e.getFromId(v, m);
              u._imgIndices.push(c._index);
            }
            e.coercePosition(c, v, p, m, h, 0);
          }
          return c;
        }
      }), Np = xe((L, k) => {
        var n = vr(), e = Or(), a = Ar(), i = sn(), o = va();
        k.exports = function(r) {
          var s = r._fullLayout, c = [], t = {}, p = [], l, f;
          for (f = 0; f < s.images.length; f++) {
            var v = s.images[f];
            if (v.visible) if (v.layer === "below" && v.xref !== "paper" && v.yref !== "paper") {
              l = i.ref2id(v.xref) + i.ref2id(v.yref);
              var g = s._plots[l];
              if (!g) {
                p.push(v);
                continue;
              }
              g.mainplot && (l = g.mainplot.id), t[l] || (t[l] = []), t[l].push(v);
            } else v.layer === "above" ? c.push(v) : p.push(v);
          }
          var x = { x: { left: { sizing: "xMin", offset: 0 }, center: { sizing: "xMid", offset: -1 / 2 }, right: { sizing: "xMax", offset: -1 } }, y: { top: { sizing: "YMin", offset: 0 }, middle: { sizing: "YMid", offset: -1 / 2 }, bottom: { sizing: "YMax", offset: -1 } } };
          function h(P) {
            var M = n.select(this);
            if (this._imgSrc !== P.source) if (M.attr("xmlns", o.svg), !r._context.staticPlot || P.source && P.source.slice(0, 5) === "data:") M.attr("xlink:href", P.source), this._imgSrc = P.source;
            else {
              var B = new Promise((function(z) {
                var q = new Image();
                this.img = q, q.setAttribute("crossOrigin", "anonymous"), q.onerror = U, q.onload = function() {
                  var G = document.createElement("canvas");
                  G.width = this.width, G.height = this.height;
                  var K = G.getContext("2d", { willReadFrequently: !0 });
                  K.drawImage(this, 0, 0);
                  var te = G.toDataURL("image/png");
                  M.attr("xlink:href", te), z();
                }, M.on("error", U), q.src = P.source, this._imgSrc = P.source;
                function U() {
                  M.remove(), z();
                }
              }).bind(this));
              r._promises.push(B);
            }
          }
          function m(P) {
            var M = n.select(this), B = a.getFromId(r, P.xref), z = a.getFromId(r, P.yref), q = a.getRefType(P.xref) === "domain", U = a.getRefType(P.yref) === "domain", G = s._size, K, te;
            B !== void 0 ? K = typeof P.xref == "string" && q ? B._length * P.sizex : Math.abs(B.l2p(P.sizex) - B.l2p(0)) : K = P.sizex * G.w, z !== void 0 ? te = typeof P.yref == "string" && U ? z._length * P.sizey : Math.abs(z.l2p(P.sizey) - z.l2p(0)) : te = P.sizey * G.h;
            var V = K * x.x[P.xanchor].offset, Z = te * x.y[P.yanchor].offset, Y = x.x[P.xanchor].sizing + x.y[P.yanchor].sizing, C, j;
            switch (B !== void 0 ? C = typeof P.xref == "string" && q ? B._length * P.x + B._offset : B.r2p(P.x) + B._offset : C = P.x * G.w + G.l, C += V, z !== void 0 ? j = typeof P.yref == "string" && U ? z._length * (1 - P.y) + z._offset : z.r2p(P.y) + z._offset : j = G.h - P.y * G.h + G.t, j += Z, P.sizing) {
              case "fill":
                Y += " slice";
                break;
              case "stretch":
                Y = "none";
                break;
            }
            M.attr({ x: C, y: j, width: K, height: te, preserveAspectRatio: Y, opacity: P.opacity });
            var J = B && a.getRefType(P.xref) !== "domain" ? B._id : "", ne = z && a.getRefType(P.yref) !== "domain" ? z._id : "", ae = J + ne;
            e.setClipUrl(M, ae ? "clip" + s._uid + ae : null, r);
          }
          function u(P) {
            return [P.xref, P.x, P.sizex, P.yref, P.y, P.sizey].join("_");
          }
          function d(P, M) {
            return P._index - M._index;
          }
          var y = s._imageLowerLayer.selectAll("image").data(p, u), _ = s._imageUpperLayer.selectAll("image").data(c, u);
          y.enter().append("image"), _.enter().append("image"), y.exit().remove(), _.exit().remove(), y.each(function(P) {
            h.bind(this)(P), m.bind(this)(P);
          }), _.each(function(P) {
            h.bind(this)(P), m.bind(this)(P);
          }), y.sort(d), _.sort(d);
          var T = Object.keys(s._plots);
          for (f = 0; f < T.length; f++) {
            l = T[f];
            var R = s._plots[l];
            if (R.imagelayer) {
              var I = R.imagelayer.selectAll("image").data(t[l] || [], u);
              I.enter().append("image"), I.exit().remove(), I.each(function(P) {
                h.bind(this)(P), m.bind(this)(P);
              }), I.sort(d);
            }
          }
        };
      }), Fp = xe((L, k) => {
        var n = xr(), e = oo();
        k.exports = function(a, i, o, r) {
          i = i || {};
          var s = o === "log" && i.type === "linear", c = o === "linear" && i.type === "log";
          if (s || c) {
            for (var t = a._fullLayout.images, p = i._id.charAt(0), l, f, v = 0; v < t.length; v++) if (l = t[v], f = "images[" + v + "].", l[p + "ref"] === i._id) {
              var g = l[p], x = l["size" + p], h = null, m = null;
              if (s) {
                h = e(g, i.range);
                var u = x / Math.pow(10, h) / 2;
                m = 2 * Math.log(u + Math.sqrt(1 + u * u)) / Math.LN10;
              } else h = Math.pow(10, g), m = h * (Math.pow(10, x / 2) - Math.pow(10, -x / 2));
              n(h) ? n(m) || (m = null) : (h = null, m = null), r(f + p, h), r(f + "size" + p, m);
            }
          }
        };
      }), Bp = xe((L, k) => {
        k.exports = { moduleType: "component", name: "images", layoutAttributes: Xs(), supplyLayoutDefaults: Rp(), includeBasePlot: Li()("images"), draw: Np(), convertCoords: Fp() };
      }), Vo = xe((L, k) => {
        k.exports = { name: "updatemenus", containerClassName: "updatemenu-container", headerGroupClassName: "updatemenu-header-group", headerClassName: "updatemenu-header", headerArrowClassName: "updatemenu-header-arrow", dropdownButtonGroupClassName: "updatemenu-dropdown-button-group", dropdownButtonClassName: "updatemenu-dropdown-button", buttonClassName: "updatemenu-button", itemRectClassName: "updatemenu-item-rect", itemTextClassName: "updatemenu-item-text", menuIndexAttrName: "updatemenu-active-index", autoMarginIdRoot: "updatemenu-", blankHeaderOpts: { label: "  " }, minWidth: 30, minHeight: 30, textPadX: 24, arrowPadX: 16, rx: 2, ry: 2, textOffsetX: 12, textOffsetY: 3, arrowOffsetX: 4, gapButtonHeader: 5, gapButton: 2, activeColor: "#F4FAFF", hoverColor: "#F4FAFF", arrowSymbol: { left: "◄", right: "►", up: "▲", down: "▼" } };
      }), Js = xe((L, k) => {
        var n = hn(), e = Zn(), a = Br().extendFlat, i = ra().overrideAll, o = po(), r = qr().templatedArray, s = r("button", { visible: { valType: "boolean" }, method: { valType: "enumerated", values: ["restyle", "relayout", "animate", "update", "skip"], dflt: "restyle" }, args: { valType: "info_array", freeLength: !0, items: [{ valType: "any" }, { valType: "any" }, { valType: "any" }] }, args2: { valType: "info_array", freeLength: !0, items: [{ valType: "any" }, { valType: "any" }, { valType: "any" }] }, label: { valType: "string", dflt: "" }, execute: { valType: "boolean", dflt: !0 } });
        k.exports = i(r("updatemenu", { _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/], visible: { valType: "boolean" }, type: { valType: "enumerated", values: ["dropdown", "buttons"], dflt: "dropdown" }, direction: { valType: "enumerated", values: ["left", "right", "up", "down"], dflt: "down" }, active: { valType: "integer", min: -1, dflt: 0 }, showactive: { valType: "boolean", dflt: !0 }, buttons: s, x: { valType: "number", min: -2, max: 3, dflt: -0.05 }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "right" }, y: { valType: "number", min: -2, max: 3, dflt: 1 }, yanchor: { valType: "enumerated", values: ["auto", "top", "middle", "bottom"], dflt: "top" }, pad: a(o({ editType: "arraydraw" }), {}), font: n({}), bgcolor: { valType: "color" }, bordercolor: { valType: "color", dflt: e.borderLine }, borderwidth: { valType: "number", min: 0, dflt: 1, editType: "arraydraw" } }), "arraydraw", "from-root");
      }), jp = xe((L, k) => {
        var n = wt(), e = aa(), a = Js(), i = Vo(), o = i.name, r = a.buttons;
        k.exports = function(t, p) {
          var l = { name: o, handleItemDefaults: s };
          e(t, p, l);
        };
        function s(t, p, l) {
          function f(x, h) {
            return n.coerce(t, p, a, x, h);
          }
          var v = e(t, p, { name: "buttons", handleItemDefaults: c }), g = f("visible", v.length > 0);
          g && (f("active"), f("direction"), f("type"), f("showactive"), f("x"), f("y"), n.noneOrAll(t, p, ["x", "y"]), f("xanchor"), f("yanchor"), f("pad.t"), f("pad.r"), f("pad.b"), f("pad.l"), n.coerceFont(f, "font", l.font), f("bgcolor", l.paper_bgcolor), f("bordercolor"), f("borderwidth"));
        }
        function c(t, p) {
          function l(v, g) {
            return n.coerce(t, p, r, v, g);
          }
          var f = l("visible", t.method === "skip" || Array.isArray(t.args));
          f && (l("method"), l("args"), l("args2"), l("label"), l("execute"));
        }
      }), Hp = xe((L, k) => {
        k.exports = o;
        var n = vr(), e = fr(), a = Or(), i = wt();
        function o(r, s, c) {
          this.gd = r, this.container = s, this.id = c, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([0]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({ opacity: 0, x: 0, y: 0, width: 0, height: 0 });
        }
        o.barWidth = 2, o.barLength = 20, o.barRadius = 2, o.barPad = 1, o.barColor = "#808BA4", o.prototype.enable = function(r, s, c) {
          var t = this.gd._fullLayout, p = t.width, l = t.height;
          this.position = r;
          var f = this.position.l, v = this.position.w, g = this.position.t, x = this.position.h, h = this.position.direction, m = h === "down", u = h === "left", d = h === "right", y = h === "up", _ = v, T = x, R, I, P, M;
          !m && !u && !d && !y && (this.position.direction = "down", m = !0);
          var B = m || y;
          B ? (R = f, I = R + _, m ? (P = g, M = Math.min(P + T, l), T = M - P) : (M = g + T, P = Math.max(M - T, 0), T = M - P)) : (P = g, M = P + T, u ? (I = f + _, R = Math.max(I - _, 0), _ = I - R) : (R = f, I = Math.min(R + _, p), _ = I - R)), this._box = { l: R, t: P, w: _, h: T };
          var z = v > _, q = o.barLength + 2 * o.barPad, U = o.barWidth + 2 * o.barPad, G = f, K = g + x;
          K + U > l && (K = l - U);
          var te = this.container.selectAll("rect.scrollbar-horizontal").data(z ? [0] : []);
          te.exit().on(".drag", null).remove(), te.enter().append("rect").classed("scrollbar-horizontal", !0).call(e.fill, o.barColor), z ? (this.hbar = te.attr({ rx: o.barRadius, ry: o.barRadius, x: G, y: K, width: q, height: U }), this._hbarXMin = G + q / 2, this._hbarTranslateMax = _ - q) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
          var V = x > T, Z = o.barWidth + 2 * o.barPad, Y = o.barLength + 2 * o.barPad, C = f + v, j = g;
          C + Z > p && (C = p - Z);
          var J = this.container.selectAll("rect.scrollbar-vertical").data(V ? [0] : []);
          J.exit().on(".drag", null).remove(), J.enter().append("rect").classed("scrollbar-vertical", !0).call(e.fill, o.barColor), V ? (this.vbar = J.attr({ rx: o.barRadius, ry: o.barRadius, x: C, y: j, width: Z, height: Y }), this._vbarYMin = j + Y / 2, this._vbarTranslateMax = T - Y) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
          var ne = this.id, ae = R - 0.5, se = V ? I + Z + 0.5 : I + 0.5, O = P - 0.5, F = z ? M + U + 0.5 : M + 0.5, S = t._topdefs.selectAll("#" + ne).data(z || V ? [0] : []);
          if (S.exit().remove(), S.enter().append("clipPath").attr("id", ne).append("rect"), z || V ? (this._clipRect = S.select("rect").attr({ x: Math.floor(ae), y: Math.floor(O), width: Math.ceil(se) - Math.floor(ae), height: Math.ceil(F) - Math.floor(O) }), this.container.call(a.setClipUrl, ne, this.gd), this.bg.attr({ x: f, y: g, width: v, height: x })) : (this.bg.attr({ width: 0, height: 0 }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), z || V) {
            var $ = n.behavior.drag().on("dragstart", function() {
              n.event.sourceEvent.preventDefault();
            }).on("drag", this._onBoxDrag.bind(this));
            this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call($);
            var re = n.behavior.drag().on("dragstart", function() {
              n.event.sourceEvent.preventDefault(), n.event.sourceEvent.stopPropagation();
            }).on("drag", this._onBarDrag.bind(this));
            z && this.hbar.on(".drag", null).call(re), V && this.vbar.on(".drag", null).call(re);
          }
          this.setTranslate(s, c);
        }, o.prototype.disable = function() {
          (this.hbar || this.vbar) && (this.bg.attr({ width: 0, height: 0 }), this.container.on("wheel", null).on(".drag", null).call(a.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
        }, o.prototype._onBoxDrag = function() {
          var r = this.translateX, s = this.translateY;
          this.hbar && (r -= n.event.dx), this.vbar && (s -= n.event.dy), this.setTranslate(r, s);
        }, o.prototype._onBoxWheel = function() {
          var r = this.translateX, s = this.translateY;
          this.hbar && (r += n.event.deltaY), this.vbar && (s += n.event.deltaY), this.setTranslate(r, s);
        }, o.prototype._onBarDrag = function() {
          var r = this.translateX, s = this.translateY;
          if (this.hbar) {
            var c = r + this._hbarXMin, t = c + this._hbarTranslateMax, p = i.constrain(n.event.x, c, t), l = (p - c) / (t - c), f = this.position.w - this._box.w;
            r = l * f;
          }
          if (this.vbar) {
            var v = s + this._vbarYMin, g = v + this._vbarTranslateMax, x = i.constrain(n.event.y, v, g), h = (x - v) / (g - v), m = this.position.h - this._box.h;
            s = h * m;
          }
          this.setTranslate(r, s);
        }, o.prototype.setTranslate = function(r, s) {
          var c = this.position.w - this._box.w, t = this.position.h - this._box.h;
          if (r = i.constrain(r || 0, 0, c), s = i.constrain(s || 0, 0, t), this.translateX = r, this.translateY = s, this.container.call(a.setTranslate, this._box.l - this.position.l - r, this._box.t - this.position.t - s), this._clipRect && this._clipRect.attr({ x: Math.floor(this.position.l + r - 0.5), y: Math.floor(this.position.t + s - 0.5) }), this.hbar) {
            var p = r / c;
            this.hbar.call(a.setTranslate, r + p * this._hbarTranslateMax, s);
          }
          if (this.vbar) {
            var l = s / t;
            this.vbar.call(a.setTranslate, r, s + l * this._vbarTranslateMax);
          }
        };
      }), qp = xe((L, k) => {
        var n = vr(), e = on(), a = fr(), i = Or(), o = wt(), r = xn(), s = qr().arrayEditor, c = kn().LINE_SPACING, t = Vo(), p = Hp();
        k.exports = function(q) {
          var U = q._fullLayout, G = o.filterVisible(U[t.name]);
          function K(ne) {
            e.autoMargin(q, M(ne));
          }
          var te = U._menulayer.selectAll("g." + t.containerClassName).data(G.length > 0 ? [0] : []);
          if (te.enter().append("g").classed(t.containerClassName, !0).style("cursor", "pointer"), te.exit().each(function() {
            n.select(this).selectAll("g." + t.headerGroupClassName).each(K);
          }).remove(), G.length !== 0) {
            var V = te.selectAll("g." + t.headerGroupClassName).data(G, l);
            V.enter().append("g").classed(t.headerGroupClassName, !0);
            for (var Z = o.ensureSingle(te, "g", t.dropdownButtonGroupClassName, function(ne) {
              ne.style("pointer-events", "all");
            }), Y = 0; Y < G.length; Y++) {
              var C = G[Y];
              P(q, C);
            }
            var j = "updatemenus" + U._uid, J = new p(q, Z, j);
            V.enter().size() && (Z.node().parentNode.appendChild(Z.node()), Z.call(z)), V.exit().each(function(ne) {
              Z.call(z), K(ne);
            }).remove(), V.each(function(ne) {
              var ae = n.select(this), se = ne.type === "dropdown" ? Z : null;
              e.manageCommandObserver(q, ne, ne.buttons, function(O) {
                g(q, ne, ne.buttons[O.index], ae, se, J, O.index, !0);
              }), ne.type === "dropdown" ? (x(q, ae, Z, J, ne), v(Z, ne) && h(q, ae, Z, J, ne)) : h(q, ae, null, null, ne);
            });
          }
        };
        function l(q) {
          return q._index;
        }
        function f(q) {
          return +q.attr(t.menuIndexAttrName) == -1;
        }
        function v(q, U) {
          return +q.attr(t.menuIndexAttrName) === U._index;
        }
        function g(q, U, G, K, te, V, Z, Y) {
          U.active = Z, s(q.layout, t.name, U).applyUpdate("active", Z), U.type === "buttons" ? h(q, K, null, null, U) : U.type === "dropdown" && (te.attr(t.menuIndexAttrName, "-1"), x(q, K, te, V, U), Y || h(q, K, te, V, U));
        }
        function x(q, U, G, K, te) {
          var V = o.ensureSingle(U, "g", t.headerClassName, function(ae) {
            ae.style("pointer-events", "all");
          }), Z = te._dims, Y = te.active, C = te.buttons[Y] || t.blankHeaderOpts, j = { y: te.pad.t, yPad: 0, x: te.pad.l, xPad: 0, index: 0 }, J = { width: Z.headerWidth, height: Z.headerHeight };
          V.call(d, te, C, q).call(B, te, j, J);
          var ne = o.ensureSingle(U, "text", t.headerArrowClassName, function(ae) {
            ae.attr("text-anchor", "end").call(i.font, te.font).text(t.arrowSymbol[te.direction]);
          });
          ne.attr({ x: Z.headerWidth - t.arrowOffsetX + te.pad.l, y: Z.headerHeight / 2 + t.textOffsetY + te.pad.t }), V.on("click", function() {
            G.call(z, String(v(G, te) ? -1 : te._index)), h(q, U, G, K, te);
          }), V.on("mouseover", function() {
            V.call(R);
          }), V.on("mouseout", function() {
            V.call(I, te);
          }), i.setTranslate(U, Z.lx, Z.ly);
        }
        function h(q, U, G, K, te) {
          G || (G = U, G.attr("pointer-events", "all"));
          var V = !f(G) || te.type === "buttons" ? te.buttons : [], Z = te.type === "dropdown" ? t.dropdownButtonClassName : t.buttonClassName, Y = G.selectAll("g." + Z).data(o.filterVisible(V)), C = Y.enter().append("g").classed(Z, !0), j = Y.exit();
          te.type === "dropdown" ? (C.attr("opacity", "0").transition().attr("opacity", "1"), j.transition().attr("opacity", "0").remove()) : j.remove();
          var J = 0, ne = 0, ae = te._dims, se = ["up", "down"].indexOf(te.direction) !== -1;
          te.type === "dropdown" && (se ? ne = ae.headerHeight + t.gapButtonHeader : J = ae.headerWidth + t.gapButtonHeader), te.type === "dropdown" && te.direction === "up" && (ne = -t.gapButtonHeader + t.gapButton - ae.openHeight), te.type === "dropdown" && te.direction === "left" && (J = -t.gapButtonHeader + t.gapButton - ae.openWidth);
          var O = { x: ae.lx + J + te.pad.l, y: ae.ly + ne + te.pad.t, yPad: t.gapButton, xPad: t.gapButton, index: 0 }, F = { l: O.x + te.borderwidth, t: O.y + te.borderwidth };
          Y.each(function(S, $) {
            var re = n.select(this);
            re.call(d, te, S, q).call(B, te, O), re.on("click", function() {
              n.event.defaultPrevented || (S.execute && (S.args2 && te.active === $ ? (g(q, te, S, U, G, K, -1), e.executeAPICommand(q, S.method, S.args2)) : (g(q, te, S, U, G, K, $), e.executeAPICommand(q, S.method, S.args))), q.emit("plotly_buttonclicked", { menu: te, button: S, active: te.active }));
            }), re.on("mouseover", function() {
              re.call(R);
            }), re.on("mouseout", function() {
              re.call(I, te), Y.call(T, te);
            });
          }), Y.call(T, te), se ? (F.w = Math.max(ae.openWidth, ae.headerWidth), F.h = O.y - F.t) : (F.w = O.x - F.l, F.h = Math.max(ae.openHeight, ae.headerHeight)), F.direction = te.direction, K && (Y.size() ? m(q, U, G, K, te, F) : u(K));
        }
        function m(q, U, G, K, te, V) {
          var Z = te.direction, Y = Z === "up" || Z === "down", C = te._dims, j = te.active, J, ne, ae;
          if (Y) for (ne = 0, ae = 0; ae < j; ae++) ne += C.heights[ae] + t.gapButton;
          else for (J = 0, ae = 0; ae < j; ae++) J += C.widths[ae] + t.gapButton;
          K.enable(V, J, ne), K.hbar && K.hbar.attr("opacity", "0").transition().attr("opacity", "1"), K.vbar && K.vbar.attr("opacity", "0").transition().attr("opacity", "1");
        }
        function u(q) {
          var U = !!q.hbar, G = !!q.vbar;
          U && q.hbar.transition().attr("opacity", "0").each("end", function() {
            U = !1, G || q.disable();
          }), G && q.vbar.transition().attr("opacity", "0").each("end", function() {
            G = !1, U || q.disable();
          });
        }
        function d(q, U, G, K) {
          q.call(y, U).call(_, U, G, K);
        }
        function y(q, U) {
          var G = o.ensureSingle(q, "rect", t.itemRectClassName, function(K) {
            K.attr({ rx: t.rx, ry: t.ry, "shape-rendering": "crispEdges" });
          });
          G.call(a.stroke, U.bordercolor).call(a.fill, U.bgcolor).style("stroke-width", U.borderwidth + "px");
        }
        function _(q, U, G, K) {
          var te = o.ensureSingle(q, "text", t.itemTextClassName, function(Y) {
            Y.attr({ "text-anchor": "start", "data-notex": 1 });
          }), V = G.label, Z = K._fullLayout._meta;
          Z && (V = o.templateString(V, Z)), te.call(i.font, U.font).text(V).call(r.convertToTspans, K);
        }
        function T(q, U) {
          var G = U.active;
          q.each(function(K, te) {
            var V = n.select(this);
            te === G && U.showactive && V.select("rect." + t.itemRectClassName).call(a.fill, t.activeColor);
          });
        }
        function R(q) {
          q.select("rect." + t.itemRectClassName).call(a.fill, t.hoverColor);
        }
        function I(q, U) {
          q.select("rect." + t.itemRectClassName).call(a.fill, U.bgcolor);
        }
        function P(q, U) {
          var G = U._dims = { width1: 0, height1: 0, heights: [], widths: [], totalWidth: 0, totalHeight: 0, openWidth: 0, openHeight: 0, lx: 0, ly: 0 }, K = i.tester.selectAll("g." + t.dropdownButtonClassName).data(o.filterVisible(U.buttons));
          K.enter().append("g").classed(t.dropdownButtonClassName, !0);
          var te = ["up", "down"].indexOf(U.direction) !== -1;
          K.each(function(J, ne) {
            var ae = n.select(this);
            ae.call(d, U, J, q);
            var se = ae.select("." + t.itemTextClassName), O = se.node() && i.bBox(se.node()).width, F = Math.max(O + t.textPadX, t.minWidth), S = U.font.size * c, $ = r.lineCount(se), re = Math.max(S * $, t.minHeight) + t.textOffsetY;
            re = Math.ceil(re), F = Math.ceil(F), G.widths[ne] = F, G.heights[ne] = re, G.height1 = Math.max(G.height1, re), G.width1 = Math.max(G.width1, F), te ? (G.totalWidth = Math.max(G.totalWidth, F), G.openWidth = G.totalWidth, G.totalHeight += re + t.gapButton, G.openHeight += re + t.gapButton) : (G.totalWidth += F + t.gapButton, G.openWidth += F + t.gapButton, G.totalHeight = Math.max(G.totalHeight, re), G.openHeight = G.totalHeight);
          }), te ? G.totalHeight -= t.gapButton : G.totalWidth -= t.gapButton, G.headerWidth = G.width1 + t.arrowPadX, G.headerHeight = G.height1, U.type === "dropdown" && (te ? (G.width1 += t.arrowPadX, G.totalHeight = G.height1) : G.totalWidth = G.width1, G.totalWidth += t.arrowPadX), K.remove();
          var V = G.totalWidth + U.pad.l + U.pad.r, Z = G.totalHeight + U.pad.t + U.pad.b, Y = q._fullLayout._size;
          G.lx = Y.l + Y.w * U.x, G.ly = Y.t + Y.h * (1 - U.y);
          var C = "left";
          o.isRightAnchor(U) && (G.lx -= V, C = "right"), o.isCenterAnchor(U) && (G.lx -= V / 2, C = "center");
          var j = "top";
          o.isBottomAnchor(U) && (G.ly -= Z, j = "bottom"), o.isMiddleAnchor(U) && (G.ly -= Z / 2, j = "middle"), G.totalWidth = Math.ceil(G.totalWidth), G.totalHeight = Math.ceil(G.totalHeight), G.lx = Math.round(G.lx), G.ly = Math.round(G.ly), e.autoMargin(q, M(U), { x: U.x, y: U.y, l: V * ({ right: 1, center: 0.5 }[C] || 0), r: V * ({ left: 1, center: 0.5 }[C] || 0), b: Z * ({ top: 1, middle: 0.5 }[j] || 0), t: Z * ({ bottom: 1, middle: 0.5 }[j] || 0) });
        }
        function M(q) {
          return t.autoMarginIdRoot + q._index;
        }
        function B(q, U, G, K) {
          K = K || {};
          var te = q.select("." + t.itemRectClassName), V = q.select("." + t.itemTextClassName), Z = U.borderwidth, Y = G.index, C = U._dims;
          i.setTranslate(q, Z + G.x, Z + G.y);
          var j = ["up", "down"].indexOf(U.direction) !== -1, J = K.height || (j ? C.heights[Y] : C.height1);
          te.attr({ x: 0, y: 0, width: K.width || (j ? C.width1 : C.widths[Y]), height: J });
          var ne = U.font.size * c, ae = r.lineCount(V), se = (ae - 1) * ne / 2;
          r.positionText(V, t.textOffsetX, J / 2 - se + t.textOffsetY), j ? G.y += C.heights[Y] + G.yPad : G.x += C.widths[Y] + G.xPad, G.index++;
        }
        function z(q, U) {
          q.attr(t.menuIndexAttrName, U || "-1").selectAll("g." + t.dropdownButtonClassName).remove();
        }
      }), Up = xe((L, k) => {
        var n = Vo();
        k.exports = { moduleType: "component", name: n.name, layoutAttributes: Js(), supplyLayoutDefaults: jp(), draw: qp() };
      }), Ei = xe((L, k) => {
        k.exports = { name: "sliders", containerClassName: "slider-container", groupClassName: "slider-group", inputAreaClass: "slider-input-area", railRectClass: "slider-rail-rect", railTouchRectClass: "slider-rail-touch-rect", gripRectClass: "slider-grip-rect", tickRectClass: "slider-tick-rect", inputProxyClass: "slider-input-proxy", labelsClass: "slider-labels", labelGroupClass: "slider-label-group", labelClass: "slider-label", currentValueClass: "slider-current-value", railHeight: 5, menuIndexAttrName: "slider-active-index", autoMarginIdRoot: "slider-", minWidth: 30, minHeight: 30, textPadX: 40, arrowOffsetX: 4, railRadius: 2, railWidth: 5, railBorder: 4, railBorderWidth: 1, railBorderColor: "#bec8d9", railBgColor: "#f8fafc", railInset: 8, stepInset: 10, gripRadius: 10, gripWidth: 20, gripHeight: 20, gripBorder: 20, gripBorderWidth: 1, gripBorderColor: "#bec8d9", gripBgColor: "#f6f8fa", gripBgActiveColor: "#dbdde0", labelPadding: 8, labelOffset: 0, tickWidth: 1, tickColor: "#333", tickOffset: 25, tickLength: 7, minorTickOffset: 25, minorTickColor: "#333", minorTickLength: 4, currentValuePadding: 8, currentValueInset: 0 };
      }), $s = xe((L, k) => {
        var n = hn(), e = po(), a = Br().extendDeepAll, i = ra().overrideAll, o = wi(), r = qr().templatedArray, s = Ei(), c = r("step", { visible: { valType: "boolean", dflt: !0 }, method: { valType: "enumerated", values: ["restyle", "relayout", "animate", "update", "skip"], dflt: "restyle" }, args: { valType: "info_array", freeLength: !0, items: [{ valType: "any" }, { valType: "any" }, { valType: "any" }] }, label: { valType: "string" }, value: { valType: "string" }, execute: { valType: "boolean", dflt: !0 } });
        k.exports = i(r("slider", { visible: { valType: "boolean", dflt: !0 }, active: { valType: "number", min: 0, dflt: 0 }, steps: c, lenmode: { valType: "enumerated", values: ["fraction", "pixels"], dflt: "fraction" }, len: { valType: "number", min: 0, dflt: 1 }, x: { valType: "number", min: -2, max: 3, dflt: 0 }, pad: a(e({ editType: "arraydraw" }), {}, { t: { dflt: 20 } }), xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "left" }, y: { valType: "number", min: -2, max: 3, dflt: 0 }, yanchor: { valType: "enumerated", values: ["auto", "top", "middle", "bottom"], dflt: "top" }, transition: { duration: { valType: "number", min: 0, dflt: 150 }, easing: { valType: "enumerated", values: o.transition.easing.values, dflt: "cubic-in-out" } }, currentvalue: { visible: { valType: "boolean", dflt: !0 }, xanchor: { valType: "enumerated", values: ["left", "center", "right"], dflt: "left" }, offset: { valType: "number", dflt: 10 }, prefix: { valType: "string" }, suffix: { valType: "string" }, font: n({}) }, font: n({}), activebgcolor: { valType: "color", dflt: s.gripBgActiveColor }, bgcolor: { valType: "color", dflt: s.railBgColor }, bordercolor: { valType: "color", dflt: s.railBorderColor }, borderwidth: { valType: "number", min: 0, dflt: s.railBorderWidth }, ticklen: { valType: "number", min: 0, dflt: s.tickLength }, tickcolor: { valType: "color", dflt: s.tickColor }, tickwidth: { valType: "number", min: 0, dflt: 1 }, minorticklen: { valType: "number", min: 0, dflt: s.minorTickLength } }), "arraydraw", "from-root");
      }), Vp = xe((L, k) => {
        var n = wt(), e = aa(), a = $s(), i = Ei(), o = i.name, r = a.steps;
        k.exports = function(t, p) {
          e(t, p, { name: o, handleItemDefaults: s });
        };
        function s(t, p, l) {
          function f(y, _) {
            return n.coerce(t, p, a, y, _);
          }
          for (var v = e(t, p, { name: "steps", handleItemDefaults: c }), g = 0, x = 0; x < v.length; x++) v[x].visible && g++;
          var h;
          if (g < 2 ? h = p.visible = !1 : h = f("visible"), !!h) {
            p._stepCount = g;
            var m = p._visibleSteps = n.filterVisible(v), u = f("active");
            (v[u] || {}).visible || (p.active = m[0]._index), f("x"), f("y"), n.noneOrAll(t, p, ["x", "y"]), f("xanchor"), f("yanchor"), f("len"), f("lenmode"), f("pad.t"), f("pad.r"), f("pad.b"), f("pad.l"), n.coerceFont(f, "font", l.font);
            var d = f("currentvalue.visible");
            d && (f("currentvalue.xanchor"), f("currentvalue.prefix"), f("currentvalue.suffix"), f("currentvalue.offset"), n.coerceFont(f, "currentvalue.font", p.font)), f("transition.duration"), f("transition.easing"), f("bgcolor"), f("activebgcolor"), f("bordercolor"), f("borderwidth"), f("ticklen"), f("tickwidth"), f("tickcolor"), f("minorticklen");
          }
        }
        function c(t, p) {
          function l(g, x) {
            return n.coerce(t, p, r, g, x);
          }
          var f;
          if (t.method !== "skip" && !Array.isArray(t.args) ? f = p.visible = !1 : f = l("visible"), f) {
            l("method"), l("args");
            var v = l("label", "step-" + p._index);
            l("value", v), l("execute");
          }
        }
      }), Yp = xe((L, k) => {
        var n = vr(), e = on(), a = fr(), i = Or(), o = wt(), r = o.strTranslate, s = xn(), c = qr().arrayEditor, t = Ei(), p = kn(), l = p.LINE_SPACING, f = p.FROM_TL, v = p.FROM_BR;
        k.exports = function(te) {
          var V = te._context.staticPlot, Z = te._fullLayout, Y = x(Z, te), C = Z._infolayer.selectAll("g." + t.containerClassName).data(Y.length > 0 ? [0] : []);
          C.enter().append("g").classed(t.containerClassName, !0).style("cursor", V ? null : "ew-resize");
          function j(se) {
            se._commandObserver && (se._commandObserver.remove(), delete se._commandObserver), e.autoMargin(te, g(se));
          }
          if (C.exit().each(function() {
            n.select(this).selectAll("g." + t.groupClassName).each(j);
          }).remove(), Y.length !== 0) {
            var J = C.selectAll("g." + t.groupClassName).data(Y, h);
            J.enter().append("g").classed(t.groupClassName, !0), J.exit().each(j).remove();
            for (var ne = 0; ne < Y.length; ne++) {
              var ae = Y[ne];
              m(te, ae);
            }
            J.each(function(se) {
              var O = n.select(this);
              B(se), e.manageCommandObserver(te, se, se._visibleSteps, function(F) {
                var S = O.data()[0];
                S.active !== F.index && (S._dragging || I(te, O, S, F.index, !1, !0));
              }), u(te, n.select(this), se);
            });
          }
        };
        function g(te) {
          return t.autoMarginIdRoot + te._index;
        }
        function x(te, V) {
          for (var Z = te[t.name], Y = [], C = 0; C < Z.length; C++) {
            var j = Z[C];
            j.visible && (j._gd = V, Y.push(j));
          }
          return Y;
        }
        function h(te) {
          return te._index;
        }
        function m(te, V) {
          var Z = i.tester.selectAll("g." + t.labelGroupClass).data(V._visibleSteps);
          Z.enter().append("g").classed(t.labelGroupClass, !0);
          var Y = 0, C = 0;
          Z.each(function(re) {
            var E = n.select(this), w = _(E, { step: re }, V), N = w.node();
            if (N) {
              var W = i.bBox(N);
              C = Math.max(C, W.height), Y = Math.max(Y, W.width);
            }
          }), Z.remove();
          var j = V._dims = {};
          j.inputAreaWidth = Math.max(t.railWidth, t.gripHeight);
          var J = te._fullLayout._size;
          j.lx = J.l + J.w * V.x, j.ly = J.t + J.h * (1 - V.y), V.lenmode === "fraction" ? j.outerLength = Math.round(J.w * V.len) : j.outerLength = V.len, j.inputAreaStart = 0, j.inputAreaLength = Math.round(j.outerLength - V.pad.l - V.pad.r);
          var ne = j.inputAreaLength - 2 * t.stepInset, ae = ne / (V._stepCount - 1), se = Y + t.labelPadding;
          if (j.labelStride = Math.max(1, Math.ceil(se / ae)), j.labelHeight = C, j.currentValueMaxWidth = 0, j.currentValueHeight = 0, j.currentValueTotalHeight = 0, j.currentValueMaxLines = 1, V.currentvalue.visible) {
            var O = i.tester.append("g");
            Z.each(function(re) {
              var E = d(O, V, re.label), w = E.node() && i.bBox(E.node()) || { width: 0, height: 0 }, N = s.lineCount(E);
              j.currentValueMaxWidth = Math.max(j.currentValueMaxWidth, Math.ceil(w.width)), j.currentValueHeight = Math.max(j.currentValueHeight, Math.ceil(w.height)), j.currentValueMaxLines = Math.max(j.currentValueMaxLines, N);
            }), j.currentValueTotalHeight = j.currentValueHeight + V.currentvalue.offset, O.remove();
          }
          j.height = j.currentValueTotalHeight + t.tickOffset + V.ticklen + t.labelOffset + j.labelHeight + V.pad.t + V.pad.b;
          var F = "left";
          o.isRightAnchor(V) && (j.lx -= j.outerLength, F = "right"), o.isCenterAnchor(V) && (j.lx -= j.outerLength / 2, F = "center");
          var S = "top";
          o.isBottomAnchor(V) && (j.ly -= j.height, S = "bottom"), o.isMiddleAnchor(V) && (j.ly -= j.height / 2, S = "middle"), j.outerLength = Math.ceil(j.outerLength), j.height = Math.ceil(j.height), j.lx = Math.round(j.lx), j.ly = Math.round(j.ly);
          var $ = { y: V.y, b: j.height * v[S], t: j.height * f[S] };
          V.lenmode === "fraction" ? ($.l = 0, $.xl = V.x - V.len * f[F], $.r = 0, $.xr = V.x + V.len * v[F]) : ($.x = V.x, $.l = j.outerLength * f[F], $.r = j.outerLength * v[F]), e.autoMargin(te, g(V), $);
        }
        function u(te, V, Z) {
          (Z.steps[Z.active] || {}).visible || (Z.active = Z._visibleSteps[0]._index), V.call(d, Z).call(K, Z).call(T, Z).call(M, Z).call(G, te, Z).call(y, te, Z);
          var Y = Z._dims;
          i.setTranslate(V, Y.lx + Z.pad.l, Y.ly + Z.pad.t), V.call(z, Z, !1), V.call(d, Z);
        }
        function d(te, V, Z) {
          if (V.currentvalue.visible) {
            var Y = V._dims, C, j;
            switch (V.currentvalue.xanchor) {
              case "right":
                C = Y.inputAreaLength - t.currentValueInset - Y.currentValueMaxWidth, j = "left";
                break;
              case "center":
                C = Y.inputAreaLength * 0.5, j = "middle";
                break;
              default:
                C = t.currentValueInset, j = "left";
            }
            var J = o.ensureSingle(te, "text", t.labelClass, function(S) {
              S.attr({ "text-anchor": j, "data-notex": 1 });
            }), ne = V.currentvalue.prefix ? V.currentvalue.prefix : "";
            if (typeof Z == "string") ne += Z;
            else {
              var ae = V.steps[V.active].label, se = V._gd._fullLayout._meta;
              se && (ae = o.templateString(ae, se)), ne += ae;
            }
            V.currentvalue.suffix && (ne += V.currentvalue.suffix), J.call(i.font, V.currentvalue.font).text(ne).call(s.convertToTspans, V._gd);
            var O = s.lineCount(J), F = (Y.currentValueMaxLines + 1 - O) * V.currentvalue.font.size * l;
            return s.positionText(J, C, F), J;
          }
        }
        function y(te, V, Z) {
          var Y = o.ensureSingle(te, "rect", t.gripRectClass, function(C) {
            C.call(P, V, te, Z).style("pointer-events", "all");
          });
          Y.attr({ width: t.gripWidth, height: t.gripHeight, rx: t.gripRadius, ry: t.gripRadius }).call(a.stroke, Z.bordercolor).call(a.fill, Z.bgcolor).style("stroke-width", Z.borderwidth + "px");
        }
        function _(te, V, Z) {
          var Y = o.ensureSingle(te, "text", t.labelClass, function(J) {
            J.attr({ "text-anchor": "middle", "data-notex": 1 });
          }), C = V.step.label, j = Z._gd._fullLayout._meta;
          return j && (C = o.templateString(C, j)), Y.call(i.font, Z.font).text(C).call(s.convertToTspans, Z._gd), Y;
        }
        function T(te, V) {
          var Z = o.ensureSingle(te, "g", t.labelsClass), Y = V._dims, C = Z.selectAll("g." + t.labelGroupClass).data(Y.labelSteps);
          C.enter().append("g").classed(t.labelGroupClass, !0), C.exit().remove(), C.each(function(j) {
            var J = n.select(this);
            J.call(_, j, V), i.setTranslate(J, q(V, j.fraction), t.tickOffset + V.ticklen + V.font.size * l + t.labelOffset + Y.currentValueTotalHeight);
          });
        }
        function R(te, V, Z, Y, C) {
          var j = Math.round(Y * (Z._stepCount - 1)), J = Z._visibleSteps[j]._index;
          J !== Z.active && I(te, V, Z, J, !0, C);
        }
        function I(te, V, Z, Y, C, j) {
          var J = Z.active;
          Z.active = Y, c(te.layout, t.name, Z).applyUpdate("active", Y);
          var ne = Z.steps[Z.active];
          V.call(z, Z, j), V.call(d, Z), te.emit("plotly_sliderchange", { slider: Z, step: Z.steps[Z.active], interaction: C, previousActive: J }), ne && ne.method && C && (V._nextMethod ? (V._nextMethod.step = ne, V._nextMethod.doCallback = C, V._nextMethod.doTransition = j) : (V._nextMethod = { step: ne, doCallback: C, doTransition: j }, V._nextMethodRaf = window.requestAnimationFrame(function() {
            var ae = V._nextMethod.step;
            ae.method && (ae.execute && e.executeAPICommand(te, ae.method, ae.args), V._nextMethod = null, V._nextMethodRaf = null);
          })));
        }
        function P(te, V, Z) {
          if (V._context.staticPlot) return;
          var Y = Z.node(), C = n.select(V);
          function j() {
            return Z.data()[0];
          }
          function J() {
            var ne = j();
            V.emit("plotly_sliderstart", { slider: ne });
            var ae = Z.select("." + t.gripRectClass);
            n.event.stopPropagation(), n.event.preventDefault(), ae.call(a.fill, ne.activebgcolor);
            var se = U(ne, n.mouse(Y)[0]);
            R(V, Z, ne, se, !0), ne._dragging = !0;
            function O() {
              var S = j(), $ = U(S, n.mouse(Y)[0]);
              R(V, Z, S, $, !1);
            }
            C.on("mousemove", O), C.on("touchmove", O);
            function F() {
              var S = j();
              S._dragging = !1, ae.call(a.fill, S.bgcolor), C.on("mouseup", null), C.on("mousemove", null), C.on("touchend", null), C.on("touchmove", null), V.emit("plotly_sliderend", { slider: S, step: S.steps[S.active] });
            }
            C.on("mouseup", F), C.on("touchend", F);
          }
          te.on("mousedown", J), te.on("touchstart", J);
        }
        function M(te, V) {
          var Z = te.selectAll("rect." + t.tickRectClass).data(V._visibleSteps), Y = V._dims;
          Z.enter().append("rect").classed(t.tickRectClass, !0), Z.exit().remove(), Z.attr({ width: V.tickwidth + "px", "shape-rendering": "crispEdges" }), Z.each(function(C, j) {
            var J = j % Y.labelStride === 0, ne = n.select(this);
            ne.attr({ height: J ? V.ticklen : V.minorticklen }).call(a.fill, V.tickcolor), i.setTranslate(ne, q(V, j / (V._stepCount - 1)) - 0.5 * V.tickwidth, (J ? t.tickOffset : t.minorTickOffset) + Y.currentValueTotalHeight);
          });
        }
        function B(te) {
          var V = te._dims;
          V.labelSteps = [];
          for (var Z = te._stepCount, Y = 0; Y < Z; Y += V.labelStride) V.labelSteps.push({ fraction: Y / (Z - 1), step: te._visibleSteps[Y] });
        }
        function z(te, V, Z) {
          for (var Y = te.select("rect." + t.gripRectClass), C = 0, j = 0; j < V._stepCount; j++) if (V._visibleSteps[j]._index === V.active) {
            C = j;
            break;
          }
          var J = q(V, C / (V._stepCount - 1));
          if (!V._invokingCommand) {
            var ne = Y;
            Z && V.transition.duration > 0 && (ne = ne.transition().duration(V.transition.duration).ease(V.transition.easing)), ne.attr("transform", r(J - t.gripWidth * 0.5, V._dims.currentValueTotalHeight));
          }
        }
        function q(te, V) {
          var Z = te._dims;
          return Z.inputAreaStart + t.stepInset + (Z.inputAreaLength - 2 * t.stepInset) * Math.min(1, Math.max(0, V));
        }
        function U(te, V) {
          var Z = te._dims;
          return Math.min(1, Math.max(0, (V - t.stepInset - Z.inputAreaStart) / (Z.inputAreaLength - 2 * t.stepInset - 2 * Z.inputAreaStart)));
        }
        function G(te, V, Z) {
          var Y = Z._dims, C = o.ensureSingle(te, "rect", t.railTouchRectClass, function(j) {
            j.call(P, V, te, Z).style("pointer-events", "all");
          });
          C.attr({ width: Y.inputAreaLength, height: Math.max(Y.inputAreaWidth, t.tickOffset + Z.ticklen + Y.labelHeight) }).call(a.fill, Z.bgcolor).attr("opacity", 0), i.setTranslate(C, 0, Y.currentValueTotalHeight);
        }
        function K(te, V) {
          var Z = V._dims, Y = Z.inputAreaLength - t.railInset * 2, C = o.ensureSingle(te, "rect", t.railRectClass);
          C.attr({ width: Y, height: t.railWidth, rx: t.railRadius, ry: t.railRadius, "shape-rendering": "crispEdges" }).call(a.stroke, V.bordercolor).call(a.fill, V.bgcolor).style("stroke-width", V.borderwidth + "px"), i.setTranslate(C, t.railInset, (Z.inputAreaWidth - t.railWidth) * 0.5 + Z.currentValueTotalHeight);
        }
      }), Gp = xe((L, k) => {
        var n = Ei();
        k.exports = { moduleType: "component", name: n.name, layoutAttributes: $s(), supplyLayoutDefaults: Vp(), draw: Yp() };
      }), Yo = xe((L, k) => {
        var n = Zn();
        k.exports = { bgcolor: { valType: "color", dflt: n.background, editType: "plot" }, bordercolor: { valType: "color", dflt: n.defaultLine, editType: "plot" }, borderwidth: { valType: "integer", dflt: 0, min: 0, editType: "plot" }, autorange: { valType: "boolean", dflt: !0, editType: "calc", impliedEdits: { "range[0]": void 0, "range[1]": void 0 } }, range: { valType: "info_array", items: [{ valType: "any", editType: "calc", impliedEdits: { "^autorange": !1 } }, { valType: "any", editType: "calc", impliedEdits: { "^autorange": !1 } }], editType: "calc", impliedEdits: { autorange: !1 } }, thickness: { valType: "number", dflt: 0.15, min: 0, max: 1, editType: "plot" }, visible: { valType: "boolean", dflt: !0, editType: "calc" }, editType: "calc" };
      }), Ks = xe((L, k) => {
        k.exports = { _isSubplotObj: !0, rangemode: { valType: "enumerated", values: ["auto", "fixed", "match"], dflt: "match", editType: "calc" }, range: { valType: "info_array", items: [{ valType: "any", editType: "plot" }, { valType: "any", editType: "plot" }], editType: "plot" }, editType: "calc" };
      }), Go = xe((L, k) => {
        k.exports = { name: "rangeslider", containerClassName: "rangeslider-container", bgClassName: "rangeslider-bg", rangePlotClassName: "rangeslider-rangeplot", maskMinClassName: "rangeslider-mask-min", maskMaxClassName: "rangeslider-mask-max", slideBoxClassName: "rangeslider-slidebox", grabberMinClassName: "rangeslider-grabber-min", grabAreaMinClassName: "rangeslider-grabarea-min", handleMinClassName: "rangeslider-handle-min", grabberMaxClassName: "rangeslider-grabber-max", grabAreaMaxClassName: "rangeslider-grabarea-max", handleMaxClassName: "rangeslider-handle-max", maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis", maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis", maskColor: "rgba(0,0,0,0.4)", maskOppAxisColor: "rgba(0,0,0,0.2)", slideBoxFill: "transparent", slideBoxCursor: "ew-resize", grabAreaFill: "transparent", grabAreaCursor: "col-resize", grabAreaWidth: 10, handleWidth: 4, handleRadius: 1, handleStrokeWidth: 1, extraPad: 15 };
      }), Zp = xe((L) => {
        var k = sn(), n = xn(), e = Go(), a = kn().LINE_SPACING, i = e.name;
        function o(r) {
          var s = r && r[i];
          return s && s.visible;
        }
        L.isVisible = o, L.makeData = function(r) {
          for (var s = k.list({ _fullLayout: r }, "x", !0), c = r.margin, t = [], p = 0; p < s.length; p++) {
            var l = s[p];
            if (o(l)) {
              t.push(l);
              var f = l[i];
              f._id = i + l._id, f._height = (r.height - c.b - c.t) * f.thickness, f._offsetShift = Math.floor(f.borderwidth / 2);
            }
          }
          r._rangeSliderData = t;
        }, L.autoMarginOpts = function(r, s) {
          var c = r._fullLayout, t = s[i], p = s._id.charAt(0), l = 0, f = 0;
          if (s.side === "bottom" && (l = s._depth, s.title.text !== c._dfltTitle[p])) {
            f = 1.5 * s.title.font.size + 10 + t._offsetShift;
            var v = (s.title.text.match(n.BR_TAG_ALL) || []).length;
            f += v * s.title.font.size * a;
          }
          return { x: 0, y: s._counterDomainMin, l: 0, r: 0, t: 0, b: t._height + l + Math.max(c.margin.b, f), pad: e.extraPad + t._offsetShift * 2 };
        };
      }), Wp = xe((L, k) => {
        var n = wt(), e = qr(), a = sn(), i = Yo(), o = Ks();
        k.exports = function(r, s, c) {
          var t = r[c], p = s[c];
          if (!(t.rangeslider || s._requestRangeslider[p._id])) return;
          n.isPlainObject(t.rangeslider) || (t.rangeslider = {});
          var l = t.rangeslider, f = e.newContainer(p, "rangeslider");
          function v(M, B) {
            return n.coerce(l, f, i, M, B);
          }
          var g, x;
          function h(M, B) {
            return n.coerce(g, x, o, M, B);
          }
          var m = v("visible");
          if (m) {
            v("bgcolor", s.plot_bgcolor), v("bordercolor"), v("borderwidth"), v("thickness"), v("autorange", !p.isValidRange(l.range)), v("range");
            var u = s._subplots;
            if (u) for (var d = u.cartesian.filter(function(M) {
              return M.substr(0, M.indexOf("y")) === a.name2id(c);
            }).map(function(M) {
              return M.substr(M.indexOf("y"), M.length);
            }), y = n.simpleMap(d, a.id2name), _ = 0; _ < y.length; _++) {
              var T = y[_];
              g = l[T] || {}, x = e.newContainer(f, T, "yaxis");
              var R = s[T], I;
              g.range && R.isValidRange(g.range) && (I = "fixed");
              var P = h("rangemode", I);
              P !== "match" && h("range", R.range.slice());
            }
            f._input = l;
          }
        };
      }), Xp = xe((L, k) => {
        var n = sn().list, e = ki().getAutoRange, a = Go();
        k.exports = function(i) {
          for (var o = n(i, "x", !0), r = 0; r < o.length; r++) {
            var s = o[r], c = s[a.name];
            c && c.visible && c.autorange && (c._input.autorange = !0, c._input.range = c.range = e(i, s));
          }
        };
      }), Jp = xe((L, k) => {
        var n = vr(), e = or(), a = on(), i = wt(), o = i.strTranslate, r = Or(), s = fr(), c = ti(), t = Kn(), p = sn(), l = Jn(), f = Aa(), v = Go();
        k.exports = function(P) {
          for (var M = P._fullLayout, B = M._rangeSliderData, z = 0; z < B.length; z++) {
            var q = B[z][v.name];
            q._clipId = q._id + "-" + M._uid;
          }
          function U(K) {
            return K._name;
          }
          var G = M._infolayer.selectAll("g." + v.containerClassName).data(B, U);
          G.exit().each(function(K) {
            var te = K[v.name];
            M._topdefs.select("#" + te._clipId).remove();
          }).remove(), B.length !== 0 && (G.enter().append("g").classed(v.containerClassName, !0).attr("pointer-events", "all"), G.each(function(K) {
            var te = n.select(this), V = K[v.name], Z = M[p.id2name(K.anchor)], Y = V[p.id2name(K.anchor)];
            if (V.range) {
              var C = i.simpleMap(V.range, K.r2l), j = i.simpleMap(K.range, K.r2l), J;
              j[0] < j[1] ? J = [Math.min(C[0], j[0]), Math.max(C[1], j[1])] : J = [Math.max(C[0], j[0]), Math.min(C[1], j[1])], V.range = V._input.range = i.simpleMap(J, K.l2r);
            }
            K.cleanRange("rangeslider.range");
            var ne = M._size, ae = K.domain;
            V._width = ne.w * (ae[1] - ae[0]);
            var se = Math.round(ne.l + ne.w * ae[0]), O = Math.round(ne.t + ne.h * (1 - K._counterDomainMin) + (K.side === "bottom" ? K._depth : 0) + V._offsetShift + v.extraPad);
            te.attr("transform", o(se, O)), V._rl = i.simpleMap(V.range, K.r2l);
            var F = V._rl[0], S = V._rl[1], $ = S - F;
            if (V.p2d = function(_e) {
              return _e / V._width * $ + F;
            }, V.d2p = function(_e) {
              return (_e - F) / $ * V._width;
            }, K.rangebreaks) {
              var re = K.locateBreaks(F, S);
              if (re.length) {
                var E, w, N = 0;
                for (E = 0; E < re.length; E++) w = re[E], N += w.max - w.min;
                var W = V._width / (S - F - N), ee = [-W * F];
                for (E = 0; E < re.length; E++) w = re[E], ee.push(ee[ee.length - 1] - W * (w.max - w.min));
                for (V.d2p = function(_e) {
                  for (var Ae = ee[0], Ce = 0; Ce < re.length; Ce++) {
                    var Ue = re[Ce];
                    if (_e >= Ue.max) Ae = ee[Ce + 1];
                    else if (_e < Ue.min) break;
                  }
                  return Ae + W * _e;
                }, E = 0; E < re.length; E++) w = re[E], w.pmin = V.d2p(w.min), w.pmax = V.d2p(w.max);
                V.p2d = function(_e) {
                  for (var Ae = ee[0], Ce = 0; Ce < re.length; Ce++) {
                    var Ue = re[Ce];
                    if (_e >= Ue.pmax) Ae = ee[Ce + 1];
                    else if (_e < Ue.pmin) break;
                  }
                  return (_e - Ae) / W;
                };
              }
            }
            if (Y.rangemode !== "match") {
              var le = Z.r2l(Y.range[0]), ie = Z.r2l(Y.range[1]), pe = ie - le;
              V.d2pOppAxis = function(_e) {
                return (_e - le) / pe * V._height;
              };
            }
            te.call(u, P, K, V).call(d, P, K, V).call(y, P, K, V).call(T, P, K, V, Y).call(R, P, K, V).call(I, P, K, V), x(te, P, K, V), m(te, P, K, V, Z, Y), K.side === "bottom" && c.draw(P, K._id + "title", { propContainer: K, propName: K._name + ".title.text", placeholder: M._dfltTitle.x, attributes: { x: K._offset + K._length / 2, y: O + V._height + V._offsetShift + 10 + 1.5 * K.title.font.size, "text-anchor": "middle" } });
          }));
        };
        function g(P) {
          return typeof P.clientX == "number" ? P.clientX : P.touches && P.touches.length > 0 ? P.touches[0].clientX : 0;
        }
        function x(P, M, B, z) {
          if (M._context.staticPlot) return;
          var q = P.select("rect." + v.slideBoxClassName).node(), U = P.select("rect." + v.grabAreaMinClassName).node(), G = P.select("rect." + v.grabAreaMaxClassName).node();
          function K() {
            var te = n.event, V = te.target, Z = g(te), Y = Z - P.node().getBoundingClientRect().left, C = z.d2p(B._rl[0]), j = z.d2p(B._rl[1]), J = l.coverSlip();
            this.addEventListener("touchmove", ne), this.addEventListener("touchend", ae), J.addEventListener("mousemove", ne), J.addEventListener("mouseup", ae);
            function ne(se) {
              var O = g(se), F = +O - Z, S, $, re;
              switch (V) {
                case q:
                  if (re = "ew-resize", C + F > B._length || j + F < 0) return;
                  S = C + F, $ = j + F;
                  break;
                case U:
                  if (re = "col-resize", C + F > B._length) return;
                  S = C + F, $ = j;
                  break;
                case G:
                  if (re = "col-resize", j + F < 0) return;
                  S = C, $ = j + F;
                  break;
                default:
                  re = "ew-resize", S = Y, $ = Y + F;
                  break;
              }
              if ($ < S) {
                var E = $;
                $ = S, S = E;
              }
              z._pixelMin = S, z._pixelMax = $, f(n.select(J), re), h(P, M, B, z);
            }
            function ae() {
              J.removeEventListener("mousemove", ne), J.removeEventListener("mouseup", ae), this.removeEventListener("touchmove", ne), this.removeEventListener("touchend", ae), i.removeElement(J);
            }
          }
          P.on("mousedown", K), P.on("touchstart", K);
        }
        function h(P, M, B, z) {
          function q(K) {
            return B.l2r(i.constrain(K, z._rl[0], z._rl[1]));
          }
          var U = q(z.p2d(z._pixelMin)), G = q(z.p2d(z._pixelMax));
          window.requestAnimationFrame(function() {
            e.call("_guiRelayout", M, B._name + ".range", [U, G]);
          });
        }
        function m(P, M, B, z, q, U) {
          var G = v.handleWidth / 2;
          function K(se) {
            return i.constrain(se, 0, z._width);
          }
          function te(se) {
            return i.constrain(se, 0, z._height);
          }
          function V(se) {
            return i.constrain(se, -G, z._width + G);
          }
          var Z = K(z.d2p(B._rl[0])), Y = K(z.d2p(B._rl[1]));
          if (P.select("rect." + v.slideBoxClassName).attr("x", Z).attr("width", Y - Z), P.select("rect." + v.maskMinClassName).attr("width", Z), P.select("rect." + v.maskMaxClassName).attr("x", Y).attr("width", z._width - Y), U.rangemode !== "match") {
            var C = z._height - te(z.d2pOppAxis(q._rl[1])), j = z._height - te(z.d2pOppAxis(q._rl[0]));
            P.select("rect." + v.maskMinOppAxisClassName).attr("x", Z).attr("height", C).attr("width", Y - Z), P.select("rect." + v.maskMaxOppAxisClassName).attr("x", Z).attr("y", j).attr("height", z._height - j).attr("width", Y - Z), P.select("rect." + v.slideBoxClassName).attr("y", C).attr("height", j - C);
          }
          var J = 0.5, ne = Math.round(V(Z - G)) - J, ae = Math.round(V(Y - G)) + J;
          P.select("g." + v.grabberMinClassName).attr("transform", o(ne, J)), P.select("g." + v.grabberMaxClassName).attr("transform", o(ae, J));
        }
        function u(P, M, B, z) {
          var q = i.ensureSingle(P, "rect", v.bgClassName, function(te) {
            te.attr({ x: 0, y: 0, "shape-rendering": "crispEdges" });
          }), U = z.borderwidth % 2 === 0 ? z.borderwidth : z.borderwidth - 1, G = -z._offsetShift, K = r.crispRound(M, z.borderwidth);
          q.attr({ width: z._width + U, height: z._height + U, transform: o(G, G), "stroke-width": K }).call(s.stroke, z.bordercolor).call(s.fill, z.bgcolor);
        }
        function d(P, M, B, z) {
          var q = M._fullLayout, U = i.ensureSingleById(q._topdefs, "clipPath", z._clipId, function(G) {
            G.append("rect").attr({ x: 0, y: 0 });
          });
          U.select("rect").attr({ width: z._width, height: z._height });
        }
        function y(P, M, B, z) {
          var q = M.calcdata, U = P.selectAll("g." + v.rangePlotClassName).data(B._subplotsWith, i.identity);
          U.enter().append("g").attr("class", function(K) {
            return v.rangePlotClassName + " " + K;
          }).call(r.setClipUrl, z._clipId, M), U.order(), U.exit().remove();
          var G;
          U.each(function(K, te) {
            var V = n.select(this), Z = te === 0, Y = p.getFromId(M, K, "y"), C = Y._name, j = z[C], J = { data: [], layout: { xaxis: { type: B.type, domain: [0, 1], range: z.range.slice(), calendar: B.calendar }, width: z._width, height: z._height, margin: { t: 0, b: 0, l: 0, r: 0 } }, _context: M._context };
            B.rangebreaks && (J.layout.xaxis.rangebreaks = B.rangebreaks), J.layout[C] = { type: Y.type, domain: [0, 1], range: j.rangemode !== "match" ? j.range.slice() : Y.range.slice(), calendar: Y.calendar }, Y.rangebreaks && (J.layout[C].rangebreaks = Y.rangebreaks), a.supplyDefaults(J);
            var ne = J._fullLayout.xaxis, ae = J._fullLayout[C];
            ne.clearCalc(), ne.setScale(), ae.clearCalc(), ae.setScale();
            var se = { id: K, plotgroup: V, xaxis: ne, yaxis: ae, isRangePlot: !0 };
            Z ? G = se : (se.mainplot = "xy", se.mainplotinfo = G), t.rangePlot(M, se, _(q, K));
          });
        }
        function _(P, M) {
          for (var B = [], z = 0; z < P.length; z++) {
            var q = P[z], U = q[0].trace;
            U.xaxis + U.yaxis === M && B.push(q);
          }
          return B;
        }
        function T(P, M, B, z, q) {
          var U = i.ensureSingle(P, "rect", v.maskMinClassName, function(V) {
            V.attr({ x: 0, y: 0, "shape-rendering": "crispEdges" });
          });
          U.attr("height", z._height).call(s.fill, v.maskColor);
          var G = i.ensureSingle(P, "rect", v.maskMaxClassName, function(V) {
            V.attr({ y: 0, "shape-rendering": "crispEdges" });
          });
          if (G.attr("height", z._height).call(s.fill, v.maskColor), q.rangemode !== "match") {
            var K = i.ensureSingle(P, "rect", v.maskMinOppAxisClassName, function(V) {
              V.attr({ y: 0, "shape-rendering": "crispEdges" });
            });
            K.attr("width", z._width).call(s.fill, v.maskOppAxisColor);
            var te = i.ensureSingle(P, "rect", v.maskMaxOppAxisClassName, function(V) {
              V.attr({ y: 0, "shape-rendering": "crispEdges" });
            });
            te.attr("width", z._width).style("border-top", v.maskOppBorder).call(s.fill, v.maskOppAxisColor);
          }
        }
        function R(P, M, B, z) {
          if (!M._context.staticPlot) {
            var q = i.ensureSingle(P, "rect", v.slideBoxClassName, function(U) {
              U.attr({ y: 0, cursor: v.slideBoxCursor, "shape-rendering": "crispEdges" });
            });
            q.attr({ height: z._height, fill: v.slideBoxFill });
          }
        }
        function I(P, M, B, z) {
          var q = i.ensureSingle(P, "g", v.grabberMinClassName), U = i.ensureSingle(P, "g", v.grabberMaxClassName), G = { x: 0, width: v.handleWidth, rx: v.handleRadius, fill: s.background, stroke: s.defaultLine, "stroke-width": v.handleStrokeWidth, "shape-rendering": "crispEdges" }, K = { y: Math.round(z._height / 4), height: Math.round(z._height / 2) }, te = i.ensureSingle(q, "rect", v.handleMinClassName, function(j) {
            j.attr(G);
          });
          te.attr(K);
          var V = i.ensureSingle(U, "rect", v.handleMaxClassName, function(j) {
            j.attr(G);
          });
          V.attr(K);
          var Z = { width: v.grabAreaWidth, x: 0, y: 0, fill: v.grabAreaFill, cursor: M._context.staticPlot ? void 0 : v.grabAreaCursor }, Y = i.ensureSingle(q, "rect", v.grabAreaMinClassName, function(j) {
            j.attr(Z);
          });
          Y.attr("height", z._height);
          var C = i.ensureSingle(U, "rect", v.grabAreaMaxClassName, function(j) {
            j.attr(Z);
          });
          C.attr("height", z._height);
        }
      }), $p = xe((L, k) => {
        var n = wt(), e = Yo(), a = Ks(), i = Zp();
        k.exports = { moduleType: "component", name: "rangeslider", schema: { subplots: { xaxis: { rangeslider: n.extendFlat({}, e, { yaxis: a }) } } }, layoutAttributes: Yo(), handleDefaults: Wp(), calcAutorange: Xp(), draw: Jp(), isVisible: i.isVisible, makeData: i.makeData, autoMarginOpts: i.autoMarginOpts };
      }), Zo = xe((L, k) => {
        var n = hn(), e = Zn(), a = qr().templatedArray, i = a("button", { visible: { valType: "boolean", dflt: !0, editType: "plot" }, step: { valType: "enumerated", values: ["month", "year", "day", "hour", "minute", "second", "all"], dflt: "month", editType: "plot" }, stepmode: { valType: "enumerated", values: ["backward", "todate"], dflt: "backward", editType: "plot" }, count: { valType: "number", min: 0, dflt: 1, editType: "plot" }, label: { valType: "string", editType: "plot" }, editType: "plot" });
        k.exports = { visible: { valType: "boolean", editType: "plot" }, buttons: i, x: { valType: "number", min: -2, max: 3, editType: "plot" }, xanchor: { valType: "enumerated", values: ["auto", "left", "center", "right"], dflt: "left", editType: "plot" }, y: { valType: "number", min: -2, max: 3, editType: "plot" }, yanchor: { valType: "enumerated", values: ["auto", "top", "middle", "bottom"], dflt: "bottom", editType: "plot" }, font: n({ editType: "plot" }), bgcolor: { valType: "color", dflt: e.lightLine, editType: "plot" }, activecolor: { valType: "color", editType: "plot" }, bordercolor: { valType: "color", dflt: e.defaultLine, editType: "plot" }, borderwidth: { valType: "number", min: 0, dflt: 0, editType: "plot" }, editType: "plot" };
      }), Qs = xe((L, k) => {
        k.exports = { yPad: 0.02, minButtonWidth: 30, rx: 3, ry: 3, lightAmount: 25, darkAmount: 10 };
      }), Kp = xe((L, k) => {
        var n = wt(), e = fr(), a = qr(), i = aa(), o = Zo(), r = Qs();
        k.exports = function(t, p, l, f, v) {
          var g = t.rangeselector || {}, x = a.newContainer(p, "rangeselector");
          function h(_, T) {
            return n.coerce(g, x, o, _, T);
          }
          var m = i(g, x, { name: "buttons", handleItemDefaults: s, calendar: v }), u = h("visible", m.length > 0);
          if (u) {
            var d = c(p, l, f);
            h("x", d[0]), h("y", d[1]), n.noneOrAll(t, p, ["x", "y"]), h("xanchor"), h("yanchor"), n.coerceFont(h, "font", l.font);
            var y = h("bgcolor");
            h("activecolor", e.contrast(y, r.lightAmount, r.darkAmount)), h("bordercolor"), h("borderwidth");
          }
        };
        function s(t, p, l, f) {
          var v = f.calendar;
          function g(m, u) {
            return n.coerce(t, p, o.buttons, m, u);
          }
          var x = g("visible");
          if (x) {
            var h = g("step");
            h !== "all" && (v && v !== "gregorian" && (h === "month" || h === "year") ? p.stepmode = "backward" : g("stepmode"), g("count")), g("label");
          }
        }
        function c(t, p, l) {
          for (var f = l.filter(function(h) {
            return p[h].anchor === t._id;
          }), v = 0, g = 0; g < f.length; g++) {
            var x = p[f[g]].domain;
            x && (v = Math.max(x[1], v));
          }
          return [t.domain[0], v + r.yPad];
        }
      }), Qp = xe((L, k) => {
        var n = ql(), e = wt().titleCase;
        k.exports = function(i, o) {
          var r = i._name, s = {};
          if (o.step === "all") s[r + ".autorange"] = !0;
          else {
            var c = a(i, o);
            s[r + ".range[0]"] = c[0], s[r + ".range[1]"] = c[1];
          }
          return s;
        };
        function a(i, o) {
          var r = i.range, s = new Date(i.r2l(r[1])), c = o.step, t = n["utc" + e(c)], p = o.count, l;
          switch (o.stepmode) {
            case "backward":
              l = i.l2r(+t.offset(s, -p));
              break;
            case "todate":
              var f = t.offset(s, -p);
              l = i.l2r(+t.ceil(f));
              break;
          }
          var v = r[1];
          return [l, v];
        }
      }), e0 = xe((L, k) => {
        var n = vr(), e = or(), a = on(), i = fr(), o = Or(), r = wt(), s = r.strTranslate, c = xn(), t = sn(), p = kn(), l = p.LINE_SPACING, f = p.FROM_TL, v = p.FROM_BR, g = Qs(), x = Qp();
        k.exports = function(I) {
          var P = I._fullLayout, M = P._infolayer.selectAll(".rangeselector").data(h(I), m);
          M.enter().append("g").classed("rangeselector", !0), M.exit().remove(), M.style({ cursor: "pointer", "pointer-events": "all" }), M.each(function(B) {
            var z = n.select(this), q = B, U = q.rangeselector, G = z.selectAll("g.button").data(r.filterVisible(U.buttons));
            G.enter().append("g").classed("button", !0), G.exit().remove(), G.each(function(K) {
              var te = n.select(this), V = x(q, K);
              K._isActive = u(q, K, V), te.call(d, U, K), te.call(_, U, K, I), te.on("click", function() {
                I._dragged || e.call("_guiRelayout", I, V);
              }), te.on("mouseover", function() {
                K._isHovered = !0, te.call(d, U, K);
              }), te.on("mouseout", function() {
                K._isHovered = !1, te.call(d, U, K);
              });
            }), R(I, G, U, q._name, z);
          });
        };
        function h(I) {
          for (var P = t.list(I, "x", !0), M = [], B = 0; B < P.length; B++) {
            var z = P[B];
            z.rangeselector && z.rangeselector.visible && M.push(z);
          }
          return M;
        }
        function m(I) {
          return I._id;
        }
        function u(I, P, M) {
          if (P.step === "all") return I.autorange === !0;
          var B = Object.keys(M);
          return I.range[0] === M[B[0]] && I.range[1] === M[B[1]];
        }
        function d(I, P, M) {
          var B = r.ensureSingle(I, "rect", "selector-rect", function(z) {
            z.attr("shape-rendering", "crispEdges");
          });
          B.attr({ rx: g.rx, ry: g.ry }), B.call(i.stroke, P.bordercolor).call(i.fill, y(P, M)).style("stroke-width", P.borderwidth + "px");
        }
        function y(I, P) {
          return P._isActive || P._isHovered ? I.activecolor : I.bgcolor;
        }
        function _(I, P, M, B) {
          function z(U) {
            c.convertToTspans(U, B);
          }
          var q = r.ensureSingle(I, "text", "selector-text", function(U) {
            U.attr("text-anchor", "middle");
          });
          q.call(o.font, P.font).text(T(M, B._fullLayout._meta)).call(z);
        }
        function T(I, P) {
          return I.label ? P ? r.templateString(I.label, P) : I.label : I.step === "all" ? "all" : I.count + I.step.charAt(0);
        }
        function R(I, P, M, B, z) {
          var q = 0, U = 0, G = M.borderwidth;
          P.each(function() {
            var C = n.select(this), j = C.select(".selector-text"), J = M.font.size * l, ne = Math.max(J * c.lineCount(j), 16) + 3;
            U = Math.max(U, ne);
          }), P.each(function() {
            var C = n.select(this), j = C.select(".selector-rect"), J = C.select(".selector-text"), ne = J.node() && o.bBox(J.node()).width, ae = M.font.size * l, se = c.lineCount(J), O = Math.max(ne + 10, g.minButtonWidth);
            C.attr("transform", s(G + q, G)), j.attr({ x: 0, y: 0, width: O, height: U }), c.positionText(J, O / 2, U / 2 - (se - 1) * ae / 2 + 3), q += O + 5;
          });
          var K = I._fullLayout._size, te = K.l + K.w * M.x, V = K.t + K.h * (1 - M.y), Z = "left";
          r.isRightAnchor(M) && (te -= q, Z = "right"), r.isCenterAnchor(M) && (te -= q / 2, Z = "center");
          var Y = "top";
          r.isBottomAnchor(M) && (V -= U, Y = "bottom"), r.isMiddleAnchor(M) && (V -= U / 2, Y = "middle"), q = Math.ceil(q), U = Math.ceil(U), te = Math.round(te), V = Math.round(V), a.autoMargin(I, B + "-range-selector", { x: M.x, y: M.y, l: q * f[Z], r: q * v[Z], b: U * v[Y], t: U * f[Y] }), z.attr("transform", s(te, V));
        }
      }), t0 = xe((L, k) => {
        k.exports = { moduleType: "component", name: "rangeselector", schema: { subplots: { xaxis: { rangeselector: Zo() } } }, layoutAttributes: Zo(), handleDefaults: Kp(), draw: e0() };
      }), oi = xe((L) => {
        var k = Br().extendFlat;
        L.attributes = function(n, e) {
          n = n || {}, e = e || {};
          var a = { valType: "info_array", editType: n.editType, items: [{ valType: "number", min: 0, max: 1, editType: n.editType }, { valType: "number", min: 0, max: 1, editType: n.editType }], dflt: [0, 1] };
          n.name && n.name + "", n.trace, e.description && "" + e.description;
          var i = { x: k({}, a, {}), y: k({}, a, {}), editType: n.editType };
          return n.noGridCell || (i.row = { valType: "integer", min: 0, dflt: 0, editType: n.editType }, i.column = { valType: "integer", min: 0, dflt: 0, editType: n.editType }), i;
        }, L.defaults = function(n, e, a, i) {
          var o = i && i.x || [0, 1], r = i && i.y || [0, 1], s = e.grid;
          if (s) {
            var c = a("domain.column");
            c !== void 0 && (c < s.columns ? o = s._domains.x[c] : delete n.domain.column);
            var t = a("domain.row");
            t !== void 0 && (t < s.rows ? r = s._domains.y[t] : delete n.domain.row);
          }
          var p = a("domain.x", o), l = a("domain.y", r);
          p[0] < p[1] || (n.domain.x = o.slice()), l[0] < l[1] || (n.domain.y = r.slice());
        };
      }), r0 = xe((L, k) => {
        var n = wt(), e = $a().counter, a = oi().attributes, i = mn().idRegex, o = qr(), r = { rows: { valType: "integer", min: 1, editType: "plot" }, roworder: { valType: "enumerated", values: ["top to bottom", "bottom to top"], dflt: "top to bottom", editType: "plot" }, columns: { valType: "integer", min: 1, editType: "plot" }, subplots: { valType: "info_array", freeLength: !0, dimensions: 2, items: { valType: "enumerated", values: [e("xy").toString(), ""], editType: "plot" }, editType: "plot" }, xaxes: { valType: "info_array", freeLength: !0, items: { valType: "enumerated", values: [i.x.toString(), ""], editType: "plot" }, editType: "plot" }, yaxes: { valType: "info_array", freeLength: !0, items: { valType: "enumerated", values: [i.y.toString(), ""], editType: "plot" }, editType: "plot" }, pattern: { valType: "enumerated", values: ["independent", "coupled"], dflt: "coupled", editType: "plot" }, xgap: { valType: "number", min: 0, max: 1, editType: "plot" }, ygap: { valType: "number", min: 0, max: 1, editType: "plot" }, domain: a({ name: "grid", editType: "plot", noGridCell: !0 }, {}), xside: { valType: "enumerated", values: ["bottom", "bottom plot", "top plot", "top"], dflt: "bottom plot", editType: "plot" }, yside: { valType: "enumerated", values: ["left", "left plot", "right plot", "right"], dflt: "left plot", editType: "plot" }, editType: "plot" };
        function s(f, v, g) {
          var x = v[g + "axes"], h = Object.keys((f._splomAxes || {})[g] || {});
          if (Array.isArray(x)) return x;
          if (h.length) return h;
        }
        function c(f, v) {
          var g = f.grid || {}, x = s(v, g, "x"), h = s(v, g, "y");
          if (!f.grid && !x && !h) return;
          var m = Array.isArray(g.subplots) && Array.isArray(g.subplots[0]), u = Array.isArray(x), d = Array.isArray(h), y = u && x !== g.xaxes && d && h !== g.yaxes, _, T;
          m ? (_ = g.subplots.length, T = g.subplots[0].length) : (d && (_ = h.length), u && (T = x.length));
          var R = o.newContainer(v, "grid");
          function I(V, Z) {
            return n.coerce(g, R, r, V, Z);
          }
          var P = I("rows", _), M = I("columns", T);
          if (!(P * M > 1)) {
            delete v.grid;
            return;
          }
          if (!m && !u && !d) {
            var B = I("pattern") === "independent";
            B && (m = !0);
          }
          R._hasSubplotGrid = m;
          var z = I("roworder"), q = z === "top to bottom", U = m ? 0.2 : 0.1, G = m ? 0.3 : 0.1, K, te;
          y && v._splomGridDflt && (K = v._splomGridDflt.xside, te = v._splomGridDflt.yside), R._domains = { x: t("x", I, U, K, M), y: t("y", I, G, te, P, q) };
        }
        function t(f, v, g, x, h, m) {
          var u = v(f + "gap", g), d = v("domain." + f);
          v(f + "side", x);
          for (var y = new Array(h), _ = d[0], T = (d[1] - _) / (h - u), R = T * (1 - u), I = 0; I < h; I++) {
            var P = _ + T * I;
            y[m ? h - 1 - I : I] = [P, P + R];
          }
          return y;
        }
        function p(f, v) {
          var g = v.grid;
          if (!(!g || !g._domains)) {
            var x = f.grid || {}, h = v._subplots, m = g._hasSubplotGrid, u = g.rows, d = g.columns, y = g.pattern === "independent", _, T, R, I, P, M, B, z = g._axisMap = {};
            if (m) {
              var q = x.subplots || [];
              M = g.subplots = new Array(u);
              var U = 1;
              for (_ = 0; _ < u; _++) {
                var G = M[_] = new Array(d), K = q[_] || [];
                for (T = 0; T < d; T++) if (y ? (P = U === 1 ? "xy" : "x" + U + "y" + U, U++) : P = K[T], G[T] = "", h.cartesian.indexOf(P) !== -1) {
                  if (B = P.indexOf("y"), R = P.slice(0, B), I = P.slice(B), z[R] !== void 0 && z[R] !== T || z[I] !== void 0 && z[I] !== _) continue;
                  G[T] = P, z[R] = T, z[I] = _;
                }
              }
            } else {
              var te = s(v, x, "x"), V = s(v, x, "y");
              g.xaxes = l(te, h.xaxis, d, z, "x"), g.yaxes = l(V, h.yaxis, u, z, "y");
            }
            var Z = g._anchors = {}, Y = g.roworder === "top to bottom";
            for (var C in z) {
              var j = C.charAt(0), J = g[j + "side"], ne, ae, se;
              if (J.length < 8) Z[C] = "free";
              else if (j === "x") {
                if (J.charAt(0) === "t" === Y ? (ne = 0, ae = 1, se = u) : (ne = u - 1, ae = -1, se = -1), m) {
                  var O = z[C];
                  for (_ = ne; _ !== se; _ += ae) if (P = M[_][O], !!P && (B = P.indexOf("y"), P.slice(0, B) === C)) {
                    Z[C] = P.slice(B);
                    break;
                  }
                } else for (_ = ne; _ !== se; _ += ae) if (I = g.yaxes[_], h.cartesian.indexOf(C + I) !== -1) {
                  Z[C] = I;
                  break;
                }
              } else if (J.charAt(0) === "l" ? (ne = 0, ae = 1, se = d) : (ne = d - 1, ae = -1, se = -1), m) {
                var F = z[C];
                for (_ = ne; _ !== se; _ += ae) if (P = M[F][_], !!P && (B = P.indexOf("y"), P.slice(B) === C)) {
                  Z[C] = P.slice(0, B);
                  break;
                }
              } else for (_ = ne; _ !== se; _ += ae) if (R = g.xaxes[_], h.cartesian.indexOf(R + C) !== -1) {
                Z[C] = R;
                break;
              }
            }
          }
        }
        function l(f, v, g, x, h) {
          var m = new Array(g), u;
          function d(y, _) {
            v.indexOf(_) !== -1 && x[_] === void 0 ? (m[y] = _, x[_] = y) : m[y] = "";
          }
          if (Array.isArray(f)) for (u = 0; u < g; u++) d(u, f[u]);
          else for (d(0, h), u = 1; u < g; u++) d(u, h + (u + 1));
          return m;
        }
        k.exports = { moduleType: "component", name: "grid", schema: { layout: { grid: r } }, layoutAttributes: r, sizeDefaults: c, contentDefaults: p };
      }), eu = xe((L, k) => {
        k.exports = { visible: { valType: "boolean", editType: "calc" }, type: { valType: "enumerated", values: ["percent", "constant", "sqrt", "data"], editType: "calc" }, symmetric: { valType: "boolean", editType: "calc" }, array: { valType: "data_array", editType: "calc" }, arrayminus: { valType: "data_array", editType: "calc" }, value: { valType: "number", min: 0, dflt: 10, editType: "calc" }, valueminus: { valType: "number", min: 0, dflt: 10, editType: "calc" }, traceref: { valType: "integer", min: 0, dflt: 0, editType: "style" }, tracerefminus: { valType: "integer", min: 0, dflt: 0, editType: "style" }, copy_ystyle: { valType: "boolean", editType: "plot" }, copy_zstyle: { valType: "boolean", editType: "style" }, color: { valType: "color", editType: "style" }, thickness: { valType: "number", min: 0, dflt: 2, editType: "style" }, width: { valType: "number", min: 0, editType: "plot" }, editType: "calc" };
      }), n0 = xe((L, k) => {
        var n = xr(), e = or(), a = wt(), i = qr(), o = eu();
        k.exports = function(r, s, c, t) {
          var p = "error_" + t.axis, l = i.newContainer(s, p), f = r[p] || {};
          function v(y, _) {
            return a.coerce(f, l, o, y, _);
          }
          var g = f.array !== void 0 || f.value !== void 0 || f.type === "sqrt", x = v("visible", g);
          if (x !== !1) {
            var h = v("type", "array" in f ? "data" : "percent"), m = !0;
            h !== "sqrt" && (m = v("symmetric", !((h === "data" ? "arrayminus" : "valueminus") in f))), h === "data" ? (v("array"), v("traceref"), m || (v("arrayminus"), v("tracerefminus"))) : (h === "percent" || h === "constant") && (v("value"), m || v("valueminus"));
            var u = "copy_" + t.inherit + "style";
            if (t.inherit) {
              var d = s["error_" + t.inherit];
              (d || {}).visible && v(u, !(f.color || n(f.thickness) || n(f.width)));
            }
            (!t.inherit || !l[u]) && (v("color", c), v("thickness"), v("width", e.traceIs(s, "gl3d") ? 0 : 4));
          }
        };
      }), tu = xe((L, k) => {
        k.exports = function(e) {
          var a = e.type, i = e.symmetric;
          if (a === "data") {
            var o = e.array || [];
            if (i) return function(t, p) {
              var l = +o[p];
              return [l, l];
            };
            var r = e.arrayminus || [];
            return function(t, p) {
              var l = +o[p], f = +r[p];
              return !isNaN(l) || !isNaN(f) ? [f || 0, l || 0] : [NaN, NaN];
            };
          } else {
            var s = n(a, e.value), c = n(a, e.valueminus);
            return i || e.valueminus === void 0 ? function(t) {
              var p = s(t);
              return [p, p];
            } : function(t) {
              return [c(t), s(t)];
            };
          }
        };
        function n(e, a) {
          if (e === "percent") return function(i) {
            return Math.abs(i * a / 100);
          };
          if (e === "constant") return function() {
            return Math.abs(a);
          };
          if (e === "sqrt") return function(i) {
            return Math.sqrt(Math.abs(i));
          };
        }
      }), a0 = xe((L, k) => {
        var n = xr(), e = or(), a = Ar(), i = wt(), o = tu();
        k.exports = function(s) {
          for (var c = s.calcdata, t = 0; t < c.length; t++) {
            var p = c[t], l = p[0].trace;
            if (l.visible === !0 && e.traceIs(l, "errorBarsOK")) {
              var f = a.getFromId(s, l.xaxis), v = a.getFromId(s, l.yaxis);
              r(p, l, f, "x"), r(p, l, v, "y");
            }
          }
        };
        function r(s, c, t, p) {
          var l = c["error_" + p] || {}, f = l.visible && ["linear", "log"].indexOf(t.type) !== -1, v = [];
          if (f) {
            for (var g = o(l), x = 0; x < s.length; x++) {
              var h = s[x], m = h.i;
              if (m === void 0) m = x;
              else if (m === null) continue;
              var u = h[p];
              if (n(t.c2l(u))) {
                var d = g(u, m);
                if (n(d[0]) && n(d[1])) {
                  var y = h[p + "s"] = u - d[0], _ = h[p + "h"] = u + d[1];
                  v.push(y, _);
                }
              }
            }
            var T = t._id, R = c._extremes[T], I = a.findExtremes(t, v, i.extendFlat({ tozero: R.opts.tozero }, { padded: !0 }));
            R.min = R.min.concat(I.min), R.max = R.max.concat(I.max);
          }
        }
      }), i0 = xe((L, k) => {
        var n = vr(), e = xr(), a = Or(), i = Fn();
        k.exports = function(r, s, c, t) {
          var p, l = c.xaxis, f = c.yaxis, v = t && t.duration > 0, g = r._context.staticPlot;
          s.each(function(x) {
            var h = x[0].trace, m = h.error_x || {}, u = h.error_y || {}, d;
            h.ids && (d = function(R) {
              return R.id;
            });
            var y = i.hasMarkers(h) && h.marker.maxdisplayed > 0;
            !u.visible && !m.visible && (x = []);
            var _ = n.select(this).selectAll("g.errorbar").data(x, d);
            if (_.exit().remove(), !!x.length) {
              m.visible || _.selectAll("path.xerror").remove(), u.visible || _.selectAll("path.yerror").remove(), _.style("opacity", 1);
              var T = _.enter().append("g").classed("errorbar", !0);
              v && T.style("opacity", 0).transition().duration(t.duration).style("opacity", 1), a.setClipUrl(_, c.layerClipId, r), _.each(function(R) {
                var I = n.select(this), P = o(R, l, f);
                if (!(y && !R.vis)) {
                  var M, B = I.select("path.yerror");
                  if (u.visible && e(P.x) && e(P.yh) && e(P.ys)) {
                    var z = u.width;
                    M = "M" + (P.x - z) + "," + P.yh + "h" + 2 * z + "m-" + z + ",0V" + P.ys, P.noYS || (M += "m-" + z + ",0h" + 2 * z), p = !B.size(), p ? B = I.append("path").style("vector-effect", g ? "none" : "non-scaling-stroke").classed("yerror", !0) : v && (B = B.transition().duration(t.duration).ease(t.easing)), B.attr("d", M);
                  } else B.remove();
                  var q = I.select("path.xerror");
                  if (m.visible && e(P.y) && e(P.xh) && e(P.xs)) {
                    var U = (m.copy_ystyle ? u : m).width;
                    M = "M" + P.xh + "," + (P.y - U) + "v" + 2 * U + "m0,-" + U + "H" + P.xs, P.noXS || (M += "m0,-" + U + "v" + 2 * U), p = !q.size(), p ? q = I.append("path").style("vector-effect", g ? "none" : "non-scaling-stroke").classed("xerror", !0) : v && (q = q.transition().duration(t.duration).ease(t.easing)), q.attr("d", M);
                  } else q.remove();
                }
              });
            }
          });
        };
        function o(r, s, c) {
          var t = { x: s.c2p(r.x), y: c.c2p(r.y) };
          return r.yh !== void 0 && (t.yh = c.c2p(r.yh), t.ys = c.c2p(r.ys), e(t.ys) || (t.noYS = !0, t.ys = c.c2p(r.ys, !0))), r.xh !== void 0 && (t.xh = s.c2p(r.xh), t.xs = s.c2p(r.xs), e(t.xs) || (t.noXS = !0, t.xs = s.c2p(r.xs, !0))), t;
        }
      }), o0 = xe((L, k) => {
        var n = vr(), e = fr();
        k.exports = function(a) {
          a.each(function(i) {
            var o = i[0].trace, r = o.error_y || {}, s = o.error_x || {}, c = n.select(this);
            c.selectAll("path.yerror").style("stroke-width", r.thickness + "px").call(e.stroke, r.color), s.copy_ystyle && (s = r), c.selectAll("path.xerror").style("stroke-width", s.thickness + "px").call(e.stroke, s.color);
          });
        };
      }), l0 = xe((L, k) => {
        var n = wt(), e = ra().overrideAll, a = eu(), i = { error_x: n.extendFlat({}, a), error_y: n.extendFlat({}, a) };
        delete i.error_x.copy_zstyle, delete i.error_y.copy_zstyle, delete i.error_y.copy_ystyle;
        var o = { error_x: n.extendFlat({}, a), error_y: n.extendFlat({}, a), error_z: n.extendFlat({}, a) };
        delete o.error_x.copy_ystyle, delete o.error_y.copy_ystyle, delete o.error_z.copy_ystyle, delete o.error_z.copy_zstyle, k.exports = { moduleType: "component", name: "errorbars", schema: { traces: { scatter: i, bar: i, histogram: i, scatter3d: e(o, "calc", "nested"), scattergl: e(i, "calc", "nested") } }, supplyDefaults: n0(), calc: a0(), makeComputeError: tu(), plot: i0(), style: o0(), hoverInfo: r };
        function r(s, c, t) {
          (c.error_y || {}).visible && (t.yerr = s.yh - s.y, c.error_y.symmetric || (t.yerrneg = s.y - s.ys)), (c.error_x || {}).visible && (t.xerr = s.xh - s.x, c.error_x.symmetric || (t.xerrneg = s.x - s.xs));
        }
      }), s0 = xe((L, k) => {
        k.exports = { cn: { colorbar: "colorbar", cbbg: "cbbg", cbfill: "cbfill", cbfills: "cbfills", cbline: "cbline", cblines: "cblines", cbaxis: "cbaxis", cbtitleunshift: "cbtitleunshift", cbtitle: "cbtitle", cboutline: "cboutline", crisp: "crisp", jsPlaceholder: "js-placeholder" } };
      }), u0 = xe((L, k) => {
        var n = vr(), e = Nn(), a = on(), i = or(), o = Ar(), r = Jn(), s = wt(), c = s.strTranslate, t = Br().extendFlat, p = Aa(), l = Or(), f = fr(), v = ti(), g = xn(), x = Un().flipScale, h = Ys(), m = Gs(), u = Xn(), d = kn(), y = d.LINE_SPACING, _ = d.FROM_TL, T = d.FROM_BR, R = s0().cn;
        function I(U) {
          var G = U._fullLayout, K = G._infolayer.selectAll("g." + R.colorbar).data(P(U), function(te) {
            return te._id;
          });
          K.enter().append("g").attr("class", function(te) {
            return te._id;
          }).classed(R.colorbar, !0), K.each(function(te) {
            var V = n.select(this);
            s.ensureSingle(V, "rect", R.cbbg), s.ensureSingle(V, "g", R.cbfills), s.ensureSingle(V, "g", R.cblines), s.ensureSingle(V, "g", R.cbaxis, function(Y) {
              Y.classed(R.crisp, !0);
            }), s.ensureSingle(V, "g", R.cbtitleunshift, function(Y) {
              Y.append("g").classed(R.cbtitle, !0);
            }), s.ensureSingle(V, "rect", R.cboutline);
            var Z = M(V, te, U);
            Z && Z.then && (U._promises || []).push(Z), U._context.edits.colorbarPosition && B(V, te, U);
          }), K.exit().each(function(te) {
            a.autoMargin(U, te._id);
          }).remove(), K.order();
        }
        function P(U) {
          var G = U._fullLayout, K = U.calcdata, te = [], V, Z, Y, C;
          function j(w) {
            return t(w, { _fillcolor: null, _line: { color: null, width: null, dash: null }, _levels: { start: null, end: null, size: null }, _filllevels: null, _fillgradient: null, _zrange: null });
          }
          function J() {
            typeof C.calc == "function" ? C.calc(U, Y, V) : (V._fillgradient = Z.reversescale ? x(Z.colorscale) : Z.colorscale, V._zrange = [Z[C.min], Z[C.max]]);
          }
          for (var ne = 0; ne < K.length; ne++) {
            var ae = K[ne];
            if (Y = ae[0].trace, !!Y._module) {
              var se = Y._module.colorbar;
              if (Y.visible === !0 && se) for (var O = Array.isArray(se), F = O ? se : [se], S = 0; S < F.length; S++) {
                C = F[S];
                var $ = C.container;
                Z = $ ? Y[$] : Y, Z && Z.showscale && (V = j(Z.colorbar), V._id = "cb" + Y.uid + (O && $ ? "-" + $ : ""), V._traceIndex = Y.index, V._propPrefix = ($ ? $ + "." : "") + "colorbar.", V._meta = Y._meta, J(), te.push(V));
              }
            }
          }
          for (var re in G._colorAxes) if (Z = G[re], Z.showscale) {
            var E = G._colorAxes[re];
            V = j(Z.colorbar), V._id = "cb" + re, V._propPrefix = re + ".colorbar.", V._meta = G._meta, C = { min: "cmin", max: "cmax" }, E[0] !== "heatmap" && (Y = E[1], C.calc = Y._module.colorbar.calc), J(), te.push(V);
          }
          return te;
        }
        function M(U, G, K) {
          var te = G.orientation === "v", V = G.len, Z = G.lenmode, Y = G.thickness, C = G.thicknessmode, j = G.outlinewidth, J = G.borderwidth, ne = G.bgcolor, ae = G.xanchor, se = G.yanchor, O = G.xpad, F = G.ypad, S = G.x, $ = te ? G.y : 1 - G.y, re = G.yref === "paper", E = G.xref === "paper", w = K._fullLayout, N = w._size, W = G._fillcolor, ee = G._line, le = G.title, ie = le.side, pe = G._zrange || n.extent((typeof W == "function" ? W : ee.color).domain()), _e = typeof ee.color == "function" ? ee.color : function() {
            return ee.color;
          }, Ae = typeof W == "function" ? W : function() {
            return W;
          }, Ce = G._levels, Ue = z(K, G, pe), Ne = Ue.fill, ke = Ue.line, A = Math.round(Y * (C === "fraction" ? te ? N.w : N.h : 1)), X = A / (te ? N.w : N.h), H = Math.round(V * (Z === "fraction" ? te ? N.h : N.w : 1)), ve = H / (te ? N.h : N.w), be = E ? N.w : K._fullLayout.width, Se = re ? N.h : K._fullLayout.height, De = Math.round(te ? S * be + O : $ * Se + F), He = { center: 0.5, right: 1 }[ae] || 0, Ze = { top: 1, middle: 0.5 }[se] || 0, We = te ? S - He * X : $ - Ze * X, $e = te ? $ - Ze * ve : S - He * ve, it = Math.round(te ? Se * (1 - $e) : be * $e);
          G._lenFrac = ve, G._thickFrac = X, G._uFrac = We, G._vFrac = $e;
          var Ke = G._axis = q(K, G, pe);
          Ke.position = X + (te ? S + O / N.w : $ + F / N.h);
          var ct = ["top", "bottom"].indexOf(ie) !== -1;
          if (te && ct && (Ke.title.side = ie, Ke.titlex = S + O / N.w, Ke.titley = $e + (le.side === "top" ? ve - F / N.h : F / N.h)), !te && !ct && (Ke.title.side = ie, Ke.titley = $ + F / N.h, Ke.titlex = $e + O / N.w), ee.color && G.tickmode === "auto") {
            Ke.tickmode = "linear", Ke.tick0 = Ce.start;
            var gt = Ce.size, ht = s.constrain(H / 50, 4, 15) + 1, _t = (pe[1] - pe[0]) / ((G.nticks || ht) * gt);
            if (_t > 1) {
              var Te = Math.pow(10, Math.floor(Math.log(_t) / Math.LN10));
              gt *= Te * s.roundUp(_t / Te, [2, 5, 10]), (Math.abs(Ce.start) / Ce.size + 1e-6) % 1 < 2e-6 && (Ke.tick0 = 0);
            }
            Ke.dtick = gt;
          }
          Ke.domain = te ? [$e + F / N.h, $e + ve - F / N.h] : [$e + O / N.w, $e + ve - O / N.w], Ke.setScale(), U.attr("transform", c(Math.round(N.l), Math.round(N.t)));
          var Ie = U.select("." + R.cbtitleunshift).attr("transform", c(-Math.round(N.l), -Math.round(N.t))), ce = Ke.ticklabelposition, ge = Ke.title.font.size, ye = U.select("." + R.cbaxis), Me, Oe = 0, je = 0;
          function qe(lt, st) {
            var xt = { propContainer: Ke, propName: G._propPrefix + "title.text", traceIndex: G._traceIndex, _meta: G._meta, placeholder: w._dfltTitle.colorbar, containerGroup: U.select("." + R.cbtitle) }, Et = lt.charAt(0) === "h" ? lt.substr(1) : "h" + lt;
            U.selectAll("." + Et + ",." + Et + "-math-group").remove(), v.draw(K, lt, t(xt, st || {}));
          }
          function Qe() {
            if (te && ct || !te && !ct) {
              var lt, st;
              ie === "top" && (lt = O + N.l + be * S, st = F + N.t + Se * (1 - $e - ve) + 3 + ge * 0.75), ie === "bottom" && (lt = O + N.l + be * S, st = F + N.t + Se * (1 - $e) - 3 - ge * 0.25), ie === "right" && (st = F + N.t + Se * $ + 3 + ge * 0.75, lt = O + N.l + be * $e), qe(Ke._id + "title", { attributes: { x: lt, y: st, "text-anchor": te ? "start" : "middle" } });
            }
          }
          function Xe() {
            if (te && !ct || !te && ct) {
              var lt = Ke.position || 0, st = Ke._offset + Ke._length / 2, xt, Et;
              if (ie === "right") Et = st, xt = N.l + be * lt + 10 + ge * (Ke.showticklabels ? 1 : 0.5);
              else if (xt = st, ie === "bottom" && (Et = N.t + Se * lt + 10 + (ce.indexOf("inside") === -1 ? Ke.tickfont.size : 0) + (Ke.ticks !== "inside" && G.ticklen || 0)), ie === "top") {
                var Bt = le.text.split("<br>").length;
                Et = N.t + Se * lt + 10 - A - y * ge * Bt;
              }
              qe((te ? "h" : "v") + Ke._id + "title", { avoid: { selection: n.select(K).selectAll("g." + Ke._id + "tick"), side: ie, offsetTop: te ? 0 : N.t, offsetLeft: te ? N.l : 0, maxShift: te ? w.width : w.height }, attributes: { x: xt, y: Et, "text-anchor": "middle" }, transform: { rotate: te ? -90 : 0, offset: 0 } });
            }
          }
          function Je() {
            if (!te && !ct || te && ct) {
              var lt = U.select("." + R.cbtitle), st = lt.select("text"), xt = [-j / 2, j / 2], Et = lt.select(".h" + Ke._id + "title-math-group").node(), Bt = 15.6;
              st.node() && (Bt = parseInt(st.node().style.fontSize, 10) * y);
              var qt;
              if (Et ? (qt = l.bBox(Et), je = qt.width, Oe = qt.height, Oe > Bt && (xt[1] -= (Oe - Bt) / 2)) : st.node() && !st.classed(R.jsPlaceholder) && (qt = l.bBox(st.node()), je = qt.width, Oe = qt.height), te) {
                if (Oe) {
                  if (Oe += 5, ie === "top") Ke.domain[1] -= Oe / N.h, xt[1] *= -1;
                  else {
                    Ke.domain[0] += Oe / N.h;
                    var jt = g.lineCount(st);
                    xt[1] += (1 - jt) * Bt;
                  }
                  lt.attr("transform", c(xt[0], xt[1])), Ke.setScale();
                }
              } else je && (ie === "right" && (Ke.domain[0] += (je + ge / 2) / N.w), lt.attr("transform", c(xt[0], xt[1])), Ke.setScale());
            }
            U.selectAll("." + R.cbfills + ",." + R.cblines).attr("transform", te ? c(0, Math.round(N.h * (1 - Ke.domain[1]))) : c(Math.round(N.w * Ke.domain[0]), 0)), ye.attr("transform", te ? c(0, Math.round(-N.t)) : c(Math.round(-N.l), 0));
            var It = U.select("." + R.cbfills).selectAll("rect." + R.cbfill).attr("style", "").data(Ne);
            It.enter().append("rect").classed(R.cbfill, !0).attr("style", ""), It.exit().remove();
            var Tt = pe.map(Ke.c2p).map(Math.round).sort(function(Ct, Ot) {
              return Ct - Ot;
            });
            It.each(function(Ct, Ot) {
              var Wt = [Ot === 0 ? pe[0] : (Ne[Ot] + Ne[Ot - 1]) / 2, Ot === Ne.length - 1 ? pe[1] : (Ne[Ot] + Ne[Ot + 1]) / 2].map(Ke.c2p).map(Math.round);
              te && (Wt[1] = s.constrain(Wt[1] + (Wt[1] > Wt[0]) ? 1 : -1, Tt[0], Tt[1]));
              var rr = n.select(this).attr(te ? "x" : "y", De).attr(te ? "y" : "x", n.min(Wt)).attr(te ? "width" : "height", Math.max(A, 2)).attr(te ? "height" : "width", Math.max(n.max(Wt) - n.min(Wt), 2));
              if (G._fillgradient) l.gradient(rr, K, G._id, te ? "vertical" : "horizontalreversed", G._fillgradient, "fill");
              else {
                var Ut = Ae(Ct).replace("e-", "");
                rr.attr("fill", e(Ut).toHexString());
              }
            });
            var Rt = U.select("." + R.cblines).selectAll("path." + R.cbline).data(ee.color && ee.width ? ke : []);
            Rt.enter().append("path").classed(R.cbline, !0), Rt.exit().remove(), Rt.each(function(Ct) {
              var Ot = De, Wt = Math.round(Ke.c2p(Ct)) + ee.width / 2 % 1;
              n.select(this).attr("d", "M" + (te ? Ot + "," + Wt : Wt + "," + Ot) + (te ? "h" : "v") + A).call(l.lineGroupStyle, ee.width, _e(Ct), ee.dash);
            }), ye.selectAll("g." + Ke._id + "tick,path").remove();
            var Vt = De + A + (j || 0) / 2 - (G.ticks === "outside" ? 1 : 0), Ft = o.calcTicks(Ke), Dt = o.getTickSigns(Ke)[2];
            return o.drawTicks(K, Ke, { vals: Ke.ticks === "inside" ? o.clipEnds(Ke, Ft) : Ft, layer: ye, path: o.makeTickPath(Ke, Vt, Dt), transFn: o.makeTransTickFn(Ke) }), o.drawLabels(K, Ke, { vals: Ft, layer: ye, transFn: o.makeTransTickLabelFn(Ke), labelFns: o.makeLabelFns(Ke, Vt) });
          }
          function ot() {
            var lt, st = A + j / 2;
            ce.indexOf("inside") === -1 && (lt = l.bBox(ye.node()), st += te ? lt.width : lt.height), Me = Ie.select("text");
            var xt = 0, Et = te && ie === "top", Bt = !te && ie === "right", qt = 0;
            if (Me.node() && !Me.classed(R.jsPlaceholder)) {
              var jt, It = Ie.select(".h" + Ke._id + "title-math-group").node();
              It && (te && ct || !te && !ct) ? (lt = l.bBox(It), xt = lt.width, jt = lt.height) : (lt = l.bBox(Ie.node()), xt = lt.right - N.l - (te ? De : it), jt = lt.bottom - N.t - (te ? it : De), !te && ie === "top" && (st += lt.height, qt = lt.height)), Bt && (Me.attr("transform", c(xt / 2 + ge / 2, 0)), xt *= 2), st = Math.max(st, te ? xt : jt);
            }
            var Tt = (te ? O : F) * 2 + st + J + j / 2, Rt = 0;
            !te && le.text && se === "bottom" && $ <= 0 && (Rt = Tt / 2, Tt += Rt, qt += Rt), w._hColorbarMoveTitle = Rt, w._hColorbarMoveCBTitle = qt;
            var Vt = J + j, Ft = (te ? De : it) - Vt / 2 - (te ? O : 0), Dt = (te ? it : De) - (te ? H : F + qt - Rt);
            U.select("." + R.cbbg).attr("x", Ft).attr("y", Dt).attr(te ? "width" : "height", Math.max(Tt - Rt, 2)).attr(te ? "height" : "width", Math.max(H + Vt, 2)).call(f.fill, ne).call(f.stroke, G.bordercolor).style("stroke-width", J);
            var Ct = Bt ? Math.max(xt - 10, 0) : 0;
            U.selectAll("." + R.cboutline).attr("x", (te ? De : it + O) + Ct).attr("y", (te ? it + F - H : De) + (Et ? Oe : 0)).attr(te ? "width" : "height", Math.max(A, 2)).attr(te ? "height" : "width", Math.max(H - (te ? 2 * F + Oe : 2 * O + Ct), 2)).call(f.stroke, G.outlinecolor).style({ fill: "none", "stroke-width": j });
            var Ot = te ? He * Tt : 0, Wt = te ? 0 : (1 - Ze) * Tt - qt;
            if (Ot = E ? N.l - Ot : -Ot, Wt = re ? N.t - Wt : -Wt, U.attr("transform", c(Ot, Wt)), !te && (J || e(ne).getAlpha() && !e.equals(w.paper_bgcolor, ne))) {
              var rr = ye.selectAll("text"), Ut = rr[0].length, Qt = U.select("." + R.cbbg).node(), nr = l.bBox(Qt), cr = l.getTranslate(U), lr = 2;
              rr.each(function(Ye, Ee) {
                var ze = 0, Ge = Ut - 1;
                if (Ee === ze || Ee === Ge) {
                  var Ve = l.bBox(this), tt = l.getTranslate(this), at;
                  if (Ee === Ge) {
                    var vt = Ve.right + tt.x, kt = nr.right + cr.x + it - J - lr + S;
                    at = kt - vt, at > 0 && (at = 0);
                  } else if (Ee === ze) {
                    var At = Ve.left + tt.x, Nt = nr.left + cr.x + it + J + lr;
                    at = Nt - At, at < 0 && (at = 0);
                  }
                  at && (Ut < 3 ? this.setAttribute("transform", "translate(" + at + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                }
              });
            }
            var $t = {}, sr = _[ae], St = T[ae], Kt = _[se], hr = T[se], he = Tt - A;
            te ? (Z === "pixels" ? ($t.y = $, $t.t = H * Kt, $t.b = H * hr) : ($t.t = $t.b = 0, $t.yt = $ + V * Kt, $t.yb = $ - V * hr), C === "pixels" ? ($t.x = S, $t.l = Tt * sr, $t.r = Tt * St) : ($t.l = he * sr, $t.r = he * St, $t.xl = S - Y * sr, $t.xr = S + Y * St)) : (Z === "pixels" ? ($t.x = S, $t.l = H * sr, $t.r = H * St) : ($t.l = $t.r = 0, $t.xl = S + V * sr, $t.xr = S - V * St), C === "pixels" ? ($t.y = 1 - $, $t.t = Tt * Kt, $t.b = Tt * hr) : ($t.t = he * Kt, $t.b = he * hr, $t.yt = $ - Y * Kt, $t.yb = $ + Y * hr));
            var fe = G.y < 0.5 ? "b" : "t", Pe = G.x < 0.5 ? "l" : "r";
            K._fullLayout._reservedMargin[G._id] = {};
            var Re = { r: w.width - Ft - Ot, l: Ft + $t.r, b: w.height - Dt - Wt, t: Dt + $t.b };
            E && re ? a.autoMargin(K, G._id, $t) : E ? K._fullLayout._reservedMargin[G._id][fe] = Re[fe] : re || te ? K._fullLayout._reservedMargin[G._id][Pe] = Re[Pe] : K._fullLayout._reservedMargin[G._id][fe] = Re[fe];
          }
          return s.syncOrAsync([a.previousPromises, Qe, Je, Xe, a.previousPromises, ot], K);
        }
        function B(U, G, K) {
          var te = G.orientation === "v", V = K._fullLayout, Z = V._size, Y, C, j;
          r.init({ element: U.node(), gd: K, prepFn: function() {
            Y = U.attr("transform"), p(U);
          }, moveFn: function(J, ne) {
            U.attr("transform", Y + c(J, ne)), C = r.align((te ? G._uFrac : G._vFrac) + J / Z.w, te ? G._thickFrac : G._lenFrac, 0, 1, G.xanchor), j = r.align((te ? G._vFrac : 1 - G._uFrac) - ne / Z.h, te ? G._lenFrac : G._thickFrac, 0, 1, G.yanchor);
            var ae = r.getCursor(C, j, G.xanchor, G.yanchor);
            p(U, ae);
          }, doneFn: function() {
            if (p(U), C !== void 0 && j !== void 0) {
              var J = {};
              J[G._propPrefix + "x"] = C, J[G._propPrefix + "y"] = j, G._traceIndex !== void 0 ? i.call("_guiRestyle", K, J, G._traceIndex) : i.call("_guiRelayout", K, J);
            }
          } });
        }
        function z(U, G, K) {
          var te = G._levels, V = [], Z = [], Y, C, j = te.end + te.size / 100, J = te.size, ne = 1.001 * K[0] - 1e-3 * K[1], ae = 1.001 * K[1] - 1e-3 * K[0];
          for (C = 0; C < 1e5 && (Y = te.start + C * J, !(J > 0 ? Y >= j : Y <= j)); C++) Y > ne && Y < ae && V.push(Y);
          if (G._fillgradient) Z = [0];
          else if (typeof G._fillcolor == "function") {
            var se = G._filllevels;
            if (se) for (j = se.end + se.size / 100, J = se.size, C = 0; C < 1e5 && (Y = se.start + C * J, !(J > 0 ? Y >= j : Y <= j)); C++) Y > K[0] && Y < K[1] && Z.push(Y);
            else Z = V.map(function(O) {
              return O - te.size / 2;
            }), Z.push(Z[Z.length - 1] + te.size);
          } else G._fillcolor && typeof G._fillcolor == "string" && (Z = [0]);
          return te.size < 0 && (V.reverse(), Z.reverse()), { line: V, fill: Z };
        }
        function q(U, G, K) {
          var te = U._fullLayout, V = G.orientation === "v", Z = { type: "linear", range: K, tickmode: G.tickmode, nticks: G.nticks, tick0: G.tick0, dtick: G.dtick, tickvals: G.tickvals, ticktext: G.ticktext, ticks: G.ticks, ticklen: G.ticklen, tickwidth: G.tickwidth, tickcolor: G.tickcolor, showticklabels: G.showticklabels, labelalias: G.labelalias, ticklabelposition: G.ticklabelposition, ticklabeloverflow: G.ticklabeloverflow, ticklabelstep: G.ticklabelstep, tickfont: G.tickfont, tickangle: G.tickangle, tickformat: G.tickformat, exponentformat: G.exponentformat, minexponent: G.minexponent, separatethousands: G.separatethousands, showexponent: G.showexponent, showtickprefix: G.showtickprefix, tickprefix: G.tickprefix, showticksuffix: G.showticksuffix, ticksuffix: G.ticksuffix, title: G.title, showline: !0, anchor: "free", side: V ? "right" : "bottom", position: 1 }, Y = V ? "y" : "x", C = { type: "linear", _id: Y + G._id }, j = { letter: Y, font: te.font, noAutotickangles: Y === "y", noHover: !0, noTickson: !0, noTicklabelmode: !0, noInsideRange: !0, calendar: te.calendar };
          function J(ne, ae) {
            return s.coerce(Z, C, u, ne, ae);
          }
          return h(Z, C, J, j, te), m(Z, C, J, j), C;
        }
        k.exports = { draw: I };
      }), c0 = xe((L, k) => {
        k.exports = { moduleType: "component", name: "colorbar", attributes: yo(), supplyDefaults: os(), draw: u0().draw, hasColorbar: ns() };
      }), f0 = xe((L, k) => {
        k.exports = { moduleType: "component", name: "legend", layoutAttributes: cs(), supplyLayoutDefaults: fs(), draw: hs(), style: ps() };
      }), d0 = xe((L, k) => {
        k.exports = { moduleType: "locale", name: "en", dictionary: { "Click to enter Colorscale title": "Click to enter Colourscale title" }, format: { days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], periods: ["AM", "PM"], dateTime: "%a %b %e %X %Y", date: "%d/%m/%Y", time: "%H:%M:%S", decimal: ".", thousands: ",", grouping: [3], currency: ["$", ""], year: "%Y", month: "%b %Y", dayMonth: "%b %-d", dayMonthYear: "%b %-d, %Y" } };
      }), p0 = xe((L, k) => {
        k.exports = { moduleType: "locale", name: "en-US", dictionary: { "Click to enter Colorscale title": "Click to enter Colorscale title" }, format: { date: "%m/%d/%Y" } };
      }), ru = xe((L, k) => {
        var n = or(), e = wt(), a = e.extendFlat, i = e.extendDeep;
        function o(s) {
          var c;
          switch (s) {
            case "themes__thumb":
              c = { autosize: !0, width: 150, height: 150, title: { text: "" }, showlegend: !1, margin: { l: 5, r: 5, t: 5, b: 5, pad: 0 }, annotations: [] };
              break;
            case "thumbnail":
              c = { title: { text: "" }, hidesources: !0, showlegend: !1, borderwidth: 0, bordercolor: "", margin: { l: 1, r: 1, t: 1, b: 1, pad: 0 }, annotations: [] };
              break;
            default:
              c = {};
          }
          return c;
        }
        function r(s) {
          var c = ["xaxis", "yaxis", "zaxis"];
          return c.indexOf(s.slice(0, 5)) > -1;
        }
        k.exports = function(s, c) {
          var t, p = s.data, l = s.layout, f = i([], p), v = i({}, l, o(c.tileClass)), g = s._context || {};
          if (c.width && (v.width = c.width), c.height && (v.height = c.height), c.tileClass === "thumbnail" || c.tileClass === "themes__thumb") {
            v.annotations = [];
            var x = Object.keys(v);
            for (t = 0; t < x.length; t++) r(x[t]) && (v[x[t]].title = { text: "" });
            for (t = 0; t < f.length; t++) {
              var h = f[t];
              h.showscale = !1, h.marker && (h.marker.showscale = !1), n.traceIs(h, "pie-like") && (h.textposition = "none");
            }
          }
          if (Array.isArray(c.annotations)) for (t = 0; t < c.annotations.length; t++) v.annotations.push(c.annotations[t]);
          var m = Object.keys(v).filter(function(T) {
            return T.match(/^scene\d*$/);
          });
          if (m.length) {
            var u = {};
            for (c.tileClass === "thumbnail" && (u = { title: { text: "" }, showaxeslabels: !1, showticklabels: !1, linetickenable: !1 }), t = 0; t < m.length; t++) {
              var d = v[m[t]];
              d.xaxis || (d.xaxis = {}), d.yaxis || (d.yaxis = {}), d.zaxis || (d.zaxis = {}), a(d.xaxis, u), a(d.yaxis, u), a(d.zaxis, u), d._scene = null;
            }
          }
          var y = document.createElement("div");
          c.tileClass && (y.className = c.tileClass);
          var _ = { gd: y, td: y, layout: v, data: f, config: { staticPlot: c.staticPlot === void 0 ? !0 : c.staticPlot, plotGlPixelRatio: c.plotGlPixelRatio === void 0 ? 2 : c.plotGlPixelRatio, displaylogo: c.displaylogo || !1, showLink: c.showLink || !1, showTips: c.showTips || !1, mapboxAccessToken: g.mapboxAccessToken } };
          return c.setBackground !== "transparent" && (_.config.setBackground = c.setBackground || "opaque"), _.gd.defaultLayout = o(c.tileClass), _;
        };
      }), h0 = xe((L, k) => {
        var n = Ra().EventEmitter, e = or(), a = wt(), i = ya(), o = ru(), r = Ro(), s = No();
        function c(t, p) {
          var l = new n(), f = o(t, { format: "png" }), v = f.gd;
          v.style.position = "absolute", v.style.left = "-5000px", document.body.appendChild(v);
          function g() {
            var h = i.getDelay(v._fullLayout);
            setTimeout(function() {
              var m = r(v), u = document.createElement("canvas");
              u.id = a.randstr(), l = s({ format: p.format, width: v._fullLayout.width, height: v._fullLayout.height, canvas: u, emitter: l, svg: m }), l.clean = function() {
                v && document.body.removeChild(v);
              };
            }, h);
          }
          var x = i.getRedrawFunc(v);
          return e.call("_doPlot", v, f.data, f.layout, f.config).then(x).then(g).catch(function(h) {
            l.emit("error", h);
          }), l;
        }
        k.exports = c;
      }), v0 = xe((L, k) => {
        var n = ya(), e = { getDelay: n.getDelay, getRedrawFunc: n.getRedrawFunc, clone: ru(), toSVG: Ro(), svgToImg: No(), toImage: h0(), downloadImage: Es() };
        k.exports = e;
      }), g0 = xe((L) => {
        L.version = ao().version, xf(), gd();
        var k = or(), n = L.register = k.register, e = op(), a = Object.keys(e);
        for (o = 0; o < a.length; o++) i = a[o], i.charAt(0) !== "_" && (L[i] = e[i]), n({ moduleType: "apiMethod", name: i, fn: e[i] });
        var i, o;
        n(bp()), n([Ap(), Ep(), pa(), zp(), Bp(), Up(), Gp(), $p(), t0(), r0(), l0(), fa(), c0(), f0(), Bn(), ws()]), n([d0(), p0()]), window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (n(window.PlotlyLocales), delete window.PlotlyLocales), L.Icons = Lo();
        var r = Bn(), s = on();
        L.Plots = { resize: s.resize, graphJson: s.graphJson, sendDataToCloud: s.sendDataToCloud }, L.Fx = { hover: r.hover, unhover: r.unhover, loneHover: r.loneHover, loneUnhover: r.loneUnhover }, L.Snapshot = v0(), L.PlotSchema = Qa();
      }), y0 = xe((L, k) => {
        k.exports = g0();
      }), Wo = xe((L, k) => {
        k.exports = { TEXTPAD: 3, eventDataKeys: ["value", "label"] };
      }), ja = xe((L, k) => {
        var n = $n(), e = na().axisHoverFormat, { hovertemplateAttrs: a, texttemplateAttrs: i, templatefallbackAttrs: o } = qn(), r = ca(), s = hn(), c = Wo(), t = Wn().pattern, p = Br().extendFlat, l = s({ editType: "calc", arrayOk: !0, colorEditType: "style" }), f = n.marker, v = f.line, g = p({}, v.width, { dflt: 0 }), x = p({ width: g, editType: "calc" }, r("marker.line")), h = p({ line: x, editType: "calc" }, r("marker"), { opacity: { valType: "number", arrayOk: !0, dflt: 1, min: 0, max: 1, editType: "style" }, pattern: t, cornerradius: { valType: "any", editType: "calc" } });
        k.exports = { x: n.x, x0: n.x0, dx: n.dx, y: n.y, y0: n.y0, dy: n.dy, xperiod: n.xperiod, yperiod: n.yperiod, xperiod0: n.xperiod0, yperiod0: n.yperiod0, xperiodalignment: n.xperiodalignment, yperiodalignment: n.yperiodalignment, xhoverformat: e("x"), yhoverformat: e("y"), text: n.text, texttemplate: i({ editType: "plot" }, { keys: c.eventDataKeys }), texttemplatefallback: o({ editType: "plot" }), hovertext: n.hovertext, hovertemplate: a({}, { keys: c.eventDataKeys }), hovertemplatefallback: o(), textposition: { valType: "enumerated", values: ["inside", "outside", "auto", "none"], dflt: "auto", arrayOk: !0, editType: "calc" }, insidetextanchor: { valType: "enumerated", values: ["end", "middle", "start"], dflt: "end", editType: "plot" }, textangle: { valType: "angle", dflt: "auto", editType: "plot" }, textfont: p({}, l, {}), insidetextfont: p({}, l, {}), outsidetextfont: p({}, l, {}), constraintext: { valType: "enumerated", values: ["inside", "outside", "both", "none"], dflt: "both", editType: "calc" }, cliponaxis: p({}, n.cliponaxis, {}), orientation: { valType: "enumerated", values: ["v", "h"], editType: "calc+clearAxisTypes" }, base: { valType: "any", dflt: null, arrayOk: !0, editType: "calc" }, offset: { valType: "number", dflt: null, arrayOk: !0, editType: "calc" }, width: { valType: "number", dflt: null, min: 0, arrayOk: !0, editType: "calc" }, marker: h, offsetgroup: n.offsetgroup, alignmentgroup: n.alignmentgroup, selected: { marker: { opacity: n.selected.marker.opacity, color: n.selected.marker.color, editType: "style" }, textfont: n.selected.textfont, editType: "style" }, unselected: { marker: { opacity: n.unselected.marker.opacity, color: n.unselected.marker.color, editType: "style" }, textfont: n.unselected.textfont, editType: "style" }, zorder: n.zorder };
      }), Xo = xe((L, k) => {
        k.exports = { barmode: { valType: "enumerated", values: ["stack", "group", "overlay", "relative"], dflt: "group", editType: "calc" }, barnorm: { valType: "enumerated", values: ["", "fraction", "percent"], dflt: "", editType: "calc" }, bargap: { valType: "number", min: 0, max: 1, editType: "calc" }, bargroupgap: { valType: "number", min: 0, max: 1, dflt: 0, editType: "calc" }, barcornerradius: { valType: "any", editType: "calc" } };
      }), nu = xe((L, k) => {
        var n = fr(), e = Un().hasColorscale, a = ga(), i = wt().coercePattern;
        k.exports = function(o, r, s, c, t) {
          var p = s("marker.color", c), l = e(o, "marker");
          l && a(o, r, t, s, { prefix: "marker.", cLetter: "c" }), s("marker.line.color", n.defaultLine), e(o, "marker.line") && a(o, r, t, s, { prefix: "marker.line.", cLetter: "c" }), s("marker.line.width"), s("marker.opacity"), i(s, "marker.pattern", p, l), s("selected.marker.color"), s("unselected.marker.color");
        };
      }), Ha = xe((L, k) => {
        var n = xr(), e = wt(), a = fr(), i = or(), o = Ds(), r = ai(), s = nu(), c = Oi(), t = ja(), p = e.coerceFont;
        function l(x, h, m, u) {
          function d(I, P) {
            return e.coerce(x, h, t, I, P);
          }
          var y = o(x, h, u, d);
          if (!y) {
            h.visible = !1;
            return;
          }
          r(x, h, u, d), d("xhoverformat"), d("yhoverformat"), d("zorder"), d("orientation", h.x && !h.y ? "h" : "v"), d("base"), d("offset"), d("width"), d("text"), d("hovertext"), d("hovertemplate"), d("hovertemplatefallback");
          var _ = d("textposition");
          g(x, h, u, d, _, { moduleHasSelected: !0, moduleHasUnselected: !0, moduleHasConstrain: !0, moduleHasCliponaxis: !0, moduleHasTextangle: !0, moduleHasInsideanchor: !0 }), s(x, h, d, m, u);
          var T = (h.marker.line || {}).color, R = i.getComponentMethod("errorbars", "supplyDefaults");
          R(x, h, T || a.defaultLine, { axis: "y" }), R(x, h, T || a.defaultLine, { axis: "x", inherit: "y" }), e.coerceSelectionMarkerOpacity(h, d);
        }
        function f(x, h) {
          var m, u;
          function d(T, R) {
            return e.coerce(u._input, u, t, T, R);
          }
          for (var y = 0; y < x.length; y++) if (u = x[y], u.type === "bar") {
            m = u._input;
            var _ = d("marker.cornerradius", h.barcornerradius);
            u.marker && (u.marker.cornerradius = v(_)), c(m, u, h, d, h.barmode);
          }
        }
        function v(x) {
          if (n(x)) {
            if (x = +x, x >= 0) return x;
          } else if (typeof x == "string" && (x = x.trim(), x.slice(-1) === "%" && n(x.slice(0, -1)) && (x = +x.slice(0, -1), x >= 0))) return x + "%";
        }
        function g(x, h, m, u, d, y) {
          y = y || {};
          var _ = y.moduleHasSelected !== !1, T = y.moduleHasUnselected !== !1, R = y.moduleHasConstrain !== !1, I = y.moduleHasCliponaxis !== !1, P = y.moduleHasTextangle !== !1, M = y.moduleHasInsideanchor !== !1, B = !!y.hasPathbar, z = Array.isArray(d) || d === "auto", q = z || d === "inside", U = z || d === "outside";
          if (q || U) {
            var G = p(u, "textfont", m.font), K = e.extendFlat({}, G), te = x.textfont && x.textfont.color, V = !te;
            if (V && delete K.color, p(u, "insidetextfont", K), B) {
              var Z = e.extendFlat({}, G);
              V && delete Z.color, p(u, "pathbar.textfont", Z);
            }
            U && p(u, "outsidetextfont", G), _ && u("selected.textfont.color"), T && u("unselected.textfont.color"), R && u("constraintext"), I && u("cliponaxis"), P && u("textangle"), u("texttemplate"), u("texttemplatefallback");
          }
          q && M && u("insidetextanchor");
        }
        k.exports = { supplyDefaults: l, crossTraceDefaults: f, handleText: g, validateCornerradius: v };
      }), au = xe((L, k) => {
        var n = or(), e = Ar(), a = wt(), i = Xo(), o = Ha().validateCornerradius;
        k.exports = function(r, s, c) {
          function t(_, T) {
            return a.coerce(r, s, i, _, T);
          }
          for (var p = !1, l = !1, f = !1, v = {}, g = t("barmode"), x = g === "group", h = 0; h < c.length; h++) {
            var m = c[h];
            if (n.traceIs(m, "bar") && m.visible) p = !0;
            else continue;
            var u = m.xaxis + m.yaxis;
            if (x ? (v[u] && (f = !0), v[u] = !0) : (u += m._input.offsetgroup, v.length > 0 && !v[u] && (f = !0), v[u] = !0), m.visible && m.type === "histogram") {
              var d = e.getFromId({ _fullLayout: s }, m[m.orientation === "v" ? "xaxis" : "yaxis"]);
              d.type !== "category" && (l = !0);
            }
          }
          if (!p) {
            delete s.barmode;
            return;
          }
          g !== "overlay" && t("barnorm"), t("bargap", l && !f ? 0 : 0.2), t("bargroupgap");
          var y = t("barcornerradius");
          s.barcornerradius = o(y);
        };
      }), Jo = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a) {
          for (var i = 0; i < e.length; i++) e[i].i = i;
          n.mergeArray(a.text, e, "tx"), n.mergeArray(a.hovertext, e, "htx");
          var o = a.marker;
          if (o) {
            n.mergeArray(o.opacity, e, "mo", !0), n.mergeArray(o.color, e, "mc");
            var r = o.line;
            r && (n.mergeArray(r.color, e, "mlc"), n.mergeArrayCastPositive(r.width, e, "mlw"));
          }
        };
      }), m0 = xe((L, k) => {
        var n = Ar(), e = ii(), a = Un().hasColorscale, i = ei(), o = Jo(), r = Bo();
        k.exports = function(s, c) {
          var t = n.getFromId(s, c.xaxis || "x"), p = n.getFromId(s, c.yaxis || "y"), l, f, v, g, x, h, m = { msUTC: !!(c.base || c.base === 0) };
          c.orientation === "h" ? (l = t.makeCalcdata(c, "x", m), v = p.makeCalcdata(c, "y"), g = e(c, p, "y", v), x = !!c.yperiodalignment, h = "y") : (l = p.makeCalcdata(c, "y", m), v = t.makeCalcdata(c, "x"), g = e(c, t, "x", v), x = !!c.xperiodalignment, h = "x"), f = g.vals;
          for (var u = Math.min(f.length, l.length), d = new Array(u), y = 0; y < u; y++) d[y] = { p: f[y], s: l[y] }, x && (d[y].orig_p = v[y], d[y][h + "End"] = g.ends[y], d[y][h + "Start"] = g.starts[y]), c.ids && (d[y].id = String(c.ids[y]));
          return a(c, "marker") && i(s, c, { vals: c.marker.color, containerStr: "marker", cLetter: "c" }), a(c, "marker.line") && i(s, c, { vals: c.marker.line.color, containerStr: "marker.line", cLetter: "c" }), o(d, c), r(d, c), d;
        };
      }), Di = xe((L, k) => {
        var n = vr(), e = wt();
        function a(s, c, t) {
          var p = s._fullLayout, l = p["_" + t + "Text_minsize"];
          if (l) {
            var f = p.uniformtext.mode === "hide", v;
            switch (t) {
              case "funnelarea":
              case "pie":
              case "sunburst":
                v = "g.slice";
                break;
              case "treemap":
              case "icicle":
                v = "g.slice, g.pathbar";
                break;
              default:
                v = "g.points > g.point";
            }
            c.selectAll(v).each(function(g) {
              var x = g.transform;
              if (x) {
                x.scale = f && x.hide ? 0 : l / x.fontSize;
                var h = n.select(this).select("text");
                e.setTransormAndDisplay(h, x);
              }
            });
          }
        }
        function i(s, c, t) {
          if (t.uniformtext.mode) {
            var p = r(s), l = t.uniformtext.minsize, f = c.scale * c.fontSize;
            c.hide = f < l, t[p] = t[p] || 1 / 0, c.hide || (t[p] = Math.min(t[p], Math.max(f, l)));
          }
        }
        function o(s, c) {
          var t = r(s);
          c[t] = void 0;
        }
        function r(s) {
          return "_" + s + "Text_minsize";
        }
        k.exports = { recordMinTextSize: i, clearMinTextSize: o, resizeText: a };
      }), $o = xe((L) => {
        var k = xr(), n = Nn(), e = wt().isArrayOrTypedArray;
        L.coerceString = function(a, i, o) {
          if (typeof i == "string") {
            if (i || !a.noBlank) return i;
          } else if ((typeof i == "number" || i === !0) && !a.strict) return String(i);
          return o !== void 0 ? o : a.dflt;
        }, L.coerceNumber = function(a, i, o) {
          if (k(i)) {
            i = +i;
            var r = a.min, s = a.max, c = r !== void 0 && i < r || s !== void 0 && i > s;
            if (!c) return i;
          }
          return o !== void 0 ? o : a.dflt;
        }, L.coerceColor = function(a, i, o) {
          return n(i).isValid() ? i : o !== void 0 ? o : a.dflt;
        }, L.coerceEnumerated = function(a, i, o) {
          return a.coerceNumber && (i = +i), a.values.indexOf(i) !== -1 ? i : o !== void 0 ? o : a.dflt;
        }, L.getValue = function(a, i) {
          var o;
          return e(a) ? i < a.length && (o = a[i]) : o = a, o;
        }, L.getLineWidth = function(a, i) {
          var o = 0 < i.mlw ? i.mlw : e(a.marker.line.width) ? 0 : a.marker.line.width;
          return o;
        };
      }), li = xe((L, k) => {
        var n = vr(), e = fr(), a = Or(), i = wt(), o = or(), r = Di().resizeText, s = ja(), c = s.textfont, t = s.insidetextfont, p = s.outsidetextfont, l = $o();
        function f(I) {
          var P = n.select(I).selectAll('g[class^="barlayer"]').selectAll("g.trace");
          r(I, P, "bar");
          var M = P.size(), B = I._fullLayout;
          P.style("opacity", function(z) {
            return z[0].trace.opacity;
          }).each(function(z) {
            (B.barmode === "stack" && M > 1 || B.bargap === 0 && B.bargroupgap === 0 && !z[0].trace.marker.line.width) && n.select(this).attr("shape-rendering", "crispEdges");
          }), P.selectAll("g.points").each(function(z) {
            var q = n.select(this), U = z[0].trace;
            v(q, U, I);
          }), o.getComponentMethod("errorbars", "style")(P);
        }
        function v(I, P, M) {
          a.pointStyle(I.selectAll("path"), P, M), g(I, P, M);
        }
        function g(I, P, M) {
          I.selectAll("text").each(function(B) {
            var z = n.select(this), q = i.ensureUniformFontSize(M, u(z, B, P, M));
            a.font(z, q);
          });
        }
        function x(I, P, M) {
          var B = P[0].trace;
          B.selectedpoints ? h(M, B, I) : (v(M, B, I), o.getComponentMethod("errorbars", "style")(M));
        }
        function h(I, P, M) {
          a.selectedPointStyle(I.selectAll("path"), P), m(I.selectAll("text"), P, M);
        }
        function m(I, P, M) {
          I.each(function(B) {
            var z = n.select(this), q;
            if (B.selected) {
              q = i.ensureUniformFontSize(M, u(z, B, P, M));
              var U = P.selected.textfont && P.selected.textfont.color;
              U && (q.color = U), a.font(z, q);
            } else a.selectedTextStyle(z, P);
          });
        }
        function u(I, P, M, B) {
          var z = B._fullLayout.font, q = M.textfont;
          if (I.classed("bartext-inside")) {
            var U = R(P, M);
            q = y(M, P.i, z, U);
          } else I.classed("bartext-outside") && (q = _(M, P.i, z));
          return q;
        }
        function d(I, P, M) {
          return T(c, I.textfont, P, M);
        }
        function y(I, P, M, B) {
          var z = d(I, P, M), q = I._input.textfont === void 0 || I._input.textfont.color === void 0 || Array.isArray(I.textfont.color) && I.textfont.color[P] === void 0;
          return q && (z = { color: e.contrast(B), family: z.family, size: z.size, weight: z.weight, style: z.style, variant: z.variant, textcase: z.textcase, lineposition: z.lineposition, shadow: z.shadow }), T(t, I.insidetextfont, P, z);
        }
        function _(I, P, M) {
          var B = d(I, P, M);
          return T(p, I.outsidetextfont, P, B);
        }
        function T(I, P, M, B) {
          P = P || {};
          var z = l.getValue(P.family, M), q = l.getValue(P.size, M), U = l.getValue(P.color, M), G = l.getValue(P.weight, M), K = l.getValue(P.style, M), te = l.getValue(P.variant, M), V = l.getValue(P.textcase, M), Z = l.getValue(P.lineposition, M), Y = l.getValue(P.shadow, M);
          return { family: l.coerceString(I.family, z, B.family), size: l.coerceNumber(I.size, q, B.size), color: l.coerceColor(I.color, U, B.color), weight: l.coerceString(I.weight, G, B.weight), style: l.coerceString(I.style, K, B.style), variant: l.coerceString(I.variant, te, B.variant), textcase: l.coerceString(I.variant, V, B.textcase), lineposition: l.coerceString(I.variant, Z, B.lineposition), shadow: l.coerceString(I.variant, Y, B.shadow) };
        }
        function R(I, P) {
          return P.type === "waterfall" ? P[I.dir].marker.color : I.mcc || I.mc || P.marker.color;
        }
        k.exports = { style: f, styleTextPoints: g, styleOnSelect: x, getInsideTextFont: y, getOutsideTextFont: _, getBarColor: R, resizeText: r };
      }), iu = xe((L, k) => {
        var n = vr(), e = xr(), a = wt(), i = xn(), o = fr(), r = Or(), s = or(), c = Ar().tickText, t = Di(), p = t.recordMinTextSize, l = t.clearMinTextSize, f = li(), v = $o(), g = Wo(), x = ja(), h = x.text, m = x.textposition, u = da().appendArrayPointValue, d = g.TEXTPAD;
        function y(J) {
          return J.id;
        }
        function _(J) {
          if (J.ids) return y;
        }
        function T(J) {
          return (J > 0) - (J < 0);
        }
        function R(J, ne) {
          return J < ne ? 1 : -1;
        }
        function I(J, ne, ae, se) {
          var O = [], F = [], S = se ? ne : ae, $ = se ? ae : ne;
          return O[0] = S.c2p(J.s0, !0), F[0] = $.c2p(J.p0, !0), O[1] = S.c2p(J.s1, !0), F[1] = $.c2p(J.p1, !0), se ? [O, F] : [F, O];
        }
        function P(J, ne, ae, se) {
          if (!ne.uniformtext.mode && M(ae)) {
            var O;
            return se && (O = se()), J.transition().duration(ae.duration).ease(ae.easing).each("end", function() {
              O && O();
            }).each("interrupt", function() {
              O && O();
            });
          } else return J;
        }
        function M(J) {
          return J && J.duration > 0;
        }
        function B(J, ne, ae, se, O, F) {
          var S = ne.xaxis, $ = ne.yaxis, re = J._fullLayout, E = J._context.staticPlot;
          O || (O = { mode: re.barmode, norm: re.barmode, gap: re.bargap, groupgap: re.bargroupgap }, l("bar", re));
          var w = a.makeTraceGroups(se, ae, "trace bars").each(function(N) {
            var W = n.select(this), ee = N[0].trace, le = N[0].t, ie = ee.type === "waterfall", pe = ee.type === "funnel", _e = ee.type === "histogram", Ae = ee.type === "bar", Ce = Ae || pe, Ue = 0;
            ie && ee.connector.visible && ee.connector.mode === "between" && (Ue = ee.connector.line.width / 2);
            var Ne = ee.orientation === "h", ke = M(O), A = a.ensureSingle(W, "g", "points"), X = _(ee), H = A.selectAll("g.point").data(a.identity, X);
            H.enter().append("g").classed("point", !0), H.exit().remove(), H.each(function(be, Se) {
              var De = n.select(this), He = I(be, S, $, Ne), Ze = He[0][0], We = He[0][1], $e = He[1][0], it = He[1][1], Ke = (Ne ? We - Ze : it - $e) === 0;
              Ke && Ce && v.getLineWidth(ee, be) && (Ke = !1), Ke || (Ke = !e(Ze) || !e(We) || !e($e) || !e(it)), be.isBlank = Ke, Ke && (Ne ? We = Ze : it = $e), Ue && !Ke && (Ne ? (Ze -= R(Ze, We) * Ue, We += R(Ze, We) * Ue) : ($e -= R($e, it) * Ue, it += R($e, it) * Ue));
              var ct, gt;
              if (ee.type === "waterfall") {
                if (!Ke) {
                  var ht = ee[be.dir].marker;
                  ct = ht.line.width, gt = ht.color;
                }
              } else ct = v.getLineWidth(ee, be), gt = be.mc || ee.marker.color;
              function _t(Vt) {
                var Ft = n.round(ct / 2 % 1, 2);
                return O.gap === 0 && O.groupgap === 0 ? n.round(Math.round(Vt) - Ft, 2) : Vt;
              }
              function Te(Vt, Ft, Dt) {
                return Dt && Vt === Ft ? Vt : Math.abs(Vt - Ft) >= 2 ? _t(Vt) : Vt > Ft ? Math.ceil(Vt) : Math.floor(Vt);
              }
              var Ie = o.opacity(gt), ce = Ie < 1 || ct > 0.01 ? _t : Te;
              J._context.staticPlot || (Ze = ce(Ze, We, Ne), We = ce(We, Ze, Ne), $e = ce($e, it, !Ne), it = ce(it, $e, !Ne));
              var ge = Ne ? S.c2p : $.c2p, ye;
              be.s0 > 0 ? ye = be._sMax : be.s0 < 0 ? ye = be._sMin : ye = be.s1 > 0 ? be._sMax : be._sMin;
              function Me(Vt, Ft) {
                if (!Vt) return 0;
                var Dt = Math.abs(Ne ? it - $e : We - Ze), Ct = Math.abs(Ne ? We - Ze : it - $e), Ot = ce(Math.abs(ge(ye, !0) - ge(0, !0))), Wt = be.hasB ? Math.min(Dt / 2, Ct / 2) : Math.min(Dt / 2, Ot), rr;
                if (Ft === "%") {
                  var Ut = Math.min(50, Vt);
                  rr = Dt * (Ut / 100);
                } else rr = Vt;
                return ce(Math.max(Math.min(rr, Wt), 0));
              }
              var Oe = Ae || _e ? Me(le.cornerradiusvalue, le.cornerradiusform) : 0, je, qe, Qe = "M" + Ze + "," + $e + "V" + it + "H" + We + "V" + $e + "Z", Xe = 0;
              if (Oe && be.s) {
                var Je = T(be.s0) === 0 || T(be.s) === T(be.s0) ? be.s1 : be.s0;
                if (Xe = ce(be.hasB ? 0 : Math.abs(ge(ye, !0) - ge(Je, !0))), Xe < Oe) {
                  var ot = R(Ze, We), lt = R($e, it), st = ot === -lt ? 1 : 0;
                  if (Ne) if (be.hasB) je = "M" + (Ze + Oe * ot) + "," + $e + "A " + Oe + "," + Oe + " 0 0 " + st + " " + Ze + "," + ($e + Oe * lt) + "V" + (it - Oe * lt) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (Ze + Oe * ot) + "," + it + "H" + (We - Oe * ot) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + We + "," + (it - Oe * lt) + "V" + ($e + Oe * lt) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (We - Oe * ot) + "," + $e + "Z";
                  else {
                    qe = Math.abs(We - Ze) + Xe;
                    var xt = qe < Oe ? Oe - Math.sqrt(qe * (2 * Oe - qe)) : 0, Et = Xe > 0 ? Math.sqrt(Xe * (2 * Oe - Xe)) : 0, Bt = ot > 0 ? Math.max : Math.min;
                    je = "M" + Ze + "," + $e + "V" + (it - xt * lt) + "H" + Bt(We - (Oe - Xe) * ot, Ze) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + We + "," + (it - Oe * lt - Et) + "V" + ($e + Oe * lt + Et) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + Bt(We - (Oe - Xe) * ot, Ze) + "," + ($e + xt * lt) + "Z";
                  }
                  else if (be.hasB) je = "M" + (Ze + Oe * ot) + "," + $e + "A " + Oe + "," + Oe + " 0 0 " + st + " " + Ze + "," + ($e + Oe * lt) + "V" + (it - Oe * lt) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (Ze + Oe * ot) + "," + it + "H" + (We - Oe * ot) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + We + "," + (it - Oe * lt) + "V" + ($e + Oe * lt) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (We - Oe * ot) + "," + $e + "Z";
                  else {
                    qe = Math.abs(it - $e) + Xe;
                    var qt = qe < Oe ? Oe - Math.sqrt(qe * (2 * Oe - qe)) : 0, jt = Xe > 0 ? Math.sqrt(Xe * (2 * Oe - Xe)) : 0, It = lt > 0 ? Math.max : Math.min;
                    je = "M" + (Ze + qt * ot) + "," + $e + "V" + It(it - (Oe - Xe) * lt, $e) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (Ze + Oe * ot - jt) + "," + it + "H" + (We - Oe * ot + jt) + "A " + Oe + "," + Oe + " 0 0 " + st + " " + (We - qt * ot) + "," + It(it - (Oe - Xe) * lt, $e) + "V" + $e + "Z";
                  }
                } else je = Qe;
              } else je = Qe;
              var Tt = P(a.ensureSingle(De, "path"), re, O, F);
              if (Tt.style("vector-effect", E ? "none" : "non-scaling-stroke").attr("d", isNaN((We - Ze) * (it - $e)) || Ke && J._context.staticPlot ? "M0,0Z" : je).call(r.setClipUrl, ne.layerClipId, J), !re.uniformtext.mode && ke) {
                var Rt = r.makePointStyleFns(ee);
                r.singlePointStyle(be, Tt, ee, Rt, J);
              }
              z(J, ne, De, N, Se, Ze, We, $e, it, Oe, Xe, O, F), ne.layerClipId && r.hideOutsideRangePoint(be, De.select("text"), S, $, ee.xcalendar, ee.ycalendar);
            });
            var ve = ee.cliponaxis === !1;
            r.setClipUrl(W, ve ? null : ne.layerClipId, J);
          });
          s.getComponentMethod("errorbars", "plot")(J, w, ne, O);
        }
        function z(J, ne, ae, se, O, F, S, $, re, E, w, N, W) {
          var ee = ne.xaxis, le = ne.yaxis, ie = J._fullLayout, pe;
          function _e(qe, Qe, Xe) {
            var Je = a.ensureSingle(qe, "text").text(Qe).attr({ class: "bartext bartext-" + pe, "text-anchor": "middle", "data-notex": 1 }).call(r.font, Xe).call(i.convertToTspans, J);
            return Je;
          }
          var Ae = se[0].trace, Ce = Ae.orientation === "h", Ue = Z(ie, se, O, ee, le);
          pe = Y(Ae, O);
          var Ne = N.mode === "stack" || N.mode === "relative", ke = se[O], A = !Ne || ke._outmost, X = ke.hasB, H = E && E - w > d;
          if (!Ue || pe === "none" || (ke.isBlank || F === S || $ === re) && (pe === "auto" || pe === "inside")) {
            ae.select("text").remove();
            return;
          }
          var ve = ie.font, be = f.getBarColor(se[O], Ae), Se = f.getInsideTextFont(Ae, O, ve, be), De = f.getOutsideTextFont(Ae, O, ve), He = Ae.insidetextanchor || "end", Ze = ae.datum();
          Ce ? ee.type === "log" && Ze.s0 <= 0 && (ee.range[0] < ee.range[1] ? F = 0 : F = ee._length) : le.type === "log" && Ze.s0 <= 0 && (le.range[0] < le.range[1] ? $ = le._length : $ = 0);
          var We = Math.abs(S - F), $e = Math.abs(re - $), it = We - 2 * d, Ke = $e - 2 * d, ct, gt, ht, _t, Te;
          if (pe === "outside" && !A && !ke.hasB && (pe = "inside"), pe === "auto") if (A) {
            pe = "inside", Te = a.ensureUniformFontSize(J, Se), ct = _e(ae, Ue, Te), gt = r.bBox(ct.node()), ht = gt.width, _t = gt.height;
            var Ie = ht > 0 && _t > 0, ce;
            H ? X ? ce = q(it - 2 * E, Ke, ht, _t, Ce) || q(it, Ke - 2 * E, ht, _t, Ce) : Ce ? ce = q(it - (E - w), Ke, ht, _t, Ce) || q(it, Ke - 2 * (E - w), ht, _t, Ce) : ce = q(it, Ke - (E - w), ht, _t, Ce) || q(it - 2 * (E - w), Ke, ht, _t, Ce) : ce = q(it, Ke, ht, _t, Ce), Ie && ce ? pe = "inside" : (pe = "outside", ct.remove(), ct = null);
          } else pe = "inside";
          if (!ct) {
            Te = a.ensureUniformFontSize(J, pe === "outside" ? De : Se), ct = _e(ae, Ue, Te);
            var ge = ct.attr("transform");
            if (ct.attr("transform", ""), gt = r.bBox(ct.node()), ht = gt.width, _t = gt.height, ct.attr("transform", ge), ht <= 0 || _t <= 0) {
              ct.remove();
              return;
            }
          }
          var ye = Ae.textangle, Me, Oe;
          pe === "outside" ? (Oe = Ae.constraintext === "both" || Ae.constraintext === "outside", Me = V(F, S, $, re, gt, { isHorizontal: Ce, constrained: Oe, angle: ye })) : (Oe = Ae.constraintext === "both" || Ae.constraintext === "inside", Me = K(F, S, $, re, gt, { isHorizontal: Ce, constrained: Oe, angle: ye, anchor: He, hasB: X, r: E, overhead: w })), Me.fontSize = Te.size, p(Ae.type === "histogram" ? "bar" : Ae.type, Me, ie), ke.transform = Me;
          var je = P(ct, ie, N, W);
          a.setTransormAndDisplay(je, Me);
        }
        function q(J, ne, ae, se, O) {
          if (J < 0 || ne < 0) return !1;
          var F = ae <= J && se <= ne, S = ae <= ne && se <= J, $ = O ? J >= ae * (ne / se) : ne >= se * (J / ae);
          return F || S || $;
        }
        function U(J) {
          return J === "auto" ? 0 : J;
        }
        function G(J, ne) {
          var ae = Math.PI / 180 * ne, se = Math.abs(Math.sin(ae)), O = Math.abs(Math.cos(ae));
          return { x: J.width * O + J.height * se, y: J.width * se + J.height * O };
        }
        function K(J, ne, ae, se, O, F) {
          var S = !!F.isHorizontal, $ = !!F.constrained, re = F.angle || 0, E = F.anchor, w = E === "end", N = E === "start", W = F.leftToRight || 0, ee = (W + 1) / 2, le = 1 - ee, ie = F.hasB, pe = F.r, _e = F.overhead, Ae = O.width, Ce = O.height, Ue = Math.abs(ne - J), Ne = Math.abs(se - ae), ke = Ue > 2 * d && Ne > 2 * d ? d : 0;
          Ue -= 2 * ke, Ne -= 2 * ke;
          var A = U(re);
          re === "auto" && !(Ae <= Ue && Ce <= Ne) && (Ae > Ue || Ce > Ne) && (!(Ae > Ne || Ce > Ue) || Ae < Ce != Ue < Ne) && (A += 90);
          var X = G(O, A), H, ve;
          if (pe && pe - _e > d) {
            var be = te(J, ne, ae, se, X, pe, _e, S, ie);
            H = be.scale, ve = be.pad;
          } else H = 1, $ && (H = Math.min(1, Ue / X.x, Ne / X.y)), ve = 0;
          var Se = O.left * le + O.right * ee, De = (O.top + O.bottom) / 2, He = (J + d) * le + (ne - d) * ee, Ze = (ae + se) / 2, We = 0, $e = 0;
          if (N || w) {
            var it = (S ? X.x : X.y) / 2;
            pe && (w || ie) && (ke += ve);
            var Ke = S ? R(J, ne) : R(ae, se);
            S ? N ? (He = J + Ke * ke, We = -Ke * it) : (He = ne - Ke * ke, We = Ke * it) : N ? (Ze = ae + Ke * ke, $e = -Ke * it) : (Ze = se - Ke * ke, $e = Ke * it);
          }
          return { textX: Se, textY: De, targetX: He, targetY: Ze, anchorX: We, anchorY: $e, scale: H, rotate: A };
        }
        function te(J, ne, ae, se, O, F, S, $, re) {
          var E = Math.max(0, Math.abs(ne - J) - 2 * d), w = Math.max(0, Math.abs(se - ae) - 2 * d), N = F - d, W = S ? N - Math.sqrt(N * N - (N - S) * (N - S)) : N, ee = re ? N * 2 : $ ? N - S : 2 * W, le = re ? N * 2 : $ ? 2 * W : N - S, ie, pe, _e, Ae, Ce;
          return O.y / O.x >= w / (E - ee) ? Ae = w / O.y : O.y / O.x <= (w - le) / E ? Ae = E / O.x : !re && $ ? (ie = O.x * O.x + O.y * O.y / 4, pe = -2 * O.x * (E - N) - O.y * (w / 2 - N), _e = (E - N) * (E - N) + (w / 2 - N) * (w / 2 - N) - N * N, Ae = (-pe + Math.sqrt(pe * pe - 4 * ie * _e)) / (2 * ie)) : re ? (ie = (O.x * O.x + O.y * O.y) / 4, pe = -O.x * (E / 2 - N) - O.y * (w / 2 - N), _e = (E / 2 - N) * (E / 2 - N) + (w / 2 - N) * (w / 2 - N) - N * N, Ae = (-pe + Math.sqrt(pe * pe - 4 * ie * _e)) / (2 * ie)) : (ie = O.x * O.x / 4 + O.y * O.y, pe = -O.x * (E / 2 - N) - 2 * O.y * (w - N), _e = (E / 2 - N) * (E / 2 - N) + (w - N) * (w - N) - N * N, Ae = (-pe + Math.sqrt(pe * pe - 4 * ie * _e)) / (2 * ie)), Ae = Math.min(1, Ae), $ ? Ce = Math.max(0, N - Math.sqrt(Math.max(0, N * N - (N - (w - O.y * Ae) / 2) * (N - (w - O.y * Ae) / 2))) - S) : Ce = Math.max(0, N - Math.sqrt(Math.max(0, N * N - (N - (E - O.x * Ae) / 2) * (N - (E - O.x * Ae) / 2))) - S), { scale: Ae, pad: Ce };
        }
        function V(J, ne, ae, se, O, F) {
          var S = !!F.isHorizontal, $ = !!F.constrained, re = F.angle || 0, E = O.width, w = O.height, N = Math.abs(ne - J), W = Math.abs(se - ae), ee;
          S ? ee = W > 2 * d ? d : 0 : ee = N > 2 * d ? d : 0;
          var le = 1;
          $ && (le = S ? Math.min(1, W / w) : Math.min(1, N / E));
          var ie = U(re), pe = G(O, ie), _e = (S ? pe.x : pe.y) / 2, Ae = (O.left + O.right) / 2, Ce = (O.top + O.bottom) / 2, Ue = (J + ne) / 2, Ne = (ae + se) / 2, ke = 0, A = 0, X = S ? R(ne, J) : R(ae, se);
          return S ? (Ue = ne - X * ee, ke = X * _e) : (Ne = se + X * ee, A = -X * _e), { textX: Ae, textY: Ce, targetX: Ue, targetY: Ne, anchorX: ke, anchorY: A, scale: le, rotate: ie };
        }
        function Z(J, ne, ae, se, O) {
          var F = ne[0].trace, S = F.texttemplate, $;
          return S ? $ = C(J, ne, ae, se, O) : F.textinfo ? $ = j(ne, ae, se, O) : $ = v.getValue(F.text, ae), v.coerceString(h, $);
        }
        function Y(J, ne) {
          var ae = v.getValue(J.textposition, ne);
          return v.coerceEnumerated(m, ae);
        }
        function C(J, ne, ae, se, O) {
          var F = ne[0].trace, S = a.castOption(F, ae, "texttemplate");
          if (!S) return "";
          var $ = F.type === "histogram", re = F.type === "waterfall", E = F.type === "funnel", w = F.orientation === "h", N, W, ee, le;
          w ? (N = "y", W = O, ee = "x", le = se) : (N = "x", W = se, ee = "y", le = O);
          function ie(ke) {
            return c(W, W.c2l(ke), !0).text;
          }
          function pe(ke) {
            return c(le, le.c2l(ke), !0).text;
          }
          var _e = ne[ae], Ae = {};
          Ae.label = _e.p, Ae.labelLabel = Ae[N + "Label"] = ie(_e.p);
          var Ce = a.castOption(F, _e.i, "text");
          (Ce === 0 || Ce) && (Ae.text = Ce), Ae.value = _e.s, Ae.valueLabel = Ae[ee + "Label"] = pe(_e.s);
          var Ue = {};
          u(Ue, F, _e.i), ($ || Ue.x === void 0) && (Ue.x = w ? Ae.value : Ae.label), ($ || Ue.y === void 0) && (Ue.y = w ? Ae.label : Ae.value), ($ || Ue.xLabel === void 0) && (Ue.xLabel = w ? Ae.valueLabel : Ae.labelLabel), ($ || Ue.yLabel === void 0) && (Ue.yLabel = w ? Ae.labelLabel : Ae.valueLabel), re && (Ae.delta = +_e.rawS || _e.s, Ae.deltaLabel = pe(Ae.delta), Ae.final = _e.v, Ae.finalLabel = pe(Ae.final), Ae.initial = Ae.final - Ae.delta, Ae.initialLabel = pe(Ae.initial)), E && (Ae.value = _e.s, Ae.valueLabel = pe(Ae.value), Ae.percentInitial = _e.begR, Ae.percentInitialLabel = a.formatPercent(_e.begR), Ae.percentPrevious = _e.difR, Ae.percentPreviousLabel = a.formatPercent(_e.difR), Ae.percentTotal = _e.sumR, Ae.percenTotalLabel = a.formatPercent(_e.sumR));
          var Ne = a.castOption(F, _e.i, "customdata");
          return Ne && (Ae.customdata = Ne), a.texttemplateString({ data: [Ue, Ae, F._meta], fallback: F.texttemplatefallback, labels: Ae, locale: J._d3locale, template: S });
        }
        function j(J, ne, ae, se) {
          var O = J[0].trace, F = O.orientation === "h", S = O.type === "waterfall", $ = O.type === "funnel";
          function re(Ne) {
            var ke = F ? se : ae;
            return c(ke, Ne, !0).text;
          }
          function E(Ne) {
            var ke = F ? ae : se;
            return c(ke, +Ne, !0).text;
          }
          var w = O.textinfo, N = J[ne], W = w.split("+"), ee = [], le, ie = function(Ne) {
            return W.indexOf(Ne) !== -1;
          };
          if (ie("label") && ee.push(re(J[ne].p)), ie("text") && (le = a.castOption(O, N.i, "text"), (le === 0 || le) && ee.push(le)), S) {
            var pe = +N.rawS || N.s, _e = N.v, Ae = _e - pe;
            ie("initial") && ee.push(E(Ae)), ie("delta") && ee.push(E(pe)), ie("final") && ee.push(E(_e));
          }
          if ($) {
            ie("value") && ee.push(E(N.s));
            var Ce = 0;
            ie("percent initial") && Ce++, ie("percent previous") && Ce++, ie("percent total") && Ce++;
            var Ue = Ce > 1;
            ie("percent initial") && (le = a.formatPercent(N.begR), Ue && (le += " of initial"), ee.push(le)), ie("percent previous") && (le = a.formatPercent(N.difR), Ue && (le += " of previous"), ee.push(le)), ie("percent total") && (le = a.formatPercent(N.sumR), Ue && (le += " of total"), ee.push(le));
          }
          return ee.join("<br>");
        }
        k.exports = { plot: B, toMoveInsideBar: K };
      }), ou = xe((L, k) => {
        var n = Bn(), e = or(), a = fr(), i = wt().fillText, o = $o().getLineWidth, r = Ar().hoverLabelText, s = Yr().BADNUM;
        function c(l, f, v, g, x) {
          var h = t(l, f, v, g, x);
          if (h) {
            var m = h.cd, u = m[0].trace, d = m[h.index];
            return h.color = p(u, d), e.getComponentMethod("errorbars", "hoverInfo")(d, u, h), [h];
          }
        }
        function t(l, f, v, g, x) {
          var h = l.cd, m = h[0].trace, u = h[0].t, d = g === "closest", y = m.type === "waterfall", _ = l.maxHoverDistance, T = l.maxSpikeDistance, R, I, P, M, B, z, q;
          m.orientation === "h" ? (R = v, I = f, P = "y", M = "x", B = se, z = J) : (R = f, I = v, P = "x", M = "y", z = se, B = J);
          var U = m[P + "period"], G = d || U;
          function K(le) {
            return V(le, -1);
          }
          function te(le) {
            return V(le, 1);
          }
          function V(le, ie) {
            var pe = le.w;
            return le[P] + ie * pe / 2;
          }
          function Z(le) {
            return le[P + "End"] - le[P + "Start"];
          }
          var Y = d ? K : U ? function(le) {
            return le.p - Z(le) / 2;
          } : function(le) {
            return Math.min(K(le), le.p - u.bardelta / 2);
          }, C = d ? te : U ? function(le) {
            return le.p + Z(le) / 2;
          } : function(le) {
            return Math.max(te(le), le.p + u.bardelta / 2);
          };
          function j(le, ie, pe) {
            return x.finiteRange && (pe = 0), n.inbox(le - R, ie - R, pe + Math.min(1, Math.abs(ie - le) / q) - 1);
          }
          function J(le) {
            return j(Y(le), C(le), _);
          }
          function ne(le) {
            return j(K(le), te(le), T);
          }
          function ae(le) {
            var ie = le[M];
            if (y) {
              var pe = Math.abs(le.rawS) || 0;
              I > 0 ? ie += pe : I < 0 && (ie -= pe);
            }
            return ie;
          }
          function se(le) {
            var ie = I, pe = le.b, _e = ae(le);
            return n.inbox(pe - ie, _e - ie, _ + (_e - ie) / (_e - pe) - 1);
          }
          function O(le) {
            var ie = I, pe = le.b, _e = ae(le);
            return n.inbox(pe - ie, _e - ie, T + (_e - ie) / (_e - pe) - 1);
          }
          var F = l[P + "a"], S = l[M + "a"];
          q = Math.abs(F.r2c(F.range[1]) - F.r2c(F.range[0]));
          function $(le) {
            return (B(le) + z(le)) / 2;
          }
          var re = n.getDistanceFunction(g, B, z, $);
          if (n.getClosest(h, re, l), l.index !== !1 && h[l.index].p !== s) {
            G || (Y = function(le) {
              return Math.min(K(le), le.p - u.bargroupwidth / 2);
            }, C = function(le) {
              return Math.max(te(le), le.p + u.bargroupwidth / 2);
            });
            var E = l.index, w = h[E], N = m.base ? w.b + w.s : w.s;
            l[M + "0"] = l[M + "1"] = S.c2p(w[M], !0), l[M + "LabelVal"] = N;
            var W = u.extents[u.extents.round(w.p)];
            l[P + "0"] = F.c2p(d ? Y(w) : W[0], !0), l[P + "1"] = F.c2p(d ? C(w) : W[1], !0);
            var ee = w.orig_p !== void 0;
            return l[P + "LabelVal"] = ee ? w.orig_p : w.p, l.labelLabel = r(F, l[P + "LabelVal"], m[P + "hoverformat"]), l.valueLabel = r(S, l[M + "LabelVal"], m[M + "hoverformat"]), l.baseLabel = r(S, w.b, m[M + "hoverformat"]), l.spikeDistance = (O(w) + ne(w)) / 2, l[P + "Spike"] = F.c2p(w.p, !0), i(w, m, l), l.hovertemplate = m.hovertemplate, l;
          }
        }
        function p(l, f) {
          var v = f.mcc || l.marker.color, g = f.mlcc || l.marker.line.color, x = o(l, f);
          if (a.opacity(v)) return v;
          if (a.opacity(g) && x) return g;
        }
        k.exports = { hoverPoints: c, hoverOnBars: t, getTraceColor: p };
      }), x0 = xe((L, k) => {
        k.exports = function(n, e, a) {
          return n.x = "xVal" in e ? e.xVal : e.x, n.y = "yVal" in e ? e.yVal : e.y, e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), a.orientation === "h" ? (n.label = n.y, n.value = n.x) : (n.label = n.x, n.value = n.y), n;
        };
      }), lu = xe((L, k) => {
        k.exports = function(e, a) {
          var i = e.cd, o = e.xaxis, r = e.yaxis, s = i[0].trace, c = s.type === "funnel", t = s.orientation === "h", p = [], l;
          if (a === !1) for (l = 0; l < i.length; l++) i[l].selected = 0;
          else for (l = 0; l < i.length; l++) {
            var f = i[l], v = "ct" in f ? f.ct : n(f, o, r, t, c);
            a.contains(v, !1, l, e) ? (p.push({ pointNumber: l, x: o.c2d(f.x), y: r.c2d(f.y) }), f.selected = 1) : f.selected = 0;
          }
          return p;
        };
        function n(e, a, i, o, r) {
          var s = a.c2p(o ? e.s0 : e.p0, !0), c = a.c2p(o ? e.s1 : e.p1, !0), t = i.c2p(o ? e.p0 : e.s0, !0), p = i.c2p(o ? e.p1 : e.s1, !0);
          return r ? [(s + c) / 2, (t + p) / 2] : o ? [c, (t + p) / 2] : [(s + c) / 2, p];
        }
      }), b0 = xe((L, k) => {
        k.exports = { attributes: ja(), layoutAttributes: Xo(), supplyDefaults: Ha().supplyDefaults, crossTraceDefaults: Ha().crossTraceDefaults, supplyLayoutDefaults: au(), calc: m0(), crossTraceCalc: Ho().crossTraceCalc, colorbar: Ci(), arraysToCalcdata: Jo(), plot: iu().plot, style: li().style, styleOnSelect: li().styleOnSelect, hoverPoints: ou().hoverPoints, eventData: x0(), selectPoints: lu(), moduleType: "trace", name: "bar", basePlotModule: Kn(), categories: ["bar-like", "cartesian", "svg", "bar", "oriented", "errorBarsOK", "showLegend", "zoomScale"], animatable: !0, meta: {} };
      }), _0 = xe((L, k) => {
        k.exports = b0();
      }), Ko = xe((L, k) => {
        var n = zo(), e = $n(), a = ja(), i = Zn(), o = na().axisHoverFormat, { hovertemplateAttrs: r, templatefallbackAttrs: s } = qn(), c = Br().extendFlat, t = e.marker, p = t.line;
        k.exports = { y: { valType: "data_array", editType: "calc+clearAxisTypes" }, x: { valType: "data_array", editType: "calc+clearAxisTypes" }, x0: { valType: "any", editType: "calc+clearAxisTypes" }, y0: { valType: "any", editType: "calc+clearAxisTypes" }, dx: { valType: "number", editType: "calc" }, dy: { valType: "number", editType: "calc" }, xperiod: e.xperiod, yperiod: e.yperiod, xperiod0: e.xperiod0, yperiod0: e.yperiod0, xperiodalignment: e.xperiodalignment, yperiodalignment: e.yperiodalignment, xhoverformat: o("x"), yhoverformat: o("y"), name: { valType: "string", editType: "calc+clearAxisTypes" }, q1: { valType: "data_array", editType: "calc+clearAxisTypes" }, median: { valType: "data_array", editType: "calc+clearAxisTypes" }, q3: { valType: "data_array", editType: "calc+clearAxisTypes" }, lowerfence: { valType: "data_array", editType: "calc" }, upperfence: { valType: "data_array", editType: "calc" }, notched: { valType: "boolean", editType: "calc" }, notchwidth: { valType: "number", min: 0, max: 0.5, dflt: 0.25, editType: "calc" }, notchspan: { valType: "data_array", editType: "calc" }, boxpoints: { valType: "enumerated", values: ["all", "outliers", "suspectedoutliers", !1], editType: "calc" }, jitter: { valType: "number", min: 0, max: 1, editType: "calc" }, pointpos: { valType: "number", min: -2, max: 2, editType: "calc" }, sdmultiple: { valType: "number", min: 0, editType: "calc", dflt: 1 }, sizemode: { valType: "enumerated", values: ["quartiles", "sd"], editType: "calc", dflt: "quartiles" }, boxmean: { valType: "enumerated", values: [!0, "sd", !1], editType: "calc" }, mean: { valType: "data_array", editType: "calc" }, sd: { valType: "data_array", editType: "calc" }, orientation: { valType: "enumerated", values: ["v", "h"], editType: "calc+clearAxisTypes" }, quartilemethod: { valType: "enumerated", values: ["linear", "exclusive", "inclusive"], dflt: "linear", editType: "calc" }, width: { valType: "number", min: 0, dflt: 0, editType: "calc" }, marker: { outliercolor: { valType: "color", dflt: "rgba(0, 0, 0, 0)", editType: "style" }, symbol: c({}, t.symbol, { arrayOk: !1, editType: "plot" }), opacity: c({}, t.opacity, { arrayOk: !1, dflt: 1, editType: "style" }), angle: c({}, t.angle, { arrayOk: !1, editType: "calc" }), size: c({}, t.size, { arrayOk: !1, editType: "calc" }), color: c({}, t.color, { arrayOk: !1, editType: "style" }), line: { color: c({}, p.color, { arrayOk: !1, dflt: i.defaultLine, editType: "style" }), width: c({}, p.width, { arrayOk: !1, dflt: 0, editType: "style" }), outliercolor: { valType: "color", editType: "style" }, outlierwidth: { valType: "number", min: 0, dflt: 1, editType: "style" }, editType: "style" }, editType: "plot" }, line: { color: { valType: "color", editType: "style" }, width: { valType: "number", min: 0, dflt: 2, editType: "style" }, editType: "plot" }, fillcolor: n(), whiskerwidth: { valType: "number", min: 0, max: 1, dflt: 0.5, editType: "calc" }, showwhiskers: { valType: "boolean", editType: "calc" }, offsetgroup: a.offsetgroup, alignmentgroup: a.alignmentgroup, selected: { marker: e.selected.marker, editType: "style" }, unselected: { marker: e.unselected.marker, editType: "style" }, text: c({}, e.text, {}), hovertext: c({}, e.hovertext, {}), hovertemplate: r({}), hovertemplatefallback: s(), hoveron: { valType: "flaglist", flags: ["boxes", "points"], dflt: "boxes+points", editType: "style" }, zorder: e.zorder };
      }), Qo = xe((L, k) => {
        k.exports = { boxmode: { valType: "enumerated", values: ["group", "overlay"], dflt: "overlay", editType: "calc" }, boxgap: { valType: "number", min: 0, max: 1, dflt: 0.3, editType: "calc" }, boxgroupgap: { valType: "number", min: 0, max: 1, dflt: 0.3, editType: "calc" } };
      }), Pi = xe((L, k) => {
        var n = wt(), e = or(), a = fr(), i = ai(), o = Oi(), r = wo(), s = Ko();
        function c(f, v, g, x) {
          function h(M, B) {
            return n.coerce(f, v, s, M, B);
          }
          if (t(f, v, h, x), v.visible !== !1) {
            i(f, v, x, h), h("xhoverformat"), h("yhoverformat");
            var m = v._hasPreCompStats;
            m && (h("lowerfence"), h("upperfence")), h("line.color", (f.marker || {}).color || g), h("line.width"), h("fillcolor", a.addOpacity(v.line.color, 0.5));
            var u = !1;
            if (m) {
              var d = h("mean"), y = h("sd");
              d && d.length && (u = !0, y && y.length && (u = "sd"));
            }
            h("whiskerwidth");
            var _ = h("sizemode"), T;
            _ === "quartiles" && (T = h("boxmean", u)), h("showwhiskers", _ === "quartiles"), (_ === "sd" || T === "sd") && h("sdmultiple"), h("width"), h("quartilemethod");
            var R = !1;
            if (m) {
              var I = h("notchspan");
              I && I.length && (R = !0);
            } else n.validate(f.notchwidth, s.notchwidth) && (R = !0);
            var P = h("notched", R);
            P && h("notchwidth"), p(f, v, h, { prefix: "box" }), h("zorder");
          }
        }
        function t(f, v, g, x) {
          function h(j) {
            var J = 0;
            return j && j.length && (J += 1, n.isArrayOrTypedArray(j[0]) && j[0].length && (J += 1)), J;
          }
          function m(j) {
            return n.validate(f[j], s[j]);
          }
          var u = g("y"), d = g("x"), y;
          if (v.type === "box") {
            var _ = g("q1"), T = g("median"), R = g("q3");
            v._hasPreCompStats = _ && _.length && T && T.length && R && R.length, y = Math.min(n.minRowLength(_), n.minRowLength(T), n.minRowLength(R));
          }
          var I = h(u), P = h(d), M = I && n.minRowLength(u), B = P && n.minRowLength(d), z = x.calendar, q = { autotypenumbers: x.autotypenumbers }, U, G;
          if (v._hasPreCompStats) switch (String(P) + String(I)) {
            case "00":
              var K = m("x0") || m("dx"), te = m("y0") || m("dy");
              te && !K ? U = "h" : U = "v", G = y;
              break;
            case "10":
              U = "v", G = Math.min(y, B);
              break;
            case "20":
              U = "h", G = Math.min(y, d.length);
              break;
            case "01":
              U = "h", G = Math.min(y, M);
              break;
            case "02":
              U = "v", G = Math.min(y, u.length);
              break;
            case "12":
              U = "v", G = Math.min(y, B, u.length);
              break;
            case "21":
              U = "h", G = Math.min(y, d.length, M);
              break;
            case "11":
              G = 0;
              break;
            case "22":
              var V = !1, Z;
              for (Z = 0; Z < d.length; Z++) if (r(d[Z], z, q) === "category") {
                V = !0;
                break;
              }
              if (V) U = "v", G = Math.min(y, B, u.length);
              else {
                for (Z = 0; Z < u.length; Z++) if (r(u[Z], z, q) === "category") {
                  V = !0;
                  break;
                }
                V ? (U = "h", G = Math.min(y, d.length, M)) : (U = "v", G = Math.min(y, B, u.length));
              }
              break;
          }
          else I > 0 ? (U = "v", P > 0 ? G = Math.min(B, M) : G = Math.min(M)) : P > 0 ? (U = "h", G = Math.min(B)) : G = 0;
          if (!G) {
            v.visible = !1;
            return;
          }
          v._length = G;
          var Y = g("orientation", U);
          v._hasPreCompStats ? Y === "v" && P === 0 ? (g("x0", 0), g("dx", 1)) : Y === "h" && I === 0 && (g("y0", 0), g("dy", 1)) : Y === "v" && P === 0 ? g("x0") : Y === "h" && I === 0 && g("y0");
          var C = e.getComponentMethod("calendars", "handleTraceDefaults");
          C(f, v, ["x", "y"], x);
        }
        function p(f, v, g, x) {
          var h = x.prefix, m = n.coerce2(f, v, s, "marker.outliercolor"), u = g("marker.line.outliercolor"), d = "outliers";
          v._hasPreCompStats ? d = "all" : (m || u) && (d = "suspectedoutliers");
          var y = g(h + "points", d);
          y ? (g("jitter", y === "all" ? 0.3 : 0), g("pointpos", y === "all" ? -1.5 : 0), g("marker.symbol"), g("marker.opacity"), g("marker.size"), g("marker.angle"), g("marker.color", v.line.color), g("marker.line.color"), g("marker.line.width"), y === "suspectedoutliers" && (g("marker.line.outliercolor", v.marker.color), g("marker.line.outlierwidth")), g("selected.marker.color"), g("unselected.marker.color"), g("selected.marker.size"), g("unselected.marker.size"), g("text"), g("hovertext")) : delete v.marker;
          var _ = g("hoveron");
          (_ === "all" || _.indexOf("points") !== -1) && (g("hovertemplate"), g("hovertemplatefallback")), n.coerceSelectionMarkerOpacity(v, g);
        }
        function l(f, v) {
          var g, x;
          function h(y) {
            return n.coerce(x._input, x, s, y);
          }
          for (var m = 0; m < f.length; m++) {
            x = f[m];
            var u = x.type;
            if (u === "box" || u === "violin") {
              g = x._input;
              var d = v[u + "mode"];
              d === "group" && o(g, x, v, h, d);
            }
          }
        }
        k.exports = { supplyDefaults: c, crossTraceDefaults: l, handleSampleDefaults: t, handlePointsDefaults: p };
      }), su = xe((L, k) => {
        var n = or(), e = wt(), a = Qo();
        function i(r, s, c, t, p) {
          for (var l = p + "Layout", f = !1, v = 0; v < c.length; v++) {
            var g = c[v];
            if (n.traceIs(g, l)) {
              f = !0;
              break;
            }
          }
          f && (t(p + "mode"), t(p + "gap"), t(p + "groupgap"));
        }
        function o(r, s, c) {
          function t(p, l) {
            return e.coerce(r, s, a, p, l);
          }
          i(r, s, c, t, "box");
        }
        k.exports = { supplyLayoutDefaults: o, _supply: i };
      }), uu = xe((L, k) => {
        var n = xr(), e = Ar(), a = ii(), i = wt(), o = Yr().BADNUM, r = i._;
        k.exports = function(y, _) {
          var T = y._fullLayout, R = e.getFromId(y, _.xaxis || "x"), I = e.getFromId(y, _.yaxis || "y"), P = [], M = _.type === "violin" ? "_numViolins" : "_numBoxes", B, z, q, U, G, K, te;
          _.orientation === "h" ? (q = R, U = "x", G = I, K = "y", te = !!_.yperiodalignment) : (q = I, U = "y", G = R, K = "x", te = !!_.xperiodalignment);
          var V = s(_, K, G, T[M]), Z = V[0], Y = V[1], C = i.distinctVals(Z, G), j = C.vals, J = C.minDiff / 2, ne, ae, se, O, F, S, $ = (_.boxpoints || _.points) === "all" ? i.identity : function(it) {
            return it.v < ne.lf || it.v > ne.uf;
          };
          if (_._hasPreCompStats) {
            var re = _[U], E = function(it) {
              return q.d2c((_[it] || [])[B]);
            }, w = 1 / 0, N = -1 / 0;
            for (B = 0; B < _._length; B++) {
              var W = Z[B];
              if (n(W)) {
                if (ne = {}, ne.pos = ne[K] = W, te && Y && (ne.orig_p = Y[B]), ne.q1 = E("q1"), ne.med = E("median"), ne.q3 = E("q3"), ae = [], re && i.isArrayOrTypedArray(re[B])) for (z = 0; z < re[B].length; z++) S = q.d2c(re[B][z]), S !== o && (F = { v: S, i: [B, z] }, l(F, _, [B, z]), ae.push(F));
                if (ne.pts = ae.sort(v), se = ne[U] = ae.map(g), O = se.length, ne.med !== o && ne.q1 !== o && ne.q3 !== o && ne.med >= ne.q1 && ne.q3 >= ne.med) {
                  var ee = E("lowerfence");
                  ne.lf = ee !== o && ee <= ne.q1 ? ee : x(ne, se, O);
                  var le = E("upperfence");
                  ne.uf = le !== o && le >= ne.q3 ? le : h(ne, se, O);
                  var ie = E("mean");
                  ne.mean = ie !== o ? ie : O ? i.mean(se, O) : (ne.q1 + ne.q3) / 2;
                  var pe = E("sd");
                  ne.sd = ie !== o && pe >= 0 ? pe : O ? i.stdev(se, O, ne.mean) : ne.q3 - ne.q1, ne.lo = m(ne), ne.uo = u(ne);
                  var _e = E("notchspan");
                  _e = _e !== o && _e > 0 ? _e : d(ne, O), ne.ln = ne.med - _e, ne.un = ne.med + _e;
                  var Ae = ne.lf, Ce = ne.uf;
                  _.boxpoints && se.length && (Ae = Math.min(Ae, se[0]), Ce = Math.max(Ce, se[O - 1])), _.notched && (Ae = Math.min(Ae, ne.ln), Ce = Math.max(Ce, ne.un)), ne.min = Ae, ne.max = Ce;
                } else {
                  i.warn(["Invalid input - make sure that q1 <= median <= q3", "q1 = " + ne.q1, "median = " + ne.med, "q3 = " + ne.q3].join(`
`));
                  var Ue;
                  ne.med !== o ? Ue = ne.med : ne.q1 !== o ? ne.q3 !== o ? Ue = (ne.q1 + ne.q3) / 2 : Ue = ne.q1 : ne.q3 !== o ? Ue = ne.q3 : Ue = 0, ne.med = Ue, ne.q1 = ne.q3 = Ue, ne.lf = ne.uf = Ue, ne.mean = ne.sd = Ue, ne.ln = ne.un = Ue, ne.min = ne.max = Ue;
                }
                w = Math.min(w, ne.min), N = Math.max(N, ne.max), ne.pts2 = ae.filter($), P.push(ne);
              }
            }
            _._extremes[q._id] = e.findExtremes(q, [w, N], { padded: !0 });
          } else {
            var Ne = q.makeCalcdata(_, U), ke = c(j, J), A = j.length, X = t(A);
            for (B = 0; B < _._length; B++) if (S = Ne[B], !!n(S)) {
              var H = i.findBin(Z[B], ke);
              H >= 0 && H < A && (F = { v: S, i: B }, l(F, _, B), X[H].push(F));
            }
            var ve = 1 / 0, be = -1 / 0, Se = _.quartilemethod, De = Se === "exclusive", He = Se === "inclusive";
            for (B = 0; B < A; B++) if (X[B].length > 0) {
              if (ne = {}, ne.pos = ne[K] = j[B], ae = ne.pts = X[B].sort(v), se = ne[U] = ae.map(g), O = se.length, ne.min = se[0], ne.max = se[O - 1], ne.mean = i.mean(se, O), ne.sd = i.stdev(se, O, ne.mean) * _.sdmultiple, ne.med = i.interp(se, 0.5), O % 2 && (De || He)) {
                var Ze, We;
                De ? (Ze = se.slice(0, O / 2), We = se.slice(O / 2 + 1)) : He && (Ze = se.slice(0, O / 2 + 1), We = se.slice(O / 2)), ne.q1 = i.interp(Ze, 0.5), ne.q3 = i.interp(We, 0.5);
              } else ne.q1 = i.interp(se, 0.25), ne.q3 = i.interp(se, 0.75);
              ne.lf = x(ne, se, O), ne.uf = h(ne, se, O), ne.lo = m(ne), ne.uo = u(ne);
              var $e = d(ne, O);
              ne.ln = ne.med - $e, ne.un = ne.med + $e, ve = Math.min(ve, ne.ln), be = Math.max(be, ne.un), ne.pts2 = ae.filter($), P.push(ne);
            }
            _.notched && i.isTypedArray(Ne) && (Ne = Array.from(Ne)), _._extremes[q._id] = e.findExtremes(q, _.notched ? Ne.concat([ve, be]) : Ne, { padded: !0 });
          }
          return f(P, _), P.length > 0 ? (P[0].t = { num: T[M], dPos: J, posLetter: K, valLetter: U, labels: { med: r(y, "median:"), min: r(y, "min:"), q1: r(y, "q1:"), q3: r(y, "q3:"), max: r(y, "max:"), mean: _.boxmean === "sd" || _.sizemode === "sd" ? r(y, "mean ± σ:").replace("σ", _.sdmultiple === 1 ? "σ" : _.sdmultiple + "σ") : r(y, "mean:"), lf: r(y, "lower fence:"), uf: r(y, "upper fence:") } }, T[M]++, P) : [{ t: { empty: !0 } }];
        };
        function s(y, _, T, R) {
          var I = _ in y, P = _ + "0" in y, M = "d" + _ in y;
          if (I || P && M) {
            var B = T.makeCalcdata(y, _), z = a(y, T, _, B).vals;
            return [z, B];
          }
          var q;
          P ? q = y[_ + "0"] : "name" in y && (T.type === "category" || n(y.name) && ["linear", "log"].indexOf(T.type) !== -1 || i.isDateTime(y.name) && T.type === "date") ? q = y.name : q = R;
          for (var U = T.type === "multicategory" ? T.r2c_just_indices(q) : T.d2c(q, 0, y[_ + "calendar"]), G = y._length, K = new Array(G), te = 0; te < G; te++) K[te] = U;
          return [K];
        }
        function c(y, _) {
          for (var T = y.length, R = new Array(T + 1), I = 0; I < T; I++) R[I] = y[I] - _;
          return R[T] = y[T - 1] + _, R;
        }
        function t(y) {
          for (var _ = new Array(y), T = 0; T < y; T++) _[T] = [];
          return _;
        }
        var p = { text: "tx", hovertext: "htx" };
        function l(y, _, T) {
          for (var R in p) i.isArrayOrTypedArray(_[R]) && (Array.isArray(T) ? i.isArrayOrTypedArray(_[R][T[0]]) && (y[p[R]] = _[R][T[0]][T[1]]) : y[p[R]] = _[R][T]);
        }
        function f(y, _) {
          if (i.isArrayOrTypedArray(_.selectedpoints)) for (var T = 0; T < y.length; T++) {
            for (var R = y[T].pts || [], I = {}, P = 0; P < R.length; P++) I[R[P].i] = P;
            i.tagSelected(R, _, I);
          }
        }
        function v(y, _) {
          return y.v - _.v;
        }
        function g(y) {
          return y.v;
        }
        function x(y, _, T) {
          return T === 0 ? y.q1 : Math.min(y.q1, _[Math.min(i.findBin(2.5 * y.q1 - 1.5 * y.q3, _, !0) + 1, T - 1)]);
        }
        function h(y, _, T) {
          return T === 0 ? y.q3 : Math.max(y.q3, _[Math.max(i.findBin(2.5 * y.q3 - 1.5 * y.q1, _), 0)]);
        }
        function m(y) {
          return 4 * y.q1 - 3 * y.q3;
        }
        function u(y) {
          return 4 * y.q3 - 3 * y.q1;
        }
        function d(y, _) {
          return _ === 0 ? 0 : 1.57 * (y.q3 - y.q1) / Math.sqrt(_);
        }
      }), cu = xe((L, k) => {
        var n = Ar(), e = wt(), a = Fa().getAxisGroup, i = ["v", "h"];
        function o(s, c) {
          for (var t = s.calcdata, p = c.xaxis, l = c.yaxis, f = 0; f < i.length; f++) {
            for (var v = i[f], g = v === "h" ? l : p, x = [], h = 0; h < t.length; h++) {
              var m = t[h], u = m[0].t, d = m[0].trace;
              d.visible === !0 && (d.type === "box" || d.type === "candlestick") && !u.empty && (d.orientation || "v") === v && d.xaxis === p._id && d.yaxis === l._id && x.push(h);
            }
            r("box", s, x, g);
          }
        }
        function r(s, c, t, p) {
          var l = c.calcdata, f = c._fullLayout, v = p._id, g = v.charAt(0), x, h, m, u = [], d = 0;
          for (x = 0; x < t.length; x++) for (m = l[t[x]], h = 0; h < m.length; h++) u.push(p.c2l(m[h].pos, !0)), d += (m[h].pts2 || []).length;
          if (u.length) {
            var y = e.distinctVals(u);
            (p.type === "category" || p.type === "multicategory") && (y.minDiff = 1);
            var _ = y.minDiff / 2;
            n.minDtick(p, y.minDiff, y.vals[0], !0);
            var T = s === "violin" ? "_numViolins" : "_numBoxes", R = f[T], I = f[s + "mode"] === "group" && R > 1, P = 1 - f[s + "gap"], M = 1 - f[s + "groupgap"];
            for (x = 0; x < t.length; x++) {
              m = l[t[x]];
              var B = m[0].trace, z = m[0].t, q = B.width, U = B.side, G, K, te, V;
              if (q) G = K = V = q / 2, te = 0;
              else if (G = _, I) {
                var Z = a(f, p._id) + B.orientation, Y = f._alignmentOpts[Z] || {}, C = Y[B.alignmentgroup] || {}, j = Object.keys(C.offsetGroups || {}).length, J = j || R, ne = j ? B._offsetIndex : z.num;
                K = G * P * M / J, te = 2 * G * (-0.5 + (ne + 0.5) / J) * P, V = G * P / J;
              } else K = G * P * M, te = 0, V = G;
              z.dPos = G, z.bPos = te, z.bdPos = K, z.wHover = V;
              var ae, se, O = te + K, F, S, $, re, E, w, N = !!q, W = (B.boxpoints || B.points) && d > 0;
              if (U === "positive" ? (ae = G * (q ? 1 : 0.5), F = O, se = F = te) : U === "negative" ? (ae = F = te, se = G * (q ? 1 : 0.5), S = O) : (ae = se = G, F = S = O), W) {
                var ee = B.pointpos, le = B.jitter, ie = B.marker.size / 2, pe = 0;
                ee + le >= 0 && (pe = O * (ee + le), pe > ae ? (N = !0, E = ie, $ = pe) : pe > F && (E = ie, $ = ae)), pe <= ae && ($ = ae);
                var _e = 0;
                ee - le <= 0 && (_e = -O * (ee - le), _e > se ? (N = !0, w = ie, re = _e) : _e > S && (w = ie, re = se)), _e <= se && (re = se);
              } else $ = ae, re = se;
              var Ae = new Array(m.length);
              for (h = 0; h < m.length; h++) Ae[h] = m[h].pos;
              B._extremes[v] = n.findExtremes(p, Ae, { padded: N, vpadminus: re, vpadplus: $, vpadLinearized: !0, ppadminus: { x: w, y: E }[g], ppadplus: { x: E, y: w }[g] });
            }
          }
        }
        k.exports = { crossTraceCalc: o, setPositionOffset: r };
      }), fu = xe((L, k) => {
        var n = vr(), e = wt(), a = Or(), i = 5, o = 0.01;
        function r(p, l, f, v) {
          var g = p._context.staticPlot, x = l.xaxis, h = l.yaxis;
          e.makeTraceGroups(v, f, "trace boxes").each(function(m) {
            var u = n.select(this), d = m[0], y = d.t, _ = d.trace;
            if (y.wdPos = y.bdPos * _.whiskerwidth, _.visible !== !0 || y.empty) {
              u.remove();
              return;
            }
            var T, R;
            _.orientation === "h" ? (T = h, R = x) : (T = x, R = h), s(u, { pos: T, val: R }, _, y, g), c(u, { x, y: h }, _, y), t(u, { pos: T, val: R }, _, y);
          });
        }
        function s(p, l, f, v, g) {
          var x = f.orientation === "h", h = l.val, m = l.pos, u = !!m.rangebreaks, d = v.bPos, y = v.wdPos || 0, _ = v.bPosPxOffset || 0, T = f.whiskerwidth || 0, R = f.showwhiskers !== !1, I = f.notched || !1, P = I ? 1 - 2 * f.notchwidth : 1, M, B;
          Array.isArray(v.bdPos) ? (M = v.bdPos[0], B = v.bdPos[1]) : (M = v.bdPos, B = v.bdPos);
          var z = p.selectAll("path.box").data(f.type !== "violin" || f.box.visible ? e.identity : []);
          z.enter().append("path").style("vector-effect", g ? "none" : "non-scaling-stroke").attr("class", "box"), z.exit().remove(), z.each(function(q) {
            if (q.empty) return n.select(this).attr("d", "M0,0Z");
            var U = m.c2l(q.pos + d, !0), G = m.l2p(U - M) + _, K = m.l2p(U + B) + _, te = u ? (G + K) / 2 : m.l2p(U) + _, V = f.whiskerwidth, Z = u ? G * V + (1 - V) * te : m.l2p(U - y) + _, Y = u ? K * V + (1 - V) * te : m.l2p(U + y) + _, C = m.l2p(U - M * P) + _, j = m.l2p(U + B * P) + _, J = f.sizemode === "sd", ne = h.c2p(J ? q.mean - q.sd : q.q1, !0), ae = J ? h.c2p(q.mean + q.sd, !0) : h.c2p(q.q3, !0), se = e.constrain(J ? h.c2p(q.mean, !0) : h.c2p(q.med, !0), Math.min(ne, ae) + 1, Math.max(ne, ae) - 1), O = q.lf === void 0 || f.boxpoints === !1 || J, F = h.c2p(O ? q.min : q.lf, !0), S = h.c2p(O ? q.max : q.uf, !0), $ = h.c2p(q.ln, !0), re = h.c2p(q.un, !0);
            x ? n.select(this).attr("d", "M" + se + "," + C + "V" + j + "M" + ne + "," + G + "V" + K + (I ? "H" + $ + "L" + se + "," + j + "L" + re + "," + K : "") + "H" + ae + "V" + G + (I ? "H" + re + "L" + se + "," + C + "L" + $ + "," + G : "") + "Z" + (R ? "M" + ne + "," + te + "H" + F + "M" + ae + "," + te + "H" + S + (T === 0 ? "" : "M" + F + "," + Z + "V" + Y + "M" + S + "," + Z + "V" + Y) : "")) : n.select(this).attr("d", "M" + C + "," + se + "H" + j + "M" + G + "," + ne + "H" + K + (I ? "V" + $ + "L" + j + "," + se + "L" + K + "," + re : "") + "V" + ae + "H" + G + (I ? "V" + re + "L" + C + "," + se + "L" + G + "," + $ : "") + "Z" + (R ? "M" + te + "," + ne + "V" + F + "M" + te + "," + ae + "V" + S + (T === 0 ? "" : "M" + Z + "," + F + "H" + Y + "M" + Z + "," + S + "H" + Y) : ""));
          });
        }
        function c(p, l, f, v) {
          var g = l.x, x = l.y, h = v.bdPos, m = v.bPos, u = f.boxpoints || f.points;
          e.seedPseudoRandom();
          var d = function(T) {
            return T.forEach(function(R) {
              R.t = v, R.trace = f;
            }), T;
          }, y = p.selectAll("g.points").data(u ? d : []);
          y.enter().append("g").attr("class", "points"), y.exit().remove();
          var _ = y.selectAll("path").data(function(T) {
            var R, I = T.pts2, P = Math.max((T.max - T.min) / 10, T.q3 - T.q1), M = P * 1e-9, B = P * o, z = [], q = 0, U;
            if (f.jitter) {
              if (P === 0) for (q = 1, z = new Array(I.length), R = 0; R < I.length; R++) z[R] = 1;
              else for (R = 0; R < I.length; R++) {
                var G = Math.max(0, R - i), K = I[G].v, te = Math.min(I.length - 1, R + i), V = I[te].v;
                u !== "all" && (I[R].v < T.lf ? V = Math.min(V, T.lf) : K = Math.max(K, T.uf));
                var Z = Math.sqrt(B * (te - G) / (V - K + M)) || 0;
                Z = e.constrain(Math.abs(Z), 0, 1), z.push(Z), q = Math.max(Z, q);
              }
              U = f.jitter * 2 / (q || 1);
            }
            for (R = 0; R < I.length; R++) {
              var Y = I[R], C = Y.v, j = f.jitter ? U * z[R] * (e.pseudoRandom() - 0.5) : 0, J = T.pos + m + h * (f.pointpos + j);
              f.orientation === "h" ? (Y.y = J, Y.x = C) : (Y.x = J, Y.y = C), u === "suspectedoutliers" && C < T.uo && C > T.lo && (Y.so = !0);
            }
            return I;
          });
          _.enter().append("path").classed("point", !0), _.exit().remove(), _.call(a.translatePoints, g, x);
        }
        function t(p, l, f, v) {
          var g = l.val, x = l.pos, h = !!x.rangebreaks, m = v.bPos, u = v.bPosPxOffset || 0, d = f.boxmean || (f.meanline || {}).visible, y, _;
          Array.isArray(v.bdPos) ? (y = v.bdPos[0], _ = v.bdPos[1]) : (y = v.bdPos, _ = v.bdPos);
          var T = p.selectAll("path.mean").data(f.type === "box" && f.boxmean || f.type === "violin" && f.box.visible && f.meanline.visible ? e.identity : []);
          T.enter().append("path").attr("class", "mean").style({ fill: "none", "vector-effect": "non-scaling-stroke" }), T.exit().remove(), T.each(function(R) {
            var I = x.c2l(R.pos + m, !0), P = x.l2p(I - y) + u, M = x.l2p(I + _) + u, B = h ? (P + M) / 2 : x.l2p(I) + u, z = g.c2p(R.mean, !0), q = g.c2p(R.mean - R.sd, !0), U = g.c2p(R.mean + R.sd, !0);
            f.orientation === "h" ? n.select(this).attr("d", "M" + z + "," + P + "V" + M + (d === "sd" ? "m0,0L" + q + "," + B + "L" + z + "," + P + "L" + U + "," + B + "Z" : "")) : n.select(this).attr("d", "M" + P + "," + z + "H" + M + (d === "sd" ? "m0,0L" + B + "," + q + "L" + P + "," + z + "L" + B + "," + U + "Z" : ""));
          });
        }
        k.exports = { plot: r, plotBoxAndWhiskers: s, plotPoints: c, plotBoxMean: t };
      }), du = xe((L, k) => {
        var n = vr(), e = fr(), a = Or();
        function i(r, s, c) {
          var t = c || n.select(r).selectAll("g.trace.boxes");
          t.style("opacity", function(p) {
            return p[0].trace.opacity;
          }), t.each(function(p) {
            var l = n.select(this), f = p[0].trace, v = f.line.width;
            function g(m, u, d, y) {
              m.style("stroke-width", u + "px").call(e.stroke, d).call(e.fill, y);
            }
            var x = l.selectAll("path.box");
            if (f.type === "candlestick") x.each(function(m) {
              if (!m.empty) {
                var u = n.select(this), d = f[m.dir];
                g(u, d.line.width, d.line.color, d.fillcolor), u.style("opacity", f.selectedpoints && !m.selected ? 0.3 : 1);
              }
            });
            else {
              g(x, v, f.line.color, f.fillcolor), l.selectAll("path.mean").style({ "stroke-width": v, "stroke-dasharray": 2 * v + "px," + v + "px" }).call(e.stroke, f.line.color);
              var h = l.selectAll("path.point");
              a.pointStyle(h, f, r);
            }
          });
        }
        function o(r, s, c) {
          var t = s[0].trace, p = c.selectAll("path.point");
          t.selectedpoints ? a.selectedPointStyle(p, t) : a.pointStyle(p, t, r);
        }
        k.exports = { style: i, styleOnSelect: o };
      }), pu = xe((L, k) => {
        var n = Ar(), e = wt(), a = Bn(), i = fr(), o = e.fillText;
        function r(t, p, l, f) {
          var v = t.cd, g = v[0].trace, x = g.hoveron, h = [], m;
          return x.indexOf("boxes") !== -1 && (h = h.concat(s(t, p, l, f))), x.indexOf("points") !== -1 && (m = c(t, p, l)), f === "closest" ? m ? [m] : h : (m && h.push(m), h);
        }
        function s(t, p, l, f) {
          var v = t.cd, g = t.xa, x = t.ya, h = v[0].trace, m = v[0].t, u = h.type === "violin", d, y, _, T, R, I, P, M, B, z, q, U = m.bdPos, G, K, te = m.wHover, V = function(_e) {
            return _.c2l(_e.pos) + m.bPos - _.c2l(I);
          };
          u && h.side !== "both" ? (h.side === "positive" && (B = function(_e) {
            var Ae = V(_e);
            return a.inbox(Ae, Ae + te, z);
          }, G = U, K = 0), h.side === "negative" && (B = function(_e) {
            var Ae = V(_e);
            return a.inbox(Ae - te, Ae, z);
          }, G = 0, K = U)) : (B = function(_e) {
            var Ae = V(_e);
            return a.inbox(Ae - te, Ae + te, z);
          }, G = K = U);
          var Z;
          u ? Z = function(_e) {
            return a.inbox(_e.span[0] - R, _e.span[1] - R, z);
          } : Z = function(_e) {
            return a.inbox(_e.min - R, _e.max - R, z);
          }, h.orientation === "h" ? (R = p, I = l, P = Z, M = B, d = "y", _ = x, y = "x", T = g) : (R = l, I = p, P = B, M = Z, d = "x", _ = g, y = "y", T = x);
          var Y = Math.min(1, U / Math.abs(_.r2c(_.range[1]) - _.r2c(_.range[0])));
          z = t.maxHoverDistance - Y, q = t.maxSpikeDistance - Y;
          function C(_e) {
            return (P(_e) + M(_e)) / 2;
          }
          var j = a.getDistanceFunction(f, P, M, C);
          if (a.getClosest(v, j, t), t.index === !1) return [];
          var J = v[t.index], ne = h.line.color, ae = (h.marker || {}).color;
          i.opacity(ne) && h.line.width ? t.color = ne : i.opacity(ae) && h.boxpoints ? t.color = ae : t.color = h.fillcolor, t[d + "0"] = _.c2p(J.pos + m.bPos - K, !0), t[d + "1"] = _.c2p(J.pos + m.bPos + G, !0), t[d + "LabelVal"] = J.orig_p !== void 0 ? J.orig_p : J.pos;
          var se = d + "Spike";
          t.spikeDistance = C(J) * q / z, t[se] = _.c2p(J.pos, !0);
          var O = h.boxmean || h.sizemode === "sd" || (h.meanline || {}).visible, F = h.boxpoints || h.points, S = F && O ? ["max", "uf", "q3", "med", "mean", "q1", "lf", "min"] : F && !O ? ["max", "uf", "q3", "med", "q1", "lf", "min"] : !F && O ? ["max", "q3", "med", "mean", "q1", "min"] : ["max", "q3", "med", "q1", "min"], $ = T.range[1] < T.range[0];
          h.orientation === ($ ? "v" : "h") && S.reverse();
          for (var re = t.spikeDistance, E = t[se], w = [], N = 0; N < S.length; N++) {
            var W = S[N];
            if (W in J) {
              var ee = J[W], le = T.c2p(ee, !0), ie = e.extendFlat({}, t);
              ie.attr = W, ie[y + "0"] = ie[y + "1"] = le, ie[y + "LabelVal"] = ee, ie[y + "Label"] = (m.labels ? m.labels[W] + " " : "") + n.hoverLabelText(T, ee, h[y + "hoverformat"]), ie.hoverOnBox = !0, W === "mean" && "sd" in J && (h.boxmean === "sd" || h.sizemode === "sd") && (ie[y + "err"] = J.sd), ie.hovertemplate = !1, w.push(ie);
            }
          }
          t.name = "", t.spikeDistance = void 0, t[se] = void 0;
          for (var pe = 0; pe < w.length; pe++) w[pe].attr !== "med" ? (w[pe].name = "", w[pe].spikeDistance = void 0, w[pe][se] = void 0) : (w[pe].spikeDistance = re, w[pe][se] = E);
          return w;
        }
        function c(t, p, l) {
          for (var f = t.cd, v = t.xa, g = t.ya, x = f[0].trace, h = v.c2p(p), m = g.c2p(l), u, d = function(Z) {
            var Y = Math.max(3, Z.mrc || 0);
            return Math.max(Math.abs(v.c2p(Z.x) - h) - Y, 1 - 3 / Y);
          }, y = function(Z) {
            var Y = Math.max(3, Z.mrc || 0);
            return Math.max(Math.abs(g.c2p(Z.y) - m) - Y, 1 - 3 / Y);
          }, _ = a.quadrature(d, y), T = !1, R, I, P = 0; P < f.length; P++) {
            R = f[P];
            for (var M = 0; M < (R.pts || []).length; M++) {
              I = R.pts[M];
              var B = _(I);
              B <= t.distance && (t.distance = B, T = [P, M]);
            }
          }
          if (!T) return !1;
          R = f[T[0]], I = R.pts[T[1]];
          var z = v.c2p(I.x, !0), q = g.c2p(I.y, !0), U = I.mrc || 1;
          u = e.extendFlat({}, t, { index: I.i, color: (x.marker || {}).color, name: x.name, x0: z - U, x1: z + U, y0: q - U, y1: q + U, spikeDistance: t.distance, hovertemplate: x.hovertemplate });
          var G = R.orig_p, K = G !== void 0 ? G : R.pos, te;
          x.orientation === "h" ? (te = g, u.xLabelVal = I.x, u.yLabelVal = K) : (te = v, u.xLabelVal = K, u.yLabelVal = I.y);
          var V = te._id.charAt(0);
          return u[V + "Spike"] = te.c2p(R.pos, !0), o(I, x, u), u;
        }
        k.exports = { hoverPoints: r, hoverOnBoxes: s, hoverOnPoints: c };
      }), w0 = xe((L, k) => {
        k.exports = function(n, e) {
          return e.hoverOnBox && (n.hoverOnBox = e.hoverOnBox), "xVal" in e && (n.x = e.xVal), "yVal" in e && (n.y = e.yVal), e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), n;
        };
      }), hu = xe((L, k) => {
        k.exports = function(n, e) {
          var a = n.cd, i = n.xaxis, o = n.yaxis, r = [], s, c;
          if (e === !1) for (s = 0; s < a.length; s++) for (c = 0; c < (a[s].pts || []).length; c++) a[s].pts[c].selected = 0;
          else for (s = 0; s < a.length; s++) for (c = 0; c < (a[s].pts || []).length; c++) {
            var t = a[s].pts[c], p = i.c2p(t.x), l = o.c2p(t.y);
            e.contains([p, l], null, t.i, n) ? (r.push({ pointNumber: t.i, x: i.c2d(t.x), y: o.c2d(t.y) }), t.selected = 1) : t.selected = 0;
          }
          return r;
        };
      }), T0 = xe((L, k) => {
        k.exports = { attributes: Ko(), layoutAttributes: Qo(), supplyDefaults: Pi().supplyDefaults, crossTraceDefaults: Pi().crossTraceDefaults, supplyLayoutDefaults: su().supplyLayoutDefaults, calc: uu(), crossTraceCalc: cu().crossTraceCalc, plot: fu().plot, style: du().style, styleOnSelect: du().styleOnSelect, hoverPoints: pu().hoverPoints, eventData: w0(), selectPoints: hu(), moduleType: "trace", name: "box", basePlotModule: Kn(), categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "boxLayout", "zoomScale"], meta: {} };
      }), k0 = xe((L, k) => {
        k.exports = T0();
      }), Ii = xe((L, k) => {
        var n = ca(), { extendFlat: e } = Br(), a = Pn(), { axisHoverFormat: i } = na(), o = hn(), { hovertemplateAttrs: r, templatefallbackAttrs: s, texttemplateAttrs: c } = qn(), t = $n();
        k.exports = e({ z: { valType: "data_array", editType: "calc" }, x: e({}, t.x, { impliedEdits: { xtype: "array" } }), x0: e({}, t.x0, { impliedEdits: { xtype: "scaled" } }), dx: e({}, t.dx, { impliedEdits: { xtype: "scaled" } }), y: e({}, t.y, { impliedEdits: { ytype: "array" } }), y0: e({}, t.y0, { impliedEdits: { ytype: "scaled" } }), dy: e({}, t.dy, { impliedEdits: { ytype: "scaled" } }), xperiod: e({}, t.xperiod, { impliedEdits: { xtype: "scaled" } }), yperiod: e({}, t.yperiod, { impliedEdits: { ytype: "scaled" } }), xperiod0: e({}, t.xperiod0, { impliedEdits: { xtype: "scaled" } }), yperiod0: e({}, t.yperiod0, { impliedEdits: { ytype: "scaled" } }), xperiodalignment: e({}, t.xperiodalignment, { impliedEdits: { xtype: "scaled" } }), yperiodalignment: e({}, t.yperiodalignment, { impliedEdits: { ytype: "scaled" } }), text: { valType: "data_array", editType: "calc" }, hovertext: { valType: "data_array", editType: "calc" }, transpose: { valType: "boolean", dflt: !1, editType: "calc" }, xtype: { valType: "enumerated", values: ["array", "scaled"], editType: "calc+clearAxisTypes" }, ytype: { valType: "enumerated", values: ["array", "scaled"], editType: "calc+clearAxisTypes" }, zsmooth: { valType: "enumerated", values: ["fast", "best", !1], dflt: !1, editType: "calc" }, hoverongaps: { valType: "boolean", dflt: !0, editType: "none" }, connectgaps: { valType: "boolean", editType: "calc" }, xgap: { valType: "number", dflt: 0, min: 0, editType: "plot" }, ygap: { valType: "number", dflt: 0, min: 0, editType: "plot" }, xhoverformat: i("x"), yhoverformat: i("y"), zhoverformat: i("z", 1), hovertemplate: r(), hovertemplatefallback: s(), texttemplate: c({ arrayOk: !1, editType: "plot" }, { keys: ["x", "y", "z", "text"] }), texttemplatefallback: s({ editType: "plot" }), textfont: o({ editType: "plot", autoSize: !0, autoColor: !0, colorEditType: "style" }), showlegend: e({}, a.showlegend, { dflt: !1 }), zorder: t.zorder }, n("", { cLetter: "z", autoColorDflt: !1 }));
      }), vu = xe((L, k) => {
        var n = xr(), e = wt(), a = or();
        k.exports = function(r, s, c, t, p, l) {
          var f = c("z");
          p = p || "x", l = l || "y";
          var v, g;
          if (f === void 0 || !f.length) return 0;
          if (e.isArray1D(f)) {
            v = c(p), g = c(l);
            var x = e.minRowLength(v), h = e.minRowLength(g);
            if (x === 0 || h === 0) return 0;
            s._length = Math.min(x, h, f.length);
          } else {
            if (v = i(p, c), g = i(l, c), !o(f)) return 0;
            c("transpose"), s._length = null;
          }
          var m = a.getComponentMethod("calendars", "handleTraceDefaults");
          return m(r, s, [p, l], t), !0;
        };
        function i(r, s) {
          var c = s(r), t = c ? s(r + "type", "array") : "scaled";
          return t === "scaled" && (s(r + "0"), s("d" + r)), c;
        }
        function o(r) {
          for (var s = !0, c = !1, t = !1, p, l = 0; l < r.length; l++) {
            if (p = r[l], !e.isArrayOrTypedArray(p)) {
              s = !1;
              break;
            }
            p.length > 0 && (c = !0);
            for (var f = 0; f < p.length; f++) if (n(p[f])) {
              t = !0;
              break;
            }
          }
          return s && c && t;
        }
      }), zi = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a) {
          e("texttemplate"), e("texttemplatefallback");
          var i = n.extendFlat({}, a.font, { color: "auto", size: "auto" });
          n.coerceFont(e, "textfont", i);
        };
      }), gu = xe((L, k) => {
        k.exports = function(n, e, a) {
          var i = a("zsmooth");
          i === !1 && (a("xgap"), a("ygap")), a("zhoverformat");
        };
      }), M0 = xe((L, k) => {
        var n = wt(), e = vu(), a = zi(), i = ai(), o = gu(), r = ga(), s = Ii();
        k.exports = function(c, t, p, l) {
          function f(g, x) {
            return n.coerce(c, t, s, g, x);
          }
          var v = e(c, t, f, l);
          if (!v) {
            t.visible = !1;
            return;
          }
          i(c, t, l, f), f("xhoverformat"), f("yhoverformat"), f("text"), f("hovertext"), f("hovertemplate"), f("hovertemplatefallback"), a(f, l), o(c, t, f, l), f("hoverongaps"), f("connectgaps", n.isArray1D(t.z) && t.zsmooth !== !1), r(c, t, l, f, { prefix: "", cLetter: "z" }), f("zorder");
        };
      }), yu = xe((L, k) => {
        var n = xr();
        k.exports = { count: function(e, a, i) {
          return i[e]++, 1;
        }, sum: function(e, a, i, o) {
          var r = o[a];
          return n(r) ? (r = Number(r), i[e] += r, r) : 0;
        }, avg: function(e, a, i, o, r) {
          var s = o[a];
          return n(s) && (s = Number(s), i[e] += s, r[e]++), 0;
        }, min: function(e, a, i, o) {
          var r = o[a];
          if (n(r)) if (r = Number(r), n(i[e])) {
            if (i[e] > r) {
              var s = r - i[e];
              return i[e] = r, s;
            }
          } else return i[e] = r, r;
          return 0;
        }, max: function(e, a, i, o) {
          var r = o[a];
          if (n(r)) if (r = Number(r), n(i[e])) {
            if (i[e] < r) {
              var s = r - i[e];
              return i[e] = r, s;
            }
          } else return i[e] = r, r;
          return 0;
        } };
      }), mu = xe((L, k) => {
        k.exports = { percent: function(n, e) {
          for (var a = n.length, i = 100 / e, o = 0; o < a; o++) n[o] *= i;
        }, probability: function(n, e) {
          for (var a = n.length, i = 0; i < a; i++) n[i] /= e;
        }, density: function(n, e, a, i) {
          var o = n.length;
          i = i || 1;
          for (var r = 0; r < o; r++) n[r] *= a[r] * i;
        }, "probability density": function(n, e, a, i) {
          var o = n.length;
          i && (e /= i);
          for (var r = 0; r < o; r++) n[r] *= a[r] / e;
        } };
      }), xu = xe((L, k) => {
        k.exports = function(n, e) {
          for (var a = n.length, i = 0, o = 0; o < a; o++) e[o] ? (n[o] /= e[o], i += n[o]) : n[o] = null;
          return i;
        };
      }), bu = xe((L, k) => {
        var n = Yr(), e = n.ONEAVGYEAR, a = n.ONEAVGMONTH, i = n.ONEDAY, o = n.ONEHOUR, r = n.ONEMIN, s = n.ONESEC, c = Ar().tickIncrement;
        k.exports = function(v, g, x, h, m) {
          var u = -1.1 * g, d = -0.1 * g, y = v - d, _ = x[0], T = x[1], R = Math.min(t(_ + d, _ + y, h, m), t(T + d, T + y, h, m)), I = Math.min(t(_ + u, _ + d, h, m), t(T + u, T + d, h, m)), P, M;
          if (R > I && I < Math.abs(T - _) / 4e3 ? (P = R, M = !1) : (P = Math.min(R, I), M = !0), h.type === "date" && P > i) {
            var B = P === e ? 1 : 6, z = P === e ? "M12" : "M1";
            return function(q, U) {
              var G = h.c2d(q, e, m), K = G.indexOf("-", B);
              K > 0 && (G = G.substr(0, K));
              var te = h.d2c(G, 0, m);
              if (te < q) {
                var V = c(te, z, !1, m);
                (te + V) / 2 < q + v && (te = V);
              }
              return U && M ? c(te, z, !0, m) : te;
            };
          }
          return function(q, U) {
            var G = P * Math.round(q / P);
            return G + P / 10 < q && G + P * 0.9 < q + v && (G += P), U && M && (G -= P), G;
          };
        };
        function t(v, g, x, h) {
          if (v * g <= 0) return 1 / 0;
          for (var m = Math.abs(g - v), u = x.type === "date", d = p(m, u), y = 0; y < 10; y++) {
            var _ = p(d * 80, u);
            if (d === _) break;
            if (l(_, v, g, u, x, h)) d = _;
            else break;
          }
          return d;
        }
        function p(v, g) {
          return g && v > s ? v > i ? v > e * 1.1 ? e : v > a * 1.1 ? a : i : v > o ? o : v > r ? r : s : Math.pow(10, Math.floor(Math.log(v) / Math.LN10));
        }
        function l(v, g, x, h, m, u) {
          if (h && v > i) {
            var d = f(g, m, u), y = f(x, m, u), _ = v === e ? 0 : 1;
            return d[_] !== y[_];
          }
          return Math.floor(x / v) - Math.floor(g / v) > 0.1;
        }
        function f(v, g, x) {
          var h = g.c2d(v, e, x).split("-");
          return h[0] === "" && (h.unshift(), h[0] = "-" + h[0]), h;
        }
      }), _u = xe((L, k) => {
        var n = xr(), e = wt(), a = or(), i = Ar(), { hasColorscale: o } = Un(), r = ei(), s = Jo(), c = yu(), t = mu(), p = xu(), l = bu();
        function f(m, u) {
          var d = [], y = [], _ = u.orientation === "h", T = i.getFromId(m, _ ? u.yaxis : u.xaxis), R = _ ? "y" : "x", I = { x: "y", y: "x" }[R], P = u[R + "calendar"], M = u.cumulative, B, z = v(m, u, T, R), q = z[0], U = z[1], G = typeof q.size == "string", K = [], te = G ? K : q, V = [], Z = [], Y = [], C = 0, j = u.histnorm, J = u.histfunc, ne = j.indexOf("density") !== -1, ae, se, O;
          M.enabled && ne && (j = j.replace(/ ?density$/, ""), ne = !1);
          var F = J === "max" || J === "min", S = F ? null : 0, $ = c.count, re = t[j], E = !1, w = function(ve) {
            return T.r2c(ve, 0, P);
          }, N;
          for (e.isArrayOrTypedArray(u[I]) && J !== "count" && (N = u[I], E = J === "avg", $ = c[J]), B = w(q.start), se = w(q.end) + (B - i.tickIncrement(B, q.size, !1, P)) / 1e6; B < se && d.length < 1e6 && (ae = i.tickIncrement(B, q.size, !1, P), d.push((B + ae) / 2), y.push(S), Y.push([]), K.push(B), ne && V.push(1 / (ae - B)), E && Z.push(0), !(ae <= B)); ) B = ae;
          K.push(B), !G && T.type === "date" && (te = { start: w(te.start), end: w(te.end), size: te.size }), m._fullLayout._roundFnOpts || (m._fullLayout._roundFnOpts = {});
          var W = u["_" + R + "bingroup"], ee = { leftGap: 1 / 0, rightGap: 1 / 0 };
          W && (m._fullLayout._roundFnOpts[W] || (m._fullLayout._roundFnOpts[W] = ee), ee = m._fullLayout._roundFnOpts[W]);
          var le = y.length, ie = !0, pe = ee.leftGap, _e = ee.rightGap, Ae = {};
          for (B = 0; B < U.length; B++) {
            var Ce = U[B];
            O = e.findBin(Ce, te), O >= 0 && O < le && (C += $(O, B, y, N, Z), ie && Y[O].length && Ce !== U[Y[O][0]] && (ie = !1), Y[O].push(B), Ae[B] = O, pe = Math.min(pe, Ce - K[O]), _e = Math.min(_e, K[O + 1] - Ce));
          }
          ee.leftGap = pe, ee.rightGap = _e;
          var Ue;
          ie || (Ue = function(ve, be) {
            return function() {
              var Se = m._fullLayout._roundFnOpts[W];
              return l(Se.leftGap, Se.rightGap, K, T, P)(ve, be);
            };
          }), E && (C = p(y, Z)), re && re(y, C, V), M.enabled && h(y, M.direction, M.currentbin);
          var Ne = Math.min(d.length, y.length), ke = [], A = 0, X = Ne - 1;
          for (B = 0; B < Ne; B++) if (y[B]) {
            A = B;
            break;
          }
          for (B = Ne - 1; B >= A; B--) if (y[B]) {
            X = B;
            break;
          }
          for (B = A; B <= X; B++) if (n(d[B]) && n(y[B])) {
            var H = { p: d[B], s: y[B], b: 0 };
            M.enabled || (H.pts = Y[B], ie ? H.ph0 = H.ph1 = Y[B].length ? U[Y[B][0]] : d[B] : (u._computePh = !0, H.ph0 = Ue(K[B]), H.ph1 = Ue(K[B + 1], !0))), ke.push(H);
          }
          return ke.length === 1 && (ke[0].width1 = i.tickIncrement(ke[0].p, q.size, !1, P) - ke[0].p), o(u, "marker") && r(m, u, { vals: u.marker.color, containerStr: "marker", cLetter: "c" }), o(u, "marker.line") && r(m, u, { vals: u.marker.line.color, containerStr: "marker.line", cLetter: "c" }), s(ke, u), e.isArrayOrTypedArray(u.selectedpoints) && e.tagSelected(ke, u, Ae), ke;
        }
        function v(m, u, d, y, _) {
          var T = y + "bins", R = m._fullLayout, I = u["_" + y + "bingroup"], P = R._histogramBinOpts[I], M = R.barmode === "overlay", B, z, q, U, G, K, te, V = function(Ce) {
            return d.r2c(Ce, 0, U);
          }, Z = function(Ce) {
            return d.c2r(Ce, 0, U);
          }, Y = d.type === "date" ? function(Ce) {
            return Ce || Ce === 0 ? e.cleanDate(Ce, null, U) : null;
          } : function(Ce) {
            return n(Ce) ? Number(Ce) : null;
          };
          function C(Ce, Ue, Ne) {
            Ue[Ce + "Found"] ? (Ue[Ce] = Y(Ue[Ce]), Ue[Ce] === null && (Ue[Ce] = Ne[Ce])) : (K[Ce] = Ue[Ce] = Ne[Ce], e.nestedProperty(z[0], T + "." + Ce).set(Ne[Ce]));
          }
          if (u["_" + y + "autoBinFinished"]) delete u["_" + y + "autoBinFinished"];
          else {
            z = P.traces;
            var j = [], J = !0, ne = !1, ae = !1;
            for (B = 0; B < z.length; B++) if (q = z[B], q.visible) {
              var se = P.dirs[B];
              G = q["_" + se + "pos0"] = d.makeCalcdata(q, se), j = e.concat(j, G), delete q["_" + y + "autoBinFinished"], u.visible === !0 && (J ? J = !1 : (delete q._autoBin, q["_" + y + "autoBinFinished"] = 1), a.traceIs(q, "2dMap") && (ne = !0), q.type === "histogram2dcontour" && (ae = !0));
            }
            U = z[0][y + "calendar"];
            var O = i.autoBin(j, d, P.nbins, ne, U, P.sizeFound && P.size), F = z[0]._autoBin = {};
            if (K = F[P.dirs[0]] = {}, ae && (P.size || (O.start = Z(i.tickIncrement(V(O.start), O.size, !0, U))), P.end === void 0 && (O.end = Z(i.tickIncrement(V(O.end), O.size, !1, U)))), M && !a.traceIs(u, "2dMap") && O._dataSpan === 0 && d.type !== "category" && d.type !== "multicategory" && u.bingroup === "" && typeof u.xbins > "u") {
              if (_) return [O, G, !0];
              O = g(m, u, d, y, T);
            }
            te = q.cumulative || {}, te.enabled && te.currentbin !== "include" && (te.direction === "decreasing" ? O.start = Z(i.tickIncrement(V(O.start), O.size, !0, U)) : O.end = Z(i.tickIncrement(V(O.end), O.size, !1, U))), P.size = O.size, P.sizeFound || (K.size = O.size, e.nestedProperty(z[0], T + ".size").set(O.size)), C("start", P, O), C("end", P, O);
          }
          G = u["_" + y + "pos0"], delete u["_" + y + "pos0"];
          var S = u._input[T] || {}, $ = e.extendFlat({}, P), re = P.start, E = d.r2l(S.start), w = E !== void 0;
          if ((P.startFound || w) && E !== d.r2l(re)) {
            var N = w ? E : e.aggNums(Math.min, null, G), W = { type: d.type === "category" || d.type === "multicategory" ? "linear" : d.type, r2l: d.r2l, dtick: P.size, tick0: re, calendar: U, range: [N, i.tickIncrement(N, P.size, !1, U)].map(d.l2r) }, ee = i.tickFirst(W);
            ee > d.r2l(N) && (ee = i.tickIncrement(ee, P.size, !0, U)), $.start = d.l2r(ee), w || e.nestedProperty(u, T + ".start").set($.start);
          }
          var le = P.end, ie = d.r2l(S.end), pe = ie !== void 0;
          if ((P.endFound || pe) && ie !== d.r2l(le)) {
            var _e = pe ? ie : e.aggNums(Math.max, null, G);
            $.end = d.l2r(_e), pe || e.nestedProperty(u, T + ".start").set($.end);
          }
          var Ae = "autobin" + y;
          return u._input[Ae] === !1 && (u._input[T] = e.extendFlat({}, u[T] || {}), delete u._input[Ae], delete u[Ae]), [$, G];
        }
        function g(m, u, d, y, _) {
          var T = m._fullLayout, R = x(m, u), I = !1, P = 1 / 0, M = [u], B, z, q;
          for (B = 0; B < R.length; B++) if (z = R[B], z === u) I = !0;
          else if (!I) q = T._histogramBinOpts[z["_" + y + "bingroup"]], P = Math.min(P, q.size || z[_].size);
          else {
            var U = v(m, z, d, y, !0), G = U[0], K = U[2];
            z["_" + y + "autoBinFinished"] = 1, z["_" + y + "pos0"] = U[1], K ? M.push(z) : P = Math.min(P, G.size);
          }
          var te = new Array(M.length);
          for (B = 0; B < M.length; B++) for (var V = M[B]["_" + y + "pos0"], Z = 0; Z < V.length; Z++) if (V[Z] !== void 0) {
            te[B] = V[Z];
            break;
          }
          for (isFinite(P) || (P = e.distinctVals(te).minDiff), B = 0; B < M.length; B++) {
            z = M[B];
            var Y = z[y + "calendar"], C = { start: d.c2r(te[B] - P / 2, 0, Y), end: d.c2r(te[B] + P / 2, 0, Y), size: P };
            z._input[_] = z[_] = C, q = T._histogramBinOpts[z["_" + y + "bingroup"]], q && e.extendFlat(q, C);
          }
          return u[_];
        }
        function x(m, u) {
          for (var d = u.xaxis, y = u.yaxis, _ = u.orientation, T = [], R = m._fullData, I = 0; I < R.length; I++) {
            var P = R[I];
            P.type === "histogram" && P.visible === !0 && P.orientation === _ && P.xaxis === d && P.yaxis === y && T.push(P);
          }
          return T;
        }
        function h(m, u, d) {
          var y, _, T;
          function R(P) {
            T = m[P], m[P] /= 2;
          }
          function I(P) {
            _ = m[P], m[P] = T + _ / 2, T += _;
          }
          if (d === "half") if (u === "increasing") for (R(0), y = 1; y < m.length; y++) I(y);
          else for (R(m.length - 1), y = m.length - 2; y >= 0; y--) I(y);
          else if (u === "increasing") {
            for (y = 1; y < m.length; y++) m[y] += m[y - 1];
            d === "exclude" && (m.unshift(0), m.pop());
          } else {
            for (y = m.length - 2; y >= 0; y--) m[y] += m[y + 1];
            d === "exclude" && (m.push(0), m.shift());
          }
        }
        k.exports = { calc: f, calcAllAutoBins: v };
      }), A0 = xe((L, k) => {
        var n = wt(), e = Ar(), a = yu(), i = mu(), o = xu(), r = bu(), s = _u().calcAllAutoBins;
        k.exports = function(l, f) {
          var v = e.getFromId(l, f.xaxis), g = e.getFromId(l, f.yaxis), x = f.xcalendar, h = f.ycalendar, m = function(_t) {
            return v.r2c(_t, 0, x);
          }, u = function(_t) {
            return g.r2c(_t, 0, h);
          }, d = function(_t) {
            return v.c2r(_t, 0, x);
          }, y = function(_t) {
            return g.c2r(_t, 0, h);
          }, _, T, R, I, P = s(l, f, v, "x"), M = P[0], B = P[1], z = s(l, f, g, "y"), q = z[0], U = z[1], G = f._length;
          B.length > G && B.splice(G, B.length - G), U.length > G && U.splice(G, U.length - G);
          var K = [], te = [], V = [], Z = typeof M.size == "string", Y = typeof q.size == "string", C = [], j = [], J = Z ? C : M, ne = Y ? j : q, ae = 0, se = [], O = [], F = f.histnorm, S = f.histfunc, $ = F.indexOf("density") !== -1, re = S === "max" || S === "min", E = re ? null : 0, w = a.count, N = i[F], W = !1, ee = [], le = [], ie = "z" in f ? f.z : "marker" in f && Array.isArray(f.marker.color) ? f.marker.color : "";
          ie && S !== "count" && (W = S === "avg", w = a[S]);
          var pe = M.size, _e = m(M.start), Ae = m(M.end) + (_e - e.tickIncrement(_e, pe, !1, x)) / 1e6;
          for (_ = _e; _ < Ae; _ = e.tickIncrement(_, pe, !1, x)) te.push(E), C.push(_), W && V.push(0);
          C.push(_);
          var Ce = te.length, Ue = (_ - _e) / Ce, Ne = d(_e + Ue / 2), ke = q.size, A = u(q.start), X = u(q.end) + (A - e.tickIncrement(A, ke, !1, h)) / 1e6;
          for (_ = A; _ < X; _ = e.tickIncrement(_, ke, !1, h)) {
            K.push(te.slice()), j.push(_);
            var H = new Array(Ce);
            for (T = 0; T < Ce; T++) H[T] = [];
            O.push(H), W && se.push(V.slice());
          }
          j.push(_);
          var ve = K.length, be = (_ - A) / ve, Se = y(A + be / 2);
          $ && (ee = c(te.length, J, Ue, Z), le = c(K.length, ne, be, Y)), !Z && v.type === "date" && (J = t(m, J)), !Y && g.type === "date" && (ne = t(u, ne));
          var De = !0, He = !0, Ze = new Array(Ce), We = new Array(ve), $e = 1 / 0, it = 1 / 0, Ke = 1 / 0, ct = 1 / 0;
          for (_ = 0; _ < G; _++) {
            var gt = B[_], ht = U[_];
            R = n.findBin(gt, J), I = n.findBin(ht, ne), R >= 0 && R < Ce && I >= 0 && I < ve && (ae += w(R, _, K[I], ie, se[I]), O[I][R].push(_), De && (Ze[R] === void 0 ? Ze[R] = gt : Ze[R] !== gt && (De = !1)), He && (We[I] === void 0 ? We[I] = ht : We[I] !== ht && (He = !1)), $e = Math.min($e, gt - C[R]), it = Math.min(it, C[R + 1] - gt), Ke = Math.min(Ke, ht - j[I]), ct = Math.min(ct, j[I + 1] - ht));
          }
          if (W) for (I = 0; I < ve; I++) ae += o(K[I], se[I]);
          if (N) for (I = 0; I < ve; I++) N(K[I], ae, ee, le[I]);
          return { x: B, xRanges: p(C, De && Ze, $e, it, v, x), x0: Ne, dx: Ue, y: U, yRanges: p(j, He && We, Ke, ct, g, h), y0: Se, dy: be, z: K, pts: O };
        };
        function c(l, f, v, g) {
          var x = new Array(l), h;
          if (g) for (h = 0; h < l; h++) x[h] = 1 / (f[h + 1] - f[h]);
          else {
            var m = 1 / v;
            for (h = 0; h < l; h++) x[h] = m;
          }
          return x;
        }
        function t(l, f) {
          return { start: l(f.start), end: l(f.end), size: f.size };
        }
        function p(l, f, v, g, x, h) {
          var m, u = l.length - 1, d = new Array(u), y = r(v, g, l, x, h);
          for (m = 0; m < u; m++) {
            var _ = (f || [])[m];
            d[m] = _ === void 0 ? [y(l[m]), y(l[m + 1], !0)] : [_, _];
          }
          return d;
        }
      }), S0 = xe((L, k) => {
        var n = wt(), e = Yr().BADNUM, a = ii();
        k.exports = function(i, o, r, s, c, t) {
          var p = i._length, l = o.makeCalcdata(i, s), f = r.makeCalcdata(i, c);
          l = a(i, o, s, l).vals, f = a(i, r, c, f).vals;
          var v = i.text, g = v !== void 0 && n.isArray1D(v), x = i.hovertext, h = x !== void 0 && n.isArray1D(x), m, u, d = n.distinctVals(l), y = d.vals, _ = n.distinctVals(f), T = _.vals, R = [], I, P, M = T.length, B = y.length;
          for (m = 0; m < t.length; m++) R[m] = n.init2dArray(M, B);
          g && (I = n.init2dArray(M, B)), h && (P = n.init2dArray(M, B));
          var z = n.init2dArray(M, B);
          for (m = 0; m < p; m++) if (l[m] !== e && f[m] !== e) {
            var q = n.findBin(l[m] + d.minDiff / 2, y), U = n.findBin(f[m] + _.minDiff / 2, T);
            for (u = 0; u < t.length; u++) {
              var G = t[u], K = i[G], te = R[u];
              te[U][q] = K[m], z[U][q] = m;
            }
            g && (I[U][q] = v[m]), h && (P[U][q] = x[m]);
          }
          for (i["_" + s] = y, i["_" + c] = T, u = 0; u < t.length; u++) i["_" + t[u]] = R[u];
          g && (i._text = I), h && (i._hovertext = P), o && o.type === "category" && (i["_" + s + "CategoryMap"] = y.map(function(V) {
            return o._categories[V];
          })), r && r.type === "category" && (i["_" + c + "CategoryMap"] = T.map(function(V) {
            return r._categories[V];
          })), i._after2before = z;
        };
      }), L0 = xe((L, k) => {
        var n = xr(), e = wt(), a = Yr().BADNUM;
        k.exports = function(i, o, r, s) {
          var c, t, p, l, f, v;
          function g(y) {
            if (n(y)) return +y;
          }
          if (o && o.transpose) {
            for (c = 0, f = 0; f < i.length; f++) c = Math.max(c, i[f].length);
            if (c === 0) return !1;
            p = function(y) {
              return y.length;
            }, l = function(y, _, T) {
              return (y[T] || [])[_];
            };
          } else c = i.length, p = function(y, _) {
            return y[_].length;
          }, l = function(y, _, T) {
            return (y[_] || [])[T];
          };
          var x = function(y, _, T) {
            return _ === a || T === a ? a : l(y, _, T);
          };
          function h(y) {
            if (o && o.type !== "carpet" && o.type !== "contourcarpet" && y && y.type === "category" && o["_" + y._id.charAt(0)].length) {
              var _ = y._id.charAt(0), T = {}, R = o["_" + _ + "CategoryMap"] || o[_];
              for (f = 0; f < R.length; f++) T[R[f]] = f;
              return function(I) {
                var P = T[y._categories[I]];
                return P + 1 ? P : a;
              };
            } else return e.identity;
          }
          var m = h(r), u = h(s);
          s && s.type === "category" && (c = s._categories.length);
          var d = new Array(c);
          for (f = 0; f < c; f++) for (r && r.type === "category" ? t = r._categories.length : t = p(i, f), d[f] = new Array(t), v = 0; v < t; v++) d[f][v] = g(x(i, u(f), m(v)));
          return d;
        };
      }), O0 = xe((L, k) => {
        var n = wt(), e = 0.01, a = [[-1, 0], [1, 0], [0, -1], [0, 1]];
        function i(r) {
          return 0.5 - 0.25 * Math.min(1, r * 0.5);
        }
        k.exports = function(r, s) {
          var c = 1, t;
          for (o(r, s), t = 0; t < s.length && !(s[t][2] < 4); t++) ;
          for (s = s.slice(t), t = 0; t < 100 && c > e; t++) c = o(r, s, i(c));
          return c > e && n.log("interp2d didn't converge quickly", c), r;
        };
        function o(r, s, c) {
          var t = 0, p, l, f, v, g, x, h, m, u, d, y, _, T;
          for (v = 0; v < s.length; v++) {
            for (p = s[v], l = p[0], f = p[1], y = r[l][f], d = 0, u = 0, g = 0; g < 4; g++) x = a[g], h = r[l + x[0]], h && (m = h[f + x[1]], m !== void 0 && (d === 0 ? _ = T = m : (_ = Math.min(_, m), T = Math.max(T, m)), u++, d += m));
            if (u === 0) throw "iterateInterp2d order is wrong: no defined neighbors";
            r[l][f] = d / u, y === void 0 ? u < 4 && (t = 1) : (r[l][f] = (1 + c) * r[l][f] - c * y, T > _ && (t = Math.max(t, Math.abs(r[l][f] - y) / (T - _))));
          }
          return t;
        }
      }), C0 = xe((L, k) => {
        var n = wt().maxRowLength;
        k.exports = function(e) {
          var a = [], i = {}, o = [], r = e[0], s = [], c = [0, 0, 0], t = n(e), p, l, f, v, g, x, h, m;
          for (l = 0; l < e.length; l++) for (p = s, s = r, r = e[l + 1] || [], f = 0; f < t; f++) s[f] === void 0 && (x = (s[f - 1] !== void 0 ? 1 : 0) + (s[f + 1] !== void 0 ? 1 : 0) + (p[f] !== void 0 ? 1 : 0) + (r[f] !== void 0 ? 1 : 0), x ? (l === 0 && x++, f === 0 && x++, l === e.length - 1 && x++, f === s.length - 1 && x++, x < 4 && (i[[l, f]] = [l, f, x]), a.push([l, f, x])) : o.push([l, f]));
          for (; o.length; ) {
            for (h = {}, m = !1, g = o.length - 1; g >= 0; g--) v = o[g], l = v[0], f = v[1], x = ((i[[l - 1, f]] || c)[2] + (i[[l + 1, f]] || c)[2] + (i[[l, f - 1]] || c)[2] + (i[[l, f + 1]] || c)[2]) / 20, x && (h[v] = [l, f, x], o.splice(g, 1), m = !0);
            if (!m) throw "findEmpties iterated with no new neighbors";
            for (v in h) i[v] = h[v], a.push(h[v]);
          }
          return a.sort(function(u, d) {
            return d[2] - u[2];
          });
        };
      }), E0 = xe((L, k) => {
        var n = or(), e = wt().isArrayOrTypedArray;
        k.exports = function(a, i, o, r, s, c) {
          var t = [], p = n.traceIs(a, "contour"), l = n.traceIs(a, "histogram"), f, v, g, x = e(i) && i.length > 1;
          if (x && !l && c.type !== "category") {
            var h = i.length;
            if (h <= s) {
              if (p) t = Array.from(i).slice(0, s);
              else if (s === 1) c.type === "log" ? t = [0.5 * i[0], 2 * i[0]] : t = [i[0] - 0.5, i[0] + 0.5];
              else if (c.type === "log") {
                for (t = [Math.pow(i[0], 1.5) / Math.pow(i[1], 0.5)], g = 1; g < h; g++) t.push(Math.sqrt(i[g - 1] * i[g]));
                t.push(Math.pow(i[h - 1], 1.5) / Math.pow(i[h - 2], 0.5));
              } else {
                for (t = [1.5 * i[0] - 0.5 * i[1]], g = 1; g < h; g++) t.push((i[g - 1] + i[g]) * 0.5);
                t.push(1.5 * i[h - 1] - 0.5 * i[h - 2]);
              }
              if (h < s) {
                var m = t[t.length - 1], u;
                if (c.type === "log") for (u = m / t[t.length - 2], g = h; g < s; g++) m *= u, t.push(m);
                else for (u = m - t[t.length - 2], g = h; g < s; g++) m += u, t.push(m);
              }
            } else return p ? i.slice(0, s) : i.slice(0, s + 1);
          } else {
            var d = a[c._id.charAt(0) + "calendar"];
            if (l) f = c.r2c(o, 0, d);
            else if (e(i) && i.length === 1) f = i[0];
            else if (o === void 0) f = 0;
            else {
              var y = c.type === "log" ? c.d2c : c.r2c;
              f = y(o, 0, d);
            }
            for (v = r || 1, g = p ? 0 : -0.5; g < s; g++) t.push(f + v * g);
          }
          return t;
        };
      }), el = xe((L, k) => {
        var n = or(), e = wt(), a = Ar(), i = ii(), o = A0(), r = ei(), s = S0(), c = L0(), t = O0(), p = C0(), l = E0(), f = Yr().BADNUM;
        k.exports = function(x, h) {
          var m = a.getFromId(x, h.xaxis || "x"), u = a.getFromId(x, h.yaxis || "y"), d = n.traceIs(h, "contour"), y = n.traceIs(h, "histogram"), _ = d ? "best" : h.zsmooth, T, R, I, P, M, B, z, q, U, G, K;
          if (m._minDtick = 0, u._minDtick = 0, y) K = o(x, h), P = K.orig_x, T = K.x, R = K.x0, I = K.dx, q = K.orig_y, M = K.y, B = K.y0, z = K.dy, U = K.z;
          else {
            var te = h.z;
            e.isArray1D(te) ? (s(h, m, u, "x", "y", ["z"]), T = h._x, M = h._y, te = h._z) : (P = h.x ? m.makeCalcdata(h, "x") : [], q = h.y ? u.makeCalcdata(h, "y") : [], T = i(h, m, "x", P).vals, M = i(h, u, "y", q).vals, h._x = T, h._y = M), R = h.x0, I = h.dx, B = h.y0, z = h.dy, U = c(te, h, m, u);
          }
          (m.rangebreaks || u.rangebreaks) && (U = g(T, M, U), y || (T = v(T), M = v(M), h._x = T, h._y = M)), !y && (d || h.connectgaps) && (h._emptypoints = p(U), t(U, h._emptypoints));
          function V(O) {
            _ = h._input.zsmooth = h.zsmooth = !1, e.warn('cannot use zsmooth: "fast": ' + O);
          }
          function Z(O) {
            if (O.length > 1) {
              var F = (O[O.length - 1] - O[0]) / (O.length - 1), S = Math.abs(F / 100);
              for (G = 0; G < O.length - 1; G++) if (Math.abs(O[G + 1] - O[G] - F) > S) return !1;
            }
            return !0;
          }
          h._islinear = !1, m.type === "log" || u.type === "log" ? _ === "fast" && V("log axis found") : Z(T) ? Z(M) ? h._islinear = !0 : _ === "fast" && V("y scale is not linear") : _ === "fast" && V("x scale is not linear");
          var Y = e.maxRowLength(U), C = h.xtype === "scaled" ? "" : T, j = l(h, C, R, I, Y, m), J = h.ytype === "scaled" ? "" : M, ne = l(h, J, B, z, U.length, u);
          h._extremes[m._id] = a.findExtremes(m, j), h._extremes[u._id] = a.findExtremes(u, ne);
          var ae = { x: j, y: ne, z: U, text: h._text || h.text, hovertext: h._hovertext || h.hovertext };
          if (h.xperiodalignment && P && (ae.orig_x = P), h.yperiodalignment && q && (ae.orig_y = q), C && C.length === j.length - 1 && (ae.xCenter = C), J && J.length === ne.length - 1 && (ae.yCenter = J), y && (ae.xRanges = K.xRanges, ae.yRanges = K.yRanges, ae.pts = K.pts), d || r(x, h, { vals: U, cLetter: "z" }), d && h.contours && h.contours.coloring === "heatmap") {
            var se = { type: h.type === "contour" ? "heatmap" : "histogram2d", xcalendar: h.xcalendar, ycalendar: h.ycalendar };
            ae.xfill = l(se, C, R, I, Y, m), ae.yfill = l(se, J, B, z, U.length, u);
          }
          return [ae];
        };
        function v(x) {
          for (var h = [], m = x.length, u = 0; u < m; u++) {
            var d = x[u];
            d !== f && h.push(d);
          }
          return h;
        }
        function g(x, h, m) {
          for (var u = [], d = -1, y = 0; y < m.length; y++) if (h[y] !== f) {
            d++, u[d] = [];
            for (var _ = 0; _ < m[y].length; _++) x[_] !== f && u[d].push(m[y][_]);
          }
          return u;
        }
      }), tl = xe((L) => {
        L.CSS_DECLARATIONS = [["image-rendering", "optimizeSpeed"], ["image-rendering", "-moz-crisp-edges"], ["image-rendering", "-o-crisp-edges"], ["image-rendering", "-webkit-optimize-contrast"], ["image-rendering", "optimize-contrast"], ["image-rendering", "crisp-edges"], ["image-rendering", "pixelated"]], L.STYLE = L.CSS_DECLARATIONS.map(function(k) {
          return k.join(": ") + "; ";
        }).join("");
      }), wu = xe((L, k) => {
        var n = tl(), e = Or(), a = wt(), i = null;
        function o() {
          if (i !== null) return i;
          i = !1;
          var r = a.isSafari() || a.isMacWKWebView() || a.isIOS();
          if (window.navigator.userAgent && !r) {
            var s = Array.from(n.CSS_DECLARATIONS).reverse(), c = window.CSS && window.CSS.supports || window.supportsCSS;
            if (typeof c == "function") i = s.some(function(f) {
              return c.apply(null, f);
            });
            else {
              var t = e.tester.append("image").attr("style", n.STYLE), p = window.getComputedStyle(t.node()), l = p.imageRendering;
              i = s.some(function(f) {
                var v = f[1];
                return l === v || l === v.toLowerCase();
              }), t.remove();
            }
          }
          return i;
        }
        k.exports = o;
      }), rl = xe((L, k) => {
        var n = vr(), e = Nn(), a = or(), i = Or(), o = Ar(), r = wt(), s = xn(), c = Hs(), t = fr(), p = fa().extractOpts, l = fa().makeColorScaleFuncFromTrace, f = va(), v = kn(), g = v.LINE_SPACING, x = wu(), h = tl().STYLE, m = "heatmap-label";
        function u(R) {
          return R.selectAll("g." + m);
        }
        function d(R) {
          u(R).remove();
        }
        k.exports = function(R, I, P, M) {
          var B = I.xaxis, z = I.yaxis;
          r.makeTraceGroups(M, P, "hm").each(function(q) {
            var U = n.select(this), G = q[0], K = G.trace, te = K.xgap || 0, V = K.ygap || 0, Z = G.z, Y = G.x, C = G.y, j = G.xCenter, J = G.yCenter, ne = a.traceIs(K, "contour"), ae = ne ? "best" : K.zsmooth, se = Z.length, O = r.maxRowLength(Z), F = !1, S = !1, $, re, E, w, N, W, ee, le;
            for (W = 0; $ === void 0 && W < Y.length - 1; ) $ = B.c2p(Y[W]), W++;
            for (W = Y.length - 1; re === void 0 && W > 0; ) re = B.c2p(Y[W]), W--;
            for (re < $ && (E = re, re = $, $ = E, F = !0), W = 0; w === void 0 && W < C.length - 1; ) w = z.c2p(C[W]), W++;
            for (W = C.length - 1; N === void 0 && W > 0; ) N = z.c2p(C[W]), W--;
            N < w && (E = w, w = N, N = E, S = !0), ne && (j = Y, J = C, Y = G.xfill, C = G.yfill);
            var ie = "default";
            if (ae ? ie = ae === "best" ? "smooth" : "fast" : K._islinear && te === 0 && V === 0 && x() && (ie = "fast"), ie !== "fast") {
              var pe = ae === "best" ? 0 : 0.5;
              $ = Math.max(-pe * B._length, $), re = Math.min((1 + pe) * B._length, re), w = Math.max(-pe * z._length, w), N = Math.min((1 + pe) * z._length, N);
            }
            var _e = Math.round(re - $), Ae = Math.round(N - w), Ce = $ >= B._length || re <= 0 || w >= z._length || N <= 0;
            if (Ce) {
              var Ue = U.selectAll("image").data([]);
              Ue.exit().remove(), d(U);
              return;
            }
            var Ne, ke;
            ie === "fast" ? (Ne = O, ke = se) : (Ne = _e, ke = Ae);
            var A = document.createElement("canvas");
            A.width = Ne, A.height = ke;
            var X = A.getContext("2d", { willReadFrequently: !0 }), H = l(K, { noNumericCheck: !0, returnArray: !0 }), ve, be;
            ie === "fast" ? (ve = F ? function(Lt) {
              return O - 1 - Lt;
            } : r.identity, be = S ? function(Lt) {
              return se - 1 - Lt;
            } : r.identity) : (ve = function(Lt) {
              return r.constrain(Math.round(B.c2p(Y[Lt]) - $), 0, _e);
            }, be = function(Lt) {
              return r.constrain(Math.round(z.c2p(C[Lt]) - w), 0, Ae);
            });
            var Se = be(0), De = [Se, Se], He = F ? 0 : 1, Ze = S ? 0 : 1, We = 0, $e = 0, it = 0, Ke = 0, ct, gt, ht, _t, Te;
            function Ie(Lt, ur) {
              if (Lt !== void 0) {
                var Ht = H(Lt);
                return Ht[0] = Math.round(Ht[0]), Ht[1] = Math.round(Ht[1]), Ht[2] = Math.round(Ht[2]), We += ur, $e += Ht[0] * ur, it += Ht[1] * ur, Ke += Ht[2] * ur, Ht;
              }
              return [0, 0, 0, 0];
            }
            function ce(Lt, ur, Ht, mr) {
              var ar = Lt[Ht.bin0];
              if (ar === void 0) return Ie(void 0, 1);
              var kr = Lt[Ht.bin1], _r = ur[Ht.bin0], Cr = ur[Ht.bin1], Yt = kr - ar || 0, Sr = _r - ar || 0, Tr;
              return kr === void 0 ? Cr === void 0 ? Tr = 0 : _r === void 0 ? Tr = 2 * (Cr - ar) : Tr = (2 * Cr - _r - ar) * 2 / 3 : Cr === void 0 ? _r === void 0 ? Tr = 0 : Tr = (2 * ar - kr - _r) * 2 / 3 : _r === void 0 ? Tr = (2 * Cr - kr - ar) * 2 / 3 : Tr = Cr + ar - kr - _r, Ie(ar + Ht.frac * Yt + mr.frac * (Sr + Ht.frac * Tr));
            }
            if (ie !== "default") {
              var ge = 0, ye;
              try {
                ye = new Uint8Array(Ne * ke * 4);
              } catch {
                ye = new Array(Ne * ke * 4);
              }
              if (ie === "smooth") {
                var Me = j || Y, Oe = J || C, je = new Array(Me.length), qe = new Array(Oe.length), Qe = new Array(_e), Xe = j ? _ : y, Je = J ? _ : y, ot, lt, st;
                for (W = 0; W < Me.length; W++) je[W] = Math.round(B.c2p(Me[W]) - $);
                for (W = 0; W < Oe.length; W++) qe[W] = Math.round(z.c2p(Oe[W]) - w);
                for (W = 0; W < _e; W++) Qe[W] = Xe(W, je);
                for (ee = 0; ee < Ae; ee++) for (ot = Je(ee, qe), lt = Z[ot.bin0], st = Z[ot.bin1], W = 0; W < _e; W++, ge += 4) Te = ce(lt, st, Qe[W], ot), T(ye, ge, Te);
              } else for (ee = 0; ee < se; ee++) for (_t = Z[ee], De = be(ee), W = 0; W < O; W++) Te = Ie(_t[W], 1), ge = (De * O + ve(W)) * 4, T(ye, ge, Te);
              var xt = X.createImageData(Ne, ke);
              try {
                xt.data.set(ye);
              } catch {
                var Et = xt.data, Bt = Et.length;
                for (ee = 0; ee < Bt; ee++) Et[ee] = ye[ee];
              }
              X.putImageData(xt, 0, 0);
            } else {
              var qt = Math.floor(te / 2), jt = Math.floor(V / 2);
              for (ee = 0; ee < se; ee++) if (_t = Z[ee], De.reverse(), De[Ze] = be(ee + 1), !(De[0] === De[1] || De[0] === void 0 || De[1] === void 0)) for (gt = ve(0), ct = [gt, gt], W = 0; W < O; W++) ct.reverse(), ct[He] = ve(W + 1), !(ct[0] === ct[1] || ct[0] === void 0 || ct[1] === void 0) && (ht = _t[W], Te = Ie(ht, (ct[1] - ct[0]) * (De[1] - De[0])), X.fillStyle = "rgba(" + Te.join(",") + ")", X.fillRect(ct[0] + qt, De[0] + jt, ct[1] - ct[0] - te, De[1] - De[0] - V));
            }
            $e = Math.round($e / We), it = Math.round(it / We), Ke = Math.round(Ke / We);
            var It = e("rgb(" + $e + "," + it + "," + Ke + ")");
            R._hmpixcount = (R._hmpixcount || 0) + We, R._hmlumcount = (R._hmlumcount || 0) + We * It.getLuminance();
            var Tt = U.selectAll("image").data(q);
            Tt.enter().append("svg:image").attr({ xmlns: f.svg, preserveAspectRatio: "none" }), Tt.attr({ height: Ae, width: _e, x: $, y: w, "xlink:href": A.toDataURL("image/png") }), ie === "fast" && !ae && Tt.attr("style", h), d(U);
            var Rt = K.texttemplate;
            if (Rt) {
              var Vt = p(K), Ft = { type: "linear", range: [Vt.min, Vt.max], _separators: B._separators, _numFormat: B._numFormat }, Dt = K.type === "histogram2dcontour", Ct = K.type === "contour", Ot = Ct ? 1 : 0, Wt = Ct ? se - 1 : se, rr = Ct ? 1 : 0, Ut = Ct ? O - 1 : O, Qt = [];
              for (W = Ot; W < Wt; W++) {
                var nr;
                if (Ct) nr = G.y[W];
                else if (Dt) {
                  if (W === 0 || W === se - 1) continue;
                  nr = G.y[W];
                } else if (G.yCenter) nr = G.yCenter[W];
                else {
                  if (W + 1 === se && G.y[W + 1] === void 0) continue;
                  nr = (G.y[W] + G.y[W + 1]) / 2;
                }
                var cr = Math.round(z.c2p(nr));
                if (!(0 > cr || cr > z._length)) for (ee = rr; ee < Ut; ee++) {
                  var lr;
                  if (Ct) lr = G.x[ee];
                  else if (Dt) {
                    if (ee === 0 || ee === O - 1) continue;
                    lr = G.x[ee];
                  } else if (G.xCenter) lr = G.xCenter[ee];
                  else {
                    if (ee + 1 === O && G.x[ee + 1] === void 0) continue;
                    lr = (G.x[ee] + G.x[ee + 1]) / 2;
                  }
                  var $t = Math.round(B.c2p(lr));
                  if (!(0 > $t || $t > B._length)) {
                    var sr = c({ x: lr, y: nr }, K, R._fullLayout);
                    sr.x = lr, sr.y = nr;
                    var St = G.z[W][ee];
                    St === void 0 ? (sr.z = "", sr.zLabel = "") : (sr.z = St, sr.zLabel = o.tickText(Ft, St, "hover").text);
                    var Kt = G.text && G.text[W] && G.text[W][ee];
                    (Kt === void 0 || Kt === !1) && (Kt = ""), sr.text = Kt;
                    var hr = r.texttemplateString({ data: [sr, K._meta], fallback: K.texttemplatefallback, labels: sr, locale: R._fullLayout._d3locale, template: Rt });
                    if (hr) {
                      var he = hr.split("<br>"), fe = he.length, Pe = 0;
                      for (le = 0; le < fe; le++) Pe = Math.max(Pe, he[le].length);
                      Qt.push({ l: fe, c: Pe, t: hr, x: $t, y: cr, z: St });
                    }
                  }
                }
              }
              var Re = K.textfont, Ye = Re.size, Ee = R._fullLayout.font.size;
              if (!Ye || Ye === "auto") {
                var ze = 1 / 0, Ge = 1 / 0, Ve = 0, tt = 0;
                for (le = 0; le < Qt.length; le++) {
                  var at = Qt[le];
                  if (Ve = Math.max(Ve, at.l), tt = Math.max(tt, at.c), le < Qt.length - 1) {
                    var vt = Qt[le + 1], kt = Math.abs(vt.x - at.x), At = Math.abs(vt.y - at.y);
                    kt && (ze = Math.min(ze, kt)), At && (Ge = Math.min(Ge, At));
                  }
                }
                !isFinite(ze) || !isFinite(Ge) ? Ye = Ee : (ze -= te, Ge -= V, ze /= tt, Ge /= Ve, ze /= g / 2, Ge /= g, Ye = Math.min(Math.floor(ze), Math.floor(Ge), Ee));
              }
              if (Ye <= 0 || !isFinite(Ye)) return;
              var Nt = function(Lt) {
                return Lt.x;
              }, Mt = function(Lt) {
                return Lt.y - Ye * (Lt.l * g / 2 - 1);
              }, Pt = u(U).data(Qt);
              Pt.enter().append("g").classed(m, 1).append("text").attr("text-anchor", "middle").each(function(Lt) {
                var ur = n.select(this), Ht = Re.color;
                (!Ht || Ht === "auto") && (Ht = t.contrast(Lt.z === void 0 ? R._fullLayout.plot_bgcolor : "rgba(" + H(Lt.z).join() + ")")), ur.attr("data-notex", 1).call(s.positionText, Nt(Lt), Mt(Lt)).call(i.font, { family: Re.family, size: Ye, color: Ht, weight: Re.weight, style: Re.style, variant: Re.variant, textcase: Re.textcase, lineposition: Re.lineposition, shadow: Re.shadow }).text(Lt.t).call(s.convertToTspans, R);
              });
            }
          });
        };
        function y(R, I) {
          var P = I.length - 2, M = r.constrain(r.findBin(R, I), 0, P), B = I[M], z = I[M + 1], q = r.constrain(M + (R - B) / (z - B) - 0.5, 0, P), U = Math.round(q), G = Math.abs(q - U);
          return !q || q === P || !G ? { bin0: U, bin1: U, frac: 0 } : { bin0: U, frac: G, bin1: Math.round(U + G / (q - U)) };
        }
        function _(R, I) {
          var P = I.length - 1, M = r.constrain(r.findBin(R, I), 0, P), B = I[M], z = I[M + 1], q = (R - B) / (z - B) || 0;
          return q <= 0 ? { bin0: M, bin1: M, frac: 0 } : q < 0.5 ? { bin0: M, bin1: M + 1, frac: q } : { bin0: M + 1, bin1: M, frac: 1 - q };
        }
        function T(R, I, P) {
          R[I] = P[0], R[I + 1] = P[1], R[I + 2] = P[2], R[I + 3] = Math.round(P[3] * 255);
        }
      }), Tu = xe((L, k) => {
        k.exports = { min: "zmin", max: "zmax" };
      }), nl = xe((L, k) => {
        var n = vr();
        k.exports = function(e) {
          n.select(e).selectAll(".hm image").style("opacity", function(a) {
            return a.trace.opacity;
          });
        };
      }), al = xe((L, k) => {
        var n = Bn(), e = wt(), a = e.isArrayOrTypedArray, i = Ar(), o = fa().extractOpts;
        k.exports = function(r, s, c, t, p) {
          p || (p = {});
          var l = p.isContour, f = r.cd[0], v = f.trace, g = r.xa, x = r.ya, h = f.x, m = f.y, u = f.z, d = f.xCenter, y = f.yCenter, _ = f.zmask, T = v.zhoverformat, R = h, I = m, P, M, B, z;
          if (r.index !== !1) {
            try {
              B = Math.round(r.index[1]), z = Math.round(r.index[0]);
            } catch {
              e.error("Error hovering on heatmap, pointNumber must be [row,col], found:", r.index);
              return;
            }
            if (B < 0 || B >= u[0].length || z < 0 || z > u.length) return;
          } else {
            if (n.inbox(s - h[0], s - h[h.length - 1], 0) > 0 || n.inbox(c - m[0], c - m[m.length - 1], 0) > 0) return;
            if (l) {
              var q;
              for (R = [2 * h[0] - h[1]], q = 1; q < h.length; q++) R.push((h[q] + h[q - 1]) / 2);
              for (R.push([2 * h[h.length - 1] - h[h.length - 2]]), I = [2 * m[0] - m[1]], q = 1; q < m.length; q++) I.push((m[q] + m[q - 1]) / 2);
              I.push([2 * m[m.length - 1] - m[m.length - 2]]);
            }
            B = Math.max(0, Math.min(R.length - 2, e.findBin(s, R))), z = Math.max(0, Math.min(I.length - 2, e.findBin(c, I)));
          }
          var U = g.c2p(h[B]), G = g.c2p(h[B + 1]), K = x.c2p(m[z]), te = x.c2p(m[z + 1]), V, Z;
          l ? (V = f.orig_x || h, Z = f.orig_y || m, G = U, P = V[B], te = K, M = Z[z]) : (V = f.orig_x || d || h, Z = f.orig_y || y || m, P = d ? V[B] : (V[B] + V[B + 1]) / 2, M = y ? Z[z] : (Z[z] + Z[z + 1]) / 2, g && g.type === "category" && (P = h[B]), x && x.type === "category" && (M = m[z]), v.zsmooth && (U = G = g.c2p(P), K = te = x.c2p(M)));
          var Y = u[z][B];
          if (_ && !_[z][B] && (Y = void 0), !(Y === void 0 && !v.hoverongaps)) {
            var C;
            a(f.hovertext) && a(f.hovertext[z]) ? C = f.hovertext[z][B] : a(f.text) && a(f.text[z]) && (C = f.text[z][B]);
            var j = o(v), J = { type: "linear", range: [j.min, j.max], hoverformat: T, _separators: g._separators, _numFormat: g._numFormat }, ne = i.tickText(J, Y, "hover").text;
            return [e.extendFlat(r, { index: v._after2before ? v._after2before[z][B] : [z, B], distance: r.maxHoverDistance, spikeDistance: r.maxSpikeDistance, x0: U, x1: G, y0: K, y1: te, xLabelVal: P, yLabelVal: M, zLabelVal: Y, zLabel: ne, text: C })];
          }
        };
      }), D0 = xe((L, k) => {
        k.exports = { attributes: Ii(), supplyDefaults: M0(), calc: el(), plot: rl(), colorbar: Tu(), style: nl(), hoverPoints: al(), moduleType: "trace", name: "heatmap", basePlotModule: Kn(), categories: ["cartesian", "svg", "2dMap", "showLegend"], meta: {} };
      }), P0 = xe((L, k) => {
        k.exports = D0();
      }), ku = xe((L, k) => {
        k.exports = function(n, e) {
          return { start: { valType: "any", editType: "calc" }, end: { valType: "any", editType: "calc" }, size: { valType: "any", editType: "calc" }, editType: "calc" };
        };
      }), I0 = xe((L, k) => {
        k.exports = { eventDataKeys: ["binNumber"] };
      }), il = xe((L, k) => {
        var n = ja(), e = na().axisHoverFormat, { hovertemplateAttrs: a, texttemplateAttrs: i, templatefallbackAttrs: o } = qn(), r = hn(), s = ku(), c = I0(), t = Br().extendFlat;
        k.exports = { x: { valType: "data_array", editType: "calc+clearAxisTypes" }, y: { valType: "data_array", editType: "calc+clearAxisTypes" }, xhoverformat: e("x"), yhoverformat: e("y"), text: t({}, n.text, {}), hovertext: t({}, n.hovertext, {}), orientation: n.orientation, histfunc: { valType: "enumerated", values: ["count", "sum", "avg", "min", "max"], dflt: "count", editType: "calc" }, histnorm: { valType: "enumerated", values: ["", "percent", "probability", "density", "probability density"], dflt: "", editType: "calc" }, cumulative: { enabled: { valType: "boolean", dflt: !1, editType: "calc" }, direction: { valType: "enumerated", values: ["increasing", "decreasing"], dflt: "increasing", editType: "calc" }, currentbin: { valType: "enumerated", values: ["include", "exclude", "half"], dflt: "include", editType: "calc" }, editType: "calc" }, nbinsx: { valType: "integer", min: 0, dflt: 0, editType: "calc" }, xbins: s("x", !0), nbinsy: { valType: "integer", min: 0, dflt: 0, editType: "calc" }, ybins: s("y", !0), autobinx: { valType: "boolean", dflt: null, editType: "calc" }, autobiny: { valType: "boolean", dflt: null, editType: "calc" }, bingroup: { valType: "string", dflt: "", editType: "calc" }, hovertemplate: a({}, { keys: c.eventDataKeys }), hovertemplatefallback: o(), texttemplate: i({ arrayOk: !1, editType: "plot" }, { keys: ["label", "value"] }), texttemplatefallback: o({ editType: "plot" }), textposition: t({}, n.textposition, { arrayOk: !1 }), textfont: r({ arrayOk: !1, editType: "plot", colorEditType: "style" }), outsidetextfont: r({ arrayOk: !1, editType: "plot", colorEditType: "style" }), insidetextfont: r({ arrayOk: !1, editType: "plot", colorEditType: "style" }), insidetextanchor: n.insidetextanchor, textangle: n.textangle, cliponaxis: n.cliponaxis, constraintext: n.constraintext, marker: n.marker, offsetgroup: n.offsetgroup, alignmentgroup: n.alignmentgroup, selected: n.selected, unselected: n.unselected, zorder: n.zorder };
      }), z0 = xe((L, k) => {
        var n = or(), e = wt(), a = fr(), i = Ha().handleText, o = nu(), r = il();
        k.exports = function(s, c, t, p) {
          function l(I, P) {
            return e.coerce(s, c, r, I, P);
          }
          var f = l("x"), v = l("y"), g = l("cumulative.enabled");
          g && (l("cumulative.direction"), l("cumulative.currentbin")), l("text");
          var x = l("textposition");
          i(s, c, p, l, x, { moduleHasSelected: !0, moduleHasUnselected: !0, moduleHasConstrain: !0, moduleHasCliponaxis: !0, moduleHasTextangle: !0, moduleHasInsideanchor: !0 }), l("hovertext"), l("hovertemplate"), l("hovertemplatefallback"), l("xhoverformat"), l("yhoverformat");
          var h = l("orientation", v && !f ? "h" : "v"), m = h === "v" ? "x" : "y", u = h === "v" ? "y" : "x", d = f && v ? Math.min(e.minRowLength(f) && e.minRowLength(v)) : e.minRowLength(c[m] || []);
          if (!d) {
            c.visible = !1;
            return;
          }
          c._length = d;
          var y = n.getComponentMethod("calendars", "handleTraceDefaults");
          y(s, c, ["x", "y"], p);
          var _ = c[u];
          _ && l("histfunc"), l("histnorm"), l("autobin" + m), o(s, c, l, t, p), e.coerceSelectionMarkerOpacity(c, l);
          var T = (c.marker.line || {}).color, R = n.getComponentMethod("errorbars", "supplyDefaults");
          R(s, c, T || a.defaultLine, { axis: "y" }), R(s, c, T || a.defaultLine, { axis: "x", inherit: "y" }), l("zorder");
        };
      }), ol = xe((L, k) => {
        var n = wt(), e = sn(), a = or().traceIs, i = Oi(), o = Ha().validateCornerradius, r = n.nestedProperty, s = Fa().getAxisGroup, c = [{ aStr: { x: "xbins.start", y: "ybins.start" }, name: "start" }, { aStr: { x: "xbins.end", y: "ybins.end" }, name: "end" }, { aStr: { x: "xbins.size", y: "ybins.size" }, name: "size" }, { aStr: { x: "nbinsx", y: "nbinsy" }, name: "nbins" }], t = ["x", "y"];
        k.exports = function(p, l) {
          var f = l._histogramBinOpts = {}, v = [], g = {}, x = [], h, m, u, d, y, _, T;
          function R(ne, ae) {
            return n.coerce(h._input, h, h._module.attributes, ne, ae);
          }
          function I(ne) {
            return ne.orientation === "v" ? "x" : "y";
          }
          function P(ne, ae) {
            var se = e.getFromTrace({ _fullLayout: l }, ne, ae);
            return se.type;
          }
          function M(ne, ae, se) {
            var O = ne.uid + "__" + se;
            ae || (ae = O);
            var F = P(ne, se), S = ne[se + "calendar"] || "", $ = f[ae], re = !0;
            $ && (F === $.axType && S === $.calendar ? (re = !1, $.traces.push(ne), $.dirs.push(se)) : (ae = O, F !== $.axType && n.warn(["Attempted to group the bins of trace", ne.index, "set on a", "type:" + F, "axis", "with bins on", "type:" + $.axType, "axis."].join(" ")), S !== $.calendar && n.warn(["Attempted to group the bins of trace", ne.index, "set with a", S, "calendar", "with bins", $.calendar ? "on a " + $.calendar + " calendar" : "w/o a set calendar"].join(" ")))), re && (f[ae] = { traces: [ne], dirs: [se], axType: F, calendar: ne[se + "calendar"] || "" }), ne["_" + se + "bingroup"] = ae;
          }
          for (y = 0; y < p.length; y++) if (h = p[y], a(h, "histogram")) {
            if (v.push(h), delete h._xautoBinFinished, delete h._yautoBinFinished, h.type === "histogram") {
              var B = R("marker.cornerradius", l.barcornerradius);
              h.marker && (h.marker.cornerradius = o(B));
            }
            a(h, "2dMap") || i(h._input, h, l, R, l.barmode);
          }
          var z = l._alignmentOpts || {};
          for (y = 0; y < v.length; y++) {
            if (h = v[y], u = "", !a(h, "2dMap")) {
              if (d = I(h), l.barmode === "group" && h.alignmentgroup) {
                var q = h[d + "axis"], U = s(l, q) + h.orientation;
                (z[U] || {})[h.alignmentgroup] && (u = U);
              }
              !u && l.barmode !== "overlay" && (u = s(l, h.xaxis) + s(l, h.yaxis) + I(h));
            }
            u ? (g[u] || (g[u] = []), g[u].push(h)) : x.push(h);
          }
          for (u in g) {
            if (m = g[u], m.length === 1) {
              x.push(m[0]);
              continue;
            }
            var G = !1;
            for (m.length && (h = m[0], G = R("bingroup")), u = G || u, y = 0; y < m.length; y++) {
              h = m[y];
              var K = h._input.bingroup;
              K && K !== u && n.warn(["Trace", h.index, "must match", "within bingroup", u + ".", "Ignoring its bingroup:", K, "setting."].join(" ")), h.bingroup = u, M(h, u, I(h));
            }
          }
          for (y = 0; y < x.length; y++) {
            h = x[y];
            var te = R("bingroup");
            if (a(h, "2dMap")) for (T = 0; T < 2; T++) {
              d = t[T];
              var V = R(d + "bingroup", te ? te + "__" + d : null);
              M(h, V, d);
            }
            else M(h, te, I(h));
          }
          for (u in f) {
            var Z = f[u];
            for (m = Z.traces, _ = 0; _ < c.length; _++) {
              var Y = c[_], C = Y.name, j, J;
              if (!(C === "nbins" && Z.sizeFound)) {
                for (y = 0; y < m.length; y++) {
                  if (h = m[y], d = Z.dirs[y], j = Y.aStr[d], r(h._input, j).get() !== void 0) {
                    Z[C] = R(j), Z[C + "Found"] = !0;
                    break;
                  }
                  J = (h._autoBin || {})[d] || {}, J[C] && r(h, j).set(J[C]);
                }
                if (C === "start" || C === "end") for (; y < m.length; y++) h = m[y], h["_" + d + "bingroup"] && (J = (h._autoBin || {})[d] || {}, R(j, J[C]));
                C === "nbins" && !Z.sizeFound && !Z.nbinsFound && (h = m[0], Z[C] = R(j));
              }
            }
          }
        };
      }), R0 = xe((L, k) => {
        var n = ou().hoverPoints, e = Ar().hoverLabelText;
        k.exports = function(a, i, o, r, s) {
          var c = n(a, i, o, r, s);
          if (c) {
            a = c[0];
            var t = a.cd[a.index], p = a.cd[0].trace;
            if (!p.cumulative.enabled) {
              var l = p.orientation === "h" ? "y" : "x";
              a[l + "Label"] = e(a[l + "a"], [t.ph0, t.ph1], p[l + "hoverformat"]);
            }
            return c;
          }
        };
      }), Mu = xe((L, k) => {
        k.exports = function(n, e, a, i, o) {
          if (n.x = "xVal" in e ? e.xVal : e.x, n.y = "yVal" in e ? e.yVal : e.y, "zLabelVal" in e && (n.z = e.zLabelVal), e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), !(a.cumulative || {}).enabled) {
            var r = Array.isArray(o) ? i[0].pts[o[0]][o[1]] : i[o].pts;
            n.pointNumbers = r, n.binNumber = n.pointNumber, delete n.pointNumber, delete n.pointIndex;
            var s;
            if (a._indexToPoints) {
              s = [];
              for (var c = 0; c < r.length; c++) s = s.concat(a._indexToPoints[r[c]]);
            } else s = r;
            n.pointIndices = s;
          }
          return n;
        };
      }), N0 = xe((L, k) => {
        k.exports = { attributes: il(), layoutAttributes: Xo(), supplyDefaults: z0(), crossTraceDefaults: ol(), supplyLayoutDefaults: au(), calc: _u().calc, crossTraceCalc: Ho().crossTraceCalc, plot: iu().plot, layerName: "barlayer", style: li().style, styleOnSelect: li().styleOnSelect, colorbar: Ci(), hoverPoints: R0(), selectPoints: lu(), eventData: Mu(), moduleType: "trace", name: "histogram", basePlotModule: Kn(), categories: ["bar-like", "cartesian", "svg", "bar", "histogram", "oriented", "errorBarsOK", "showLegend"], meta: {} };
      }), F0 = xe((L, k) => {
        k.exports = N0();
      }), ll = xe((L, k) => {
        var n = il(), e = ku(), a = Ii(), i = Pn(), o = na().axisHoverFormat, { hovertemplateAttrs: r, texttemplateAttrs: s, templatefallbackAttrs: c } = qn(), t = ca(), p = Br().extendFlat;
        k.exports = p({ x: n.x, y: n.y, z: { valType: "data_array", editType: "calc" }, marker: { color: { valType: "data_array", editType: "calc" }, editType: "calc" }, histnorm: n.histnorm, histfunc: n.histfunc, nbinsx: n.nbinsx, xbins: e("x"), nbinsy: n.nbinsy, ybins: e("y"), autobinx: n.autobinx, autobiny: n.autobiny, bingroup: p({}, n.bingroup, {}), xbingroup: p({}, n.bingroup, {}), ybingroup: p({}, n.bingroup, {}), xgap: a.xgap, ygap: a.ygap, zsmooth: a.zsmooth, xhoverformat: o("x"), yhoverformat: o("y"), zhoverformat: o("z", 1), hovertemplate: r({}, { keys: ["z"] }), hovertemplatefallback: c(), texttemplate: s({ arrayOk: !1, editType: "plot" }, { keys: ["z"] }), texttemplatefallback: c({ editType: "plot" }), textfont: a.textfont, showlegend: p({}, i.showlegend, { dflt: !1 }) }, t("", { cLetter: "z", autoColorDflt: !1 }));
      }), Au = xe((L, k) => {
        var n = or(), e = wt();
        k.exports = function(a, i, o, r) {
          var s = o("x"), c = o("y"), t = e.minRowLength(s), p = e.minRowLength(c);
          if (!t || !p) {
            i.visible = !1;
            return;
          }
          i._length = Math.min(t, p);
          var l = n.getComponentMethod("calendars", "handleTraceDefaults");
          l(a, i, ["x", "y"], r);
          var f = o("z") || o("marker.color");
          f && o("histfunc"), o("histnorm"), o("autobinx"), o("autobiny");
        };
      }), B0 = xe((L, k) => {
        var n = wt(), e = Au(), a = gu(), i = ga(), o = zi(), r = ll();
        k.exports = function(s, c, t, p) {
          function l(f, v) {
            return n.coerce(s, c, r, f, v);
          }
          e(s, c, l, p), c.visible !== !1 && (a(s, c, l, p), i(s, c, p, l, { prefix: "", cLetter: "z" }), l("hovertemplate"), l("hovertemplatefallback"), o(l, p), l("xhoverformat"), l("yhoverformat"));
        };
      }), j0 = xe((L, k) => {
        var n = al(), e = Ar().hoverLabelText;
        k.exports = function(a, i, o, r, s) {
          var c = n(a, i, o, r, s);
          if (c) {
            a = c[0];
            var t = a.index, p = t[0], l = t[1], f = a.cd[0], v = f.trace, g = f.xRanges[l], x = f.yRanges[p];
            return a.xLabel = e(a.xa, [g[0], g[1]], v.xhoverformat), a.yLabel = e(a.ya, [x[0], x[1]], v.yhoverformat), c;
          }
        };
      }), H0 = xe((L, k) => {
        k.exports = { attributes: ll(), supplyDefaults: B0(), crossTraceDefaults: ol(), calc: el(), plot: rl(), layerName: "heatmaplayer", colorbar: Tu(), style: nl(), hoverPoints: j0(), eventData: Mu(), moduleType: "trace", name: "histogram2d", basePlotModule: Kn(), categories: ["cartesian", "svg", "2dMap", "histogram", "showLegend"], meta: {} };
      }), q0 = xe((L, k) => {
        k.exports = H0();
      }), sl = xe((L, k) => {
        k.exports = { COMPARISON_OPS: ["=", "!=", "<", ">=", ">", "<="], COMPARISON_OPS2: ["=", "<", ">=", ">", "<="], INTERVAL_OPS: ["[]", "()", "[)", "(]", "][", ")(", "](", ")["], SET_OPS: ["{}", "}{"], CONSTRAINT_REDUCTION: { "=": "=", "<": "<", "<=": "<", ">": ">", ">=": ">", "[]": "[]", "()": "[]", "[)": "[]", "(]": "[]", "][": "][", ")(": "][", "](": "][", ")[": "][" } };
      }), ul = xe((L, k) => {
        var n = Ii(), e = $n(), a = na(), i = a.axisHoverFormat, o = a.descriptionOnlyNumbers, r = ca(), s = Wn().dash, c = hn(), t = Br().extendFlat, p = sl(), l = p.COMPARISON_OPS2, f = p.INTERVAL_OPS, v = e.line;
        k.exports = t({ z: n.z, x: n.x, x0: n.x0, dx: n.dx, y: n.y, y0: n.y0, dy: n.dy, xperiod: n.xperiod, yperiod: n.yperiod, xperiod0: e.xperiod0, yperiod0: e.yperiod0, xperiodalignment: n.xperiodalignment, yperiodalignment: n.yperiodalignment, text: n.text, hovertext: n.hovertext, transpose: n.transpose, xtype: n.xtype, ytype: n.ytype, xhoverformat: i("x"), yhoverformat: i("y"), zhoverformat: i("z", 1), hovertemplate: n.hovertemplate, hovertemplatefallback: n.hovertemplatefallback, texttemplate: t({}, n.texttemplate, {}), texttemplatefallback: n.texttemplatefallback, textfont: t({}, n.textfont, {}), hoverongaps: n.hoverongaps, connectgaps: t({}, n.connectgaps, {}), fillcolor: { valType: "color", editType: "calc" }, autocontour: { valType: "boolean", dflt: !0, editType: "calc", impliedEdits: { "contours.start": void 0, "contours.end": void 0, "contours.size": void 0 } }, ncontours: { valType: "integer", dflt: 15, min: 1, editType: "calc" }, contours: { type: { valType: "enumerated", values: ["levels", "constraint"], dflt: "levels", editType: "calc" }, start: { valType: "number", dflt: null, editType: "plot", impliedEdits: { "^autocontour": !1 } }, end: { valType: "number", dflt: null, editType: "plot", impliedEdits: { "^autocontour": !1 } }, size: { valType: "number", dflt: null, min: 0, editType: "plot", impliedEdits: { "^autocontour": !1 } }, coloring: { valType: "enumerated", values: ["fill", "heatmap", "lines", "none"], dflt: "fill", editType: "calc" }, showlines: { valType: "boolean", dflt: !0, editType: "plot" }, showlabels: { valType: "boolean", dflt: !1, editType: "plot" }, labelfont: c({ editType: "plot", colorEditType: "style" }), labelformat: { valType: "string", dflt: "", editType: "plot", description: o("contour label") }, operation: { valType: "enumerated", values: [].concat(l).concat(f), dflt: "=", editType: "calc" }, value: { valType: "any", dflt: 0, editType: "calc" }, editType: "calc", impliedEdits: { autocontour: !1 } }, line: { color: t({}, v.color, { editType: "style+colorbars" }), width: { valType: "number", min: 0, editType: "style+colorbars" }, dash: s, smoothing: t({}, v.smoothing, {}), editType: "plot" }, zorder: e.zorder }, r("", { cLetter: "z", autoColorDflt: !1, editTypeOverride: "calc" }));
      }), Su = xe((L, k) => {
        var n = ll(), e = ul(), a = ca(), i = na().axisHoverFormat, o = Br().extendFlat;
        k.exports = o({ x: n.x, y: n.y, z: n.z, marker: n.marker, histnorm: n.histnorm, histfunc: n.histfunc, nbinsx: n.nbinsx, xbins: n.xbins, nbinsy: n.nbinsy, ybins: n.ybins, autobinx: n.autobinx, autobiny: n.autobiny, bingroup: n.bingroup, xbingroup: n.xbingroup, ybingroup: n.ybingroup, autocontour: e.autocontour, ncontours: e.ncontours, contours: e.contours, line: { color: e.line.color, width: o({}, e.line.width, { dflt: 0.5 }), dash: e.line.dash, smoothing: e.line.smoothing, editType: "plot" }, xhoverformat: i("x"), yhoverformat: i("y"), zhoverformat: i("z", 1), hovertemplate: n.hovertemplate, hovertemplatefallback: n.hovertemplatefallback, texttemplate: e.texttemplate, texttemplatefallback: e.texttemplatefallback, textfont: e.textfont }, a("", { cLetter: "z", editTypeOverride: "calc" }));
      }), Lu = xe((L, k) => {
        k.exports = function(n, e, a, i) {
          var o = i("contours.start"), r = i("contours.end"), s = o === !1 || r === !1, c = a("contours.size"), t;
          s ? t = e.autocontour = !0 : t = a("autocontour", !1), (t || !c) && a("ncontours");
        };
      }), Ou = xe((L, k) => {
        var n = wt();
        k.exports = function(e, a, i, o) {
          o || (o = {});
          var r = e("contours.showlabels");
          if (r) {
            var s = a.font;
            n.coerceFont(e, "contours.labelfont", s, { overrideDflt: { color: i } }), e("contours.labelformat");
          }
          o.hasHover !== !1 && e("zhoverformat");
        };
      }), Cu = xe((L, k) => {
        var n = ga(), e = Ou();
        k.exports = function(a, i, o, r, s) {
          var c = o("contours.coloring"), t, p = "";
          c === "fill" && (t = o("contours.showlines")), t !== !1 && (c !== "lines" && (p = o("line.color", "#000")), o("line.width", 0.5), o("line.dash")), c !== "none" && (a.showlegend !== !0 && (i.showlegend = !1), i._dfltShowLegend = !1, n(a, i, r, o, { prefix: "", cLetter: "z" })), o("line.smoothing"), e(o, r, p, s);
        };
      }), U0 = xe((L, k) => {
        var n = wt(), e = Au(), a = Lu(), i = Cu(), o = zi(), r = Su();
        k.exports = function(s, c, t, p) {
          function l(v, g) {
            return n.coerce(s, c, r, v, g);
          }
          function f(v) {
            return n.coerce2(s, c, r, v);
          }
          e(s, c, l, p), c.visible !== !1 && (a(s, c, l, f), i(s, c, l, p), l("xhoverformat"), l("yhoverformat"), l("hovertemplate"), l("hovertemplatefallback"), c.contours && c.contours.coloring === "heatmap" && o(l, p));
        };
      }), V0 = xe((L, k) => {
        var n = Ar(), e = wt();
        k.exports = function(i, o) {
          var r = i.contours;
          if (i.autocontour) {
            var s = i.zmin, c = i.zmax;
            (i.zauto || s === void 0) && (s = e.aggNums(Math.min, null, o)), (i.zauto || c === void 0) && (c = e.aggNums(Math.max, null, o));
            var t = a(s, c, i.ncontours);
            r.size = t.dtick, r.start = n.tickFirst(t), t.range.reverse(), r.end = n.tickFirst(t), r.start === s && (r.start += r.size), r.end === c && (r.end -= r.size), r.start > r.end && (r.start = r.end = (r.start + r.end) / 2), i._input.contours || (i._input.contours = {}), e.extendFlat(i._input.contours, { start: r.start, end: r.end, size: r.size }), i._input.autocontour = !0;
          } else if (r.type !== "constraint") {
            var p = r.start, l = r.end, f = i._input.contours;
            if (p > l && (r.start = f.start = l, l = r.end = f.end = p, p = r.start), !(r.size > 0)) {
              var v;
              p === l ? v = 1 : v = a(p, l, i.ncontours).dtick, f.size = r.size = v;
            }
          }
        };
        function a(i, o, r) {
          var s = { type: "linear", range: [i, o] };
          return n.autoTicks(s, (o - i) / (r || 15)), s;
        }
      }), Ri = xe((L, k) => {
        k.exports = function(n) {
          return n.end + n.size / 1e6;
        };
      }), Eu = xe((L, k) => {
        var n = fa(), e = el(), a = V0(), i = Ri();
        k.exports = function(o, r) {
          var s = e(o, r), c = s[0].z;
          a(r, c);
          var t = r.contours, p = n.extractOpts(r), l;
          if (t.coloring === "heatmap" && p.auto && r.autocontour === !1) {
            var f = t.start, v = i(t), g = t.size || 1, x = Math.floor((v - f) / g) + 1;
            isFinite(g) || (g = 1, x = 1);
            var h = f - g / 2, m = h + x * g;
            l = [h, m];
          } else l = c;
          return n.calc(o, r, { vals: l, cLetter: "z" }), s;
        };
      }), cl = xe((L, k) => {
        k.exports = { BOTTOMSTART: [1, 9, 13, 104, 713], TOPSTART: [4, 6, 7, 104, 713], LEFTSTART: [8, 12, 14, 208, 1114], RIGHTSTART: [2, 3, 11, 208, 1114], NEWDELTA: [null, [-1, 0], [0, -1], [-1, 0], [1, 0], null, [0, -1], [-1, 0], [0, 1], [0, 1], null, [0, 1], [1, 0], [1, 0], [0, -1]], CHOOSESADDLE: { 104: [4, 1], 208: [2, 8], 713: [7, 13], 1114: [11, 14] }, SADDLEREMAINDER: { 1: 4, 2: 8, 4: 1, 7: 13, 8: 2, 11: 14, 13: 7, 14: 11 }, LABELDISTANCE: 2, LABELINCREASE: 10, LABELMIN: 3, LABELMAX: 10, LABELOPTIMIZER: { EDGECOST: 1, ANGLECOST: 1, NEIGHBORCOST: 5, SAMELEVELFACTOR: 10, SAMELEVELDISTANCE: 5, MAXCOST: 100, INITIALSEARCHPOINTS: 10, ITERATIONS: 5 } };
      }), Y0 = xe((L, k) => {
        var n = cl();
        k.exports = function(a) {
          var i = a[0].z, o = i.length, r = i[0].length, s = o === 2 || r === 2, c, t, p, l, f, v, g, x, h;
          for (t = 0; t < o - 1; t++) for (l = [], t === 0 && (l = l.concat(n.BOTTOMSTART)), t === o - 2 && (l = l.concat(n.TOPSTART)), c = 0; c < r - 1; c++) for (p = l.slice(), c === 0 && (p = p.concat(n.LEFTSTART)), c === r - 2 && (p = p.concat(n.RIGHTSTART)), f = c + "," + t, v = [[i[t][c], i[t][c + 1]], [i[t + 1][c], i[t + 1][c + 1]]], h = 0; h < a.length; h++) x = a[h], g = e(x.level, v), g && (x.crossings[f] = g, p.indexOf(g) !== -1 && (x.starts.push([c, t]), s && p.indexOf(g, p.indexOf(g) + 1) !== -1 && x.starts.push([c, t])));
        };
        function e(a, i) {
          var o = (i[0][0] > a ? 0 : 1) + (i[0][1] > a ? 0 : 2) + (i[1][1] > a ? 0 : 4) + (i[1][0] > a ? 0 : 8);
          if (o === 5 || o === 10) {
            var r = (i[0][0] + i[0][1] + i[1][0] + i[1][1]) / 4;
            return a > r ? o === 5 ? 713 : 1114 : o === 5 ? 104 : 208;
          }
          return o === 15 ? 0 : o;
        }
      }), G0 = xe((L, k) => {
        var n = wt(), e = cl();
        k.exports = function(c, t, p) {
          var l, f, v, g, x;
          for (t = t || 0.01, p = p || 0.01, v = 0; v < c.length; v++) {
            for (g = c[v], x = 0; x < g.starts.length; x++) f = g.starts[x], o(g, f, "edge", t, p);
            for (l = 0; Object.keys(g.crossings).length && l < 1e4; ) l++, f = Object.keys(g.crossings)[0].split(",").map(Number), o(g, f, void 0, t, p);
            l === 1e4 && n.log("Infinite loop in contour?");
          }
        };
        function a(c, t, p, l) {
          return Math.abs(c[0] - t[0]) < p && Math.abs(c[1] - t[1]) < l;
        }
        function i(c, t) {
          var p = c[2] - t[2], l = c[3] - t[3];
          return Math.sqrt(p * p + l * l);
        }
        function o(c, t, p, l, f) {
          var v = t.join(","), g = c.crossings[v], x = r(g, p, t), h = [s(c, t, [-x[0], -x[1]])], m = c.z.length, u = c.z[0].length, d = t.slice(), y = x.slice(), _;
          for (_ = 0; _ < 1e4; _++) {
            if (g > 20 ? (g = e.CHOOSESADDLE[g][(x[0] || x[1]) < 0 ? 0 : 1], c.crossings[v] = e.SADDLEREMAINDER[g]) : delete c.crossings[v], x = e.NEWDELTA[g], !x) {
              n.log("Found bad marching index:", g, t, c.level);
              break;
            }
            h.push(s(c, t, x)), t[0] += x[0], t[1] += x[1], v = t.join(","), a(h[h.length - 1], h[h.length - 2], l, f) && h.pop();
            var T = x[0] && (t[0] < 0 || t[0] > u - 2) || x[1] && (t[1] < 0 || t[1] > m - 2), R = t[0] === d[0] && t[1] === d[1] && x[0] === y[0] && x[1] === y[1];
            if (R || p && T) break;
            g = c.crossings[v];
          }
          _ === 1e4 && n.log("Infinite loop in contour?");
          var I = a(h[0], h[h.length - 1], l, f), P = 0, M = 0.2 * c.smoothing, B = [], z = 0, q, U, G, K, te, V, Z, Y, C, j, J;
          for (_ = 1; _ < h.length; _++) Z = i(h[_], h[_ - 1]), P += Z, B.push(Z);
          var ne = P / B.length * M;
          function ae(F) {
            return h[F % h.length];
          }
          for (_ = h.length - 2; _ >= z; _--) if (q = B[_], q < ne) {
            for (G = 0, U = _ - 1; U >= z && q + B[U] < ne; U--) q += B[U];
            if (I && _ === h.length - 2) for (G = 0; G < U && q + B[G] < ne; G++) q += B[G];
            te = _ - U + G + 1, V = Math.floor((_ + U + G + 2) / 2), !I && _ === h.length - 2 ? K = h[h.length - 1] : !I && U === -1 ? K = h[0] : te % 2 ? K = ae(V) : K = [(ae(V)[0] + ae(V + 1)[0]) / 2, (ae(V)[1] + ae(V + 1)[1]) / 2], h.splice(U + 1, _ - U + 1, K), _ = U + 1, G && (z = G), I && (_ === h.length - 2 ? h[G] = h[h.length - 1] : _ === 0 && (h[h.length - 1] = h[0]));
          }
          for (h.splice(0, z), _ = 0; _ < h.length; _++) h[_].length = 2;
          if (!(h.length < 2)) if (I) h.pop(), c.paths.push(h);
          else {
            p || n.log("Unclosed interior contour?", c.level, d.join(","), h.join("L"));
            var se = !1;
            for (Y = 0; Y < c.edgepaths.length; Y++) if (j = c.edgepaths[Y], !se && a(j[0], h[h.length - 1], l, f)) {
              h.pop(), se = !0;
              var O = !1;
              for (C = 0; C < c.edgepaths.length; C++) if (J = c.edgepaths[C], a(J[J.length - 1], h[0], l, f)) {
                O = !0, h.shift(), c.edgepaths.splice(Y, 1), C === Y ? c.paths.push(h.concat(J)) : (C > Y && C--, c.edgepaths[C] = J.concat(h, j));
                break;
              }
              O || (c.edgepaths[Y] = h.concat(j));
            }
            for (Y = 0; Y < c.edgepaths.length && !se; Y++) j = c.edgepaths[Y], a(j[j.length - 1], h[0], l, f) && (h.shift(), c.edgepaths[Y] = j.concat(h), se = !0);
            se || c.edgepaths.push(h);
          }
        }
        function r(c, t, p) {
          var l = 0, f = 0;
          return c > 20 && t ? c === 208 || c === 1114 ? l = p[0] === 0 ? 1 : -1 : f = p[1] === 0 ? 1 : -1 : e.BOTTOMSTART.indexOf(c) !== -1 ? f = 1 : e.LEFTSTART.indexOf(c) !== -1 ? l = 1 : e.TOPSTART.indexOf(c) !== -1 ? f = -1 : l = -1, [l, f];
        }
        function s(c, t, p) {
          var l = t[0] + Math.max(p[0], 0), f = t[1] + Math.max(p[1], 0), v = c.z[f][l], g = c.xaxis, x = c.yaxis;
          if (p[1]) {
            var h = (c.level - v) / (c.z[f][l + 1] - v), m = (h !== 1 ? (1 - h) * g.c2l(c.x[l]) : 0) + (h !== 0 ? h * g.c2l(c.x[l + 1]) : 0);
            return [g.c2p(g.l2c(m), !0), x.c2p(c.y[f], !0), l + h, f];
          } else {
            var u = (c.level - v) / (c.z[f + 1][l] - v), d = (u !== 1 ? (1 - u) * x.c2l(c.y[f]) : 0) + (u !== 0 ? u * x.c2l(c.y[f + 1]) : 0);
            return [g.c2p(c.x[l], !0), x.c2p(x.l2c(d), !0), l, f + u];
          }
        }
      }), Z0 = xe((L, k) => {
        var n = sl(), e = xr();
        k.exports = { "[]": i("[]"), "][": i("]["), ">": o(">"), "<": o("<"), "=": o("=") };
        function a(r, s) {
          var c = Array.isArray(s), t;
          function p(l) {
            return e(l) ? +l : null;
          }
          return n.COMPARISON_OPS2.indexOf(r) !== -1 ? t = p(c ? s[0] : s) : n.INTERVAL_OPS.indexOf(r) !== -1 ? t = c ? [p(s[0]), p(s[1])] : [p(s), p(s)] : n.SET_OPS.indexOf(r) !== -1 && (t = c ? s.map(p) : [p(s)]), t;
        }
        function i(r) {
          return function(s) {
            s = a(r, s);
            var c = Math.min(s[0], s[1]), t = Math.max(s[0], s[1]);
            return { start: c, end: t, size: t - c };
          };
        }
        function o(r) {
          return function(s) {
            return s = a(r, s), { start: s, end: 1 / 0, size: 1 / 0 };
          };
        }
      }), W0 = xe((L, k) => {
        var n = wt(), e = Z0(), a = Ri();
        k.exports = function(i, o, r) {
          for (var s = i.type === "constraint" ? e[i._operation](i.value) : i, c = s.size, t = [], p = a(s), l = r.trace._carpetTrace, f = l ? { xaxis: l.aaxis, yaxis: l.baxis, x: r.a, y: r.b } : { xaxis: o.xaxis, yaxis: o.yaxis, x: r.x, y: r.y }, v = s.start; v < p; v += c) if (t.push(n.extendFlat({ level: v, crossings: {}, starts: [], edgepaths: [], paths: [], z: r.z, smoothing: r.trace.line.smoothing }, f)), t.length > 1e3) {
            n.warn("Too many contours, clipping at 1000", i);
            break;
          }
          return t;
        };
      }), X0 = xe((L, k) => {
        var n = wt();
        k.exports = function(a, i) {
          var o, r, s, c = function(l) {
            return l.reverse();
          }, t = function(l) {
            return l;
          };
          switch (i) {
            case "=":
            case "<":
              return a;
            case ">":
              for (a.length !== 1 && n.warn("Contour data invalid for the specified inequality operation."), r = a[0], o = 0; o < r.edgepaths.length; o++) r.edgepaths[o] = c(r.edgepaths[o]);
              for (o = 0; o < r.paths.length; o++) r.paths[o] = c(r.paths[o]);
              for (o = 0; o < r.starts.length; o++) r.starts[o] = c(r.starts[o]);
              return a;
            case "][":
              var p = c;
              c = t, t = p;
            case "[]":
              for (a.length !== 2 && n.warn("Contour data invalid for the specified inequality range operation."), r = e(a[0]), s = e(a[1]), o = 0; o < r.edgepaths.length; o++) r.edgepaths[o] = c(r.edgepaths[o]);
              for (o = 0; o < r.paths.length; o++) r.paths[o] = c(r.paths[o]);
              for (o = 0; o < r.starts.length; o++) r.starts[o] = c(r.starts[o]);
              for (; s.edgepaths.length; ) r.edgepaths.push(t(s.edgepaths.shift()));
              for (; s.paths.length; ) r.paths.push(t(s.paths.shift()));
              for (; s.starts.length; ) r.starts.push(t(s.starts.shift()));
              return [r];
          }
        };
        function e(a) {
          return n.extendFlat({}, a, { edgepaths: n.extendDeep([], a.edgepaths), paths: n.extendDeep([], a.paths), starts: n.extendDeep([], a.starts) });
        }
      }), J0 = xe((L, k) => {
        k.exports = function(n, e) {
          var a = n[0], i = a.z, o;
          switch (e.type) {
            case "levels":
              var r = Math.min(i[0][0], i[0][1]);
              for (o = 0; o < n.length; o++) {
                var s = n[o];
                s.prefixBoundary = !s.edgepaths.length && (r > s.level || s.starts.length && r === s.level);
              }
              break;
            case "constraint":
              if (a.prefixBoundary = !1, a.edgepaths.length) return;
              var c = a.x.length, t = a.y.length, p = -1 / 0, l = 1 / 0;
              for (o = 0; o < t; o++) l = Math.min(l, i[o][0]), l = Math.min(l, i[o][c - 1]), p = Math.max(p, i[o][0]), p = Math.max(p, i[o][c - 1]);
              for (o = 1; o < c - 1; o++) l = Math.min(l, i[0][o]), l = Math.min(l, i[t - 1][o]), p = Math.max(p, i[0][o]), p = Math.max(p, i[t - 1][o]);
              var f = e.value, v, g;
              switch (e._operation) {
                case ">":
                  f > p && (a.prefixBoundary = !0);
                  break;
                case "<":
                  (f < l || a.starts.length && f === l) && (a.prefixBoundary = !0);
                  break;
                case "[]":
                  v = Math.min(f[0], f[1]), g = Math.max(f[0], f[1]), (g < l || v > p || a.starts.length && g === l) && (a.prefixBoundary = !0);
                  break;
                case "][":
                  v = Math.min(f[0], f[1]), g = Math.max(f[0], f[1]), v < l && g > p && (a.prefixBoundary = !0);
                  break;
              }
              break;
          }
        };
      }), Du = xe((L) => {
        var k = vr(), n = wt(), e = Or(), a = fa(), i = xn(), o = Ar(), r = ri(), s = rl(), c = Y0(), t = G0(), p = W0(), l = X0(), f = J0(), v = cl(), g = v.LABELOPTIMIZER;
        L.plot = function(T, R, I, P) {
          var M = R.xaxis, B = R.yaxis;
          n.makeTraceGroups(P, I, "contour").each(function(z) {
            var q = k.select(this), U = z[0], G = U.trace, K = U.x, te = U.y, V = G.contours, Z = p(V, R, U), Y = n.ensureSingle(q, "g", "heatmapcoloring"), C = [];
            V.coloring === "heatmap" && (C = [z]), s(T, R, C, Y), c(Z), t(Z);
            var j = M.c2p(K[0], !0), J = M.c2p(K[K.length - 1], !0), ne = B.c2p(te[0], !0), ae = B.c2p(te[te.length - 1], !0), se = [[j, ae], [J, ae], [J, ne], [j, ne]], O = Z;
            V.type === "constraint" && (O = l(Z, V._operation)), x(q, se, V), h(q, O, se, V), u(q, Z, T, U, V), y(q, R, T, U, se);
          });
        };
        function x(T, R, I) {
          var P = n.ensureSingle(T, "g", "contourbg"), M = P.selectAll("path").data(I.coloring === "fill" ? [0] : []);
          M.enter().append("path"), M.exit().remove(), M.attr("d", "M" + R.join("L") + "Z").style("stroke", "none");
        }
        function h(T, R, I, P) {
          var M = P.coloring === "fill" || P.type === "constraint" && P._operation !== "=", B = "M" + I.join("L") + "Z";
          M && f(R, P);
          var z = n.ensureSingle(T, "g", "contourfill"), q = z.selectAll("path").data(M ? R : []);
          q.enter().append("path"), q.exit().remove(), q.each(function(U) {
            var G = (U.prefixBoundary ? B : "") + m(U, I);
            G ? k.select(this).attr("d", G).style("stroke", "none") : k.select(this).remove();
          });
        }
        function m(T, R) {
          var I = "", P = 0, M = T.edgepaths.map(function(J, ne) {
            return ne;
          }), B = !0, z, q, U, G, K, te;
          function V(J) {
            return Math.abs(J[1] - R[0][1]) < 0.01;
          }
          function Z(J) {
            return Math.abs(J[1] - R[2][1]) < 0.01;
          }
          function Y(J) {
            return Math.abs(J[0] - R[0][0]) < 0.01;
          }
          function C(J) {
            return Math.abs(J[0] - R[2][0]) < 0.01;
          }
          for (; M.length; ) {
            for (te = e.smoothopen(T.edgepaths[P], T.smoothing), I += B ? te : te.replace(/^M/, "L"), M.splice(M.indexOf(P), 1), z = T.edgepaths[P][T.edgepaths[P].length - 1], G = -1, U = 0; U < 4; U++) {
              if (!z) {
                n.log("Missing end?", P, T);
                break;
              }
              for (V(z) && !C(z) ? q = R[1] : Y(z) ? q = R[0] : Z(z) ? q = R[3] : C(z) && (q = R[2]), K = 0; K < T.edgepaths.length; K++) {
                var j = T.edgepaths[K][0];
                Math.abs(z[0] - q[0]) < 0.01 ? Math.abs(z[0] - j[0]) < 0.01 && (j[1] - z[1]) * (q[1] - j[1]) >= 0 && (q = j, G = K) : Math.abs(z[1] - q[1]) < 0.01 ? Math.abs(z[1] - j[1]) < 0.01 && (j[0] - z[0]) * (q[0] - j[0]) >= 0 && (q = j, G = K) : n.log("endpt to newendpt is not vert. or horz.", z, q, j);
              }
              if (z = q, G >= 0) break;
              I += "L" + q;
            }
            if (G === T.edgepaths.length) {
              n.log("unclosed perimeter path");
              break;
            }
            P = G, B = M.indexOf(P) === -1, B && (P = M[0], I += "Z");
          }
          for (P = 0; P < T.paths.length; P++) I += e.smoothclosed(T.paths[P], T.smoothing);
          return I;
        }
        function u(T, R, I, P, M) {
          var B = I._context.staticPlot, z = n.ensureSingle(T, "g", "contourlines"), q = M.showlines !== !1, U = M.showlabels, G = q && U, K = L.createLines(z, q || U, R, B), te = L.createLineClip(z, G, I, P.trace.uid), V = T.selectAll("g.contourlabels").data(U ? [0] : []);
          if (V.exit().remove(), V.enter().append("g").classed("contourlabels", !0), U) {
            var Z = [], Y = [];
            n.clearLocationCache();
            var C = L.labelFormatter(I, P), j = e.tester.append("text").attr("data-notex", 1).call(e.font, M.labelfont), J = R[0].xaxis, ne = R[0].yaxis, ae = J._length, se = ne._length, O = J.range, F = ne.range, S = n.aggNums(Math.min, null, P.x), $ = n.aggNums(Math.max, null, P.x), re = n.aggNums(Math.min, null, P.y), E = n.aggNums(Math.max, null, P.y), w = Math.max(J.c2p(S, !0), 0), N = Math.min(J.c2p($, !0), ae), W = Math.max(ne.c2p(E, !0), 0), ee = Math.min(ne.c2p(re, !0), se), le = {};
            O[0] < O[1] ? (le.left = w, le.right = N) : (le.left = N, le.right = w), F[0] < F[1] ? (le.top = W, le.bottom = ee) : (le.top = ee, le.bottom = W), le.middle = (le.top + le.bottom) / 2, le.center = (le.left + le.right) / 2, Z.push([[le.left, le.top], [le.right, le.top], [le.right, le.bottom], [le.left, le.bottom]]);
            var ie = Math.sqrt(ae * ae + se * se), pe = v.LABELDISTANCE * ie / Math.max(1, R.length / v.LABELINCREASE);
            K.each(function(_e) {
              var Ae = L.calcTextOpts(_e.level, C, j, I);
              k.select(this).selectAll("path").each(function() {
                var Ce = this, Ue = n.getVisibleSegment(Ce, le, Ae.height / 2);
                if (Ue && !(Ue.len < (Ae.width + Ae.height) * v.LABELMIN)) for (var Ne = Math.min(Math.ceil(Ue.len / pe), v.LABELMAX), ke = 0; ke < Ne; ke++) {
                  var A = L.findBestTextLocation(Ce, Ue, Ae, Y, le);
                  if (!A) break;
                  L.addLabelData(A, Ae, Y, Z);
                }
              });
            }), j.remove(), L.drawLabels(V, Y, I, te, G ? Z : null);
          }
          U && !q && K.remove();
        }
        L.createLines = function(T, R, I, P) {
          var M = I[0].smoothing, B = T.selectAll("g.contourlevel").data(R ? I : []);
          if (B.exit().remove(), B.enter().append("g").classed("contourlevel", !0), R) {
            var z = B.selectAll("path.openline").data(function(U) {
              return U.pedgepaths || U.edgepaths;
            });
            z.exit().remove(), z.enter().append("path").classed("openline", !0), z.attr("d", function(U) {
              return e.smoothopen(U, M);
            }).style("stroke-miterlimit", 1).style("vector-effect", P ? "none" : "non-scaling-stroke");
            var q = B.selectAll("path.closedline").data(function(U) {
              return U.ppaths || U.paths;
            });
            q.exit().remove(), q.enter().append("path").classed("closedline", !0), q.attr("d", function(U) {
              return e.smoothclosed(U, M);
            }).style("stroke-miterlimit", 1).style("vector-effect", P ? "none" : "non-scaling-stroke");
          }
          return B;
        }, L.createLineClip = function(T, R, I, P) {
          var M = I._fullLayout._clips, B = R ? "clipline" + P : null, z = M.selectAll("#" + B).data(R ? [0] : []);
          return z.exit().remove(), z.enter().append("clipPath").classed("contourlineclip", !0).attr("id", B), e.setClipUrl(T, B, I), z;
        }, L.labelFormatter = function(T, R) {
          var I = T._fullLayout, P = R.trace, M = P.contours, B = { type: "linear", _id: "ycontour", showexponent: "all", exponentformat: "B" };
          if (M.labelformat) B.tickformat = M.labelformat, r(B, I);
          else {
            var z = a.extractOpts(P);
            if (z && z.colorbar && z.colorbar._axis) B = z.colorbar._axis;
            else {
              if (M.type === "constraint") {
                var q = M.value;
                n.isArrayOrTypedArray(q) ? B.range = [q[0], q[q.length - 1]] : B.range = [q, q];
              } else B.range = [M.start, M.end], B.nticks = (M.end - M.start) / M.size;
              B.range[0] === B.range[1] && (B.range[1] += B.range[0] || 1), B.nticks || (B.nticks = 1e3), r(B, I), o.prepTicks(B), B._tmin = null, B._tmax = null;
            }
          }
          return function(U) {
            return o.tickText(B, U).text;
          };
        }, L.calcTextOpts = function(T, R, I, P) {
          var M = R(T);
          I.text(M).call(i.convertToTspans, P);
          var B = I.node(), z = e.bBox(B, !0);
          return { text: M, width: z.width, height: z.height, fontSize: +B.style["font-size"].replace("px", ""), level: T, dy: (z.top + z.bottom) / 2 };
        }, L.findBestTextLocation = function(T, R, I, P, M) {
          var B = I.width, z, q, U, G, K;
          R.isClosed ? (q = R.len / g.INITIALSEARCHPOINTS, z = R.min + q / 2, U = R.max) : (q = (R.len - B) / (g.INITIALSEARCHPOINTS + 1), z = R.min + q + B / 2, U = R.max - (q + B) / 2);
          for (var te = 1 / 0, V = 0; V < g.ITERATIONS; V++) {
            for (var Z = z; Z < U; Z += q) {
              var Y = n.getTextLocation(T, R.total, Z, B), C = d(Y, I, P, M);
              C < te && (te = C, K = Y, G = Z);
            }
            if (te > g.MAXCOST * 2) break;
            V && (q /= 2), z = G - q / 2, U = z + q * 1.5;
          }
          if (te <= g.MAXCOST) return K;
        };
        function d(T, R, I, P) {
          var M = R.width / 2, B = R.height / 2, z = T.x, q = T.y, U = T.theta, G = Math.cos(U) * M, K = Math.sin(U) * M, te = (z > P.center ? P.right - z : z - P.left) / (G + Math.abs(Math.sin(U) * B)), V = (q > P.middle ? P.bottom - q : q - P.top) / (Math.abs(K) + Math.cos(U) * B);
          if (te < 1 || V < 1) return 1 / 0;
          var Z = g.EDGECOST * (1 / (te - 1) + 1 / (V - 1));
          Z += g.ANGLECOST * U * U;
          for (var Y = z - G, C = q - K, j = z + G, J = q + K, ne = 0; ne < I.length; ne++) {
            var ae = I[ne], se = Math.cos(ae.theta) * ae.width / 2, O = Math.sin(ae.theta) * ae.width / 2, F = n.segmentDistance(Y, C, j, J, ae.x - se, ae.y - O, ae.x + se, ae.y + O) * 2 / (R.height + ae.height), S = ae.level === R.level, $ = S ? g.SAMELEVELDISTANCE : 1;
            if (F <= $) return 1 / 0;
            var re = g.NEIGHBORCOST * (S ? g.SAMELEVELFACTOR : 1);
            Z += re / (F - $);
          }
          return Z;
        }
        L.addLabelData = function(T, R, I, P) {
          var M = R.fontSize, B = R.width + M / 3, z = Math.max(0, R.height - M / 3), q = T.x, U = T.y, G = T.theta, K = Math.sin(G), te = Math.cos(G), V = function(Y, C) {
            return [q + Y * te - C * K, U + Y * K + C * te];
          }, Z = [V(-B / 2, -z / 2), V(-B / 2, z / 2), V(B / 2, z / 2), V(B / 2, -z / 2)];
          I.push({ text: R.text, x: q, y: U, dy: R.dy, theta: G, level: R.level, width: B, height: z }), P.push(Z);
        }, L.drawLabels = function(T, R, I, P, M) {
          var B = T.selectAll("text").data(R, function(G) {
            return G.text + "," + G.x + "," + G.y + "," + G.theta;
          });
          if (B.exit().remove(), B.enter().append("text").attr({ "data-notex": 1, "text-anchor": "middle" }).each(function(G) {
            var K = G.x + Math.sin(G.theta) * G.dy, te = G.y - Math.cos(G.theta) * G.dy;
            k.select(this).text(G.text).attr({ x: K, y: te, transform: "rotate(" + 180 * G.theta / Math.PI + " " + K + " " + te + ")" }).call(i.convertToTspans, I);
          }), M) {
            for (var z = "", q = 0; q < M.length; q++) z += "M" + M[q].join("L") + "Z";
            var U = n.ensureSingle(P, "path", "");
            U.attr("d", z);
          }
        };
        function y(T, R, I, P, M) {
          var B = P.trace, z = I._fullLayout._clips, q = "clip" + B.uid, U = z.selectAll("#" + q).data(B.connectgaps ? [] : [0]);
          if (U.enter().append("clipPath").classed("contourclip", !0).attr("id", q), U.exit().remove(), B.connectgaps === !1) {
            var G = { level: 0.9, crossings: {}, starts: [], edgepaths: [], paths: [], xaxis: R.xaxis, yaxis: R.yaxis, x: P.x, y: P.y, z: _(P), smoothing: 0 };
            c([G]), t([G]), f([G], { type: "levels" });
            var K = n.ensureSingle(U, "path", "");
            K.attr("d", (G.prefixBoundary ? "M" + M.join("L") + "Z" : "") + m(G, M));
          } else q = null;
          e.setClipUrl(T, q, I);
        }
        function _(T) {
          var R = T.trace._emptypoints, I = [], P = T.z.length, M = T.z[0].length, B, z = [], q;
          for (B = 0; B < M; B++) z.push(1);
          for (B = 0; B < P; B++) I.push(z.slice());
          for (B = 0; B < R.length; B++) q = R[B], I[q[0]][q[1]] = 0;
          return T.zmask = I, I;
        }
      }), Pu = xe((L, k) => {
        var n = vr(), e = fa(), a = Ri();
        k.exports = function(i) {
          var o = i.contours, r = o.start, s = a(o), c = o.size || 1, t = Math.floor((s - r) / c) + 1, p = o.coloring === "lines" ? 0 : 1, l = e.extractOpts(i);
          isFinite(c) || (c = 1, t = 1);
          var f = l.reversescale ? e.flipScale(l.colorscale) : l.colorscale, v = f.length, g = new Array(v), x = new Array(v), h, m, u = l.min, d = l.max;
          if (o.coloring === "heatmap") {
            for (m = 0; m < v; m++) h = f[m], g[m] = h[0] * (d - u) + u, x[m] = h[1];
            var y = n.extent([u, d, o.start, o.start + c * (t - 1)]), _ = y[u < d ? 0 : 1], T = y[u < d ? 1 : 0];
            _ !== u && (g.splice(0, 0, _), x.splice(0, 0, x[0])), T !== d && (g.push(T), x.push(x[x.length - 1]));
          } else {
            var R = i._input && typeof i._input.zmin == "number" && typeof i._input.zmax == "number";
            for (R && (r <= u || s >= d) && (r <= u && (r = u), s >= d && (s = d), t = Math.floor((s - r) / c) + 1, p = 0), m = 0; m < v; m++) h = f[m], g[m] = (h[0] * (t + p - 1) - p / 2) * c + r, x[m] = h[1];
            (R || i.autocontour) && (g[0] > u && (g.unshift(u), x.unshift(x[0])), g[g.length - 1] < d && (g.push(d), x.push(x[x.length - 1])));
          }
          return e.makeColorScaleFunc({ domain: g, range: x }, { noNumericCheck: !0 });
        };
      }), Iu = xe((L, k) => {
        var n = vr(), e = Or(), a = nl(), i = Pu();
        k.exports = function(o) {
          var r = n.select(o).selectAll("g.contour");
          r.style("opacity", function(s) {
            return s[0].trace.opacity;
          }), r.each(function(s) {
            var c = n.select(this), t = s[0].trace, p = t.contours, l = t.line, f = p.size || 1, v = p.start, g = p.type === "constraint", x = !g && p.coloring === "lines", h = !g && p.coloring === "fill", m = x || h ? i(t) : null;
            c.selectAll("g.contourlevel").each(function(y) {
              n.select(this).selectAll("path").call(e.lineGroupStyle, l.width, x ? m(y.level) : l.color, l.dash);
            });
            var u = p.labelfont;
            if (c.selectAll("g.contourlabels text").each(function(y) {
              e.font(n.select(this), { weight: u.weight, style: u.style, variant: u.variant, textcase: u.textcase, lineposition: u.lineposition, shadow: u.shadow, family: u.family, size: u.size, color: u.color || (x ? m(y.level) : l.color) });
            }), g) c.selectAll("g.contourfill path").style("fill", t.fillcolor);
            else if (h) {
              var d;
              c.selectAll("g.contourfill path").style("fill", function(y) {
                return d === void 0 && (d = y.level), m(y.level + 0.5 * f);
              }), d === void 0 && (d = v), c.selectAll("g.contourbg path").style("fill", m(d - 0.5 * f));
            }
          }), a(o);
        };
      }), zu = xe((L, k) => {
        var n = fa(), e = Pu(), a = Ri();
        function i(o, r, s) {
          var c = r.contours, t = r.line, p = c.size || 1, l = c.coloring, f = e(r, { isColorbar: !0 });
          if (l === "heatmap") {
            var v = n.extractOpts(r);
            s._fillgradient = v.reversescale ? n.flipScale(v.colorscale) : v.colorscale, s._zrange = [v.min, v.max];
          } else l === "fill" && (s._fillcolor = f);
          s._line = { color: l === "lines" ? f : t.color, width: c.showlines !== !1 ? t.width : 0, dash: t.dash }, s._levels = { start: c.start, end: a(c), size: p };
        }
        k.exports = { min: "zmin", max: "zmax", calc: i };
      }), Ru = xe((L, k) => {
        var n = fr(), e = al();
        k.exports = function(a, i, o, r, s) {
          s || (s = {}), s.isContour = !0;
          var c = e(a, i, o, r, s);
          return c && c.forEach(function(t) {
            var p = t.trace;
            p.contours.type === "constraint" && (p.fillcolor && n.opacity(p.fillcolor) ? t.color = n.addOpacity(p.fillcolor, 1) : p.contours.showlines && n.opacity(p.line.color) && (t.color = n.addOpacity(p.line.color, 1)));
          }), c;
        };
      }), $0 = xe((L, k) => {
        k.exports = { attributes: Su(), supplyDefaults: U0(), crossTraceDefaults: ol(), calc: Eu(), plot: Du().plot, layerName: "contourlayer", style: Iu(), colorbar: zu(), hoverPoints: Ru(), moduleType: "trace", name: "histogram2dcontour", basePlotModule: Kn(), categories: ["cartesian", "svg", "2dMap", "contour", "histogram", "showLegend"], meta: {} };
      }), K0 = xe((L, k) => {
        k.exports = $0();
      }), Q0 = xe((L, k) => {
        var n = xr(), e = Ou(), a = fr(), i = a.addOpacity, o = a.opacity, r = sl(), s = wt().isArrayOrTypedArray, c = r.CONSTRAINT_REDUCTION, t = r.COMPARISON_OPS2;
        k.exports = function(l, f, v, g, x, h) {
          var m = f.contours, u, d, y, _ = v("contours.operation");
          if (m._operation = c[_], p(v, m), _ === "=" ? u = m.showlines = !0 : (u = v("contours.showlines"), y = v("fillcolor", i((l.line || {}).color || x, 0.5))), u) {
            var T = y && o(y) ? i(f.fillcolor, 1) : x;
            d = v("line.color", T), v("line.width", 2), v("line.dash");
          }
          v("line.smoothing"), e(v, g, d, h);
        };
        function p(l, f) {
          var v;
          t.indexOf(f.operation) === -1 ? (l("contours.value", [0, 1]), s(f.value) ? f.value.length > 2 ? f.value = f.value.slice(2) : f.length === 0 ? f.value = [0, 1] : f.length < 2 ? (v = parseFloat(f.value[0]), f.value = [v, v + 1]) : f.value = [parseFloat(f.value[0]), parseFloat(f.value[1])] : n(f.value) && (v = parseFloat(f.value), f.value = [v, v + 1])) : (l("contours.value", 0), n(f.value) || (s(f.value) ? f.value = parseFloat(f.value[0]) : f.value = 0));
        }
      }), eh = xe((L, k) => {
        var n = wt(), e = vu(), a = ai(), i = Q0(), o = Lu(), r = Cu(), s = zi(), c = ul();
        k.exports = function(t, p, l, f) {
          function v(m, u) {
            return n.coerce(t, p, c, m, u);
          }
          function g(m) {
            return n.coerce2(t, p, c, m);
          }
          var x = e(t, p, v, f);
          if (!x) {
            p.visible = !1;
            return;
          }
          a(t, p, f, v), v("xhoverformat"), v("yhoverformat"), v("text"), v("hovertext"), v("hoverongaps"), v("hovertemplate"), v("hovertemplatefallback");
          var h = v("contours.type") === "constraint";
          v("connectgaps", n.isArray1D(p.z)), h ? i(t, p, v, f, l) : (o(t, p, v, g), r(t, p, v, f)), p.contours && p.contours.coloring === "heatmap" && s(v, f), v("zorder");
        };
      }), th = xe((L, k) => {
        k.exports = { attributes: ul(), supplyDefaults: eh(), calc: Eu(), plot: Du().plot, style: Iu(), colorbar: zu(), hoverPoints: Ru(), moduleType: "trace", name: "contour", basePlotModule: Kn(), categories: ["cartesian", "svg", "2dMap", "contour", "showLegend"], meta: {} };
      }), rh = xe((L, k) => {
        k.exports = th();
      }), Nu = xe((L, k) => {
        var { hovertemplateAttrs: n, texttemplateAttrs: e, templatefallbackAttrs: a } = qn(), i = zo(), o = $n(), r = Pn(), s = ca(), c = Wn().dash, t = Br().extendFlat, p = o.marker, l = o.line, f = p.line;
        k.exports = { a: { valType: "data_array", editType: "calc" }, b: { valType: "data_array", editType: "calc" }, c: { valType: "data_array", editType: "calc" }, sum: { valType: "number", dflt: 0, min: 0, editType: "calc" }, mode: t({}, o.mode, { dflt: "markers" }), text: t({}, o.text, {}), texttemplate: e({ editType: "plot" }, { keys: ["a", "b", "c", "text"] }), texttemplatefallback: a({ editType: "plot" }), hovertext: t({}, o.hovertext, {}), line: { color: l.color, width: l.width, dash: c, backoff: l.backoff, shape: t({}, l.shape, { values: ["linear", "spline"] }), smoothing: l.smoothing, editType: "calc" }, connectgaps: o.connectgaps, cliponaxis: o.cliponaxis, fill: t({}, o.fill, { values: ["none", "toself", "tonext"], dflt: "none" }), fillcolor: i(), marker: t({ symbol: p.symbol, opacity: p.opacity, angle: p.angle, angleref: p.angleref, standoff: p.standoff, maxdisplayed: p.maxdisplayed, size: p.size, sizeref: p.sizeref, sizemin: p.sizemin, sizemode: p.sizemode, line: t({ width: f.width, editType: "calc" }, s("marker.line")), gradient: p.gradient, editType: "calc" }, s("marker")), textfont: o.textfont, textposition: o.textposition, selected: o.selected, unselected: o.unselected, hoverinfo: t({}, r.hoverinfo, { flags: ["a", "b", "c", "text", "name"] }), hoveron: o.hoveron, hovertemplate: n(), hovertemplatefallback: a() };
      }), nh = xe((L, k) => {
        var n = wt(), e = Si(), a = Fn(), i = Ps(), o = Is(), r = zs(), s = Rs(), c = Ns(), t = Nu();
        k.exports = function(p, l, f, v) {
          function g(_, T) {
            return n.coerce(p, l, t, _, T);
          }
          var x = g("a"), h = g("b"), m = g("c"), u;
          if (x ? (u = x.length, h ? (u = Math.min(u, h.length), m && (u = Math.min(u, m.length))) : m ? u = Math.min(u, m.length) : u = 0) : h && m && (u = Math.min(h.length, m.length)), !u) {
            l.visible = !1;
            return;
          }
          l._length = u, g("sum"), g("text"), g("hovertext"), l.hoveron !== "fills" && (g("hovertemplate"), g("hovertemplatefallback"));
          var d = u < e.PTS_LINESONLY ? "lines+markers" : "lines";
          g("mode", d), a.hasMarkers(l) && i(p, l, f, v, g, { gradient: !0 }), a.hasLines(l) && (o(p, l, f, v, g, { backoff: !0 }), r(p, l, g), g("connectgaps")), a.hasText(l) && (g("texttemplate"), g("texttemplatefallback"), s(p, l, v, g));
          var y = [];
          (a.hasMarkers(l) || a.hasText(l)) && (g("cliponaxis"), g("marker.maxdisplayed"), y.push("points")), g("fill"), l.fill !== "none" && (c(p, l, f, g), a.hasLines(l) || r(p, l, g)), (l.fill === "tonext" || l.fill === "toself") && y.push("fills"), g("hoveron", y.join("+") || "points"), n.coerceSelectionMarkerOpacity(l, g);
        };
      }), ah = xe((L, k) => {
        var n = Ar();
        k.exports = function(e, a, i) {
          var o = {}, r = i[a.subplot]._subplot;
          return o.aLabel = n.tickText(r.aaxis, e.a, !0).text, o.bLabel = n.tickText(r.baxis, e.b, !0).text, o.cLabel = n.tickText(r.caxis, e.c, !0).text, o;
        };
      }), ih = xe((L, k) => {
        var n = xr(), e = Fs(), a = Fo(), i = Bo(), o = jo().calcMarkerSize, r = ["a", "b", "c"], s = { a: ["b", "c"], b: ["a", "c"], c: ["a", "b"] };
        k.exports = function(c, t) {
          var p = c._fullLayout[t.subplot], l = p.sum, f = t.sum || l, v = { a: t.a, b: t.b, c: t.c }, g = t.ids, x, h, m, u, d, y;
          for (x = 0; x < r.length; x++) if (m = r[x], !v[m]) {
            for (d = v[s[m][0]], y = v[s[m][1]], u = new Array(d.length), h = 0; h < d.length; h++) u[h] = f - d[h] - y[h];
            v[m] = u;
          }
          var _ = t._length, T = new Array(_), R, I, P, M, B, z;
          for (x = 0; x < _; x++) R = v.a[x], I = v.b[x], P = v.c[x], n(R) && n(I) && n(P) ? (R = +R, I = +I, P = +P, M = l / (R + I + P), M !== 1 && (R *= M, I *= M, P *= M), z = R, B = P - I, T[x] = { x: B, y: z, a: R, b: I, c: P }, g && (T[x].id = g[x])) : T[x] = { x: !1, y: !1 };
          return o(t, _), e(c, t), a(T, t), i(T, t), T;
        };
      }), oh = xe((L, k) => {
        var n = js();
        k.exports = function(e, a, i) {
          var o = a.plotContainer;
          o.select(".scatterlayer").selectAll("*").remove();
          for (var r = a.xaxis, s = a.yaxis, c = { xaxis: r, yaxis: s, plot: o, layerClipId: a._hasClipOnAxisFalse ? a.clipIdRelative : null }, t = a.layers.frontplot.select("g.scatterlayer"), p = 0; p < i.length; p++) {
            var l = i[p];
            l.length && (l[0].trace._xA = r, l[0].trace._yA = s);
          }
          n(e, c, i, t);
        };
      }), lh = xe((L, k) => {
        var n = qs();
        k.exports = function(e, a, i, o) {
          var r = n(e, a, i, o);
          if (!r || r[0].index === !1) return;
          var s = r[0];
          if (s.index === void 0) {
            var c = 1 - s.y0 / e.ya._length, t = e.xa._length, p = t * c / 2, l = t - p;
            return s.x0 = Math.max(Math.min(s.x0, l), p), s.x1 = Math.max(Math.min(s.x1, l), p), r;
          }
          var f = s.cd[s.index], v = s.trace, g = s.subplot;
          s.a = f.a, s.b = f.b, s.c = f.c, s.xLabelVal = void 0, s.yLabelVal = void 0;
          var x = {};
          x[v.subplot] = { _subplot: g };
          var h = v._module.formatLabels(f, v, x);
          s.aLabel = h.aLabel, s.bLabel = h.bLabel, s.cLabel = h.cLabel;
          var m = f.hi || v.hoverinfo, u = [];
          function d(_, T) {
            u.push(_._hovertitle + ": " + T);
          }
          if (!v.hovertemplate) {
            var y = m.split("+");
            y.indexOf("all") !== -1 && (y = ["a", "b", "c"]), y.indexOf("a") !== -1 && d(g.aaxis, s.aLabel), y.indexOf("b") !== -1 && d(g.baxis, s.bLabel), y.indexOf("c") !== -1 && d(g.caxis, s.cLabel);
          }
          return s.extraText = u.join("<br>"), s.hovertemplate = v.hovertemplate, r;
        };
      }), sh = xe((L, k) => {
        k.exports = function(n, e, a, i, o) {
          if (e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), i[o]) {
            var r = i[o];
            n.a = r.a, n.b = r.b, n.c = r.c;
          } else n.a = e.a, n.b = e.b, n.c = e.c;
          return n;
        };
      }), uh = xe((L, k) => {
        var n = vr(), e = Nn(), a = or(), i = wt(), o = i.strTranslate, r = i._, s = fr(), c = Or(), t = ri(), p = Br().extendFlat, l = on(), f = Ar(), v = Jn(), g = Bn(), x = Na(), h = x.freeMode, m = x.rectMode, u = ti(), d = pa().prepSelect, y = pa().selectOnClick, _ = pa().clearOutline, T = pa().clearSelectionsCache, R = mn();
        function I(Z, Y) {
          this.id = Z.id, this.graphDiv = Z.graphDiv, this.init(Y), this.makeFramework(Y), this.updateFx(Y), this.aTickLayout = null, this.bTickLayout = null, this.cTickLayout = null;
        }
        k.exports = I;
        var P = I.prototype;
        P.init = function(Z) {
          this.container = Z._ternarylayer, this.defs = Z._defs, this.layoutId = Z._uid, this.traceHash = {}, this.layers = {};
        }, P.plot = function(Z, Y) {
          var C = this, j = Y[C.id], J = Y._size;
          C._hasClipOnAxisFalse = !1;
          for (var ne = 0; ne < Z.length; ne++) {
            var ae = Z[ne][0].trace;
            if (ae.cliponaxis === !1) {
              C._hasClipOnAxisFalse = !0;
              break;
            }
          }
          C.updateLayers(j), C.adjustLayout(j, J), l.generalUpdatePerTraceModule(C.graphDiv, C, Z, j), C.layers.plotbg.select("path").call(s.fill, j.bgcolor);
        }, P.makeFramework = function(Z) {
          var Y = this, C = Y.graphDiv, j = Z[Y.id], J = Y.clipId = "clip" + Y.layoutId + Y.id, ne = Y.clipIdRelative = "clip-relative" + Y.layoutId + Y.id;
          Y.clipDef = i.ensureSingleById(Z._clips, "clipPath", J, function(ae) {
            ae.append("path").attr("d", "M0,0Z");
          }), Y.clipDefRelative = i.ensureSingleById(Z._clips, "clipPath", ne, function(ae) {
            ae.append("path").attr("d", "M0,0Z");
          }), Y.plotContainer = i.ensureSingle(Y.container, "g", Y.id), Y.updateLayers(j), c.setClipUrl(Y.layers.backplot, J, C), c.setClipUrl(Y.layers.grids, J, C);
        }, P.updateFx = function(Z) {
          Z._ternarylayer.selectAll("g.toplevel").style("cursor", Z.dragmode === "pan" ? "move" : "crosshair");
        }, P.updateLayers = function(Z) {
          var Y = this, C = Y.layers, j = ["draglayer", "plotbg", "backplot", "grids"];
          Z.aaxis.layer === "below traces" && j.push("aaxis", "aline"), Z.baxis.layer === "below traces" && j.push("baxis", "bline"), Z.caxis.layer === "below traces" && j.push("caxis", "cline"), j.push("frontplot"), Z.aaxis.layer === "above traces" && j.push("aaxis", "aline"), Z.baxis.layer === "above traces" && j.push("baxis", "bline"), Z.caxis.layer === "above traces" && j.push("caxis", "cline");
          var J = Y.plotContainer.selectAll("g.toplevel").data(j, String), ne = ["agrid", "bgrid", "cgrid"];
          J.enter().append("g").attr("class", function(ae) {
            return "toplevel " + ae;
          }).each(function(ae) {
            var se = n.select(this);
            C[ae] = se, ae === "frontplot" ? se.append("g").classed("scatterlayer", !0) : ae === "backplot" ? se.append("g").classed("maplayer", !0) : ae === "plotbg" ? se.append("path").attr("d", "M0,0Z") : ae === "aline" || ae === "bline" || ae === "cline" ? se.append("path") : ae === "grids" && ne.forEach(function(O) {
              C[O] = se.append("g").classed("grid " + O, !0);
            });
          }), J.order();
        };
        var M = Math.sqrt(4 / 3);
        P.adjustLayout = function(Z, Y) {
          var C = this, j = Z.domain, J = (j.x[0] + j.x[1]) / 2, ne = (j.y[0] + j.y[1]) / 2, ae = j.x[1] - j.x[0], se = j.y[1] - j.y[0], O = ae * Y.w, F = se * Y.h, S = Z.sum, $ = Z.aaxis.min, re = Z.baxis.min, E = Z.caxis.min, w, N, W, ee, le, ie;
          O > M * F ? (ee = F, W = ee * M) : (W = O, ee = W / M), le = ae * W / O, ie = se * ee / F, w = Y.l + Y.w * J - W / 2, N = Y.t + Y.h * (1 - ne) - ee / 2, C.x0 = w, C.y0 = N, C.w = W, C.h = ee, C.sum = S, C.xaxis = { type: "linear", range: [$ + 2 * E - S, S - $ - 2 * re], domain: [J - le / 2, J + le / 2], _id: "x" }, t(C.xaxis, C.graphDiv._fullLayout), C.xaxis.setScale(), C.xaxis.isPtWithinRange = function(ve) {
            return ve.a >= C.aaxis.range[0] && ve.a <= C.aaxis.range[1] && ve.b >= C.baxis.range[1] && ve.b <= C.baxis.range[0] && ve.c >= C.caxis.range[1] && ve.c <= C.caxis.range[0];
          }, C.yaxis = { type: "linear", range: [$, S - re - E], domain: [ne - ie / 2, ne + ie / 2], _id: "y" }, t(C.yaxis, C.graphDiv._fullLayout), C.yaxis.setScale(), C.yaxis.isPtWithinRange = function() {
            return !0;
          };
          var pe = C.yaxis.domain[0], _e = C.aaxis = p({}, Z.aaxis, { range: [$, S - re - E], side: "left", tickangle: (+Z.aaxis.tickangle || 0) - 30, domain: [pe, pe + ie * M], anchor: "free", position: 0, _id: "y", _length: W });
          t(_e, C.graphDiv._fullLayout), _e.setScale();
          var Ae = C.baxis = p({}, Z.baxis, { range: [S - $ - E, re], side: "bottom", domain: C.xaxis.domain, anchor: "free", position: 0, _id: "x", _length: W });
          t(Ae, C.graphDiv._fullLayout), Ae.setScale();
          var Ce = C.caxis = p({}, Z.caxis, { range: [S - $ - re, E], side: "right", tickangle: (+Z.caxis.tickangle || 0) + 30, domain: [pe, pe + ie * M], anchor: "free", position: 0, _id: "y", _length: W });
          t(Ce, C.graphDiv._fullLayout), Ce.setScale();
          var Ue = "M" + w + "," + (N + ee) + "h" + W + "l-" + W / 2 + ",-" + ee + "Z";
          C.clipDef.select("path").attr("d", Ue), C.layers.plotbg.select("path").attr("d", Ue);
          var Ne = "M0," + ee + "h" + W + "l-" + W / 2 + ",-" + ee + "Z";
          C.clipDefRelative.select("path").attr("d", Ne);
          var ke = o(w, N);
          C.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", ke), C.clipDefRelative.select("path").attr("transform", null);
          var A = o(w - Ae._offset, N + ee);
          C.layers.baxis.attr("transform", A), C.layers.bgrid.attr("transform", A);
          var X = o(w + W / 2, N) + "rotate(30)" + o(0, -_e._offset);
          C.layers.aaxis.attr("transform", X), C.layers.agrid.attr("transform", X);
          var H = o(w + W / 2, N) + "rotate(-30)" + o(0, -Ce._offset);
          C.layers.caxis.attr("transform", H), C.layers.cgrid.attr("transform", H), C.drawAxes(!0), C.layers.aline.select("path").attr("d", _e.showline ? "M" + w + "," + (N + ee) + "l" + W / 2 + ",-" + ee : "M0,0").call(s.stroke, _e.linecolor || "#000").style("stroke-width", (_e.linewidth || 0) + "px"), C.layers.bline.select("path").attr("d", Ae.showline ? "M" + w + "," + (N + ee) + "h" + W : "M0,0").call(s.stroke, Ae.linecolor || "#000").style("stroke-width", (Ae.linewidth || 0) + "px"), C.layers.cline.select("path").attr("d", Ce.showline ? "M" + (w + W / 2) + "," + N + "l" + W / 2 + "," + ee : "M0,0").call(s.stroke, Ce.linecolor || "#000").style("stroke-width", (Ce.linewidth || 0) + "px"), C.graphDiv._context.staticPlot || C.initInteractions(), c.setClipUrl(C.layers.frontplot, C._hasClipOnAxisFalse ? null : C.clipId, C.graphDiv);
        }, P.drawAxes = function(Z) {
          var Y = this, C = Y.graphDiv, j = Y.id.substr(7) + "title", J = Y.layers, ne = Y.aaxis, ae = Y.baxis, se = Y.caxis;
          if (Y.drawAx(ne), Y.drawAx(ae), Y.drawAx(se), Z) {
            var O = Math.max(ne.showticklabels ? ne.tickfont.size / 2 : 0, (se.showticklabels ? se.tickfont.size * 0.75 : 0) + (se.ticks === "outside" ? se.ticklen * 0.87 : 0)), F = (ae.showticklabels ? ae.tickfont.size : 0) + (ae.ticks === "outside" ? ae.ticklen : 0) + 3;
            J["a-title"] = u.draw(C, "a" + j, { propContainer: ne, propName: Y.id + ".aaxis.title.text", placeholder: r(C, "Click to enter Component A title"), attributes: { x: Y.x0 + Y.w / 2, y: Y.y0 - ne.title.font.size / 3 - O, "text-anchor": "middle" } }), J["b-title"] = u.draw(C, "b" + j, { propContainer: ae, propName: Y.id + ".baxis.title.text", placeholder: r(C, "Click to enter Component B title"), attributes: { x: Y.x0 - F, y: Y.y0 + Y.h + ae.title.font.size * 0.83 + F, "text-anchor": "middle" } }), J["c-title"] = u.draw(C, "c" + j, { propContainer: se, propName: Y.id + ".caxis.title.text", placeholder: r(C, "Click to enter Component C title"), attributes: { x: Y.x0 + Y.w + F, y: Y.y0 + Y.h + se.title.font.size * 0.83 + F, "text-anchor": "middle" } });
          }
        }, P.drawAx = function(Z) {
          var Y = this, C = Y.graphDiv, j = Z._name, J = j.charAt(0), ne = Z._id, ae = Y.layers[j], se = 30, O = J + "tickLayout", F = B(Z);
          Y[O] !== F && (ae.selectAll("." + ne + "tick").remove(), Y[O] = F), Z.setScale();
          var S = f.calcTicks(Z), $ = f.clipEnds(Z, S), re = f.makeTransTickFn(Z), E = f.getTickSigns(Z)[2], w = i.deg2rad(se), N = E * (Z.linewidth || 1) / 2, W = E * Z.ticklen, ee = Y.w, le = Y.h, ie = J === "b" ? "M0," + N + "l" + Math.sin(w) * W + "," + Math.cos(w) * W : "M" + N + ",0l" + Math.cos(w) * W + "," + -Math.sin(w) * W, pe = { a: "M0,0l" + le + ",-" + ee / 2, b: "M0,0l-" + ee / 2 + ",-" + le, c: "M0,0l-" + le + "," + ee / 2 }[J];
          f.drawTicks(C, Z, { vals: Z.ticks === "inside" ? $ : S, layer: ae, path: ie, transFn: re, crisp: !1 }), f.drawGrid(C, Z, { vals: $, layer: Y.layers[J + "grid"], path: pe, transFn: re, crisp: !1 }), f.drawLabels(C, Z, { vals: S, layer: ae, transFn: re, labelFns: f.makeLabelFns(Z, 0, se) });
        };
        function B(Z) {
          return Z.ticks + String(Z.ticklen) + String(Z.showticklabels);
        }
        var z = R.MINZOOM / 2 + 0.87, q = "m-0.87,.5h" + z + "v3h-" + (z + 5.2) + "l" + (z / 2 + 2.6) + ",-" + (z * 0.87 + 4.5) + "l2.6,1.5l-" + z / 2 + "," + z * 0.87 + "Z", U = "m0.87,.5h-" + z + "v3h" + (z + 5.2) + "l-" + (z / 2 + 2.6) + ",-" + (z * 0.87 + 4.5) + "l-2.6,1.5l" + z / 2 + "," + z * 0.87 + "Z", G = "m0,1l" + z / 2 + "," + z * 0.87 + "l2.6,-1.5l-" + (z / 2 + 2.6) + ",-" + (z * 0.87 + 4.5) + "l-" + (z / 2 + 2.6) + "," + (z * 0.87 + 4.5) + "l2.6,1.5l" + z / 2 + ",-" + z * 0.87 + "Z", K = "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z", te = !0;
        P.clearOutline = function() {
          T(this.dragOptions), _(this.dragOptions.gd);
        }, P.initInteractions = function() {
          var Z = this, Y = Z.layers.plotbg.select("path").node(), C = Z.graphDiv, j = C._fullLayout._zoomlayer, J, ne;
          this.dragOptions = { element: Y, gd: C, plotinfo: { id: Z.id, domain: C._fullLayout[Z.id].domain, xaxis: Z.xaxis, yaxis: Z.yaxis }, subplot: Z.id, prepFn: function(A, X, H) {
            Z.dragOptions.xaxes = [Z.xaxis], Z.dragOptions.yaxes = [Z.yaxis], J = C._fullLayout._invScaleX, ne = C._fullLayout._invScaleY;
            var ve = Z.dragOptions.dragmode = C._fullLayout.dragmode;
            h(ve) ? Z.dragOptions.minDrag = 1 : Z.dragOptions.minDrag = void 0, ve === "zoom" ? (Z.dragOptions.moveFn = Ae, Z.dragOptions.clickFn = ee, Z.dragOptions.doneFn = Ce, le(A, X, H)) : ve === "pan" ? (Z.dragOptions.moveFn = Ne, Z.dragOptions.clickFn = ee, Z.dragOptions.doneFn = ke, Ue(), Z.clearOutline(C)) : (m(ve) || h(ve)) && d(A, X, H, Z.dragOptions, ve);
          } };
          var ae, se, O, F, S, $, re, E, w, N;
          function W(A) {
            var X = {};
            return X[Z.id + ".aaxis.min"] = A.a, X[Z.id + ".baxis.min"] = A.b, X[Z.id + ".caxis.min"] = A.c, X;
          }
          function ee(A, X) {
            var H = C._fullLayout.clickmode;
            V(C), A === 2 && (C.emit("plotly_doubleclick", null), a.call("_guiRelayout", C, W({ a: 0, b: 0, c: 0 }))), H.indexOf("select") > -1 && A === 1 && y(X, C, [Z.xaxis], [Z.yaxis], Z.id, Z.dragOptions), H.indexOf("event") > -1 && g.click(C, X, Z.id);
          }
          function le(A, X, H) {
            var ve = Y.getBoundingClientRect();
            ae = X - ve.left, se = H - ve.top, C._fullLayout._calcInverseTransform(C);
            var be = C._fullLayout._invTransform, Se = i.apply3DTransform(be)(ae, se);
            ae = Se[0], se = Se[1], O = { a: Z.aaxis.range[0], b: Z.baxis.range[1], c: Z.caxis.range[1] }, S = O, F = Z.aaxis.range[1] - O.a, $ = e(Z.graphDiv._fullLayout[Z.id].bgcolor).getLuminance(), re = "M0," + Z.h + "L" + Z.w / 2 + ", 0L" + Z.w + "," + Z.h + "Z", E = !1, w = j.append("path").attr("class", "zoombox").attr("transform", o(Z.x0, Z.y0)).style({ fill: $ > 0.2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)", "stroke-width": 0 }).attr("d", re), N = j.append("path").attr("class", "zoombox-corners").attr("transform", o(Z.x0, Z.y0)).style({ fill: s.background, stroke: s.defaultLine, "stroke-width": 1, opacity: 0 }).attr("d", "M0,0Z"), Z.clearOutline(C);
          }
          function ie(A, X) {
            return 1 - X / Z.h;
          }
          function pe(A, X) {
            return 1 - (A + (Z.h - X) / Math.sqrt(3)) / Z.w;
          }
          function _e(A, X) {
            return (A - (Z.h - X) / Math.sqrt(3)) / Z.w;
          }
          function Ae(A, X) {
            var H = ae + A * J, ve = se + X * ne, be = Math.max(0, Math.min(1, ie(ae, se), ie(H, ve))), Se = Math.max(0, Math.min(1, pe(ae, se), pe(H, ve))), De = Math.max(0, Math.min(1, _e(ae, se), _e(H, ve))), He = (be / 2 + De) * Z.w, Ze = (1 - be / 2 - Se) * Z.w, We = (He + Ze) / 2, $e = Ze - He, it = (1 - be) * Z.h, Ke = it - $e / M;
            $e < R.MINZOOM ? (S = O, w.attr("d", re), N.attr("d", "M0,0Z")) : (S = { a: O.a + be * F, b: O.b + Se * F, c: O.c + De * F }, w.attr("d", re + "M" + He + "," + it + "H" + Ze + "L" + We + "," + Ke + "L" + He + "," + it + "Z"), N.attr("d", "M" + ae + "," + se + K + "M" + He + "," + it + q + "M" + Ze + "," + it + U + "M" + We + "," + Ke + G)), E || (w.transition().style("fill", $ > 0.2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), N.transition().style("opacity", 1).duration(200), E = !0), C.emit("plotly_relayouting", W(S));
          }
          function Ce() {
            V(C), S !== O && (a.call("_guiRelayout", C, W(S)), te && C.data && C._context.showTips && (i.notifier(r(C, "Double-click to zoom back out"), "long"), te = !1));
          }
          function Ue() {
            O = { a: Z.aaxis.range[0], b: Z.baxis.range[1], c: Z.caxis.range[1] }, S = O;
          }
          function Ne(A, X) {
            var H = A / Z.xaxis._m, ve = X / Z.yaxis._m;
            S = { a: O.a - ve, b: O.b + (H + ve) / 2, c: O.c - (H - ve) / 2 };
            var be = [S.a, S.b, S.c].sort(i.sorterAsc), Se = { a: be.indexOf(S.a), b: be.indexOf(S.b), c: be.indexOf(S.c) };
            be[0] < 0 && (be[1] + be[0] / 2 < 0 ? (be[2] += be[0] + be[1], be[0] = be[1] = 0) : (be[2] += be[0] / 2, be[1] += be[0] / 2, be[0] = 0), S = { a: be[Se.a], b: be[Se.b], c: be[Se.c] }, X = (O.a - S.a) * Z.yaxis._m, A = (O.c - S.c - O.b + S.b) * Z.xaxis._m);
            var De = o(Z.x0 + A, Z.y0 + X);
            Z.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", De);
            var He = o(-A, -X);
            Z.clipDefRelative.select("path").attr("transform", He), Z.aaxis.range = [S.a, Z.sum - S.b - S.c], Z.baxis.range = [Z.sum - S.a - S.c, S.b], Z.caxis.range = [Z.sum - S.a - S.b, S.c], Z.drawAxes(!1), Z._hasClipOnAxisFalse && Z.plotContainer.select(".scatterlayer").selectAll(".trace").call(c.hideOutsideRangePoints, Z), C.emit("plotly_relayouting", W(S));
          }
          function ke() {
            a.call("_guiRelayout", C, W(S));
          }
          Y.onmousemove = function(A) {
            g.hover(C, A, Z.id), C._fullLayout._lasthover = Y, C._fullLayout._hoversubplot = Z.id;
          }, Y.onmouseout = function(A) {
            C._dragging || v.unhover(C, A);
          }, v.init(this.dragOptions);
        };
        function V(Z) {
          n.select(Z).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
        }
      }), Fu = xe((L, k) => {
        var n = Zn(), e = oi().attributes, a = Xn(), i = ra().overrideAll, o = Br().extendFlat, r = { title: { text: a.title.text, font: a.title.font }, color: a.color, tickmode: a.minor.tickmode, nticks: o({}, a.nticks, { dflt: 6, min: 1 }), tick0: a.tick0, dtick: a.dtick, tickvals: a.tickvals, ticktext: a.ticktext, ticks: a.ticks, ticklen: a.ticklen, tickwidth: a.tickwidth, tickcolor: a.tickcolor, ticklabelstep: a.ticklabelstep, showticklabels: a.showticklabels, labelalias: a.labelalias, showtickprefix: a.showtickprefix, tickprefix: a.tickprefix, showticksuffix: a.showticksuffix, ticksuffix: a.ticksuffix, showexponent: a.showexponent, exponentformat: a.exponentformat, minexponent: a.minexponent, separatethousands: a.separatethousands, tickfont: a.tickfont, tickangle: a.tickangle, tickformat: a.tickformat, tickformatstops: a.tickformatstops, hoverformat: a.hoverformat, showline: o({}, a.showline, { dflt: !0 }), linecolor: a.linecolor, linewidth: a.linewidth, showgrid: o({}, a.showgrid, { dflt: !0 }), gridcolor: a.gridcolor, gridwidth: a.gridwidth, griddash: a.griddash, layer: a.layer, min: { valType: "number", dflt: 0, min: 0 } }, s = k.exports = i({ domain: e({ name: "ternary" }), bgcolor: { valType: "color", dflt: n.background }, sum: { valType: "number", dflt: 1, min: 0 }, aaxis: r, baxis: r, caxis: r }, "plot", "from-root");
        s.uirevision = { valType: "any", editType: "none" }, s.aaxis.uirevision = s.baxis.uirevision = s.caxis.uirevision = { valType: "any", editType: "none" };
      }), ch = xe((L, k) => {
        var n = wt(), e = qr(), a = oi().defaults;
        k.exports = function(i, o, r, s) {
          var c = s.type, t = s.attributes, p = s.handleDefaults, l = s.partition || "x", f = o._subplots[c], v = f.length, g = v && f[0].replace(/\d+$/, ""), x, h;
          function m(_, T) {
            return n.coerce(x, h, t, _, T);
          }
          for (var u = 0; u < v; u++) {
            var d = f[u];
            i[d] ? x = i[d] : x = i[d] = {}, h = e.newContainer(o, d, g), s.noUirevision || m("uirevision", o.uirevision);
            var y = {};
            y[l] = [u / v, (u + 1) / v], a(h, o, m, y), s.id = d, p(x, h, m, s);
          }
        };
      }), fh = xe((L, k) => {
        var n = fr(), e = qr(), a = wt(), i = ch(), o = bo(), r = _o(), s = xo(), c = mo(), t = Vs(), p = Fu(), l = ["aaxis", "baxis", "caxis"];
        k.exports = function(g, x, h) {
          i(g, x, h, { type: "ternary", attributes: p, handleDefaults: f, font: x.font, paper_bgcolor: x.paper_bgcolor });
        };
        function f(g, x, h, m) {
          var u = h("bgcolor"), d = h("sum");
          m.bgColor = n.combine(u, m.paper_bgcolor);
          for (var y, _, T, R = 0; R < l.length; R++) y = l[R], _ = g[y] || {}, T = e.newContainer(x, y), T._name = y, v(_, T, m, x);
          var I = x.aaxis, P = x.baxis, M = x.caxis;
          I.min + P.min + M.min >= d && (I.min = 0, P.min = 0, M.min = 0, g.aaxis && delete g.aaxis.min, g.baxis && delete g.baxis.min, g.caxis && delete g.caxis.min);
        }
        function v(g, x, h, m) {
          var u = p[x._name];
          function d(B, z) {
            return a.coerce(g, x, u, B, z);
          }
          d("uirevision", m.uirevision), x.type = "linear";
          var y = d("color"), _ = y !== u.color.dflt ? y : h.font.color, T = x._name, R = T.charAt(0).toUpperCase(), I = "Component " + R, P = d("title.text", I);
          x._hovertitle = P === I ? P : R, a.coerceFont(d, "title.font", h.font, { overrideDflt: { size: a.bigFont(h.font.size), color: _ } }), d("min"), c(g, x, d, "linear"), r(g, x, d, "linear"), o(g, x, d, "linear", { noAutotickangles: !0, noTicklabelshift: !0, noTicklabelstandoff: !0 }), s(g, x, d, { outerTicks: !0 });
          var M = d("showticklabels");
          M && (a.coerceFont(d, "tickfont", h.font, { overrideDflt: { color: _ } }), d("tickangle"), d("tickformat")), t(g, x, d, { dfltColor: y, bgColor: h.bgColor, blend: 60, showLine: !0, showGrid: !0, noZeroLine: !0, attributes: u }), d("hoverformat"), d("layer");
        }
      }), dh = xe((L) => {
        var k = uh(), n = go().getSubplotCalcData, e = wt().counterRegex, a = "ternary";
        L.name = a;
        var i = L.attr = "subplot";
        L.idRoot = a, L.idRegex = L.attrRegex = e(a);
        var o = L.attributes = {};
        o[i] = { valType: "subplotid", dflt: "ternary", editType: "calc" }, L.layoutAttributes = Fu(), L.supplyLayoutDefaults = fh(), L.plot = function(r) {
          for (var s = r._fullLayout, c = r.calcdata, t = s._subplots[a], p = 0; p < t.length; p++) {
            var l = t[p], f = n(c, a, l), v = s[l]._subplot;
            v || (v = new k({ id: l, graphDiv: r, container: s._ternarylayer.node() }, s), s[l]._subplot = v), v.plot(f, s, r._promises);
          }
        }, L.clean = function(r, s, c, t) {
          for (var p = t._subplots[a] || [], l = 0; l < p.length; l++) {
            var f = p[l], v = t[f]._subplot;
            !s[f] && v && (v.plotContainer.remove(), v.clipDef.remove(), v.clipDefRelative.remove(), v.layers["a-title"].remove(), v.layers["b-title"].remove(), v.layers["c-title"].remove());
          }
        }, L.updateFx = function(r) {
          var s = r._fullLayout;
          s._ternarylayer.selectAll("g.toplevel").style("cursor", s.dragmode === "pan" ? "move" : "crosshair");
        };
      }), ph = xe((L, k) => {
        k.exports = { attributes: Nu(), supplyDefaults: nh(), colorbar: Ci(), formatLabels: ah(), calc: ih(), plot: oh(), style: Ba().style, styleOnSelect: Ba().styleOnSelect, hoverPoints: lh(), selectPoints: Us(), eventData: sh(), moduleType: "trace", name: "scatterternary", basePlotModule: dh(), categories: ["ternary", "symbols", "showLegend", "scatter-like"], meta: {} };
      }), hh = xe((L, k) => {
        k.exports = ph();
      }), Bu = xe((L, k) => {
        var n = Ko(), e = Br().extendFlat, a = na().axisHoverFormat;
        k.exports = { y: n.y, x: n.x, x0: n.x0, y0: n.y0, xhoverformat: a("x"), yhoverformat: a("y"), name: e({}, n.name, {}), orientation: e({}, n.orientation, {}), bandwidth: { valType: "number", min: 0, editType: "calc" }, scalegroup: { valType: "string", dflt: "", editType: "calc" }, scalemode: { valType: "enumerated", values: ["width", "count"], dflt: "width", editType: "calc" }, spanmode: { valType: "enumerated", values: ["soft", "hard", "manual"], dflt: "soft", editType: "calc" }, span: { valType: "info_array", items: [{ valType: "any", editType: "calc" }, { valType: "any", editType: "calc" }], editType: "calc" }, line: { color: { valType: "color", editType: "style" }, width: { valType: "number", min: 0, dflt: 2, editType: "style" }, editType: "plot" }, fillcolor: n.fillcolor, points: e({}, n.boxpoints, {}), jitter: e({}, n.jitter, {}), pointpos: e({}, n.pointpos, {}), width: e({}, n.width, {}), marker: n.marker, text: n.text, hovertext: n.hovertext, hovertemplate: n.hovertemplate, hovertemplatefallback: n.hovertemplatefallback, quartilemethod: n.quartilemethod, box: { visible: { valType: "boolean", dflt: !1, editType: "plot" }, width: { valType: "number", min: 0, max: 1, dflt: 0.25, editType: "plot" }, fillcolor: { valType: "color", editType: "style" }, line: { color: { valType: "color", editType: "style" }, width: { valType: "number", min: 0, editType: "style" }, editType: "style" }, editType: "plot" }, meanline: { visible: { valType: "boolean", dflt: !1, editType: "plot" }, color: { valType: "color", editType: "style" }, width: { valType: "number", min: 0, editType: "style" }, editType: "plot" }, side: { valType: "enumerated", values: ["both", "positive", "negative"], dflt: "both", editType: "calc" }, offsetgroup: n.offsetgroup, alignmentgroup: n.alignmentgroup, selected: n.selected, unselected: n.unselected, hoveron: { valType: "flaglist", flags: ["violins", "points", "kde"], dflt: "violins+points+kde", extras: ["all"], editType: "style" }, zorder: n.zorder };
      }), ju = xe((L, k) => {
        var n = Qo(), e = wt().extendFlat;
        k.exports = { violinmode: e({}, n.boxmode, {}), violingap: e({}, n.boxgap, {}), violingroupgap: e({}, n.boxgroupgap, {}) };
      }), vh = xe((L, k) => {
        var n = wt(), e = fr(), a = Pi(), i = Bu();
        k.exports = function(o, r, s, c) {
          function t(P, M) {
            return n.coerce(o, r, i, P, M);
          }
          function p(P, M) {
            return n.coerce2(o, r, i, P, M);
          }
          if (a.handleSampleDefaults(o, r, t, c), r.visible !== !1) {
            t("bandwidth"), t("side");
            var l = t("width");
            l || (t("scalegroup", r.name), t("scalemode"));
            var f = t("span"), v;
            Array.isArray(f) && (v = "manual"), t("spanmode", v);
            var g = t("line.color", (o.marker || {}).color || s), x = t("line.width"), h = t("fillcolor", e.addOpacity(r.line.color, 0.5));
            a.handlePointsDefaults(o, r, t, { prefix: "" });
            var m = p("box.width"), u = p("box.fillcolor", h), d = p("box.line.color", g), y = p("box.line.width", x), _ = t("box.visible", !!(m || u || d || y));
            _ || (r.box = { visible: !1 });
            var T = p("meanline.color", g), R = p("meanline.width", x), I = t("meanline.visible", !!(T || R));
            I || (r.meanline = { visible: !1 }), t("quartilemethod"), t("zorder");
          }
        };
      }), gh = xe((L, k) => {
        var n = wt(), e = ju(), a = su();
        k.exports = function(i, o, r) {
          function s(c, t) {
            return n.coerce(i, o, e, c, t);
          }
          a._supply(i, o, r, s, "violin");
        };
      }), fl = xe((L) => {
        var k = wt(), n = { gaussian: function(e) {
          return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * e * e);
        } };
        L.makeKDE = function(e, a, i) {
          var o = i.length, r = n.gaussian, s = e.bandwidth, c = 1 / (o * s);
          return function(t) {
            for (var p = 0, l = 0; l < o; l++) p += r((t - i[l]) / s);
            return c * p;
          };
        }, L.getPositionOnKdePath = function(e, a, i) {
          var o, r;
          a.orientation === "h" ? (o = "y", r = "x") : (o = "x", r = "y");
          var s = k.findPointOnPath(e.path, i, r, { pathLength: e.pathLength }), c = e.posCenterPx, t = s[o], p = a.side === "both" ? 2 * c - t : c;
          return [t, p];
        }, L.getKdeValue = function(e, a, i) {
          var o = e.pts.map(L.extractVal), r = L.makeKDE(e, a, o);
          return r(i) / e.posDensityScale;
        }, L.extractVal = function(e) {
          return e.v;
        };
      }), yh = xe((L, k) => {
        var n = wt(), e = Ar(), a = uu(), i = fl(), o = Yr().BADNUM;
        k.exports = function(t, p) {
          var l = a(t, p);
          if (l[0].t.empty) return l;
          for (var f = t._fullLayout, v = e.getFromId(t, p[p.orientation === "h" ? "xaxis" : "yaxis"]), g = 1 / 0, x = -1 / 0, h = 0, m = 0, u = 0; u < l.length; u++) {
            var d = l[u], y = d.pts.map(i.extractVal), _ = d.bandwidth = s(p, d, y), T = d.span = c(p, d, v, _);
            if (d.min === d.max && _ === 0) T = d.span = [d.min, d.max], d.density = [{ v: 1, t: T[0] }], d.bandwidth = _, h = Math.max(h, 1);
            else {
              var R = T[1] - T[0], I = Math.ceil(R / (_ / 3)), P = R / I;
              if (!isFinite(P) || !isFinite(I)) return n.error("Something went wrong with computing the violin span"), l[0].t.empty = !0, l;
              var M = i.makeKDE(d, p, y);
              d.density = new Array(I);
              for (var B = 0, z = T[0]; z < T[1] + P / 2; B++, z += P) {
                var q = M(z);
                d.density[B] = { v: q, t: z }, h = Math.max(h, q);
              }
            }
            m = Math.max(m, y.length), g = Math.min(g, T[0]), x = Math.max(x, T[1]);
          }
          var U = e.findExtremes(v, [g, x], { padded: !0 });
          if (p._extremes[v._id] = U, p.width) l[0].t.maxKDE = h;
          else {
            var G = f._violinScaleGroupStats, K = p.scalegroup, te = G[K];
            te ? (te.maxKDE = Math.max(te.maxKDE, h), te.maxCount = Math.max(te.maxCount, m)) : G[K] = { maxKDE: h, maxCount: m };
          }
          return l[0].t.labels.kde = n._(t, "kde:"), l;
        };
        function r(t, p, l) {
          var f = Math.min(p, l / 1.349);
          return 1.059 * f * Math.pow(t, -0.2);
        }
        function s(t, p, l) {
          var f = p.max - p.min;
          if (!f) return t.bandwidth ? t.bandwidth : 0;
          if (t.bandwidth) return Math.max(t.bandwidth, f / 1e4);
          var v = l.length, g = n.stdev(l, v - 1, p.mean);
          return Math.max(r(v, g, p.q3 - p.q1), f / 100);
        }
        function c(t, p, l, f) {
          var v = t.spanmode, g = t.span || [], x = [p.min, p.max], h = [p.min - 2 * f, p.max + 2 * f], m;
          function u(y) {
            var _ = g[y], T = l.type === "multicategory" ? l.r2c(_) : l.d2c(_, 0, t[p.valLetter + "calendar"]);
            return T === o ? h[y] : T;
          }
          v === "soft" ? m = h : v === "hard" ? m = x : m = [u(0), u(1)];
          var d = { type: "linear", range: m };
          return e.setConvert(d), d.cleanRange(), m;
        }
      }), mh = xe((L, k) => {
        var n = cu().setPositionOffset, e = ["v", "h"];
        k.exports = function(a, i) {
          for (var o = a.calcdata, r = i.xaxis, s = i.yaxis, c = 0; c < e.length; c++) {
            for (var t = e[c], p = t === "h" ? s : r, l = [], f = 0; f < o.length; f++) {
              var v = o[f], g = v[0].t, x = v[0].trace;
              x.visible === !0 && x.type === "violin" && !g.empty && x.orientation === t && x.xaxis === r._id && x.yaxis === s._id && l.push(f);
            }
            n("violin", a, l, p);
          }
        };
      }), xh = xe((L, k) => {
        var n = vr(), e = wt(), a = Or(), i = fu(), o = Bs(), r = fl();
        k.exports = function(s, c, t, p) {
          var l = s._context.staticPlot, f = s._fullLayout, v = c.xaxis, g = c.yaxis;
          function x(h, m) {
            var u = o(h, { xaxis: v, yaxis: g, trace: m, connectGaps: !0, baseTolerance: 0.75, shape: "spline", simplify: !0, linearized: !0 });
            return a.smoothopen(u[0], 1);
          }
          e.makeTraceGroups(p, t, "trace violins").each(function(h) {
            var m = n.select(this), u = h[0], d = u.t, y = u.trace;
            if (y.visible !== !0 || d.empty) {
              m.remove();
              return;
            }
            var _ = d.bPos, T = d.bdPos, R = c[d.valLetter + "axis"], I = c[d.posLetter + "axis"], P = y.side === "both", M = P || y.side === "positive", B = P || y.side === "negative", z = m.selectAll("path.violin").data(e.identity);
            z.enter().append("path").style("vector-effect", l ? "none" : "non-scaling-stroke").attr("class", "violin"), z.exit().remove(), z.each(function(Y) {
              var C = n.select(this), j = Y.density, J = j.length, ne = I.c2l(Y.pos + _, !0), ae = I.l2p(ne), se;
              if (y.width) se = d.maxKDE / T;
              else {
                var O = f._violinScaleGroupStats[y.scalegroup];
                se = y.scalemode === "count" ? O.maxKDE / T * (O.maxCount / Y.pts.length) : O.maxKDE / T;
              }
              var F, S, $, re, E, w, N;
              if (M) {
                for (w = new Array(J), re = 0; re < J; re++) N = w[re] = {}, N[d.posLetter] = ne + j[re].v / se, N[d.valLetter] = R.c2l(j[re].t, !0);
                F = x(w, y);
              }
              if (B) {
                for (w = new Array(J), E = 0, re = J - 1; E < J; E++, re--) N = w[E] = {}, N[d.posLetter] = ne - j[re].v / se, N[d.valLetter] = R.c2l(j[re].t, !0);
                S = x(w, y);
              }
              if (P) $ = F + "L" + S.substr(1) + "Z";
              else {
                var W = [ae, R.c2p(j[0].t)], ee = [ae, R.c2p(j[J - 1].t)];
                y.orientation === "h" && (W.reverse(), ee.reverse()), M ? $ = "M" + W + "L" + F.substr(1) + "L" + ee : $ = "M" + ee + "L" + S.substr(1) + "L" + W;
              }
              C.attr("d", $), Y.posCenterPx = ae, Y.posDensityScale = se * T, Y.path = C.node(), Y.pathLength = Y.path.getTotalLength() / (P ? 2 : 1);
            });
            var q = y.box, U = q.width, G = (q.line || {}).width, K, te;
            P ? (K = T * U, te = 0) : M ? (K = [0, T * U / 2], te = G * { x: 1, y: -1 }[d.posLetter]) : (K = [T * U / 2, 0], te = G * { x: -1, y: 1 }[d.posLetter]), i.plotBoxAndWhiskers(m, { pos: I, val: R }, y, { bPos: _, bdPos: K, bPosPxOffset: te }), i.plotBoxMean(m, { pos: I, val: R }, y, { bPos: _, bdPos: K, bPosPxOffset: te });
            var V;
            !y.box.visible && y.meanline.visible && (V = e.identity);
            var Z = m.selectAll("path.meanline").data(V || []);
            Z.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", l ? "none" : "non-scaling-stroke"), Z.exit().remove(), Z.each(function(Y) {
              var C = R.c2p(Y.mean, !0), j = r.getPositionOnKdePath(Y, y, C);
              n.select(this).attr("d", y.orientation === "h" ? "M" + C + "," + j[0] + "V" + j[1] : "M" + j[0] + "," + C + "H" + j[1]);
            }), i.plotPoints(m, { x: v, y: g }, y, d);
          });
        };
      }), bh = xe((L, k) => {
        var n = vr(), e = fr(), a = Ba().stylePoints;
        k.exports = function(i) {
          var o = n.select(i).selectAll("g.trace.violins");
          o.style("opacity", function(r) {
            return r[0].trace.opacity;
          }), o.each(function(r) {
            var s = r[0].trace, c = n.select(this), t = s.box || {}, p = t.line || {}, l = s.meanline || {}, f = l.width;
            c.selectAll("path.violin").style("stroke-width", s.line.width + "px").call(e.stroke, s.line.color).call(e.fill, s.fillcolor), c.selectAll("path.box").style("stroke-width", p.width + "px").call(e.stroke, p.color).call(e.fill, t.fillcolor);
            var v = { "stroke-width": f + "px", "stroke-dasharray": 2 * f + "px," + f + "px" };
            c.selectAll("path.mean").style(v).call(e.stroke, l.color), c.selectAll("path.meanline").style(v).call(e.stroke, l.color), a(c, s, i);
          });
        };
      }), _h = xe((L, k) => {
        var n = fr(), e = wt(), a = Ar(), i = pu(), o = fl();
        k.exports = function(r, s, c, t, p) {
          p || (p = {});
          var l = p.hoverLayer, f = r.cd, v = f[0].trace, g = v.hoveron, x = g.indexOf("violins") !== -1, h = g.indexOf("kde") !== -1, m = [], u, d;
          if (x || h) {
            var y = i.hoverOnBoxes(r, s, c, t);
            if (h && y.length > 0) {
              var _ = r.xa, T = r.ya, R, I, P, M, B;
              v.orientation === "h" ? (B = s, R = "y", P = T, I = "x", M = _) : (B = c, R = "x", P = _, I = "y", M = T);
              var z = f[r.index];
              if (B >= z.span[0] && B <= z.span[1]) {
                var q = e.extendFlat({}, r), U = M.c2p(B, !0), G = o.getKdeValue(z, v, B), K = o.getPositionOnKdePath(z, v, U), te = P._offset, V = P._length;
                q[R + "0"] = K[0], q[R + "1"] = K[1], q[I + "0"] = q[I + "1"] = U, q[I + "Label"] = I + ": " + a.hoverLabelText(M, B, v[I + "hoverformat"]) + ", " + f[0].t.labels.kde + " " + G.toFixed(3);
                for (var Z = 0, Y = 0; Y < y.length; Y++) if (y[Y].attr === "med") {
                  Z = Y;
                  break;
                }
                q.spikeDistance = y[Z].spikeDistance;
                var C = R + "Spike";
                q[C] = y[Z][C], y[Z].spikeDistance = void 0, y[Z][C] = void 0, q.hovertemplate = !1, m.push(q), d = {}, d[R + "1"] = e.constrain(te + K[0], te, te + V), d[R + "2"] = e.constrain(te + K[1], te, te + V), d[I + "1"] = d[I + "2"] = M._offset + U;
              }
            }
            x && (m = m.concat(y));
          }
          g.indexOf("points") !== -1 && (u = i.hoverOnPoints(r, s, c));
          var j = l.selectAll(".violinline-" + v.uid).data(d ? [0] : []);
          return j.enter().append("line").classed("violinline-" + v.uid, !0).attr("stroke-width", 1.5), j.exit().remove(), j.attr(d).call(n.stroke, r.color), t === "closest" ? u ? [u] : m : (u && m.push(u), m);
        };
      }), wh = xe((L, k) => {
        k.exports = { attributes: Bu(), layoutAttributes: ju(), supplyDefaults: vh(), crossTraceDefaults: Pi().crossTraceDefaults, supplyLayoutDefaults: gh(), calc: yh(), crossTraceCalc: mh(), plot: xh(), style: bh(), styleOnSelect: Ba().styleOnSelect, hoverPoints: _h(), selectPoints: hu(), moduleType: "trace", name: "violin", basePlotModule: Kn(), categories: ["cartesian", "svg", "symbols", "oriented", "box-violin", "showLegend", "violinLayout", "zoomScale"], meta: {} };
      }), Th = xe((L, k) => {
        k.exports = wh();
      }), si = xe((L, k) => {
        k.exports = { colormodel: { rgb: { min: [0, 0, 0], max: [255, 255, 255], fmt: function(n) {
          return n.slice(0, 3);
        }, suffix: ["", "", ""] }, rgba: { min: [0, 0, 0, 0], max: [255, 255, 255, 1], fmt: function(n) {
          return n.slice(0, 4);
        }, suffix: ["", "", "", ""] }, rgba256: { colormodel: "rgba", zminDflt: [0, 0, 0, 0], zmaxDflt: [255, 255, 255, 255], min: [0, 0, 0, 0], max: [255, 255, 255, 1], fmt: function(n) {
          return n.slice(0, 4);
        }, suffix: ["", "", "", ""] }, hsl: { min: [0, 0, 0], max: [360, 100, 100], fmt: function(n) {
          var e = n.slice(0, 3);
          return e[1] = e[1] + "%", e[2] = e[2] + "%", e;
        }, suffix: ["°", "%", "%"] }, hsla: { min: [0, 0, 0, 0], max: [360, 100, 100, 1], fmt: function(n) {
          var e = n.slice(0, 4);
          return e[1] = e[1] + "%", e[2] = e[2] + "%", e;
        }, suffix: ["°", "%", "%", ""] } } };
      }), Hu = xe((L, k) => {
        var n = Pn(), e = $n().zorder, { hovertemplateAttrs: a, templatefallbackAttrs: i } = qn(), o = Br().extendFlat, r = si().colormodel, s = ["rgb", "rgba", "rgba256", "hsl", "hsla"], c = [], t = [];
        for (l = 0; l < s.length; l++) p = r[s[l]], c.push("For the `" + s[l] + "` colormodel, it is [" + (p.zminDflt || p.min).join(", ") + "]."), t.push("For the `" + s[l] + "` colormodel, it is [" + (p.zmaxDflt || p.max).join(", ") + "].");
        var p, l;
        k.exports = o({ source: { valType: "string", editType: "calc" }, z: { valType: "data_array", editType: "calc" }, colormodel: { valType: "enumerated", values: s, editType: "calc" }, zsmooth: { valType: "enumerated", values: ["fast", !1], dflt: !1, editType: "plot" }, zmin: { valType: "info_array", items: [{ valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }], editType: "calc" }, zmax: { valType: "info_array", items: [{ valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }, { valType: "number", editType: "calc" }], editType: "calc" }, x0: { valType: "any", dflt: 0, editType: "calc+clearAxisTypes" }, y0: { valType: "any", dflt: 0, editType: "calc+clearAxisTypes" }, dx: { valType: "number", dflt: 1, editType: "calc", description: "Set the pixel's horizontal size." }, dy: { valType: "number", dflt: 1, editType: "calc", description: "Set the pixel's vertical size" }, text: { valType: "data_array", editType: "plot" }, hovertext: { valType: "data_array", editType: "plot" }, hoverinfo: o({}, n.hoverinfo, { flags: ["x", "y", "z", "color", "name", "text"], dflt: "x+y+z+text+name" }), hovertemplate: a({}, { keys: ["z", "color", "colormodel"] }), hovertemplatefallback: i(), zorder: e });
      }), kh = xe((L, k) => {
        var n = wt(), e = Hu(), a = si(), i = ya().IMAGE_URL_PREFIX;
        k.exports = function(o, r) {
          function s(p, l) {
            return n.coerce(o, r, e, p, l);
          }
          s("source"), r.source && !r.source.match(i) && delete r.source, r._hasSource = !!r.source;
          var c = s("z");
          if (r._hasZ = !(c === void 0 || !c.length || !c[0] || !c[0].length), !r._hasZ && !r._hasSource) {
            r.visible = !1;
            return;
          }
          s("x0"), s("y0"), s("dx"), s("dy");
          var t;
          r._hasZ ? (s("colormodel", "rgb"), t = a.colormodel[r.colormodel], s("zmin", t.zminDflt || t.min), s("zmax", t.zmaxDflt || t.max)) : r._hasSource && (r.colormodel = "rgba256", t = a.colormodel[r.colormodel], r.zmin = t.zminDflt, r.zmax = t.zmaxDflt), s("zsmooth"), s("text"), s("hovertext"), s("hovertemplate"), s("hovertemplatefallback"), r._length = null, s("zorder");
        };
      }), ma = xe((L, k) => {
        typeof Object.create == "function" ? k.exports = function(n, e) {
          e && (n.super_ = e, n.prototype = Object.create(e.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }));
        } : k.exports = function(n, e) {
          if (e) {
            n.super_ = e;
            var a = function() {
            };
            a.prototype = e.prototype, n.prototype = new a(), n.prototype.constructor = n;
          }
        };
      }), qu = xe((L, k) => {
        k.exports = Ra().EventEmitter;
      }), Mh = xe((L) => {
        L.byteLength = s, L.toByteArray = t, L.fromByteArray = f;
        var k = [], n = [], e = typeof Uint8Array < "u" ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        for (i = 0, o = a.length; i < o; ++i) k[i] = a[i], n[a.charCodeAt(i)] = i;
        var i, o;
        n[45] = 62, n[95] = 63;
        function r(v) {
          var g = v.length;
          if (g % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var x = v.indexOf("=");
          x === -1 && (x = g);
          var h = x === g ? 0 : 4 - x % 4;
          return [x, h];
        }
        function s(v) {
          var g = r(v), x = g[0], h = g[1];
          return (x + h) * 3 / 4 - h;
        }
        function c(v, g, x) {
          return (g + x) * 3 / 4 - x;
        }
        function t(v) {
          var g, x = r(v), h = x[0], m = x[1], u = new e(c(v, h, m)), d = 0, y = m > 0 ? h - 4 : h, _;
          for (_ = 0; _ < y; _ += 4) g = n[v.charCodeAt(_)] << 18 | n[v.charCodeAt(_ + 1)] << 12 | n[v.charCodeAt(_ + 2)] << 6 | n[v.charCodeAt(_ + 3)], u[d++] = g >> 16 & 255, u[d++] = g >> 8 & 255, u[d++] = g & 255;
          return m === 2 && (g = n[v.charCodeAt(_)] << 2 | n[v.charCodeAt(_ + 1)] >> 4, u[d++] = g & 255), m === 1 && (g = n[v.charCodeAt(_)] << 10 | n[v.charCodeAt(_ + 1)] << 4 | n[v.charCodeAt(_ + 2)] >> 2, u[d++] = g >> 8 & 255, u[d++] = g & 255), u;
        }
        function p(v) {
          return k[v >> 18 & 63] + k[v >> 12 & 63] + k[v >> 6 & 63] + k[v & 63];
        }
        function l(v, g, x) {
          for (var h, m = [], u = g; u < x; u += 3) h = (v[u] << 16 & 16711680) + (v[u + 1] << 8 & 65280) + (v[u + 2] & 255), m.push(p(h));
          return m.join("");
        }
        function f(v) {
          for (var g, x = v.length, h = x % 3, m = [], u = 16383, d = 0, y = x - h; d < y; d += u) m.push(l(v, d, d + u > y ? y : d + u));
          return h === 1 ? (g = v[x - 1], m.push(k[g >> 2] + k[g << 4 & 63] + "==")) : h === 2 && (g = (v[x - 2] << 8) + v[x - 1], m.push(k[g >> 10] + k[g >> 4 & 63] + k[g << 2 & 63] + "=")), m.join("");
        }
      }), Ah = xe((L) => {
        L.read = function(k, n, e, a, i) {
          var o, r, s = i * 8 - a - 1, c = (1 << s) - 1, t = c >> 1, p = -7, l = e ? i - 1 : 0, f = e ? -1 : 1, v = k[n + l];
          for (l += f, o = v & (1 << -p) - 1, v >>= -p, p += s; p > 0; o = o * 256 + k[n + l], l += f, p -= 8) ;
          for (r = o & (1 << -p) - 1, o >>= -p, p += a; p > 0; r = r * 256 + k[n + l], l += f, p -= 8) ;
          if (o === 0) o = 1 - t;
          else {
            if (o === c) return r ? NaN : (v ? -1 : 1) * (1 / 0);
            r = r + Math.pow(2, a), o = o - t;
          }
          return (v ? -1 : 1) * r * Math.pow(2, o - a);
        }, L.write = function(k, n, e, a, i, o) {
          var r, s, c, t = o * 8 - i - 1, p = (1 << t) - 1, l = p >> 1, f = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = a ? 0 : o - 1, g = a ? 1 : -1, x = n < 0 || n === 0 && 1 / n < 0 ? 1 : 0;
          for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (s = isNaN(n) ? 1 : 0, r = p) : (r = Math.floor(Math.log(n) / Math.LN2), n * (c = Math.pow(2, -r)) < 1 && (r--, c *= 2), r + l >= 1 ? n += f / c : n += f * Math.pow(2, 1 - l), n * c >= 2 && (r++, c /= 2), r + l >= p ? (s = 0, r = p) : r + l >= 1 ? (s = (n * c - 1) * Math.pow(2, i), r = r + l) : (s = n * Math.pow(2, l - 1) * Math.pow(2, i), r = 0)); i >= 8; k[e + v] = s & 255, v += g, s /= 256, i -= 8) ;
          for (r = r << i | s, t += i; t > 0; k[e + v] = r & 255, v += g, r /= 256, t -= 8) ;
          k[e + v - g] |= x * 128;
        };
      }), ui = xe((L) => {
        var k = Mh(), n = Ah(), e = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
        L.Buffer = r, L.SlowBuffer = m, L.INSPECT_MAX_BYTES = 50;
        var a = 2147483647;
        L.kMaxLength = a, r.TYPED_ARRAY_SUPPORT = i(), !r.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
        function i() {
          try {
            let A = new Uint8Array(1), X = { foo: function() {
              return 42;
            } };
            return Object.setPrototypeOf(X, Uint8Array.prototype), Object.setPrototypeOf(A, X), A.foo() === 42;
          } catch {
            return !1;
          }
        }
        Object.defineProperty(r.prototype, "parent", { enumerable: !0, get: function() {
          if (r.isBuffer(this)) return this.buffer;
        } }), Object.defineProperty(r.prototype, "offset", { enumerable: !0, get: function() {
          if (r.isBuffer(this)) return this.byteOffset;
        } });
        function o(A) {
          if (A > a) throw new RangeError('The value "' + A + '" is invalid for option "size"');
          let X = new Uint8Array(A);
          return Object.setPrototypeOf(X, r.prototype), X;
        }
        function r(A, X, H) {
          if (typeof A == "number") {
            if (typeof X == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return p(A);
          }
          return s(A, X, H);
        }
        r.poolSize = 8192;
        function s(A, X, H) {
          if (typeof A == "string") return l(A, X);
          if (ArrayBuffer.isView(A)) return v(A);
          if (A == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof A);
          if (Ae(A, ArrayBuffer) || A && Ae(A.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ae(A, SharedArrayBuffer) || A && Ae(A.buffer, SharedArrayBuffer))) return g(A, X, H);
          if (typeof A == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
          let ve = A.valueOf && A.valueOf();
          if (ve != null && ve !== A) return r.from(ve, X, H);
          let be = x(A);
          if (be) return be;
          if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof A[Symbol.toPrimitive] == "function") return r.from(A[Symbol.toPrimitive]("string"), X, H);
          throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof A);
        }
        r.from = function(A, X, H) {
          return s(A, X, H);
        }, Object.setPrototypeOf(r.prototype, Uint8Array.prototype), Object.setPrototypeOf(r, Uint8Array);
        function c(A) {
          if (typeof A != "number") throw new TypeError('"size" argument must be of type number');
          if (A < 0) throw new RangeError('The value "' + A + '" is invalid for option "size"');
        }
        function t(A, X, H) {
          return c(A), A <= 0 ? o(A) : X !== void 0 ? typeof H == "string" ? o(A).fill(X, H) : o(A).fill(X) : o(A);
        }
        r.alloc = function(A, X, H) {
          return t(A, X, H);
        };
        function p(A) {
          return c(A), o(A < 0 ? 0 : h(A) | 0);
        }
        r.allocUnsafe = function(A) {
          return p(A);
        }, r.allocUnsafeSlow = function(A) {
          return p(A);
        };
        function l(A, X) {
          if ((typeof X != "string" || X === "") && (X = "utf8"), !r.isEncoding(X)) throw new TypeError("Unknown encoding: " + X);
          let H = u(A, X) | 0, ve = o(H), be = ve.write(A, X);
          return be !== H && (ve = ve.slice(0, be)), ve;
        }
        function f(A) {
          let X = A.length < 0 ? 0 : h(A.length) | 0, H = o(X);
          for (let ve = 0; ve < X; ve += 1) H[ve] = A[ve] & 255;
          return H;
        }
        function v(A) {
          if (Ae(A, Uint8Array)) {
            let X = new Uint8Array(A);
            return g(X.buffer, X.byteOffset, X.byteLength);
          }
          return f(A);
        }
        function g(A, X, H) {
          if (X < 0 || A.byteLength < X) throw new RangeError('"offset" is outside of buffer bounds');
          if (A.byteLength < X + (H || 0)) throw new RangeError('"length" is outside of buffer bounds');
          let ve;
          return X === void 0 && H === void 0 ? ve = new Uint8Array(A) : H === void 0 ? ve = new Uint8Array(A, X) : ve = new Uint8Array(A, X, H), Object.setPrototypeOf(ve, r.prototype), ve;
        }
        function x(A) {
          if (r.isBuffer(A)) {
            let X = h(A.length) | 0, H = o(X);
            return H.length === 0 || A.copy(H, 0, 0, X), H;
          }
          if (A.length !== void 0) return typeof A.length != "number" || Ce(A.length) ? o(0) : f(A);
          if (A.type === "Buffer" && Array.isArray(A.data)) return f(A.data);
        }
        function h(A) {
          if (A >= a) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
          return A | 0;
        }
        function m(A) {
          return +A != A && (A = 0), r.alloc(+A);
        }
        r.isBuffer = function(A) {
          return A != null && A._isBuffer === !0 && A !== r.prototype;
        }, r.compare = function(A, X) {
          if (Ae(A, Uint8Array) && (A = r.from(A, A.offset, A.byteLength)), Ae(X, Uint8Array) && (X = r.from(X, X.offset, X.byteLength)), !r.isBuffer(A) || !r.isBuffer(X)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
          if (A === X) return 0;
          let H = A.length, ve = X.length;
          for (let be = 0, Se = Math.min(H, ve); be < Se; ++be) if (A[be] !== X[be]) {
            H = A[be], ve = X[be];
            break;
          }
          return H < ve ? -1 : ve < H ? 1 : 0;
        }, r.isEncoding = function(A) {
          switch (String(A).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, r.concat = function(A, X) {
          if (!Array.isArray(A)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (A.length === 0) return r.alloc(0);
          let H;
          if (X === void 0) for (X = 0, H = 0; H < A.length; ++H) X += A[H].length;
          let ve = r.allocUnsafe(X), be = 0;
          for (H = 0; H < A.length; ++H) {
            let Se = A[H];
            if (Ae(Se, Uint8Array)) be + Se.length > ve.length ? (r.isBuffer(Se) || (Se = r.from(Se)), Se.copy(ve, be)) : Uint8Array.prototype.set.call(ve, Se, be);
            else if (r.isBuffer(Se)) Se.copy(ve, be);
            else throw new TypeError('"list" argument must be an Array of Buffers');
            be += Se.length;
          }
          return ve;
        };
        function u(A, X) {
          if (r.isBuffer(A)) return A.length;
          if (ArrayBuffer.isView(A) || Ae(A, ArrayBuffer)) return A.byteLength;
          if (typeof A != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof A);
          let H = A.length, ve = arguments.length > 2 && arguments[2] === !0;
          if (!ve && H === 0) return 0;
          let be = !1;
          for (; ; ) switch (X) {
            case "ascii":
            case "latin1":
            case "binary":
              return H;
            case "utf8":
            case "utf-8":
              return ee(A).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return H * 2;
            case "hex":
              return H >>> 1;
            case "base64":
              return pe(A).length;
            default:
              if (be) return ve ? -1 : ee(A).length;
              X = ("" + X).toLowerCase(), be = !0;
          }
        }
        r.byteLength = u;
        function d(A, X, H) {
          let ve = !1;
          if ((X === void 0 || X < 0) && (X = 0), X > this.length || ((H === void 0 || H > this.length) && (H = this.length), H <= 0) || (H >>>= 0, X >>>= 0, H <= X)) return "";
          for (A || (A = "utf8"); ; ) switch (A) {
            case "hex":
              return V(this, X, H);
            case "utf8":
            case "utf-8":
              return q(this, X, H);
            case "ascii":
              return K(this, X, H);
            case "latin1":
            case "binary":
              return te(this, X, H);
            case "base64":
              return z(this, X, H);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return Z(this, X, H);
            default:
              if (ve) throw new TypeError("Unknown encoding: " + A);
              A = (A + "").toLowerCase(), ve = !0;
          }
        }
        r.prototype._isBuffer = !0;
        function y(A, X, H) {
          let ve = A[X];
          A[X] = A[H], A[H] = ve;
        }
        r.prototype.swap16 = function() {
          let A = this.length;
          if (A % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (let X = 0; X < A; X += 2) y(this, X, X + 1);
          return this;
        }, r.prototype.swap32 = function() {
          let A = this.length;
          if (A % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (let X = 0; X < A; X += 4) y(this, X, X + 3), y(this, X + 1, X + 2);
          return this;
        }, r.prototype.swap64 = function() {
          let A = this.length;
          if (A % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (let X = 0; X < A; X += 8) y(this, X, X + 7), y(this, X + 1, X + 6), y(this, X + 2, X + 5), y(this, X + 3, X + 4);
          return this;
        }, r.prototype.toString = function() {
          let A = this.length;
          return A === 0 ? "" : arguments.length === 0 ? q(this, 0, A) : d.apply(this, arguments);
        }, r.prototype.toLocaleString = r.prototype.toString, r.prototype.equals = function(A) {
          if (!r.isBuffer(A)) throw new TypeError("Argument must be a Buffer");
          return this === A ? !0 : r.compare(this, A) === 0;
        }, r.prototype.inspect = function() {
          let A = "", X = L.INSPECT_MAX_BYTES;
          return A = this.toString("hex", 0, X).replace(/(.{2})/g, "$1 ").trim(), this.length > X && (A += " ... "), "<Buffer " + A + ">";
        }, e && (r.prototype[e] = r.prototype.inspect), r.prototype.compare = function(A, X, H, ve, be) {
          if (Ae(A, Uint8Array) && (A = r.from(A, A.offset, A.byteLength)), !r.isBuffer(A)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof A);
          if (X === void 0 && (X = 0), H === void 0 && (H = A ? A.length : 0), ve === void 0 && (ve = 0), be === void 0 && (be = this.length), X < 0 || H > A.length || ve < 0 || be > this.length) throw new RangeError("out of range index");
          if (ve >= be && X >= H) return 0;
          if (ve >= be) return -1;
          if (X >= H) return 1;
          if (X >>>= 0, H >>>= 0, ve >>>= 0, be >>>= 0, this === A) return 0;
          let Se = be - ve, De = H - X, He = Math.min(Se, De), Ze = this.slice(ve, be), We = A.slice(X, H);
          for (let $e = 0; $e < He; ++$e) if (Ze[$e] !== We[$e]) {
            Se = Ze[$e], De = We[$e];
            break;
          }
          return Se < De ? -1 : De < Se ? 1 : 0;
        };
        function _(A, X, H, ve, be) {
          if (A.length === 0) return -1;
          if (typeof H == "string" ? (ve = H, H = 0) : H > 2147483647 ? H = 2147483647 : H < -2147483648 && (H = -2147483648), H = +H, Ce(H) && (H = be ? 0 : A.length - 1), H < 0 && (H = A.length + H), H >= A.length) {
            if (be) return -1;
            H = A.length - 1;
          } else if (H < 0) if (be) H = 0;
          else return -1;
          if (typeof X == "string" && (X = r.from(X, ve)), r.isBuffer(X)) return X.length === 0 ? -1 : T(A, X, H, ve, be);
          if (typeof X == "number") return X = X & 255, typeof Uint8Array.prototype.indexOf == "function" ? be ? Uint8Array.prototype.indexOf.call(A, X, H) : Uint8Array.prototype.lastIndexOf.call(A, X, H) : T(A, [X], H, ve, be);
          throw new TypeError("val must be string, number or Buffer");
        }
        function T(A, X, H, ve, be) {
          let Se = 1, De = A.length, He = X.length;
          if (ve !== void 0 && (ve = String(ve).toLowerCase(), ve === "ucs2" || ve === "ucs-2" || ve === "utf16le" || ve === "utf-16le")) {
            if (A.length < 2 || X.length < 2) return -1;
            Se = 2, De /= 2, He /= 2, H /= 2;
          }
          function Ze($e, it) {
            return Se === 1 ? $e[it] : $e.readUInt16BE(it * Se);
          }
          let We;
          if (be) {
            let $e = -1;
            for (We = H; We < De; We++) if (Ze(A, We) === Ze(X, $e === -1 ? 0 : We - $e)) {
              if ($e === -1 && ($e = We), We - $e + 1 === He) return $e * Se;
            } else $e !== -1 && (We -= We - $e), $e = -1;
          } else for (H + He > De && (H = De - He), We = H; We >= 0; We--) {
            let $e = !0;
            for (let it = 0; it < He; it++) if (Ze(A, We + it) !== Ze(X, it)) {
              $e = !1;
              break;
            }
            if ($e) return We;
          }
          return -1;
        }
        r.prototype.includes = function(A, X, H) {
          return this.indexOf(A, X, H) !== -1;
        }, r.prototype.indexOf = function(A, X, H) {
          return _(this, A, X, H, !0);
        }, r.prototype.lastIndexOf = function(A, X, H) {
          return _(this, A, X, H, !1);
        };
        function R(A, X, H, ve) {
          H = Number(H) || 0;
          let be = A.length - H;
          ve ? (ve = Number(ve), ve > be && (ve = be)) : ve = be;
          let Se = X.length;
          ve > Se / 2 && (ve = Se / 2);
          let De;
          for (De = 0; De < ve; ++De) {
            let He = parseInt(X.substr(De * 2, 2), 16);
            if (Ce(He)) return De;
            A[H + De] = He;
          }
          return De;
        }
        function I(A, X, H, ve) {
          return _e(ee(X, A.length - H), A, H, ve);
        }
        function P(A, X, H, ve) {
          return _e(le(X), A, H, ve);
        }
        function M(A, X, H, ve) {
          return _e(pe(X), A, H, ve);
        }
        function B(A, X, H, ve) {
          return _e(ie(X, A.length - H), A, H, ve);
        }
        r.prototype.write = function(A, X, H, ve) {
          if (X === void 0) ve = "utf8", H = this.length, X = 0;
          else if (H === void 0 && typeof X == "string") ve = X, H = this.length, X = 0;
          else if (isFinite(X)) X = X >>> 0, isFinite(H) ? (H = H >>> 0, ve === void 0 && (ve = "utf8")) : (ve = H, H = void 0);
          else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          let be = this.length - X;
          if ((H === void 0 || H > be) && (H = be), A.length > 0 && (H < 0 || X < 0) || X > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          ve || (ve = "utf8");
          let Se = !1;
          for (; ; ) switch (ve) {
            case "hex":
              return R(this, A, X, H);
            case "utf8":
            case "utf-8":
              return I(this, A, X, H);
            case "ascii":
            case "latin1":
            case "binary":
              return P(this, A, X, H);
            case "base64":
              return M(this, A, X, H);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return B(this, A, X, H);
            default:
              if (Se) throw new TypeError("Unknown encoding: " + ve);
              ve = ("" + ve).toLowerCase(), Se = !0;
          }
        }, r.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        };
        function z(A, X, H) {
          return X === 0 && H === A.length ? k.fromByteArray(A) : k.fromByteArray(A.slice(X, H));
        }
        function q(A, X, H) {
          H = Math.min(A.length, H);
          let ve = [], be = X;
          for (; be < H; ) {
            let Se = A[be], De = null, He = Se > 239 ? 4 : Se > 223 ? 3 : Se > 191 ? 2 : 1;
            if (be + He <= H) {
              let Ze, We, $e, it;
              switch (He) {
                case 1:
                  Se < 128 && (De = Se);
                  break;
                case 2:
                  Ze = A[be + 1], (Ze & 192) === 128 && (it = (Se & 31) << 6 | Ze & 63, it > 127 && (De = it));
                  break;
                case 3:
                  Ze = A[be + 1], We = A[be + 2], (Ze & 192) === 128 && (We & 192) === 128 && (it = (Se & 15) << 12 | (Ze & 63) << 6 | We & 63, it > 2047 && (it < 55296 || it > 57343) && (De = it));
                  break;
                case 4:
                  Ze = A[be + 1], We = A[be + 2], $e = A[be + 3], (Ze & 192) === 128 && (We & 192) === 128 && ($e & 192) === 128 && (it = (Se & 15) << 18 | (Ze & 63) << 12 | (We & 63) << 6 | $e & 63, it > 65535 && it < 1114112 && (De = it));
              }
            }
            De === null ? (De = 65533, He = 1) : De > 65535 && (De -= 65536, ve.push(De >>> 10 & 1023 | 55296), De = 56320 | De & 1023), ve.push(De), be += He;
          }
          return G(ve);
        }
        var U = 4096;
        function G(A) {
          let X = A.length;
          if (X <= U) return String.fromCharCode.apply(String, A);
          let H = "", ve = 0;
          for (; ve < X; ) H += String.fromCharCode.apply(String, A.slice(ve, ve += U));
          return H;
        }
        function K(A, X, H) {
          let ve = "";
          H = Math.min(A.length, H);
          for (let be = X; be < H; ++be) ve += String.fromCharCode(A[be] & 127);
          return ve;
        }
        function te(A, X, H) {
          let ve = "";
          H = Math.min(A.length, H);
          for (let be = X; be < H; ++be) ve += String.fromCharCode(A[be]);
          return ve;
        }
        function V(A, X, H) {
          let ve = A.length;
          (!X || X < 0) && (X = 0), (!H || H < 0 || H > ve) && (H = ve);
          let be = "";
          for (let Se = X; Se < H; ++Se) be += Ue[A[Se]];
          return be;
        }
        function Z(A, X, H) {
          let ve = A.slice(X, H), be = "";
          for (let Se = 0; Se < ve.length - 1; Se += 2) be += String.fromCharCode(ve[Se] + ve[Se + 1] * 256);
          return be;
        }
        r.prototype.slice = function(A, X) {
          let H = this.length;
          A = ~~A, X = X === void 0 ? H : ~~X, A < 0 ? (A += H, A < 0 && (A = 0)) : A > H && (A = H), X < 0 ? (X += H, X < 0 && (X = 0)) : X > H && (X = H), X < A && (X = A);
          let ve = this.subarray(A, X);
          return Object.setPrototypeOf(ve, r.prototype), ve;
        };
        function Y(A, X, H) {
          if (A % 1 !== 0 || A < 0) throw new RangeError("offset is not uint");
          if (A + X > H) throw new RangeError("Trying to access beyond buffer length");
        }
        r.prototype.readUintLE = r.prototype.readUIntLE = function(A, X, H) {
          A = A >>> 0, X = X >>> 0, H || Y(A, X, this.length);
          let ve = this[A], be = 1, Se = 0;
          for (; ++Se < X && (be *= 256); ) ve += this[A + Se] * be;
          return ve;
        }, r.prototype.readUintBE = r.prototype.readUIntBE = function(A, X, H) {
          A = A >>> 0, X = X >>> 0, H || Y(A, X, this.length);
          let ve = this[A + --X], be = 1;
          for (; X > 0 && (be *= 256); ) ve += this[A + --X] * be;
          return ve;
        }, r.prototype.readUint8 = r.prototype.readUInt8 = function(A, X) {
          return A = A >>> 0, X || Y(A, 1, this.length), this[A];
        }, r.prototype.readUint16LE = r.prototype.readUInt16LE = function(A, X) {
          return A = A >>> 0, X || Y(A, 2, this.length), this[A] | this[A + 1] << 8;
        }, r.prototype.readUint16BE = r.prototype.readUInt16BE = function(A, X) {
          return A = A >>> 0, X || Y(A, 2, this.length), this[A] << 8 | this[A + 1];
        }, r.prototype.readUint32LE = r.prototype.readUInt32LE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), (this[A] | this[A + 1] << 8 | this[A + 2] << 16) + this[A + 3] * 16777216;
        }, r.prototype.readUint32BE = r.prototype.readUInt32BE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), this[A] * 16777216 + (this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3]);
        }, r.prototype.readBigUInt64LE = Ne(function(A) {
          A = A >>> 0, E(A, "offset");
          let X = this[A], H = this[A + 7];
          (X === void 0 || H === void 0) && w(A, this.length - 8);
          let ve = X + this[++A] * 2 ** 8 + this[++A] * 2 ** 16 + this[++A] * 2 ** 24, be = this[++A] + this[++A] * 2 ** 8 + this[++A] * 2 ** 16 + H * 2 ** 24;
          return BigInt(ve) + (BigInt(be) << BigInt(32));
        }), r.prototype.readBigUInt64BE = Ne(function(A) {
          A = A >>> 0, E(A, "offset");
          let X = this[A], H = this[A + 7];
          (X === void 0 || H === void 0) && w(A, this.length - 8);
          let ve = X * 2 ** 24 + this[++A] * 2 ** 16 + this[++A] * 2 ** 8 + this[++A], be = this[++A] * 2 ** 24 + this[++A] * 2 ** 16 + this[++A] * 2 ** 8 + H;
          return (BigInt(ve) << BigInt(32)) + BigInt(be);
        }), r.prototype.readIntLE = function(A, X, H) {
          A = A >>> 0, X = X >>> 0, H || Y(A, X, this.length);
          let ve = this[A], be = 1, Se = 0;
          for (; ++Se < X && (be *= 256); ) ve += this[A + Se] * be;
          return be *= 128, ve >= be && (ve -= Math.pow(2, 8 * X)), ve;
        }, r.prototype.readIntBE = function(A, X, H) {
          A = A >>> 0, X = X >>> 0, H || Y(A, X, this.length);
          let ve = X, be = 1, Se = this[A + --ve];
          for (; ve > 0 && (be *= 256); ) Se += this[A + --ve] * be;
          return be *= 128, Se >= be && (Se -= Math.pow(2, 8 * X)), Se;
        }, r.prototype.readInt8 = function(A, X) {
          return A = A >>> 0, X || Y(A, 1, this.length), this[A] & 128 ? (255 - this[A] + 1) * -1 : this[A];
        }, r.prototype.readInt16LE = function(A, X) {
          A = A >>> 0, X || Y(A, 2, this.length);
          let H = this[A] | this[A + 1] << 8;
          return H & 32768 ? H | 4294901760 : H;
        }, r.prototype.readInt16BE = function(A, X) {
          A = A >>> 0, X || Y(A, 2, this.length);
          let H = this[A + 1] | this[A] << 8;
          return H & 32768 ? H | 4294901760 : H;
        }, r.prototype.readInt32LE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), this[A] | this[A + 1] << 8 | this[A + 2] << 16 | this[A + 3] << 24;
        }, r.prototype.readInt32BE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), this[A] << 24 | this[A + 1] << 16 | this[A + 2] << 8 | this[A + 3];
        }, r.prototype.readBigInt64LE = Ne(function(A) {
          A = A >>> 0, E(A, "offset");
          let X = this[A], H = this[A + 7];
          (X === void 0 || H === void 0) && w(A, this.length - 8);
          let ve = this[A + 4] + this[A + 5] * 2 ** 8 + this[A + 6] * 2 ** 16 + (H << 24);
          return (BigInt(ve) << BigInt(32)) + BigInt(X + this[++A] * 2 ** 8 + this[++A] * 2 ** 16 + this[++A] * 2 ** 24);
        }), r.prototype.readBigInt64BE = Ne(function(A) {
          A = A >>> 0, E(A, "offset");
          let X = this[A], H = this[A + 7];
          (X === void 0 || H === void 0) && w(A, this.length - 8);
          let ve = (X << 24) + this[++A] * 2 ** 16 + this[++A] * 2 ** 8 + this[++A];
          return (BigInt(ve) << BigInt(32)) + BigInt(this[++A] * 2 ** 24 + this[++A] * 2 ** 16 + this[++A] * 2 ** 8 + H);
        }), r.prototype.readFloatLE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), n.read(this, A, !0, 23, 4);
        }, r.prototype.readFloatBE = function(A, X) {
          return A = A >>> 0, X || Y(A, 4, this.length), n.read(this, A, !1, 23, 4);
        }, r.prototype.readDoubleLE = function(A, X) {
          return A = A >>> 0, X || Y(A, 8, this.length), n.read(this, A, !0, 52, 8);
        }, r.prototype.readDoubleBE = function(A, X) {
          return A = A >>> 0, X || Y(A, 8, this.length), n.read(this, A, !1, 52, 8);
        };
        function C(A, X, H, ve, be, Se) {
          if (!r.isBuffer(A)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (X > be || X < Se) throw new RangeError('"value" argument is out of bounds');
          if (H + ve > A.length) throw new RangeError("Index out of range");
        }
        r.prototype.writeUintLE = r.prototype.writeUIntLE = function(A, X, H, ve) {
          if (A = +A, X = X >>> 0, H = H >>> 0, !ve) {
            let De = Math.pow(2, 8 * H) - 1;
            C(this, A, X, H, De, 0);
          }
          let be = 1, Se = 0;
          for (this[X] = A & 255; ++Se < H && (be *= 256); ) this[X + Se] = A / be & 255;
          return X + H;
        }, r.prototype.writeUintBE = r.prototype.writeUIntBE = function(A, X, H, ve) {
          if (A = +A, X = X >>> 0, H = H >>> 0, !ve) {
            let De = Math.pow(2, 8 * H) - 1;
            C(this, A, X, H, De, 0);
          }
          let be = H - 1, Se = 1;
          for (this[X + be] = A & 255; --be >= 0 && (Se *= 256); ) this[X + be] = A / Se & 255;
          return X + H;
        }, r.prototype.writeUint8 = r.prototype.writeUInt8 = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 1, 255, 0), this[X] = A & 255, X + 1;
        }, r.prototype.writeUint16LE = r.prototype.writeUInt16LE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 2, 65535, 0), this[X] = A & 255, this[X + 1] = A >>> 8, X + 2;
        }, r.prototype.writeUint16BE = r.prototype.writeUInt16BE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 2, 65535, 0), this[X] = A >>> 8, this[X + 1] = A & 255, X + 2;
        }, r.prototype.writeUint32LE = r.prototype.writeUInt32LE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 4, 4294967295, 0), this[X + 3] = A >>> 24, this[X + 2] = A >>> 16, this[X + 1] = A >>> 8, this[X] = A & 255, X + 4;
        }, r.prototype.writeUint32BE = r.prototype.writeUInt32BE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 4, 4294967295, 0), this[X] = A >>> 24, this[X + 1] = A >>> 16, this[X + 2] = A >>> 8, this[X + 3] = A & 255, X + 4;
        };
        function j(A, X, H, ve, be) {
          re(X, ve, be, A, H, 7);
          let Se = Number(X & BigInt(4294967295));
          A[H++] = Se, Se = Se >> 8, A[H++] = Se, Se = Se >> 8, A[H++] = Se, Se = Se >> 8, A[H++] = Se;
          let De = Number(X >> BigInt(32) & BigInt(4294967295));
          return A[H++] = De, De = De >> 8, A[H++] = De, De = De >> 8, A[H++] = De, De = De >> 8, A[H++] = De, H;
        }
        function J(A, X, H, ve, be) {
          re(X, ve, be, A, H, 7);
          let Se = Number(X & BigInt(4294967295));
          A[H + 7] = Se, Se = Se >> 8, A[H + 6] = Se, Se = Se >> 8, A[H + 5] = Se, Se = Se >> 8, A[H + 4] = Se;
          let De = Number(X >> BigInt(32) & BigInt(4294967295));
          return A[H + 3] = De, De = De >> 8, A[H + 2] = De, De = De >> 8, A[H + 1] = De, De = De >> 8, A[H] = De, H + 8;
        }
        r.prototype.writeBigUInt64LE = Ne(function(A, X = 0) {
          return j(this, A, X, BigInt(0), BigInt("0xffffffffffffffff"));
        }), r.prototype.writeBigUInt64BE = Ne(function(A, X = 0) {
          return J(this, A, X, BigInt(0), BigInt("0xffffffffffffffff"));
        }), r.prototype.writeIntLE = function(A, X, H, ve) {
          if (A = +A, X = X >>> 0, !ve) {
            let He = Math.pow(2, 8 * H - 1);
            C(this, A, X, H, He - 1, -He);
          }
          let be = 0, Se = 1, De = 0;
          for (this[X] = A & 255; ++be < H && (Se *= 256); ) A < 0 && De === 0 && this[X + be - 1] !== 0 && (De = 1), this[X + be] = (A / Se >> 0) - De & 255;
          return X + H;
        }, r.prototype.writeIntBE = function(A, X, H, ve) {
          if (A = +A, X = X >>> 0, !ve) {
            let He = Math.pow(2, 8 * H - 1);
            C(this, A, X, H, He - 1, -He);
          }
          let be = H - 1, Se = 1, De = 0;
          for (this[X + be] = A & 255; --be >= 0 && (Se *= 256); ) A < 0 && De === 0 && this[X + be + 1] !== 0 && (De = 1), this[X + be] = (A / Se >> 0) - De & 255;
          return X + H;
        }, r.prototype.writeInt8 = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 1, 127, -128), A < 0 && (A = 255 + A + 1), this[X] = A & 255, X + 1;
        }, r.prototype.writeInt16LE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 2, 32767, -32768), this[X] = A & 255, this[X + 1] = A >>> 8, X + 2;
        }, r.prototype.writeInt16BE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 2, 32767, -32768), this[X] = A >>> 8, this[X + 1] = A & 255, X + 2;
        }, r.prototype.writeInt32LE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 4, 2147483647, -2147483648), this[X] = A & 255, this[X + 1] = A >>> 8, this[X + 2] = A >>> 16, this[X + 3] = A >>> 24, X + 4;
        }, r.prototype.writeInt32BE = function(A, X, H) {
          return A = +A, X = X >>> 0, H || C(this, A, X, 4, 2147483647, -2147483648), A < 0 && (A = 4294967295 + A + 1), this[X] = A >>> 24, this[X + 1] = A >>> 16, this[X + 2] = A >>> 8, this[X + 3] = A & 255, X + 4;
        }, r.prototype.writeBigInt64LE = Ne(function(A, X = 0) {
          return j(this, A, X, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        }), r.prototype.writeBigInt64BE = Ne(function(A, X = 0) {
          return J(this, A, X, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
        });
        function ne(A, X, H, ve, be, Se) {
          if (H + ve > A.length) throw new RangeError("Index out of range");
          if (H < 0) throw new RangeError("Index out of range");
        }
        function ae(A, X, H, ve, be) {
          return X = +X, H = H >>> 0, be || ne(A, X, H, 4), n.write(A, X, H, ve, 23, 4), H + 4;
        }
        r.prototype.writeFloatLE = function(A, X, H) {
          return ae(this, A, X, !0, H);
        }, r.prototype.writeFloatBE = function(A, X, H) {
          return ae(this, A, X, !1, H);
        };
        function se(A, X, H, ve, be) {
          return X = +X, H = H >>> 0, be || ne(A, X, H, 8), n.write(A, X, H, ve, 52, 8), H + 8;
        }
        r.prototype.writeDoubleLE = function(A, X, H) {
          return se(this, A, X, !0, H);
        }, r.prototype.writeDoubleBE = function(A, X, H) {
          return se(this, A, X, !1, H);
        }, r.prototype.copy = function(A, X, H, ve) {
          if (!r.isBuffer(A)) throw new TypeError("argument should be a Buffer");
          if (H || (H = 0), !ve && ve !== 0 && (ve = this.length), X >= A.length && (X = A.length), X || (X = 0), ve > 0 && ve < H && (ve = H), ve === H || A.length === 0 || this.length === 0) return 0;
          if (X < 0) throw new RangeError("targetStart out of bounds");
          if (H < 0 || H >= this.length) throw new RangeError("Index out of range");
          if (ve < 0) throw new RangeError("sourceEnd out of bounds");
          ve > this.length && (ve = this.length), A.length - X < ve - H && (ve = A.length - X + H);
          let be = ve - H;
          return this === A && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(X, H, ve) : Uint8Array.prototype.set.call(A, this.subarray(H, ve), X), be;
        }, r.prototype.fill = function(A, X, H, ve) {
          if (typeof A == "string") {
            if (typeof X == "string" ? (ve = X, X = 0, H = this.length) : typeof H == "string" && (ve = H, H = this.length), ve !== void 0 && typeof ve != "string") throw new TypeError("encoding must be a string");
            if (typeof ve == "string" && !r.isEncoding(ve)) throw new TypeError("Unknown encoding: " + ve);
            if (A.length === 1) {
              let Se = A.charCodeAt(0);
              (ve === "utf8" && Se < 128 || ve === "latin1") && (A = Se);
            }
          } else typeof A == "number" ? A = A & 255 : typeof A == "boolean" && (A = Number(A));
          if (X < 0 || this.length < X || this.length < H) throw new RangeError("Out of range index");
          if (H <= X) return this;
          X = X >>> 0, H = H === void 0 ? this.length : H >>> 0, A || (A = 0);
          let be;
          if (typeof A == "number") for (be = X; be < H; ++be) this[be] = A;
          else {
            let Se = r.isBuffer(A) ? A : r.from(A, ve), De = Se.length;
            if (De === 0) throw new TypeError('The value "' + A + '" is invalid for argument "value"');
            for (be = 0; be < H - X; ++be) this[be + X] = Se[be % De];
          }
          return this;
        };
        var O = {};
        function F(A, X, H) {
          O[A] = class extends H {
            constructor() {
              super(), Object.defineProperty(this, "message", { value: X.apply(this, arguments), writable: !0, configurable: !0 }), this.name = `${this.name} [${A}]`, this.stack, delete this.name;
            }
            get code() {
              return A;
            }
            set code(ve) {
              Object.defineProperty(this, "code", { configurable: !0, enumerable: !0, value: ve, writable: !0 });
            }
            toString() {
              return `${this.name} [${A}]: ${this.message}`;
            }
          };
        }
        F("ERR_BUFFER_OUT_OF_BOUNDS", function(A) {
          return A ? `${A} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
        }, RangeError), F("ERR_INVALID_ARG_TYPE", function(A, X) {
          return `The "${A}" argument must be of type number. Received type ${typeof X}`;
        }, TypeError), F("ERR_OUT_OF_RANGE", function(A, X, H) {
          let ve = `The value of "${A}" is out of range.`, be = H;
          return Number.isInteger(H) && Math.abs(H) > 2 ** 32 ? be = S(String(H)) : typeof H == "bigint" && (be = String(H), (H > BigInt(2) ** BigInt(32) || H < -(BigInt(2) ** BigInt(32))) && (be = S(be)), be += "n"), ve += ` It must be ${X}. Received ${be}`, ve;
        }, RangeError);
        function S(A) {
          let X = "", H = A.length, ve = A[0] === "-" ? 1 : 0;
          for (; H >= ve + 4; H -= 3) X = `_${A.slice(H - 3, H)}${X}`;
          return `${A.slice(0, H)}${X}`;
        }
        function $(A, X, H) {
          E(X, "offset"), (A[X] === void 0 || A[X + H] === void 0) && w(X, A.length - (H + 1));
        }
        function re(A, X, H, ve, be, Se) {
          if (A > H || A < X) {
            let De = typeof X == "bigint" ? "n" : "", He;
            throw X === 0 || X === BigInt(0) ? He = `>= 0${De} and < 2${De} ** ${(Se + 1) * 8}${De}` : He = `>= -(2${De} ** ${(Se + 1) * 8 - 1}${De}) and < 2 ** ${(Se + 1) * 8 - 1}${De}`, new O.ERR_OUT_OF_RANGE("value", He, A);
          }
          $(ve, be, Se);
        }
        function E(A, X) {
          if (typeof A != "number") throw new O.ERR_INVALID_ARG_TYPE(X, "number", A);
        }
        function w(A, X, H) {
          throw Math.floor(A) !== A ? (E(A, H), new O.ERR_OUT_OF_RANGE("offset", "an integer", A)) : X < 0 ? new O.ERR_BUFFER_OUT_OF_BOUNDS() : new O.ERR_OUT_OF_RANGE("offset", `>= 0 and <= ${X}`, A);
        }
        var N = /[^+/0-9A-Za-z-_]/g;
        function W(A) {
          if (A = A.split("=")[0], A = A.trim().replace(N, ""), A.length < 2) return "";
          for (; A.length % 4 !== 0; ) A = A + "=";
          return A;
        }
        function ee(A, X) {
          X = X || 1 / 0;
          let H, ve = A.length, be = null, Se = [];
          for (let De = 0; De < ve; ++De) {
            if (H = A.charCodeAt(De), H > 55295 && H < 57344) {
              if (!be) {
                if (H > 56319) {
                  (X -= 3) > -1 && Se.push(239, 191, 189);
                  continue;
                } else if (De + 1 === ve) {
                  (X -= 3) > -1 && Se.push(239, 191, 189);
                  continue;
                }
                be = H;
                continue;
              }
              if (H < 56320) {
                (X -= 3) > -1 && Se.push(239, 191, 189), be = H;
                continue;
              }
              H = (be - 55296 << 10 | H - 56320) + 65536;
            } else be && (X -= 3) > -1 && Se.push(239, 191, 189);
            if (be = null, H < 128) {
              if ((X -= 1) < 0) break;
              Se.push(H);
            } else if (H < 2048) {
              if ((X -= 2) < 0) break;
              Se.push(H >> 6 | 192, H & 63 | 128);
            } else if (H < 65536) {
              if ((X -= 3) < 0) break;
              Se.push(H >> 12 | 224, H >> 6 & 63 | 128, H & 63 | 128);
            } else if (H < 1114112) {
              if ((X -= 4) < 0) break;
              Se.push(H >> 18 | 240, H >> 12 & 63 | 128, H >> 6 & 63 | 128, H & 63 | 128);
            } else throw new Error("Invalid code point");
          }
          return Se;
        }
        function le(A) {
          let X = [];
          for (let H = 0; H < A.length; ++H) X.push(A.charCodeAt(H) & 255);
          return X;
        }
        function ie(A, X) {
          let H, ve, be, Se = [];
          for (let De = 0; De < A.length && !((X -= 2) < 0); ++De) H = A.charCodeAt(De), ve = H >> 8, be = H % 256, Se.push(be), Se.push(ve);
          return Se;
        }
        function pe(A) {
          return k.toByteArray(W(A));
        }
        function _e(A, X, H, ve) {
          let be;
          for (be = 0; be < ve && !(be + H >= X.length || be >= A.length); ++be) X[be + H] = A[be];
          return be;
        }
        function Ae(A, X) {
          return A instanceof X || A != null && A.constructor != null && A.constructor.name != null && A.constructor.name === X.name;
        }
        function Ce(A) {
          return A !== A;
        }
        var Ue = function() {
          let A = "0123456789abcdef", X = new Array(256);
          for (let H = 0; H < 16; ++H) {
            let ve = H * 16;
            for (let be = 0; be < 16; ++be) X[ve + be] = A[H] + A[be];
          }
          return X;
        }();
        function Ne(A) {
          return typeof BigInt > "u" ? ke : A;
        }
        function ke() {
          throw new Error("BigInt not supported");
        }
      }), dl = xe((L, k) => {
        k.exports = function() {
          if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
          if (typeof Symbol.iterator == "symbol") return !0;
          var n = {}, e = Symbol("test"), a = Object(e);
          if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(a) !== "[object Symbol]") return !1;
          var i = 42;
          n[e] = i;
          for (var o in n) return !1;
          if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0) return !1;
          var r = Object.getOwnPropertySymbols(n);
          if (r.length !== 1 || r[0] !== e || !Object.prototype.propertyIsEnumerable.call(n, e)) return !1;
          if (typeof Object.getOwnPropertyDescriptor == "function") {
            var s = Object.getOwnPropertyDescriptor(n, e);
            if (s.value !== i || s.enumerable !== !0) return !1;
          }
          return !0;
        };
      }), Ni = xe((L, k) => {
        var n = dl();
        k.exports = function() {
          return n() && !!Symbol.toStringTag;
        };
      }), Uu = xe((L, k) => {
        k.exports = Object;
      }), Sh = xe((L, k) => {
        k.exports = Error;
      }), Lh = xe((L, k) => {
        k.exports = EvalError;
      }), Oh = xe((L, k) => {
        k.exports = RangeError;
      }), Ch = xe((L, k) => {
        k.exports = ReferenceError;
      }), Vu = xe((L, k) => {
        k.exports = SyntaxError;
      }), ci = xe((L, k) => {
        k.exports = TypeError;
      }), Eh = xe((L, k) => {
        k.exports = URIError;
      }), Dh = xe((L, k) => {
        k.exports = Math.abs;
      }), Ph = xe((L, k) => {
        k.exports = Math.floor;
      }), Ih = xe((L, k) => {
        k.exports = Math.max;
      }), zh = xe((L, k) => {
        k.exports = Math.min;
      }), Rh = xe((L, k) => {
        k.exports = Math.pow;
      }), Nh = xe((L, k) => {
        k.exports = Math.round;
      }), Fh = xe((L, k) => {
        k.exports = Number.isNaN || function(n) {
          return n !== n;
        };
      }), Bh = xe((L, k) => {
        var n = Fh();
        k.exports = function(e) {
          return n(e) || e === 0 ? e : e < 0 ? -1 : 1;
        };
      }), jh = xe((L, k) => {
        k.exports = Object.getOwnPropertyDescriptor;
      }), qa = xe((L, k) => {
        var n = jh();
        if (n) try {
          n([], "length");
        } catch {
          n = null;
        }
        k.exports = n;
      }), Fi = xe((L, k) => {
        var n = Object.defineProperty || !1;
        if (n) try {
          n({}, "a", { value: 1 });
        } catch {
          n = !1;
        }
        k.exports = n;
      }), Hh = xe((L, k) => {
        var n = typeof Symbol < "u" && Symbol, e = dl();
        k.exports = function() {
          return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
        };
      }), Yu = xe((L, k) => {
        k.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
      }), Gu = xe((L, k) => {
        var n = Uu();
        k.exports = n.getPrototypeOf || null;
      }), qh = xe((L, k) => {
        var n = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, a = Math.max, i = "[object Function]", o = function(c, t) {
          for (var p = [], l = 0; l < c.length; l += 1) p[l] = c[l];
          for (var f = 0; f < t.length; f += 1) p[f + c.length] = t[f];
          return p;
        }, r = function(c, t) {
          for (var p = [], l = t, f = 0; l < c.length; l += 1, f += 1) p[f] = c[l];
          return p;
        }, s = function(c, t) {
          for (var p = "", l = 0; l < c.length; l += 1) p += c[l], l + 1 < c.length && (p += t);
          return p;
        };
        k.exports = function(c) {
          var t = this;
          if (typeof t != "function" || e.apply(t) !== i) throw new TypeError(n + t);
          for (var p = r(arguments, 1), l, f = function() {
            if (this instanceof l) {
              var m = t.apply(this, o(p, arguments));
              return Object(m) === m ? m : this;
            }
            return t.apply(c, o(p, arguments));
          }, v = a(0, t.length - p.length), g = [], x = 0; x < v; x++) g[x] = "$" + x;
          if (l = Function("binder", "return function (" + s(g, ",") + "){ return binder.apply(this,arguments); }")(f), t.prototype) {
            var h = function() {
            };
            h.prototype = t.prototype, l.prototype = new h(), h.prototype = null;
          }
          return l;
        };
      }), fi = xe((L, k) => {
        var n = qh();
        k.exports = Function.prototype.bind || n;
      }), pl = xe((L, k) => {
        k.exports = Function.prototype.call;
      }), Zu = xe((L, k) => {
        k.exports = Function.prototype.apply;
      }), Uh = xe((L, k) => {
        k.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
      }), Vh = xe((L, k) => {
        var n = fi(), e = Zu(), a = pl(), i = Uh();
        k.exports = i || n.call(a, e);
      }), Yh = xe((L, k) => {
        var n = fi(), e = ci(), a = pl(), i = Vh();
        k.exports = function(o) {
          if (o.length < 1 || typeof o[0] != "function") throw new e("a function is required");
          return i(n, a, o);
        };
      }), Gh = xe((L, k) => {
        var n = Yh(), e = qa(), a;
        try {
          a = [].__proto__ === Array.prototype;
        } catch (s) {
          if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS") throw s;
        }
        var i = !!a && e && e(Object.prototype, "__proto__"), o = Object, r = o.getPrototypeOf;
        k.exports = i && typeof i.get == "function" ? n([i.get]) : typeof r == "function" ? function(s) {
          return r(s == null ? s : o(s));
        } : !1;
      }), Zh = xe((L, k) => {
        var n = Yu(), e = Gu(), a = Gh();
        k.exports = n ? function(i) {
          return n(i);
        } : e ? function(i) {
          if (!i || typeof i != "object" && typeof i != "function") throw new TypeError("getProto: not an object");
          return e(i);
        } : a ? function(i) {
          return a(i);
        } : null;
      }), Wh = xe((L, k) => {
        var n = Function.prototype.call, e = Object.prototype.hasOwnProperty, a = fi();
        k.exports = a.call(n, e);
      }), hl = xe((L, k) => {
        var n, e = Uu(), a = Sh(), i = Lh(), o = Oh(), r = Ch(), s = Vu(), c = ci(), t = Eh(), p = Dh(), l = Ph(), f = Ih(), v = zh(), g = Rh(), x = Nh(), h = Bh(), m = Function, u = function($) {
          try {
            return m('"use strict"; return (' + $ + ").constructor;")();
          } catch {
          }
        }, d = qa(), y = Fi(), _ = function() {
          throw new c();
        }, T = d ? function() {
          try {
            return arguments.callee, _;
          } catch {
            try {
              return d(arguments, "callee").get;
            } catch {
              return _;
            }
          }
        }() : _, R = Hh()(), I = Zh(), P = Gu(), M = Yu(), B = Zu(), z = pl(), q = {}, U = typeof Uint8Array > "u" || !I ? n : I(Uint8Array), G = { __proto__: null, "%AggregateError%": typeof AggregateError > "u" ? n : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer, "%ArrayIteratorPrototype%": R && I ? I([][Symbol.iterator]()) : n, "%AsyncFromSyncIteratorPrototype%": n, "%AsyncFunction%": q, "%AsyncGenerator%": q, "%AsyncGeneratorFunction%": q, "%AsyncIteratorPrototype%": q, "%Atomics%": typeof Atomics > "u" ? n : Atomics, "%BigInt%": typeof BigInt > "u" ? n : BigInt, "%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView > "u" ? n : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": a, "%eval%": eval, "%EvalError%": i, "%Float16Array%": typeof Float16Array > "u" ? n : Float16Array, "%Float32Array%": typeof Float32Array > "u" ? n : Float32Array, "%Float64Array%": typeof Float64Array > "u" ? n : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry, "%Function%": m, "%GeneratorFunction%": q, "%Int8Array%": typeof Int8Array > "u" ? n : Int8Array, "%Int16Array%": typeof Int16Array > "u" ? n : Int16Array, "%Int32Array%": typeof Int32Array > "u" ? n : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": R && I ? I(I([][Symbol.iterator]())) : n, "%JSON%": typeof JSON == "object" ? JSON : n, "%Map%": typeof Map > "u" ? n : Map, "%MapIteratorPrototype%": typeof Map > "u" || !R || !I ? n : I((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": e, "%Object.getOwnPropertyDescriptor%": d, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise > "u" ? n : Promise, "%Proxy%": typeof Proxy > "u" ? n : Proxy, "%RangeError%": o, "%ReferenceError%": r, "%Reflect%": typeof Reflect > "u" ? n : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set > "u" ? n : Set, "%SetIteratorPrototype%": typeof Set > "u" || !R || !I ? n : I((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": R && I ? I(""[Symbol.iterator]()) : n, "%Symbol%": R ? Symbol : n, "%SyntaxError%": s, "%ThrowTypeError%": T, "%TypedArray%": U, "%TypeError%": c, "%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array, "%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array, "%URIError%": t, "%WeakMap%": typeof WeakMap > "u" ? n : WeakMap, "%WeakRef%": typeof WeakRef > "u" ? n : WeakRef, "%WeakSet%": typeof WeakSet > "u" ? n : WeakSet, "%Function.prototype.call%": z, "%Function.prototype.apply%": B, "%Object.defineProperty%": y, "%Object.getPrototypeOf%": P, "%Math.abs%": p, "%Math.floor%": l, "%Math.max%": f, "%Math.min%": v, "%Math.pow%": g, "%Math.round%": x, "%Math.sign%": h, "%Reflect.getPrototypeOf%": M };
        if (I) try {
          null.error;
        } catch ($) {
          K = I(I($)), G["%Error.prototype%"] = K;
        }
        var K, te = function $(re) {
          var E;
          if (re === "%AsyncFunction%") E = u("async function () {}");
          else if (re === "%GeneratorFunction%") E = u("function* () {}");
          else if (re === "%AsyncGeneratorFunction%") E = u("async function* () {}");
          else if (re === "%AsyncGenerator%") {
            var w = $("%AsyncGeneratorFunction%");
            w && (E = w.prototype);
          } else if (re === "%AsyncIteratorPrototype%") {
            var N = $("%AsyncGenerator%");
            N && I && (E = I(N.prototype));
          }
          return G[re] = E, E;
        }, V = { __proto__: null, "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, Z = fi(), Y = Wh(), C = Z.call(z, Array.prototype.concat), j = Z.call(B, Array.prototype.splice), J = Z.call(z, String.prototype.replace), ne = Z.call(z, String.prototype.slice), ae = Z.call(z, RegExp.prototype.exec), se = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, O = /\\(\\)?/g, F = function($) {
          var re = ne($, 0, 1), E = ne($, -1);
          if (re === "%" && E !== "%") throw new s("invalid intrinsic syntax, expected closing `%`");
          if (E === "%" && re !== "%") throw new s("invalid intrinsic syntax, expected opening `%`");
          var w = [];
          return J($, se, function(N, W, ee, le) {
            w[w.length] = ee ? J(le, O, "$1") : W || N;
          }), w;
        }, S = function($, re) {
          var E = $, w;
          if (Y(V, E) && (w = V[E], E = "%" + w[0] + "%"), Y(G, E)) {
            var N = G[E];
            if (N === q && (N = te(E)), typeof N > "u" && !re) throw new c("intrinsic " + $ + " exists, but is not available. Please file an issue!");
            return { alias: w, name: E, value: N };
          }
          throw new s("intrinsic " + $ + " does not exist!");
        };
        k.exports = function($, re) {
          if (typeof $ != "string" || $.length === 0) throw new c("intrinsic name must be a non-empty string");
          if (arguments.length > 1 && typeof re != "boolean") throw new c('"allowMissing" argument must be a boolean');
          if (ae(/^%?[^%]*%?$/, $) === null) throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
          var E = F($), w = E.length > 0 ? E[0] : "", N = S("%" + w + "%", re), W = N.name, ee = N.value, le = !1, ie = N.alias;
          ie && (w = ie[0], j(E, C([0, 1], ie)));
          for (var pe = 1, _e = !0; pe < E.length; pe += 1) {
            var Ae = E[pe], Ce = ne(Ae, 0, 1), Ue = ne(Ae, -1);
            if ((Ce === '"' || Ce === "'" || Ce === "`" || Ue === '"' || Ue === "'" || Ue === "`") && Ce !== Ue) throw new s("property names with quotes must have matching quotes");
            if ((Ae === "constructor" || !_e) && (le = !0), w += "." + Ae, W = "%" + w + "%", Y(G, W)) ee = G[W];
            else if (ee != null) {
              if (!(Ae in ee)) {
                if (!re) throw new c("base intrinsic for " + $ + " exists, but the property is not available.");
                return;
              }
              if (d && pe + 1 >= E.length) {
                var Ne = d(ee, Ae);
                _e = !!Ne, _e && "get" in Ne && !("originalValue" in Ne.get) ? ee = Ne.get : ee = ee[Ae];
              } else _e = Y(ee, Ae), ee = ee[Ae];
              _e && !le && (G[W] = ee);
            }
          }
          return ee;
        };
      }), Xh = xe((L, k) => {
        var n = Fi(), e = Vu(), a = ci(), i = qa();
        k.exports = function(o, r, s) {
          if (!o || typeof o != "object" && typeof o != "function") throw new a("`obj` must be an object or a function`");
          if (typeof r != "string" && typeof r != "symbol") throw new a("`property` must be a string or a symbol`");
          if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new a("`nonEnumerable`, if provided, must be a boolean or null");
          if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new a("`nonWritable`, if provided, must be a boolean or null");
          if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new a("`nonConfigurable`, if provided, must be a boolean or null");
          if (arguments.length > 6 && typeof arguments[6] != "boolean") throw new a("`loose`, if provided, must be a boolean");
          var c = arguments.length > 3 ? arguments[3] : null, t = arguments.length > 4 ? arguments[4] : null, p = arguments.length > 5 ? arguments[5] : null, l = arguments.length > 6 ? arguments[6] : !1, f = !!i && i(o, r);
          if (n) n(o, r, { configurable: p === null && f ? f.configurable : !p, enumerable: c === null && f ? f.enumerable : !c, value: s, writable: t === null && f ? f.writable : !t });
          else if (l || !c && !t && !p) o[r] = s;
          else throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
        };
      }), Wu = xe((L, k) => {
        var n = Fi(), e = function() {
          return !!n;
        };
        e.hasArrayLengthDefineBug = function() {
          if (!n) return null;
          try {
            return n([], "length", { value: 1 }).length !== 1;
          } catch {
            return !0;
          }
        }, k.exports = e;
      }), Jh = xe((L, k) => {
        var n = hl(), e = Xh(), a = Wu()(), i = qa(), o = ci(), r = n("%Math.floor%");
        k.exports = function(s, c) {
          if (typeof s != "function") throw new o("`fn` is not a function");
          if (typeof c != "number" || c < 0 || c > 4294967295 || r(c) !== c) throw new o("`length` must be a positive 32-bit integer");
          var t = arguments.length > 2 && !!arguments[2], p = !0, l = !0;
          if ("length" in s && i) {
            var f = i(s, "length");
            f && !f.configurable && (p = !1), f && !f.writable && (l = !1);
          }
          return (p || l || !t) && (a ? e(s, "length", c, !0, !0) : e(s, "length", c)), s;
        };
      }), Bi = xe((L, k) => {
        var n = fi(), e = hl(), a = Jh(), i = ci(), o = e("%Function.prototype.apply%"), r = e("%Function.prototype.call%"), s = e("%Reflect.apply%", !0) || n.call(r, o), c = Fi(), t = e("%Math.max%");
        k.exports = function(l) {
          if (typeof l != "function") throw new i("a function is required");
          var f = s(n, r, arguments);
          return a(f, 1 + t(0, l.length - (arguments.length - 1)), !0);
        };
        var p = function() {
          return s(n, o, arguments);
        };
        c ? c(k.exports, "apply", { value: p }) : k.exports.apply = p;
      }), di = xe((L, k) => {
        var n = hl(), e = Bi(), a = e(n("String.prototype.indexOf"));
        k.exports = function(i, o) {
          var r = n(i, !!o);
          return typeof r == "function" && a(i, ".prototype.") > -1 ? e(r) : r;
        };
      }), $h = xe((L, k) => {
        var n = Ni()(), e = di(), a = e("Object.prototype.toString"), i = function(s) {
          return n && s && typeof s == "object" && Symbol.toStringTag in s ? !1 : a(s) === "[object Arguments]";
        }, o = function(s) {
          return i(s) ? !0 : s !== null && typeof s == "object" && typeof s.length == "number" && s.length >= 0 && a(s) !== "[object Array]" && a(s.callee) === "[object Function]";
        }, r = function() {
          return i(arguments);
        }();
        i.isLegacyArguments = o, k.exports = r ? i : o;
      }), Kh = xe((L, k) => {
        var n = Object.prototype.toString, e = Function.prototype.toString, a = /^\s*(?:function)?\*/, i = Ni()(), o = Object.getPrototypeOf, r = function() {
          if (!i) return !1;
          try {
            return Function("return function*() {}")();
          } catch {
          }
        }, s;
        k.exports = function(c) {
          if (typeof c != "function") return !1;
          if (a.test(e.call(c))) return !0;
          if (!i) {
            var t = n.call(c);
            return t === "[object GeneratorFunction]";
          }
          if (!o) return !1;
          if (typeof s > "u") {
            var p = r();
            s = p ? o(p) : !1;
          }
          return o(c) === s;
        };
      }), Qh = xe((L, k) => {
        var n = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, a, i;
        if (typeof e == "function" && typeof Object.defineProperty == "function") try {
          a = Object.defineProperty({}, "length", { get: function() {
            throw i;
          } }), i = {}, e(function() {
            throw 42;
          }, null, a);
        } catch (d) {
          d !== i && (e = null);
        }
        else e = null;
        var o = /^\s*class\b/, r = function(d) {
          try {
            var y = n.call(d);
            return o.test(y);
          } catch {
            return !1;
          }
        }, s = function(d) {
          try {
            return r(d) ? !1 : (n.call(d), !0);
          } catch {
            return !1;
          }
        }, c = Object.prototype.toString, t = "[object Object]", p = "[object Function]", l = "[object GeneratorFunction]", f = "[object HTMLAllCollection]", v = "[object HTML document.all class]", g = "[object HTMLCollection]", x = typeof Symbol == "function" && !!Symbol.toStringTag, h = !(0 in [,]), m = function() {
          return !1;
        };
        typeof document == "object" && (u = document.all, c.call(u) === c.call(document.all) && (m = function(d) {
          if ((h || !d) && (typeof d > "u" || typeof d == "object")) try {
            var y = c.call(d);
            return (y === f || y === v || y === g || y === t) && d("") == null;
          } catch {
          }
          return !1;
        }));
        var u;
        k.exports = e ? function(d) {
          if (m(d)) return !0;
          if (!d || typeof d != "function" && typeof d != "object") return !1;
          try {
            e(d, null, a);
          } catch (y) {
            if (y !== i) return !1;
          }
          return !r(d) && s(d);
        } : function(d) {
          if (m(d)) return !0;
          if (!d || typeof d != "function" && typeof d != "object") return !1;
          if (x) return s(d);
          if (r(d)) return !1;
          var y = c.call(d);
          return y !== p && y !== l && !/^\[object HTML/.test(y) ? !1 : s(d);
        };
      }), Xu = xe((L, k) => {
        var n = Qh(), e = Object.prototype.toString, a = Object.prototype.hasOwnProperty, i = function(c, t, p) {
          for (var l = 0, f = c.length; l < f; l++) a.call(c, l) && (p == null ? t(c[l], l, c) : t.call(p, c[l], l, c));
        }, o = function(c, t, p) {
          for (var l = 0, f = c.length; l < f; l++) p == null ? t(c.charAt(l), l, c) : t.call(p, c.charAt(l), l, c);
        }, r = function(c, t, p) {
          for (var l in c) a.call(c, l) && (p == null ? t(c[l], l, c) : t.call(p, c[l], l, c));
        }, s = function(c, t, p) {
          if (!n(t)) throw new TypeError("iterator must be a function");
          var l;
          arguments.length >= 3 && (l = p), e.call(c) === "[object Array]" ? i(c, t, l) : typeof c == "string" ? o(c, t, l) : r(c, t, l);
        };
        k.exports = s;
      }), Ju = xe((L, k) => {
        var n = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"], e = typeof globalThis > "u" ? window : globalThis;
        k.exports = function() {
          for (var a = [], i = 0; i < n.length; i++) typeof e[n[i]] == "function" && (a[a.length] = n[i]);
          return a;
        };
      }), e1 = xe((L, k) => {
        var n = Xu(), e = Ju(), a = Bi(), i = di(), o = qa(), r = i("Object.prototype.toString"), s = Ni()(), c = typeof globalThis > "u" ? window : globalThis, t = e(), p = i("String.prototype.slice"), l = Object.getPrototypeOf, f = i("Array.prototype.indexOf", !0) || function(h, m) {
          for (var u = 0; u < h.length; u += 1) if (h[u] === m) return u;
          return -1;
        }, v = { __proto__: null };
        s && o && l ? n(t, function(h) {
          var m = new c[h]();
          if (Symbol.toStringTag in m) {
            var u = l(m), d = o(u, Symbol.toStringTag);
            if (!d) {
              var y = l(u);
              d = o(y, Symbol.toStringTag);
            }
            v["$" + h] = a(d.get);
          }
        }) : n(t, function(h) {
          var m = new c[h](), u = m.slice || m.set;
          u && (v["$" + h] = a(u));
        });
        var g = function(h) {
          var m = !1;
          return n(v, function(u, d) {
            if (!m) try {
              "$" + u(h) === d && (m = p(d, 1));
            } catch {
            }
          }), m;
        }, x = function(h) {
          var m = !1;
          return n(v, function(u, d) {
            if (!m) try {
              u(h), m = p(d, 1);
            } catch {
            }
          }), m;
        };
        k.exports = function(h) {
          if (!h || typeof h != "object") return !1;
          if (!s) {
            var m = p(r(h), 8, -1);
            return f(t, m) > -1 ? m : m !== "Object" ? !1 : x(h);
          }
          return o ? g(h) : null;
        };
      }), t1 = xe((L, k) => {
        var n = Xu(), e = Ju(), a = di(), i = a("Object.prototype.toString"), o = Ni()(), r = qa(), s = typeof globalThis > "u" ? window : globalThis, c = e(), t = a("Array.prototype.indexOf", !0) || function(g, x) {
          for (var h = 0; h < g.length; h += 1) if (g[h] === x) return h;
          return -1;
        }, p = a("String.prototype.slice"), l = {}, f = Object.getPrototypeOf;
        o && r && f && n(c, function(g) {
          var x = new s[g]();
          if (Symbol.toStringTag in x) {
            var h = f(x), m = r(h, Symbol.toStringTag);
            if (!m) {
              var u = f(h);
              m = r(u, Symbol.toStringTag);
            }
            l[g] = m.get;
          }
        });
        var v = function(g) {
          var x = !1;
          return n(l, function(h, m) {
            if (!x) try {
              x = h.call(g) === m;
            } catch {
            }
          }), x;
        };
        k.exports = function(g) {
          if (!g || typeof g != "object") return !1;
          if (!o || !(Symbol.toStringTag in g)) {
            var x = p(i(g), 8, -1);
            return t(c, x) > -1;
          }
          return r ? v(g) : !1;
        };
      }), $u = xe((L) => {
        var k = $h(), n = Kh(), e = e1(), a = t1();
        function i(ie) {
          return ie.call.bind(ie);
        }
        var o = typeof BigInt < "u", r = typeof Symbol < "u", s = i(Object.prototype.toString), c = i(Number.prototype.valueOf), t = i(String.prototype.valueOf), p = i(Boolean.prototype.valueOf);
        o && (l = i(BigInt.prototype.valueOf));
        var l;
        r && (f = i(Symbol.prototype.valueOf));
        var f;
        function v(ie, pe) {
          if (typeof ie != "object") return !1;
          try {
            return pe(ie), !0;
          } catch {
            return !1;
          }
        }
        L.isArgumentsObject = k, L.isGeneratorFunction = n, L.isTypedArray = a;
        function g(ie) {
          return typeof Promise < "u" && ie instanceof Promise || ie !== null && typeof ie == "object" && typeof ie.then == "function" && typeof ie.catch == "function";
        }
        L.isPromise = g;
        function x(ie) {
          return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(ie) : a(ie) || j(ie);
        }
        L.isArrayBufferView = x;
        function h(ie) {
          return e(ie) === "Uint8Array";
        }
        L.isUint8Array = h;
        function m(ie) {
          return e(ie) === "Uint8ClampedArray";
        }
        L.isUint8ClampedArray = m;
        function u(ie) {
          return e(ie) === "Uint16Array";
        }
        L.isUint16Array = u;
        function d(ie) {
          return e(ie) === "Uint32Array";
        }
        L.isUint32Array = d;
        function y(ie) {
          return e(ie) === "Int8Array";
        }
        L.isInt8Array = y;
        function _(ie) {
          return e(ie) === "Int16Array";
        }
        L.isInt16Array = _;
        function T(ie) {
          return e(ie) === "Int32Array";
        }
        L.isInt32Array = T;
        function R(ie) {
          return e(ie) === "Float32Array";
        }
        L.isFloat32Array = R;
        function I(ie) {
          return e(ie) === "Float64Array";
        }
        L.isFloat64Array = I;
        function P(ie) {
          return e(ie) === "BigInt64Array";
        }
        L.isBigInt64Array = P;
        function M(ie) {
          return e(ie) === "BigUint64Array";
        }
        L.isBigUint64Array = M;
        function B(ie) {
          return s(ie) === "[object Map]";
        }
        B.working = typeof Map < "u" && B(/* @__PURE__ */ new Map());
        function z(ie) {
          return typeof Map > "u" ? !1 : B.working ? B(ie) : ie instanceof Map;
        }
        L.isMap = z;
        function q(ie) {
          return s(ie) === "[object Set]";
        }
        q.working = typeof Set < "u" && q(/* @__PURE__ */ new Set());
        function U(ie) {
          return typeof Set > "u" ? !1 : q.working ? q(ie) : ie instanceof Set;
        }
        L.isSet = U;
        function G(ie) {
          return s(ie) === "[object WeakMap]";
        }
        G.working = typeof WeakMap < "u" && G(/* @__PURE__ */ new WeakMap());
        function K(ie) {
          return typeof WeakMap > "u" ? !1 : G.working ? G(ie) : ie instanceof WeakMap;
        }
        L.isWeakMap = K;
        function te(ie) {
          return s(ie) === "[object WeakSet]";
        }
        te.working = typeof WeakSet < "u" && te(/* @__PURE__ */ new WeakSet());
        function V(ie) {
          return te(ie);
        }
        L.isWeakSet = V;
        function Z(ie) {
          return s(ie) === "[object ArrayBuffer]";
        }
        Z.working = typeof ArrayBuffer < "u" && Z(new ArrayBuffer());
        function Y(ie) {
          return typeof ArrayBuffer > "u" ? !1 : Z.working ? Z(ie) : ie instanceof ArrayBuffer;
        }
        L.isArrayBuffer = Y;
        function C(ie) {
          return s(ie) === "[object DataView]";
        }
        C.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && C(new DataView(new ArrayBuffer(1), 0, 1));
        function j(ie) {
          return typeof DataView > "u" ? !1 : C.working ? C(ie) : ie instanceof DataView;
        }
        L.isDataView = j;
        var J = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
        function ne(ie) {
          return s(ie) === "[object SharedArrayBuffer]";
        }
        function ae(ie) {
          return typeof J > "u" ? !1 : (typeof ne.working > "u" && (ne.working = ne(new J())), ne.working ? ne(ie) : ie instanceof J);
        }
        L.isSharedArrayBuffer = ae;
        function se(ie) {
          return s(ie) === "[object AsyncFunction]";
        }
        L.isAsyncFunction = se;
        function O(ie) {
          return s(ie) === "[object Map Iterator]";
        }
        L.isMapIterator = O;
        function F(ie) {
          return s(ie) === "[object Set Iterator]";
        }
        L.isSetIterator = F;
        function S(ie) {
          return s(ie) === "[object Generator]";
        }
        L.isGeneratorObject = S;
        function $(ie) {
          return s(ie) === "[object WebAssembly.Module]";
        }
        L.isWebAssemblyCompiledModule = $;
        function re(ie) {
          return v(ie, c);
        }
        L.isNumberObject = re;
        function E(ie) {
          return v(ie, t);
        }
        L.isStringObject = E;
        function w(ie) {
          return v(ie, p);
        }
        L.isBooleanObject = w;
        function N(ie) {
          return o && v(ie, l);
        }
        L.isBigIntObject = N;
        function W(ie) {
          return r && v(ie, f);
        }
        L.isSymbolObject = W;
        function ee(ie) {
          return re(ie) || E(ie) || w(ie) || N(ie) || W(ie);
        }
        L.isBoxedPrimitive = ee;
        function le(ie) {
          return typeof Uint8Array < "u" && (Y(ie) || ae(ie));
        }
        L.isAnyArrayBuffer = le, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(ie) {
          Object.defineProperty(L, ie, { enumerable: !1, value: function() {
            throw new Error(ie + " is not supported in userland");
          } });
        });
      }), Ku = xe((L, k) => {
        k.exports = function(n) {
          return n && typeof n == "object" && typeof n.copy == "function" && typeof n.fill == "function" && typeof n.readUInt8 == "function";
        };
      }), Qu = xe((L) => {
        var k = Object.getOwnPropertyDescriptors || function(C) {
          for (var j = Object.keys(C), J = {}, ne = 0; ne < j.length; ne++) J[j[ne]] = Object.getOwnPropertyDescriptor(C, j[ne]);
          return J;
        }, n = /%[sdj%]/g;
        L.format = function(C) {
          if (!y(C)) {
            for (var j = [], J = 0; J < arguments.length; J++) j.push(o(arguments[J]));
            return j.join(" ");
          }
          for (var J = 1, ne = arguments, ae = ne.length, se = String(C).replace(n, function(S) {
            if (S === "%%") return "%";
            if (J >= ae) return S;
            switch (S) {
              case "%s":
                return String(ne[J++]);
              case "%d":
                return Number(ne[J++]);
              case "%j":
                try {
                  return JSON.stringify(ne[J++]);
                } catch {
                  return "[Circular]";
                }
              default:
                return S;
            }
          }), O = ne[J]; J < ae; O = ne[++J]) m(O) || !I(O) ? se += " " + O : se += " " + o(O);
          return se;
        }, L.deprecate = function(C, j) {
          if (typeof process < "u" && process.noDeprecation === !0) return C;
          if (typeof process > "u") return function() {
            return L.deprecate(C, j).apply(this, arguments);
          };
          var J = !1;
          function ne() {
            if (!J) {
              if (process.throwDeprecation) throw new Error(j);
              process.traceDeprecation ? console.trace(j) : console.error(j), J = !0;
            }
            return C.apply(this, arguments);
          }
          return ne;
        };
        var e = {}, a = /^$/;
        i = "false", i = i.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + i + "$", "i");
        var i;
        L.debuglog = function(C) {
          if (C = C.toUpperCase(), !e[C]) if (a.test(C)) {
            var j = process.pid;
            e[C] = function() {
              var J = L.format.apply(L, arguments);
              console.error("%s %d: %s", C, j, J);
            };
          } else e[C] = function() {
          };
          return e[C];
        };
        function o(C, j) {
          var J = { seen: [], stylize: s };
          return arguments.length >= 3 && (J.depth = arguments[2]), arguments.length >= 4 && (J.colors = arguments[3]), h(j) ? J.showHidden = j : j && L._extend(J, j), T(J.showHidden) && (J.showHidden = !1), T(J.depth) && (J.depth = 2), T(J.colors) && (J.colors = !1), T(J.customInspect) && (J.customInspect = !0), J.colors && (J.stylize = r), t(J, C, J.depth);
        }
        L.inspect = o, o.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, o.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" };
        function r(C, j) {
          var J = o.styles[j];
          return J ? "\x1B[" + o.colors[J][0] + "m" + C + "\x1B[" + o.colors[J][1] + "m" : C;
        }
        function s(C, j) {
          return C;
        }
        function c(C) {
          var j = {};
          return C.forEach(function(J, ne) {
            j[J] = !0;
          }), j;
        }
        function t(C, j, J) {
          if (C.customInspect && j && B(j.inspect) && j.inspect !== L.inspect && !(j.constructor && j.constructor.prototype === j)) {
            var ne = j.inspect(J, C);
            return y(ne) || (ne = t(C, ne, J)), ne;
          }
          var ae = p(C, j);
          if (ae) return ae;
          var se = Object.keys(j), O = c(se);
          if (C.showHidden && (se = Object.getOwnPropertyNames(j)), M(j) && (se.indexOf("message") >= 0 || se.indexOf("description") >= 0)) return l(j);
          if (se.length === 0) {
            if (B(j)) {
              var F = j.name ? ": " + j.name : "";
              return C.stylize("[Function" + F + "]", "special");
            }
            if (R(j)) return C.stylize(RegExp.prototype.toString.call(j), "regexp");
            if (P(j)) return C.stylize(Date.prototype.toString.call(j), "date");
            if (M(j)) return l(j);
          }
          var S = "", $ = !1, re = ["{", "}"];
          if (x(j) && ($ = !0, re = ["[", "]"]), B(j)) {
            var E = j.name ? ": " + j.name : "";
            S = " [Function" + E + "]";
          }
          if (R(j) && (S = " " + RegExp.prototype.toString.call(j)), P(j) && (S = " " + Date.prototype.toUTCString.call(j)), M(j) && (S = " " + l(j)), se.length === 0 && (!$ || j.length == 0)) return re[0] + S + re[1];
          if (J < 0) return R(j) ? C.stylize(RegExp.prototype.toString.call(j), "regexp") : C.stylize("[Object]", "special");
          C.seen.push(j);
          var w;
          return $ ? w = f(C, j, J, O, se) : w = se.map(function(N) {
            return v(C, j, J, O, N, $);
          }), C.seen.pop(), g(w, S, re);
        }
        function p(C, j) {
          if (T(j)) return C.stylize("undefined", "undefined");
          if (y(j)) {
            var J = "'" + JSON.stringify(j).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return C.stylize(J, "string");
          }
          if (d(j)) return C.stylize("" + j, "number");
          if (h(j)) return C.stylize("" + j, "boolean");
          if (m(j)) return C.stylize("null", "null");
        }
        function l(C) {
          return "[" + Error.prototype.toString.call(C) + "]";
        }
        function f(C, j, J, ne, ae) {
          for (var se = [], O = 0, F = j.length; O < F; ++O) te(j, String(O)) ? se.push(v(C, j, J, ne, String(O), !0)) : se.push("");
          return ae.forEach(function(S) {
            S.match(/^\d+$/) || se.push(v(C, j, J, ne, S, !0));
          }), se;
        }
        function v(C, j, J, ne, ae, se) {
          var O, F, S;
          if (S = Object.getOwnPropertyDescriptor(j, ae) || { value: j[ae] }, S.get ? S.set ? F = C.stylize("[Getter/Setter]", "special") : F = C.stylize("[Getter]", "special") : S.set && (F = C.stylize("[Setter]", "special")), te(ne, ae) || (O = "[" + ae + "]"), F || (C.seen.indexOf(S.value) < 0 ? (m(J) ? F = t(C, S.value, null) : F = t(C, S.value, J - 1), F.indexOf(`
`) > -1 && (se ? F = F.split(`
`).map(function($) {
            return "  " + $;
          }).join(`
`).slice(2) : F = `
` + F.split(`
`).map(function($) {
            return "   " + $;
          }).join(`
`))) : F = C.stylize("[Circular]", "special")), T(O)) {
            if (se && ae.match(/^\d+$/)) return F;
            O = JSON.stringify("" + ae), O.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (O = O.slice(1, -1), O = C.stylize(O, "name")) : (O = O.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), O = C.stylize(O, "string"));
          }
          return O + ": " + F;
        }
        function g(C, j, J) {
          var ne = 0, ae = C.reduce(function(se, O) {
            return ne++, O.indexOf(`
`) >= 0 && ne++, se + O.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0);
          return ae > 60 ? J[0] + (j === "" ? "" : j + `
 `) + " " + C.join(`,
  `) + " " + J[1] : J[0] + j + " " + C.join(", ") + " " + J[1];
        }
        L.types = $u();
        function x(C) {
          return Array.isArray(C);
        }
        L.isArray = x;
        function h(C) {
          return typeof C == "boolean";
        }
        L.isBoolean = h;
        function m(C) {
          return C === null;
        }
        L.isNull = m;
        function u(C) {
          return C == null;
        }
        L.isNullOrUndefined = u;
        function d(C) {
          return typeof C == "number";
        }
        L.isNumber = d;
        function y(C) {
          return typeof C == "string";
        }
        L.isString = y;
        function _(C) {
          return typeof C == "symbol";
        }
        L.isSymbol = _;
        function T(C) {
          return C === void 0;
        }
        L.isUndefined = T;
        function R(C) {
          return I(C) && q(C) === "[object RegExp]";
        }
        L.isRegExp = R, L.types.isRegExp = R;
        function I(C) {
          return typeof C == "object" && C !== null;
        }
        L.isObject = I;
        function P(C) {
          return I(C) && q(C) === "[object Date]";
        }
        L.isDate = P, L.types.isDate = P;
        function M(C) {
          return I(C) && (q(C) === "[object Error]" || C instanceof Error);
        }
        L.isError = M, L.types.isNativeError = M;
        function B(C) {
          return typeof C == "function";
        }
        L.isFunction = B;
        function z(C) {
          return C === null || typeof C == "boolean" || typeof C == "number" || typeof C == "string" || typeof C == "symbol" || typeof C > "u";
        }
        L.isPrimitive = z, L.isBuffer = Ku();
        function q(C) {
          return Object.prototype.toString.call(C);
        }
        function U(C) {
          return C < 10 ? "0" + C.toString(10) : C.toString(10);
        }
        var G = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        function K() {
          var C = /* @__PURE__ */ new Date(), j = [U(C.getHours()), U(C.getMinutes()), U(C.getSeconds())].join(":");
          return [C.getDate(), G[C.getMonth()], j].join(" ");
        }
        L.log = function() {
          console.log("%s - %s", K(), L.format.apply(L, arguments));
        }, L.inherits = ma(), L._extend = function(C, j) {
          if (!j || !I(j)) return C;
          for (var J = Object.keys(j), ne = J.length; ne--; ) C[J[ne]] = j[J[ne]];
          return C;
        };
        function te(C, j) {
          return Object.prototype.hasOwnProperty.call(C, j);
        }
        var V = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
        L.promisify = function(C) {
          if (typeof C != "function") throw new TypeError('The "original" argument must be of type Function');
          if (V && C[V]) {
            var j = C[V];
            if (typeof j != "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(j, V, { value: j, enumerable: !1, writable: !1, configurable: !0 }), j;
          }
          function j() {
            for (var J, ne, ae = new Promise(function(F, S) {
              J = F, ne = S;
            }), se = [], O = 0; O < arguments.length; O++) se.push(arguments[O]);
            se.push(function(F, S) {
              F ? ne(F) : J(S);
            });
            try {
              C.apply(this, se);
            } catch (F) {
              ne(F);
            }
            return ae;
          }
          return Object.setPrototypeOf(j, Object.getPrototypeOf(C)), V && Object.defineProperty(j, V, { value: j, enumerable: !1, writable: !1, configurable: !0 }), Object.defineProperties(j, k(C));
        }, L.promisify.custom = V;
        function Z(C, j) {
          if (!C) {
            var J = new Error("Promise was rejected with a falsy value");
            J.reason = C, C = J;
          }
          return j(C);
        }
        function Y(C) {
          if (typeof C != "function") throw new TypeError('The "original" argument must be of type Function');
          function j() {
            for (var J = [], ne = 0; ne < arguments.length; ne++) J.push(arguments[ne]);
            var ae = J.pop();
            if (typeof ae != "function") throw new TypeError("The last argument must be of type Function");
            var se = this, O = function() {
              return ae.apply(se, arguments);
            };
            C.apply(this, J).then(function(F) {
              process.nextTick(O.bind(null, null, F));
            }, function(F) {
              process.nextTick(Z.bind(null, F, O));
            });
          }
          return Object.setPrototypeOf(j, Object.getPrototypeOf(C)), Object.defineProperties(j, k(C)), j;
        }
        L.callbackify = Y;
      }), r1 = xe((L, k) => {
        function n(v, g) {
          var x = Object.keys(v);
          if (Object.getOwnPropertySymbols) {
            var h = Object.getOwnPropertySymbols(v);
            g && (h = h.filter(function(m) {
              return Object.getOwnPropertyDescriptor(v, m).enumerable;
            })), x.push.apply(x, h);
          }
          return x;
        }
        function e(v) {
          for (var g = 1; g < arguments.length; g++) {
            var x = arguments[g] != null ? arguments[g] : {};
            g % 2 ? n(Object(x), !0).forEach(function(h) {
              a(v, h, x[h]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(x)) : n(Object(x)).forEach(function(h) {
              Object.defineProperty(v, h, Object.getOwnPropertyDescriptor(x, h));
            });
          }
          return v;
        }
        function a(v, g, x) {
          return g in v ? Object.defineProperty(v, g, { value: x, enumerable: !0, configurable: !0, writable: !0 }) : v[g] = x, v;
        }
        function i(v, g) {
          if (!(v instanceof g)) throw new TypeError("Cannot call a class as a function");
        }
        function o(v, g) {
          for (var x = 0; x < g.length; x++) {
            var h = g[x];
            h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(v, h.key, h);
          }
        }
        function r(v, g, x) {
          return g && o(v.prototype, g), v;
        }
        var s = ui(), c = s.Buffer, t = Qu(), p = t.inspect, l = p && p.custom || "inspect";
        function f(v, g, x) {
          c.prototype.copy.call(v, g, x);
        }
        k.exports = function() {
          function v() {
            i(this, v), this.head = null, this.tail = null, this.length = 0;
          }
          return r(v, [{ key: "push", value: function(g) {
            var x = { data: g, next: null };
            this.length > 0 ? this.tail.next = x : this.head = x, this.tail = x, ++this.length;
          } }, { key: "unshift", value: function(g) {
            var x = { data: g, next: this.head };
            this.length === 0 && (this.tail = x), this.head = x, ++this.length;
          } }, { key: "shift", value: function() {
            if (this.length !== 0) {
              var g = this.head.data;
              return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, g;
            }
          } }, { key: "clear", value: function() {
            this.head = this.tail = null, this.length = 0;
          } }, { key: "join", value: function(g) {
            if (this.length === 0) return "";
            for (var x = this.head, h = "" + x.data; x = x.next; ) h += g + x.data;
            return h;
          } }, { key: "concat", value: function(g) {
            if (this.length === 0) return c.alloc(0);
            for (var x = c.allocUnsafe(g >>> 0), h = this.head, m = 0; h; ) f(h.data, x, m), m += h.data.length, h = h.next;
            return x;
          } }, { key: "consume", value: function(g, x) {
            var h;
            return g < this.head.data.length ? (h = this.head.data.slice(0, g), this.head.data = this.head.data.slice(g)) : g === this.head.data.length ? h = this.shift() : h = x ? this._getString(g) : this._getBuffer(g), h;
          } }, { key: "first", value: function() {
            return this.head.data;
          } }, { key: "_getString", value: function(g) {
            var x = this.head, h = 1, m = x.data;
            for (g -= m.length; x = x.next; ) {
              var u = x.data, d = g > u.length ? u.length : g;
              if (d === u.length ? m += u : m += u.slice(0, g), g -= d, g === 0) {
                d === u.length ? (++h, x.next ? this.head = x.next : this.head = this.tail = null) : (this.head = x, x.data = u.slice(d));
                break;
              }
              ++h;
            }
            return this.length -= h, m;
          } }, { key: "_getBuffer", value: function(g) {
            var x = c.allocUnsafe(g), h = this.head, m = 1;
            for (h.data.copy(x), g -= h.data.length; h = h.next; ) {
              var u = h.data, d = g > u.length ? u.length : g;
              if (u.copy(x, x.length - g, 0, d), g -= d, g === 0) {
                d === u.length ? (++m, h.next ? this.head = h.next : this.head = this.tail = null) : (this.head = h, h.data = u.slice(d));
                break;
              }
              ++m;
            }
            return this.length -= m, x;
          } }, { key: l, value: function(g, x) {
            return p(this, e({}, x, { depth: 0, customInspect: !1 }));
          } }]), v;
        }();
      }), ec = xe((L, k) => {
        function n(s, c) {
          var t = this, p = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
          return p || l ? (c ? c(s) : s && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(o, this, s)) : process.nextTick(o, this, s)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(s || null, function(f) {
            !c && f ? t._writableState ? t._writableState.errorEmitted ? process.nextTick(a, t) : (t._writableState.errorEmitted = !0, process.nextTick(e, t, f)) : process.nextTick(e, t, f) : c ? (process.nextTick(a, t), c(f)) : process.nextTick(a, t);
          }), this);
        }
        function e(s, c) {
          o(s, c), a(s);
        }
        function a(s) {
          s._writableState && !s._writableState.emitClose || s._readableState && !s._readableState.emitClose || s.emit("close");
        }
        function i() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
        function o(s, c) {
          s.emit("error", c);
        }
        function r(s, c) {
          var t = s._readableState, p = s._writableState;
          t && t.autoDestroy || p && p.autoDestroy ? s.destroy(c) : s.emit("error", c);
        }
        k.exports = { destroy: n, undestroy: i, errorOrDestroy: r };
      }), Ua = xe((L, k) => {
        function n(c, t) {
          c.prototype = Object.create(t.prototype), c.prototype.constructor = c, c.__proto__ = t;
        }
        var e = {};
        function a(c, t, p) {
          p || (p = Error);
          function l(v, g, x) {
            return typeof t == "string" ? t : t(v, g, x);
          }
          var f = function(v) {
            n(g, v);
            function g(x, h, m) {
              return v.call(this, l(x, h, m)) || this;
            }
            return g;
          }(p);
          f.prototype.name = p.name, f.prototype.code = c, e[c] = f;
        }
        function i(c, t) {
          if (Array.isArray(c)) {
            var p = c.length;
            return c = c.map(function(l) {
              return String(l);
            }), p > 2 ? "one of ".concat(t, " ").concat(c.slice(0, p - 1).join(", "), ", or ") + c[p - 1] : p === 2 ? "one of ".concat(t, " ").concat(c[0], " or ").concat(c[1]) : "of ".concat(t, " ").concat(c[0]);
          } else return "of ".concat(t, " ").concat(String(c));
        }
        function o(c, t, p) {
          return c.substr(0, t.length) === t;
        }
        function r(c, t, p) {
          return (p === void 0 || p > c.length) && (p = c.length), c.substring(p - t.length, p) === t;
        }
        function s(c, t, p) {
          return typeof p != "number" && (p = 0), p + t.length > c.length ? !1 : c.indexOf(t, p) !== -1;
        }
        a("ERR_INVALID_OPT_VALUE", function(c, t) {
          return 'The value "' + t + '" is invalid for option "' + c + '"';
        }, TypeError), a("ERR_INVALID_ARG_TYPE", function(c, t, p) {
          var l;
          typeof t == "string" && o(t, "not ") ? (l = "must not be", t = t.replace(/^not /, "")) : l = "must be";
          var f;
          if (r(c, " argument")) f = "The ".concat(c, " ").concat(l, " ").concat(i(t, "type"));
          else {
            var v = s(c, ".") ? "property" : "argument";
            f = 'The "'.concat(c, '" ').concat(v, " ").concat(l, " ").concat(i(t, "type"));
          }
          return f += ". Received type ".concat(typeof p), f;
        }, TypeError), a("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), a("ERR_METHOD_NOT_IMPLEMENTED", function(c) {
          return "The " + c + " method is not implemented";
        }), a("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), a("ERR_STREAM_DESTROYED", function(c) {
          return "Cannot call " + c + " after a stream was destroyed";
        }), a("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), a("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), a("ERR_STREAM_WRITE_AFTER_END", "write after end"), a("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), a("ERR_UNKNOWN_ENCODING", function(c) {
          return "Unknown encoding: " + c;
        }, TypeError), a("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), k.exports.codes = e;
      }), tc = xe((L, k) => {
        var n = Ua().codes.ERR_INVALID_OPT_VALUE;
        function e(i, o, r) {
          return i.highWaterMark != null ? i.highWaterMark : o ? i[r] : null;
        }
        function a(i, o, r, s) {
          var c = e(o, s, r);
          if (c != null) {
            if (!(isFinite(c) && Math.floor(c) === c) || c < 0) {
              var t = s ? r : "highWaterMark";
              throw new n(t, c);
            }
            return Math.floor(c);
          }
          return i.objectMode ? 16 : 16 * 1024;
        }
        k.exports = { getHighWaterMark: a };
      }), n1 = xe((L, k) => {
        k.exports = n;
        function n(a, i) {
          if (e("noDeprecation")) return a;
          var o = !1;
          function r() {
            if (!o) {
              if (e("throwDeprecation")) throw new Error(i);
              e("traceDeprecation") ? console.trace(i) : console.warn(i), o = !0;
            }
            return a.apply(this, arguments);
          }
          return r;
        }
        function e(a) {
          try {
            if (!window.localStorage) return !1;
          } catch {
            return !1;
          }
          var i = window.localStorage[a];
          return i == null ? !1 : String(i).toLowerCase() === "true";
        }
      }), rc = xe((L, k) => {
        k.exports = P;
        function n(O) {
          var F = this;
          this.next = null, this.entry = null, this.finish = function() {
            se(F, O);
          };
        }
        var e;
        P.WritableState = R;
        var a = { deprecate: n1() }, i = qu(), o = ui().Buffer, r = window.Uint8Array || function() {
        };
        function s(O) {
          return o.from(O);
        }
        function c(O) {
          return o.isBuffer(O) || O instanceof r;
        }
        var t = ec(), p = tc(), l = p.getHighWaterMark, f = Ua().codes, v = f.ERR_INVALID_ARG_TYPE, g = f.ERR_METHOD_NOT_IMPLEMENTED, x = f.ERR_MULTIPLE_CALLBACK, h = f.ERR_STREAM_CANNOT_PIPE, m = f.ERR_STREAM_DESTROYED, u = f.ERR_STREAM_NULL_VALUES, d = f.ERR_STREAM_WRITE_AFTER_END, y = f.ERR_UNKNOWN_ENCODING, _ = t.errorOrDestroy;
        ma()(P, i);
        function T() {
        }
        function R(O, F, S) {
          e = e || Va(), O = O || {}, typeof S != "boolean" && (S = F instanceof e), this.objectMode = !!O.objectMode, S && (this.objectMode = this.objectMode || !!O.writableObjectMode), this.highWaterMark = l(this, O, "writableHighWaterMark", S), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
          var $ = O.decodeStrings === !1;
          this.decodeStrings = !$, this.defaultEncoding = O.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(re) {
            te(F, re);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = O.emitClose !== !1, this.autoDestroy = !!O.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new n(this);
        }
        R.prototype.getBuffer = function() {
          for (var O = this.bufferedRequest, F = []; O; ) F.push(O), O = O.next;
          return F;
        }, function() {
          try {
            Object.defineProperty(R.prototype, "buffer", { get: a.deprecate(function() {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
          } catch {
          }
        }();
        var I;
        typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (I = Function.prototype[Symbol.hasInstance], Object.defineProperty(P, Symbol.hasInstance, { value: function(O) {
          return I.call(this, O) ? !0 : this !== P ? !1 : O && O._writableState instanceof R;
        } })) : I = function(O) {
          return O instanceof this;
        };
        function P(O) {
          e = e || Va();
          var F = this instanceof e;
          if (!F && !I.call(P, this)) return new P(O);
          this._writableState = new R(O, this, F), this.writable = !0, O && (typeof O.write == "function" && (this._write = O.write), typeof O.writev == "function" && (this._writev = O.writev), typeof O.destroy == "function" && (this._destroy = O.destroy), typeof O.final == "function" && (this._final = O.final)), i.call(this);
        }
        P.prototype.pipe = function() {
          _(this, new h());
        };
        function M(O, F) {
          var S = new d();
          _(O, S), process.nextTick(F, S);
        }
        function B(O, F, S, $) {
          var re;
          return S === null ? re = new u() : typeof S != "string" && !F.objectMode && (re = new v("chunk", ["string", "Buffer"], S)), re ? (_(O, re), process.nextTick($, re), !1) : !0;
        }
        P.prototype.write = function(O, F, S) {
          var $ = this._writableState, re = !1, E = !$.objectMode && c(O);
          return E && !o.isBuffer(O) && (O = s(O)), typeof F == "function" && (S = F, F = null), E ? F = "buffer" : F || (F = $.defaultEncoding), typeof S != "function" && (S = T), $.ending ? M(this, S) : (E || B(this, $, O, S)) && ($.pendingcb++, re = q(this, $, E, O, F, S)), re;
        }, P.prototype.cork = function() {
          this._writableState.corked++;
        }, P.prototype.uncork = function() {
          var O = this._writableState;
          O.corked && (O.corked--, !O.writing && !O.corked && !O.bufferProcessing && O.bufferedRequest && Y(this, O));
        }, P.prototype.setDefaultEncoding = function(O) {
          if (typeof O == "string" && (O = O.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((O + "").toLowerCase()) > -1)) throw new y(O);
          return this._writableState.defaultEncoding = O, this;
        }, Object.defineProperty(P.prototype, "writableBuffer", { enumerable: !1, get: function() {
          return this._writableState && this._writableState.getBuffer();
        } });
        function z(O, F, S) {
          return !O.objectMode && O.decodeStrings !== !1 && typeof F == "string" && (F = o.from(F, S)), F;
        }
        Object.defineProperty(P.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
          return this._writableState.highWaterMark;
        } });
        function q(O, F, S, $, re, E) {
          if (!S) {
            var w = z(F, $, re);
            $ !== w && (S = !0, re = "buffer", $ = w);
          }
          var N = F.objectMode ? 1 : $.length;
          F.length += N;
          var W = F.length < F.highWaterMark;
          if (W || (F.needDrain = !0), F.writing || F.corked) {
            var ee = F.lastBufferedRequest;
            F.lastBufferedRequest = { chunk: $, encoding: re, isBuf: S, callback: E, next: null }, ee ? ee.next = F.lastBufferedRequest : F.bufferedRequest = F.lastBufferedRequest, F.bufferedRequestCount += 1;
          } else U(O, F, !1, N, $, re, E);
          return W;
        }
        function U(O, F, S, $, re, E, w) {
          F.writelen = $, F.writecb = w, F.writing = !0, F.sync = !0, F.destroyed ? F.onwrite(new m("write")) : S ? O._writev(re, F.onwrite) : O._write(re, E, F.onwrite), F.sync = !1;
        }
        function G(O, F, S, $, re) {
          --F.pendingcb, S ? (process.nextTick(re, $), process.nextTick(ne, O, F), O._writableState.errorEmitted = !0, _(O, $)) : (re($), O._writableState.errorEmitted = !0, _(O, $), ne(O, F));
        }
        function K(O) {
          O.writing = !1, O.writecb = null, O.length -= O.writelen, O.writelen = 0;
        }
        function te(O, F) {
          var S = O._writableState, $ = S.sync, re = S.writecb;
          if (typeof re != "function") throw new x();
          if (K(S), F) G(O, S, $, F, re);
          else {
            var E = C(S) || O.destroyed;
            !E && !S.corked && !S.bufferProcessing && S.bufferedRequest && Y(O, S), $ ? process.nextTick(V, O, S, E, re) : V(O, S, E, re);
          }
        }
        function V(O, F, S, $) {
          S || Z(O, F), F.pendingcb--, $(), ne(O, F);
        }
        function Z(O, F) {
          F.length === 0 && F.needDrain && (F.needDrain = !1, O.emit("drain"));
        }
        function Y(O, F) {
          F.bufferProcessing = !0;
          var S = F.bufferedRequest;
          if (O._writev && S && S.next) {
            var $ = F.bufferedRequestCount, re = new Array($), E = F.corkedRequestsFree;
            E.entry = S;
            for (var w = 0, N = !0; S; ) re[w] = S, S.isBuf || (N = !1), S = S.next, w += 1;
            re.allBuffers = N, U(O, F, !0, F.length, re, "", E.finish), F.pendingcb++, F.lastBufferedRequest = null, E.next ? (F.corkedRequestsFree = E.next, E.next = null) : F.corkedRequestsFree = new n(F), F.bufferedRequestCount = 0;
          } else {
            for (; S; ) {
              var W = S.chunk, ee = S.encoding, le = S.callback, ie = F.objectMode ? 1 : W.length;
              if (U(O, F, !1, ie, W, ee, le), S = S.next, F.bufferedRequestCount--, F.writing) break;
            }
            S === null && (F.lastBufferedRequest = null);
          }
          F.bufferedRequest = S, F.bufferProcessing = !1;
        }
        P.prototype._write = function(O, F, S) {
          S(new g("_write()"));
        }, P.prototype._writev = null, P.prototype.end = function(O, F, S) {
          var $ = this._writableState;
          return typeof O == "function" ? (S = O, O = null, F = null) : typeof F == "function" && (S = F, F = null), O != null && this.write(O, F), $.corked && ($.corked = 1, this.uncork()), $.ending || ae(this, $, S), this;
        }, Object.defineProperty(P.prototype, "writableLength", { enumerable: !1, get: function() {
          return this._writableState.length;
        } });
        function C(O) {
          return O.ending && O.length === 0 && O.bufferedRequest === null && !O.finished && !O.writing;
        }
        function j(O, F) {
          O._final(function(S) {
            F.pendingcb--, S && _(O, S), F.prefinished = !0, O.emit("prefinish"), ne(O, F);
          });
        }
        function J(O, F) {
          !F.prefinished && !F.finalCalled && (typeof O._final == "function" && !F.destroyed ? (F.pendingcb++, F.finalCalled = !0, process.nextTick(j, O, F)) : (F.prefinished = !0, O.emit("prefinish")));
        }
        function ne(O, F) {
          var S = C(F);
          if (S && (J(O, F), F.pendingcb === 0 && (F.finished = !0, O.emit("finish"), F.autoDestroy))) {
            var $ = O._readableState;
            (!$ || $.autoDestroy && $.endEmitted) && O.destroy();
          }
          return S;
        }
        function ae(O, F, S) {
          F.ending = !0, ne(O, F), S && (F.finished ? process.nextTick(S) : O.once("finish", S)), F.ended = !0, O.writable = !1;
        }
        function se(O, F, S) {
          var $ = O.entry;
          for (O.entry = null; $; ) {
            var re = $.callback;
            F.pendingcb--, re(S), $ = $.next;
          }
          F.corkedRequestsFree.next = O;
        }
        Object.defineProperty(P.prototype, "destroyed", { enumerable: !1, get: function() {
          return this._writableState === void 0 ? !1 : this._writableState.destroyed;
        }, set: function(O) {
          this._writableState && (this._writableState.destroyed = O);
        } }), P.prototype.destroy = t.destroy, P.prototype._undestroy = t.undestroy, P.prototype._destroy = function(O, F) {
          F(O);
        };
      }), Va = xe((L, k) => {
        var n = Object.keys || function(p) {
          var l = [];
          for (var f in p) l.push(f);
          return l;
        };
        k.exports = s;
        var e = ac(), a = rc();
        for (ma()(s, e), i = n(a.prototype), r = 0; r < i.length; r++) o = i[r], s.prototype[o] || (s.prototype[o] = a.prototype[o]);
        var i, o, r;
        function s(p) {
          if (!(this instanceof s)) return new s(p);
          e.call(this, p), a.call(this, p), this.allowHalfOpen = !0, p && (p.readable === !1 && (this.readable = !1), p.writable === !1 && (this.writable = !1), p.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", c)));
        }
        Object.defineProperty(s.prototype, "writableHighWaterMark", { enumerable: !1, get: function() {
          return this._writableState.highWaterMark;
        } }), Object.defineProperty(s.prototype, "writableBuffer", { enumerable: !1, get: function() {
          return this._writableState && this._writableState.getBuffer();
        } }), Object.defineProperty(s.prototype, "writableLength", { enumerable: !1, get: function() {
          return this._writableState.length;
        } });
        function c() {
          this._writableState.ended || process.nextTick(t, this);
        }
        function t(p) {
          p.end();
        }
        Object.defineProperty(s.prototype, "destroyed", { enumerable: !1, get: function() {
          return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
        }, set: function(p) {
          this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = p, this._writableState.destroyed = p);
        } });
      }), a1 = xe((L, k) => {
        var n = ui(), e = n.Buffer;
        function a(o, r) {
          for (var s in o) r[s] = o[s];
        }
        e.from && e.alloc && e.allocUnsafe && e.allocUnsafeSlow ? k.exports = n : (a(n, L), L.Buffer = i);
        function i(o, r, s) {
          return e(o, r, s);
        }
        i.prototype = Object.create(e.prototype), a(e, i), i.from = function(o, r, s) {
          if (typeof o == "number") throw new TypeError("Argument must not be a number");
          return e(o, r, s);
        }, i.alloc = function(o, r, s) {
          if (typeof o != "number") throw new TypeError("Argument must be a number");
          var c = e(o);
          return r !== void 0 ? typeof s == "string" ? c.fill(r, s) : c.fill(r) : c.fill(0), c;
        }, i.allocUnsafe = function(o) {
          if (typeof o != "number") throw new TypeError("Argument must be a number");
          return e(o);
        }, i.allocUnsafeSlow = function(o) {
          if (typeof o != "number") throw new TypeError("Argument must be a number");
          return n.SlowBuffer(o);
        };
      }), nc = xe((L) => {
        var k = a1().Buffer, n = k.isEncoding || function(m) {
          switch (m = "" + m, m && m.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return !0;
            default:
              return !1;
          }
        };
        function e(m) {
          if (!m) return "utf8";
          for (var u; ; ) switch (m) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return m;
            default:
              if (u) return;
              m = ("" + m).toLowerCase(), u = !0;
          }
        }
        function a(m) {
          var u = e(m);
          if (typeof u != "string" && (k.isEncoding === n || !n(m))) throw new Error("Unknown encoding: " + m);
          return u || m;
        }
        L.StringDecoder = i;
        function i(m) {
          this.encoding = a(m);
          var u;
          switch (this.encoding) {
            case "utf16le":
              this.text = l, this.end = f, u = 4;
              break;
            case "utf8":
              this.fillLast = c, u = 4;
              break;
            case "base64":
              this.text = v, this.end = g, u = 3;
              break;
            default:
              this.write = x, this.end = h;
              return;
          }
          this.lastNeed = 0, this.lastTotal = 0, this.lastChar = k.allocUnsafe(u);
        }
        i.prototype.write = function(m) {
          if (m.length === 0) return "";
          var u, d;
          if (this.lastNeed) {
            if (u = this.fillLast(m), u === void 0) return "";
            d = this.lastNeed, this.lastNeed = 0;
          } else d = 0;
          return d < m.length ? u ? u + this.text(m, d) : this.text(m, d) : u || "";
        }, i.prototype.end = p, i.prototype.text = t, i.prototype.fillLast = function(m) {
          if (this.lastNeed <= m.length) return m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, m.length), this.lastNeed -= m.length;
        };
        function o(m) {
          return m <= 127 ? 0 : m >> 5 === 6 ? 2 : m >> 4 === 14 ? 3 : m >> 3 === 30 ? 4 : m >> 6 === 2 ? -1 : -2;
        }
        function r(m, u, d) {
          var y = u.length - 1;
          if (y < d) return 0;
          var _ = o(u[y]);
          return _ >= 0 ? (_ > 0 && (m.lastNeed = _ - 1), _) : --y < d || _ === -2 ? 0 : (_ = o(u[y]), _ >= 0 ? (_ > 0 && (m.lastNeed = _ - 2), _) : --y < d || _ === -2 ? 0 : (_ = o(u[y]), _ >= 0 ? (_ > 0 && (_ === 2 ? _ = 0 : m.lastNeed = _ - 3), _) : 0));
        }
        function s(m, u, d) {
          if ((u[0] & 192) !== 128) return m.lastNeed = 0, "�";
          if (m.lastNeed > 1 && u.length > 1) {
            if ((u[1] & 192) !== 128) return m.lastNeed = 1, "�";
            if (m.lastNeed > 2 && u.length > 2 && (u[2] & 192) !== 128) return m.lastNeed = 2, "�";
          }
        }
        function c(m) {
          var u = this.lastTotal - this.lastNeed, d = s(this, m);
          if (d !== void 0) return d;
          if (this.lastNeed <= m.length) return m.copy(this.lastChar, u, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          m.copy(this.lastChar, u, 0, m.length), this.lastNeed -= m.length;
        }
        function t(m, u) {
          var d = r(this, m, u);
          if (!this.lastNeed) return m.toString("utf8", u);
          this.lastTotal = d;
          var y = m.length - (d - this.lastNeed);
          return m.copy(this.lastChar, 0, y), m.toString("utf8", u, y);
        }
        function p(m) {
          var u = m && m.length ? this.write(m) : "";
          return this.lastNeed ? u + "�" : u;
        }
        function l(m, u) {
          if ((m.length - u) % 2 === 0) {
            var d = m.toString("utf16le", u);
            if (d) {
              var y = d.charCodeAt(d.length - 1);
              if (y >= 55296 && y <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1], d.slice(0, -1);
            }
            return d;
          }
          return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = m[m.length - 1], m.toString("utf16le", u, m.length - 1);
        }
        function f(m) {
          var u = m && m.length ? this.write(m) : "";
          if (this.lastNeed) {
            var d = this.lastTotal - this.lastNeed;
            return u + this.lastChar.toString("utf16le", 0, d);
          }
          return u;
        }
        function v(m, u) {
          var d = (m.length - u) % 3;
          return d === 0 ? m.toString("base64", u) : (this.lastNeed = 3 - d, this.lastTotal = 3, d === 1 ? this.lastChar[0] = m[m.length - 1] : (this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1]), m.toString("base64", u, m.length - d));
        }
        function g(m) {
          var u = m && m.length ? this.write(m) : "";
          return this.lastNeed ? u + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : u;
        }
        function x(m) {
          return m.toString(this.encoding);
        }
        function h(m) {
          return m && m.length ? this.write(m) : "";
        }
      }), vl = xe((L, k) => {
        var n = Ua().codes.ERR_STREAM_PREMATURE_CLOSE;
        function e(r) {
          var s = !1;
          return function() {
            if (!s) {
              s = !0;
              for (var c = arguments.length, t = new Array(c), p = 0; p < c; p++) t[p] = arguments[p];
              r.apply(this, t);
            }
          };
        }
        function a() {
        }
        function i(r) {
          return r.setHeader && typeof r.abort == "function";
        }
        function o(r, s, c) {
          if (typeof s == "function") return o(r, null, s);
          s || (s = {}), c = e(c || a);
          var t = s.readable || s.readable !== !1 && r.readable, p = s.writable || s.writable !== !1 && r.writable, l = function() {
            r.writable || v();
          }, f = r._writableState && r._writableState.finished, v = function() {
            p = !1, f = !0, t || c.call(r);
          }, g = r._readableState && r._readableState.endEmitted, x = function() {
            t = !1, g = !0, p || c.call(r);
          }, h = function(d) {
            c.call(r, d);
          }, m = function() {
            var d;
            if (t && !g) return (!r._readableState || !r._readableState.ended) && (d = new n()), c.call(r, d);
            if (p && !f) return (!r._writableState || !r._writableState.ended) && (d = new n()), c.call(r, d);
          }, u = function() {
            r.req.on("finish", v);
          };
          return i(r) ? (r.on("complete", v), r.on("abort", m), r.req ? u() : r.on("request", u)) : p && !r._writableState && (r.on("end", l), r.on("close", l)), r.on("end", x), r.on("finish", v), s.error !== !1 && r.on("error", h), r.on("close", m), function() {
            r.removeListener("complete", v), r.removeListener("abort", m), r.removeListener("request", u), r.req && r.req.removeListener("finish", v), r.removeListener("end", l), r.removeListener("close", l), r.removeListener("finish", v), r.removeListener("end", x), r.removeListener("error", h), r.removeListener("close", m);
          };
        }
        k.exports = o;
      }), i1 = xe((L, k) => {
        var n;
        function e(u, d, y) {
          return d in u ? Object.defineProperty(u, d, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : u[d] = y, u;
        }
        var a = vl(), i = Symbol("lastResolve"), o = Symbol("lastReject"), r = Symbol("error"), s = Symbol("ended"), c = Symbol("lastPromise"), t = Symbol("handlePromise"), p = Symbol("stream");
        function l(u, d) {
          return { value: u, done: d };
        }
        function f(u) {
          var d = u[i];
          if (d !== null) {
            var y = u[p].read();
            y !== null && (u[c] = null, u[i] = null, u[o] = null, d(l(y, !1)));
          }
        }
        function v(u) {
          process.nextTick(f, u);
        }
        function g(u, d) {
          return function(y, _) {
            u.then(function() {
              if (d[s]) {
                y(l(void 0, !0));
                return;
              }
              d[t](y, _);
            }, _);
          };
        }
        var x = Object.getPrototypeOf(function() {
        }), h = Object.setPrototypeOf((n = { get stream() {
          return this[p];
        }, next: function() {
          var u = this, d = this[r];
          if (d !== null) return Promise.reject(d);
          if (this[s]) return Promise.resolve(l(void 0, !0));
          if (this[p].destroyed) return new Promise(function(R, I) {
            process.nextTick(function() {
              u[r] ? I(u[r]) : R(l(void 0, !0));
            });
          });
          var y = this[c], _;
          if (y) _ = new Promise(g(y, this));
          else {
            var T = this[p].read();
            if (T !== null) return Promise.resolve(l(T, !1));
            _ = new Promise(this[t]);
          }
          return this[c] = _, _;
        } }, e(n, Symbol.asyncIterator, function() {
          return this;
        }), e(n, "return", function() {
          var u = this;
          return new Promise(function(d, y) {
            u[p].destroy(null, function(_) {
              if (_) {
                y(_);
                return;
              }
              d(l(void 0, !0));
            });
          });
        }), n), x), m = function(u) {
          var d, y = Object.create(h, (d = {}, e(d, p, { value: u, writable: !0 }), e(d, i, { value: null, writable: !0 }), e(d, o, { value: null, writable: !0 }), e(d, r, { value: null, writable: !0 }), e(d, s, { value: u._readableState.endEmitted, writable: !0 }), e(d, t, { value: function(_, T) {
            var R = y[p].read();
            R ? (y[c] = null, y[i] = null, y[o] = null, _(l(R, !1))) : (y[i] = _, y[o] = T);
          }, writable: !0 }), d));
          return y[c] = null, a(u, function(_) {
            if (_ && _.code !== "ERR_STREAM_PREMATURE_CLOSE") {
              var T = y[o];
              T !== null && (y[c] = null, y[i] = null, y[o] = null, T(_)), y[r] = _;
              return;
            }
            var R = y[i];
            R !== null && (y[c] = null, y[i] = null, y[o] = null, R(l(void 0, !0))), y[s] = !0;
          }), u.on("readable", v.bind(null, y)), y;
        };
        k.exports = m;
      }), o1 = xe((L, k) => {
        k.exports = function() {
          throw new Error("Readable.from is not available in the browser");
        };
      }), ac = xe((L, k) => {
        k.exports = M;
        var n;
        M.ReadableState = P, Ra().EventEmitter;
        var e = function(E, w) {
          return E.listeners(w).length;
        }, a = qu(), i = ui().Buffer, o = window.Uint8Array || function() {
        };
        function r(E) {
          return i.from(E);
        }
        function s(E) {
          return i.isBuffer(E) || E instanceof o;
        }
        var c = Qu(), t;
        c && c.debuglog ? t = c.debuglog("stream") : t = function() {
        };
        var p = r1(), l = ec(), f = tc(), v = f.getHighWaterMark, g = Ua().codes, x = g.ERR_INVALID_ARG_TYPE, h = g.ERR_STREAM_PUSH_AFTER_EOF, m = g.ERR_METHOD_NOT_IMPLEMENTED, u = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, d, y, _;
        ma()(M, a);
        var T = l.errorOrDestroy, R = ["error", "close", "destroy", "pause", "resume"];
        function I(E, w, N) {
          if (typeof E.prependListener == "function") return E.prependListener(w, N);
          !E._events || !E._events[w] ? E.on(w, N) : Array.isArray(E._events[w]) ? E._events[w].unshift(N) : E._events[w] = [N, E._events[w]];
        }
        function P(E, w, N) {
          n = n || Va(), E = E || {}, typeof N != "boolean" && (N = w instanceof n), this.objectMode = !!E.objectMode, N && (this.objectMode = this.objectMode || !!E.readableObjectMode), this.highWaterMark = v(this, E, "readableHighWaterMark", N), this.buffer = new p(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = E.emitClose !== !1, this.autoDestroy = !!E.autoDestroy, this.destroyed = !1, this.defaultEncoding = E.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, E.encoding && (d || (d = nc().StringDecoder), this.decoder = new d(E.encoding), this.encoding = E.encoding);
        }
        function M(E) {
          if (n = n || Va(), !(this instanceof M)) return new M(E);
          var w = this instanceof n;
          this._readableState = new P(E, this, w), this.readable = !0, E && (typeof E.read == "function" && (this._read = E.read), typeof E.destroy == "function" && (this._destroy = E.destroy)), a.call(this);
        }
        Object.defineProperty(M.prototype, "destroyed", { enumerable: !1, get: function() {
          return this._readableState === void 0 ? !1 : this._readableState.destroyed;
        }, set: function(E) {
          this._readableState && (this._readableState.destroyed = E);
        } }), M.prototype.destroy = l.destroy, M.prototype._undestroy = l.undestroy, M.prototype._destroy = function(E, w) {
          w(E);
        }, M.prototype.push = function(E, w) {
          var N = this._readableState, W;
          return N.objectMode ? W = !0 : typeof E == "string" && (w = w || N.defaultEncoding, w !== N.encoding && (E = i.from(E, w), w = ""), W = !0), B(this, E, w, !1, W);
        }, M.prototype.unshift = function(E) {
          return B(this, E, null, !0, !1);
        };
        function B(E, w, N, W, ee) {
          t("readableAddChunk", w);
          var le = E._readableState;
          if (w === null) le.reading = !1, te(E, le);
          else {
            var ie;
            if (ee || (ie = q(le, w)), ie) T(E, ie);
            else if (le.objectMode || w && w.length > 0) if (typeof w != "string" && !le.objectMode && Object.getPrototypeOf(w) !== i.prototype && (w = r(w)), W) le.endEmitted ? T(E, new u()) : z(E, le, w, !0);
            else if (le.ended) T(E, new h());
            else {
              if (le.destroyed) return !1;
              le.reading = !1, le.decoder && !N ? (w = le.decoder.write(w), le.objectMode || w.length !== 0 ? z(E, le, w, !1) : Y(E, le)) : z(E, le, w, !1);
            }
            else W || (le.reading = !1, Y(E, le));
          }
          return !le.ended && (le.length < le.highWaterMark || le.length === 0);
        }
        function z(E, w, N, W) {
          w.flowing && w.length === 0 && !w.sync ? (w.awaitDrain = 0, E.emit("data", N)) : (w.length += w.objectMode ? 1 : N.length, W ? w.buffer.unshift(N) : w.buffer.push(N), w.needReadable && V(E)), Y(E, w);
        }
        function q(E, w) {
          var N;
          return !s(w) && typeof w != "string" && w !== void 0 && !E.objectMode && (N = new x("chunk", ["string", "Buffer", "Uint8Array"], w)), N;
        }
        M.prototype.isPaused = function() {
          return this._readableState.flowing === !1;
        }, M.prototype.setEncoding = function(E) {
          d || (d = nc().StringDecoder);
          var w = new d(E);
          this._readableState.decoder = w, this._readableState.encoding = this._readableState.decoder.encoding;
          for (var N = this._readableState.buffer.head, W = ""; N !== null; ) W += w.write(N.data), N = N.next;
          return this._readableState.buffer.clear(), W !== "" && this._readableState.buffer.push(W), this._readableState.length = W.length, this;
        };
        var U = 1073741824;
        function G(E) {
          return E >= U ? E = U : (E--, E |= E >>> 1, E |= E >>> 2, E |= E >>> 4, E |= E >>> 8, E |= E >>> 16, E++), E;
        }
        function K(E, w) {
          return E <= 0 || w.length === 0 && w.ended ? 0 : w.objectMode ? 1 : E !== E ? w.flowing && w.length ? w.buffer.head.data.length : w.length : (E > w.highWaterMark && (w.highWaterMark = G(E)), E <= w.length ? E : w.ended ? w.length : (w.needReadable = !0, 0));
        }
        M.prototype.read = function(E) {
          t("read", E), E = parseInt(E, 10);
          var w = this._readableState, N = E;
          if (E !== 0 && (w.emittedReadable = !1), E === 0 && w.needReadable && ((w.highWaterMark !== 0 ? w.length >= w.highWaterMark : w.length > 0) || w.ended)) return t("read: emitReadable", w.length, w.ended), w.length === 0 && w.ended ? S(this) : V(this), null;
          if (E = K(E, w), E === 0 && w.ended) return w.length === 0 && S(this), null;
          var W = w.needReadable;
          t("need readable", W), (w.length === 0 || w.length - E < w.highWaterMark) && (W = !0, t("length less than watermark", W)), w.ended || w.reading ? (W = !1, t("reading or ended", W)) : W && (t("do read"), w.reading = !0, w.sync = !0, w.length === 0 && (w.needReadable = !0), this._read(w.highWaterMark), w.sync = !1, w.reading || (E = K(N, w)));
          var ee;
          return E > 0 ? ee = F(E, w) : ee = null, ee === null ? (w.needReadable = w.length <= w.highWaterMark, E = 0) : (w.length -= E, w.awaitDrain = 0), w.length === 0 && (w.ended || (w.needReadable = !0), N !== E && w.ended && S(this)), ee !== null && this.emit("data", ee), ee;
        };
        function te(E, w) {
          if (t("onEofChunk"), !w.ended) {
            if (w.decoder) {
              var N = w.decoder.end();
              N && N.length && (w.buffer.push(N), w.length += w.objectMode ? 1 : N.length);
            }
            w.ended = !0, w.sync ? V(E) : (w.needReadable = !1, w.emittedReadable || (w.emittedReadable = !0, Z(E)));
          }
        }
        function V(E) {
          var w = E._readableState;
          t("emitReadable", w.needReadable, w.emittedReadable), w.needReadable = !1, w.emittedReadable || (t("emitReadable", w.flowing), w.emittedReadable = !0, process.nextTick(Z, E));
        }
        function Z(E) {
          var w = E._readableState;
          t("emitReadable_", w.destroyed, w.length, w.ended), !w.destroyed && (w.length || w.ended) && (E.emit("readable"), w.emittedReadable = !1), w.needReadable = !w.flowing && !w.ended && w.length <= w.highWaterMark, O(E);
        }
        function Y(E, w) {
          w.readingMore || (w.readingMore = !0, process.nextTick(C, E, w));
        }
        function C(E, w) {
          for (; !w.reading && !w.ended && (w.length < w.highWaterMark || w.flowing && w.length === 0); ) {
            var N = w.length;
            if (t("maybeReadMore read 0"), E.read(0), N === w.length) break;
          }
          w.readingMore = !1;
        }
        M.prototype._read = function(E) {
          T(this, new m("_read()"));
        }, M.prototype.pipe = function(E, w) {
          var N = this, W = this._readableState;
          switch (W.pipesCount) {
            case 0:
              W.pipes = E;
              break;
            case 1:
              W.pipes = [W.pipes, E];
              break;
            default:
              W.pipes.push(E);
              break;
          }
          W.pipesCount += 1, t("pipe count=%d opts=%j", W.pipesCount, w);
          var ee = (!w || w.end !== !1) && E !== process.stdout && E !== process.stderr, le = ee ? pe : X;
          W.endEmitted ? process.nextTick(le) : N.once("end", le), E.on("unpipe", ie);
          function ie(H, ve) {
            t("onunpipe"), H === N && ve && ve.hasUnpiped === !1 && (ve.hasUnpiped = !0, Ce());
          }
          function pe() {
            t("onend"), E.end();
          }
          var _e = j(N);
          E.on("drain", _e);
          var Ae = !1;
          function Ce() {
            t("cleanup"), E.removeListener("close", ke), E.removeListener("finish", A), E.removeListener("drain", _e), E.removeListener("error", Ne), E.removeListener("unpipe", ie), N.removeListener("end", pe), N.removeListener("end", X), N.removeListener("data", Ue), Ae = !0, W.awaitDrain && (!E._writableState || E._writableState.needDrain) && _e();
          }
          N.on("data", Ue);
          function Ue(H) {
            t("ondata");
            var ve = E.write(H);
            t("dest.write", ve), ve === !1 && ((W.pipesCount === 1 && W.pipes === E || W.pipesCount > 1 && re(W.pipes, E) !== -1) && !Ae && (t("false write response, pause", W.awaitDrain), W.awaitDrain++), N.pause());
          }
          function Ne(H) {
            t("onerror", H), X(), E.removeListener("error", Ne), e(E, "error") === 0 && T(E, H);
          }
          I(E, "error", Ne);
          function ke() {
            E.removeListener("finish", A), X();
          }
          E.once("close", ke);
          function A() {
            t("onfinish"), E.removeListener("close", ke), X();
          }
          E.once("finish", A);
          function X() {
            t("unpipe"), N.unpipe(E);
          }
          return E.emit("pipe", N), W.flowing || (t("pipe resume"), N.resume()), E;
        };
        function j(E) {
          return function() {
            var w = E._readableState;
            t("pipeOnDrain", w.awaitDrain), w.awaitDrain && w.awaitDrain--, w.awaitDrain === 0 && e(E, "data") && (w.flowing = !0, O(E));
          };
        }
        M.prototype.unpipe = function(E) {
          var w = this._readableState, N = { hasUnpiped: !1 };
          if (w.pipesCount === 0) return this;
          if (w.pipesCount === 1) return E && E !== w.pipes ? this : (E || (E = w.pipes), w.pipes = null, w.pipesCount = 0, w.flowing = !1, E && E.emit("unpipe", this, N), this);
          if (!E) {
            var W = w.pipes, ee = w.pipesCount;
            w.pipes = null, w.pipesCount = 0, w.flowing = !1;
            for (var le = 0; le < ee; le++) W[le].emit("unpipe", this, { hasUnpiped: !1 });
            return this;
          }
          var ie = re(w.pipes, E);
          return ie === -1 ? this : (w.pipes.splice(ie, 1), w.pipesCount -= 1, w.pipesCount === 1 && (w.pipes = w.pipes[0]), E.emit("unpipe", this, N), this);
        }, M.prototype.on = function(E, w) {
          var N = a.prototype.on.call(this, E, w), W = this._readableState;
          return E === "data" ? (W.readableListening = this.listenerCount("readable") > 0, W.flowing !== !1 && this.resume()) : E === "readable" && !W.endEmitted && !W.readableListening && (W.readableListening = W.needReadable = !0, W.flowing = !1, W.emittedReadable = !1, t("on readable", W.length, W.reading), W.length ? V(this) : W.reading || process.nextTick(ne, this)), N;
        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(E, w) {
          var N = a.prototype.removeListener.call(this, E, w);
          return E === "readable" && process.nextTick(J, this), N;
        }, M.prototype.removeAllListeners = function(E) {
          var w = a.prototype.removeAllListeners.apply(this, arguments);
          return (E === "readable" || E === void 0) && process.nextTick(J, this), w;
        };
        function J(E) {
          var w = E._readableState;
          w.readableListening = E.listenerCount("readable") > 0, w.resumeScheduled && !w.paused ? w.flowing = !0 : E.listenerCount("data") > 0 && E.resume();
        }
        function ne(E) {
          t("readable nexttick read 0"), E.read(0);
        }
        M.prototype.resume = function() {
          var E = this._readableState;
          return E.flowing || (t("resume"), E.flowing = !E.readableListening, ae(this, E)), E.paused = !1, this;
        };
        function ae(E, w) {
          w.resumeScheduled || (w.resumeScheduled = !0, process.nextTick(se, E, w));
        }
        function se(E, w) {
          t("resume", w.reading), w.reading || E.read(0), w.resumeScheduled = !1, E.emit("resume"), O(E), w.flowing && !w.reading && E.read(0);
        }
        M.prototype.pause = function() {
          return t("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (t("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
        };
        function O(E) {
          var w = E._readableState;
          for (t("flow", w.flowing); w.flowing && E.read() !== null; ) ;
        }
        M.prototype.wrap = function(E) {
          var w = this, N = this._readableState, W = !1;
          E.on("end", function() {
            if (t("wrapped end"), N.decoder && !N.ended) {
              var ie = N.decoder.end();
              ie && ie.length && w.push(ie);
            }
            w.push(null);
          }), E.on("data", function(ie) {
            if (t("wrapped data"), N.decoder && (ie = N.decoder.write(ie)), !(N.objectMode && ie == null) && !(!N.objectMode && (!ie || !ie.length))) {
              var pe = w.push(ie);
              pe || (W = !0, E.pause());
            }
          });
          for (var ee in E) this[ee] === void 0 && typeof E[ee] == "function" && (this[ee] = /* @__PURE__ */ function(ie) {
            return function() {
              return E[ie].apply(E, arguments);
            };
          }(ee));
          for (var le = 0; le < R.length; le++) E.on(R[le], this.emit.bind(this, R[le]));
          return this._read = function(ie) {
            t("wrapped _read", ie), W && (W = !1, E.resume());
          }, this;
        }, typeof Symbol == "function" && (M.prototype[Symbol.asyncIterator] = function() {
          return y === void 0 && (y = i1()), y(this);
        }), Object.defineProperty(M.prototype, "readableHighWaterMark", { enumerable: !1, get: function() {
          return this._readableState.highWaterMark;
        } }), Object.defineProperty(M.prototype, "readableBuffer", { enumerable: !1, get: function() {
          return this._readableState && this._readableState.buffer;
        } }), Object.defineProperty(M.prototype, "readableFlowing", { enumerable: !1, get: function() {
          return this._readableState.flowing;
        }, set: function(E) {
          this._readableState && (this._readableState.flowing = E);
        } }), M._fromList = F, Object.defineProperty(M.prototype, "readableLength", { enumerable: !1, get: function() {
          return this._readableState.length;
        } });
        function F(E, w) {
          if (w.length === 0) return null;
          var N;
          return w.objectMode ? N = w.buffer.shift() : !E || E >= w.length ? (w.decoder ? N = w.buffer.join("") : w.buffer.length === 1 ? N = w.buffer.first() : N = w.buffer.concat(w.length), w.buffer.clear()) : N = w.buffer.consume(E, w.decoder), N;
        }
        function S(E) {
          var w = E._readableState;
          t("endReadable", w.endEmitted), w.endEmitted || (w.ended = !0, process.nextTick($, w, E));
        }
        function $(E, w) {
          if (t("endReadableNT", E.endEmitted, E.length), !E.endEmitted && E.length === 0 && (E.endEmitted = !0, w.readable = !1, w.emit("end"), E.autoDestroy)) {
            var N = w._writableState;
            (!N || N.autoDestroy && N.finished) && w.destroy();
          }
        }
        typeof Symbol == "function" && (M.from = function(E, w) {
          return _ === void 0 && (_ = o1()), _(M, E, w);
        });
        function re(E, w) {
          for (var N = 0, W = E.length; N < W; N++) if (E[N] === w) return N;
          return -1;
        }
      }), ic = xe((L, k) => {
        k.exports = c;
        var n = Ua().codes, e = n.ERR_METHOD_NOT_IMPLEMENTED, a = n.ERR_MULTIPLE_CALLBACK, i = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, o = n.ERR_TRANSFORM_WITH_LENGTH_0, r = Va();
        ma()(c, r);
        function s(l, f) {
          var v = this._transformState;
          v.transforming = !1;
          var g = v.writecb;
          if (g === null) return this.emit("error", new a());
          v.writechunk = null, v.writecb = null, f != null && this.push(f), g(l);
          var x = this._readableState;
          x.reading = !1, (x.needReadable || x.length < x.highWaterMark) && this._read(x.highWaterMark);
        }
        function c(l) {
          if (!(this instanceof c)) return new c(l);
          r.call(this, l), this._transformState = { afterTransform: s.bind(this), needTransform: !1, transforming: !1, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = !0, this._readableState.sync = !1, l && (typeof l.transform == "function" && (this._transform = l.transform), typeof l.flush == "function" && (this._flush = l.flush)), this.on("prefinish", t);
        }
        function t() {
          var l = this;
          typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(f, v) {
            p(l, f, v);
          }) : p(this, null, null);
        }
        c.prototype.push = function(l, f) {
          return this._transformState.needTransform = !1, r.prototype.push.call(this, l, f);
        }, c.prototype._transform = function(l, f, v) {
          v(new e("_transform()"));
        }, c.prototype._write = function(l, f, v) {
          var g = this._transformState;
          if (g.writecb = v, g.writechunk = l, g.writeencoding = f, !g.transforming) {
            var x = this._readableState;
            (g.needTransform || x.needReadable || x.length < x.highWaterMark) && this._read(x.highWaterMark);
          }
        }, c.prototype._read = function(l) {
          var f = this._transformState;
          f.writechunk !== null && !f.transforming ? (f.transforming = !0, this._transform(f.writechunk, f.writeencoding, f.afterTransform)) : f.needTransform = !0;
        }, c.prototype._destroy = function(l, f) {
          r.prototype._destroy.call(this, l, function(v) {
            f(v);
          });
        };
        function p(l, f, v) {
          if (f) return l.emit("error", f);
          if (v != null && l.push(v), l._writableState.length) throw new o();
          if (l._transformState.transforming) throw new i();
          return l.push(null);
        }
      }), l1 = xe((L, k) => {
        k.exports = e;
        var n = ic();
        ma()(e, n);
        function e(a) {
          if (!(this instanceof e)) return new e(a);
          n.call(this, a);
        }
        e.prototype._transform = function(a, i, o) {
          o(null, a);
        };
      }), s1 = xe((L, k) => {
        var n;
        function e(v) {
          var g = !1;
          return function() {
            g || (g = !0, v.apply(void 0, arguments));
          };
        }
        var a = Ua().codes, i = a.ERR_MISSING_ARGS, o = a.ERR_STREAM_DESTROYED;
        function r(v) {
          if (v) throw v;
        }
        function s(v) {
          return v.setHeader && typeof v.abort == "function";
        }
        function c(v, g, x, h) {
          h = e(h);
          var m = !1;
          v.on("close", function() {
            m = !0;
          }), n === void 0 && (n = vl()), n(v, { readable: g, writable: x }, function(d) {
            if (d) return h(d);
            m = !0, h();
          });
          var u = !1;
          return function(d) {
            if (!m && !u) {
              if (u = !0, s(v)) return v.abort();
              if (typeof v.destroy == "function") return v.destroy();
              h(d || new o("pipe"));
            }
          };
        }
        function t(v) {
          v();
        }
        function p(v, g) {
          return v.pipe(g);
        }
        function l(v) {
          return !v.length || typeof v[v.length - 1] != "function" ? r : v.pop();
        }
        function f() {
          for (var v = arguments.length, g = new Array(v), x = 0; x < v; x++) g[x] = arguments[x];
          var h = l(g);
          if (Array.isArray(g[0]) && (g = g[0]), g.length < 2) throw new i("streams");
          var m, u = g.map(function(d, y) {
            var _ = y < g.length - 1, T = y > 0;
            return c(d, _, T, function(R) {
              m || (m = R), R && u.forEach(t), !_ && (u.forEach(t), h(m));
            });
          });
          return g.reduce(p);
        }
        k.exports = f;
      }), u1 = xe((L, k) => {
        k.exports = a;
        var n = Ra().EventEmitter, e = ma();
        e(a, n), a.Readable = ac(), a.Writable = rc(), a.Duplex = Va(), a.Transform = ic(), a.PassThrough = l1(), a.finished = vl(), a.pipeline = s1(), a.Stream = a;
        function a() {
          n.call(this);
        }
        a.prototype.pipe = function(i, o) {
          var r = this;
          function s(g) {
            i.writable && i.write(g) === !1 && r.pause && r.pause();
          }
          r.on("data", s);
          function c() {
            r.readable && r.resume && r.resume();
          }
          i.on("drain", c), !i._isStdio && (!o || o.end !== !1) && (r.on("end", p), r.on("close", l));
          var t = !1;
          function p() {
            t || (t = !0, i.end());
          }
          function l() {
            t || (t = !0, typeof i.destroy == "function" && i.destroy());
          }
          function f(g) {
            if (v(), n.listenerCount(this, "error") === 0) throw g;
          }
          r.on("error", f), i.on("error", f);
          function v() {
            r.removeListener("data", s), i.removeListener("drain", c), r.removeListener("end", p), r.removeListener("close", l), r.removeListener("error", f), i.removeListener("error", f), r.removeListener("end", v), r.removeListener("close", v), i.removeListener("close", v);
          }
          return r.on("end", v), r.on("close", v), i.on("close", v), i.emit("pipe", r), i;
        };
      }), pi = xe((L) => {
        var k = Object.getOwnPropertyDescriptors || function(C) {
          for (var j = Object.keys(C), J = {}, ne = 0; ne < j.length; ne++) J[j[ne]] = Object.getOwnPropertyDescriptor(C, j[ne]);
          return J;
        }, n = /%[sdj%]/g;
        L.format = function(C) {
          if (!y(C)) {
            for (var j = [], J = 0; J < arguments.length; J++) j.push(o(arguments[J]));
            return j.join(" ");
          }
          for (var J = 1, ne = arguments, ae = ne.length, se = String(C).replace(n, function(S) {
            if (S === "%%") return "%";
            if (J >= ae) return S;
            switch (S) {
              case "%s":
                return String(ne[J++]);
              case "%d":
                return Number(ne[J++]);
              case "%j":
                try {
                  return JSON.stringify(ne[J++]);
                } catch {
                  return "[Circular]";
                }
              default:
                return S;
            }
          }), O = ne[J]; J < ae; O = ne[++J]) m(O) || !I(O) ? se += " " + O : se += " " + o(O);
          return se;
        }, L.deprecate = function(C, j) {
          if (typeof process < "u" && process.noDeprecation === !0) return C;
          if (typeof process > "u") return function() {
            return L.deprecate(C, j).apply(this, arguments);
          };
          var J = !1;
          function ne() {
            if (!J) {
              if (process.throwDeprecation) throw new Error(j);
              process.traceDeprecation ? console.trace(j) : console.error(j), J = !0;
            }
            return C.apply(this, arguments);
          }
          return ne;
        };
        var e = {}, a = /^$/;
        i = "false", i = i.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + i + "$", "i");
        var i;
        L.debuglog = function(C) {
          if (C = C.toUpperCase(), !e[C]) if (a.test(C)) {
            var j = process.pid;
            e[C] = function() {
              var J = L.format.apply(L, arguments);
              console.error("%s %d: %s", C, j, J);
            };
          } else e[C] = function() {
          };
          return e[C];
        };
        function o(C, j) {
          var J = { seen: [], stylize: s };
          return arguments.length >= 3 && (J.depth = arguments[2]), arguments.length >= 4 && (J.colors = arguments[3]), h(j) ? J.showHidden = j : j && L._extend(J, j), T(J.showHidden) && (J.showHidden = !1), T(J.depth) && (J.depth = 2), T(J.colors) && (J.colors = !1), T(J.customInspect) && (J.customInspect = !0), J.colors && (J.stylize = r), t(J, C, J.depth);
        }
        L.inspect = o, o.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, o.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" };
        function r(C, j) {
          var J = o.styles[j];
          return J ? "\x1B[" + o.colors[J][0] + "m" + C + "\x1B[" + o.colors[J][1] + "m" : C;
        }
        function s(C, j) {
          return C;
        }
        function c(C) {
          var j = {};
          return C.forEach(function(J, ne) {
            j[J] = !0;
          }), j;
        }
        function t(C, j, J) {
          if (C.customInspect && j && B(j.inspect) && j.inspect !== L.inspect && !(j.constructor && j.constructor.prototype === j)) {
            var ne = j.inspect(J, C);
            return y(ne) || (ne = t(C, ne, J)), ne;
          }
          var ae = p(C, j);
          if (ae) return ae;
          var se = Object.keys(j), O = c(se);
          if (C.showHidden && (se = Object.getOwnPropertyNames(j)), M(j) && (se.indexOf("message") >= 0 || se.indexOf("description") >= 0)) return l(j);
          if (se.length === 0) {
            if (B(j)) {
              var F = j.name ? ": " + j.name : "";
              return C.stylize("[Function" + F + "]", "special");
            }
            if (R(j)) return C.stylize(RegExp.prototype.toString.call(j), "regexp");
            if (P(j)) return C.stylize(Date.prototype.toString.call(j), "date");
            if (M(j)) return l(j);
          }
          var S = "", $ = !1, re = ["{", "}"];
          if (x(j) && ($ = !0, re = ["[", "]"]), B(j)) {
            var E = j.name ? ": " + j.name : "";
            S = " [Function" + E + "]";
          }
          if (R(j) && (S = " " + RegExp.prototype.toString.call(j)), P(j) && (S = " " + Date.prototype.toUTCString.call(j)), M(j) && (S = " " + l(j)), se.length === 0 && (!$ || j.length == 0)) return re[0] + S + re[1];
          if (J < 0) return R(j) ? C.stylize(RegExp.prototype.toString.call(j), "regexp") : C.stylize("[Object]", "special");
          C.seen.push(j);
          var w;
          return $ ? w = f(C, j, J, O, se) : w = se.map(function(N) {
            return v(C, j, J, O, N, $);
          }), C.seen.pop(), g(w, S, re);
        }
        function p(C, j) {
          if (T(j)) return C.stylize("undefined", "undefined");
          if (y(j)) {
            var J = "'" + JSON.stringify(j).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return C.stylize(J, "string");
          }
          if (d(j)) return C.stylize("" + j, "number");
          if (h(j)) return C.stylize("" + j, "boolean");
          if (m(j)) return C.stylize("null", "null");
        }
        function l(C) {
          return "[" + Error.prototype.toString.call(C) + "]";
        }
        function f(C, j, J, ne, ae) {
          for (var se = [], O = 0, F = j.length; O < F; ++O) te(j, String(O)) ? se.push(v(C, j, J, ne, String(O), !0)) : se.push("");
          return ae.forEach(function(S) {
            S.match(/^\d+$/) || se.push(v(C, j, J, ne, S, !0));
          }), se;
        }
        function v(C, j, J, ne, ae, se) {
          var O, F, S;
          if (S = Object.getOwnPropertyDescriptor(j, ae) || { value: j[ae] }, S.get ? S.set ? F = C.stylize("[Getter/Setter]", "special") : F = C.stylize("[Getter]", "special") : S.set && (F = C.stylize("[Setter]", "special")), te(ne, ae) || (O = "[" + ae + "]"), F || (C.seen.indexOf(S.value) < 0 ? (m(J) ? F = t(C, S.value, null) : F = t(C, S.value, J - 1), F.indexOf(`
`) > -1 && (se ? F = F.split(`
`).map(function($) {
            return "  " + $;
          }).join(`
`).slice(2) : F = `
` + F.split(`
`).map(function($) {
            return "   " + $;
          }).join(`
`))) : F = C.stylize("[Circular]", "special")), T(O)) {
            if (se && ae.match(/^\d+$/)) return F;
            O = JSON.stringify("" + ae), O.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (O = O.slice(1, -1), O = C.stylize(O, "name")) : (O = O.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), O = C.stylize(O, "string"));
          }
          return O + ": " + F;
        }
        function g(C, j, J) {
          var ne = 0, ae = C.reduce(function(se, O) {
            return ne++, O.indexOf(`
`) >= 0 && ne++, se + O.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0);
          return ae > 60 ? J[0] + (j === "" ? "" : j + `
 `) + " " + C.join(`,
  `) + " " + J[1] : J[0] + j + " " + C.join(", ") + " " + J[1];
        }
        L.types = $u();
        function x(C) {
          return Array.isArray(C);
        }
        L.isArray = x;
        function h(C) {
          return typeof C == "boolean";
        }
        L.isBoolean = h;
        function m(C) {
          return C === null;
        }
        L.isNull = m;
        function u(C) {
          return C == null;
        }
        L.isNullOrUndefined = u;
        function d(C) {
          return typeof C == "number";
        }
        L.isNumber = d;
        function y(C) {
          return typeof C == "string";
        }
        L.isString = y;
        function _(C) {
          return typeof C == "symbol";
        }
        L.isSymbol = _;
        function T(C) {
          return C === void 0;
        }
        L.isUndefined = T;
        function R(C) {
          return I(C) && q(C) === "[object RegExp]";
        }
        L.isRegExp = R, L.types.isRegExp = R;
        function I(C) {
          return typeof C == "object" && C !== null;
        }
        L.isObject = I;
        function P(C) {
          return I(C) && q(C) === "[object Date]";
        }
        L.isDate = P, L.types.isDate = P;
        function M(C) {
          return I(C) && (q(C) === "[object Error]" || C instanceof Error);
        }
        L.isError = M, L.types.isNativeError = M;
        function B(C) {
          return typeof C == "function";
        }
        L.isFunction = B;
        function z(C) {
          return C === null || typeof C == "boolean" || typeof C == "number" || typeof C == "string" || typeof C == "symbol" || typeof C > "u";
        }
        L.isPrimitive = z, L.isBuffer = Ku();
        function q(C) {
          return Object.prototype.toString.call(C);
        }
        function U(C) {
          return C < 10 ? "0" + C.toString(10) : C.toString(10);
        }
        var G = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        function K() {
          var C = /* @__PURE__ */ new Date(), j = [U(C.getHours()), U(C.getMinutes()), U(C.getSeconds())].join(":");
          return [C.getDate(), G[C.getMonth()], j].join(" ");
        }
        L.log = function() {
          console.log("%s - %s", K(), L.format.apply(L, arguments));
        }, L.inherits = ma(), L._extend = function(C, j) {
          if (!j || !I(j)) return C;
          for (var J = Object.keys(j), ne = J.length; ne--; ) C[J[ne]] = j[J[ne]];
          return C;
        };
        function te(C, j) {
          return Object.prototype.hasOwnProperty.call(C, j);
        }
        var V = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
        L.promisify = function(C) {
          if (typeof C != "function") throw new TypeError('The "original" argument must be of type Function');
          if (V && C[V]) {
            var j = C[V];
            if (typeof j != "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(j, V, { value: j, enumerable: !1, writable: !1, configurable: !0 }), j;
          }
          function j() {
            for (var J, ne, ae = new Promise(function(F, S) {
              J = F, ne = S;
            }), se = [], O = 0; O < arguments.length; O++) se.push(arguments[O]);
            se.push(function(F, S) {
              F ? ne(F) : J(S);
            });
            try {
              C.apply(this, se);
            } catch (F) {
              ne(F);
            }
            return ae;
          }
          return Object.setPrototypeOf(j, Object.getPrototypeOf(C)), V && Object.defineProperty(j, V, { value: j, enumerable: !1, writable: !1, configurable: !0 }), Object.defineProperties(j, k(C));
        }, L.promisify.custom = V;
        function Z(C, j) {
          if (!C) {
            var J = new Error("Promise was rejected with a falsy value");
            J.reason = C, C = J;
          }
          return j(C);
        }
        function Y(C) {
          if (typeof C != "function") throw new TypeError('The "original" argument must be of type Function');
          function j() {
            for (var J = [], ne = 0; ne < arguments.length; ne++) J.push(arguments[ne]);
            var ae = J.pop();
            if (typeof ae != "function") throw new TypeError("The last argument must be of type Function");
            var se = this, O = function() {
              return ae.apply(se, arguments);
            };
            C.apply(this, J).then(function(F) {
              process.nextTick(O.bind(null, null, F));
            }, function(F) {
              process.nextTick(Z.bind(null, F, O));
            });
          }
          return Object.setPrototypeOf(j, Object.getPrototypeOf(C)), Object.defineProperties(j, k(C)), j;
        }
        L.callbackify = Y;
      }), oc = xe((L, k) => {
        function n(d) {
          "@babel/helpers - typeof";
          return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
            return typeof y;
          } : function(y) {
            return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
          }, n(d);
        }
        function e(d, y, _) {
          return Object.defineProperty(d, "prototype", { writable: !1 }), d;
        }
        function a(d, y) {
          if (!(d instanceof y)) throw new TypeError("Cannot call a class as a function");
        }
        function i(d, y) {
          if (typeof y != "function" && y !== null) throw new TypeError("Super expression must either be null or a function");
          d.prototype = Object.create(y && y.prototype, { constructor: { value: d, writable: !0, configurable: !0 } }), Object.defineProperty(d, "prototype", { writable: !1 }), y && o(d, y);
        }
        function o(d, y) {
          return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, T) {
            return _.__proto__ = T, _;
          }, o(d, y);
        }
        function r(d) {
          var y = t();
          return function() {
            var _ = p(d), T;
            if (y) {
              var R = p(this).constructor;
              T = Reflect.construct(_, arguments, R);
            } else T = _.apply(this, arguments);
            return s(this, T);
          };
        }
        function s(d, y) {
          if (y && (n(y) === "object" || typeof y == "function")) return y;
          if (y !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
          return c(d);
        }
        function c(d) {
          if (d === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return d;
        }
        function t() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function p(d) {
          return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(y) {
            return y.__proto__ || Object.getPrototypeOf(y);
          }, p(d);
        }
        var l = {}, f, v;
        function g(d, y, _) {
          _ || (_ = Error);
          function T(I, P, M) {
            return typeof y == "string" ? y : y(I, P, M);
          }
          var R = function(I) {
            i(M, I);
            var P = r(M);
            function M(B, z, q) {
              var U;
              return a(this, M), U = P.call(this, T(B, z, q)), U.code = d, U;
            }
            return e(M);
          }(_);
          l[d] = R;
        }
        function x(d, y) {
          if (Array.isArray(d)) {
            var _ = d.length;
            return d = d.map(function(T) {
              return String(T);
            }), _ > 2 ? "one of ".concat(y, " ").concat(d.slice(0, _ - 1).join(", "), ", or ") + d[_ - 1] : _ === 2 ? "one of ".concat(y, " ").concat(d[0], " or ").concat(d[1]) : "of ".concat(y, " ").concat(d[0]);
          } else return "of ".concat(y, " ").concat(String(d));
        }
        function h(d, y, _) {
          return d.substr(0, y.length) === y;
        }
        function m(d, y, _) {
          return (_ === void 0 || _ > d.length) && (_ = d.length), d.substring(_ - y.length, _) === y;
        }
        function u(d, y, _) {
          return typeof _ != "number" && (_ = 0), _ + y.length > d.length ? !1 : d.indexOf(y, _) !== -1;
        }
        g("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), g("ERR_INVALID_ARG_TYPE", function(d, y, _) {
          f === void 0 && (f = yl()), f(typeof d == "string", "'name' must be a string");
          var T;
          typeof y == "string" && h(y, "not ") ? (T = "must not be", y = y.replace(/^not /, "")) : T = "must be";
          var R;
          if (m(d, " argument")) R = "The ".concat(d, " ").concat(T, " ").concat(x(y, "type"));
          else {
            var I = u(d, ".") ? "property" : "argument";
            R = 'The "'.concat(d, '" ').concat(I, " ").concat(T, " ").concat(x(y, "type"));
          }
          return R += ". Received type ".concat(n(_)), R;
        }, TypeError), g("ERR_INVALID_ARG_VALUE", function(d, y) {
          var _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
          v === void 0 && (v = pi());
          var T = v.inspect(y);
          return T.length > 128 && (T = "".concat(T.slice(0, 128), "...")), "The argument '".concat(d, "' ").concat(_, ". Received ").concat(T);
        }, TypeError), g("ERR_INVALID_RETURN_VALUE", function(d, y, _) {
          var T;
          return _ && _.constructor && _.constructor.name ? T = "instance of ".concat(_.constructor.name) : T = "type ".concat(n(_)), "Expected ".concat(d, ' to be returned from the "').concat(y, '"') + " function but got ".concat(T, ".");
        }, TypeError), g("ERR_MISSING_ARGS", function() {
          for (var d = arguments.length, y = new Array(d), _ = 0; _ < d; _++) y[_] = arguments[_];
          f === void 0 && (f = yl()), f(y.length > 0, "At least one arg needs to be specified");
          var T = "The ", R = y.length;
          switch (y = y.map(function(I) {
            return '"'.concat(I, '"');
          }), R) {
            case 1:
              T += "".concat(y[0], " argument");
              break;
            case 2:
              T += "".concat(y[0], " and ").concat(y[1], " arguments");
              break;
            default:
              T += y.slice(0, R - 1).join(", "), T += ", and ".concat(y[R - 1], " arguments");
              break;
          }
          return "".concat(T, " must be specified");
        }, TypeError), k.exports.codes = l;
      }), c1 = xe((L, k) => {
        function n(Y, C) {
          var j = Object.keys(Y);
          if (Object.getOwnPropertySymbols) {
            var J = Object.getOwnPropertySymbols(Y);
            C && (J = J.filter(function(ne) {
              return Object.getOwnPropertyDescriptor(Y, ne).enumerable;
            })), j.push.apply(j, J);
          }
          return j;
        }
        function e(Y) {
          for (var C = 1; C < arguments.length; C++) {
            var j = arguments[C] != null ? arguments[C] : {};
            C % 2 ? n(Object(j), !0).forEach(function(J) {
              a(Y, J, j[J]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(j)) : n(Object(j)).forEach(function(J) {
              Object.defineProperty(Y, J, Object.getOwnPropertyDescriptor(j, J));
            });
          }
          return Y;
        }
        function a(Y, C, j) {
          return C = s(C), C in Y ? Object.defineProperty(Y, C, { value: j, enumerable: !0, configurable: !0, writable: !0 }) : Y[C] = j, Y;
        }
        function i(Y, C) {
          if (!(Y instanceof C)) throw new TypeError("Cannot call a class as a function");
        }
        function o(Y, C) {
          for (var j = 0; j < C.length; j++) {
            var J = C[j];
            J.enumerable = J.enumerable || !1, J.configurable = !0, "value" in J && (J.writable = !0), Object.defineProperty(Y, s(J.key), J);
          }
        }
        function r(Y, C, j) {
          return C && o(Y.prototype, C), Object.defineProperty(Y, "prototype", { writable: !1 }), Y;
        }
        function s(Y) {
          var C = c(Y, "string");
          return d(C) === "symbol" ? C : String(C);
        }
        function c(Y, C) {
          if (d(Y) !== "object" || Y === null) return Y;
          var j = Y[Symbol.toPrimitive];
          if (j !== void 0) {
            var J = j.call(Y, C);
            if (d(J) !== "object") return J;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(Y);
        }
        function t(Y, C) {
          if (typeof C != "function" && C !== null) throw new TypeError("Super expression must either be null or a function");
          Y.prototype = Object.create(C && C.prototype, { constructor: { value: Y, writable: !0, configurable: !0 } }), Object.defineProperty(Y, "prototype", { writable: !1 }), C && m(Y, C);
        }
        function p(Y) {
          var C = x();
          return function() {
            var j = u(Y), J;
            if (C) {
              var ne = u(this).constructor;
              J = Reflect.construct(j, arguments, ne);
            } else J = j.apply(this, arguments);
            return l(this, J);
          };
        }
        function l(Y, C) {
          if (C && (d(C) === "object" || typeof C == "function")) return C;
          if (C !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
          return f(Y);
        }
        function f(Y) {
          if (Y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return Y;
        }
        function v(Y) {
          var C = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
          return v = function(j) {
            if (j === null || !h(j)) return j;
            if (typeof j != "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof C < "u") {
              if (C.has(j)) return C.get(j);
              C.set(j, J);
            }
            function J() {
              return g(j, arguments, u(this).constructor);
            }
            return J.prototype = Object.create(j.prototype, { constructor: { value: J, enumerable: !1, writable: !0, configurable: !0 } }), m(J, j);
          }, v(Y);
        }
        function g(Y, C, j) {
          return x() ? g = Reflect.construct.bind() : g = function(J, ne, ae) {
            var se = [null];
            se.push.apply(se, ne);
            var O = Function.bind.apply(J, se), F = new O();
            return ae && m(F, ae.prototype), F;
          }, g.apply(null, arguments);
        }
        function x() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function h(Y) {
          return Function.toString.call(Y).indexOf("[native code]") !== -1;
        }
        function m(Y, C) {
          return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(j, J) {
            return j.__proto__ = J, j;
          }, m(Y, C);
        }
        function u(Y) {
          return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(C) {
            return C.__proto__ || Object.getPrototypeOf(C);
          }, u(Y);
        }
        function d(Y) {
          "@babel/helpers - typeof";
          return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
            return typeof C;
          } : function(C) {
            return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
          }, d(Y);
        }
        var y = pi(), _ = y.inspect, T = oc(), R = T.codes.ERR_INVALID_ARG_TYPE;
        function I(Y, C, j) {
          return (j === void 0 || j > Y.length) && (j = Y.length), Y.substring(j - C.length, j) === C;
        }
        function P(Y, C) {
          if (C = Math.floor(C), Y.length == 0 || C == 0) return "";
          var j = Y.length * C;
          for (C = Math.floor(Math.log(C) / Math.log(2)); C; ) Y += Y, C--;
          return Y += Y.substring(0, j - Y.length), Y;
        }
        var M = "", B = "", z = "", q = "", U = { deepStrictEqual: "Expected values to be strictly deep-equal:", strictEqual: "Expected values to be strictly equal:", strictEqualObject: 'Expected "actual" to be reference-equal to "expected":', deepEqual: "Expected values to be loosely deep-equal:", equal: "Expected values to be loosely equal:", notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:', notStrictEqual: 'Expected "actual" to be strictly unequal to:', notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":', notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:', notEqual: 'Expected "actual" to be loosely unequal to:', notIdentical: "Values identical but not reference-equal:" }, G = 10;
        function K(Y) {
          var C = Object.keys(Y), j = Object.create(Object.getPrototypeOf(Y));
          return C.forEach(function(J) {
            j[J] = Y[J];
          }), Object.defineProperty(j, "message", { value: Y.message }), j;
        }
        function te(Y) {
          return _(Y, { compact: !1, customInspect: !1, depth: 1e3, maxArrayLength: 1 / 0, showHidden: !1, breakLength: 1 / 0, showProxy: !1, sorted: !0, getters: !0 });
        }
        function V(Y, C, j) {
          var J = "", ne = "", ae = 0, se = "", O = !1, F = te(Y), S = F.split(`
`), $ = te(C).split(`
`), re = 0, E = "";
          if (j === "strictEqual" && d(Y) === "object" && d(C) === "object" && Y !== null && C !== null && (j = "strictEqualObject"), S.length === 1 && $.length === 1 && S[0] !== $[0]) {
            var w = S[0].length + $[0].length;
            if (w <= G) {
              if ((d(Y) !== "object" || Y === null) && (d(C) !== "object" || C === null) && (Y !== 0 || C !== 0)) return "".concat(U[j], `

`) + "".concat(S[0], " !== ").concat($[0], `
`);
            } else if (j !== "strictEqualObject") {
              var N = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
              if (w < N) {
                for (; S[0][re] === $[0][re]; ) re++;
                re > 2 && (E = `
  `.concat(P(" ", re), "^"), re = 0);
              }
            }
          }
          for (var W = S[S.length - 1], ee = $[$.length - 1]; W === ee && (re++ < 2 ? se = `
  `.concat(W).concat(se) : J = W, S.pop(), $.pop(), !(S.length === 0 || $.length === 0)); ) W = S[S.length - 1], ee = $[$.length - 1];
          var le = Math.max(S.length, $.length);
          if (le === 0) {
            var ie = F.split(`
`);
            if (ie.length > 30) for (ie[26] = "".concat(M, "...").concat(q); ie.length > 27; ) ie.pop();
            return "".concat(U.notIdentical, `

`).concat(ie.join(`
`), `
`);
          }
          re > 3 && (se = `
`.concat(M, "...").concat(q).concat(se), O = !0), J !== "" && (se = `
  `.concat(J).concat(se), J = "");
          var pe = 0, _e = U[j] + `
`.concat(B, "+ actual").concat(q, " ").concat(z, "- expected").concat(q), Ae = " ".concat(M, "...").concat(q, " Lines skipped");
          for (re = 0; re < le; re++) {
            var Ce = re - ae;
            if (S.length < re + 1) Ce > 1 && re > 2 && (Ce > 4 ? (ne += `
`.concat(M, "...").concat(q), O = !0) : Ce > 3 && (ne += `
  `.concat($[re - 2]), pe++), ne += `
  `.concat($[re - 1]), pe++), ae = re, J += `
`.concat(z, "-").concat(q, " ").concat($[re]), pe++;
            else if ($.length < re + 1) Ce > 1 && re > 2 && (Ce > 4 ? (ne += `
`.concat(M, "...").concat(q), O = !0) : Ce > 3 && (ne += `
  `.concat(S[re - 2]), pe++), ne += `
  `.concat(S[re - 1]), pe++), ae = re, ne += `
`.concat(B, "+").concat(q, " ").concat(S[re]), pe++;
            else {
              var Ue = $[re], Ne = S[re], ke = Ne !== Ue && (!I(Ne, ",") || Ne.slice(0, -1) !== Ue);
              ke && I(Ue, ",") && Ue.slice(0, -1) === Ne && (ke = !1, Ne += ","), ke ? (Ce > 1 && re > 2 && (Ce > 4 ? (ne += `
`.concat(M, "...").concat(q), O = !0) : Ce > 3 && (ne += `
  `.concat(S[re - 2]), pe++), ne += `
  `.concat(S[re - 1]), pe++), ae = re, ne += `
`.concat(B, "+").concat(q, " ").concat(Ne), J += `
`.concat(z, "-").concat(q, " ").concat(Ue), pe += 2) : (ne += J, J = "", (Ce === 1 || re === 0) && (ne += `
  `.concat(Ne), pe++));
            }
            if (pe > 20 && re < le - 2) return "".concat(_e).concat(Ae, `
`).concat(ne, `
`).concat(M, "...").concat(q).concat(J, `
`) + "".concat(M, "...").concat(q);
          }
          return "".concat(_e).concat(O ? Ae : "", `
`).concat(ne).concat(J).concat(se).concat(E);
        }
        var Z = function(Y, C) {
          t(J, Y);
          var j = p(J);
          function J(ne) {
            var ae;
            if (i(this, J), d(ne) !== "object" || ne === null) throw new R("options", "Object", ne);
            var se = ne.message, O = ne.operator, F = ne.stackStartFn, S = ne.actual, $ = ne.expected, re = Error.stackTraceLimit;
            if (Error.stackTraceLimit = 0, se != null) ae = j.call(this, String(se));
            else if (process.stderr && process.stderr.isTTY && (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1 ? (M = "\x1B[34m", B = "\x1B[32m", q = "\x1B[39m", z = "\x1B[31m") : (M = "", B = "", q = "", z = "")), d(S) === "object" && S !== null && d($) === "object" && $ !== null && "stack" in S && S instanceof Error && "stack" in $ && $ instanceof Error && (S = K(S), $ = K($)), O === "deepStrictEqual" || O === "strictEqual") ae = j.call(this, V(S, $, O));
            else if (O === "notDeepStrictEqual" || O === "notStrictEqual") {
              var E = U[O], w = te(S).split(`
`);
              if (O === "notStrictEqual" && d(S) === "object" && S !== null && (E = U.notStrictEqualObject), w.length > 30) for (w[26] = "".concat(M, "...").concat(q); w.length > 27; ) w.pop();
              w.length === 1 ? ae = j.call(this, "".concat(E, " ").concat(w[0])) : ae = j.call(this, "".concat(E, `

`).concat(w.join(`
`), `
`));
            } else {
              var N = te(S), W = "", ee = U[O];
              O === "notDeepEqual" || O === "notEqual" ? (N = "".concat(U[O], `

`).concat(N), N.length > 1024 && (N = "".concat(N.slice(0, 1021), "..."))) : (W = "".concat(te($)), N.length > 512 && (N = "".concat(N.slice(0, 509), "...")), W.length > 512 && (W = "".concat(W.slice(0, 509), "...")), O === "deepEqual" || O === "equal" ? N = "".concat(ee, `

`).concat(N, `

should equal

`) : W = " ".concat(O, " ").concat(W)), ae = j.call(this, "".concat(N).concat(W));
            }
            return Error.stackTraceLimit = re, ae.generatedMessage = !se, Object.defineProperty(f(ae), "name", { value: "AssertionError [ERR_ASSERTION]", enumerable: !1, writable: !0, configurable: !0 }), ae.code = "ERR_ASSERTION", ae.actual = S, ae.expected = $, ae.operator = O, Error.captureStackTrace && Error.captureStackTrace(f(ae), F), ae.stack, ae.name = "AssertionError", l(ae);
          }
          return r(J, [{ key: "toString", value: function() {
            return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
          } }, { key: C, value: function(ne, ae) {
            return _(this, e(e({}, ae), {}, { customInspect: !1, depth: 0 }));
          } }]), J;
        }(v(Error), _.custom);
        k.exports = Z;
      }), lc = xe((L, k) => {
        var n = Object.prototype.toString;
        k.exports = function(e) {
          var a = n.call(e), i = a === "[object Arguments]";
          return i || (i = a !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && n.call(e.callee) === "[object Function]"), i;
        };
      }), f1 = xe((L, k) => {
        var n;
        Object.keys || (e = Object.prototype.hasOwnProperty, a = Object.prototype.toString, i = lc(), o = Object.prototype.propertyIsEnumerable, r = !o.call({ toString: null }, "toString"), s = o.call(function() {
        }, "prototype"), c = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], t = function(v) {
          var g = v.constructor;
          return g && g.prototype === v;
        }, p = { $applicationCache: !0, $console: !0, $external: !0, $frame: !0, $frameElement: !0, $frames: !0, $innerHeight: !0, $innerWidth: !0, $onmozfullscreenchange: !0, $onmozfullscreenerror: !0, $outerHeight: !0, $outerWidth: !0, $pageXOffset: !0, $pageYOffset: !0, $parent: !0, $scrollLeft: !0, $scrollTop: !0, $scrollX: !0, $scrollY: !0, $self: !0, $webkitIndexedDB: !0, $webkitStorageInfo: !0, $window: !0 }, l = function() {
          if (typeof window > "u") return !1;
          for (var v in window) try {
            if (!p["$" + v] && e.call(window, v) && window[v] !== null && typeof window[v] == "object") try {
              t(window[v]);
            } catch {
              return !0;
            }
          } catch {
            return !0;
          }
          return !1;
        }(), f = function(v) {
          if (typeof window > "u" || !l) return t(v);
          try {
            return t(v);
          } catch {
            return !1;
          }
        }, n = function(v) {
          var g = v !== null && typeof v == "object", x = a.call(v) === "[object Function]", h = i(v), m = g && a.call(v) === "[object String]", u = [];
          if (!g && !x && !h) throw new TypeError("Object.keys called on a non-object");
          var d = s && x;
          if (m && v.length > 0 && !e.call(v, 0)) for (var y = 0; y < v.length; ++y) u.push(String(y));
          if (h && v.length > 0) for (var _ = 0; _ < v.length; ++_) u.push(String(_));
          else for (var T in v) !(d && T === "prototype") && e.call(v, T) && u.push(String(T));
          if (r) for (var R = f(v), I = 0; I < c.length; ++I) !(R && c[I] === "constructor") && e.call(v, c[I]) && u.push(c[I]);
          return u;
        });
        var e, a, i, o, r, s, c, t, p, l, f;
        k.exports = n;
      }), sc = xe((L, k) => {
        var n = Array.prototype.slice, e = lc(), a = Object.keys, i = a ? function(r) {
          return a(r);
        } : f1(), o = Object.keys;
        i.shim = function() {
          if (Object.keys) {
            var r = function() {
              var s = Object.keys(arguments);
              return s && s.length === arguments.length;
            }(1, 2);
            r || (Object.keys = function(s) {
              return e(s) ? o(n.call(s)) : o(s);
            });
          } else Object.keys = i;
          return Object.keys || i;
        }, k.exports = i;
      }), d1 = xe((L, k) => {
        var n = sc(), e = dl()(), a = di(), i = Object, o = a("Array.prototype.push"), r = a("Object.prototype.propertyIsEnumerable"), s = e ? Object.getOwnPropertySymbols : null;
        k.exports = function(c, t) {
          if (c == null) throw new TypeError("target must be an object");
          var p = i(c);
          if (arguments.length === 1) return p;
          for (var l = 1; l < arguments.length; ++l) {
            var f = i(arguments[l]), v = n(f), g = e && (Object.getOwnPropertySymbols || s);
            if (g) for (var x = g(f), h = 0; h < x.length; ++h) {
              var m = x[h];
              r(f, m) && o(v, m);
            }
            for (var u = 0; u < v.length; ++u) {
              var d = v[u];
              if (r(f, d)) {
                var y = f[d];
                p[d] = y;
              }
            }
          }
          return p;
        };
      }), p1 = xe((L, k) => {
        var n = d1(), e = function() {
          if (!Object.assign) return !1;
          for (var i = "abcdefghijklmnopqrst", o = i.split(""), r = {}, s = 0; s < o.length; ++s) r[o[s]] = o[s];
          var c = Object.assign({}, r), t = "";
          for (var p in c) t += p;
          return i !== t;
        }, a = function() {
          if (!Object.assign || !Object.preventExtensions) return !1;
          var i = Object.preventExtensions({ 1: 2 });
          try {
            Object.assign(i, "xy");
          } catch {
            return i[1] === "y";
          }
          return !1;
        };
        k.exports = function() {
          return !Object.assign || e() || a() ? n : Object.assign;
        };
      }), uc = xe((L, k) => {
        var n = function(e) {
          return e !== e;
        };
        k.exports = function(e, a) {
          return e === 0 && a === 0 ? 1 / e === 1 / a : !!(e === a || n(e) && n(a));
        };
      }), gl = xe((L, k) => {
        var n = uc();
        k.exports = function() {
          return typeof Object.is == "function" ? Object.is : n;
        };
      }), ji = xe((L, k) => {
        var n = sc(), e = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", a = Object.prototype.toString, i = Array.prototype.concat, o = Object.defineProperty, r = function(l) {
          return typeof l == "function" && a.call(l) === "[object Function]";
        }, s = Wu()(), c = o && s, t = function(l, f, v, g) {
          if (f in l) {
            if (g === !0) {
              if (l[f] === v) return;
            } else if (!r(g) || !g()) return;
          }
          c ? o(l, f, { configurable: !0, enumerable: !1, value: v, writable: !0 }) : l[f] = v;
        }, p = function(l, f) {
          var v = arguments.length > 2 ? arguments[2] : {}, g = n(f);
          e && (g = i.call(g, Object.getOwnPropertySymbols(f)));
          for (var x = 0; x < g.length; x += 1) t(l, g[x], f[g[x]], v[g[x]]);
        };
        p.supportsDescriptors = !!c, k.exports = p;
      }), h1 = xe((L, k) => {
        var n = gl(), e = ji();
        k.exports = function() {
          var a = n();
          return e(Object, { is: a }, { is: function() {
            return Object.is !== a;
          } }), a;
        };
      }), v1 = xe((L, k) => {
        var n = ji(), e = Bi(), a = uc(), i = gl(), o = h1(), r = e(i(), Object);
        n(r, { getPolyfill: i, implementation: a, shim: o }), k.exports = r;
      }), cc = xe((L, k) => {
        k.exports = function(n) {
          return n !== n;
        };
      }), fc = xe((L, k) => {
        var n = cc();
        k.exports = function() {
          return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : n;
        };
      }), g1 = xe((L, k) => {
        var n = ji(), e = fc();
        k.exports = function() {
          var a = e();
          return n(Number, { isNaN: a }, { isNaN: function() {
            return Number.isNaN !== a;
          } }), a;
        };
      }), y1 = xe((L, k) => {
        var n = Bi(), e = ji(), a = cc(), i = fc(), o = g1(), r = n(i(), Number);
        e(r, { getPolyfill: i, implementation: a, shim: o }), k.exports = r;
      }), m1 = xe((L, k) => {
        function n(ke, A) {
          return r(ke) || o(ke, A) || a(ke, A) || e();
        }
        function e() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        function a(ke, A) {
          if (ke) {
            if (typeof ke == "string") return i(ke, A);
            var X = Object.prototype.toString.call(ke).slice(8, -1);
            if (X === "Object" && ke.constructor && (X = ke.constructor.name), X === "Map" || X === "Set") return Array.from(ke);
            if (X === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(X)) return i(ke, A);
          }
        }
        function i(ke, A) {
          (A == null || A > ke.length) && (A = ke.length);
          for (var X = 0, H = new Array(A); X < A; X++) H[X] = ke[X];
          return H;
        }
        function o(ke, A) {
          var X = ke == null ? null : typeof Symbol < "u" && ke[Symbol.iterator] || ke["@@iterator"];
          if (X != null) {
            var H, ve, be, Se, De = [], He = !0, Ze = !1;
            try {
              if (be = (X = X.call(ke)).next, A !== 0) for (; !(He = (H = be.call(X)).done) && (De.push(H.value), De.length !== A); He = !0) ;
            } catch (We) {
              Ze = !0, ve = We;
            } finally {
              try {
                if (!He && X.return != null && (Se = X.return(), Object(Se) !== Se)) return;
              } finally {
                if (Ze) throw ve;
              }
            }
            return De;
          }
        }
        function r(ke) {
          if (Array.isArray(ke)) return ke;
        }
        function s(ke) {
          "@babel/helpers - typeof";
          return s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, s(ke);
        }
        var c = /a/g.flags !== void 0, t = function(ke) {
          var A = [];
          return ke.forEach(function(X) {
            return A.push(X);
          }), A;
        }, p = function(ke) {
          var A = [];
          return ke.forEach(function(X, H) {
            return A.push([H, X]);
          }), A;
        }, l = Object.is ? Object.is : v1(), f = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
          return [];
        }, v = Number.isNaN ? Number.isNaN : y1();
        function g(ke) {
          return ke.call.bind(ke);
        }
        var x = g(Object.prototype.hasOwnProperty), h = g(Object.prototype.propertyIsEnumerable), m = g(Object.prototype.toString), u = pi().types, d = u.isAnyArrayBuffer, y = u.isArrayBufferView, _ = u.isDate, T = u.isMap, R = u.isRegExp, I = u.isSet, P = u.isNativeError, M = u.isBoxedPrimitive, B = u.isNumberObject, z = u.isStringObject, q = u.isBooleanObject, U = u.isBigIntObject, G = u.isSymbolObject, K = u.isFloat32Array, te = u.isFloat64Array;
        function V(ke) {
          if (ke.length === 0 || ke.length > 10) return !0;
          for (var A = 0; A < ke.length; A++) {
            var X = ke.charCodeAt(A);
            if (X < 48 || X > 57) return !0;
          }
          return ke.length === 10 && ke >= Math.pow(2, 32);
        }
        function Z(ke) {
          return Object.keys(ke).filter(V).concat(f(ke).filter(Object.prototype.propertyIsEnumerable.bind(ke)));
        }
        function Y(ke, A) {
          if (ke === A) return 0;
          for (var X = ke.length, H = A.length, ve = 0, be = Math.min(X, H); ve < be; ++ve) if (ke[ve] !== A[ve]) {
            X = ke[ve], H = A[ve];
            break;
          }
          return X < H ? -1 : H < X ? 1 : 0;
        }
        var C = !0, j = !1, J = 0, ne = 1, ae = 2, se = 3;
        function O(ke, A) {
          return c ? ke.source === A.source && ke.flags === A.flags : RegExp.prototype.toString.call(ke) === RegExp.prototype.toString.call(A);
        }
        function F(ke, A) {
          if (ke.byteLength !== A.byteLength) return !1;
          for (var X = 0; X < ke.byteLength; X++) if (ke[X] !== A[X]) return !1;
          return !0;
        }
        function S(ke, A) {
          return ke.byteLength !== A.byteLength ? !1 : Y(new Uint8Array(ke.buffer, ke.byteOffset, ke.byteLength), new Uint8Array(A.buffer, A.byteOffset, A.byteLength)) === 0;
        }
        function $(ke, A) {
          return ke.byteLength === A.byteLength && Y(new Uint8Array(ke), new Uint8Array(A)) === 0;
        }
        function re(ke, A) {
          return B(ke) ? B(A) && l(Number.prototype.valueOf.call(ke), Number.prototype.valueOf.call(A)) : z(ke) ? z(A) && String.prototype.valueOf.call(ke) === String.prototype.valueOf.call(A) : q(ke) ? q(A) && Boolean.prototype.valueOf.call(ke) === Boolean.prototype.valueOf.call(A) : U(ke) ? U(A) && BigInt.prototype.valueOf.call(ke) === BigInt.prototype.valueOf.call(A) : G(A) && Symbol.prototype.valueOf.call(ke) === Symbol.prototype.valueOf.call(A);
        }
        function E(ke, A, X, H) {
          if (ke === A) return ke !== 0 ? !0 : X ? l(ke, A) : !0;
          if (X) {
            if (s(ke) !== "object") return typeof ke == "number" && v(ke) && v(A);
            if (s(A) !== "object" || ke === null || A === null || Object.getPrototypeOf(ke) !== Object.getPrototypeOf(A)) return !1;
          } else {
            if (ke === null || s(ke) !== "object") return A === null || s(A) !== "object" ? ke == A : !1;
            if (A === null || s(A) !== "object") return !1;
          }
          var ve = m(ke), be = m(A);
          if (ve !== be) return !1;
          if (Array.isArray(ke)) {
            if (ke.length !== A.length) return !1;
            var Se = Z(ke), De = Z(A);
            return Se.length !== De.length ? !1 : N(ke, A, X, H, ne, Se);
          }
          if (ve === "[object Object]" && (!T(ke) && T(A) || !I(ke) && I(A))) return !1;
          if (_(ke)) {
            if (!_(A) || Date.prototype.getTime.call(ke) !== Date.prototype.getTime.call(A)) return !1;
          } else if (R(ke)) {
            if (!R(A) || !O(ke, A)) return !1;
          } else if (P(ke) || ke instanceof Error) {
            if (ke.message !== A.message || ke.name !== A.name) return !1;
          } else if (y(ke)) {
            if (!X && (K(ke) || te(ke))) {
              if (!F(ke, A)) return !1;
            } else if (!S(ke, A)) return !1;
            var He = Z(ke), Ze = Z(A);
            return He.length !== Ze.length ? !1 : N(ke, A, X, H, J, He);
          } else {
            if (I(ke)) return !I(A) || ke.size !== A.size ? !1 : N(ke, A, X, H, ae);
            if (T(ke)) return !T(A) || ke.size !== A.size ? !1 : N(ke, A, X, H, se);
            if (d(ke)) {
              if (!$(ke, A)) return !1;
            } else if (M(ke) && !re(ke, A)) return !1;
          }
          return N(ke, A, X, H, J);
        }
        function w(ke, A) {
          return A.filter(function(X) {
            return h(ke, X);
          });
        }
        function N(ke, A, X, H, ve, be) {
          if (arguments.length === 5) {
            be = Object.keys(ke);
            var Se = Object.keys(A);
            if (be.length !== Se.length) return !1;
          }
          for (var De = 0; De < be.length; De++) if (!x(A, be[De])) return !1;
          if (X && arguments.length === 5) {
            var He = f(ke);
            if (He.length !== 0) {
              var Ze = 0;
              for (De = 0; De < He.length; De++) {
                var We = He[De];
                if (h(ke, We)) {
                  if (!h(A, We)) return !1;
                  be.push(We), Ze++;
                } else if (h(A, We)) return !1;
              }
              var $e = f(A);
              if (He.length !== $e.length && w(A, $e).length !== Ze) return !1;
            } else {
              var it = f(A);
              if (it.length !== 0 && w(A, it).length !== 0) return !1;
            }
          }
          if (be.length === 0 && (ve === J || ve === ne && ke.length === 0 || ke.size === 0)) return !0;
          if (H === void 0) H = { val1: /* @__PURE__ */ new Map(), val2: /* @__PURE__ */ new Map(), position: 0 };
          else {
            var Ke = H.val1.get(ke);
            if (Ke !== void 0) {
              var ct = H.val2.get(A);
              if (ct !== void 0) return Ke === ct;
            }
            H.position++;
          }
          H.val1.set(ke, H.position), H.val2.set(A, H.position);
          var gt = Ce(ke, A, X, be, H, ve);
          return H.val1.delete(ke), H.val2.delete(A), gt;
        }
        function W(ke, A, X, H) {
          for (var ve = t(ke), be = 0; be < ve.length; be++) {
            var Se = ve[be];
            if (E(A, Se, X, H)) return ke.delete(Se), !0;
          }
          return !1;
        }
        function ee(ke) {
          switch (s(ke)) {
            case "undefined":
              return null;
            case "object":
              return;
            case "symbol":
              return !1;
            case "string":
              ke = +ke;
            case "number":
              if (v(ke)) return !1;
          }
          return !0;
        }
        function le(ke, A, X) {
          var H = ee(X);
          return H ?? (A.has(H) && !ke.has(H));
        }
        function ie(ke, A, X, H, ve) {
          var be = ee(X);
          if (be != null) return be;
          var Se = A.get(be);
          return Se === void 0 && !A.has(be) || !E(H, Se, !1, ve) ? !1 : !ke.has(be) && E(H, Se, !1, ve);
        }
        function pe(ke, A, X, H) {
          for (var ve = null, be = t(ke), Se = 0; Se < be.length; Se++) {
            var De = be[Se];
            if (s(De) === "object" && De !== null) ve === null && (ve = /* @__PURE__ */ new Set()), ve.add(De);
            else if (!A.has(De)) {
              if (X || !le(ke, A, De)) return !1;
              ve === null && (ve = /* @__PURE__ */ new Set()), ve.add(De);
            }
          }
          if (ve !== null) {
            for (var He = t(A), Ze = 0; Ze < He.length; Ze++) {
              var We = He[Ze];
              if (s(We) === "object" && We !== null) {
                if (!W(ve, We, X, H)) return !1;
              } else if (!X && !ke.has(We) && !W(ve, We, X, H)) return !1;
            }
            return ve.size === 0;
          }
          return !0;
        }
        function _e(ke, A, X, H, ve, be) {
          for (var Se = t(ke), De = 0; De < Se.length; De++) {
            var He = Se[De];
            if (E(X, He, ve, be) && E(H, A.get(He), ve, be)) return ke.delete(He), !0;
          }
          return !1;
        }
        function Ae(ke, A, X, H) {
          for (var ve = null, be = p(ke), Se = 0; Se < be.length; Se++) {
            var De = n(be[Se], 2), He = De[0], Ze = De[1];
            if (s(He) === "object" && He !== null) ve === null && (ve = /* @__PURE__ */ new Set()), ve.add(He);
            else {
              var We = A.get(He);
              if (We === void 0 && !A.has(He) || !E(Ze, We, X, H)) {
                if (X || !ie(ke, A, He, Ze, H)) return !1;
                ve === null && (ve = /* @__PURE__ */ new Set()), ve.add(He);
              }
            }
          }
          if (ve !== null) {
            for (var $e = p(A), it = 0; it < $e.length; it++) {
              var Ke = n($e[it], 2), ct = Ke[0], gt = Ke[1];
              if (s(ct) === "object" && ct !== null) {
                if (!_e(ve, ke, ct, gt, X, H)) return !1;
              } else if (!X && (!ke.has(ct) || !E(ke.get(ct), gt, !1, H)) && !_e(ve, ke, ct, gt, !1, H)) return !1;
            }
            return ve.size === 0;
          }
          return !0;
        }
        function Ce(ke, A, X, H, ve, be) {
          var Se = 0;
          if (be === ae) {
            if (!pe(ke, A, X, ve)) return !1;
          } else if (be === se) {
            if (!Ae(ke, A, X, ve)) return !1;
          } else if (be === ne) for (; Se < ke.length; Se++) if (x(ke, Se)) {
            if (!x(A, Se) || !E(ke[Se], A[Se], X, ve)) return !1;
          } else {
            if (x(A, Se)) return !1;
            for (var De = Object.keys(ke); Se < De.length; Se++) {
              var He = De[Se];
              if (!x(A, He) || !E(ke[He], A[He], X, ve)) return !1;
            }
            return De.length === Object.keys(A).length;
          }
          for (Se = 0; Se < H.length; Se++) {
            var Ze = H[Se];
            if (!E(ke[Ze], A[Ze], X, ve)) return !1;
          }
          return !0;
        }
        function Ue(ke, A) {
          return E(ke, A, j);
        }
        function Ne(ke, A) {
          return E(ke, A, C);
        }
        k.exports = { isDeepEqual: Ue, isDeepStrictEqual: Ne };
      }), yl = xe((L, k) => {
        function n(ae) {
          "@babel/helpers - typeof";
          return n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(se) {
            return typeof se;
          } : function(se) {
            return se && typeof Symbol == "function" && se.constructor === Symbol && se !== Symbol.prototype ? "symbol" : typeof se;
          }, n(ae);
        }
        function e(ae, se, O) {
          return Object.defineProperty(ae, "prototype", { writable: !1 }), ae;
        }
        function a(ae, se) {
          if (!(ae instanceof se)) throw new TypeError("Cannot call a class as a function");
        }
        var i = oc(), o = i.codes, r = o.ERR_AMBIGUOUS_ARGUMENT, s = o.ERR_INVALID_ARG_TYPE, c = o.ERR_INVALID_ARG_VALUE, t = o.ERR_INVALID_RETURN_VALUE, p = o.ERR_MISSING_ARGS, l = c1(), f = pi(), v = f.inspect, g = pi().types, x = g.isPromise, h = g.isRegExp, m = p1()(), u = gl()(), d = di()("RegExp.prototype.test"), y, _;
        function T() {
          var ae = m1();
          y = ae.isDeepEqual, _ = ae.isDeepStrictEqual;
        }
        var R = !1, I = k.exports = q, P = {};
        function M(ae) {
          throw ae.message instanceof Error ? ae.message : new l(ae);
        }
        function B(ae, se, O, F, S) {
          var $ = arguments.length, re;
          if ($ === 0) re = "Failed";
          else if ($ === 1) O = ae, ae = void 0;
          else {
            if (R === !1) {
              R = !0;
              var E = process.emitWarning ? process.emitWarning : console.warn.bind(console);
              E("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
            }
            $ === 2 && (F = "!=");
          }
          if (O instanceof Error) throw O;
          var w = { actual: ae, expected: se, operator: F === void 0 ? "fail" : F, stackStartFn: S || B };
          O !== void 0 && (w.message = O);
          var N = new l(w);
          throw re && (N.message = re, N.generatedMessage = !0), N;
        }
        I.fail = B, I.AssertionError = l;
        function z(ae, se, O, F) {
          if (!O) {
            var S = !1;
            if (se === 0) S = !0, F = "No value argument passed to `assert.ok()`";
            else if (F instanceof Error) throw F;
            var $ = new l({ actual: O, expected: !0, message: F, operator: "==", stackStartFn: ae });
            throw $.generatedMessage = S, $;
          }
        }
        function q() {
          for (var ae = arguments.length, se = new Array(ae), O = 0; O < ae; O++) se[O] = arguments[O];
          z.apply(void 0, [q, se.length].concat(se));
        }
        I.ok = q, I.equal = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          se != O && M({ actual: se, expected: O, message: F, operator: "==", stackStartFn: ae });
        }, I.notEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          se == O && M({ actual: se, expected: O, message: F, operator: "!=", stackStartFn: ae });
        }, I.deepEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          y === void 0 && T(), y(se, O) || M({ actual: se, expected: O, message: F, operator: "deepEqual", stackStartFn: ae });
        }, I.notDeepEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          y === void 0 && T(), y(se, O) && M({ actual: se, expected: O, message: F, operator: "notDeepEqual", stackStartFn: ae });
        }, I.deepStrictEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          y === void 0 && T(), _(se, O) || M({ actual: se, expected: O, message: F, operator: "deepStrictEqual", stackStartFn: ae });
        }, I.notDeepStrictEqual = U;
        function U(ae, se, O) {
          if (arguments.length < 2) throw new p("actual", "expected");
          y === void 0 && T(), _(ae, se) && M({ actual: ae, expected: se, message: O, operator: "notDeepStrictEqual", stackStartFn: U });
        }
        I.strictEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          u(se, O) || M({ actual: se, expected: O, message: F, operator: "strictEqual", stackStartFn: ae });
        }, I.notStrictEqual = function ae(se, O, F) {
          if (arguments.length < 2) throw new p("actual", "expected");
          u(se, O) && M({ actual: se, expected: O, message: F, operator: "notStrictEqual", stackStartFn: ae });
        };
        var G = e(function ae(se, O, F) {
          var S = this;
          a(this, ae), O.forEach(function($) {
            $ in se && (F !== void 0 && typeof F[$] == "string" && h(se[$]) && d(se[$], F[$]) ? S[$] = F[$] : S[$] = se[$]);
          });
        });
        function K(ae, se, O, F, S, $) {
          if (!(O in ae) || !_(ae[O], se[O])) {
            if (!F) {
              var re = new G(ae, S), E = new G(se, S, ae), w = new l({ actual: re, expected: E, operator: "deepStrictEqual", stackStartFn: $ });
              throw w.actual = ae, w.expected = se, w.operator = $.name, w;
            }
            M({ actual: ae, expected: se, message: F, operator: $.name, stackStartFn: $ });
          }
        }
        function te(ae, se, O, F) {
          if (typeof se != "function") {
            if (h(se)) return d(se, ae);
            if (arguments.length === 2) throw new s("expected", ["Function", "RegExp"], se);
            if (n(ae) !== "object" || ae === null) {
              var S = new l({ actual: ae, expected: se, message: O, operator: "deepStrictEqual", stackStartFn: F });
              throw S.operator = F.name, S;
            }
            var $ = Object.keys(se);
            if (se instanceof Error) $.push("name", "message");
            else if ($.length === 0) throw new c("error", se, "may not be an empty object");
            return y === void 0 && T(), $.forEach(function(re) {
              typeof ae[re] == "string" && h(se[re]) && d(se[re], ae[re]) || K(ae, se, re, O, $, F);
            }), !0;
          }
          return se.prototype !== void 0 && ae instanceof se ? !0 : Error.isPrototypeOf(se) ? !1 : se.call({}, ae) === !0;
        }
        function V(ae) {
          if (typeof ae != "function") throw new s("fn", "Function", ae);
          try {
            ae();
          } catch (se) {
            return se;
          }
          return P;
        }
        function Z(ae) {
          return x(ae) || ae !== null && n(ae) === "object" && typeof ae.then == "function" && typeof ae.catch == "function";
        }
        function Y(ae) {
          return Promise.resolve().then(function() {
            var se;
            if (typeof ae == "function") {
              if (se = ae(), !Z(se)) throw new t("instance of Promise", "promiseFn", se);
            } else if (Z(ae)) se = ae;
            else throw new s("promiseFn", ["Function", "Promise"], ae);
            return Promise.resolve().then(function() {
              return se;
            }).then(function() {
              return P;
            }).catch(function(O) {
              return O;
            });
          });
        }
        function C(ae, se, O, F) {
          if (typeof O == "string") {
            if (arguments.length === 4) throw new s("error", ["Object", "Error", "Function", "RegExp"], O);
            if (n(se) === "object" && se !== null) {
              if (se.message === O) throw new r("error/message", 'The error message "'.concat(se.message, '" is identical to the message.'));
            } else if (se === O) throw new r("error/message", 'The error "'.concat(se, '" is identical to the message.'));
            F = O, O = void 0;
          } else if (O != null && n(O) !== "object" && typeof O != "function") throw new s("error", ["Object", "Error", "Function", "RegExp"], O);
          if (se === P) {
            var S = "";
            O && O.name && (S += " (".concat(O.name, ")")), S += F ? ": ".concat(F) : ".";
            var $ = ae.name === "rejects" ? "rejection" : "exception";
            M({ actual: void 0, expected: O, operator: ae.name, message: "Missing expected ".concat($).concat(S), stackStartFn: ae });
          }
          if (O && !te(se, O, F, ae)) throw se;
        }
        function j(ae, se, O, F) {
          if (se !== P) {
            if (typeof O == "string" && (F = O, O = void 0), !O || te(se, O)) {
              var S = F ? ": ".concat(F) : ".", $ = ae.name === "doesNotReject" ? "rejection" : "exception";
              M({ actual: se, expected: O, operator: ae.name, message: "Got unwanted ".concat($).concat(S, `
`) + 'Actual message: "'.concat(se && se.message, '"'), stackStartFn: ae });
            }
            throw se;
          }
        }
        I.throws = function ae(se) {
          for (var O = arguments.length, F = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++) F[S - 1] = arguments[S];
          C.apply(void 0, [ae, V(se)].concat(F));
        }, I.rejects = function ae(se) {
          for (var O = arguments.length, F = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++) F[S - 1] = arguments[S];
          return Y(se).then(function($) {
            return C.apply(void 0, [ae, $].concat(F));
          });
        }, I.doesNotThrow = function ae(se) {
          for (var O = arguments.length, F = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++) F[S - 1] = arguments[S];
          j.apply(void 0, [ae, V(se)].concat(F));
        }, I.doesNotReject = function ae(se) {
          for (var O = arguments.length, F = new Array(O > 1 ? O - 1 : 0), S = 1; S < O; S++) F[S - 1] = arguments[S];
          return Y(se).then(function($) {
            return j.apply(void 0, [ae, $].concat(F));
          });
        }, I.ifError = function ae(se) {
          if (se != null) {
            var O = "ifError got unwanted exception: ";
            n(se) === "object" && typeof se.message == "string" ? se.message.length === 0 && se.constructor ? O += se.constructor.name : O += se.message : O += v(se);
            var F = new l({ actual: se, expected: null, operator: "ifError", message: O, stackStartFn: ae }), S = se.stack;
            if (typeof S == "string") {
              var $ = S.split(`
`);
              $.shift();
              for (var re = F.stack.split(`
`), E = 0; E < $.length; E++) {
                var w = re.indexOf($[E]);
                if (w !== -1) {
                  re = re.slice(0, w);
                  break;
                }
              }
              F.stack = "".concat(re.join(`
`), `
`).concat($.join(`
`));
            }
            throw F;
          }
        };
        function J(ae, se, O, F, S) {
          if (!h(se)) throw new s("regexp", "RegExp", se);
          var $ = S === "match";
          if (typeof ae != "string" || d(se, ae) !== $) {
            if (O instanceof Error) throw O;
            var re = !O;
            O = O || (typeof ae != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(n(ae), " (").concat(v(ae), ")") : ($ ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(v(se), `. Input:

`).concat(v(ae), `
`));
            var E = new l({ actual: ae, expected: se, message: O, operator: S, stackStartFn: F });
            throw E.generatedMessage = re, E;
          }
        }
        I.match = function ae(se, O, F) {
          J(se, O, F, ae, "match");
        }, I.doesNotMatch = function ae(se, O, F) {
          J(se, O, F, ae, "doesNotMatch");
        };
        function ne() {
          for (var ae = arguments.length, se = new Array(ae), O = 0; O < ae; O++) se[O] = arguments[O];
          z.apply(void 0, [ne, se.length].concat(se));
        }
        I.strict = m(ne, I, { equal: I.strictEqual, deepEqual: I.deepStrictEqual, notEqual: I.notStrictEqual, notDeepEqual: I.notDeepStrictEqual }), I.strict.strict = I.strict;
      }), x1 = xe((L, k) => {
        var n = 1e3, e = n * 60, a = e * 60, i = a * 24, o = i * 365.25;
        k.exports = function(p, l) {
          l = l || {};
          var f = typeof p;
          if (f === "string" && p.length > 0) return r(p);
          if (f === "number" && isNaN(p) === !1) return l.long ? c(p) : s(p);
          throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(p));
        };
        function r(p) {
          if (p = String(p), !(p.length > 100)) {
            var l = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(p);
            if (l) {
              var f = parseFloat(l[1]), v = (l[2] || "ms").toLowerCase();
              switch (v) {
                case "years":
                case "year":
                case "yrs":
                case "yr":
                case "y":
                  return f * o;
                case "days":
                case "day":
                case "d":
                  return f * i;
                case "hours":
                case "hour":
                case "hrs":
                case "hr":
                case "h":
                  return f * a;
                case "minutes":
                case "minute":
                case "mins":
                case "min":
                case "m":
                  return f * e;
                case "seconds":
                case "second":
                case "secs":
                case "sec":
                case "s":
                  return f * n;
                case "milliseconds":
                case "millisecond":
                case "msecs":
                case "msec":
                case "ms":
                  return f;
                default:
                  return;
              }
            }
          }
        }
        function s(p) {
          return p >= i ? Math.round(p / i) + "d" : p >= a ? Math.round(p / a) + "h" : p >= e ? Math.round(p / e) + "m" : p >= n ? Math.round(p / n) + "s" : p + "ms";
        }
        function c(p) {
          return t(p, i, "day") || t(p, a, "hour") || t(p, e, "minute") || t(p, n, "second") || p + " ms";
        }
        function t(p, l, f) {
          if (!(p < l)) return p < l * 1.5 ? Math.floor(p / l) + " " + f : Math.ceil(p / l) + " " + f + "s";
        }
      }), b1 = xe((L, k) => {
        L = k.exports = a.debug = a.default = a, L.coerce = s, L.disable = o, L.enable = i, L.enabled = r, L.humanize = x1(), L.names = [], L.skips = [], L.formatters = {};
        var n;
        function e(c) {
          var t = 0, p;
          for (p in c) t = (t << 5) - t + c.charCodeAt(p), t |= 0;
          return L.colors[Math.abs(t) % L.colors.length];
        }
        function a(c) {
          function t() {
            if (t.enabled) {
              var p = t, l = +/* @__PURE__ */ new Date(), f = l - (n || l);
              p.diff = f, p.prev = n, p.curr = l, n = l;
              for (var v = new Array(arguments.length), g = 0; g < v.length; g++) v[g] = arguments[g];
              v[0] = L.coerce(v[0]), typeof v[0] != "string" && v.unshift("%O");
              var x = 0;
              v[0] = v[0].replace(/%([a-zA-Z%])/g, function(m, u) {
                if (m === "%%") return m;
                x++;
                var d = L.formatters[u];
                if (typeof d == "function") {
                  var y = v[x];
                  m = d.call(p, y), v.splice(x, 1), x--;
                }
                return m;
              }), L.formatArgs.call(p, v);
              var h = t.log || L.log || console.log.bind(console);
              h.apply(p, v);
            }
          }
          return t.namespace = c, t.enabled = L.enabled(c), t.useColors = L.useColors(), t.color = e(c), typeof L.init == "function" && L.init(t), t;
        }
        function i(c) {
          L.save(c), L.names = [], L.skips = [];
          for (var t = (typeof c == "string" ? c : "").split(/[\s,]+/), p = t.length, l = 0; l < p; l++) t[l] && (c = t[l].replace(/\*/g, ".*?"), c[0] === "-" ? L.skips.push(new RegExp("^" + c.substr(1) + "$")) : L.names.push(new RegExp("^" + c + "$")));
        }
        function o() {
          L.enable("");
        }
        function r(c) {
          var t, p;
          for (t = 0, p = L.skips.length; t < p; t++) if (L.skips[t].test(c)) return !1;
          for (t = 0, p = L.names.length; t < p; t++) if (L.names[t].test(c)) return !0;
          return !1;
        }
        function s(c) {
          return c instanceof Error ? c.stack || c.message : c;
        }
      }), _1 = xe((L, k) => {
        L = k.exports = b1(), L.log = a, L.formatArgs = e, L.save = i, L.load = o, L.useColors = n, L.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : r(), L.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"];
        function n() {
          return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
        }
        L.formatters.j = function(s) {
          try {
            return JSON.stringify(s);
          } catch (c) {
            return "[UnexpectedJSONParseError]: " + c.message;
          }
        };
        function e(s) {
          var c = this.useColors;
          if (s[0] = (c ? "%c" : "") + this.namespace + (c ? " %c" : " ") + s[0] + (c ? "%c " : " ") + "+" + L.humanize(this.diff), !!c) {
            var t = "color: " + this.color;
            s.splice(1, 0, t, "color: inherit");
            var p = 0, l = 0;
            s[0].replace(/%[a-zA-Z%]/g, function(f) {
              f !== "%%" && (p++, f === "%c" && (l = p));
            }), s.splice(l, 0, t);
          }
        }
        function a() {
          return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
        }
        function i(s) {
          try {
            s == null ? L.storage.removeItem("debug") : L.storage.debug = s;
          } catch {
          }
        }
        function o() {
          var s;
          try {
            s = L.storage.debug;
          } catch {
          }
          return !s && typeof process < "u" && "env" in process && (s = process.env.DEBUG), s;
        }
        L.enable(o());
        function r() {
          try {
            return window.localStorage;
          } catch {
          }
        }
      }), w1 = xe((L, k) => {
        var n = yl(), e = _1()("stream-parser");
        k.exports = s;
        var a = -1, i = 0, o = 1, r = 2;
        function s(u) {
          var d = u && typeof u._transform == "function", y = u && typeof u._write == "function";
          if (!d && !y) throw new Error("must pass a Writable or Transform stream in");
          e("extending Parser into stream"), u._bytes = t, u._skipBytes = p, d && (u._passthrough = l), d ? u._transform = v : u._write = f;
        }
        function c(u) {
          e("initializing parser stream"), u._parserBytesLeft = 0, u._parserBuffers = [], u._parserBuffered = 0, u._parserState = a, u._parserCallback = null, typeof u.push == "function" && (u._parserOutput = u.push.bind(u)), u._parserInit = !0;
        }
        function t(u, d) {
          n(!this._parserCallback, 'there is already a "callback" set!'), n(isFinite(u) && u > 0, 'can only buffer a finite number of bytes > 0, got "' + u + '"'), this._parserInit || c(this), e("buffering %o bytes", u), this._parserBytesLeft = u, this._parserCallback = d, this._parserState = i;
        }
        function p(u, d) {
          n(!this._parserCallback, 'there is already a "callback" set!'), n(u > 0, 'can only skip > 0 bytes, got "' + u + '"'), this._parserInit || c(this), e("skipping %o bytes", u), this._parserBytesLeft = u, this._parserCallback = d, this._parserState = o;
        }
        function l(u, d) {
          n(!this._parserCallback, 'There is already a "callback" set!'), n(u > 0, 'can only pass through > 0 bytes, got "' + u + '"'), this._parserInit || c(this), e("passing through %o bytes", u), this._parserBytesLeft = u, this._parserCallback = d, this._parserState = r;
        }
        function f(u, d, y) {
          this._parserInit || c(this), e("write(%o bytes)", u.length), typeof d == "function" && (y = d), h(this, u, null, y);
        }
        function v(u, d, y) {
          this._parserInit || c(this), e("transform(%o bytes)", u.length), typeof d != "function" && (d = this._parserOutput), h(this, u, d, y);
        }
        function g(u, d, y, _) {
          return u._parserBytesLeft <= 0 ? _(new Error("got data but not currently parsing anything")) : d.length <= u._parserBytesLeft ? function() {
            return x(u, d, y, _);
          } : function() {
            var T = d.slice(0, u._parserBytesLeft);
            return x(u, T, y, function(R) {
              if (R) return _(R);
              if (d.length > T.length) return function() {
                return g(u, d.slice(T.length), y, _);
              };
            });
          };
        }
        function x(u, d, y, _) {
          if (u._parserBytesLeft -= d.length, e("%o bytes left for stream piece", u._parserBytesLeft), u._parserState === i ? (u._parserBuffers.push(d), u._parserBuffered += d.length) : u._parserState === r && y(d), u._parserBytesLeft === 0) {
            var T = u._parserCallback;
            if (T && u._parserState === i && u._parserBuffers.length > 1 && (d = Buffer.concat(u._parserBuffers, u._parserBuffered)), u._parserState !== i && (d = null), u._parserCallback = null, u._parserBuffered = 0, u._parserState = a, u._parserBuffers.splice(0), T) {
              var R = [];
              d && R.push(d), y && R.push(y);
              var I = T.length > R.length;
              I && R.push(m(_));
              var P = T.apply(u, R);
              if (!I || _ === P) return _;
            }
          } else return _;
        }
        var h = m(g);
        function m(u) {
          return function() {
            for (var d = u.apply(this, arguments); typeof d == "function"; ) d = d();
            return d;
          };
        }
      }), jr = xe((L) => {
        var k = u1().Transform, n = w1();
        function e() {
          k.call(this, { readableObjectMode: !0 });
        }
        e.prototype = Object.create(k.prototype), e.prototype.constructor = e, n(e.prototype), L.ParserStream = e, L.sliceEq = function(i, o, r) {
          for (var s = o, c = 0; c < r.length; ) if (i[s++] !== r[c++]) return !1;
          return !0;
        }, L.str2arr = function(i, o) {
          var r = [], s = 0;
          if (o && o === "hex") for (; s < i.length; ) r.push(parseInt(i.slice(s, s + 2), 16)), s += 2;
          else for (; s < i.length; s++) r.push(i.charCodeAt(s) & 255);
          return r;
        }, L.readUInt16LE = function(i, o) {
          return i[o] | i[o + 1] << 8;
        }, L.readUInt16BE = function(i, o) {
          return i[o + 1] | i[o] << 8;
        }, L.readUInt32LE = function(i, o) {
          return i[o] | i[o + 1] << 8 | i[o + 2] << 16 | i[o + 3] * 16777216;
        }, L.readUInt32BE = function(i, o) {
          return i[o + 3] | i[o + 2] << 8 | i[o + 1] << 16 | i[o] * 16777216;
        };
        function a(i, o, r) {
          Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "", this.name = this.constructor.name, this.message = i, o && (this.code = o), r && (this.statusCode = r);
        }
        a.prototype = Object.create(Error.prototype), a.prototype.constructor = a, L.ProbeError = a;
      }), T1 = xe((L, k) => {
        var n = jr().readUInt16BE, e = jr().readUInt32BE;
        function a(l, f) {
          if (l.length < 4 + f) return null;
          var v = e(l, f);
          return l.length < v + f || v < 8 ? null : { boxtype: String.fromCharCode.apply(null, l.slice(f + 4, f + 8)), data: l.slice(f + 8, f + v), end: f + v };
        }
        k.exports.unbox = a;
        function i(l, f) {
          for (var v = 0; ; ) {
            var g = a(l, v);
            if (!g) break;
            switch (g.boxtype) {
              case "ispe":
                f.sizes.push({ width: e(g.data, 4), height: e(g.data, 8) });
                break;
              case "irot":
                f.transforms.push({ type: "irot", value: g.data[0] & 3 });
                break;
              case "imir":
                f.transforms.push({ type: "imir", value: g.data[0] & 1 });
                break;
            }
            v = g.end;
          }
        }
        function o(l, f, v) {
          for (var g = 0, x = 0; x < v; x++) g = g * 256 + (l[f + x] || 0);
          return g;
        }
        function r(l, f) {
          for (var v = l[4] >> 4 & 15, g = l[4] & 15, x = l[5] >> 4 & 15, h = n(l, 6), m = 8, u = 0; u < h; u++) {
            var d = n(l, m);
            m += 2;
            var y = n(l, m);
            m += 2;
            var _ = o(l, m, x);
            m += x;
            var T = n(l, m);
            if (m += 2, y === 0 && T === 1) {
              var R = o(l, m, v), I = o(l, m + v, g);
              f.item_loc[d] = { length: I, offset: R + _ };
            }
            m += T * (v + g);
          }
        }
        function s(l, f) {
          for (var v = n(l, 4), g = 6, x = 0; x < v; x++) {
            var h = a(l, g);
            if (!h) break;
            if (h.boxtype === "infe") {
              for (var m = n(h.data, 4), u = "", d = 8; d < h.data.length && h.data[d]; d++) u += String.fromCharCode(h.data[d]);
              f.item_inf[u] = m;
            }
            g = h.end;
          }
        }
        function c(l, f) {
          for (var v = 0; ; ) {
            var g = a(l, v);
            if (!g) break;
            g.boxtype === "ipco" && i(g.data, f), v = g.end;
          }
        }
        function t(l, f) {
          for (var v = 4; ; ) {
            var g = a(l, v);
            if (!g) break;
            g.boxtype === "iprp" && c(g.data, f), g.boxtype === "iloc" && r(g.data, f), g.boxtype === "iinf" && s(g.data, f), v = g.end;
          }
        }
        function p(l) {
          var f = l.reduce(function(x, h) {
            return x.width > h.width || x.width === h.width && x.height > h.height ? x : h;
          }), v = l.reduce(function(x, h) {
            return x.height > h.height || x.height === h.height && x.width > h.width ? x : h;
          }), g;
          return f.width > v.height || f.width === v.height && f.height > v.width ? g = f : g = v, g;
        }
        k.exports.readSizeFromMeta = function(l) {
          var f = { sizes: [], transforms: [], item_inf: {}, item_loc: {} };
          if (t(l, f), !!f.sizes.length) {
            var v = p(f.sizes), g = 1;
            f.transforms.forEach(function(h) {
              var m = { 1: 6, 2: 5, 3: 8, 4: 7, 5: 4, 6: 3, 7: 2, 8: 1 }, u = { 1: 4, 2: 3, 3: 2, 4: 1, 5: 6, 6: 5, 7: 8, 8: 7 };
              if (h.type === "imir" && (h.value === 0 ? g = u[g] : (g = u[g], g = m[g], g = m[g])), h.type === "irot") for (var d = 0; d < h.value; d++) g = m[g];
            });
            var x = null;
            return f.item_inf.Exif && (x = f.item_loc[f.item_inf.Exif]), { width: v.width, height: v.height, orientation: f.transforms.length ? g : null, variants: f.sizes, exif_location: x };
          }
        }, k.exports.getMimeType = function(l) {
          var f = String.fromCharCode.apply(null, l.slice(0, 4)), v = {};
          v[f] = !0;
          for (var g = 8; g < l.length; g += 4) v[String.fromCharCode.apply(null, l.slice(g, g + 4))] = !0;
          if (!(!v.mif1 && !v.msf1 && !v.miaf)) return f === "avif" || f === "avis" || f === "avio" ? { type: "avif", mime: "image/avif" } : f === "heic" || f === "heix" ? { type: "heic", mime: "image/heic" } : f === "hevc" || f === "hevx" ? { type: "heic", mime: "image/heic-sequence" } : v.avif || v.avis ? { type: "avif", mime: "image/avif" } : v.heic || v.heix || v.hevc || v.hevx || v.heis ? v.msf1 ? { type: "heif", mime: "image/heif-sequence" } : { type: "heif", mime: "image/heif" } : { type: "avif", mime: "image/avif" };
        };
      }), ml = xe((L, k) => {
        function n(i, o) {
          var r = new Error(i);
          return r.code = o, r;
        }
        function e(i) {
          try {
            return decodeURIComponent(escape(i));
          } catch {
            return i;
          }
        }
        function a(i, o, r) {
          this.input = i.subarray(o, r), this.start = o;
          var s = String.fromCharCode.apply(null, this.input.subarray(0, 4));
          if (s !== "II*\0" && s !== "MM\0*") throw n("invalid TIFF signature", "EBADDATA");
          this.big_endian = s[0] === "M";
        }
        a.prototype.each = function(i) {
          this.aborted = !1;
          var o = this.read_uint32(4);
          for (this.ifds_to_read = [{ id: 0, offset: o }]; this.ifds_to_read.length > 0 && !this.aborted; ) {
            var r = this.ifds_to_read.shift();
            r.offset && this.scan_ifd(r.id, r.offset, i);
          }
        }, a.prototype.read_uint16 = function(i) {
          var o = this.input;
          if (i + 2 > o.length) throw n("unexpected EOF", "EBADDATA");
          return this.big_endian ? o[i] * 256 + o[i + 1] : o[i] + o[i + 1] * 256;
        }, a.prototype.read_uint32 = function(i) {
          var o = this.input;
          if (i + 4 > o.length) throw n("unexpected EOF", "EBADDATA");
          return this.big_endian ? o[i] * 16777216 + o[i + 1] * 65536 + o[i + 2] * 256 + o[i + 3] : o[i] + o[i + 1] * 256 + o[i + 2] * 65536 + o[i + 3] * 16777216;
        }, a.prototype.is_subifd_link = function(i, o) {
          return i === 0 && o === 34665 || i === 0 && o === 34853 || i === 34665 && o === 40965;
        }, a.prototype.exif_format_length = function(i) {
          switch (i) {
            case 1:
            case 2:
            case 6:
            case 7:
              return 1;
            case 3:
            case 8:
              return 2;
            case 4:
            case 9:
            case 11:
              return 4;
            case 5:
            case 10:
            case 12:
              return 8;
            default:
              return 0;
          }
        }, a.prototype.exif_format_read = function(i, o) {
          var r;
          switch (i) {
            case 1:
            case 2:
              return r = this.input[o], r;
            case 6:
              return r = this.input[o], r | (r & 128) * 33554430;
            case 3:
              return r = this.read_uint16(o), r;
            case 8:
              return r = this.read_uint16(o), r | (r & 32768) * 131070;
            case 4:
              return r = this.read_uint32(o), r;
            case 9:
              return r = this.read_uint32(o), r | 0;
            case 5:
            case 10:
            case 11:
            case 12:
              return null;
            case 7:
              return null;
            default:
              return null;
          }
        }, a.prototype.scan_ifd = function(i, o, r) {
          var s = this.read_uint16(o);
          o += 2;
          for (var c = 0; c < s; c++) {
            var t = this.read_uint16(o), p = this.read_uint16(o + 2), l = this.read_uint32(o + 4), f = this.exif_format_length(p), v = l * f, g = v <= 4 ? o + 8 : this.read_uint32(o + 8), x = !1;
            if (g + v > this.input.length) throw n("unexpected EOF", "EBADDATA");
            for (var h = [], m = g, u = 0; u < l; u++, m += f) {
              var d = this.exif_format_read(p, m);
              if (d === null) {
                h = null;
                break;
              }
              h.push(d);
            }
            Array.isArray(h) && p === 2 && (h = e(String.fromCharCode.apply(null, h)), h && h[h.length - 1] === "\0" && (h = h.slice(0, -1))), this.is_subifd_link(i, t) && Array.isArray(h) && Number.isInteger(h[0]) && h[0] > 0 && (this.ifds_to_read.push({ id: t, offset: h[0] }), x = !0);
            var y = { is_big_endian: this.big_endian, ifd: i, tag: t, format: p, count: l, entry_offset: o + this.start, data_length: v, data_offset: g + this.start, value: h, is_subifd_link: x };
            if (r(y) === !1) {
              this.aborted = !0;
              return;
            }
            o += 12;
          }
          i === 0 && this.ifds_to_read.push({ id: 1, offset: this.read_uint32(o) });
        }, k.exports.ExifParser = a, k.exports.get_orientation = function(i) {
          var o = 0;
          try {
            return new a(i, 0, i.length).each(function(r) {
              if (r.ifd === 0 && r.tag === 274 && Array.isArray(r.value)) return o = r.value[0], !1;
            }), o;
          } catch {
            return -1;
          }
        };
      }), k1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt32BE, i = T1(), o = ml(), r = n("ftyp");
        k.exports = function(s) {
          if (e(s, 4, r)) {
            var c = i.unbox(s, 0);
            if (c) {
              var t = i.getMimeType(c.data);
              if (t) {
                for (var p, l = c.end; ; ) {
                  var f = i.unbox(s, l);
                  if (!f) break;
                  if (l = f.end, f.boxtype === "mdat") return;
                  if (f.boxtype === "meta") {
                    p = f.data;
                    break;
                  }
                }
                if (p) {
                  var v = i.readSizeFromMeta(p);
                  if (v) {
                    var g = { width: v.width, height: v.height, type: t.type, mime: t.mime, wUnits: "px", hUnits: "px" };
                    if (v.variants.length > 1 && (g.variants = v.variants), v.orientation && (g.orientation = v.orientation), v.exif_location && v.exif_location.offset + v.exif_location.length <= s.length) {
                      var x = a(s, v.exif_location.offset), h = s.slice(v.exif_location.offset + x + 4, v.exif_location.offset + v.exif_location.length), m = o.get_orientation(h);
                      m > 0 && (g.orientation = m);
                    }
                    return g;
                  }
                }
              }
            }
          }
        };
      }), M1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt16LE, i = n("BM");
        k.exports = function(o) {
          if (!(o.length < 26) && e(o, 0, i)) return { width: a(o, 18), height: a(o, 22), type: "bmp", mime: "image/bmp", wUnits: "px", hUnits: "px" };
        };
      }), A1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt16LE, i = n("GIF87a"), o = n("GIF89a");
        k.exports = function(r) {
          if (!(r.length < 10) && !(!e(r, 0, i) && !e(r, 0, o))) return { width: a(r, 6), height: a(r, 8), type: "gif", mime: "image/gif", wUnits: "px", hUnits: "px" };
        };
      }), S1 = xe((L, k) => {
        var n = jr().readUInt16LE, e = 0, a = 1, i = 16;
        k.exports = function(o) {
          var r = n(o, 0), s = n(o, 2), c = n(o, 4);
          if (!(r !== e || s !== a || !c)) {
            for (var t = [], p = { width: 0, height: 0 }, l = 0; l < c; l++) {
              var f = o[6 + i * l] || 256, v = o[6 + i * l + 1] || 256, g = { width: f, height: v };
              t.push(g), (f > p.width || v > p.height) && (p = g);
            }
            return { width: p.width, height: p.height, variants: t, type: "ico", mime: "image/x-icon", wUnits: "px", hUnits: "px" };
          }
        };
      }), L1 = xe((L, k) => {
        var n = jr().readUInt16BE, e = jr().str2arr, a = jr().sliceEq, i = ml(), o = e("Exif\0\0");
        k.exports = function(r) {
          if (!(r.length < 2) && !(r[0] !== 255 || r[1] !== 216 || r[2] !== 255)) for (var s = 2; ; ) {
            for (; ; ) {
              if (r.length - s < 2) return;
              if (r[s++] === 255) break;
            }
            for (var c = r[s++], t; c === 255; ) c = r[s++];
            if (208 <= c && c <= 217 || c === 1) t = 0;
            else if (192 <= c && c <= 254) {
              if (r.length - s < 2) return;
              t = n(r, s) - 2, s += 2;
            } else return;
            if (c === 217 || c === 218) return;
            var p;
            if (c === 225 && t >= 10 && a(r, s, o) && (p = i.get_orientation(r.slice(s + 6, s + t))), t >= 5 && 192 <= c && c <= 207 && c !== 196 && c !== 200 && c !== 204) {
              if (r.length - s < t) return;
              var l = { width: n(r, s + 3), height: n(r, s + 1), type: "jpg", mime: "image/jpeg", wUnits: "px", hUnits: "px" };
              return p > 0 && (l.orientation = p), l;
            }
            s += t;
          }
        };
      }), O1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt32BE, i = n(`PNG\r

`), o = n("IHDR");
        k.exports = function(r) {
          if (!(r.length < 24) && e(r, 0, i) && e(r, 12, o)) return { width: a(r, 16), height: a(r, 20), type: "png", mime: "image/png", wUnits: "px", hUnits: "px" };
        };
      }), C1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt32BE, i = n("8BPS\0");
        k.exports = function(o) {
          if (!(o.length < 22) && e(o, 0, i)) return { width: a(o, 18), height: a(o, 14), type: "psd", mime: "image/vnd.adobe.photoshop", wUnits: "px", hUnits: "px" };
        };
      }), E1 = xe((L, k) => {
        function n(f) {
          return f === 32 || f === 9 || f === 13 || f === 10;
        }
        function e(f) {
          return typeof f == "number" && isFinite(f) && f > 0;
        }
        function a(f) {
          var v = 0, g = f.length;
          for (f[0] === 239 && f[1] === 187 && f[2] === 191 && (v = 3); v < g && n(f[v]); ) v++;
          return v === g ? !1 : f[v] === 60;
        }
        var i = /<[-_.:a-zA-Z0-9][^>]*>/, o = /^<([-_.:a-zA-Z0-9]+:)?svg\s/, r = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/, s = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/, c = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/, t = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;
        function p(f) {
          var v = f.match(r), g = f.match(s), x = f.match(c);
          return { width: v && (v[1] || v[2]), height: g && (g[1] || g[2]), viewbox: x && (x[1] || x[2]) };
        }
        function l(f) {
          return t.test(f) ? f.match(t)[0] : "px";
        }
        k.exports = function(f) {
          if (a(f)) {
            for (var v = "", g = 0; g < f.length; g++) v += String.fromCharCode(f[g]);
            var x = (v.match(i) || [""])[0];
            if (o.test(x)) {
              var h = p(x), m = parseFloat(h.width), u = parseFloat(h.height);
              if (h.width && h.height) return !e(m) || !e(u) ? void 0 : { width: m, height: u, type: "svg", mime: "image/svg+xml", wUnits: l(h.width), hUnits: l(h.height) };
              var d = (h.viewbox || "").split(" "), y = { width: d[2], height: d[3] }, _ = parseFloat(y.width), T = parseFloat(y.height);
              if (!(!e(_) || !e(T)) && l(y.width) === l(y.height)) {
                var R = _ / T;
                return h.width ? e(m) ? { width: m, height: m / R, type: "svg", mime: "image/svg+xml", wUnits: l(h.width), hUnits: l(h.width) } : void 0 : h.height ? e(u) ? { width: u * R, height: u, type: "svg", mime: "image/svg+xml", wUnits: l(h.height), hUnits: l(h.height) } : void 0 : { width: _, height: T, type: "svg", mime: "image/svg+xml", wUnits: l(y.width), hUnits: l(y.height) };
              }
            }
          }
        };
      }), D1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt16LE, i = jr().readUInt16BE, o = jr().readUInt32LE, r = jr().readUInt32BE, s = n("II*\0"), c = n("MM\0*");
        function t(f, v, g) {
          return g ? i(f, v) : a(f, v);
        }
        function p(f, v, g) {
          return g ? r(f, v) : o(f, v);
        }
        function l(f, v, g) {
          var x = t(f, v + 2, g), h = p(f, v + 4, g);
          return h !== 1 || x !== 3 && x !== 4 ? null : x === 3 ? t(f, v + 8, g) : p(f, v + 8, g);
        }
        k.exports = function(f) {
          if (!(f.length < 8) && !(!e(f, 0, s) && !e(f, 0, c))) {
            var v = f[0] === 77, g = p(f, 4, v) - 8;
            if (!(g < 0)) {
              var x = g + 8;
              if (!(f.length - x < 2)) {
                var h = t(f, x + 0, v) * 12;
                if (!(h <= 0) && (x += 2, !(f.length - x < h))) {
                  var m, u, d, y;
                  for (m = 0; m < h; m += 12) y = t(f, x + m, v), y === 256 ? u = l(f, x + m, v) : y === 257 && (d = l(f, x + m, v));
                  if (u && d) return { width: u, height: d, type: "tiff", mime: "image/tiff", wUnits: "px", hUnits: "px" };
                }
              }
            }
          }
        };
      }), P1 = xe((L, k) => {
        var n = jr().str2arr, e = jr().sliceEq, a = jr().readUInt16LE, i = jr().readUInt32LE, o = ml(), r = n("RIFF"), s = n("WEBP");
        function c(l, f) {
          if (!(l[f + 3] !== 157 || l[f + 4] !== 1 || l[f + 5] !== 42)) return { width: a(l, f + 6) & 16383, height: a(l, f + 8) & 16383, type: "webp", mime: "image/webp", wUnits: "px", hUnits: "px" };
        }
        function t(l, f) {
          if (l[f] === 47) {
            var v = i(l, f + 1);
            return { width: (v & 16383) + 1, height: (v >> 14 & 16383) + 1, type: "webp", mime: "image/webp", wUnits: "px", hUnits: "px" };
          }
        }
        function p(l, f) {
          return { width: (l[f + 6] << 16 | l[f + 5] << 8 | l[f + 4]) + 1, height: (l[f + 9] << f | l[f + 8] << 8 | l[f + 7]) + 1, type: "webp", mime: "image/webp", wUnits: "px", hUnits: "px" };
        }
        k.exports = function(l) {
          if (!(l.length < 16) && !(!e(l, 0, r) && !e(l, 8, s))) {
            var f = 12, v = null, g = 0, x = i(l, 4) + 8;
            if (!(x > l.length)) {
              for (; f + 8 < x; ) {
                if (l[f] === 0) {
                  f++;
                  continue;
                }
                var h = String.fromCharCode.apply(null, l.slice(f, f + 4)), m = i(l, f + 4);
                h === "VP8 " && m >= 10 ? v = v || c(l, f + 8) : h === "VP8L" && m >= 9 ? v = v || t(l, f + 8) : h === "VP8X" && m >= 10 ? v = v || p(l, f + 8) : h === "EXIF" && (g = o.get_orientation(l.slice(f + 8, f + 8 + m)), f = 1 / 0), f += 8 + m;
              }
              if (v) return g > 0 && (v.orientation = g), v;
            }
          }
        };
      }), I1 = xe((L, k) => {
        k.exports = { avif: k1(), bmp: M1(), gif: A1(), ico: S1(), jpeg: L1(), png: O1(), psd: C1(), svg: E1(), tiff: D1(), webp: P1() };
      }), z1 = xe((L, k) => {
        var n = I1();
        function e(a) {
          for (var i = Object.keys(n), o = 0; o < i.length; o++) {
            var r = n[i[o]](a);
            if (r) return r;
          }
          return null;
        }
        k.exports = function(a) {
          return e(a);
        }, k.exports.parsers = n;
      }), R1 = xe((L) => {
        var k = z1(), n = ya().IMAGE_URL_PREFIX, e = ui().Buffer;
        L.getImageSize = function(a) {
          var i = a.replace(n, ""), o = new e(i, "base64");
          return k(o);
        };
      }), N1 = xe((L, k) => {
        var n = wt(), e = si(), a = xr(), i = Ar(), o = wt().maxRowLength, r = R1().getImageSize;
        k.exports = function(p, l) {
          var f, v;
          if (l._hasZ) f = l.z.length, v = o(l.z);
          else if (l._hasSource) {
            var g = r(l.source);
            f = g.height, v = g.width;
          }
          var x = i.getFromId(p, l.xaxis || "x"), h = i.getFromId(p, l.yaxis || "y"), m = x.d2c(l.x0) - l.dx / 2, u = h.d2c(l.y0) - l.dy / 2, d, y = [m, m + v * l.dx], _ = [u, u + f * l.dy];
          if (x && x.type === "log") for (d = 0; d < v; d++) y.push(m + d * l.dx);
          if (h && h.type === "log") for (d = 0; d < f; d++) _.push(u + d * l.dy);
          l._extremes[x._id] = i.findExtremes(x, y), l._extremes[h._id] = i.findExtremes(h, _), l._scaler = t(l);
          var T = { x0: m, y0: u, z: l.z, w: v, h: f };
          return [T];
        };
        function s(p, l, f, v) {
          return function(g) {
            return n.constrain((g - p) * l, f, v);
          };
        }
        function c(p, l) {
          return function(f) {
            return n.constrain(f, p, l);
          };
        }
        function t(p) {
          var l = e.colormodel[p.colormodel], f = l.colormodel || p.colormodel, v = f.length;
          p._sArray = [];
          for (var g = 0; g < v; g++) l.min[g] !== p.zmin[g] || l.max[g] !== p.zmax[g] ? p._sArray.push(s(p.zmin[g], (l.max[g] - l.min[g]) / (p.zmax[g] - p.zmin[g]), l.min[g], l.max[g])) : p._sArray.push(c(l.min[g], l.max[g]));
          return function(x) {
            for (var h = x.slice(0, v), m = 0; m < v; m++) {
              var u = h[m];
              if (!a(u)) return !1;
              h[m] = p._sArray[m](u);
            }
            return h;
          };
        }
      }), F1 = xe((L, k) => {
        var n = vr(), e = wt(), a = e.strTranslate, i = va(), o = si(), r = wu(), s = tl().STYLE;
        k.exports = function(c, t, p, l) {
          var f = t.xaxis, v = t.yaxis, g = !c._context._exportedPlot && r();
          e.makeTraceGroups(l, p, "im").each(function(x) {
            var h = n.select(this), m = x[0], u = m.trace, d = (u.zsmooth === "fast" || u.zsmooth === !1 && g) && !u._hasZ && u._hasSource && f.type === "linear" && v.type === "linear";
            u._realImage = d;
            var y = m.z, _ = m.x0, T = m.y0, R = m.w, I = m.h, P = u.dx, M = u.dy, B, z, q, U, G, K;
            for (K = 0; B === void 0 && K < R; ) B = f.c2p(_ + K * P), K++;
            for (K = R; z === void 0 && K > 0; ) z = f.c2p(_ + K * P), K--;
            for (K = 0; U === void 0 && K < I; ) U = v.c2p(T + K * M), K++;
            for (K = I; G === void 0 && K > 0; ) G = v.c2p(T + K * M), K--;
            if (z < B && (q = z, z = B, B = q), G < U && (q = U, U = G, G = q), !d) {
              var te = 0.5;
              B = Math.max(-te * f._length, B), z = Math.min((1 + te) * f._length, z), U = Math.max(-te * v._length, U), G = Math.min((1 + te) * v._length, G);
            }
            var V = Math.round(z - B), Z = Math.round(G - U), Y = V <= 0 || Z <= 0;
            if (Y) {
              var C = h.selectAll("image").data([]);
              C.exit().remove();
              return;
            }
            function j(E) {
              var w = document.createElement("canvas");
              w.width = V, w.height = Z;
              var N = w.getContext("2d", { willReadFrequently: !0 }), W = function(A) {
                return e.constrain(Math.round(f.c2p(_ + A * P) - B), 0, V);
              }, ee = function(A) {
                return e.constrain(Math.round(v.c2p(T + A * M) - U), 0, Z);
              }, le = o.colormodel[u.colormodel], ie = le.colormodel || u.colormodel, pe = le.fmt, _e;
              for (K = 0; K < m.w; K++) {
                var Ae = W(K), Ce = W(K + 1);
                if (!(Ce === Ae || isNaN(Ce) || isNaN(Ae))) for (var Ue = 0; Ue < m.h; Ue++) {
                  var Ne = ee(Ue), ke = ee(Ue + 1);
                  ke === Ne || isNaN(ke) || isNaN(Ne) || !E(K, Ue) || (_e = u._scaler(E(K, Ue)), _e ? N.fillStyle = ie + "(" + pe(_e).join(",") + ")" : N.fillStyle = "rgba(0,0,0,0)", N.fillRect(Ae, Ne, Ce - Ae, ke - Ne));
                }
              }
              return w;
            }
            var J = h.selectAll("image").data([x]);
            J.enter().append("svg:image").attr({ xmlns: i.svg, preserveAspectRatio: "none" }), J.exit().remove();
            var ne = u.zsmooth === !1 ? s : "";
            if (d) {
              var ae = e.simpleMap(f.range, f.r2l), se = e.simpleMap(v.range, v.r2l), O = ae[1] < ae[0], F = se[1] > se[0];
              if (O || F) {
                var S = B + V / 2, $ = U + Z / 2;
                ne += "transform:" + a(S + "px", $ + "px") + "scale(" + (O ? -1 : 1) + "," + (F ? -1 : 1) + ")" + a(-S + "px", -$ + "px") + ";";
              }
            }
            J.attr("style", ne);
            var re = new Promise(function(E) {
              if (u._hasZ) E();
              else if (u._hasSource) if (u._canvas && u._canvas.el.width === R && u._canvas.el.height === I && u._canvas.source === u.source) E();
              else {
                var w = document.createElement("canvas");
                w.width = R, w.height = I;
                var N = w.getContext("2d", { willReadFrequently: !0 });
                u._image = u._image || new Image();
                var W = u._image;
                W.onload = function() {
                  N.drawImage(W, 0, 0), u._canvas = { el: w, source: u.source }, E();
                }, W.setAttribute("src", u.source);
              }
            }).then(function() {
              var E, w;
              if (u._hasZ) w = j(function(ee, le) {
                var ie = y[le][ee];
                return e.isTypedArray(ie) && (ie = Array.from(ie)), ie;
              }), E = w.toDataURL("image/png");
              else if (u._hasSource) if (d) E = u.source;
              else {
                var N = u._canvas.el.getContext("2d", { willReadFrequently: !0 }), W = N.getImageData(0, 0, R, I).data;
                w = j(function(ee, le) {
                  var ie = 4 * (le * R + ee);
                  return [W[ie], W[ie + 1], W[ie + 2], W[ie + 3]];
                }), E = w.toDataURL("image/png");
              }
              J.attr({ "xlink:href": E, height: Z, width: V, x: B, y: U });
            });
            c._promises.push(re);
          });
        };
      }), B1 = xe((L, k) => {
        var n = vr();
        k.exports = function(e) {
          n.select(e).selectAll(".im image").style("opacity", function(a) {
            return a[0].trace.opacity;
          });
        };
      }), j1 = xe((L, k) => {
        var n = Bn(), e = wt(), a = e.isArrayOrTypedArray, i = si();
        k.exports = function(o, r, s) {
          var c = o.cd[0], t = c.trace, p = o.xa, l = o.ya;
          if (!(n.inbox(r - c.x0, r - (c.x0 + c.w * t.dx), 0) > 0 || n.inbox(s - c.y0, s - (c.y0 + c.h * t.dy), 0) > 0)) {
            var f = Math.floor((r - c.x0) / t.dx), v = Math.floor(Math.abs(s - c.y0) / t.dy), g;
            if (t._hasZ ? g = c.z[v][f] : t._hasSource && (g = t._canvas.el.getContext("2d", { willReadFrequently: !0 }).getImageData(f, v, 1, 1).data), !!g) {
              var x = c.hi || t.hoverinfo, h;
              if (x) {
                var m = x.split("+");
                m.indexOf("all") !== -1 && (m = ["color"]), m.indexOf("color") !== -1 && (h = !0);
              }
              var u = i.colormodel[t.colormodel], d = u.colormodel || t.colormodel, y = d.length, _ = t._scaler(g), T = u.suffix, R = [];
              (t.hovertemplate || h) && (R.push("[" + [_[0] + T[0], _[1] + T[1], _[2] + T[2]].join(", ")), y === 4 && R.push(", " + _[3] + T[3]), R.push("]"), R = R.join(""), o.extraText = d.toUpperCase() + ": " + R);
              var I;
              a(t.hovertext) && a(t.hovertext[v]) ? I = t.hovertext[v][f] : a(t.text) && a(t.text[v]) && (I = t.text[v][f]);
              var P = l.c2p(c.y0 + (v + 0.5) * t.dy), M = c.x0 + (f + 0.5) * t.dx, B = c.y0 + (v + 0.5) * t.dy, z = "[" + g.slice(0, t.colormodel.length).join(", ") + "]";
              return [e.extendFlat(o, { index: [v, f], x0: p.c2p(c.x0 + f * t.dx), x1: p.c2p(c.x0 + (f + 1) * t.dx), y0: P, y1: P, color: _, xVal: M, xLabelVal: M, yVal: B, yLabelVal: B, zLabelVal: z, text: I, hovertemplateLabels: { zLabel: z, colorLabel: R, "color[0]Label": _[0] + T[0], "color[1]Label": _[1] + T[1], "color[2]Label": _[2] + T[2], "color[3]Label": _[3] + T[3] } })];
            }
          }
        };
      }), H1 = xe((L, k) => {
        k.exports = function(n, e) {
          return "xVal" in e && (n.x = e.xVal), "yVal" in e && (n.y = e.yVal), e.xa && (n.xaxis = e.xa), e.ya && (n.yaxis = e.ya), n.color = e.color, n.colormodel = e.trace.colormodel, n.z || (n.z = e.color), n;
        };
      }), q1 = xe((L, k) => {
        k.exports = { attributes: Hu(), supplyDefaults: kh(), calc: N1(), plot: F1(), style: B1(), hoverPoints: j1(), eventData: H1(), moduleType: "trace", name: "image", basePlotModule: Kn(), categories: ["cartesian", "svg", "2dMap", "noSortingByValue"], animatable: !1, meta: {} };
      }), U1 = xe((L, k) => {
        k.exports = q1();
      }), dc = xe((L, k) => {
        var n = Pn(), e = oi().attributes, a = hn(), i = Zn(), { hovertemplateAttrs: o, texttemplateAttrs: r, templatefallbackAttrs: s } = qn(), c = Br().extendFlat, t = Wn().pattern, p = a({ editType: "plot", arrayOk: !0, colorEditType: "plot" });
        k.exports = { labels: { valType: "data_array", editType: "calc" }, label0: { valType: "number", dflt: 0, editType: "calc" }, dlabel: { valType: "number", dflt: 1, editType: "calc" }, values: { valType: "data_array", editType: "calc" }, marker: { colors: { valType: "data_array", editType: "calc" }, line: { color: { valType: "color", dflt: i.defaultLine, arrayOk: !0, editType: "style" }, width: { valType: "number", min: 0, dflt: 0, arrayOk: !0, editType: "style" }, editType: "calc" }, pattern: t, editType: "calc" }, text: { valType: "data_array", editType: "plot" }, hovertext: { valType: "string", dflt: "", arrayOk: !0, editType: "style" }, scalegroup: { valType: "string", dflt: "", editType: "calc" }, textinfo: { valType: "flaglist", flags: ["label", "text", "value", "percent"], extras: ["none"], editType: "calc" }, hoverinfo: c({}, n.hoverinfo, { flags: ["label", "text", "value", "percent", "name"] }), hovertemplate: o({}, { keys: ["label", "color", "value", "percent", "text"] }), hovertemplatefallback: s(), texttemplate: r({ editType: "plot" }, { keys: ["label", "color", "value", "percent", "text"] }), texttemplatefallback: s({ editType: "plot" }), textposition: { valType: "enumerated", values: ["inside", "outside", "auto", "none"], dflt: "auto", arrayOk: !0, editType: "plot" }, textfont: c({}, p, {}), insidetextorientation: { valType: "enumerated", values: ["horizontal", "radial", "tangential", "auto"], dflt: "auto", editType: "plot" }, insidetextfont: c({}, p, {}), outsidetextfont: c({}, p, {}), automargin: { valType: "boolean", dflt: !1, editType: "plot" }, title: { text: { valType: "string", dflt: "", editType: "plot" }, font: c({}, p, {}), position: { valType: "enumerated", values: ["top left", "top center", "top right", "middle center", "bottom left", "bottom center", "bottom right"], editType: "plot" }, editType: "plot" }, domain: e({ name: "pie", trace: !0, editType: "calc" }), hole: { valType: "number", min: 0, max: 1, dflt: 0, editType: "calc" }, sort: { valType: "boolean", dflt: !0, editType: "calc" }, direction: { valType: "enumerated", values: ["clockwise", "counterclockwise"], dflt: "counterclockwise", editType: "calc" }, rotation: { valType: "angle", dflt: 0, editType: "calc" }, pull: { valType: "number", min: 0, max: 1, dflt: 0, arrayOk: !0, editType: "calc" } };
      }), V1 = xe((L, k) => {
        var n = xr(), e = wt(), a = dc(), i = oi().defaults, o = Ha().handleText, r = wt().coercePattern;
        function s(p, l) {
          var f = e.isArrayOrTypedArray(p), v = e.isArrayOrTypedArray(l), g = Math.min(f ? p.length : 1 / 0, v ? l.length : 1 / 0);
          if (isFinite(g) || (g = 0), g && v) {
            for (var x, h = 0; h < g; h++) {
              var m = l[h];
              if (n(m) && m > 0) {
                x = !0;
                break;
              }
            }
            x || (g = 0);
          }
          return { hasLabels: f, hasValues: v, len: g };
        }
        function c(p, l, f, v, g) {
          var x = v("marker.line.width");
          x && v("marker.line.color", g ? void 0 : f.paper_bgcolor);
          var h = v("marker.colors");
          r(v, "marker.pattern", h), p.marker && !l.marker.pattern.fgcolor && (l.marker.pattern.fgcolor = p.marker.colors), l.marker.pattern.bgcolor || (l.marker.pattern.bgcolor = f.paper_bgcolor);
        }
        function t(p, l, f, v) {
          function g(z, q) {
            return e.coerce(p, l, a, z, q);
          }
          var x = g("labels"), h = g("values"), m = s(x, h), u = m.len;
          if (l._hasLabels = m.hasLabels, l._hasValues = m.hasValues, !l._hasLabels && l._hasValues && (g("label0"), g("dlabel")), !u) {
            l.visible = !1;
            return;
          }
          l._length = u, c(p, l, v, g, !0), g("scalegroup");
          var d = g("text"), y = g("texttemplate");
          g("texttemplatefallback");
          var _;
          if (y || (_ = g("textinfo", e.isArrayOrTypedArray(d) ? "text+percent" : "percent")), g("hovertext"), g("hovertemplate"), g("hovertemplatefallback"), y || _ && _ !== "none") {
            var T = g("textposition");
            o(p, l, v, g, T, { moduleHasSelected: !1, moduleHasUnselected: !1, moduleHasConstrain: !1, moduleHasCliponaxis: !1, moduleHasTextangle: !1, moduleHasInsideanchor: !1 });
            var R = Array.isArray(T) || T === "auto", I = R || T === "outside";
            I && g("automargin"), (T === "inside" || T === "auto" || Array.isArray(T)) && g("insidetextorientation");
          } else _ === "none" && g("textposition", "none");
          i(l, v, g);
          var P = g("hole"), M = g("title.text");
          if (M) {
            var B = g("title.position", P ? "middle center" : "top center");
            !P && B === "middle center" && (l.title.position = "top center"), e.coerceFont(g, "title.font", v.font);
          }
          g("sort"), g("direction"), g("rotation"), g("pull");
        }
        k.exports = { handleLabelsAndValues: s, handleMarkerDefaults: c, supplyDefaults: t };
      }), pc = xe((L, k) => {
        k.exports = { hiddenlabels: { valType: "data_array", editType: "calc" }, piecolorway: { valType: "colorlist", editType: "calc" }, extendpiecolors: { valType: "boolean", dflt: !0, editType: "calc" } };
      }), Y1 = xe((L, k) => {
        var n = wt(), e = pc();
        k.exports = function(a, i) {
          function o(r, s) {
            return n.coerce(a, i, e, r, s);
          }
          o("hiddenlabels"), o("piecolorway", i.colorway), o("extendpiecolors");
        };
      }), hc = xe((L, k) => {
        var n = xr(), e = Nn(), a = fr(), i = {};
        function o(t, p) {
          var l = [], f = t._fullLayout, v = f.hiddenlabels || [], g = p.labels, x = p.marker.colors || [], h = p.values, m = p._length, u = p._hasValues && m, d, y;
          if (p.dlabel) for (g = new Array(m), d = 0; d < m; d++) g[d] = String(p.label0 + d * p.dlabel);
          var _ = {}, T = r(f["_" + p.type + "colormap"]), R = 0, I = !1;
          for (d = 0; d < m; d++) {
            var P, M, B;
            if (u) {
              if (P = h[d], !n(P)) continue;
              P = +P;
            } else P = 1;
            M = g[d], (M === void 0 || M === "") && (M = d), M = String(M);
            var z = _[M];
            z === void 0 ? (_[M] = l.length, B = v.indexOf(M) !== -1, B || (R += P), l.push({ v: P, label: M, color: T(x[d], M), i: d, pts: [d], hidden: B })) : (I = !0, y = l[z], y.v += P, y.pts.push(d), y.hidden || (R += P), y.color === !1 && x[d] && (y.color = T(x[d], M)));
          }
          l = l.filter(function(U) {
            return U.v >= 0;
          });
          var q = p.type === "funnelarea" ? I : p.sort;
          return q && l.sort(function(U, G) {
            return G.v - U.v;
          }), l[0] && (l[0].vTotal = R), l;
        }
        function r(t) {
          return function(p, l) {
            return !p || (p = e(p), !p.isValid()) ? !1 : (p = a.addOpacity(p, p.getAlpha()), t[l] || (t[l] = p), p);
          };
        }
        function s(t, p) {
          var l = (p || {}).type;
          l || (l = "pie");
          var f = t._fullLayout, v = t.calcdata, g = f[l + "colorway"], x = f["_" + l + "colormap"];
          f["extend" + l + "colors"] && (g = c(g, i));
          for (var h = 0, m = 0; m < v.length; m++) {
            var u = v[m], d = u[0].trace.type;
            if (d === l) for (var y = 0; y < u.length; y++) {
              var _ = u[y];
              _.color === !1 && (x[_.label] ? _.color = x[_.label] : (x[_.label] = _.color = g[h % g.length], h++));
            }
          }
        }
        function c(t, p) {
          var l, f = JSON.stringify(t), v = p[f];
          if (!v) {
            for (v = t.slice(), l = 0; l < t.length; l++) v.push(e(t[l]).lighten(20).toHexString());
            for (l = 0; l < t.length; l++) v.push(e(t[l]).darken(20).toHexString());
            p[f] = v;
          }
          return v;
        }
        k.exports = { calc: o, crossTraceCalc: s, makePullColorFn: r, generateExtendedColors: c };
      }), G1 = xe((L, k) => {
        var n = da().appendArrayMultiPointValues;
        k.exports = function(e, a) {
          var i = { curveNumber: a.index, pointNumbers: e.pts, data: a._input, fullData: a, label: e.label, color: e.color, value: e.v, percent: e.percent, text: e.text, bbox: e.bbox, v: e.v };
          return e.pts.length === 1 && (i.pointNumber = i.i = e.pts[0]), n(i, a, e.pts), a.type === "funnelarea" && (delete i.v, delete i.i), i;
        };
      }), Z1 = xe((L, k) => {
        var n = vr(), e = on(), a = Bn(), i = fr(), o = Or(), r = wt(), s = r.strScale, c = r.strTranslate, t = xn(), p = Di(), l = p.recordMinTextSize, f = p.clearMinTextSize, v = Wo().TEXTPAD, g = ko(), x = G1(), h = wt().isValidTextValue;
        function m(F, S) {
          var $ = F._context.staticPlot, re = F._fullLayout, E = re._size;
          f("pie", re), T(S, F), j(S, E);
          var w = r.makeTraceGroups(re._pielayer, S, "trace").each(function(N) {
            var W = n.select(this), ee = N[0], le = ee.trace;
            ne(N), W.attr("stroke-linejoin", "round"), W.each(function() {
              var ie = n.select(this).selectAll("g.slice").data(N);
              ie.enter().append("g").classed("slice", !0), ie.exit().remove();
              var pe = [[[], []], [[], []]], _e = !1;
              ie.each(function(H, ve) {
                if (H.hidden) {
                  n.select(this).selectAll("path,g").remove();
                  return;
                }
                H.pointNumber = H.i, H.curveNumber = le.index, pe[H.pxmid[1] < 0 ? 0 : 1][H.pxmid[0] < 0 ? 0 : 1].push(H);
                var be = ee.cx, Se = ee.cy, De = n.select(this), He = De.selectAll("path.surface").data([H]);
                if (He.enter().append("path").classed("surface", !0).style({ "pointer-events": $ ? "none" : "all" }), De.call(d, F, N), le.pull) {
                  var Ze = +g.castOption(le.pull, H.pts) || 0;
                  Ze > 0 && (be += Ze * H.pxmid[0], Se += Ze * H.pxmid[1]);
                }
                H.cxFinal = be, H.cyFinal = Se;
                function We(_t, Te, Ie, ce) {
                  var ge = ce * (Te[0] - _t[0]), ye = ce * (Te[1] - _t[1]);
                  return "a" + ce * ee.r + "," + ce * ee.r + " 0 " + H.largeArc + (Ie ? " 1 " : " 0 ") + ge + "," + ye;
                }
                var $e = le.hole;
                if (H.v === ee.vTotal) {
                  var it = "M" + (be + H.px0[0]) + "," + (Se + H.px0[1]) + We(H.px0, H.pxmid, !0, 1) + We(H.pxmid, H.px0, !0, 1) + "Z";
                  $e ? He.attr("d", "M" + (be + $e * H.px0[0]) + "," + (Se + $e * H.px0[1]) + We(H.px0, H.pxmid, !1, $e) + We(H.pxmid, H.px0, !1, $e) + "Z" + it) : He.attr("d", it);
                } else {
                  var Ke = We(H.px0, H.px1, !0, 1);
                  if ($e) {
                    var ct = 1 - $e;
                    He.attr("d", "M" + (be + $e * H.px1[0]) + "," + (Se + $e * H.px1[1]) + We(H.px1, H.px0, !1, $e) + "l" + ct * H.px0[0] + "," + ct * H.px0[1] + Ke + "Z");
                  } else He.attr("d", "M" + be + "," + Se + "l" + H.px0[0] + "," + H.px0[1] + Ke + "Z");
                }
                se(F, H, ee);
                var gt = g.castOption(le.textposition, H.pts), ht = De.selectAll("g.slicetext").data(H.text && gt !== "none" ? [0] : []);
                ht.enter().append("g").classed("slicetext", !0), ht.exit().remove(), ht.each(function() {
                  var _t = r.ensureSingle(n.select(this), "text", "", function(je) {
                    je.attr("data-notex", 1);
                  }), Te = r.ensureUniformFontSize(F, gt === "outside" ? y(le, H, re.font) : _(le, H, re.font));
                  _t.text(H.text).attr({ class: "slicetext", transform: "", "text-anchor": "middle" }).call(o.font, Te).call(t.convertToTspans, F);
                  var Ie = o.bBox(_t.node()), ce;
                  if (gt === "outside") ce = G(Ie, H);
                  else if (ce = R(Ie, H, ee), gt === "auto" && ce.scale < 1) {
                    var ge = r.ensureUniformFontSize(F, le.outsidetextfont);
                    _t.call(o.font, ge), Ie = o.bBox(_t.node()), ce = G(Ie, H);
                  }
                  var ye = ce.textPosAngle, Me = ye === void 0 ? H.pxmid : ae(ee.r, ye);
                  if (ce.targetX = be + Me[0] * ce.rCenter + (ce.x || 0), ce.targetY = Se + Me[1] * ce.rCenter + (ce.y || 0), O(ce, Ie), ce.outside) {
                    var Oe = ce.targetY;
                    H.yLabelMin = Oe - Ie.height / 2, H.yLabelMid = Oe, H.yLabelMax = Oe + Ie.height / 2, H.labelExtraX = 0, H.labelExtraY = 0, _e = !0;
                  }
                  ce.fontSize = Te.size, l(le.type, ce, re), N[ve].transform = ce, r.setTransormAndDisplay(_t, ce);
                });
              });
              var Ae = n.select(this).selectAll("g.titletext").data(le.title.text ? [0] : []);
              if (Ae.enter().append("g").classed("titletext", !0), Ae.exit().remove(), Ae.each(function() {
                var H = r.ensureSingle(n.select(this), "text", "", function(Se) {
                  Se.attr("data-notex", 1);
                }), ve = le.title.text;
                le._meta && (ve = r.templateString(ve, le._meta)), H.text(ve).attr({ class: "titletext", transform: "", "text-anchor": "middle" }).call(o.font, le.title.font).call(t.convertToTspans, F);
                var be;
                le.title.position === "middle center" ? be = K(ee) : be = te(ee, E), H.attr("transform", c(be.x, be.y) + s(Math.min(1, be.scale)) + c(be.tx, be.ty));
              }), _e && C(pe, le), u(ie, le), _e && le.automargin) {
                var Ce = o.bBox(W.node()), Ue = le.domain, Ne = E.w * (Ue.x[1] - Ue.x[0]), ke = E.h * (Ue.y[1] - Ue.y[0]), A = (0.5 * Ne - ee.r) / E.w, X = (0.5 * ke - ee.r) / E.h;
                e.autoMargin(F, "pie." + le.uid + ".automargin", { xl: Ue.x[0] - A, xr: Ue.x[1] + A, yb: Ue.y[0] - X, yt: Ue.y[1] + X, l: Math.max(ee.cx - ee.r - Ce.left, 0), r: Math.max(Ce.right - (ee.cx + ee.r), 0), b: Math.max(Ce.bottom - (ee.cy + ee.r), 0), t: Math.max(ee.cy - ee.r - Ce.top, 0), pad: 5 });
              }
            });
          });
          setTimeout(function() {
            w.selectAll("tspan").each(function() {
              var N = n.select(this);
              N.attr("dy") && N.attr("dy", N.attr("dy"));
            });
          }, 0);
        }
        function u(F, S) {
          F.each(function($) {
            var re = n.select(this);
            if (!$.labelExtraX && !$.labelExtraY) {
              re.select("path.textline").remove();
              return;
            }
            var E = re.select("g.slicetext text");
            $.transform.targetX += $.labelExtraX, $.transform.targetY += $.labelExtraY, r.setTransormAndDisplay(E, $.transform);
            var w = $.cxFinal + $.pxmid[0], N = $.cyFinal + $.pxmid[1], W = "M" + w + "," + N, ee = ($.yLabelMax - $.yLabelMin) * ($.pxmid[0] < 0 ? -1 : 1) / 4;
            if ($.labelExtraX) {
              var le = $.labelExtraX * $.pxmid[1] / $.pxmid[0], ie = $.yLabelMid + $.labelExtraY - ($.cyFinal + $.pxmid[1]);
              Math.abs(le) > Math.abs(ie) ? W += "l" + ie * $.pxmid[0] / $.pxmid[1] + "," + ie + "H" + (w + $.labelExtraX + ee) : W += "l" + $.labelExtraX + "," + le + "v" + (ie - le) + "h" + ee;
            } else W += "V" + ($.yLabelMid + $.labelExtraY) + "h" + ee;
            r.ensureSingle(re, "path", "textline").call(i.stroke, S.outsidetextfont.color).attr({ "stroke-width": Math.min(2, S.outsidetextfont.size / 8), d: W, fill: "none" });
          });
        }
        function d(F, S, $) {
          var re = $[0], E = re.cx, w = re.cy, N = re.trace, W = N.type === "funnelarea";
          "_hasHoverLabel" in N || (N._hasHoverLabel = !1), "_hasHoverEvent" in N || (N._hasHoverEvent = !1), F.on("mouseover", function(ee) {
            var le = S._fullLayout, ie = S._fullData[N.index];
            if (!(S._dragging || le.hovermode === !1)) {
              var pe = ie.hoverinfo;
              if (Array.isArray(pe) && (pe = a.castHoverinfo({ hoverinfo: [g.castOption(pe, ee.pts)], _module: N._module }, le, 0)), pe === "all" && (pe = "label+text+value+percent+name"), ie.hovertemplate || pe !== "none" && pe !== "skip" && pe) {
                var _e = ee.rInscribed || 0, Ae = E + ee.pxmid[0] * (1 - _e), Ce = w + ee.pxmid[1] * (1 - _e), Ue = le.separators, Ne = [];
                if (pe && pe.indexOf("label") !== -1 && Ne.push(ee.label), ee.text = g.castOption(ie.hovertext || ie.text, ee.pts), pe && pe.indexOf("text") !== -1) {
                  var ke = ee.text;
                  r.isValidTextValue(ke) && Ne.push(ke);
                }
                ee.value = ee.v, ee.valueLabel = g.formatPieValue(ee.v, Ue), pe && pe.indexOf("value") !== -1 && Ne.push(ee.valueLabel), ee.percent = ee.v / re.vTotal, ee.percentLabel = g.formatPiePercent(ee.percent, Ue), pe && pe.indexOf("percent") !== -1 && Ne.push(ee.percentLabel);
                var A = ie.hoverlabel, X = A.font, H = [];
                a.loneHover({ trace: N, x0: Ae - _e * re.r, x1: Ae + _e * re.r, y: Ce, _x0: W ? E + ee.TL[0] : Ae - _e * re.r, _x1: W ? E + ee.TR[0] : Ae + _e * re.r, _y0: W ? w + ee.TL[1] : Ce - _e * re.r, _y1: W ? w + ee.BL[1] : Ce + _e * re.r, text: Ne.join("<br>"), name: ie.hovertemplate || pe.indexOf("name") !== -1 ? ie.name : void 0, idealAlign: ee.pxmid[0] < 0 ? "left" : "right", color: g.castOption(A.bgcolor, ee.pts) || ee.color, borderColor: g.castOption(A.bordercolor, ee.pts), fontFamily: g.castOption(X.family, ee.pts), fontSize: g.castOption(X.size, ee.pts), fontColor: g.castOption(X.color, ee.pts), nameLength: g.castOption(A.namelength, ee.pts), textAlign: g.castOption(A.align, ee.pts), hovertemplate: g.castOption(ie.hovertemplate, ee.pts), hovertemplateLabels: ee, eventData: [x(ee, ie)] }, { container: le._hoverlayer.node(), outerContainer: le._paper.node(), gd: S, inOut_bbox: H }), ee.bbox = H[0], N._hasHoverLabel = !0;
              }
              N._hasHoverEvent = !0, S.emit("plotly_hover", { points: [x(ee, ie)], event: n.event });
            }
          }), F.on("mouseout", function(ee) {
            var le = S._fullLayout, ie = S._fullData[N.index], pe = n.select(this).datum();
            N._hasHoverEvent && (ee.originalEvent = n.event, S.emit("plotly_unhover", { points: [x(pe, ie)], event: n.event }), N._hasHoverEvent = !1), N._hasHoverLabel && (a.loneUnhover(le._hoverlayer.node()), N._hasHoverLabel = !1);
          }), F.on("click", function(ee) {
            var le = S._fullLayout, ie = S._fullData[N.index];
            S._dragging || le.hovermode === !1 || (S._hoverdata = [x(ee, ie)], a.click(S, n.event));
          });
        }
        function y(F, S, $) {
          var re = g.castOption(F.outsidetextfont.color, S.pts) || g.castOption(F.textfont.color, S.pts) || $.color, E = g.castOption(F.outsidetextfont.family, S.pts) || g.castOption(F.textfont.family, S.pts) || $.family, w = g.castOption(F.outsidetextfont.size, S.pts) || g.castOption(F.textfont.size, S.pts) || $.size, N = g.castOption(F.outsidetextfont.weight, S.pts) || g.castOption(F.textfont.weight, S.pts) || $.weight, W = g.castOption(F.outsidetextfont.style, S.pts) || g.castOption(F.textfont.style, S.pts) || $.style, ee = g.castOption(F.outsidetextfont.variant, S.pts) || g.castOption(F.textfont.variant, S.pts) || $.variant, le = g.castOption(F.outsidetextfont.textcase, S.pts) || g.castOption(F.textfont.textcase, S.pts) || $.textcase, ie = g.castOption(F.outsidetextfont.lineposition, S.pts) || g.castOption(F.textfont.lineposition, S.pts) || $.lineposition, pe = g.castOption(F.outsidetextfont.shadow, S.pts) || g.castOption(F.textfont.shadow, S.pts) || $.shadow;
          return { color: re, family: E, size: w, weight: N, style: W, variant: ee, textcase: le, lineposition: ie, shadow: pe };
        }
        function _(F, S, $) {
          var re = g.castOption(F.insidetextfont.color, S.pts);
          !re && F._input.textfont && (re = g.castOption(F._input.textfont.color, S.pts));
          var E = g.castOption(F.insidetextfont.family, S.pts) || g.castOption(F.textfont.family, S.pts) || $.family, w = g.castOption(F.insidetextfont.size, S.pts) || g.castOption(F.textfont.size, S.pts) || $.size, N = g.castOption(F.insidetextfont.weight, S.pts) || g.castOption(F.textfont.weight, S.pts) || $.weight, W = g.castOption(F.insidetextfont.style, S.pts) || g.castOption(F.textfont.style, S.pts) || $.style, ee = g.castOption(F.insidetextfont.variant, S.pts) || g.castOption(F.textfont.variant, S.pts) || $.variant, le = g.castOption(F.insidetextfont.textcase, S.pts) || g.castOption(F.textfont.textcase, S.pts) || $.textcase, ie = g.castOption(F.insidetextfont.lineposition, S.pts) || g.castOption(F.textfont.lineposition, S.pts) || $.lineposition, pe = g.castOption(F.insidetextfont.shadow, S.pts) || g.castOption(F.textfont.shadow, S.pts) || $.shadow;
          return { color: re || i.contrast(S.color), family: E, size: w, weight: N, style: W, variant: ee, textcase: le, lineposition: ie, shadow: pe };
        }
        function T(F, S) {
          for (var $, re, E = 0; E < F.length; E++) if ($ = F[E][0], re = $.trace, re.title.text) {
            var w = re.title.text;
            re._meta && (w = r.templateString(w, re._meta));
            var N = o.tester.append("text").attr("data-notex", 1).text(w).call(o.font, re.title.font).call(t.convertToTspans, S), W = o.bBox(N.node(), !0);
            $.titleBox = { width: W.width, height: W.height }, N.remove();
          }
        }
        function R(F, S, $) {
          var re = $.r || S.rpx1, E = S.rInscribed, w = S.startangle === S.stopangle;
          if (w) return { rCenter: 1 - E, scale: 0, rotate: 0, textPosAngle: 0 };
          var N = S.ring, W = N === 1 && Math.abs(S.startangle - S.stopangle) === Math.PI * 2, ee = S.halfangle, le = S.midangle, ie = $.trace.insidetextorientation, pe = ie === "horizontal", _e = ie === "tangential", Ae = ie === "radial", Ce = ie === "auto", Ue = [], Ne;
          if (!Ce) {
            var ke = function(De, He) {
              if (I(S, De)) {
                var Ze = Math.abs(De - S.startangle), We = Math.abs(De - S.stopangle), $e = Ze < We ? Ze : We;
                He === "tan" ? Ne = M(F, re, N, $e, 0) : Ne = P(F, re, N, $e, Math.PI / 2), Ne.textPosAngle = De, Ue.push(Ne);
              }
            }, A;
            if (pe || _e) {
              for (A = 4; A >= -4; A -= 2) ke(Math.PI * A, "tan");
              for (A = 4; A >= -4; A -= 2) ke(Math.PI * (A + 1), "tan");
            }
            if (pe || Ae) {
              for (A = 4; A >= -4; A -= 2) ke(Math.PI * (A + 1.5), "rad");
              for (A = 4; A >= -4; A -= 2) ke(Math.PI * (A + 0.5), "rad");
            }
          }
          if (W || Ce || pe) {
            var X = Math.sqrt(F.width * F.width + F.height * F.height);
            if (Ne = { scale: E * re * 2 / X, rCenter: 1 - E, rotate: 0 }, Ne.textPosAngle = (S.startangle + S.stopangle) / 2, Ne.scale >= 1) return Ne;
            Ue.push(Ne);
          }
          (Ce || Ae) && (Ne = P(F, re, N, ee, le), Ne.textPosAngle = (S.startangle + S.stopangle) / 2, Ue.push(Ne)), (Ce || _e) && (Ne = M(F, re, N, ee, le), Ne.textPosAngle = (S.startangle + S.stopangle) / 2, Ue.push(Ne));
          for (var H = 0, ve = 0, be = 0; be < Ue.length; be++) {
            var Se = Ue[be].scale;
            if (ve < Se && (ve = Se, H = be), !Ce && ve >= 1) break;
          }
          return Ue[H];
        }
        function I(F, S) {
          var $ = F.startangle, re = F.stopangle;
          return $ > S && S > re || $ < S && S < re;
        }
        function P(F, S, $, re, E) {
          S = Math.max(0, S - 2 * v);
          var w = F.width / F.height, N = q(w, re, S, $);
          return { scale: N * 2 / F.height, rCenter: B(w, N / S), rotate: z(E) };
        }
        function M(F, S, $, re, E) {
          S = Math.max(0, S - 2 * v);
          var w = F.height / F.width, N = q(w, re, S, $);
          return { scale: N * 2 / F.width, rCenter: B(w, N / S), rotate: z(E + Math.PI / 2) };
        }
        function B(F, S) {
          return Math.cos(S) - F * S;
        }
        function z(F) {
          return (180 / Math.PI * F + 720) % 180 - 90;
        }
        function q(F, S, $, re) {
          var E = F + 1 / (2 * Math.tan(S));
          return $ * Math.min(1 / (Math.sqrt(E * E + 0.5) + E), re / (Math.sqrt(F * F + re / 2) + F));
        }
        function U(F, S) {
          return F.v === S.vTotal && !S.trace.hole ? 1 : Math.min(1 / (1 + 1 / Math.sin(F.halfangle)), F.ring / 2);
        }
        function G(F, S) {
          var $ = S.pxmid[0], re = S.pxmid[1], E = F.width / 2, w = F.height / 2;
          return $ < 0 && (E *= -1), re < 0 && (w *= -1), { scale: 1, rCenter: 1, rotate: 0, x: E + Math.abs(w) * (E > 0 ? 1 : -1) / 2, y: w / (1 + $ * $ / (re * re)), outside: !0 };
        }
        function K(F) {
          var S = Math.sqrt(F.titleBox.width * F.titleBox.width + F.titleBox.height * F.titleBox.height);
          return { x: F.cx, y: F.cy, scale: F.trace.hole * F.r * 2 / S, tx: 0, ty: -F.titleBox.height / 2 + F.trace.title.font.size };
        }
        function te(F, S) {
          var $ = 1, re = 1, E, w = F.trace, N = { x: F.cx, y: F.cy }, W = { tx: 0, ty: 0 };
          W.ty += w.title.font.size, E = Y(w), w.title.position.indexOf("top") !== -1 ? (N.y -= (1 + E) * F.r, W.ty -= F.titleBox.height) : w.title.position.indexOf("bottom") !== -1 && (N.y += (1 + E) * F.r);
          var ee = V(F.r, F.trace.aspectratio), le = S.w * (w.domain.x[1] - w.domain.x[0]) / 2;
          return w.title.position.indexOf("left") !== -1 ? (le = le + ee, N.x -= (1 + E) * ee, W.tx += F.titleBox.width / 2) : w.title.position.indexOf("center") !== -1 ? le *= 2 : w.title.position.indexOf("right") !== -1 && (le = le + ee, N.x += (1 + E) * ee, W.tx -= F.titleBox.width / 2), $ = le / F.titleBox.width, re = Z(F, S) / F.titleBox.height, { x: N.x, y: N.y, scale: Math.min($, re), tx: W.tx, ty: W.ty };
        }
        function V(F, S) {
          return F / (S === void 0 ? 1 : S);
        }
        function Z(F, S) {
          var $ = F.trace, re = S.h * ($.domain.y[1] - $.domain.y[0]);
          return Math.min(F.titleBox.height, re / 2);
        }
        function Y(F) {
          var S = F.pull;
          if (!S) return 0;
          var $;
          if (r.isArrayOrTypedArray(S)) for (S = 0, $ = 0; $ < F.pull.length; $++) F.pull[$] > S && (S = F.pull[$]);
          return S;
        }
        function C(F, S) {
          var $, re, E, w, N, W, ee, le, ie, pe, _e, Ae, Ce;
          function Ue(X, H) {
            return X.pxmid[1] - H.pxmid[1];
          }
          function Ne(X, H) {
            return H.pxmid[1] - X.pxmid[1];
          }
          function ke(X, H) {
            H || (H = {});
            var ve = H.labelExtraY + (re ? H.yLabelMax : H.yLabelMin), be = re ? X.yLabelMin : X.yLabelMax, Se = re ? X.yLabelMax : X.yLabelMin, De = X.cyFinal + N(X.px0[1], X.px1[1]), He = ve - be, Ze, We, $e, it, Ke, ct;
            if (He * ee > 0 && (X.labelExtraY = He), !!r.isArrayOrTypedArray(S.pull)) for (We = 0; We < pe.length; We++) $e = pe[We], !($e === X || (g.castOption(S.pull, X.pts) || 0) >= (g.castOption(S.pull, $e.pts) || 0)) && ((X.pxmid[1] - $e.pxmid[1]) * ee > 0 ? (it = $e.cyFinal + N($e.px0[1], $e.px1[1]), He = it - be - X.labelExtraY, He * ee > 0 && (X.labelExtraY += He)) : (Se + X.labelExtraY - De) * ee > 0 && (Ze = 3 * W * Math.abs(We - pe.indexOf(X)), Ke = $e.cxFinal + w($e.px0[0], $e.px1[0]), ct = Ke + Ze - (X.cxFinal + X.pxmid[0]) - X.labelExtraX, ct * W > 0 && (X.labelExtraX += ct)));
          }
          for (re = 0; re < 2; re++) for (E = re ? Ue : Ne, N = re ? Math.max : Math.min, ee = re ? 1 : -1, $ = 0; $ < 2; $++) {
            for (w = $ ? Math.max : Math.min, W = $ ? 1 : -1, le = F[re][$], le.sort(E), ie = F[1 - re][$], pe = ie.concat(le), Ae = [], _e = 0; _e < le.length; _e++) le[_e].yLabelMid !== void 0 && Ae.push(le[_e]);
            for (Ce = !1, _e = 0; re && _e < ie.length; _e++) if (ie[_e].yLabelMid !== void 0) {
              Ce = ie[_e];
              break;
            }
            for (_e = 0; _e < Ae.length; _e++) {
              var A = _e && Ae[_e - 1];
              Ce && !_e && (A = Ce), ke(Ae[_e], A);
            }
          }
        }
        function j(F, S) {
          for (var $ = [], re = 0; re < F.length; re++) {
            var E = F[re][0], w = E.trace, N = w.domain, W = S.w * (N.x[1] - N.x[0]), ee = S.h * (N.y[1] - N.y[0]);
            w.title.text && w.title.position !== "middle center" && (ee -= Z(E, S));
            var le = W / 2, ie = ee / 2;
            w.type === "funnelarea" && !w.scalegroup && (ie /= w.aspectratio), E.r = Math.min(le, ie) / (1 + Y(w)), E.cx = S.l + S.w * (w.domain.x[1] + w.domain.x[0]) / 2, E.cy = S.t + S.h * (1 - w.domain.y[0]) - ee / 2, w.title.text && w.title.position.indexOf("bottom") !== -1 && (E.cy -= Z(E, S)), w.scalegroup && $.indexOf(w.scalegroup) === -1 && $.push(w.scalegroup);
          }
          J(F, $);
        }
        function J(F, S) {
          for (var $, re, E, w = 0; w < S.length; w++) {
            var N = 1 / 0, W = S[w];
            for (re = 0; re < F.length; re++) if ($ = F[re][0], E = $.trace, E.scalegroup === W) {
              var ee;
              if (E.type === "pie") ee = $.r * $.r;
              else if (E.type === "funnelarea") {
                var le, ie;
                E.aspectratio > 1 ? (le = $.r, ie = le / E.aspectratio) : (ie = $.r, le = ie * E.aspectratio), le *= (1 + E.baseratio) / 2, ee = le * ie;
              }
              N = Math.min(N, ee / $.vTotal);
            }
            for (re = 0; re < F.length; re++) if ($ = F[re][0], E = $.trace, E.scalegroup === W) {
              var pe = N * $.vTotal;
              E.type === "funnelarea" && (pe /= (1 + E.baseratio) / 2, pe /= E.aspectratio), $.r = Math.sqrt(pe);
            }
          }
        }
        function ne(F) {
          var S = F[0], $ = S.r, re = S.trace, E = g.getRotationAngle(re.rotation), w = 2 * Math.PI / S.vTotal, N = "px0", W = "px1", ee, le, ie;
          if (re.direction === "counterclockwise") {
            for (ee = 0; ee < F.length && F[ee].hidden; ee++) ;
            if (ee === F.length) return;
            E += w * F[ee].v, w *= -1, N = "px1", W = "px0";
          }
          for (ie = ae($, E), ee = 0; ee < F.length; ee++) le = F[ee], !le.hidden && (le[N] = ie, le.startangle = E, E += w * le.v / 2, le.pxmid = ae($, E), le.midangle = E, E += w * le.v / 2, ie = ae($, E), le.stopangle = E, le[W] = ie, le.largeArc = le.v > S.vTotal / 2 ? 1 : 0, le.halfangle = Math.PI * Math.min(le.v / S.vTotal, 0.5), le.ring = 1 - re.hole, le.rInscribed = U(le, S));
        }
        function ae(F, S) {
          return [F * Math.sin(S), -F * Math.cos(S)];
        }
        function se(F, S, $) {
          var re = F._fullLayout, E = $.trace, w = E.texttemplate, N = E.textinfo;
          if (!w && N && N !== "none") {
            var W = N.split("+"), ee = function(H) {
              return W.indexOf(H) !== -1;
            }, le = ee("label"), ie = ee("text"), pe = ee("value"), _e = ee("percent"), Ae = re.separators, Ce;
            if (Ce = le ? [S.label] : [], ie) {
              var Ue = g.getFirstFilled(E.text, S.pts);
              h(Ue) && Ce.push(Ue);
            }
            pe && Ce.push(g.formatPieValue(S.v, Ae)), _e && Ce.push(g.formatPiePercent(S.v / $.vTotal, Ae)), S.text = Ce.join("<br>");
          }
          function Ne(H) {
            return { label: H.label, value: H.v, valueLabel: g.formatPieValue(H.v, re.separators), percent: H.v / $.vTotal, percentLabel: g.formatPiePercent(H.v / $.vTotal, re.separators), color: H.color, text: H.text, customdata: r.castOption(E, H.i, "customdata") };
          }
          if (w) {
            var ke = r.castOption(E, S.i, "texttemplate");
            if (!ke) S.text = "";
            else {
              var A = Ne(S), X = g.getFirstFilled(E.text, S.pts);
              (h(X) || X === "") && (A.text = X), S.text = r.texttemplateString({ data: [A, E._meta], fallback: E.texttemplatefallback, labels: A, locale: F._fullLayout._d3locale, template: ke });
            }
          }
        }
        function O(F, S) {
          var $ = F.rotate * Math.PI / 180, re = Math.cos($), E = Math.sin($), w = (S.left + S.right) / 2, N = (S.top + S.bottom) / 2;
          F.textX = w * re - N * E, F.textY = w * E + N * re, F.noCenter = !0;
        }
        k.exports = { plot: m, formatSliceLabel: se, transformInsideText: R, determineInsideTextFont: _, positionTitleOutside: te, prerenderTitles: T, layoutAreas: j, attachFxHandlers: d, computeTransform: O };
      }), W1 = xe((L, k) => {
        var n = vr(), e = Mo(), a = Di().resizeText;
        k.exports = function(i) {
          var o = i._fullLayout._pielayer.selectAll(".trace");
          a(i, o, "pie"), o.each(function(r) {
            var s = r[0], c = s.trace, t = n.select(this);
            t.style({ opacity: c.opacity }), t.selectAll("path.surface").each(function(p) {
              n.select(this).call(e, p, c, i);
            });
          });
        };
      }), X1 = xe((L) => {
        var k = on();
        L.name = "pie", L.plot = function(n, e, a, i) {
          k.plotBasePlot(L.name, n, e, a, i);
        }, L.clean = function(n, e, a, i) {
          k.cleanBasePlot(L.name, n, e, a, i);
        };
      }), J1 = xe((L, k) => {
        k.exports = { attributes: dc(), supplyDefaults: V1().supplyDefaults, supplyLayoutDefaults: Y1(), layoutAttributes: pc(), calc: hc().calc, crossTraceCalc: hc().crossTraceCalc, plot: Z1().plot, style: W1(), styleOne: Mo(), moduleType: "trace", name: "pie", basePlotModule: X1(), categories: ["pie-like", "pie", "showLegend"], meta: {} };
      }), $1 = xe((L, k) => {
        k.exports = J1();
      }), Mn = xe((L, k) => {
        var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
        function i(r) {
          if (r == null) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(r);
        }
        function o() {
          try {
            if (!Object.assign) return !1;
            var r = new String("abc");
            if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5") return !1;
            for (var s = {}, c = 0; c < 10; c++) s["_" + String.fromCharCode(c)] = c;
            var t = Object.getOwnPropertyNames(s).map(function(l) {
              return s[l];
            });
            if (t.join("") !== "0123456789") return !1;
            var p = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(l) {
              p[l] = l;
            }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
          } catch {
            return !1;
          }
        }
        k.exports = o() ? Object.assign : function(r, s) {
          for (var c, t = i(r), p, l = 1; l < arguments.length; l++) {
            c = Object(arguments[l]);
            for (var f in c) e.call(c, f) && (t[f] = c[f]);
            if (n) {
              p = n(c);
              for (var v = 0; v < p.length; v++) a.call(c, p[v]) && (t[p[v]] = c[p[v]]);
            }
          }
          return t;
        };
      }), An = xe((L, k) => {
        var n = Mn();
        function e() {
          this.regionalOptions = [], this.regionalOptions[""] = { invalidCalendar: "Calendar {0} not found", invalidDate: "Invalid {0} date", invalidMonth: "Invalid {0} month", invalidYear: "Invalid {0} year", differentCalendars: "Cannot mix {0} and {1} dates" }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
        }
        n(e.prototype, { instance: function(c, t) {
          c = (c || "gregorian").toLowerCase(), t = t || "";
          var p = this._localCals[c + "-" + t];
          if (!p && this.calendars[c] && (p = new this.calendars[c](t), this._localCals[c + "-" + t] = p), !p) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, c);
          return p;
        }, newDate: function(c, t, p, l, f) {
          return l = (c != null && c.year ? c.calendar() : typeof l == "string" ? this.instance(l, f) : l) || this.instance(), l.newDate(c, t, p);
        }, substituteDigits: function(c) {
          return function(t) {
            return (t + "").replace(/[0-9]/g, function(p) {
              return c[p];
            });
          };
        }, substituteChineseDigits: function(c, t) {
          return function(p) {
            for (var l = "", f = 0; p > 0; ) {
              var v = p % 10;
              l = (v === 0 ? "" : c[v] + t[f]) + l, f++, p = Math.floor(p / 10);
            }
            return l.indexOf(c[1] + t[1]) === 0 && (l = l.substr(1)), l || c[0];
          };
        } });
        function a(c, t, p, l) {
          if (this._calendar = c, this._year = t, this._month = p, this._day = l, this._calendar._validateLevel === 0 && !this._calendar.isValid(this._year, this._month, this._day)) throw (s.local.invalidDate || s.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
        }
        function i(c, t) {
          return c = "" + c, "000000".substring(0, t - c.length) + c;
        }
        n(a.prototype, { newDate: function(c, t, p) {
          return this._calendar.newDate(c ?? this, t, p);
        }, year: function(c) {
          return arguments.length === 0 ? this._year : this.set(c, "y");
        }, month: function(c) {
          return arguments.length === 0 ? this._month : this.set(c, "m");
        }, day: function(c) {
          return arguments.length === 0 ? this._day : this.set(c, "d");
        }, date: function(c, t, p) {
          if (!this._calendar.isValid(c, t, p)) throw (s.local.invalidDate || s.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
          return this._year = c, this._month = t, this._day = p, this;
        }, leapYear: function() {
          return this._calendar.leapYear(this);
        }, epoch: function() {
          return this._calendar.epoch(this);
        }, formatYear: function() {
          return this._calendar.formatYear(this);
        }, monthOfYear: function() {
          return this._calendar.monthOfYear(this);
        }, weekOfYear: function() {
          return this._calendar.weekOfYear(this);
        }, daysInYear: function() {
          return this._calendar.daysInYear(this);
        }, dayOfYear: function() {
          return this._calendar.dayOfYear(this);
        }, daysInMonth: function() {
          return this._calendar.daysInMonth(this);
        }, dayOfWeek: function() {
          return this._calendar.dayOfWeek(this);
        }, weekDay: function() {
          return this._calendar.weekDay(this);
        }, extraInfo: function() {
          return this._calendar.extraInfo(this);
        }, add: function(c, t) {
          return this._calendar.add(this, c, t);
        }, set: function(c, t) {
          return this._calendar.set(this, c, t);
        }, compareTo: function(c) {
          if (this._calendar.name !== c._calendar.name) throw (s.local.differentCalendars || s.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, c._calendar.local.name);
          var t = this._year !== c._year ? this._year - c._year : this._month !== c._month ? this.monthOfYear() - c.monthOfYear() : this._day - c._day;
          return t === 0 ? 0 : t < 0 ? -1 : 1;
        }, calendar: function() {
          return this._calendar;
        }, toJD: function() {
          return this._calendar.toJD(this);
        }, fromJD: function(c) {
          return this._calendar.fromJD(c);
        }, toJSDate: function() {
          return this._calendar.toJSDate(this);
        }, fromJSDate: function(c) {
          return this._calendar.fromJSDate(c);
        }, toString: function() {
          return (this.year() < 0 ? "-" : "") + i(Math.abs(this.year()), 4) + "-" + i(this.month(), 2) + "-" + i(this.day(), 2);
        } });
        function o() {
          this.shortYearCutoff = "+10";
        }
        n(o.prototype, { _validateLevel: 0, newDate: function(c, t, p) {
          return c == null ? this.today() : (c.year && (this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate), p = c.day(), t = c.month(), c = c.year()), new a(this, c, t, p));
        }, today: function() {
          return this.fromJSDate(/* @__PURE__ */ new Date());
        }, epoch: function(c) {
          var t = this._validate(c, this.minMonth, this.minDay, s.local.invalidYear || s.regionalOptions[""].invalidYear);
          return t.year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
        }, formatYear: function(c) {
          var t = this._validate(c, this.minMonth, this.minDay, s.local.invalidYear || s.regionalOptions[""].invalidYear);
          return (t.year() < 0 ? "-" : "") + i(Math.abs(t.year()), 4);
        }, monthsInYear: function(c) {
          return this._validate(c, this.minMonth, this.minDay, s.local.invalidYear || s.regionalOptions[""].invalidYear), 12;
        }, monthOfYear: function(c, t) {
          var p = this._validate(c, t, this.minDay, s.local.invalidMonth || s.regionalOptions[""].invalidMonth);
          return (p.month() + this.monthsInYear(p) - this.firstMonth) % this.monthsInYear(p) + this.minMonth;
        }, fromMonthOfYear: function(c, t) {
          var p = (t + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(c) + this.minMonth;
          return this._validate(c, p, this.minDay, s.local.invalidMonth || s.regionalOptions[""].invalidMonth), p;
        }, daysInYear: function(c) {
          var t = this._validate(c, this.minMonth, this.minDay, s.local.invalidYear || s.regionalOptions[""].invalidYear);
          return this.leapYear(t) ? 366 : 365;
        }, dayOfYear: function(c, t, p) {
          var l = this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate);
          return l.toJD() - this.newDate(l.year(), this.fromMonthOfYear(l.year(), this.minMonth), this.minDay).toJD() + 1;
        }, daysInWeek: function() {
          return 7;
        }, dayOfWeek: function(c, t, p) {
          var l = this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate);
          return (Math.floor(this.toJD(l)) + 2) % this.daysInWeek();
        }, extraInfo: function(c, t, p) {
          return this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate), {};
        }, add: function(c, t, p) {
          return this._validate(c, this.minMonth, this.minDay, s.local.invalidDate || s.regionalOptions[""].invalidDate), this._correctAdd(c, this._add(c, t, p), t, p);
        }, _add: function(c, t, p) {
          if (this._validateLevel++, p === "d" || p === "w") {
            var l = c.toJD() + t * (p === "w" ? this.daysInWeek() : 1), f = c.calendar().fromJD(l);
            return this._validateLevel--, [f.year(), f.month(), f.day()];
          }
          try {
            var v = c.year() + (p === "y" ? t : 0), g = c.monthOfYear() + (p === "m" ? t : 0), f = c.day(), x = function(u) {
              for (; g < u.minMonth; ) v--, g += u.monthsInYear(v);
              for (var d = u.monthsInYear(v); g > d - 1 + u.minMonth; ) v++, g -= d, d = u.monthsInYear(v);
            };
            p === "y" ? (c.month() !== this.fromMonthOfYear(v, g) && (g = this.newDate(v, c.month(), this.minDay).monthOfYear()), g = Math.min(g, this.monthsInYear(v)), f = Math.min(f, this.daysInMonth(v, this.fromMonthOfYear(v, g)))) : p === "m" && (x(this), f = Math.min(f, this.daysInMonth(v, this.fromMonthOfYear(v, g))));
            var h = [v, this.fromMonthOfYear(v, g), f];
            return this._validateLevel--, h;
          } catch (m) {
            throw this._validateLevel--, m;
          }
        }, _correctAdd: function(c, t, p, l) {
          if (!this.hasYearZero && (l === "y" || l === "m") && (t[0] === 0 || c.year() > 0 != t[0] > 0)) {
            var f = { y: [1, 1, "y"], m: [1, this.monthsInYear(-1), "m"], w: [this.daysInWeek(), this.daysInYear(-1), "d"], d: [1, this.daysInYear(-1), "d"] }[l], v = p < 0 ? -1 : 1;
            t = this._add(c, p * f[0] + v * f[1], f[2]);
          }
          return c.date(t[0], t[1], t[2]);
        }, set: function(c, t, p) {
          this._validate(c, this.minMonth, this.minDay, s.local.invalidDate || s.regionalOptions[""].invalidDate);
          var l = p === "y" ? t : c.year(), f = p === "m" ? t : c.month(), v = p === "d" ? t : c.day();
          return (p === "y" || p === "m") && (v = Math.min(v, this.daysInMonth(l, f))), c.date(l, f, v);
        }, isValid: function(c, t, p) {
          this._validateLevel++;
          var l = this.hasYearZero || c !== 0;
          if (l) {
            var f = this.newDate(c, t, this.minDay);
            l = t >= this.minMonth && t - this.minMonth < this.monthsInYear(f) && p >= this.minDay && p - this.minDay < this.daysInMonth(f);
          }
          return this._validateLevel--, l;
        }, toJSDate: function(c, t, p) {
          var l = this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate);
          return s.instance().fromJD(this.toJD(l)).toJSDate();
        }, fromJSDate: function(c) {
          return this.fromJD(s.instance().fromJSDate(c).toJD());
        }, _validate: function(c, t, p, l) {
          if (c.year) {
            if (this._validateLevel === 0 && this.name !== c.calendar().name) throw (s.local.differentCalendars || s.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, c.calendar().local.name);
            return c;
          }
          try {
            if (this._validateLevel++, this._validateLevel === 1 && !this.isValid(c, t, p)) throw l.replace(/\{0\}/, this.local.name);
            var f = this.newDate(c, t, p);
            return this._validateLevel--, f;
          } catch (v) {
            throw this._validateLevel--, v;
          }
        } });
        function r(c) {
          this.local = this.regionalOptions[c] || this.regionalOptions[""];
        }
        r.prototype = new o(), n(r.prototype, { name: "Gregorian", jdEpoch: 17214255e-1, daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Gregorian", epochs: ["BCE", "CE"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "mm/dd/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(p) {
          var t = this._validate(p, this.minMonth, this.minDay, s.local.invalidYear || s.regionalOptions[""].invalidYear), p = t.year() + (t.year() < 0 ? 1 : 0);
          return p % 4 === 0 && (p % 100 !== 0 || p % 400 === 0);
        }, weekOfYear: function(c, t, p) {
          var l = this.newDate(c, t, p);
          return l.add(4 - (l.dayOfWeek() || 7), "d"), Math.floor((l.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(c, t) {
          var p = this._validate(c, t, this.minDay, s.local.invalidMonth || s.regionalOptions[""].invalidMonth);
          return this.daysPerMonth[p.month() - 1] + (p.month() === 2 && this.leapYear(p.year()) ? 1 : 0);
        }, weekDay: function(c, t, p) {
          return (this.dayOfWeek(c, t, p) || 7) < 6;
        }, toJD: function(c, t, p) {
          var l = this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate);
          c = l.year(), t = l.month(), p = l.day(), c < 0 && c++, t < 3 && (t += 12, c--);
          var f = Math.floor(c / 100), v = 2 - f + Math.floor(f / 4);
          return Math.floor(365.25 * (c + 4716)) + Math.floor(30.6001 * (t + 1)) + p + v - 1524.5;
        }, fromJD: function(c) {
          var t = Math.floor(c + 0.5), p = Math.floor((t - 186721625e-2) / 36524.25);
          p = t + 1 + p - Math.floor(p / 4);
          var l = p + 1524, f = Math.floor((l - 122.1) / 365.25), v = Math.floor(365.25 * f), g = Math.floor((l - v) / 30.6001), x = l - v - Math.floor(g * 30.6001), h = g - (g > 13.5 ? 13 : 1), m = f - (h > 2.5 ? 4716 : 4715);
          return m <= 0 && m--, this.newDate(m, h, x);
        }, toJSDate: function(c, t, p) {
          var l = this._validate(c, t, p, s.local.invalidDate || s.regionalOptions[""].invalidDate), f = new Date(l.year(), l.month() - 1, l.day());
          return f.setHours(0), f.setMinutes(0), f.setSeconds(0), f.setMilliseconds(0), f.setHours(f.getHours() > 12 ? f.getHours() + 2 : 0), f;
        }, fromJSDate: function(c) {
          return this.newDate(c.getFullYear(), c.getMonth() + 1, c.getDate());
        } });
        var s = k.exports = new e();
        s.cdate = a, s.baseCalendar = o, s.calendars.gregorian = r;
      }), K1 = xe(() => {
        var L = Mn(), k = An();
        L(k.regionalOptions[""], { invalidArguments: "Invalid arguments", invalidFormat: "Cannot format a date from another calendar", missingNumberAt: "Missing number at position {0}", unknownNameAt: "Unknown name at position {0}", unexpectedLiteralAt: "Unexpected literal at position {0}", unexpectedText: "Additional text found at end" }), k.local = k.regionalOptions[""], L(k.cdate.prototype, { formatDate: function(n, e) {
          return typeof n != "string" && (e = n, n = ""), this._calendar.formatDate(n || "", this, e);
        } }), L(k.baseCalendar.prototype, { UNIX_EPOCH: k.instance().newDate(1970, 1, 1).toJD(), SECS_PER_DAY: 24 * 60 * 60, TICKS_EPOCH: k.instance().jdEpoch, TICKS_PER_DAY: 24 * 60 * 60 * 1e7, ATOM: "yyyy-mm-dd", COOKIE: "D, dd M yyyy", FULL: "DD, MM d, yyyy", ISO_8601: "yyyy-mm-dd", JULIAN: "J", RFC_822: "D, d M yy", RFC_850: "DD, dd-M-yy", RFC_1036: "D, d M yy", RFC_1123: "D, d M yyyy", RFC_2822: "D, d M yyyy", RSS: "D, d M yy", TICKS: "!", TIMESTAMP: "@", W3C: "yyyy-mm-dd", formatDate: function(n, e, a) {
          if (typeof n != "string" && (a = e, e = n, n = ""), !e) return "";
          if (e.calendar() !== this) throw k.local.invalidFormat || k.regionalOptions[""].invalidFormat;
          n = n || this.local.dateFormat, a = a || {};
          for (var i = a.dayNamesShort || this.local.dayNamesShort, o = a.dayNames || this.local.dayNames, r = a.monthNumbers || this.local.monthNumbers, s = a.monthNamesShort || this.local.monthNamesShort, c = a.monthNames || this.local.monthNames, t = a.calculateWeek || this.local.calculateWeek, p = function(_, T) {
            for (var R = 1; y + R < n.length && n.charAt(y + R) === _; ) R++;
            return y += R - 1, Math.floor(R / (T || 1)) > 1;
          }, l = function(_, T, R, I) {
            var P = "" + T;
            if (p(_, I)) for (; P.length < R; ) P = "0" + P;
            return P;
          }, f = function(_, T, R, I) {
            return p(_) ? I[T] : R[T];
          }, v = this, g = function(_) {
            return typeof r == "function" ? r.call(v, _, p("m")) : m(l("m", _.month(), 2));
          }, x = function(_, T) {
            return T ? typeof c == "function" ? c.call(v, _) : c[_.month() - v.minMonth] : typeof s == "function" ? s.call(v, _) : s[_.month() - v.minMonth];
          }, h = this.local.digits, m = function(_) {
            return a.localNumbers && h ? h(_) : _;
          }, u = "", d = !1, y = 0; y < n.length; y++) if (d) n.charAt(y) === "'" && !p("'") ? d = !1 : u += n.charAt(y);
          else switch (n.charAt(y)) {
            case "d":
              u += m(l("d", e.day(), 2));
              break;
            case "D":
              u += f("D", e.dayOfWeek(), i, o);
              break;
            case "o":
              u += l("o", e.dayOfYear(), 3);
              break;
            case "w":
              u += l("w", e.weekOfYear(), 2);
              break;
            case "m":
              u += g(e);
              break;
            case "M":
              u += x(e, p("M"));
              break;
            case "y":
              u += p("y", 2) ? e.year() : (e.year() % 100 < 10 ? "0" : "") + e.year() % 100;
              break;
            case "Y":
              p("Y", 2), u += e.formatYear();
              break;
            case "J":
              u += e.toJD();
              break;
            case "@":
              u += (e.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
              break;
            case "!":
              u += (e.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
              break;
            case "'":
              p("'") ? u += "'" : d = !0;
              break;
            default:
              u += n.charAt(y);
          }
          return u;
        }, parseDate: function(n, e, a) {
          if (e == null) throw k.local.invalidArguments || k.regionalOptions[""].invalidArguments;
          if (e = typeof e == "object" ? e.toString() : e + "", e === "") return null;
          n = n || this.local.dateFormat, a = a || {};
          var i = a.shortYearCutoff || this.shortYearCutoff;
          i = typeof i != "string" ? i : this.today().year() % 100 + parseInt(i, 10);
          for (var o = a.dayNamesShort || this.local.dayNamesShort, r = a.dayNames || this.local.dayNames, s = a.parseMonth || this.local.parseMonth, c = a.monthNumbers || this.local.monthNumbers, t = a.monthNamesShort || this.local.monthNamesShort, p = a.monthNames || this.local.monthNames, l = -1, f = -1, v = -1, g = -1, x = -1, h = !1, m = !1, u = function(q, U) {
            for (var G = 1; M + G < n.length && n.charAt(M + G) === q; ) G++;
            return M += G - 1, Math.floor(G / (U || 1)) > 1;
          }, d = function(q, U) {
            var G = u(q, U), K = [2, 3, G ? 4 : 2, G ? 4 : 2, 10, 11, 20]["oyYJ@!".indexOf(q) + 1], te = new RegExp("^-?\\d{1," + K + "}"), V = e.substring(P).match(te);
            if (!V) throw (k.local.missingNumberAt || k.regionalOptions[""].missingNumberAt).replace(/\{0\}/, P);
            return P += V[0].length, parseInt(V[0], 10);
          }, y = this, _ = function() {
            if (typeof c == "function") {
              u("m");
              var q = c.call(y, e.substring(P));
              return P += q.length, q;
            }
            return d("m");
          }, T = function(q, U, G, K) {
            for (var te = u(q, K) ? G : U, V = 0; V < te.length; V++) if (e.substr(P, te[V].length).toLowerCase() === te[V].toLowerCase()) return P += te[V].length, V + y.minMonth;
            throw (k.local.unknownNameAt || k.regionalOptions[""].unknownNameAt).replace(/\{0\}/, P);
          }, R = function() {
            if (typeof p == "function") {
              var q = u("M") ? p.call(y, e.substring(P)) : t.call(y, e.substring(P));
              return P += q.length, q;
            }
            return T("M", t, p);
          }, I = function() {
            if (e.charAt(P) !== n.charAt(M)) throw (k.local.unexpectedLiteralAt || k.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, P);
            P++;
          }, P = 0, M = 0; M < n.length; M++) if (m) n.charAt(M) === "'" && !u("'") ? m = !1 : I();
          else switch (n.charAt(M)) {
            case "d":
              g = d("d");
              break;
            case "D":
              T("D", o, r);
              break;
            case "o":
              x = d("o");
              break;
            case "w":
              d("w");
              break;
            case "m":
              v = _();
              break;
            case "M":
              v = R();
              break;
            case "y":
              var B = M;
              h = !u("y", 2), M = B, f = d("y", 2);
              break;
            case "Y":
              f = d("Y", 2);
              break;
            case "J":
              l = d("J") + 0.5, e.charAt(P) === "." && (P++, d("J"));
              break;
            case "@":
              l = d("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
              break;
            case "!":
              l = d("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
              break;
            case "*":
              P = e.length;
              break;
            case "'":
              u("'") ? I() : m = !0;
              break;
            default:
              I();
          }
          if (P < e.length) throw k.local.unexpectedText || k.regionalOptions[""].unexpectedText;
          if (f === -1 ? f = this.today().year() : f < 100 && h && (f += i === -1 ? 1900 : this.today().year() - this.today().year() % 100 - (f <= i ? 0 : 100)), typeof v == "string" && (v = s.call(this, f, v)), x > -1) {
            v = 1, g = x;
            for (var z = this.daysInMonth(f, v); g > z; z = this.daysInMonth(f, v)) v++, g -= z;
          }
          return l > -1 ? this.fromJD(l) : this.newDate(f, v, g);
        }, determineDate: function(n, e, a, i, o) {
          a && typeof a != "object" && (o = i, i = a, a = null), typeof i != "string" && (o = i, i = "");
          var r = this, s = function(c) {
            try {
              return r.parseDate(i, c, o);
            } catch {
            }
            c = c.toLowerCase();
            for (var t = (c.match(/^c/) && a ? a.newDate() : null) || r.today(), p = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, l = p.exec(c); l; ) t.add(parseInt(l[1], 10), l[2] || "d"), l = p.exec(c);
            return t;
          };
          return e = e ? e.newDate() : null, n = n == null ? e : typeof n == "string" ? s(n) : typeof n == "number" ? isNaN(n) || n === 1 / 0 || n === -1 / 0 ? e : r.today().add(n, "d") : r.newDate(n), n;
        } });
      }), Q1 = xe(() => {
        var L = An(), k = Mn(), n = L.instance();
        function e(l) {
          this.local = this.regionalOptions[l || ""] || this.regionalOptions[""];
        }
        e.prototype = new L.baseCalendar(), k(e.prototype, { name: "Chinese", jdEpoch: 17214255e-1, hasYearZero: !1, minMonth: 0, firstMonth: 0, minDay: 1, regionalOptions: { "": { name: "Chinese", epochs: ["BEC", "EC"], monthNumbers: function(l, f) {
          if (typeof l == "string") {
            var v = l.match(i);
            return v ? v[0] : "";
          }
          var g = this._validateYear(l), x = l.month(), h = "" + this.toChineseMonth(g, x);
          return f && h.length < 2 && (h = "0" + h), this.isIntercalaryMonth(g, x) && (h += "i"), h;
        }, monthNames: function(l) {
          if (typeof l == "string") {
            var f = l.match(o);
            return f ? f[0] : "";
          }
          var v = this._validateYear(l), g = l.month(), x = this.toChineseMonth(v, g), h = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"][x - 1];
          return this.isIntercalaryMonth(v, g) && (h = "闰" + h), h;
        }, monthNamesShort: function(l) {
          if (typeof l == "string") {
            var f = l.match(r);
            return f ? f[0] : "";
          }
          var v = this._validateYear(l), g = l.month(), x = this.toChineseMonth(v, g), h = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"][x - 1];
          return this.isIntercalaryMonth(v, g) && (h = "闰" + h), h;
        }, parseMonth: function(l, f) {
          l = this._validateYear(l);
          var v = parseInt(f), g;
          if (isNaN(v)) f[0] === "闰" && (g = !0, f = f.substring(1)), f[f.length - 1] === "月" && (f = f.substring(0, f.length - 1)), v = 1 + ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"].indexOf(f);
          else {
            var x = f[f.length - 1];
            g = x === "i" || x === "I";
          }
          var h = this.toMonthIndex(l, v, g);
          return h;
        }, dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 1, isRTL: !1 } }, _validateYear: function(l, f) {
          if (l.year && (l = l.year()), typeof l != "number" || l < 1888 || l > 2111) throw f.replace(/\{0\}/, this.local.name);
          return l;
        }, toMonthIndex: function(l, f, v) {
          var g = this.intercalaryMonth(l), x = v && f !== g;
          if (x || f < 1 || f > 12) throw L.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var h;
          return g ? !v && f <= g ? h = f - 1 : h = f : h = f - 1, h;
        }, toChineseMonth: function(l, f) {
          l.year && (l = l.year(), f = l.month());
          var v = this.intercalaryMonth(l), g = v ? 12 : 11;
          if (f < 0 || f > g) throw L.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var x;
          return v ? f < v ? x = f + 1 : x = f : x = f + 1, x;
        }, intercalaryMonth: function(l) {
          l = this._validateYear(l);
          var f = s[l - s[0]], v = f >> 13;
          return v;
        }, isIntercalaryMonth: function(l, f) {
          l.year && (l = l.year(), f = l.month());
          var v = this.intercalaryMonth(l);
          return !!v && v === f;
        }, leapYear: function(l) {
          return this.intercalaryMonth(l) !== 0;
        }, weekOfYear: function(l, f, v) {
          var g = this._validateYear(l, L.local.invalidyear), x = c[g - c[0]], h = x >> 9 & 4095, m = x >> 5 & 15, u = x & 31, d;
          d = n.newDate(h, m, u), d.add(4 - (d.dayOfWeek() || 7), "d");
          var y = this.toJD(l, f, v) - d.toJD();
          return 1 + Math.floor(y / 7);
        }, monthsInYear: function(l) {
          return this.leapYear(l) ? 13 : 12;
        }, daysInMonth: function(l, f) {
          l.year && (f = l.month(), l = l.year()), l = this._validateYear(l);
          var v = s[l - s[0]], g = v >> 13, x = g ? 12 : 11;
          if (f > x) throw L.local.invalidMonth.replace(/\{0\}/, this.local.name);
          var h = v & 1 << 12 - f ? 30 : 29;
          return h;
        }, weekDay: function(l, f, v) {
          return (this.dayOfWeek(l, f, v) || 7) < 6;
        }, toJD: function(l, f, v) {
          var g = this._validate(l, h, v, L.local.invalidDate);
          l = this._validateYear(g.year()), f = g.month(), v = g.day();
          var x = this.isIntercalaryMonth(l, f), h = this.toChineseMonth(l, f), m = p(l, h, v, x);
          return n.toJD(m.year, m.month, m.day);
        }, fromJD: function(l) {
          var f = n.fromJD(l), v = t(f.year(), f.month(), f.day()), g = this.toMonthIndex(v.year, v.month, v.isIntercalary);
          return this.newDate(v.year, g, v.day);
        }, fromString: function(l) {
          var f = l.match(a), v = this._validateYear(+f[1]), g = +f[2], x = !!f[3], h = this.toMonthIndex(v, g, x), m = +f[4];
          return this.newDate(v, h, m);
        }, add: function(l, f, v) {
          var g = l.year(), x = l.month(), h = this.isIntercalaryMonth(g, x), m = this.toChineseMonth(g, x), u = Object.getPrototypeOf(e.prototype).add.call(this, l, f, v);
          if (v === "y") {
            var d = u.year(), y = u.month(), _ = this.isIntercalaryMonth(d, m), T = h && _ ? this.toMonthIndex(d, m, !0) : this.toMonthIndex(d, m, !1);
            T !== y && u.month(T);
          }
          return u;
        } });
        var a = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m, i = /^\d?\d[iI]?/m, o = /^闰?十?[一二三四五六七八九]?月/m, r = /^闰?十?[一二三四五六七八九]?/m;
        L.calendars.chinese = e;
        var s = [1887, 5780, 5802, 19157, 2742, 50359, 1198, 2646, 46378, 7466, 3412, 30122, 5482, 67949, 2396, 5294, 43597, 6732, 6954, 36181, 2772, 4954, 18781, 2396, 54427, 5274, 6730, 47781, 5800, 6868, 21210, 4790, 59703, 2350, 5270, 46667, 3402, 3496, 38325, 1388, 4782, 18735, 2350, 52374, 6804, 7498, 44457, 2906, 1388, 29294, 4700, 63789, 6442, 6804, 56138, 5802, 2772, 38235, 1210, 4698, 22827, 5418, 63125, 3476, 5802, 43701, 2484, 5302, 27223, 2646, 70954, 7466, 3412, 54698, 5482, 2412, 38062, 5294, 2636, 32038, 6954, 60245, 2772, 4826, 43357, 2394, 5274, 39501, 6730, 72357, 5800, 5844, 53978, 4790, 2358, 38039, 5270, 87627, 3402, 3496, 54708, 5484, 4782, 43311, 2350, 3222, 27978, 7498, 68965, 2904, 5484, 45677, 4700, 6444, 39573, 6804, 6986, 19285, 2772, 62811, 1210, 4698, 47403, 5418, 5780, 38570, 5546, 76469, 2420, 5302, 51799, 2646, 5414, 36501, 3412, 5546, 18869, 2412, 54446, 5276, 6732, 48422, 6822, 2900, 28010, 4826, 92509, 2394, 5274, 55883, 6730, 6820, 47956, 5812, 2778, 18779, 2358, 62615, 5270, 5450, 46757, 3492, 5556, 27318, 4718, 67887, 2350, 3222, 52554, 7498, 3428, 38252, 5468, 4700, 31022, 6444, 64149, 6804, 6986, 43861, 2772, 5338, 35421, 2650, 70955, 5418, 5780, 54954, 5546, 2740, 38074, 5302, 2646, 29991, 3366, 61011, 3412, 5546, 43445, 2412, 5294, 35406, 6732, 72998, 6820, 6996, 52586, 2778, 2396, 38045, 5274, 6698, 23333, 6820, 64338, 5812, 2746, 43355, 2358, 5270, 39499, 5450, 79525, 3492, 5548], c = [1887, 966732, 967231, 967733, 968265, 968766, 969297, 969798, 970298, 970829, 971330, 971830, 972362, 972863, 973395, 973896, 974397, 974928, 975428, 975929, 976461, 976962, 977462, 977994, 978494, 979026, 979526, 980026, 980558, 981059, 981559, 982091, 982593, 983124, 983624, 984124, 984656, 985157, 985656, 986189, 986690, 987191, 987722, 988222, 988753, 989254, 989754, 990286, 990788, 991288, 991819, 992319, 992851, 993352, 993851, 994383, 994885, 995385, 995917, 996418, 996918, 997450, 997949, 998481, 998982, 999483, 1000014, 1000515, 1001016, 1001548, 1002047, 1002578, 1003080, 1003580, 1004111, 1004613, 1005113, 1005645, 1006146, 1006645, 1007177, 1007678, 1008209, 1008710, 1009211, 1009743, 1010243, 1010743, 1011275, 1011775, 1012306, 1012807, 1013308, 1013840, 1014341, 1014841, 1015373, 1015874, 1016404, 1016905, 1017405, 1017937, 1018438, 1018939, 1019471, 1019972, 1020471, 1021002, 1021503, 1022035, 1022535, 1023036, 1023568, 1024069, 1024568, 1025100, 1025601, 1026102, 1026633, 1027133, 1027666, 1028167, 1028666, 1029198, 1029699, 1030199, 1030730, 1031231, 1031763, 1032264, 1032764, 1033296, 1033797, 1034297, 1034828, 1035329, 1035830, 1036362, 1036861, 1037393, 1037894, 1038394, 1038925, 1039427, 1039927, 1040459, 1040959, 1041491, 1041992, 1042492, 1043023, 1043524, 1044024, 1044556, 1045057, 1045558, 1046090, 1046590, 1047121, 1047622, 1048122, 1048654, 1049154, 1049655, 1050187, 1050689, 1051219, 1051720, 1052220, 1052751, 1053252, 1053752, 1054284, 1054786, 1055285, 1055817, 1056317, 1056849, 1057349, 1057850, 1058382, 1058883, 1059383, 1059915, 1060415, 1060947, 1061447, 1061947, 1062479, 1062981, 1063480, 1064012, 1064514, 1065014, 1065545, 1066045, 1066577, 1067078, 1067578, 1068110, 1068611, 1069112, 1069642, 1070142, 1070674, 1071175, 1071675, 1072207, 1072709, 1073209, 1073740, 1074241, 1074741, 1075273, 1075773, 1076305, 1076807, 1077308, 1077839, 1078340, 1078840, 1079372, 1079871, 1080403, 1080904];
        function t(l, f, v, g) {
          var x, h;
          if (typeof l == "object") x = l, h = f || {};
          else {
            var m = typeof l == "number" && l >= 1888 && l <= 2111;
            if (!m) throw new Error("Solar year outside range 1888-2111");
            var u = typeof f == "number" && f >= 1 && f <= 12;
            if (!u) throw new Error("Solar month outside range 1 - 12");
            var d = typeof v == "number" && v >= 1 && v <= 31;
            if (!d) throw new Error("Solar day outside range 1 - 31");
            x = { year: l, month: f, day: v }, h = {};
          }
          var y = c[x.year - c[0]], _ = x.year << 9 | x.month << 5 | x.day;
          h.year = _ >= y ? x.year : x.year - 1, y = c[h.year - c[0]];
          var T = y >> 9 & 4095, R = y >> 5 & 15, I = y & 31, P, M = new Date(T, R - 1, I), B = new Date(x.year, x.month - 1, x.day);
          P = Math.round((B - M) / (24 * 3600 * 1e3));
          var z = s[h.year - s[0]], q;
          for (q = 0; q < 13; q++) {
            var U = z & 1 << 12 - q ? 30 : 29;
            if (P < U) break;
            P -= U;
          }
          var G = z >> 13;
          return !G || q < G ? (h.isIntercalary = !1, h.month = 1 + q) : q === G ? (h.isIntercalary = !0, h.month = q) : (h.isIntercalary = !1, h.month = q), h.day = 1 + P, h;
        }
        function p(l, f, v, g, x) {
          var h, m;
          if (typeof l == "object") m = l, h = f || {};
          else {
            var u = typeof l == "number" && l >= 1888 && l <= 2111;
            if (!u) throw new Error("Lunar year outside range 1888-2111");
            var d = typeof f == "number" && f >= 1 && f <= 12;
            if (!d) throw new Error("Lunar month outside range 1 - 12");
            var y = typeof v == "number" && v >= 1 && v <= 30;
            if (!y) throw new Error("Lunar day outside range 1 - 30");
            var _;
            typeof g == "object" ? (_ = !1, h = g) : (_ = !!g, h = {}), m = { year: l, month: f, day: v, isIntercalary: _ };
          }
          var T;
          T = m.day - 1;
          var R = s[m.year - s[0]], I = R >> 13, P;
          I && (m.month > I || m.isIntercalary) ? P = m.month : P = m.month - 1;
          for (var M = 0; M < P; M++) {
            var B = R & 1 << 12 - M ? 30 : 29;
            T += B;
          }
          var z = c[m.year - c[0]], q = z >> 9 & 4095, U = z >> 5 & 15, G = z & 31, K = new Date(q, U - 1, G + T);
          return h.year = K.getFullYear(), h.month = 1 + K.getMonth(), h.day = K.getDate(), h;
        }
      }), ev = xe(() => {
        var L = An(), k = Mn();
        function n(e) {
          this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Coptic", jdEpoch: 18250295e-1, daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Coptic", epochs: ["BAM", "AM"], monthNames: ["Thout", "Paopi", "Hathor", "Koiak", "Tobi", "Meshir", "Paremhat", "Paremoude", "Pashons", "Paoni", "Epip", "Mesori", "Pi Kogi Enavot"], monthNamesShort: ["Tho", "Pao", "Hath", "Koi", "Tob", "Mesh", "Pat", "Pad", "Pash", "Pao", "Epi", "Meso", "PiK"], dayNames: ["Tkyriaka", "Pesnau", "Pshoment", "Peftoou", "Ptiou", "Psoou", "Psabbaton"], dayNamesShort: ["Tky", "Pes", "Psh", "Pef", "Pti", "Pso", "Psa"], dayNamesMin: ["Tk", "Pes", "Psh", "Pef", "Pt", "Pso", "Psa"], digits: null, dateFormat: "dd/mm/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(i) {
          var a = this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), i = a.year() + (a.year() < 0 ? 1 : 0);
          return i % 4 === 3 || i % 4 === -1;
        }, monthsInYear: function(e) {
          return this._validate(e, this.minMonth, this.minDay, L.local.invalidYear || L.regionalOptions[""].invalidYear), 13;
        }, weekOfYear: function(e, a, i) {
          var o = this.newDate(e, a, i);
          return o.add(-o.dayOfWeek(), "d"), Math.floor((o.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(e, a) {
          var i = this._validate(e, a, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[i.month() - 1] + (i.month() === 13 && this.leapYear(i.year()) ? 1 : 0);
        }, weekDay: function(e, a, i) {
          return (this.dayOfWeek(e, a, i) || 7) < 6;
        }, toJD: function(e, a, i) {
          var o = this._validate(e, a, i, L.local.invalidDate);
          return e = o.year(), e < 0 && e++, o.day() + (o.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
        }, fromJD: function(e) {
          var a = Math.floor(e) + 0.5 - this.jdEpoch, i = Math.floor((a - Math.floor((a + 366) / 1461)) / 365) + 1;
          i <= 0 && i--, a = Math.floor(e) + 0.5 - this.newDate(i, 1, 1).toJD();
          var o = Math.floor(a / 30) + 1, r = a - (o - 1) * 30 + 1;
          return this.newDate(i, o, r);
        } }), L.calendars.coptic = n;
      }), tv = xe(() => {
        var L = An(), k = Mn();
        function n(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Discworld", jdEpoch: 17214255e-1, daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Discworld", epochs: ["BUC", "UC"], monthNames: ["Ick", "Offle", "February", "March", "April", "May", "June", "Grune", "August", "Spune", "Sektober", "Ember", "December"], monthNamesShort: ["Ick", "Off", "Feb", "Mar", "Apr", "May", "Jun", "Gru", "Aug", "Spu", "Sek", "Emb", "Dec"], dayNames: ["Sunday", "Octeday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Oct", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Oc", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 2, isRTL: !1 } }, leapYear: function(a) {
          return this._validate(a, this.minMonth, this.minDay, L.local.invalidYear), !1;
        }, monthsInYear: function(a) {
          return this._validate(a, this.minMonth, this.minDay, L.local.invalidYear), 13;
        }, daysInYear: function(a) {
          return this._validate(a, this.minMonth, this.minDay, L.local.invalidYear), 400;
        }, weekOfYear: function(a, i, o) {
          var r = this.newDate(a, i, o);
          return r.add(-r.dayOfWeek(), "d"), Math.floor((r.dayOfYear() - 1) / 8) + 1;
        }, daysInMonth: function(a, i) {
          var o = this._validate(a, i, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[o.month() - 1];
        }, daysInWeek: function() {
          return 8;
        }, dayOfWeek: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          return (r.day() + 1) % 8;
        }, weekDay: function(a, i, o) {
          var r = this.dayOfWeek(a, i, o);
          return r >= 2 && r <= 6;
        }, extraInfo: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          return { century: e[Math.floor((r.year() - 1) / 100) + 1] || "" };
        }, toJD: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          return a = r.year() + (r.year() < 0 ? 1 : 0), i = r.month(), o = r.day(), o + (i > 1 ? 16 : 0) + (i > 2 ? (i - 2) * 32 : 0) + (a - 1) * 400 + this.jdEpoch - 1;
        }, fromJD: function(a) {
          a = Math.floor(a + 0.5) - Math.floor(this.jdEpoch) - 1;
          var i = Math.floor(a / 400) + 1;
          a -= (i - 1) * 400, a += a > 15 ? 16 : 0;
          var o = Math.floor(a / 32) + 1, r = a - (o - 1) * 32 + 1;
          return this.newDate(i <= 0 ? i - 1 : i, o, r);
        } });
        var e = { 20: "Fruitbat", 21: "Anchovy" };
        L.calendars.discworld = n;
      }), rv = xe(() => {
        var L = An(), k = Mn();
        function n(e) {
          this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Ethiopian", jdEpoch: 17242205e-1, daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Ethiopian", epochs: ["BEE", "EE"], monthNames: ["Meskerem", "Tikemet", "Hidar", "Tahesas", "Tir", "Yekatit", "Megabit", "Miazia", "Genbot", "Sene", "Hamle", "Nehase", "Pagume"], monthNamesShort: ["Mes", "Tik", "Hid", "Tah", "Tir", "Yek", "Meg", "Mia", "Gen", "Sen", "Ham", "Neh", "Pag"], dayNames: ["Ehud", "Segno", "Maksegno", "Irob", "Hamus", "Arb", "Kidame"], dayNamesShort: ["Ehu", "Seg", "Mak", "Iro", "Ham", "Arb", "Kid"], dayNamesMin: ["Eh", "Se", "Ma", "Ir", "Ha", "Ar", "Ki"], digits: null, dateFormat: "dd/mm/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(i) {
          var a = this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), i = a.year() + (a.year() < 0 ? 1 : 0);
          return i % 4 === 3 || i % 4 === -1;
        }, monthsInYear: function(e) {
          return this._validate(e, this.minMonth, this.minDay, L.local.invalidYear || L.regionalOptions[""].invalidYear), 13;
        }, weekOfYear: function(e, a, i) {
          var o = this.newDate(e, a, i);
          return o.add(-o.dayOfWeek(), "d"), Math.floor((o.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(e, a) {
          var i = this._validate(e, a, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[i.month() - 1] + (i.month() === 13 && this.leapYear(i.year()) ? 1 : 0);
        }, weekDay: function(e, a, i) {
          return (this.dayOfWeek(e, a, i) || 7) < 6;
        }, toJD: function(e, a, i) {
          var o = this._validate(e, a, i, L.local.invalidDate);
          return e = o.year(), e < 0 && e++, o.day() + (o.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
        }, fromJD: function(e) {
          var a = Math.floor(e) + 0.5 - this.jdEpoch, i = Math.floor((a - Math.floor((a + 366) / 1461)) / 365) + 1;
          i <= 0 && i--, a = Math.floor(e) + 0.5 - this.newDate(i, 1, 1).toJD();
          var o = Math.floor(a / 30) + 1, r = a - (o - 1) * 30 + 1;
          return this.newDate(i, o, r);
        } }), L.calendars.ethiopian = n;
      }), nv = xe(() => {
        var L = An(), k = Mn();
        function n(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Hebrew", jdEpoch: 347995.5, daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29], hasYearZero: !1, minMonth: 1, firstMonth: 7, minDay: 1, regionalOptions: { "": { name: "Hebrew", epochs: ["BAM", "AM"], monthNames: ["Nisan", "Iyar", "Sivan", "Tammuz", "Av", "Elul", "Tishrei", "Cheshvan", "Kislev", "Tevet", "Shevat", "Adar", "Adar II"], monthNamesShort: ["Nis", "Iya", "Siv", "Tam", "Av", "Elu", "Tis", "Che", "Kis", "Tev", "She", "Ada", "Ad2"], dayNames: ["Yom Rishon", "Yom Sheni", "Yom Shlishi", "Yom Revi'i", "Yom Chamishi", "Yom Shishi", "Yom Shabbat"], dayNamesShort: ["Ris", "She", "Shl", "Rev", "Cha", "Shi", "Sha"], dayNamesMin: ["Ri", "She", "Shl", "Re", "Ch", "Shi", "Sha"], digits: null, dateFormat: "dd/mm/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(a) {
          var i = this._validate(a, this.minMonth, this.minDay, L.local.invalidYear);
          return this._leapYear(i.year());
        }, _leapYear: function(a) {
          return a = a < 0 ? a + 1 : a, e(a * 7 + 1, 19) < 7;
        }, monthsInYear: function(a) {
          return this._validate(a, this.minMonth, this.minDay, L.local.invalidYear), this._leapYear(a.year ? a.year() : a) ? 13 : 12;
        }, weekOfYear: function(a, i, o) {
          var r = this.newDate(a, i, o);
          return r.add(-r.dayOfWeek(), "d"), Math.floor((r.dayOfYear() - 1) / 7) + 1;
        }, daysInYear: function(a) {
          var i = this._validate(a, this.minMonth, this.minDay, L.local.invalidYear);
          return a = i.year(), this.toJD(a === -1 ? 1 : a + 1, 7, 1) - this.toJD(a, 7, 1);
        }, daysInMonth: function(a, i) {
          return a.year && (i = a.month(), a = a.year()), this._validate(a, i, this.minDay, L.local.invalidMonth), i === 12 && this.leapYear(a) || i === 8 && e(this.daysInYear(a), 10) === 5 ? 30 : i === 9 && e(this.daysInYear(a), 10) === 3 ? 29 : this.daysPerMonth[i - 1];
        }, weekDay: function(a, i, o) {
          return this.dayOfWeek(a, i, o) !== 6;
        }, extraInfo: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          return { yearType: (this.leapYear(r) ? "embolismic" : "common") + " " + ["deficient", "regular", "complete"][this.daysInYear(r) % 10 - 3] };
        }, toJD: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          a = r.year(), i = r.month(), o = r.day();
          var s = a <= 0 ? a + 1 : a, c = this.jdEpoch + this._delay1(s) + this._delay2(s) + o + 1;
          if (i < 7) {
            for (var t = 7; t <= this.monthsInYear(a); t++) c += this.daysInMonth(a, t);
            for (var t = 1; t < i; t++) c += this.daysInMonth(a, t);
          } else for (var t = 7; t < i; t++) c += this.daysInMonth(a, t);
          return c;
        }, _delay1: function(a) {
          var i = Math.floor((235 * a - 234) / 19), o = 12084 + 13753 * i, r = i * 29 + Math.floor(o / 25920);
          return e(3 * (r + 1), 7) < 3 && r++, r;
        }, _delay2: function(a) {
          var i = this._delay1(a - 1), o = this._delay1(a), r = this._delay1(a + 1);
          return r - o === 356 ? 2 : o - i === 382 ? 1 : 0;
        }, fromJD: function(a) {
          a = Math.floor(a) + 0.5;
          for (var i = Math.floor((a - this.jdEpoch) * 98496 / 35975351) - 1; a >= this.toJD(i === -1 ? 1 : i + 1, 7, 1); ) i++;
          for (var o = a < this.toJD(i, 1, 1) ? 7 : 1; a > this.toJD(i, o, this.daysInMonth(i, o)); ) o++;
          var r = a - this.toJD(i, o, 1) + 1;
          return this.newDate(i, o, r);
        } });
        function e(a, i) {
          return a - i * Math.floor(a / i);
        }
        L.calendars.hebrew = n;
      }), av = xe(() => {
        var L = An(), k = Mn();
        function n(e) {
          this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Islamic", jdEpoch: 19484395e-1, daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Islamic", epochs: ["BH", "AH"], monthNames: ["Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-thani", "Jumada al-awwal", "Jumada al-thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"], monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"], dayNames: ["Yawm al-ahad", "Yawm al-ithnayn", "Yawm ath-thulaathaa'", "Yawm al-arbi'aa'", "Yawm al-khamīs", "Yawm al-jum'a", "Yawm as-sabt"], dayNamesShort: ["Aha", "Ith", "Thu", "Arb", "Kha", "Jum", "Sab"], dayNamesMin: ["Ah", "It", "Th", "Ar", "Kh", "Ju", "Sa"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 6, isRTL: !1 } }, leapYear: function(e) {
          var a = this._validate(e, this.minMonth, this.minDay, L.local.invalidYear);
          return (a.year() * 11 + 14) % 30 < 11;
        }, weekOfYear: function(e, a, i) {
          var o = this.newDate(e, a, i);
          return o.add(-o.dayOfWeek(), "d"), Math.floor((o.dayOfYear() - 1) / 7) + 1;
        }, daysInYear: function(e) {
          return this.leapYear(e) ? 355 : 354;
        }, daysInMonth: function(e, a) {
          var i = this._validate(e, a, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[i.month() - 1] + (i.month() === 12 && this.leapYear(i.year()) ? 1 : 0);
        }, weekDay: function(e, a, i) {
          return this.dayOfWeek(e, a, i) !== 5;
        }, toJD: function(e, a, i) {
          var o = this._validate(e, a, i, L.local.invalidDate);
          return e = o.year(), a = o.month(), i = o.day(), e = e <= 0 ? e + 1 : e, i + Math.ceil(29.5 * (a - 1)) + (e - 1) * 354 + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
        }, fromJD: function(e) {
          e = Math.floor(e) + 0.5;
          var a = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
          a = a <= 0 ? a - 1 : a;
          var i = Math.min(12, Math.ceil((e - 29 - this.toJD(a, 1, 1)) / 29.5) + 1), o = e - this.toJD(a, i, 1) + 1;
          return this.newDate(a, i, o);
        } }), L.calendars.islamic = n;
      }), iv = xe(() => {
        var L = An(), k = Mn();
        function n(e) {
          this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Julian", jdEpoch: 17214235e-1, daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Julian", epochs: ["BC", "AD"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "mm/dd/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(i) {
          var a = this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), i = a.year() < 0 ? a.year() + 1 : a.year();
          return i % 4 === 0;
        }, weekOfYear: function(e, a, i) {
          var o = this.newDate(e, a, i);
          return o.add(4 - (o.dayOfWeek() || 7), "d"), Math.floor((o.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(e, a) {
          var i = this._validate(e, a, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[i.month() - 1] + (i.month() === 2 && this.leapYear(i.year()) ? 1 : 0);
        }, weekDay: function(e, a, i) {
          return (this.dayOfWeek(e, a, i) || 7) < 6;
        }, toJD: function(e, a, i) {
          var o = this._validate(e, a, i, L.local.invalidDate);
          return e = o.year(), a = o.month(), i = o.day(), e < 0 && e++, a <= 2 && (e--, a += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (a + 1)) + i - 1524.5;
        }, fromJD: function(e) {
          var a = Math.floor(e + 0.5), i = a + 1524, o = Math.floor((i - 122.1) / 365.25), r = Math.floor(365.25 * o), s = Math.floor((i - r) / 30.6001), c = s - Math.floor(s < 14 ? 1 : 13), t = o - Math.floor(c > 2 ? 4716 : 4715), p = i - r - Math.floor(30.6001 * s);
          return t <= 0 && t--, this.newDate(t, c, p);
        } }), L.calendars.julian = n;
      }), ov = xe(() => {
        var L = An(), k = Mn();
        function n(i) {
          this.local = this.regionalOptions[i || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Mayan", jdEpoch: 584282.5, hasYearZero: !0, minMonth: 0, firstMonth: 0, minDay: 0, regionalOptions: { "": { name: "Mayan", epochs: ["", ""], monthNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"], monthNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17"], dayNames: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"], dayNamesShort: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"], dayNamesMin: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"], digits: null, dateFormat: "YYYY.m.d", firstDay: 0, isRTL: !1, haabMonths: ["Pop", "Uo", "Zip", "Zotz", "Tzec", "Xul", "Yaxkin", "Mol", "Chen", "Yax", "Zac", "Ceh", "Mac", "Kankin", "Muan", "Pax", "Kayab", "Cumku", "Uayeb"], tzolkinMonths: ["Imix", "Ik", "Akbal", "Kan", "Chicchan", "Cimi", "Manik", "Lamat", "Muluc", "Oc", "Chuen", "Eb", "Ben", "Ix", "Men", "Cib", "Caban", "Etznab", "Cauac", "Ahau"] } }, leapYear: function(i) {
          return this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), !1;
        }, formatYear: function(i) {
          var o = this._validate(i, this.minMonth, this.minDay, L.local.invalidYear);
          i = o.year();
          var r = Math.floor(i / 400);
          i = i % 400, i += i < 0 ? 400 : 0;
          var s = Math.floor(i / 20);
          return r + "." + s + "." + i % 20;
        }, forYear: function(i) {
          if (i = i.split("."), i.length < 3) throw "Invalid Mayan year";
          for (var o = 0, r = 0; r < i.length; r++) {
            var s = parseInt(i[r], 10);
            if (Math.abs(s) > 19 || r > 0 && s < 0) throw "Invalid Mayan year";
            o = o * 20 + s;
          }
          return o;
        }, monthsInYear: function(i) {
          return this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), 18;
        }, weekOfYear: function(i, o, r) {
          return this._validate(i, o, r, L.local.invalidDate), 0;
        }, daysInYear: function(i) {
          return this._validate(i, this.minMonth, this.minDay, L.local.invalidYear), 360;
        }, daysInMonth: function(i, o) {
          return this._validate(i, o, this.minDay, L.local.invalidMonth), 20;
        }, daysInWeek: function() {
          return 5;
        }, dayOfWeek: function(i, o, r) {
          var s = this._validate(i, o, r, L.local.invalidDate);
          return s.day();
        }, weekDay: function(i, o, r) {
          return this._validate(i, o, r, L.local.invalidDate), !0;
        }, extraInfo: function(i, o, r) {
          var s = this._validate(i, o, r, L.local.invalidDate), c = s.toJD(), t = this._toHaab(c), p = this._toTzolkin(c);
          return { haabMonthName: this.local.haabMonths[t[0] - 1], haabMonth: t[0], haabDay: t[1], tzolkinDayName: this.local.tzolkinMonths[p[0] - 1], tzolkinDay: p[0], tzolkinTrecena: p[1] };
        }, _toHaab: function(i) {
          i -= this.jdEpoch;
          var o = e(i + 8 + 17 * 20, 365);
          return [Math.floor(o / 20) + 1, e(o, 20)];
        }, _toTzolkin: function(i) {
          return i -= this.jdEpoch, [a(i + 20, 20), a(i + 4, 13)];
        }, toJD: function(i, o, r) {
          var s = this._validate(i, o, r, L.local.invalidDate);
          return s.day() + s.month() * 20 + s.year() * 360 + this.jdEpoch;
        }, fromJD: function(i) {
          i = Math.floor(i) + 0.5 - this.jdEpoch;
          var o = Math.floor(i / 360);
          i = i % 360, i += i < 0 ? 360 : 0;
          var r = Math.floor(i / 20), s = i % 20;
          return this.newDate(o, r, s);
        } });
        function e(i, o) {
          return i - o * Math.floor(i / o);
        }
        function a(i, o) {
          return e(i - 1, o) + 1;
        }
        L.calendars.mayan = n;
      }), lv = xe(() => {
        var L = An(), k = Mn();
        function n(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar();
        var e = L.instance("gregorian");
        k(n.prototype, { name: "Nanakshahi", jdEpoch: 22576735e-1, daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Nanakshahi", epochs: ["BN", "AN"], monthNames: ["Chet", "Vaisakh", "Jeth", "Harh", "Sawan", "Bhadon", "Assu", "Katak", "Maghar", "Poh", "Magh", "Phagun"], monthNamesShort: ["Che", "Vai", "Jet", "Har", "Saw", "Bha", "Ass", "Kat", "Mgr", "Poh", "Mgh", "Pha"], dayNames: ["Somvaar", "Mangalvar", "Budhvaar", "Veervaar", "Shukarvaar", "Sanicharvaar", "Etvaar"], dayNamesShort: ["Som", "Mangal", "Budh", "Veer", "Shukar", "Sanichar", "Et"], dayNamesMin: ["So", "Ma", "Bu", "Ve", "Sh", "Sa", "Et"], digits: null, dateFormat: "dd-mm-yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(a) {
          var i = this._validate(a, this.minMonth, this.minDay, L.local.invalidYear || L.regionalOptions[""].invalidYear);
          return e.leapYear(i.year() + (i.year() < 1 ? 1 : 0) + 1469);
        }, weekOfYear: function(a, i, o) {
          var r = this.newDate(a, i, o);
          return r.add(1 - (r.dayOfWeek() || 7), "d"), Math.floor((r.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(a, i) {
          var o = this._validate(a, i, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[o.month() - 1] + (o.month() === 12 && this.leapYear(o.year()) ? 1 : 0);
        }, weekDay: function(a, i, o) {
          return (this.dayOfWeek(a, i, o) || 7) < 6;
        }, toJD: function(s, i, o) {
          var r = this._validate(s, i, o, L.local.invalidMonth), s = r.year();
          s < 0 && s++;
          for (var c = r.day(), t = 1; t < r.month(); t++) c += this.daysPerMonth[t - 1];
          return c + e.toJD(s + 1468, 3, 13);
        }, fromJD: function(a) {
          a = Math.floor(a + 0.5);
          for (var i = Math.floor((a - (this.jdEpoch - 1)) / 366); a >= this.toJD(i + 1, 1, 1); ) i++;
          for (var o = a - Math.floor(this.toJD(i, 1, 1) + 0.5) + 1, r = 1; o > this.daysInMonth(i, r); ) o -= this.daysInMonth(i, r), r++;
          return this.newDate(i, r, o);
        } }), L.calendars.nanakshahi = n;
      }), sv = xe(() => {
        var L = An(), k = Mn();
        function n(e) {
          this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Nepali", jdEpoch: 17007095e-1, daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, daysPerYear: 365, regionalOptions: { "": { name: "Nepali", epochs: ["BBS", "ABS"], monthNames: ["Baisakh", "Jestha", "Ashadh", "Shrawan", "Bhadra", "Ashwin", "Kartik", "Mangsir", "Paush", "Mangh", "Falgun", "Chaitra"], monthNamesShort: ["Bai", "Je", "As", "Shra", "Bha", "Ash", "Kar", "Mang", "Pau", "Ma", "Fal", "Chai"], dayNames: ["Aaitabaar", "Sombaar", "Manglbaar", "Budhabaar", "Bihibaar", "Shukrabaar", "Shanibaar"], dayNamesShort: ["Aaita", "Som", "Mangl", "Budha", "Bihi", "Shukra", "Shani"], dayNamesMin: ["Aai", "So", "Man", "Bu", "Bi", "Shu", "Sha"], digits: null, dateFormat: "dd/mm/yyyy", firstDay: 1, isRTL: !1 } }, leapYear: function(e) {
          return this.daysInYear(e) !== this.daysPerYear;
        }, weekOfYear: function(e, a, i) {
          var o = this.newDate(e, a, i);
          return o.add(-o.dayOfWeek(), "d"), Math.floor((o.dayOfYear() - 1) / 7) + 1;
        }, daysInYear: function(e) {
          var a = this._validate(e, this.minMonth, this.minDay, L.local.invalidYear);
          if (e = a.year(), typeof this.NEPALI_CALENDAR_DATA[e] > "u") return this.daysPerYear;
          for (var i = 0, o = this.minMonth; o <= 12; o++) i += this.NEPALI_CALENDAR_DATA[e][o];
          return i;
        }, daysInMonth: function(e, a) {
          return e.year && (a = e.month(), e = e.year()), this._validate(e, a, this.minDay, L.local.invalidMonth), typeof this.NEPALI_CALENDAR_DATA[e] > "u" ? this.daysPerMonth[a - 1] : this.NEPALI_CALENDAR_DATA[e][a];
        }, weekDay: function(e, a, i) {
          return this.dayOfWeek(e, a, i) !== 6;
        }, toJD: function(e, a, i) {
          var o = this._validate(e, a, i, L.local.invalidDate);
          e = o.year(), a = o.month(), i = o.day();
          var r = L.instance(), s = 0, c = a, t = e;
          this._createMissingCalendarData(e);
          var p = e - (c > 9 || c === 9 && i >= this.NEPALI_CALENDAR_DATA[t][0] ? 56 : 57);
          for (a !== 9 && (s = i, c--); c !== 9; ) c <= 0 && (c = 12, t--), s += this.NEPALI_CALENDAR_DATA[t][c], c--;
          return a === 9 ? (s += i - this.NEPALI_CALENDAR_DATA[t][0], s < 0 && (s += r.daysInYear(p))) : s += this.NEPALI_CALENDAR_DATA[t][9] - this.NEPALI_CALENDAR_DATA[t][0], r.newDate(p, 1, 1).add(s, "d").toJD();
        }, fromJD: function(e) {
          var a = L.instance(), i = a.fromJD(e), o = i.year(), r = i.dayOfYear(), s = o + 56;
          this._createMissingCalendarData(s);
          for (var c = 9, t = this.NEPALI_CALENDAR_DATA[s][0], p = this.NEPALI_CALENDAR_DATA[s][c] - t + 1; r > p; ) c++, c > 12 && (c = 1, s++), p += this.NEPALI_CALENDAR_DATA[s][c];
          var l = this.NEPALI_CALENDAR_DATA[s][c] - (p - r);
          return this.newDate(s, c, l);
        }, _createMissingCalendarData: function(e) {
          var a = this.daysPerMonth.slice(0);
          a.unshift(17);
          for (var i = e - 1; i < e + 2; i++) typeof this.NEPALI_CALENDAR_DATA[i] > "u" && (this.NEPALI_CALENDAR_DATA[i] = a);
        }, NEPALI_CALENDAR_DATA: { 1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30], 1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30], 1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30], 1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31], 1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], 1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], 1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2e3: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], 2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30], 2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31], 2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31], 2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32], 2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], 2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30], 2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30], 2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31], 2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31], 2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30], 2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31], 2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31], 2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30], 2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30], 2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30], 2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30], 2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30], 2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30], 2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30], 2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30], 2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30], 2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30], 2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30], 2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30], 2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30], 2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31], 2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30], 2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30] } }), L.calendars.nepali = n;
      }), uv = xe(() => {
        var L = An(), k = Mn();
        function n(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        function e(a) {
          var i = a - 475;
          a < 0 && i++;
          var o = 0.242197, r = o * i, s = o * (i + 1), c = r - Math.floor(r), t = s - Math.floor(s);
          return c > t;
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "Persian", jdEpoch: 19483205e-1, daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Persian", epochs: ["BP", "AP"], monthNames: ["Farvardin", "Ordibehesht", "Khordad", "Tir", "Mordad", "Shahrivar", "Mehr", "Aban", "Azar", "Dey", "Bahman", "Esfand"], monthNamesShort: ["Far", "Ord", "Kho", "Tir", "Mor", "Sha", "Meh", "Aba", "Aza", "Dey", "Bah", "Esf"], dayNames: ["Yekshanbeh", "Doshanbeh", "Seshanbeh", "Chahārshanbeh", "Panjshanbeh", "Jom'eh", "Shanbeh"], dayNamesShort: ["Yek", "Do", "Se", "Cha", "Panj", "Jom", "Sha"], dayNamesMin: ["Ye", "Do", "Se", "Ch", "Pa", "Jo", "Sh"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 6, isRTL: !1 } }, leapYear: function(a) {
          var i = this._validate(a, this.minMonth, this.minDay, L.local.invalidYear);
          return e(i.year());
        }, weekOfYear: function(a, i, o) {
          var r = this.newDate(a, i, o);
          return r.add(-((r.dayOfWeek() + 1) % 7), "d"), Math.floor((r.dayOfYear() - 1) / 7) + 1;
        }, daysInMonth: function(a, i) {
          var o = this._validate(a, i, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[o.month() - 1] + (o.month() === 12 && this.leapYear(o.year()) ? 1 : 0);
        }, weekDay: function(a, i, o) {
          return this.dayOfWeek(a, i, o) !== 5;
        }, toJD: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate);
          a = r.year(), i = r.month(), o = r.day();
          var s = 0;
          if (a > 0) for (var c = 1; c < a; c++) e(c) && s++;
          else if (a < 0) for (var c = a; c < 0; c++) e(c) && s--;
          return o + (i <= 7 ? (i - 1) * 31 : (i - 1) * 30 + 6) + (a > 0 ? a - 1 : a) * 365 + s + this.jdEpoch - 1;
        }, fromJD: function(a) {
          a = Math.floor(a) + 0.5;
          var i = 475 + (a - this.toJD(475, 1, 1)) / 365.242197, o = Math.floor(i);
          o <= 0 && o--, a > this.toJD(o, 12, e(o) ? 30 : 29) && (o++, o === 0 && o++);
          var r = a - this.toJD(o, 1, 1) + 1, s = r <= 186 ? Math.ceil(r / 31) : Math.ceil((r - 6) / 30), c = a - this.toJD(o, s, 1) + 1;
          return this.newDate(o, s, c);
        } }), L.calendars.persian = n, L.calendars.jalali = n;
      }), cv = xe(() => {
        var L = An(), k = Mn(), n = L.instance();
        function e(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        e.prototype = new L.baseCalendar(), k(e.prototype, { name: "Taiwan", jdEpoch: 24194025e-1, yearsOffset: 1911, daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Taiwan", epochs: ["BROC", "ROC"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 1, isRTL: !1 } }, leapYear: function(o) {
          var i = this._validate(o, this.minMonth, this.minDay, L.local.invalidYear), o = this._t2gYear(i.year());
          return n.leapYear(o);
        }, weekOfYear: function(s, i, o) {
          var r = this._validate(s, this.minMonth, this.minDay, L.local.invalidYear), s = this._t2gYear(r.year());
          return n.weekOfYear(s, r.month(), r.day());
        }, daysInMonth: function(a, i) {
          var o = this._validate(a, i, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[o.month() - 1] + (o.month() === 2 && this.leapYear(o.year()) ? 1 : 0);
        }, weekDay: function(a, i, o) {
          return (this.dayOfWeek(a, i, o) || 7) < 6;
        }, toJD: function(s, i, o) {
          var r = this._validate(s, i, o, L.local.invalidDate), s = this._t2gYear(r.year());
          return n.toJD(s, r.month(), r.day());
        }, fromJD: function(a) {
          var i = n.fromJD(a), o = this._g2tYear(i.year());
          return this.newDate(o, i.month(), i.day());
        }, _t2gYear: function(a) {
          return a + this.yearsOffset + (a >= -this.yearsOffset && a <= -1 ? 1 : 0);
        }, _g2tYear: function(a) {
          return a - this.yearsOffset - (a >= 1 && a <= this.yearsOffset ? 1 : 0);
        } }), L.calendars.taiwan = e;
      }), fv = xe(() => {
        var L = An(), k = Mn(), n = L.instance();
        function e(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        e.prototype = new L.baseCalendar(), k(e.prototype, { name: "Thai", jdEpoch: 15230985e-1, yearsOffset: 543, daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Thai", epochs: ["BBE", "BE"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], digits: null, dateFormat: "dd/mm/yyyy", firstDay: 0, isRTL: !1 } }, leapYear: function(o) {
          var i = this._validate(o, this.minMonth, this.minDay, L.local.invalidYear), o = this._t2gYear(i.year());
          return n.leapYear(o);
        }, weekOfYear: function(s, i, o) {
          var r = this._validate(s, this.minMonth, this.minDay, L.local.invalidYear), s = this._t2gYear(r.year());
          return n.weekOfYear(s, r.month(), r.day());
        }, daysInMonth: function(a, i) {
          var o = this._validate(a, i, this.minDay, L.local.invalidMonth);
          return this.daysPerMonth[o.month() - 1] + (o.month() === 2 && this.leapYear(o.year()) ? 1 : 0);
        }, weekDay: function(a, i, o) {
          return (this.dayOfWeek(a, i, o) || 7) < 6;
        }, toJD: function(s, i, o) {
          var r = this._validate(s, i, o, L.local.invalidDate), s = this._t2gYear(r.year());
          return n.toJD(s, r.month(), r.day());
        }, fromJD: function(a) {
          var i = n.fromJD(a), o = this._g2tYear(i.year());
          return this.newDate(o, i.month(), i.day());
        }, _t2gYear: function(a) {
          return a - this.yearsOffset - (a >= 1 && a <= this.yearsOffset ? 1 : 0);
        }, _g2tYear: function(a) {
          return a + this.yearsOffset + (a >= -this.yearsOffset && a <= -1 ? 1 : 0);
        } }), L.calendars.thai = e;
      }), dv = xe(() => {
        var L = An(), k = Mn();
        function n(a) {
          this.local = this.regionalOptions[a || ""] || this.regionalOptions[""];
        }
        n.prototype = new L.baseCalendar(), k(n.prototype, { name: "UmmAlQura", hasYearZero: !1, minMonth: 1, firstMonth: 1, minDay: 1, regionalOptions: { "": { name: "Umm al-Qura", epochs: ["BH", "AH"], monthNames: ["Al-Muharram", "Safar", "Rabi' al-awwal", "Rabi' Al-Thani", "Jumada Al-Awwal", "Jumada Al-Thani", "Rajab", "Sha'aban", "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"], monthNamesShort: ["Muh", "Saf", "Rab1", "Rab2", "Jum1", "Jum2", "Raj", "Sha'", "Ram", "Shaw", "DhuQ", "DhuH"], dayNames: ["Yawm al-Ahad", "Yawm al-Ithnain", "Yawm al-Thalāthā’", "Yawm al-Arba‘ā’", "Yawm al-Khamīs", "Yawm al-Jum‘a", "Yawm al-Sabt"], dayNamesMin: ["Ah", "Ith", "Th", "Ar", "Kh", "Ju", "Sa"], digits: null, dateFormat: "yyyy/mm/dd", firstDay: 6, isRTL: !0 } }, leapYear: function(a) {
          var i = this._validate(a, this.minMonth, this.minDay, L.local.invalidYear);
          return this.daysInYear(i.year()) === 355;
        }, weekOfYear: function(a, i, o) {
          var r = this.newDate(a, i, o);
          return r.add(-r.dayOfWeek(), "d"), Math.floor((r.dayOfYear() - 1) / 7) + 1;
        }, daysInYear: function(a) {
          for (var i = 0, o = 1; o <= 12; o++) i += this.daysInMonth(a, o);
          return i;
        }, daysInMonth: function(a, i) {
          for (var o = this._validate(a, i, this.minDay, L.local.invalidMonth), r = o.toJD() - 24e5 + 0.5, s = 0, c = 0; c < e.length; c++) {
            if (e[c] > r) return e[s] - e[s - 1];
            s++;
          }
          return 30;
        }, weekDay: function(a, i, o) {
          return this.dayOfWeek(a, i, o) !== 5;
        }, toJD: function(a, i, o) {
          var r = this._validate(a, i, o, L.local.invalidDate), s = 12 * (r.year() - 1) + r.month() - 15292, c = r.day() + e[s - 1] - 1;
          return c + 24e5 - 0.5;
        }, fromJD: function(a) {
          for (var i = a - 24e5 + 0.5, o = 0, r = 0; r < e.length && !(e[r] > i); r++) o++;
          var s = o + 15292, c = Math.floor((s - 1) / 12), t = c + 1, p = s - 12 * c, l = i - e[o - 1] + 1;
          return this.newDate(t, p, l);
        }, isValid: function(a, i, o) {
          var r = L.baseCalendar.prototype.isValid.apply(this, arguments);
          return r && (a = a.year != null ? a.year : a, r = a >= 1276 && a <= 1500), r;
        }, _validate: function(a, i, o, r) {
          var s = L.baseCalendar.prototype._validate.apply(this, arguments);
          if (s.year < 1276 || s.year > 1500) throw r.replace(/\{0\}/, this.local.name);
          return s;
        } }), L.calendars.ummalqura = n;
        var e = [20, 50, 79, 109, 138, 168, 197, 227, 256, 286, 315, 345, 374, 404, 433, 463, 492, 522, 551, 581, 611, 641, 670, 700, 729, 759, 788, 818, 847, 877, 906, 936, 965, 995, 1024, 1054, 1083, 1113, 1142, 1172, 1201, 1231, 1260, 1290, 1320, 1350, 1379, 1409, 1438, 1468, 1497, 1527, 1556, 1586, 1615, 1645, 1674, 1704, 1733, 1763, 1792, 1822, 1851, 1881, 1910, 1940, 1969, 1999, 2028, 2058, 2087, 2117, 2146, 2176, 2205, 2235, 2264, 2294, 2323, 2353, 2383, 2413, 2442, 2472, 2501, 2531, 2560, 2590, 2619, 2649, 2678, 2708, 2737, 2767, 2796, 2826, 2855, 2885, 2914, 2944, 2973, 3003, 3032, 3062, 3091, 3121, 3150, 3180, 3209, 3239, 3268, 3298, 3327, 3357, 3386, 3416, 3446, 3476, 3505, 3535, 3564, 3594, 3623, 3653, 3682, 3712, 3741, 3771, 3800, 3830, 3859, 3889, 3918, 3948, 3977, 4007, 4036, 4066, 4095, 4125, 4155, 4185, 4214, 4244, 4273, 4303, 4332, 4362, 4391, 4421, 4450, 4480, 4509, 4539, 4568, 4598, 4627, 4657, 4686, 4716, 4745, 4775, 4804, 4834, 4863, 4893, 4922, 4952, 4981, 5011, 5040, 5070, 5099, 5129, 5158, 5188, 5218, 5248, 5277, 5307, 5336, 5366, 5395, 5425, 5454, 5484, 5513, 5543, 5572, 5602, 5631, 5661, 5690, 5720, 5749, 5779, 5808, 5838, 5867, 5897, 5926, 5956, 5985, 6015, 6044, 6074, 6103, 6133, 6162, 6192, 6221, 6251, 6281, 6311, 6340, 6370, 6399, 6429, 6458, 6488, 6517, 6547, 6576, 6606, 6635, 6665, 6694, 6724, 6753, 6783, 6812, 6842, 6871, 6901, 6930, 6960, 6989, 7019, 7048, 7078, 7107, 7137, 7166, 7196, 7225, 7255, 7284, 7314, 7344, 7374, 7403, 7433, 7462, 7492, 7521, 7551, 7580, 7610, 7639, 7669, 7698, 7728, 7757, 7787, 7816, 7846, 7875, 7905, 7934, 7964, 7993, 8023, 8053, 8083, 8112, 8142, 8171, 8201, 8230, 8260, 8289, 8319, 8348, 8378, 8407, 8437, 8466, 8496, 8525, 8555, 8584, 8614, 8643, 8673, 8702, 8732, 8761, 8791, 8821, 8850, 8880, 8909, 8938, 8968, 8997, 9027, 9056, 9086, 9115, 9145, 9175, 9205, 9234, 9264, 9293, 9322, 9352, 9381, 9410, 9440, 9470, 9499, 9529, 9559, 9589, 9618, 9648, 9677, 9706, 9736, 9765, 9794, 9824, 9853, 9883, 9913, 9943, 9972, 10002, 10032, 10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621, 10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213, 11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803, 11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393, 12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984, 13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574, 13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166, 14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756, 14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347, 15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937, 15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528, 16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118, 17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709, 17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300, 18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890, 18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481, 19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071, 20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662, 20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253, 21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843, 21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434, 22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024, 23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616, 23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206, 24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796, 24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387, 25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977, 26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568, 26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159, 27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750, 27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340, 28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577, 28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167, 29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759, 29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348, 30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939, 30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530, 31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120, 32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711, 32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302, 33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893, 33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483, 34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074, 35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665, 35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254, 36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845, 36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436, 37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027, 38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617, 38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208, 39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798, 39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389, 40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980, 41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570, 41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161, 42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751, 42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342, 43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932, 43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523, 44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114, 45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704, 45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295, 46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885, 46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476, 47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066, 48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657, 48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248, 49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838, 49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429, 50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019, 51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611, 51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200, 52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792, 52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383, 53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973, 54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564, 54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154, 55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745, 55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335, 56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926, 56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517, 57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107, 58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698, 58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288, 59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879, 59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469, 60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061, 61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651, 61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242, 62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832, 62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423, 63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014, 64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603, 64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195, 65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785, 65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376, 66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967, 66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557, 67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68e3, 68030, 68060, 68089, 68119, 68148, 68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738, 68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330, 69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919, 69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510, 70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101, 71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691, 71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282, 72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872, 72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464, 73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053, 74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645, 74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235, 75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826, 75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416, 76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007, 77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598, 77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188, 78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779, 78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369, 79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960, 79990];
      }), pv = xe((L, k) => {
        k.exports = An(), K1(), Q1(), ev(), tv(), rv(), nv(), av(), iv(), ov(), lv(), sv(), uv(), cv(), fv(), dv();
      }), hv = xe((L, k) => {
        var n = pv(), e = wt(), a = Yr(), i = a.EPOCHJD, o = a.ONEDAY, r = { valType: "enumerated", values: e.sortObjectKeys(n.calendars), editType: "calc", dflt: "gregorian" }, s = function(R, I, P, M) {
          var B = {};
          return B[P] = r, e.coerce(R, I, B, P, M);
        }, c = function(R, I, P, M) {
          for (var B = 0; B < P.length; B++) s(R, I, P[B] + "calendar", M.calendar);
        }, t = { chinese: "2000-01-01", coptic: "2000-01-01", discworld: "2000-01-01", ethiopian: "2000-01-01", hebrew: "5000-01-01", islamic: "1000-01-01", julian: "2000-01-01", mayan: "5000-01-01", nanakshahi: "1000-01-01", nepali: "2000-01-01", persian: "1000-01-01", jalali: "1000-01-01", taiwan: "1000-01-01", thai: "2000-01-01", ummalqura: "1400-01-01" }, p = { chinese: "2000-01-02", coptic: "2000-01-03", discworld: "2000-01-03", ethiopian: "2000-01-05", hebrew: "5000-01-01", islamic: "1000-01-02", julian: "2000-01-03", mayan: "5000-01-01", nanakshahi: "1000-01-05", nepali: "2000-01-05", persian: "1000-01-01", jalali: "1000-01-01", taiwan: "1000-01-04", thai: "2000-01-04", ummalqura: "1400-01-06" }, l = { chinese: ["2000-01-01", "2001-01-01"], coptic: ["1700-01-01", "1701-01-01"], discworld: ["1800-01-01", "1801-01-01"], ethiopian: ["2000-01-01", "2001-01-01"], hebrew: ["5700-01-01", "5701-01-01"], islamic: ["1400-01-01", "1401-01-01"], julian: ["2000-01-01", "2001-01-01"], mayan: ["5200-01-01", "5201-01-01"], nanakshahi: ["0500-01-01", "0501-01-01"], nepali: ["2000-01-01", "2001-01-01"], persian: ["1400-01-01", "1401-01-01"], jalali: ["1400-01-01", "1401-01-01"], taiwan: ["0100-01-01", "0101-01-01"], thai: ["2500-01-01", "2501-01-01"], ummalqura: ["1400-01-01", "1401-01-01"] }, f = "##", v = { d: { 0: "dd", "-": "d" }, e: { 0: "d", "-": "d" }, a: { 0: "D", "-": "D" }, A: { 0: "DD", "-": "DD" }, j: { 0: "oo", "-": "o" }, W: { 0: "ww", "-": "w" }, m: { 0: "mm", "-": "m" }, b: { 0: "M", "-": "M" }, B: { 0: "MM", "-": "MM" }, y: { 0: "yy", "-": "yy" }, Y: { 0: "yyyy", "-": "yyyy" }, U: f, w: f, c: { 0: "D M d %X yyyy", "-": "D M d %X yyyy" }, x: { 0: "mm/dd/yyyy", "-": "mm/dd/yyyy" } };
        function g(R, I, P) {
          for (var M = Math.floor((I + 0.05) / o) + i, B = h(P).fromJD(M), z = 0, q, U, G, K, te; (z = R.indexOf("%", z)) !== -1; ) q = R.charAt(z + 1), q === "0" || q === "-" || q === "_" ? (G = 3, U = R.charAt(z + 2), q === "_" && (q = "-")) : (U = q, q = "0", G = 2), K = v[U], K ? (K === f ? te = f : te = B.formatDate(K[q]), R = R.substr(0, z) + te + R.substr(z + G), z += te.length) : z += G;
          return R;
        }
        var x = {};
        function h(R) {
          var I = x[R];
          return I || (I = x[R] = n.instance(R), I);
        }
        function m(R) {
          return e.extendFlat({}, r, { description: R });
        }
        function u(R) {
          return "Sets the calendar system to use with `" + R + "` date data.";
        }
        var d = { xcalendar: m(u("x")) }, y = e.extendFlat({}, d, { ycalendar: m(u("y")) }), _ = e.extendFlat({}, y, { zcalendar: m(u("z")) }), T = m(["Sets the calendar system to use for `range` and `tick0`", "if this is a date axis. This does not set the calendar for", "interpreting data on this axis, that's specified in the trace", "or via the global `layout.calendar`"].join(" "));
        k.exports = { moduleType: "component", name: "calendars", schema: { traces: { scatter: y, bar: y, box: y, heatmap: y, contour: y, histogram: y, histogram2d: y, histogram2dcontour: y, scatter3d: _, surface: _, mesh3d: _, scattergl: y, ohlc: d, candlestick: d }, layout: { calendar: m(["Sets the default calendar system to use for interpreting and", "displaying dates throughout the plot."].join(" ")) }, subplots: { xaxis: { calendar: T }, yaxis: { calendar: T }, scene: { xaxis: { calendar: T }, yaxis: { calendar: T }, zaxis: { calendar: T } }, polar: { radialaxis: { calendar: T } } } }, layoutAttributes: r, handleDefaults: s, handleTraceDefaults: c, CANONICAL_SUNDAY: p, CANONICAL_TICK: t, DFLTRANGE: l, getCal: h, worldCalFmt: g };
      }), vv = xe((L, k) => {
        k.exports = hv();
      }), gv = xe((L, k) => {
        var n = y0();
        n.register([_0(), k0(), P0(), F0(), q0(), K0(), rh(), hh(), Th(), U1(), $1(), vv()]), k.exports = n;
      });
      return gv();
    })();
    /*! Bundled license information:
    
    	native-promise-only/lib/npo.src.js:
    	  (*! Native Promise Only
    	      v0.8.1 (c) Kyle Simpson
    	      MIT License: http://getify.mit-license.org
    	  *)
    
    	polybooljs/index.js:
    	  (*
    	   * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
    	   * @license MIT
    	   * @preserve Project Home: https://github.com/voidqk/polybooljs
    	   *)
    
    	ieee754/index.js:
    	  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)
    
    	buffer/index.js:
    	  (*!
    	   * The buffer module from node.js, for the browser.
    	   *
    	   * @author   Feross Aboukhadijeh <https://feross.org>
    	   * @license  MIT
    	   *)
    
    	safe-buffer/index.js:
    	  (*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)
    
    	assert/build/internal/util/comparisons.js:
    	  (*!
    	   * The buffer module from node.js, for the browser.
    	   *
    	   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
    	   * @license  MIT
    	   *)
    
    	object-assign/index.js:
    	  (*
    	  object-assign
    	  (c) Sindre Sorhus
    	  @license MIT
    	  *)
    	*/
    return window.Plotly = ua, ua;
  });
})(gf);
var ty = gf.exports;
const ny = /* @__PURE__ */ ey(ty);
export {
  ny as P,
  ry as a,
  Qg as c,
  ey as g
};
//# sourceMappingURL=plotly-vendor-Xl9RTeYD.js.map
